(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.bx.eL === region.hS.eL)
	{
		return 'on line ' + region.bx.eL;
	}
	return 'on lines ' + region.bx.eL + ' through ' + region.hS.eL;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.jM,
		impl.le,
		impl.kZ,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		j5: func(record.j5),
		kX: record.kX,
		kx: record.kx
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.j5;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.kX;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.kx) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.jM,
		impl.le,
		impl.kZ,
		function(sendToApp, initialModel) {
			var view = impl.lm;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.jM,
		impl.le,
		impl.kZ,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.hg && impl.hg(sendToApp)
			var view = impl.lm;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.dq);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.k8) && (_VirtualDom_doc.title = title = doc.k8);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.kh;
	var onUrlRequest = impl.ki;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		hg: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.il === next.il
							&& curr.hY === next.hY
							&& curr.ii.a === next.ii.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		jM: function(flags)
		{
			return A3(impl.jM, flags, _Browser_getUrl(), key);
		},
		lm: impl.lm,
		le: impl.le,
		kZ: impl.kZ
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { jG: 'hidden', i1: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { jG: 'mozHidden', i1: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { jG: 'msHidden', i1: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { jG: 'webkitHidden', i1: 'webkitvisibilitychange' }
		: { jG: 'hidden', i1: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		iu: _Browser_getScene(),
		J: {
			am: _Browser_window.pageXOffset,
			bf: _Browser_window.pageYOffset,
			ln: _Browser_doc.documentElement.clientWidth,
			Y: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		ln: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		Y: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			iu: {
				ln: node.scrollWidth,
				Y: node.scrollHeight
			},
			J: {
				am: node.scrollLeft,
				bf: node.scrollTop,
				ln: node.clientWidth,
				Y: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			iu: _Browser_getScene(),
			J: {
				am: x,
				bf: y,
				ln: _Browser_doc.documentElement.clientWidth,
				Y: _Browser_doc.documentElement.clientHeight
			},
			jt: {
				am: x + rect.left,
				bf: y + rect.top,
				ln: rect.width,
				Y: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.jz.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.jz.b, xhr)); });
		$elm$core$Maybe$isJust(request.iH) && _Http_track(router, xhr, request.iH.a);

		try {
			xhr.open(request.h7, request.lg, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.lg));
		}

		_Http_configureRequest(xhr, request);

		request.dq.a && xhr.setRequestHeader('Content-Type', request.dq.a);
		xhr.send(request.dq.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.hX; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.iF.a || 0;
	xhr.responseType = request.jz.d;
	xhr.withCredentials = request.iP;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		lg: xhr.responseURL,
		kV: xhr.status,
		kW: xhr.statusText,
		hX: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			kQ: event.loaded,
			iv: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			ky: event.loaded,
			iv: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.kb) { flags += 'm'; }
	if (options.i0) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder._) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.af),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.af);
		} else {
			var treeLen = builder._ * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.aj) : builder.aj;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder._);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.af) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.af);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{aj: nodeList, _: (len / $elm$core$Array$branchFactor) | 0, af: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {hW: fragment, hY: host, $8: path, ii: port_, il: protocol, im: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$document = _Browser_document;
var $author$project$Main$Error = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Environments$Route$MainMenu = {$: 0};
var $author$project$Main$ReceivedEnvironmentMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$ReceivedRepositoryMsg = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Environments$Flags$Language$DE = 0;
var $author$project$Environments$Flags$Flags$Flags = F8(
	function (seed, seedExtension, language, translationUrls, network, baseUri, platform, apiVersion) {
		return {er: apiVersion, bC: baseUri, jS: language, c3: network, eT: platform, eX: seed, kO: seedExtension, ld: translationUrls};
	});
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Environments$Flags$Language$fromString = function (str) {
	switch (str) {
		case 'DE':
			return 0;
		case 'EN':
			return 0;
		default:
			return 0;
	}
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Environments$Flags$Language$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$Environments$Flags$Language$fromString, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$string);
var $author$project$Environments$Flags$Platform$Android = function (a) {
	return {$: 1, a: a};
};
var $author$project$Environments$Flags$Platform$IOS = function (a) {
	return {$: 2, a: a};
};
var $author$project$Environments$Flags$Platform$Web = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Environments$Flags$Platform$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (platform) {
		switch (platform) {
			case 'web':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'version',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Environments$Flags$Platform$Web));
			case 'android':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'version',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Environments$Flags$Platform$Android));
			case 'ios':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'version',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Environments$Flags$Platform$IOS));
			default:
				return $elm$json$Json$Decode$fail('Unknown Platform');
		}
	},
	A2($elm$json$Json$Decode$field, 'platform', $elm$json$Json$Decode$string));
var $author$project$Environments$Flags$TranslationUrls$Data = F2(
	function (de, en) {
		return {hH: de, hR: en};
	});
var $author$project$Environments$Flags$TranslationUrls$TranslationUrls = $elm$core$Basics$identity;
var $author$project$Environments$Flags$TranslationUrls$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'en',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'de',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Environments$Flags$TranslationUrls$Data))));
var $author$project$Environments$Network$Offline = 1;
var $author$project$Environments$Network$Online = 0;
var $author$project$Environments$Network$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (state) {
		switch (state) {
			case 'ONLINE':
				return $elm$json$Json$Decode$succeed(0);
			case 'OFFLINE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unknown state');
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Environments$Network$offline = 1;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $author$project$Utils$Decode$withDefault = F2(
	function (def, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					decoder,
					$elm$json$Json$Decode$succeed(def)
				]));
	});
var $author$project$Environments$Flags$Flags$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'apiVersion',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'platform',
		$author$project$Environments$Flags$Platform$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'baseUri',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'network',
				A2($author$project$Utils$Decode$withDefault, $author$project$Environments$Network$offline, $author$project$Environments$Network$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'translationUrls',
					$author$project$Environments$Flags$TranslationUrls$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'language',
						A2($author$project$Utils$Decode$withDefault, 0, $author$project$Environments$Flags$Language$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'seedExtension',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'seed',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$Environments$Flags$Flags$Flags)))))))));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Auth$ReLoginModal$Hidden = {$: 0};
var $author$project$Auth$ReLoginModal$hidden = $author$project$Auth$ReLoginModal$Hidden;
var $author$project$Environments$Environment$GotViewport = function (a) {
	return {$: 4, a: a};
};
var $author$project$Environments$Environment$LoadSession = {$: 0};
var $author$project$Environments$Environment$LoadUserRights = {$: 3};
var $author$project$Auth$UserRights$Loading = {$: 0};
var $author$project$Environments$Environment$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Environments$Environment$NoUpdateNeeded = 0;
var $author$project$Environments$Environment$ReceivedTimeZone = function (a) {
	return {$: 3, a: a};
};
var $author$project$Environments$Environment$Wide = 0;
var $author$project$Environments$App$Active = 0;
var $author$project$Environments$App$active = 0;
var $author$project$Environments$Flags$TranslationUrls$get = F2(
	function (language, _v0) {
		var data = _v0;
		if (!language) {
			return data.hH;
		} else {
			return data.hR;
		}
	});
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$Seed = $elm$core$Basics$identity;
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{aj: nodeList, _: nodeListSize, af: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $NoRedInk$elm_random_pcg_extended$Internal$Pcg$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $NoRedInk$elm_random_pcg_extended$Internal$Pcg$initialSeed = function (x) {
	var _v0 = $NoRedInk$elm_random_pcg_extended$Internal$Pcg$next(
		A2($NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $NoRedInk$elm_random_pcg_extended$Internal$Pcg$next(
		A2($NoRedInk$elm_random_pcg_extended$Internal$Pcg$Seed, state2, incr));
};
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$initialSeed = F2(
	function (baseSeed, extendedSeed) {
		return {
			bV: $NoRedInk$elm_random_pcg_extended$Internal$Pcg$initialSeed(baseSeed),
			bm: $elm$core$Array$fromList(extendedSeed)
		};
	});
var $ChristophP$elm_i18next$I18Next$Translations = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $ChristophP$elm_i18next$I18Next$initialTranslations = $elm$core$Dict$empty;
var $author$project$Environments$Environment$ReceivedTranslations = function (a) {
	return {$: 2, a: a};
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.kV));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {iq: reqs, iz: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.iH;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.iq));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.iz)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					iP: r.iP,
					dq: r.dq,
					jz: A2(_Http_mapExpect, func, r.jz),
					hX: r.hX,
					h7: r.h7,
					iF: r.iF,
					iH: r.iH,
					lg: r.lg
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{iP: false, dq: r.dq, jz: r.jz, hX: r.hX, h7: r.h7, iF: r.iF, iH: r.iH, lg: r.lg}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{dq: $elm$http$Http$emptyBody, jz: r.jz, hX: _List_Nil, h7: 'GET', iF: $elm$core$Maybe$Nothing, iH: $elm$core$Maybe$Nothing, lg: r.lg});
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslationsHelp = F3(
	function (initialValue, namespace, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, val, acc) {
					var newNamespace = function (currentKey) {
						return $elm$core$String$isEmpty(namespace) ? currentKey : (namespace + ('.' + currentKey));
					};
					if (val.$ === 1) {
						var str = val.a;
						return A3(
							$elm$core$Dict$insert,
							newNamespace(key),
							str,
							acc);
					} else {
						var children = val.a;
						return A3(
							$ChristophP$elm_i18next$I18Next$flattenTranslationsHelp,
							acc,
							newNamespace(key),
							children);
					}
				}),
			initialValue,
			dict);
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslations = A2($ChristophP$elm_i18next$I18Next$flattenTranslationsHelp, $elm$core$Dict$empty, '');
var $ChristophP$elm_i18next$I18Next$Branch = function (a) {
	return {$: 0, a: a};
};
var $ChristophP$elm_i18next$I18Next$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
function $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $ChristophP$elm_i18next$I18Next$Leaf, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$map,
						$ChristophP$elm_i18next$I18Next$Branch,
						$elm$json$Json$Decode$dict(
							$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder()));
				})
			]));
}
var $ChristophP$elm_i18next$I18Next$treeDecoder = $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder();
$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder = function () {
	return $ChristophP$elm_i18next$I18Next$treeDecoder;
};
var $ChristophP$elm_i18next$I18Next$translationsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $ChristophP$elm_i18next$I18Next$flattenTranslations, $elm$core$Basics$identity),
	$elm$json$Json$Decode$dict($ChristophP$elm_i18next$I18Next$treeDecoder));
var $author$project$Environments$Environment$loadTranslations = function (translationUrl) {
	return $elm$http$Http$get(
		{
			jz: A2($elm$http$Http$expectJson, $author$project$Environments$Environment$ReceivedTranslations, $ChristophP$elm_i18next$I18Next$translationsDecoder),
			lg: translationUrl
		});
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $NoRedInk$elm_uuid$Prng$Uuid$toString = function (_v0) {
	var internalString = _v0;
	return internalString;
};
var $author$project$Tenant$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Tenant$Id$encode = A2($elm$core$Basics$composeR, $author$project$Tenant$Id$toString, $elm$json$Json$Encode$string);
var $author$project$User$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$User$Id$encode = A2($elm$core$Basics$composeR, $author$project$User$Id$toString, $elm$json$Json$Encode$string);
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Auth$Session$encode = function (session) {
	switch (session.$) {
		case 1:
			var tenantId = session.a;
			var userId = session.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(tenantId)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(userId))
					]));
		case 2:
			var tenantId = session.a;
			var userId = session.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(tenantId)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(userId))
					]));
		default:
			return $elm$json$Json$Encode$null;
	}
};
var $author$project$Rights$Right$toString = function (right) {
	switch (right) {
		case 0:
			return 'editRights';
		case 1:
			return 'editOrganisationUnit';
		case 2:
			return 'editPlan';
		case 3:
			return 'editTenant';
		case 4:
			return 'createMeasure';
		case 5:
			return 'editMeasure';
		case 6:
			return 'deleteMeasure';
		case 7:
			return 'createAudit';
		case 8:
			return 'editAudit';
		default:
			return 'deleteAudit';
	}
};
var $author$project$Rights$Right$encode = function (right) {
	return $elm$json$Json$Encode$string(
		$author$project$Rights$Right$toString(right));
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $turboMaCk$any_dict$Dict$Any$toList = function (_v0) {
	var dict = _v0.cL;
	return $elm$core$Dict$values(dict);
};
var $turboMaCk$any_dict$Dict$Any$keys = A2(
	$elm$core$Basics$composeL,
	$elm$core$List$map($elm$core$Tuple$first),
	$turboMaCk$any_dict$Dict$Any$toList);
var $turboMaCk$any_set$Set$Any$toList = function (_v0) {
	var dict = _v0;
	return $turboMaCk$any_dict$Dict$Any$keys(dict);
};
var $turboMaCk$any_set$Set$Any$encode = function (encoder) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$json$Json$Encode$list(encoder),
		$turboMaCk$any_set$Set$Any$toList);
};
var $author$project$Auth$RightSet$encode = $turboMaCk$any_set$Set$Any$encode($author$project$Rights$Right$encode);
var $author$project$OrganisationUnit$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$OrganisationUnit$Id$encode = A2($elm$core$Basics$composeR, $author$project$OrganisationUnit$Id$toString, $elm$json$Json$Encode$string);
var $author$project$Auth$UserRights$encodeTuple = function (_v0) {
	var organisationUnitId = _v0.a;
	var rightSet = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'organisationUnitId',
				$author$project$OrganisationUnit$Id$encode(organisationUnitId)),
				_Utils_Tuple2(
				'rightSet',
				$author$project$Auth$RightSet$encode(rightSet))
			]));
};
var $author$project$Auth$UserRights$matrixToList = $turboMaCk$any_dict$Dict$Any$toList;
var $author$project$Auth$UserRights$encode = function (userRights) {
	switch (userRights.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'state',
						$elm$json$Json$Encode$string('LOADING'))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'state',
						$elm$json$Json$Encode$string('NOT_INITIALIZED'))
					]));
		default:
			var data = userRights.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'state',
						$elm$json$Json$Encode$string('INITIALIZED')),
						_Utils_Tuple2(
						'settingsRights',
						$author$project$Auth$RightSet$encode(data.hf)),
						_Utils_Tuple2(
						'matrix',
						A2(
							$elm$json$Json$Encode$list,
							$author$project$Auth$UserRights$encodeTuple,
							$author$project$Auth$UserRights$matrixToList(data.h4)))
					]));
	}
};
var $author$project$Environments$Environment$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_SESSION'))
					]));
		case 1:
			var session_ = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_SESSION')),
						_Utils_Tuple2(
						'session',
						$author$project$Auth$Session$encode(session_))
					]));
		case 2:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DELETE_SESSION'))
					]));
		case 3:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_USER_RIGHTS'))
					]));
		case 4:
			var userRights_ = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_USER_RIGHTS')),
						_Utils_Tuple2(
						'userRights',
						$author$project$Auth$UserRights$encode(userRights_))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_DATA'))
					]));
	}
};
var $author$project$Environments$Environment$environmentOutbox = _Platform_outgoingPort('environmentOutbox', $elm$core$Basics$identity);
var $author$project$Environments$Environment$send = A2($elm$core$Basics$composeR, $author$project$Environments$Environment$encodeOutMsg, $author$project$Environments$Environment$environmentOutbox);
var $author$project$Auth$Session$Unknown = {$: 0};
var $author$project$Auth$Session$unknown = $author$project$Auth$Session$Unknown;
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Environments$Environment$init = F2(
	function (flags, route_) {
		var translationUrl = A2($author$project$Environments$Flags$TranslationUrls$get, flags.jS, flags.ld);
		var seed = A2($NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$initialSeed, flags.eX, flags.kO);
		return _Utils_Tuple2(
			$author$project$Environments$Environment$Loading(
				{
					er: flags.er,
					dn: $author$project$Environments$App$active,
					bC: flags.bC,
					fk: $elm$core$Maybe$Nothing,
					ez: _List_Nil,
					eH: $elm$core$Maybe$Nothing,
					c3: flags.c3,
					d$: $elm$core$Maybe$Just(route_),
					eT: flags.eT,
					bL: 0,
					eb: route_,
					f4: false,
					eX: seed,
					aO: $author$project$Auth$Session$unknown,
					cw: {d0: 0, el: $elm$time$Time$utc},
					dj: $ChristophP$elm_i18next$I18Next$initialTranslations,
					cy: $author$project$Auth$UserRights$Loading,
					J: {Y: 0, be: 0, ln: 0}
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Environments$Environment$loadTranslations(translationUrl),
						$author$project$Environments$Environment$send($author$project$Environments$Environment$LoadSession),
						A2($elm$core$Task$perform, $author$project$Environments$Environment$GotViewport, $elm$browser$Browser$Dom$getViewport),
						A2($elm$core$Task$perform, $author$project$Environments$Environment$ReceivedTimeZone, $elm$time$Time$here),
						$author$project$Environments$Environment$send($author$project$Environments$Environment$LoadUserRights)
					])));
	});
var $author$project$Environments$Repository$Repository = $elm$core$Basics$identity;
var $author$project$EventStream$EventStream$Disconnected = {$: 0};
var $author$project$EventStream$EventStream$disconnected = $author$project$EventStream$EventStream$Disconnected;
var $author$project$Audit$Service$Idle = {$: 0};
var $author$project$Audit$Service$idle = $author$project$Audit$Service$Idle;
var $author$project$CheckpointData$Service$Idle = {$: 0};
var $author$project$CheckpointData$Service$idle = $author$project$CheckpointData$Service$Idle;
var $author$project$Measure$Service$Idle = {$: 0};
var $author$project$Measure$Service$idle = $author$project$Measure$Service$Idle;
var $author$project$OrganisationUnit$Service$Idle = {$: 0};
var $author$project$OrganisationUnit$Service$idle = $author$project$OrganisationUnit$Service$Idle;
var $author$project$Plan$Service$Idle = {$: 0};
var $author$project$Plan$Service$idle = $author$project$Plan$Service$Idle;
var $author$project$Rights$Service$Idle = {$: 0};
var $author$project$Rights$Service$idle = $author$project$Rights$Service$Idle;
var $author$project$Tenant$Service$Idle = {$: 0};
var $author$project$Tenant$Service$idle = $author$project$Tenant$Service$Idle;
var $author$project$User$Service$Idle = {$: 0};
var $author$project$User$Service$idle = $author$project$User$Service$Idle;
var $author$project$Audit$Store$LoadData = {$: 0};
var $author$project$Audit$Store$Loading = {$: 0};
var $author$project$Audit$Store$auditStoreOutbox = _Platform_outgoingPort('auditStoreOutbox', $elm$core$Basics$identity);
var $author$project$Audit$Audits$dict = function (_v0) {
	var data = _v0;
	return data.cL;
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Utils$Encode$timestamp = A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int);
var $author$project$Audit$CompletionStatus$encode = function (completionStatus) {
	if (!completionStatus.$) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'CompletionType',
					$elm$json$Json$Encode$string('Open'))
				]));
	} else {
		var posix = completionStatus.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'CompletionType',
					$elm$json$Json$Encode$string('Completed')),
					_Utils_Tuple2(
					'timestamp',
					$author$project$Utils$Encode$timestamp(posix))
				]));
	}
};
var $author$project$Audit$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Audit$Id$encode = A2($elm$core$Basics$composeR, $author$project$Audit$Id$toString, $elm$json$Json$Encode$string);
var $author$project$Audit$Record$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Audit$Record$Id$encode = A2($elm$core$Basics$composeR, $author$project$Audit$Record$Id$toString, $elm$json$Json$Encode$string);
var $author$project$CheckpointData$Checkpoint$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$CheckpointData$Checkpoint$Id$encode = A2($elm$core$Basics$composeR, $author$project$CheckpointData$Checkpoint$Id$toString, $elm$json$Json$Encode$string);
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$Date_Time$Month$toInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $author$project$Date_Time$NaiveDate$toStringYMD = function (_v0) {
	var y = _v0.a;
	var m = _v0.b;
	var d = _v0.c;
	var ys = $elm$core$String$fromInt(y);
	var ms = A3(
		$elm$core$Basics$composeR,
		$author$project$Date_Time$Month$toInt,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromInt,
			A2($elm$core$String$padLeft, 2, '0')),
		m);
	var ds = A3(
		$elm$core$Basics$composeR,
		$elm$core$String$fromInt,
		A2($elm$core$String$padLeft, 2, '0'),
		d);
	return ys + ('-' + (ms + ('-' + ds)));
};
var $author$project$Date_Time$NaiveDate$encode = A2($elm$core$Basics$composeR, $author$project$Date_Time$NaiveDate$toStringYMD, $elm$json$Json$Encode$string);
var $author$project$Date_Time$NaiveTime$toStringWithSeconds = function (_v0) {
	var h = _v0.a;
	var m = _v0.b;
	var s = _v0.c;
	var ss = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(s));
	var mm = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(m));
	var hh = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(h));
	return hh + (':' + (mm + (':' + ss)));
};
var $author$project$Date_Time$NaiveTime$encode = A2($elm$core$Basics$composeR, $author$project$Date_Time$NaiveTime$toStringWithSeconds, $elm$json$Json$Encode$string);
var $author$project$File$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$File$Id$encode = A2($elm$core$Basics$composeR, $author$project$File$Id$toString, $elm$json$Json$Encode$string);
var $author$project$File$Filename$encode = function (filename) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$File$Id$encode(filename.fw)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(filename.g_))
			]));
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$encodeOption = function (option) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(option.fw)),
				_Utils_Tuple2(
				'text',
				$elm$json$Json$Encode$string(option.hl))
			]));
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$CheckpointData$Checkpoint$Value$encode = function (cpValue) {
	switch (cpValue.$) {
		case 0:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('number')),
						_Utils_Tuple2(
						'value',
						$elm$json$Json$Encode$float(value))
					]));
		case 1:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('textRow')),
						_Utils_Tuple2(
						'value',
						$elm$json$Json$Encode$string(value))
					]));
		case 2:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('textMemo')),
						_Utils_Tuple2(
						'value',
						$elm$json$Json$Encode$string(value))
					]));
		case 3:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('checkbox')),
						_Utils_Tuple2(
						'value',
						$elm$json$Json$Encode$bool(value))
					]));
		case 4:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('individualData')),
						_Utils_Tuple2(
						'value',
						$elm$json$Json$Encode$string(value))
					]));
		case 5:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('select')),
						_Utils_Tuple2(
						'value',
						$author$project$CheckpointData$Checkpoint$CheckpointType$encodeOption(value))
					]));
		case 6:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('multiSelect')),
						_Utils_Tuple2(
						'value',
						A2($elm$json$Json$Encode$list, $author$project$CheckpointData$Checkpoint$CheckpointType$encodeOption, value))
					]));
		case 7:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('date')),
						_Utils_Tuple2(
						'value',
						$author$project$Date_Time$NaiveDate$encode(value))
					]));
		case 8:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('image')),
						_Utils_Tuple2(
						'value',
						$author$project$File$Filename$encode(value))
					]));
		case 9:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('signature')),
						_Utils_Tuple2(
						'value',
						$author$project$File$Filename$encode(value))
					]));
		default:
			var value = cpValue.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'recordType',
						$elm$json$Json$Encode$string('time')),
						_Utils_Tuple2(
						'value',
						$author$project$Date_Time$NaiveTime$encode(value))
					]));
	}
};
var $author$project$File$Filenames$encode = $turboMaCk$any_set$Set$Any$encode($author$project$File$Filename$encode);
var $author$project$Audit$Record$Record$encode = function (record) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'recordId',
				$author$project$Audit$Record$Id$encode(record.bK)),
				_Utils_Tuple2(
				'recordTimestamp',
				$author$project$Utils$Encode$timestamp(record.g8)),
				_Utils_Tuple2(
				'checkpointId',
				$author$project$CheckpointData$Checkpoint$Id$encode(record.i5)),
				_Utils_Tuple2(
				'auditorId',
				$author$project$User$Id$encode(record.iW)),
				_Utils_Tuple2(
				'value',
				$author$project$CheckpointData$Checkpoint$Value$encode(record.ll)),
				_Utils_Tuple2(
				'files',
				$author$project$File$Filenames$encode(record.cT))
			]));
};
var $author$project$Audit$Record$Records$unwrap = function (_v0) {
	var data = _v0;
	return data;
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $turboMaCk$any_dict$Dict$Any$values = A2(
	$elm$core$Basics$composeL,
	$elm$core$List$map($elm$core$Tuple$second),
	$turboMaCk$any_dict$Dict$Any$toList);
var $author$project$Audit$Record$Records$values = A2(
	$elm$core$Basics$composeR,
	$author$project$Audit$Record$Records$unwrap,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.cL;
		},
		$turboMaCk$any_dict$Dict$Any$values));
var $author$project$Audit$Record$Records$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Audit$Record$Records$values,
	$elm$json$Json$Encode$list($author$project$Audit$Record$Record$encode));
var $author$project$Plan$Execution$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Plan$Execution$Id$encode = A2($elm$core$Basics$composeR, $author$project$Plan$Execution$Id$toString, $elm$json$Json$Encode$string);
var $author$project$Plan$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Plan$Id$encode = A2($elm$core$Basics$composeR, $author$project$Plan$Id$toString, $elm$json$Json$Encode$string);
var $author$project$User$Ids$encode = $turboMaCk$any_set$Set$Any$encode($author$project$User$Id$encode);
var $author$project$CheckpointData$Checkpoint$CheckpointType$encode = function (cpType) {
	switch (cpType.$) {
		case 0:
			var numberModel_ = cpType.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('number')),
						_Utils_Tuple2(
						'decimalPoints',
						$elm$json$Json$Encode$int(numberModel_.hJ))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('textRow'))
					]));
		case 2:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('textMemo'))
					]));
		case 3:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('checkbox'))
					]));
		case 4:
			var individualDataModel = cpType.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('individualData')),
						_Utils_Tuple2(
						'values',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, individualDataModel.bd))
					]));
		case 5:
			var selectModel = cpType.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('select')),
						_Utils_Tuple2(
						'options',
						A2($elm$json$Json$Encode$list, $author$project$CheckpointData$Checkpoint$CheckpointType$encodeOption, selectModel.fR))
					]));
		case 6:
			var multiSelectModel = cpType.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('multiSelect')),
						_Utils_Tuple2(
						'options',
						A2($elm$json$Json$Encode$list, $author$project$CheckpointData$Checkpoint$CheckpointType$encodeOption, multiSelectModel.fR))
					]));
		case 7:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('date'))
					]));
		case 8:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('image'))
					]));
		case 9:
			var infoModel = cpType.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('info')),
						_Utils_Tuple2(
						'text',
						$elm$json$Json$Encode$string(infoModel.hl))
					]));
		case 10:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('signature'))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'checkpointType',
						$elm$json$Json$Encode$string('time'))
					]));
	}
};
var $author$project$CheckpointData$CheckpointGroup$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$CheckpointData$CheckpointGroup$Id$encode = A2($elm$core$Basics$composeR, $author$project$CheckpointData$CheckpointGroup$Id$toString, $elm$json$Json$Encode$string);
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Utils$Encode$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $elm$core$String$trim = _String_trim;
var $author$project$Utils$Encode$nullIfBlankString = function (str) {
	var _v0 = $elm$core$String$trim(str);
	if (_v0 === '') {
		return $elm$json$Json$Encode$null;
	} else {
		var trimmedStr = _v0;
		return $elm$json$Json$Encode$string(trimmedStr);
	}
};
var $author$project$CheckpointData$Checkpoint$Checkpoint$encode = function (checkpoint) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'checkpointId',
				$author$project$CheckpointData$Checkpoint$Id$encode(checkpoint.i5)),
				_Utils_Tuple2(
				'checkpointGroupId',
				$author$project$CheckpointData$CheckpointGroup$Id$encode(checkpoint.cC)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(checkpoint.k8)),
				_Utils_Tuple2(
				'description',
				$author$project$Utils$Encode$nullIfBlankString(checkpoint.aY)),
				_Utils_Tuple2(
				'checkpointType',
				$author$project$CheckpointData$Checkpoint$CheckpointType$encode(checkpoint.fg)),
				_Utils_Tuple2(
				'prev',
				A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, checkpoint.kw)),
				_Utils_Tuple2(
				'next',
				A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, checkpoint.kc)),
				_Utils_Tuple2(
				'files',
				$author$project$File$Filenames$encode(checkpoint.cT)),
				_Utils_Tuple2(
				'revision',
				$elm$json$Json$Encode$int(checkpoint.i))
			]));
};
var $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$encode = function (checkpoint) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'checkpointGroupId',
				$author$project$CheckpointData$CheckpointGroup$Id$encode(checkpoint.cC)),
				_Utils_Tuple2(
				'organisationUnitId',
				$author$project$OrganisationUnit$Id$encode(checkpoint.km)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(checkpoint.k8)),
				_Utils_Tuple2(
				'description',
				$author$project$Utils$Encode$nullIfBlankString(checkpoint.aY)),
				_Utils_Tuple2(
				'prev',
				A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, checkpoint.kw)),
				_Utils_Tuple2(
				'next',
				A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, checkpoint.kc)),
				_Utils_Tuple2(
				'first',
				A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, checkpoint.jC)),
				_Utils_Tuple2(
				'last',
				A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, checkpoint.jT)),
				_Utils_Tuple2(
				'revision',
				$elm$json$Json$Encode$int(checkpoint.i))
			]));
};
var $author$project$CheckpointData$CheckpointHierarchy$encodeCheckpointHierarchy = function (checkpointHierarchy) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'checkpointGroups',
				A2($elm$json$Json$Encode$list, $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$encode, checkpointHierarchy.gt)),
				_Utils_Tuple2(
				'checkpoints',
				A2($elm$json$Json$Encode$list, $author$project$CheckpointData$Checkpoint$Checkpoint$encode, checkpointHierarchy.i6))
			]));
};
var $author$project$Audit$Audit$encode = function (audit) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'auditId',
				$author$project$Audit$Id$encode(audit.gm)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(audit.fw)),
				_Utils_Tuple2(
				'planId',
				$author$project$Plan$Id$encode(audit.d5)),
				_Utils_Tuple2(
				'planRevision',
				A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$int, audit.d6)),
				_Utils_Tuple2(
				'executionId',
				A2($author$project$Utils$Encode$maybe, $author$project$Plan$Execution$Id$encode, audit.dH)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(audit.k8)),
				_Utils_Tuple2(
				'description',
				$author$project$Utils$Encode$nullIfBlankString(audit.aY)),
				_Utils_Tuple2(
				'creationTimestamp',
				$author$project$Utils$Encode$timestamp(audit.dw)),
				_Utils_Tuple2(
				'deadlineTimestamp',
				$author$project$Utils$Encode$timestamp(audit.hI)),
				_Utils_Tuple2(
				'auditors',
				$author$project$User$Ids$encode(audit.bT)),
				_Utils_Tuple2(
				'checkpointHierarchy',
				$author$project$CheckpointData$CheckpointHierarchy$encodeCheckpointHierarchy(audit.ff)),
				_Utils_Tuple2(
				'records',
				$author$project$Audit$Record$Records$encode(audit.io)),
				_Utils_Tuple2(
				'completionStatus',
				$author$project$Audit$CompletionStatus$encode(audit.jb)),
				_Utils_Tuple2(
				'revision',
				$elm$json$Json$Encode$int(audit.i))
			]));
};
var $author$project$Audit$Dict$values = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$Audit$Dict$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Audit$Dict$values,
	$elm$json$Json$Encode$list($author$project$Audit$Audit$encode));
var $author$project$Types$EventId$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Types$EventId$encode = A2($elm$core$Basics$composeR, $author$project$Types$EventId$toString, $elm$json$Json$Encode$string);
var $author$project$Audit$Audits$lastEventId = function (_v0) {
	var data = _v0;
	return data.fD;
};
var $author$project$Audit$Audits$encode = function (audits) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'audits',
				$author$project$Audit$Dict$encode(
					$author$project$Audit$Audits$dict(audits))),
				_Utils_Tuple2(
				'lastEventId',
				A2(
					$author$project$Utils$Encode$maybe,
					$author$project$Types$EventId$encode,
					$author$project$Audit$Audits$lastEventId(audits)))
			]));
};
var $author$project$Types$CommandId$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Types$CommandId$encode = A2($elm$core$Basics$composeR, $author$project$Types$CommandId$toString, $elm$json$Json$Encode$string);
var $author$project$Audit$Command$encode = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.audit.create.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(payload.fw)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'planRevision',
						$elm$json$Json$Encode$int(payload.d6)),
						_Utils_Tuple2(
						'executionId',
						A2($author$project$Utils$Encode$maybe, $author$project$Plan$Execution$Id$encode, payload.dH)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'creationTimestamp',
						$author$project$Utils$Encode$timestamp(payload.dw)),
						_Utils_Tuple2(
						'deadlineTimestamp',
						$author$project$Utils$Encode$timestamp(payload.hI)),
						_Utils_Tuple2(
						'auditors',
						$author$project$User$Ids$encode(payload.bT)),
						_Utils_Tuple2(
						'checkpointHierarchy',
						$author$project$CheckpointData$CheckpointHierarchy$encodeCheckpointHierarchy(payload.ff))
					]));
		case 1:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.audit.record-checkpoint.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'record',
						$author$project$Audit$Record$Record$encode(payload.ct)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 2:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.audit.changeTitle.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 3:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.audit.changeDescription.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 4:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.audit.changeDeadline.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'deadlineTimestamp',
						$author$project$Utils$Encode$timestamp(payload.hI)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 5:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.audit.changeAuditors.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'addAuditors',
						$author$project$User$Ids$encode(payload.ge)),
						_Utils_Tuple2(
						'removeAuditors',
						$author$project$User$Ids$encode(payload.g9)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 6:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.audit.addRecordFiles.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'recordId',
						$author$project$Audit$Record$Id$encode(payload.bK)),
						_Utils_Tuple2(
						'files',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.cT)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 7:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.audit.removeRecordFiles.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'recordId',
						$author$project$Audit$Record$Id$encode(payload.bK)),
						_Utils_Tuple2(
						'files',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.cT)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 8:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.audit.complete.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		default:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.audit.delete.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
	}
};
var $author$project$Types$Queue$toList = function (_v0) {
	var front = _v0.a;
	var rear = _v0.b;
	return _Utils_ap(
		front,
		$elm$core$List$reverse(rear));
};
var $author$project$Types$Queue$encode = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Types$Queue$toList,
		$elm$json$Json$Encode$list(encoder));
};
var $author$project$Audit$Commands$encode = $author$project$Types$Queue$encode($author$project$Audit$Command$encode);
var $author$project$Audit$Event$encode = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.audit.created.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(payload.fw)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'planRevision',
						$elm$json$Json$Encode$int(payload.d6)),
						_Utils_Tuple2(
						'executionId',
						A2($author$project$Utils$Encode$maybe, $author$project$Plan$Execution$Id$encode, payload.dH)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'creationTimestamp',
						$author$project$Utils$Encode$timestamp(payload.dw)),
						_Utils_Tuple2(
						'deadlineTimestamp',
						$author$project$Utils$Encode$timestamp(payload.hI)),
						_Utils_Tuple2(
						'auditors',
						$author$project$User$Ids$encode(payload.bT)),
						_Utils_Tuple2(
						'checkpointHierarchy',
						$author$project$CheckpointData$CheckpointHierarchy$encodeCheckpointHierarchy(payload.ff)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 1:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.audit.checkpoint-recorded.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'record',
						$author$project$Audit$Record$Record$encode(payload.ct)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 2:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.audit.title-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 3:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.audit.description-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 4:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.audit.deadline-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'deadlineTimestamp',
						$author$project$Utils$Encode$timestamp(payload.hI)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 5:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.audit.auditors-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'addAuditors',
						$author$project$User$Ids$encode(payload.ge)),
						_Utils_Tuple2(
						'removeAuditors',
						$author$project$User$Ids$encode(payload.g9)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 6:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.audit.record-files-added.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'recordId',
						$author$project$Audit$Record$Id$encode(payload.bK)),
						_Utils_Tuple2(
						'files',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.cT)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 7:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.audit.record-files-removed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'recordId',
						$author$project$Audit$Record$Id$encode(payload.bK)),
						_Utils_Tuple2(
						'files',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.cT)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 8:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.audit.completed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		default:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.audit.deleted.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(payload.gm)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
	}
};
var $author$project$Audit$Events$encode = $author$project$Types$Queue$encode($author$project$Audit$Event$encode);
var $author$project$Audit$Ids$encode = $turboMaCk$any_set$Set$Any$encode($author$project$Audit$Id$encode);
var $author$project$Audit$Modifications$encode = function (modifications) {
	if (!modifications.$) {
		return $elm$json$Json$Encode$null;
	} else {
		var data = modifications.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'changed',
					$author$project$Audit$Dict$encode(data.bh)),
					_Utils_Tuple2(
					'completed',
					$author$project$Audit$Ids$encode(data.b$)),
					_Utils_Tuple2(
					'deleted',
					$author$project$Audit$Ids$encode(data.dA)),
					_Utils_Tuple2(
					'lastEventId',
					$author$project$Types$EventId$encode(data.fD))
				]));
	}
};
var $author$project$Audit$Store$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_DATA'))
					]));
		case 1:
			var audits_ = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_AUDITS')),
						_Utils_Tuple2(
						'audits',
						$author$project$Audit$Audits$encode(audits_))
					]));
		case 2:
			var modifications = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_MODIFICATIONS')),
						_Utils_Tuple2(
						'modifications',
						$author$project$Audit$Modifications$encode(modifications))
					]));
		case 3:
			var commands_ = msg.a;
			var events_ = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_COMMANDS_AND_EVENTS')),
						_Utils_Tuple2(
						'commands',
						$author$project$Audit$Commands$encode(commands_)),
						_Utils_Tuple2(
						'events',
						$author$project$Audit$Events$encode(events_))
					]));
		case 4:
			var commandId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId))
					]));
		default:
			var commandId = msg.a;
			var auditId = msg.b;
			var eventVersion = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND_AND_EVENT')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId)),
						_Utils_Tuple2(
						'auditId',
						$author$project$Audit$Id$encode(auditId)),
						_Utils_Tuple2(
						'eventVersion',
						$elm$json$Json$Encode$int(eventVersion))
					]));
	}
};
var $author$project$Audit$Store$send = A2($elm$core$Basics$composeR, $author$project$Audit$Store$encodeOutMsg, $author$project$Audit$Store$auditStoreOutbox);
var $author$project$Audit$Store$load = _Utils_Tuple2(
	$author$project$Audit$Store$Loading,
	$author$project$Audit$Store$send($author$project$Audit$Store$LoadData));
var $author$project$CheckpointData$Store$LoadData = {$: 0};
var $author$project$CheckpointData$Store$Loading = {$: 0};
var $author$project$CheckpointData$Store$checkpointDataStoreOutbox = _Platform_outgoingPort('checkpointDataStoreOutbox', $elm$core$Basics$identity);
var $author$project$CheckpointData$Checkpoint$Dict$values = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$CheckpointData$Checkpoint$Dict$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$CheckpointData$Checkpoint$Dict$values,
	$elm$json$Json$Encode$list($author$project$CheckpointData$Checkpoint$Checkpoint$encode));
var $author$project$CheckpointData$CheckpointGroup$Dict$values = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$CheckpointData$CheckpointGroup$Dict$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$CheckpointData$CheckpointGroup$Dict$values,
	$elm$json$Json$Encode$list($author$project$CheckpointData$CheckpointGroup$CheckpointGroup$encode));
var $author$project$CheckpointData$CheckpointData$encodeHierarchy = function (hierarchy) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'checkpointGroups',
				$author$project$CheckpointData$CheckpointGroup$Dict$encode(hierarchy.gt)),
				_Utils_Tuple2(
				'checkpoints',
				$author$project$CheckpointData$Checkpoint$Dict$encode(hierarchy.i6))
			]));
};
var $author$project$CheckpointData$CheckpointData$encode = function (_v0) {
	var data = _v0;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hierarchy',
				$author$project$CheckpointData$CheckpointData$encodeHierarchy(data.a8)),
				_Utils_Tuple2(
				'lastEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, data.fD))
			]));
};
var $author$project$CheckpointData$Command$encode = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.create-checkpoint-group.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'prev',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.kw)),
						_Utils_Tuple2(
						'next',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.kc)),
						_Utils_Tuple2(
						'first',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.jC)),
						_Utils_Tuple2(
						'last',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.jT))
					]));
		case 1:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.change-checkpoint-group-title.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 2:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.change-checkpoint-group-description.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 3:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.move-before-checkpoint-group.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'nextId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.ax)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 4:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.move-after-checkpoint-group.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'previousId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.ay)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 5:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.delete-checkpoint-group.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'prev',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.kw)),
						_Utils_Tuple2(
						'next',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.kc)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 6:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.create-checkpoint.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'checkpointType',
						$author$project$CheckpointData$Checkpoint$CheckpointType$encode(payload.fg)),
						_Utils_Tuple2(
						'prev',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.kw)),
						_Utils_Tuple2(
						'next',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.kc)),
						_Utils_Tuple2(
						'files',
						$author$project$File$Filenames$encode(payload.cT))
					]));
		case 7:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.change-checkpoint-type.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'checkpointType',
						$author$project$CheckpointData$Checkpoint$CheckpointType$encode(payload.fg)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 8:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.change-checkpoint-title.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 9:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.change-checkpoint-description.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 10:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.change-checkpoint-files.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'addedFiles',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.iM)),
						_Utils_Tuple2(
						'deletedFiles',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.jk)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 11:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.move-checkpoint.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 12:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.move-before-checkpoint.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'nextId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.ax)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 13:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.move-after-checkpoint.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'previousId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.ay)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		default:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.delete-checkpoint.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
	}
};
var $author$project$CheckpointData$Commands$encode = $author$project$Types$Queue$encode($author$project$CheckpointData$Command$encode);
var $author$project$CheckpointData$Event$encode = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.created-checkpoint-group.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'prev',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.kw)),
						_Utils_Tuple2(
						'next',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.kc)),
						_Utils_Tuple2(
						'first',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.jC)),
						_Utils_Tuple2(
						'last',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.jT)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 1:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.changed-checkpoint-group-title.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 2:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.changed-checkpoint-group-description.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 3:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.moved-before-checkpoint-group.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'newPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.d_)),
						_Utils_Tuple2(
						'newNextId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.fJ)),
						_Utils_Tuple2(
						'oldPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.c5)),
						_Utils_Tuple2(
						'oldNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.c4)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 4:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.moved-after-checkpoint-group.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'newPreviousId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.d_)),
						_Utils_Tuple2(
						'newNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.fJ)),
						_Utils_Tuple2(
						'oldPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.c5)),
						_Utils_Tuple2(
						'oldNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.c4)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 5:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.deleted-checkpoint-group.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'oldPrev',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.kw)),
						_Utils_Tuple2(
						'oldNext',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.kc)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 6:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.created-checkpoint.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'checkpointType',
						$author$project$CheckpointData$Checkpoint$CheckpointType$encode(payload.fg)),
						_Utils_Tuple2(
						'prev',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.kw)),
						_Utils_Tuple2(
						'next',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.kc)),
						_Utils_Tuple2(
						'files',
						$author$project$File$Filenames$encode(payload.cT)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 7:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.changed-checkpoint-type.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'checkpointType',
						$author$project$CheckpointData$Checkpoint$CheckpointType$encode(payload.fg)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 8:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.changed-checkpoint-title.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 9:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.changed-checkpoint-description.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 10:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.changed-checkpoint-files.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'addedFiles',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.iM)),
						_Utils_Tuple2(
						'deletedFiles',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.jk)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 11:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.moved-checkpoint.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'newParentId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.dZ)),
						_Utils_Tuple2(
						'newPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.d_)),
						_Utils_Tuple2(
						'oldParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.g1)),
						_Utils_Tuple2(
						'oldPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.c5)),
						_Utils_Tuple2(
						'oldNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.c4)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 12:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.moved-before-checkpoint.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'newParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.dZ)),
						_Utils_Tuple2(
						'newPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.d_)),
						_Utils_Tuple2(
						'newNextId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.fJ)),
						_Utils_Tuple2(
						'oldParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.g1)),
						_Utils_Tuple2(
						'oldPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.c5)),
						_Utils_Tuple2(
						'oldNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.c4)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 13:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.moved-after-checkpoint.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$encode(payload.cC)),
						_Utils_Tuple2(
						'newParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.dZ)),
						_Utils_Tuple2(
						'newPreviousId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.d_)),
						_Utils_Tuple2(
						'newNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.fJ)),
						_Utils_Tuple2(
						'oldParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.g1)),
						_Utils_Tuple2(
						'oldPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.c5)),
						_Utils_Tuple2(
						'oldNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$Checkpoint$Id$encode, payload.c4)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		default:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.checkpoint-group.deleted-checkpoint.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$encode(payload.i5)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
	}
};
var $author$project$CheckpointData$Events$encode = $author$project$Types$Queue$encode($author$project$CheckpointData$Event$encode);
var $author$project$CheckpointData$Checkpoint$Ids$encode = $turboMaCk$any_set$Set$Any$encode($author$project$CheckpointData$Checkpoint$Id$encode);
var $author$project$CheckpointData$CheckpointGroup$Ids$encode = $turboMaCk$any_set$Set$Any$encode($author$project$CheckpointData$CheckpointGroup$Id$encode);
var $author$project$CheckpointData$Modifications$encode = function (modifications) {
	if (!modifications.$) {
		return $elm$json$Json$Encode$null;
	} else {
		var data = modifications.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'changedCheckpointGroups',
					$author$project$CheckpointData$CheckpointGroup$Dict$encode(data.bW)),
					_Utils_Tuple2(
					'deletedCheckpointGroups',
					$author$project$CheckpointData$CheckpointGroup$Ids$encode(data.b1)),
					_Utils_Tuple2(
					'changedCheckpoints',
					$author$project$CheckpointData$Checkpoint$Dict$encode(data.bX)),
					_Utils_Tuple2(
					'deletedCheckpoints',
					$author$project$CheckpointData$Checkpoint$Ids$encode(data.b2)),
					_Utils_Tuple2(
					'lastEventId',
					$author$project$Types$EventId$encode(data.fD))
				]));
	}
};
var $author$project$CheckpointData$Store$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_DATA'))
					]));
		case 1:
			var checkpointData_ = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_CHECKPOINT_DATA')),
						_Utils_Tuple2(
						'checkpointData',
						$author$project$CheckpointData$CheckpointData$encode(checkpointData_))
					]));
		case 2:
			var modifications = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_MODIFICATIONS')),
						_Utils_Tuple2(
						'modifications',
						$author$project$CheckpointData$Modifications$encode(modifications))
					]));
		case 3:
			var commands_ = msg.a;
			var events_ = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_COMMANDS_AND_EVENTS')),
						_Utils_Tuple2(
						'commands',
						$author$project$CheckpointData$Commands$encode(commands_)),
						_Utils_Tuple2(
						'events',
						$author$project$CheckpointData$Events$encode(events_))
					]));
		case 4:
			var commandId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId))
					]));
		default:
			var commandId = msg.a;
			var eventVersion = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND_AND_EVENT')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId)),
						_Utils_Tuple2(
						'eventVersion',
						$elm$json$Json$Encode$int(eventVersion))
					]));
	}
};
var $author$project$CheckpointData$Store$send = A2($elm$core$Basics$composeR, $author$project$CheckpointData$Store$encodeOutMsg, $author$project$CheckpointData$Store$checkpointDataStoreOutbox);
var $author$project$CheckpointData$Store$load = _Utils_Tuple2(
	$author$project$CheckpointData$Store$Loading,
	$author$project$CheckpointData$Store$send($author$project$CheckpointData$Store$LoadData));
var $author$project$File$Store$LoadFiles = {$: 0};
var $author$project$File$Store$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Queue$Queue = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Types$Queue$empty = A2($author$project$Types$Queue$Queue, _List_Nil, _List_Nil);
var $author$project$File$Operations$empty = $author$project$Types$Queue$empty;
var $author$project$Measure$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Measure$Id$encode = A2($elm$core$Basics$composeR, $author$project$Measure$Id$toString, $elm$json$Json$Encode$string);
var $author$project$File$File$encodeStatus = function (status) {
	switch (status) {
		case 0:
			return $elm$json$Json$Encode$string('LOCAL');
		case 1:
			return $elm$json$Json$Encode$string('REMOTE');
		default:
			return $elm$json$Json$Encode$string('SYNCHRONIZED');
	}
};
var $author$project$File$File$encodeMeasureImage = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('MEASURE_IMAGE')),
				_Utils_Tuple2(
				'measureId',
				$author$project$Measure$Id$encode(data.h5)),
				_Utils_Tuple2(
				'organisationUnitId',
				$author$project$OrganisationUnit$Id$encode(data.km)),
				_Utils_Tuple2(
				'filename',
				$author$project$File$Filename$encode(data.P)),
				_Utils_Tuple2(
				'status',
				$author$project$File$File$encodeStatus(data.kU)),
				_Utils_Tuple2(
				'deleted',
				$elm$json$Json$Encode$bool(data.dA))
			]));
};
var $author$project$File$File$encodeOrganisationUnitFileType = function (type_) {
	if (!type_) {
		return $elm$json$Json$Encode$string('FLOORPLAN');
	} else {
		return $elm$json$Json$Encode$string('COMMONFILE');
	}
};
var $author$project$File$File$encodeOrganisationUnitFile = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('ORGANISATION_UNIT_FILE')),
				_Utils_Tuple2(
				'filename',
				$author$project$File$Filename$encode(data.P)),
				_Utils_Tuple2(
				'organisationUnitId',
				$author$project$OrganisationUnit$Id$encode(data.km)),
				_Utils_Tuple2(
				'status',
				$author$project$File$File$encodeStatus(data.kU)),
				_Utils_Tuple2(
				'deleted',
				$elm$json$Json$Encode$bool(data.dA)),
				_Utils_Tuple2(
				'fileType',
				$author$project$File$File$encodeOrganisationUnitFileType(data.fs))
			]));
};
var $author$project$File$File$encodeRecordImage = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('RECORD_IMAGE')),
				_Utils_Tuple2(
				'filename',
				$author$project$File$Filename$encode(data.P)),
				_Utils_Tuple2(
				'auditId',
				$author$project$Audit$Id$encode(data.gm)),
				_Utils_Tuple2(
				'recordId',
				$author$project$Audit$Record$Id$encode(data.bK)),
				_Utils_Tuple2(
				'status',
				$author$project$File$File$encodeStatus(data.kU)),
				_Utils_Tuple2(
				'deleted',
				$elm$json$Json$Encode$bool(data.dA))
			]));
};
var $author$project$File$File$encodeUserAvatar = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('USER_AVATAR')),
				_Utils_Tuple2(
				'filename',
				$author$project$File$Filename$encode(data.P)),
				_Utils_Tuple2(
				'userId',
				$author$project$User$Id$encode(data.dk)),
				_Utils_Tuple2(
				'status',
				$author$project$File$File$encodeStatus(data.kU)),
				_Utils_Tuple2(
				'deleted',
				$elm$json$Json$Encode$bool(data.dA))
			]));
};
var $author$project$File$File$encode = function (file) {
	switch (file.$) {
		case 0:
			var data = file.a;
			return $author$project$File$File$encodeUserAvatar(data);
		case 1:
			var data = file.a;
			return $author$project$File$File$encodeOrganisationUnitFile(data);
		case 2:
			var data = file.a;
			return $author$project$File$File$encodeMeasureImage(data);
		default:
			var data = file.a;
			return $author$project$File$File$encodeRecordImage(data);
	}
};
var $author$project$File$Dict$encode = A2(
	$elm$core$Basics$composeR,
	$turboMaCk$any_dict$Dict$Any$values,
	$elm$json$Json$Encode$list($author$project$File$File$encode));
var $author$project$File$Files$unwrap = function (_v0) {
	var dict = _v0;
	return dict;
};
var $author$project$File$Files$encode = A2($elm$core$Basics$composeR, $author$project$File$Files$unwrap, $author$project$File$Dict$encode);
var $author$project$File$Modifications$encode = function (modifications) {
	if (!modifications.$) {
		return $elm$json$Json$Encode$null;
	} else {
		var data = modifications.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'changed',
					$author$project$File$Dict$encode(data.bh)),
					_Utils_Tuple2(
					'deleted',
					$author$project$File$Filenames$encode(data.dA))
				]));
	}
};
var $author$project$File$Store$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_FILES'))
					]));
		case 1:
			var files = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_FILES')),
						_Utils_Tuple2(
						'files',
						$author$project$File$Files$encode(files))
					]));
		case 2:
			var modifications = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_MODIFICATIONS')),
						_Utils_Tuple2(
						'modifications',
						$author$project$File$Modifications$encode(modifications))
					]));
		case 3:
			var apiVersion = msg.a;
			var path = msg.b;
			var file = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('UPLOAD_FILE')),
						_Utils_Tuple2(
						'file',
						$author$project$File$File$encode(file)),
						_Utils_Tuple2(
						'apiVersion',
						$elm$json$Json$Encode$int(apiVersion)),
						_Utils_Tuple2(
						'path',
						$elm$json$Json$Encode$string(path))
					]));
		case 4:
			var apiVersion = msg.a;
			var path = msg.b;
			var file = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DOWNLOAD_FILE')),
						_Utils_Tuple2(
						'file',
						$author$project$File$File$encode(file)),
						_Utils_Tuple2(
						'apiVersion',
						$elm$json$Json$Encode$int(apiVersion)),
						_Utils_Tuple2(
						'path',
						$elm$json$Json$Encode$string(path))
					]));
		default:
			var apiVersion = msg.a;
			var path = msg.b;
			var file = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DELETE_FILE')),
						_Utils_Tuple2(
						'apiVersion',
						$elm$json$Json$Encode$int(apiVersion)),
						_Utils_Tuple2(
						'file',
						$author$project$File$File$encode(file)),
						_Utils_Tuple2(
						'path',
						$elm$json$Json$Encode$string(path))
					]));
	}
};
var $author$project$File$Store$fileStoreOutbox = _Platform_outgoingPort('fileStoreOutbox', $elm$core$Basics$identity);
var $author$project$File$Store$send = A2($elm$core$Basics$composeR, $author$project$File$Store$encodeOutMsg, $author$project$File$Store$fileStoreOutbox);
var $author$project$File$Store$load = _Utils_Tuple2(
	$author$project$File$Store$Loading(
		{Q: $author$project$File$Operations$empty, V: $author$project$File$Operations$empty}),
	$author$project$File$Store$send($author$project$File$Store$LoadFiles));
var $author$project$Measure$Store$LoadData = {$: 0};
var $author$project$Measure$Store$Loading = {$: 0};
var $author$project$Measure$MeasureType$encode = function (measureType) {
	if (!measureType.$) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'measureType',
					$elm$json$Json$Encode$string('Task'))
				]));
	} else {
		var issueData = measureType.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'measureType',
					$elm$json$Json$Encode$string('Issue')),
					_Utils_Tuple2(
					'checkpointId',
					$author$project$CheckpointData$Checkpoint$Id$encode(issueData.i5)),
					_Utils_Tuple2(
					'auditId',
					$author$project$Audit$Id$encode(issueData.gm)),
					_Utils_Tuple2(
					'recordId',
					$author$project$Audit$Record$Id$encode(issueData.bK))
				]));
	}
};
var $author$project$Measure$Command$encode = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.measure.create.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(payload.fw)),
						_Utils_Tuple2(
						'measureType',
						$author$project$Measure$MeasureType$encode(payload.h6)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'creationTimestamp',
						$author$project$Utils$Encode$timestamp(payload.dw)),
						_Utils_Tuple2(
						'deadlineTimestamp',
						A2($author$project$Utils$Encode$maybe, $author$project$Utils$Encode$timestamp, payload.hI)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'creatorId',
						$author$project$User$Id$encode(payload.jd)),
						_Utils_Tuple2(
						'images',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.fx)),
						_Utils_Tuple2(
						'responsibleUsers',
						$author$project$User$Ids$encode(payload.bb))
					]));
		case 1:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.measure.change-title.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 2:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.measure.change-description.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 3:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.measure.change-responsible-users.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'addResponsibleUsers',
						$author$project$User$Ids$encode(payload.e9)),
						_Utils_Tuple2(
						'removeResponsibleUsers',
						$author$project$User$Ids$encode(payload.f_)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 4:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.measure.change-deadline.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'deadlineTimestamp',
						A2($author$project$Utils$Encode$maybe, $author$project$Utils$Encode$timestamp, payload.hI)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 5:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.measure.change-organisation-unit.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 6:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.measure.add-images.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'addImages',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.gf)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 7:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.measure.remove-images.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'removeImages',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.ha)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 8:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.measure.complete.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		default:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.measure.delete.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'idForError',
						$elm$json$Json$Encode$string(payload.k)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
	}
};
var $author$project$Measure$Commands$encode = $author$project$Types$Queue$encode($author$project$Measure$Command$encode);
var $author$project$Measure$Event$encode = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.measure.created.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(payload.fw)),
						_Utils_Tuple2(
						'measureType',
						$author$project$Measure$MeasureType$encode(payload.h6)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'creationTimestamp',
						$author$project$Utils$Encode$timestamp(payload.dw)),
						_Utils_Tuple2(
						'deadlineTimestamp',
						A2($author$project$Utils$Encode$maybe, $author$project$Utils$Encode$timestamp, payload.hI)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'creatorId',
						$author$project$User$Id$encode(payload.jd)),
						_Utils_Tuple2(
						'images',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.fx)),
						_Utils_Tuple2(
						'responsibleUsers',
						$author$project$User$Ids$encode(payload.bb)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 1:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.measure.title-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 2:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.measure.description-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 3:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.measure.responsible-users-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'addResponsibleUsers',
						$author$project$User$Ids$encode(payload.e9)),
						_Utils_Tuple2(
						'removeResponsibleUsers',
						$author$project$User$Ids$encode(payload.f_)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 4:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.measure.deadline-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'deadlineTimestamp',
						A2($author$project$Utils$Encode$maybe, $author$project$Utils$Encode$timestamp, payload.hI)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 5:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.measure.organisation-unit-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 6:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.measure.images-added.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'addImages',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.gf)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 7:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.measure.images-removed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'removeImages',
						A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, payload.ha)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 8:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.measure.completed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		default:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.measure.deleted.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(payload.h5)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
	}
};
var $author$project$Measure$Events$encode = $author$project$Types$Queue$encode($author$project$Measure$Event$encode);
var $author$project$Measure$Measures$unwrap = function (_v0) {
	var data = _v0;
	return data;
};
var $author$project$Measure$Measures$dict = A2(
	$elm$core$Basics$composeR,
	$author$project$Measure$Measures$unwrap,
	function ($) {
		return $.cL;
	});
var $author$project$Measure$CompletionStatus$encode = function (completionStatus) {
	if (!completionStatus.$) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'CompletionType',
					$elm$json$Json$Encode$string('Open'))
				]));
	} else {
		var posix = completionStatus.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'CompletionType',
					$elm$json$Json$Encode$string('Completed')),
					_Utils_Tuple2(
					'timestamp',
					$author$project$Utils$Encode$timestamp(posix))
				]));
	}
};
var $author$project$Measure$Measure$encode = function (measure) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'measureId',
				$author$project$Measure$Id$encode(measure.h5)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(measure.fw)),
				_Utils_Tuple2(
				'measureType',
				$author$project$Measure$MeasureType$encode(measure.h6)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(measure.k8)),
				_Utils_Tuple2(
				'description',
				$author$project$Utils$Encode$nullIfBlankString(measure.aY)),
				_Utils_Tuple2(
				'creationTimestamp',
				$author$project$Utils$Encode$timestamp(measure.dw)),
				_Utils_Tuple2(
				'deadlineTimestamp',
				A2($author$project$Utils$Encode$maybe, $author$project$Utils$Encode$timestamp, measure.hI)),
				_Utils_Tuple2(
				'organisationUnitId',
				$author$project$OrganisationUnit$Id$encode(measure.km)),
				_Utils_Tuple2(
				'creatorId',
				$author$project$User$Id$encode(measure.jd)),
				_Utils_Tuple2(
				'images',
				A2($elm$json$Json$Encode$list, $author$project$File$Filename$encode, measure.fx)),
				_Utils_Tuple2(
				'responsibleUsers',
				$author$project$User$Ids$encode(measure.bb)),
				_Utils_Tuple2(
				'completionStatus',
				$author$project$Measure$CompletionStatus$encode(measure.jb)),
				_Utils_Tuple2(
				'revision',
				$elm$json$Json$Encode$int(measure.i))
			]));
};
var $author$project$Measure$Dict$values = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$Measure$Dict$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Measure$Dict$values,
	$elm$json$Json$Encode$list($author$project$Measure$Measure$encode));
var $author$project$Measure$Measures$lastEventId = A2(
	$elm$core$Basics$composeR,
	$author$project$Measure$Measures$unwrap,
	function ($) {
		return $.fD;
	});
var $author$project$Measure$Measures$encode = function (measures) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'measures',
				$author$project$Measure$Dict$encode(
					$author$project$Measure$Measures$dict(measures))),
				_Utils_Tuple2(
				'lastEventId',
				A2(
					$author$project$Utils$Encode$maybe,
					$author$project$Types$EventId$encode,
					$author$project$Measure$Measures$lastEventId(measures)))
			]));
};
var $author$project$Measure$Ids$encode = $turboMaCk$any_set$Set$Any$encode($author$project$Measure$Id$encode);
var $author$project$Measure$Modifications$encode = function (modifications) {
	if (!modifications.$) {
		return $elm$json$Json$Encode$null;
	} else {
		var data = modifications.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'changed',
					$author$project$Measure$Dict$encode(data.bh)),
					_Utils_Tuple2(
					'completed',
					$author$project$Measure$Ids$encode(data.b$)),
					_Utils_Tuple2(
					'deleted',
					$author$project$Measure$Ids$encode(data.dA)),
					_Utils_Tuple2(
					'lastEventId',
					$author$project$Types$EventId$encode(data.fD))
				]));
	}
};
var $author$project$Measure$Store$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_DATA'))
					]));
		case 1:
			var measures_ = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_MEASURES')),
						_Utils_Tuple2(
						'measures',
						$author$project$Measure$Measures$encode(measures_))
					]));
		case 2:
			var modifications = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_MODIFICATIONS')),
						_Utils_Tuple2(
						'modifications',
						$author$project$Measure$Modifications$encode(modifications))
					]));
		case 3:
			var commands_ = msg.a;
			var events_ = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_COMMANDS_AND_EVENTS')),
						_Utils_Tuple2(
						'commands',
						$author$project$Measure$Commands$encode(commands_)),
						_Utils_Tuple2(
						'events',
						$author$project$Measure$Events$encode(events_))
					]));
		case 4:
			var commandId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId))
					]));
		default:
			var commandId = msg.a;
			var measureId = msg.b;
			var eventVersion = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND_AND_EVENT')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId)),
						_Utils_Tuple2(
						'measureId',
						$author$project$Measure$Id$encode(measureId)),
						_Utils_Tuple2(
						'eventVersion',
						$elm$json$Json$Encode$int(eventVersion))
					]));
	}
};
var $author$project$Measure$Store$measureStoreOutbox = _Platform_outgoingPort('measureStoreOutbox', $elm$core$Basics$identity);
var $author$project$Measure$Store$send = A2($elm$core$Basics$composeR, $author$project$Measure$Store$encodeOutMsg, $author$project$Measure$Store$measureStoreOutbox);
var $author$project$Measure$Store$load = _Utils_Tuple2(
	$author$project$Measure$Store$Loading,
	$author$project$Measure$Store$send($author$project$Measure$Store$LoadData));
var $author$project$OrganisationUnit$Store$LoadData = {$: 0};
var $author$project$OrganisationUnit$Store$Loading = {$: 0};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$UI$Style$Color$unsafeInt255Digits = function (n) {
	var digit1 = (n / 16) | 0;
	var digit0 = (!(!digit1)) ? A2($elm$core$Basics$modBy, digit1 * 16, n) : n;
	return _Utils_Tuple2(digit1, digit0);
};
var $author$project$UI$Style$Color$unsafeIntToChar = function (i) {
	if (i < 10) {
		return A2(
			$elm$core$Maybe$withDefault,
			'0',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$elm$core$String$uncons(
					$elm$core$String$fromInt(i))));
	} else {
		switch (i) {
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				return '0';
		}
	}
};
var $author$project$UI$Style$Color$int255ToHex = function (n) {
	return (n < 0) ? '00' : ((n > 255) ? 'ff' : function (_v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(
			$elm$core$String$cons,
			a,
			A2($elm$core$String$cons, b, ''));
	}(
		A3(
			$elm$core$Tuple$mapBoth,
			$author$project$UI$Style$Color$unsafeIntToChar,
			$author$project$UI$Style$Color$unsafeIntToChar,
			$author$project$UI$Style$Color$unsafeInt255Digits(n))));
};
var $elm$core$Basics$round = _Basics_round;
var $author$project$UI$Style$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {eq: a, iZ: b, jE: g, kz: r};
};
var $author$project$UI$Style$Color$toHex = function (c) {
	var components = $author$project$UI$Style$Color$toRgba(c);
	return '#' + $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			$author$project$UI$Style$Color$int255ToHex,
			A2(
				$elm$core$List$map,
				$elm$core$Basics$round,
				A2(
					$elm$core$List$map,
					$elm$core$Basics$mul(255),
					_List_fromArray(
						[components.kz, components.jE, components.iZ, components.eq])))));
};
var $author$project$UI$Style$Color$encode = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$UI$Style$Color$toHex);
var $author$project$OrganisationUnit$Command$encode = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.create.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'floorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.ap)),
						_Utils_Tuple2(
						'firstGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.ao)),
						_Utils_Tuple2(
						'lastGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.jU)),
						_Utils_Tuple2(
						'color',
						$author$project$UI$Style$Color$encode(payload.K))
					]));
		case 1:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.create-child.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'parentId',
						$author$project$OrganisationUnit$Id$encode(payload.fV)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'floorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.ap)),
						_Utils_Tuple2(
						'firstGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.ao)),
						_Utils_Tuple2(
						'lastGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.jU)),
						_Utils_Tuple2(
						'color',
						$author$project$UI$Style$Color$encode(payload.K))
					]));
		case 2:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.create-before.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'nextId',
						$author$project$OrganisationUnit$Id$encode(payload.ax)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'floorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.ap)),
						_Utils_Tuple2(
						'firstGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.ao)),
						_Utils_Tuple2(
						'lastGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.jU)),
						_Utils_Tuple2(
						'color',
						$author$project$UI$Style$Color$encode(payload.K))
					]));
		case 3:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.create-after.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'previousId',
						$author$project$OrganisationUnit$Id$encode(payload.ay)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'floorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.ap)),
						_Utils_Tuple2(
						'firstGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.ao)),
						_Utils_Tuple2(
						'lastGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.jU)),
						_Utils_Tuple2(
						'color',
						$author$project$UI$Style$Color$encode(payload.K))
					]));
		case 4:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.move.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'parentId',
						$author$project$OrganisationUnit$Id$encode(payload.fV)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 5:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.move-before.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'parentId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.fV)),
						_Utils_Tuple2(
						'nextId',
						$author$project$OrganisationUnit$Id$encode(payload.ax)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 6:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.move-after.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'parentId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.fV)),
						_Utils_Tuple2(
						'previousId',
						$author$project$OrganisationUnit$Id$encode(payload.ay)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 7:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.change-title.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 8:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.change-description.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 9:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.change-color.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'color',
						$author$project$UI$Style$Color$encode(payload.K)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 10:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.change-floorPlan.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'newFloorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.fI)),
						_Utils_Tuple2(
						'oldFloorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.fM)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		default:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.delete.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
	}
};
var $author$project$OrganisationUnit$Commands$encode = $author$project$Types$Queue$encode($author$project$OrganisationUnit$Command$encode);
var $author$project$OrganisationUnit$Ids$encode = $turboMaCk$any_set$Set$Any$encode($author$project$OrganisationUnit$Id$encode);
var $author$project$OrganisationUnit$Event$encode = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.created.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'previousId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.ay)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'floorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.ap)),
						_Utils_Tuple2(
						'firstGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.ao)),
						_Utils_Tuple2(
						'lastGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.jU)),
						_Utils_Tuple2(
						'color',
						$author$project$UI$Style$Color$encode(payload.K)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 1:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.child-created.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'parentId',
						$author$project$OrganisationUnit$Id$encode(payload.fV)),
						_Utils_Tuple2(
						'previousId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.ay)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'floorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.ap)),
						_Utils_Tuple2(
						'firstGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.ao)),
						_Utils_Tuple2(
						'lastGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.jU)),
						_Utils_Tuple2(
						'color',
						$author$project$UI$Style$Color$encode(payload.K)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 2:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.created-before.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'parentId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.fV)),
						_Utils_Tuple2(
						'previousId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.ay)),
						_Utils_Tuple2(
						'nextId',
						$author$project$OrganisationUnit$Id$encode(payload.ax)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'floorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.ap)),
						_Utils_Tuple2(
						'firstGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.ao)),
						_Utils_Tuple2(
						'lastGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.jU)),
						_Utils_Tuple2(
						'color',
						$author$project$UI$Style$Color$encode(payload.K)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 3:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.created-after.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'parentId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.fV)),
						_Utils_Tuple2(
						'previousId',
						$author$project$OrganisationUnit$Id$encode(payload.ay)),
						_Utils_Tuple2(
						'nextId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.ax)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'floorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.ap)),
						_Utils_Tuple2(
						'firstGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.ao)),
						_Utils_Tuple2(
						'lastGroup',
						A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, payload.jU)),
						_Utils_Tuple2(
						'color',
						$author$project$UI$Style$Color$encode(payload.K)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 4:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.moved.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'newParentId',
						$author$project$OrganisationUnit$Id$encode(payload.dZ)),
						_Utils_Tuple2(
						'newPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.d_)),
						_Utils_Tuple2(
						'oldParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.g1)),
						_Utils_Tuple2(
						'oldPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.c5)),
						_Utils_Tuple2(
						'oldNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.c4)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 5:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.moved-before.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'newParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.dZ)),
						_Utils_Tuple2(
						'newPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.d_)),
						_Utils_Tuple2(
						'newNextId',
						$author$project$OrganisationUnit$Id$encode(payload.fJ)),
						_Utils_Tuple2(
						'oldParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.g1)),
						_Utils_Tuple2(
						'oldPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.c5)),
						_Utils_Tuple2(
						'oldNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.c4)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 6:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.moved-after.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'newParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.dZ)),
						_Utils_Tuple2(
						'newPreviousId',
						$author$project$OrganisationUnit$Id$encode(payload.d_)),
						_Utils_Tuple2(
						'newNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.fJ)),
						_Utils_Tuple2(
						'oldParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.g1)),
						_Utils_Tuple2(
						'oldPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.c5)),
						_Utils_Tuple2(
						'oldNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.c4)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 7:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.title-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 8:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.description-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 9:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.color-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'color',
						$author$project$UI$Style$Color$encode(payload.K)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 10:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.floor-plan-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'newFloorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.fI)),
						_Utils_Tuple2(
						'oldFloorPlan',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.fM)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		default:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.organisation-unit.deleted.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$encode(payload.km)),
						_Utils_Tuple2(
						'oldParentId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.g1)),
						_Utils_Tuple2(
						'oldPreviousId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.c5)),
						_Utils_Tuple2(
						'oldNextId',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.c4)),
						_Utils_Tuple2(
						'descendantOrganisationUnits',
						$author$project$OrganisationUnit$Ids$encode(payload.hK)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
	}
};
var $author$project$OrganisationUnit$Events$encode = $author$project$Types$Queue$encode($author$project$OrganisationUnit$Event$encode);
var $author$project$OrganisationUnit$OrganisationUnit$encode = function (organisationUnit) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'organisationUnitId',
				$author$project$OrganisationUnit$Id$encode(organisationUnit.km)),
				_Utils_Tuple2(
				'parentId',
				A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, organisationUnit.fV)),
				_Utils_Tuple2(
				'previousId',
				A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, organisationUnit.ay)),
				_Utils_Tuple2(
				'nextId',
				A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, organisationUnit.ax)),
				_Utils_Tuple2(
				'firstChildId',
				A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, organisationUnit.hV)),
				_Utils_Tuple2(
				'lastChildId',
				A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, organisationUnit.fC)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(organisationUnit.k8)),
				_Utils_Tuple2(
				'description',
				$author$project$Utils$Encode$nullIfBlankString(organisationUnit.aY)),
				_Utils_Tuple2(
				'floorPlan',
				A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, organisationUnit.ap)),
				_Utils_Tuple2(
				'firstGroup',
				A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, organisationUnit.ao)),
				_Utils_Tuple2(
				'lastGroup',
				A2($author$project$Utils$Encode$maybe, $author$project$CheckpointData$CheckpointGroup$Id$encode, organisationUnit.jU)),
				_Utils_Tuple2(
				'color',
				$author$project$UI$Style$Color$encode(organisationUnit.K)),
				_Utils_Tuple2(
				'revision',
				$elm$json$Json$Encode$int(organisationUnit.i))
			]));
};
var $author$project$OrganisationUnit$Dict$values = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$OrganisationUnit$Dict$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$OrganisationUnit$Dict$values,
	$elm$json$Json$Encode$list($author$project$OrganisationUnit$OrganisationUnit$encode));
var $author$project$OrganisationUnit$Modifications$encode = function (modifications) {
	if (!modifications.$) {
		return $elm$json$Json$Encode$null;
	} else {
		var data = modifications.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'changedOrganisationUnits',
					$author$project$OrganisationUnit$Dict$encode(data.hC)),
					_Utils_Tuple2(
					'deletedOrganisationUnits',
					$author$project$OrganisationUnit$Dict$encode(data.dB)),
					_Utils_Tuple2(
					'firstId',
					A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, data.eC)),
					_Utils_Tuple2(
					'lastId',
					A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, data.eI)),
					_Utils_Tuple2(
					'lastEventId',
					$author$project$Types$EventId$encode(data.fD))
				]));
	}
};
var $author$project$OrganisationUnit$Hierarchy$encode = function (_v0) {
	var data = _v0;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'organisationUnits',
				$author$project$OrganisationUnit$Dict$encode(data.kn)),
				_Utils_Tuple2(
				'deletedOrganisationUnits',
				$author$project$OrganisationUnit$Dict$encode(data.dB)),
				_Utils_Tuple2(
				'firstId',
				A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, data.eC)),
				_Utils_Tuple2(
				'lastId',
				A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, data.eI))
			]));
};
var $author$project$OrganisationUnit$OrganisationUnits$encode = function (_v0) {
	var data = _v0;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hierarchy',
				$author$project$OrganisationUnit$Hierarchy$encode(data.a8)),
				_Utils_Tuple2(
				'lastEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, data.fD)),
				_Utils_Tuple2(
				'rootList',
				A2($elm$json$Json$Encode$list, $author$project$OrganisationUnit$Id$encode, data.f2))
			]));
};
var $author$project$OrganisationUnit$Store$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_DATA'))
					]));
		case 1:
			var organisationUnits_ = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_ORGANISATION_UNITS')),
						_Utils_Tuple2(
						'organisationUnits',
						$author$project$OrganisationUnit$OrganisationUnits$encode(organisationUnits_))
					]));
		case 2:
			var modifications = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_MODIFICATIONS')),
						_Utils_Tuple2(
						'modifications',
						$author$project$OrganisationUnit$Modifications$encode(modifications))
					]));
		case 3:
			var commands_ = msg.a;
			var events_ = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_COMMANDS_AND_EVENTS')),
						_Utils_Tuple2(
						'commands',
						$author$project$OrganisationUnit$Commands$encode(commands_)),
						_Utils_Tuple2(
						'events',
						$author$project$OrganisationUnit$Events$encode(events_))
					]));
		case 4:
			var commandId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId))
					]));
		default:
			var commandId = msg.a;
			var eventVersion = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND_AND_EVENT')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId)),
						_Utils_Tuple2(
						'eventVersion',
						$elm$json$Json$Encode$int(eventVersion))
					]));
	}
};
var $author$project$OrganisationUnit$Store$organisationUnitStoreOutbox = _Platform_outgoingPort('organisationUnitStoreOutbox', $elm$core$Basics$identity);
var $author$project$OrganisationUnit$Store$send = A2($elm$core$Basics$composeR, $author$project$OrganisationUnit$Store$encodeOutMsg, $author$project$OrganisationUnit$Store$organisationUnitStoreOutbox);
var $author$project$OrganisationUnit$Store$load = _Utils_Tuple2(
	$author$project$OrganisationUnit$Store$Loading,
	$author$project$OrganisationUnit$Store$send($author$project$OrganisationUnit$Store$LoadData));
var $author$project$Plan$Store$LoadData = {$: 0};
var $author$project$Plan$Store$Loading = {$: 0};
var $author$project$Plan$Schedule$Frequency$Daily = 0;
var $author$project$Plan$Schedule$Frequency$toString = function (frequency) {
	switch (frequency) {
		case 0:
			return 'DAILY';
		case 1:
			return 'WEEKLY';
		case 2:
			return 'MONTHLY';
		default:
			return 'YEARLY';
	}
};
var $author$project$Plan$Schedule$Frequency$encode = A2($elm$core$Basics$composeR, $author$project$Plan$Schedule$Frequency$toString, $elm$json$Json$Encode$string);
var $author$project$Plan$Schedule$Schedule$encodeDailyModel = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'frequency',
				$author$project$Plan$Schedule$Frequency$encode(0)),
				_Utils_Tuple2(
				'interval',
				$elm$json$Json$Encode$int(model.a0)),
				_Utils_Tuple2(
				'creatingTime',
				$author$project$Date_Time$NaiveTime$encode(model.aV)),
				_Utils_Tuple2(
				'deadlineTime',
				$author$project$Date_Time$NaiveTime$encode(model.ex)),
				_Utils_Tuple2(
				'startDate',
				$author$project$Date_Time$NaiveDate$encode(model.a2)),
				_Utils_Tuple2(
				'endDate',
				A2($author$project$Utils$Encode$maybe, $author$project$Date_Time$NaiveDate$encode, model.aZ)),
				_Utils_Tuple2(
				'timeZone',
				$elm$json$Json$Encode$string(model.el))
			]));
};
var $author$project$Plan$Schedule$Frequency$Monthly = 2;
var $author$project$Plan$Schedule$Schedule$encodeMonthlyModel = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'frequency',
				$author$project$Plan$Schedule$Frequency$encode(2)),
				_Utils_Tuple2(
				'interval',
				$elm$json$Json$Encode$int(model.a0)),
				_Utils_Tuple2(
				'day',
				$elm$json$Json$Encode$int(model.dz)),
				_Utils_Tuple2(
				'creatingTime',
				$author$project$Date_Time$NaiveTime$encode(model.aV)),
				_Utils_Tuple2(
				'deadlineTime',
				$author$project$Date_Time$NaiveTime$encode(model.ex)),
				_Utils_Tuple2(
				'startDate',
				$author$project$Date_Time$NaiveDate$encode(model.a2)),
				_Utils_Tuple2(
				'endDate',
				A2($author$project$Utils$Encode$maybe, $author$project$Date_Time$NaiveDate$encode, model.aZ)),
				_Utils_Tuple2(
				'timeZone',
				$elm$json$Json$Encode$string(model.el))
			]));
};
var $author$project$Plan$Schedule$Frequency$Weekly = 1;
var $author$project$Date_Time$Weekday$toString = function (weekday) {
	switch (weekday) {
		case 0:
			return 'MONDAY';
		case 1:
			return 'TUESDAY';
		case 2:
			return 'WEDNESDAY';
		case 3:
			return 'THURSDAY';
		case 4:
			return 'FRIDAY';
		case 5:
			return 'SATURDAY';
		default:
			return 'SUNDAY';
	}
};
var $author$project$Date_Time$Weekday$encode = A2($elm$core$Basics$composeR, $author$project$Date_Time$Weekday$toString, $elm$json$Json$Encode$string);
var $author$project$Date_Time$Weekday$Friday = 4;
var $author$project$Date_Time$Weekday$Monday = 0;
var $author$project$Date_Time$Weekday$Saturday = 5;
var $author$project$Date_Time$Weekday$Sunday = 6;
var $author$project$Date_Time$Weekday$Thursday = 3;
var $author$project$Date_Time$Weekday$Tuesday = 1;
var $author$project$Date_Time$Weekday$Wednesday = 2;
var $author$project$Date_Time$Weekday$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6]);
var $author$project$Date_Time$Weekdays$weekdayToInt = function (weekday) {
	switch (weekday) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 8;
		case 4:
			return 16;
		case 5:
			return 32;
		default:
			return 64;
	}
};
var $author$project$Date_Time$Weekdays$member = F2(
	function (weekday, _v0) {
		var value = _v0;
		var i = $author$project$Date_Time$Weekdays$weekdayToInt(weekday);
		return _Utils_eq(i & value, i);
	});
var $author$project$Date_Time$Weekdays$toList = function (weekdays) {
	var maybeAddWeekdayToList = F2(
		function (weekday, acc) {
			return A2($author$project$Date_Time$Weekdays$member, weekday, weekdays) ? A2($elm$core$List$cons, weekday, acc) : acc;
		});
	return A3($elm$core$List$foldl, maybeAddWeekdayToList, _List_Nil, $author$project$Date_Time$Weekday$all);
};
var $author$project$Date_Time$Weekdays$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Date_Time$Weekdays$toList,
	$elm$json$Json$Encode$list($author$project$Date_Time$Weekday$encode));
var $author$project$Plan$Schedule$Schedule$encodeWeeklyModel = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'frequency',
				$author$project$Plan$Schedule$Frequency$encode(1)),
				_Utils_Tuple2(
				'interval',
				$elm$json$Json$Encode$int(model.a0)),
				_Utils_Tuple2(
				'weekdays',
				$author$project$Date_Time$Weekdays$encode(model.hq)),
				_Utils_Tuple2(
				'creatingTime',
				$author$project$Date_Time$NaiveTime$encode(model.aV)),
				_Utils_Tuple2(
				'deadlineTime',
				$author$project$Date_Time$NaiveTime$encode(model.ex)),
				_Utils_Tuple2(
				'startDate',
				$author$project$Date_Time$NaiveDate$encode(model.a2)),
				_Utils_Tuple2(
				'endDate',
				A2($author$project$Utils$Encode$maybe, $author$project$Date_Time$NaiveDate$encode, model.aZ)),
				_Utils_Tuple2(
				'timeZone',
				$elm$json$Json$Encode$string(model.el))
			]));
};
var $author$project$Plan$Schedule$Frequency$Yearly = 3;
var $author$project$Date_Time$Month$toString = function (month) {
	switch (month) {
		case 0:
			return 'JANUARY';
		case 1:
			return 'FEBRUARY';
		case 2:
			return 'MARCH';
		case 3:
			return 'APRIL';
		case 4:
			return 'MAY';
		case 5:
			return 'JUNE';
		case 6:
			return 'July';
		case 7:
			return 'AUGUST';
		case 8:
			return 'SEPTEMBER';
		case 9:
			return 'OCTOBER';
		case 10:
			return 'NOVEMBER';
		default:
			return 'DECEMBER';
	}
};
var $author$project$Date_Time$Month$encode = A2($elm$core$Basics$composeR, $author$project$Date_Time$Month$toString, $elm$json$Json$Encode$string);
var $author$project$Plan$Schedule$Schedule$encodeYearlyModel = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'frequency',
				$author$project$Plan$Schedule$Frequency$encode(3)),
				_Utils_Tuple2(
				'interval',
				$elm$json$Json$Encode$int(model.a0)),
				_Utils_Tuple2(
				'month',
				$author$project$Date_Time$Month$encode(model.gZ)),
				_Utils_Tuple2(
				'day',
				$elm$json$Json$Encode$int(model.dz)),
				_Utils_Tuple2(
				'creatingTime',
				$author$project$Date_Time$NaiveTime$encode(model.aV)),
				_Utils_Tuple2(
				'deadlineTime',
				$author$project$Date_Time$NaiveTime$encode(model.ex)),
				_Utils_Tuple2(
				'startDate',
				$author$project$Date_Time$NaiveDate$encode(model.a2)),
				_Utils_Tuple2(
				'endDate',
				A2($author$project$Utils$Encode$maybe, $author$project$Date_Time$NaiveDate$encode, model.aZ)),
				_Utils_Tuple2(
				'timeZone',
				$elm$json$Json$Encode$string(model.el))
			]));
};
var $author$project$Plan$Schedule$Schedule$encode = function (schedule) {
	switch (schedule.$) {
		case 0:
			var model = schedule.a;
			return $author$project$Plan$Schedule$Schedule$encodeDailyModel(model);
		case 1:
			var model = schedule.a;
			return $author$project$Plan$Schedule$Schedule$encodeWeeklyModel(model);
		case 2:
			var model = schedule.a;
			return $author$project$Plan$Schedule$Schedule$encodeMonthlyModel(model);
		default:
			var model = schedule.a;
			return $author$project$Plan$Schedule$Schedule$encodeYearlyModel(model);
	}
};
var $author$project$Plan$Execution$Execution$encode = function (execution) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'executionId',
				$author$project$Plan$Execution$Id$encode(execution.dH)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(execution.k8)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(execution.aY)),
				_Utils_Tuple2(
				'schedule',
				$author$project$Plan$Schedule$Schedule$encode(execution.hd))
			]));
};
var $author$project$Plan$Command$encode = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.plan.create.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'executions',
						A2($elm$json$Json$Encode$list, $author$project$Plan$Execution$Execution$encode, payload.fr)),
						_Utils_Tuple2(
						'checkpointGroups',
						$author$project$CheckpointData$CheckpointGroup$Ids$encode(payload.gt)),
						_Utils_Tuple2(
						'auditors',
						$author$project$User$Ids$encode(payload.bT))
					]));
		case 1:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.plan.change-title.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 2:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.plan.change-description.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 3:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.plan.add-execution.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'execution',
						$author$project$Plan$Execution$Execution$encode(payload.jw)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 4:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.plan.change-execution.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'execution',
						$author$project$Plan$Execution$Execution$encode(payload.jw)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 5:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.plan.remove-execution.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'executionId',
						$author$project$Plan$Execution$Id$encode(payload.dH)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 6:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.plan.change-auditors.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'addAuditors',
						$author$project$User$Ids$encode(payload.ge)),
						_Utils_Tuple2(
						'removeAuditors',
						$author$project$User$Ids$encode(payload.g9)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 7:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.plan.change-checkpoint-groups.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'addCheckpointGroups',
						$author$project$CheckpointData$CheckpointGroup$Ids$encode(payload.e7)),
						_Utils_Tuple2(
						'removeCheckpointGroups',
						$author$project$CheckpointData$CheckpointGroup$Ids$encode(payload.fY)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 8:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.plan.delete.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		default:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.plan.execute-manuel.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
	}
};
var $author$project$Plan$Commands$encode = $author$project$Types$Queue$encode($author$project$Plan$Command$encode);
var $author$project$Plan$Event$encode = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.plan.created.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$author$project$Utils$Encode$nullIfBlankString(payload.aY)),
						_Utils_Tuple2(
						'executions',
						A2($elm$json$Json$Encode$list, $author$project$Plan$Execution$Execution$encode, payload.fr)),
						_Utils_Tuple2(
						'checkpointGroups',
						$author$project$CheckpointData$CheckpointGroup$Ids$encode(payload.gt)),
						_Utils_Tuple2(
						'auditors',
						$author$project$User$Ids$encode(payload.bT)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 1:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.plan.title-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 2:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.plan.description-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 3:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.plan.execution-added.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'execution',
						$author$project$Plan$Execution$Execution$encode(payload.jw)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 4:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.plan.execution-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'execution',
						$author$project$Plan$Execution$Execution$encode(payload.jw)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 5:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.plan.execution-removed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'executionId',
						$author$project$Plan$Execution$Id$encode(payload.dH)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 6:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.plan.auditors-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'addAuditors',
						$author$project$User$Ids$encode(payload.ge)),
						_Utils_Tuple2(
						'auditors',
						$author$project$User$Ids$encode(payload.g9)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 7:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.plan.checkpoint-groups-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'addCheckpointGroups',
						$author$project$CheckpointData$CheckpointGroup$Ids$encode(payload.e7)),
						_Utils_Tuple2(
						'removeCheckpointGroup',
						$author$project$CheckpointData$CheckpointGroup$Ids$encode(payload.fY)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 8:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.plan.deleted.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		default:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.plan.manuel-executed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(payload.d5)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
	}
};
var $author$project$Plan$Events$encode = $author$project$Types$Queue$encode($author$project$Plan$Event$encode);
var $author$project$Plan$Plan$encode = function (plan) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'planId',
				$author$project$Plan$Id$encode(plan.d5)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(plan.k8)),
				_Utils_Tuple2(
				'description',
				$author$project$Utils$Encode$nullIfBlankString(plan.aY)),
				_Utils_Tuple2(
				'executions',
				A2($elm$json$Json$Encode$list, $author$project$Plan$Execution$Execution$encode, plan.fr)),
				_Utils_Tuple2(
				'checkpointGroups',
				$author$project$CheckpointData$CheckpointGroup$Ids$encode(plan.gt)),
				_Utils_Tuple2(
				'auditors',
				$author$project$User$Ids$encode(plan.bT)),
				_Utils_Tuple2(
				'revision',
				$elm$json$Json$Encode$int(plan.i))
			]));
};
var $author$project$Plan$Dict$values = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$Plan$Dict$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Plan$Dict$values,
	$elm$json$Json$Encode$list($author$project$Plan$Plan$encode));
var $author$project$Plan$Ids$encode = $turboMaCk$any_set$Set$Any$encode($author$project$Plan$Id$encode);
var $author$project$Plan$Modifications$encode = function (modifications) {
	if (!modifications.$) {
		return $elm$json$Json$Encode$null;
	} else {
		var data = modifications.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'changed',
					$author$project$Plan$Dict$encode(data.bh)),
					_Utils_Tuple2(
					'deleted',
					$author$project$Plan$Ids$encode(data.dA)),
					_Utils_Tuple2(
					'lastEventId',
					$author$project$Types$EventId$encode(data.fD))
				]));
	}
};
var $author$project$Plan$Plans$dict = function (_v0) {
	var data = _v0;
	return data.cL;
};
var $author$project$Plan$Plans$lastEventId = function (_v0) {
	var data = _v0;
	return data.fD;
};
var $author$project$Plan$Plans$encode = function (plans) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'plans',
				$author$project$Plan$Dict$encode(
					$author$project$Plan$Plans$dict(plans))),
				_Utils_Tuple2(
				'lastEventId',
				A2(
					$author$project$Utils$Encode$maybe,
					$author$project$Types$EventId$encode,
					$author$project$Plan$Plans$lastEventId(plans)))
			]));
};
var $author$project$Plan$Store$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_DATA'))
					]));
		case 1:
			var plans_ = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_PLANS')),
						_Utils_Tuple2(
						'plans',
						$author$project$Plan$Plans$encode(plans_))
					]));
		case 2:
			var modifications = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_MODIFICATIONS')),
						_Utils_Tuple2(
						'modifications',
						$author$project$Plan$Modifications$encode(modifications))
					]));
		case 3:
			var commands_ = msg.a;
			var events_ = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_COMMANDS_AND_EVENTS')),
						_Utils_Tuple2(
						'commands',
						$author$project$Plan$Commands$encode(commands_)),
						_Utils_Tuple2(
						'events',
						$author$project$Plan$Events$encode(events_))
					]));
		case 4:
			var commandId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId))
					]));
		default:
			var commandId = msg.a;
			var planId = msg.b;
			var eventVersion = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND_AND_EVENT')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId)),
						_Utils_Tuple2(
						'planId',
						$author$project$Plan$Id$encode(planId)),
						_Utils_Tuple2(
						'eventVersion',
						$elm$json$Json$Encode$int(eventVersion))
					]));
	}
};
var $author$project$Plan$Store$planStoreOutbox = _Platform_outgoingPort('planStoreOutbox', $elm$core$Basics$identity);
var $author$project$Plan$Store$send = A2($elm$core$Basics$composeR, $author$project$Plan$Store$encodeOutMsg, $author$project$Plan$Store$planStoreOutbox);
var $author$project$Plan$Store$load = _Utils_Tuple2(
	$author$project$Plan$Store$Loading,
	$author$project$Plan$Store$send($author$project$Plan$Store$LoadData));
var $author$project$Rights$Store$LoadData = {$: 0};
var $author$project$Rights$Store$Loading = {$: 0};
var $author$project$Rights$Role$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Rights$Role$Id$encode = A2($elm$core$Basics$composeR, $author$project$Rights$Role$Id$toString, $elm$json$Json$Encode$string);
var $author$project$Rights$Team$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Rights$Team$Id$encode = A2($elm$core$Basics$composeR, $author$project$Rights$Team$Id$toString, $elm$json$Json$Encode$string);
var $author$project$Rights$Command$encode = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.create-role.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'rights',
						A2($elm$json$Json$Encode$list, $author$project$Rights$Right$encode, payload.kF))
					]));
		case 1:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.change-role-title.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 2:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.change-role-description.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 3:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.add-rights.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'rights',
						A2($elm$json$Json$Encode$list, $author$project$Rights$Right$encode, payload.kF)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 4:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.remove-rights.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'rights',
						A2($elm$json$Json$Encode$list, $author$project$Rights$Right$encode, payload.kF)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 5:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.delete-role.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 6:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.create-team.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$encode(payload.kn))
					]));
		case 7:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.change-team-title.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 8:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.change-team-description.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 9:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.add-organisation-units.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$encode(payload.kn)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		case 10:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.remove-organisation-units.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$encode(payload.kn)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
		default:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.rights.delete-team.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'titleForError',
						$elm$json$Json$Encode$string(payload.l))
					]));
	}
};
var $author$project$Rights$Commands$encode = $author$project$Types$Queue$encode($author$project$Rights$Command$encode);
var $author$project$Rights$Event$encode = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.role-created.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'rights',
						A2($elm$json$Json$Encode$list, $author$project$Rights$Right$encode, payload.kF)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 1:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.role-title-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 2:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.role-description-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 3:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.rights-added.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'rights',
						A2($elm$json$Json$Encode$list, $author$project$Rights$Right$encode, payload.kF)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 4:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.rights-removed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'rights',
						A2($elm$json$Json$Encode$list, $author$project$Rights$Right$encode, payload.kF)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 5:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.role-deleted.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'roleId',
						$author$project$Rights$Role$Id$encode(payload.hc)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 6:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.team-created.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$encode(payload.kn)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 7:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.team-title-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'title',
						$elm$json$Json$Encode$string(payload.k8)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 8:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.team-description-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(payload.aY)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 9:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.organisation-units-added.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$encode(payload.kn)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 10:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.organisation-units-removed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$encode(payload.kn)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		default:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.rights.team-deleted.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'teamId',
						$author$project$Rights$Team$Id$encode(payload.k1)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
	}
};
var $author$project$Rights$Events$encode = $author$project$Types$Queue$encode($author$project$Rights$Event$encode);
var $author$project$Rights$Role$Role$encode = function (role) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'roleId',
				$author$project$Rights$Role$Id$encode(role.hc)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(role.k8)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(role.aY)),
				_Utils_Tuple2(
				'rights',
				A2($elm$json$Json$Encode$list, $author$project$Rights$Right$encode, role.kF)),
				_Utils_Tuple2(
				'revision',
				$elm$json$Json$Encode$int(role.i))
			]));
};
var $author$project$Rights$Role$Dict$values = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$Rights$Role$Dict$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Rights$Role$Dict$values,
	$elm$json$Json$Encode$list($author$project$Rights$Role$Role$encode));
var $author$project$Rights$Role$Ids$encode = $turboMaCk$any_set$Set$Any$encode($author$project$Rights$Role$Id$encode);
var $author$project$Rights$Team$Team$encode = function (role) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'teamId',
				$author$project$Rights$Team$Id$encode(role.k1)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(role.k8)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(role.aY)),
				_Utils_Tuple2(
				'organisationUnits',
				$author$project$OrganisationUnit$Ids$encode(role.kn)),
				_Utils_Tuple2(
				'revision',
				$elm$json$Json$Encode$int(role.i))
			]));
};
var $author$project$Rights$Team$Dict$values = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$Rights$Team$Dict$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Rights$Team$Dict$values,
	$elm$json$Json$Encode$list($author$project$Rights$Team$Team$encode));
var $author$project$Rights$Team$Ids$encode = $turboMaCk$any_set$Set$Any$encode($author$project$Rights$Team$Id$encode);
var $author$project$Rights$Modifications$encode = function (modifications) {
	if (!modifications.$) {
		return $elm$json$Json$Encode$null;
	} else {
		var data = modifications.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'changedRoles',
					$author$project$Rights$Role$Dict$encode(data.bY)),
					_Utils_Tuple2(
					'deletedRoles',
					$author$project$Rights$Role$Ids$encode(data.b3)),
					_Utils_Tuple2(
					'changedTeams',
					$author$project$Rights$Team$Dict$encode(data.bZ)),
					_Utils_Tuple2(
					'deletedTeams',
					$author$project$Rights$Team$Ids$encode(data.b4)),
					_Utils_Tuple2(
					'lastEventId',
					$author$project$Types$EventId$encode(data.fD))
				]));
	}
};
var $author$project$Rights$Rights$encode = function (_v0) {
	var data = _v0;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'roles',
				$author$project$Rights$Role$Dict$encode(data.db)),
				_Utils_Tuple2(
				'teams',
				$author$project$Rights$Team$Dict$encode(data.dg)),
				_Utils_Tuple2(
				'lastEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, data.fD))
			]));
};
var $author$project$Rights$Store$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_DATA'))
					]));
		case 1:
			var rights_ = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_RIGHTS')),
						_Utils_Tuple2(
						'rights',
						$author$project$Rights$Rights$encode(rights_))
					]));
		case 2:
			var modifications = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_MODIFICATIONS')),
						_Utils_Tuple2(
						'modifications',
						$author$project$Rights$Modifications$encode(modifications))
					]));
		case 3:
			var commands_ = msg.a;
			var events_ = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_COMMANDS_AND_EVENTS')),
						_Utils_Tuple2(
						'commands',
						$author$project$Rights$Commands$encode(commands_)),
						_Utils_Tuple2(
						'events',
						$author$project$Rights$Events$encode(events_))
					]));
		case 4:
			var commandId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId))
					]));
		default:
			var commandId = msg.a;
			var eventVersion = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND_AND_EVENT')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId)),
						_Utils_Tuple2(
						'eventVersion',
						$elm$json$Json$Encode$int(eventVersion))
					]));
	}
};
var $author$project$Rights$Store$rightsStoreOutbox = _Platform_outgoingPort('rightsStoreOutbox', $elm$core$Basics$identity);
var $author$project$Rights$Store$send = A2($elm$core$Basics$composeR, $author$project$Rights$Store$encodeOutMsg, $author$project$Rights$Store$rightsStoreOutbox);
var $author$project$Rights$Store$load = _Utils_Tuple2(
	$author$project$Rights$Store$Loading,
	$author$project$Rights$Store$send($author$project$Rights$Store$LoadData));
var $author$project$Tenant$Store$LoadData = {$: 0};
var $author$project$Tenant$Store$Loading = {$: 0};
var $author$project$Tenant$Command$encode = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.tenant.change-road.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'road',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.hb))
					]));
		case 1:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.tenant.change-house-number.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'houseNumber',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.gP))
					]));
		case 2:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.tenant.change-zip-code.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'zipCode',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.hr))
					]));
		case 3:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.tenant.change-location.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'location',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.gV))
					]));
		case 4:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.tenant.change-country.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'country',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.gw))
					]));
		case 5:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.tenant.change-phone-number.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'phoneNumber',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.g7))
					]));
		case 6:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.tenant.change-url.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'url',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.lg))
					]));
		default:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.tenant.change-logo.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'logo',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.jX))
					]));
	}
};
var $author$project$Tenant$Commands$encode = $author$project$Types$Queue$encode($author$project$Tenant$Command$encode);
var $author$project$Tenant$Limitations$encode = function (limitations) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'plans',
				$elm$json$Json$Encode$int(limitations.aL)),
				_Utils_Tuple2(
				'users',
				$elm$json$Json$Encode$int(limitations.lk)),
				_Utils_Tuple2(
				'organisationUnits',
				$elm$json$Json$Encode$int(limitations.kn))
			]));
};
var $author$project$Tenant$Event$encode = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.tenant.created.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 1:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.tenant.road-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'road',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.hb)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 2:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.tenant.house-number-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'houseNumber',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.gP)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 3:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.tenant.zip-code-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'zipCode',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.hr)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 4:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.tenant.location-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'location',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.gV)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 5:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.tenant.country-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'country',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.gw)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 6:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.tenant.phone-number-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'phoneNumber',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.g7)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 7:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.tenant.url-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'url',
						A2($author$project$Utils$Encode$maybe, $elm$json$Json$Encode$string, payload.lg)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 8:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.tenant.logo-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'logo',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.jX)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		default:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.tenant.limitations-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(payload.k5)),
						_Utils_Tuple2(
						'limitations',
						$author$project$Tenant$Limitations$encode(payload.jW)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
	}
};
var $author$project$Tenant$Events$encode = $author$project$Types$Queue$encode($author$project$Tenant$Event$encode);
var $author$project$Tenant$Tenant$encode = function (tenant) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'tenantId',
				$author$project$Tenant$Id$encode(tenant.k5)),
				_Utils_Tuple2(
				'tenantName',
				$elm$json$Json$Encode$string(tenant.aP)),
				_Utils_Tuple2(
				'limitations',
				$author$project$Tenant$Limitations$encode(tenant.jW)),
				_Utils_Tuple2(
				'road',
				$author$project$Utils$Encode$nullIfBlankString(tenant.hb)),
				_Utils_Tuple2(
				'houseNumber',
				$author$project$Utils$Encode$nullIfBlankString(tenant.gP)),
				_Utils_Tuple2(
				'zipCode',
				$author$project$Utils$Encode$nullIfBlankString(tenant.hr)),
				_Utils_Tuple2(
				'location',
				$author$project$Utils$Encode$nullIfBlankString(tenant.gV)),
				_Utils_Tuple2(
				'country',
				$author$project$Utils$Encode$nullIfBlankString(tenant.gw)),
				_Utils_Tuple2(
				'phoneNumber',
				$author$project$Utils$Encode$nullIfBlankString(tenant.g7)),
				_Utils_Tuple2(
				'url',
				$author$project$Utils$Encode$nullIfBlankString(tenant.lg)),
				_Utils_Tuple2(
				'logo',
				A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, tenant.jX)),
				_Utils_Tuple2(
				'revision',
				$elm$json$Json$Encode$int(tenant.i)),
				_Utils_Tuple2(
				'lastEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, tenant.fD))
			]));
};
var $author$project$Tenant$Tenant$encodeModification = function (modifications) {
	if (!modifications.$) {
		return $elm$json$Json$Encode$null;
	} else {
		var data = modifications.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'changed',
					$author$project$Tenant$Tenant$encode(data.bh))
				]));
	}
};
var $author$project$Tenant$Store$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_DATA'))
					]));
		case 1:
			var tenant_ = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_TENANT')),
						_Utils_Tuple2(
						'tenant',
						$author$project$Tenant$Tenant$encode(tenant_))
					]));
		case 2:
			var modifications = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_MODIFICATIONS')),
						_Utils_Tuple2(
						'modifications',
						$author$project$Tenant$Tenant$encodeModification(modifications))
					]));
		case 3:
			var commands_ = msg.a;
			var events_ = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_COMMANDS_AND_EVENTS')),
						_Utils_Tuple2(
						'commands',
						$author$project$Tenant$Commands$encode(commands_)),
						_Utils_Tuple2(
						'events',
						$author$project$Tenant$Events$encode(events_))
					]));
		case 4:
			var commandId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId))
					]));
		default:
			var commandId = msg.a;
			var tenantId = msg.b;
			var eventVersion = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND_AND_EVENT')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId)),
						_Utils_Tuple2(
						'tenantId',
						$author$project$Tenant$Id$encode(tenantId)),
						_Utils_Tuple2(
						'eventVersion',
						$elm$json$Json$Encode$int(eventVersion))
					]));
	}
};
var $author$project$Tenant$Store$tenantStoreOutbox = _Platform_outgoingPort('tenantStoreOutbox', $elm$core$Basics$identity);
var $author$project$Tenant$Store$send = A2($elm$core$Basics$composeR, $author$project$Tenant$Store$encodeOutMsg, $author$project$Tenant$Store$tenantStoreOutbox);
var $author$project$Tenant$Store$load = _Utils_Tuple2(
	$author$project$Tenant$Store$Loading,
	$author$project$Tenant$Store$send($author$project$Tenant$Store$LoadData));
var $author$project$User$Store$LoadData = {$: 0};
var $author$project$User$Store$Loading = {$: 0};
var $author$project$Auth$Password$encode = function (_v0) {
	var password = _v0;
	return $elm$json$Json$Encode$string(password);
};
var $author$project$User$EmailAddress$toString = function (_v0) {
	var emailAddress = _v0;
	return emailAddress;
};
var $author$project$User$EmailAddress$encode = A2($elm$core$Basics$composeR, $author$project$User$EmailAddress$toString, $elm$json$Json$Encode$string);
var $author$project$User$TeamRoles$encodeTeamRole = function (teamRoles) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'teamId',
				$author$project$Rights$Team$Id$encode(teamRoles.k1)),
				_Utils_Tuple2(
				'roleIds',
				$author$project$Rights$Role$Ids$encode(teamRoles.kH))
			]));
};
var $author$project$User$TeamRoles$encode = $turboMaCk$any_set$Set$Any$encode($author$project$User$TeamRoles$encodeTeamRole);
var $author$project$User$Command$encode = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.user.create.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'username',
						$elm$json$Json$Encode$string(payload.iK)),
						_Utils_Tuple2(
						'emailAddress',
						A2($author$project$Utils$Encode$maybe, $author$project$User$EmailAddress$encode, payload.ju)),
						_Utils_Tuple2(
						'password',
						$author$project$Auth$Password$encode(payload.a1)),
						_Utils_Tuple2(
						'name',
						$author$project$Utils$Encode$nullIfBlankString(payload.g_)),
						_Utils_Tuple2(
						'teamRoles',
						$author$project$User$TeamRoles$encode(payload.k2)),
						_Utils_Tuple2(
						'entryOrganisationUnit',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.hT)),
						_Utils_Tuple2(
						'avatar',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.iX))
					]));
		case 1:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.user.change-email-address.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'emailAddress',
						$author$project$User$EmailAddress$encode(payload.ju)),
						_Utils_Tuple2(
						'nameForError',
						$elm$json$Json$Encode$string(payload.cl))
					]));
		case 2:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.user.change-password.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'password',
						$author$project$Auth$Password$encode(payload.a1)),
						_Utils_Tuple2(
						'nameForError',
						$elm$json$Json$Encode$string(payload.cl))
					]));
		case 3:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.user.rename.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'name',
						$author$project$Utils$Encode$nullIfBlankString(payload.g_)),
						_Utils_Tuple2(
						'nameForError',
						$elm$json$Json$Encode$string(payload.cl))
					]));
		case 4:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.user.add-team-role.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'teamRole',
						$author$project$User$TeamRoles$encodeTeamRole(payload.bQ)),
						_Utils_Tuple2(
						'nameForError',
						$elm$json$Json$Encode$string(payload.cl))
					]));
		case 5:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.user.change-team-role.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'teamRole',
						$author$project$User$TeamRoles$encodeTeamRole(payload.bQ)),
						_Utils_Tuple2(
						'nameForError',
						$elm$json$Json$Encode$string(payload.cl))
					]));
		case 6:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.user.remove-team-role.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'teamRole',
						$author$project$User$TeamRoles$encodeTeamRole(payload.bQ)),
						_Utils_Tuple2(
						'nameForError',
						$elm$json$Json$Encode$string(payload.cl))
					]));
		case 7:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.user.change-avatar.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'avatar',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.iX)),
						_Utils_Tuple2(
						'nameForError',
						$elm$json$Json$Encode$string(payload.cl))
					]));
		case 8:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.user.change-entry-organisation-unit.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'entryOrganisationUnit',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.hT)),
						_Utils_Tuple2(
						'nameForError',
						$elm$json$Json$Encode$string(payload.cl))
					]));
		default:
			var payload = command.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commandType',
						$elm$json$Json$Encode$string('de.awenko.user.delete.v1')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'username',
						$elm$json$Json$Encode$string(payload.iK))
					]));
	}
};
var $author$project$User$Commands$encode = $author$project$Types$Queue$encode($author$project$User$Command$encode);
var $author$project$User$Event$encode = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.user.created.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'username',
						$elm$json$Json$Encode$string(payload.iK)),
						_Utils_Tuple2(
						'emailAddress',
						A2($author$project$Utils$Encode$maybe, $author$project$User$EmailAddress$encode, payload.ju)),
						_Utils_Tuple2(
						'name',
						$author$project$Utils$Encode$nullIfBlankString(payload.g_)),
						_Utils_Tuple2(
						'teamRoles',
						$author$project$User$TeamRoles$encode(payload.k2)),
						_Utils_Tuple2(
						'avatar',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.iX)),
						_Utils_Tuple2(
						'entryOrganisationUnit',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.hT)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 1:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.user.email-address-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'emailAddress',
						$author$project$User$EmailAddress$encode(payload.ju)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 2:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.user.password-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 3:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.user.renamed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'name',
						$author$project$Utils$Encode$nullIfBlankString(payload.g_)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 4:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.user.team-role-added.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'teamRole',
						$author$project$User$TeamRoles$encodeTeamRole(payload.bQ)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 5:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.user.team-role-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'teamRole',
						$author$project$User$TeamRoles$encodeTeamRole(payload.bQ)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 6:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.user.team-role-removed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'teamRole',
						$author$project$User$TeamRoles$encodeTeamRole(payload.bQ)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 7:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.user.avatar-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'avatar',
						A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, payload.iX)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		case 8:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.user.entry-organisation-unit-changed.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'entryOrganisationUnit',
						A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, payload.hT)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
		default:
			var payload = event.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'eventType',
						$elm$json$Json$Encode$string('de.awenko.user.deleted.v1')),
						_Utils_Tuple2(
						'eventId',
						$author$project$Types$EventId$encode(payload.N)),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(payload.L)),
						_Utils_Tuple2(
						'commandTimestamp',
						$author$project$Utils$Encode$timestamp(payload.M)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(payload.dk)),
						_Utils_Tuple2(
						'username',
						$elm$json$Json$Encode$string(payload.iK)),
						_Utils_Tuple2(
						'version',
						$elm$json$Json$Encode$int(payload.n))
					]));
	}
};
var $author$project$User$Events$encode = $author$project$Types$Queue$encode($author$project$User$Event$encode);
var $author$project$User$User$encode = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userId',
				$author$project$User$Id$encode(user.dk)),
				_Utils_Tuple2(
				'username',
				$elm$json$Json$Encode$string(user.iK)),
				_Utils_Tuple2(
				'emailAddress',
				A2($author$project$Utils$Encode$maybe, $author$project$User$EmailAddress$encode, user.ju)),
				_Utils_Tuple2(
				'name',
				$author$project$Utils$Encode$nullIfBlankString(user.g_)),
				_Utils_Tuple2(
				'teamRoles',
				$author$project$User$TeamRoles$encode(user.k2)),
				_Utils_Tuple2(
				'avatar',
				A2($author$project$Utils$Encode$maybe, $author$project$File$Filename$encode, user.iX)),
				_Utils_Tuple2(
				'entryOrganisationUnit',
				A2($author$project$Utils$Encode$maybe, $author$project$OrganisationUnit$Id$encode, user.hT)),
				_Utils_Tuple2(
				'revision',
				$elm$json$Json$Encode$int(user.i))
			]));
};
var $author$project$User$Dict$values = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$User$Dict$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$User$Dict$values,
	$elm$json$Json$Encode$list($author$project$User$User$encode));
var $author$project$User$Modifications$encode = function (modifications) {
	if (!modifications.$) {
		return $elm$json$Json$Encode$null;
	} else {
		var data = modifications.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'changed',
					$author$project$User$Dict$encode(data.bh)),
					_Utils_Tuple2(
					'deleted',
					$author$project$User$Ids$encode(data.dA)),
					_Utils_Tuple2(
					'lastEventId',
					$author$project$Types$EventId$encode(data.fD))
				]));
	}
};
var $author$project$User$Users$unwrap = function (_v0) {
	var data = _v0;
	return data;
};
var $author$project$User$Users$dict = A2(
	$elm$core$Basics$composeR,
	$author$project$User$Users$unwrap,
	function ($) {
		return $.cL;
	});
var $author$project$User$Users$lastEventId = A2(
	$elm$core$Basics$composeR,
	$author$project$User$Users$unwrap,
	function ($) {
		return $.fD;
	});
var $author$project$User$Users$encode = function (users) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'users',
				$author$project$User$Dict$encode(
					$author$project$User$Users$dict(users))),
				_Utils_Tuple2(
				'lastEventId',
				A2(
					$author$project$Utils$Encode$maybe,
					$author$project$Types$EventId$encode,
					$author$project$User$Users$lastEventId(users)))
			]));
};
var $author$project$User$Store$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOAD_DATA'))
					]));
		case 1:
			var users_ = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_USERS')),
						_Utils_Tuple2(
						'users',
						$author$project$User$Users$encode(users_))
					]));
		case 2:
			var modifications = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_MODIFICATIONS')),
						_Utils_Tuple2(
						'modifications',
						$author$project$User$Modifications$encode(modifications))
					]));
		case 3:
			var commands_ = msg.a;
			var events_ = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_COMMANDS_AND_EVENTS')),
						_Utils_Tuple2(
						'commands',
						$author$project$User$Commands$encode(commands_)),
						_Utils_Tuple2(
						'events',
						$author$project$User$Events$encode(events_))
					]));
		case 4:
			var commandId = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId))
					]));
		default:
			var commandId = msg.a;
			var userId = msg.b;
			var eventVersion = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('REMOVE_COMMAND_AND_EVENT')),
						_Utils_Tuple2(
						'commandId',
						$author$project$Types$CommandId$encode(commandId)),
						_Utils_Tuple2(
						'userId',
						$author$project$User$Id$encode(userId)),
						_Utils_Tuple2(
						'eventVersion',
						$elm$json$Json$Encode$int(eventVersion))
					]));
	}
};
var $author$project$User$Store$userStoreOutbox = _Platform_outgoingPort('userStoreOutbox', $elm$core$Basics$identity);
var $author$project$User$Store$send = A2($elm$core$Basics$composeR, $author$project$User$Store$encodeOutMsg, $author$project$User$Store$userStoreOutbox);
var $author$project$User$Store$load = _Utils_Tuple2(
	$author$project$User$Store$Loading,
	$author$project$User$Store$send($author$project$User$Store$LoadData));
var $author$project$Environments$Repository$init = function () {
	var _v0 = $author$project$User$Store$load;
	var userStore_ = _v0.a;
	var userStoreCmd = _v0.b;
	var _v1 = $author$project$Tenant$Store$load;
	var tenantStore_ = _v1.a;
	var tenantStoreCmd = _v1.b;
	var _v2 = $author$project$Rights$Store$load;
	var rightsStore_ = _v2.a;
	var rightsStoreCmd = _v2.b;
	var _v3 = $author$project$Plan$Store$load;
	var planStore_ = _v3.a;
	var planStoreCmd = _v3.b;
	var _v4 = $author$project$OrganisationUnit$Store$load;
	var organisationUnitStore_ = _v4.a;
	var organisationUnitStoreCmd = _v4.b;
	var _v5 = $author$project$Measure$Store$load;
	var measureStore_ = _v5.a;
	var measureStoreCmd = _v5.b;
	var _v6 = $author$project$File$Store$load;
	var fileStore_ = _v6.a;
	var fileStoreCmd = _v6.b;
	var _v7 = $author$project$CheckpointData$Store$load;
	var checkpointDataStore_ = _v7.a;
	var checkpointDataStoreCmd = _v7.b;
	var _v8 = $author$project$Audit$Store$load;
	var auditStore_ = _v8.a;
	var auditStoreCmd = _v8.b;
	return _Utils_Tuple2(
		{bg: $author$project$Audit$Service$idle, aa: auditStore_, bj: $author$project$CheckpointData$Service$idle, C: checkpointDataStore_, j: $author$project$EventStream$EventStream$disconnected, ad: fileStore_, bo: $author$project$Measure$Service$idle, R: measureStore_, br: $author$project$OrganisationUnit$Service$idle, T: organisationUnitStore_, bt: $author$project$Plan$Service$idle, U: planStore_, bM: $author$project$Rights$Service$idle, al: rightsStore_, bz: $author$project$Tenant$Service$idle, ag: tenantStore_, bA: $author$project$User$Service$idle, ah: userStore_},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[fileStoreCmd, userStoreCmd, organisationUnitStoreCmd, planStoreCmd, auditStoreCmd, measureStoreCmd, tenantStoreCmd, checkpointDataStoreCmd, rightsStoreCmd])));
}();
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Main$init = function (flagsJson) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Environments$Flags$Flags$decode, flagsJson);
	if (!_v0.$) {
		var flags = _v0.a;
		var _v1 = $author$project$Environments$Repository$init;
		var repository = _v1.a;
		var repositoryCmd = _v1.b;
		var _v2 = A2($author$project$Environments$Environment$init, flags, $author$project$Environments$Route$MainMenu);
		var environment = _v2.a;
		var environmentCmd = _v2.b;
		return _Utils_Tuple2(
			$author$project$Main$Loading(
				{ac: environment, az: $author$project$Auth$ReLoginModal$hidden, ae: repository}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedEnvironmentMsg, environmentCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedRepositoryMsg, repositoryCmd)
					])));
	} else {
		var err = _v0.a;
		var string = $elm$json$Json$Decode$errorToString(err);
		return _Utils_Tuple2(
			$author$project$Main$Error(string),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Main$ReceivedErrorModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$ReceivedLoginMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$ReceivedNavbarMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$ReceivedPageMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$ReceivedReLoginMsg = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Auth$Login$GotCurrentURL = function (a) {
	return {$: 7, a: a};
};
var $author$project$Auth$Login$LoginFailed = function (a) {
	return {$: 6, a: a};
};
var $author$project$Auth$Login$LoginSucceeded = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Auth$Login$SavedBaseUri = {$: 13};
var $author$project$Tenant$Id$Id = $elm$core$Basics$identity;
var $NoRedInk$elm_uuid$Prng$Uuid$Uuid = $elm$core$Basics$identity;
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {jL: index, j1: match, cm: number, kY: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{i0: false, kb: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $NoRedInk$elm_uuid$Prng$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $NoRedInk$elm_uuid$Prng$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $NoRedInk$elm_uuid$Prng$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $NoRedInk$elm_uuid$Prng$Uuid$isValidUuid = $NoRedInk$elm_uuid$Prng$Uuid$Barebones$isValidUuid;
var $elm$core$String$toLower = _String_toLower;
var $NoRedInk$elm_uuid$Prng$Uuid$fromString = function (text) {
	return $NoRedInk$elm_uuid$Prng$Uuid$isValidUuid(text) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(text)) : $elm$core$Maybe$Nothing;
};
var $NoRedInk$elm_uuid$Prng$Uuid$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $NoRedInk$elm_uuid$Prng$Uuid$fromString(string);
		if (!_v0.$) {
			var uuid = _v0.a;
			return $elm$json$Json$Decode$succeed(uuid);
		} else {
			return $elm$json$Json$Decode$fail('Not a valid UUID');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Tenant$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$User$Id$Id = $elm$core$Basics$identity;
var $author$project$User$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Auth$Login$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOGIN_SUCCEEDED':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'userId',
					$author$project$User$Id$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						$elm$json$Json$Decode$succeed($author$project$Auth$Login$LoginSucceeded)));
			case 'LOGIN_FAILED':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'msg',
					$elm$json$Json$Decode$string,
					'LOGIN_INVALID',
					$elm$json$Json$Decode$succeed($author$project$Auth$Login$LoginFailed));
			case 'CURRENT_URL':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Auth$Login$GotCurrentURL));
			case 'SAVED_BASE_URI':
				return $elm$json$Json$Decode$succeed($author$project$Auth$Login$SavedBaseUri);
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Auth$Login$ReceivedErrorMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Auth$Login$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$Auth$Login$ReceivedErrorMsg(error);
	}
};
var $author$project$Auth$Login$loginInbox = _Platform_incomingPort('loginInbox', $elm$json$Json$Decode$value);
var $author$project$Auth$Login$subscriptions = $author$project$Auth$Login$loginInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Auth$Login$decodeMsg),
		$author$project$Auth$Login$handleDecodeResult));
var $author$project$Auth$ReLoginModal$GotTenant = function (a) {
	return {$: 9, a: a};
};
var $author$project$Auth$ReLoginModal$LoginFailed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Auth$ReLoginModal$LoginSucceeded = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Tenant$Tenant$Tenant = function (tenantId) {
	return function (tenantName) {
		return function (limitations) {
			return function (road) {
				return function (houseNumber) {
					return function (zipCode) {
						return function (location) {
							return function (country) {
								return function (phoneNumber) {
									return function (url) {
										return function (logo) {
											return function (revision) {
												return function (lastEventId) {
													return {gw: country, gP: houseNumber, fD: lastEventId, jW: limitations, gV: location, jX: logo, g7: phoneNumber, i: revision, hb: road, k5: tenantId, aP: tenantName, lg: url, hr: zipCode};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$File$Filename$Filename = F2(
	function (id, name) {
		return {fw: id, g_: name};
	});
var $author$project$File$Id$Id = $elm$core$Basics$identity;
var $author$project$File$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$File$Filename$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$author$project$File$Id$decode,
		$elm$json$Json$Decode$succeed($author$project$File$Filename$Filename)));
var $author$project$Tenant$Limitations$Limitations = F3(
	function (plans, users, organisationUnits) {
		return {kn: organisationUnits, aL: plans, lk: users};
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Tenant$Limitations$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'organisationUnits',
	$elm$json$Json$Decode$int,
	-1,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'users',
		$elm$json$Json$Decode$int,
		-1,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'plans',
			$elm$json$Json$Decode$int,
			-1,
			$elm$json$Json$Decode$succeed($author$project$Tenant$Limitations$Limitations))));
var $author$project$Types$EventId$Id = $elm$core$Basics$identity;
var $author$project$Types$EventId$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Tenant$Tenant$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'lastEventId',
	$elm$json$Json$Decode$maybe($author$project$Types$EventId$decode),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'revision',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'logo',
			$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'url',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'phoneNumber',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'country',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'location',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'zipCode',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'houseNumber',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'road',
										$elm$json$Json$Decode$string,
										'',
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'limitations',
											$author$project$Tenant$Limitations$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'tenantName',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'tenantId',
													$author$project$Tenant$Id$decode,
													$elm$json$Json$Decode$succeed($author$project$Tenant$Tenant$Tenant))))))))))))));
var $author$project$Auth$ReLoginModal$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOGIN_SUCCEEDED':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'userId',
					$author$project$User$Id$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						$elm$json$Json$Decode$succeed($author$project$Auth$ReLoginModal$LoginSucceeded)));
			case 'LOGIN_FAILED':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'msg',
					$elm$json$Json$Decode$string,
					'LOGIN_INVALID',
					$elm$json$Json$Decode$succeed($author$project$Auth$ReLoginModal$LoginFailed));
			case 'GOT_TENANT':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'tenant',
					$author$project$Tenant$Tenant$decode,
					$elm$json$Json$Decode$succeed($author$project$Auth$ReLoginModal$GotTenant));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Auth$ReLoginModal$ReceivedErrorMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Auth$ReLoginModal$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$Auth$ReLoginModal$ReceivedErrorMsg(error);
	}
};
var $author$project$Auth$ReLoginModal$reLoginInbox = _Platform_incomingPort('reLoginInbox', $elm$json$Json$Decode$value);
var $author$project$Auth$ReLoginModal$subscriptions = $author$project$Auth$ReLoginModal$reLoginInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Auth$ReLoginModal$decodeMsg),
		$author$project$Auth$ReLoginModal$handleDecodeResult));
var $author$project$Environments$Environment$ChangedAppState = function (a) {
	return {$: 0, a: a};
};
var $author$project$Environments$Environment$ChangedNetworkState = function (a) {
	return {$: 1, a: a};
};
var $author$project$Environments$Environment$LoadedUserRights = function (a) {
	return {$: 9, a: a};
};
var $author$project$Environments$Environment$ReceivedSession = function (a) {
	return {$: 6, a: a};
};
var $author$project$Environments$Environment$RemovedData = {$: 10};
var $author$project$Environments$Environment$SavedUserRights = {$: 8};
var $author$project$Environments$Environment$SessionExpired = {$: 7};
var $author$project$Auth$Session$Known = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Auth$Session$decodeKnown = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'userId',
	$author$project$User$Id$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tenantId',
		$author$project$Tenant$Id$decode,
		$elm$json$Json$Decode$succeed($author$project$Auth$Session$Known)));
var $author$project$Auth$Session$decodeUnknown = $elm$json$Json$Decode$succeed($author$project$Auth$Session$Unknown);
var $author$project$Auth$Session$decode = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Auth$Session$decodeKnown, $author$project$Auth$Session$decodeUnknown]));
var $author$project$Auth$UserRights$Data = F2(
	function (settingsRights, matrix) {
		return {h4: matrix, hf: settingsRights};
	});
var $author$project$Auth$UserRights$Initialized = function (a) {
	return {$: 2, a: a};
};
var $author$project$Auth$UserRights$NotInitialized = {$: 1};
var $author$project$Rights$Right$CreateAudit = 7;
var $author$project$Rights$Right$CreateMeasure = 4;
var $author$project$Rights$Right$DeleteAudit = 9;
var $author$project$Rights$Right$DeleteMeasure = 6;
var $author$project$Rights$Right$EditAudit = 8;
var $author$project$Rights$Right$EditMeasure = 5;
var $author$project$Rights$Right$EditOrganisationUnit = 1;
var $author$project$Rights$Right$EditPlan = 2;
var $author$project$Rights$Right$EditRights = 0;
var $author$project$Rights$Right$EditTenant = 3;
var $author$project$Rights$Right$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'editRights':
				return $elm$json$Json$Decode$succeed(0);
			case 'editOrganisationUnit':
				return $elm$json$Json$Decode$succeed(1);
			case 'editPlan':
				return $elm$json$Json$Decode$succeed(2);
			case 'editTenant':
				return $elm$json$Json$Decode$succeed(3);
			case 'createMeasure':
				return $elm$json$Json$Decode$succeed(4);
			case 'editMeasure':
				return $elm$json$Json$Decode$succeed(5);
			case 'deleteMeasure':
				return $elm$json$Json$Decode$succeed(6);
			case 'createAudit':
				return $elm$json$Json$Decode$succeed(7);
			case 'editAudit':
				return $elm$json$Json$Decode$succeed(8);
			case 'deleteAudit':
				return $elm$json$Json$Decode$succeed(9);
			default:
				return $elm$json$Json$Decode$fail('unknown right');
		}
	},
	$elm$json$Json$Decode$string);
var $turboMaCk$any_set$Set$Any$AnySet = $elm$core$Basics$identity;
var $turboMaCk$any_dict$Dict$Any$AnyDict = $elm$core$Basics$identity;
var $turboMaCk$any_dict$Dict$Any$fromList = F2(
	function (f, xs) {
		return {
			cL: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var k = _v0.a;
						var v = _v0.b;
						return _Utils_Tuple2(
							f(k),
							_Utils_Tuple2(k, v));
					},
					xs)),
			a3: f
		};
	});
var $turboMaCk$any_set$Set$Any$fromList = function (toComparable) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Basics$identity,
			$turboMaCk$any_dict$Dict$Any$fromList(toComparable)),
		$elm$core$List$map(
			function (a) {
				return _Utils_Tuple2(a, 0);
			}));
};
var $turboMaCk$any_set$Set$Any$decode = F2(
	function (conversion, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$turboMaCk$any_set$Set$Any$fromList(conversion),
			$elm$json$Json$Decode$list(decoder));
	});
var $author$project$Auth$RightSet$decode = A2($turboMaCk$any_set$Set$Any$decode, $author$project$Rights$Right$toString, $author$project$Rights$Right$decode);
var $author$project$Auth$UserRights$DecodeHelper = F2(
	function (organisationUnitId, rightSet) {
		return {km: organisationUnitId, it: rightSet};
	});
var $author$project$OrganisationUnit$Id$Id = $elm$core$Basics$identity;
var $author$project$OrganisationUnit$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$Auth$UserRights$decodeHelperToTuple = function (_v0) {
	var organisationUnitId = _v0.km;
	var rightSet = _v0.it;
	return _Utils_Tuple2(organisationUnitId, rightSet);
};
var $author$project$Auth$UserRights$decodeTuple = A2(
	$elm$json$Json$Decode$map,
	$author$project$Auth$UserRights$decodeHelperToTuple,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rightSet',
		$author$project$Auth$RightSet$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'organisationUnitId',
			$author$project$OrganisationUnit$Id$decode,
			$elm$json$Json$Decode$succeed($author$project$Auth$UserRights$DecodeHelper))));
var $author$project$Auth$UserRights$matrixFromList = $turboMaCk$any_dict$Dict$Any$fromList($author$project$OrganisationUnit$Id$toString);
var $author$project$Auth$UserRights$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (state) {
		if (state === 'INITIALIZED') {
			return A3(
				$elm$core$Basics$composeR,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'matrix',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Auth$UserRights$matrixFromList,
						$elm$json$Json$Decode$list($author$project$Auth$UserRights$decodeTuple))),
				$elm$json$Json$Decode$map($author$project$Auth$UserRights$Initialized),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'settingsRights',
					$author$project$Auth$RightSet$decode,
					$elm$json$Json$Decode$succeed($author$project$Auth$UserRights$Data)));
		} else {
			return $elm$json$Json$Decode$succeed($author$project$Auth$UserRights$NotInitialized);
		}
	},
	A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string));
var $author$project$Environments$App$Inactive = 1;
var $author$project$Environments$App$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (state) {
		switch (state) {
			case 'ACTIVE':
				return $elm$json$Json$Decode$succeed(0);
			case 'INACTIVE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unknown state');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Environments$Environment$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'CHANGED_APP_STATE':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Environments$Environment$ChangedAppState,
					A2($elm$json$Json$Decode$field, 'state', $author$project$Environments$App$decode));
			case 'CHANGED_NETWORK_STATE':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Environments$Environment$ChangedNetworkState,
					A2($elm$json$Json$Decode$field, 'state', $author$project$Environments$Network$decode));
			case 'RECEIVED_SESSION':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Environments$Environment$ReceivedSession,
					A2($elm$json$Json$Decode$field, 'session', $author$project$Auth$Session$decode));
			case 'SAVED_SESSION':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Environments$Environment$ReceivedSession,
					A2($elm$json$Json$Decode$field, 'session', $author$project$Auth$Session$decode));
			case 'SESSION_EXPIRED':
				return $elm$json$Json$Decode$succeed($author$project$Environments$Environment$SessionExpired);
			case 'SAVED_USER_RIGHTS':
				return $elm$json$Json$Decode$succeed($author$project$Environments$Environment$SavedUserRights);
			case 'LOADED_USER_RIGHTS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Environments$Environment$LoadedUserRights,
					A2($elm$json$Json$Decode$field, 'userRights', $author$project$Auth$UserRights$decode));
			case 'REMOVED_DATA':
				return $elm$json$Json$Decode$succeed($author$project$Environments$Environment$RemovedData);
			default:
				return $elm$json$Json$Decode$fail('Unknown message type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Environments$Environment$environmentInbox = _Platform_incomingPort('environmentInbox', $elm$json$Json$Decode$value);
var $author$project$Environments$Environment$ReceivedErrorMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Environments$Environment$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$Environments$Environment$ReceivedErrorMsg(error);
	}
};
var $author$project$Environments$Environment$GotResizeEvent = function (a) {
	return {$: 5, a: a};
};
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {ig: pids, iz: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {gF: event, bn: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.ig,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.bn;
		var event = _v0.gF;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.iz);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Environments$Environment$resizeSubscription = $elm$browser$Browser$Events$onResize(
	F2(
		function (w, h) {
			return $author$project$Environments$Environment$GotResizeEvent(
				{Y: h, ln: w});
		}));
var $author$project$Environments$Environment$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Environments$Environment$environmentInbox(
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeValue($author$project$Environments$Environment$decodeMsg),
				$author$project$Environments$Environment$handleDecodeResult)),
			$author$project$Environments$Environment$resizeSubscription
		]));
var $author$project$Environments$ErrorHandling$ErrorModal$ReceivedCopyMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$CopyToClipboard$copyToClipboardInbox = _Platform_incomingPort('copyToClipboardInbox', $elm$json$Json$Decode$value);
var $author$project$Utils$CopyToClipboard$GotCopiedResponse = {$: 1};
var $author$project$Utils$CopyToClipboard$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		if (type_ === 'COPIED') {
			return $elm$json$Json$Decode$succeed($author$project$Utils$CopyToClipboard$GotCopiedResponse);
		} else {
			return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Utils$CopyToClipboard$GotDecodeError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$CopyToClipboard$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$Utils$CopyToClipboard$GotDecodeError(error);
	}
};
var $author$project$Utils$CopyToClipboard$subscriptions = $author$project$Utils$CopyToClipboard$copyToClipboardInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Utils$CopyToClipboard$decodeMsg),
		$author$project$Utils$CopyToClipboard$handleDecodeResult));
var $author$project$Environments$ErrorHandling$ErrorModal$subscriptions = A2($elm$core$Platform$Sub$map, $author$project$Environments$ErrorHandling$ErrorModal$ReceivedCopyMsg, $author$project$Utils$CopyToClipboard$subscriptions);
var $author$project$Environments$Repository$ReceivedAuditStoreMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Environments$Repository$ReceivedCheckpointDataStoreMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Environments$Repository$ReceivedEventStreamMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Environments$Repository$ReceivedFileStoreMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Environments$Repository$ReceivedHttpResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Environments$Repository$ReceivedMeasureStoreMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Environments$Repository$ReceivedOrganisationUnitStoreMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Environments$Repository$ReceivedPlanStoreMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Environments$Repository$ReceivedRightsStoreMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Environments$Repository$ReceivedTenantStoreMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Environments$Repository$ReceivedUserStoreMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audit$Store$auditStoreInbox = _Platform_incomingPort('auditStoreInbox', $elm$json$Json$Decode$value);
var $author$project$Audit$Store$LoadedData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audit$Store$RemovedCommand = {$: 4};
var $author$project$Audit$Store$RemovedCommandAndEvent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Audit$Store$SavedAudits = {$: 1};
var $author$project$Audit$Store$SavedCommandsAndEvents = {$: 3};
var $author$project$Audit$Store$SavedModifications = {$: 2};
var $author$project$Audit$Id$Id = $elm$core$Basics$identity;
var $author$project$Audit$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$Types$CommandId$Id = $elm$core$Basics$identity;
var $author$project$Types$CommandId$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$Audit$Store$Data = F3(
	function (audits, events, commands) {
		return {aC: audits, cD: commands, b8: events};
	});
var $author$project$Audit$Audits$Audits = $elm$core$Basics$identity;
var $author$project$Audit$Audits$Data = F2(
	function (dict, lastEventId) {
		return {cL: dict, fD: lastEventId};
	});
var $author$project$Audit$Audit$Audit = function (auditId) {
	return function (id) {
		return function (planId) {
			return function (planRevision) {
				return function (executionId) {
					return function (title) {
						return function (description) {
							return function (creationTimestamp) {
								return function (deadlineTimestamp) {
									return function (auditors) {
										return function (checkpointHierarchy) {
											return function (records) {
												return function (completionStatus) {
													return function (revision) {
														return {gm: auditId, bT: auditors, ff: checkpointHierarchy, jb: completionStatus, dw: creationTimestamp, hI: deadlineTimestamp, aY: description, dH: executionId, fw: id, d5: planId, d6: planRevision, io: records, i: revision, k8: title};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Audit$CompletionStatus$Completed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$CompletionStatus$Open = {$: 0};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $author$project$Utils$Decode$timestamp = A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int);
var $author$project$Audit$CompletionStatus$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (commandType) {
		switch (commandType) {
			case 'Open':
				return $elm$json$Json$Decode$succeed($author$project$Audit$CompletionStatus$Open);
			case 'Completed':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'timestamp',
					$author$project$Utils$Decode$timestamp,
					$elm$json$Json$Decode$succeed($author$project$Audit$CompletionStatus$Completed));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'CompletionType', $elm$json$Json$Decode$string));
var $author$project$Audit$Record$Record$Record = F6(
	function (recordId, recordTimestamp, checkpointId, auditorId, value, files) {
		return {iW: auditorId, i5: checkpointId, cT: files, bK: recordId, g8: recordTimestamp, ll: value};
	});
var $author$project$Audit$Record$Id$Id = $elm$core$Basics$identity;
var $author$project$Audit$Record$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$CheckpointData$Checkpoint$Id$Id = $elm$core$Basics$identity;
var $author$project$CheckpointData$Checkpoint$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$CheckpointData$Checkpoint$Value$CheckboxValue = function (a) {
	return {$: 3, a: a};
};
var $author$project$CheckpointData$Checkpoint$Value$DateValue = function (a) {
	return {$: 7, a: a};
};
var $author$project$CheckpointData$Checkpoint$Value$ImageValue = function (a) {
	return {$: 8, a: a};
};
var $author$project$CheckpointData$Checkpoint$Value$IndividualDataValue = function (a) {
	return {$: 4, a: a};
};
var $author$project$CheckpointData$Checkpoint$Value$MultiSelectValue = function (a) {
	return {$: 6, a: a};
};
var $author$project$CheckpointData$Checkpoint$Value$NumberValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$CheckpointData$Checkpoint$Value$SelectValue = function (a) {
	return {$: 5, a: a};
};
var $author$project$CheckpointData$Checkpoint$Value$SignatureValue = function (a) {
	return {$: 9, a: a};
};
var $author$project$CheckpointData$Checkpoint$Value$TextMemoValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Checkpoint$Value$TextRowValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$Checkpoint$Value$TimeValue = function (a) {
	return {$: 10, a: a};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Date_Time$Month$April = 3;
var $author$project$Date_Time$Month$August = 7;
var $author$project$Date_Time$Month$December = 11;
var $author$project$Date_Time$Month$February = 1;
var $author$project$Date_Time$Month$January = 0;
var $author$project$Date_Time$Month$July = 6;
var $author$project$Date_Time$Month$June = 5;
var $author$project$Date_Time$Month$March = 2;
var $author$project$Date_Time$Month$May = 4;
var $author$project$Date_Time$Month$November = 10;
var $author$project$Date_Time$Month$October = 9;
var $author$project$Date_Time$Month$September = 8;
var $author$project$Date_Time$Month$fromInt = function (i) {
	switch (i) {
		case 1:
			return $elm$core$Maybe$Just(0);
		case 2:
			return $elm$core$Maybe$Just(1);
		case 3:
			return $elm$core$Maybe$Just(2);
		case 4:
			return $elm$core$Maybe$Just(3);
		case 5:
			return $elm$core$Maybe$Just(4);
		case 6:
			return $elm$core$Maybe$Just(5);
		case 7:
			return $elm$core$Maybe$Just(6);
		case 8:
			return $elm$core$Maybe$Just(7);
		case 9:
			return $elm$core$Maybe$Just(8);
		case 10:
			return $elm$core$Maybe$Just(9);
		case 11:
			return $elm$core$Maybe$Just(10);
		case 12:
			return $elm$core$Maybe$Just(11);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Date_Time$NaiveDate$NaiveDate = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Date_Time$NaiveDate$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $author$project$Date_Time$NaiveDate$numberOfDaysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 1:
				return $author$project$Date_Time$NaiveDate$isLeapYear(y) ? 29 : 28;
			case 3:
				return 30;
			case 5:
				return 30;
			case 8:
				return 30;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $author$project$Date_Time$NaiveDate$ymd = F3(
	function (y, m, d) {
		return ((d < 1) || (_Utils_cmp(
			d,
			A2($author$project$Date_Time$NaiveDate$numberOfDaysInMonth, y, m)) > 0)) ? $elm$core$Result$Err('Not a valid date') : $elm$core$Result$Ok(
			A3($author$project$Date_Time$NaiveDate$NaiveDate, y, m, d));
	});
var $author$project$Date_Time$NaiveDate$fromStringYMD = function (str) {
	var _v0 = A2($elm$core$String$split, '-', str);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var ys = _v0.a;
		var _v1 = _v0.b;
		var ms = _v1.a;
		var _v2 = _v1.b;
		var ds = _v2.a;
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Result$toMaybe,
			A4(
				$elm$core$Maybe$map3,
				$author$project$Date_Time$NaiveDate$ymd,
				$elm$core$String$toInt(ys),
				A3(
					$elm$core$Basics$composeR,
					$elm$core$String$toInt,
					$elm$core$Maybe$andThen($author$project$Date_Time$Month$fromInt),
					ms),
				$elm$core$String$toInt(ds)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Date_Time$NaiveDate$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Date_Time$NaiveDate$fromStringYMD,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Not a valid date')))),
	$elm$json$Json$Decode$string);
var $author$project$Date_Time$NaiveTime$NaiveTime = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Date_Time$NaiveTime$setHour = F2(
	function (h, _v0) {
		var m = _v0.b;
		var s = _v0.c;
		return ((h < 0) || (h > 23)) ? $elm$core$Result$Err('Must be between 0 and 23') : $elm$core$Result$Ok(
			A3($author$project$Date_Time$NaiveTime$NaiveTime, h, m, s));
	});
var $author$project$Date_Time$NaiveTime$setMinute = F2(
	function (m, _v0) {
		var h = _v0.a;
		var s = _v0.c;
		return ((m < 0) || (m > 59)) ? $elm$core$Result$Err('Must be between 0 and 59') : $elm$core$Result$Ok(
			A3($author$project$Date_Time$NaiveTime$NaiveTime, h, m, s));
	});
var $author$project$Date_Time$NaiveTime$hm = F2(
	function (h, m) {
		return A2(
			$elm$core$Result$andThen,
			$author$project$Date_Time$NaiveTime$setMinute(m),
			A2(
				$author$project$Date_Time$NaiveTime$setHour,
				h,
				A3($author$project$Date_Time$NaiveTime$NaiveTime, 0, 0, 0)));
	});
var $author$project$Date_Time$NaiveTime$setSecond = F2(
	function (s, _v0) {
		var h = _v0.a;
		var m = _v0.b;
		return ((s < 0) || (s > 59)) ? $elm$core$Result$Err('Must be between 0 and 59') : $elm$core$Result$Ok(
			A3($author$project$Date_Time$NaiveTime$NaiveTime, h, m, s));
	});
var $author$project$Date_Time$NaiveTime$hms = F3(
	function (h, m, s) {
		return A2(
			$elm$core$Result$andThen,
			$author$project$Date_Time$NaiveTime$setSecond(s),
			A2($author$project$Date_Time$NaiveTime$hm, h, m));
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Date_Time$NaiveTime$fromString = function (str) {
	var _v0 = A2($elm$core$String$split, ':', str);
	_v0$2:
	while (true) {
		if (_v0.b && _v0.b.b) {
			if (_v0.b.b.b) {
				if (!_v0.b.b.b.b) {
					var hh = _v0.a;
					var _v1 = _v0.b;
					var mm = _v1.a;
					var _v2 = _v1.b;
					var ss = _v2.a;
					return A2(
						$elm$core$Maybe$andThen,
						$elm$core$Result$toMaybe,
						A4(
							$elm$core$Maybe$map3,
							$author$project$Date_Time$NaiveTime$hms,
							$elm$core$String$toInt(hh),
							$elm$core$String$toInt(mm),
							$elm$core$String$toInt(ss)));
				} else {
					break _v0$2;
				}
			} else {
				var hh = _v0.a;
				var _v3 = _v0.b;
				var mm = _v3.a;
				return A2(
					$elm$core$Maybe$andThen,
					$elm$core$Result$toMaybe,
					A3(
						$elm$core$Maybe$map2,
						$author$project$Date_Time$NaiveTime$hm,
						$elm$core$String$toInt(hh),
						$elm$core$String$toInt(mm)));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Date_Time$NaiveTime$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Date_Time$NaiveTime$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Not a valid time')))),
	$elm$json$Json$Decode$string);
var $author$project$CheckpointData$Checkpoint$CheckpointType$Option = F2(
	function (id, text) {
		return {fw: id, hl: text};
	});
var $author$project$CheckpointData$Checkpoint$CheckpointType$decodeOption = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'text',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$Option)));
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$CheckpointData$Checkpoint$Value$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (checkpointValue) {
		switch (checkpointValue) {
			case 'number':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$float,
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$NumberValue));
			case 'textRow':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$TextRowValue));
			case 'textMemo':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$TextMemoValue));
			case 'checkbox':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$CheckboxValue));
			case 'individualData':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$IndividualDataValue));
			case 'select':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$author$project$CheckpointData$Checkpoint$CheckpointType$decodeOption,
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$SelectValue));
			case 'multiSelect':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$list($author$project$CheckpointData$Checkpoint$CheckpointType$decodeOption),
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$MultiSelectValue));
			case 'date':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$author$project$Date_Time$NaiveDate$decode,
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$DateValue));
			case 'image':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$author$project$File$Filename$decode,
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$ImageValue));
			case 'signature':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$author$project$File$Filename$decode,
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$SignatureValue));
			case 'time':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$author$project$Date_Time$NaiveTime$decode,
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Value$TimeValue));
			default:
				return $elm$json$Json$Decode$fail('Unknown Value');
		}
	},
	A2($elm$json$Json$Decode$field, 'recordType', $elm$json$Json$Decode$string));
var $author$project$File$Filename$toIdString = function (filename) {
	return $author$project$File$Id$toString(filename.fw);
};
var $author$project$File$Filenames$decode = A2($turboMaCk$any_set$Set$Any$decode, $author$project$File$Filename$toIdString, $author$project$File$Filename$decode);
var $turboMaCk$any_dict$Dict$Any$empty = function (toKey) {
	return {cL: $elm$core$Dict$empty, a3: toKey};
};
var $turboMaCk$any_set$Set$Any$empty = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $turboMaCk$any_dict$Dict$Any$empty);
var $author$project$File$Filenames$empty = $turboMaCk$any_set$Set$Any$empty($author$project$File$Filename$toIdString);
var $author$project$Audit$Record$Record$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'files',
	$author$project$File$Filenames$decode,
	$author$project$File$Filenames$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$author$project$CheckpointData$Checkpoint$Value$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'auditorId',
			$author$project$User$Id$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'checkpointId',
				$author$project$CheckpointData$Checkpoint$Id$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recordTimestamp',
					$author$project$Utils$Decode$timestamp,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'recordId',
						$author$project$Audit$Record$Id$decode,
						$elm$json$Json$Decode$succeed($author$project$Audit$Record$Record$Record)))))));
var $author$project$Audit$Record$Records$Records = $elm$core$Basics$identity;
var $author$project$Audit$Record$Records$empty = {
	ev: $turboMaCk$any_dict$Dict$Any$empty($author$project$CheckpointData$Checkpoint$Id$toString),
	cL: $turboMaCk$any_dict$Dict$Any$empty($author$project$Audit$Record$Id$toString)
};
var $turboMaCk$any_dict$Dict$Any$insert = F3(
	function (k, v, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				cL: A3(
					$elm$core$Dict$insert,
					inner.a3(k),
					_Utils_Tuple2(k, v),
					inner.cL)
			});
	});
var $author$project$Audit$Record$Records$insert = F2(
	function (record, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				ev: A3($turboMaCk$any_dict$Dict$Any$insert, record.i5, record.bK, data.ev),
				cL: A3($turboMaCk$any_dict$Dict$Any$insert, record.bK, record, data.cL)
			});
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Audit$Record$Records$fromListAndSortByRecordTimestamp = function (recordList) {
	var sortedByRecordTimeStamp = A2(
		$elm$core$List$sortBy,
		function (record) {
			return $elm$time$Time$posixToMillis(record.g8);
		},
		recordList);
	return A3($elm$core$List$foldl, $author$project$Audit$Record$Records$insert, $author$project$Audit$Record$Records$empty, sortedByRecordTimeStamp);
};
var $author$project$Audit$Record$Records$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$Audit$Record$Records$fromListAndSortByRecordTimestamp,
	$elm$json$Json$Decode$list($author$project$Audit$Record$Record$decode));
var $author$project$Plan$Execution$Id$Id = $elm$core$Basics$identity;
var $author$project$Plan$Execution$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$Plan$Id$Id = $elm$core$Basics$identity;
var $author$project$Plan$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$User$Ids$decode = A2($turboMaCk$any_set$Set$Any$decode, $author$project$User$Id$toString, $author$project$User$Id$decode);
var $author$project$CheckpointData$CheckpointHierarchy$CheckpointHierarchy = F2(
	function (checkpointGroups, checkpoints) {
		return {gt: checkpointGroups, i6: checkpoints};
	});
var $author$project$CheckpointData$Checkpoint$Checkpoint$Checkpoint = F9(
	function (checkpointId, checkpointGroupId, title, description, checkpointType, prev, next, files, revision) {
		return {cC: checkpointGroupId, i5: checkpointId, fg: checkpointType, aY: description, cT: files, kc: next, kw: prev, i: revision, k8: title};
	});
var $author$project$CheckpointData$Checkpoint$CheckpointType$CheckboxType = {$: 3};
var $author$project$CheckpointData$Checkpoint$CheckpointType$DateType = {$: 7};
var $author$project$CheckpointData$Checkpoint$CheckpointType$ImageType = {$: 8};
var $author$project$CheckpointData$Checkpoint$CheckpointType$IndividualDataModel = function (values) {
	return {bd: values};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$IndividualDataType = function (a) {
	return {$: 4, a: a};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$InfoModel = function (text) {
	return {hl: text};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$InfoType = function (a) {
	return {$: 9, a: a};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$MultiSelectModel = function (options) {
	return {fR: options};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$MultiSelectType = function (a) {
	return {$: 6, a: a};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$NumberModel = function (decimalPoints) {
	return {hJ: decimalPoints};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$NumberType = function (a) {
	return {$: 0, a: a};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$SelectModel = function (options) {
	return {fR: options};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$SelectType = function (a) {
	return {$: 5, a: a};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$SignatureType = {$: 10};
var $author$project$CheckpointData$Checkpoint$CheckpointType$TextMemoType = {$: 2};
var $author$project$CheckpointData$Checkpoint$CheckpointType$TextRowType = {$: 1};
var $author$project$CheckpointData$Checkpoint$CheckpointType$TimeType = {$: 11};
var $author$project$CheckpointData$Checkpoint$CheckpointType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (checkpointType) {
		switch (checkpointType) {
			case 'number':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'decimalPoints', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Checkpoint$CheckpointType$NumberType),
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$NumberModel));
			case 'textRow':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$TextRowType);
			case 'textMemo':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$TextMemoType);
			case 'checkbox':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$CheckboxType);
			case 'individualData':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'values',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						_List_Nil),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Checkpoint$CheckpointType$IndividualDataType),
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$IndividualDataModel));
			case 'select':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'options',
						$elm$json$Json$Decode$list($author$project$CheckpointData$Checkpoint$CheckpointType$decodeOption),
						_List_Nil),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Checkpoint$CheckpointType$SelectType),
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$SelectModel));
			case 'multiSelect':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'options',
						$elm$json$Json$Decode$list($author$project$CheckpointData$Checkpoint$CheckpointType$decodeOption),
						_List_Nil),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Checkpoint$CheckpointType$MultiSelectType),
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$MultiSelectModel));
			case 'date':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$DateType);
			case 'image':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$ImageType);
			case 'info':
				return A3(
					$elm$core$Basics$composeR,
					A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'text', $elm$json$Json$Decode$string, ''),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Checkpoint$CheckpointType$InfoType),
					$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$InfoModel));
			case 'signature':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$SignatureType);
			case 'time':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$CheckpointType$TimeType);
			default:
				return $elm$json$Json$Decode$fail('Unknown Type');
		}
	},
	A2($elm$json$Json$Decode$field, 'checkpointType', $elm$json$Json$Decode$string));
var $author$project$CheckpointData$CheckpointGroup$Id$Id = $elm$core$Basics$identity;
var $author$project$CheckpointData$CheckpointGroup$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$CheckpointData$Checkpoint$Checkpoint$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revision',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'files',
		$author$project$File$Filenames$decode,
		$author$project$File$Filenames$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'next',
			$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'prev',
				$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'checkpointType',
					$author$project$CheckpointData$Checkpoint$CheckpointType$decode,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'checkpointGroupId',
								$author$project$CheckpointData$CheckpointGroup$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'checkpointId',
									$author$project$CheckpointData$Checkpoint$Id$decode,
									$elm$json$Json$Decode$succeed($author$project$CheckpointData$Checkpoint$Checkpoint$Checkpoint))))))))));
var $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$CheckpointGroup = F9(
	function (checkpointGroupId, organisationUnitId, title, description, prev, next, first, last, revision) {
		return {cC: checkpointGroupId, aY: description, jC: first, jT: last, kc: next, km: organisationUnitId, kw: prev, i: revision, k8: title};
	});
var $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revision',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'last',
		$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'first',
			$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'next',
				$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'prev',
					$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'organisationUnitId',
								$author$project$OrganisationUnit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'checkpointGroupId',
									$author$project$CheckpointData$CheckpointGroup$Id$decode,
									$elm$json$Json$Decode$succeed($author$project$CheckpointData$CheckpointGroup$CheckpointGroup$CheckpointGroup))))))))));
var $author$project$CheckpointData$CheckpointHierarchy$decodeCheckpointHierarchy = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'checkpoints',
	$elm$json$Json$Decode$list($author$project$CheckpointData$Checkpoint$Checkpoint$decode),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'checkpointGroups',
		$elm$json$Json$Decode$list($author$project$CheckpointData$CheckpointGroup$CheckpointGroup$decode),
		_List_Nil,
		$elm$json$Json$Decode$succeed($author$project$CheckpointData$CheckpointHierarchy$CheckpointHierarchy)));
var $author$project$User$Ids$empty = $turboMaCk$any_set$Set$Any$empty($author$project$User$Id$toString);
var $author$project$Audit$Audit$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revision',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'completionStatus',
		$author$project$Audit$CompletionStatus$decode,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'records',
			$author$project$Audit$Record$Records$decode,
			$author$project$Audit$Record$Records$empty,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'checkpointHierarchy',
				$author$project$CheckpointData$CheckpointHierarchy$decodeCheckpointHierarchy,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'auditors',
					$author$project$User$Ids$decode,
					$author$project$User$Ids$empty,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'deadlineTimestamp',
						$author$project$Utils$Decode$timestamp,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'creationTimestamp',
							$author$project$Utils$Decode$timestamp,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'description',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'title',
									$elm$json$Json$Decode$string,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'executionId',
										$elm$json$Json$Decode$maybe($author$project$Plan$Execution$Id$decode),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'planRevision',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'planId',
												$author$project$Plan$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'auditId',
														$author$project$Audit$Id$decode,
														$elm$json$Json$Decode$succeed($author$project$Audit$Audit$Audit)))))))))))))));
var $author$project$Utils$Tuple$with = F3(
	function (firstFn, secondFn, value) {
		return _Utils_Tuple2(
			firstFn(value),
			secondFn(value));
	});
var $author$project$Audit$Dict$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2(
			$author$project$Utils$Tuple$with,
			function ($) {
				return $.gm;
			},
			$elm$core$Basics$identity)),
	$turboMaCk$any_dict$Dict$Any$fromList($author$project$Audit$Id$toString));
var $author$project$Audit$Dict$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$Audit$Dict$fromList,
	$elm$json$Json$Decode$list($author$project$Audit$Audit$decode));
var $author$project$Audit$Audits$AuditV1 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audit$Audits$AuditV2 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$OldAudits$AuditV1 = function (auditId) {
	return function (id) {
		return function (planId) {
			return function (title) {
				return function (description) {
					return function (creationTimestamp) {
						return function (deadlineTimestamp) {
							return function (auditors) {
								return function (checkpointHierarchy) {
									return function (records) {
										return function (isCompleted) {
											return function (version) {
												return {gm: auditId, bT: auditors, ff: checkpointHierarchy, dw: creationTimestamp, hI: deadlineTimestamp, aY: description, fw: id, jN: isCompleted, d5: planId, io: records, k8: title, n: version};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Audit$OldAudits$decodeAuditV1 = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'version',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isCompleted',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'records',
			$author$project$Audit$Record$Records$decode,
			$author$project$Audit$Record$Records$empty,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'checkpointHierarchy',
				$author$project$CheckpointData$CheckpointHierarchy$decodeCheckpointHierarchy,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'auditors',
					$author$project$User$Ids$decode,
					$author$project$User$Ids$empty,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'deadlineTimestamp',
						$author$project$Utils$Decode$timestamp,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'creationTimestamp',
							$author$project$Utils$Decode$timestamp,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'description',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'title',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'planId',
										$author$project$Plan$Id$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'auditId',
												$author$project$Audit$Id$decode,
												$elm$json$Json$Decode$succeed($author$project$Audit$OldAudits$AuditV1)))))))))))));
var $author$project$Audit$Audits$decodeAuditValues = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Audit$Audits$AuditV1, $author$project$Audit$OldAudits$decodeAuditV1),
			A2($elm$json$Json$Decode$map, $author$project$Audit$Audits$AuditV2, $author$project$Audit$Audit$decode)
		]));
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $author$project$Audit$OldAudits$auditV1ToAudit = function (auditV1) {
	return {gm: auditV1.gm, bT: auditV1.bT, ff: auditV1.ff, jb: $author$project$Audit$CompletionStatus$Open, dw: auditV1.dw, hI: auditV1.hI, aY: auditV1.aY, dH: $elm$core$Maybe$Nothing, fw: auditV1.fw, d5: auditV1.d5, d6: $elm$core$Maybe$Nothing, io: auditV1.io, i: auditV1.n, k8: auditV1.k8};
};
var $author$project$Audit$Audits$oldAuditToDict = function (listAuditVersion) {
	var transformAudits = F2(
		function (auditVersion, auditList) {
			if (!auditVersion.$) {
				var auditV1 = auditVersion.a;
				return A2(
					$elm$core$List$append,
					auditList,
					_List_fromArray(
						[
							$author$project$Audit$OldAudits$auditV1ToAudit(auditV1)
						]));
			} else {
				var audit = auditVersion.a;
				return A2(
					$elm$core$List$append,
					auditList,
					_List_fromArray(
						[audit]));
			}
		});
	return $author$project$Audit$Dict$fromList(
		A3($elm$core$List$foldl, transformAudits, _List_Nil, listAuditVersion));
};
var $author$project$Audit$Audits$decodeFromOldAudits = A2(
	$elm$json$Json$Decode$map,
	$author$project$Audit$Audits$oldAuditToDict,
	$elm$json$Json$Decode$list($author$project$Audit$Audits$decodeAuditValues));
var $author$project$Audit$Dict$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$Audit$Id$toString);
var $author$project$Audit$Audits$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lastEventId',
		$elm$json$Json$Decode$maybe($author$project$Types$EventId$decode),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'audits',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[$author$project$Audit$Dict$decode, $author$project$Audit$Audits$decodeFromOldAudits])),
			$author$project$Audit$Dict$empty,
			$elm$json$Json$Decode$succeed($author$project$Audit$Audits$Data))));
var $author$project$Audit$Command$AddRecordFiles = function (a) {
	return {$: 6, a: a};
};
var $author$project$Audit$Command$AddRecordFilesPayload = F7(
	function (commandId, commandTimestamp, auditId, recordId, files, idForError, titleForError) {
		return {gm: auditId, L: commandId, M: commandTimestamp, cT: files, k: idForError, bK: recordId, l: titleForError};
	});
var $author$project$Audit$Command$ChangeAuditors = function (a) {
	return {$: 5, a: a};
};
var $author$project$Audit$Command$ChangeAuditorsPayload = F7(
	function (commandId, commandTimestamp, auditId, addAuditors, removeAuditors, idForError, titleForError) {
		return {ge: addAuditors, gm: auditId, L: commandId, M: commandTimestamp, k: idForError, g9: removeAuditors, l: titleForError};
	});
var $author$project$Audit$Command$ChangeDeadline = function (a) {
	return {$: 4, a: a};
};
var $author$project$Audit$Command$ChangeDeadlinePayload = F6(
	function (commandId, commandTimestamp, auditId, deadlineTimestamp, idForError, titleForError) {
		return {gm: auditId, L: commandId, M: commandTimestamp, hI: deadlineTimestamp, k: idForError, l: titleForError};
	});
var $author$project$Audit$Command$ChangeDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audit$Command$ChangeDescriptionPayload = F6(
	function (commandId, commandTimestamp, auditId, description, idForError, titleForError) {
		return {gm: auditId, L: commandId, M: commandTimestamp, aY: description, k: idForError, l: titleForError};
	});
var $author$project$Audit$Command$ChangeTitle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audit$Command$ChangeTitlePayload = F6(
	function (commandId, commandTimestamp, auditId, title, idForError, titleForError) {
		return {gm: auditId, L: commandId, M: commandTimestamp, k: idForError, k8: title, l: titleForError};
	});
var $author$project$Audit$Command$Complete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Audit$Command$CompletePayload = F5(
	function (commandId, commandTimestamp, auditId, idForError, titleForError) {
		return {gm: auditId, L: commandId, M: commandTimestamp, k: idForError, l: titleForError};
	});
var $author$project$Audit$Command$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audit$Command$CreatePayload = function (commandId) {
	return function (commandTimestamp) {
		return function (auditId) {
			return function (id) {
				return function (planId) {
					return function (planRevision) {
						return function (executionId) {
							return function (title) {
								return function (description) {
									return function (creationTimestamp) {
										return function (deadlineTimestamp) {
											return function (auditors) {
												return function (checkpointHierarchy) {
													return {gm: auditId, bT: auditors, ff: checkpointHierarchy, L: commandId, M: commandTimestamp, dw: creationTimestamp, hI: deadlineTimestamp, aY: description, dH: executionId, fw: id, d5: planId, d6: planRevision, k8: title};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Audit$Command$Delete = function (a) {
	return {$: 9, a: a};
};
var $author$project$Audit$Command$DeletePayload = F5(
	function (commandId, commandTimestamp, auditId, idForError, titleForError) {
		return {gm: auditId, L: commandId, M: commandTimestamp, k: idForError, l: titleForError};
	});
var $author$project$Audit$Command$RecordCheckpoint = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$Command$RecordCheckpointPayload = F6(
	function (commandId, commandTimestamp, auditId, record, idForError, titleForError) {
		return {gm: auditId, L: commandId, M: commandTimestamp, k: idForError, ct: record, l: titleForError};
	});
var $author$project$Audit$Command$RemoveRecordFiles = function (a) {
	return {$: 7, a: a};
};
var $author$project$Audit$Command$RemoveRecordFilesPayload = F7(
	function (commandId, commandTimestamp, auditId, recordId, files, idForError, titleForError) {
		return {gm: auditId, L: commandId, M: commandTimestamp, cT: files, k: idForError, bK: recordId, l: titleForError};
	});
var $author$project$Audit$Command$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (commandType) {
		switch (commandType) {
			case 'de.awenko.audit.create.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'checkpointHierarchy', $author$project$CheckpointData$CheckpointHierarchy$decodeCheckpointHierarchy),
					$elm$json$Json$Decode$map($author$project$Audit$Command$Create),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'auditors',
						$author$project$User$Ids$decode,
						$author$project$User$Ids$empty,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'deadlineTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'creationTimestamp',
								$author$project$Utils$Decode$timestamp,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'title',
										$elm$json$Json$Decode$string,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'executionId',
											$elm$json$Json$Decode$maybe($author$project$Plan$Execution$Id$decode),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'planRevision',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'planId',
													$author$project$Plan$Id$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'auditId',
															$author$project$Audit$Id$decode,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'commandTimestamp',
																$author$project$Utils$Decode$timestamp,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'commandId',
																	$author$project$Types$CommandId$decode,
																	$elm$json$Json$Decode$succeed($author$project$Audit$Command$CreatePayload))))))))))))));
			case 'de.awenko.audit.record-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Audit$Command$RecordCheckpoint),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'record',
							$author$project$Audit$Record$Record$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'auditId',
								$author$project$Audit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Audit$Command$RecordCheckpointPayload)))))));
			case 'de.awenko.audit.changeTitle.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Audit$Command$ChangeTitle),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'auditId',
								$author$project$Audit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Audit$Command$ChangeTitlePayload)))))));
			case 'de.awenko.audit.changeDescription.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Audit$Command$ChangeDescription),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'description',
							$elm$json$Json$Decode$string,
							'',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'auditId',
								$author$project$Audit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Audit$Command$ChangeDescriptionPayload)))))));
			case 'de.awenko.audit.changeDeadline.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Audit$Command$ChangeDeadline),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'deadlineTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'auditId',
								$author$project$Audit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Audit$Command$ChangeDeadlinePayload)))))));
			case 'de.awenko.audit.changeAuditors.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Audit$Command$ChangeAuditors),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'removeAuditors',
							$author$project$User$Ids$decode,
							$author$project$User$Ids$empty,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'addAuditors',
								$author$project$User$Ids$decode,
								$author$project$User$Ids$empty,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'auditId',
									$author$project$Audit$Id$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandTimestamp',
										$author$project$Utils$Decode$timestamp,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'commandId',
											$author$project$Types$CommandId$decode,
											$elm$json$Json$Decode$succeed($author$project$Audit$Command$ChangeAuditorsPayload))))))));
			case 'de.awenko.audit.addRecordFiles.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Audit$Command$AddRecordFiles),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'files',
							$elm$json$Json$Decode$list($author$project$File$Filename$decode),
							_List_Nil,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'recordId',
								$author$project$Audit$Record$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'auditId',
									$author$project$Audit$Id$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandTimestamp',
										$author$project$Utils$Decode$timestamp,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'commandId',
											$author$project$Types$CommandId$decode,
											$elm$json$Json$Decode$succeed($author$project$Audit$Command$AddRecordFilesPayload))))))));
			case 'de.awenko.audit.removeRecordFiles.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Audit$Command$RemoveRecordFiles),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'files',
							$elm$json$Json$Decode$list($author$project$File$Filename$decode),
							_List_Nil,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'recordId',
								$author$project$Audit$Record$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'auditId',
									$author$project$Audit$Id$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandTimestamp',
										$author$project$Utils$Decode$timestamp,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'commandId',
											$author$project$Types$CommandId$decode,
											$elm$json$Json$Decode$succeed($author$project$Audit$Command$RemoveRecordFilesPayload))))))));
			case 'de.awenko.audit.complete.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Audit$Command$Complete),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'auditId',
							$author$project$Audit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Audit$Command$CompletePayload))))));
			case 'de.awenko.audit.delete.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Audit$Command$Delete),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'auditId',
							$author$project$Audit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Audit$Command$DeletePayload))))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'commandType', $elm$json$Json$Decode$string));
var $author$project$Types$Queue$fromList = function (list) {
	return A2($author$project$Types$Queue$Queue, list, _List_Nil);
};
var $author$project$Types$Queue$decode = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$list,
	$elm$json$Json$Decode$map($author$project$Types$Queue$fromList));
var $author$project$Audit$Commands$decode = $author$project$Types$Queue$decode($author$project$Audit$Command$decode);
var $author$project$Audit$Event$AuditorsChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Audit$Event$AuditorsChangedPayload = F7(
	function (eventId, commandId, commandTimestamp, auditId, addAuditors, removeAuditors, version) {
		return {ge: addAuditors, gm: auditId, L: commandId, M: commandTimestamp, N: eventId, g9: removeAuditors, n: version};
	});
var $author$project$Audit$Event$CheckpointRecorded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$Event$CheckpointRecordedPayload = F6(
	function (eventId, commandId, commandTimestamp, auditId, record, version) {
		return {gm: auditId, L: commandId, M: commandTimestamp, N: eventId, ct: record, n: version};
	});
var $author$project$Audit$Event$Completed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Audit$Event$CompletedPayload = F5(
	function (eventId, commandId, commandTimestamp, auditId, version) {
		return {gm: auditId, L: commandId, M: commandTimestamp, N: eventId, n: version};
	});
var $author$project$Audit$Event$Created = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audit$Event$CreatedPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (auditId) {
				return function (id) {
					return function (planId) {
						return function (planRevision) {
							return function (executionId) {
								return function (title) {
									return function (description) {
										return function (creationTimestamp) {
											return function (deadlineTimestamp) {
												return function (auditors) {
													return function (checkpointHierarchy) {
														return function (version) {
															return {gm: auditId, bT: auditors, ff: checkpointHierarchy, L: commandId, M: commandTimestamp, dw: creationTimestamp, hI: deadlineTimestamp, aY: description, N: eventId, dH: executionId, fw: id, d5: planId, d6: planRevision, k8: title, n: version};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Audit$Event$DeadlineChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Audit$Event$DeadlineChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, auditId, deadlineTimestamp, version) {
		return {gm: auditId, L: commandId, M: commandTimestamp, hI: deadlineTimestamp, N: eventId, n: version};
	});
var $author$project$Audit$Event$Deleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Audit$Event$DeletedPayload = F5(
	function (eventId, commandId, commandTimestamp, auditId, version) {
		return {gm: auditId, L: commandId, M: commandTimestamp, N: eventId, n: version};
	});
var $author$project$Audit$Event$DescriptionChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audit$Event$DescriptionChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, auditId, description, version) {
		return {gm: auditId, L: commandId, M: commandTimestamp, aY: description, N: eventId, n: version};
	});
var $author$project$Audit$Event$RecordFilesAdded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Audit$Event$RecordFilesAddedPayload = F7(
	function (eventId, commandId, commandTimestamp, auditId, recordId, files, version) {
		return {gm: auditId, L: commandId, M: commandTimestamp, N: eventId, cT: files, bK: recordId, n: version};
	});
var $author$project$Audit$Event$RecordFilesRemoved = function (a) {
	return {$: 7, a: a};
};
var $author$project$Audit$Event$RecordFilesRemovedPayload = F7(
	function (eventId, commandId, commandTimestamp, auditId, recordId, files, version) {
		return {gm: auditId, L: commandId, M: commandTimestamp, N: eventId, cT: files, bK: recordId, n: version};
	});
var $author$project$Audit$Event$TitleChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audit$Event$TitleChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, auditId, title, version) {
		return {gm: auditId, L: commandId, M: commandTimestamp, N: eventId, k8: title, n: version};
	});
var $author$project$Audit$Event$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (commandType) {
		switch (commandType) {
			case 'de.awenko.audit.created.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Audit$Event$Created),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'checkpointHierarchy',
						$author$project$CheckpointData$CheckpointHierarchy$decodeCheckpointHierarchy,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'auditors',
							$author$project$User$Ids$decode,
							$author$project$User$Ids$empty,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'deadlineTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'creationTimestamp',
									$author$project$Utils$Decode$timestamp,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										$elm$json$Json$Decode$string,
										'',
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'title',
											$elm$json$Json$Decode$string,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'executionId',
												$elm$json$Json$Decode$maybe($author$project$Plan$Execution$Id$decode),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'planRevision',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'planId',
														$author$project$Plan$Id$decode,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'auditId',
																$author$project$Audit$Id$decode,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'commandTimestamp',
																	$author$project$Utils$Decode$timestamp,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'commandId',
																		$author$project$Types$CommandId$decode,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'eventId',
																			$author$project$Types$EventId$decode,
																			$elm$json$Json$Decode$succeed($author$project$Audit$Event$CreatedPayload))))))))))))))));
			case 'de.awenko.audit.checkpoint-recorded.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Audit$Event$CheckpointRecorded),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'record',
						$author$project$Audit$Record$Record$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'auditId',
							$author$project$Audit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Audit$Event$CheckpointRecordedPayload)))))));
			case 'de.awenko.audit.title-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Audit$Event$TitleChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'auditId',
							$author$project$Audit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Audit$Event$TitleChangedPayload)))))));
			case 'de.awenko.audit.description-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Audit$Event$DescriptionChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'auditId',
							$author$project$Audit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Audit$Event$DescriptionChangedPayload)))))));
			case 'de.awenko.audit.deadline-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Audit$Event$DeadlineChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'deadlineTimestamp',
						$author$project$Utils$Decode$timestamp,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'auditId',
							$author$project$Audit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Audit$Event$DeadlineChangedPayload)))))));
			case 'de.awenko.audit.auditors-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Audit$Event$AuditorsChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'removeAuditors',
						$author$project$User$Ids$decode,
						$author$project$User$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'addAuditors',
							$author$project$User$Ids$decode,
							$author$project$User$Ids$empty,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'auditId',
								$author$project$Audit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'eventId',
											$author$project$Types$EventId$decode,
											$elm$json$Json$Decode$succeed($author$project$Audit$Event$AuditorsChangedPayload))))))));
			case 'de.awenko.audit.record-files-added.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Audit$Event$RecordFilesAdded),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'files',
						$elm$json$Json$Decode$list($author$project$File$Filename$decode),
						_List_Nil,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'recordId',
							$author$project$Audit$Record$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'auditId',
								$author$project$Audit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'eventId',
											$author$project$Types$EventId$decode,
											$elm$json$Json$Decode$succeed($author$project$Audit$Event$RecordFilesAddedPayload))))))));
			case 'de.awenko.audit.record-files-removed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Audit$Event$RecordFilesRemoved),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'files',
						$elm$json$Json$Decode$list($author$project$File$Filename$decode),
						_List_Nil,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'recordId',
							$author$project$Audit$Record$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'auditId',
								$author$project$Audit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'eventId',
											$author$project$Types$EventId$decode,
											$elm$json$Json$Decode$succeed($author$project$Audit$Event$RecordFilesRemovedPayload))))))));
			case 'de.awenko.audit.completed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Audit$Event$Completed),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'auditId',
						$author$project$Audit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$Audit$Event$CompletedPayload))))));
			case 'de.awenko.audit.deleted.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Audit$Event$Deleted),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'auditId',
						$author$project$Audit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$Audit$Event$DeletedPayload))))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'eventType', $elm$json$Json$Decode$string));
var $author$project$Audit$Events$decode = $author$project$Types$Queue$decode($author$project$Audit$Event$decode);
var $author$project$Audit$Audits$empty = {cL: $author$project$Audit$Dict$empty, fD: $elm$core$Maybe$Nothing};
var $author$project$Audit$Commands$empty = $author$project$Types$Queue$empty;
var $author$project$Audit$Events$empty = $author$project$Types$Queue$empty;
var $author$project$Audit$Store$decodeData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'commands',
	$author$project$Audit$Commands$decode,
	$author$project$Audit$Commands$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'events',
		$author$project$Audit$Events$decode,
		$author$project$Audit$Events$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'audits',
			$author$project$Audit$Audits$decode,
			$author$project$Audit$Audits$empty,
			$elm$json$Json$Decode$succeed($author$project$Audit$Store$Data))));
var $author$project$Audit$Store$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOADED_DATA':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Audit$Store$LoadedData,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Audit$Store$decodeData));
			case 'SAVED_AUDITS':
				return $elm$json$Json$Decode$succeed($author$project$Audit$Store$SavedAudits);
			case 'SAVED_MODIFICATIONS':
				return $elm$json$Json$Decode$succeed($author$project$Audit$Store$SavedModifications);
			case 'SAVED_COMMANDS_AND_EVENTS':
				return $elm$json$Json$Decode$succeed($author$project$Audit$Store$SavedCommandsAndEvents);
			case 'REMOVED_COMMAND':
				return $elm$json$Json$Decode$succeed($author$project$Audit$Store$RemovedCommand);
			case 'REMOVED_COMMAND_AND_EVENT':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventVersion',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'auditId',
						$author$project$Audit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandId',
							$author$project$Types$CommandId$decode,
							$elm$json$Json$Decode$succeed($author$project$Audit$Store$RemovedCommandAndEvent))));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Audit$Store$ReceivedErrorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Audit$Store$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$Audit$Store$ReceivedErrorMsg(error);
	}
};
var $author$project$Audit$Store$subscriptions = $author$project$Audit$Store$auditStoreInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Audit$Store$decodeMsg),
		$author$project$Audit$Store$handleDecodeResult));
var $author$project$CheckpointData$Store$checkpointDataStoreInbox = _Platform_incomingPort('checkpointDataStoreInbox', $elm$json$Json$Decode$value);
var $author$project$CheckpointData$Store$LoadedData = function (a) {
	return {$: 0, a: a};
};
var $author$project$CheckpointData$Store$RemovedCommand = {$: 4};
var $author$project$CheckpointData$Store$RemovedCommandAndEvent = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$CheckpointData$Store$SavedCheckpointData = {$: 1};
var $author$project$CheckpointData$Store$SavedCommandsAndEvents = {$: 3};
var $author$project$CheckpointData$Store$SavedModifications = {$: 2};
var $author$project$CheckpointData$Store$Data = F3(
	function (checkpointData, events, commands) {
		return {a: checkpointData, cD: commands, b8: events};
	});
var $author$project$CheckpointData$CheckpointData$CheckpointData = $elm$core$Basics$identity;
var $author$project$CheckpointData$CheckpointData$Data = F2(
	function (hierarchy, lastEventId) {
		return {a8: hierarchy, fD: lastEventId};
	});
var $author$project$CheckpointData$CheckpointData$Hierarchy = F2(
	function (checkpointGroups, checkpoints) {
		return {gt: checkpointGroups, i6: checkpoints};
	});
var $author$project$CheckpointData$Checkpoint$Dict$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2(
			$author$project$Utils$Tuple$with,
			function ($) {
				return $.i5;
			},
			$elm$core$Basics$identity)),
	$turboMaCk$any_dict$Dict$Any$fromList($author$project$CheckpointData$Checkpoint$Id$toString));
var $author$project$CheckpointData$Checkpoint$Dict$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$CheckpointData$Checkpoint$Dict$fromList,
	$elm$json$Json$Decode$list($author$project$CheckpointData$Checkpoint$Checkpoint$decode));
var $author$project$CheckpointData$CheckpointGroup$Dict$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2(
			$author$project$Utils$Tuple$with,
			function ($) {
				return $.cC;
			},
			$elm$core$Basics$identity)),
	$turboMaCk$any_dict$Dict$Any$fromList($author$project$CheckpointData$CheckpointGroup$Id$toString));
var $author$project$CheckpointData$CheckpointGroup$Dict$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$CheckpointData$CheckpointGroup$Dict$fromList,
	$elm$json$Json$Decode$list($author$project$CheckpointData$CheckpointGroup$CheckpointGroup$decode));
var $author$project$CheckpointData$Checkpoint$Dict$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$CheckpointData$Checkpoint$Id$toString);
var $author$project$CheckpointData$CheckpointGroup$Dict$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$CheckpointData$CheckpointGroup$Id$toString);
var $author$project$CheckpointData$CheckpointData$decodeHierarchy = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'checkpoints',
	$author$project$CheckpointData$Checkpoint$Dict$decode,
	$author$project$CheckpointData$Checkpoint$Dict$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'checkpointGroups',
		$author$project$CheckpointData$CheckpointGroup$Dict$decode,
		$author$project$CheckpointData$CheckpointGroup$Dict$empty,
		$elm$json$Json$Decode$succeed($author$project$CheckpointData$CheckpointData$Hierarchy)));
var $author$project$CheckpointData$CheckpointData$emptyHierarchy = {gt: $author$project$CheckpointData$CheckpointGroup$Dict$empty, i6: $author$project$CheckpointData$Checkpoint$Dict$empty};
var $author$project$CheckpointData$CheckpointData$decode = A3(
	$elm$core$Basics$composeR,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lastEventId',
		$elm$json$Json$Decode$maybe($author$project$Types$EventId$decode),
		$elm$core$Maybe$Nothing),
	$elm$json$Json$Decode$map($elm$core$Basics$identity),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'hierarchy',
		$author$project$CheckpointData$CheckpointData$decodeHierarchy,
		$author$project$CheckpointData$CheckpointData$emptyHierarchy,
		$elm$json$Json$Decode$succeed($author$project$CheckpointData$CheckpointData$Data)));
var $author$project$CheckpointData$Command$ChangeCheckpointDescription = function (a) {
	return {$: 9, a: a};
};
var $author$project$CheckpointData$Command$ChangeCheckpointDescriptionPayload = F5(
	function (commandId, commandTimestamp, checkpointId, description, titleForError) {
		return {i5: checkpointId, L: commandId, M: commandTimestamp, aY: description, l: titleForError};
	});
var $author$project$CheckpointData$Command$ChangeCheckpointFiles = function (a) {
	return {$: 10, a: a};
};
var $author$project$CheckpointData$Command$ChangeCheckpointFilesPayload = F6(
	function (commandId, commandTimestamp, checkpointId, addedFiles, deletedFiles, titleForError) {
		return {iM: addedFiles, i5: checkpointId, L: commandId, M: commandTimestamp, jk: deletedFiles, l: titleForError};
	});
var $author$project$CheckpointData$Command$ChangeCheckpointGroupDescription = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Command$ChangeCheckpointGroupDescriptionPayload = F5(
	function (commandId, commandTimestamp, checkpointGroupId, description, titleForError) {
		return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, aY: description, l: titleForError};
	});
var $author$project$CheckpointData$Command$ChangeCheckpointGroupTitle = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$Command$ChangeCheckpointGroupTitlePayload = F5(
	function (commandId, commandTimestamp, checkpointGroupId, title, titleForError) {
		return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, k8: title, l: titleForError};
	});
var $author$project$CheckpointData$Command$ChangeCheckpointTitle = function (a) {
	return {$: 8, a: a};
};
var $author$project$CheckpointData$Command$ChangeCheckpointTitlePayload = F5(
	function (commandId, commandTimestamp, checkpointId, title, titleForError) {
		return {i5: checkpointId, L: commandId, M: commandTimestamp, k8: title, l: titleForError};
	});
var $author$project$CheckpointData$Command$ChangeCheckpointType = function (a) {
	return {$: 7, a: a};
};
var $author$project$CheckpointData$Command$ChangeCheckpointTypePayload = F5(
	function (commandId, commandTimestamp, checkpointId, checkpointType, titleForError) {
		return {i5: checkpointId, fg: checkpointType, L: commandId, M: commandTimestamp, l: titleForError};
	});
var $author$project$CheckpointData$Command$CreateCheckpoint = function (a) {
	return {$: 6, a: a};
};
var $author$project$CheckpointData$Command$CreateCheckpointGroup = function (a) {
	return {$: 0, a: a};
};
var $author$project$CheckpointData$Command$CreateCheckpointGroupPayload = function (commandId) {
	return function (commandTimestamp) {
		return function (checkpointGroupId) {
			return function (organisationUnitId) {
				return function (title) {
					return function (description) {
						return function (prev) {
							return function (next) {
								return function (first) {
									return function (last) {
										return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, aY: description, jC: first, jT: last, kc: next, km: organisationUnitId, kw: prev, k8: title};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CheckpointData$Command$CreateCheckpointPayload = function (commandId) {
	return function (commandTimestamp) {
		return function (checkpointId) {
			return function (checkpointGroupId) {
				return function (title) {
					return function (description) {
						return function (checkpointType) {
							return function (prev) {
								return function (next) {
									return function (files) {
										return {cC: checkpointGroupId, i5: checkpointId, fg: checkpointType, L: commandId, M: commandTimestamp, aY: description, cT: files, kc: next, kw: prev, k8: title};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CheckpointData$Command$DeleteCheckpoint = function (a) {
	return {$: 14, a: a};
};
var $author$project$CheckpointData$Command$DeleteCheckpointGroup = function (a) {
	return {$: 5, a: a};
};
var $author$project$CheckpointData$Command$DeleteCheckpointGroupPayload = F7(
	function (commandId, commandTimestamp, checkpointGroupId, organisationUnitId, prev, next, titleForError) {
		return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, kc: next, km: organisationUnitId, kw: prev, l: titleForError};
	});
var $author$project$CheckpointData$Command$DeleteCheckpointPayload = F4(
	function (commandId, commandTimestamp, checkpointId, titleForError) {
		return {i5: checkpointId, L: commandId, M: commandTimestamp, l: titleForError};
	});
var $author$project$CheckpointData$Command$MoveCheckpoint = function (a) {
	return {$: 11, a: a};
};
var $author$project$CheckpointData$Command$MoveCheckpointAfter = function (a) {
	return {$: 13, a: a};
};
var $author$project$CheckpointData$Command$MoveCheckpointAfterPayload = F6(
	function (commandId, commandTimestamp, checkpointId, checkpointGroupId, previousId, titleForError) {
		return {cC: checkpointGroupId, i5: checkpointId, L: commandId, M: commandTimestamp, ay: previousId, l: titleForError};
	});
var $author$project$CheckpointData$Command$MoveCheckpointBefore = function (a) {
	return {$: 12, a: a};
};
var $author$project$CheckpointData$Command$MoveCheckpointBeforePayload = F6(
	function (commandId, commandTimestamp, checkpointId, checkpointGroupId, nextId, titleForError) {
		return {cC: checkpointGroupId, i5: checkpointId, L: commandId, M: commandTimestamp, ax: nextId, l: titleForError};
	});
var $author$project$CheckpointData$Command$MoveCheckpointGroupAfter = function (a) {
	return {$: 4, a: a};
};
var $author$project$CheckpointData$Command$MoveCheckpointGroupAfterPayload = F6(
	function (commandId, commandTimestamp, checkpointGroupId, previousId, organisationUnitId, titleForError) {
		return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, km: organisationUnitId, ay: previousId, l: titleForError};
	});
var $author$project$CheckpointData$Command$MoveCheckpointGroupBefore = function (a) {
	return {$: 3, a: a};
};
var $author$project$CheckpointData$Command$MoveCheckpointGroupBeforePayload = F6(
	function (commandId, commandTimestamp, checkpointGroupId, nextId, organisationUnitId, titleForError) {
		return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, ax: nextId, km: organisationUnitId, l: titleForError};
	});
var $author$project$CheckpointData$Command$MoveCheckpointPayload = F5(
	function (commandId, commandTimestamp, checkpointId, checkpointGroupId, titleForError) {
		return {cC: checkpointGroupId, i5: checkpointId, L: commandId, M: commandTimestamp, l: titleForError};
	});
var $author$project$CheckpointData$Command$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (commandType) {
		switch (commandType) {
			case 'de.awenko.checkpoint-group.create-checkpoint-group.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'last',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
						$elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$CreateCheckpointGroup),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'first',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'next',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'prev',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'title',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'organisationUnitId',
											$author$project$OrganisationUnit$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'checkpointGroupId',
												$author$project$CheckpointData$CheckpointGroup$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandTimestamp',
													$author$project$Utils$Decode$timestamp,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandId',
														$author$project$Types$CommandId$decode,
														$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$CreateCheckpointGroupPayload)))))))))));
			case 'de.awenko.checkpoint-group.change-checkpoint-group-title.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$ChangeCheckpointGroupTitle),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointGroupId',
							$author$project$CheckpointData$CheckpointGroup$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$ChangeCheckpointGroupTitlePayload))))));
			case 'de.awenko.checkpoint-group.change-checkpoint-group-description.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$ChangeCheckpointGroupDescription),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointGroupId',
							$author$project$CheckpointData$CheckpointGroup$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$ChangeCheckpointGroupDescriptionPayload))))));
			case 'de.awenko.checkpoint-group.move-before-checkpoint-group.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$MoveCheckpointGroupBefore),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nextId',
							$author$project$CheckpointData$CheckpointGroup$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'checkpointGroupId',
								$author$project$CheckpointData$CheckpointGroup$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$MoveCheckpointGroupBeforePayload)))))));
			case 'de.awenko.checkpoint-group.move-after-checkpoint-group.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$MoveCheckpointGroupAfter),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'previousId',
							$author$project$CheckpointData$CheckpointGroup$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'checkpointGroupId',
								$author$project$CheckpointData$CheckpointGroup$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$MoveCheckpointGroupAfterPayload)))))));
			case 'de.awenko.checkpoint-group.delete-checkpoint-group.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$DeleteCheckpointGroup),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'oldNext',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldPrev',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'organisationUnitId',
								$author$project$OrganisationUnit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'checkpointGroupId',
									$author$project$CheckpointData$CheckpointGroup$Id$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandTimestamp',
										$author$project$Utils$Decode$timestamp,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'commandId',
											$author$project$Types$CommandId$decode,
											$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$DeleteCheckpointGroupPayload))))))));
			case 'de.awenko.checkpoint-group.create-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'files', $author$project$File$Filenames$decode, $author$project$File$Filenames$empty),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$CreateCheckpoint),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'next',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'prev',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'checkpointType',
								$author$project$CheckpointData$Checkpoint$CheckpointType$decode,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'title',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'checkpointGroupId',
											$author$project$CheckpointData$CheckpointGroup$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'checkpointId',
												$author$project$CheckpointData$Checkpoint$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandTimestamp',
													$author$project$Utils$Decode$timestamp,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandId',
														$author$project$Types$CommandId$decode,
														$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$CreateCheckpointPayload)))))))))));
			case 'de.awenko.checkpoint-group.change-checkpoint-type.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$ChangeCheckpointType),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'checkpointType',
						$author$project$CheckpointData$Checkpoint$CheckpointType$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointId',
							$author$project$CheckpointData$Checkpoint$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$ChangeCheckpointTypePayload))))));
			case 'de.awenko.checkpoint-group.change-checkpoint-title.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$ChangeCheckpointTitle),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointId',
							$author$project$CheckpointData$Checkpoint$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$ChangeCheckpointTitlePayload))))));
			case 'de.awenko.checkpoint-group.change-checkpoint-description.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$ChangeCheckpointDescription),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointId',
							$author$project$CheckpointData$Checkpoint$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$ChangeCheckpointDescriptionPayload))))));
			case 'de.awenko.checkpoint-group.change-checkpoint-files.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$ChangeCheckpointFiles),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'deletedFiles',
						$elm$json$Json$Decode$list($author$project$File$Filename$decode),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'addedFiles',
							$elm$json$Json$Decode$list($author$project$File$Filename$decode),
							_List_Nil,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'checkpointId',
								$author$project$CheckpointData$Checkpoint$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$ChangeCheckpointFilesPayload)))))));
			case 'de.awenko.checkpoint-group.move-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$MoveCheckpoint),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'checkpointGroupId',
						$author$project$CheckpointData$CheckpointGroup$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointId',
							$author$project$CheckpointData$Checkpoint$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$MoveCheckpointPayload))))));
			case 'de.awenko.checkpoint-group.move-before-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$MoveCheckpointBefore),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nextId',
						$author$project$CheckpointData$Checkpoint$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointGroupId',
							$author$project$CheckpointData$CheckpointGroup$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'checkpointId',
								$author$project$CheckpointData$Checkpoint$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$MoveCheckpointBeforePayload)))))));
			case 'de.awenko.checkpoint-group.move-after-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$MoveCheckpointAfter),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'previousId',
						$author$project$CheckpointData$Checkpoint$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointGroupId',
							$author$project$CheckpointData$CheckpointGroup$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'checkpointId',
								$author$project$CheckpointData$Checkpoint$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$MoveCheckpointAfterPayload)))))));
			case 'de.awenko.checkpoint-group.delete-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Command$DeleteCheckpoint),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$CheckpointData$Command$DeleteCheckpointPayload)))));
			default:
				return $elm$json$Json$Decode$fail('Unknown command');
		}
	},
	A2($elm$json$Json$Decode$field, 'commandType', $elm$json$Json$Decode$string));
var $author$project$CheckpointData$Commands$decode = $author$project$Types$Queue$decode($author$project$CheckpointData$Command$decode);
var $author$project$CheckpointData$Event$CheckpointCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$CheckpointData$Event$CheckpointCreatedPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (checkpointId) {
				return function (checkpointGroupId) {
					return function (title) {
						return function (description) {
							return function (checkpointType) {
								return function (prev) {
									return function (next) {
										return function (files) {
											return function (version) {
												return {cC: checkpointGroupId, i5: checkpointId, fg: checkpointType, L: commandId, M: commandTimestamp, aY: description, N: eventId, cT: files, kc: next, kw: prev, k8: title, n: version};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CheckpointData$Event$CheckpointDeleted = function (a) {
	return {$: 14, a: a};
};
var $author$project$CheckpointData$Event$CheckpointDeletedPayload = F5(
	function (eventId, commandId, commandTimestamp, checkpointId, version) {
		return {i5: checkpointId, L: commandId, M: commandTimestamp, N: eventId, n: version};
	});
var $author$project$CheckpointData$Event$CheckpointDescriptionChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$CheckpointData$Event$CheckpointDescriptionChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, checkpointId, description, version) {
		return {i5: checkpointId, L: commandId, M: commandTimestamp, aY: description, N: eventId, n: version};
	});
var $author$project$CheckpointData$Event$CheckpointFilesChanged = function (a) {
	return {$: 10, a: a};
};
var $author$project$CheckpointData$Event$CheckpointFilesChangedPayload = F7(
	function (eventId, commandId, commandTimestamp, checkpointId, addedFiles, deletedFiles, version) {
		return {iM: addedFiles, i5: checkpointId, L: commandId, M: commandTimestamp, jk: deletedFiles, N: eventId, n: version};
	});
var $author$project$CheckpointData$Event$CheckpointGroupCreated = function (a) {
	return {$: 0, a: a};
};
var $author$project$CheckpointData$Event$CheckpointGroupCreatedPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (checkpointGroupId) {
				return function (organisationUnitId) {
					return function (title) {
						return function (description) {
							return function (prev) {
								return function (next) {
									return function (first) {
										return function (last) {
											return function (version) {
												return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, aY: description, N: eventId, jC: first, jT: last, kc: next, km: organisationUnitId, kw: prev, k8: title, n: version};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CheckpointData$Event$CheckpointGroupDeleted = function (a) {
	return {$: 5, a: a};
};
var $author$project$CheckpointData$Event$CheckpointGroupDeletedPayload = F8(
	function (eventId, commandId, commandTimestamp, checkpointGroupId, organisationUnitId, prev, next, version) {
		return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, N: eventId, kc: next, km: organisationUnitId, kw: prev, n: version};
	});
var $author$project$CheckpointData$Event$CheckpointGroupDescriptionChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Event$CheckpointGroupDescriptionChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, checkpointGroupId, description, version) {
		return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, aY: description, N: eventId, n: version};
	});
var $author$project$CheckpointData$Event$CheckpointGroupTitleChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$Event$CheckpointGroupTitleChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, checkpointGroupId, title, version) {
		return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, N: eventId, k8: title, n: version};
	});
var $author$project$CheckpointData$Event$CheckpointTitleChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$CheckpointData$Event$CheckpointTitleChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, checkpointId, title, version) {
		return {i5: checkpointId, L: commandId, M: commandTimestamp, N: eventId, k8: title, n: version};
	});
var $author$project$CheckpointData$Event$CheckpointTypeChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$CheckpointData$Event$CheckpointTypeChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, checkpointId, checkpointType, version) {
		return {i5: checkpointId, fg: checkpointType, L: commandId, M: commandTimestamp, N: eventId, n: version};
	});
var $author$project$CheckpointData$Event$MovedCheckpoint = function (a) {
	return {$: 11, a: a};
};
var $author$project$CheckpointData$Event$MovedCheckpointAfter = function (a) {
	return {$: 13, a: a};
};
var $author$project$CheckpointData$Event$MovedCheckpointAfterPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (checkpointId) {
				return function (checkpointGroupId) {
					return function (newParentId) {
						return function (newPreviousId) {
							return function (newNextId) {
								return function (oldParentId) {
									return function (oldPreviousId) {
										return function (oldNextId) {
											return function (version) {
												return {cC: checkpointGroupId, i5: checkpointId, L: commandId, M: commandTimestamp, N: eventId, fJ: newNextId, dZ: newParentId, d_: newPreviousId, c4: oldNextId, g1: oldParentId, c5: oldPreviousId, n: version};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CheckpointData$Event$MovedCheckpointBefore = function (a) {
	return {$: 12, a: a};
};
var $author$project$CheckpointData$Event$MovedCheckpointBeforePayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (checkpointId) {
				return function (checkpointGroupId) {
					return function (newParentId) {
						return function (newPreviousId) {
							return function (newNextId) {
								return function (oldParentId) {
									return function (oldPreviousId) {
										return function (oldNextId) {
											return function (version) {
												return {cC: checkpointGroupId, i5: checkpointId, L: commandId, M: commandTimestamp, N: eventId, fJ: newNextId, dZ: newParentId, d_: newPreviousId, c4: oldNextId, g1: oldParentId, c5: oldPreviousId, n: version};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CheckpointData$Event$MovedCheckpointGroupAfter = function (a) {
	return {$: 4, a: a};
};
var $author$project$CheckpointData$Event$MovedCheckpointGroupAfterPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (checkpointGroupId) {
				return function (newPreviousId) {
					return function (newNextId) {
						return function (oldPreviousId) {
							return function (oldNextId) {
								return function (organisationUnitId) {
									return function (version) {
										return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, N: eventId, fJ: newNextId, d_: newPreviousId, c4: oldNextId, c5: oldPreviousId, km: organisationUnitId, n: version};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CheckpointData$Event$MovedCheckpointGroupBefore = function (a) {
	return {$: 3, a: a};
};
var $author$project$CheckpointData$Event$MovedCheckpointGroupBeforePayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (checkpointGroupId) {
				return function (newPreviousId) {
					return function (newNextId) {
						return function (oldPreviousId) {
							return function (oldNextId) {
								return function (organisationUnitId) {
									return function (version) {
										return {cC: checkpointGroupId, L: commandId, M: commandTimestamp, N: eventId, fJ: newNextId, d_: newPreviousId, c4: oldNextId, c5: oldPreviousId, km: organisationUnitId, n: version};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CheckpointData$Event$MovedCheckpointPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (checkpointId) {
				return function (newParentId) {
					return function (newPreviousId) {
						return function (oldParentId) {
							return function (oldPreviousId) {
								return function (oldNextId) {
									return function (version) {
										return {i5: checkpointId, L: commandId, M: commandTimestamp, N: eventId, dZ: newParentId, d_: newPreviousId, c4: oldNextId, g1: oldParentId, c5: oldPreviousId, n: version};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CheckpointData$Event$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (eventType) {
		switch (eventType) {
			case 'de.awenko.checkpoint-group.created-checkpoint-group.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$CheckpointGroupCreated),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'last',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'first',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'next',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'prev',
									$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										$elm$json$Json$Decode$string,
										'',
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'title',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'organisationUnitId',
												$author$project$OrganisationUnit$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'checkpointGroupId',
													$author$project$CheckpointData$CheckpointGroup$Id$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandTimestamp',
														$author$project$Utils$Decode$timestamp,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'commandId',
															$author$project$Types$CommandId$decode,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'eventId',
																$author$project$Types$EventId$decode,
																$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$CheckpointGroupCreatedPayload)))))))))))));
			case 'de.awenko.checkpoint-group.changed-checkpoint-group-title.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$CheckpointGroupTitleChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointGroupId',
							$author$project$CheckpointData$CheckpointGroup$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$CheckpointGroupTitleChangedPayload)))))));
			case 'de.awenko.checkpoint-group.changed-checkpoint-group-description.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$CheckpointGroupDescriptionChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointGroupId',
							$author$project$CheckpointData$CheckpointGroup$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$CheckpointGroupDescriptionChangedPayload)))))));
			case 'de.awenko.checkpoint-group.moved-before-checkpoint-group.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$MovedCheckpointGroupBefore),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$decode,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldNextId',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'oldPreviousId',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'newNextId',
									$author$project$CheckpointData$CheckpointGroup$Id$decode,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'newPreviousId',
										$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'checkpointGroupId',
											$author$project$CheckpointData$CheckpointGroup$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'commandTimestamp',
												$author$project$Utils$Decode$timestamp,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandId',
													$author$project$Types$CommandId$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'eventId',
														$author$project$Types$EventId$decode,
														$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$MovedCheckpointGroupBeforePayload)))))))))));
			case 'de.awenko.checkpoint-group.moved-after-checkpoint-group.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$MovedCheckpointGroupAfter),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$decode,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldNextId',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'oldPreviousId',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'newNextId',
									$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'newPreviousId',
										$author$project$CheckpointData$CheckpointGroup$Id$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'checkpointGroupId',
											$author$project$CheckpointData$CheckpointGroup$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'commandTimestamp',
												$author$project$Utils$Decode$timestamp,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandId',
													$author$project$Types$CommandId$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'eventId',
														$author$project$Types$EventId$decode,
														$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$MovedCheckpointGroupAfterPayload)))))))))));
			case 'de.awenko.checkpoint-group.deleted-checkpoint-group.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$CheckpointGroupDeleted),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'oldNext',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldPrev',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'organisationUnitId',
								$author$project$OrganisationUnit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'checkpointGroupId',
									$author$project$CheckpointData$CheckpointGroup$Id$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandTimestamp',
										$author$project$Utils$Decode$timestamp,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'commandId',
											$author$project$Types$CommandId$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'eventId',
												$author$project$Types$EventId$decode,
												$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$CheckpointGroupDeletedPayload)))))))));
			case 'de.awenko.checkpoint-group.created-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$CheckpointCreated),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'files',
						$author$project$File$Filenames$decode,
						$author$project$File$Filenames$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'next',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'prev',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'checkpointType',
									$author$project$CheckpointData$Checkpoint$CheckpointType$decode,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										$elm$json$Json$Decode$string,
										'',
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'title',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'checkpointGroupId',
												$author$project$CheckpointData$CheckpointGroup$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'checkpointId',
													$author$project$CheckpointData$Checkpoint$Id$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandTimestamp',
														$author$project$Utils$Decode$timestamp,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'commandId',
															$author$project$Types$CommandId$decode,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'eventId',
																$author$project$Types$EventId$decode,
																$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$CheckpointCreatedPayload)))))))))))));
			case 'de.awenko.checkpoint-group.changed-checkpoint-type.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$CheckpointTypeChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'checkpointType',
						$author$project$CheckpointData$Checkpoint$CheckpointType$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointId',
							$author$project$CheckpointData$Checkpoint$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$CheckpointTypeChangedPayload)))))));
			case 'de.awenko.checkpoint-group.changed-checkpoint-title.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$CheckpointTitleChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointId',
							$author$project$CheckpointData$Checkpoint$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$CheckpointTitleChangedPayload)))))));
			case 'de.awenko.checkpoint-group.changed-checkpoint-description.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$CheckpointDescriptionChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointId',
							$author$project$CheckpointData$Checkpoint$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$CheckpointDescriptionChangedPayload)))))));
			case 'de.awenko.checkpoint-group.changed-checkpoint-files.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$CheckpointFilesChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'deletedFiles',
						$elm$json$Json$Decode$list($author$project$File$Filename$decode),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'addedFiles',
							$elm$json$Json$Decode$list($author$project$File$Filename$decode),
							_List_Nil,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'checkpointId',
								$author$project$CheckpointData$Checkpoint$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'eventId',
											$author$project$Types$EventId$decode,
											$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$CheckpointFilesChangedPayload))))))));
			case 'de.awenko.checkpoint-group.moved-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$MovedCheckpoint),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'oldNextId',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldPreviousId',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'oldParentId',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'newPreviousId',
									$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'newParentId',
										$author$project$CheckpointData$CheckpointGroup$Id$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'checkpointId',
											$author$project$CheckpointData$Checkpoint$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'commandTimestamp',
												$author$project$Utils$Decode$timestamp,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandId',
													$author$project$Types$CommandId$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'eventId',
														$author$project$Types$EventId$decode,
														$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$MovedCheckpointPayload)))))))))));
			case 'de.awenko.checkpoint-group.moved-before-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$MovedCheckpointBefore),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'oldNextId',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldPreviousId',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'oldParentId',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'newNextId',
									$author$project$CheckpointData$Checkpoint$Id$decode,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'newPreviousId',
										$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'newParentId',
											$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'checkpointGroupId',
												$author$project$CheckpointData$CheckpointGroup$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'checkpointId',
													$author$project$CheckpointData$Checkpoint$Id$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandTimestamp',
														$author$project$Utils$Decode$timestamp,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'commandId',
															$author$project$Types$CommandId$decode,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'eventId',
																$author$project$Types$EventId$decode,
																$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$MovedCheckpointBeforePayload)))))))))))));
			case 'de.awenko.checkpoint-group.moved-after-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$MovedCheckpointAfter),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'oldNextId',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldPreviousId',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'oldParentId',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'newNextId',
									$elm$json$Json$Decode$maybe($author$project$CheckpointData$Checkpoint$Id$decode),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'newPreviousId',
										$author$project$CheckpointData$Checkpoint$Id$decode,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'newParentId',
											$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'checkpointGroupId',
												$author$project$CheckpointData$CheckpointGroup$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'checkpointId',
													$author$project$CheckpointData$Checkpoint$Id$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandTimestamp',
														$author$project$Utils$Decode$timestamp,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'commandId',
															$author$project$Types$CommandId$decode,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'eventId',
																$author$project$Types$EventId$decode,
																$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$MovedCheckpointAfterPayload)))))))))))));
			case 'de.awenko.checkpoint-group.deleted-checkpoint.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$CheckpointData$Event$CheckpointDeleted),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'checkpointId',
						$author$project$CheckpointData$Checkpoint$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$CheckpointData$Event$CheckpointDeletedPayload))))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'eventType', $elm$json$Json$Decode$string));
var $author$project$CheckpointData$Events$decode = $author$project$Types$Queue$decode($author$project$CheckpointData$Event$decode);
var $author$project$CheckpointData$CheckpointData$empty = {a8: $author$project$CheckpointData$CheckpointData$emptyHierarchy, fD: $elm$core$Maybe$Nothing};
var $author$project$CheckpointData$Commands$empty = $author$project$Types$Queue$empty;
var $author$project$CheckpointData$Events$empty = $author$project$Types$Queue$empty;
var $author$project$CheckpointData$Store$decodeData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'commands',
	$author$project$CheckpointData$Commands$decode,
	$author$project$CheckpointData$Commands$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'events',
		$author$project$CheckpointData$Events$decode,
		$author$project$CheckpointData$Events$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'checkpointData',
			$author$project$CheckpointData$CheckpointData$decode,
			$author$project$CheckpointData$CheckpointData$empty,
			$elm$json$Json$Decode$succeed($author$project$CheckpointData$Store$Data))));
var $author$project$CheckpointData$Store$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOADED_DATA':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$CheckpointData$Store$LoadedData,
					A2($elm$json$Json$Decode$field, 'data', $author$project$CheckpointData$Store$decodeData));
			case 'SAVED_CHECKPOINT_DATA':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Store$SavedCheckpointData);
			case 'SAVED_MODIFICATIONS':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Store$SavedModifications);
			case 'SAVED_COMMANDS_AND_EVENTS':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Store$SavedCommandsAndEvents);
			case 'REMOVED_COMMAND':
				return $elm$json$Json$Decode$succeed($author$project$CheckpointData$Store$RemovedCommand);
			case 'REMOVED_COMMAND_AND_EVENT':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventVersion',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'commandId',
						$author$project$Types$CommandId$decode,
						$elm$json$Json$Decode$succeed($author$project$CheckpointData$Store$RemovedCommandAndEvent)));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$CheckpointData$Store$ReceivedErrorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$CheckpointData$Store$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$CheckpointData$Store$ReceivedErrorMsg(error);
	}
};
var $author$project$CheckpointData$Store$subscriptions = $author$project$CheckpointData$Store$checkpointDataStoreInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$CheckpointData$Store$decodeMsg),
		$author$project$CheckpointData$Store$handleDecodeResult));
var $author$project$EventStream$EventStream$ReceivedAuditEvent = function (a) {
	return {$: 8, a: a};
};
var $author$project$EventStream$EventStream$ReceivedAuditsStatus = function (a) {
	return {$: 7, a: a};
};
var $author$project$EventStream$EventStream$ReceivedCheckpointDataEvent = function (a) {
	return {$: 14, a: a};
};
var $author$project$EventStream$EventStream$ReceivedCheckpointDataStatus = function (a) {
	return {$: 13, a: a};
};
var $author$project$EventStream$EventStream$ReceivedMeasureEvent = function (a) {
	return {$: 10, a: a};
};
var $author$project$EventStream$EventStream$ReceivedMeasureStatus = function (a) {
	return {$: 9, a: a};
};
var $author$project$EventStream$EventStream$ReceivedOrganisationUnitEvent = function (a) {
	return {$: 4, a: a};
};
var $author$project$EventStream$EventStream$ReceivedOrganisationUnitStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$EventStream$EventStream$ReceivedPlanEvent = function (a) {
	return {$: 6, a: a};
};
var $author$project$EventStream$EventStream$ReceivedPlanStatus = function (a) {
	return {$: 5, a: a};
};
var $author$project$EventStream$EventStream$ReceivedRightsEvent = function (a) {
	return {$: 16, a: a};
};
var $author$project$EventStream$EventStream$ReceivedRightsStatus = function (a) {
	return {$: 15, a: a};
};
var $author$project$EventStream$EventStream$ReceivedStatus = function (a) {
	return {$: 0, a: a};
};
var $author$project$EventStream$EventStream$ReceivedTenantEvent = function (a) {
	return {$: 12, a: a};
};
var $author$project$EventStream$EventStream$ReceivedTenantStatus = function (a) {
	return {$: 11, a: a};
};
var $author$project$EventStream$EventStream$ReceivedUserEvent = function (a) {
	return {$: 2, a: a};
};
var $author$project$EventStream$EventStream$ReceivedUserStatus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$Event$Completed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Measure$Event$CompletedPayload = F5(
	function (eventId, commandId, commandTimestamp, measureId, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, h5: measureId, n: version};
	});
var $author$project$Measure$Event$Created = function (a) {
	return {$: 0, a: a};
};
var $author$project$Measure$Event$CreatedPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (measureId) {
				return function (id) {
					return function (measureType) {
						return function (title) {
							return function (description) {
								return function (creationTimestamp) {
									return function (deadlineTimestamp) {
										return function (organisationUnitId) {
											return function (creatorId) {
												return function (images) {
													return function (responsibleUsers) {
														return function (version) {
															return {L: commandId, M: commandTimestamp, dw: creationTimestamp, jd: creatorId, hI: deadlineTimestamp, aY: description, N: eventId, fw: id, fx: images, h5: measureId, h6: measureType, km: organisationUnitId, bb: responsibleUsers, k8: title, n: version};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Measure$Event$DeadlineChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Measure$Event$DeadlineChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, measureId, deadlineTimestamp, version) {
		return {L: commandId, M: commandTimestamp, hI: deadlineTimestamp, N: eventId, h5: measureId, n: version};
	});
var $author$project$Measure$Event$Deleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Measure$Event$DeletedPayload = F5(
	function (eventId, commandId, commandTimestamp, measureId, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, h5: measureId, n: version};
	});
var $author$project$Measure$Event$DescriptionChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Measure$Event$DescriptionChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, measureId, description, version) {
		return {L: commandId, M: commandTimestamp, aY: description, N: eventId, h5: measureId, n: version};
	});
var $author$project$Measure$Event$ImagesAdded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Measure$Event$ImagesAddedPayload = F6(
	function (eventId, commandId, commandTimestamp, measureId, addImages, version) {
		return {gf: addImages, L: commandId, M: commandTimestamp, N: eventId, h5: measureId, n: version};
	});
var $author$project$Measure$Event$ImagesRemoved = function (a) {
	return {$: 7, a: a};
};
var $author$project$Measure$Event$ImagesRemovedPayload = F6(
	function (eventId, commandId, commandTimestamp, measureId, removeImages, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, h5: measureId, ha: removeImages, n: version};
	});
var $author$project$Measure$Event$OrganisationUnitChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Measure$Event$OrganisationUnitChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, measureId, organisationUnitId, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, h5: measureId, km: organisationUnitId, n: version};
	});
var $author$project$Measure$Event$ResponsibleUsersChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Measure$Event$ResponsibleUsersChangedPayload = F7(
	function (eventId, commandId, commandTimestamp, measureId, addResponsibleUsers, removeResponsibleUsers, version) {
		return {e9: addResponsibleUsers, L: commandId, M: commandTimestamp, N: eventId, h5: measureId, f_: removeResponsibleUsers, n: version};
	});
var $author$project$Measure$Event$TitleChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$Event$TitleChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, measureId, title, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, h5: measureId, k8: title, n: version};
	});
var $author$project$Measure$Id$Id = $elm$core$Basics$identity;
var $author$project$Measure$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$Measure$MeasureType$Issue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$MeasureType$IssueData = F3(
	function (checkpointId, auditId, recordId) {
		return {gm: auditId, i5: checkpointId, bK: recordId};
	});
var $author$project$Measure$MeasureType$Task = {$: 0};
var $author$project$Measure$MeasureType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (measureType) {
		switch (measureType) {
			case 'Task':
				return $elm$json$Json$Decode$succeed($author$project$Measure$MeasureType$Task);
			case 'Issue':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'recordId', $author$project$Audit$Record$Id$decode),
					$elm$json$Json$Decode$map($author$project$Measure$MeasureType$Issue),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'auditId',
						$author$project$Audit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'checkpointId',
							$author$project$CheckpointData$Checkpoint$Id$decode,
							$elm$json$Json$Decode$succeed($author$project$Measure$MeasureType$IssueData))));
			default:
				return $elm$json$Json$Decode$fail('Unknown type');
		}
	},
	A2($elm$json$Json$Decode$field, 'measureType', $elm$json$Json$Decode$string));
var $author$project$Measure$Event$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (eventType) {
		switch (eventType) {
			case 'de.awenko.measure.created.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Measure$Event$Created),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'responsibleUsers',
						$author$project$User$Ids$decode,
						$author$project$User$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'images',
							$elm$json$Json$Decode$list($author$project$File$Filename$decode),
							_List_Nil,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'creatorId',
								$author$project$User$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'organisationUnitId',
									$author$project$OrganisationUnit$Id$decode,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'deadlineTimestamp',
										$elm$json$Json$Decode$maybe($author$project$Utils$Decode$timestamp),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'creationTimestamp',
											$author$project$Utils$Decode$timestamp,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'description',
												$elm$json$Json$Decode$string,
												'',
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'title',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'measureType',
														$author$project$Measure$MeasureType$decode,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'measureId',
																$author$project$Measure$Id$decode,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'commandTimestamp',
																	$author$project$Utils$Decode$timestamp,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'commandId',
																		$author$project$Types$CommandId$decode,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'eventId',
																			$author$project$Types$EventId$decode,
																			$elm$json$Json$Decode$succeed($author$project$Measure$Event$CreatedPayload))))))))))))))));
			case 'de.awenko.measure.title-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Measure$Event$TitleChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'measureId',
							$author$project$Measure$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Event$TitleChangedPayload)))))));
			case 'de.awenko.measure.description-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Measure$Event$DescriptionChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'measureId',
							$author$project$Measure$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Event$DescriptionChangedPayload)))))));
			case 'de.awenko.measure.responsible-users-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Measure$Event$ResponsibleUsersChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'removeResponsibleUsers',
						$author$project$User$Ids$decode,
						$author$project$User$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'addResponsibleUsers',
							$author$project$User$Ids$decode,
							$author$project$User$Ids$empty,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'measureId',
								$author$project$Measure$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'eventId',
											$author$project$Types$EventId$decode,
											$elm$json$Json$Decode$succeed($author$project$Measure$Event$ResponsibleUsersChangedPayload))))))));
			case 'de.awenko.measure.deadline-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Measure$Event$DeadlineChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'deadlineTimestamp',
						$elm$json$Json$Decode$maybe($author$project$Utils$Decode$timestamp),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'measureId',
							$author$project$Measure$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Event$DeadlineChangedPayload)))))));
			case 'de.awenko.measure.organisation-unit-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Measure$Event$OrganisationUnitChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'measureId',
							$author$project$Measure$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Event$OrganisationUnitChangedPayload)))))));
			case 'de.awenko.measure.images-added.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Measure$Event$ImagesAdded),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'addImages',
						$elm$json$Json$Decode$list($author$project$File$Filename$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'measureId',
							$author$project$Measure$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Event$ImagesAddedPayload)))))));
			case 'de.awenko.measure.images-removed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Measure$Event$ImagesRemoved),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'removeImages',
						$elm$json$Json$Decode$list($author$project$File$Filename$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'measureId',
							$author$project$Measure$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Event$ImagesRemovedPayload)))))));
			case 'de.awenko.measure.completed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Measure$Event$Completed),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'measureId',
						$author$project$Measure$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$Measure$Event$CompletedPayload))))));
			case 'de.awenko.measure.deleted.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Measure$Event$Deleted),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'measureId',
						$author$project$Measure$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$Measure$Event$DeletedPayload))))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'eventType', $elm$json$Json$Decode$string));
var $author$project$OrganisationUnit$Event$ChildCreated = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$Event$ChildCreatedPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (organisationUnitId) {
				return function (parentId) {
					return function (previousId) {
						return function (title) {
							return function (description) {
								return function (floorPlan) {
									return function (firstGroup) {
										return function (lastGroup) {
											return function (color) {
												return function (version) {
													return {K: color, L: commandId, M: commandTimestamp, aY: description, N: eventId, ao: firstGroup, ap: floorPlan, jU: lastGroup, km: organisationUnitId, fV: parentId, ay: previousId, k8: title, n: version};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$Event$ColorChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$OrganisationUnit$Event$ColorChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, organisationUnitId, color, version) {
		return {K: color, L: commandId, M: commandTimestamp, N: eventId, km: organisationUnitId, n: version};
	});
var $author$project$OrganisationUnit$Event$Created = function (a) {
	return {$: 0, a: a};
};
var $author$project$OrganisationUnit$Event$CreatedAfter = function (a) {
	return {$: 3, a: a};
};
var $author$project$OrganisationUnit$Event$CreatedAfterPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (organisationUnitId) {
				return function (parentId) {
					return function (previousId) {
						return function (nextId) {
							return function (title) {
								return function (description) {
									return function (floorPlan) {
										return function (firstGroup) {
											return function (lastGroup) {
												return function (color) {
													return function (version) {
														return {K: color, L: commandId, M: commandTimestamp, aY: description, N: eventId, ao: firstGroup, ap: floorPlan, jU: lastGroup, ax: nextId, km: organisationUnitId, fV: parentId, ay: previousId, k8: title, n: version};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$Event$CreatedBefore = function (a) {
	return {$: 2, a: a};
};
var $author$project$OrganisationUnit$Event$CreatedBeforePayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (organisationUnitId) {
				return function (parentId) {
					return function (previousId) {
						return function (nextId) {
							return function (title) {
								return function (description) {
									return function (floorPlan) {
										return function (firstGroup) {
											return function (lastGroup) {
												return function (color) {
													return function (version) {
														return {K: color, L: commandId, M: commandTimestamp, aY: description, N: eventId, ao: firstGroup, ap: floorPlan, jU: lastGroup, ax: nextId, km: organisationUnitId, fV: parentId, ay: previousId, k8: title, n: version};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$Event$CreatedPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (organisationUnitId) {
				return function (previousId) {
					return function (title) {
						return function (description) {
							return function (floorPlan) {
								return function (firstGroup) {
									return function (lastGroup) {
										return function (color) {
											return function (version) {
												return {K: color, L: commandId, M: commandTimestamp, aY: description, N: eventId, ao: firstGroup, ap: floorPlan, jU: lastGroup, km: organisationUnitId, ay: previousId, k8: title, n: version};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$Event$Deleted = function (a) {
	return {$: 11, a: a};
};
var $author$project$OrganisationUnit$Event$DeletedPayload = F9(
	function (eventId, commandId, commandTimestamp, organisationUnitId, oldParentId, oldPreviousId, oldNextId, descendantOrganisationUnits, version) {
		return {L: commandId, M: commandTimestamp, hK: descendantOrganisationUnits, N: eventId, c4: oldNextId, g1: oldParentId, c5: oldPreviousId, km: organisationUnitId, n: version};
	});
var $author$project$OrganisationUnit$Event$DescriptionChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$OrganisationUnit$Event$DescriptionChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, organisationUnitId, description, version) {
		return {L: commandId, M: commandTimestamp, aY: description, N: eventId, km: organisationUnitId, n: version};
	});
var $author$project$OrganisationUnit$Event$FloorPlanChanged = function (a) {
	return {$: 10, a: a};
};
var $author$project$OrganisationUnit$Event$FloorPlanChangedPayload = F7(
	function (eventId, commandId, commandTimestamp, organisationUnitId, newFloorPlan, oldFloorPlan, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, fI: newFloorPlan, fM: oldFloorPlan, km: organisationUnitId, n: version};
	});
var $author$project$OrganisationUnit$Event$Moved = function (a) {
	return {$: 4, a: a};
};
var $author$project$OrganisationUnit$Event$MovedAfter = function (a) {
	return {$: 6, a: a};
};
var $author$project$OrganisationUnit$Event$MovedAfterPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (organisationUnitId) {
				return function (newParentId) {
					return function (newPreviousId) {
						return function (newNextId) {
							return function (oldParentId) {
								return function (oldPreviousId) {
									return function (oldNextId) {
										return function (version) {
											return {L: commandId, M: commandTimestamp, N: eventId, fJ: newNextId, dZ: newParentId, d_: newPreviousId, c4: oldNextId, g1: oldParentId, c5: oldPreviousId, km: organisationUnitId, n: version};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$Event$MovedBefore = function (a) {
	return {$: 5, a: a};
};
var $author$project$OrganisationUnit$Event$MovedBeforePayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (organisationUnitId) {
				return function (newParentId) {
					return function (newPreviousId) {
						return function (newNextId) {
							return function (oldParentId) {
								return function (oldPreviousId) {
									return function (oldNextId) {
										return function (version) {
											return {L: commandId, M: commandTimestamp, N: eventId, fJ: newNextId, dZ: newParentId, d_: newPreviousId, c4: oldNextId, g1: oldParentId, c5: oldPreviousId, km: organisationUnitId, n: version};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$Event$MovedPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (organisationUnitId) {
				return function (newParentId) {
					return function (newPreviousId) {
						return function (oldParentId) {
							return function (oldPreviousId) {
								return function (oldNextId) {
									return function (version) {
										return {L: commandId, M: commandTimestamp, N: eventId, dZ: newParentId, d_: newPreviousId, c4: oldNextId, g1: oldParentId, c5: oldPreviousId, km: organisationUnitId, n: version};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$Event$TitleChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$OrganisationUnit$Event$TitleChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, organisationUnitId, title, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, km: organisationUnitId, k8: title, n: version};
	});
var $author$project$OrganisationUnit$Ids$decode = A2($turboMaCk$any_set$Set$Any$decode, $author$project$OrganisationUnit$Id$toString, $author$project$OrganisationUnit$Id$decode);
var $author$project$UI$Style$Color$Rgba = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Char$toLower = _Char_toLower;
var $author$project$UI$Style$Color$hexToInt = function (_char) {
	var _v0 = $elm$core$Char$toLower(_char);
	switch (_v0) {
		case '0':
			return $elm$core$Maybe$Just(0);
		case '1':
			return $elm$core$Maybe$Just(1);
		case '2':
			return $elm$core$Maybe$Just(2);
		case '3':
			return $elm$core$Maybe$Just(3);
		case '4':
			return $elm$core$Maybe$Just(4);
		case '5':
			return $elm$core$Maybe$Just(5);
		case '6':
			return $elm$core$Maybe$Just(6);
		case '7':
			return $elm$core$Maybe$Just(7);
		case '8':
			return $elm$core$Maybe$Just(8);
		case '9':
			return $elm$core$Maybe$Just(9);
		case 'a':
			return $elm$core$Maybe$Just(10);
		case 'b':
			return $elm$core$Maybe$Just(11);
		case 'c':
			return $elm$core$Maybe$Just(12);
		case 'd':
			return $elm$core$Maybe$Just(13);
		case 'e':
			return $elm$core$Maybe$Just(14);
		case 'f':
			return $elm$core$Maybe$Just(15);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $author$project$UI$Style$Color$hex2ToInt = F2(
	function (c1, c2) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (v1, v2) {
					return (v1 << 4) + v2;
				}),
			$author$project$UI$Style$Color$hexToInt(c1),
			$author$project$UI$Style$Color$hexToInt(c2));
	});
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $author$project$UI$Style$Color$fromHex8 = F4(
	function (_v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		return A5(
			$elm$core$Maybe$map4,
			F4(
				function (r, g, b, a) {
					return A4($author$project$UI$Style$Color$Rgba, r / 255, g / 255, b / 255, a / 255);
				}),
			A2($author$project$UI$Style$Color$hex2ToInt, r1, r2),
			A2($author$project$UI$Style$Color$hex2ToInt, g1, g2),
			A2($author$project$UI$Style$Color$hex2ToInt, b1, b2),
			A2($author$project$UI$Style$Color$hex2ToInt, a1, a2));
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $author$project$UI$Style$Color$fromHex = function (hexString) {
	var _v0 = $elm$core$String$toList(hexString);
	_v0$8:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v4 = _v0.b;
				var g = _v4.a;
				var _v5 = _v4.b;
				var b = _v5.a;
				return A4(
					$author$project$UI$Style$Color$fromHex8,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					if ('#' === _v0.a) {
						var _v1 = _v0.b;
						var r = _v1.a;
						var _v2 = _v1.b;
						var g = _v2.a;
						var _v3 = _v2.b;
						var b = _v3.a;
						return A4(
							$author$project$UI$Style$Color$fromHex8,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2('f', 'f'));
					} else {
						var r = _v0.a;
						var _v10 = _v0.b;
						var g = _v10.a;
						var _v11 = _v10.b;
						var b = _v11.a;
						var _v12 = _v11.b;
						var a = _v12.a;
						return A4(
							$author$project$UI$Style$Color$fromHex8,
							_Utils_Tuple2(r, r),
							_Utils_Tuple2(g, g),
							_Utils_Tuple2(b, b),
							_Utils_Tuple2(a, a));
					}
				} else {
					if (!_v0.b.b.b.b.b.b) {
						if ('#' === _v0.a) {
							var _v6 = _v0.b;
							var r = _v6.a;
							var _v7 = _v6.b;
							var g = _v7.a;
							var _v8 = _v7.b;
							var b = _v8.a;
							var _v9 = _v8.b;
							var a = _v9.a;
							return A4(
								$author$project$UI$Style$Color$fromHex8,
								_Utils_Tuple2(r, r),
								_Utils_Tuple2(g, g),
								_Utils_Tuple2(b, b),
								_Utils_Tuple2(a, a));
						} else {
							break _v0$8;
						}
					} else {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v19 = _v0.b;
							var r2 = _v19.a;
							var _v20 = _v19.b;
							var g1 = _v20.a;
							var _v21 = _v20.b;
							var g2 = _v21.a;
							var _v22 = _v21.b;
							var b1 = _v22.a;
							var _v23 = _v22.b;
							var b2 = _v23.a;
							return A4(
								$author$project$UI$Style$Color$fromHex8,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (!_v0.b.b.b.b.b.b.b.b) {
								if ('#' === _v0.a) {
									var _v13 = _v0.b;
									var r1 = _v13.a;
									var _v14 = _v13.b;
									var r2 = _v14.a;
									var _v15 = _v14.b;
									var g1 = _v15.a;
									var _v16 = _v15.b;
									var g2 = _v16.a;
									var _v17 = _v16.b;
									var b1 = _v17.a;
									var _v18 = _v17.b;
									var b2 = _v18.a;
									return A4(
										$author$project$UI$Style$Color$fromHex8,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2('f', 'f'));
								} else {
									break _v0$8;
								}
							} else {
								if (_v0.b.b.b.b.b.b.b.b.b) {
									if (('#' === _v0.a) && (!_v0.b.b.b.b.b.b.b.b.b.b)) {
										var _v24 = _v0.b;
										var r1 = _v24.a;
										var _v25 = _v24.b;
										var r2 = _v25.a;
										var _v26 = _v25.b;
										var g1 = _v26.a;
										var _v27 = _v26.b;
										var g2 = _v27.a;
										var _v28 = _v27.b;
										var b1 = _v28.a;
										var _v29 = _v28.b;
										var b2 = _v29.a;
										var _v30 = _v29.b;
										var a1 = _v30.a;
										var _v31 = _v30.b;
										var a2 = _v31.a;
										return A4(
											$author$project$UI$Style$Color$fromHex8,
											_Utils_Tuple2(r1, r2),
											_Utils_Tuple2(g1, g2),
											_Utils_Tuple2(b1, b2),
											_Utils_Tuple2(a1, a2));
									} else {
										break _v0$8;
									}
								} else {
									var r1 = _v0.a;
									var _v32 = _v0.b;
									var r2 = _v32.a;
									var _v33 = _v32.b;
									var g1 = _v33.a;
									var _v34 = _v33.b;
									var g2 = _v34.a;
									var _v35 = _v34.b;
									var b1 = _v35.a;
									var _v36 = _v35.b;
									var b2 = _v36.a;
									var _v37 = _v36.b;
									var a1 = _v37.a;
									var _v38 = _v37.b;
									var a2 = _v38.a;
									return A4(
										$author$project$UI$Style$Color$fromHex8,
										_Utils_Tuple2(r1, r2),
										_Utils_Tuple2(g1, g2),
										_Utils_Tuple2(b1, b2),
										_Utils_Tuple2(a1, a2));
								}
							}
						}
					}
				}
			}
		} else {
			break _v0$8;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$UI$Style$Color$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $author$project$UI$Style$Color$fromHex(str);
		if (!_v0.$) {
			var color = _v0.a;
			return $elm$json$Json$Decode$succeed(color);
		} else {
			return $elm$json$Json$Decode$succeed(
				A4($author$project$UI$Style$Color$Rgba, 56 / 255, 92 / 255, 107 / 255, 1.0));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$OrganisationUnit$Ids$empty = $turboMaCk$any_set$Set$Any$empty($author$project$OrganisationUnit$Id$toString);
var $author$project$OrganisationUnit$Event$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (eventType) {
		switch (eventType) {
			case 'de.awenko.organisation-unit.created.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$Created),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'color',
						$author$project$UI$Style$Color$decode,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'lastGroup',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'firstGroup',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'floorPlan',
									$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										$elm$json$Json$Decode$string,
										'',
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'title',
											$elm$json$Json$Decode$string,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'previousId',
												$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'organisationUnitId',
													$author$project$OrganisationUnit$Id$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandTimestamp',
														$author$project$Utils$Decode$timestamp,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'commandId',
															$author$project$Types$CommandId$decode,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'eventId',
																$author$project$Types$EventId$decode,
																$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$CreatedPayload)))))))))))));
			case 'de.awenko.organisation-unit.child-created.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$ChildCreated),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'color',
						$author$project$UI$Style$Color$decode,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'lastGroup',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'firstGroup',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'floorPlan',
									$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										$elm$json$Json$Decode$string,
										'',
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'title',
											$elm$json$Json$Decode$string,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'previousId',
												$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'parentId',
													$author$project$OrganisationUnit$Id$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'organisationUnitId',
														$author$project$OrganisationUnit$Id$decode,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'commandTimestamp',
															$author$project$Utils$Decode$timestamp,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'commandId',
																$author$project$Types$CommandId$decode,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'eventId',
																	$author$project$Types$EventId$decode,
																	$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$ChildCreatedPayload))))))))))))));
			case 'de.awenko.organisation-unit.created-before.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$CreatedBefore),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'color',
						$author$project$UI$Style$Color$decode,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'lastGroup',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'firstGroup',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'floorPlan',
									$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										$elm$json$Json$Decode$string,
										'',
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'title',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'nextId',
												$author$project$OrganisationUnit$Id$decode,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'previousId',
													$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'parentId',
														$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
														$elm$core$Maybe$Nothing,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'organisationUnitId',
															$author$project$OrganisationUnit$Id$decode,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'commandTimestamp',
																$author$project$Utils$Decode$timestamp,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'commandId',
																	$author$project$Types$CommandId$decode,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'eventId',
																		$author$project$Types$EventId$decode,
																		$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$CreatedBeforePayload)))))))))))))));
			case 'de.awenko.organisation-unit.created-after.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$CreatedAfter),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'color',
						$author$project$UI$Style$Color$decode,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'lastGroup',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'firstGroup',
								$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'floorPlan',
									$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										$elm$json$Json$Decode$string,
										'',
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'title',
											$elm$json$Json$Decode$string,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'nextId',
												$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'previousId',
													$author$project$OrganisationUnit$Id$decode,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'parentId',
														$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
														$elm$core$Maybe$Nothing,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'organisationUnitId',
															$author$project$OrganisationUnit$Id$decode,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'commandTimestamp',
																$author$project$Utils$Decode$timestamp,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'commandId',
																	$author$project$Types$CommandId$decode,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'eventId',
																		$author$project$Types$EventId$decode,
																		$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$CreatedAfterPayload)))))))))))))));
			case 'de.awenko.organisation-unit.moved.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$Moved),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'oldNextId',
						$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldPreviousId',
							$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'oldParentId',
								$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'newPreviousId',
									$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'newParentId',
										$author$project$OrganisationUnit$Id$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'organisationUnitId',
											$author$project$OrganisationUnit$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'commandTimestamp',
												$author$project$Utils$Decode$timestamp,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandId',
													$author$project$Types$CommandId$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'eventId',
														$author$project$Types$EventId$decode,
														$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$MovedPayload)))))))))));
			case 'de.awenko.organisation-unit.moved-before.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$MovedBefore),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'oldNextId',
						$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldPreviousId',
							$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'oldParentId',
								$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'newNextId',
									$author$project$OrganisationUnit$Id$decode,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'newPreviousId',
										$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'newParentId',
											$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'organisationUnitId',
												$author$project$OrganisationUnit$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandTimestamp',
													$author$project$Utils$Decode$timestamp,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandId',
														$author$project$Types$CommandId$decode,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'eventId',
															$author$project$Types$EventId$decode,
															$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$MovedBeforePayload))))))))))));
			case 'de.awenko.organisation-unit.moved-after.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$MovedAfter),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'oldNextId',
						$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldPreviousId',
							$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'oldParentId',
								$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'newNextId',
									$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'newPreviousId',
										$author$project$OrganisationUnit$Id$decode,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'newParentId',
											$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'organisationUnitId',
												$author$project$OrganisationUnit$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandTimestamp',
													$author$project$Utils$Decode$timestamp,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandId',
														$author$project$Types$CommandId$decode,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'eventId',
															$author$project$Types$EventId$decode,
															$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$MovedAfterPayload))))))))))));
			case 'de.awenko.organisation-unit.title-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$TitleChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'organisationUnitId',
							$author$project$OrganisationUnit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$TitleChangedPayload)))))));
			case 'de.awenko.organisation-unit.description-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$DescriptionChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'organisationUnitId',
							$author$project$OrganisationUnit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$DescriptionChangedPayload)))))));
			case 'de.awenko.organisation-unit.color-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$ColorChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'color',
						$author$project$UI$Style$Color$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'organisationUnitId',
							$author$project$OrganisationUnit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$ColorChangedPayload)))))));
			case 'de.awenko.organisation-unit.floor-plan-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$FloorPlanChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'oldFloorPlan',
						$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'newFloorPlan',
							$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'organisationUnitId',
								$author$project$OrganisationUnit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'eventId',
											$author$project$Types$EventId$decode,
											$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$FloorPlanChangedPayload))))))));
			case 'de.awenko.organisation-unit.deleted.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Event$Deleted),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'descendantOrganisationUnits',
						$author$project$OrganisationUnit$Ids$decode,
						$author$project$OrganisationUnit$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'oldNextId',
							$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'oldPreviousId',
								$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'oldParentId',
									$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'organisationUnitId',
										$author$project$OrganisationUnit$Id$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'commandTimestamp',
											$author$project$Utils$Decode$timestamp,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'commandId',
												$author$project$Types$CommandId$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'eventId',
													$author$project$Types$EventId$decode,
													$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Event$DeletedPayload))))))))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'eventType', $elm$json$Json$Decode$string));
var $author$project$Plan$Event$AuditorsChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Plan$Event$AuditorsChangedPayload = F7(
	function (eventId, commandId, commandTimestamp, planId, addAuditors, removeAuditors, version) {
		return {ge: addAuditors, L: commandId, M: commandTimestamp, N: eventId, d5: planId, g9: removeAuditors, n: version};
	});
var $author$project$Plan$Event$CheckpointGroupsChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Plan$Event$CheckpointGroupsChangedPayload = F7(
	function (eventId, commandId, commandTimestamp, planId, addCheckpointGroups, removeCheckpointGroups, version) {
		return {e7: addCheckpointGroups, L: commandId, M: commandTimestamp, N: eventId, d5: planId, fY: removeCheckpointGroups, n: version};
	});
var $author$project$Plan$Event$Created = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Event$CreatedPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (planId) {
				return function (title) {
					return function (description) {
						return function (executions) {
							return function (checkpointGroups) {
								return function (auditors) {
									return function (version) {
										return {bT: auditors, gt: checkpointGroups, L: commandId, M: commandTimestamp, aY: description, N: eventId, fr: executions, d5: planId, k8: title, n: version};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Plan$Event$Deleted = function (a) {
	return {$: 8, a: a};
};
var $author$project$Plan$Event$DeletedPayload = F5(
	function (eventId, commandId, commandTimestamp, planId, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, d5: planId, n: version};
	});
var $author$project$Plan$Event$DescriptionChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$Event$DescriptionChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, planId, description, version) {
		return {L: commandId, M: commandTimestamp, aY: description, N: eventId, d5: planId, n: version};
	});
var $author$project$Plan$Event$ExecutionAdded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$Event$ExecutionAddedPayload = F6(
	function (eventId, commandId, commandTimestamp, planId, execution, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, jw: execution, d5: planId, n: version};
	});
var $author$project$Plan$Event$ExecutionChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Plan$Event$ExecutionChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, planId, execution, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, jw: execution, d5: planId, n: version};
	});
var $author$project$Plan$Event$ExecutionRemoved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Plan$Event$ExecutionRemovedPayload = F6(
	function (eventId, commandId, commandTimestamp, planId, executionId, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, dH: executionId, d5: planId, n: version};
	});
var $author$project$Plan$Event$PlanExecuted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Plan$Event$PlanExecutedPayload = F5(
	function (eventId, commandId, commandTimestamp, planId, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, d5: planId, n: version};
	});
var $author$project$Plan$Event$TitleChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Event$TitleChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, planId, title, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, d5: planId, k8: title, n: version};
	});
var $author$project$CheckpointData$CheckpointGroup$Ids$decode = A2($turboMaCk$any_set$Set$Any$decode, $author$project$CheckpointData$CheckpointGroup$Id$toString, $author$project$CheckpointData$CheckpointGroup$Id$decode);
var $author$project$Plan$Execution$Execution$Execution = F4(
	function (executionId, title, description, schedule) {
		return {aY: description, dH: executionId, hd: schedule, k8: title};
	});
var $author$project$Plan$Schedule$Schedule$Daily = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Schedule$Schedule$DailyModel = F6(
	function (interval, creatingTime, deadlineTime, startDate, endDate, timeZone) {
		return {aV: creatingTime, ex: deadlineTime, aZ: endDate, a0: interval, a2: startDate, el: timeZone};
	});
var $author$project$Plan$Schedule$Schedule$decodeDaily = A3(
	$elm$core$Basics$composeR,
	A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'timeZone', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$map($author$project$Plan$Schedule$Schedule$Daily),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'endDate',
		$elm$json$Json$Decode$maybe($author$project$Date_Time$NaiveDate$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'startDate',
			$author$project$Date_Time$NaiveDate$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deadlineTime',
				$author$project$Date_Time$NaiveTime$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'creatingTime',
					$author$project$Date_Time$NaiveTime$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'interval',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Plan$Schedule$Schedule$DailyModel)))))));
var $author$project$Plan$Schedule$Schedule$Monthly = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$Schedule$Schedule$MonthlyModel = F7(
	function (interval, day, creatingTime, deadlineTime, startDate, endDate, timeZone) {
		return {aV: creatingTime, dz: day, ex: deadlineTime, aZ: endDate, a0: interval, a2: startDate, el: timeZone};
	});
var $author$project$Plan$Schedule$Schedule$decodeMonthly = A3(
	$elm$core$Basics$composeR,
	A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'timeZone', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$map($author$project$Plan$Schedule$Schedule$Monthly),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'endDate',
		$elm$json$Json$Decode$maybe($author$project$Date_Time$NaiveDate$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'startDate',
			$author$project$Date_Time$NaiveDate$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deadlineTime',
				$author$project$Date_Time$NaiveTime$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'creatingTime',
					$author$project$Date_Time$NaiveTime$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'day',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'interval',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Plan$Schedule$Schedule$MonthlyModel))))))));
var $author$project$Plan$Schedule$Schedule$Weekly = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Schedule$Schedule$WeeklyModel = F7(
	function (interval, weekdays, creatingTime, deadlineTime, startDate, endDate, timeZone) {
		return {aV: creatingTime, ex: deadlineTime, aZ: endDate, a0: interval, a2: startDate, el: timeZone, hq: weekdays};
	});
var $elm$json$Json$Decode$array = _Json_decodeArray;
var $author$project$Date_Time$Weekday$fromString = function (str) {
	switch (str) {
		case 'MONDAY':
			return $elm$core$Maybe$Just(0);
		case 'TUESDAY':
			return $elm$core$Maybe$Just(1);
		case 'WEDNESDAY':
			return $elm$core$Maybe$Just(2);
		case 'THURSDAY':
			return $elm$core$Maybe$Just(3);
		case 'FRIDAY':
			return $elm$core$Maybe$Just(4);
		case 'SATURDAY':
			return $elm$core$Maybe$Just(5);
		case 'SUNDAY':
			return $elm$core$Maybe$Just(6);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Date_Time$Weekday$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Date_Time$Weekday$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Not a valid weekday')))),
	$elm$json$Json$Decode$string);
var $author$project$Date_Time$Weekdays$Weekdays = $elm$core$Basics$identity;
var $author$project$Date_Time$Weekdays$empty = 0;
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $author$project$Date_Time$Weekdays$insert = F2(
	function (weekday, _v0) {
		var value = _v0;
		return value | $author$project$Date_Time$Weekdays$weekdayToInt(weekday);
	});
var $author$project$Date_Time$Weekdays$decode = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Array$foldl, $author$project$Date_Time$Weekdays$insert, $author$project$Date_Time$Weekdays$empty),
	$elm$json$Json$Decode$array($author$project$Date_Time$Weekday$decode));
var $author$project$Plan$Schedule$Schedule$decodeWeekly = A3(
	$elm$core$Basics$composeR,
	A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'timeZone', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$map($author$project$Plan$Schedule$Schedule$Weekly),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'endDate',
		$elm$json$Json$Decode$maybe($author$project$Date_Time$NaiveDate$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'startDate',
			$author$project$Date_Time$NaiveDate$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deadlineTime',
				$author$project$Date_Time$NaiveTime$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'creatingTime',
					$author$project$Date_Time$NaiveTime$decode,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'weekdays',
						$author$project$Date_Time$Weekdays$decode,
						$author$project$Date_Time$Weekdays$empty,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'interval',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Plan$Schedule$Schedule$WeeklyModel))))))));
var $author$project$Plan$Schedule$Schedule$Yearly = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$Schedule$Schedule$YearlyModel = F8(
	function (interval, month, day, creatingTime, deadlineTime, startDate, endDate, timeZone) {
		return {aV: creatingTime, dz: day, ex: deadlineTime, aZ: endDate, a0: interval, gZ: month, a2: startDate, el: timeZone};
	});
var $author$project$Date_Time$Month$fromString = function (str) {
	switch (str) {
		case 'JANUARY':
			return $elm$core$Maybe$Just(0);
		case 'FEBRUARY':
			return $elm$core$Maybe$Just(1);
		case 'MARCH':
			return $elm$core$Maybe$Just(2);
		case 'APRIL':
			return $elm$core$Maybe$Just(3);
		case 'MAY':
			return $elm$core$Maybe$Just(4);
		case 'JUNE':
			return $elm$core$Maybe$Just(5);
		case 'JULY':
			return $elm$core$Maybe$Just(6);
		case 'AUGUST':
			return $elm$core$Maybe$Just(7);
		case 'SEPTEMBER':
			return $elm$core$Maybe$Just(8);
		case 'OCTOBER':
			return $elm$core$Maybe$Just(9);
		case 'NOVEMBER':
			return $elm$core$Maybe$Just(10);
		case 'DECEMBER':
			return $elm$core$Maybe$Just(11);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Date_Time$Month$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Date_Time$Month$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Not a valid month')))),
	$elm$json$Json$Decode$string);
var $author$project$Plan$Schedule$Schedule$decodeYearly = A3(
	$elm$core$Basics$composeR,
	A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'timeZone', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$map($author$project$Plan$Schedule$Schedule$Yearly),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'endDate',
		$elm$json$Json$Decode$maybe($author$project$Date_Time$NaiveDate$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'startDate',
			$author$project$Date_Time$NaiveDate$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deadlineTime',
				$author$project$Date_Time$NaiveTime$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'creatingTime',
					$author$project$Date_Time$NaiveTime$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'day',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'month',
							$author$project$Date_Time$Month$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'interval',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$Plan$Schedule$Schedule$YearlyModel)))))))));
var $author$project$Plan$Schedule$Frequency$fromString = function (str) {
	switch (str) {
		case 'DAILY':
			return $elm$core$Maybe$Just(0);
		case 'WEEKLY':
			return $elm$core$Maybe$Just(1);
		case 'MONTHLY':
			return $elm$core$Maybe$Just(2);
		case 'YEARLY':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$Schedule$Frequency$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Plan$Schedule$Frequency$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Not a valid frequency')))),
	$elm$json$Json$Decode$string);
var $author$project$Plan$Schedule$Schedule$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (f) {
		switch (f) {
			case 0:
				return $author$project$Plan$Schedule$Schedule$decodeDaily;
			case 1:
				return $author$project$Plan$Schedule$Schedule$decodeWeekly;
			case 2:
				return $author$project$Plan$Schedule$Schedule$decodeMonthly;
			default:
				return $author$project$Plan$Schedule$Schedule$decodeYearly;
		}
	},
	A2($elm$json$Json$Decode$field, 'frequency', $author$project$Plan$Schedule$Frequency$decoder));
var $author$project$Plan$Execution$Execution$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'schedule',
	$author$project$Plan$Schedule$Schedule$decode,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'description',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'executionId',
				$author$project$Plan$Execution$Id$decode,
				$elm$json$Json$Decode$succeed($author$project$Plan$Execution$Execution$Execution)))));
var $author$project$CheckpointData$CheckpointGroup$Ids$empty = $turboMaCk$any_set$Set$Any$empty($author$project$CheckpointData$CheckpointGroup$Id$toString);
var $author$project$Plan$Event$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (eventType) {
		switch (eventType) {
			case 'de.awenko.plan.created.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Plan$Event$Created),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'auditors',
						$author$project$User$Ids$decode,
						$author$project$User$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'checkpointGroups',
							$author$project$CheckpointData$CheckpointGroup$Ids$decode,
							$author$project$CheckpointData$CheckpointGroup$Ids$empty,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'executions',
								$elm$json$Json$Decode$list($author$project$Plan$Execution$Execution$decode),
								_List_Nil,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'title',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'planId',
											$author$project$Plan$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'commandTimestamp',
												$author$project$Utils$Decode$timestamp,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandId',
													$author$project$Types$CommandId$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'eventId',
														$author$project$Types$EventId$decode,
														$elm$json$Json$Decode$succeed($author$project$Plan$Event$CreatedPayload)))))))))));
			case 'de.awenko.plan.title-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Plan$Event$TitleChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Plan$Event$TitleChangedPayload)))))));
			case 'de.awenko.plan.description-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Plan$Event$DescriptionChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Plan$Event$DescriptionChangedPayload)))))));
			case 'de.awenko.plan.execution-added.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Plan$Event$ExecutionAdded),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'execution',
						$author$project$Plan$Execution$Execution$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Plan$Event$ExecutionAddedPayload)))))));
			case 'de.awenko.plan.execution-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Plan$Event$ExecutionChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'execution',
						$author$project$Plan$Execution$Execution$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Plan$Event$ExecutionChangedPayload)))))));
			case 'de.awenko.plan.execution-removed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Plan$Event$ExecutionRemoved),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'executionId',
						$author$project$Plan$Execution$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Plan$Event$ExecutionRemovedPayload)))))));
			case 'de.awenko.plan.auditors-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Plan$Event$AuditorsChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'removeAuditors',
						$author$project$User$Ids$decode,
						$author$project$User$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'addAuditors',
							$author$project$User$Ids$decode,
							$author$project$User$Ids$empty,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'planId',
								$author$project$Plan$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'eventId',
											$author$project$Types$EventId$decode,
											$elm$json$Json$Decode$succeed($author$project$Plan$Event$AuditorsChangedPayload))))))));
			case 'de.awenko.plan.checkpoint-groups-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Plan$Event$CheckpointGroupsChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'removeCheckpointGroups',
						$author$project$CheckpointData$CheckpointGroup$Ids$decode,
						$author$project$CheckpointData$CheckpointGroup$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'addCheckpointGroups',
							$author$project$CheckpointData$CheckpointGroup$Ids$decode,
							$author$project$CheckpointData$CheckpointGroup$Ids$empty,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'planId',
								$author$project$Plan$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'eventId',
											$author$project$Types$EventId$decode,
											$elm$json$Json$Decode$succeed($author$project$Plan$Event$CheckpointGroupsChangedPayload))))))));
			case 'de.awenko.plan.deleted.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Plan$Event$Deleted),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'planId',
						$author$project$Plan$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$Plan$Event$DeletedPayload))))));
			case 'de.awenko.plan.manuel-executed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Plan$Event$PlanExecuted),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'planId',
						$author$project$Plan$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$Plan$Event$PlanExecutedPayload))))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'eventType', $elm$json$Json$Decode$string));
var $author$project$Rights$Event$OrganisationUnitsAdded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Rights$Event$OrganisationUnitsAddedPayload = F6(
	function (eventId, commandId, commandTimestamp, teamId, organisationUnits, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, kn: organisationUnits, k1: teamId, n: version};
	});
var $author$project$Rights$Event$OrganisationUnitsRemoved = function (a) {
	return {$: 10, a: a};
};
var $author$project$Rights$Event$OrganisationUnitsRemovedPayload = F6(
	function (eventId, commandId, commandTimestamp, teamId, organisationUnits, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, kn: organisationUnits, k1: teamId, n: version};
	});
var $author$project$Rights$Event$RightsAdded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Rights$Event$RightsAddedPayload = F6(
	function (eventId, commandId, commandTimestamp, roleId, rights, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, kF: rights, hc: roleId, n: version};
	});
var $author$project$Rights$Event$RightsRemoved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Rights$Event$RightsRemovedPayload = F6(
	function (eventId, commandId, commandTimestamp, roleId, rights, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, kF: rights, hc: roleId, n: version};
	});
var $author$project$Rights$Event$RoleCreated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Rights$Event$RoleCreatedPayload = F8(
	function (eventId, commandId, commandTimestamp, roleId, title, description, rights, version) {
		return {L: commandId, M: commandTimestamp, aY: description, N: eventId, kF: rights, hc: roleId, k8: title, n: version};
	});
var $author$project$Rights$Event$RoleDeleted = function (a) {
	return {$: 5, a: a};
};
var $author$project$Rights$Event$RoleDeletedPayload = F5(
	function (eventId, commandId, commandTimestamp, roleId, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, hc: roleId, n: version};
	});
var $author$project$Rights$Event$RoleDescriptionChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Event$RoleDescriptionChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, roleId, description, version) {
		return {L: commandId, M: commandTimestamp, aY: description, N: eventId, hc: roleId, n: version};
	});
var $author$project$Rights$Event$RoleTitleChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Event$RoleTitleChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, roleId, title, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, hc: roleId, k8: title, n: version};
	});
var $author$project$Rights$Event$TeamCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Rights$Event$TeamCreatedPayload = F8(
	function (eventId, commandId, commandTimestamp, teamId, title, description, organisationUnits, version) {
		return {L: commandId, M: commandTimestamp, aY: description, N: eventId, kn: organisationUnits, k1: teamId, k8: title, n: version};
	});
var $author$project$Rights$Event$TeamDeleted = function (a) {
	return {$: 11, a: a};
};
var $author$project$Rights$Event$TeamDeletedPayload = F5(
	function (eventId, commandId, commandTimestamp, teamId, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, k1: teamId, n: version};
	});
var $author$project$Rights$Event$TeamDescriptionChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Rights$Event$TeamDescriptionChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, teamId, description, version) {
		return {L: commandId, M: commandTimestamp, aY: description, N: eventId, k1: teamId, n: version};
	});
var $author$project$Rights$Event$TeamTitleChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Rights$Event$TeamTitleChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, teamId, title, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, k1: teamId, k8: title, n: version};
	});
var $author$project$Rights$Role$Id$Id = $elm$core$Basics$identity;
var $author$project$Rights$Role$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$Rights$Team$Id$Id = $elm$core$Basics$identity;
var $author$project$Rights$Team$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$decoder);
var $author$project$Rights$Event$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (eventType) {
		switch (eventType) {
			case 'de.awenko.rights.role-created.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$RoleCreated),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'rights',
						$elm$json$Json$Decode$list($author$project$Rights$Right$decode),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'description',
							$elm$json$Json$Decode$string,
							'',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'title',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'roleId',
									$author$project$Rights$Role$Id$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandTimestamp',
										$author$project$Utils$Decode$timestamp,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'commandId',
											$author$project$Types$CommandId$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'eventId',
												$author$project$Types$EventId$decode,
												$elm$json$Json$Decode$succeed($author$project$Rights$Event$RoleCreatedPayload)))))))));
			case 'de.awenko.rights.role-title-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$RoleTitleChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'roleId',
							$author$project$Rights$Role$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Rights$Event$RoleTitleChangedPayload)))))));
			case 'de.awenko.rights.role-description-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$RoleDescriptionChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'roleId',
							$author$project$Rights$Role$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Rights$Event$RoleDescriptionChangedPayload)))))));
			case 'de.awenko.rights.rights-added.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$RightsAdded),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rights',
						$elm$json$Json$Decode$list($author$project$Rights$Right$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'roleId',
							$author$project$Rights$Role$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Rights$Event$RightsAddedPayload)))))));
			case 'de.awenko.rights.rights-removed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$RightsRemoved),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rights',
						$elm$json$Json$Decode$list($author$project$Rights$Right$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'roleId',
							$author$project$Rights$Role$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Rights$Event$RightsRemovedPayload)))))));
			case 'de.awenko.rights.role-deleted.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$RoleDeleted),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'roleId',
						$author$project$Rights$Role$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$Rights$Event$RoleDeletedPayload))))));
			case 'de.awenko.rights.team-created.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$TeamCreated),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$decode,
						$author$project$OrganisationUnit$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'description',
							$elm$json$Json$Decode$string,
							'',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'title',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'teamId',
									$author$project$Rights$Team$Id$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandTimestamp',
										$author$project$Utils$Decode$timestamp,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'commandId',
											$author$project$Types$CommandId$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'eventId',
												$author$project$Types$EventId$decode,
												$elm$json$Json$Decode$succeed($author$project$Rights$Event$TeamCreatedPayload)))))))));
			case 'de.awenko.rights.team-title-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$TeamTitleChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'teamId',
							$author$project$Rights$Team$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Rights$Event$TeamTitleChangedPayload)))))));
			case 'de.awenko.rights.team-description-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$TeamDescriptionChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'teamId',
							$author$project$Rights$Team$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Rights$Event$TeamDescriptionChangedPayload)))))));
			case 'de.awenko.rights.organisation-units-added.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$OrganisationUnitsAdded),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'teamId',
							$author$project$Rights$Team$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Rights$Event$OrganisationUnitsAddedPayload)))))));
			case 'de.awenko.rights.organisation-units-removed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$OrganisationUnitsRemoved),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'teamId',
							$author$project$Rights$Team$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Rights$Event$OrganisationUnitsRemovedPayload)))))));
			case 'de.awenko.rights.team-deleted.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Rights$Event$TeamDeleted),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'teamId',
						$author$project$Rights$Team$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$Rights$Event$TeamDeletedPayload))))));
			default:
				return $elm$json$Json$Decode$fail('unknown rights event');
		}
	},
	A2($elm$json$Json$Decode$field, 'eventType', $elm$json$Json$Decode$string));
var $author$project$Tenant$Event$CountryChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Tenant$Event$CountryChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, tenantId, country, version) {
		return {L: commandId, M: commandTimestamp, gw: country, N: eventId, k5: tenantId, n: version};
	});
var $author$project$Tenant$Event$HouseNumberChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Tenant$Event$HouseNumberChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, tenantId, houseNumber, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, gP: houseNumber, k5: tenantId, n: version};
	});
var $author$project$Tenant$Event$LimitationsChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$Tenant$Event$LimitationsChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, tenantId, limitations, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, jW: limitations, k5: tenantId, n: version};
	});
var $author$project$Tenant$Event$LocationChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Tenant$Event$LocationChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, tenantId, location, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, gV: location, k5: tenantId, n: version};
	});
var $author$project$Tenant$Event$LogoChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Tenant$Event$LogoChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, tenantId, logo, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, jX: logo, k5: tenantId, n: version};
	});
var $author$project$Tenant$Event$PhoneNumberChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Tenant$Event$PhoneNumberChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, tenantId, phoneNumber, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, g7: phoneNumber, k5: tenantId, n: version};
	});
var $author$project$Tenant$Event$RoadChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tenant$Event$RoadChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, tenantId, road, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, hb: road, k5: tenantId, n: version};
	});
var $author$project$Tenant$Event$TenantCreated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Tenant$Event$TenantCreatedPayload = F5(
	function (eventId, commandId, commandTimestamp, tenantId, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, k5: tenantId, n: version};
	});
var $author$project$Tenant$Event$UrlChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Tenant$Event$UrlChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, tenantId, url, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, k5: tenantId, lg: url, n: version};
	});
var $author$project$Tenant$Event$ZipCodeChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Tenant$Event$ZipCodeChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, tenantId, zipCode, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, k5: tenantId, n: version, hr: zipCode};
	});
var $author$project$Tenant$Event$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (eventType) {
		switch (eventType) {
			case 'de.awenko.tenant.created.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Tenant$Event$TenantCreated),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$Tenant$Event$TenantCreatedPayload))))));
			case 'de.awenko.tenant.road-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Tenant$Event$RoadChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'road',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'tenantId',
							$author$project$Tenant$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Tenant$Event$RoadChangedPayload)))))));
			case 'de.awenko.tenant.house-number-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Tenant$Event$HouseNumberChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'houseNumber',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'tenantId',
							$author$project$Tenant$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Tenant$Event$HouseNumberChangedPayload)))))));
			case 'de.awenko.tenant.zip-code-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Tenant$Event$ZipCodeChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'zipCode',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'tenantId',
							$author$project$Tenant$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Tenant$Event$ZipCodeChangedPayload)))))));
			case 'de.awenko.tenant.location-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Tenant$Event$LocationChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'location',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'tenantId',
							$author$project$Tenant$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Tenant$Event$LocationChangedPayload)))))));
			case 'de.awenko.tenant.country-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Tenant$Event$CountryChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'country',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'tenantId',
							$author$project$Tenant$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Tenant$Event$CountryChangedPayload)))))));
			case 'de.awenko.tenant.phone-number-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Tenant$Event$PhoneNumberChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'phoneNumber',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'tenantId',
							$author$project$Tenant$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Tenant$Event$PhoneNumberChangedPayload)))))));
			case 'de.awenko.tenant.url-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Tenant$Event$UrlChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'url',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'tenantId',
							$author$project$Tenant$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Tenant$Event$UrlChangedPayload)))))));
			case 'de.awenko.tenant.logo-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Tenant$Event$LogoChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'logo',
						$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'tenantId',
							$author$project$Tenant$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Tenant$Event$LogoChangedPayload)))))));
			case 'de.awenko.tenant.limitations-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$Tenant$Event$LimitationsChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'limitations',
						$author$project$Tenant$Limitations$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'tenantId',
							$author$project$Tenant$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$Tenant$Event$LimitationsChangedPayload)))))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'eventType', $elm$json$Json$Decode$string));
var $author$project$User$Event$AvatarChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$User$Event$AvatarChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, userId, avatar, version) {
		return {iX: avatar, L: commandId, M: commandTimestamp, N: eventId, dk: userId, n: version};
	});
var $author$project$User$Event$Created = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$Event$CreatedPayload = function (eventId) {
	return function (commandId) {
		return function (commandTimestamp) {
			return function (userId) {
				return function (username) {
					return function (emailAddress) {
						return function (name) {
							return function (teamRoles) {
								return function (avatar) {
									return function (entryOrganisationUnit) {
										return function (version) {
											return {iX: avatar, L: commandId, M: commandTimestamp, ju: emailAddress, hT: entryOrganisationUnit, N: eventId, g_: name, k2: teamRoles, dk: userId, iK: username, n: version};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$Event$Deleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$User$Event$DeletedPayload = F6(
	function (eventId, commandId, commandTimestamp, userId, username, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, dk: userId, iK: username, n: version};
	});
var $author$project$User$Event$EmailAddressChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$Event$EmailAddressChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, userId, emailAddress, version) {
		return {L: commandId, M: commandTimestamp, ju: emailAddress, N: eventId, dk: userId, n: version};
	});
var $author$project$User$Event$EntryOrganisationUnitChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$User$Event$EntryOrganisationUnitChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, userId, entryOrganisationUnit, version) {
		return {L: commandId, M: commandTimestamp, hT: entryOrganisationUnit, N: eventId, dk: userId, n: version};
	});
var $author$project$User$Event$PasswordChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$Event$PasswordChangedPayload = F5(
	function (eventId, commandId, commandTimestamp, userId, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, dk: userId, n: version};
	});
var $author$project$User$Event$Renamed = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$Event$RenamedPayload = F6(
	function (eventId, commandId, commandTimestamp, userId, name, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, g_: name, dk: userId, n: version};
	});
var $author$project$User$Event$TeamRoleAdded = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$Event$TeamRoleAddedPayload = F6(
	function (eventId, commandId, commandTimestamp, userId, teamRole, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, bQ: teamRole, dk: userId, n: version};
	});
var $author$project$User$Event$TeamRoleChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$User$Event$TeamRoleChangedPayload = F6(
	function (eventId, commandId, commandTimestamp, userId, teamRole, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, bQ: teamRole, dk: userId, n: version};
	});
var $author$project$User$Event$TeamRoleRemoved = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$Event$TeamRoleRemovedPayload = F6(
	function (eventId, commandId, commandTimestamp, userId, teamRole, version) {
		return {L: commandId, M: commandTimestamp, N: eventId, bQ: teamRole, dk: userId, n: version};
	});
var $author$project$User$EmailAddress$EmailAddress = $elm$core$Basics$identity;
var $author$project$User$EmailAddress$fromString = function (input) {
	var parts = A2(
		$elm$core$List$map,
		$elm$core$String$trim,
		A2($elm$core$String$split, '@', input));
	if ((parts.b && parts.b.b) && (!parts.b.b.b)) {
		if (parts.a === '') {
			var _v1 = parts.b;
			return $elm$core$Maybe$Nothing;
		} else {
			if (parts.b.a === '') {
				var _v2 = parts.b;
				return $elm$core$Maybe$Nothing;
			} else {
				var localPart = parts.a;
				var _v3 = parts.b;
				var domainPart = _v3.a;
				return $elm$core$Maybe$Just(localPart + ('@' + domainPart));
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$User$EmailAddress$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$User$EmailAddress$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Not a valid email address')))),
	$elm$json$Json$Decode$string);
var $author$project$User$TeamRoles$TeamRole = F2(
	function (teamId, roleIds) {
		return {kH: roleIds, k1: teamId};
	});
var $author$project$Rights$Role$Ids$decode = A2($turboMaCk$any_set$Set$Any$decode, $author$project$Rights$Role$Id$toString, $author$project$Rights$Role$Id$decode);
var $author$project$Rights$Role$Ids$empty = $turboMaCk$any_set$Set$Any$empty($author$project$Rights$Role$Id$toString);
var $author$project$User$TeamRoles$decodeTeamRole = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'roleIds',
	$author$project$Rights$Role$Ids$decode,
	$author$project$Rights$Role$Ids$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'teamId',
		$author$project$Rights$Team$Id$decode,
		$elm$json$Json$Decode$succeed($author$project$User$TeamRoles$TeamRole)));
var $author$project$User$TeamRoles$decode = A2(
	$turboMaCk$any_set$Set$Any$decode,
	function (teamRoles) {
		return $author$project$Rights$Team$Id$toString(teamRoles.k1);
	},
	$author$project$User$TeamRoles$decodeTeamRole);
var $author$project$User$TeamRoles$empty = $turboMaCk$any_set$Set$Any$empty(
	function (teamRoles) {
		return $author$project$Rights$Team$Id$toString(teamRoles.k1);
	});
var $author$project$User$Event$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (eventType) {
		switch (eventType) {
			case 'de.awenko.user.created.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$User$Event$Created),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'entryOrganisationUnit',
						$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'avatar',
							$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'teamRoles',
								$author$project$User$TeamRoles$decode,
								$author$project$User$TeamRoles$empty,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'name',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'emailAddress',
										$elm$json$Json$Decode$maybe($author$project$User$EmailAddress$decode),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'username',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'userId',
												$author$project$User$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandTimestamp',
													$author$project$Utils$Decode$timestamp,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandId',
														$author$project$Types$CommandId$decode,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'eventId',
															$author$project$Types$EventId$decode,
															$elm$json$Json$Decode$succeed($author$project$User$Event$CreatedPayload))))))))))));
			case 'de.awenko.user.email-address-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$User$Event$EmailAddressChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'emailAddress',
						$author$project$User$EmailAddress$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$User$Event$EmailAddressChangedPayload)))))));
			case 'de.awenko.user.password-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$User$Event$PasswordChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'userId',
						$author$project$User$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eventId',
									$author$project$Types$EventId$decode,
									$elm$json$Json$Decode$succeed($author$project$User$Event$PasswordChangedPayload))))));
			case 'de.awenko.user.renamed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$User$Event$Renamed),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'name',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$User$Event$RenamedPayload)))))));
			case 'de.awenko.user.team-role-added.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$User$Event$TeamRoleAdded),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'teamRole',
						$author$project$User$TeamRoles$decodeTeamRole,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$User$Event$TeamRoleAddedPayload)))))));
			case 'de.awenko.user.team-role-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$User$Event$TeamRoleChanged),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'teamRole',
						$author$project$User$TeamRoles$decodeTeamRole,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$User$Event$TeamRoleChangedPayload)))))));
			case 'de.awenko.user.team-role-removed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$User$Event$TeamRoleRemoved),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'teamRole',
						$author$project$User$TeamRoles$decodeTeamRole,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$User$Event$TeamRoleRemovedPayload)))))));
			case 'de.awenko.user.avatar-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$User$Event$AvatarChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'avatar',
						$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$User$Event$AvatarChangedPayload)))))));
			case 'de.awenko.user.entry-organisation-unit-changed.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$User$Event$EntryOrganisationUnitChanged),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'entryOrganisationUnit',
						$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$User$Event$EntryOrganisationUnitChangedPayload)))))));
			case 'de.awenko.user.deleted.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'version', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$map($author$project$User$Event$Deleted),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'username',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eventId',
										$author$project$Types$EventId$decode,
										$elm$json$Json$Decode$succeed($author$project$User$Event$DeletedPayload)))))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'eventType', $elm$json$Json$Decode$string));
var $author$project$EventStream$EventStream$OutOfDate = 2;
var $author$project$EventStream$EventStream$UpToDate = 1;
var $author$project$EventStream$EventStream$decodeResourceStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (status_) {
		switch (status_) {
			case 'UP_TO_DATE':
				return $elm$json$Json$Decode$succeed(1);
			case 'OUT_OF_DATE':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown status');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$EventStream$EventStream$EventStreamConnected = {$: 1};
var $author$project$EventStream$EventStream$EventStreamDisconnected = {$: 0};
var $author$project$EventStream$EventStream$EventStreamError = function (a) {
	return {$: 2, a: a};
};
var $author$project$EventStream$EventStream$decodeState = A2(
	$elm$json$Json$Decode$andThen,
	function (status_) {
		switch (status_) {
			case 'DISCONNECTED':
				return $elm$json$Json$Decode$succeed($author$project$EventStream$EventStream$EventStreamDisconnected);
			case 'CONNECTED':
				return $elm$json$Json$Decode$succeed($author$project$EventStream$EventStream$EventStreamConnected);
			case 'ERROR':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'error',
					$elm$json$Json$Decode$string,
					'unknown error',
					$elm$json$Json$Decode$succeed($author$project$EventStream$EventStream$EventStreamError));
			default:
				return $elm$json$Json$Decode$fail('Unknown status');
		}
	},
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string));
var $author$project$EventStream$EventStream$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'STATUS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedStatus,
					A2($elm$json$Json$Decode$field, 'state', $author$project$EventStream$EventStream$decodeState));
			case 'USER_STATUS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedUserStatus,
					A2($elm$json$Json$Decode$field, 'status', $author$project$EventStream$EventStream$decodeResourceStatus));
			case 'USER_EVENT':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedUserEvent,
					A2($elm$json$Json$Decode$field, 'event', $author$project$User$Event$decode));
			case 'ORGANISATION_UNIT_STATUS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedOrganisationUnitStatus,
					A2($elm$json$Json$Decode$field, 'status', $author$project$EventStream$EventStream$decodeResourceStatus));
			case 'ORGANISATION_UNIT_EVENT':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedOrganisationUnitEvent,
					A2($elm$json$Json$Decode$field, 'event', $author$project$OrganisationUnit$Event$decode));
			case 'PLAN_STATUS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedPlanStatus,
					A2($elm$json$Json$Decode$field, 'status', $author$project$EventStream$EventStream$decodeResourceStatus));
			case 'PLAN_EVENT':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedPlanEvent,
					A2($elm$json$Json$Decode$field, 'event', $author$project$Plan$Event$decode));
			case 'AUDIT_STATUS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedAuditsStatus,
					A2($elm$json$Json$Decode$field, 'status', $author$project$EventStream$EventStream$decodeResourceStatus));
			case 'AUDIT_EVENT':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedAuditEvent,
					A2($elm$json$Json$Decode$field, 'event', $author$project$Audit$Event$decode));
			case 'MEASURE_STATUS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedMeasureStatus,
					A2($elm$json$Json$Decode$field, 'status', $author$project$EventStream$EventStream$decodeResourceStatus));
			case 'MEASURE_EVENT':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedMeasureEvent,
					A2($elm$json$Json$Decode$field, 'event', $author$project$Measure$Event$decode));
			case 'TENANT_STATUS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedTenantStatus,
					A2($elm$json$Json$Decode$field, 'status', $author$project$EventStream$EventStream$decodeResourceStatus));
			case 'TENANT_EVENT':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedTenantEvent,
					A2($elm$json$Json$Decode$field, 'event', $author$project$Tenant$Event$decode));
			case 'CHECKPOINT_DATA_STATUS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedCheckpointDataStatus,
					A2($elm$json$Json$Decode$field, 'status', $author$project$EventStream$EventStream$decodeResourceStatus));
			case 'CHECKPOINT_DATA_EVENT':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedCheckpointDataEvent,
					A2($elm$json$Json$Decode$field, 'event', $author$project$CheckpointData$Event$decode));
			case 'RIGHT_STATUS':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedRightsStatus,
					A2($elm$json$Json$Decode$field, 'status', $author$project$EventStream$EventStream$decodeResourceStatus));
			case 'RIGHTS_EVENT':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$EventStream$EventStream$ReceivedRightsEvent,
					A2($elm$json$Json$Decode$field, 'event', $author$project$Rights$Event$decode));
			default:
				return $elm$json$Json$Decode$fail('Unknown message type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$EventStream$EventStream$eventStreamInbox = _Platform_incomingPort('eventStreamInbox', $elm$json$Json$Decode$value);
var $author$project$EventStream$EventStream$ReceivedErrorMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$EventStream$EventStream$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$EventStream$EventStream$ReceivedErrorMsg(error);
	}
};
var $author$project$EventStream$EventStream$subscriptions = $author$project$EventStream$EventStream$eventStreamInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$EventStream$EventStream$decodeMsg),
		$author$project$EventStream$EventStream$handleDecodeResult));
var $author$project$File$Store$DeletedFile = function (a) {
	return {$: 6, a: a};
};
var $author$project$File$Store$DownloadedFile = function (a) {
	return {$: 4, a: a};
};
var $author$project$File$Store$ErrorDownloadingFile = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$File$Store$LoadedFiles = function (a) {
	return {$: 0, a: a};
};
var $author$project$File$Store$SavedFiles = {$: 1};
var $author$project$File$Store$SavedModifications = {$: 2};
var $author$project$File$Store$UploadedFile = function (a) {
	return {$: 3, a: a};
};
var $author$project$File$File$MeasureImage = function (a) {
	return {$: 2, a: a};
};
var $author$project$File$File$MeasureImageData = F5(
	function (measureId, organisationUnitId, filename, status, deleted) {
		return {dA: deleted, P: filename, h5: measureId, km: organisationUnitId, kU: status};
	});
var $author$project$File$File$Local = 0;
var $author$project$File$File$Remote = 1;
var $author$project$File$File$Synchronized = 2;
var $author$project$File$File$decodeStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (status_) {
		switch (status_) {
			case 'LOCAL':
				return $elm$json$Json$Decode$succeed(0);
			case 'REMOTE':
				return $elm$json$Json$Decode$succeed(1);
			case 'SYNCHRONIZED':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown status');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$File$File$decodeMeasureImage = A2(
	$elm$json$Json$Decode$map,
	$author$project$File$File$MeasureImage,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deleted',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$author$project$File$File$decodeStatus,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'filename',
				$author$project$File$Filename$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'organisationUnitId',
					$author$project$OrganisationUnit$Id$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'measureId',
						$author$project$Measure$Id$decode,
						$elm$json$Json$Decode$succeed($author$project$File$File$MeasureImageData)))))));
var $author$project$File$File$FloorPlan = 0;
var $author$project$File$File$OrganisationUnitData = F5(
	function (organisationUnitId, filename, status, deleted, fileType) {
		return {dA: deleted, fs: fileType, P: filename, km: organisationUnitId, kU: status};
	});
var $author$project$File$File$OrganisationUnitFile = function (a) {
	return {$: 1, a: a};
};
var $author$project$File$File$CommonFile = 1;
var $author$project$File$File$decodeOrganisationUnitFileType = A2(
	$elm$json$Json$Decode$andThen,
	function (status_) {
		switch (status_) {
			case 'FLOORPLAN':
				return $elm$json$Json$Decode$succeed(0);
			case 'COMMONFILE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unknown status');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$File$File$decodeOrganisationUnit = A2(
	$elm$json$Json$Decode$map,
	$author$project$File$File$OrganisationUnitFile,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'fileType',
		$author$project$File$File$decodeOrganisationUnitFileType,
		0,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'deleted',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$author$project$File$File$decodeStatus,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'filename',
					$author$project$File$Filename$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$decode,
						$elm$json$Json$Decode$succeed($author$project$File$File$OrganisationUnitData)))))));
var $author$project$File$File$RecordImage = function (a) {
	return {$: 3, a: a};
};
var $author$project$File$File$RecordImageData = F5(
	function (auditId, recordId, filename, status, deleted) {
		return {gm: auditId, dA: deleted, P: filename, bK: recordId, kU: status};
	});
var $author$project$File$File$decodeRecordImage = A2(
	$elm$json$Json$Decode$map,
	$author$project$File$File$RecordImage,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deleted',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$author$project$File$File$decodeStatus,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'filename',
				$author$project$File$Filename$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recordId',
					$author$project$Audit$Record$Id$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'auditId',
						$author$project$Audit$Id$decode,
						$elm$json$Json$Decode$succeed($author$project$File$File$RecordImageData)))))));
var $author$project$File$File$UserAvatar = function (a) {
	return {$: 0, a: a};
};
var $author$project$File$File$UserAvatarData = F4(
	function (userId, filename, status, deleted) {
		return {dA: deleted, P: filename, kU: status, dk: userId};
	});
var $author$project$File$File$decodeUserAvatar = A2(
	$elm$json$Json$Decode$map,
	$author$project$File$File$UserAvatar,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deleted',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$author$project$File$File$decodeStatus,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'filename',
				$author$project$File$Filename$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'userId',
					$author$project$User$Id$decode,
					$elm$json$Json$Decode$succeed($author$project$File$File$UserAvatarData))))));
var $author$project$File$File$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'USER_AVATAR':
				return $author$project$File$File$decodeUserAvatar;
			case 'ORGANISATION_UNIT_FILE':
				return $author$project$File$File$decodeOrganisationUnit;
			case 'MEASURE_IMAGE':
				return $author$project$File$File$decodeMeasureImage;
			case 'RECORD_IMAGE':
				return $author$project$File$File$decodeRecordImage;
			default:
				return $elm$json$Json$Decode$fail('Unknown type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$File$Files$Files = $elm$core$Basics$identity;
var $author$project$File$File$filename = function (file) {
	switch (file.$) {
		case 0:
			var data = file.a;
			return data.P;
		case 1:
			var data = file.a;
			return data.P;
		case 2:
			var data = file.a;
			return data.P;
		default:
			var data = file.a;
			return data.P;
	}
};
var $author$project$File$Dict$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2($author$project$Utils$Tuple$with, $author$project$File$File$filename, $elm$core$Basics$identity)),
	$turboMaCk$any_dict$Dict$Any$fromList($author$project$File$Filename$toIdString));
var $author$project$File$Dict$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$File$Dict$fromList,
	$elm$json$Json$Decode$list($author$project$File$File$decode));
var $author$project$File$Files$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$File$Dict$decode);
var $author$project$File$Store$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOADED_FILES':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$File$Store$LoadedFiles,
					A2($elm$json$Json$Decode$field, 'files', $author$project$File$Files$decode));
			case 'SAVED_FILES':
				return $elm$json$Json$Decode$succeed($author$project$File$Store$SavedFiles);
			case 'SAVED_MODIFICATIONS':
				return $elm$json$Json$Decode$succeed($author$project$File$Store$SavedModifications);
			case 'UPLOADED_FILE':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$File$Store$UploadedFile,
					A2($elm$json$Json$Decode$field, 'file', $author$project$File$File$decode));
			case 'DOWNLOADED_FILE':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$File$Store$DownloadedFile,
					A2($elm$json$Json$Decode$field, 'file', $author$project$File$File$decode));
			case 'ERROR_DOWNLOADING_FILE':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'file',
					$author$project$File$File$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$File$Store$ErrorDownloadingFile)));
			case 'DELETED_FILE':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$File$Store$DeletedFile,
					A2($elm$json$Json$Decode$field, 'file', $author$project$File$Filename$decode));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$File$Store$fileStoreInbox = _Platform_incomingPort('fileStoreInbox', $elm$json$Json$Decode$value);
var $author$project$File$Store$ReceivedErrorMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$File$Store$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$File$Store$ReceivedErrorMsg(error);
	}
};
var $author$project$File$Store$subscriptions = $author$project$File$Store$fileStoreInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$File$Store$decodeMsg),
		$author$project$File$Store$handleDecodeResult));
var $author$project$Measure$Store$LoadedData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Measure$Store$RemovedCommand = {$: 4};
var $author$project$Measure$Store$RemovedCommandAndEvent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Measure$Store$SavedCommandsAndEvents = {$: 3};
var $author$project$Measure$Store$SavedMeasures = {$: 1};
var $author$project$Measure$Store$SavedModifications = {$: 2};
var $author$project$Measure$Store$Data = F3(
	function (measures, events, commands) {
		return {cD: commands, b8: events, aI: measures};
	});
var $author$project$Measure$Command$AddImages = function (a) {
	return {$: 6, a: a};
};
var $author$project$Measure$Command$AddImagesPayload = F6(
	function (commandId, commandTimestamp, measureId, addImages, idForError, titleForError) {
		return {gf: addImages, L: commandId, M: commandTimestamp, k: idForError, h5: measureId, l: titleForError};
	});
var $author$project$Measure$Command$ChangeDeadline = function (a) {
	return {$: 4, a: a};
};
var $author$project$Measure$Command$ChangeDeadlinePayload = F6(
	function (commandId, commandTimestamp, measureId, deadlineTimestamp, idForError, titleForError) {
		return {L: commandId, M: commandTimestamp, hI: deadlineTimestamp, k: idForError, h5: measureId, l: titleForError};
	});
var $author$project$Measure$Command$ChangeDescription = function (a) {
	return {$: 2, a: a};
};
var $author$project$Measure$Command$ChangeDescriptionPayload = F6(
	function (commandId, commandTimestamp, measureId, description, idForError, titleForError) {
		return {L: commandId, M: commandTimestamp, aY: description, k: idForError, h5: measureId, l: titleForError};
	});
var $author$project$Measure$Command$ChangeOrganisationUnit = function (a) {
	return {$: 5, a: a};
};
var $author$project$Measure$Command$ChangeOrganisationUnitPayload = F6(
	function (commandId, commandTimestamp, measureId, organisationUnitId, idForError, titleForError) {
		return {L: commandId, M: commandTimestamp, k: idForError, h5: measureId, km: organisationUnitId, l: titleForError};
	});
var $author$project$Measure$Command$ChangeResponsibleUsers = function (a) {
	return {$: 3, a: a};
};
var $author$project$Measure$Command$ChangeResponsibleUsersPayload = F7(
	function (commandId, commandTimestamp, measureId, addResponsibleUsers, removeResponsibleUsers, idForError, titleForError) {
		return {e9: addResponsibleUsers, L: commandId, M: commandTimestamp, k: idForError, h5: measureId, f_: removeResponsibleUsers, l: titleForError};
	});
var $author$project$Measure$Command$ChangeTitle = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$Command$ChangeTitlePayload = F6(
	function (commandId, commandTimestamp, measureId, title, idForError, titleForError) {
		return {L: commandId, M: commandTimestamp, k: idForError, h5: measureId, k8: title, l: titleForError};
	});
var $author$project$Measure$Command$Complete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Measure$Command$CompletePayload = F5(
	function (commandId, commandTimestamp, measureId, idForError, titleForError) {
		return {L: commandId, M: commandTimestamp, k: idForError, h5: measureId, l: titleForError};
	});
var $author$project$Measure$Command$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$Measure$Command$CreatePayload = function (commandId) {
	return function (commandTimestamp) {
		return function (measureId) {
			return function (id) {
				return function (measureType) {
					return function (title) {
						return function (description) {
							return function (creationTimestamp) {
								return function (deadlineTimestamp) {
									return function (organisationUnitId) {
										return function (creatorId) {
											return function (images) {
												return function (responsibleUsers) {
													return {L: commandId, M: commandTimestamp, dw: creationTimestamp, jd: creatorId, hI: deadlineTimestamp, aY: description, fw: id, fx: images, h5: measureId, h6: measureType, km: organisationUnitId, bb: responsibleUsers, k8: title};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Measure$Command$Delete = function (a) {
	return {$: 9, a: a};
};
var $author$project$Measure$Command$DeletePayload = F5(
	function (commandId, commandTimestamp, measureId, idForError, titleForError) {
		return {L: commandId, M: commandTimestamp, k: idForError, h5: measureId, l: titleForError};
	});
var $author$project$Measure$Command$RemoveImages = function (a) {
	return {$: 7, a: a};
};
var $author$project$Measure$Command$RemoveImagesPayload = F6(
	function (commandId, commandTimestamp, measureId, removeImages, idForError, titleForError) {
		return {L: commandId, M: commandTimestamp, k: idForError, h5: measureId, ha: removeImages, l: titleForError};
	});
var $author$project$Measure$Command$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (commandType) {
		switch (commandType) {
			case 'de.awenko.measure.create.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'responsibleUsers', $author$project$User$Ids$decode, $author$project$User$Ids$empty),
					$elm$json$Json$Decode$map($author$project$Measure$Command$Create),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'images',
						$elm$json$Json$Decode$list($author$project$File$Filename$decode),
						_List_Nil,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'creatorId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'organisationUnitId',
								$author$project$OrganisationUnit$Id$decode,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'deadlineTimestamp',
									$elm$json$Json$Decode$maybe($author$project$Utils$Decode$timestamp),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'creationTimestamp',
										$author$project$Utils$Decode$timestamp,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'description',
											$elm$json$Json$Decode$string,
											'',
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'title',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'measureType',
													$author$project$Measure$MeasureType$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'measureId',
															$author$project$Measure$Id$decode,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'commandTimestamp',
																$author$project$Utils$Decode$timestamp,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'commandId',
																	$author$project$Types$CommandId$decode,
																	$elm$json$Json$Decode$succeed($author$project$Measure$Command$CreatePayload))))))))))))));
			case 'de.awenko.measure.change-title.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Measure$Command$ChangeTitle),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'measureId',
								$author$project$Measure$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Command$ChangeTitlePayload)))))));
			case 'de.awenko.measure.change-description.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Measure$Command$ChangeDescription),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'description',
							$elm$json$Json$Decode$string,
							'',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'measureId',
								$author$project$Measure$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Command$ChangeDescriptionPayload)))))));
			case 'de.awenko.measure.change-responsible-users.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Measure$Command$ChangeResponsibleUsers),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'removeResponsibleUsers',
							$author$project$User$Ids$decode,
							$author$project$User$Ids$empty,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'addResponsibleUsers',
								$author$project$User$Ids$decode,
								$author$project$User$Ids$empty,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'measureId',
									$author$project$Measure$Id$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandTimestamp',
										$author$project$Utils$Decode$timestamp,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'commandId',
											$author$project$Types$CommandId$decode,
											$elm$json$Json$Decode$succeed($author$project$Measure$Command$ChangeResponsibleUsersPayload))))))));
			case 'de.awenko.measure.change-deadline.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Measure$Command$ChangeDeadline),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'deadlineTimestamp',
							$elm$json$Json$Decode$maybe($author$project$Utils$Decode$timestamp),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'measureId',
								$author$project$Measure$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Command$ChangeDeadlinePayload)))))));
			case 'de.awenko.measure.change-organisation-unit.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Measure$Command$ChangeOrganisationUnit),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'organisationUnitId',
							$author$project$OrganisationUnit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'measureId',
								$author$project$Measure$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Command$ChangeOrganisationUnitPayload)))))));
			case 'de.awenko.measure.add-images.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Measure$Command$AddImages),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'addImages',
							$elm$json$Json$Decode$list($author$project$File$Filename$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'measureId',
								$author$project$Measure$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Command$AddImagesPayload)))))));
			case 'de.awenko.measure.remove-images.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Measure$Command$RemoveImages),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'removeImages',
							$elm$json$Json$Decode$list($author$project$File$Filename$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'measureId',
								$author$project$Measure$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Measure$Command$RemoveImagesPayload)))))));
			case 'de.awenko.measure.complete.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Measure$Command$Complete),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'measureId',
							$author$project$Measure$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Measure$Command$CompletePayload))))));
			case 'de.awenko.measure.delete.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Measure$Command$Delete),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'idForError',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'measureId',
							$author$project$Measure$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Measure$Command$DeletePayload))))));
			default:
				return $elm$json$Json$Decode$fail('Unknown command');
		}
	},
	A2($elm$json$Json$Decode$field, 'commandType', $elm$json$Json$Decode$string));
var $author$project$Measure$Commands$decode = $author$project$Types$Queue$decode($author$project$Measure$Command$decode);
var $author$project$Measure$Events$decode = $author$project$Types$Queue$decode($author$project$Measure$Event$decode);
var $author$project$Measure$Measures$Data = F2(
	function (dict, lastEventId) {
		return {cL: dict, fD: lastEventId};
	});
var $author$project$Measure$Measures$Measures = $elm$core$Basics$identity;
var $author$project$Measure$Measure$Measure = function (measureId) {
	return function (id) {
		return function (measureType) {
			return function (title) {
				return function (description) {
					return function (creationTimestamp) {
						return function (deadlineTimestamp) {
							return function (organisationUnitId) {
								return function (creatorId) {
									return function (images) {
										return function (responsibleUsers) {
											return function (completionStatus) {
												return function (revision) {
													return {jb: completionStatus, dw: creationTimestamp, jd: creatorId, hI: deadlineTimestamp, aY: description, fw: id, fx: images, h5: measureId, h6: measureType, km: organisationUnitId, bb: responsibleUsers, i: revision, k8: title};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Measure$CompletionStatus$Completed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$CompletionStatus$Open = {$: 0};
var $author$project$Measure$CompletionStatus$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (completionType) {
		switch (completionType) {
			case 'Open':
				return $elm$json$Json$Decode$succeed($author$project$Measure$CompletionStatus$Open);
			case 'Completed':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'timestamp',
					$author$project$Utils$Decode$timestamp,
					$elm$json$Json$Decode$succeed($author$project$Measure$CompletionStatus$Completed));
			default:
				return $elm$json$Json$Decode$fail('Unknown type');
		}
	},
	A2($elm$json$Json$Decode$field, 'CompletionType', $elm$json$Json$Decode$string));
var $author$project$Measure$Measure$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revision',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'completionStatus',
		$author$project$Measure$CompletionStatus$decode,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'responsibleUsers',
			$author$project$User$Ids$decode,
			$author$project$User$Ids$empty,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'images',
				$elm$json$Json$Decode$list($author$project$File$Filename$decode),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'creatorId',
					$author$project$User$Id$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$decode,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'deadlineTimestamp',
							$elm$json$Json$Decode$maybe($author$project$Utils$Decode$timestamp),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'creationTimestamp',
								$author$project$Utils$Decode$timestamp,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'title',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'measureType',
											$author$project$Measure$MeasureType$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'measureId',
													$author$project$Measure$Id$decode,
													$elm$json$Json$Decode$succeed($author$project$Measure$Measure$Measure))))))))))))));
var $author$project$Measure$Dict$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2(
			$author$project$Utils$Tuple$with,
			function ($) {
				return $.h5;
			},
			$elm$core$Basics$identity)),
	$turboMaCk$any_dict$Dict$Any$fromList($author$project$Measure$Id$toString));
var $author$project$Measure$Dict$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$Measure$Dict$fromList,
	$elm$json$Json$Decode$list($author$project$Measure$Measure$decode));
var $author$project$Measure$Measures$MeasureV1 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Measure$Measures$MeasureV2 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$OldMeasures$MeasureV1 = function (measureId) {
	return function (id) {
		return function (title) {
			return function (description) {
				return function (creationTimestamp) {
					return function (deadlineTimestamp) {
						return function (organisationUnitId) {
							return function (checkpointId) {
								return function (auditorId) {
									return function (auditId) {
										return function (recordId) {
											return function (images) {
												return function (responsibleUsers) {
													return function (isCompleted) {
														return function (version) {
															return {gm: auditId, iW: auditorId, i5: checkpointId, dw: creationTimestamp, hI: deadlineTimestamp, aY: description, fw: id, fx: images, jN: isCompleted, h5: measureId, km: organisationUnitId, bK: recordId, bb: responsibleUsers, k8: title, n: version};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Measure$OldMeasures$decodeMeasureV1 = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'version',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isCompleted',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'responsibleUsers',
			$author$project$User$Ids$decode,
			$author$project$User$Ids$empty,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'images',
				$elm$json$Json$Decode$list($author$project$File$Filename$decode),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recordId',
					$author$project$Audit$Record$Id$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'auditId',
						$author$project$Audit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'auditorId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'checkpointId',
								$author$project$CheckpointData$Checkpoint$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'organisationUnitId',
									$author$project$OrganisationUnit$Id$decode,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'deadlineTimestamp',
										$elm$json$Json$Decode$maybe($author$project$Utils$Decode$timestamp),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'creationTimestamp',
											$author$project$Utils$Decode$timestamp,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'description',
												$elm$json$Json$Decode$string,
												'',
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'title',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'measureId',
															$author$project$Measure$Id$decode,
															$elm$json$Json$Decode$succeed($author$project$Measure$OldMeasures$MeasureV1))))))))))))))));
var $author$project$Measure$Measures$decodeMeasureValues = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Measure$Measures$MeasureV1, $author$project$Measure$OldMeasures$decodeMeasureV1),
			A2($elm$json$Json$Decode$map, $author$project$Measure$Measures$MeasureV2, $author$project$Measure$Measure$decode)
		]));
var $author$project$Measure$OldMeasures$measureV1ToMeasureV2 = function (oldMeasure) {
	var measureType = $author$project$Measure$MeasureType$Issue(
		{gm: oldMeasure.gm, i5: oldMeasure.i5, bK: oldMeasure.bK});
	var completionStatus = oldMeasure.jN ? $author$project$Measure$CompletionStatus$Completed(
		$elm$time$Time$millisToPosix(0)) : $author$project$Measure$CompletionStatus$Open;
	return {jb: completionStatus, dw: oldMeasure.dw, jd: oldMeasure.iW, hI: oldMeasure.hI, aY: oldMeasure.aY, fw: oldMeasure.fw, fx: oldMeasure.fx, h5: oldMeasure.h5, h6: measureType, km: oldMeasure.km, bb: oldMeasure.bb, i: oldMeasure.n, k8: oldMeasure.k8};
};
var $author$project$Measure$Measures$oldMeasureToDict = function (listMeasureVersion) {
	var transformMeasures = F2(
		function (measureVersion, measureList) {
			if (!measureVersion.$) {
				var measureV1 = measureVersion.a;
				return A2(
					$elm$core$List$append,
					measureList,
					_List_fromArray(
						[
							$author$project$Measure$OldMeasures$measureV1ToMeasureV2(measureV1)
						]));
			} else {
				var measure = measureVersion.a;
				return A2(
					$elm$core$List$append,
					measureList,
					_List_fromArray(
						[measure]));
			}
		});
	return $author$project$Measure$Dict$fromList(
		A3($elm$core$List$foldl, transformMeasures, _List_Nil, listMeasureVersion));
};
var $author$project$Measure$Measures$decodeFromOldMeasures = A2(
	$elm$json$Json$Decode$map,
	$author$project$Measure$Measures$oldMeasureToDict,
	$elm$json$Json$Decode$list($author$project$Measure$Measures$decodeMeasureValues));
var $author$project$Measure$Dict$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$Measure$Id$toString);
var $author$project$Measure$Measures$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lastEventId',
		$elm$json$Json$Decode$maybe($author$project$Types$EventId$decode),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'measures',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[$author$project$Measure$Dict$decode, $author$project$Measure$Measures$decodeFromOldMeasures])),
			$author$project$Measure$Dict$empty,
			$elm$json$Json$Decode$succeed($author$project$Measure$Measures$Data))));
var $author$project$Measure$Commands$empty = $author$project$Types$Queue$empty;
var $author$project$Measure$Events$empty = $author$project$Types$Queue$empty;
var $author$project$Measure$Measures$empty = {cL: $author$project$Measure$Dict$empty, fD: $elm$core$Maybe$Nothing};
var $author$project$Measure$Store$decodeData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'commands',
	$author$project$Measure$Commands$decode,
	$author$project$Measure$Commands$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'events',
		$author$project$Measure$Events$decode,
		$author$project$Measure$Events$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'measures',
			$author$project$Measure$Measures$decode,
			$author$project$Measure$Measures$empty,
			$elm$json$Json$Decode$succeed($author$project$Measure$Store$Data))));
var $author$project$Measure$Store$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOADED_DATA':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Measure$Store$LoadedData,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Measure$Store$decodeData));
			case 'SAVED_MEASURES':
				return $elm$json$Json$Decode$succeed($author$project$Measure$Store$SavedMeasures);
			case 'SAVED_MODIFICATIONS':
				return $elm$json$Json$Decode$succeed($author$project$Measure$Store$SavedModifications);
			case 'SAVED_COMMANDS_AND_EVENTS':
				return $elm$json$Json$Decode$succeed($author$project$Measure$Store$SavedCommandsAndEvents);
			case 'REMOVED_COMMAND':
				return $elm$json$Json$Decode$succeed($author$project$Measure$Store$RemovedCommand);
			case 'REMOVED_COMMAND_AND_EVENT':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventVersion',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'measureId',
						$author$project$Measure$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandId',
							$author$project$Types$CommandId$decode,
							$elm$json$Json$Decode$succeed($author$project$Measure$Store$RemovedCommandAndEvent))));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Measure$Store$ReceivedErrorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Measure$Store$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$Measure$Store$ReceivedErrorMsg(error);
	}
};
var $author$project$Measure$Store$measureStoreInbox = _Platform_incomingPort('measureStoreInbox', $elm$json$Json$Decode$value);
var $author$project$Measure$Store$subscriptions = $author$project$Measure$Store$measureStoreInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Measure$Store$decodeMsg),
		$author$project$Measure$Store$handleDecodeResult));
var $author$project$OrganisationUnit$Store$LoadedData = function (a) {
	return {$: 0, a: a};
};
var $author$project$OrganisationUnit$Store$RemovedCommand = {$: 4};
var $author$project$OrganisationUnit$Store$RemovedCommandAndEvent = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$OrganisationUnit$Store$SavedCommandsAndEvents = {$: 3};
var $author$project$OrganisationUnit$Store$SavedModifications = {$: 2};
var $author$project$OrganisationUnit$Store$SavedOrganisationUnits = {$: 1};
var $author$project$OrganisationUnit$Store$Data = F3(
	function (organisationUnits, events, commands) {
		return {cD: commands, b8: events, kn: organisationUnits};
	});
var $author$project$OrganisationUnit$Command$ChangeColor = function (a) {
	return {$: 9, a: a};
};
var $author$project$OrganisationUnit$Command$ChangeColorPayload = F5(
	function (commandId, commandTimestamp, organisationUnitId, color, titleForError) {
		return {K: color, L: commandId, M: commandTimestamp, km: organisationUnitId, l: titleForError};
	});
var $author$project$OrganisationUnit$Command$ChangeDescription = function (a) {
	return {$: 8, a: a};
};
var $author$project$OrganisationUnit$Command$ChangeDescriptionPayload = F5(
	function (commandId, commandTimestamp, organisationUnitId, description, titleForError) {
		return {L: commandId, M: commandTimestamp, aY: description, km: organisationUnitId, l: titleForError};
	});
var $author$project$OrganisationUnit$Command$ChangeFloorPlan = function (a) {
	return {$: 10, a: a};
};
var $author$project$OrganisationUnit$Command$ChangeFloorPlanPayload = F6(
	function (commandId, commandTimestamp, organisationUnitId, newFloorPlan, oldFloorPlan, titleForError) {
		return {L: commandId, M: commandTimestamp, fI: newFloorPlan, fM: oldFloorPlan, km: organisationUnitId, l: titleForError};
	});
var $author$project$OrganisationUnit$Command$ChangeTitle = function (a) {
	return {$: 7, a: a};
};
var $author$project$OrganisationUnit$Command$ChangeTitlePayload = F5(
	function (commandId, commandTimestamp, organisationUnitId, title, titleForError) {
		return {L: commandId, M: commandTimestamp, km: organisationUnitId, k8: title, l: titleForError};
	});
var $author$project$OrganisationUnit$Command$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$OrganisationUnit$Command$CreateAfter = function (a) {
	return {$: 3, a: a};
};
var $author$project$OrganisationUnit$Command$CreateAfterPayload = function (commandId) {
	return function (commandTimestamp) {
		return function (organisationUnitId) {
			return function (previousId) {
				return function (title) {
					return function (description) {
						return function (floorPlan) {
							return function (firstGroup) {
								return function (lastGroup) {
									return function (color) {
										return {K: color, L: commandId, M: commandTimestamp, aY: description, ao: firstGroup, ap: floorPlan, jU: lastGroup, km: organisationUnitId, ay: previousId, k8: title};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$Command$CreateBefore = function (a) {
	return {$: 2, a: a};
};
var $author$project$OrganisationUnit$Command$CreateBeforePayload = function (commandId) {
	return function (commandTimestamp) {
		return function (organisationUnitId) {
			return function (nextId) {
				return function (title) {
					return function (description) {
						return function (floorPlan) {
							return function (firstGroup) {
								return function (lastGroup) {
									return function (color) {
										return {K: color, L: commandId, M: commandTimestamp, aY: description, ao: firstGroup, ap: floorPlan, jU: lastGroup, ax: nextId, km: organisationUnitId, k8: title};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$Command$CreateChild = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$Command$CreateChildPayload = function (commandId) {
	return function (commandTimestamp) {
		return function (organisationUnitId) {
			return function (parentId) {
				return function (title) {
					return function (description) {
						return function (floorPlan) {
							return function (firstGroup) {
								return function (lastGroup) {
									return function (color) {
										return {K: color, L: commandId, M: commandTimestamp, aY: description, ao: firstGroup, ap: floorPlan, jU: lastGroup, km: organisationUnitId, fV: parentId, k8: title};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$Command$CreatePayload = F9(
	function (commandId, commandTimestamp, organisationUnitId, title, description, floorPlan, firstGroup, lastGroup, color) {
		return {K: color, L: commandId, M: commandTimestamp, aY: description, ao: firstGroup, ap: floorPlan, jU: lastGroup, km: organisationUnitId, k8: title};
	});
var $author$project$OrganisationUnit$Command$Delete = function (a) {
	return {$: 11, a: a};
};
var $author$project$OrganisationUnit$Command$DeletePayload = F4(
	function (commandId, commandTimestamp, organisationUnitId, titleForError) {
		return {L: commandId, M: commandTimestamp, km: organisationUnitId, l: titleForError};
	});
var $author$project$OrganisationUnit$Command$Move = function (a) {
	return {$: 4, a: a};
};
var $author$project$OrganisationUnit$Command$MoveAfter = function (a) {
	return {$: 6, a: a};
};
var $author$project$OrganisationUnit$Command$MoveAfterPayload = F6(
	function (commandId, commandTimestamp, organisationUnitId, parentId, previousId, titleForError) {
		return {L: commandId, M: commandTimestamp, km: organisationUnitId, fV: parentId, ay: previousId, l: titleForError};
	});
var $author$project$OrganisationUnit$Command$MoveBefore = function (a) {
	return {$: 5, a: a};
};
var $author$project$OrganisationUnit$Command$MoveBeforePayload = F6(
	function (commandId, commandTimestamp, organisationUnitId, parentId, nextId, titleForError) {
		return {L: commandId, M: commandTimestamp, ax: nextId, km: organisationUnitId, fV: parentId, l: titleForError};
	});
var $author$project$OrganisationUnit$Command$MovePayload = F5(
	function (commandId, commandTimestamp, organisationUnitId, parentId, titleForError) {
		return {L: commandId, M: commandTimestamp, km: organisationUnitId, fV: parentId, l: titleForError};
	});
var $author$project$OrganisationUnit$Command$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (commandType) {
		switch (commandType) {
			case 'de.awenko.organisation-unit.create.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'color', $author$project$UI$Style$Color$decode),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$Create),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'lastGroup',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'firstGroup',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'floorPlan',
								$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'title',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'organisationUnitId',
											$author$project$OrganisationUnit$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'commandTimestamp',
												$author$project$Utils$Decode$timestamp,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandId',
													$author$project$Types$CommandId$decode,
													$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$CreatePayload))))))))));
			case 'de.awenko.organisation-unit.create-child.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'color', $author$project$UI$Style$Color$decode),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$CreateChild),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'lastGroup',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'firstGroup',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'floorPlan',
								$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'title',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'parentId',
											$author$project$OrganisationUnit$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'organisationUnitId',
												$author$project$OrganisationUnit$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandTimestamp',
													$author$project$Utils$Decode$timestamp,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandId',
														$author$project$Types$CommandId$decode,
														$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$CreateChildPayload)))))))))));
			case 'de.awenko.organisation-unit.create-before.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'color', $author$project$UI$Style$Color$decode),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$CreateBefore),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'lastGroup',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'firstGroup',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'floorPlan',
								$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'title',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'nextId',
											$author$project$OrganisationUnit$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'organisationUnitId',
												$author$project$OrganisationUnit$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandTimestamp',
													$author$project$Utils$Decode$timestamp,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandId',
														$author$project$Types$CommandId$decode,
														$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$CreateBeforePayload)))))))))));
			case 'de.awenko.organisation-unit.create-after.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'color', $author$project$UI$Style$Color$decode),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$CreateAfter),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'lastGroup',
						$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'firstGroup',
							$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'floorPlan',
								$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'title',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'previousId',
											$author$project$OrganisationUnit$Id$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'organisationUnitId',
												$author$project$OrganisationUnit$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandTimestamp',
													$author$project$Utils$Decode$timestamp,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandId',
														$author$project$Types$CommandId$decode,
														$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$CreateAfterPayload)))))))))));
			case 'de.awenko.organisation-unit.move.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$Move),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'parentId',
						$author$project$OrganisationUnit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'organisationUnitId',
							$author$project$OrganisationUnit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$MovePayload))))));
			case 'de.awenko.organisation-unit.move-before.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$MoveBefore),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'nextId',
						$author$project$OrganisationUnit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'parentId',
							$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'organisationUnitId',
								$author$project$OrganisationUnit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$MoveBeforePayload)))))));
			case 'de.awenko.organisation-unit.move-after.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$MoveAfter),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'previousId',
						$author$project$OrganisationUnit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'parentId',
							$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'organisationUnitId',
								$author$project$OrganisationUnit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$MoveAfterPayload)))))));
			case 'de.awenko.organisation-unit.change-title.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$ChangeTitle),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'organisationUnitId',
							$author$project$OrganisationUnit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$ChangeTitlePayload))))));
			case 'de.awenko.organisation-unit.change-description.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$ChangeDescription),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'organisationUnitId',
							$author$project$OrganisationUnit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$ChangeDescriptionPayload))))));
			case 'de.awenko.organisation-unit.change-color.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$ChangeColor),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'color',
						$author$project$UI$Style$Color$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'organisationUnitId',
							$author$project$OrganisationUnit$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$ChangeColorPayload))))));
			case 'de.awenko.organisation-unit.change-floorPlan.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$ChangeFloorPlan),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'oldFloorPlan',
						$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'newFloorPlan',
							$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'organisationUnitId',
								$author$project$OrganisationUnit$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$ChangeFloorPlanPayload)))))));
			case 'de.awenko.organisation-unit.delete.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$OrganisationUnit$Command$Delete),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnitId',
						$author$project$OrganisationUnit$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Command$DeletePayload)))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'commandType', $elm$json$Json$Decode$string));
var $author$project$OrganisationUnit$Commands$decode = $author$project$Types$Queue$decode($author$project$OrganisationUnit$Command$decode);
var $author$project$OrganisationUnit$Events$decode = $author$project$Types$Queue$decode($author$project$OrganisationUnit$Event$decode);
var $author$project$OrganisationUnit$OrganisationUnits$Data = F3(
	function (hierarchy, lastEventId, rootList) {
		return {a8: hierarchy, fD: lastEventId, f2: rootList};
	});
var $author$project$OrganisationUnit$OrganisationUnits$OrganisationUnits = $elm$core$Basics$identity;
var $author$project$OrganisationUnit$Hierarchy$Data = F4(
	function (organisationUnits, deletedOrganisationUnits, firstId, lastId) {
		return {dB: deletedOrganisationUnits, eC: firstId, eI: lastId, kn: organisationUnits};
	});
var $author$project$OrganisationUnit$Hierarchy$Hierarchy = $elm$core$Basics$identity;
var $author$project$OrganisationUnit$OrganisationUnit$OrganisationUnit = function (organisationUnitId) {
	return function (parentId) {
		return function (previousId) {
			return function (nextId) {
				return function (firstChildId) {
					return function (lastChildId) {
						return function (title) {
							return function (description) {
								return function (floorPlan) {
									return function (firstGroup) {
										return function (lastGroup) {
											return function (color) {
												return function (revision) {
													return {K: color, aY: description, hV: firstChildId, ao: firstGroup, ap: floorPlan, fC: lastChildId, jU: lastGroup, ax: nextId, km: organisationUnitId, fV: parentId, ay: previousId, i: revision, k8: title};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$OrganisationUnit$OrganisationUnit$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revision',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'color',
		$author$project$UI$Style$Color$decode,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'lastGroup',
			$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'firstGroup',
				$elm$json$Json$Decode$maybe($author$project$CheckpointData$CheckpointGroup$Id$decode),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'floorPlan',
					$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'lastChildId',
								$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'firstChildId',
									$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'nextId',
										$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'previousId',
											$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'parentId',
												$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'organisationUnitId',
													$author$project$OrganisationUnit$Id$decode,
													$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$OrganisationUnit$OrganisationUnit))))))))))))));
var $author$project$OrganisationUnit$Dict$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2(
			$author$project$Utils$Tuple$with,
			function ($) {
				return $.km;
			},
			$elm$core$Basics$identity)),
	$turboMaCk$any_dict$Dict$Any$fromList($author$project$OrganisationUnit$Id$toString));
var $author$project$OrganisationUnit$Dict$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$OrganisationUnit$Dict$fromList,
	$elm$json$Json$Decode$list($author$project$OrganisationUnit$OrganisationUnit$decode));
var $author$project$OrganisationUnit$Dict$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$OrganisationUnit$Id$toString);
var $author$project$OrganisationUnit$Hierarchy$decode = A3(
	$elm$core$Basics$composeR,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lastId',
		$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
		$elm$core$Maybe$Nothing),
	$elm$json$Json$Decode$map($elm$core$Basics$identity),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'firstId',
		$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'deletedOrganisationUnits',
			$author$project$OrganisationUnit$Dict$decode,
			$author$project$OrganisationUnit$Dict$empty,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'organisationUnits',
				$author$project$OrganisationUnit$Dict$decode,
				$author$project$OrganisationUnit$Dict$empty,
				$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Hierarchy$Data)))));
var $author$project$OrganisationUnit$Hierarchy$empty = {dB: $author$project$OrganisationUnit$Dict$empty, eC: $elm$core$Maybe$Nothing, eI: $elm$core$Maybe$Nothing, kn: $author$project$OrganisationUnit$Dict$empty};
var $author$project$OrganisationUnit$OrganisationUnits$decode = A3(
	$elm$core$Basics$composeR,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'rootList',
		$elm$json$Json$Decode$list($author$project$OrganisationUnit$Id$decode),
		_List_Nil),
	$elm$json$Json$Decode$map($elm$core$Basics$identity),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lastEventId',
		$elm$json$Json$Decode$maybe($author$project$Types$EventId$decode),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'hierarchy',
			$author$project$OrganisationUnit$Hierarchy$decode,
			$author$project$OrganisationUnit$Hierarchy$empty,
			$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$OrganisationUnits$Data))));
var $author$project$OrganisationUnit$Commands$empty = $author$project$Types$Queue$empty;
var $author$project$OrganisationUnit$Events$empty = $author$project$Types$Queue$empty;
var $author$project$OrganisationUnit$OrganisationUnits$empty = {a8: $author$project$OrganisationUnit$Hierarchy$empty, fD: $elm$core$Maybe$Nothing, f2: _List_Nil};
var $author$project$OrganisationUnit$Store$decodeData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'commands',
	$author$project$OrganisationUnit$Commands$decode,
	$author$project$OrganisationUnit$Commands$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'events',
		$author$project$OrganisationUnit$Events$decode,
		$author$project$OrganisationUnit$Events$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'organisationUnits',
			$author$project$OrganisationUnit$OrganisationUnits$decode,
			$author$project$OrganisationUnit$OrganisationUnits$empty,
			$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Store$Data))));
var $author$project$OrganisationUnit$Store$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOADED_DATA':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$OrganisationUnit$Store$LoadedData,
					A2($elm$json$Json$Decode$field, 'data', $author$project$OrganisationUnit$Store$decodeData));
			case 'SAVED_ORGANISATION_UNITS':
				return $elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Store$SavedOrganisationUnits);
			case 'SAVED_MODIFICATIONS':
				return $elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Store$SavedModifications);
			case 'SAVED_COMMANDS_AND_EVENTS':
				return $elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Store$SavedCommandsAndEvents);
			case 'REMOVED_COMMAND':
				return $elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Store$RemovedCommand);
			case 'REMOVED_COMMAND_AND_EVENT':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventVersion',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'commandId',
						$author$project$Types$CommandId$decode,
						$elm$json$Json$Decode$succeed($author$project$OrganisationUnit$Store$RemovedCommandAndEvent)));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$OrganisationUnit$Store$ReceivedErrorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$OrganisationUnit$Store$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$OrganisationUnit$Store$ReceivedErrorMsg(error);
	}
};
var $author$project$OrganisationUnit$Store$organisationUnitStoreInbox = _Platform_incomingPort('organisationUnitStoreInbox', $elm$json$Json$Decode$value);
var $author$project$OrganisationUnit$Store$subscriptions = $author$project$OrganisationUnit$Store$organisationUnitStoreInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$OrganisationUnit$Store$decodeMsg),
		$author$project$OrganisationUnit$Store$handleDecodeResult));
var $author$project$Plan$Store$LoadedData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Store$RemovedCommand = {$: 4};
var $author$project$Plan$Store$RemovedCommandAndEvent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Plan$Store$SavedCommandsAndEvents = {$: 3};
var $author$project$Plan$Store$SavedModifications = {$: 2};
var $author$project$Plan$Store$SavedPlans = {$: 1};
var $author$project$Plan$Store$Data = F3(
	function (plans, events, commands) {
		return {cD: commands, b8: events, aL: plans};
	});
var $author$project$Plan$Command$AddExecution = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$Command$AddExecutionPayload = F5(
	function (commandId, commandTimestamp, planId, execution, titleForError) {
		return {L: commandId, M: commandTimestamp, jw: execution, d5: planId, l: titleForError};
	});
var $author$project$Plan$Command$ChangeAuditors = function (a) {
	return {$: 6, a: a};
};
var $author$project$Plan$Command$ChangeAuditorsPayload = F6(
	function (commandId, commandTimestamp, planId, addAuditors, removeAuditors, titleForError) {
		return {ge: addAuditors, L: commandId, M: commandTimestamp, d5: planId, g9: removeAuditors, l: titleForError};
	});
var $author$project$Plan$Command$ChangeCheckpointGroups = function (a) {
	return {$: 7, a: a};
};
var $author$project$Plan$Command$ChangeCheckpointGroupsPayload = F6(
	function (commandId, commandTimestamp, planId, addCheckpointGroups, removeCheckpointGroups, titleForError) {
		return {e7: addCheckpointGroups, L: commandId, M: commandTimestamp, d5: planId, fY: removeCheckpointGroups, l: titleForError};
	});
var $author$project$Plan$Command$ChangeDescription = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$Command$ChangeDescriptionPayload = F5(
	function (commandId, commandTimestamp, planId, description, titleForError) {
		return {L: commandId, M: commandTimestamp, aY: description, d5: planId, l: titleForError};
	});
var $author$project$Plan$Command$ChangeExecution = function (a) {
	return {$: 4, a: a};
};
var $author$project$Plan$Command$ChangeExecutionPayload = F5(
	function (commandId, commandTimestamp, planId, execution, titleForError) {
		return {L: commandId, M: commandTimestamp, jw: execution, d5: planId, l: titleForError};
	});
var $author$project$Plan$Command$ChangeTitle = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Command$ChangeTitlePayload = F5(
	function (commandId, commandTimestamp, planId, title, titleForError) {
		return {L: commandId, M: commandTimestamp, d5: planId, k8: title, l: titleForError};
	});
var $author$project$Plan$Command$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Command$CreatePayload = F8(
	function (commandId, commandTimestamp, planId, title, description, executions, checkpointGroups, auditors) {
		return {bT: auditors, gt: checkpointGroups, L: commandId, M: commandTimestamp, aY: description, fr: executions, d5: planId, k8: title};
	});
var $author$project$Plan$Command$Delete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Plan$Command$DeletePayload = F4(
	function (commandId, commandTimestamp, planId, titleForError) {
		return {L: commandId, M: commandTimestamp, d5: planId, l: titleForError};
	});
var $author$project$Plan$Command$ExecutePlan = function (a) {
	return {$: 9, a: a};
};
var $author$project$Plan$Command$ExecutePlanPayload = F4(
	function (commandId, commandTimestamp, planId, titleForError) {
		return {L: commandId, M: commandTimestamp, d5: planId, l: titleForError};
	});
var $author$project$Plan$Command$RemoveExecution = function (a) {
	return {$: 5, a: a};
};
var $author$project$Plan$Command$RemoveExecutionPayload = F5(
	function (commandId, commandTimestamp, planId, executionId, titleForError) {
		return {L: commandId, M: commandTimestamp, dH: executionId, d5: planId, l: titleForError};
	});
var $author$project$Plan$Command$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (commandType) {
		switch (commandType) {
			case 'de.awenko.plan.create.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'auditors', $author$project$User$Ids$decode, $author$project$User$Ids$empty),
					$elm$json$Json$Decode$map($author$project$Plan$Command$Create),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'checkpointGroups',
						$author$project$CheckpointData$CheckpointGroup$Ids$decode,
						$author$project$CheckpointData$CheckpointGroup$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'executions',
							$elm$json$Json$Decode$list($author$project$Plan$Execution$Execution$decode),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'description',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'title',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'planId',
										$author$project$Plan$Id$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'commandTimestamp',
											$author$project$Utils$Decode$timestamp,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'commandId',
												$author$project$Types$CommandId$decode,
												$elm$json$Json$Decode$succeed($author$project$Plan$Command$CreatePayload)))))))));
			case 'de.awenko.plan.change-title.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Plan$Command$ChangeTitle),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Plan$Command$ChangeTitlePayload))))));
			case 'de.awenko.plan.change-description.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Plan$Command$ChangeDescription),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Plan$Command$ChangeDescriptionPayload))))));
			case 'de.awenko.plan.add-execution.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Plan$Command$AddExecution),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'execution',
						$author$project$Plan$Execution$Execution$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Plan$Command$AddExecutionPayload))))));
			case 'de.awenko.plan.change-execution.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Plan$Command$ChangeExecution),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'execution',
						$author$project$Plan$Execution$Execution$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Plan$Command$ChangeExecutionPayload))))));
			case 'de.awenko.plan.remove-execution.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Plan$Command$RemoveExecution),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'executionId',
						$author$project$Plan$Execution$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Plan$Command$RemoveExecutionPayload))))));
			case 'de.awenko.plan.change-auditors.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Plan$Command$ChangeAuditors),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'removeAuditors',
						$author$project$User$Ids$decode,
						$author$project$User$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'addAuditors',
							$author$project$User$Ids$decode,
							$author$project$User$Ids$empty,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'planId',
								$author$project$Plan$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Plan$Command$ChangeAuditorsPayload)))))));
			case 'de.awenko.plan.change-checkpoint-groups.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Plan$Command$ChangeCheckpointGroups),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'removeCheckpointGroups',
						$author$project$CheckpointData$CheckpointGroup$Ids$decode,
						$author$project$CheckpointData$CheckpointGroup$Ids$empty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'addCheckpointGroups',
							$author$project$CheckpointData$CheckpointGroup$Ids$decode,
							$author$project$CheckpointData$CheckpointGroup$Ids$empty,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'planId',
								$author$project$Plan$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Plan$Command$ChangeCheckpointGroupsPayload)))))));
			case 'de.awenko.plan.delete.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Plan$Command$Delete),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'planId',
						$author$project$Plan$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Plan$Command$DeletePayload)))));
			case 'de.awenko.plan.execute-manuel.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Plan$Command$ExecutePlan),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'planId',
						$author$project$Plan$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Plan$Command$ExecutePlanPayload)))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'commandType', $elm$json$Json$Decode$string));
var $author$project$Plan$Commands$decode = $author$project$Types$Queue$decode($author$project$Plan$Command$decode);
var $author$project$Plan$Events$decode = $author$project$Types$Queue$decode($author$project$Plan$Event$decode);
var $author$project$Plan$Plans$Data = F2(
	function (dict, lastEventId) {
		return {cL: dict, fD: lastEventId};
	});
var $author$project$Plan$Plans$Plans = $elm$core$Basics$identity;
var $author$project$Plan$Plan$Plan = F7(
	function (planId, title, description, executions, checkpointGroups, auditors, revision) {
		return {bT: auditors, gt: checkpointGroups, aY: description, fr: executions, d5: planId, i: revision, k8: title};
	});
var $author$project$Plan$Plan$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revision',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'auditors',
		$author$project$User$Ids$decode,
		$author$project$User$Ids$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'checkpointGroups',
			$author$project$CheckpointData$CheckpointGroup$Ids$decode,
			$author$project$CheckpointData$CheckpointGroup$Ids$empty,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'executions',
				$elm$json$Json$Decode$list($author$project$Plan$Execution$Execution$decode),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'description',
					$elm$json$Json$Decode$string,
					'',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'planId',
							$author$project$Plan$Id$decode,
							$elm$json$Json$Decode$succeed($author$project$Plan$Plan$Plan))))))));
var $author$project$Plan$Dict$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2(
			$author$project$Utils$Tuple$with,
			function ($) {
				return $.d5;
			},
			$elm$core$Basics$identity)),
	$turboMaCk$any_dict$Dict$Any$fromList($author$project$Plan$Id$toString));
var $author$project$Plan$Dict$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$Plan$Dict$fromList,
	$elm$json$Json$Decode$list($author$project$Plan$Plan$decode));
var $author$project$Plan$Dict$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$Plan$Id$toString);
var $author$project$Plan$Plans$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lastEventId',
		$elm$json$Json$Decode$maybe($author$project$Types$EventId$decode),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'plans',
			$author$project$Plan$Dict$decode,
			$author$project$Plan$Dict$empty,
			$elm$json$Json$Decode$succeed($author$project$Plan$Plans$Data))));
var $author$project$Plan$Commands$empty = $author$project$Types$Queue$empty;
var $author$project$Plan$Events$empty = $author$project$Types$Queue$empty;
var $author$project$Plan$Plans$empty = {cL: $author$project$Plan$Dict$empty, fD: $elm$core$Maybe$Nothing};
var $author$project$Plan$Store$decodeData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'commands',
	$author$project$Plan$Commands$decode,
	$author$project$Plan$Commands$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'events',
		$author$project$Plan$Events$decode,
		$author$project$Plan$Events$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'plans',
			$author$project$Plan$Plans$decode,
			$author$project$Plan$Plans$empty,
			$elm$json$Json$Decode$succeed($author$project$Plan$Store$Data))));
var $author$project$Plan$Store$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOADED_DATA':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Plan$Store$LoadedData,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Plan$Store$decodeData));
			case 'SAVED_PLANS':
				return $elm$json$Json$Decode$succeed($author$project$Plan$Store$SavedPlans);
			case 'SAVED_MODIFICATIONS':
				return $elm$json$Json$Decode$succeed($author$project$Plan$Store$SavedModifications);
			case 'SAVED_COMMANDS_AND_EVENTS':
				return $elm$json$Json$Decode$succeed($author$project$Plan$Store$SavedCommandsAndEvents);
			case 'REMOVED_COMMAND':
				return $elm$json$Json$Decode$succeed($author$project$Plan$Store$RemovedCommand);
			case 'REMOVED_COMMAND_AND_EVENT':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventVersion',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'planId',
						$author$project$Plan$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandId',
							$author$project$Types$CommandId$decode,
							$elm$json$Json$Decode$succeed($author$project$Plan$Store$RemovedCommandAndEvent))));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Plan$Store$ReceivedErrorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Plan$Store$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$Plan$Store$ReceivedErrorMsg(error);
	}
};
var $author$project$Plan$Store$planStoreInbox = _Platform_incomingPort('planStoreInbox', $elm$json$Json$Decode$value);
var $author$project$Plan$Store$subscriptions = $author$project$Plan$Store$planStoreInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Plan$Store$decodeMsg),
		$author$project$Plan$Store$handleDecodeResult));
var $author$project$Rights$Store$LoadedData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Rights$Store$RemovedCommand = {$: 4};
var $author$project$Rights$Store$RemovedCommandAndEvent = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Rights$Store$SavedCommandsAndEvents = {$: 3};
var $author$project$Rights$Store$SavedModifications = {$: 2};
var $author$project$Rights$Store$SavedRightsData = {$: 1};
var $author$project$Rights$Store$Data = F3(
	function (rights, events, commands) {
		return {cD: commands, b8: events, kF: rights};
	});
var $author$project$Rights$Command$AddOrganisationUnits = function (a) {
	return {$: 9, a: a};
};
var $author$project$Rights$Command$AddOrganisationUnitsPayload = F5(
	function (commandId, commandTimestamp, teamId, organisationUnits, titleForError) {
		return {L: commandId, M: commandTimestamp, kn: organisationUnits, k1: teamId, l: titleForError};
	});
var $author$project$Rights$Command$AddRights = function (a) {
	return {$: 3, a: a};
};
var $author$project$Rights$Command$AddRightsPayload = F5(
	function (commandId, commandTimestamp, roleId, rights, titleForError) {
		return {L: commandId, M: commandTimestamp, kF: rights, hc: roleId, l: titleForError};
	});
var $author$project$Rights$Command$ChangeRoleDescription = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Command$ChangeRoleDescriptionPayload = F5(
	function (commandId, commandTimestamp, roleId, description, titleForError) {
		return {L: commandId, M: commandTimestamp, aY: description, hc: roleId, l: titleForError};
	});
var $author$project$Rights$Command$ChangeRoleTitle = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Command$ChangeRoleTitlePayload = F5(
	function (commandId, commandTimestamp, roleId, title, titleForError) {
		return {L: commandId, M: commandTimestamp, hc: roleId, k8: title, l: titleForError};
	});
var $author$project$Rights$Command$ChangeTeamDescription = function (a) {
	return {$: 8, a: a};
};
var $author$project$Rights$Command$ChangeTeamDescriptionPayload = F5(
	function (commandId, commandTimestamp, teamId, description, titleForError) {
		return {L: commandId, M: commandTimestamp, aY: description, k1: teamId, l: titleForError};
	});
var $author$project$Rights$Command$ChangeTeamTitle = function (a) {
	return {$: 7, a: a};
};
var $author$project$Rights$Command$ChangeTeamTitlePayload = F5(
	function (commandId, commandTimestamp, teamId, title, titleForError) {
		return {L: commandId, M: commandTimestamp, k1: teamId, k8: title, l: titleForError};
	});
var $author$project$Rights$Command$CreateRole = function (a) {
	return {$: 0, a: a};
};
var $author$project$Rights$Command$CreateRolePayload = F6(
	function (commandId, commandTimestamp, roleId, title, description, rights) {
		return {L: commandId, M: commandTimestamp, aY: description, kF: rights, hc: roleId, k8: title};
	});
var $author$project$Rights$Command$CreateTeam = function (a) {
	return {$: 6, a: a};
};
var $author$project$Rights$Command$CreateTeamPayload = F6(
	function (commandId, commandTimestamp, teamId, title, description, organisationUnits) {
		return {L: commandId, M: commandTimestamp, aY: description, kn: organisationUnits, k1: teamId, k8: title};
	});
var $author$project$Rights$Command$DeleteRole = function (a) {
	return {$: 5, a: a};
};
var $author$project$Rights$Command$DeleteRolePayload = F4(
	function (commandId, commandTimestamp, roleId, titleForError) {
		return {L: commandId, M: commandTimestamp, hc: roleId, l: titleForError};
	});
var $author$project$Rights$Command$DeleteTeam = function (a) {
	return {$: 11, a: a};
};
var $author$project$Rights$Command$DeleteTeamPayload = F4(
	function (commandId, commandTimestamp, teamId, titleForError) {
		return {L: commandId, M: commandTimestamp, k1: teamId, l: titleForError};
	});
var $author$project$Rights$Command$RemoveOrganisationUnits = function (a) {
	return {$: 10, a: a};
};
var $author$project$Rights$Command$RemoveOrganisationUnitsPayload = F5(
	function (commandId, commandTimestamp, teamId, organisationUnits, titleForError) {
		return {L: commandId, M: commandTimestamp, kn: organisationUnits, k1: teamId, l: titleForError};
	});
var $author$project$Rights$Command$RemoveRights = function (a) {
	return {$: 4, a: a};
};
var $author$project$Rights$Command$RemoveRightsPayload = F5(
	function (commandId, commandTimestamp, roleId, rights, titleForError) {
		return {L: commandId, M: commandTimestamp, kF: rights, hc: roleId, l: titleForError};
	});
var $author$project$Rights$Command$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (commandType) {
		switch (commandType) {
			case 'de.awenko.rights.create-role.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'rights',
						$elm$json$Json$Decode$list($author$project$Rights$Right$decode),
						_List_Nil),
					$elm$json$Json$Decode$map($author$project$Rights$Command$CreateRole),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'roleId',
								$author$project$Rights$Role$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Rights$Command$CreateRolePayload)))))));
			case 'de.awenko.rights.change-role-title.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Rights$Command$ChangeRoleTitle),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'roleId',
							$author$project$Rights$Role$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Rights$Command$ChangeRoleTitlePayload))))));
			case 'de.awenko.rights.change-role-description.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Rights$Command$ChangeRoleDescription),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'roleId',
							$author$project$Rights$Role$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Rights$Command$ChangeRoleDescriptionPayload))))));
			case 'de.awenko.rights.add-rights.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Rights$Command$AddRights),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rights',
						$elm$json$Json$Decode$list($author$project$Rights$Right$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'roleId',
							$author$project$Rights$Role$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Rights$Command$AddRightsPayload))))));
			case 'de.awenko.rights.remove-rights.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Rights$Command$RemoveRights),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rights',
						$elm$json$Json$Decode$list($author$project$Rights$Right$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'roleId',
							$author$project$Rights$Role$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Rights$Command$RemoveRightsPayload))))));
			case 'de.awenko.rights.delete-role.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Rights$Command$DeleteRole),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'roleId',
						$author$project$Rights$Role$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Rights$Command$DeleteRolePayload)))));
			case 'de.awenko.rights.create-team.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'organisationUnits', $author$project$OrganisationUnit$Ids$decode, $author$project$OrganisationUnit$Ids$empty),
					$elm$json$Json$Decode$map($author$project$Rights$Command$CreateTeam),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'teamId',
								$author$project$Rights$Team$Id$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandTimestamp',
									$author$project$Utils$Decode$timestamp,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'commandId',
										$author$project$Types$CommandId$decode,
										$elm$json$Json$Decode$succeed($author$project$Rights$Command$CreateTeamPayload)))))));
			case 'de.awenko.rights.change-team-title.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Rights$Command$ChangeTeamTitle),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'teamId',
							$author$project$Rights$Team$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Rights$Command$ChangeTeamTitlePayload))))));
			case 'de.awenko.rights.change-team-description.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Rights$Command$ChangeTeamDescription),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'teamId',
							$author$project$Rights$Team$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Rights$Command$ChangeTeamDescriptionPayload))))));
			case 'de.awenko.rights.add-organisation-units.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Rights$Command$AddOrganisationUnits),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'teamId',
							$author$project$Rights$Team$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Rights$Command$AddOrganisationUnitsPayload))))));
			case 'de.awenko.rights.remove-organisation-units.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Rights$Command$RemoveOrganisationUnits),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationUnits',
						$author$project$OrganisationUnit$Ids$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'teamId',
							$author$project$Rights$Team$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$Rights$Command$RemoveOrganisationUnitsPayload))))));
			case 'de.awenko.rights.delete-team.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'titleForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$Rights$Command$DeleteTeam),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'teamId',
						$author$project$Rights$Team$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Rights$Command$DeleteTeamPayload)))));
			default:
				return $elm$json$Json$Decode$fail('unknown rights command');
		}
	},
	A2($elm$json$Json$Decode$field, 'commandType', $elm$json$Json$Decode$string));
var $author$project$Rights$Commands$decode = $author$project$Types$Queue$decode($author$project$Rights$Command$decode);
var $author$project$Rights$Events$decode = $author$project$Types$Queue$decode($author$project$Rights$Event$decode);
var $author$project$Rights$Rights$Data = F3(
	function (roles, teams, lastEventId) {
		return {fD: lastEventId, db: roles, dg: teams};
	});
var $author$project$Rights$Rights$Rights = $elm$core$Basics$identity;
var $author$project$Rights$Role$Role$Role = F5(
	function (roleId, title, description, rights, revision) {
		return {aY: description, i: revision, kF: rights, hc: roleId, k8: title};
	});
var $author$project$Rights$Role$Role$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revision',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'rights',
		$elm$json$Json$Decode$list($author$project$Rights$Right$decode),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'description',
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'roleId',
					$author$project$Rights$Role$Id$decode,
					$elm$json$Json$Decode$succeed($author$project$Rights$Role$Role$Role))))));
var $author$project$Rights$Role$Dict$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2(
			$author$project$Utils$Tuple$with,
			function ($) {
				return $.hc;
			},
			$elm$core$Basics$identity)),
	$turboMaCk$any_dict$Dict$Any$fromList($author$project$Rights$Role$Id$toString));
var $author$project$Rights$Role$Dict$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$Rights$Role$Dict$fromList,
	$elm$json$Json$Decode$list($author$project$Rights$Role$Role$decode));
var $author$project$Rights$Team$Team$Team = F5(
	function (teamId, title, description, organisationUnits, revision) {
		return {aY: description, kn: organisationUnits, i: revision, k1: teamId, k8: title};
	});
var $author$project$Rights$Team$Team$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revision',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'organisationUnits',
		$author$project$OrganisationUnit$Ids$decode,
		$author$project$OrganisationUnit$Ids$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'description',
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'teamId',
					$author$project$Rights$Team$Id$decode,
					$elm$json$Json$Decode$succeed($author$project$Rights$Team$Team$Team))))));
var $author$project$Rights$Team$Dict$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2(
			$author$project$Utils$Tuple$with,
			function ($) {
				return $.k1;
			},
			$elm$core$Basics$identity)),
	$turboMaCk$any_dict$Dict$Any$fromList($author$project$Rights$Team$Id$toString));
var $author$project$Rights$Team$Dict$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$Rights$Team$Dict$fromList,
	$elm$json$Json$Decode$list($author$project$Rights$Team$Team$decode));
var $author$project$Rights$Role$Dict$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$Rights$Role$Id$toString);
var $author$project$Rights$Team$Dict$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$Rights$Team$Id$toString);
var $author$project$Rights$Rights$decode = A3(
	$elm$core$Basics$composeR,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lastEventId',
		$elm$json$Json$Decode$maybe($author$project$Types$EventId$decode),
		$elm$core$Maybe$Nothing),
	$elm$json$Json$Decode$map($elm$core$Basics$identity),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'teams',
		$author$project$Rights$Team$Dict$decode,
		$author$project$Rights$Team$Dict$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'roles',
			$author$project$Rights$Role$Dict$decode,
			$author$project$Rights$Role$Dict$empty,
			$elm$json$Json$Decode$succeed($author$project$Rights$Rights$Data))));
var $author$project$Rights$Commands$empty = $author$project$Types$Queue$empty;
var $author$project$Rights$Events$empty = $author$project$Types$Queue$empty;
var $author$project$Rights$Rights$empty = {fD: $elm$core$Maybe$Nothing, db: $author$project$Rights$Role$Dict$empty, dg: $author$project$Rights$Team$Dict$empty};
var $author$project$Rights$Store$decodeData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'commands',
	$author$project$Rights$Commands$decode,
	$author$project$Rights$Commands$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'events',
		$author$project$Rights$Events$decode,
		$author$project$Rights$Events$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'rights',
			$author$project$Rights$Rights$decode,
			$author$project$Rights$Rights$empty,
			$elm$json$Json$Decode$succeed($author$project$Rights$Store$Data))));
var $author$project$Rights$Store$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOADED_DATA':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Rights$Store$LoadedData,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Rights$Store$decodeData));
			case 'SAVED_RIGHTS':
				return $elm$json$Json$Decode$succeed($author$project$Rights$Store$SavedRightsData);
			case 'SAVED_MODIFICATIONS':
				return $elm$json$Json$Decode$succeed($author$project$Rights$Store$SavedModifications);
			case 'SAVED_COMMANDS_AND_EVENTS':
				return $elm$json$Json$Decode$succeed($author$project$Rights$Store$SavedCommandsAndEvents);
			case 'REMOVED_COMMAND':
				return $elm$json$Json$Decode$succeed($author$project$Rights$Store$RemovedCommand);
			case 'REMOVED_COMMAND_AND_EVENT':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventVersion',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'commandId',
						$author$project$Types$CommandId$decode,
						$elm$json$Json$Decode$succeed($author$project$Rights$Store$RemovedCommandAndEvent)));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Rights$Store$ReceivedErrorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Rights$Store$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$Rights$Store$ReceivedErrorMsg(error);
	}
};
var $author$project$Rights$Store$rightsStoreInbox = _Platform_incomingPort('rightsStoreInbox', $elm$json$Json$Decode$value);
var $author$project$Rights$Store$subscriptions = $author$project$Rights$Store$rightsStoreInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Rights$Store$decodeMsg),
		$author$project$Rights$Store$handleDecodeResult));
var $author$project$Tenant$Store$LoadedData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Tenant$Store$RemovedCommand = {$: 4};
var $author$project$Tenant$Store$RemovedCommandAndEvent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Tenant$Store$SavedCommandsAndEvents = {$: 3};
var $author$project$Tenant$Store$SavedModifications = {$: 2};
var $author$project$Tenant$Store$SavedTenant = {$: 1};
var $author$project$Tenant$Store$Data = F3(
	function (tenant, events, commands) {
		return {cD: commands, b8: events, iC: tenant};
	});
var $author$project$Tenant$Command$ChangeCountry = function (a) {
	return {$: 4, a: a};
};
var $author$project$Tenant$Command$ChangeCountryPayload = F4(
	function (commandId, commandTimestamp, tenantId, country) {
		return {L: commandId, M: commandTimestamp, gw: country, k5: tenantId};
	});
var $author$project$Tenant$Command$ChangeHouseNumber = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tenant$Command$ChangeHouseNumberPayload = F4(
	function (commandId, commandTimestamp, tenantId, houseNumber) {
		return {L: commandId, M: commandTimestamp, gP: houseNumber, k5: tenantId};
	});
var $author$project$Tenant$Command$ChangeLocation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Tenant$Command$ChangeLocationPayload = F4(
	function (commandId, commandTimestamp, tenantId, location) {
		return {L: commandId, M: commandTimestamp, gV: location, k5: tenantId};
	});
var $author$project$Tenant$Command$ChangeLogo = function (a) {
	return {$: 7, a: a};
};
var $author$project$Tenant$Command$ChangeLogoPayload = F4(
	function (commandId, commandTimestamp, tenantId, logo) {
		return {L: commandId, M: commandTimestamp, jX: logo, k5: tenantId};
	});
var $author$project$Tenant$Command$ChangePhoneNumber = function (a) {
	return {$: 5, a: a};
};
var $author$project$Tenant$Command$ChangePhoneNumberPayload = F4(
	function (commandId, commandTimestamp, tenantId, phoneNumber) {
		return {L: commandId, M: commandTimestamp, g7: phoneNumber, k5: tenantId};
	});
var $author$project$Tenant$Command$ChangeRoad = function (a) {
	return {$: 0, a: a};
};
var $author$project$Tenant$Command$ChangeRoadPayload = F4(
	function (commandId, commandTimestamp, tenantId, road) {
		return {L: commandId, M: commandTimestamp, hb: road, k5: tenantId};
	});
var $author$project$Tenant$Command$ChangeUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Tenant$Command$ChangeUrlPayload = F4(
	function (commandId, commandTimestamp, tenantId, url) {
		return {L: commandId, M: commandTimestamp, k5: tenantId, lg: url};
	});
var $author$project$Tenant$Command$ChangeZipCode = function (a) {
	return {$: 2, a: a};
};
var $author$project$Tenant$Command$ChangeZipCodePayload = F4(
	function (commandId, commandTimestamp, tenantId, zipCode) {
		return {L: commandId, M: commandTimestamp, k5: tenantId, hr: zipCode};
	});
var $author$project$Tenant$Command$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (commandType) {
		switch (commandType) {
			case 'de.awenko.tenant.change-road.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'road',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$map($author$project$Tenant$Command$ChangeRoad),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Tenant$Command$ChangeRoadPayload)))));
			case 'de.awenko.tenant.change-house-number.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'houseNumber',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$map($author$project$Tenant$Command$ChangeHouseNumber),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Tenant$Command$ChangeHouseNumberPayload)))));
			case 'de.awenko.tenant.change-zip-code.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'zipCode',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$map($author$project$Tenant$Command$ChangeZipCode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Tenant$Command$ChangeZipCodePayload)))));
			case 'de.awenko.tenant.change-location.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'location',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$map($author$project$Tenant$Command$ChangeLocation),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Tenant$Command$ChangeLocationPayload)))));
			case 'de.awenko.tenant.change-country.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'country',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$map($author$project$Tenant$Command$ChangeCountry),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Tenant$Command$ChangeCountryPayload)))));
			case 'de.awenko.tenant.change-phone-number.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'phoneNumber',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$map($author$project$Tenant$Command$ChangePhoneNumber),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Tenant$Command$ChangePhoneNumberPayload)))));
			case 'de.awenko.tenant.change-url.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'url',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$map($author$project$Tenant$Command$ChangeUrl),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Tenant$Command$ChangeUrlPayload)))));
			case 'de.awenko.tenant.change-logo.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'logo',
						$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
						$elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$map($author$project$Tenant$Command$ChangeLogo),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$Tenant$Command$ChangeLogoPayload)))));
			default:
				return $elm$json$Json$Decode$fail('Unknown command');
		}
	},
	A2($elm$json$Json$Decode$field, 'commandType', $elm$json$Json$Decode$string));
var $author$project$Tenant$Commands$decode = $author$project$Types$Queue$decode($author$project$Tenant$Command$decode);
var $author$project$Tenant$Events$decode = $author$project$Types$Queue$decode($author$project$Tenant$Event$decode);
var $author$project$Tenant$Commands$empty = $author$project$Types$Queue$empty;
var $author$project$Tenant$Events$empty = $author$project$Types$Queue$empty;
var $author$project$Tenant$Store$decodeData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'commands',
	$author$project$Tenant$Commands$decode,
	$author$project$Tenant$Commands$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'events',
		$author$project$Tenant$Events$decode,
		$author$project$Tenant$Events$empty,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tenant',
			$elm$json$Json$Decode$maybe($author$project$Tenant$Tenant$decode),
			$elm$json$Json$Decode$succeed($author$project$Tenant$Store$Data))));
var $author$project$Tenant$Store$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOADED_DATA':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Tenant$Store$LoadedData,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Tenant$Store$decodeData));
			case 'SAVED_TENANT':
				return $elm$json$Json$Decode$succeed($author$project$Tenant$Store$SavedTenant);
			case 'SAVED_MODIFICATIONS':
				return $elm$json$Json$Decode$succeed($author$project$Tenant$Store$SavedModifications);
			case 'SAVED_COMMANDS_AND_EVENTS':
				return $elm$json$Json$Decode$succeed($author$project$Tenant$Store$SavedCommandsAndEvents);
			case 'REMOVED_COMMAND':
				return $elm$json$Json$Decode$succeed($author$project$Tenant$Store$RemovedCommand);
			case 'REMOVED_COMMAND_AND_EVENT':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventVersion',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tenantId',
						$author$project$Tenant$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandId',
							$author$project$Types$CommandId$decode,
							$elm$json$Json$Decode$succeed($author$project$Tenant$Store$RemovedCommandAndEvent))));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Tenant$Store$ReceivedErrorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Tenant$Store$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$Tenant$Store$ReceivedErrorMsg(error);
	}
};
var $author$project$Tenant$Store$tenantStoreInbox = _Platform_incomingPort('tenantStoreInbox', $elm$json$Json$Decode$value);
var $author$project$Tenant$Store$subscriptions = $author$project$Tenant$Store$tenantStoreInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Tenant$Store$decodeMsg),
		$author$project$Tenant$Store$handleDecodeResult));
var $author$project$User$Store$LoadedData = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$Store$RemovedCommand = {$: 4};
var $author$project$User$Store$RemovedCommandAndEvent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$User$Store$SavedCommandsAndEvents = {$: 3};
var $author$project$User$Store$SavedModifications = {$: 2};
var $author$project$User$Store$SavedUsers = {$: 1};
var $author$project$User$Store$Data = F3(
	function (users, events, commands) {
		return {cD: commands, b8: events, lk: users};
	});
var $author$project$User$Command$AddTeamRole = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$Command$AddTeamRolePayload = F5(
	function (commandId, commandTimestamp, userId, teamRole, nameForError) {
		return {L: commandId, M: commandTimestamp, cl: nameForError, bQ: teamRole, dk: userId};
	});
var $author$project$User$Command$ChangeAvatar = function (a) {
	return {$: 7, a: a};
};
var $author$project$User$Command$ChangeAvatarPayload = F5(
	function (commandId, commandTimestamp, userId, avatar, nameForError) {
		return {iX: avatar, L: commandId, M: commandTimestamp, cl: nameForError, dk: userId};
	});
var $author$project$User$Command$ChangeEmailAddress = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$Command$ChangeEmailAddressPayload = F5(
	function (commandId, commandTimestamp, userId, emailAddress, nameForError) {
		return {L: commandId, M: commandTimestamp, ju: emailAddress, cl: nameForError, dk: userId};
	});
var $author$project$User$Command$ChangeEntryOrganisationUnit = function (a) {
	return {$: 8, a: a};
};
var $author$project$User$Command$ChangeEntryOrganisationUnitPayload = F5(
	function (commandId, commandTimestamp, userId, entryOrganisationUnit, nameForError) {
		return {L: commandId, M: commandTimestamp, hT: entryOrganisationUnit, cl: nameForError, dk: userId};
	});
var $author$project$User$Command$ChangePassword = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$Command$ChangePasswordPayload = F5(
	function (commandId, commandTimestamp, userId, password, nameForError) {
		return {L: commandId, M: commandTimestamp, cl: nameForError, a1: password, dk: userId};
	});
var $author$project$User$Command$ChangeTeamRole = function (a) {
	return {$: 5, a: a};
};
var $author$project$User$Command$ChangeTeamRolePayload = F5(
	function (commandId, commandTimestamp, userId, teamRole, nameForError) {
		return {L: commandId, M: commandTimestamp, cl: nameForError, bQ: teamRole, dk: userId};
	});
var $author$project$User$Command$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$Command$CreatePayload = function (commandId) {
	return function (commandTimestamp) {
		return function (userId) {
			return function (username) {
				return function (emailAddress) {
					return function (password) {
						return function (name) {
							return function (teamRoles) {
								return function (entryOrganisationUnit) {
									return function (avatar) {
										return {iX: avatar, L: commandId, M: commandTimestamp, ju: emailAddress, hT: entryOrganisationUnit, g_: name, a1: password, k2: teamRoles, dk: userId, iK: username};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$Command$Delete = function (a) {
	return {$: 9, a: a};
};
var $author$project$User$Command$DeletePayload = F4(
	function (commandId, commandTimestamp, userId, username) {
		return {L: commandId, M: commandTimestamp, dk: userId, iK: username};
	});
var $author$project$User$Command$RemoveTeamRole = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$Command$RemoveTeamRolePayload = F5(
	function (commandId, commandTimestamp, userId, teamRole, nameForError) {
		return {L: commandId, M: commandTimestamp, cl: nameForError, bQ: teamRole, dk: userId};
	});
var $author$project$User$Command$Rename = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$Command$RenamePayload = F5(
	function (commandId, commandTimestamp, userId, name, nameForError) {
		return {L: commandId, M: commandTimestamp, g_: name, cl: nameForError, dk: userId};
	});
var $author$project$Auth$Password$Password = $elm$core$Basics$identity;
var $author$project$Auth$Password$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$User$Command$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (commandType) {
		switch (commandType) {
			case 'de.awenko.user.create.v1':
				return A3(
					$elm$core$Basics$composeR,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'avatar',
						$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
						$elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$map($author$project$User$Command$Create),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'entryOrganisationUnit',
						$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'teamRoles',
							$author$project$User$TeamRoles$decode,
							$author$project$User$TeamRoles$empty,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'name',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'password',
									$author$project$Auth$Password$decode,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'emailAddress',
										$elm$json$Json$Decode$maybe($author$project$User$EmailAddress$decode),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'username',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'userId',
												$author$project$User$Id$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'commandTimestamp',
													$author$project$Utils$Decode$timestamp,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'commandId',
														$author$project$Types$CommandId$decode,
														$elm$json$Json$Decode$succeed($author$project$User$Command$CreatePayload)))))))))));
			case 'de.awenko.user.change-email-address.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'nameForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$User$Command$ChangeEmailAddress),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'emailAddress',
						$author$project$User$EmailAddress$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$User$Command$ChangeEmailAddressPayload))))));
			case 'de.awenko.user.change-password.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'nameForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$User$Command$ChangePassword),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'password',
						$author$project$Auth$Password$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$User$Command$ChangePasswordPayload))))));
			case 'de.awenko.user.rename.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'nameForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$User$Command$Rename),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'name',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$User$Command$RenamePayload))))));
			case 'de.awenko.user.add-team-role.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'nameForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$User$Command$AddTeamRole),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'teamRole',
						$author$project$User$TeamRoles$decodeTeamRole,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$User$Command$AddTeamRolePayload))))));
			case 'de.awenko.user.change-team-role.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'nameForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$User$Command$ChangeTeamRole),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'teamRole',
						$author$project$User$TeamRoles$decodeTeamRole,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$User$Command$ChangeTeamRolePayload))))));
			case 'de.awenko.user.remove-team-role.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'nameForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$User$Command$RemoveTeamRole),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'teamRole',
						$author$project$User$TeamRoles$decodeTeamRole,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$User$Command$RemoveTeamRolePayload))))));
			case 'de.awenko.user.change-avatar.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'nameForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$User$Command$ChangeAvatar),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'avatar',
						$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$User$Command$ChangeAvatarPayload))))));
			case 'de.awenko.user.change-entry-organisation-unit.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'nameForError', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$User$Command$ChangeEntryOrganisationUnit),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'entryOrganisationUnit',
						$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'userId',
							$author$project$User$Id$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandTimestamp',
								$author$project$Utils$Decode$timestamp,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'commandId',
									$author$project$Types$CommandId$decode,
									$elm$json$Json$Decode$succeed($author$project$User$Command$ChangeEntryOrganisationUnitPayload))))));
			case 'de.awenko.user.delete.v1':
				return A3(
					$elm$core$Basics$composeR,
					A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'username', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$map($author$project$User$Command$Delete),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'userId',
						$author$project$User$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandTimestamp',
							$author$project$Utils$Decode$timestamp,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commandId',
								$author$project$Types$CommandId$decode,
								$elm$json$Json$Decode$succeed($author$project$User$Command$DeletePayload)))));
			default:
				return $elm$json$Json$Decode$fail('Unknown event');
		}
	},
	A2($elm$json$Json$Decode$field, 'commandType', $elm$json$Json$Decode$string));
var $author$project$User$Commands$decode = $author$project$Types$Queue$decode($author$project$User$Command$decode);
var $author$project$User$Events$decode = $author$project$Types$Queue$decode($author$project$User$Event$decode);
var $author$project$User$Users$Data = F2(
	function (dict, lastEventId) {
		return {cL: dict, fD: lastEventId};
	});
var $author$project$User$Users$Users = $elm$core$Basics$identity;
var $author$project$User$User$User = F8(
	function (userId, username, emailAddress, name, teamRoles, avatar, entryOrganisationUnit, revision) {
		return {iX: avatar, ju: emailAddress, hT: entryOrganisationUnit, g_: name, i: revision, k2: teamRoles, dk: userId, iK: username};
	});
var $author$project$User$User$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revision',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'entryOrganisationUnit',
		$elm$json$Json$Decode$maybe($author$project$OrganisationUnit$Id$decode),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'avatar',
			$elm$json$Json$Decode$maybe($author$project$File$Filename$decode),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'teamRoles',
				$author$project$User$TeamRoles$decode,
				$author$project$User$TeamRoles$empty,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'name',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'emailAddress',
						$elm$json$Json$Decode$maybe($author$project$User$EmailAddress$decode),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'username',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'userId',
								$author$project$User$Id$decode,
								$elm$json$Json$Decode$succeed($author$project$User$User$User)))))))));
var $author$project$User$Dict$fromList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		A2(
			$author$project$Utils$Tuple$with,
			function ($) {
				return $.dk;
			},
			$elm$core$Basics$identity)),
	$turboMaCk$any_dict$Dict$Any$fromList($author$project$User$Id$toString));
var $author$project$User$Dict$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$User$Dict$fromList,
	$elm$json$Json$Decode$list($author$project$User$User$decode));
var $author$project$User$Dict$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$User$Id$toString);
var $author$project$User$Users$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lastEventId',
		$elm$json$Json$Decode$maybe($author$project$Types$EventId$decode),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'users',
			$author$project$User$Dict$decode,
			$author$project$User$Dict$empty,
			$elm$json$Json$Decode$succeed($author$project$User$Users$Data))));
var $author$project$User$Commands$empty = $author$project$Types$Queue$empty;
var $author$project$User$Events$empty = $author$project$Types$Queue$empty;
var $author$project$User$Users$empty = {cL: $author$project$User$Dict$empty, fD: $elm$core$Maybe$Nothing};
var $author$project$User$Store$decodeData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'commands',
	$author$project$User$Commands$decode,
	$author$project$User$Commands$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'events',
		$author$project$User$Events$decode,
		$author$project$User$Events$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'users',
			$author$project$User$Users$decode,
			$author$project$User$Users$empty,
			$elm$json$Json$Decode$succeed($author$project$User$Store$Data))));
var $author$project$User$Store$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'LOADED_DATA':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$User$Store$LoadedData,
					A2($elm$json$Json$Decode$field, 'data', $author$project$User$Store$decodeData));
			case 'SAVED_USERS':
				return $elm$json$Json$Decode$succeed($author$project$User$Store$SavedUsers);
			case 'SAVED_MODIFICATIONS':
				return $elm$json$Json$Decode$succeed($author$project$User$Store$SavedModifications);
			case 'SAVED_COMMANDS_AND_EVENTS':
				return $elm$json$Json$Decode$succeed($author$project$User$Store$SavedCommandsAndEvents);
			case 'REMOVED_COMMAND':
				return $elm$json$Json$Decode$succeed($author$project$User$Store$RemovedCommand);
			case 'REMOVED_COMMAND_AND_EVENT':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'eventVersion',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'userId',
						$author$project$User$Id$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'commandId',
							$author$project$Types$CommandId$decode,
							$elm$json$Json$Decode$succeed($author$project$User$Store$RemovedCommandAndEvent))));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$User$Store$ReceivedErrorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$Store$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$User$Store$ReceivedErrorMsg(error);
	}
};
var $author$project$User$Store$userStoreInbox = _Platform_incomingPort('userStoreInbox', $elm$json$Json$Decode$value);
var $author$project$User$Store$subscriptions = $author$project$User$Store$userStoreInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$User$Store$decodeMsg),
		$author$project$User$Store$handleDecodeResult));
var $author$project$Utils$Http$GotBadGetResponse = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Utils$Http$GotBadPostAuditResponse = F4(
	function (a, b, c, d) {
		return {$: 16, a: a, b: b, c: c, d: d};
	});
var $author$project$Utils$Http$GotBadPostCheckpointGroupResponse = F4(
	function (a, b, c, d) {
		return {$: 26, a: a, b: b, c: c, d: d};
	});
var $author$project$Utils$Http$GotBadPostMeasureResponse = F4(
	function (a, b, c, d) {
		return {$: 20, a: a, b: b, c: c, d: d};
	});
var $author$project$Utils$Http$GotBadPostOrganisationUnitResponse = F4(
	function (a, b, c, d) {
		return {$: 8, a: a, b: b, c: c, d: d};
	});
var $author$project$Utils$Http$GotBadPostPlanResponse = F4(
	function (a, b, c, d) {
		return {$: 11, a: a, b: b, c: c, d: d};
	});
var $author$project$Utils$Http$GotBadPostRightsResponse = F4(
	function (a, b, c, d) {
		return {$: 29, a: a, b: b, c: c, d: d};
	});
var $author$project$Utils$Http$GotBadPostTenantResponse = F4(
	function (a, b, c, d) {
		return {$: 23, a: a, b: b, c: c, d: d};
	});
var $author$project$Utils$Http$GotBadPostUserResponse = F4(
	function (a, b, c, d) {
		return {$: 5, a: a, b: b, c: c, d: d};
	});
var $author$project$Utils$Http$GotErrorResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$Http$GotGetAuditResponse = function (a) {
	return {$: 13, a: a};
};
var $author$project$Utils$Http$GotGetAuditsArchiveResponse = function (a) {
	return {$: 14, a: a};
};
var $author$project$Utils$Http$GotGetAuditsResponse = function (a) {
	return {$: 12, a: a};
};
var $author$project$Utils$Http$GotGetCheckpointGroupsResponse = function (a) {
	return {$: 24, a: a};
};
var $author$project$Utils$Http$GotGetCheckpointHistoryResponse = function (a) {
	return {$: 31, a: a};
};
var $author$project$Utils$Http$GotGetCombinedArchiveResponse = function (a) {
	return {$: 30, a: a};
};
var $author$project$Utils$Http$GotGetMeasuresArchiveResponse = function (a) {
	return {$: 18, a: a};
};
var $author$project$Utils$Http$GotGetMeasuresResponse = function (a) {
	return {$: 17, a: a};
};
var $author$project$Utils$Http$GotGetOrganisationUnitsResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Utils$Http$GotGetPlansResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Utils$Http$GotGetRightsResponse = function (a) {
	return {$: 27, a: a};
};
var $author$project$Utils$Http$GotGetTenantResponse = function (a) {
	return {$: 21, a: a};
};
var $author$project$Utils$Http$GotGetUsersResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Utils$Http$GotPostAuditCommandResponse = function (a) {
	return {$: 15, a: a};
};
var $author$project$Utils$Http$GotPostCheckpointGroupCommandResponse = function (a) {
	return {$: 25, a: a};
};
var $author$project$Utils$Http$GotPostMeasureCommandResponse = function (a) {
	return {$: 19, a: a};
};
var $author$project$Utils$Http$GotPostOrganisationUnitCommandResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$Utils$Http$GotPostPlanCommandResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Utils$Http$GotPostRightsCommandResponse = function (a) {
	return {$: 28, a: a};
};
var $author$project$Utils$Http$GotPostTenantCommandResponse = function (a) {
	return {$: 22, a: a};
};
var $author$project$Utils$Http$GotPostUserCommandResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Archive$ArchivedAudits$ArchivedAudits = $elm$core$Basics$identity;
var $author$project$Archive$ArchivedAudits$Data = F2(
	function (dict, count) {
		return {ew: count, cL: dict};
	});
var $author$project$Archive$ArchivedAudits$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'count',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'audits',
			$author$project$Audit$Dict$decode,
			$author$project$Audit$Dict$empty,
			$elm$json$Json$Decode$succeed($author$project$Archive$ArchivedAudits$Data))));
var $author$project$Archive$ArchivedMeasures$ArchivedMeasures = $elm$core$Basics$identity;
var $author$project$Archive$ArchivedMeasures$Data = F2(
	function (dict, count) {
		return {ew: count, cL: dict};
	});
var $author$project$Archive$ArchivedMeasures$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'count',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'measures',
			$author$project$Measure$Dict$decode,
			$author$project$Measure$Dict$empty,
			$elm$json$Json$Decode$succeed($author$project$Archive$ArchivedMeasures$Data))));
var $author$project$Archive$CombinedArchive$CombinedArchive = $elm$core$Basics$identity;
var $author$project$Archive$CombinedArchive$Data = F2(
	function (values, count) {
		return {ew: count, bd: values};
	});
var $author$project$Archive$CombinedArchive$Audit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Archive$CombinedArchive$Measure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Archive$CombinedArchive$decodeValue = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 'Audit':
				return A2($elm$json$Json$Decode$map, $author$project$Archive$CombinedArchive$Audit, $author$project$Audit$Audit$decode);
			case 'Measure':
				return A2($elm$json$Json$Decode$map, $author$project$Archive$CombinedArchive$Measure, $author$project$Measure$Measure$decode);
			default:
				return $elm$json$Json$Decode$fail('Unknown Value');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Archive$CombinedArchive$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'count',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'list',
			$elm$json$Json$Decode$list($author$project$Archive$CombinedArchive$decodeValue),
			_List_Nil,
			$elm$json$Json$Decode$succeed($author$project$Archive$CombinedArchive$Data))));
var $author$project$CheckpointHistory$CheckpointHistory$CheckpointHistory = F2(
	function (checkpointId, auditRecords) {
		return {iV: auditRecords, i5: checkpointId};
	});
var $author$project$CheckpointHistory$AuditRecord$AuditRecord = F2(
	function (auditId, record) {
		return {gm: auditId, ct: record};
	});
var $author$project$CheckpointHistory$AuditRecord$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'record',
	$author$project$Audit$Record$Record$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'auditId',
		$author$project$Audit$Id$decode,
		$elm$json$Json$Decode$succeed($author$project$CheckpointHistory$AuditRecord$AuditRecord)));
var $author$project$CheckpointHistory$CheckpointHistory$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'records',
	$elm$json$Json$Decode$list($author$project$CheckpointHistory$AuditRecord$decode),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'checkpointId',
		$author$project$CheckpointData$Checkpoint$Id$decode,
		$elm$json$Json$Decode$succeed($author$project$CheckpointHistory$CheckpointHistory$CheckpointHistory)));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Utils$Http$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'GOT_RESPONSE':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (resultType) {
						switch (resultType) {
							case 'GET_USERS':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$User$Users$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetUsersResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'SEND_USER_COMMAND':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$User$Command$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotPostUserCommandResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$User$Command$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'resultType',
													$elm$json$Json$Decode$string,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														status,
														$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadPostUserResponse)))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_ORGANISATION_UNITS':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$OrganisationUnit$OrganisationUnits$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetOrganisationUnitsResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'SEND_ORGANISATION_UNIT_COMMAND':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$OrganisationUnit$Command$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotPostOrganisationUnitCommandResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$OrganisationUnit$Command$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'resultType',
													$elm$json$Json$Decode$string,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														status,
														$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadPostOrganisationUnitResponse)))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_PLANS':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$Plan$Plans$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetPlansResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'SEND_PLAN_COMMAND':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$Plan$Command$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotPostPlanCommandResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$Plan$Command$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'resultType',
													$elm$json$Json$Decode$string,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														status,
														$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadPostPlanResponse)))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_AUDITS':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$Audit$Audits$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetAuditsResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_AUDIT':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$Audit$Audit$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetAuditResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_AUDITS_ARCHIVE':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$Archive$ArchivedAudits$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetAuditsArchiveResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'SEND_AUDIT_COMMAND':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$Audit$Command$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotPostAuditCommandResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$Audit$Command$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'resultType',
													$elm$json$Json$Decode$string,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														status,
														$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadPostAuditResponse)))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_MEASURES':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$Measure$Measures$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetMeasuresResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_MEASURES_ARCHIVE':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$Archive$ArchivedMeasures$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetMeasuresArchiveResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'SEND_MEASURE_COMMAND':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$Measure$Command$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotPostMeasureCommandResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$Measure$Command$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'resultType',
													$elm$json$Json$Decode$string,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														status,
														$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadPostMeasureResponse)))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_TENANT':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$Tenant$Tenant$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetTenantResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'SEND_TENANT_COMMAND':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$Tenant$Command$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotPostTenantCommandResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$Tenant$Command$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'resultType',
													$elm$json$Json$Decode$string,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														status,
														$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadPostTenantResponse)))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_CHECKPOINT_GROUPS':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$CheckpointData$CheckpointData$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetCheckpointGroupsResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'SEND_CHECKPOINT_GROUP_COMMAND':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$CheckpointData$Command$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotPostCheckpointGroupCommandResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$CheckpointData$Command$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'resultType',
													$elm$json$Json$Decode$string,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														status,
														$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadPostCheckpointGroupResponse)))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_RIGHTS':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$Rights$Rights$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetRightsResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'SEND_RIGHTS_COMMAND':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$Rights$Command$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotPostRightsCommandResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'command',
											$author$project$Rights$Command$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'resultType',
													$elm$json$Json$Decode$string,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														status,
														$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadPostRightsResponse)))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_COMBINED_ARCHIVE':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$Archive$CombinedArchive$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetCombinedArchiveResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							case 'GET_CHECKPOINT_HISTORY':
								return A2(
									$elm$json$Json$Decode$andThen,
									function (status) {
										return (status === 200) ? A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'data',
											$author$project$CheckpointHistory$CheckpointHistory$decode,
											$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotGetCheckpointHistoryResponse)) : A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'resultType',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'data',
												$elm$json$Json$Decode$string,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													status,
													$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotBadGetResponse))));
									},
									A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int));
							default:
								return $elm$json$Json$Decode$fail('Unknown result type');
						}
					},
					A2($elm$json$Json$Decode$field, 'resultType', $elm$json$Json$Decode$string));
			case 'GOT_ERROR_RESPONSE':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'resultType',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Utils$Http$GotErrorResponse));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Utils$Http$GotDecodeError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$Http$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$Utils$Http$GotDecodeError(error);
	}
};
var $author$project$Utils$Http$httpInbox = _Platform_incomingPort('httpInbox', $elm$json$Json$Decode$value);
var $author$project$Utils$Http$subscriptions = $author$project$Utils$Http$httpInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Utils$Http$decodeMsg),
		$author$project$Utils$Http$handleDecodeResult));
var $author$project$Environments$Repository$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedEventStreamMsg, $author$project$EventStream$EventStream$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedUserStoreMsg, $author$project$User$Store$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedFileStoreMsg, $author$project$File$Store$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedOrganisationUnitStoreMsg, $author$project$OrganisationUnit$Store$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedPlanStoreMsg, $author$project$Plan$Store$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedAuditStoreMsg, $author$project$Audit$Store$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedMeasureStoreMsg, $author$project$Measure$Store$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedTenantStoreMsg, $author$project$Tenant$Store$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedCheckpointDataStoreMsg, $author$project$CheckpointData$Store$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedRightsStoreMsg, $author$project$Rights$Store$subscriptions),
			A2($elm$core$Platform$Sub$map, $author$project$Environments$Repository$ReceivedHttpResponse, $author$project$Utils$Http$subscriptions)
		]));
var $author$project$Page$Navbar$GotAnimationFrame = function (a) {
	return {$: 3, a: a};
};
var $tad_lispy$springs$Spring$atRest = function (_v0) {
	var _this = _v0;
	return _Utils_eq(_this.ll, _this.de) && (_this.dl === 0.0);
};
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {g2: oldTime, ir: request, iz: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.ir;
		var oldTime = _v0.g2;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.iz;
		var oldTime = _v0.g2;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrameDelta = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Delta(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrameDelta = $elm$browser$Browser$AnimationManager$onAnimationFrameDelta;
var $author$project$Page$Navbar$subscriptions = function (state) {
	if (state.$ === 3) {
		var spring = state.a;
		return $tad_lispy$springs$Spring$atRest(spring) ? $elm$core$Platform$Sub$none : $elm$browser$Browser$Events$onAnimationFrameDelta($author$project$Page$Navbar$GotAnimationFrame);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Page$Page$subscriptions = function (_v0) {
	var page = _v0;
	return page.kZ;
};
var $author$project$Main$subscriptions = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedEnvironmentMsg, $author$project$Environments$Environment$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedRepositoryMsg, $author$project$Environments$Repository$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedErrorModalMsg, $author$project$Environments$ErrorHandling$ErrorModal$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedReLoginMsg, $author$project$Auth$ReLoginModal$subscriptions)
					]));
		case 1:
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedEnvironmentMsg, $author$project$Environments$Environment$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedRepositoryMsg, $author$project$Environments$Repository$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedLoginMsg, $author$project$Auth$Login$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedErrorModalMsg, $author$project$Environments$ErrorHandling$ErrorModal$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedReLoginMsg, $author$project$Auth$ReLoginModal$subscriptions)
					]));
		case 2:
			var model = state.a;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedEnvironmentMsg, $author$project$Environments$Environment$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedRepositoryMsg, $author$project$Environments$Repository$subscriptions),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$ReceivedPageMsg,
						$author$project$Page$Page$subscriptions(model.ak)),
						A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$ReceivedNavbarMsg,
						$author$project$Page$Navbar$subscriptions(model.ba)),
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedErrorModalMsg, $author$project$Environments$ErrorHandling$ErrorModal$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Main$ReceivedReLoginMsg, $author$project$Auth$ReLoginModal$subscriptions)
					]));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Main$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Environments$Environment$Loaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Environments$Environment$LoadedSession = function (a) {
	return {$: 1, a: a};
};
var $author$project$Environments$Environment$LoadedTranslations = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Environments$Environment$navigateHelper = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (newRoute) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{d$: $elm$core$Maybe$Nothing, eb: newRoute}),
				newRoute);
		},
		model.d$);
};
var $author$project$Environments$Environment$navigate = function (state) {
	switch (state.$) {
		case 0:
			var model = state.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$mapFirst($author$project$Environments$Environment$Loading),
				$author$project$Environments$Environment$navigateHelper(model));
		case 1:
			var model = state.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$mapFirst($author$project$Environments$Environment$LoadedSession),
				$author$project$Environments$Environment$navigateHelper(model));
		case 2:
			var model = state.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$mapFirst($author$project$Environments$Environment$LoadedTranslations),
				$author$project$Environments$Environment$navigateHelper(model));
		default:
			var model = state.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$mapFirst($author$project$Environments$Environment$Loaded),
				$author$project$Environments$Environment$navigateHelper(model));
	}
};
var $author$project$Page$Page$GotArchivePageMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Page$Page = $elm$core$Basics$identity;
var $author$project$Page$Page$buildSubscriptions = F2(
	function (descriptor, page) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2(
				$elm$core$Maybe$map,
				function (subs) {
					return A2(
						$elm$core$Platform$Sub$map,
						descriptor.r,
						subs(page));
				},
				descriptor.kZ));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $rtfeldman$elm_css$VirtualDom$Styled$mapAttribute = F2(
	function (transform, _v0) {
		var prop = _v0.a;
		var styles = _v0.b;
		var classname = _v0.c;
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$mapAttribute, transform, prop),
			styles,
			classname);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$map = F2(
	function (transform, vdomNode) {
		switch (vdomNode.$) {
			case 0:
				var elemType = vdomNode.a;
				var properties = vdomNode.b;
				var children = vdomNode.c;
				return A3(
					$rtfeldman$elm_css$VirtualDom$Styled$Node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$map(transform),
						children));
			case 1:
				var ns = vdomNode.a;
				var elemType = vdomNode.b;
				var properties = vdomNode.c;
				var children = vdomNode.d;
				return A4(
					$rtfeldman$elm_css$VirtualDom$Styled$NodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$map(transform),
						children));
			case 2:
				var elemType = vdomNode.a;
				var properties = vdomNode.b;
				var children = vdomNode.c;
				return A3(
					$rtfeldman$elm_css$VirtualDom$Styled$KeyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var key = _v1.a;
							var child = _v1.b;
							return _Utils_Tuple2(
								key,
								A2($rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
						},
						children));
			case 3:
				var ns = vdomNode.a;
				var elemType = vdomNode.b;
				var properties = vdomNode.c;
				var children = vdomNode.d;
				return A4(
					$rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						function (_v2) {
							var key = _v2.a;
							var child = _v2.b;
							return _Utils_Tuple2(
								key,
								A2($rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
						},
						children));
			default:
				var vdom = vdomNode.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
					A2($elm$virtual_dom$VirtualDom$map, transform, vdom));
		}
	});
var $rtfeldman$elm_css$Html$Styled$map = $rtfeldman$elm_css$VirtualDom$Styled$map;
var $author$project$Page$Page$buildView = F4(
	function (descriptor, page, environment, repository) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			descriptor.r,
			A3(descriptor.lm, environment, repository, page));
	});
var $author$project$Page$Page$buildPage = F2(
	function (descriptor, page) {
		return {
			kZ: A2($author$project$Page$Page$buildSubscriptions, descriptor, page),
			le: A2($author$project$Page$Page$buildUpdate, descriptor, page),
			lm: A2($author$project$Page$Page$buildView, descriptor, page)
		};
	});
var $author$project$Page$Page$buildUpdate = F5(
	function (descriptor, oldPage, mainMsg, oldEnvironment, oldRepository) {
		return A2(
			$elm$core$Maybe$withDefault,
			{
				ab: $elm$core$Platform$Cmd$none,
				ac: oldEnvironment,
				ak: A2($author$project$Page$Page$buildPage, descriptor, oldPage),
				ae: oldRepository
			},
			A2(
				$elm$core$Maybe$map,
				function (result) {
					return {
						ab: A2($elm$core$Platform$Cmd$map, descriptor.r, result.ab),
						ac: result.ac,
						ak: A2($author$project$Page$Page$buildPage, descriptor, result.ak),
						ae: result.ae
					};
				},
				A2(
					$elm$core$Maybe$map,
					function (msg) {
						return A4(descriptor.le, msg, oldEnvironment, oldRepository, oldPage);
					},
					descriptor.S(mainMsg))));
	});
var $author$project$Page$Page$init = F2(
	function (descriptor, _v0) {
		var environment = _v0.a;
		var page = _v0.b;
		var cmd = _v0.c;
		return _Utils_Tuple3(
			environment,
			A2($author$project$Page$Page$buildPage, descriptor, page),
			A2($elm$core$Platform$Cmd$map, descriptor.r, cmd));
	});
var $author$project$Archive$Page$GotAuditArchiveContentMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Archive$Page$GotCombinedArchiveContentMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Archive$Page$GotMeasureArchiveContentMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Archive$AuditArchiveContent$GotEditAuditDialogMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Archive$AuditArchiveContent$GotGetAuditsArchiveResult = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audit$EditDialog$GotDeleteResponse = function (a) {
	return {$: 15, a: a};
};
var $author$project$Audit$EditDialog$subscriptions = function (dialog) {
	switch (dialog.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			return A2($elm$core$Platform$Sub$map, $author$project$Audit$EditDialog$GotDeleteResponse, $author$project$Utils$Http$subscriptions);
		default:
			return A2($elm$core$Platform$Sub$map, $author$project$Audit$EditDialog$GotDeleteResponse, $author$project$Utils$Http$subscriptions);
	}
};
var $author$project$Archive$AuditArchiveContent$subscriptions = function (content) {
	if (content.$ === 1) {
		var model = content.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Archive$AuditArchiveContent$GotEditAuditDialogMsg,
					$author$project$Audit$EditDialog$subscriptions(model.cN)),
					A2($elm$core$Platform$Sub$map, $author$project$Archive$AuditArchiveContent$GotGetAuditsArchiveResult, $author$project$Utils$Http$subscriptions)
				]));
	} else {
		return A2($elm$core$Platform$Sub$map, $author$project$Archive$AuditArchiveContent$GotGetAuditsArchiveResult, $author$project$Utils$Http$subscriptions);
	}
};
var $author$project$Archive$CombinedArchiveContent$GotEditAuditDialogMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Archive$CombinedArchiveContent$GotEditMeasureDialogMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Archive$CombinedArchiveContent$GotGetCombinedArchiveResult = function (a) {
	return {$: 0, a: a};
};
var $author$project$Measure$EditDialog$GotHttpResponse = function (a) {
	return {$: 22, a: a};
};
var $author$project$Measure$EditDialog$GotImageEditorMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Measure$EditDialog$GotTmpFileMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$File$TmpFile$TmpFile$DownloadedTmpMeasureFile = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$File$TmpFile$TmpFile$DownloadedTmpRecordFile = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$File$TmpFile$TmpFile$ErrorDownloadingMeasureFile = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$File$TmpFile$TmpFile$ErrorDownloadingRecordFile = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$File$TmpFile$TmpFile$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'DOWNLOADED_TMP_RECORD_FILE':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recordId',
					$author$project$Audit$Record$Id$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'blobUrl',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$File$TmpFile$TmpFile$DownloadedTmpRecordFile)));
			case 'DOWNLOADED_TMP_MEASURE_FILE':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'filename',
					$author$project$File$Filename$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'blobUrl',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$File$TmpFile$TmpFile$DownloadedTmpMeasureFile)));
			case 'ERROR_DOWNLOADING_RECORD_FILE':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recordId',
					$author$project$Audit$Record$Id$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$File$TmpFile$TmpFile$ErrorDownloadingRecordFile)));
			case 'ERROR_DOWNLOADING_MEASURE_FILE':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'filename',
					$author$project$File$Filename$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$File$TmpFile$TmpFile$ErrorDownloadingMeasureFile)));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$File$TmpFile$TmpFile$ReceivedErrorMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$File$TmpFile$TmpFile$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$File$TmpFile$TmpFile$ReceivedErrorMsg(error);
	}
};
var $author$project$File$TmpFile$TmpFile$tmpFileStoreInbox = _Platform_incomingPort('tmpFileStoreInbox', $elm$json$Json$Decode$value);
var $author$project$File$TmpFile$TmpFile$subscriptions = $author$project$File$TmpFile$TmpFile$tmpFileStoreInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$File$TmpFile$TmpFile$decodeMsg),
		$author$project$File$TmpFile$TmpFile$handleDecodeResult));
var $author$project$UI$ImagesEditor$ImageSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$UI$ImagesEditor$PhotoTaken = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$ImagesEditor$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'PHOTO_TAKEN':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$UI$ImagesEditor$PhotoTaken,
					A2($elm$json$Json$Decode$field, 'filename', $author$project$File$Filename$decode));
			case 'IMAGE_SELECTED':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$UI$ImagesEditor$ImageSelected,
					A2($elm$json$Json$Decode$field, 'filename', $author$project$File$Filename$decode));
			default:
				return $elm$json$Json$Decode$fail('Unknown msg type');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$UI$ImagesEditor$ReceivedErrorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$UI$ImagesEditor$handleDecodeResult = function (result) {
	if (!result.$) {
		var value = result.a;
		return value;
	} else {
		var error = result.a;
		return $author$project$UI$ImagesEditor$ReceivedErrorMsg(error);
	}
};
var $author$project$UI$ImagesEditor$measureImageEditorInbox = _Platform_incomingPort('measureImageEditorInbox', $elm$json$Json$Decode$value);
var $author$project$UI$ImagesEditor$subscriptions = $author$project$UI$ImagesEditor$measureImageEditorInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$UI$ImagesEditor$decodeMsg),
		$author$project$UI$ImagesEditor$handleDecodeResult));
var $author$project$Measure$EditDialog$subscriptions = function (dialog) {
	switch (dialog.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Sub$map, $author$project$Measure$EditDialog$GotImageEditorMsg, $author$project$UI$ImagesEditor$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Measure$EditDialog$GotHttpResponse, $author$project$Utils$Http$subscriptions),
						A2($elm$core$Platform$Sub$map, $author$project$Measure$EditDialog$GotTmpFileMsg, $author$project$File$TmpFile$TmpFile$subscriptions)
					]));
		case 2:
			return A2($elm$core$Platform$Sub$map, $author$project$Measure$EditDialog$GotHttpResponse, $author$project$Utils$Http$subscriptions);
		default:
			return A2($elm$core$Platform$Sub$map, $author$project$Measure$EditDialog$GotHttpResponse, $author$project$Utils$Http$subscriptions);
	}
};
var $author$project$Archive$CombinedArchiveContent$subscriptions = function (content) {
	if (content.$ === 1) {
		var model = content.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Archive$CombinedArchiveContent$GotEditAuditDialogMsg,
					$author$project$Audit$EditDialog$subscriptions(model.cN)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Archive$CombinedArchiveContent$GotEditMeasureDialogMsg,
					$author$project$Measure$EditDialog$subscriptions(model.cP)),
					A2($elm$core$Platform$Sub$map, $author$project$Archive$CombinedArchiveContent$GotGetCombinedArchiveResult, $author$project$Utils$Http$subscriptions)
				]));
	} else {
		return A2($elm$core$Platform$Sub$map, $author$project$Archive$CombinedArchiveContent$GotGetCombinedArchiveResult, $author$project$Utils$Http$subscriptions);
	}
};
var $author$project$Archive$MeasureArchiveContent$GotEditMeasureDialogMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Archive$MeasureArchiveContent$GotGetMeasuresArchiveResult = function (a) {
	return {$: 0, a: a};
};
var $author$project$Archive$MeasureArchiveContent$subscriptions = function (content) {
	if (content.$ === 1) {
		var model = content.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Archive$MeasureArchiveContent$GotEditMeasureDialogMsg,
					$author$project$Measure$EditDialog$subscriptions(model.cP)),
					A2($elm$core$Platform$Sub$map, $author$project$Archive$MeasureArchiveContent$GotGetMeasuresArchiveResult, $author$project$Utils$Http$subscriptions)
				]));
	} else {
		return A2($elm$core$Platform$Sub$map, $author$project$Archive$MeasureArchiveContent$GotGetMeasuresArchiveResult, $author$project$Utils$Http$subscriptions);
	}
};
var $author$project$Archive$Page$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = model.ai;
	switch (_v1.$) {
		case 0:
			var content = _v1.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Archive$Page$GotCombinedArchiveContentMsg,
				$author$project$Archive$CombinedArchiveContent$subscriptions(content));
		case 1:
			var content = _v1.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Archive$Page$GotAuditArchiveContentMsg,
				$author$project$Archive$AuditArchiveContent$subscriptions(content));
		default:
			var content = _v1.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Archive$Page$GotMeasureArchiveContentMsg,
				$author$project$Archive$MeasureArchiveContent$subscriptions(content));
	}
};
var $author$project$Archive$Page$Page = $elm$core$Basics$identity;
var $author$project$Archive$Page$enteredSearchString = F4(
	function (newSearchString, environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{aN: newSearchString}),
			ae: repository
		};
	});
var $author$project$Archive$Page$AuditArchive = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $turboMaCk$any_dict$Dict$Any$member = F2(
	function (k, _v0) {
		var dict = _v0.cL;
		var toKey = _v0.a3;
		return A2(
			$elm$core$Dict$member,
			toKey(k),
			dict);
	});
var $author$project$Audit$Dict$member = $turboMaCk$any_dict$Dict$Any$member;
var $turboMaCk$any_dict$Dict$Any$remove = F2(
	function (k, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				cL: A2(
					$elm$core$Dict$remove,
					inner.a3(k),
					inner.cL)
			});
	});
var $author$project$Audit$Dict$remove = $turboMaCk$any_dict$Dict$Any$remove;
var $author$project$Archive$ArchivedAudits$removeAudit = F2(
	function (auditId, archivedAudits) {
		var data = archivedAudits;
		return A2($author$project$Audit$Dict$member, auditId, data.cL) ? {
			ew: data.ew - 1,
			cL: A2($author$project$Audit$Dict$remove, auditId, data.cL)
		} : archivedAudits;
	});
var $author$project$Environments$ErrorHandling$Error$CommandHandlingError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audit$EditDialog$Hidden = {$: 0};
var $author$project$Environments$Environment$unwrap = function (state) {
	switch (state.$) {
		case 0:
			var model = state.a;
			return model;
		case 1:
			var model = state.a;
			return model;
		case 2:
			var model = state.a;
			return model;
		default:
			var model = state.a;
			return model;
	}
};
var $author$project$Environments$Environment$apiVersion = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.er;
	});
var $author$project$Environments$Environment$appState = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.dn;
	});
var $author$project$Environments$Environment$map = F2(
	function (fn, state) {
		switch (state.$) {
			case 0:
				var model = state.a;
				return $author$project$Environments$Environment$Loading(
					fn(model));
			case 1:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedSession(
					fn(model));
			case 2:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedTranslations(
					fn(model));
			default:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					fn(model));
		}
	});
var $author$project$Auth$Session$maybeUserId = function (session) {
	switch (session.$) {
		case 1:
			var id = session.b;
			return $elm$core$Maybe$Just(id);
		case 2:
			var id = session.b;
			return $elm$core$Maybe$Just(id);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Environments$Environment$networkState = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.c3;
	});
var $author$project$Environments$Environment$platform = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.eT;
	});
var $author$project$Environments$Environment$session = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.aO;
	});
var $author$project$Environments$Environment$viewport = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.J;
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Environments$Environment$viewTypeString = function (viewType) {
	if (!viewType) {
		return 'Wide';
	} else {
		return 'Thin';
	}
};
var $author$project$Environments$Environment$viewportString = function (viewport_) {
	return '{ width : ' + ($elm$core$String$fromFloat(viewport_.ln) + (', height :' + ($elm$core$String$fromFloat(viewport_.Y) + (', viewType : ' + ($author$project$Environments$Environment$viewTypeString(viewport_.be) + ' }')))));
};
var $author$project$Environments$Environment$addError = F2(
	function (payload, state) {
		var metaData = {
			er: $author$project$Environments$Environment$apiVersion(state),
			dn: $author$project$Environments$Environment$appState(state),
			c3: $author$project$Environments$Environment$networkState(state),
			eT: $author$project$Environments$Environment$platform(state),
			lh: $author$project$Auth$Session$maybeUserId(
				$author$project$Environments$Environment$session(state)),
			J: $author$project$Environments$Environment$viewportString(
				$author$project$Environments$Environment$viewport(state))
		};
		var error = {gg: payload.gg, gE: payload.gE, gH: payload.gH, gK: payload.gK, fw: payload.fw, j7: metaData};
		return A2(
			$author$project$Environments$Environment$map,
			function (model) {
				return _Utils_update(
					model,
					{
						ez: A2($elm$core$List$cons, error, model.ez),
						eH: $elm$core$Maybe$Just(error)
					});
			},
			state);
	});
var $author$project$Environments$ErrorHandling$ToString$auditErrorToString = function (err) {
	if (!err.$) {
		var id = err.a;
		return 'Audit.DoesNotExist' + $author$project$Audit$Id$toString(id);
	} else {
		var id = err.a;
		return 'Audit.AlreadyExists' + $author$project$Audit$Id$toString(id);
	}
};
var $author$project$Environments$ErrorHandling$Id$Id = $elm$core$Basics$identity;
var $author$project$Environments$ErrorHandling$Id$from = $elm$core$Basics$identity;
var $author$project$Audit$Commands$fromList = $author$project$Types$Queue$fromList;
var $NoRedInk$elm_random_general$Random$General$Generator = $elm$core$Basics$identity;
var $NoRedInk$elm_random_general$Random$General$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$map = $NoRedInk$elm_random_general$Random$General$map;
var $NoRedInk$elm_random_general$Random$General$Config = $elm$core$Basics$identity;
var $NoRedInk$elm_random_general$Random$General$makeConfig = F2(
	function (next, peel) {
		return {kc: next, eQ: peel};
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtensionHelp = F3(
	function (index, prev, arr) {
		incrementExtensionHelp:
		while (true) {
			if (!prev) {
				var _v0 = A2($elm$core$Array$get, index, arr);
				if (!_v0.$) {
					var elem = _v0.a;
					var newElem = (elem + 1013904223) >>> 0;
					var $temp$index = index + 1,
						$temp$prev = newElem,
						$temp$arr = A3($elm$core$Array$set, index, newElem, arr);
					index = $temp$index;
					prev = $temp$prev;
					arr = $temp$arr;
					continue incrementExtensionHelp;
				} else {
					return arr;
				}
			} else {
				return arr;
			}
		}
	});
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtension = function (arr) {
	return A3($NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtensionHelp, 0, 0, arr);
};
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$next = function (_v0) {
	var s = _v0;
	var newBase = $NoRedInk$elm_random_pcg_extended$Internal$Pcg$next(s.bV);
	var baseState = newBase.a;
	return {
		bV: newBase,
		bm: (!baseState) ? $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$incrementExtension(s.bm) : s.bm
	};
};
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $NoRedInk$elm_random_pcg_extended$Internal$Pcg$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $NoRedInk$elm_random_pcg_extended$Internal$Pcg$config = A2($NoRedInk$elm_random_general$Random$General$makeConfig, $NoRedInk$elm_random_pcg_extended$Internal$Pcg$next, $NoRedInk$elm_random_pcg_extended$Internal$Pcg$peel);
var $NoRedInk$elm_random_general$Random$General$int = F3(
	function (_v0, a, b) {
		var c = _v0;
		return function (seed0) {
			var _v1 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v1.a;
			var hi = _v1.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & c.eQ(seed0)) >>> 0) + lo,
					c.kc(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = c.eQ(seed);
						var seedN = c.kc(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $NoRedInk$elm_random_pcg_extended$Internal$Pcg$int = $NoRedInk$elm_random_general$Random$General$int($NoRedInk$elm_random_pcg_extended$Internal$Pcg$config);
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $NoRedInk$elm_random_general$Random$General$step = F2(
	function (_v0, seed) {
		var gen = _v0;
		return gen(seed);
	});
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$peel = function (_v0) {
	var s = _v0;
	var baseOut = $NoRedInk$elm_random_pcg_extended$Internal$Pcg$peel(s.bV);
	var _v1 = A2(
		$NoRedInk$elm_random_general$Random$General$step,
		A2(
			$NoRedInk$elm_random_pcg_extended$Internal$Pcg$int,
			0,
			$elm$core$Array$length(s.bm) - 1),
		s.bV);
	var randIndex = _v1.a;
	var extension = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$core$Array$get, randIndex, s.bm));
	return (baseOut ^ extension) >>> 0;
};
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$config = A2($NoRedInk$elm_random_general$Random$General$makeConfig, $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$next, $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$peel);
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$int = $NoRedInk$elm_random_general$Random$General$int($NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$config);
var $NoRedInk$elm_uuid$Prng$Uuid$hexGenerator = A2($NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$int, 0, 15);
var $NoRedInk$elm_random_general$Random$General$listHelp = F4(
	function (list_, n, generate, seed) {
		listHelp:
		while (true) {
			if (n < 1) {
				return _Utils_Tuple2(list_, seed);
			} else {
				var _v0 = generate(seed);
				var value = _v0.a;
				var newSeed = _v0.b;
				var $temp$list_ = A2($elm$core$List$cons, value, list_),
					$temp$n = n - 1,
					$temp$generate = generate,
					$temp$seed = newSeed;
				list_ = $temp$list_;
				n = $temp$n;
				generate = $temp$generate;
				seed = $temp$seed;
				continue listHelp;
			}
		}
	});
var $NoRedInk$elm_random_general$Random$General$list = F2(
	function (n, _v0) {
		var generate = _v0;
		return function (seed) {
			return A4($NoRedInk$elm_random_general$Random$General$listHelp, _List_Nil, n, generate, seed);
		};
	});
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$list = $NoRedInk$elm_random_general$Random$General$list;
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$String$fromList = _String_fromList;
var $NoRedInk$elm_uuid$Prng$Uuid$Barebones$limitDigitRange8ToB = function (digit) {
	return (digit & 3) | 8;
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $NoRedInk$elm_uuid$Prng$Uuid$Barebones$hexDigits = function () {
	var mapChars = F2(
		function (offset, digit) {
			return $elm$core$Char$fromCode(digit + offset);
		});
	return $elm$core$Array$fromList(
		_Utils_ap(
			A2(
				$elm$core$List$map,
				mapChars(48),
				A2($elm$core$List$range, 0, 9)),
			A2(
				$elm$core$List$map,
				mapChars(97),
				A2($elm$core$List$range, 0, 5))));
}();
var $NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex = function (index) {
	var maybeResult = A2($elm$core$Array$get, index, $NoRedInk$elm_uuid$Prng$Uuid$Barebones$hexDigits);
	if (maybeResult.$ === 1) {
		return 'x';
	} else {
		var result = maybeResult.a;
		return result;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $NoRedInk$elm_uuid$Prng$Uuid$Barebones$toUuidString = function (thirtyOneHexDigits) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
					A2($elm$core$List$take, 8, thirtyOneHexDigits))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						4,
						A2($elm$core$List$drop, 8, thirtyOneHexDigits)))),
				'-',
				'4',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						3,
						A2($elm$core$List$drop, 12, thirtyOneHexDigits)))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$map,
						$NoRedInk$elm_uuid$Prng$Uuid$Barebones$limitDigitRange8ToB,
						A2(
							$elm$core$List$take,
							1,
							A2($elm$core$List$drop, 15, thirtyOneHexDigits))))),
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						3,
						A2($elm$core$List$drop, 16, thirtyOneHexDigits)))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$NoRedInk$elm_uuid$Prng$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						12,
						A2($elm$core$List$drop, 19, thirtyOneHexDigits))))
			]));
};
var $NoRedInk$elm_uuid$Prng$Uuid$stringGenerator = A2(
	$NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$map,
	$NoRedInk$elm_uuid$Prng$Uuid$Barebones$toUuidString,
	A2($NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$list, 31, $NoRedInk$elm_uuid$Prng$Uuid$hexGenerator));
var $NoRedInk$elm_uuid$Prng$Uuid$generator = A2($NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$map, $elm$core$Basics$identity, $NoRedInk$elm_uuid$Prng$Uuid$stringGenerator);
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$step = $NoRedInk$elm_random_general$Random$General$step;
var $author$project$Environments$Environment$generateUuidHelper = function (model) {
	return A2(
		$elm$core$Tuple$mapSecond,
		function (seed) {
			return _Utils_update(
				model,
				{eX: seed});
		},
		A2($NoRedInk$elm_random_pcg_extended$Random$Pcg$Extended$step, $NoRedInk$elm_uuid$Prng$Uuid$generator, model.eX));
};
var $author$project$Environments$Environment$generateUuid = function (state) {
	switch (state.$) {
		case 0:
			var model = state.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$author$project$Environments$Environment$Loading,
				$author$project$Environments$Environment$generateUuidHelper(model));
		case 1:
			var model = state.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$author$project$Environments$Environment$LoadedSession,
				$author$project$Environments$Environment$generateUuidHelper(model));
		case 2:
			var model = state.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$author$project$Environments$Environment$LoadedTranslations,
				$author$project$Environments$Environment$generateUuidHelper(model));
		default:
			var model = state.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$author$project$Environments$Environment$Loaded,
				$author$project$Environments$Environment$generateUuidHelper(model));
	}
};
var $author$project$Audit$Audit$NotModified = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audit$Audit$Changed = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Audit$Audit$auditFromModification = function (modification) {
	switch (modification.$) {
		case 0:
			var maybeAudit = modification.a;
			return maybeAudit;
		case 1:
			var audit = modification.a;
			return $elm$core$Maybe$Just(audit);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$User$Ids$fromList = $turboMaCk$any_set$Set$Any$fromList($author$project$User$Id$toString);
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$Basics$not = _Basics_not;
var $author$project$User$Ids$toList = $turboMaCk$any_set$Set$Any$toList;
var $author$project$Audit$Audit$applyAuditorsChanged = F2(
	function (payload, _v0) {
		var modification = _v0.a;
		var fileOperations = _v0.b;
		var _v1 = $author$project$Audit$Audit$auditFromModification(modification);
		if (!_v1.$) {
			var audit = _v1.a;
			if (_Utils_eq(payload.gm, audit.gm) && (_Utils_cmp(payload.n, audit.i) > 0)) {
				var newAuditors = $author$project$User$Ids$fromList(
					_Utils_ap(
						$author$project$User$Ids$toList(payload.ge),
						A2(
							$elm$core$List$filter,
							function (auditor) {
								return !A2(
									$elm$core$List$member,
									auditor,
									$author$project$User$Ids$toList(payload.g9));
							},
							$author$project$User$Ids$toList(audit.bT))));
				var newAudit = _Utils_update(
					audit,
					{bT: newAuditors, i: payload.n});
				return _Utils_Tuple2(
					A2($author$project$Audit$Audit$Changed, newAudit, payload.N),
					fileOperations);
			} else {
				return _Utils_Tuple2(modification, fileOperations);
			}
		} else {
			return _Utils_Tuple2(modification, fileOperations);
		}
	});
var $author$project$File$Operation$CreateRecordImage = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Types$Queue$queue = F2(
	function (front, rear) {
		if (!front.b) {
			return A2(
				$author$project$Types$Queue$Queue,
				$elm$core$List$reverse(rear),
				_List_Nil);
		} else {
			return A2($author$project$Types$Queue$Queue, front, rear);
		}
	});
var $author$project$Types$Queue$enqueue = F2(
	function (a, _v0) {
		var front = _v0.a;
		var rear = _v0.b;
		return A2(
			$author$project$Types$Queue$queue,
			front,
			A2($elm$core$List$cons, a, rear));
	});
var $author$project$File$Operations$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$Audit$Audit$applyCheckpointRecorded = F2(
	function (payload, _v0) {
		var modification = _v0.a;
		var fileOperations = _v0.b;
		var _v1 = $author$project$Audit$Audit$auditFromModification(modification);
		if (!_v1.$) {
			var audit = _v1.a;
			if (_Utils_eq(payload.gm, audit.gm) && (_Utils_cmp(payload.n, audit.i) > 0)) {
				var newFileOperations = function () {
					var _v2 = payload.ct.ll;
					switch (_v2.$) {
						case 8:
							var filename = _v2.a;
							return A2(
								$author$project$File$Operations$enqueue,
								A3($author$project$File$Operation$CreateRecordImage, payload.gm, payload.ct.bK, filename),
								fileOperations);
						case 9:
							var filename = _v2.a;
							return A2(
								$author$project$File$Operations$enqueue,
								A3($author$project$File$Operation$CreateRecordImage, payload.gm, payload.ct.bK, filename),
								fileOperations);
						default:
							return fileOperations;
					}
				}();
				var newAudit = _Utils_update(
					audit,
					{
						io: A2($author$project$Audit$Record$Records$insert, payload.ct, audit.io),
						i: payload.n
					});
				return _Utils_Tuple2(
					A2($author$project$Audit$Audit$Changed, newAudit, payload.N),
					newFileOperations);
			} else {
				return _Utils_Tuple2(modification, fileOperations);
			}
		} else {
			return _Utils_Tuple2(modification, fileOperations);
		}
	});
var $author$project$Audit$Audit$Completed = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$File$Operation$Delete = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$File$Operation$RemoveFromServer = $elm$core$Basics$identity;
var $author$project$Utils$Utils$reduceMaybeList = F2(
	function (maybe, list) {
		if (!maybe.$) {
			var value = maybe.a;
			return A2($elm$core$List$cons, value, list);
		} else {
			return list;
		}
	});
var $author$project$Audit$Audit$applyCompletedEvent = F2(
	function (payload, _v0) {
		var modification = _v0.a;
		var fileOperations = _v0.b;
		var _v1 = $author$project$Audit$Audit$auditFromModification(modification);
		if (!_v1.$) {
			var audit = _v1.a;
			if (_Utils_eq(payload.gm, audit.gm) && (_Utils_cmp(payload.n, audit.i) > 0)) {
				var newFileOperations = A3(
					$elm$core$List$foldl,
					A2(
						$elm$core$Basics$composeR,
						$author$project$File$Operation$Delete(false),
						$author$project$File$Operations$enqueue),
					fileOperations,
					A3(
						$elm$core$List$foldl,
						$author$project$Utils$Utils$reduceMaybeList,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (record) {
								var _v2 = record.ll;
								if (_v2.$ === 8) {
									var filename = _v2.a;
									return $elm$core$Maybe$Just(filename);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							$author$project$Audit$Record$Records$values(audit.io))));
				return _Utils_Tuple2(
					A2($author$project$Audit$Audit$Completed, audit.gm, payload.N),
					newFileOperations);
			} else {
				return _Utils_Tuple2(modification, fileOperations);
			}
		} else {
			return _Utils_Tuple2(modification, fileOperations);
		}
	});
var $author$project$Audit$Audit$applyCreatedEvent = F2(
	function (payload, _v0) {
		var modification = _v0.a;
		var fileOperations = _v0.b;
		var _v1 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v1.$ === 1) {
			var newAudit = {
				gm: payload.gm,
				bT: payload.bT,
				ff: payload.ff,
				jb: $author$project$Audit$CompletionStatus$Open,
				dw: payload.dw,
				hI: payload.hI,
				aY: payload.aY,
				dH: payload.dH,
				fw: payload.fw,
				d5: payload.d5,
				d6: $elm$core$Maybe$Just(payload.d6),
				io: $author$project$Audit$Record$Records$empty,
				i: 0,
				k8: payload.k8
			};
			return _Utils_Tuple2(
				A2($author$project$Audit$Audit$Changed, newAudit, payload.N),
				fileOperations);
		} else {
			return _Utils_Tuple2(modification, fileOperations);
		}
	});
var $author$project$Audit$Audit$applyDeadlineChanged = F2(
	function (payload, _v0) {
		var modification = _v0.a;
		var fileOperations = _v0.b;
		var _v1 = $author$project$Audit$Audit$auditFromModification(modification);
		if (!_v1.$) {
			var audit = _v1.a;
			if (_Utils_eq(payload.gm, audit.gm) && (_Utils_cmp(payload.n, audit.i) > 0)) {
				var newAudit = _Utils_update(
					audit,
					{hI: payload.hI, i: payload.n});
				return _Utils_Tuple2(
					A2($author$project$Audit$Audit$Changed, newAudit, payload.N),
					fileOperations);
			} else {
				return _Utils_Tuple2(modification, fileOperations);
			}
		} else {
			return _Utils_Tuple2(modification, fileOperations);
		}
	});
var $author$project$Audit$Audit$Deleted = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Audit$Audit$applyDeletedEvent = F2(
	function (payload, _v0) {
		var modification = _v0.a;
		var fileOperations = _v0.b;
		var _v1 = $author$project$Audit$Audit$auditFromModification(modification);
		if (!_v1.$) {
			var audit = _v1.a;
			if (_Utils_eq(payload.gm, audit.gm) && (_Utils_cmp(payload.n, audit.i) > 0)) {
				var newFileOperations = A3(
					$elm$core$List$foldl,
					A2(
						$elm$core$Basics$composeR,
						$author$project$File$Operation$Delete(false),
						$author$project$File$Operations$enqueue),
					fileOperations,
					A3(
						$elm$core$List$foldl,
						$author$project$Utils$Utils$reduceMaybeList,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (record) {
								var _v2 = record.ll;
								if (_v2.$ === 8) {
									var filename = _v2.a;
									return $elm$core$Maybe$Just(filename);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							$author$project$Audit$Record$Records$values(audit.io))));
				return _Utils_Tuple2(
					A2($author$project$Audit$Audit$Deleted, audit.gm, payload.N),
					newFileOperations);
			} else {
				return _Utils_Tuple2(modification, fileOperations);
			}
		} else {
			return _Utils_Tuple2(modification, fileOperations);
		}
	});
var $author$project$Audit$Audit$applyDescriptionChanged = F2(
	function (payload, _v0) {
		var modification = _v0.a;
		var fileOperations = _v0.b;
		var _v1 = $author$project$Audit$Audit$auditFromModification(modification);
		if (!_v1.$) {
			var audit = _v1.a;
			if (_Utils_eq(payload.gm, audit.gm) && (_Utils_cmp(payload.n, audit.i) > 0)) {
				var newAudit = _Utils_update(
					audit,
					{aY: payload.aY, i: payload.n});
				return _Utils_Tuple2(
					A2($author$project$Audit$Audit$Changed, newAudit, payload.N),
					fileOperations);
			} else {
				return _Utils_Tuple2(modification, fileOperations);
			}
		} else {
			return _Utils_Tuple2(modification, fileOperations);
		}
	});
var $turboMaCk$any_set$Set$Any$insert = F2(
	function (a, _v0) {
		var dict = _v0;
		return A3($turboMaCk$any_dict$Dict$Any$insert, a, 0, dict);
	});
var $author$project$File$Filenames$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$Audit$Record$Record$addFiles = F2(
	function (files, checkpointGroup) {
		var removeHelper = F2(
			function (file, filenames) {
				return A2($author$project$File$Filenames$insert, file, filenames);
			});
		return _Utils_update(
			checkpointGroup,
			{
				cT: A3($elm$core$List$foldl, removeHelper, checkpointGroup.cT, files)
			});
	});
var $turboMaCk$any_dict$Dict$Any$get = F2(
	function (k, _v0) {
		var dict = _v0.cL;
		var toKey = _v0.a3;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Dict$get,
				toKey(k),
				dict));
	});
var $author$project$Audit$Record$Records$get = function (recordId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Audit$Record$Records$unwrap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.cL;
			},
			$turboMaCk$any_dict$Dict$Any$get(recordId)));
};
var $author$project$Audit$Audit$applyRecordFilesAdded = F2(
	function (payload, _v0) {
		var modification = _v0.a;
		var fileOperations = _v0.b;
		var _v1 = $author$project$Audit$Audit$auditFromModification(modification);
		if (!_v1.$) {
			var audit = _v1.a;
			if (_Utils_eq(payload.gm, audit.gm) && (_Utils_cmp(payload.n, audit.i) > 0)) {
				var _v2 = A2($author$project$Audit$Record$Records$get, payload.bK, audit.io);
				if (!_v2.$) {
					var record = _v2.a;
					var newRecord = A2($author$project$Audit$Record$Record$addFiles, payload.cT, record);
					var newAudit = _Utils_update(
						audit,
						{
							io: A2($author$project$Audit$Record$Records$insert, newRecord, audit.io),
							i: payload.n
						});
					return _Utils_Tuple2(
						A2($author$project$Audit$Audit$Changed, newAudit, payload.N),
						fileOperations);
				} else {
					return _Utils_Tuple2(modification, fileOperations);
				}
			} else {
				return _Utils_Tuple2(modification, fileOperations);
			}
		} else {
			return _Utils_Tuple2(modification, fileOperations);
		}
	});
var $author$project$File$Operations$fromList = $author$project$Types$Queue$fromList;
var $author$project$Types$Queue$fold = F2(
	function (fn, acc) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Types$Queue$toList,
			A2($elm$core$List$foldl, fn, acc));
	});
var $author$project$Types$Queue$merge = $author$project$Types$Queue$fold($author$project$Types$Queue$enqueue);
var $author$project$File$Operations$merge = $author$project$Types$Queue$merge;
var $turboMaCk$any_set$Set$Any$remove = F2(
	function (a, _v0) {
		var dict = _v0;
		return A2($turboMaCk$any_dict$Dict$Any$remove, a, dict);
	});
var $author$project$File$Filenames$remove = $turboMaCk$any_set$Set$Any$remove;
var $author$project$Audit$Record$Record$removeFiles = F2(
	function (files, checkpointGroup) {
		var removeHelper = F2(
			function (file, filenames) {
				return A2($author$project$File$Filenames$remove, file, filenames);
			});
		return _Utils_update(
			checkpointGroup,
			{
				cT: A3($elm$core$List$foldl, removeHelper, checkpointGroup.cT, files)
			});
	});
var $author$project$Audit$Audit$applyRecordFilesRemoved = F2(
	function (payload, _v0) {
		var modification = _v0.a;
		var fileOperations = _v0.b;
		var _v1 = $author$project$Audit$Audit$auditFromModification(modification);
		if (!_v1.$) {
			var audit = _v1.a;
			if (_Utils_eq(payload.gm, audit.gm) && (_Utils_cmp(payload.n, audit.i) > 0)) {
				var _v2 = A2($author$project$Audit$Record$Records$get, payload.bK, audit.io);
				if (!_v2.$) {
					var record = _v2.a;
					var removeOperations = $author$project$File$Operations$fromList(
						A2(
							$elm$core$List$map,
							function (image) {
								return A2($author$project$File$Operation$Delete, true, image);
							},
							payload.cT));
					var newRecord = A2($author$project$Audit$Record$Record$removeFiles, payload.cT, record);
					var newAudit = _Utils_update(
						audit,
						{
							io: A2($author$project$Audit$Record$Records$insert, newRecord, audit.io),
							i: payload.n
						});
					return _Utils_Tuple2(
						A2($author$project$Audit$Audit$Changed, newAudit, payload.N),
						A2($author$project$File$Operations$merge, removeOperations, fileOperations));
				} else {
					return _Utils_Tuple2(modification, fileOperations);
				}
			} else {
				return _Utils_Tuple2(modification, fileOperations);
			}
		} else {
			return _Utils_Tuple2(modification, fileOperations);
		}
	});
var $author$project$Audit$Audit$applyTitleChanged = F2(
	function (payload, _v0) {
		var modification = _v0.a;
		var fileOperations = _v0.b;
		var _v1 = $author$project$Audit$Audit$auditFromModification(modification);
		if (!_v1.$) {
			var audit = _v1.a;
			if (_Utils_eq(payload.gm, audit.gm) && (_Utils_cmp(payload.n, audit.i) > 0)) {
				var newAudit = _Utils_update(
					audit,
					{i: payload.n, k8: payload.k8});
				return _Utils_Tuple2(
					A2($author$project$Audit$Audit$Changed, newAudit, payload.N),
					fileOperations);
			} else {
				return _Utils_Tuple2(modification, fileOperations);
			}
		} else {
			return _Utils_Tuple2(modification, fileOperations);
		}
	});
var $author$project$Audit$Audit$applyEventHelper = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $author$project$Audit$Audit$applyCreatedEvent(payload);
		case 1:
			var payload = event.a;
			return $author$project$Audit$Audit$applyCheckpointRecorded(payload);
		case 2:
			var payload = event.a;
			return $author$project$Audit$Audit$applyTitleChanged(payload);
		case 3:
			var payload = event.a;
			return $author$project$Audit$Audit$applyDescriptionChanged(payload);
		case 4:
			var payload = event.a;
			return $author$project$Audit$Audit$applyDeadlineChanged(payload);
		case 5:
			var payload = event.a;
			return $author$project$Audit$Audit$applyAuditorsChanged(payload);
		case 6:
			var payload = event.a;
			return $author$project$Audit$Audit$applyRecordFilesAdded(payload);
		case 7:
			var payload = event.a;
			return $author$project$Audit$Audit$applyRecordFilesRemoved(payload);
		case 8:
			var payload = event.a;
			return $author$project$Audit$Audit$applyCompletedEvent(payload);
		default:
			var payload = event.a;
			return $author$project$Audit$Audit$applyDeletedEvent(payload);
	}
};
var $author$project$Audit$Audit$applyEvent = F2(
	function (event, maybeAudit) {
		return A2(
			$author$project$Audit$Audit$applyEventHelper,
			event,
			_Utils_Tuple2(
				$author$project$Audit$Audit$NotModified(maybeAudit),
				$author$project$File$Operations$empty));
	});
var $author$project$Audit$Event$auditId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.gm;
		case 1:
			var payload = event.a;
			return payload.gm;
		case 2:
			var payload = event.a;
			return payload.gm;
		case 3:
			var payload = event.a;
			return payload.gm;
		case 4:
			var payload = event.a;
			return payload.gm;
		case 5:
			var payload = event.a;
			return payload.gm;
		case 6:
			var payload = event.a;
			return payload.gm;
		case 7:
			var payload = event.a;
			return payload.gm;
		case 8:
			var payload = event.a;
			return payload.gm;
		default:
			var payload = event.a;
			return payload.gm;
	}
};
var $author$project$Audit$Dict$get = $turboMaCk$any_dict$Dict$Any$get;
var $author$project$Audit$Audits$get = function (auditId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Audit$Audits$dict,
		$author$project$Audit$Dict$get(auditId));
};
var $author$project$Utils$Utils$with = F3(
	function (view, fn, value) {
		return A2(
			fn,
			view(value),
			value);
	});
var $author$project$Audit$Dict$insert = A2(
	$author$project$Utils$Utils$with,
	function ($) {
		return $.gm;
	},
	$turboMaCk$any_dict$Dict$Any$insert);
var $author$project$Audit$Audits$insert = F2(
	function (audit, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				cL: A2($author$project$Audit$Dict$insert, audit, data.cL)
			});
	});
var $author$project$Audit$Audits$remove = F2(
	function (auditId, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				cL: A2($author$project$Audit$Dict$remove, auditId, data.cL)
			});
	});
var $author$project$Audit$Modifications$NotEmpty = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$Ids$empty = $turboMaCk$any_set$Set$Any$empty($author$project$Audit$Id$toString);
var $author$project$Audit$Ids$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$Audit$Ids$remove = $turboMaCk$any_set$Set$Any$remove;
var $author$project$Audit$Dict$singleton = function (audit) {
	return A2($author$project$Audit$Dict$insert, audit, $author$project$Audit$Dict$empty);
};
var $author$project$Audit$Ids$singleton = function (id) {
	return A2($author$project$Audit$Ids$insert, id, $author$project$Audit$Ids$empty);
};
var $author$project$Audit$Modifications$with = F2(
	function (modification, modifications) {
		var _v0 = _Utils_Tuple2(modification, modifications);
		switch (_v0.a.$) {
			case 0:
				return modifications;
			case 1:
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var audit = _v1.a;
					var eventId = _v1.b;
					var _v2 = _v0.b;
					return $author$project$Audit$Modifications$NotEmpty(
						{
							bh: $author$project$Audit$Dict$singleton(audit),
							b$: $author$project$Audit$Ids$empty,
							dA: $author$project$Audit$Ids$empty,
							fD: eventId
						});
				} else {
					var _v3 = _v0.a;
					var audit = _v3.a;
					var eventId = _v3.b;
					var data = _v0.b.a;
					return $author$project$Audit$Modifications$NotEmpty(
						_Utils_update(
							data,
							{
								bh: A2($author$project$Audit$Dict$insert, audit, data.bh),
								fD: eventId
							}));
				}
			case 2:
				if (!_v0.b.$) {
					var _v4 = _v0.a;
					var auditId = _v4.a;
					var eventId = _v4.b;
					var _v5 = _v0.b;
					return $author$project$Audit$Modifications$NotEmpty(
						{
							bh: $author$project$Audit$Dict$empty,
							b$: $author$project$Audit$Ids$singleton(auditId),
							dA: $author$project$Audit$Ids$empty,
							fD: eventId
						});
				} else {
					var _v6 = _v0.a;
					var auditId = _v6.a;
					var eventId = _v6.b;
					var data = _v0.b.a;
					return $author$project$Audit$Modifications$NotEmpty(
						_Utils_update(
							data,
							{
								bh: A2($author$project$Audit$Dict$remove, auditId, data.bh),
								b$: A2($author$project$Audit$Ids$insert, auditId, data.b$),
								fD: eventId
							}));
				}
			default:
				if (!_v0.b.$) {
					var _v7 = _v0.a;
					var auditId = _v7.a;
					var eventId = _v7.b;
					var _v8 = _v0.b;
					return $author$project$Audit$Modifications$NotEmpty(
						{
							bh: $author$project$Audit$Dict$empty,
							b$: $author$project$Audit$Ids$empty,
							dA: $author$project$Audit$Ids$singleton(auditId),
							fD: eventId
						});
				} else {
					var _v9 = _v0.a;
					var auditId = _v9.a;
					var eventId = _v9.b;
					var data = _v0.b.a;
					return $author$project$Audit$Modifications$NotEmpty(
						_Utils_update(
							data,
							{
								bh: A2($author$project$Audit$Dict$remove, auditId, data.bh),
								b$: A2($author$project$Audit$Ids$remove, auditId, data.b$),
								dA: A2($author$project$Audit$Ids$insert, auditId, data.dA),
								fD: eventId
							}));
				}
		}
	});
var $author$project$Audit$Audits$withLastEventId = F2(
	function (eventId, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				fD: $elm$core$Maybe$Just(eventId)
			});
	});
var $author$project$Audit$Audits$applyEvent = F2(
	function (event, _v0) {
		var audits = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		var _v1 = A2(
			$author$project$Audit$Audit$applyEvent,
			event,
			A2(
				$author$project$Audit$Audits$get,
				$author$project$Audit$Event$auditId(event),
				audits));
		var modification = _v1.a;
		var newFileOperations = _v1.b;
		switch (modification.$) {
			case 0:
				return _Utils_Tuple3(
					audits,
					modifications,
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
			case 1:
				var audit = modification.a;
				var eventId = modification.b;
				return _Utils_Tuple3(
					A2(
						$author$project$Audit$Audits$withLastEventId,
						eventId,
						A2($author$project$Audit$Audits$insert, audit, audits)),
					A2($author$project$Audit$Modifications$with, modification, modifications),
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
			case 2:
				var auditId = modification.a;
				var eventId = modification.b;
				return _Utils_Tuple3(
					A2(
						$author$project$Audit$Audits$withLastEventId,
						eventId,
						A2($author$project$Audit$Audits$remove, auditId, audits)),
					A2($author$project$Audit$Modifications$with, modification, modifications),
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
			default:
				var auditId = modification.a;
				var eventId = modification.b;
				return _Utils_Tuple3(
					A2(
						$author$project$Audit$Audits$withLastEventId,
						eventId,
						A2($author$project$Audit$Audits$remove, auditId, audits)),
					A2($author$project$Audit$Modifications$with, modification, modifications),
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
		}
	});
var $author$project$Audit$Modifications$Empty = {$: 0};
var $author$project$Audit$Modifications$empty = $author$project$Audit$Modifications$Empty;
var $author$project$Audit$Events$fold = $author$project$Types$Queue$fold;
var $author$project$Audit$Audits$applyEvents = F2(
	function (events, audits) {
		return A3(
			$author$project$Audit$Events$fold,
			$author$project$Audit$Audits$applyEvent,
			_Utils_Tuple3(audits, $author$project$Audit$Modifications$empty, $author$project$File$Operations$empty),
			events);
	});
var $author$project$Audit$Store$audits = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Audit$Audits$empty;
		case 1:
			return $author$project$Audit$Audits$empty;
		case 2:
			var data = state.a;
			return data.aC;
		default:
			var data = state.a;
			return data.aC;
	}
};
var $author$project$Audit$Store$events = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Audit$Events$empty;
		case 1:
			var data = state.a;
			return data.b8;
		case 2:
			var data = state.a;
			return data.b8;
		default:
			var data = state.a;
			return data.b8;
	}
};
var $author$project$Utils$Triple$first = function (_v0) {
	var a = _v0.a;
	return a;
};
var $author$project$Environments$Repository$audits = function (_v0) {
	var data = _v0;
	return $author$project$Audit$Audits$dict(
		$author$project$Utils$Triple$first(
			A2(
				$author$project$Audit$Audits$applyEvents,
				$author$project$Audit$Store$events(data.aa),
				$author$project$Audit$Store$audits(data.aa))));
};
var $author$project$Environments$Repository$getAudit = function (auditId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Environments$Repository$audits,
		$author$project$Audit$Dict$get(auditId));
};
var $author$project$Audit$Commands$fold = $author$project$Types$Queue$fold;
var $author$project$Audit$Audit$DoesNotExist = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$EventId$from = $elm$core$Basics$identity;
var $author$project$Types$Queue$singleton = function (a) {
	return A2(
		$author$project$Types$Queue$Queue,
		_List_fromArray(
			[a]),
		_List_Nil);
};
var $author$project$Audit$Events$singleton = $author$project$Types$Queue$singleton;
var $author$project$Audit$Audit$handleAddRecordFilesCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Audit$Audit$DoesNotExist(payload.gm));
		} else {
			var audit = _v0.a;
			return $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Audit$Events$singleton(
							$author$project$Audit$Event$RecordFilesAdded(
								{gm: payload.gm, L: payload.L, M: payload.M, N: eventId, cT: payload.cT, bK: payload.bK, n: audit.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Audit$Audit$handleChangeAuditorsCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Audit$Audit$DoesNotExist(payload.gm));
		} else {
			var audit = _v0.a;
			return $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Audit$Events$singleton(
							$author$project$Audit$Event$AuditorsChanged(
								{ge: payload.ge, gm: payload.gm, L: payload.L, M: payload.M, N: eventId, g9: payload.g9, n: audit.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Audit$Audit$handleChangeDeadlineCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Audit$Audit$DoesNotExist(payload.gm));
		} else {
			var audit = _v0.a;
			return _Utils_eq(audit.hI, payload.hI) ? $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Audit$Events$empty, environment)) : $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Audit$Events$singleton(
							$author$project$Audit$Event$DeadlineChanged(
								{gm: payload.gm, L: payload.L, M: payload.M, hI: payload.hI, N: eventId, n: audit.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Audit$Audit$handleChangeDescriptionCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Audit$Audit$DoesNotExist(payload.gm));
		} else {
			var audit = _v0.a;
			return _Utils_eq(audit.aY, payload.aY) ? $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Audit$Events$empty, environment)) : $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Audit$Events$singleton(
							$author$project$Audit$Event$DescriptionChanged(
								{gm: payload.gm, L: payload.L, M: payload.M, aY: payload.aY, N: eventId, n: audit.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Audit$Audit$handleChangeTitleCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Audit$Audit$DoesNotExist(payload.gm));
		} else {
			var audit = _v0.a;
			return _Utils_eq(audit.k8, payload.k8) ? $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Audit$Events$empty, environment)) : $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Audit$Events$singleton(
							$author$project$Audit$Event$TitleChanged(
								{gm: payload.gm, L: payload.L, M: payload.M, N: eventId, k8: payload.k8, n: audit.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Audit$Audit$handleCompleteCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Audit$Events$empty, environment));
		} else {
			var audit = _v0.a;
			return $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Audit$Events$singleton(
							$author$project$Audit$Event$Completed(
								{gm: audit.gm, L: payload.L, M: payload.M, N: eventId, n: audit.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Audit$Audit$AlreadyExists = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$Audit$handleCreateCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Audit$Events$singleton(
							$author$project$Audit$Event$Created(
								{gm: payload.gm, bT: payload.bT, ff: payload.ff, L: payload.L, M: payload.M, dw: payload.dw, hI: payload.hI, aY: payload.aY, N: eventId, dH: payload.dH, fw: payload.fw, d5: payload.d5, d6: payload.d6, k8: payload.k8, n: 0}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		} else {
			var audit = _v0.a;
			return $elm$core$Result$Err(
				$author$project$Audit$Audit$AlreadyExists(audit.gm));
		}
	});
var $author$project$Audit$Audit$handleDeleteCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Audit$Events$empty, environment));
		} else {
			var audit = _v0.a;
			return $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Audit$Events$singleton(
							$author$project$Audit$Event$Deleted(
								{gm: audit.gm, L: payload.L, M: payload.M, N: eventId, n: audit.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Utils$Maybe$filter = function (fn) {
	return $elm$core$Maybe$andThen(
		function (a) {
			return fn(a) ? $elm$core$Maybe$Just(a) : $elm$core$Maybe$Nothing;
		});
};
var $author$project$Audit$Audit$handleRecordCheckpointCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Audit$Audit$DoesNotExist(payload.gm));
		} else {
			var audit = _v0.a;
			var maybeRecord = A2(
				$author$project$Utils$Maybe$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ll;
					},
					$elm$core$Basics$eq(payload.ct.ll)),
				A2($author$project$Audit$Record$Records$get, payload.ct.bK, audit.io));
			if (!maybeRecord.$) {
				return $elm$core$Result$Ok(
					_Utils_Tuple2($author$project$Audit$Events$empty, environment));
			} else {
				return $elm$core$Result$Ok(
					A2(
						$elm$core$Tuple$mapFirst,
						function (eventId) {
							return $author$project$Audit$Events$singleton(
								$author$project$Audit$Event$CheckpointRecorded(
									{gm: payload.gm, L: payload.L, M: payload.M, N: eventId, ct: payload.ct, n: audit.i + 1}));
						},
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Types$EventId$from,
							$author$project$Environments$Environment$generateUuid(environment))));
			}
		}
	});
var $author$project$Audit$Audit$handleRemoveRecordFilesCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Audit$Audit$auditFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Audit$Audit$DoesNotExist(payload.gm));
		} else {
			var audit = _v0.a;
			return $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Audit$Events$singleton(
							$author$project$Audit$Event$RecordFilesRemoved(
								{gm: payload.gm, L: payload.L, M: payload.M, N: eventId, cT: payload.cT, bK: payload.bK, n: audit.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Audit$Audit$applyEvents = F2(
	function (events, modification) {
		return A3($author$project$Audit$Events$fold, $author$project$Audit$Audit$applyEventHelper, modification, events);
	});
var $author$project$Audit$Commands$enqueue = $author$project$Types$Queue$enqueue;
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Types$Queue$isEmpty = function (_v0) {
	var front = _v0.a;
	var rear = _v0.b;
	return $elm$core$List$isEmpty(front) && $elm$core$List$isEmpty(rear);
};
var $author$project$Audit$Events$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$Audit$Events$merge = $author$project$Types$Queue$merge;
var $author$project$Audit$Audit$mapCommandResult = F3(
	function (command, acc, _v0) {
		var events = _v0.a;
		var environment = _v0.b;
		if ($author$project$Audit$Events$isEmpty(events)) {
			return _Utils_update(
				acc,
				{ac: environment});
		} else {
			var _v1 = A2(
				$author$project$Audit$Audit$applyEvents,
				events,
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.au;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newModifications = _v1.a;
			var newFileOperations = _v1.b;
			return _Utils_update(
				acc,
				{
					cD: A2($author$project$Audit$Commands$enqueue, command, acc.cD),
					ac: environment,
					b8: A2($author$project$Audit$Events$merge, acc.b8, events),
					cb: newFileOperations,
					au: newModifications
				});
		}
	});
var $author$project$Audit$Audit$handleCommandHelper = F2(
	function (command, acc) {
		switch (command.$) {
			case 0:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Audit$Audit$mapCommandResult, command, acc),
					A3($author$project$Audit$Audit$handleCreateCommand, payload, acc.ac, acc.au));
			case 1:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Audit$Audit$mapCommandResult, command, acc),
					A3($author$project$Audit$Audit$handleRecordCheckpointCommand, payload, acc.ac, acc.au));
			case 2:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Audit$Audit$mapCommandResult, command, acc),
					A3($author$project$Audit$Audit$handleChangeTitleCommand, payload, acc.ac, acc.au));
			case 3:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Audit$Audit$mapCommandResult, command, acc),
					A3($author$project$Audit$Audit$handleChangeDescriptionCommand, payload, acc.ac, acc.au));
			case 4:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Audit$Audit$mapCommandResult, command, acc),
					A3($author$project$Audit$Audit$handleChangeDeadlineCommand, payload, acc.ac, acc.au));
			case 5:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Audit$Audit$mapCommandResult, command, acc),
					A3($author$project$Audit$Audit$handleChangeAuditorsCommand, payload, acc.ac, acc.au));
			case 6:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Audit$Audit$mapCommandResult, command, acc),
					A3($author$project$Audit$Audit$handleAddRecordFilesCommand, payload, acc.ac, acc.au));
			case 7:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Audit$Audit$mapCommandResult, command, acc),
					A3($author$project$Audit$Audit$handleRemoveRecordFilesCommand, payload, acc.ac, acc.au));
			case 8:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Audit$Audit$mapCommandResult, command, acc),
					A3($author$project$Audit$Audit$handleCompleteCommand, payload, acc.ac, acc.au));
			default:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Audit$Audit$mapCommandResult, command, acc),
					A3($author$project$Audit$Audit$handleDeleteCommand, payload, acc.ac, acc.au));
		}
	});
var $author$project$Audit$Audit$handleCommands = F3(
	function (commands, environment, maybeAudit) {
		var acc = $elm$core$Result$Ok(
			{
				cD: $author$project$Audit$Commands$empty,
				ac: environment,
				b8: $author$project$Audit$Events$empty,
				cb: $author$project$File$Operations$empty,
				au: $author$project$Audit$Audit$NotModified(maybeAudit)
			});
		return A2(
			$elm$core$Result$map,
			function (data) {
				return {cD: data.cD, ac: data.ac, b8: data.b8, cb: data.cb};
			},
			A3(
				$author$project$Audit$Commands$fold,
				A2($elm$core$Basics$composeR, $author$project$Audit$Audit$handleCommandHelper, $elm$core$Result$andThen),
				acc,
				commands));
	});
var $author$project$Audit$Commands$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$Environments$Repository$unwrap = function (_v0) {
	var data = _v0;
	return data;
};
var $author$project$Environments$Repository$auditStore = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.aa;
	});
var $author$project$Environments$Repository$fileStore = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.ad;
	});
var $author$project$Audit$Store$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audit$Store$NotReady = 0;
var $author$project$Audit$Store$SaveCommandsAndEvents = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Audit$Commands$merge = $author$project$Types$Queue$merge;
var $author$project$Audit$Store$saveCommandsAndEvents = F3(
	function (commands_, events_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Audit$Store$Loaded(
							{
								aC: $author$project$Audit$Audits$empty,
								cD: A2($author$project$Audit$Commands$merge, data.cD, commands_),
								b8: A2($author$project$Audit$Events$merge, data.b8, events_)
							}),
						$author$project$Audit$Store$send(
							A2($author$project$Audit$Store$SaveCommandsAndEvents, commands_, events_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Audit$Store$Loaded(
							_Utils_update(
								data,
								{
									cD: A2($author$project$Audit$Commands$merge, data.cD, commands_),
									b8: A2($author$project$Audit$Events$merge, data.b8, events_)
								})),
						$author$project$Audit$Store$send(
							A2($author$project$Audit$Store$SaveCommandsAndEvents, commands_, events_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$File$Store$SaveModifications = function (a) {
	return {$: 2, a: a};
};
var $author$project$File$Store$Saving = function (a) {
	return {$: 2, a: a};
};
var $author$project$File$File$deleted = function (file) {
	switch (file.$) {
		case 0:
			var data = file.a;
			return $author$project$File$File$UserAvatar(
				_Utils_update(
					data,
					{dA: true}));
		case 1:
			var data = file.a;
			return $author$project$File$File$OrganisationUnitFile(
				_Utils_update(
					data,
					{dA: true}));
		case 2:
			var data = file.a;
			return $author$project$File$File$MeasureImage(
				_Utils_update(
					data,
					{dA: true}));
		default:
			var data = file.a;
			return $author$project$File$File$RecordImage(
				_Utils_update(
					data,
					{dA: true}));
	}
};
var $author$project$File$Dict$get = $turboMaCk$any_dict$Dict$Any$get;
var $author$project$File$Files$get = function (filename) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$File$Files$unwrap,
		$author$project$File$Dict$get(filename));
};
var $author$project$File$Dict$insert = A2($author$project$Utils$Utils$with, $author$project$File$File$filename, $turboMaCk$any_dict$Dict$Any$insert);
var $author$project$File$Files$insert = function (file) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$File$Files$unwrap,
		A2(
			$elm$core$Basics$composeR,
			$author$project$File$Dict$insert(file),
			$elm$core$Basics$identity));
};
var $author$project$File$Dict$remove = $turboMaCk$any_dict$Dict$Any$remove;
var $author$project$File$Files$remove = function (filename) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$File$Files$unwrap,
		A2(
			$elm$core$Basics$composeR,
			$author$project$File$Dict$remove(filename),
			$elm$core$Basics$identity));
};
var $author$project$File$Modifications$NotEmpty = function (a) {
	return {$: 1, a: a};
};
var $turboMaCk$any_dict$Dict$Any$singleton = F3(
	function (k, v, f) {
		return A3(
			$turboMaCk$any_dict$Dict$Any$insert,
			k,
			v,
			$turboMaCk$any_dict$Dict$Any$empty(f));
	});
var $author$project$File$Dict$singleton = function (file) {
	return A3(
		$turboMaCk$any_dict$Dict$Any$singleton,
		$author$project$File$File$filename(file),
		file,
		$author$project$File$Filename$toIdString);
};
var $author$project$File$Modifications$withChanged = F2(
	function (file, modifications) {
		if (!modifications.$) {
			return $author$project$File$Modifications$NotEmpty(
				{
					bh: $author$project$File$Dict$singleton(file),
					dA: $author$project$File$Filenames$empty
				});
		} else {
			var data = modifications.a;
			return $author$project$File$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						bh: A2($author$project$File$Dict$insert, file, data.bh)
					}));
		}
	});
var $author$project$File$Dict$empty = $turboMaCk$any_dict$Dict$Any$empty($author$project$File$Filename$toIdString);
var $turboMaCk$any_set$Set$Any$singleton = function (a) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$identity,
		A2($turboMaCk$any_dict$Dict$Any$singleton, a, 0));
};
var $author$project$File$Filenames$singleton = function (filename) {
	return A2($turboMaCk$any_set$Set$Any$singleton, filename, $author$project$File$Filename$toIdString);
};
var $author$project$File$Modifications$withDeleted = F2(
	function (filename, modifications) {
		if (!modifications.$) {
			return $author$project$File$Modifications$NotEmpty(
				{
					bh: $author$project$File$Dict$empty,
					dA: $author$project$File$Filenames$singleton(filename)
				});
		} else {
			var data = modifications.a;
			return $author$project$File$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						dA: A2($author$project$File$Filenames$insert, filename, data.dA)
					}));
		}
	});
var $author$project$File$Files$applyDeleteOperation = F3(
	function (_v0, filename, _v1) {
		var removeFromServer = _v0;
		var files = _v1.a;
		var modifications = _v1.b;
		var _v2 = A2($author$project$File$Files$get, filename, files);
		if (!_v2.$) {
			var file = _v2.a;
			if (removeFromServer) {
				var changedFile = $author$project$File$File$deleted(file);
				return _Utils_Tuple2(
					A2($author$project$File$Files$insert, changedFile, files),
					A2($author$project$File$Modifications$withChanged, changedFile, modifications));
			} else {
				return _Utils_Tuple2(
					A2($author$project$File$Files$remove, filename, files),
					A2($author$project$File$Modifications$withDeleted, filename, modifications));
			}
		} else {
			return _Utils_Tuple2(files, modifications);
		}
	});
var $author$project$File$File$localMeasureImage = F3(
	function (measureId, organisationUnitId, filename_) {
		return $author$project$File$File$MeasureImage(
			{dA: false, P: filename_, h5: measureId, km: organisationUnitId, kU: 0});
	});
var $author$project$File$Dict$member = $turboMaCk$any_dict$Dict$Any$member;
var $author$project$File$Files$member = function (filename) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$File$Files$unwrap,
		$author$project$File$Dict$member(filename));
};
var $author$project$File$Files$applyLocalCreateMeasureImage = F4(
	function (measureId, organisationUnitId, filename, _v0) {
		var files = _v0.a;
		var modifications = _v0.b;
		if (A2($author$project$File$Files$member, filename, files)) {
			return _Utils_Tuple2(files, modifications);
		} else {
			var newFile = A3($author$project$File$File$localMeasureImage, measureId, organisationUnitId, filename);
			return _Utils_Tuple2(
				A2($author$project$File$Files$insert, newFile, files),
				A2($author$project$File$Modifications$withChanged, newFile, modifications));
		}
	});
var $author$project$File$File$localOrganisationUnitFile = F2(
	function (organisationUnitId, filename_) {
		return $author$project$File$File$OrganisationUnitFile(
			{dA: false, fs: 0, P: filename_, km: organisationUnitId, kU: 0});
	});
var $author$project$File$Files$applyLocalCreateOrganisationUnitAvatar = F3(
	function (organisationUnitId, filename, _v0) {
		var files = _v0.a;
		var modifications = _v0.b;
		if (A2($author$project$File$Files$member, filename, files)) {
			return _Utils_Tuple2(files, modifications);
		} else {
			var newFile = A2($author$project$File$File$localOrganisationUnitFile, organisationUnitId, filename);
			return _Utils_Tuple2(
				A2($author$project$File$Files$insert, newFile, files),
				A2($author$project$File$Modifications$withChanged, newFile, modifications));
		}
	});
var $author$project$File$File$localRecordImage = F3(
	function (auditId, recordId, filename_) {
		return $author$project$File$File$RecordImage(
			{gm: auditId, dA: false, P: filename_, bK: recordId, kU: 0});
	});
var $author$project$File$Files$applyLocalCreateRecordImage = F4(
	function (auditId, recordId, filename, _v0) {
		var files = _v0.a;
		var modifications = _v0.b;
		if (A2($author$project$File$Files$member, filename, files)) {
			return _Utils_Tuple2(files, modifications);
		} else {
			var newFile = A3($author$project$File$File$localRecordImage, auditId, recordId, filename);
			return _Utils_Tuple2(
				A2($author$project$File$Files$insert, newFile, files),
				A2($author$project$File$Modifications$withChanged, newFile, modifications));
		}
	});
var $author$project$File$File$localUserAvatar = F2(
	function (userId, filename_) {
		return $author$project$File$File$UserAvatar(
			{dA: false, P: filename_, kU: 0, dk: userId});
	});
var $author$project$File$Files$applyLocalCreateUserAvatar = F3(
	function (userId, filename, _v0) {
		var files = _v0.a;
		var modifications = _v0.b;
		if (A2($author$project$File$Files$member, filename, files)) {
			return _Utils_Tuple2(files, modifications);
		} else {
			var newFile = A2($author$project$File$File$localUserAvatar, userId, filename);
			return _Utils_Tuple2(
				A2($author$project$File$Files$insert, newFile, files),
				A2($author$project$File$Modifications$withChanged, newFile, modifications));
		}
	});
var $author$project$File$Files$applyLocalOperation = function (operation) {
	switch (operation.$) {
		case 0:
			var userId = operation.a;
			var filename = operation.b;
			return A2($author$project$File$Files$applyLocalCreateUserAvatar, userId, filename);
		case 1:
			var organisationUnitId = operation.a;
			var filename = operation.b;
			return A2($author$project$File$Files$applyLocalCreateOrganisationUnitAvatar, organisationUnitId, filename);
		case 2:
			var measureId = operation.a;
			var organisationUnitId = operation.b;
			var filename = operation.c;
			return A3($author$project$File$Files$applyLocalCreateMeasureImage, measureId, organisationUnitId, filename);
		case 3:
			var auditId = operation.a;
			var recordId = operation.b;
			var filename = operation.c;
			return A3($author$project$File$Files$applyLocalCreateRecordImage, auditId, recordId, filename);
		default:
			var deleteFromServer = operation.a;
			var filename = operation.b;
			return A2($author$project$File$Files$applyDeleteOperation, deleteFromServer, filename);
	}
};
var $author$project$File$Operations$fold = $author$project$Types$Queue$fold;
var $author$project$File$Files$applyLocalOperations = F2(
	function (operations, acc) {
		return A3($author$project$File$Operations$fold, $author$project$File$Files$applyLocalOperation, acc, operations);
	});
var $author$project$File$Modifications$Empty = {$: 0};
var $author$project$File$Modifications$empty = $author$project$File$Modifications$Empty;
var $author$project$File$Synchronization$Started = function (a) {
	return {$: 1, a: a};
};
var $author$project$File$Synchronization$Synchronizing = function (a) {
	return {$: 2, a: a};
};
var $author$project$File$SynchronizationTask$Delete = function (a) {
	return {$: 2, a: a};
};
var $author$project$File$SynchronizationTask$Download = function (a) {
	return {$: 1, a: a};
};
var $author$project$File$SynchronizationTask$Upload = function (a) {
	return {$: 0, a: a};
};
var $author$project$File$File$isDeleted = function (file) {
	switch (file.$) {
		case 0:
			var data = file.a;
			return data.dA;
		case 1:
			var data = file.a;
			return data.dA;
		case 2:
			var data = file.a;
			return data.dA;
		default:
			var data = file.a;
			return data.dA;
	}
};
var $author$project$File$File$isLocal = function (file) {
	switch (file.$) {
		case 0:
			var data = file.a;
			return !data.kU;
		case 1:
			var data = file.a;
			return !data.kU;
		case 2:
			var data = file.a;
			return !data.kU;
		default:
			var data = file.a;
			return !data.kU;
	}
};
var $author$project$File$File$isRemote = function (file) {
	switch (file.$) {
		case 0:
			var data = file.a;
			return data.kU === 1;
		case 1:
			var data = file.a;
			return data.kU === 1;
		case 2:
			var data = file.a;
			return data.kU === 1;
		default:
			var data = file.a;
			return data.kU === 1;
	}
};
var $author$project$File$SynchronizationTask$fromFile = function (file) {
	return $author$project$File$File$isLocal(file) ? $elm$core$Maybe$Just(
		$author$project$File$SynchronizationTask$Upload(file)) : ($author$project$File$File$isDeleted(file) ? $elm$core$Maybe$Just(
		$author$project$File$SynchronizationTask$Delete(file)) : ($author$project$File$File$isRemote(file) ? $elm$core$Maybe$Just(
		$author$project$File$SynchronizationTask$Download(file)) : $elm$core$Maybe$Nothing));
};
var $author$project$File$SynchronizationTasks$fromList = $author$project$Types$Queue$fromList;
var $author$project$File$Dict$toList = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$File$Files$toList = A2($elm$core$Basics$composeR, $author$project$File$Files$unwrap, $author$project$File$Dict$toList);
var $author$project$File$SynchronizationTasks$fromFiles = A2(
	$elm$core$Basics$composeR,
	$author$project$File$Files$toList,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filterMap($author$project$File$SynchronizationTask$fromFile),
		$author$project$File$SynchronizationTasks$fromList));
var $author$project$File$Synchronization$withFiles = F2(
	function (files, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return $author$project$File$Synchronization$Started(
					$author$project$File$SynchronizationTasks$fromFiles(files));
			default:
				return $author$project$File$Synchronization$Synchronizing(
					$author$project$File$SynchronizationTasks$fromFiles(files));
		}
	});
var $author$project$File$Store$saveLocalOperations = F2(
	function (newOperations, state) {
		switch (state.$) {
			case 0:
				var data = state.a;
				return _Utils_Tuple2(
					$author$project$File$Store$Loading(
						_Utils_update(
							data,
							{
								Q: A2($author$project$File$Operations$merge, data.Q, newOperations)
							})),
					$elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				var _v1 = A2(
					$author$project$File$Files$applyLocalOperations,
					newOperations,
					_Utils_Tuple2(data.cT, $author$project$File$Modifications$empty));
				var newFiles = _v1.a;
				var modifications = _v1.b;
				var newSynchronization = A2($author$project$File$Synchronization$withFiles, newFiles, data.b);
				return _Utils_Tuple2(
					$author$project$File$Store$Saving(
						{cT: newFiles, Q: $author$project$File$Operations$empty, V: $author$project$File$Operations$empty, b: newSynchronization}),
					$author$project$File$Store$send(
						$author$project$File$Store$SaveModifications(modifications)));
			default:
				var data = state.a;
				return _Utils_Tuple2(
					$author$project$File$Store$Saving(
						_Utils_update(
							data,
							{
								Q: A2($author$project$File$Operations$merge, data.Q, newOperations)
							})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Environments$Repository$withAuditStore = F2(
	function (auditStore_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{aa: auditStore_});
	});
var $author$project$Environments$Repository$withFileStore = F2(
	function (fileStore_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{ad: fileStore_});
	});
var $author$project$Environments$Repository$saveAuditCommandsAndEventsAndFileOperations = F4(
	function (commands, events, fileOperations, repository) {
		var _v0 = A3(
			$author$project$Audit$Store$saveCommandsAndEvents,
			commands,
			events,
			$author$project$Environments$Repository$auditStore(repository));
		if (!_v0.$) {
			var _v1 = _v0.a;
			var newAuditStore = _v1.a;
			var auditStoreCmd = _v1.b;
			var _v2 = A2(
				$author$project$File$Store$saveLocalOperations,
				fileOperations,
				$author$project$Environments$Repository$fileStore(repository));
			var newFileStore = _v2.a;
			var fileStoreCmd = _v2.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Environments$Repository$withFileStore,
					newFileStore,
					A2($author$project$Environments$Repository$withAuditStore, newAuditStore, repository)),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[auditStoreCmd, fileStoreCmd])));
		} else {
			return _Utils_Tuple2(repository, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Audit$EditDialog$createdCommands = F4(
	function (commands, environment, repository, dialog) {
		if (dialog.$ === 2) {
			var model = dialog.a;
			var _v1 = A3(
				$author$project$Audit$Audit$handleCommands,
				$author$project$Audit$Commands$fromList(commands),
				environment,
				A2($author$project$Environments$Repository$getAudit, model.es.gm, repository));
			if (_v1.$ === 1) {
				var error = _v1.a;
				var _v2 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v2.a;
				var newEnvironment = _v2.b;
				var newError = {
					gg: '',
					gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
						$author$project$Environments$ErrorHandling$ToString$auditErrorToString(error)),
					gH: 'Audit.EditDialog.elm',
					gK: 'createdCommands',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: dialog,
					ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
					ae: repository
				};
			} else {
				var resultData = _v1.a;
				if ($author$project$Audit$Commands$isEmpty(resultData.cD) || $author$project$Audit$Events$isEmpty(resultData.b8)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Audit$EditDialog$Hidden, ac: environment, ae: repository};
				} else {
					var _v3 = A4($author$project$Environments$Repository$saveAuditCommandsAndEventsAndFileOperations, resultData.cD, resultData.b8, resultData.cb, repository);
					var newRepository = _v3.a;
					var cmd = _v3.b;
					return {ab: cmd, jn: $author$project$Audit$EditDialog$Hidden, ac: resultData.ac, ae: newRepository};
				}
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Utils$Http$SendAuditsCommand = 9;
var $author$project$Environments$Environment$baseUri = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.bC;
	});
var $author$project$Utils$Http$SendPost = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Utils$Http$encodeHeader = function (header) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(header.bn)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$string(header.ll))
			]));
};
var $author$project$Utils$Http$encodeOutMsg = F2(
	function (msg, resultTypeString) {
		if (!msg.$) {
			var url = msg.a;
			var data = msg.b;
			var headers = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SEND_POST')),
						_Utils_Tuple2(
						'resultType',
						$elm$json$Json$Encode$string(resultTypeString)),
						_Utils_Tuple2(
						'url',
						$elm$json$Json$Encode$string(url)),
						_Utils_Tuple2('data', data),
						_Utils_Tuple2(
						'headerArray',
						A2($elm$json$Json$Encode$list, $author$project$Utils$Http$encodeHeader, headers))
					]));
		} else {
			var url = msg.a;
			var headers = msg.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SEND_GET')),
						_Utils_Tuple2(
						'resultType',
						$elm$json$Json$Encode$string(resultTypeString)),
						_Utils_Tuple2(
						'url',
						$elm$json$Json$Encode$string(url)),
						_Utils_Tuple2(
						'headerArray',
						A2($elm$json$Json$Encode$list, $author$project$Utils$Http$encodeHeader, headers))
					]));
		}
	});
var $author$project$Utils$Http$httpOutbox = _Platform_outgoingPort('httpOutbox', $elm$core$Basics$identity);
var $author$project$Utils$Http$resultTypeToString = function (resultType) {
	switch (resultType) {
		case 0:
			return 'GET_USERS';
		case 1:
			return 'SEND_USER_COMMAND';
		case 2:
			return 'GET_ORGANISATION_UNITS';
		case 3:
			return 'SEND_ORGANISATION_UNIT_COMMAND';
		case 4:
			return 'GET_PLANS';
		case 5:
			return 'SEND_PLAN_COMMAND';
		case 6:
			return 'GET_AUDITS';
		case 7:
			return 'GET_AUDIT';
		case 8:
			return 'GET_AUDITS_ARCHIVE';
		case 9:
			return 'SEND_AUDIT_COMMAND';
		case 10:
			return 'GET_MEASURES';
		case 11:
			return 'GET_MEASURES_ARCHIVE';
		case 12:
			return 'SEND_MEASURE_COMMAND';
		case 13:
			return 'GET_TENANT';
		case 14:
			return 'SEND_TENANT_COMMAND';
		case 15:
			return 'GET_CHECKPOINT_GROUPS';
		case 16:
			return 'SEND_CHECKPOINT_GROUP_COMMAND';
		case 17:
			return 'GET_RIGHTS';
		case 18:
			return 'SEND_RIGHTS_COMMAND';
		case 19:
			return 'GET_COMBINED_ARCHIVE';
		default:
			return 'GET_CHECKPOINT_HISTORY';
	}
};
var $author$project$Utils$Http$sendPost = F4(
	function (url, resultType, value, headers) {
		var outMsg = A3($author$project$Utils$Http$SendPost, url, value, headers);
		return $author$project$Utils$Http$httpOutbox(
			A2(
				$author$project$Utils$Http$encodeOutMsg,
				outMsg,
				$author$project$Utils$Http$resultTypeToString(resultType)));
	});
var $author$project$Audit$EditDialog$deleteRequest = F2(
	function (command, environment) {
		var baseUrl = $author$project$Environments$Environment$baseUri(environment) + '/audits/command/delete';
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Audit$EditDialog$GotDeleteResponse,
			A4(
				$author$project$Utils$Http$sendPost,
				baseUrl,
				9,
				$author$project$Audit$Command$encode(command),
				_List_Nil));
	});
var $author$project$Environments$Network$isOnline = $elm$core$Basics$eq(0);
var $author$project$Environments$Environment$isOnline = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.c3;
		},
		$author$project$Environments$Network$isOnline));
var $author$project$Environments$Environment$isOffline = A2($elm$core$Basics$composeR, $author$project$Environments$Environment$isOnline, $elm$core$Basics$not);
var $author$project$Audit$EditDialog$createdDeleteCommand = F4(
	function (command, environment, repository, dialog) {
		return $author$project$Environments$Environment$isOffline(environment) ? {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository} : {
			ab: A2($author$project$Audit$EditDialog$deleteRequest, command, environment),
			jn: dialog,
			ac: environment,
			ae: repository
		};
	});
var $author$project$Audit$EditDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Environments$Environment$timeOffset = function (state) {
	var model = $author$project$Environments$Environment$unwrap(state);
	return model.cw.d0;
};
var $author$project$Date_Time$NaiveTime$toUtcTime = F2(
	function (offset, _v0) {
		var h = _v0.a;
		var m = _v0.b;
		var s = _v0.c;
		var offsetInHours = $elm$core$Basics$round(offset / ((60 * 60) * 1000));
		var calculatedHour = h - offsetInHours;
		var newHour = ((calculatedHour >= 0) && (calculatedHour <= 23)) ? calculatedHour : ((calculatedHour < 0) ? (24 + calculatedHour) : (calculatedHour - 24));
		return A3($author$project$Date_Time$NaiveTime$NaiveTime, newHour, m, s);
	});
var $author$project$Audit$EditDialog$addHourValue = F3(
	function (environment, hourInput, model) {
		if ($elm$core$String$isEmpty(hourInput)) {
			return _Utils_update(
				model,
				{cf: hourInput});
		} else {
			if ($elm$core$String$isEmpty(model.cj)) {
				var _v0 = $elm$core$String$toInt(hourInput);
				if (_v0.$ === 1) {
					return model;
				} else {
					var hour = _v0.a;
					return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
						model,
						{cf: hourInput}) : model;
				}
			} else {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(hourInput),
					$elm$core$String$toInt(model.cj));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var hour = _v1.a.a;
					var minute = _v1.b.a;
					var _v2 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
					if (!_v2.$) {
						var naiveTime = _v2.a;
						return _Utils_update(
							model,
							{
								ex: A2(
									$author$project$Date_Time$NaiveTime$toUtcTime,
									$author$project$Environments$Environment$timeOffset(environment),
									naiveTime),
								cf: hourInput
							});
					} else {
						return model;
					}
				} else {
					return model;
				}
			}
		}
	});
var $author$project$Audit$EditDialog$enteredHour = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Audit$EditDialog$Visible(
					A3($author$project$Audit$EditDialog$addHourValue, environment, input, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$EditDialog$EditArchived = 1;
var $author$project$Audit$EditDialog$addMinuteValue = F3(
	function (environment, minuteInput, model) {
		if ($elm$core$String$isEmpty(minuteInput)) {
			return _Utils_update(
				model,
				{cj: minuteInput});
		} else {
			if ($elm$core$String$isEmpty(model.cf)) {
				var _v0 = $elm$core$String$toInt(minuteInput);
				if (_v0.$ === 1) {
					return model;
				} else {
					var hour = _v0.a;
					return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
						model,
						{cj: minuteInput}) : model;
				}
			} else {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(model.cf),
					$elm$core$String$toInt(minuteInput));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var hour = _v1.a.a;
					var minute = _v1.b.a;
					var _v2 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
					if (!_v2.$) {
						var naiveTime = _v2.a;
						return _Utils_update(
							model,
							{
								ex: A2(
									$author$project$Date_Time$NaiveTime$toUtcTime,
									$author$project$Environments$Environment$timeOffset(environment),
									naiveTime),
								cj: minuteInput
							});
					} else {
						return model;
					}
				} else {
					return model;
				}
			}
		}
	});
var $author$project$Audit$EditDialog$enteredMinute = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return (model.aq === 1) ? {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository} : {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Audit$EditDialog$Visible(
					A3($author$project$Audit$EditDialog$addMinuteValue, environment, input, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$UI$BasicDataEditor$Editor = $elm$core$Basics$identity;
var $author$project$UI$BasicDataEditor$WithColorPicker = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$ColorPicker$State = $elm$core$Basics$identity;
var $author$project$UI$ColorPicker$Unpressed = {$: 0};
var $author$project$UI$Style$Color$hsla = F4(
	function (hue, sat, light, alpha) {
		var _v0 = _Utils_Tuple3(hue, sat, light);
		var h = _v0.a;
		var s = _v0.b;
		var l = _v0.c;
		var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
		var m1 = (l * 2) - m2;
		var hueToRgb = function (h__) {
			var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
			return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
		};
		var b = hueToRgb(h - (1 / 3));
		var g = hueToRgb(h);
		var r = hueToRgb(h + (1 / 3));
		return A4($author$project$UI$Style$Color$Rgba, r, g, b, alpha);
	});
var $author$project$UI$Style$Color$fromHsla = function (_v0) {
	var hue = _v0.Z;
	var saturation = _v0.dc;
	var lightness = _v0.c2;
	var alpha = _v0.eq;
	return A4($author$project$UI$Style$Color$hsla, hue, saturation, lightness, alpha);
};
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$UI$Style$Color$toHsla = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var minColor = A2(
		$elm$core$Basics$min,
		r,
		A2($elm$core$Basics$min, g, b));
	var maxColor = A2(
		$elm$core$Basics$max,
		r,
		A2($elm$core$Basics$max, g, b));
	var l = (minColor + maxColor) / 2;
	var s = _Utils_eq(minColor, maxColor) ? 0 : ((l < 0.5) ? ((maxColor - minColor) / (maxColor + minColor)) : ((maxColor - minColor) / ((2 - maxColor) - minColor)));
	var h1 = _Utils_eq(maxColor, r) ? ((g - b) / (maxColor - minColor)) : (_Utils_eq(maxColor, g) ? (2 + ((b - r) / (maxColor - minColor))) : (4 + ((r - g) / (maxColor - minColor))));
	var h2 = h1 * (1 / 6);
	var h3 = $elm$core$Basics$isNaN(h2) ? 0 : ((h2 < 0) ? (h2 + 1) : h2);
	return {eq: a, Z: h3, c2: l, dc: s};
};
var $author$project$UI$ColorPicker$widgetWidth = 200;
var $author$project$UI$ColorPicker$calcHue = F2(
	function (col, _v0) {
		var x = _v0.am;
		var mousePressed = _v0.dY;
		var hue = x / $author$project$UI$ColorPicker$widgetWidth;
		var hsla = $author$project$UI$Style$Color$toHsla(col);
		var saturation = hsla.dc;
		var lightness = hsla.c2;
		var alpha = hsla.eq;
		var newCol = ((!saturation) && (lightness < 0.02)) ? _Utils_update(
			hsla,
			{Z: hue, c2: 0.5, dc: 0.5}) : _Utils_update(
			hsla,
			{Z: hue});
		return $author$project$UI$Style$Color$fromHsla(newCol);
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $author$project$UI$ColorPicker$calcOpacity = F3(
	function (col, _v0, _v1) {
		var x = _v1.am;
		var mousePressed = _v1.dY;
		var hsla = $author$project$UI$Style$Color$toHsla(col);
		return $author$project$UI$Style$Color$fromHsla(
			_Utils_update(
				hsla,
				{
					eq: A3($elm$core$Basics$clamp, 0, $author$project$UI$ColorPicker$widgetWidth, x) / $author$project$UI$ColorPicker$widgetWidth
				}));
	});
var $author$project$UI$ColorPicker$widgetHeight = 150;
var $author$project$UI$ColorPicker$calcSatLight = F3(
	function (col, currHue, _v0) {
		var x = _v0.am;
		var y = _v0.bf;
		var mousePressed = _v0.dY;
		var hsla = $author$project$UI$Style$Color$toHsla(col);
		return $author$project$UI$Style$Color$fromHsla(
			_Utils_update(
				hsla,
				{Z: currHue, c2: 1 - (y / $author$project$UI$ColorPicker$widgetHeight), dc: x / $author$project$UI$ColorPicker$widgetWidth}));
	});
var $author$project$UI$ColorPicker$setHue = F3(
	function (mouseTarget, mouseInfo, model) {
		switch (mouseTarget.$) {
			case 1:
				var hue = mouseTarget.a;
				return _Utils_update(
					model,
					{
						Z: $elm$core$Maybe$Just(
							A2($elm$core$Maybe$withDefault, hue, model.Z))
					});
			case 2:
				return _Utils_update(
					model,
					{
						Z: $elm$core$Maybe$Just(mouseInfo.am / $author$project$UI$ColorPicker$widgetWidth)
					});
			case 3:
				var hue = mouseTarget.a;
				return _Utils_update(
					model,
					{
						Z: $elm$core$Maybe$Just(
							A2($elm$core$Maybe$withDefault, hue, model.Z))
					});
			default:
				return model;
		}
	});
var $author$project$UI$ColorPicker$setMouseTarget = F2(
	function (mouseTarget, model) {
		return _Utils_update(
			model,
			{ck: mouseTarget});
	});
var $author$project$UI$ColorPicker$setTextInput = F2(
	function (str, model) {
		return _Utils_update(
			model,
			{o: str});
	});
var $author$project$UI$ColorPicker$updateHueAfterInput = F2(
	function (maybeColor, model) {
		if (!maybeColor.$) {
			var color_ = maybeColor.a;
			var _v1 = $author$project$UI$Style$Color$toHsla(color_);
			var hue = _v1.Z;
			var saturation = _v1.dc;
			var lightness = _v1.c2;
			var alpha = _v1.eq;
			return _Utils_update(
				model,
				{
					Z: $elm$core$Maybe$Just(hue)
				});
		} else {
			return model;
		}
	});
var $author$project$UI$ColorPicker$updateTextInput = F2(
	function (maybeColor, model) {
		if (!maybeColor.$) {
			var color_ = maybeColor.a;
			return _Utils_update(
				model,
				{
					o: $author$project$UI$Style$Color$toHex(color_)
				});
		} else {
			return model;
		}
	});
var $author$project$UI$ColorPicker$update_ = F3(
	function (message, col, model) {
		var calcNewColor = function (mouseTarget) {
			switch (mouseTarget.$) {
				case 1:
					var hue = mouseTarget.a;
					return A2(
						$elm$core$Basics$composeL,
						$elm$core$Maybe$Just,
						A2(
							$author$project$UI$ColorPicker$calcSatLight,
							col,
							A2($elm$core$Maybe$withDefault, hue, model.Z)));
				case 2:
					return A2(
						$elm$core$Basics$composeL,
						$elm$core$Maybe$Just,
						$author$project$UI$ColorPicker$calcHue(col));
				case 3:
					var hue = mouseTarget.a;
					return A2(
						$elm$core$Basics$composeL,
						$elm$core$Maybe$Just,
						A2(
							$author$project$UI$ColorPicker$calcOpacity,
							col,
							A2($elm$core$Maybe$withDefault, hue, model.Z)));
				default:
					return function (_v2) {
						return $elm$core$Maybe$Nothing;
					};
			}
		};
		var handleMouseMove = F2(
			function (mouseTarget, mouseInfo) {
				if (mouseInfo.dY && _Utils_eq(model.ck, mouseTarget)) {
					var maybeColor = A2(calcNewColor, mouseTarget, mouseInfo);
					return _Utils_Tuple2(
						A2(
							$author$project$UI$ColorPicker$updateTextInput,
							maybeColor,
							A3($author$project$UI$ColorPicker$setHue, mouseTarget, mouseInfo, model)),
						maybeColor);
				} else {
					if ((!mouseInfo.dY) && _Utils_eq(model.ck, mouseTarget)) {
						return _Utils_Tuple2(
							A2($author$project$UI$ColorPicker$setMouseTarget, $author$project$UI$ColorPicker$Unpressed, model),
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
					}
				}
			});
		switch (message.$) {
			case 0:
				var mouseTarget = message.a;
				var mouseInfo = message.b;
				var maybeColor = A2(calcNewColor, mouseTarget, mouseInfo);
				return _Utils_Tuple2(
					A2(
						$author$project$UI$ColorPicker$updateTextInput,
						maybeColor,
						A3(
							$author$project$UI$ColorPicker$setHue,
							mouseTarget,
							mouseInfo,
							A2($author$project$UI$ColorPicker$setMouseTarget, mouseTarget, model))),
					maybeColor);
			case 1:
				var mouseTarget = message.a;
				var mouseInfo = message.b;
				return A2(handleMouseMove, mouseTarget, mouseInfo);
			case 2:
				var mouseTarget = message.a;
				var mouseInfo = message.b;
				var maybeColor = A2(calcNewColor, mouseTarget, mouseInfo);
				return _Utils_Tuple2(
					A2(
						$author$project$UI$ColorPicker$updateTextInput,
						maybeColor,
						A3($author$project$UI$ColorPicker$setHue, mouseTarget, mouseInfo, model)),
					maybeColor);
			case 3:
				return _Utils_Tuple2(
					A2($author$project$UI$ColorPicker$setMouseTarget, $author$project$UI$ColorPicker$Unpressed, model),
					$elm$core$Maybe$Nothing);
			case 4:
				var str = message.a;
				var maybeColor = $author$project$UI$Style$Color$fromHex(str);
				return _Utils_Tuple2(
					A2(
						$author$project$UI$ColorPicker$updateHueAfterInput,
						maybeColor,
						A2($author$project$UI$ColorPicker$setTextInput, str, model)),
					maybeColor);
			default:
				return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$UI$ColorPicker$update = F3(
	function (message, col, _v0) {
		var model = _v0;
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Basics$identity,
			A3($author$project$UI$ColorPicker$update_, message, col, model));
	});
var $author$project$UI$BasicDataEditor$gotColorPickerMsg = F2(
	function (colorPickerMsg, editor_) {
		var model = editor_;
		var _v0 = model.aF;
		if (!_v0.$) {
			return editor_;
		} else {
			var withColorPickerModel = _v0.a;
			var _v1 = A3($author$project$UI$ColorPicker$update, colorPickerMsg, withColorPickerModel.K, withColorPickerModel.aF);
			var state = _v1.a;
			var color_ = _v1.b;
			return _Utils_update(
				model,
				{
					aF: $author$project$UI$BasicDataEditor$WithColorPicker(
						{
							K: A2($elm$core$Maybe$withDefault, withColorPickerModel.K, color_),
							aF: state
						})
				});
		}
	});
var $author$project$UI$BasicDataEditor$withDescription = F2(
	function (description_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{aY: description_});
	});
var $author$project$UI$BasicDataEditor$withTitle = F2(
	function (title_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{k8: title_});
	});
var $author$project$UI$BasicDataEditor$update = function (msg) {
	switch (msg.$) {
		case 0:
			var title_ = msg.a;
			return $author$project$UI$BasicDataEditor$withTitle(title_);
		case 1:
			var description_ = msg.a;
			return $author$project$UI$BasicDataEditor$withDescription(description_);
		default:
			var colorPickerMsg = msg.a;
			return $author$project$UI$BasicDataEditor$gotColorPickerMsg(colorPickerMsg);
	}
};
var $author$project$Audit$EditDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return (model.aq === 1) ? {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository} : {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Audit$EditDialog$Visible(
					_Utils_update(
						model,
						{
							aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Environments$Route$Archive = {$: 11};
var $author$project$Environments$ErrorHandling$Error$DecodeError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Environments$ErrorHandling$Error$HttpError = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Environments$ErrorHandling$Error$OtherError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Environments$Environment$navigateTo = function (route_) {
	return $author$project$Environments$Environment$map(
		function (model) {
			return _Utils_eq(model.eb, route_) ? model : _Utils_update(
				model,
				{
					d$: $elm$core$Maybe$Just(route_)
				});
		});
};
var $author$project$Audit$EditDialog$gotDeleteResponse = F4(
	function (httpMsg, environment, repository, dialog) {
		if (dialog.$ === 2) {
			switch (httpMsg.$) {
				case 15:
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: $author$project$Audit$EditDialog$Hidden,
						ac: A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Archive, environment),
						ae: repository
					};
				case 16:
					var status = httpMsg.a;
					var responseMessage = httpMsg.b;
					var resultType = httpMsg.c;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var updatedEnvironment = _v2.b;
					var newError = {
						gg: resultType,
						gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
						gH: 'Audit/EditDialog.elm',
						gK: 'gotDeleteResponse',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: dialog,
						ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
						ae: repository
					};
				case 0:
					var resultType = httpMsg.a;
					var _v3 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v3.a;
					var updatedEnvironment = _v3.b;
					var newError = {
						gg: 'Unknown return from Javascript in http handler. index.js -> initHttpPort',
						gE: $author$project$Environments$ErrorHandling$Error$OtherError(resultType),
						gH: 'Audit/EditDialog.elm',
						gK: 'gotDeleteResponse',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: dialog,
						ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
						ae: repository
					};
				case 1:
					var decodeError = httpMsg.a;
					var _v4 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v4.a;
					var updatedEnvironment = _v4.b;
					var newError = {
						gg: 'Error while Decoding incoming http request',
						gE: $author$project$Environments$ErrorHandling$Error$DecodeError(decodeError),
						gH: 'Audit/EditDialog.elm',
						gK: 'gotDeleteResponse',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: dialog,
						ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
						ae: repository
					};
				default:
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$UI$DatePicker$value = function (_v0) {
	var model = _v0;
	return model.ll;
};
var $author$project$UI$DateInput$maybeDatePickerDate = function (state) {
	if (!state.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var datePicker = state.a;
		return $author$project$UI$DatePicker$value(datePicker);
	}
};
var $author$project$Audit$EditDialog$userChangedEndDateInput = F4(
	function (state, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (model.aq === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var _v1 = function () {
					var _v2 = $author$project$UI$DateInput$maybeDatePickerDate(state);
					if (!_v2.$) {
						var newDate = _v2.a;
						return _Utils_Tuple2(newDate, $elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple2(model.bl, model.dy);
					}
				}();
				var deadlineDate = _v1.a;
				var dateTextInput = _v1.b;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Audit$EditDialog$Visible(
						_Utils_update(
							model,
							{dy: dateTextInput, bl: deadlineDate, cQ: state})),
					ac: environment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$EditDialog$CreatedCommands = function (a) {
	return {$: 12, a: a};
};
var $author$project$Audit$EditDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$CommandId$from = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Audit$Command$commandHelper = F2(
	function (environment, buildCommand) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Types$CommandId$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var commandId_ = _v0.a;
		var newEnvironment = _v0.b;
		return _Utils_Tuple2(
			newEnvironment,
			A2(
				$elm$core$Task$map,
				buildCommand(commandId_),
				$elm$time$Time$now));
	});
var $author$project$Audit$Command$changeAuditors = F6(
	function (environment, auditId_, idForError, titleForError, addAuditors, removeAuditors) {
		return A2(
			$author$project$Audit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Audit$Command$ChangeAuditors(
						{ge: addAuditors, gm: auditId_, L: commandId_, M: commandTimestamp, k: idForError, g9: removeAuditors, l: titleForError});
				}));
	});
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $turboMaCk$any_dict$Dict$Any$isEmpty = function (_v0) {
	var dict = _v0.cL;
	return $elm$core$Dict$isEmpty(dict);
};
var $turboMaCk$any_set$Set$Any$isEmpty = function (_v0) {
	var dict = _v0;
	return $turboMaCk$any_dict$Dict$Any$isEmpty(dict);
};
var $author$project$User$Ids$isEmpty = $turboMaCk$any_set$Set$Any$isEmpty;
var $author$project$Audit$EditDialog$withAddResponsibleUsersCommand = F4(
	function (audit, addAuditors, removeAuditors, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return ($author$project$User$Ids$isEmpty(addAuditors) && $author$project$User$Ids$isEmpty(removeAuditors)) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A6($author$project$Audit$Command$changeAuditors, environment, audit.gm, audit.fw, audit.k8, addAuditors, removeAuditors));
	});
var $author$project$Audit$Command$changeDeadline = F5(
	function (environment, auditId_, idForError, titleForError, deadlineTimestamp) {
		return A2(
			$author$project$Audit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Audit$Command$ChangeDeadline(
						{gm: auditId_, L: commandId_, M: commandTimestamp, hI: deadlineTimestamp, k: idForError, l: titleForError});
				}));
	});
var $author$project$Date_Time$Month$fromMonth = function (m) {
	switch (m) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		default:
			return 11;
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.bx, posixMinutes) < 0) {
					return posixMinutes + era.d0;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		dz: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		gZ: month,
		iL: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).dz;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).gZ;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).iL;
	});
var $author$project$Date_Time$NaiveDate$fromPosix = F2(
	function (timeZone, time) {
		var y = A2($elm$time$Time$toYear, timeZone, time);
		var m = $author$project$Date_Time$Month$fromMonth(
			A2($elm$time$Time$toMonth, timeZone, time));
		var d = A2($elm$time$Time$toDay, timeZone, time);
		return A3($author$project$Date_Time$NaiveDate$NaiveDate, y, m, d);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $author$project$Date_Time$NaiveTime$fromPosix = F2(
	function (timeZone, time) {
		var s = A2($elm$time$Time$toSecond, timeZone, time);
		var m = A2($elm$time$Time$toMinute, timeZone, time);
		var h = A2($elm$time$Time$toHour, timeZone, time);
		return A3($author$project$Date_Time$NaiveTime$NaiveTime, h, m, s);
	});
var $author$project$Date_Time$NaiveTime$toMillis = function (_v0) {
	var h = _v0.a;
	var m = _v0.b;
	var s = _v0.c;
	return ((h * 3600000) + (m * 60000)) + (s * 1000);
};
var $author$project$Date_Time$NaiveDate$countLeapYears = function (year_) {
	var max = ((year_ / 4) | 0) - 492;
	var _false = ((year_ / 400) | 0) - 4;
	var century = ((year_ / 100) | 0) - 19;
	return max + (century - _false);
};
var $author$project$Date_Time$NaiveDate$daysBeforeMonth = F2(
	function (m, y) {
		var addLeap = $author$project$Date_Time$NaiveDate$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + addLeap;
			case 3:
				return 90 + addLeap;
			case 4:
				return 120 + addLeap;
			case 5:
				return 151 + addLeap;
			case 6:
				return 181 + addLeap;
			case 7:
				return 212 + addLeap;
			case 8:
				return 243 + addLeap;
			case 9:
				return 273 + addLeap;
			case 10:
				return 304 + addLeap;
			default:
				return 334 + addLeap;
		}
	});
var $author$project$Date_Time$NaiveDate$millisInDay = 86400000;
var $author$project$Date_Time$NaiveDate$toPosix = function (_v0) {
	var y = _v0.a;
	var m = _v0.b;
	var d = _v0.c;
	var days = (((y * 365) + $author$project$Date_Time$NaiveDate$countLeapYears(y - 1)) + A2($author$project$Date_Time$NaiveDate$daysBeforeMonth, m, y)) + (d - 1);
	var epoch = (days - 719050) * $author$project$Date_Time$NaiveDate$millisInDay;
	return $elm$time$Time$millisToPosix(epoch);
};
var $author$project$Audit$EditDialog$withChangeDeadlineCommand = F4(
	function (audit, newDate, newTime, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var oldTime = A2($author$project$Date_Time$NaiveTime$fromPosix, $elm$time$Time$utc, audit.hI);
		var oldDate = A2($author$project$Date_Time$NaiveDate$fromPosix, $elm$time$Time$utc, audit.hI);
		if (_Utils_eq(newDate, oldDate) && _Utils_eq(newTime, oldTime)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var newDeadline = $elm$time$Time$millisToPosix(
				$elm$time$Time$posixToMillis(
					$author$project$Date_Time$NaiveDate$toPosix(newDate)) + $author$project$Date_Time$NaiveTime$toMillis(newTime));
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A5($author$project$Audit$Command$changeDeadline, environment, audit.gm, audit.fw, audit.k8, newDeadline));
		}
	});
var $author$project$Audit$Command$changeDescription = F2(
	function (environment, payload) {
		return A2(
			$author$project$Audit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Audit$Command$ChangeDescription(
						{gm: payload.gm, L: commandId_, M: commandTimestamp, aY: payload.aY, k: payload.k, l: payload.l});
				}));
	});
var $author$project$UI$BasicDataEditor$unwrap = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$UI$BasicDataEditor$description = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$BasicDataEditor$unwrap,
	function ($) {
		return $.aY;
	});
var $author$project$Audit$EditDialog$withChangeDescriptionCommand = F3(
	function (audit, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var _v1 = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$description(basicDataEditor));
		if (_v1 === '') {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var description = _v1;
			return _Utils_eq(description, audit.aY) ? _Utils_Tuple2(environment, tasks) : A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2(
					$author$project$Audit$Command$changeDescription,
					environment,
					{gm: audit.gm, aY: description, k: audit.fw, l: audit.k8}));
		}
	});
var $author$project$Audit$Command$changeTitle = F2(
	function (environment, payload) {
		return A2(
			$author$project$Audit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Audit$Command$ChangeTitle(
						{gm: payload.gm, L: commandId_, M: commandTimestamp, k: payload.k, k8: payload.k8, l: payload.l});
				}));
	});
var $author$project$UI$BasicDataEditor$title = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$BasicDataEditor$unwrap,
	function ($) {
		return $.k8;
	});
var $author$project$Audit$EditDialog$withChangeTitleCommand = F3(
	function (audit, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var _v1 = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		if (_v1 === '') {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var title = _v1;
			return _Utils_eq(title, audit.k8) ? _Utils_Tuple2(environment, tasks) : A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2(
					$author$project$Audit$Command$changeTitle,
					environment,
					{gm: audit.gm, k: audit.fw, k8: title, l: audit.k8}));
		}
	});
var $author$project$Audit$EditDialog$createCommands = F2(
	function (environment, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A4(
				$author$project$Audit$EditDialog$withAddResponsibleUsersCommand,
				model.es,
				model.ge,
				model.g9,
				A4(
					$author$project$Audit$EditDialog$withChangeDeadlineCommand,
					model.es,
					model.bl,
					model.ex,
					A3(
						$author$project$Audit$EditDialog$withChangeDescriptionCommand,
						model.es,
						model.aQ,
						A3(
							$author$project$Audit$EditDialog$withChangeTitleCommand,
							model.es,
							model.aQ,
							_Utils_Tuple2(environment, _List_Nil))))));
	});
var $author$project$Utils$String$isBlank = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty);
var $author$project$Audit$EditDialog$userClickedApplyButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if ($author$project$Utils$String$isBlank(
				$author$project$UI$BasicDataEditor$title(model.aQ)) || (model.aq === 1)) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var _v1 = A2($author$project$Audit$EditDialog$createCommands, environment, model);
				var newEnvironment = _v1.a;
				var tasks = _v1.b;
				return {
					ab: A2(
						$elm$core$Task$perform,
						$author$project$Audit$EditDialog$CreatedCommands,
						$elm$core$Task$sequence(tasks)),
					jn: $author$project$Audit$EditDialog$HandlingCommands(model),
					ac: newEnvironment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$EditDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Audit$EditDialog$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$EditDialog$userClickedCloseButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Audit$EditDialog$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$EditDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Audit$EditDialog$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$EditDialog$CreatedDeleteCommand = function (a) {
	return {$: 14, a: a};
};
var $turboMaCk$any_set$Set$Any$member = F2(
	function (a, _v0) {
		var dict = _v0;
		return A2($turboMaCk$any_dict$Dict$Any$member, a, dict);
	});
var $author$project$Auth$RightSet$member = $turboMaCk$any_set$Set$Any$member;
var $author$project$Auth$Authorization$authorizeSetting = F2(
	function (userRights, right) {
		if (userRights.$ === 2) {
			var data = userRights.a;
			return A2($author$project$Auth$RightSet$member, right, data.hf);
		} else {
			return false;
		}
	});
var $author$project$Auth$RightSet$empty = $turboMaCk$any_set$Set$Any$empty($author$project$Rights$Right$toString);
var $author$project$Auth$UserRights$getRightSetFromMatrix = F2(
	function (organisationUnitId, userRights) {
		return A2($turboMaCk$any_dict$Dict$Any$get, organisationUnitId, userRights);
	});
var $author$project$Auth$UserRights$getRightSetFromMatrixWithDefault = F2(
	function (organisationUnitId, userRights) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Auth$RightSet$empty,
			A2($author$project$Auth$UserRights$getRightSetFromMatrix, organisationUnitId, userRights));
	});
var $author$project$Auth$Authorization$authorize = F3(
	function (userRights, right, organisationUnitId) {
		if (userRights.$ === 2) {
			var data = userRights.a;
			return A2(
				$author$project$Auth$RightSet$member,
				right,
				A2($author$project$Auth$UserRights$getRightSetFromMatrixWithDefault, organisationUnitId, data.h4)) || A2($author$project$Auth$Authorization$authorizeSetting, userRights, 3);
		} else {
			return false;
		}
	});
var $author$project$Environments$Environment$userRights = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.cy;
	});
var $author$project$Audit$EditDialog$checkAuditRight = F4(
	function (environment, repository, auditId, right) {
		return A2(
			$elm$core$List$member,
			true,
			A2(
				$elm$core$List$map,
				function (organisationUnitId) {
					return A3(
						$author$project$Auth$Authorization$authorize,
						$author$project$Environments$Environment$userRights(environment),
						right,
						organisationUnitId);
				},
				A2(
					$elm$core$List$map,
					function (checkpointGroup) {
						return checkpointGroup.km;
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (audit) {
								return audit.ff.gt;
							},
							A2($author$project$Environments$Repository$getAudit, auditId, repository))))));
	});
var $author$project$Audit$Command$delete = F4(
	function (environment, auditId_, idForError, titleForError) {
		return A2(
			$author$project$Audit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Audit$Command$Delete(
						{gm: auditId_, L: commandId_, M: commandTimestamp, k: idForError, l: titleForError});
				}));
	});
var $author$project$Audit$EditDialog$userClickedDelete = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (A4($author$project$Audit$EditDialog$checkAuditRight, environment, repository, model.es.gm, 9)) {
				var _v1 = A4($author$project$Audit$Command$delete, environment, model.es.gm, model.es.fw, model.es.k8);
				var newEnvironment = _v1.a;
				var task = _v1.b;
				var cmd_ = function () {
					var _v2 = model.aq;
					if (!_v2) {
						return A2(
							$elm$core$Task$perform,
							$author$project$Audit$EditDialog$CreatedCommands,
							$elm$core$Task$sequence(
								_List_fromArray(
									[task])));
					} else {
						return A2($elm$core$Task$perform, $author$project$Audit$EditDialog$CreatedDeleteCommand, task);
					}
				}();
				return {
					ab: cmd_,
					jn: $author$project$Audit$EditDialog$HandlingCommands(model),
					ac: newEnvironment,
					ae: repository
				};
			} else {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$EditDialog$BasicDataTab = 0;
var $author$project$Audit$EditDialog$switchTab = F2(
	function (tab, model) {
		if (_Utils_eq(model.cI, tab)) {
			return model;
		} else {
			if (!model.cI) {
				var title = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$title(model.aQ));
				var description = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$description(model.aQ));
				return $elm$core$String$isEmpty(title) ? model : _Utils_update(
					model,
					{
						aQ: A2(
							$author$project$UI$BasicDataEditor$withDescription,
							description,
							A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ)),
						cI: tab
					});
			} else {
				return _Utils_update(
					model,
					{cI: tab});
			}
		}
	});
var $author$project$Audit$EditDialog$userClickedTabIcon = F4(
	function (tab, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Audit$EditDialog$Visible(
					A2($author$project$Audit$EditDialog$switchTab, tab, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$UI$DateInput$inputToNaivDate = function (input) {
	var _v0 = A2($elm$core$String$split, '-', input);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var ds = _v0.a;
		var _v1 = _v0.b;
		var ms = _v1.a;
		var _v2 = _v1.b;
		var ys = _v2.a;
		return (($elm$core$String$length(ys) < 4) || (($elm$core$String$length(ms) < 2) || ($elm$core$String$length(ds) < 2))) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$andThen,
			$elm$core$Result$toMaybe,
			A4(
				$elm$core$Maybe$map3,
				$author$project$Date_Time$NaiveDate$ymd,
				$elm$core$String$toInt(ys),
				A3(
					$elm$core$Basics$composeR,
					$elm$core$String$toInt,
					$elm$core$Maybe$andThen($author$project$Date_Time$Month$fromInt),
					ms),
				$elm$core$String$toInt(ds)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$UI$DateInput$Collapsed = {$: 0};
var $author$project$UI$DateInput$Expanded = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$DatePicker$State = $elm$core$Basics$identity;
var $author$project$Date_Time$NaiveDate$month = function (_v0) {
	var m = _v0.b;
	return m;
};
var $author$project$Date_Time$NaiveDate$year = function (_v0) {
	var y = _v0.a;
	return y;
};
var $author$project$UI$DatePicker$initialDate = function (date) {
	return {
		ar: $author$project$Date_Time$NaiveDate$month(date),
		aG: $author$project$Date_Time$NaiveDate$year(date),
		ll: $elm$core$Maybe$Just(date)
	};
};
var $author$project$UI$DateInput$updateDatePicker = F2(
	function (naiveDate, state) {
		if (!state.$) {
			return $author$project$UI$DateInput$Collapsed;
		} else {
			return $author$project$UI$DateInput$Expanded(
				$author$project$UI$DatePicker$initialDate(naiveDate));
		}
	});
var $author$project$Audit$EditDialog$userEnteredDateText = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (model.aq === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var _v1 = function () {
					var _v2 = $author$project$UI$DateInput$inputToNaivDate(
						A3($elm$core$String$replace, '.', '-', input));
					if (!_v2.$) {
						var dateValue = _v2.a;
						return _Utils_Tuple3(
							dateValue,
							$elm$core$Maybe$Nothing,
							A2($author$project$UI$DateInput$updateDatePicker, dateValue, model.cQ));
					} else {
						return _Utils_Tuple3(
							model.bl,
							$elm$core$Maybe$Just(input),
							model.cQ);
					}
				}();
				var deadlineDate = _v1.a;
				var dateTextInput = _v1.b;
				var endDateInput = _v1.c;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Audit$EditDialog$Visible(
						_Utils_update(
							model,
							{dy: dateTextInput, bl: deadlineDate, cQ: endDateInput})),
					ac: environment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$Ids$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$User$Ids$member = $turboMaCk$any_set$Set$Any$member;
var $author$project$User$Ids$remove = $turboMaCk$any_set$Set$Any$remove;
var $author$project$Audit$EditDialog$userSelectedUser = F4(
	function (userId, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (model.aq === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var newModel = A2($author$project$User$Ids$member, userId, model.g9) ? _Utils_update(
					model,
					{
						g9: A2($author$project$User$Ids$remove, userId, model.g9),
						bb: A2($author$project$User$Ids$insert, userId, model.bb)
					}) : _Utils_update(
					model,
					{
						ge: A2($author$project$User$Ids$insert, userId, model.ge),
						bb: A2($author$project$User$Ids$insert, userId, model.bb)
					});
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Audit$EditDialog$Visible(newModel),
					ac: environment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$EditDialog$userUnselectedUser = F4(
	function (userId, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (model.aq === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var newModel = A2($author$project$User$Ids$member, userId, model.ge) ? _Utils_update(
					model,
					{
						ge: A2($author$project$User$Ids$remove, userId, model.ge),
						bb: A2($author$project$User$Ids$remove, userId, model.bb)
					}) : _Utils_update(
					model,
					{
						g9: A2($author$project$User$Ids$insert, userId, model.g9),
						bb: A2($author$project$User$Ids$remove, userId, model.bb)
					});
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Audit$EditDialog$Visible(newModel),
					ac: environment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$EditDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Audit$EditDialog$userClickedCloseDialog;
		case 1:
			var tab = msg.a;
			return $author$project$Audit$EditDialog$userClickedTabIcon(tab);
		case 2:
			return $author$project$Audit$EditDialog$userClickedCancelButton;
		case 3:
			return $author$project$Audit$EditDialog$userClickedApplyButton;
		case 4:
			return $author$project$Audit$EditDialog$userClickedCloseButton;
		case 5:
			var editorMsg = msg.a;
			return $author$project$Audit$EditDialog$gotBasicDataEditorMsg(editorMsg);
		case 6:
			var state = msg.a;
			return $author$project$Audit$EditDialog$userChangedEndDateInput(state);
		case 7:
			var text = msg.a;
			return $author$project$Audit$EditDialog$userEnteredDateText(text);
		case 8:
			var input = msg.a;
			return $author$project$Audit$EditDialog$enteredHour(input);
		case 9:
			var input = msg.a;
			return $author$project$Audit$EditDialog$enteredMinute(input);
		case 10:
			var userId = msg.a;
			return $author$project$Audit$EditDialog$userSelectedUser(userId);
		case 11:
			var userId = msg.a;
			return $author$project$Audit$EditDialog$userUnselectedUser(userId);
		case 12:
			var commands = msg.a;
			return $author$project$Audit$EditDialog$createdCommands(commands);
		case 13:
			return $author$project$Audit$EditDialog$userClickedDelete;
		case 14:
			var command = msg.a;
			return $author$project$Audit$EditDialog$createdDeleteCommand(command);
		default:
			var httpMsg = msg.a;
			return $author$project$Audit$EditDialog$gotDeleteResponse(httpMsg);
	}
};
var $author$project$Archive$AuditArchiveContent$ContentError = {$: 2};
var $author$project$Archive$AuditArchiveContent$ContentLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Archive$AuditArchiveContent$ContentLoading = {$: 0};
var $author$project$Archive$AuditArchiveContent$withArchivedAudits = F2(
	function (archivedAudits, content) {
		switch (content.$) {
			case 0:
				return $author$project$Archive$AuditArchiveContent$ContentLoading;
			case 1:
				var model = content.a;
				return $author$project$Archive$AuditArchiveContent$ContentLoaded(
					_Utils_update(
						model,
						{aA: archivedAudits}));
			default:
				return $author$project$Archive$AuditArchiveContent$ContentError;
		}
	});
var $author$project$Archive$AuditArchiveContent$withEditAuditDialog = F2(
	function (editDialog_, content) {
		switch (content.$) {
			case 0:
				return $author$project$Archive$AuditArchiveContent$ContentLoading;
			case 1:
				var model = content.a;
				return $author$project$Archive$AuditArchiveContent$ContentLoaded(
					_Utils_update(
						model,
						{cN: editDialog_}));
			default:
				return $author$project$Archive$AuditArchiveContent$ContentError;
		}
	});
var $author$project$Archive$AuditArchiveContent$gotEditAuditDialogMsg = F4(
	function (dialogMsg, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var updatedArchivedMeasures = function () {
				if (((dialogMsg.$ === 15) && (dialogMsg.a.$ === 15)) && (dialogMsg.a.a.$ === 9)) {
					var deletePayload = dialogMsg.a.a.a;
					return A2($author$project$Archive$ArchivedAudits$removeAudit, deletePayload.gm, model.aA);
				} else {
					return model.aA;
				}
			}();
			var result = A4($author$project$Audit$EditDialog$update, dialogMsg, environment, repository, model.cN);
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$AuditArchiveContent$GotEditAuditDialogMsg, result.ab),
				ai: A2(
					$author$project$Archive$AuditArchiveContent$withArchivedAudits,
					updatedArchivedMeasures,
					A2($author$project$Archive$AuditArchiveContent$withEditAuditDialog, result.jn, content)),
				ac: result.ac,
				ae: result.ae
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$ArchivedAudits$dict = function (_v0) {
	var data = _v0;
	return data.cL;
};
var $author$project$Archive$ArchivedAudits$empty = {ew: -1, cL: $author$project$Audit$Dict$empty};
var $author$project$Audit$EditDialog$hidden = $author$project$Audit$EditDialog$Hidden;
var $turboMaCk$any_dict$Dict$Any$union = F2(
	function (_v0, _v1) {
		var inner = _v0;
		var dict = _v1.cL;
		return _Utils_update(
			inner,
			{
				cL: A2($elm$core$Dict$union, inner.cL, dict)
			});
	});
var $author$project$Audit$Dict$union = $turboMaCk$any_dict$Dict$Any$union;
var $author$project$Archive$ArchivedAudits$updateDict = F2(
	function (_v0, newDict) {
		var data = _v0;
		return _Utils_update(
			data,
			{cL: newDict});
	});
var $author$project$Archive$AuditArchiveContent$gotGetAuditsArchiveResult = F4(
	function (result, environment, repository, content) {
		switch (result.$) {
			case 0:
				var resultType = result.a;
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v1.a;
				var updatedEnvironment = _v1.b;
				var newError = {
					gg: 'Unknown return from Javascript in http handler. index.js -> initHttpPort',
					gE: $author$project$Environments$ErrorHandling$Error$OtherError(resultType),
					gH: 'Archive.AuditArchiveContent.elm',
					gK: 'gotGetAuditsResult',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					ai: $author$project$Archive$AuditArchiveContent$ContentError,
					ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					ae: repository
				};
			case 1:
				var decodeError = result.a;
				var _v2 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v2.a;
				var updatedEnvironment = _v2.b;
				var newError = {
					gg: 'Error while Decoding incoming http request',
					gE: $author$project$Environments$ErrorHandling$Error$DecodeError(decodeError),
					gH: 'Archive.AuditArchiveContent.elm',
					gK: 'gotGetAuditsResult',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					ai: $author$project$Archive$AuditArchiveContent$ContentError,
					ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					ae: repository
				};
			case 2:
				var status = result.a;
				var responseMessage = result.b;
				var resultType = result.c;
				var _v3 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v3.a;
				var updatedEnvironment = _v3.b;
				var newError = {
					gg: resultType,
					gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
					gH: 'Archive.AuditArchiveContent.elm',
					gK: 'gotGetAuditsResult',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					ai: $author$project$Archive$AuditArchiveContent$ContentError,
					ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					ae: repository
				};
			case 14:
				var archivedAudits = result.a;
				switch (content.$) {
					case 0:
						return {
							ab: $elm$core$Platform$Cmd$none,
							ai: $author$project$Archive$AuditArchiveContent$ContentLoaded(
								{aA: archivedAudits, cN: $author$project$Audit$EditDialog$hidden, bF: 300}),
							ac: environment,
							ae: repository
						};
					case 1:
						var model = content.a;
						return {
							ab: $elm$core$Platform$Cmd$none,
							ai: $author$project$Archive$AuditArchiveContent$ContentLoaded(
								_Utils_update(
									model,
									{
										aA: A2(
											$author$project$Archive$ArchivedAudits$updateDict,
											archivedAudits,
											A2(
												$author$project$Audit$Dict$union,
												$author$project$Archive$ArchivedAudits$dict(model.aA),
												$author$project$Archive$ArchivedAudits$dict(archivedAudits)))
									})),
							ac: environment,
							ae: repository
						};
					default:
						return {
							ab: $elm$core$Platform$Cmd$none,
							ai: $author$project$Archive$AuditArchiveContent$ContentLoaded(
								{aA: $author$project$Archive$ArchivedAudits$empty, cN: $author$project$Audit$EditDialog$hidden, bF: 300}),
							ac: environment,
							ae: repository
						};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$ArchivedAudits$count = function (_v0) {
	var data = _v0;
	return data.ew;
};
var $author$project$Utils$Http$GetAuditsArchive = 8;
var $author$project$Utils$Http$Header = F2(
	function (key, value) {
		return {bn: key, ll: value};
	});
var $author$project$Utils$Http$SendGet = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Utils$Http$sendGet = F3(
	function (url, headers, resultType) {
		var outMsg = A2($author$project$Utils$Http$SendGet, url, headers);
		return $author$project$Utils$Http$httpOutbox(
			A2(
				$author$project$Utils$Http$encodeOutMsg,
				outMsg,
				$author$project$Utils$Http$resultTypeToString(resultType)));
	});
var $author$project$Archive$AuditArchiveContent$getRequest = F3(
	function (environment, search, last_chunk) {
		var takeHeader = _List_fromArray(
			[
				A2(
				$author$project$Utils$Http$Header,
				'x-take',
				$elm$core$String$fromInt(last_chunk + 300)),
				A2(
				$author$project$Utils$Http$Header,
				'x-skip',
				$elm$core$String$fromInt(last_chunk))
			]);
		var searchHeader = $elm$core$String$isEmpty(search) ? _List_Nil : _List_fromArray(
			[
				A2($author$project$Utils$Http$Header, 'x-search-string', search)
			]);
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Archive$AuditArchiveContent$GotGetAuditsArchiveResult,
			A3(
				$author$project$Utils$Http$sendGet,
				$author$project$Environments$Environment$baseUri(environment) + '/audits/query/archived',
				A2($elm$core$List$append, takeHeader, searchHeader),
				8));
	});
var $author$project$Archive$AuditArchiveContent$scrollEvent = F5(
	function (searchValue, scrollInfo, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var _v1 = (((scrollInfo.kM - scrollInfo.kN) <= 2000) && (_Utils_cmp(
				model.bF,
				$author$project$Archive$ArchivedAudits$count(model.aA)) < 0)) ? _Utils_Tuple2(
				model.bF + 300,
				A3($author$project$Archive$AuditArchiveContent$getRequest, environment, searchValue, model.bF)) : _Utils_Tuple2(model.bF, $elm$core$Platform$Cmd$none);
			var newTakeValue = _v1.a;
			var cmd = _v1.b;
			return {
				ab: cmd,
				ai: $author$project$Archive$AuditArchiveContent$ContentLoaded(
					_Utils_update(
						model,
						{bF: newTakeValue})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$AuditArchiveContent$searchOnEnter = F4(
	function (searchValue, environment, repository, content) {
		if (content.$ === 1) {
			return {
				ab: A3($author$project$Archive$AuditArchiveContent$getRequest, environment, searchValue, 0),
				ai: $author$project$Archive$AuditArchiveContent$ContentLoading,
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$ArchivedAudits$get = function (auditId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Archive$ArchivedAudits$dict,
		$author$project$Audit$Dict$get(auditId));
};
var $author$project$UI$DateInput$collapsed = $author$project$UI$DateInput$Collapsed;
var $author$project$Audit$EditDialog$disableInput = F4(
	function (environment, repository, auditId, context) {
		return (context === 1) || (!A4($author$project$Audit$EditDialog$checkAuditRight, environment, repository, auditId, 8));
	});
var $author$project$UI$BasicDataEditor$NoColorPicker = {$: 0};
var $author$project$UI$BasicDataEditor$default = {aF: $author$project$UI$BasicDataEditor$NoColorPicker, aY: '', ey: false, k8: ''};
var $author$project$UI$BasicDataEditor$from = function (model) {
	return A2(
		$author$project$UI$BasicDataEditor$withDescription,
		model.aY,
		A2($author$project$UI$BasicDataEditor$withTitle, model.k8, $author$project$UI$BasicDataEditor$default));
};
var $author$project$Date_Time$NaiveTime$hour = function (_v0) {
	var h = _v0.a;
	return h;
};
var $author$project$Audit$EditDialog$intToFormattedString = function (value) {
	var str = $elm$core$String$fromInt(value);
	return (value < 10) ? ('0' + str) : str;
};
var $author$project$Date_Time$NaiveTime$minute = function (_v0) {
	var m = _v0.b;
	return m;
};
var $author$project$Audit$EditDialog$getHourAndMinuteValues = function (time) {
	return _Utils_Tuple2(
		$author$project$Audit$EditDialog$intToFormattedString(
			$author$project$Date_Time$NaiveTime$hour(time)),
		$author$project$Audit$EditDialog$intToFormattedString(
			$author$project$Date_Time$NaiveTime$minute(time)));
};
var $author$project$UI$BasicDataEditor$withDisableInput = F2(
	function (disableInput_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{ey: disableInput_});
	});
var $author$project$Audit$EditDialog$show = F5(
	function (environment, repository, context, timeZone, audit) {
		var _v0 = $author$project$Audit$EditDialog$getHourAndMinuteValues(
			A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, audit.hI));
		var hourValue = _v0.a;
		var minuteValue = _v0.b;
		return $author$project$Audit$EditDialog$Visible(
			{
				ge: $author$project$User$Ids$empty,
				es: audit,
				aQ: A2(
					$author$project$UI$BasicDataEditor$withDisableInput,
					A4($author$project$Audit$EditDialog$disableInput, environment, repository, audit.gm, context),
					$author$project$UI$BasicDataEditor$from(audit)),
				aq: context,
				cI: 0,
				dy: $elm$core$Maybe$Nothing,
				bl: A2($author$project$Date_Time$NaiveDate$fromPosix, $elm$time$Time$utc, audit.hI),
				ex: A2($author$project$Date_Time$NaiveTime$fromPosix, $elm$time$Time$utc, audit.hI),
				cQ: $author$project$UI$DateInput$collapsed,
				cf: hourValue,
				cj: minuteValue,
				g9: $author$project$User$Ids$empty,
				bb: audit.bT
			});
	});
var $author$project$Environments$Environment$timeZone = function (state) {
	var model = $author$project$Environments$Environment$unwrap(state);
	return model.cw.el;
};
var $author$project$Archive$AuditArchiveContent$userClickedEditIcon = F4(
	function (auditId, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var updatedContent = function () {
				var _v1 = A2($author$project$Archive$ArchivedAudits$get, auditId, model.aA);
				if (!_v1.$) {
					var audit = _v1.a;
					return A2(
						$author$project$Archive$AuditArchiveContent$withEditAuditDialog,
						A5(
							$author$project$Audit$EditDialog$show,
							environment,
							repository,
							1,
							$author$project$Environments$Environment$timeZone(environment),
							audit),
						content);
				} else {
					return content;
				}
			}();
			return {ab: $elm$core$Platform$Cmd$none, ai: updatedContent, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Environments$Route$ViewArchivedAudit = function (a) {
	return {$: 12, a: a};
};
var $author$project$Archive$AuditArchiveContent$userClickedViewAudit = F4(
	function (auditId, environment, repository, content) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ai: content,
			ac: A2(
				$author$project$Environments$Environment$navigateTo,
				$author$project$Environments$Route$ViewArchivedAudit(auditId),
				environment),
			ae: repository
		};
	});
var $author$project$Archive$AuditArchiveContent$update = function (msg) {
	switch (msg.$) {
		case 0:
			var result = msg.a;
			return $author$project$Archive$AuditArchiveContent$gotGetAuditsArchiveResult(result);
		case 1:
			var auditId = msg.a;
			return $author$project$Archive$AuditArchiveContent$userClickedEditIcon(auditId);
		case 2:
			var auditId = msg.a;
			return $author$project$Archive$AuditArchiveContent$userClickedViewAudit(auditId);
		case 3:
			var dialogMsg = msg.a;
			return $author$project$Archive$AuditArchiveContent$gotEditAuditDialogMsg(dialogMsg);
		case 4:
			var searchValue = msg.a;
			return $author$project$Archive$AuditArchiveContent$searchOnEnter(searchValue);
		default:
			var searchValue = msg.a;
			var scrollInfo = msg.b;
			return A2($author$project$Archive$AuditArchiveContent$scrollEvent, searchValue, scrollInfo);
	}
};
var $author$project$Archive$Page$gotAuditArchiveContentMsg = F4(
	function (contentMsg, environment, repository, _v0) {
		var model = _v0;
		var _v1 = model.ai;
		if (_v1.$ === 1) {
			var auditContent = _v1.a;
			var updateResult = A4($author$project$Archive$AuditArchiveContent$update, contentMsg, environment, repository, auditContent);
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$Page$GotAuditArchiveContentMsg, updateResult.ab),
				ac: updateResult.ac,
				ak: _Utils_update(
					model,
					{
						ai: $author$project$Archive$Page$AuditArchive(updateResult.ai)
					}),
				ae: updateResult.ae
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: model, ae: repository};
		}
	});
var $author$project$Archive$Page$CombinedArchive = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Archive$CombinedArchive$getAudit = F2(
	function (auditId, _v0) {
		var data = _v0;
		return $elm$core$List$head(
			A3(
				$elm$core$List$foldl,
				$author$project$Utils$Utils$reduceMaybeList,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (value) {
						if (!value.$) {
							var audit = value.a;
							return _Utils_eq(audit.gm, auditId) ? $elm$core$Maybe$Just(audit) : $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					data.bd)));
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Utils$Maybe$isJust = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		$elm$core$Basics$always(true)),
	$elm$core$Maybe$withDefault(false));
var $author$project$Archive$CombinedArchive$removeAudit = F2(
	function (auditId, combinedArchive) {
		var data = combinedArchive;
		return $author$project$Utils$Maybe$isJust(
			A2($author$project$Archive$CombinedArchive$getAudit, auditId, combinedArchive)) ? {
			ew: data.ew - 1,
			bd: A2(
				$elm$core$List$filter,
				function (value) {
					if (!value.$) {
						var audit = value.a;
						return !_Utils_eq(audit.gm, auditId);
					} else {
						return true;
					}
				},
				data.bd)
		} : combinedArchive;
	});
var $author$project$Archive$CombinedArchiveContent$ContentError = {$: 2};
var $author$project$Archive$CombinedArchiveContent$ContentLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Archive$CombinedArchiveContent$ContentLoading = {$: 0};
var $author$project$Archive$CombinedArchiveContent$withCombinedMeasures = F2(
	function (combinedArchive, content) {
		switch (content.$) {
			case 0:
				return $author$project$Archive$CombinedArchiveContent$ContentLoading;
			case 1:
				var model = content.a;
				return $author$project$Archive$CombinedArchiveContent$ContentLoaded(
					_Utils_update(
						model,
						{an: combinedArchive}));
			default:
				return $author$project$Archive$CombinedArchiveContent$ContentError;
		}
	});
var $author$project$Archive$CombinedArchiveContent$withEditAuditDialog = F2(
	function (editDialog_, content) {
		switch (content.$) {
			case 0:
				return $author$project$Archive$CombinedArchiveContent$ContentLoading;
			case 1:
				var model = content.a;
				return $author$project$Archive$CombinedArchiveContent$ContentLoaded(
					_Utils_update(
						model,
						{cN: editDialog_}));
			default:
				return $author$project$Archive$CombinedArchiveContent$ContentError;
		}
	});
var $author$project$Archive$CombinedArchiveContent$gotEditAuditDialogMsg = F4(
	function (dialogMsg, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var updatedCombinedArchived = function () {
				if (((dialogMsg.$ === 15) && (dialogMsg.a.$ === 15)) && (dialogMsg.a.a.$ === 9)) {
					var deletePayload = dialogMsg.a.a.a;
					return A2($author$project$Archive$CombinedArchive$removeAudit, deletePayload.gm, model.an);
				} else {
					return model.an;
				}
			}();
			var result = A4($author$project$Audit$EditDialog$update, dialogMsg, environment, repository, model.cN);
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$CombinedArchiveContent$GotEditAuditDialogMsg, result.ab),
				ai: A2(
					$author$project$Archive$CombinedArchiveContent$withCombinedMeasures,
					updatedCombinedArchived,
					A2($author$project$Archive$CombinedArchiveContent$withEditAuditDialog, result.jn, content)),
				ac: result.ac,
				ae: result.ae
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$CombinedArchive$getMeasure = F2(
	function (measureId, _v0) {
		var data = _v0;
		return $elm$core$List$head(
			A3(
				$elm$core$List$foldl,
				$author$project$Utils$Utils$reduceMaybeList,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (value) {
						if (!value.$) {
							return $elm$core$Maybe$Nothing;
						} else {
							var measure = value.a;
							return _Utils_eq(measure.h5, measureId) ? $elm$core$Maybe$Just(measure) : $elm$core$Maybe$Nothing;
						}
					},
					data.bd)));
	});
var $author$project$Archive$CombinedArchive$removeMeasure = F2(
	function (measureId, combinedArchive) {
		var data = combinedArchive;
		return $author$project$Utils$Maybe$isJust(
			A2($author$project$Archive$CombinedArchive$getMeasure, measureId, combinedArchive)) ? {
			ew: data.ew - 1,
			bd: A2(
				$elm$core$List$filter,
				function (value) {
					if (!value.$) {
						return true;
					} else {
						var measure = value.a;
						return !_Utils_eq(measure.h5, measureId);
					}
				},
				data.bd)
		} : combinedArchive;
	});
var $author$project$Measure$Measure$AlreadyExists = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$EditDialog$Deleted = {$: 3};
var $author$project$Measure$EditDialog$Hidden = {$: 0};
var $author$project$Measure$Commands$fromList = $author$project$Types$Queue$fromList;
var $author$project$Measure$Measure$NotModified = function (a) {
	return {$: 0, a: a};
};
var $author$project$Measure$Measure$Completed = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Measure$Measure$measureFromModification = function (modification) {
	switch (modification.$) {
		case 0:
			var maybeMeasure = modification.a;
			return maybeMeasure;
		case 1:
			var measure = modification.a;
			return $elm$core$Maybe$Just(measure);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Measure$Measure$applyCompletedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$Measure$Measure$measureFromModification(modification);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(payload.h5, measure.h5) && (_Utils_cmp(payload.n, measure.i) > 0)) {
				var newFileOperations = A3(
					$elm$core$List$foldl,
					A2(
						$elm$core$Basics$composeR,
						$author$project$File$Operation$Delete(false),
						$author$project$File$Operations$enqueue),
					fileOperations,
					measure.fx);
				return _Utils_Tuple2(
					A2($author$project$Measure$Measure$Completed, measure.h5, payload.N),
					newFileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$Measure$Measure$Changed = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$File$Operation$CreateMeasureImage = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Measure$Measure$applyCreatedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$Measure$Measure$measureFromModification(modification);
		if (!_v0.$) {
			return acc;
		} else {
			var newMeasure = {jb: $author$project$Measure$CompletionStatus$Open, dw: payload.dw, jd: payload.jd, hI: payload.hI, aY: payload.aY, fw: payload.fw, fx: payload.fx, h5: payload.h5, h6: payload.h6, km: payload.km, bb: payload.bb, i: 0, k8: payload.k8};
			var newFileOperations = A3(
				$elm$core$List$foldl,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$File$Operation$CreateMeasureImage, payload.h5, payload.km),
					$author$project$File$Operations$enqueue),
				fileOperations,
				payload.fx);
			return _Utils_Tuple2(
				A2($author$project$Measure$Measure$Changed, newMeasure, payload.N),
				newFileOperations);
		}
	});
var $author$project$Measure$Measure$applyDeadlineChangedChangedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$Measure$Measure$measureFromModification(modification);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(payload.h5, measure.h5) && (_Utils_cmp(payload.n, measure.i) > 0)) {
				var newMeasure = _Utils_update(
					measure,
					{hI: payload.hI, i: payload.n});
				return _Utils_Tuple2(
					A2($author$project$Measure$Measure$Changed, newMeasure, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$Measure$Measure$Deleted = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Measure$Measure$applyDeletedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$Measure$Measure$measureFromModification(modification);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(payload.h5, measure.h5) && (_Utils_cmp(payload.n, measure.i) > 0)) {
				var newFileOperations = A3(
					$elm$core$List$foldl,
					A2(
						$elm$core$Basics$composeR,
						$author$project$File$Operation$Delete(false),
						$author$project$File$Operations$enqueue),
					fileOperations,
					measure.fx);
				return _Utils_Tuple2(
					A2($author$project$Measure$Measure$Deleted, measure.h5, payload.N),
					newFileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$Measure$Measure$applyDescriptionChangedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$Measure$Measure$measureFromModification(modification);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(payload.h5, measure.h5) && (_Utils_cmp(payload.n, measure.i) > 0)) {
				var newMeasure = _Utils_update(
					measure,
					{aY: payload.aY, i: payload.n});
				return _Utils_Tuple2(
					A2($author$project$Measure$Measure$Changed, newMeasure, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$Measure$Measure$applyImageAddedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$Measure$Measure$measureFromModification(modification);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(payload.h5, measure.h5) && (_Utils_cmp(payload.n, measure.i) > 0)) {
				var newMeasure = _Utils_update(
					measure,
					{
						fx: A2($elm$core$List$append, measure.fx, payload.gf),
						i: payload.n
					});
				var measureOperations = $author$project$File$Operations$fromList(
					A2(
						$elm$core$List$map,
						function (image) {
							return A3($author$project$File$Operation$CreateMeasureImage, payload.h5, measure.km, image);
						},
						payload.gf));
				var newFileOperations = A2($author$project$File$Operations$merge, measureOperations, fileOperations);
				return _Utils_Tuple2(
					A2($author$project$Measure$Measure$Changed, newMeasure, payload.N),
					newFileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$Measure$Measure$applyImageRemovedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$Measure$Measure$measureFromModification(modification);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(payload.h5, measure.h5) && (_Utils_cmp(payload.n, measure.i) > 0)) {
				var removeOperations = $author$project$File$Operations$fromList(
					A2(
						$elm$core$List$map,
						function (image) {
							return A2($author$project$File$Operation$Delete, true, image);
						},
						payload.ha));
				var newMeasure = _Utils_update(
					measure,
					{
						fx: A2(
							$elm$core$List$filter,
							function (image) {
								return !A2($elm$core$List$member, image, payload.ha);
							},
							measure.fx),
						i: payload.n
					});
				return _Utils_Tuple2(
					A2($author$project$Measure$Measure$Changed, newMeasure, payload.N),
					A2($author$project$File$Operations$merge, removeOperations, fileOperations));
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$Measure$Measure$applyOrganisationUnitChangedChangedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$Measure$Measure$measureFromModification(modification);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(payload.h5, measure.h5) && (_Utils_cmp(payload.n, measure.i) > 0)) {
				var newMeasure = _Utils_update(
					measure,
					{km: payload.km, i: payload.n});
				return _Utils_Tuple2(
					A2($author$project$Measure$Measure$Changed, newMeasure, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $turboMaCk$any_dict$Dict$Any$diff = F2(
	function (_v0, _v1) {
		var inner = _v0;
		var dict = _v1.cL;
		return _Utils_update(
			inner,
			{
				cL: A2($elm$core$Dict$diff, inner.cL, dict)
			});
	});
var $turboMaCk$any_set$Set$Any$diff = F2(
	function (_v0, _v1) {
		var d1 = _v0;
		var d2 = _v1;
		return A2($turboMaCk$any_dict$Dict$Any$diff, d1, d2);
	});
var $author$project$User$Ids$diff = $turboMaCk$any_set$Set$Any$diff;
var $turboMaCk$any_set$Set$Any$union = F2(
	function (_v0, _v1) {
		var d1 = _v0;
		var d2 = _v1;
		return A2($turboMaCk$any_dict$Dict$Any$union, d1, d2);
	});
var $author$project$User$Ids$union = $turboMaCk$any_set$Set$Any$union;
var $author$project$Measure$Measure$applyResponsibleUsersChangedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$Measure$Measure$measureFromModification(modification);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(payload.h5, measure.h5) && (_Utils_cmp(payload.n, measure.i) > 0)) {
				var withNewUsers = A2($author$project$User$Ids$union, measure.bb, payload.e9);
				var withRemovedUsers = A2($author$project$User$Ids$diff, withNewUsers, payload.f_);
				var newMeasure = _Utils_update(
					measure,
					{bb: withRemovedUsers, i: payload.n});
				return _Utils_Tuple2(
					A2($author$project$Measure$Measure$Changed, newMeasure, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$Measure$Measure$applyTitleChangedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$Measure$Measure$measureFromModification(modification);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(payload.h5, measure.h5) && (_Utils_cmp(payload.n, measure.i) > 0)) {
				var newMeasure = _Utils_update(
					measure,
					{i: payload.n, k8: payload.k8});
				return _Utils_Tuple2(
					A2($author$project$Measure$Measure$Changed, newMeasure, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$Measure$Measure$applyEventHelper = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $author$project$Measure$Measure$applyCreatedEvent(payload);
		case 1:
			var payload = event.a;
			return $author$project$Measure$Measure$applyTitleChangedEvent(payload);
		case 2:
			var payload = event.a;
			return $author$project$Measure$Measure$applyDescriptionChangedEvent(payload);
		case 3:
			var payload = event.a;
			return $author$project$Measure$Measure$applyResponsibleUsersChangedEvent(payload);
		case 4:
			var payload = event.a;
			return $author$project$Measure$Measure$applyDeadlineChangedChangedEvent(payload);
		case 5:
			var payload = event.a;
			return $author$project$Measure$Measure$applyOrganisationUnitChangedChangedEvent(payload);
		case 6:
			var payload = event.a;
			return $author$project$Measure$Measure$applyImageAddedEvent(payload);
		case 7:
			var payload = event.a;
			return $author$project$Measure$Measure$applyImageRemovedEvent(payload);
		case 8:
			var payload = event.a;
			return $author$project$Measure$Measure$applyCompletedEvent(payload);
		default:
			var payload = event.a;
			return $author$project$Measure$Measure$applyDeletedEvent(payload);
	}
};
var $author$project$Measure$Measure$applyEvent = F2(
	function (event, maybeMeasure) {
		return A2(
			$author$project$Measure$Measure$applyEventHelper,
			event,
			_Utils_Tuple2(
				$author$project$Measure$Measure$NotModified(maybeMeasure),
				$author$project$File$Operations$empty));
	});
var $author$project$Measure$Dict$get = $turboMaCk$any_dict$Dict$Any$get;
var $author$project$Measure$Measures$get = function (measureId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Measure$Measures$dict,
		$author$project$Measure$Dict$get(measureId));
};
var $author$project$Measure$Dict$insert = A2(
	$author$project$Utils$Utils$with,
	function ($) {
		return $.h5;
	},
	$turboMaCk$any_dict$Dict$Any$insert);
var $author$project$Measure$Measures$insert = F2(
	function (measure, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				cL: A2($author$project$Measure$Dict$insert, measure, data.cL)
			});
	});
var $author$project$Measure$Event$measureId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.h5;
		case 1:
			var payload = event.a;
			return payload.h5;
		case 2:
			var payload = event.a;
			return payload.h5;
		case 3:
			var payload = event.a;
			return payload.h5;
		case 4:
			var payload = event.a;
			return payload.h5;
		case 5:
			var payload = event.a;
			return payload.h5;
		case 6:
			var payload = event.a;
			return payload.h5;
		case 7:
			var payload = event.a;
			return payload.h5;
		case 8:
			var payload = event.a;
			return payload.h5;
		default:
			var payload = event.a;
			return payload.h5;
	}
};
var $author$project$Measure$Dict$remove = $turboMaCk$any_dict$Dict$Any$remove;
var $author$project$Measure$Measures$remove = F2(
	function (measureId, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				cL: A2($author$project$Measure$Dict$remove, measureId, data.cL)
			});
	});
var $author$project$Measure$Modifications$NotEmpty = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$Ids$empty = $turboMaCk$any_set$Set$Any$empty($author$project$Measure$Id$toString);
var $author$project$Measure$Ids$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$Measure$Ids$remove = $turboMaCk$any_set$Set$Any$remove;
var $author$project$Measure$Dict$singleton = function (measure) {
	return A2($author$project$Measure$Dict$insert, measure, $author$project$Measure$Dict$empty);
};
var $author$project$Measure$Ids$singleton = function (id) {
	return A2($author$project$Measure$Ids$insert, id, $author$project$Measure$Ids$empty);
};
var $author$project$Measure$Modifications$with = F2(
	function (modification, modifications) {
		var _v0 = _Utils_Tuple2(modification, modifications);
		switch (_v0.a.$) {
			case 0:
				return modifications;
			case 1:
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var measure = _v1.a;
					var eventId = _v1.b;
					var _v2 = _v0.b;
					return $author$project$Measure$Modifications$NotEmpty(
						{
							bh: $author$project$Measure$Dict$singleton(measure),
							b$: $author$project$Measure$Ids$empty,
							dA: $author$project$Measure$Ids$empty,
							fD: eventId
						});
				} else {
					var _v3 = _v0.a;
					var measure = _v3.a;
					var eventId = _v3.b;
					var data = _v0.b.a;
					return $author$project$Measure$Modifications$NotEmpty(
						_Utils_update(
							data,
							{
								bh: A2($author$project$Measure$Dict$insert, measure, data.bh),
								fD: eventId
							}));
				}
			case 2:
				if (!_v0.b.$) {
					var _v4 = _v0.a;
					var measureId = _v4.a;
					var eventId = _v4.b;
					var _v5 = _v0.b;
					return $author$project$Measure$Modifications$NotEmpty(
						{
							bh: $author$project$Measure$Dict$empty,
							b$: $author$project$Measure$Ids$singleton(measureId),
							dA: $author$project$Measure$Ids$empty,
							fD: eventId
						});
				} else {
					var _v6 = _v0.a;
					var measureId = _v6.a;
					var eventId = _v6.b;
					var data = _v0.b.a;
					return $author$project$Measure$Modifications$NotEmpty(
						_Utils_update(
							data,
							{
								bh: A2($author$project$Measure$Dict$remove, measureId, data.bh),
								b$: A2($author$project$Measure$Ids$insert, measureId, data.b$),
								fD: eventId
							}));
				}
			default:
				if (!_v0.b.$) {
					var _v7 = _v0.a;
					var measureId = _v7.a;
					var eventId = _v7.b;
					var _v8 = _v0.b;
					return $author$project$Measure$Modifications$NotEmpty(
						{
							bh: $author$project$Measure$Dict$empty,
							b$: $author$project$Measure$Ids$empty,
							dA: $author$project$Measure$Ids$singleton(measureId),
							fD: eventId
						});
				} else {
					var _v9 = _v0.a;
					var measureId = _v9.a;
					var eventId = _v9.b;
					var data = _v0.b.a;
					return $author$project$Measure$Modifications$NotEmpty(
						_Utils_update(
							data,
							{
								bh: A2($author$project$Measure$Dict$remove, measureId, data.bh),
								b$: A2($author$project$Measure$Ids$remove, measureId, data.b$),
								dA: A2($author$project$Measure$Ids$insert, measureId, data.dA),
								fD: eventId
							}));
				}
		}
	});
var $author$project$Measure$Measures$withLastEventId = F2(
	function (eventId, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				fD: $elm$core$Maybe$Just(eventId)
			});
	});
var $author$project$Measure$Measures$applyEventHelper = F2(
	function (event, _v0) {
		var measures = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		var _v1 = A2(
			$author$project$Measure$Measure$applyEvent,
			event,
			A2(
				$author$project$Measure$Measures$get,
				$author$project$Measure$Event$measureId(event),
				measures));
		var modification = _v1.a;
		var newFileOperations = _v1.b;
		switch (modification.$) {
			case 0:
				return _Utils_Tuple3(
					measures,
					modifications,
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
			case 1:
				var measure = modification.a;
				var eventId = modification.b;
				return _Utils_Tuple3(
					A2(
						$author$project$Measure$Measures$withLastEventId,
						eventId,
						A2($author$project$Measure$Measures$insert, measure, measures)),
					A2($author$project$Measure$Modifications$with, modification, modifications),
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
			case 2:
				var measureId = modification.a;
				var eventId = modification.b;
				return _Utils_Tuple3(
					A2(
						$author$project$Measure$Measures$withLastEventId,
						eventId,
						A2($author$project$Measure$Measures$remove, measureId, measures)),
					A2($author$project$Measure$Modifications$with, modification, modifications),
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
			default:
				var measureId = modification.a;
				var eventId = modification.b;
				return _Utils_Tuple3(
					A2(
						$author$project$Measure$Measures$withLastEventId,
						eventId,
						A2($author$project$Measure$Measures$remove, measureId, measures)),
					A2($author$project$Measure$Modifications$with, modification, modifications),
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
		}
	});
var $author$project$Measure$Modifications$Empty = {$: 0};
var $author$project$Measure$Modifications$empty = $author$project$Measure$Modifications$Empty;
var $author$project$Measure$Events$fold = $author$project$Types$Queue$fold;
var $author$project$Measure$Measures$applyEvents = F2(
	function (events, measures) {
		return A3(
			$author$project$Measure$Events$fold,
			$author$project$Measure$Measures$applyEventHelper,
			_Utils_Tuple3(measures, $author$project$Measure$Modifications$empty, $author$project$File$Operations$empty),
			events);
	});
var $author$project$Measure$Store$events = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Measure$Events$empty;
		case 1:
			var data = state.a;
			return data.b8;
		case 2:
			var data = state.a;
			return data.b8;
		default:
			var data = state.a;
			return data.b8;
	}
};
var $author$project$Measure$Store$measures = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Measure$Measures$empty;
		case 1:
			return $author$project$Measure$Measures$empty;
		case 3:
			var data = state.a;
			return data.aI;
		default:
			var data = state.a;
			return data.aI;
	}
};
var $author$project$Environments$Repository$getMeasure = F2(
	function (measureId, _v0) {
		var data = _v0;
		return A2(
			$author$project$Measure$Measures$get,
			measureId,
			$author$project$Utils$Triple$first(
				A2(
					$author$project$Measure$Measures$applyEvents,
					$author$project$Measure$Store$events(data.R),
					$author$project$Measure$Store$measures(data.R))));
	});
var $author$project$Measure$Commands$fold = $author$project$Types$Queue$fold;
var $author$project$Measure$Measure$DoesNotExist = function (a) {
	return {$: 0, a: a};
};
var $author$project$Measure$Measure$applyEvents = F2(
	function (events, acc) {
		return A3($author$project$Measure$Events$fold, $author$project$Measure$Measure$applyEventHelper, acc, events);
	});
var $author$project$Measure$Commands$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$Measure$Events$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$Measure$Events$singleton = $author$project$Types$Queue$singleton;
var $author$project$Measure$Measure$handleAddImagesCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Measure$Measure$measureFromModification(acc.au);
		if (!_v0.$) {
			var measure = _v0.a;
			if ($elm$core$List$isEmpty(
				A2(
					$elm$core$List$filter,
					function (image) {
						return !A2($elm$core$List$member, image, measure.fx);
					},
					payload.gf))) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Measure$Event$ImagesAdded(
					{gf: payload.gf, L: payload.L, M: payload.M, N: eventId, h5: payload.h5, n: measure.i + 1});
				var _v2 = A2(
					$author$project$Measure$Measure$applyEvents,
					$author$project$Measure$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Measure$Commands$enqueue,
							$author$project$Measure$Command$AddImages(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Measure$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Measure$Measure$DoesNotExist(payload.h5));
		}
	});
var $author$project$Measure$Measure$handleChangeDeadlineCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Measure$Measure$measureFromModification(acc.au);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(measure.hI, payload.hI)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Measure$Event$DeadlineChanged(
					{L: payload.L, M: payload.M, hI: payload.hI, N: eventId, h5: payload.h5, n: measure.i + 1});
				var _v2 = A2(
					$author$project$Measure$Measure$applyEvents,
					$author$project$Measure$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Measure$Commands$enqueue,
							$author$project$Measure$Command$ChangeDeadline(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Measure$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Measure$Measure$DoesNotExist(payload.h5));
		}
	});
var $author$project$Measure$Measure$handleChangeDescriptionCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Measure$Measure$measureFromModification(acc.au);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(measure.aY, payload.aY)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Measure$Event$DescriptionChanged(
					{L: payload.L, M: payload.M, aY: payload.aY, N: eventId, h5: payload.h5, n: measure.i + 1});
				var _v2 = A2(
					$author$project$Measure$Measure$applyEvents,
					$author$project$Measure$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Measure$Commands$enqueue,
							$author$project$Measure$Command$ChangeDescription(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Measure$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Measure$Measure$DoesNotExist(payload.h5));
		}
	});
var $author$project$Measure$Measure$handleChangeOrganisationUnitCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Measure$Measure$measureFromModification(acc.au);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(measure.km, payload.km)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Measure$Event$OrganisationUnitChanged(
					{L: payload.L, M: payload.M, N: eventId, h5: payload.h5, km: payload.km, n: measure.i + 1});
				var _v2 = A2(
					$author$project$Measure$Measure$applyEvents,
					$author$project$Measure$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Measure$Commands$enqueue,
							$author$project$Measure$Command$ChangeOrganisationUnit(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Measure$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Measure$Measure$DoesNotExist(payload.h5));
		}
	});
var $author$project$Measure$Measure$handleChangeResponsibleUsersCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Measure$Measure$measureFromModification(acc.au);
		if (!_v0.$) {
			var measure = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Measure$Event$ResponsibleUsersChanged(
				{e9: payload.e9, L: payload.L, M: payload.M, N: eventId, h5: payload.h5, f_: payload.f_, n: measure.i + 1});
			var _v2 = A2(
				$author$project$Measure$Measure$applyEvents,
				$author$project$Measure$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.au;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newModification = _v2.a;
			var newFileOperations = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Measure$Commands$enqueue,
						$author$project$Measure$Command$ChangeResponsibleUsers(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Measure$Events$enqueue, event, acc.b8),
					cb: newFileOperations,
					au: newModification
				});
		} else {
			return $elm$core$Result$Err(
				$author$project$Measure$Measure$DoesNotExist(payload.h5));
		}
	});
var $author$project$Measure$Measure$handleChangeTitleCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Measure$Measure$measureFromModification(acc.au);
		if (!_v0.$) {
			var measure = _v0.a;
			if (_Utils_eq(measure.k8, payload.k8)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Measure$Event$TitleChanged(
					{L: payload.L, M: payload.M, N: eventId, h5: payload.h5, k8: payload.k8, n: measure.i + 1});
				var _v2 = A2(
					$author$project$Measure$Measure$applyEvents,
					$author$project$Measure$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Measure$Commands$enqueue,
							$author$project$Measure$Command$ChangeTitle(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Measure$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Measure$Measure$DoesNotExist(payload.h5));
		}
	});
var $author$project$Measure$Measure$handleCompleteCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Measure$Measure$measureFromModification(acc.au);
		if (!_v0.$) {
			var measure = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Measure$Event$Completed(
				{L: payload.L, M: payload.M, N: eventId, h5: payload.h5, n: measure.i + 1});
			var _v2 = A2(
				$author$project$Measure$Measure$applyEvents,
				$author$project$Measure$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.au;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newModification = _v2.a;
			var newFileOperations = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Measure$Commands$enqueue,
						$author$project$Measure$Command$Complete(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Measure$Events$enqueue, event, acc.b8),
					cb: newFileOperations,
					au: newModification
				});
		} else {
			return $elm$core$Result$Ok(acc);
		}
	});
var $author$project$Measure$Measure$handleCreateCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Measure$Measure$measureFromModification(acc.au);
		if (_v0.$ === 1) {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Measure$Event$Created(
				{L: payload.L, M: payload.M, dw: payload.dw, jd: payload.jd, hI: payload.hI, aY: payload.aY, N: eventId, fw: payload.fw, fx: payload.fx, h5: payload.h5, h6: payload.h6, km: payload.km, bb: payload.bb, k8: payload.k8, n: 0});
			var _v2 = A2(
				$author$project$Measure$Measure$applyEvents,
				$author$project$Measure$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.au;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newModification = _v2.a;
			var newFileOperations = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Measure$Commands$enqueue,
						$author$project$Measure$Command$Create(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Measure$Events$enqueue, event, acc.b8),
					cb: newFileOperations,
					au: newModification
				});
		} else {
			var measure = _v0.a;
			return $elm$core$Result$Err(
				$author$project$Measure$Measure$AlreadyExists(measure.h5));
		}
	});
var $author$project$Measure$Measure$handleDeleteCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Measure$Measure$measureFromModification(acc.au);
		if (!_v0.$) {
			var measure = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Measure$Event$Deleted(
				{L: payload.L, M: payload.M, N: eventId, h5: payload.h5, n: measure.i + 1});
			var _v2 = A2(
				$author$project$Measure$Measure$applyEvents,
				$author$project$Measure$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.au;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newModification = _v2.a;
			var newFileOperations = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Measure$Commands$enqueue,
						$author$project$Measure$Command$Delete(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Measure$Events$enqueue, event, acc.b8),
					cb: newFileOperations,
					au: newModification
				});
		} else {
			return $elm$core$Result$Ok(acc);
		}
	});
var $author$project$Measure$Measure$handleRemoveImagesCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Measure$Measure$measureFromModification(acc.au);
		if (!_v0.$) {
			var measure = _v0.a;
			if ($elm$core$List$isEmpty(
				A2(
					$elm$core$List$filter,
					function (image) {
						return A2($elm$core$List$member, image, measure.fx);
					},
					payload.ha))) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Measure$Event$ImagesRemoved(
					{L: payload.L, M: payload.M, N: eventId, h5: payload.h5, ha: payload.ha, n: measure.i + 1});
				var _v2 = A2(
					$author$project$Measure$Measure$applyEvents,
					$author$project$Measure$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Measure$Commands$enqueue,
							$author$project$Measure$Command$RemoveImages(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Measure$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Measure$Measure$DoesNotExist(payload.h5));
		}
	});
var $author$project$Measure$Measure$handleCommandHelper = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $author$project$Measure$Measure$handleCreateCommand(payload);
		case 1:
			var payload = command.a;
			return $author$project$Measure$Measure$handleChangeTitleCommand(payload);
		case 2:
			var payload = command.a;
			return $author$project$Measure$Measure$handleChangeDescriptionCommand(payload);
		case 3:
			var payload = command.a;
			return $author$project$Measure$Measure$handleChangeResponsibleUsersCommand(payload);
		case 4:
			var payload = command.a;
			return $author$project$Measure$Measure$handleChangeDeadlineCommand(payload);
		case 5:
			var payload = command.a;
			return $author$project$Measure$Measure$handleChangeOrganisationUnitCommand(payload);
		case 6:
			var payload = command.a;
			return $author$project$Measure$Measure$handleAddImagesCommand(payload);
		case 7:
			var payload = command.a;
			return $author$project$Measure$Measure$handleRemoveImagesCommand(payload);
		case 8:
			var payload = command.a;
			return $author$project$Measure$Measure$handleCompleteCommand(payload);
		default:
			var payload = command.a;
			return $author$project$Measure$Measure$handleDeleteCommand(payload);
	}
};
var $author$project$Measure$Measure$handleCommands = F3(
	function (commands, environment, maybeMeasure) {
		var acc = $elm$core$Result$Ok(
			{
				cD: $author$project$Measure$Commands$empty,
				ac: environment,
				b8: $author$project$Measure$Events$empty,
				cb: $author$project$File$Operations$empty,
				au: $author$project$Measure$Measure$NotModified(maybeMeasure)
			});
		return A2(
			$elm$core$Result$map,
			function (data) {
				return {cD: data.cD, ac: data.ac, b8: data.b8, cb: data.cb};
			},
			A3(
				$author$project$Measure$Commands$fold,
				A2($elm$core$Basics$composeR, $author$project$Measure$Measure$handleCommandHelper, $elm$core$Result$andThen),
				acc,
				commands));
	});
var $author$project$Measure$Commands$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$Measure$Events$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$Environments$ErrorHandling$ToString$measureErrorToString = function (err) {
	if (!err.$) {
		var id = err.a;
		return 'Measure.DoesNotExist' + $author$project$Measure$Id$toString(id);
	} else {
		var id = err.a;
		return 'Measure.AlreadyExists' + $author$project$Measure$Id$toString(id);
	}
};
var $author$project$Environments$Repository$measureStore = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.R;
	});
var $author$project$Measure$Store$NotReady = 0;
var $author$project$Measure$Store$SaveCommandsAndEvents = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Measure$Store$Saving = function (a) {
	return {$: 3, a: a};
};
var $author$project$Measure$Commands$merge = $author$project$Types$Queue$merge;
var $author$project$Measure$Events$merge = $author$project$Types$Queue$merge;
var $author$project$Measure$Store$saveCommandsAndEvents = F3(
	function (commands_, events_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Measure$Store$Saving(
							{
								cD: A2($author$project$Measure$Commands$merge, data.cD, commands_),
								b8: A2($author$project$Measure$Events$merge, data.b8, events_),
								aI: $author$project$Measure$Measures$empty
							}),
						$author$project$Measure$Store$send(
							A2($author$project$Measure$Store$SaveCommandsAndEvents, commands_, events_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Measure$Store$Saving(
							_Utils_update(
								data,
								{
									cD: A2($author$project$Measure$Commands$merge, data.cD, commands_),
									b8: A2($author$project$Measure$Events$merge, data.b8, events_)
								})),
						$author$project$Measure$Store$send(
							A2($author$project$Measure$Store$SaveCommandsAndEvents, commands_, events_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$withMeasureStore = F2(
	function (measureStore_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{R: measureStore_});
	});
var $author$project$Environments$Repository$saveMeasureCommandsAndEventsAndFileOperations = F4(
	function (commands, events, fileOperations, repository) {
		var _v0 = A3(
			$author$project$Measure$Store$saveCommandsAndEvents,
			commands,
			events,
			$author$project$Environments$Repository$measureStore(repository));
		if (!_v0.$) {
			var _v1 = _v0.a;
			var newMeasureStore = _v1.a;
			var measureStoreCmd = _v1.b;
			var _v2 = A2(
				$author$project$File$Store$saveLocalOperations,
				fileOperations,
				$author$project$Environments$Repository$fileStore(repository));
			var newFileStore = _v2.a;
			var fileStoreCmd = _v2.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Environments$Repository$withFileStore,
					newFileStore,
					A2($author$project$Environments$Repository$withMeasureStore, newMeasureStore, repository)),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[measureStoreCmd, fileStoreCmd])));
		} else {
			return _Utils_Tuple2(repository, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Measure$EditDialog$createdCommands = F4(
	function (commands, environment, repository, dialog) {
		if (dialog.$ === 2) {
			var model = dialog.a;
			var _v1 = A3(
				$author$project$Measure$Measure$handleCommands,
				$author$project$Measure$Commands$fromList(commands),
				environment,
				A2($author$project$Environments$Repository$getMeasure, model.h.h5, repository));
			if (_v1.$ === 1) {
				if (!_v1.a.$) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$EditDialog$Deleted, ac: environment, ae: repository};
				} else {
					var msg = _v1.a.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$measureErrorToString(
								$author$project$Measure$Measure$AlreadyExists(msg))),
						gH: 'Measure.EditDialog.elm',
						gK: 'createdCommands',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: $author$project$Measure$EditDialog$Hidden,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				}
			} else {
				var resultData = _v1.a;
				if ($author$project$Measure$Commands$isEmpty(resultData.cD) || $author$project$Measure$Events$isEmpty(resultData.b8)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$EditDialog$Hidden, ac: resultData.ac, ae: repository};
				} else {
					var _v3 = A4($author$project$Environments$Repository$saveMeasureCommandsAndEventsAndFileOperations, resultData.cD, resultData.b8, resultData.cb, repository);
					var newRepository = _v3.a;
					var cmd = _v3.b;
					return {ab: cmd, jn: $author$project$Measure$EditDialog$Hidden, ac: resultData.ac, ae: newRepository};
				}
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Utils$Http$SendMeasuresCommand = 12;
var $author$project$Measure$EditDialog$deleteRequest = F2(
	function (command, environment) {
		var baseUrl = $author$project$Environments$Environment$baseUri(environment) + '/measures/command/delete';
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Measure$EditDialog$GotHttpResponse,
			A4(
				$author$project$Utils$Http$sendPost,
				baseUrl,
				12,
				$author$project$Measure$Command$encode(command),
				_List_Nil));
	});
var $author$project$Measure$EditDialog$createdDeleteCommand = F4(
	function (command, environment, repository, dialog) {
		return {
			ab: A2($author$project$Measure$EditDialog$deleteRequest, command, environment),
			jn: dialog,
			ac: environment,
			ae: repository
		};
	});
var $author$project$Measure$EditDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$EditDialog$NoDeadline = {$: 0};
var $author$project$Measure$EditDialog$WithDeadline = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Measure$EditDialog$addNaiveTimeToDeadlineState = F2(
	function (newTime, deadlineState) {
		if (!deadlineState.$) {
			return $author$project$Measure$EditDialog$NoDeadline;
		} else {
			var naiveDate = deadlineState.a;
			return A2($author$project$Measure$EditDialog$WithDeadline, naiveDate, newTime);
		}
	});
var $author$project$Measure$EditDialog$addHourValue = F3(
	function (environment, hourInput, model) {
		if ($elm$core$String$isEmpty(hourInput)) {
			return _Utils_update(
				model,
				{cf: hourInput});
		} else {
			if ($elm$core$String$isEmpty(model.cj)) {
				var _v0 = $elm$core$String$toInt(hourInput);
				if (_v0.$ === 1) {
					return model;
				} else {
					var hour = _v0.a;
					return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
						model,
						{cf: hourInput}) : model;
				}
			} else {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(hourInput),
					$elm$core$String$toInt(model.cj));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var hour = _v1.a.a;
					var minute = _v1.b.a;
					var _v2 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
					if (!_v2.$) {
						var naiveTime = _v2.a;
						var newTime = A2(
							$author$project$Date_Time$NaiveTime$toUtcTime,
							$author$project$Environments$Environment$timeOffset(environment),
							naiveTime);
						return _Utils_update(
							model,
							{
								bl: A2($author$project$Measure$EditDialog$addNaiveTimeToDeadlineState, newTime, model.bl),
								cf: hourInput
							});
					} else {
						return model;
					}
				} else {
					return model;
				}
			}
		}
	});
var $author$project$Measure$EditDialog$enteredHour = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Measure$EditDialog$Visible(
					A3($author$project$Measure$EditDialog$addHourValue, environment, input, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$EditArchived = 1;
var $author$project$Measure$EditDialog$addMinuteValue = F3(
	function (environment, minuteInput, model) {
		if ($elm$core$String$isEmpty(minuteInput)) {
			return _Utils_update(
				model,
				{cj: minuteInput});
		} else {
			if ($elm$core$String$isEmpty(model.cf)) {
				var _v0 = $elm$core$String$toInt(minuteInput);
				if (_v0.$ === 1) {
					return model;
				} else {
					var hour = _v0.a;
					return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
						model,
						{cj: minuteInput}) : model;
				}
			} else {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(model.cf),
					$elm$core$String$toInt(minuteInput));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var hour = _v1.a.a;
					var minute = _v1.b.a;
					var _v2 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
					if (!_v2.$) {
						var naiveTime = _v2.a;
						var newTime = A2(
							$author$project$Date_Time$NaiveTime$toUtcTime,
							$author$project$Environments$Environment$timeOffset(environment),
							naiveTime);
						return _Utils_update(
							model,
							{
								bl: A2($author$project$Measure$EditDialog$addNaiveTimeToDeadlineState, newTime, model.bl),
								cj: minuteInput
							});
					} else {
						return model;
					}
				} else {
					return model;
				}
			}
		}
	});
var $author$project$Measure$EditDialog$enteredMinute = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return (model.aq === 1) ? {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository} : {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Measure$EditDialog$Visible(
					A3($author$project$Measure$EditDialog$addMinuteValue, environment, input, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return (model.aq === 1) ? {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository} : {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Measure$EditDialog$Visible(
					_Utils_update(
						model,
						{
							aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$gotCurrentPosix = F4(
	function (now, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Measure$EditDialog$Visible(
					_Utils_update(
						model,
						{fK: now})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$UI$ImagesEditor$Editor = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$UI$ImagesEditor$setAlternativeFiles = F2(
	function (alternativeFileLookup, _v0) {
		var images_ = _v0.a;
		var disabled_ = _v0.b;
		return A3(
			$author$project$UI$ImagesEditor$Editor,
			images_,
			disabled_,
			$elm$core$Maybe$Just(alternativeFileLookup));
	});
var $author$project$Measure$EditDialog$gotGotTmpFileMsgMsg = F4(
	function (msg, environment, repository, dialog) {
		var _v0 = _Utils_Tuple2(dialog, msg);
		if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
			var model = _v0.a.a;
			var _v1 = _v0.b;
			var blobUrl = _v1.a;
			var filename = _v1.b;
			var newFileUrls = A2(
				$elm$core$List$cons,
				_Utils_Tuple2(blobUrl, filename),
				model.cS);
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Measure$EditDialog$Visible(
					_Utils_update(
						model,
						{
							cS: newFileUrls,
							cY: A2($author$project$UI$ImagesEditor$setAlternativeFiles, newFileUrls, model.cY)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$gotHttpResponse = F4(
	function (httpMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 1:
				var model = dialog.a;
				switch (httpMsg.$) {
					case 13:
						var audit = httpMsg.a;
						return {
							ab: $elm$core$Platform$Cmd$none,
							jn: $author$project$Measure$EditDialog$Visible(
								_Utils_update(
									model,
									{
										fF: $elm$core$Maybe$Just(audit)
									})),
							ac: environment,
							ae: repository
						};
					case 2:
						var status = httpMsg.a;
						var responseMessage = httpMsg.b;
						var resultType = httpMsg.c;
						if (status === 404) {
							return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
						} else {
							var _v2 = A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Environments$ErrorHandling$Id$from,
								$author$project$Environments$Environment$generateUuid(environment));
							var newId = _v2.a;
							var updatedEnvironment = _v2.b;
							var newError = {
								gg: resultType,
								gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
								gH: 'Measure/EditDialog.elm',
								gK: 'gotGetAuditResult',
								fw: newId
							};
							return {
								ab: $elm$core$Platform$Cmd$none,
								jn: dialog,
								ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
								ae: repository
							};
						}
					case 0:
						var resultType = httpMsg.a;
						var _v3 = A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Environments$ErrorHandling$Id$from,
							$author$project$Environments$Environment$generateUuid(environment));
						var newId = _v3.a;
						var updatedEnvironment = _v3.b;
						var newError = {
							gg: 'Unknown return from Javascript in http handler. index.js -> initHttpPort',
							gE: $author$project$Environments$ErrorHandling$Error$OtherError(resultType),
							gH: 'Measure/EditDialog.elm',
							gK: 'gotGetAuditResult',
							fw: newId
						};
						return {
							ab: $elm$core$Platform$Cmd$none,
							jn: dialog,
							ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
							ae: repository
						};
					case 1:
						var decodeError = httpMsg.a;
						var _v4 = A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Environments$ErrorHandling$Id$from,
							$author$project$Environments$Environment$generateUuid(environment));
						var newId = _v4.a;
						var updatedEnvironment = _v4.b;
						var newError = {
							gg: 'Error while Decoding incoming http request',
							gE: $author$project$Environments$ErrorHandling$Error$DecodeError(decodeError),
							gH: 'Measure/EditDialog.elm',
							gK: 'gotGetAuditResult',
							fw: newId
						};
						return {
							ab: $elm$core$Platform$Cmd$none,
							jn: dialog,
							ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
							ae: repository
						};
					default:
						return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				}
			case 2:
				switch (httpMsg.$) {
					case 19:
						return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$EditDialog$Hidden, ac: environment, ae: repository};
					case 20:
						var status = httpMsg.a;
						var responseMessage = httpMsg.b;
						var resultType = httpMsg.c;
						var _v6 = A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Environments$ErrorHandling$Id$from,
							$author$project$Environments$Environment$generateUuid(environment));
						var newId = _v6.a;
						var updatedEnvironment = _v6.b;
						var newError = {
							gg: resultType,
							gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
							gH: 'Measure/EditDialog.elm',
							gK: 'gotDeleteResponse',
							fw: newId
						};
						return {
							ab: $elm$core$Platform$Cmd$none,
							jn: dialog,
							ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
							ae: repository
						};
					case 0:
						var resultType = httpMsg.a;
						var _v7 = A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Environments$ErrorHandling$Id$from,
							$author$project$Environments$Environment$generateUuid(environment));
						var newId = _v7.a;
						var updatedEnvironment = _v7.b;
						var newError = {
							gg: 'Unknown return from Javascript in http handler. index.js -> initHttpPort',
							gE: $author$project$Environments$ErrorHandling$Error$OtherError(resultType),
							gH: 'Measure/EditDialog.elm',
							gK: 'gotDeleteResponse',
							fw: newId
						};
						return {
							ab: $elm$core$Platform$Cmd$none,
							jn: dialog,
							ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
							ae: repository
						};
					case 1:
						var decodeError = httpMsg.a;
						var _v8 = A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Environments$ErrorHandling$Id$from,
							$author$project$Environments$Environment$generateUuid(environment));
						var newId = _v8.a;
						var updatedEnvironment = _v8.b;
						var newError = {
							gg: 'Error while Decoding incoming http request',
							gE: $author$project$Environments$ErrorHandling$Error$DecodeError(decodeError),
							gH: 'Measure/EditDialog.elm',
							gK: 'gotDeleteResponse',
							fw: newId
						};
						return {
							ab: $elm$core$Platform$Cmd$none,
							jn: dialog,
							ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
							ae: repository
						};
					default:
						return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$UI$ImagesEditor$SelectImages = 1;
var $author$project$UI$ImagesEditor$TakePhoto = 0;
var $author$project$UI$ImagesEditor$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'Measure.ImagesEditorr.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$UI$ImagesEditor$encodeOutMsg = function (outMsg) {
	if (!outMsg) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('TAKE_PHOTO'))
				]));
	} else {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('SELECT_IMAGES'))
				]));
	}
};
var $author$project$UI$ImagesEditor$measureImageEditorOutbox = _Platform_outgoingPort('measureImageEditorOutbox', $elm$core$Basics$identity);
var $author$project$UI$ImagesEditor$send = A2($elm$core$Basics$composeR, $author$project$UI$ImagesEditor$encodeOutMsg, $author$project$UI$ImagesEditor$measureImageEditorOutbox);
var $author$project$UI$ImagesEditor$updateImages = F2(
	function (_v0, images_) {
		var disabled_ = _v0.b;
		var alternativeFileLookup_ = _v0.c;
		return A3($author$project$UI$ImagesEditor$Editor, images_, disabled_, alternativeFileLookup_);
	});
var $author$project$UI$ImagesEditor$update = F3(
	function (msg, environment, editor) {
		var images_ = editor.a;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					environment,
					editor,
					$author$project$UI$ImagesEditor$send(0));
			case 1:
				return _Utils_Tuple3(
					environment,
					editor,
					$author$project$UI$ImagesEditor$send(1));
			case 2:
				var filename = msg.a;
				return _Utils_Tuple3(
					environment,
					A2(
						$author$project$UI$ImagesEditor$updateImages,
						editor,
						A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(filename),
							images_)),
					$elm$core$Platform$Cmd$none);
			case 3:
				var filename = msg.a;
				return _Utils_Tuple3(
					environment,
					A2(
						$author$project$UI$ImagesEditor$updateImages,
						editor,
						_Utils_ap(
							images_,
							_List_fromArray(
								[filename]))),
					$elm$core$Platform$Cmd$none);
			case 4:
				var filename = msg.a;
				return _Utils_Tuple3(
					environment,
					A2(
						$author$project$UI$ImagesEditor$updateImages,
						editor,
						_Utils_ap(
							images_,
							_List_fromArray(
								[filename]))),
					$elm$core$Platform$Cmd$none);
			default:
				var err = msg.a;
				return _Utils_Tuple3(
					A2($author$project$UI$ImagesEditor$receivedErrorMsg, err, environment),
					editor,
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Measure$EditDialog$gotImageEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (model.aq === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var _v1 = A3($author$project$UI$ImagesEditor$update, editorMsg, environment, model.cY);
				var newEnvironment = _v1.a;
				var newImageEditor = _v1.b;
				var imageEditorCmd = _v1.c;
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Measure$EditDialog$GotImageEditorMsg, imageEditorCmd),
					jn: $author$project$Measure$EditDialog$Visible(
						_Utils_update(
							model,
							{cY: newImageEditor})),
					ac: newEnvironment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$UI$OrganisationUnitNavigation$Hidden = {$: 0};
var $author$project$UI$OrganisationUnitNavigation$closeDialog = $author$project$UI$OrganisationUnitNavigation$Hidden;
var $author$project$UI$OrganisationUnitNavigation$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$OrganisationStructure$collapseOrganisationUnit = F2(
	function (id, expandedList) {
		return A2(
			$elm$core$List$filter,
			function (item) {
				return !_Utils_eq(item, id);
			},
			expandedList);
	});
var $author$project$UI$OrganisationUnitNavigation$gotCollapseOrganisationUnitMsg = F2(
	function (id, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var newModel = _Utils_update(
				model,
				{
					dI: A2($author$project$UI$OrganisationStructure$collapseOrganisationUnit, id, model.dI)
				});
			return $author$project$UI$OrganisationUnitNavigation$Visible(newModel);
		} else {
			return dialog;
		}
	});
var $author$project$UI$OrganisationStructure$expandOrganisationUnit = F2(
	function (id, expandedList) {
		return A2($elm$core$List$cons, id, expandedList);
	});
var $author$project$UI$OrganisationUnitNavigation$gotExpandOrganisationUnitMsg = F2(
	function (id, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var newModel = _Utils_update(
				model,
				{
					dI: A2($author$project$UI$OrganisationStructure$expandOrganisationUnit, id, model.dI)
				});
			return $author$project$UI$OrganisationUnitNavigation$Visible(newModel);
		} else {
			return dialog;
		}
	});
var $author$project$UI$OrganisationUnitNavigation$update = F2(
	function (msg, dialog) {
		switch (msg.$) {
			case 0:
				return $author$project$UI$OrganisationUnitNavigation$closeDialog;
			case 1:
				var id = msg.a;
				return A2($author$project$UI$OrganisationUnitNavigation$gotExpandOrganisationUnitMsg, id, dialog);
			case 2:
				var id = msg.a;
				return A2($author$project$UI$OrganisationUnitNavigation$gotCollapseOrganisationUnitMsg, id, dialog);
			case 3:
				return $author$project$UI$OrganisationUnitNavigation$closeDialog;
			default:
				return $author$project$UI$OrganisationUnitNavigation$closeDialog;
		}
	});
var $author$project$Measure$EditDialog$receivedOrganisationUnitNavigationMsg = F4(
	function (msg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (model.aq === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var organisationUnitId = function () {
					if (msg.$ === 3) {
						var organisationUnit = msg.a;
						return organisationUnit.km;
					} else {
						return model.km;
					}
				}();
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$EditDialog$Visible(
						_Utils_update(
							model,
							{
								km: organisationUnitId,
								d3: A2($author$project$UI$OrganisationUnitNavigation$update, msg, model.d3)
							})),
					ac: environment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Date_Time$NaiveTime$mid = A3($author$project$Date_Time$NaiveTime$NaiveTime, 12, 0, 0);
var $author$project$Measure$EditDialog$addNaiveDateToDeadlineState = F2(
	function (newDate, deadlineState) {
		if (!deadlineState.$) {
			return A2($author$project$Measure$EditDialog$WithDeadline, newDate, $author$project$Date_Time$NaiveTime$mid);
		} else {
			var naiveTime = deadlineState.b;
			return A2($author$project$Measure$EditDialog$WithDeadline, newDate, naiveTime);
		}
	});
var $author$project$Measure$EditDialog$userChangedEndDateInput = F4(
	function (state, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (model.aq === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var _v1 = function () {
					var _v2 = $author$project$UI$DateInput$maybeDatePickerDate(state);
					if (!_v2.$) {
						var newDate = _v2.a;
						return _Utils_Tuple2(
							A2($author$project$Measure$EditDialog$addNaiveDateToDeadlineState, newDate, model.bl),
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple2(model.bl, model.dy);
					}
				}();
				var deadlineDate = _v1.a;
				var dateTextInput = _v1.b;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$EditDialog$Visible(
						_Utils_update(
							model,
							{dy: dateTextInput, bl: deadlineDate, cQ: state})),
					ac: environment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$CreatedCommands = function (a) {
	return {$: 18, a: a};
};
var $author$project$Measure$EditDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$Measure$Command$commandHelper = F2(
	function (environment, buildCommand) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Types$CommandId$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var commandId_ = _v0.a;
		var newEnvironment = _v0.b;
		return _Utils_Tuple2(
			newEnvironment,
			A2(
				$elm$core$Task$map,
				buildCommand(commandId_),
				$elm$time$Time$now));
	});
var $author$project$Measure$Command$addImages = F5(
	function (environment, measureId, idForError, titleForError, images) {
		return A2(
			$author$project$Measure$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Measure$Command$AddImages(
						{gf: images, L: commandId_, M: commandTimestamp, k: idForError, h5: measureId, l: titleForError});
				}));
	});
var $author$project$UI$ImagesEditor$images = function (_v0) {
	var images_ = _v0.a;
	return images_;
};
var $author$project$Measure$EditDialog$withAddImageCommands = F3(
	function (measure, imageEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var images = $author$project$UI$ImagesEditor$images(imageEditor);
		if (_Utils_eq(measure.fx, images)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var addImages = A2(
				$elm$core$List$filter,
				function (image) {
					return !A2($elm$core$List$member, image, measure.fx);
				},
				images);
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A5($author$project$Measure$Command$addImages, environment, measure.h5, measure.fw, measure.k8, addImages));
		}
	});
var $author$project$Measure$Command$changeDeadline = F2(
	function (environment, model) {
		return A2(
			$author$project$Measure$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Measure$Command$ChangeDeadline(
						{L: commandId_, M: commandTimestamp, hI: model.hI, k: model.k, h5: model.h5, l: model.l});
				}));
	});
var $author$project$Measure$EditDialog$withChangDeadlineCommand = F3(
	function (measure, deadlineState, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var _v1 = _Utils_Tuple2(measure.hI, deadlineState);
		if (!_v1.a.$) {
			if (!_v1.b.$) {
				var _v2 = _v1.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$List$cons, task, tasks);
					},
					A2(
						$author$project$Measure$Command$changeDeadline,
						environment,
						{hI: $elm$core$Maybe$Nothing, k: measure.fw, h5: measure.h5, l: measure.k8}));
			} else {
				var deadlineTimestamp = _v1.a.a;
				var _v3 = _v1.b;
				var naiveDate = _v3.a;
				var naiveTime = _v3.b;
				var oldTime = A2($author$project$Date_Time$NaiveTime$fromPosix, $elm$time$Time$utc, deadlineTimestamp);
				var oldDate = A2($author$project$Date_Time$NaiveDate$fromPosix, $elm$time$Time$utc, deadlineTimestamp);
				return (_Utils_eq(naiveDate, oldDate) && _Utils_eq(naiveTime, oldTime)) ? _Utils_Tuple2(environment, tasks) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$List$cons, task, tasks);
					},
					A2(
						$author$project$Measure$Command$changeDeadline,
						environment,
						{
							hI: $elm$core$Maybe$Just(
								$elm$time$Time$millisToPosix(
									$elm$time$Time$posixToMillis(
										$author$project$Date_Time$NaiveDate$toPosix(naiveDate)) + $author$project$Date_Time$NaiveTime$toMillis(naiveTime))),
							k: measure.fw,
							h5: measure.h5,
							l: measure.k8
						}));
			}
		} else {
			if (_v1.b.$ === 1) {
				var _v4 = _v1.a;
				var _v5 = _v1.b;
				var newDate = _v5.a;
				var newTime = _v5.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$List$cons, task, tasks);
					},
					A2(
						$author$project$Measure$Command$changeDeadline,
						environment,
						{
							hI: $elm$core$Maybe$Just(
								$elm$time$Time$millisToPosix(
									$elm$time$Time$posixToMillis(
										$author$project$Date_Time$NaiveDate$toPosix(newDate)) + $author$project$Date_Time$NaiveTime$toMillis(newTime))),
							k: measure.fw,
							h5: measure.h5,
							l: measure.k8
						}));
			} else {
				var _v6 = _v1.a;
				var _v7 = _v1.b;
				return _Utils_Tuple2(environment, tasks);
			}
		}
	});
var $author$project$Measure$Command$changeDescription = F2(
	function (environment, model) {
		return A2(
			$author$project$Measure$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Measure$Command$ChangeDescription(
						{L: commandId_, M: commandTimestamp, aY: model.aY, k: model.k, h5: model.h5, l: model.l});
				}));
	});
var $author$project$Measure$EditDialog$withChangeDescriptionCommand = F3(
	function (measure, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(
			$author$project$UI$BasicDataEditor$description(basicDataEditor),
			measure.aY) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$Measure$Command$changeDescription,
				environment,
				{
					aY: $author$project$UI$BasicDataEditor$description(basicDataEditor),
					k: measure.fw,
					h5: measure.h5,
					l: measure.k8
				}));
	});
var $author$project$Measure$Command$changeOrganisationUnit = F2(
	function (environment, model) {
		return A2(
			$author$project$Measure$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Measure$Command$ChangeOrganisationUnit(
						{L: commandId_, M: commandTimestamp, k: model.k, h5: model.h5, km: model.km, l: model.l});
				}));
	});
var $author$project$Measure$EditDialog$withChangeOrganisationUnitCommand = F3(
	function (measure, organisationUnitId, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(measure.km, organisationUnitId) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$Measure$Command$changeOrganisationUnit,
				environment,
				{k: measure.fw, h5: measure.h5, km: organisationUnitId, l: measure.k8}));
	});
var $author$project$Measure$Command$changeResponsibleUsers = F2(
	function (environment, model) {
		return A2(
			$author$project$Measure$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Measure$Command$ChangeResponsibleUsers(
						{e9: model.e9, L: commandId_, M: commandTimestamp, k: model.k, h5: model.h5, f_: model.f_, l: model.l});
				}));
	});
var $author$project$Measure$EditDialog$withChangeResponsibleUsersCommand = F4(
	function (measure, addAuditors, removeAuditors, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return ($author$project$User$Ids$isEmpty(addAuditors) && $author$project$User$Ids$isEmpty(removeAuditors)) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$Measure$Command$changeResponsibleUsers,
				environment,
				{e9: addAuditors, k: measure.fw, h5: measure.h5, f_: removeAuditors, l: measure.k8}));
	});
var $author$project$Measure$Command$changeTitle = F2(
	function (environment, model) {
		return A2(
			$author$project$Measure$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Measure$Command$ChangeTitle(
						{L: commandId_, M: commandTimestamp, k: model.k, h5: model.h5, k8: model.k8, l: model.l});
				}));
	});
var $author$project$Measure$EditDialog$withChangeTitleCommand = F3(
	function (measure, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var _v1 = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		if (_v1 === '') {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var title = _v1;
			return _Utils_eq(title, measure.k8) ? _Utils_Tuple2(environment, tasks) : A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2(
					$author$project$Measure$Command$changeTitle,
					environment,
					{k: measure.fw, h5: measure.h5, k8: title, l: measure.k8}));
		}
	});
var $author$project$Measure$Command$removeImages = F5(
	function (environment, measureId, idForError, titleForError, images) {
		return A2(
			$author$project$Measure$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Measure$Command$RemoveImages(
						{L: commandId_, M: commandTimestamp, k: idForError, h5: measureId, ha: images, l: titleForError});
				}));
	});
var $author$project$Measure$EditDialog$withRemoveImageCommands = F3(
	function (measure, imageEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var images = $author$project$UI$ImagesEditor$images(imageEditor);
		if (_Utils_eq(measure.fx, images)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var deletedImages = A2(
				$elm$core$List$filter,
				function (image) {
					return !A2($elm$core$List$member, image, images);
				},
				measure.fx);
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A5($author$project$Measure$Command$removeImages, environment, measure.h5, measure.fw, measure.k8, deletedImages));
		}
	});
var $author$project$Measure$EditDialog$createCommands = F3(
	function (environment, measure, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A3(
				$author$project$Measure$EditDialog$withRemoveImageCommands,
				measure,
				model.cY,
				A3(
					$author$project$Measure$EditDialog$withAddImageCommands,
					measure,
					model.cY,
					A3(
						$author$project$Measure$EditDialog$withChangeOrganisationUnitCommand,
						measure,
						model.km,
						A3(
							$author$project$Measure$EditDialog$withChangDeadlineCommand,
							measure,
							model.bl,
							A4(
								$author$project$Measure$EditDialog$withChangeResponsibleUsersCommand,
								measure,
								model.ge,
								model.g9,
								A3(
									$author$project$Measure$EditDialog$withChangeDescriptionCommand,
									measure,
									model.aQ,
									A3(
										$author$project$Measure$EditDialog$withChangeTitleCommand,
										measure,
										model.aQ,
										_Utils_Tuple2(environment, _List_Nil)))))))));
	});
var $author$project$Measure$EditDialog$userClickedApplyButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = A2($author$project$Environments$Repository$getMeasure, model.h.h5, repository);
				if (_v1.$ === 1) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$EditDialog$Deleted, ac: environment, ae: repository};
				} else {
					var measure = _v1.a;
					if ($author$project$Utils$String$isBlank(
						$author$project$UI$BasicDataEditor$title(model.aQ)) || (model.aq === 1)) {
						return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
					} else {
						var _v2 = A3($author$project$Measure$EditDialog$createCommands, environment, measure, model);
						var newEnvironment = _v2.a;
						var tasks = _v2.b;
						return {
							ab: A2(
								$elm$core$Task$perform,
								$author$project$Measure$EditDialog$CreatedCommands,
								$elm$core$Task$sequence(tasks)),
							jn: $author$project$Measure$EditDialog$HandlingCommands(model),
							ac: newEnvironment,
							ae: repository
						};
					}
				}
			case 3:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$EditDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$EditDialog$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$userClickedCloseButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 2) {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$EditDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$EditDialog$Hidden, ac: environment, ae: repository};
			case 3:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$EditDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$Command$complete = F4(
	function (environment, measureId, idForError, titleForError) {
		return A2(
			$author$project$Measure$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Measure$Command$Complete(
						{L: commandId_, M: commandTimestamp, k: idForError, h5: measureId, l: titleForError});
				}));
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Measure$EditDialog$userClickedCompleteButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 1:
				var model = dialog.a;
				if (model.aq === 1) {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				} else {
					var _v1 = A2(
						$elm$core$Tuple$mapSecond,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$singleton,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Task$sequence,
								$elm$core$Task$perform($author$project$Measure$EditDialog$CreatedCommands))),
						A4($author$project$Measure$Command$complete, environment, model.h.h5, model.h.fw, model.h.k8));
					var newEnvironment = _v1.a;
					var cmd = _v1.b;
					return {
						ab: cmd,
						jn: $author$project$Measure$EditDialog$HandlingCommands(model),
						ac: newEnvironment,
						ae: repository
					};
				}
			case 3:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$EditDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$CreatedDeleteCommand = function (a) {
	return {$: 20, a: a};
};
var $author$project$Measure$Command$delete = F4(
	function (environment, measureId, idForError, titleForError) {
		return A2(
			$author$project$Measure$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Measure$Command$Delete(
						{L: commandId_, M: commandTimestamp, k: idForError, h5: measureId, l: titleForError});
				}));
	});
var $author$project$Measure$EditDialog$userClickedDelete = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (A3(
				$author$project$Auth$Authorization$authorize,
				$author$project$Environments$Environment$userRights(environment),
				6,
				model.h.km)) {
				var _v1 = A4($author$project$Measure$Command$delete, environment, model.h.h5, model.h.fw, model.h.k8);
				var newEnvironment = _v1.a;
				var task = _v1.b;
				var cmd_ = function () {
					var _v2 = model.aq;
					if (!_v2) {
						return A2(
							$elm$core$Task$perform,
							$author$project$Measure$EditDialog$CreatedCommands,
							$elm$core$Task$sequence(
								_List_fromArray(
									[task])));
					} else {
						return A2($elm$core$Task$perform, $author$project$Measure$EditDialog$CreatedDeleteCommand, task);
					}
				}();
				return {
					ab: cmd_,
					jn: $author$project$Measure$EditDialog$HandlingCommands(model),
					ac: newEnvironment,
					ae: repository
				};
			} else {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Environments$Route$PerformAudit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Measure$EditDialog$userClickedOnAudit = F4(
	function (audit, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var route = function () {
				var _v1 = audit.jb;
				if (!_v1.$) {
					return $author$project$Environments$Route$PerformAudit(audit.gm);
				} else {
					return $author$project$Environments$Route$ViewArchivedAudit(audit.gm);
				}
			}();
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: dialog,
				ac: A2($author$project$Environments$Environment$navigateTo, route, environment),
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$File$TmpFile$TmpFile$DownloadTmpMeasureFile = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$File$TmpFile$TmpFile$encodeOutMsg = function (msg) {
	if (!msg.$) {
		var apiVersion = msg.a;
		var filename = msg.b;
		var path = msg.c;
		var recordId = msg.d;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DOWNLOAD_TMP_RECORD_FILE')),
					_Utils_Tuple2(
					'apiVersion',
					$elm$json$Json$Encode$int(apiVersion)),
					_Utils_Tuple2(
					'filename',
					$author$project$File$Filename$encode(filename)),
					_Utils_Tuple2(
					'path',
					$elm$json$Json$Encode$string(path)),
					_Utils_Tuple2(
					'recordId',
					$author$project$Audit$Record$Id$encode(recordId))
				]));
	} else {
		var apiVersion = msg.a;
		var filename = msg.b;
		var path = msg.c;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DOWNLOAD_TMP_MEASURE_FILE')),
					_Utils_Tuple2(
					'apiVersion',
					$elm$json$Json$Encode$int(apiVersion)),
					_Utils_Tuple2(
					'filename',
					$author$project$File$Filename$encode(filename)),
					_Utils_Tuple2(
					'path',
					$elm$json$Json$Encode$string(path))
				]));
	}
};
var $author$project$File$TmpFile$TmpFile$tmpFileStoreOutbox = _Platform_outgoingPort('tmpFileStoreOutbox', $elm$core$Basics$identity);
var $author$project$File$TmpFile$TmpFile$send = A2($elm$core$Basics$composeR, $author$project$File$TmpFile$TmpFile$encodeOutMsg, $author$project$File$TmpFile$TmpFile$tmpFileStoreOutbox);
var $author$project$File$TmpFile$TmpFile$downloadMeasureFile = F3(
	function (environment, filename, path) {
		return $author$project$File$TmpFile$TmpFile$send(
			A3(
				$author$project$File$TmpFile$TmpFile$DownloadTmpMeasureFile,
				$author$project$Environments$Environment$apiVersion(environment),
				filename,
				path));
	});
var $author$project$Measure$EditDialog$getFilePath = F2(
	function (organisationUnitId, measureId) {
		return 'organisationUnits/' + ($author$project$OrganisationUnit$Id$toString(organisationUnitId) + ('/measures/' + $author$project$Measure$Id$toString(measureId)));
	});
var $author$project$Measure$EditDialog$BasicDataTab = 0;
var $author$project$Measure$EditDialog$switchTab = F2(
	function (tab, model) {
		if (_Utils_eq(model.cI, tab)) {
			return model;
		} else {
			if (!model.cI) {
				var title = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$title(model.aQ));
				var description = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$description(model.aQ));
				return $elm$core$String$isEmpty(title) ? model : _Utils_update(
					model,
					{
						aQ: A2(
							$author$project$UI$BasicDataEditor$withDescription,
							description,
							A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ)),
						cI: tab
					});
			} else {
				return _Utils_update(
					model,
					{cI: tab});
			}
		}
	});
var $author$project$Measure$EditDialog$userClickedTabIcon = F4(
	function (tab, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var fileCmds = function () {
				var _v1 = _Utils_Tuple2(tab, model.aq);
				if ((_v1.a === 1) && (_v1.b === 1)) {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					return $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (filename) {
								return A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Measure$EditDialog$GotTmpFileMsg,
									A3(
										$author$project$File$TmpFile$TmpFile$downloadMeasureFile,
										environment,
										filename,
										A2($author$project$Measure$EditDialog$getFilePath, model.h.km, model.h.h5)));
							},
							model.h.fx));
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			}();
			return {
				ab: fileCmds,
				jn: $author$project$Measure$EditDialog$Visible(
					A2($author$project$Measure$EditDialog$switchTab, tab, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$userDeletedDeadline = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return (model.aq === 1) ? {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository} : {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Measure$EditDialog$Visible(
					_Utils_update(
						model,
						{bl: $author$project$Measure$EditDialog$NoDeadline})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$userEnteredDateText = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (model.aq === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var _v1 = function () {
					var _v2 = model.bl;
					if (!_v2.$) {
						return _Utils_Tuple2(
							$elm$core$String$fromInt(
								$author$project$Date_Time$NaiveTime$hour(
									A2(
										$author$project$Date_Time$NaiveTime$fromPosix,
										$author$project$Environments$Environment$timeZone(environment),
										$elm$time$Time$millisToPosix(
											$author$project$Date_Time$NaiveTime$toMillis($author$project$Date_Time$NaiveTime$mid))))),
							'00');
					} else {
						return _Utils_Tuple2(model.cf, model.cj);
					}
				}();
				var hourInput = _v1.a;
				var minuteInput = _v1.b;
				var _v3 = function () {
					var _v4 = $author$project$UI$DateInput$inputToNaivDate(
						A3($elm$core$String$replace, '.', '-', input));
					if (!_v4.$) {
						var dateValue = _v4.a;
						return _Utils_Tuple3(
							A2($author$project$Measure$EditDialog$addNaiveDateToDeadlineState, dateValue, model.bl),
							$elm$core$Maybe$Nothing,
							A2($author$project$UI$DateInput$updateDatePicker, dateValue, model.cQ));
					} else {
						return _Utils_Tuple3(
							model.bl,
							$elm$core$Maybe$Just(input),
							model.cQ);
					}
				}();
				var deadlineDate = _v3.a;
				var dateTextInput = _v3.b;
				var endDateInput = _v3.c;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$EditDialog$Visible(
						_Utils_update(
							model,
							{dy: dateTextInput, bl: deadlineDate, cQ: endDateInput, cf: hourInput, cj: minuteInput})),
					ac: environment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$UI$OrganisationUnitNavigation$VisibleModel = F2(
	function (expandedOrganisationUnitList, showAllWhenEditTenant) {
		return {dI: expandedOrganisationUnitList, kS: showAllWhenEditTenant};
	});
var $author$project$UI$OrganisationUnitNavigation$visible = function (showAllWhenEditTenant) {
	return $author$project$UI$OrganisationUnitNavigation$Visible(
		A2($author$project$UI$OrganisationUnitNavigation$VisibleModel, _List_Nil, showAllWhenEditTenant));
};
var $author$project$Measure$EditDialog$userLickedOrganisationUnit = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return (model.aq === 1) ? {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository} : {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Measure$EditDialog$Visible(
					_Utils_update(
						model,
						{
							d3: $author$project$UI$OrganisationUnitNavigation$visible(false)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$userSelectedUser = F4(
	function (userId, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (model.aq === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var newModel = A2($author$project$User$Ids$member, userId, model.g9) ? _Utils_update(
					model,
					{
						g9: A2($author$project$User$Ids$remove, userId, model.g9),
						bb: A2($author$project$User$Ids$insert, userId, model.bb)
					}) : _Utils_update(
					model,
					{
						ge: A2($author$project$User$Ids$insert, userId, model.ge),
						bb: A2($author$project$User$Ids$insert, userId, model.bb)
					});
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$EditDialog$Visible(newModel),
					ac: environment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$userUnselectedUser = F4(
	function (userId, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			if (model.aq === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var newModel = A2($author$project$User$Ids$member, userId, model.ge) ? _Utils_update(
					model,
					{
						ge: A2($author$project$User$Ids$remove, userId, model.ge),
						bb: A2($author$project$User$Ids$remove, userId, model.bb)
					}) : _Utils_update(
					model,
					{
						g9: A2($author$project$User$Ids$insert, userId, model.g9),
						bb: A2($author$project$User$Ids$remove, userId, model.bb)
					});
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$EditDialog$Visible(newModel),
					ac: environment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			var now = msg.a;
			return $author$project$Measure$EditDialog$gotCurrentPosix(now);
		case 1:
			return $author$project$Measure$EditDialog$userClickedCloseDialog;
		case 2:
			var tab = msg.a;
			return $author$project$Measure$EditDialog$userClickedTabIcon(tab);
		case 3:
			return $author$project$Measure$EditDialog$userClickedCancelButton;
		case 4:
			return $author$project$Measure$EditDialog$userClickedApplyButton;
		case 5:
			return $author$project$Measure$EditDialog$userClickedCompleteButton;
		case 6:
			return $author$project$Measure$EditDialog$userClickedCloseButton;
		case 7:
			var editorMsg = msg.a;
			return $author$project$Measure$EditDialog$gotBasicDataEditorMsg(editorMsg);
		case 8:
			var editorMsg = msg.a;
			return $author$project$Measure$EditDialog$gotImageEditorMsg(editorMsg);
		case 9:
			var userId = msg.a;
			return $author$project$Measure$EditDialog$userSelectedUser(userId);
		case 10:
			var userId = msg.a;
			return $author$project$Measure$EditDialog$userUnselectedUser(userId);
		case 11:
			var state = msg.a;
			return $author$project$Measure$EditDialog$userChangedEndDateInput(state);
		case 12:
			var text = msg.a;
			return $author$project$Measure$EditDialog$userEnteredDateText(text);
		case 13:
			var input = msg.a;
			return $author$project$Measure$EditDialog$enteredHour(input);
		case 14:
			var input = msg.a;
			return $author$project$Measure$EditDialog$enteredMinute(input);
		case 15:
			return $author$project$Measure$EditDialog$userDeletedDeadline;
		case 16:
			return $author$project$Measure$EditDialog$userLickedOrganisationUnit;
		case 17:
			var navigationMsg = msg.a;
			return $author$project$Measure$EditDialog$receivedOrganisationUnitNavigationMsg(navigationMsg);
		case 18:
			var commands = msg.a;
			return $author$project$Measure$EditDialog$createdCommands(commands);
		case 19:
			return $author$project$Measure$EditDialog$userClickedDelete;
		case 20:
			var command = msg.a;
			return $author$project$Measure$EditDialog$createdDeleteCommand(command);
		case 21:
			var audit = msg.a;
			return $author$project$Measure$EditDialog$userClickedOnAudit(audit);
		case 22:
			var httpMsg = msg.a;
			return $author$project$Measure$EditDialog$gotHttpResponse(httpMsg);
		default:
			var tmpFileMsg = msg.a;
			return $author$project$Measure$EditDialog$gotGotTmpFileMsgMsg(tmpFileMsg);
	}
};
var $author$project$Archive$CombinedArchiveContent$withEditMeasureDialog = F2(
	function (editDialog_, content) {
		switch (content.$) {
			case 0:
				return $author$project$Archive$CombinedArchiveContent$ContentLoading;
			case 1:
				var model = content.a;
				return $author$project$Archive$CombinedArchiveContent$ContentLoaded(
					_Utils_update(
						model,
						{cP: editDialog_}));
			default:
				return $author$project$Archive$CombinedArchiveContent$ContentError;
		}
	});
var $author$project$Archive$CombinedArchiveContent$gotEditMeasureDialogMsg = F4(
	function (dialogMsg, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var updatedCombinedArchived = function () {
				if (((dialogMsg.$ === 22) && (dialogMsg.a.$ === 19)) && (dialogMsg.a.a.$ === 9)) {
					var deletePayload = dialogMsg.a.a.a;
					return A2($author$project$Archive$CombinedArchive$removeMeasure, deletePayload.h5, model.an);
				} else {
					return model.an;
				}
			}();
			var result = A4($author$project$Measure$EditDialog$update, dialogMsg, environment, repository, model.cP);
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$CombinedArchiveContent$GotEditMeasureDialogMsg, result.ab),
				ai: A2(
					$author$project$Archive$CombinedArchiveContent$withCombinedMeasures,
					updatedCombinedArchived,
					A2($author$project$Archive$CombinedArchiveContent$withEditMeasureDialog, result.jn, content)),
				ac: result.ac,
				ae: result.ae
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$CombinedArchive$empty = {ew: -1, bd: _List_Nil};
var $author$project$Measure$EditDialog$hidden = $author$project$Measure$EditDialog$Hidden;
var $author$project$Archive$CombinedArchive$updateValues = F2(
	function (_v0, newValues) {
		var data = _v0;
		return _Utils_update(
			data,
			{bd: newValues});
	});
var $author$project$Archive$CombinedArchive$values = function (_v0) {
	var data = _v0;
	return data.bd;
};
var $author$project$Archive$CombinedArchiveContent$gotGetCombinedArchiveResult = F4(
	function (result, environment, repository, content) {
		switch (result.$) {
			case 0:
				var resultType = result.a;
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v1.a;
				var updatedEnvironment = _v1.b;
				var newError = {
					gg: 'Unknown return from Javascript in http handler. index.js -> initHttpPort',
					gE: $author$project$Environments$ErrorHandling$Error$OtherError(resultType),
					gH: 'Archive.CombinedArchiveContentt.elm',
					gK: 'gotGetMeasuresResult',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					ai: $author$project$Archive$CombinedArchiveContent$ContentError,
					ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					ae: repository
				};
			case 1:
				var decodeError = result.a;
				var _v2 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v2.a;
				var updatedEnvironment = _v2.b;
				var newError = {
					gg: 'Error while Decoding incoming http request',
					gE: $author$project$Environments$ErrorHandling$Error$DecodeError(decodeError),
					gH: 'Archive.CombinedArchiveContent.elm',
					gK: 'gotGetCombinedArchiveResult',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					ai: $author$project$Archive$CombinedArchiveContent$ContentError,
					ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					ae: repository
				};
			case 2:
				var status = result.a;
				var responseMessage = result.b;
				var resultType = result.c;
				if ((status === 404) && (resultType === 'GET_AUDIT')) {
					return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
				} else {
					var _v3 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v3.a;
					var updatedEnvironment = _v3.b;
					var newError = {
						gg: resultType,
						gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
						gH: 'Archive.CombinedArchiveContent.elm',
						gK: 'gotGetCombinedArchiveResult',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						ai: $author$project$Archive$CombinedArchiveContent$ContentError,
						ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
						ae: repository
					};
				}
			case 30:
				var combinedArchive = result.a;
				switch (content.$) {
					case 0:
						return {
							ab: $elm$core$Platform$Cmd$none,
							ai: $author$project$Archive$CombinedArchiveContent$ContentLoaded(
								{an: combinedArchive, cN: $author$project$Audit$EditDialog$hidden, cP: $author$project$Measure$EditDialog$hidden, bF: 300}),
							ac: environment,
							ae: repository
						};
					case 1:
						var model = content.a;
						return {
							ab: $elm$core$Platform$Cmd$none,
							ai: $author$project$Archive$CombinedArchiveContent$ContentLoaded(
								_Utils_update(
									model,
									{
										an: A2(
											$author$project$Archive$CombinedArchive$updateValues,
											combinedArchive,
											_Utils_ap(
												$author$project$Archive$CombinedArchive$values(model.an),
												$author$project$Archive$CombinedArchive$values(combinedArchive)))
									})),
							ac: environment,
							ae: repository
						};
					default:
						return {
							ab: $elm$core$Platform$Cmd$none,
							ai: $author$project$Archive$CombinedArchiveContent$ContentLoaded(
								{an: $author$project$Archive$CombinedArchive$empty, cN: $author$project$Audit$EditDialog$hidden, cP: $author$project$Measure$EditDialog$hidden, bF: 300}),
							ac: environment,
							ae: repository
						};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$CombinedArchive$count = function (_v0) {
	var data = _v0;
	return data.ew;
};
var $author$project$Utils$Http$GetCombinedArchive = 19;
var $author$project$Archive$CombinedArchiveContent$getRequest = F3(
	function (environment, search, last_chunk) {
		var takeHeader = _List_fromArray(
			[
				A2(
				$author$project$Utils$Http$Header,
				'x-take',
				$elm$core$String$fromInt(last_chunk + 300)),
				A2(
				$author$project$Utils$Http$Header,
				'x-skip',
				$elm$core$String$fromInt(last_chunk))
			]);
		var searchHeader = $elm$core$String$isEmpty(search) ? _List_Nil : _List_fromArray(
			[
				A2($author$project$Utils$Http$Header, 'x-search-string', search)
			]);
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Archive$CombinedArchiveContent$GotGetCombinedArchiveResult,
			A3(
				$author$project$Utils$Http$sendGet,
				$author$project$Environments$Environment$baseUri(environment) + '/evaluation/query',
				A2($elm$core$List$append, takeHeader, searchHeader),
				19));
	});
var $author$project$Archive$CombinedArchiveContent$scrollEvent = F5(
	function (searchValue, scrollInfo, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var _v1 = (((scrollInfo.kM - scrollInfo.kN) <= 2000) && (_Utils_cmp(
				model.bF,
				$author$project$Archive$CombinedArchive$count(model.an)) < 0)) ? _Utils_Tuple2(
				model.bF + 300,
				A3($author$project$Archive$CombinedArchiveContent$getRequest, environment, searchValue, model.bF)) : _Utils_Tuple2(model.bF, $elm$core$Platform$Cmd$none);
			var newTakeValue = _v1.a;
			var cmd = _v1.b;
			return {
				ab: cmd,
				ai: $author$project$Archive$CombinedArchiveContent$ContentLoaded(
					_Utils_update(
						model,
						{bF: newTakeValue})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$CombinedArchiveContent$searchOnEnter = F4(
	function (searchValue, environment, repository, content) {
		if (content.$ === 1) {
			return {
				ab: A3($author$project$Archive$CombinedArchiveContent$getRequest, environment, searchValue, 0),
				ai: $author$project$Archive$CombinedArchiveContent$ContentLoading,
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$CombinedArchiveContent$userClickedAuditEditIcon = F4(
	function (auditId, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var updatedContent = function () {
				var _v1 = A2($author$project$Archive$CombinedArchive$getAudit, auditId, model.an);
				if (!_v1.$) {
					var audit = _v1.a;
					return A2(
						$author$project$Archive$CombinedArchiveContent$withEditAuditDialog,
						A5(
							$author$project$Audit$EditDialog$show,
							environment,
							repository,
							1,
							$author$project$Environments$Environment$timeZone(environment),
							audit),
						content);
				} else {
					return content;
				}
			}();
			return {ab: $elm$core$Platform$Cmd$none, ai: updatedContent, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$EditDialog$GotCurrentPosix = function (a) {
	return {$: 0, a: a};
};
var $author$project$Measure$EditDialog$disableInput = F3(
	function (environment, measure, context) {
		return (context === 1) || (!A3(
			$author$project$Auth$Authorization$authorize,
			$author$project$Environments$Environment$userRights(environment),
			5,
			measure.km));
	});
var $author$project$UI$ImagesEditor$disabled = F2(
	function (bool, _v0) {
		var images_ = _v0.a;
		var alternativeFileLookup_ = _v0.c;
		return A3($author$project$UI$ImagesEditor$Editor, images_, bool, alternativeFileLookup_);
	});
var $author$project$UI$ImagesEditor$from = function (files) {
	return A3($author$project$UI$ImagesEditor$Editor, files, false, $elm$core$Maybe$Nothing);
};
var $author$project$Utils$Triple$fromTuple = F2(
	function (a, _v0) {
		var b = _v0.a;
		var c = _v0.b;
		return _Utils_Tuple3(a, b, c);
	});
var $author$project$Utils$Http$GetAudit = 7;
var $author$project$Measure$EditDialog$getAuditRequest = F2(
	function (auditId, environment) {
		var baseUrl = A3(
			$elm$core$String$replace,
			'baseUri',
			$author$project$Environments$Environment$baseUri(environment),
			'baseUri/audits/query/' + $author$project$Audit$Id$toString(auditId));
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Measure$EditDialog$GotHttpResponse,
			A3($author$project$Utils$Http$sendGet, baseUrl, _List_Nil, 7));
	});
var $author$project$Measure$EditDialog$intToFormattedString = function (value) {
	var str = $elm$core$String$fromInt(value);
	return (value < 10) ? ('0' + str) : str;
};
var $author$project$Measure$EditDialog$getHourAndMinuteValues = function (time) {
	return _Utils_Tuple2(
		$author$project$Measure$EditDialog$intToFormattedString(
			$author$project$Date_Time$NaiveTime$hour(time)),
		$author$project$Measure$EditDialog$intToFormattedString(
			$author$project$Date_Time$NaiveTime$minute(time)));
};
var $author$project$UI$OrganisationUnitNavigation$hidden = $author$project$UI$OrganisationUnitNavigation$Hidden;
var $author$project$Measure$EditDialog$show = F4(
	function (environment, repository, context, measure) {
		var timeZone = $author$project$Environments$Environment$timeZone(environment);
		var _v0 = function () {
			var _v1 = measure.hI;
			if (!_v1.$) {
				var deadlineTimestamp = _v1.a;
				return A2(
					$author$project$Utils$Triple$fromTuple,
					A2(
						$author$project$Measure$EditDialog$WithDeadline,
						A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, deadlineTimestamp),
						A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, deadlineTimestamp)),
					$author$project$Measure$EditDialog$getHourAndMinuteValues(
						A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, deadlineTimestamp)));
			} else {
				return _Utils_Tuple3($author$project$Measure$EditDialog$NoDeadline, '', '');
			}
		}();
		var deadlineDate = _v0.a;
		var hourValue = _v0.b;
		var minuteValue = _v0.c;
		var _v2 = function () {
			var _v3 = measure.h6;
			if (!_v3.$) {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			} else {
				var issueData = _v3.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Environments$Environment$isOffline(environment) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2($author$project$Measure$EditDialog$getAuditRequest, issueData.gm, environment)),
					A2(
						$elm$core$Maybe$map,
						function (audit) {
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(audit),
								$elm$core$Platform$Cmd$none);
						},
						A2($author$project$Environments$Repository$getAudit, issueData.gm, repository)));
			}
		}();
		var maybeOriginAudit = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			$author$project$Measure$EditDialog$Visible(
				{
					ge: $author$project$User$Ids$empty,
					aQ: A2(
						$author$project$UI$BasicDataEditor$withDisableInput,
						A3($author$project$Measure$EditDialog$disableInput, environment, measure, context),
						$author$project$UI$BasicDataEditor$from(measure)),
					aq: context,
					cI: 0,
					dy: $elm$core$Maybe$Nothing,
					bl: deadlineDate,
					cQ: $author$project$UI$DateInput$collapsed,
					cS: _List_Nil,
					cf: hourValue,
					cY: A2(
						$author$project$UI$ImagesEditor$setAlternativeFiles,
						_List_Nil,
						A2(
							$author$project$UI$ImagesEditor$disabled,
							A3($author$project$Measure$EditDialog$disableInput, environment, measure, context),
							$author$project$UI$ImagesEditor$from(measure.fx))),
					fF: maybeOriginAudit,
					h: measure,
					cj: minuteValue,
					fK: $elm$time$Time$millisToPosix(0),
					km: measure.km,
					d3: $author$project$UI$OrganisationUnitNavigation$hidden,
					g9: $author$project$User$Ids$empty,
					bb: measure.bb
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Measure$EditDialog$GotCurrentPosix, $elm$time$Time$now),
						cmd
					])));
	});
var $author$project$Archive$CombinedArchiveContent$userClickedMeasureEditIcon = F4(
	function (measureId, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var _v1 = function () {
				var _v2 = A2($author$project$Archive$CombinedArchive$getMeasure, measureId, model.an);
				if (!_v2.$) {
					var measure = _v2.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Archive$CombinedArchiveContent$GotEditMeasureDialogMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (newDialog) {
								return A2($author$project$Archive$CombinedArchiveContent$withEditMeasureDialog, newDialog, content);
							},
							A4($author$project$Measure$EditDialog$show, environment, repository, 1, measure)));
				} else {
					return _Utils_Tuple2(content, $elm$core$Platform$Cmd$none);
				}
			}();
			var updatedContent = _v1.a;
			var cmd = _v1.b;
			return {ab: cmd, ai: updatedContent, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$CombinedArchiveContent$userClickedViewAudit = F4(
	function (auditId, environment, repository, content) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ai: content,
			ac: A2(
				$author$project$Environments$Environment$navigateTo,
				$author$project$Environments$Route$ViewArchivedAudit(auditId),
				environment),
			ae: repository
		};
	});
var $author$project$Archive$CombinedArchiveContent$update = function (msg) {
	switch (msg.$) {
		case 0:
			var result = msg.a;
			return $author$project$Archive$CombinedArchiveContent$gotGetCombinedArchiveResult(result);
		case 1:
			var measureId = msg.a;
			return $author$project$Archive$CombinedArchiveContent$userClickedMeasureEditIcon(measureId);
		case 2:
			var auditId = msg.a;
			return $author$project$Archive$CombinedArchiveContent$userClickedAuditEditIcon(auditId);
		case 3:
			var auditId = msg.a;
			return $author$project$Archive$CombinedArchiveContent$userClickedViewAudit(auditId);
		case 4:
			var dialogMsg = msg.a;
			return $author$project$Archive$CombinedArchiveContent$gotEditMeasureDialogMsg(dialogMsg);
		case 5:
			var dialogMsg = msg.a;
			return $author$project$Archive$CombinedArchiveContent$gotEditAuditDialogMsg(dialogMsg);
		case 6:
			var searchValue = msg.a;
			return $author$project$Archive$CombinedArchiveContent$searchOnEnter(searchValue);
		default:
			var searchValue = msg.a;
			var scrollInfo = msg.b;
			return A2($author$project$Archive$CombinedArchiveContent$scrollEvent, searchValue, scrollInfo);
	}
};
var $author$project$Archive$Page$gotCombinedArchiveContentMsg = F4(
	function (contentMsg, environment, repository, _v0) {
		var model = _v0;
		var _v1 = model.ai;
		if (!_v1.$) {
			var combinedContent = _v1.a;
			var updateResult = A4($author$project$Archive$CombinedArchiveContent$update, contentMsg, environment, repository, combinedContent);
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$Page$GotCombinedArchiveContentMsg, updateResult.ab),
				ac: updateResult.ac,
				ak: _Utils_update(
					model,
					{
						ai: $author$project$Archive$Page$CombinedArchive(updateResult.ai)
					}),
				ae: updateResult.ae
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: model, ae: repository};
		}
	});
var $author$project$Archive$Page$MeasureArchive = function (a) {
	return {$: 2, a: a};
};
var $author$project$Measure$Dict$member = $turboMaCk$any_dict$Dict$Any$member;
var $author$project$Archive$ArchivedMeasures$removeMeasure = F2(
	function (measureId, archivedMeasures) {
		var data = archivedMeasures;
		return A2($author$project$Measure$Dict$member, measureId, data.cL) ? {
			ew: data.ew - 1,
			cL: A2($author$project$Measure$Dict$remove, measureId, data.cL)
		} : archivedMeasures;
	});
var $author$project$Archive$MeasureArchiveContent$ContentError = {$: 2};
var $author$project$Archive$MeasureArchiveContent$ContentLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Archive$MeasureArchiveContent$ContentLoading = {$: 0};
var $author$project$Archive$MeasureArchiveContent$withArchivedMeasures = F2(
	function (archivedMeasures, content) {
		switch (content.$) {
			case 0:
				return $author$project$Archive$MeasureArchiveContent$ContentLoading;
			case 1:
				var model = content.a;
				return $author$project$Archive$MeasureArchiveContent$ContentLoaded(
					_Utils_update(
						model,
						{aB: archivedMeasures}));
			default:
				return $author$project$Archive$MeasureArchiveContent$ContentError;
		}
	});
var $author$project$Archive$MeasureArchiveContent$withEditMeasureDialog = F2(
	function (editDialog_, content) {
		switch (content.$) {
			case 0:
				return $author$project$Archive$MeasureArchiveContent$ContentLoading;
			case 1:
				var model = content.a;
				return $author$project$Archive$MeasureArchiveContent$ContentLoaded(
					_Utils_update(
						model,
						{cP: editDialog_}));
			default:
				return $author$project$Archive$MeasureArchiveContent$ContentError;
		}
	});
var $author$project$Archive$MeasureArchiveContent$gotEditMeasureDialogMsg = F4(
	function (dialogMsg, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var updatedArchivedMeasures = function () {
				if (((dialogMsg.$ === 22) && (dialogMsg.a.$ === 19)) && (dialogMsg.a.a.$ === 9)) {
					var deletePayload = dialogMsg.a.a.a;
					return A2($author$project$Archive$ArchivedMeasures$removeMeasure, deletePayload.h5, model.aB);
				} else {
					return model.aB;
				}
			}();
			var result = A4($author$project$Measure$EditDialog$update, dialogMsg, environment, repository, model.cP);
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$MeasureArchiveContent$GotEditMeasureDialogMsg, result.ab),
				ai: A2(
					$author$project$Archive$MeasureArchiveContent$withArchivedMeasures,
					updatedArchivedMeasures,
					A2($author$project$Archive$MeasureArchiveContent$withEditMeasureDialog, result.jn, content)),
				ac: result.ac,
				ae: result.ae
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$ArchivedMeasures$dict = function (_v0) {
	var data = _v0;
	return data.cL;
};
var $author$project$Archive$ArchivedMeasures$empty = {ew: -1, cL: $author$project$Measure$Dict$empty};
var $author$project$Measure$Dict$union = $turboMaCk$any_dict$Dict$Any$union;
var $author$project$Archive$ArchivedMeasures$updateDict = F2(
	function (_v0, newDict) {
		var data = _v0;
		return _Utils_update(
			data,
			{cL: newDict});
	});
var $author$project$Archive$MeasureArchiveContent$gotGetMeasuresArchiveResult = F4(
	function (result, environment, repository, content) {
		switch (result.$) {
			case 0:
				var resultType = result.a;
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v1.a;
				var updatedEnvironment = _v1.b;
				var newError = {
					gg: 'Unknown return from Javascript in http handler. index.js -> initHttpPort',
					gE: $author$project$Environments$ErrorHandling$Error$OtherError(resultType),
					gH: 'Archive.MeasureArchiveContent.elm',
					gK: 'gotGetMeasuresResult',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					ai: $author$project$Archive$MeasureArchiveContent$ContentError,
					ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					ae: repository
				};
			case 1:
				var decodeError = result.a;
				var _v2 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v2.a;
				var updatedEnvironment = _v2.b;
				var newError = {
					gg: 'Error while Decoding incoming http request',
					gE: $author$project$Environments$ErrorHandling$Error$DecodeError(decodeError),
					gH: 'Archive.MeasureArchiveContent.elm',
					gK: 'gotGetMeasuresResult',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					ai: $author$project$Archive$MeasureArchiveContent$ContentError,
					ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					ae: repository
				};
			case 2:
				var status = result.a;
				var responseMessage = result.b;
				var resultType = result.c;
				if ((status === 404) && (resultType === 'GET_AUDIT')) {
					return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
				} else {
					var _v3 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v3.a;
					var updatedEnvironment = _v3.b;
					var newError = {
						gg: resultType,
						gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
						gH: 'Archive.MeasureArchiveContent.elm',
						gK: 'gotGetMeasuresResult',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						ai: $author$project$Archive$MeasureArchiveContent$ContentError,
						ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
						ae: repository
					};
				}
			case 18:
				var archivedMeasures = result.a;
				switch (content.$) {
					case 0:
						return {
							ab: $elm$core$Platform$Cmd$none,
							ai: $author$project$Archive$MeasureArchiveContent$ContentLoaded(
								{aB: archivedMeasures, cP: $author$project$Measure$EditDialog$hidden, bF: 300}),
							ac: environment,
							ae: repository
						};
					case 1:
						var model = content.a;
						return {
							ab: $elm$core$Platform$Cmd$none,
							ai: $author$project$Archive$MeasureArchiveContent$ContentLoaded(
								_Utils_update(
									model,
									{
										aB: A2(
											$author$project$Archive$ArchivedMeasures$updateDict,
											archivedMeasures,
											A2(
												$author$project$Measure$Dict$union,
												$author$project$Archive$ArchivedMeasures$dict(model.aB),
												$author$project$Archive$ArchivedMeasures$dict(archivedMeasures)))
									})),
							ac: environment,
							ae: repository
						};
					default:
						return {
							ab: $elm$core$Platform$Cmd$none,
							ai: $author$project$Archive$MeasureArchiveContent$ContentLoaded(
								{aB: $author$project$Archive$ArchivedMeasures$empty, cP: $author$project$Measure$EditDialog$hidden, bF: 300}),
							ac: environment,
							ae: repository
						};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$ArchivedMeasures$count = function (_v0) {
	var data = _v0;
	return data.ew;
};
var $author$project$Utils$Http$GetMeasuresArchive = 11;
var $author$project$Archive$MeasureArchiveContent$getRequest = F3(
	function (environment, search, last_chunk) {
		var takeHeader = _List_fromArray(
			[
				A2(
				$author$project$Utils$Http$Header,
				'x-take',
				$elm$core$String$fromInt(last_chunk + 300)),
				A2(
				$author$project$Utils$Http$Header,
				'x-skip',
				$elm$core$String$fromInt(last_chunk))
			]);
		var searchHeader = $elm$core$String$isEmpty(search) ? _List_Nil : _List_fromArray(
			[
				A2($author$project$Utils$Http$Header, 'x-search-string', search)
			]);
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Archive$MeasureArchiveContent$GotGetMeasuresArchiveResult,
			A3(
				$author$project$Utils$Http$sendGet,
				$author$project$Environments$Environment$baseUri(environment) + '/measures/query/archived',
				A2($elm$core$List$append, takeHeader, searchHeader),
				11));
	});
var $author$project$Archive$MeasureArchiveContent$scrollEvent = F5(
	function (searchValue, scrollInfo, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var _v1 = (((scrollInfo.kM - scrollInfo.kN) <= 2000) && (_Utils_cmp(
				model.bF,
				$author$project$Archive$ArchivedMeasures$count(model.aB)) < 0)) ? _Utils_Tuple2(
				model.bF + 300,
				A3($author$project$Archive$MeasureArchiveContent$getRequest, environment, searchValue, model.bF)) : _Utils_Tuple2(model.bF, $elm$core$Platform$Cmd$none);
			var newTakeValue = _v1.a;
			var cmd = _v1.b;
			return {
				ab: cmd,
				ai: $author$project$Archive$MeasureArchiveContent$ContentLoaded(
					_Utils_update(
						model,
						{bF: newTakeValue})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$MeasureArchiveContent$searchOnEnter = F4(
	function (searchValue, environment, repository, content) {
		if (content.$ === 1) {
			return {
				ab: A3($author$project$Archive$MeasureArchiveContent$getRequest, environment, searchValue, 0),
				ai: $author$project$Archive$MeasureArchiveContent$ContentLoading,
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$ArchivedMeasures$get = function (measureId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Archive$ArchivedMeasures$dict,
		$author$project$Measure$Dict$get(measureId));
};
var $author$project$Archive$MeasureArchiveContent$userClickedEditIcon = F4(
	function (measureId, environment, repository, content) {
		if (content.$ === 1) {
			var model = content.a;
			var _v1 = function () {
				var _v2 = A2($author$project$Archive$ArchivedMeasures$get, measureId, model.aB);
				if (!_v2.$) {
					var measure = _v2.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Archive$MeasureArchiveContent$GotEditMeasureDialogMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (newDialog) {
								return A2($author$project$Archive$MeasureArchiveContent$withEditMeasureDialog, newDialog, content);
							},
							A4($author$project$Measure$EditDialog$show, environment, repository, 1, measure)));
				} else {
					return _Utils_Tuple2(content, $elm$core$Platform$Cmd$none);
				}
			}();
			var updatedContent = _v1.a;
			var cmd = _v1.b;
			return {ab: cmd, ai: updatedContent, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ai: content, ac: environment, ae: repository};
		}
	});
var $author$project$Archive$MeasureArchiveContent$update = function (msg) {
	switch (msg.$) {
		case 0:
			var result = msg.a;
			return $author$project$Archive$MeasureArchiveContent$gotGetMeasuresArchiveResult(result);
		case 1:
			var measureId = msg.a;
			return $author$project$Archive$MeasureArchiveContent$userClickedEditIcon(measureId);
		case 2:
			var dialogMsg = msg.a;
			return $author$project$Archive$MeasureArchiveContent$gotEditMeasureDialogMsg(dialogMsg);
		case 3:
			var searchValue = msg.a;
			return $author$project$Archive$MeasureArchiveContent$searchOnEnter(searchValue);
		default:
			var searchValue = msg.a;
			var scrollInfo = msg.b;
			return A2($author$project$Archive$MeasureArchiveContent$scrollEvent, searchValue, scrollInfo);
	}
};
var $author$project$Archive$Page$gotMeasureArchiveContentMsg = F4(
	function (contentMsg, environment, repository, _v0) {
		var model = _v0;
		var _v1 = model.ai;
		if (_v1.$ === 2) {
			var measureContent = _v1.a;
			var updateResult = A4($author$project$Archive$MeasureArchiveContent$update, contentMsg, environment, repository, measureContent);
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$Page$GotMeasureArchiveContentMsg, updateResult.ab),
				ac: updateResult.ac,
				ak: _Utils_update(
					model,
					{
						ai: $author$project$Archive$Page$MeasureArchive(updateResult.ai)
					}),
				ae: updateResult.ae
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: model, ae: repository};
		}
	});
var $author$project$Archive$AuditArchiveContent$ScrollEvent = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Archive$CombinedArchiveContent$ScrollEvent = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Archive$MeasureArchiveContent$ScrollEvent = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Archive$Page$scrollEvent = F4(
	function (scrollInfo, environment, repository, _v0) {
		var model = _v0;
		var _v1 = model.ai;
		switch (_v1.$) {
			case 0:
				var combinedContent = _v1.a;
				var updateResult = A4(
					$author$project$Archive$CombinedArchiveContent$update,
					A2($author$project$Archive$CombinedArchiveContent$ScrollEvent, model.aN, scrollInfo),
					environment,
					repository,
					combinedContent);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$Page$GotCombinedArchiveContentMsg, updateResult.ab),
					ac: updateResult.ac,
					ak: _Utils_update(
						model,
						{
							ai: $author$project$Archive$Page$CombinedArchive(updateResult.ai)
						}),
					ae: updateResult.ae
				};
			case 1:
				var auditContent = _v1.a;
				var updateResult = A4(
					$author$project$Archive$AuditArchiveContent$update,
					A2($author$project$Archive$AuditArchiveContent$ScrollEvent, model.aN, scrollInfo),
					environment,
					repository,
					auditContent);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$Page$GotAuditArchiveContentMsg, updateResult.ab),
					ac: updateResult.ac,
					ak: _Utils_update(
						model,
						{
							ai: $author$project$Archive$Page$AuditArchive(updateResult.ai)
						}),
					ae: updateResult.ae
				};
			default:
				var measureContent = _v1.a;
				var updateResult = A4(
					$author$project$Archive$MeasureArchiveContent$update,
					A2($author$project$Archive$MeasureArchiveContent$ScrollEvent, model.aN, scrollInfo),
					environment,
					repository,
					measureContent);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$Page$GotMeasureArchiveContentMsg, updateResult.ab),
					ac: updateResult.ac,
					ak: _Utils_update(
						model,
						{
							ai: $author$project$Archive$Page$MeasureArchive(updateResult.ai)
						}),
					ae: updateResult.ae
				};
		}
	});
var $author$project$Archive$AuditArchiveContent$SearchOnEnter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Archive$CombinedArchiveContent$SearchOnEnter = function (a) {
	return {$: 6, a: a};
};
var $author$project$Archive$MeasureArchiveContent$SearchOnEnter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Archive$Page$searchOnEnter = F3(
	function (environment, repository, _v0) {
		var model = _v0;
		var _v1 = model.ai;
		switch (_v1.$) {
			case 0:
				var combinedContent = _v1.a;
				var updateResult = A4(
					$author$project$Archive$CombinedArchiveContent$update,
					$author$project$Archive$CombinedArchiveContent$SearchOnEnter(model.aN),
					environment,
					repository,
					combinedContent);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$Page$GotCombinedArchiveContentMsg, updateResult.ab),
					ac: updateResult.ac,
					ak: _Utils_update(
						model,
						{
							ai: $author$project$Archive$Page$CombinedArchive(updateResult.ai)
						}),
					ae: updateResult.ae
				};
			case 1:
				var auditContent = _v1.a;
				var updateResult = A4(
					$author$project$Archive$AuditArchiveContent$update,
					$author$project$Archive$AuditArchiveContent$SearchOnEnter(model.aN),
					environment,
					repository,
					auditContent);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$Page$GotAuditArchiveContentMsg, updateResult.ab),
					ac: updateResult.ac,
					ak: _Utils_update(
						model,
						{
							ai: $author$project$Archive$Page$AuditArchive(updateResult.ai)
						}),
					ae: updateResult.ae
				};
			default:
				var measureContent = _v1.a;
				var updateResult = A4(
					$author$project$Archive$MeasureArchiveContent$update,
					$author$project$Archive$MeasureArchiveContent$SearchOnEnter(model.aN),
					environment,
					repository,
					measureContent);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$Page$GotMeasureArchiveContentMsg, updateResult.ab),
					ac: updateResult.ac,
					ak: _Utils_update(
						model,
						{
							ai: $author$project$Archive$Page$MeasureArchive(updateResult.ai)
						}),
					ae: updateResult.ae
				};
		}
	});
var $author$project$Archive$Page$userClickedContent = F4(
	function (_v0, environment, repository, _v1) {
		var newContent = _v0.a;
		var contentCmd = _v0.b;
		var model = _v1;
		return {
			ab: contentCmd,
			ac: environment,
			ak: _Utils_update(
				model,
				{ai: newContent}),
			ae: repository
		};
	});
var $author$project$Environments$Environment$setSeeAll = F2(
	function (newSeeAll, state) {
		return A2(
			$author$project$Environments$Environment$map,
			function (model) {
				return _Utils_update(
					model,
					{f4: newSeeAll});
			},
			state);
	});
var $author$project$Archive$Page$userDeselectedSeeAll = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$setSeeAll, false, environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$Archive$Page$userSelectedSeeAll = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$setSeeAll, true, environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$Archive$Page$update = function (msg) {
	switch (msg.$) {
		case 0:
			var content = msg.a;
			return $author$project$Archive$Page$userClickedContent(content);
		case 1:
			var pageMsg = msg.a;
			return $author$project$Archive$Page$gotCombinedArchiveContentMsg(pageMsg);
		case 2:
			var pageMsg = msg.a;
			return $author$project$Archive$Page$gotAuditArchiveContentMsg(pageMsg);
		case 3:
			var pageMsg = msg.a;
			return $author$project$Archive$Page$gotMeasureArchiveContentMsg(pageMsg);
		case 4:
			return $author$project$Archive$Page$userSelectedSeeAll;
		case 5:
			return $author$project$Archive$Page$userDeselectedSeeAll;
		case 6:
			var searchValue = msg.a;
			return $author$project$Archive$Page$enteredSearchString(searchValue);
		case 7:
			return $author$project$Archive$Page$searchOnEnter;
		default:
			var scrollInfo = msg.a;
			return $author$project$Archive$Page$scrollEvent(scrollInfo);
	}
};
var $author$project$Archive$Page$ScrollEvent = function (a) {
	return {$: 8, a: a};
};
var $author$project$UI$Page$Config = $elm$core$Basics$identity;
var $author$project$UI$Page$appendContent = F2(
	function (content, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				ai: A2($elm$core$List$cons, content, config.ai)
			});
	});
var $author$project$UI$Page$appendHeader = F2(
	function (header, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				gO: A2($elm$core$List$cons, header, config.gO)
			});
	});
var $ChristophP$elm_i18next$I18Next$t = F2(
	function (_v0, key) {
		var translations = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, translations));
	});
var $author$project$Translations$Archive$auditMainHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.auditMainHeader');
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Svg$Styled$Attributes$d = $rtfeldman$elm_css$VirtualDom$Styled$attribute('d');
var $rtfeldman$elm_css$VirtualDom$Styled$nodeNS = $rtfeldman$elm_css$VirtualDom$Styled$NodeNS;
var $rtfeldman$elm_css$Svg$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$nodeNS('http://www.w3.org/2000/svg');
var $rtfeldman$elm_css$Svg$Styled$path = $rtfeldman$elm_css$Svg$Styled$node('path');
var $rtfeldman$elm_css$Svg$Styled$Attributes$fill = $rtfeldman$elm_css$VirtualDom$Styled$attribute('fill');
var $author$project$UI$Style$Color$toString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var pct = function (x) {
		return $elm$core$Basics$round(x * 255);
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromInt(
				pct(r)),
				',',
				$elm$core$String$fromInt(
				pct(g)),
				',',
				$elm$core$String$fromInt(
				pct(b)),
				',',
				$elm$core$String$fromFloat(a),
				')'
			]));
};
var $author$project$UI$Icons$fillColor = A2($elm$core$Basics$composeR, $author$project$UI$Style$Color$toString, $rtfeldman$elm_css$Svg$Styled$Attributes$fill);
var $author$project$UI$Icons$setFillColor = A2($elm$core$Basics$composeR, $author$project$UI$Icons$fillColor, $elm$core$List$cons);
var $rtfeldman$elm_css$Svg$Styled$Attributes$viewBox = $rtfeldman$elm_css$VirtualDom$Styled$attribute('viewBox');
var $author$project$UI$Icons$setViewBox = A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Svg$Styled$Attributes$viewBox, $elm$core$List$cons);
var $rtfeldman$elm_css$Svg$Styled$svg = $rtfeldman$elm_css$Svg$Styled$node('svg');
var $author$project$UI$Icons$checkedDocument = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M29.761 22.07c-.487-.492-1.278-.492-1.771-.007l-5.826 5.777-2.133-2.145c-.485-.494-1.277-.494-1.77-.007-.493.486-.493 1.278-.007 1.772l3.014 3.033c.243.245.562.368.89.368.319 0 .637-.117.881-.361l6.714-6.659c.494-.486.494-1.279.008-1.771m7.423-11.445h-6.708V8.25c0-.688-.563-1.25-1.25-1.25H18.782c-.687 0-1.25.562-1.25 1.25v6.576c0 .688.563 1.25 1.25 1.25h7.721c.688 0 1.25-.562 1.25-1.25 0-.687-.562-1.249-1.25-1.249h-6.472V9.5h7.952v2.375c0 .688.562 1.25 1.25 1.25h6.708V38.5H12.066V13.125h1.91c.687 0 1.249-.562 1.249-1.25 0-.687-.562-1.25-1.249-1.25h-3.159c-.688 0-1.25.563-1.25 1.25V39.75c0 .688.562 1.25 1.25 1.25h26.367c.687 0 1.249-.562 1.249-1.25V11.875c0-.687-.562-1.25-1.249-1.25')
						]),
					_List_Nil)
				]));
	});
var $author$project$Translations$Archive$combinedMainHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.combinedMainHeader');
};
var $elm$virtual_dom$VirtualDom$lazy5 = _VirtualDom_lazy5;
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var newStyles = _v0.b;
		var classname = _v0.c;
		return $elm$core$List$isEmpty(newStyles) ? styles : A3($elm$core$Dict$insert, classname, newStyles, styles);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_v0) {
	var val = _v0.a;
	return val;
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			if (!properties.b) {
				return candidate;
			} else {
				var _v1 = properties.a;
				var styles = _v1.b;
				var classname = _v1.c;
				var rest = properties.b;
				if ($elm$core$String$isEmpty(classname)) {
					var $temp$candidate = candidate,
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				} else {
					var $temp$candidate = $elm$core$Maybe$Just(
						_Utils_Tuple2(classname, styles)),
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
	var _v0 = A2($rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, $elm$core$Maybe$Nothing, properties);
	if (_v0.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var _v1 = _v0.a;
		var classname = _v1.a;
		var styles = _v1.b;
		return A2($elm$core$Dict$singleton, classname, styles);
	}
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.b;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.ji) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.g_, record.ji, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{ji: decl, g_: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.hD;
	var imports = _v0.h_;
	var namespaces = _v0.ib;
	var declarations = _v0.jj;
	var _v1 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v1.a;
	var compactedDeclarations = _v1.b;
	var finalDeclarations = A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
	return {hD: charset, jj: finalDeclarations, h_: imports, ib: namespaces};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.hU + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.ll)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A2(
				$elm$core$String$join,
				' and ',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
			mediaQueries));
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
var $rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
	return _Utils_ap($rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
};
var $rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
var $rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
	return str + ';';
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Css$Structure$Output$indent, $rtfeldman$elm_css$Css$Structure$Output$emitProperty),
			properties));
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
				$elm$core$String$join,
				'',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
				$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
			]));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
			]));
	return A2(
		$elm$core$String$append,
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				segments)),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
	function (indentLevel, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		var selectorStr = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
				A2($elm$core$List$cons, firstSelector, otherSelectors)));
		return A2(
			$elm$core$String$join,
			'',
			_List_fromArray(
				[
					selectorStr,
					' {\n',
					indentLevel,
					$rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
					'\n',
					indentLevel,
					'}'
				]));
	});
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return A2($rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, $rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A2(
				$elm$core$String$join,
				',\n',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
			var blocks = A2(
				$elm$core$String$join,
				'\n\n',
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeL,
						$rtfeldman$elm_css$Css$Structure$Output$indent,
						$rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock($rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
					styleBlocks));
			return '@media ' + (query + (' {\n' + (blocks + '\n}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.g_;
			var declaration = decl.a.ji;
			return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.hD;
	var imports = _v0.h_;
	var namespaces = _v0.ib;
	var declarations = _v0.jj;
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
					A2(
					$elm$core$String$join,
					'\n\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
				])));
};
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							var _v9 = declarations.a;
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {ds: charsProcessed, dO: hash, eX: seed, kR: shift};
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
	var acc = (!(!data.dO)) ? (data.eX ^ A2(
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
		A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
			15,
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.dO)))) : data.eX;
	var h0 = acc ^ data.ds;
	var h1 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			5,
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
					A2(
						$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
						15,
						A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.dO | ((255 & $elm$core$Char$toCode(c)) << data.kR);
		var _v0 = data.kR;
		if (_v0 === 24) {
			return {
				ds: data.ds + 1,
				dO: 0,
				eX: A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.eX, res),
				kR: 0
			};
		} else {
			return {ds: data.ds + 1, dO: res, eX: data.eX, kR: data.kR + 8};
		}
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
	function (seed, str) {
		return $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
				A4($rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$murmurSeed = 15739;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, $rtfeldman$elm_css$Hash$murmurSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var str = declaration.a;
								var properties = declaration.b;
								return _List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{ji: str, g_: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var str = snippetDeclaration.a;
			var properties = snippetDeclaration.b;
			return _List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.hD;
	var imports = _v0.h_;
	var namespaces = _v0.ib;
	var snippets = _v0.iw;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {hD: charset, jj: declarations, h_: imports, ib: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_v0) {
	var classname = _v0.a;
	var styles = _v0.b;
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
		styles,
		$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
				])));
};
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {hD: $elm$core$Maybe$Nothing, h_: _List_Nil, ib: _List_Nil, iw: snippets};
};
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
		$elm$core$List$singleton(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
					$elm$core$Dict$toList(dict)))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
	return A3(
		$elm$virtual_dom$VirtualDom$node,
		'style',
		_List_Nil,
		$elm$core$List$singleton(
			$elm$virtual_dom$VirtualDom$text(
				$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
	function (elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
	function (ns, elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
	function (ns, elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp4 = F5(
	function (fn, arg1, arg2, arg3, arg4) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A4(fn, arg1, arg2, arg3, arg4));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy4 = F5(
	function (fn, arg1, arg2, arg3, arg4) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A6($elm$virtual_dom$VirtualDom$lazy5, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp4, fn, arg1, arg2, arg3, arg4));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy4 = $rtfeldman$elm_css$VirtualDom$Styled$lazy4;
var $author$project$Translations$Archive$measureMainHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.measureMainHeader');
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $author$project$Utils$ScrollInfo$ScrollInfo = F3(
	function (scrollHeight, scrollTop, offsetHeight) {
		return {ke: offsetHeight, kM: scrollHeight, kN: scrollTop};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Utils$ScrollInfo$scrollInfoDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Utils$ScrollInfo$ScrollInfo,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollHeight']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollTop']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'offsetHeight']),
		$elm$json$Json$Decode$float));
var $author$project$Utils$ScrollInfo$onScroll = function (msg) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$Events$on,
			'scroll',
			A2($elm$json$Json$Decode$map, msg, $author$project$Utils$ScrollInfo$scrollInfoDecoder))
		]);
};
var $author$project$UI$Page$page = function (title) {
	return {fc: _List_Nil, ai: _List_Nil, gO: _List_Nil, jI: $elm$core$Maybe$Nothing, k8: title};
};
var $author$project$Environments$Environment$translations = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.dj;
	});
var $author$project$UI$Icon$NoOnClick = {$: 2};
var $author$project$UI$Icon$Unicolor = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Style$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($author$project$UI$Style$Color$Rgba, r, g, b, a);
	});
var $author$project$UI$Style$Theme$grey = A4($author$project$UI$Style$Color$rgba, 155 / 255, 173 / 255, 181 / 255, 1.0);
var $author$project$UI$Icon$unicolor = function (icon) {
	return $author$project$UI$Icon$Unicolor(
		{dN: $author$project$UI$Style$Theme$grey, jI: icon, bJ: $author$project$UI$Icon$NoOnClick, by: _List_Nil});
};
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$row = {gJ: 0, eD: 0, ll: 'row'};
var $rtfeldman$elm_css$Css$column = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{ll: 'column'});
var $rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
var $rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
	return $elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
				$rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
					$elm$core$List$singleton(
						$rtfeldman$elm_css$Css$Preprocess$stylesheet(
							$elm$core$List$singleton(
								A2(
									$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
									styles,
									$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var classname = $rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classProperty = A2(
		$elm$virtual_dom$VirtualDom$property,
		'className',
		$elm$json$Json$Encode$string(classname));
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$displayFlex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.ll);
	});
var $rtfeldman$elm_css$Css$flexDirection = $rtfeldman$elm_css$Css$prop1('flex-direction');
var $author$project$Environments$Environment$getViewType = function (state) {
	var viewPort = $author$project$Environments$Environment$viewport(state);
	return viewPort.be;
};
var $rtfeldman$elm_css$Css$hidden = {aR: 0, d4: 0, ll: 'hidden', e5: 0};
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp = F2(
	function (fn, arg) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			fn(arg));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy = F2(
	function (fn, arg) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A3($elm$virtual_dom$VirtualDom$lazy2, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp, fn, arg));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy = $rtfeldman$elm_css$VirtualDom$Styled$lazy;
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Css$overflowX = $rtfeldman$elm_css$Css$prop1('overflow-x');
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.ll, argB.ll])));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $rtfeldman$elm_css$Css$RemUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			hs: 0,
			hB: 0,
			dK: 0,
			aH: 0,
			eK: 0,
			dP: 0,
			ch: 0,
			dQ: 0,
			dR: 0,
			c0: 0,
			c1: 0,
			bG: 0,
			cn: numericValue,
			ej: 0,
			en: unitLabel,
			e3: units,
			ll: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$rem = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'rem');
var $rtfeldman$elm_css$Css$block = {W: 0, ll: 'block'};
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$flexGrow = $rtfeldman$elm_css$Css$prop1('flex-grow');
var $rtfeldman$elm_css$Css$flexShrink = $rtfeldman$elm_css$Css$prop1('flex-shrink');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		c1: 0,
		bG: 0,
		cm: 0,
		fL: 0,
		cn: val,
		en: '',
		e3: 0,
		ll: $elm$core$String$fromFloat(val)
	};
};
var $author$project$UI$Page$viewContent = function (_v0) {
	var content = _v0.ai;
	var attributeMsg = _v0.fc;
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-page-content',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$num(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$num(1))
					]))
			]),
		$elm$core$List$reverse(content));
};
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.ll);
};
var $rtfeldman$elm_css$Css$ellipsis = {iD: 0, ll: 'ellipsis'};
var $rtfeldman$elm_css$Html$Styled$h1 = $rtfeldman$elm_css$Html$Styled$node('h1');
var $rtfeldman$elm_css$Css$marginBottom = $rtfeldman$elm_css$Css$prop1('margin-bottom');
var $rtfeldman$elm_css$Css$noWrap = {eD: 0, ft: 0, ll: 'nowrap', cz: 0};
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $rtfeldman$elm_css$Css$textOverflow = $rtfeldman$elm_css$Css$prop1('text-overflow');
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ', ', args) + ')'));
	});
var $rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			eq: alpha,
			iZ: b,
			K: 0,
			jE: g,
			kz: r,
			ll: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])),
					_List_fromArray(
						[
							$elm$core$String$fromFloat(alpha)
						])))
		};
	});
var $author$project$UI$Style$Color$toCssColor = function (rgba_) {
	var _v0 = $author$project$UI$Style$Color$toRgba(rgba_);
	var red = _v0.kz;
	var green = _v0.jE;
	var blue = _v0.iZ;
	var alpha = _v0.eq;
	return A4(
		$rtfeldman$elm_css$Css$rgba,
		$elm$core$Basics$round(255 * red),
		$elm$core$Basics$round(255 * green),
		$elm$core$Basics$round(255 * blue),
		alpha);
};
var $author$project$UI$Style$Theme$darkGrey = A4($author$project$UI$Style$Color$rgba, 56 / 255, 92 / 255, 107 / 255, 1.0);
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$marginRight = $rtfeldman$elm_css$Css$prop1('margin-right');
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$default = {c: 0, ll: 'default'};
var $rtfeldman$elm_css$Css$pointer = {c: 0, ll: 'pointer'};
var $rtfeldman$elm_css$Svg$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $rtfeldman$elm_css$Svg$Styled$Events$stopPropagationOn = $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn;
var $author$project$UI$Icon$setOnClick = F2(
	function (onClick, attributes) {
		switch (onClick.$) {
			case 0:
				var msg = onClick.a;
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Svg$Styled$Events$onClick(msg),
					attributes);
			case 1:
				var msg = onClick.a;
				return A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Svg$Styled$Events$stopPropagationOn,
						'click',
						$elm$json$Json$Decode$succeed(
							_Utils_Tuple2(msg, true))),
					attributes);
			default:
				return attributes;
		}
	});
var $rtfeldman$elm_css$Svg$Styled$Internal$css = function (styles) {
	var classname = $rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classAttribute = A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classAttribute, styles, classname);
};
var $rtfeldman$elm_css$Svg$Styled$Attributes$css = $rtfeldman$elm_css$Svg$Styled$Internal$css;
var $author$project$UI$Icon$stylesToAttributes = function (styles) {
	if (!styles.b) {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$css(styles)
			]);
	}
};
var $author$project$UI$Icon$view = function (config) {
	var cursor_ = function (onClick) {
		if (onClick.$ === 2) {
			return $rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default);
		} else {
			return $rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer);
		}
	};
	if (!config.$) {
		var options = config.a;
		return A2(
			options.jI,
			options.dN,
			A2(
				$author$project$UI$Icon$setOnClick,
				options.bJ,
				$author$project$UI$Icon$stylesToAttributes(
					A2(
						$elm$core$List$cons,
						cursor_(options.bJ),
						options.by))));
	} else {
		var options = config.a;
		return A3(
			options.jI,
			options.dN,
			options.go,
			A2(
				$author$project$UI$Icon$setOnClick,
				options.bJ,
				$author$project$UI$Icon$stylesToAttributes(
					A2(
						$elm$core$List$cons,
						cursor_(options.bJ),
						options.by))));
	}
};
var $author$project$UI$Icon$Bicolor = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Icon$withForegroundColor = F2(
	function (color, config) {
		if (!config.$) {
			var options = config.a;
			return $author$project$UI$Icon$Unicolor(
				_Utils_update(
					options,
					{dN: color}));
		} else {
			var options = config.a;
			return $author$project$UI$Icon$Bicolor(
				_Utils_update(
					options,
					{dN: color}));
		}
	});
var $author$project$UI$Icon$withStyle = F2(
	function (style, config) {
		if (!config.$) {
			var options = config.a;
			return $author$project$UI$Icon$Unicolor(
				_Utils_update(
					options,
					{
						by: A2($elm$core$List$cons, style, options.by)
					}));
		} else {
			var options = config.a;
			return $author$project$UI$Icon$Bicolor(
				_Utils_update(
					options,
					{
						by: A2($elm$core$List$cons, style, options.by)
					}));
		}
	});
var $author$project$UI$Page$viewIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$Icon$withForegroundColor($author$project$UI$Style$Theme$darkGrey),
	A2(
		$elm$core$Basics$composeR,
		$author$project$UI$Icon$withStyle(
			$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$rem(3))),
		A2(
			$elm$core$Basics$composeR,
			$author$project$UI$Icon$withStyle(
				$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$rem(0.2))),
			$author$project$UI$Icon$view)));
var $rtfeldman$elm_css$Css$middle = $rtfeldman$elm_css$Css$prop1('middle');
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$verticalAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'verticalAlign',
		'vertical-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$UI$Page$viewTitle = function (title) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(title)
			]));
};
var $rtfeldman$elm_css$Css$whiteSpace = $rtfeldman$elm_css$Css$prop1('white-space');
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$zero = {eK: 0, dP: 0, ch: 0, dQ: 0, dR: 0, c0: 0, c1: 0, cm: 0, cn: 0, fU: 0, en: '', e3: 0, ll: '0'};
var $author$project$UI$Page$viewHeader = function (_v0) {
	var config = _v0;
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-page-header',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
						$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero)
					]))
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$h1,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
								$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1)),
								$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
								$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
								$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$rtfeldman$elm_css$Html$Styled$text(''),
						A2($elm$core$Maybe$map, $author$project$UI$Page$viewIcon, config.jI)),
						$author$project$UI$Page$viewTitle(config.k8)
					])),
			$elm$core$List$reverse(config.gO)));
};
var $author$project$UI$Page$view = F2(
	function (environment, config) {
		var config_ = config;
		var paddingLeftRight = function () {
			var _v0 = $author$project$Environments$Environment$getViewType(environment);
			if (!_v0) {
				return 3;
			} else {
				return 0.5;
			}
		}();
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-page',
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$property, 'grid-area', 'page'),
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
								A2(
								$rtfeldman$elm_css$Css$padding2,
								$rtfeldman$elm_css$Css$zero,
								$rtfeldman$elm_css$Css$rem(paddingLeftRight)),
								$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden)
							]))
					]),
				config_.fc),
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$UI$Page$viewHeader, config),
					$author$project$UI$Page$viewContent(config)
				]));
	});
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $author$project$Translations$Archive$error = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.error');
};
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.ll;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		ce: 0,
		fz: 0,
		c1: 0,
		bG: 0,
		cm: 0,
		fL: 0,
		cn: val,
		en: '',
		e3: 0,
		ll: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$Archive$AuditArchiveContent$viewErrorText = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Archive$error(translations))
			]));
};
var $author$project$UI$Page$withIcon = F2(
	function (icon, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				jI: $elm$core$Maybe$Just(icon)
			});
	});
var $author$project$Archive$AuditArchiveContent$viewError = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return A2(
		$author$project$UI$Page$view,
		environment,
		A2(
			$author$project$UI$Page$appendContent,
			$author$project$Archive$AuditArchiveContent$viewErrorText(translations),
			A2(
				$author$project$UI$Page$withIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedDocument),
				$author$project$UI$Page$page(
					$author$project$Translations$Archive$auditMainHeader(translations)))));
};
var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3 = F4(
	function (fn, arg1, arg2, arg3) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A3(fn, arg1, arg2, arg3));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy3 = F4(
	function (fn, arg1, arg2, arg3) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A5($elm$virtual_dom$VirtualDom$lazy4, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp3, fn, arg1, arg2, arg3));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy3 = $rtfeldman$elm_css$VirtualDom$Styled$lazy3;
var $author$project$User$User$NotModified = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$User$Changed = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$File$Operation$CreateUserAvatar = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$User$User$userFromModification = function (modification) {
	switch (modification.$) {
		case 0:
			var maybeUser = modification.a;
			return maybeUser;
		case 1:
			var user = modification.a;
			return $elm$core$Maybe$Just(user);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$User$User$applyAvatarChangedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$User$User$userFromModification(modification);
		if (!_v0.$) {
			var user = _v0.a;
			if (_Utils_eq(payload.dk, user.dk) && (_Utils_cmp(payload.n, user.i) > 0)) {
				var newUser = _Utils_update(
					user,
					{iX: payload.iX, i: payload.n});
				var newFileOperations = function () {
					var _v1 = _Utils_Tuple2(payload.iX, user.iX);
					if (!_v1.a.$) {
						if (!_v1.b.$) {
							var newAvatar = _v1.a.a;
							var oldAvatar = _v1.b.a;
							return A2(
								$author$project$File$Operations$enqueue,
								A2($author$project$File$Operation$Delete, true, oldAvatar),
								A2(
									$author$project$File$Operations$enqueue,
									A2($author$project$File$Operation$CreateUserAvatar, payload.dk, newAvatar),
									fileOperations));
						} else {
							var newAvatar = _v1.a.a;
							var _v2 = _v1.b;
							return A2(
								$author$project$File$Operations$enqueue,
								A2($author$project$File$Operation$CreateUserAvatar, payload.dk, newAvatar),
								fileOperations);
						}
					} else {
						if (!_v1.b.$) {
							var _v3 = _v1.a;
							var oldAvatar = _v1.b.a;
							return A2(
								$author$project$File$Operations$enqueue,
								A2($author$project$File$Operation$Delete, true, oldAvatar),
								fileOperations);
						} else {
							var _v4 = _v1.a;
							var _v5 = _v1.b;
							return fileOperations;
						}
					}
				}();
				return _Utils_Tuple2(
					A2($author$project$User$User$Changed, newUser, payload.N),
					newFileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$User$User$applyCreatedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$User$User$userFromModification(modification);
		if (!_v0.$) {
			return acc;
		} else {
			var newUser = {iX: payload.iX, ju: payload.ju, hT: payload.hT, g_: payload.g_, i: 0, k2: payload.k2, dk: payload.dk, iK: payload.iK};
			var newFileOperations = A2(
				$elm$core$Maybe$withDefault,
				fileOperations,
				A2(
					$elm$core$Maybe$map,
					function (avatar) {
						return A2(
							$author$project$File$Operations$enqueue,
							A2($author$project$File$Operation$CreateUserAvatar, payload.dk, avatar),
							fileOperations);
					},
					payload.iX));
			return _Utils_Tuple2(
				A2($author$project$User$User$Changed, newUser, payload.N),
				newFileOperations);
		}
	});
var $author$project$User$User$Deleted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$User$User$applyDeletedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$User$User$userFromModification(modification);
		if (!_v0.$) {
			var user = _v0.a;
			if (_Utils_eq(payload.dk, user.dk) && (_Utils_cmp(payload.n, user.i) > 0)) {
				var newFileOperations = A2(
					$elm$core$Maybe$withDefault,
					fileOperations,
					A2(
						$elm$core$Maybe$map,
						function (avatar) {
							return A2(
								$author$project$File$Operations$enqueue,
								A2($author$project$File$Operation$Delete, false, avatar),
								fileOperations);
						},
						user.iX));
				return _Utils_Tuple2(
					A2($author$project$User$User$Deleted, user.dk, payload.N),
					newFileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$User$User$applyEmailAddressChangedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$User$User$userFromModification(modification);
		if (!_v0.$) {
			var user = _v0.a;
			if (_Utils_eq(payload.dk, user.dk) && (_Utils_cmp(payload.n, user.i) > 0)) {
				var newUser = _Utils_update(
					user,
					{
						ju: $elm$core$Maybe$Just(payload.ju),
						i: payload.n
					});
				return _Utils_Tuple2(
					A2($author$project$User$User$Changed, newUser, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$User$User$applyEntryOrganisationUnitEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$User$User$userFromModification(modification);
		if (!_v0.$) {
			var user = _v0.a;
			if (_Utils_eq(payload.dk, user.dk) && (_Utils_cmp(payload.n, user.i) > 0)) {
				var newUser = _Utils_update(
					user,
					{hT: payload.hT, i: payload.n});
				return _Utils_Tuple2(
					A2($author$project$User$User$Changed, newUser, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$User$User$applyPasswordChangedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$User$User$userFromModification(modification);
		if (!_v0.$) {
			var user = _v0.a;
			if (_Utils_eq(payload.dk, user.dk)) {
				var newUser = _Utils_update(
					user,
					{i: payload.n});
				return _Utils_Tuple2(
					A2($author$project$User$User$Changed, newUser, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$User$User$applyRenamedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$User$User$userFromModification(modification);
		if (!_v0.$) {
			var user = _v0.a;
			if (_Utils_eq(payload.dk, user.dk) && (_Utils_cmp(payload.n, user.i) > 0)) {
				var newUser = _Utils_update(
					user,
					{g_: payload.g_, i: payload.n});
				return _Utils_Tuple2(
					A2($author$project$User$User$Changed, newUser, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$User$TeamRoles$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$User$User$applyTeamRoleAddedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$User$User$userFromModification(modification);
		if (!_v0.$) {
			var user = _v0.a;
			if (_Utils_eq(payload.dk, user.dk) && (_Utils_cmp(payload.n, user.i) > 0)) {
				var newUser = _Utils_update(
					user,
					{
						i: payload.n,
						k2: A2($author$project$User$TeamRoles$insert, payload.bQ, user.k2)
					});
				return _Utils_Tuple2(
					A2($author$project$User$User$Changed, newUser, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$User$User$applyTeamRoleChangedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$User$User$userFromModification(modification);
		if (!_v0.$) {
			var user = _v0.a;
			if (_Utils_eq(payload.dk, user.dk) && (_Utils_cmp(payload.n, user.i) > 0)) {
				var newUser = _Utils_update(
					user,
					{
						i: payload.n,
						k2: A2($author$project$User$TeamRoles$insert, payload.bQ, user.k2)
					});
				return _Utils_Tuple2(
					A2($author$project$User$User$Changed, newUser, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$User$TeamRoles$remove = $turboMaCk$any_set$Set$Any$remove;
var $author$project$User$User$applyTeamRoleRemovedEvent = F2(
	function (payload, acc) {
		var modification = acc.a;
		var fileOperations = acc.b;
		var _v0 = $author$project$User$User$userFromModification(modification);
		if (!_v0.$) {
			var user = _v0.a;
			if (_Utils_eq(payload.dk, user.dk) && (_Utils_cmp(payload.n, user.i) > 0)) {
				var newUser = _Utils_update(
					user,
					{
						i: payload.n,
						k2: A2($author$project$User$TeamRoles$remove, payload.bQ, user.k2)
					});
				return _Utils_Tuple2(
					A2($author$project$User$User$Changed, newUser, payload.N),
					fileOperations);
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$User$User$applyEventHelper = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $author$project$User$User$applyCreatedEvent(payload);
		case 1:
			var payload = event.a;
			return $author$project$User$User$applyEmailAddressChangedEvent(payload);
		case 2:
			var payload = event.a;
			return $author$project$User$User$applyPasswordChangedEvent(payload);
		case 3:
			var payload = event.a;
			return $author$project$User$User$applyRenamedEvent(payload);
		case 4:
			var payload = event.a;
			return $author$project$User$User$applyTeamRoleAddedEvent(payload);
		case 5:
			var payload = event.a;
			return $author$project$User$User$applyTeamRoleChangedEvent(payload);
		case 6:
			var payload = event.a;
			return $author$project$User$User$applyTeamRoleRemovedEvent(payload);
		case 7:
			var payload = event.a;
			return $author$project$User$User$applyAvatarChangedEvent(payload);
		case 8:
			var payload = event.a;
			return $author$project$User$User$applyEntryOrganisationUnitEvent(payload);
		default:
			var payload = event.a;
			return $author$project$User$User$applyDeletedEvent(payload);
	}
};
var $author$project$User$User$applyEvent = F2(
	function (event, maybeUser) {
		return A2(
			$author$project$User$User$applyEventHelper,
			event,
			_Utils_Tuple2(
				$author$project$User$User$NotModified(maybeUser),
				$author$project$File$Operations$empty));
	});
var $author$project$User$Dict$get = $turboMaCk$any_dict$Dict$Any$get;
var $author$project$User$Users$get = function (userId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$User$Users$dict,
		$author$project$User$Dict$get(userId));
};
var $author$project$User$Dict$insert = A2(
	$author$project$Utils$Utils$with,
	function ($) {
		return $.dk;
	},
	$turboMaCk$any_dict$Dict$Any$insert);
var $author$project$User$Users$insert = F2(
	function (user, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				cL: A2($author$project$User$Dict$insert, user, data.cL)
			});
	});
var $author$project$User$Dict$remove = $turboMaCk$any_dict$Dict$Any$remove;
var $author$project$User$Users$remove = F2(
	function (userId, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				cL: A2($author$project$User$Dict$remove, userId, data.cL)
			});
	});
var $author$project$User$Event$userId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.dk;
		case 1:
			var payload = event.a;
			return payload.dk;
		case 2:
			var payload = event.a;
			return payload.dk;
		case 3:
			var payload = event.a;
			return payload.dk;
		case 4:
			var payload = event.a;
			return payload.dk;
		case 5:
			var payload = event.a;
			return payload.dk;
		case 6:
			var payload = event.a;
			return payload.dk;
		case 7:
			var payload = event.a;
			return payload.dk;
		case 8:
			var payload = event.a;
			return payload.dk;
		default:
			var payload = event.a;
			return payload.dk;
	}
};
var $author$project$User$Modifications$NotEmpty = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$Dict$singleton = function (user) {
	return A2($author$project$User$Dict$insert, user, $author$project$User$Dict$empty);
};
var $author$project$User$Ids$singleton = function (id) {
	return A2($author$project$User$Ids$insert, id, $author$project$User$Ids$empty);
};
var $author$project$User$Modifications$with = F2(
	function (modification, modifications) {
		var _v0 = _Utils_Tuple2(modification, modifications);
		switch (_v0.a.$) {
			case 0:
				return modifications;
			case 1:
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var user = _v1.a;
					var eventId = _v1.b;
					var _v2 = _v0.b;
					return $author$project$User$Modifications$NotEmpty(
						{
							bh: $author$project$User$Dict$singleton(user),
							dA: $author$project$User$Ids$empty,
							fD: eventId
						});
				} else {
					var _v3 = _v0.a;
					var user = _v3.a;
					var eventId = _v3.b;
					var data = _v0.b.a;
					return $author$project$User$Modifications$NotEmpty(
						_Utils_update(
							data,
							{
								bh: A2($author$project$User$Dict$insert, user, data.bh),
								fD: eventId
							}));
				}
			default:
				if (!_v0.b.$) {
					var _v4 = _v0.a;
					var userId = _v4.a;
					var eventId = _v4.b;
					var _v5 = _v0.b;
					return $author$project$User$Modifications$NotEmpty(
						{
							bh: $author$project$User$Dict$empty,
							dA: $author$project$User$Ids$singleton(userId),
							fD: eventId
						});
				} else {
					var _v6 = _v0.a;
					var userId = _v6.a;
					var eventId = _v6.b;
					var data = _v0.b.a;
					return $author$project$User$Modifications$NotEmpty(
						_Utils_update(
							data,
							{
								bh: A2($author$project$User$Dict$remove, userId, data.bh),
								dA: A2($author$project$User$Ids$insert, userId, data.dA),
								fD: eventId
							}));
				}
		}
	});
var $author$project$User$Users$withLastEventId = F2(
	function (eventId, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				fD: $elm$core$Maybe$Just(eventId)
			});
	});
var $author$project$User$Users$applyEventHelper = F2(
	function (event, _v0) {
		var users = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		var _v1 = A2(
			$author$project$User$User$applyEvent,
			event,
			A2(
				$author$project$User$Users$get,
				$author$project$User$Event$userId(event),
				users));
		var modification = _v1.a;
		var newFileOperations = _v1.b;
		switch (modification.$) {
			case 0:
				return _Utils_Tuple3(
					users,
					modifications,
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
			case 1:
				var user = modification.a;
				var eventId = modification.b;
				return _Utils_Tuple3(
					A2(
						$author$project$User$Users$withLastEventId,
						eventId,
						A2($author$project$User$Users$insert, user, users)),
					A2($author$project$User$Modifications$with, modification, modifications),
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
			default:
				var userId = modification.a;
				var eventId = modification.b;
				return _Utils_Tuple3(
					A2(
						$author$project$User$Users$withLastEventId,
						eventId,
						A2($author$project$User$Users$remove, userId, users)),
					A2($author$project$User$Modifications$with, modification, modifications),
					A2($author$project$File$Operations$merge, fileOperations, newFileOperations));
		}
	});
var $author$project$User$Modifications$Empty = {$: 0};
var $author$project$User$Modifications$empty = $author$project$User$Modifications$Empty;
var $author$project$User$Events$fold = $author$project$Types$Queue$fold;
var $author$project$User$Users$applyEvents = F2(
	function (events, users) {
		return A3(
			$author$project$User$Events$fold,
			$author$project$User$Users$applyEventHelper,
			_Utils_Tuple3(users, $author$project$User$Modifications$empty, $author$project$File$Operations$empty),
			events);
	});
var $author$project$User$Store$events = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$User$Events$empty;
		case 1:
			var data = state.a;
			return data.b8;
		case 2:
			var data = state.a;
			return data.b8;
		default:
			var data = state.a;
			return data.b8;
	}
};
var $author$project$User$Store$users = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$User$Users$empty;
		case 1:
			return $author$project$User$Users$empty;
		case 2:
			var data = state.a;
			return data.lk;
		default:
			var data = state.a;
			return data.lk;
	}
};
var $author$project$Environments$Repository$users = function (_v0) {
	var data = _v0;
	return $author$project$User$Users$dict(
		$author$project$Utils$Triple$first(
			A2(
				$author$project$User$Users$applyEvents,
				$author$project$User$Store$events(data.ah),
				$author$project$User$Store$users(data.ah))));
};
var $author$project$Audit$EditDialog$AuditorTab = 1;
var $author$project$Audit$EditDialog$UserClickedCloseDialog = {$: 0};
var $author$project$UI$Dialog$Config = $elm$core$Basics$identity;
var $author$project$UI$Dialog$appendContent = F2(
	function (content, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				ai: A2($elm$core$List$cons, content, config.ai)
			});
	});
var $author$project$UI$Dialog$appendFooter = F2(
	function (footer, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				eE: A2($elm$core$List$cons, footer, config.eE)
			});
	});
var $author$project$UI$Dialog$appendHeader = F2(
	function (header, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				gO: A2($elm$core$List$cons, header, config.gO)
			});
	});
var $author$project$UI$Dialog$appendStyle = F2(
	function (styles, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				by: A2($elm$core$List$append, config.by, styles)
			});
	});
var $author$project$UI$Dialog$dialog = F2(
	function (title, onClose) {
		return {ai: _List_Nil, eE: _List_Nil, gO: _List_Nil, jI: $elm$core$Maybe$Nothing, g4: onClose, by: _List_Nil, f5: $elm$core$Maybe$Nothing, k8: title};
	});
var $author$project$Translations$Audits$EditDialog$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'audits.editDialog.header');
};
var $rtfeldman$elm_css$Css$minHeight = $rtfeldman$elm_css$Css$prop1('min-height');
var $rtfeldman$elm_css$Css$minWidth = $rtfeldman$elm_css$Css$prop1('min-width');
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $author$project$UI$Icons$taskList = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M16.684 12.332c-.667 0-1.213.548-1.213 1.214v1.727c0 .033-.028.059-.06.059h-4.923c-.032 0-.06-.026-.06-.059v-4.924c0-.032.028-.06.06-.06h4.923c.667 0 1.211-.544 1.211-1.213 0-.668-.544-1.214-1.211-1.214h-4.923C9.12 7.856 8 8.975 8 10.344v4.922c0 1.375 1.12 2.487 2.488 2.487h4.923c1.375 0 2.486-1.12 2.486-2.487v-1.72c0-.666-.545-1.214-1.213-1.214M16.684 23.517c-.667 0-1.213.548-1.213 1.214v1.726c0 .033-.028.06-.06.06h-4.923c-.032 0-.06-.027-.06-.06v-4.921c0-.034.028-.061.06-.061h4.923c.667 0 1.211-.547 1.211-1.214 0-.667-.544-1.215-1.211-1.215h-4.923C9.113 19.046 8 20.167 8 21.536v4.921c0 1.375 1.12 2.489 2.488 2.489h4.923c1.375 0 2.486-1.12 2.486-2.489v-1.726c0-.666-.545-1.214-1.213-1.214M16.684 34.711c-.667 0-1.213.545-1.213 1.213v1.726c0 .032-.028.06-.06.06h-4.923c-.032 0-.06-.028-.06-.06v-4.923c0-.033.028-.061.06-.061h4.923c.667 0 1.211-.546 1.211-1.213 0-.668-.544-1.213-1.211-1.213h-4.923C9.113 30.24 8 31.359 8 32.727v4.923c0 1.376 1.12 2.488 2.488 2.488h4.923c1.375 0 2.486-1.121 2.486-2.488v-1.726c0-.668-.545-1.213-1.213-1.213M20.918 14.019h17.867c.667 0 1.215-.548 1.215-1.216 0-.666-.548-1.212-1.215-1.212H20.918c-.668 0-1.212.546-1.212 1.212 0 .668.544 1.216 1.212 1.216M38.785 22.783H20.918c-.667 0-1.213.545-1.213 1.213 0 .666.546 1.215 1.213 1.215h17.867c.668 0 1.215-.549 1.215-1.215 0-.668-.547-1.213-1.215-1.213M38.785 33.976H20.918c-.667 0-1.213.545-1.213 1.213s.546 1.213 1.213 1.213h17.867c.668 0 1.215-.545 1.215-1.213s-.547-1.213-1.215-1.213')
						]),
					_List_Nil)
				]));
	});
var $rtfeldman$elm_css$Css$bottom = $rtfeldman$elm_css$Css$prop1('bottom');
var $rtfeldman$elm_css$Css$fixed = {et: 0, eU: 0, f6: 0, ll: 'fixed'};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$right = $rtfeldman$elm_css$Css$prop1('right');
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $rtfeldman$elm_css$Css$absolute = {eU: 0, ll: 'absolute'};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.ll);
};
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $author$project$UI$Style$Theme$transparentBlack = A4($author$project$UI$Style$Color$rgba, 0, 0, 0, 0.8);
var $author$project$UI$Dialog$viewBackdrop = A3(
	$rtfeldman$elm_css$Html$Styled$node,
	'aw-dialog-backdrop',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$px(-9)),
					$rtfeldman$elm_css$Css$right(
					$rtfeldman$elm_css$Css$px(-9)),
					$rtfeldman$elm_css$Css$bottom(
					$rtfeldman$elm_css$Css$px(-9)),
					$rtfeldman$elm_css$Css$left(
					$rtfeldman$elm_css$Css$px(-9)),
					$rtfeldman$elm_css$Css$backgroundColor(
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$transparentBlack)),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$rem(1))
				]))
		]),
	_List_Nil);
var $author$project$UI$Dialog$viewSubDialog = $elm$core$Maybe$withDefault(
	$rtfeldman$elm_css$Html$Styled$text(''));
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.ll, argB.ll, argC.ll])));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$float = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'float',
		'float',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1('max-height');
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $rtfeldman$elm_css$Css$solid = {aR: 0, dh: 0, ll: 'solid'};
var $rtfeldman$elm_css$Css$valuesOrNone = function (list) {
	return $elm$core$List$isEmpty(list) ? {ll: 'none'} : {
		ll: A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.ll;
				},
				list))
	};
};
var $rtfeldman$elm_css$Css$transforms = A2(
	$elm$core$Basics$composeL,
	$rtfeldman$elm_css$Css$prop1('transform'),
	$rtfeldman$elm_css$Css$valuesOrNone);
var $rtfeldman$elm_css$Css$transform = function (only) {
	return $rtfeldman$elm_css$Css$transforms(
		_List_fromArray(
			[only]));
};
var $rtfeldman$elm_css$Css$translate2 = F2(
	function (tx, ty) {
		return {
			q: 0,
			ll: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'translate',
				_List_fromArray(
					[tx.ll, ty.ll]))
		};
	});
var $rtfeldman$elm_css$Css$auto = {iO: 0, c: 0, dK: 0, fz: 0, jQ: 0, dP: 0, ch: 0, bG: 0, d4: 0, bu: 0, f6: 0, ek: 0, a4: 0, ll: 'auto'};
var $rtfeldman$elm_css$Css$overflowY = $rtfeldman$elm_css$Css$prop1('overflow-y');
var $author$project$UI$Dialog$viewContent = function (content) {
	if (!content.b) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-dialog-content',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$flexShrink(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
						]))
				]),
			$elm$core$List$reverse(content));
	}
};
var $author$project$UI$Dialog$viewFooter = function (footer) {
	if (!footer.b) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-dialog-footer',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero)
						]))
				]),
			$elm$core$List$reverse(footer));
	}
};
var $author$project$UI$Dialog$viewHeader = function (header) {
	if (!header.b) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-dialog-header',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero)
						]))
				]),
			$elm$core$List$reverse(header));
	}
};
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$UI$Icons$close = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M24 21.879l11.667-11.668c.586-.585 1.536-.585 2.122 0 .585.586.585 1.536 0 2.122L26.121 24l11.668 11.667c.585.586.585 1.536 0 2.122-.586.585-1.536.585-2.122 0L24 26.121 12.333 37.789l-.007.006c-.586.579-1.531.577-2.115-.006-.585-.586-.585-1.536 0-2.122L21.879 24 10.211 12.333l-.006-.007c-.579-.586-.577-1.531.006-2.115.586-.585 1.536-.585 2.122 0L24 21.879z')
						]),
					_List_Nil)
				]));
	});
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $author$project$UI$Icon$OnClickStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Icon$withOnClickStopPropagation = F2(
	function (msg, config) {
		if (!config.$) {
			var options = config.a;
			return $author$project$UI$Icon$Unicolor(
				_Utils_update(
					options,
					{
						bJ: $author$project$UI$Icon$OnClickStopPropagation(msg)
					}));
		} else {
			var options = config.a;
			return $author$project$UI$Icon$Bicolor(
				_Utils_update(
					options,
					{
						bJ: $author$project$UI$Icon$OnClickStopPropagation(msg)
					}));
		}
	});
var $author$project$UI$Dialog$viewCloseIcon = function (onClose) {
	return $author$project$UI$Icon$view(
		A2(
			$author$project$UI$Icon$withStyle,
			$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$rem(0.2)),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3)),
				A3(
					$elm$core$Basics$composeR,
					$author$project$UI$Icon$withOnClickStopPropagation(onClose),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Icon$withStyle(
							$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero)),
						$author$project$UI$Icon$withStyle(
							$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero))),
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$close)))));
};
var $author$project$UI$Dialog$viewIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$Icon$withForegroundColor($author$project$UI$Style$Theme$darkGrey),
	A2(
		$elm$core$Basics$composeR,
		$author$project$UI$Icon$withStyle(
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero)),
		A2(
			$elm$core$Basics$composeR,
			$author$project$UI$Icon$withStyle(
				$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero)),
			A2(
				$elm$core$Basics$composeR,
				$author$project$UI$Icon$withStyle(
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3))),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Icon$withStyle(
						$rtfeldman$elm_css$Css$marginRight(
							$rtfeldman$elm_css$Css$rem(0.2))),
					$author$project$UI$Icon$view)))));
var $author$project$UI$Dialog$viewTitle = function (title) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
						$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
						$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(title)
			]));
};
var $author$project$UI$Dialog$viewWindowTitleBar = F3(
	function (title, icon, onClose) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$rtfeldman$elm_css$Html$Styled$text(''),
					A2($elm$core$Maybe$map, $author$project$UI$Dialog$viewIcon, icon)),
					$author$project$UI$Dialog$viewTitle(title),
					$author$project$UI$Dialog$viewCloseIcon(onClose)
				]));
	});
var $author$project$UI$Style$Theme$white = A4($author$project$UI$Style$Color$rgba, 255 / 255, 255 / 255, 255 / 255, 1.0);
var $author$project$UI$Dialog$viewWindow = function (config) {
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-dialog-window',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$rem(1)),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$rem(0.5),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
							$rtfeldman$elm_css$Css$float($rtfeldman$elm_css$Css$left),
							$rtfeldman$elm_css$Css$minWidth(
							$rtfeldman$elm_css$Css$rem(20)),
							$rtfeldman$elm_css$Css$maxWidth(
							$rtfeldman$elm_css$Css$pct(90)),
							$rtfeldman$elm_css$Css$maxHeight(
							$rtfeldman$elm_css$Css$pct(100)),
							A2($rtfeldman$elm_css$Css$property, 'width', 'max-content'),
							$rtfeldman$elm_css$Css$left(
							$rtfeldman$elm_css$Css$pct(50)),
							$rtfeldman$elm_css$Css$right(
							$rtfeldman$elm_css$Css$pct(50)),
							$rtfeldman$elm_css$Css$top(
							$rtfeldman$elm_css$Css$pct(50)),
							$rtfeldman$elm_css$Css$transform(
							A2(
								$rtfeldman$elm_css$Css$translate2,
								$rtfeldman$elm_css$Css$pct(-50),
								$rtfeldman$elm_css$Css$pct(-50)))
						]),
					config.by))
			]),
		_List_fromArray(
			[
				A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$UI$Dialog$viewWindowTitleBar, config.k8, config.jI, config.g4),
				A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$UI$Dialog$viewHeader, config.gO),
				$author$project$UI$Dialog$viewContent(config.ai),
				A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$UI$Dialog$viewFooter, config.eE)
			]));
};
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $author$project$UI$Dialog$view = function (_v0) {
	var config = _v0;
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-dialog',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
						$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(2)),
						$rtfeldman$elm_css$Css$zIndex(
						$rtfeldman$elm_css$Css$int(3))
					]))
			]),
		_List_fromArray(
			[
				$author$project$UI$Dialog$viewBackdrop,
				$author$project$UI$Dialog$viewWindow(config),
				$author$project$UI$Dialog$viewSubDialog(config.f5)
			]));
};
var $author$project$UI$Bar$Config = $elm$core$Basics$identity;
var $author$project$UI$Bar$bar = function (label) {
	return {gl: _List_Nil, gp: $author$project$UI$Style$Theme$darkGrey, h2: label, c$: _List_Nil, fN: $elm$core$Maybe$Nothing, g5: $elm$core$Maybe$Nothing, c9: _List_Nil, kE: $elm$core$Maybe$Nothing, by: _List_Nil, hm: $author$project$UI$Style$Theme$white};
};
var $author$project$Translations$Measures$ResponsibleUsers$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.responsibleUsers.header');
};
var $author$project$UI$Icons$user = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M23.956 9.083c-1.629 0-4.388.63-4.582 4.841l-.002.042-.01.063c-.003.039-.426 4.441 1.545 6.656.735.834 1.735 1.244 3.061 1.256 1.4-.012 2.374-.41 3.123-1.255 1.806-2.034 1.597-5.9 1.545-6.565l-.011-.026-.007-.198c-.179-3.893-2.597-4.769-4.594-4.814l-.068-.614v.614zm-.069 15.935c-2.191-.037-3.962-.808-5.273-2.293-2.78-3.135-2.357-8.413-2.298-9.006.182-3.921 2.093-5.812 3.666-6.702C21.534 6.133 23.141 6 23.962 6h.117c1.491.03 2.826.382 3.984 1.046 1.551.886 3.437 2.771 3.623 6.705.055.561.481 5.84-2.301 8.975-1.319 1.484-3.091 2.255-5.268 2.292h-.23zM24.011 42c-8.534 0-13.634-3.337-13.685-3.372-.261-.161-.473-.415-.589-.722-.397-1.002-.398-2.8-.39-3.326.008-.117.007-.148.007-.181.043-1.379.151-4.959 3.513-6.113l.122-.036c2.955-.75 5.436-2.469 5.461-2.487.266-.186.569-.283.888-.283.499 0 .971.245 1.259.654.488.692.32 1.654-.374 2.144-.761.511-3.337 2.144-6.444 2.942-1.053.378-1.3 1.481-1.355 3.252l-.006.11c-.011.533.018 1.248.087 1.759 1.426.759 5.493 2.59 11.499 2.59 6.034 0 10.075-1.824 11.492-2.582.065-.497.094-1.206.087-1.711-.005-.011-.007-.09-.007-.178-.051-1.708-.305-2.855-1.408-3.248-3.458-.887-6.271-2.845-6.389-2.928-.694-.49-.861-1.451-.375-2.143.289-.409.76-.654 1.261-.654.317 0 .623.097.882.281.026.018 2.532 1.741 5.472 2.49l.11.033c3.37 1.149 3.477 4.738 3.517 6.089l.007.196c.007.384.019 2.301-.367 3.326-.114.297-.325.555-.596.731-.551.349-5.543 3.367-13.679 3.367')
						]),
					_List_Nil)
				]));
	});
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $author$project$Utils$CSS$changeCursor = function (maybe) {
	return A3(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			function (_v0) {
				return $rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer);
			}),
		$elm$core$Maybe$withDefault(
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)),
		maybe);
};
var $rtfeldman$elm_css$Css$paddingLeft = $rtfeldman$elm_css$Css$prop1('padding-left');
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $rtfeldman$elm_css$Css$none = {$7: 0, hz: 0, aR: 0, c: 0, W: 0, jH: 0, h0: 0, gS: 0, dR: 0, c0: 0, bG: 0, e: 0, d: 0, g$: 0, fU: 0, ks: 0, bu: 0, f$: 0, kK: 0, ei: 0, di: 0, a4: 0, q: 0, lf: 0, ll: 'none'};
var $rtfeldman$elm_css$Css$textDecoration = $rtfeldman$elm_css$Css$prop1('text-decoration');
var $rtfeldman$elm_css$Css$underline = {ei: 0, ll: 'underline'};
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$UI$Bar$withClick = function () {
	var addOnClick = function (msg) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
			]);
	};
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(addOnClick),
		$elm$core$Maybe$withDefault(_List_Nil));
}();
var $author$project$UI$Bar$viewLabel = F2(
	function (label, onLabelClick) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$flexGrow(
								$rtfeldman$elm_css$Css$int(1)),
								$rtfeldman$elm_css$Css$flexShrink(
								$rtfeldman$elm_css$Css$int(1)),
								$rtfeldman$elm_css$Css$paddingLeft(
								$rtfeldman$elm_css$Css$rem(0.5)),
								$rtfeldman$elm_css$Css$lineHeight(
								$rtfeldman$elm_css$Css$rem(2.5)),
								$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
								$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden),
								$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
								A2(
								$elm$core$Maybe$withDefault,
								$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return $rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline);
									},
									onLabelClick)),
								$author$project$Utils$CSS$changeCursor(onLabelClick)
							]))
					]),
				$author$project$UI$Bar$withClick(onLabelClick)),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $author$project$UI$Bar$viewIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$Icon$withForegroundColor($author$project$UI$Style$Theme$white),
	A2(
		$elm$core$Basics$composeR,
		$author$project$UI$Icon$withStyle(
			$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$rem(2.5))),
		A2(
			$elm$core$Basics$composeR,
			$author$project$UI$Icon$withStyle(
				$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero)),
			A2(
				$elm$core$Basics$composeR,
				$author$project$UI$Icon$withStyle(
					$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero)),
				$author$project$UI$Icon$view))));
var $author$project$UI$Bar$viewLeftIcon = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $author$project$UI$Bar$viewIcon, $elm$core$List$cons),
	_List_Nil);
var $author$project$UI$Bar$viewRightIcons = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $author$project$UI$Bar$viewIcon, $elm$core$List$cons),
	_List_Nil);
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $author$project$UI$Bar$viewRightText = function (maybeText) {
	if (!maybeText.$) {
		var text_ = maybeText.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$paddingRight(
							$rtfeldman$elm_css$Css$rem(0.5)),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$rem(2.5)),
							$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
							$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(text_)
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$UI$Bar$view = function (_v0) {
	var config = _v0;
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-bar',
		_Utils_ap(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$paddingLeft(
							$rtfeldman$elm_css$Css$rem(0.3)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$rem(0.4)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor(config.gp)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor(config.hm)),
							$rtfeldman$elm_css$Css$batch(config.by),
							$author$project$Utils$CSS$changeCursor(config.fN)
						]))
				]),
			_Utils_ap(
				$author$project$UI$Bar$withClick(config.fN),
				config.gl)),
		_Utils_ap(
			$author$project$UI$Bar$viewLeftIcon(config.c$),
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$UI$Bar$viewLabel, config.h2, config.g5)
					]),
				_Utils_ap(
					$author$project$UI$Bar$viewRightIcons(config.c9),
					_List_fromArray(
						[
							$author$project$UI$Bar$viewRightText(config.kE)
						])))));
};
var $author$project$UI$Bar$withLeftIcon = F2(
	function (icon, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				c$: _List_fromArray(
					[icon])
			});
	});
var $author$project$Audit$ResponsibleUsersEditor$viewBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$user),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Measures$ResponsibleUsers$header(translations))));
};
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $author$project$Audit$EditDialog$footer = function (content) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
					]))
			]),
		content);
};
var $author$project$Audit$EditDialog$UserClickedApplyButton = {$: 3};
var $author$project$Translations$Buttons$apply = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'buttons.apply');
};
var $author$project$UI$Button$Config = $elm$core$Basics$identity;
var $author$project$UI$Button$darkGrey = function (label) {
	return {
		jo: false,
		h2: label,
		bJ: $elm$core$Maybe$Nothing,
		d2: $elm$core$Maybe$Nothing,
		by: _List_fromArray(
			[
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
				$rtfeldman$elm_css$Css$color(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
				$rtfeldman$elm_css$Css$backgroundColor(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
			])
	};
};
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$focus = $rtfeldman$elm_css$Css$pseudoClass('focus');
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $rtfeldman$elm_css$Css$outline = $rtfeldman$elm_css$Css$prop1('outline');
var $rtfeldman$elm_css$Css$notAllowed = {c: 0, ll: 'not-allowed'};
var $author$project$UI$Button$setCursor = function (_v0) {
	var config = _v0;
	return config.jo ? $rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed) : $author$project$Utils$CSS$changeCursor(config.bJ);
};
var $author$project$UI$Button$setOnClick = F2(
	function (maybeMsg, attributes) {
		return A2(
			$elm$core$Maybe$withDefault,
			attributes,
			A2(
				$elm$core$Maybe$map,
				function (msg) {
					return A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
							'click',
							$elm$json$Json$Decode$succeed(
								_Utils_Tuple2(msg, true))),
						attributes);
				},
				maybeMsg));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onMouseDown = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$UI$Button$setOnMouseDown = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$Events$onMouseDown, $elm$core$List$cons)),
	$elm$core$Maybe$withDefault($elm$core$Basics$identity));
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $author$project$UI$Button$view = function (_v0) {
	var config = _v0;
	var styleList = _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$rem(0.5),
			$rtfeldman$elm_css$Css$rem(1)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$rem(0.5)),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				])),
			$rtfeldman$elm_css$Css$batch(config.by),
			$rtfeldman$elm_css$Css$opacity(
			config.jo ? $rtfeldman$elm_css$Css$num(0.5) : $rtfeldman$elm_css$Css$num(1.0)),
			$author$project$UI$Button$setCursor(config)
		]);
	var cssAttribute = $rtfeldman$elm_css$Html$Styled$Attributes$css(styleList);
	var attributes = A2(
		$author$project$UI$Button$setOnMouseDown,
		config.d2,
		A2(
			$author$project$UI$Button$setOnClick,
			config.bJ,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(config.jo),
					cssAttribute
				])));
	return A2(
		$rtfeldman$elm_css$Html$Styled$button,
		attributes,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(config.h2)
			]));
};
var $author$project$UI$Button$withOnClick = F2(
	function (msg, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				bJ: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Audit$EditDialog$viewApplyButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Audit$EditDialog$UserClickedApplyButton,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$apply(translations))));
};
var $author$project$Audit$EditDialog$UserClickedCancelButton = {$: 2};
var $author$project$Translations$Buttons$cancel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'buttons.cancel');
};
var $author$project$UI$Style$Theme$lightGrey = A4($author$project$UI$Style$Color$rgba, 224 / 255, 232 / 255, 238 / 255, 1.0);
var $author$project$UI$Button$lightGrey = function (label) {
	return {
		jo: false,
		h2: label,
		bJ: $elm$core$Maybe$Nothing,
		d2: $elm$core$Maybe$Nothing,
		by: _List_fromArray(
			[
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
				$rtfeldman$elm_css$Css$color(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
				$rtfeldman$elm_css$Css$backgroundColor(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
			])
	};
};
var $author$project$Audit$EditDialog$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Audit$EditDialog$UserClickedCancelButton,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$Audit$EditDialog$viewFooter = F2(
	function (translations, context) {
		var secondButton = (context === 1) ? $rtfeldman$elm_css$Html$Styled$text('') : $author$project$Audit$EditDialog$viewApplyButton(translations);
		return $author$project$Audit$EditDialog$footer(
			_List_fromArray(
				[
					$author$project$Audit$EditDialog$viewCancelButton(translations),
					secondButton
				]));
	});
var $author$project$Audit$EditDialog$UserSelectedUser = function (a) {
	return {$: 10, a: a};
};
var $author$project$Audit$EditDialog$UserUnselectedUser = function (a) {
	return {$: 11, a: a};
};
var $author$project$Translations$Measures$ResponsibleUsers$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.responsibleUsers.emptyText');
};
var $author$project$UI$Table$Config = $elm$core$Basics$identity;
var $author$project$UI$Table$fromList = F2(
	function (toRow, items) {
		return {
			fc: _List_Nil,
			dE: '',
			c_: _List_Nil,
			cu: A3(
				$elm$core$List$foldl,
				A2($elm$core$Basics$composeR, toRow, $elm$core$List$cons),
				_List_Nil,
				items),
			dd: _List_Nil
		};
	});
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$UI$DragAndDrop$DragAndDrop$Move = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$borderBottom = $rtfeldman$elm_css$Css$prop1('border-bottom');
var $rtfeldman$elm_css$Css$borderBottom3 = $rtfeldman$elm_css$Css$prop3('border-bottom');
var $rtfeldman$elm_css$Css$lastChild = $rtfeldman$elm_css$Css$pseudoClass('last-child');
var $author$project$UI$DragAndDrop$MouseEvent$defaultOptions = {kx: true, kX: false};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$UI$DragAndDrop$MouseEvent$DragDropEvent = F5(
	function (clientPos, offsetPos, targetsSize, targetsOffset, targetsScrollOffset) {
		return {i7: clientPos, g0: offsetPos, k$: targetsOffset, k0: targetsScrollOffset, iB: targetsSize};
	});
var $author$project$UI$DragAndDrop$MouseEvent$clientPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$UI$DragAndDrop$MouseEvent$offsetPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$float));
var $author$project$UI$DragAndDrop$MouseEvent$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $author$project$UI$DragAndDrop$MouseEvent$targetsOffset = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float));
var $author$project$UI$DragAndDrop$MouseEvent$targetsOffsetParentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'offsetParent', decoder);
};
var $author$project$UI$DragAndDrop$MouseEvent$targetsScrollOffset = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float));
var $author$project$UI$DragAndDrop$MouseEvent$targetsSize = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float));
var $author$project$UI$DragAndDrop$MouseEvent$eventDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$UI$DragAndDrop$MouseEvent$DragDropEvent,
	$author$project$UI$DragAndDrop$MouseEvent$clientPos,
	$author$project$UI$DragAndDrop$MouseEvent$offsetPos,
	$author$project$UI$DragAndDrop$MouseEvent$target($author$project$UI$DragAndDrop$MouseEvent$targetsSize),
	$author$project$UI$DragAndDrop$MouseEvent$target($author$project$UI$DragAndDrop$MouseEvent$targetsOffset),
	$author$project$UI$DragAndDrop$MouseEvent$target(
		$author$project$UI$DragAndDrop$MouseEvent$targetsOffsetParentElement($author$project$UI$DragAndDrop$MouseEvent$targetsScrollOffset)));
var $author$project$UI$DragAndDrop$MouseEvent$onWithOptions = F3(
	function (event, options, toMsg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (ev) {
					return {
						j5: toMsg(ev),
						kx: options.kx,
						kX: options.kX
					};
				},
				$author$project$UI$DragAndDrop$MouseEvent$eventDecoder));
	});
var $author$project$UI$DragAndDrop$MouseEvent$onMouseMove = A2($author$project$UI$DragAndDrop$MouseEvent$onWithOptions, 'mousemove', $author$project$UI$DragAndDrop$MouseEvent$defaultOptions);
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $author$project$UI$DragAndDrop$DragAndDrop$Down = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$UI$DragAndDrop$DragAndDrop$Over = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$UI$DragAndDrop$DragAndDrop$Up = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$UI$Table$Row$elementToRenderEqualsHoveredElement = F2(
	function (elemA, maybeElem) {
		if (!maybeElem.$) {
			var _v1 = maybeElem.a;
			var elemB = _v1.a;
			return _Utils_eq(elemB, elemA);
		} else {
			return false;
		}
	});
var $author$project$UI$Table$Row$elementToRenderIsNotDraggedElement = F2(
	function (elemA, maybeElem) {
		if (!maybeElem.$) {
			var _v1 = maybeElem.a;
			var elemB = _v1.a;
			return !_Utils_eq(elemB, elemA);
		} else {
			return false;
		}
	});
var $rtfeldman$elm_css$Css$move = {c: 0, ll: 'move'};
var $author$project$UI$DragAndDrop$MouseEvent$onMouseDown = A2($author$project$UI$DragAndDrop$MouseEvent$onWithOptions, 'mousedown', $author$project$UI$DragAndDrop$MouseEvent$defaultOptions);
var $author$project$UI$DragAndDrop$MouseEvent$onMouseOver = A2($author$project$UI$DragAndDrop$MouseEvent$onWithOptions, 'mouseover', $author$project$UI$DragAndDrop$MouseEvent$defaultOptions);
var $author$project$UI$DragAndDrop$MouseEvent$onMouseUp = A2($author$project$UI$DragAndDrop$MouseEvent$onWithOptions, 'mouseup', $author$project$UI$DragAndDrop$MouseEvent$defaultOptions);
var $author$project$UI$Table$Row$rowAttributes = F2(
	function (dragAndDropConfig, elem) {
		var additionalCss = (A2($author$project$UI$Table$Row$elementToRenderEqualsHoveredElement, elem, dragAndDropConfig.hN.jf) && A2($author$project$UI$Table$Row$elementToRenderIsNotDraggedElement, elem, dragAndDropConfig.hN.hF)) ? dragAndDropConfig.hO : _List_Nil;
		var _v0 = dragAndDropConfig.hN.hF;
		if (!_v0.$) {
			var _v1 = _v0.a;
			var draggedElement = _v1.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						$author$project$UI$DragAndDrop$MouseEvent$onMouseOver(
						A2(
							$elm$core$Basics$composeL,
							dragAndDropConfig.hL,
							$author$project$UI$DragAndDrop$DragAndDrop$Over(elem))),
						$author$project$UI$DragAndDrop$MouseEvent$onMouseUp(
						A2(
							$elm$core$Basics$composeL,
							dragAndDropConfig.hM,
							A2($author$project$UI$DragAndDrop$DragAndDrop$Up, draggedElement, elem)))
					]),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$move),
					additionalCss));
		} else {
			return _Utils_Tuple2(
				_List_fromArray(
					[
						$author$project$UI$DragAndDrop$MouseEvent$onMouseDown(
						A2(
							$elm$core$Basics$composeL,
							dragAndDropConfig.hL,
							$author$project$UI$DragAndDrop$DragAndDrop$Down(elem)))
					]),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					additionalCss));
		}
	});
var $author$project$UI$Table$Row$setOnClick = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$Events$onClick, $elm$core$List$cons)),
	$elm$core$Maybe$withDefault($elm$core$Basics$identity));
var $rtfeldman$elm_css$Css$transparent = {K: 0, ll: 'transparent'};
var $rtfeldman$elm_css$Css$inlineBlock = {W: 0, ll: 'inline-block'};
var $rtfeldman$elm_css$Css$margin = $rtfeldman$elm_css$Css$prop1('margin');
var $rtfeldman$elm_css$Css$relative = {eU: 0, ll: 'relative'};
var $author$project$UI$Avatar$setOnClick = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$Events$onClick, $elm$core$List$cons)),
	$elm$core$Maybe$withDefault($elm$core$Basics$identity));
var $author$project$UI$Icons$editCircle = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M32 58.462C17.406 58.462 5.537 46.592 5.537 32 5.537 17.406 17.406 5.536 32 5.536c14.594 0 26.463 11.87 26.463 26.464 0 14.592-11.869 26.462-26.463 26.462m21.914-48.376C48.054 4.238 40.28 1 32 1c-8.28 0-16.067 3.225-21.914 9.086C4.226 15.932 1 23.719 1 32c0 8.28 3.226 16.066 9.086 21.914C15.933 59.773 23.72 63 32 63c8.28 0 16.067-3.227 21.914-9.086C59.761 48.054 63 40.28 63 32c0-8.281-3.226-16.068-9.086-21.914')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M41.288 19.37L21.079 39.578c-.514.514-.514 1.35 0 1.871.255.256.594.389.931.389.338 0 .674-.133.932-.389L43.151 21.24c.513-.514.513-1.351 0-1.87-.514-.516-1.35-.516-1.863 0')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M47.428 15.334l-.227-.236c-1.372-1.372-3.192-2.127-5.129-2.127-1.937 0-3.764.755-5.129 2.127L15.317 36.716c-.213.213-.345.491-.381.792l-1.05 9.672c-.043.396.096.793.382 1.078.251.25.588.39.932.39.045 0 .095 0 .14-.008l9.671-1.048c.302-.029.581-.169.793-.381l16.848-16.849c.513-.514.513-1.352 0-1.872-.513-.514-1.35-.514-1.87 0L24.27 45.007l-7.581.83.822-7.58 21.297-21.286c.872-.876 2.031-1.354 3.264-1.354 1.233 0 2.393.478 3.267 1.354l.22.22c.873.871 1.348 2.032 1.348 3.263 0 1.232-.475 2.393-1.348 3.265l-.713.712c-.513.515-.513 1.35 0 1.873.513.512 1.349.512 1.872 0l.71-.712c1.374-1.373 2.129-3.193 2.129-5.131 0-1.937-.755-3.762-2.129-5.127')
						]),
					_List_Nil)
				]));
	});
var $rtfeldman$elm_css$Css$EmUnits = 0;
var $rtfeldman$elm_css$Css$em = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'em');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $author$project$UI$Avatar$viewEditIcon = function (showEditIcon) {
	return showEditIcon ? A2(
		$author$project$UI$Icons$editCircle,
		$author$project$UI$Style$Theme$grey,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
						$rtfeldman$elm_css$Css$bottom(
						$rtfeldman$elm_css$Css$em(-1)),
						$rtfeldman$elm_css$Css$left(
						$rtfeldman$elm_css$Css$pct(50)),
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(-1.25)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$rem(2.5)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$em(0.2),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$pct(50)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white))
					]))
			])) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$UI$Style$Theme$lightRed = A4($author$project$UI$Style$Color$rgba, 239 / 255, 41 / 255, 41 / 255, 1.0);
var $author$project$UI$Avatar$viewNumber = function (number) {
	if (!number) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
							$rtfeldman$elm_css$Css$top(
							$rtfeldman$elm_css$Css$rem(-0.25)),
							$rtfeldman$elm_css$Css$right(
							$rtfeldman$elm_css$Css$rem(-0.25)),
							$rtfeldman$elm_css$Css$minWidth(
							$rtfeldman$elm_css$Css$rem(1.5)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$rem(0.25)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$rem(0.75)),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$fromInt(number))
				]));
	}
};
var $author$project$UI$Avatar$viewIcon = function (options) {
	var cssAttribute = $rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
				A2($rtfeldman$elm_css$Css$property, 'align-content', 'center'),
				$rtfeldman$elm_css$Css$batch(options.by)
			]));
	var attributes = A2(
		$author$project$UI$Avatar$setOnClick,
		options.bJ,
		_List_fromArray(
			[cssAttribute]));
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-avatar',
		attributes,
		_List_fromArray(
			[
				$author$project$UI$Icon$view(
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(4)),
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$margin(
							$rtfeldman$elm_css$Css$rem(-0.2)),
						options.jI))),
				$author$project$UI$Avatar$viewNumber(options.cm),
				$author$project$UI$Avatar$viewEditIcon(options.b7)
			]));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$attribute = $rtfeldman$elm_css$VirtualDom$Styled$attribute;
var $rtfeldman$elm_css$Css$textIndent = $rtfeldman$elm_css$Css$prop1('text-indent');
var $author$project$UI$Avatar$viewImage = function (options) {
	var cssAttribute = $rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
				$rtfeldman$elm_css$Css$batch(options.by),
				$author$project$Utils$CSS$changeCursor(options.bJ),
				$rtfeldman$elm_css$Css$textIndent($rtfeldman$elm_css$Css$zero)
			]));
	var attributes = A2(
		$author$project$UI$Avatar$setOnClick,
		options.bJ,
		_List_fromArray(
			[cssAttribute]));
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-avatar',
		attributes,
		_List_fromArray(
			[
				A3(
				$rtfeldman$elm_css$Html$Styled$node,
				'aw-image',
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'filename',
						$author$project$File$Filename$toIdString(options.P)),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$rem(4)),
								$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$rem(4)),
								$rtfeldman$elm_css$Css$borderRadius(
								$rtfeldman$elm_css$Css$pct(50)),
								$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
							]))
					]),
				_List_Nil),
				$author$project$UI$Avatar$viewNumber(options.cm),
				$author$project$UI$Avatar$viewEditIcon(options.b7)
			]));
};
var $author$project$UI$Avatar$view = function (avatar) {
	if (!avatar.$) {
		var options = avatar.a;
		return $author$project$UI$Avatar$viewImage(options);
	} else {
		var options = avatar.a;
		return $author$project$UI$Avatar$viewIcon(options);
	}
};
var $author$project$UI$Avatar$Icon = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Avatar$Image = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Avatar$withStyle = F2(
	function (style, avatar) {
		if (!avatar.$) {
			var options = avatar.a;
			return $author$project$UI$Avatar$Image(
				_Utils_update(
					options,
					{
						by: A2($elm$core$List$cons, style, options.by)
					}));
		} else {
			var options = avatar.a;
			return $author$project$UI$Avatar$Icon(
				_Utils_update(
					options,
					{
						by: A2($elm$core$List$cons, style, options.by)
					}));
		}
	});
var $author$project$UI$Table$Row$viewAvatar = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		$author$project$UI$Avatar$withStyle(
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero))),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			$author$project$UI$Avatar$withStyle(
				$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero))),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				$author$project$UI$Avatar$withStyle(
					$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$rem(4)))),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					$author$project$UI$Avatar$withStyle(
						$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(4)))),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						$author$project$UI$Avatar$withStyle(
							$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$rem(0.2)))),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$UI$Avatar$view),
						$elm$core$Maybe$withDefault(
							$rtfeldman$elm_css$Html$Styled$text(''))))))));
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $rtfeldman$elm_css$Css$Structure$AdjacentSibling = 0;
var $rtfeldman$elm_css$Css$Preprocess$NestSnippet = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Global$adjacentSiblings = $rtfeldman$elm_css$Css$Preprocess$NestSnippet(0);
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.ll);
};
var $rtfeldman$elm_css$Css$checked = $rtfeldman$elm_css$Css$pseudoClass('checked');
var $rtfeldman$elm_css$Html$Styled$Attributes$checked = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('checked');
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $rtfeldman$elm_css$Html$Styled$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $rtfeldman$elm_css$Html$Styled$Events$onCheck = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetChecked));
};
var $author$project$UI$Checkbox$setOnCheck = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$Events$onCheck, $elm$core$List$cons)),
	$elm$core$Maybe$withDefault($elm$core$Basics$identity));
var $rtfeldman$elm_css$Css$Structure$TypeSelector = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Global$typeSelector = F2(
	function (selectorStr, styles) {
		var sequence = A2($rtfeldman$elm_css$Css$Structure$TypeSelectorSequence, selectorStr, _List_Nil);
		var sel = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, sel, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$borderLeftWidth = $rtfeldman$elm_css$Css$prop1('border-left-width');
var $rtfeldman$elm_css$Css$borderTopWidth = $rtfeldman$elm_css$Css$prop1('border-top-width');
var $rtfeldman$elm_css$Css$calcExpressionToString = function (expression) {
	if (!expression) {
		return '+';
	} else {
		return '-';
	}
};
var $rtfeldman$elm_css$Css$calc = F3(
	function (firstExpr, expression, secondExpr) {
		var withoutCalcStr = function (l) {
			return A2($elm$core$String$startsWith, 'calc(', l.ll) ? A2($elm$core$String$dropLeft, 4, l.ll) : l.ll;
		};
		var calcs = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					withoutCalcStr(firstExpr),
					$rtfeldman$elm_css$Css$calcExpressionToString(expression),
					withoutCalcStr(secondExpr)
				]));
		var value = A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'calc',
			_List_fromArray(
				[calcs]));
		return {hB: 0, dK: 0, aH: 0, eK: 0, dP: 0, ch: 0, dQ: 0, dR: 0, c0: 0, c1: 0, bG: 0, ej: 0, ll: value};
	});
var $rtfeldman$elm_css$Css$angleConverter = F2(
	function (suffix, angleVal) {
		return {
			iR: 0,
			bB: 0,
			ll: _Utils_ap(
				$elm$core$String$fromFloat(angleVal),
				suffix)
		};
	});
var $rtfeldman$elm_css$Css$deg = $rtfeldman$elm_css$Css$angleConverter('deg');
var $rtfeldman$elm_css$Css$Subtraction = 1;
var $rtfeldman$elm_css$Css$minus = 1;
var $rtfeldman$elm_css$Css$pointerEvents = $rtfeldman$elm_css$Css$prop1('pointer-events');
var $rtfeldman$elm_css$Css$rotate = function (_v0) {
	var value = _v0.ll;
	return {
		q: 0,
		ll: A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'rotate',
			_List_fromArray(
				[value]))
	};
};
var $author$project$UI$Checkbox$viewToggle = A2(
	$rtfeldman$elm_css$Html$Styled$span,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$top(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$rem(0.293),
						$rtfeldman$elm_css$Css$minus,
						$rtfeldman$elm_css$Css$px(1))),
					$rtfeldman$elm_css$Css$left(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$rem(0.683),
						$rtfeldman$elm_css$Css$minus,
						$rtfeldman$elm_css$Css$px(1))),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$rem(0.75)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(1.25)),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$rem(0.25),
					$rtfeldman$elm_css$Css$solid,
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
					$rtfeldman$elm_css$Css$borderTopWidth($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$borderLeftWidth($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$rotate(
						$rtfeldman$elm_css$Css$deg(45))),
					$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
				]))
		]),
	_List_Nil);
var $author$project$UI$Checkbox$viewCheckbox = F2(
	function (config, styles) {
		var cursor_ = config.cg ? $rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed) : $author$project$Utils$CSS$changeCursor(config.cp);
		var inputAttributes = _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
				$rtfeldman$elm_css$Html$Styled$Attributes$checked(config.cZ),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(config.cg),
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, '-moz-appearance', 'none'),
						A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
						A2($rtfeldman$elm_css$Css$property, 'appearance', 'none'),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$rem(2)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(2)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$rem(0.25)),
						$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
						$rtfeldman$elm_css$Css$focus(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$borderColor(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							])),
						$rtfeldman$elm_css$Css$checked(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Global$adjacentSiblings(
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$Global$typeSelector,
										'span',
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block)
											]))
									]))
							])),
						cursor_
					]))
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
							$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
							$rtfeldman$elm_css$Css$batch(styles)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					A2($author$project$UI$Checkbox$setOnCheck, config.cp, inputAttributes),
					_List_Nil),
					$author$project$UI$Checkbox$viewToggle
				]));
	});
var $author$project$UI$Checkbox$viewLabel = function (text_) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(text_)
			]));
};
var $author$project$UI$Checkbox$viewLabeled = function (config) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$label,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$lineHeight(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
						$rtfeldman$elm_css$Css$batch(config.by)
					]))
			]),
		_List_fromArray(
			[
				A2($author$project$UI$Checkbox$viewCheckbox, config, _List_Nil),
				$author$project$UI$Checkbox$viewLabel(config.h2)
			]));
};
var $author$project$UI$Checkbox$viewUnlabeled = function (config) {
	return A2($author$project$UI$Checkbox$viewCheckbox, config, config.by);
};
var $author$project$UI$Checkbox$view = function (config) {
	if (!config.$) {
		var labeledConfig = config.a;
		return $author$project$UI$Checkbox$viewLabeled(labeledConfig);
	} else {
		var unlabeledConfig = config.a;
		return $author$project$UI$Checkbox$viewUnlabeled(unlabeledConfig);
	}
};
var $author$project$UI$Checkbox$Labeled = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Checkbox$Unlabeled = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Checkbox$withStyle = F2(
	function (style, config) {
		if (!config.$) {
			var labeledConfig = config.a;
			return $author$project$UI$Checkbox$Labeled(
				_Utils_update(
					labeledConfig,
					{
						by: A2($elm$core$List$cons, style, labeledConfig.by)
					}));
		} else {
			var unlabeledConfig = config.a;
			return $author$project$UI$Checkbox$Unlabeled(
				_Utils_update(
					unlabeledConfig,
					{
						by: A2($elm$core$List$cons, style, unlabeledConfig.by)
					}));
		}
	});
var $author$project$UI$Table$Row$viewCheckbox = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		$author$project$UI$Checkbox$withStyle(
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero))),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			$author$project$UI$Checkbox$withStyle(
				$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero))),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				$author$project$UI$Checkbox$withStyle(
					$rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(0.5)))),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					$author$project$UI$Checkbox$withStyle(
						$rtfeldman$elm_css$Css$marginLeft(
							$rtfeldman$elm_css$Css$rem(1)))),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map($author$project$UI$Checkbox$view),
					$elm$core$Maybe$withDefault(
						$rtfeldman$elm_css$Html$Styled$text('')))))));
var $author$project$UI$Table$Row$viewLabel = F3(
	function (viewType, label, labelColor) {
		var fontSize_ = function () {
			if (!viewType) {
				return 1.25;
			} else {
				return 1;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
							$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$rem(fontSize_)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor(labelColor))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $author$project$UI$Table$Row$viewSubLabel = F3(
	function (viewType, subLabel, subLabelDirection) {
		if ($elm$core$String$isEmpty(subLabel)) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var fontSize_ = function () {
				if (!viewType) {
					return 1;
				} else {
					return 0.75;
				}
			}();
			var additionalCss = function () {
				if (!subLabelDirection) {
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginLeft(
							$rtfeldman$elm_css$Css$rem(0.6)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]);
				} else {
					return _List_Nil;
				}
			}();
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
									$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$rem(fontSize_)),
									$rtfeldman$elm_css$Css$maxHeight(
									$rtfeldman$elm_css$Css$rem(4.75)),
									$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
									A2($rtfeldman$elm_css$Css$property, 'white-space', 'pre-wrap')
								]),
							additionalCss))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(subLabel)
					]));
		}
	});
var $author$project$UI$Table$Row$viewLabelAndSubLabel = F5(
	function (viewType, label, subLabel, subLabelDirection, labelColor) {
		var direction = function () {
			if (!subLabelDirection) {
				return $rtfeldman$elm_css$Css$row;
			} else {
				return $rtfeldman$elm_css$Css$column;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$flexShrink(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$paddingLeft(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection(direction),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$UI$Table$Row$viewLabel, viewType, label, labelColor),
					A3($author$project$UI$Table$Row$viewSubLabel, viewType, subLabel, subLabelDirection)
				]));
	});
var $rtfeldman$elm_css$Css$borderRight3 = $rtfeldman$elm_css$Css$prop3('border-right');
var $rtfeldman$elm_css$Css$inlineTable = {W: 0, ll: 'inline-table'};
var $author$project$UI$Table$Row$viewNumberAndId = F4(
	function (viewType, maybeNumber, id, beamColor) {
		var fontSize_ = function () {
			if (!viewType) {
				return 3;
			} else {
				return 2;
			}
		}();
		var _v0 = _Utils_Tuple2(maybeNumber, id);
		if (!_v0.a.$) {
			if (_v0.b === '') {
				var number = _v0.a.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(4.25)),
									$rtfeldman$elm_css$Css$paddingRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									A3(
									$rtfeldman$elm_css$Css$borderRight3,
									$rtfeldman$elm_css$Css$px(3),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(beamColor)),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$rem(fontSize_)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$num(1)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineTable)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(number))
						]));
			} else {
				var number = _v0.a.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(4.25)),
									$rtfeldman$elm_css$Css$paddingRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									A3(
									$rtfeldman$elm_css$Css$borderRight3,
									$rtfeldman$elm_css$Css$px(3),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(beamColor)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$num(1)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineTable)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$rem(3)),
											$rtfeldman$elm_css$Css$fontWeight(
											$rtfeldman$elm_css$Css$int(600)),
											$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(number))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$rem(0.75)),
											$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('ID: ' + id)
								]))
						]));
			}
		} else {
			if (_v0.b === '') {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$rem(3)),
									$rtfeldman$elm_css$Css$paddingRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									A3(
									$rtfeldman$elm_css$Css$borderRight3,
									$rtfeldman$elm_css$Css$px(3),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(beamColor)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$num(1)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_Nil);
			} else {
				var id_ = _v0.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(4.25)),
									$rtfeldman$elm_css$Css$paddingRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									A3(
									$rtfeldman$elm_css$Css$borderRight3,
									$rtfeldman$elm_css$Css$px(3),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(beamColor)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$num(1)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineTable)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$rem(3)),
											$rtfeldman$elm_css$Css$fontWeight(
											$rtfeldman$elm_css$Css$int(600)),
											$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(id_)
								]))
						]));
			}
		}
	});
var $author$project$UI$Table$Row$viewIcon = function (viewType) {
	var height_ = function () {
		if (!viewType) {
			return 4;
		} else {
			return 3;
		}
	}();
	return A2(
		$elm$core$Basics$composeR,
		$author$project$UI$Icon$withStyle(
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero)),
		A2(
			$elm$core$Basics$composeR,
			$author$project$UI$Icon$withStyle(
				$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero)),
			A2(
				$elm$core$Basics$composeR,
				$author$project$UI$Icon$withStyle(
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(height_))),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Icon$withStyle(
						$rtfeldman$elm_css$Css$marginLeft(
							$rtfeldman$elm_css$Css$rem(1))),
					$author$project$UI$Icon$view))));
};
var $author$project$UI$Table$Row$viewRightIcons = function (viewType) {
	return A2(
		$elm$core$List$foldl,
		A2(
			$elm$core$Basics$composeR,
			$author$project$UI$Table$Row$viewIcon(viewType),
			$elm$core$List$cons),
		_List_Nil);
};
var $author$project$UI$Table$Row$view = function (_v0) {
	var config = _v0;
	var subContent = A2(
		$elm$core$Maybe$withDefault,
		$rtfeldman$elm_css$Html$Styled$text(''),
		A2(
			$elm$core$Maybe$map,
			function (content) {
				return content;
			},
			config.gi));
	var nodeCss = $rtfeldman$elm_css$Html$Styled$Attributes$css(
		_Utils_ap(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$rem(0.5)),
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$rem(0.5)),
					A3(
					$rtfeldman$elm_css$Css$borderBottom3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
					$rtfeldman$elm_css$Css$color(
					$author$project$UI$Style$Color$toCssColor(config.fB)),
					$rtfeldman$elm_css$Css$lastChild(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$paddingBottom($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$borderBottom($rtfeldman$elm_css$Css$zero)
						])),
					$author$project$Utils$CSS$changeCursor(config.bJ),
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
				]),
			config.gh));
	var _v1 = function () {
		var _v2 = config.hN;
		if (!_v2.$) {
			return _Utils_Tuple2(
				_List_Nil,
				$rtfeldman$elm_css$Html$Styled$text(''));
		} else {
			var dragAndDropConfig = _v2.a;
			var _v3 = dragAndDropConfig.hN.hF;
			if (!_v3.$) {
				var _v4 = _v3.a;
				var draggedElement = _v4.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							$author$project$UI$DragAndDrop$MouseEvent$onMouseMove(
							A2(
								$elm$core$Basics$composeL,
								dragAndDropConfig.hL,
								$author$project$UI$DragAndDrop$DragAndDrop$Move(draggedElement)))
						]),
					dragAndDropConfig.iG(dragAndDropConfig.hN));
			} else {
				return _Utils_Tuple2(
					_List_Nil,
					dragAndDropConfig.iG(dragAndDropConfig.hN));
			}
		}
	}();
	var dndListener = _v1.a;
	var ghost = _v1.b;
	var _v5 = function () {
		var _v6 = config.hN;
		if (!_v6.$) {
			return _Utils_Tuple2(_List_Nil, _List_Nil);
		} else {
			var dragAndDropConfig = _v6.a;
			return A2($author$project$UI$Table$Row$rowAttributes, dragAndDropConfig, config.hQ);
		}
	}();
	var rowAttributes_ = _v5.a;
	var dragAndDropStyle = _v5.b;
	var attributes = _Utils_ap(
		rowAttributes_,
		A2(
			$author$project$UI$Table$Row$setOnClick,
			config.bJ,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$author$project$Utils$CSS$changeCursor(config.bJ),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(100)),
								A3(
								$rtfeldman$elm_css$Css$border3,
								$rtfeldman$elm_css$Css$px(2),
								$rtfeldman$elm_css$Css$solid,
								$rtfeldman$elm_css$Css$transparent)
							]),
						dragAndDropStyle))
				])));
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-table-row',
		_Utils_ap(
			_List_fromArray(
				[nodeCss]),
			dndListener),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				attributes,
				A2(
					$elm$core$List$cons,
					$author$project$UI$Table$Row$viewAvatar(config.iX),
					A2(
						$elm$core$List$cons,
						A4($author$project$UI$Table$Row$viewNumberAndId, config.be, config.cm, config.fw, config.gq),
						A2(
							$elm$core$List$cons,
							A5($author$project$UI$Table$Row$viewLabelAndSubLabel, config.be, config.h2, config.hh, config.hi, config.fB),
							A2(
								$elm$core$List$cons,
								$author$project$UI$Table$Row$viewCheckbox(config.gs),
								A2($author$project$UI$Table$Row$viewRightIcons, config.be, config.c9)))))),
				subContent,
				ghost
			]));
};
var $author$project$UI$Table$viewRows = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $author$project$UI$Table$Row$view, $elm$core$List$cons),
	_List_Nil);
var $author$project$UI$Table$view = function (_v0) {
	var config = _v0;
	var _v1 = config.cu;
	if (!_v1.b) {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-table',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$rem(1.2)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(config.dE)
				]));
	} else {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-table',
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$rem(1))
								]),
							config.dd))
					]),
				config.fc),
			_Utils_ap(
				$author$project$UI$Table$viewRows(config.cu),
				config.c_));
	}
};
var $author$project$UI$Icon$bicolor = function (icon) {
	return $author$project$UI$Icon$Bicolor(
		{go: $author$project$UI$Style$Theme$lightGrey, dN: $author$project$UI$Style$Theme$darkGrey, jI: icon, bJ: $author$project$UI$Icon$NoOnClick, by: _List_Nil});
};
var $author$project$UI$Avatar$icon = function (i) {
	return $author$project$UI$Avatar$Icon(
		{b7: false, jI: i, cm: 0, bJ: $elm$core$Maybe$Nothing, by: _List_Nil});
};
var $author$project$UI$Table$Row$Column = 1;
var $author$project$UI$Table$Row$Config = $elm$core$Basics$identity;
var $author$project$UI$Table$Row$NoDragAndDrop = {$: 0};
var $author$project$UI$Table$Row$row = F3(
	function (platform, label, elem) {
		return {gh: _List_Nil, gi: $elm$core$Maybe$Nothing, iX: $elm$core$Maybe$Nothing, gq: $author$project$UI$Style$Theme$grey, gs: $elm$core$Maybe$Nothing, hN: $author$project$UI$Table$Row$NoDragAndDrop, hQ: elem, fw: '', h2: label, fB: $author$project$UI$Style$Theme$darkGrey, cm: $elm$core$Maybe$Nothing, bJ: $elm$core$Maybe$Nothing, c9: _List_Nil, hh: '', hi: 1, be: platform};
	});
var $author$project$UI$Icons$userCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63 32c0 17.121-13.879 31-31 31C14.878 63 1 49.121 1 32 1 14.879 14.878 1 32 1c17.121 0 31 13.879 31 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M31.956 17.083c-1.629 0-4.388.63-4.582 4.841l-.002.042-.01.063c-.003.039-.426 4.441 1.545 6.656.735.834 1.735 1.244 3.061 1.256 1.4-.012 2.374-.41 3.123-1.255 1.806-2.034 1.597-5.9 1.545-6.565l-.011-.026-.007-.198c-.179-3.893-2.597-4.769-4.594-4.814h-.068zm-.069 15.935c-2.191-.037-3.962-.808-5.273-2.293-2.78-3.135-2.357-8.413-2.298-9.006.182-3.921 2.093-5.812 3.666-6.702 1.552-.884 3.159-1.017 3.98-1.017h.117c1.491.03 2.826.382 3.984 1.046 1.551.886 3.437 2.771 3.623 6.705.055.561.481 5.84-2.301 8.975-1.319 1.484-3.091 2.255-5.268 2.292h-.23zM32.011 50c-8.534 0-13.634-3.337-13.685-3.372-.261-.161-.473-.415-.589-.722-.397-1.002-.398-2.8-.39-3.326.008-.117.007-.148.007-.181.043-1.379.151-4.959 3.513-6.113l.122-.036c2.955-.75 5.436-2.469 5.461-2.487.266-.186.569-.283.888-.283.499 0 .971.245 1.259.654.488.692.32 1.654-.374 2.144-.761.511-3.337 2.144-6.444 2.942-1.053.378-1.3 1.481-1.355 3.252l-.006.11c-.011.533.018 1.248.087 1.759 1.426.759 5.493 2.59 11.499 2.59 6.034 0 10.075-1.824 11.492-2.582.065-.497.094-1.206.087-1.711-.005-.011-.007-.09-.007-.178-.051-1.708-.305-2.855-1.408-3.248-3.458-.887-6.271-2.845-6.389-2.928-.694-.49-.861-1.451-.375-2.143.289-.409.76-.654 1.261-.654.317 0 .623.097.882.281.026.018 2.532 1.741 5.472 2.49l.11.033c3.37 1.149 3.477 4.738 3.517 6.089l.007.196c.007.384.019 2.301-.367 3.326-.114.297-.325.555-.596.731-.551.349-5.543 3.367-13.679 3.367')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$Checkbox$checked = F2(
	function (isChecked, config) {
		if (!config.$) {
			var labeledConfig = config.a;
			return $author$project$UI$Checkbox$Labeled(
				_Utils_update(
					labeledConfig,
					{cZ: isChecked}));
		} else {
			var unlabeledConfig = config.a;
			return $author$project$UI$Checkbox$Unlabeled(
				_Utils_update(
					unlabeledConfig,
					{cZ: isChecked}));
		}
	});
var $author$project$UI$Checkbox$disabled = F2(
	function (isDisabled, config) {
		if (!config.$) {
			var labeledConfig = config.a;
			return $author$project$UI$Checkbox$Labeled(
				_Utils_update(
					labeledConfig,
					{cg: isDisabled}));
		} else {
			var unlabeledConfig = config.a;
			return $author$project$UI$Checkbox$Unlabeled(
				_Utils_update(
					unlabeledConfig,
					{cg: isDisabled}));
		}
	});
var $author$project$Utils$Bool$ifElse = F3(
	function (trueValue, falseValue, boolValue) {
		return boolValue ? trueValue : falseValue;
	});
var $author$project$UI$Checkbox$unlabeled = $author$project$UI$Checkbox$Unlabeled(
	{cZ: false, cg: false, cp: $elm$core$Maybe$Nothing, by: _List_Nil});
var $author$project$UI$Checkbox$withOnCheck = F2(
	function (onCheck, config) {
		if (!config.$) {
			var labeledConfig = config.a;
			return $author$project$UI$Checkbox$Labeled(
				_Utils_update(
					labeledConfig,
					{
						cp: $elm$core$Maybe$Just(onCheck)
					}));
		} else {
			var unlabeledConfig = config.a;
			return $author$project$UI$Checkbox$Unlabeled(
				_Utils_update(
					unlabeledConfig,
					{
						cp: $elm$core$Maybe$Just(onCheck)
					}));
		}
	});
var $author$project$Audit$ResponsibleUsersEditor$viewCheckbox = F3(
	function (config, userId, selectedIds) {
		return A2(
			$author$project$UI$Checkbox$withOnCheck,
			A2(
				$author$project$Utils$Bool$ifElse,
				config.kf(userId),
				config.kg(userId)),
			A2(
				$author$project$UI$Checkbox$checked,
				A2($author$project$User$Ids$member, userId, selectedIds),
				A2($author$project$UI$Checkbox$disabled, config.jo, $author$project$UI$Checkbox$unlabeled)));
	});
var $author$project$UI$Table$Row$withAvatar = F2(
	function (avatar, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				iX: $elm$core$Maybe$Just(avatar)
			});
	});
var $author$project$UI$Table$Row$withCheckbox = F2(
	function (checkbox, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				gs: $elm$core$Maybe$Just(checkbox)
			});
	});
var $author$project$Audit$ResponsibleUsersEditor$viewRow = F4(
	function (conf, viewType, selectedUsers, user) {
		var label = $elm$core$String$isEmpty(user.g_) ? user.iK : user.g_;
		return A2(
			$author$project$UI$Table$Row$withCheckbox,
			A3($author$project$Audit$ResponsibleUsersEditor$viewCheckbox, conf, user.dk, selectedUsers),
			A2(
				$author$project$UI$Table$Row$withAvatar,
				$author$project$UI$Avatar$icon(
					$author$project$UI$Icon$bicolor($author$project$UI$Icons$userCircleBicolor)),
				A3($author$project$UI$Table$Row$row, viewType, label, user)));
	});
var $author$project$UI$Table$withEmptyText = F2(
	function (text_, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{dE: text_});
	});
var $author$project$Audit$ResponsibleUsersEditor$viewTable = F3(
	function (conf, environment, selectedUsers) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$elm$core$Basics$composeR,
			$author$project$User$Dict$values,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$sortBy(
					function (u) {
						return $elm$core$String$toLower(
							_Utils_ap(u.g_, u.iK));
					}),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Table$fromList(
						A3(
							$author$project$Audit$ResponsibleUsersEditor$viewRow,
							conf,
							$author$project$Environments$Environment$getViewType(environment),
							selectedUsers)),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Table$withEmptyText(
							$author$project$Translations$Measures$ResponsibleUsers$emptyText(translations)),
						$author$project$UI$Table$view))));
	});
var $author$project$Audit$EditDialog$viewResponsibleUsersTable = function (disableInput_) {
	return $author$project$Audit$ResponsibleUsersEditor$viewTable(
		{jo: disableInput_, kf: $author$project$Audit$EditDialog$UserSelectedUser, kg: $author$project$Audit$EditDialog$UserUnselectedUser});
};
var $author$project$Audit$EditDialog$DeleteTab = 2;
var $author$project$UI$TabBar$Config = $elm$core$Basics$identity;
var $author$project$UI$TabBar$appendRightIcon = F2(
	function (icon, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				c9: A2($elm$core$List$cons, icon, config.c9)
			});
	});
var $author$project$UI$Icons$delete = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M24 9.172c2.081.002 3.767 1.686 3.769 3.766h1.672C29.441 9.932 27.003 7.5 24 7.5c-3.004 0-5.441 2.432-5.441 5.438h1.671c.003-2.08 1.689-3.764 3.77-3.766m11.829 11.456h-3.452v17.717H15.626V20.628h-3.455v-4.469h23.658v4.469zM10.5 14.488V22.3h3.454v17.716h20.092V22.3H37.5v-7.812h-27zm19.603 9.026h-1.672v12.045h1.672V23.514zm-5.267-.002h-1.671v12.046h1.671V23.512zm-5.267.002h-1.672v12.045h1.672V23.514z')
						]),
					_List_Nil)
				]));
	});
var $author$project$Audit$EditDialog$UserClickedTabIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Icon$OnClick = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Icon$withOnClick = F2(
	function (msg, config) {
		if (!config.$) {
			var options = config.a;
			return $author$project$UI$Icon$Unicolor(
				_Utils_update(
					options,
					{
						bJ: $author$project$UI$Icon$OnClick(msg)
					}));
		} else {
			var options = config.a;
			return $author$project$UI$Icon$Bicolor(
				_Utils_update(
					options,
					{
						bJ: $author$project$UI$Icon$OnClick(msg)
					}));
		}
	});
var $author$project$Audit$EditDialog$viewTabBarIcon = F3(
	function (icon, tab, currentTab) {
		return _Utils_eq(tab, currentTab) ? A2(
			$author$project$UI$Icon$withForegroundColor,
			$author$project$UI$Style$Theme$darkGrey,
			$author$project$UI$Icon$unicolor(icon)) : A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$Audit$EditDialog$UserClickedTabIcon(tab),
			A2(
				$author$project$UI$Icon$withForegroundColor,
				$author$project$UI$Style$Theme$grey,
				$author$project$UI$Icon$unicolor(icon)));
	});
var $author$project$Audit$EditDialog$appendDeleteIcon = F5(
	function (environment, repository, auditId, currentTab, tabBarConfig) {
		return A4($author$project$Audit$EditDialog$checkAuditRight, environment, repository, auditId, 9) ? A2(
			$author$project$UI$TabBar$appendRightIcon,
			A3($author$project$Audit$EditDialog$viewTabBarIcon, $author$project$UI$Icons$delete, 2, currentTab),
			tabBarConfig) : tabBarConfig;
	});
var $author$project$UI$TabBar$tabBar = function (title) {
	return {iX: $elm$core$Maybe$Nothing, fw: '', cm: $elm$core$Maybe$Nothing, c9: _List_Nil, hj: '', k8: title};
};
var $author$project$UI$Icons$tag = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M38.413 9.586c-.962-.965-2.29-1.523-3.738-1.574-1.375-.054-2.783.332-4.057 1.114a1.195 1.195 0 00.618 2.215c.22 0 .435-.06.622-.175 1.735-1.063 3.734-1.016 4.862.113.666.663.969 1.627.858 2.709-.121 1.175-.696 2.33-1.63 3.26-.93.93-2.09 1.507-3.26 1.627-1.082.107-2.045-.2-2.708-.857a2.257 2.257 0 00-1.607-.664c-.612 0-1.183.24-1.614.664-.43.427-.67 1.01-.667 1.615 0 .61.24 1.181.673 1.613a2.257 2.257 0 001.608.665 2.293 2.293 0 001.866-.965 5.962 5.962 0 002.027.347c.219 0 .444-.013.668-.033.02 0 .04-.008.063-.008l.204 2.983a2.375 2.375 0 01-.684 1.826l-11.14 11.126c-.623.62-1.645.62-2.269 0l-8.297-8.297a1.598 1.598 0 01-.47-1.134c0-.431.165-.831.47-1.135l11.134-11.132a2.345 2.345 0 011.818-.684l9.886.657a1.2 1.2 0 001.28-1.2c0-.625-.493-1.15-1.118-1.19l-9.889-.656a4.728 4.728 0 00-3.665 1.38L9.125 24.926a3.972 3.972 0 00-1.169 2.83c0 1.07.419 2.069 1.17 2.828l8.289 8.29a4.031 4.031 0 005.656 0l11.131-11.131a4.747 4.747 0 001.382-3.68l-.238-3.494a8.414 8.414 0 002.303-1.635c1.316-1.315 2.139-2.987 2.313-4.709.178-1.81-.373-3.457-1.55-4.64l.001.001z')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$TabBar$viewAvatar = function (maybeAvatar) {
	if (!maybeAvatar.$) {
		var avatar = maybeAvatar.a;
		return $author$project$UI$Avatar$view(
			A2(
				$author$project$UI$Avatar$withStyle,
				$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
				A2(
					$author$project$UI$Avatar$withStyle,
					$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
					avatar)));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$UI$TabBar$viewNumberAndId = F2(
	function (maybeNumber, id) {
		var _v0 = _Utils_Tuple2(maybeNumber, id);
		if (!_v0.a.$) {
			if (_v0.b === '') {
				var number = _v0.a.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$paddingRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									A3(
									$rtfeldman$elm_css$Css$borderRight3,
									$rtfeldman$elm_css$Css$px(2),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$rem(3)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$num(1)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(number))
						]));
			} else {
				var number = _v0.a.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(4.25)),
									$rtfeldman$elm_css$Css$paddingRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									A3(
									$rtfeldman$elm_css$Css$borderRight3,
									$rtfeldman$elm_css$Css$px(2),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$num(1)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$rem(3)),
											$rtfeldman$elm_css$Css$fontWeight(
											$rtfeldman$elm_css$Css$int(600)),
											$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(number))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$rem(0.75)),
											$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('ID: ' + id)
								]))
						]));
			}
		} else {
			if (_v0.b === '') {
				var _v1 = _v0.a;
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				var _v2 = _v0.a;
				var id_ = _v0.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$paddingRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									A3(
									$rtfeldman$elm_css$Css$borderRight3,
									$rtfeldman$elm_css$Css$px(2),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$rem(3)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$num(1)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(id_)
						]));
			}
		}
	});
var $author$project$UI$TabBar$viewIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$Icon$withStyle(
		$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$rem(3))),
	A2(
		$elm$core$Basics$composeR,
		$author$project$UI$Icon$withStyle(
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero)),
		A2(
			$elm$core$Basics$composeR,
			$author$project$UI$Icon$withStyle(
				$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero)),
			$author$project$UI$Icon$view)));
var $author$project$UI$TabBar$viewRightIcons = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $author$project$UI$TabBar$viewIcon, $elm$core$List$cons),
	_List_Nil);
var $author$project$UI$TabBar$viewSubTitle = function (subTitle) {
	if (subTitle === '') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
							$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(subTitle)
				]));
	}
};
var $author$project$UI$TabBar$viewTitle = function (title) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
						$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
						$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$em(1.2)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(title)
			]));
};
var $author$project$UI$TabBar$viewTitleAndSubTitle = F2(
	function (title, subTitle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$flexShrink(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$paddingLeft(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$TabBar$viewTitle(title),
					$author$project$UI$TabBar$viewSubTitle(subTitle)
				]));
	});
var $author$project$UI$TabBar$view = function (_v0) {
	var config = _v0;
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-tab-bar',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1))
					]))
			]),
		A2(
			$elm$core$List$cons,
			$author$project$UI$TabBar$viewAvatar(config.iX),
			A2(
				$elm$core$List$cons,
				A2($author$project$UI$TabBar$viewNumberAndId, config.cm, config.fw),
				A2(
					$elm$core$List$cons,
					A2($author$project$UI$TabBar$viewTitleAndSubTitle, config.k8, config.hj),
					$author$project$UI$TabBar$viewRightIcons(config.c9)))));
};
var $author$project$UI$TabBar$withId = F2(
	function (id, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{fw: id});
	});
var $author$project$UI$TabBar$withSubTitle = F2(
	function (subTitle, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{hj: subTitle});
	});
var $author$project$Audit$EditDialog$viewTabBar = F4(
	function (environment, repository, audit, currentTab) {
		return $author$project$UI$TabBar$view(
			A5(
				$author$project$Audit$EditDialog$appendDeleteIcon,
				environment,
				repository,
				audit.gm,
				currentTab,
				A2(
					$author$project$UI$TabBar$appendRightIcon,
					A3($author$project$Audit$EditDialog$viewTabBarIcon, $author$project$UI$Icons$user, 1, currentTab),
					A2(
						$author$project$UI$TabBar$appendRightIcon,
						A3($author$project$Audit$EditDialog$viewTabBarIcon, $author$project$UI$Icons$tag, 0, currentTab),
						A2(
							$author$project$UI$TabBar$withId,
							audit.fw,
							A2(
								$author$project$UI$TabBar$withSubTitle,
								audit.aY,
								$author$project$UI$TabBar$tabBar(audit.k8)))))));
	});
var $author$project$UI$Dialog$withIcon = F2(
	function (icon, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				jI: $elm$core$Maybe$Just(icon)
			});
	});
var $author$project$Audit$EditDialog$viewAuditorsTab = F4(
	function (environment, repository, model, availableUsers) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$pct(50))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A2($author$project$Audit$EditDialog$viewFooter, translations, model.aq),
					A2(
						$author$project$UI$Dialog$appendContent,
						A4(
							$author$project$Audit$EditDialog$viewResponsibleUsersTable,
							A4($author$project$Audit$EditDialog$disableInput, environment, repository, model.es.gm, model.aq),
							environment,
							model.bb,
							availableUsers),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Audit$ResponsibleUsersEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A4($author$project$Audit$EditDialog$viewTabBar, environment, repository, model.es, 1),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Audits$EditDialog$header(translations),
										$author$project$Audit$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Audit$EditDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Translations$Misc$BasicData$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'misc.basicData.header');
};
var $author$project$UI$BasicDataEditor$viewBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$tag),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Misc$BasicData$header(translations))));
};
var $author$project$Audit$EditDialog$EnteredHour = function (a) {
	return {$: 8, a: a};
};
var $author$project$Audit$EditDialog$EnteredMinute = function (a) {
	return {$: 9, a: a};
};
var $author$project$Audit$EditDialog$UserChangedEndDateInput = function (a) {
	return {$: 6, a: a};
};
var $author$project$Audit$EditDialog$UserEnteredDateText = function (a) {
	return {$: 7, a: a};
};
var $author$project$UI$DateInput$Config = $elm$core$Basics$identity;
var $author$project$UI$DateInput$dateInput = F3(
	function (defaultYear, defaultMonth, onChange) {
		return {gz: defaultMonth, gA: defaultYear, jo: false, fw: 'date-input', c6: onChange, eO: $elm$core$Maybe$Nothing, eP: $elm$core$Maybe$Nothing, by: _List_Nil, gb: false};
	});
var $author$project$Translations$Plans$Schedule$deadlineTimeFirstLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.deadlineTimeFirstLabel');
};
var $author$project$UI$DateInput$disabled = F2(
	function (disabled_, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{jo: disabled_});
	});
var $rtfeldman$elm_css$Css$stretch = $rtfeldman$elm_css$Css$prop1('stretch');
var $author$project$UI$TimeInput$Config = $elm$core$Basics$identity;
var $author$project$UI$TimeInput$timeInput = F2(
	function (hourMsg, minuteMsg) {
		return {hZ: hourMsg, h8: minuteMsg, eO: $elm$core$Maybe$Nothing};
	});
var $rtfeldman$elm_css$Html$Styled$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$UI$DateInput$onEnterHelper = function (msg) {
	var isEnterKey = function (keyCode) {
		return (keyCode === 13) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('');
	};
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$andThen, isEnterKey, $rtfeldman$elm_css$Html$Styled$Events$keyCode));
};
var $author$project$UI$DateInput$setOnEnter = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2($elm$core$Basics$composeR, $author$project$UI$DateInput$onEnterHelper, $elm$core$List$cons)),
	$elm$core$Maybe$withDefault($elm$core$Basics$identity));
var $rtfeldman$elm_css$Html$Styled$Attributes$tabindex = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$UI$DatePicker$init = F2(
	function (displayYear, displayMonth) {
		return {ar: displayMonth, aG: displayYear, ll: $elm$core$Maybe$Nothing};
	});
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.ll, argB.ll, argC.ll, argD.ll])));
	});
var $rtfeldman$elm_css$Css$borderRadius4 = $rtfeldman$elm_css$Css$prop4('border-radius');
var $author$project$UI$TextInput$MultiLine = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$TextInput$Password = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$TextInput$SingleLine = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$TextInput$mapConfig = F2(
	function (fn, config) {
		switch (config.$) {
			case 0:
				var internalConfig = config.a;
				return A3($elm$core$Basics$composeR, fn, $author$project$UI$TextInput$SingleLine, internalConfig);
			case 1:
				var internalConfig = config.a;
				return A3($elm$core$Basics$composeR, fn, $author$project$UI$TextInput$MultiLine, internalConfig);
			default:
				var internalConfig = config.a;
				return A3($elm$core$Basics$composeR, fn, $author$project$UI$TextInput$Password, internalConfig);
		}
	});
var $author$project$UI$TextInput$disabled = function (disabled_) {
	return $author$project$UI$TextInput$mapConfig(
		function (c) {
			return _Utils_update(
				c,
				{jo: disabled_});
		});
};
var $author$project$Date_Time$NaiveDate$format = function (_v0) {
	var y = _v0.a;
	var m = _v0.b;
	var d = _v0.c;
	var yyyy = $elm$core$String$fromInt(y);
	var mm = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$author$project$Date_Time$Month$toInt(m)));
	var dd = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(d));
	return dd + ('.' + (mm + ('.' + yyyy)));
};
var $author$project$Translations$DateInput$placeHolder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'dateInput.placeHolder');
};
var $author$project$UI$TextInput$singleLine = $author$project$UI$TextInput$SingleLine(
	{dx: $elm$core$Maybe$Nothing, jo: false, fw: '', eO: $elm$core$Maybe$Nothing, d1: $elm$core$Maybe$Nothing, cr: '', dd: _List_Nil, ll: ''});
var $rtfeldman$elm_css$Html$Styled$Attributes$autocomplete = function (bool) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$placeholder = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('placeholder');
var $rtfeldman$elm_css$Css$resize = $rtfeldman$elm_css$Css$prop1('resize');
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $author$project$UI$TextInput$setId = function (id) {
	if (id === '') {
		return $elm$core$Basics$identity;
	} else {
		return $elm$core$List$cons(
			$rtfeldman$elm_css$Html$Styled$Attributes$id(id));
	}
};
var $author$project$UI$TextInput$onEnterHelper = function (msg) {
	var isEnterKey = function (keyCode) {
		return (keyCode === 13) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('');
	};
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$andThen, isEnterKey, $rtfeldman$elm_css$Html$Styled$Events$keyCode));
};
var $author$project$UI$TextInput$setOnEnter = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2($elm$core$Basics$composeR, $author$project$UI$TextInput$onEnterHelper, $elm$core$List$cons)),
	$elm$core$Maybe$withDefault($elm$core$Basics$identity));
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $author$project$UI$TextInput$setOnInput = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$Events$onInput, $elm$core$List$cons)),
	$elm$core$Maybe$withDefault($elm$core$Basics$identity));
var $rtfeldman$elm_css$Css$text_ = {c: 0, ll: 'text'};
var $rtfeldman$elm_css$Html$Styled$textarea = $rtfeldman$elm_css$Html$Styled$node('textarea');
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $rtfeldman$elm_css$Css$vertical = {f$: 0, ll: 'vertical'};
var $author$project$UI$TextInput$viewMultiLine = function (internalConfig) {
	var _v0 = internalConfig.jo ? _Utils_Tuple2(
		$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.5)),
		$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed)) : _Utils_Tuple2(
		$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(1)),
		$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$text_));
	var disabledOpacity = _v0.a;
	var disabledCursor = _v0.b;
	var attributes = _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
			$rtfeldman$elm_css$Html$Styled$Attributes$value(internalConfig.ll),
			$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(internalConfig.cr),
			$rtfeldman$elm_css$Html$Styled$Attributes$disabled(internalConfig.jo),
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, '-moz-appearance', 'none'),
						A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
						A2($rtfeldman$elm_css$Css$property, 'appearance', 'none'),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(3)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(9)),
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$resize($rtfeldman$elm_css$Css$none),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
						$rtfeldman$elm_css$Css$focus(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$borderColor(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							])),
						disabledOpacity,
						disabledCursor,
						$rtfeldman$elm_css$Css$resize($rtfeldman$elm_css$Css$vertical)
					]),
				internalConfig.dd))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$textarea,
		A2(
			$author$project$UI$TextInput$setOnEnter,
			internalConfig.eO,
			A2(
				$author$project$UI$TextInput$setOnInput,
				internalConfig.d1,
				A2($author$project$UI$TextInput$setId, internalConfig.fw, attributes))),
		_List_Nil);
};
var $author$project$UI$TextInput$viewPassword = function (internalConfig) {
	var attributes = _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$type_('password'),
			$rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
			$rtfeldman$elm_css$Html$Styled$Attributes$value(internalConfig.ll),
			$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(internalConfig.cr),
			$rtfeldman$elm_css$Html$Styled$Attributes$disabled(internalConfig.jo),
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, '-moz-appearance', 'none'),
						A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
						A2($rtfeldman$elm_css$Css$property, 'appearance', 'none'),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
						$rtfeldman$elm_css$Css$focus(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$borderColor(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				internalConfig.dd))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$input,
		A2(
			$author$project$UI$TextInput$setOnEnter,
			internalConfig.eO,
			A2(
				$author$project$UI$TextInput$setOnInput,
				internalConfig.d1,
				A2($author$project$UI$TextInput$setId, internalConfig.fw, attributes))),
		_List_Nil);
};
var $rtfeldman$elm_css$Html$Styled$datalist = $rtfeldman$elm_css$Html$Styled$node('datalist');
var $rtfeldman$elm_css$Html$Styled$Attributes$list = $rtfeldman$elm_css$VirtualDom$Styled$attribute('list');
var $rtfeldman$elm_css$Html$Styled$option = $rtfeldman$elm_css$Html$Styled$node('option');
var $author$project$UI$TextInput$viewSingleLine = function (internalConfig) {
	var _v0 = internalConfig.jo ? _Utils_Tuple2(
		$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.5)),
		$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed)) : _Utils_Tuple2(
		$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(1)),
		$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$text_));
	var disabledOpacity = _v0.a;
	var disabledCursor = _v0.b;
	var _v1 = function () {
		var _v2 = internalConfig.dx;
		if (!_v2.$) {
			var datalist_ = _v2.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$datalist,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id(datalist_.g_)
							]),
						A2(
							$elm$core$List$map,
							function (elem) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$option,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(elem)
										]),
									_List_Nil);
							},
							datalist_.fR))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$list(datalist_.g_)
					]));
		} else {
			return _Utils_Tuple2(_List_Nil, _List_Nil);
		}
	}();
	var additionalHtml = _v1.a;
	var additionalAttribute = _v1.b;
	var attributes = _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
				$rtfeldman$elm_css$Html$Styled$Attributes$autocomplete(false),
				$rtfeldman$elm_css$Html$Styled$Attributes$value(internalConfig.ll),
				$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(internalConfig.cr),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(internalConfig.jo),
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, '-moz-appearance', 'none'),
							A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
							A2($rtfeldman$elm_css$Css$property, 'appearance', 'none'),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$rem(0.5)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$rem(0.5)),
							$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
							$rtfeldman$elm_css$Css$focus(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$borderColor(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
								])),
							disabledOpacity,
							disabledCursor
						]),
					internalConfig.dd))
			]),
		additionalAttribute);
	return A2(
		$rtfeldman$elm_css$Html$Styled$input,
		A2(
			$author$project$UI$TextInput$setOnEnter,
			internalConfig.eO,
			A2(
				$author$project$UI$TextInput$setOnInput,
				internalConfig.d1,
				A2($author$project$UI$TextInput$setId, internalConfig.fw, attributes))),
		additionalHtml);
};
var $author$project$UI$TextInput$view = function (config) {
	switch (config.$) {
		case 0:
			var model = config.a;
			return $author$project$UI$TextInput$viewSingleLine(model);
		case 1:
			var model = config.a;
			return $author$project$UI$TextInput$viewMultiLine(model);
		default:
			var model = config.a;
			return $author$project$UI$TextInput$viewPassword(model);
	}
};
var $author$project$UI$TextInput$withId = function (id_) {
	return $author$project$UI$TextInput$mapConfig(
		function (c) {
			return _Utils_update(
				c,
				{fw: id_});
		});
};
var $author$project$UI$TextInput$withOnInput = function (onInput) {
	return $author$project$UI$TextInput$mapConfig(
		function (c) {
			return _Utils_update(
				c,
				{
					d1: $elm$core$Maybe$Just(onInput)
				});
		});
};
var $author$project$UI$TextInput$withPlaceholder = function (placeholder) {
	return $author$project$UI$TextInput$mapConfig(
		function (c) {
			return _Utils_update(
				c,
				{cr: placeholder});
		});
};
var $author$project$UI$TextInput$withStyle = function (style) {
	return $author$project$UI$TextInput$mapConfig(
		function (c) {
			return _Utils_update(
				c,
				{
					dd: A2(
						$elm$core$List$append,
						c.dd,
						_List_fromArray(
							[style]))
				});
		});
};
var $author$project$UI$TextInput$withValue = function (value) {
	return $author$project$UI$TextInput$mapConfig(
		function (c) {
			return _Utils_update(
				c,
				{ll: value});
		});
};
var $author$project$UI$DateInput$viewButtonTextInput = F5(
	function (translations, config, borderBottomLeftRadius, date, textInput) {
		var text_ = function () {
			if (textInput.$ === 1) {
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$Date_Time$NaiveDate$format, date));
			} else {
				var value = textInput.a;
				return value;
			}
		}();
		var addOnTextInput = function (textInputElement) {
			var _v0 = config.eP;
			if (!_v0.$) {
				var msg = _v0.a;
				return A2($author$project$UI$TextInput$withOnInput, msg, textInputElement);
			} else {
				return textInputElement;
			}
		};
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withStyle,
				A4(
					$rtfeldman$elm_css$Css$borderRadius4,
					$rtfeldman$elm_css$Css$rem(0.5),
					$rtfeldman$elm_css$Css$rem(0),
					$rtfeldman$elm_css$Css$rem(0),
					$rtfeldman$elm_css$Css$rem(borderBottomLeftRadius)),
				A2(
					$author$project$UI$TextInput$withStyle,
					$rtfeldman$elm_css$Css$borderColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
					A2(
						$author$project$UI$TextInput$withStyle,
						$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
						addOnTextInput(
							A2(
								$author$project$UI$TextInput$withPlaceholder,
								$author$project$Translations$DateInput$placeHolder(translations),
								A2(
									$author$project$UI$TextInput$disabled,
									config.jo,
									A2(
										$author$project$UI$TextInput$withId,
										config.fw,
										A2($author$project$UI$TextInput$withValue, text_, $author$project$UI$TextInput$singleLine)))))))));
	});
var $author$project$UI$Icons$arrowDown = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0l24 48L48 0H0z')
						]),
					_List_Nil)
				]));
	});
var $rtfeldman$elm_css$Css$borderBottomRightRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-right-radius');
var $rtfeldman$elm_css$Css$borderLeft = $rtfeldman$elm_css$Css$prop1('border-left');
var $rtfeldman$elm_css$Css$borderTopRightRadius = $rtfeldman$elm_css$Css$prop1('border-top-right-radius');
var $author$project$UI$DateInput$viewButtonToggle = F3(
	function (msg, disabled_, borderBottomRightRadius_) {
		var _v0 = disabled_ ? _Utils_Tuple2(
			$rtfeldman$elm_css$Css$opacity(
				$rtfeldman$elm_css$Css$num(0.5)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed)) : _Utils_Tuple2(
			$rtfeldman$elm_css$Css$opacity(
				$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer));
		var disabledOpacity = _v0.a;
		var disabledCursor = _v0.b;
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-data-toggle-button',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(2.6)),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$borderTopRightRadius(
							$rtfeldman$elm_css$Css$rem(0.5)),
							$rtfeldman$elm_css$Css$borderBottomRightRadius(
							$rtfeldman$elm_css$Css$rem(borderBottomRightRadius_)),
							$rtfeldman$elm_css$Css$borderLeft(
							$rtfeldman$elm_css$Css$px(0)),
							disabledOpacity,
							disabledCursor
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						disabledCursor,
						A2(
							$author$project$UI$Icon$withStyle,
							$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$rem(3)),
							A2(
								$author$project$UI$Icon$withStyle,
								$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$rem(0.75)),
								A2(
									$author$project$UI$Icon$withForegroundColor,
									$author$project$UI$Style$Theme$darkGrey,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$arrowDown))))))
				]));
	});
var $author$project$UI$DateInput$viewCollapsedButton = F4(
	function (translations, config, date, textInput) {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-date-input-button',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A5($author$project$UI$DateInput$viewButtonTextInput, translations, config, 0.5, date, textInput),
					A3(
					$author$project$UI$DateInput$viewButtonToggle,
					A3(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$UI$DatePicker$initialDate),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(
								A2($author$project$UI$DatePicker$init, config.gA, config.gz)),
							A2($elm$core$Basics$composeR, $author$project$UI$DateInput$Expanded, config.c6)),
						date),
					config.jo,
					0.5)
				]));
	});
var $author$project$UI$DateInput$viewCollapsed = F4(
	function (translations, date, textInput, config) {
		var attributes = A2(
			$author$project$UI$DateInput$setOnEnter,
			config.eO,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
							$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$batch(config.by)
						]))
				]));
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-date-input',
			attributes,
			_List_fromArray(
				[
					A4($author$project$UI$DateInput$viewCollapsedButton, translations, config, date, textInput)
				]));
	});
var $rtfeldman$elm_css$Css$borderTop = $rtfeldman$elm_css$Css$prop1('border-top');
var $author$project$UI$DatePicker$Config = $elm$core$Basics$identity;
var $author$project$UI$DatePicker$datePicker = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$padding3 = $rtfeldman$elm_css$Css$prop3('padding');
var $ChristophP$elm_i18next$I18Next$Curly = {$: 0};
var $ChristophP$elm_i18next$I18Next$delimsToTuple = function (delims) {
	switch (delims.$) {
		case 0:
			return _Utils_Tuple2('{{', '}}');
		case 1:
			return _Utils_Tuple2('__', '__');
		default:
			var tuple = delims.a;
			return tuple;
	}
};
var $ChristophP$elm_i18next$I18Next$replacePlaceholders = F3(
	function (replacements, delims, str) {
		var _v0 = $ChristophP$elm_i18next$I18Next$delimsToTuple(delims);
		var start = _v0.a;
		var end = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, acc) {
					var key = _v1.a;
					var value = _v1.b;
					return A3(
						$elm$core$String$replace,
						_Utils_ap(
							start,
							_Utils_ap(key, end)),
						value,
						acc);
				}),
			str,
			replacements);
	});
var $ChristophP$elm_i18next$I18Next$tr = F4(
	function (_v0, delims, key, replacements) {
		var translations = _v0;
		var _v1 = A2($elm$core$Dict$get, key, translations);
		if (!_v1.$) {
			var str = _v1.a;
			return A3($ChristophP$elm_i18next$I18Next$replacePlaceholders, replacements, delims, str);
		} else {
			return key;
		}
	});
var $author$project$Translations$DatePicker$monthAndYear = F3(
	function (translations, month, year) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'datePicker.monthAndYear',
			_List_fromArray(
				[
					_Utils_Tuple2('month', month),
					_Utils_Tuple2('year', year)
				]));
	});
var $author$project$Translations$Months$april = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.April');
};
var $author$project$Translations$Months$august = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.August');
};
var $author$project$Translations$Months$december = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.December');
};
var $author$project$Translations$Months$february = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.February');
};
var $author$project$Translations$Months$january = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.January');
};
var $author$project$Translations$Months$july = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.July');
};
var $author$project$Translations$Months$june = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.June');
};
var $author$project$Translations$Months$march = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.March');
};
var $author$project$Translations$Months$may = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.May');
};
var $author$project$Translations$Months$november = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.November');
};
var $author$project$Translations$Months$october = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.October');
};
var $author$project$Translations$Months$september = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'months.September');
};
var $author$project$Date_Time$Month$translate = F2(
	function (translations, month) {
		switch (month) {
			case 0:
				return $author$project$Translations$Months$january(translations);
			case 1:
				return $author$project$Translations$Months$february(translations);
			case 2:
				return $author$project$Translations$Months$march(translations);
			case 3:
				return $author$project$Translations$Months$april(translations);
			case 4:
				return $author$project$Translations$Months$may(translations);
			case 5:
				return $author$project$Translations$Months$june(translations);
			case 6:
				return $author$project$Translations$Months$july(translations);
			case 7:
				return $author$project$Translations$Months$august(translations);
			case 8:
				return $author$project$Translations$Months$september(translations);
			case 9:
				return $author$project$Translations$Months$october(translations);
			case 10:
				return $author$project$Translations$Months$november(translations);
			default:
				return $author$project$Translations$Months$december(translations);
		}
	});
var $author$project$UI$Icons$arrowRight = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 48l48-24L0 0v48z')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$DatePicker$incrementMonth = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_update(
			model,
			{ar: 0, aG: model.aG + 1}),
		A2(
			$elm$core$Maybe$map,
			function (nextMonth) {
				return _Utils_update(
					model,
					{ar: nextMonth});
			},
			$author$project$Date_Time$Month$fromInt(
				1 + $author$project$Date_Time$Month$toInt(model.ar))));
};
var $author$project$UI$DatePicker$viewNextMonth = F2(
	function (model, _v0) {
		var onChangedState = _v0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$rem(2.5)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(2.5)),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$rem(2.5)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A3(
						$elm$core$Basics$composeR,
						$author$project$UI$DatePicker$incrementMonth,
						A2($elm$core$Basics$composeR, $elm$core$Basics$identity, onChangedState),
						model))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(1.25)),
						A2(
							$author$project$UI$Icon$withForegroundColor,
							$author$project$UI$Style$Theme$darkGrey,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$arrowRight))))
				]));
	});
var $author$project$UI$Icons$arrowLeft = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M48 0L0 24l48 24V0z')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$DatePicker$decrementMonth = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_update(
			model,
			{ar: 11, aG: model.aG - 1}),
		A2(
			$elm$core$Maybe$map,
			function (nextMonth) {
				return _Utils_update(
					model,
					{ar: nextMonth});
			},
			$author$project$Date_Time$Month$fromInt(
				(-1) + $author$project$Date_Time$Month$toInt(model.ar))));
};
var $author$project$UI$DatePicker$viewPreviousMonth = F2(
	function (model, _v0) {
		var onChangedState = _v0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$rem(2.5)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(2.5)),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$rem(2.5)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A3(
						$elm$core$Basics$composeR,
						$author$project$UI$DatePicker$decrementMonth,
						A2($elm$core$Basics$composeR, $elm$core$Basics$identity, onChangedState),
						model))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(1.25)),
						A2(
							$author$project$UI$Icon$withForegroundColor,
							$author$project$UI$Style$Theme$darkGrey,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$arrowLeft))))
				]));
	});
var $author$project$UI$DatePicker$viewMonthAndYear = F3(
	function (translations, model, config) {
		var year = $elm$core$String$fromInt(model.aG);
		var month = A2($author$project$Date_Time$Month$translate, translations, model.ar);
		var text_ = A3($author$project$Translations$DatePicker$monthAndYear, translations, month, year);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$DatePicker$viewPreviousMonth, model, config),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(text_)
						])),
					A2($author$project$UI$DatePicker$viewNextMonth, model, config)
				]));
	});
var $author$project$UI$DatePicker$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $author$project$UI$DatePicker$numberOfDaysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 1:
				return $author$project$UI$DatePicker$isLeapYear(y) ? 29 : 28;
			case 3:
				return 30;
			case 5:
				return 30;
			case 8:
				return 30;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $author$project$UI$DatePicker$asValueIn = F2(
	function (model, date) {
		return _Utils_update(
			model,
			{ll: date});
	});
var $author$project$Date_Time$NaiveDate$day = function (_v0) {
	var d = _v0.c;
	return d;
};
var $author$project$UI$DatePicker$isDayPicked = F2(
	function (model, day) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (date) {
					return _Utils_eq(
						model.aG,
						$author$project$Date_Time$NaiveDate$year(date)) && (_Utils_eq(
						model.ar,
						$author$project$Date_Time$NaiveDate$month(date)) && _Utils_eq(
						day,
						$author$project$Date_Time$NaiveDate$day(date)));
				},
				model.ll));
	});
var $author$project$UI$DatePicker$pickedDayStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$lineHeight(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$rem(2.75),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(2))),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$rem(0.25)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(600)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
		]));
var $author$project$UI$DatePicker$viewDay = F3(
	function (model, _v0, day) {
		var onChangedState = _v0;
		return A2($author$project$UI$DatePicker$isDayPicked, model, day) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$UI$DatePicker$pickedDayStyle]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$fromInt(day))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A3(
						$elm$core$Basics$composeR,
						$elm$core$Result$toMaybe,
						A2(
							$elm$core$Basics$composeR,
							$author$project$UI$DatePicker$asValueIn(model),
							A2($elm$core$Basics$composeR, $elm$core$Basics$identity, onChangedState)),
						A3($author$project$Date_Time$NaiveDate$ymd, model.aG, model.ar, day)))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$fromInt(day))
				]));
	});
var $author$project$UI$DatePicker$numberOfBlankDaysInMonth = F2(
	function (year, month) {
		var _v0 = function () {
			switch (month) {
				case 0:
					return _Utils_Tuple2(year - 1, 0);
				case 1:
					return _Utils_Tuple2(year - 1, 3);
				case 2:
					return _Utils_Tuple2(year, 2);
				case 3:
					return _Utils_Tuple2(year, 5);
				case 4:
					return _Utils_Tuple2(year, 0);
				case 5:
					return _Utils_Tuple2(year, 3);
				case 6:
					return _Utils_Tuple2(year, 5);
				case 7:
					return _Utils_Tuple2(year, 1);
				case 8:
					return _Utils_Tuple2(year, 4);
				case 9:
					return _Utils_Tuple2(year, 6);
				case 10:
					return _Utils_Tuple2(year, 2);
				default:
					return _Utils_Tuple2(year, 4);
			}
		}();
		var y = _v0.a;
		var t = _v0.b;
		return A2($elm$core$Basics$modBy, 7, (((y + ((y / 4) | 0)) - ((y / 100) | 0)) + ((y / 400) | 0)) + t);
	});
var $author$project$UI$DatePicker$viewFirstDay = F2(
	function (model, _v0) {
		var onChangedState = _v0;
		var numberOfBlankDays = A2($author$project$UI$DatePicker$numberOfBlankDaysInMonth, model.aG, model.ar);
		var gridColumn = $elm$core$String$fromInt(numberOfBlankDays + 1);
		return A2($author$project$UI$DatePicker$isDayPicked, model, 1) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'grid-column', gridColumn + ('/' + gridColumn)),
							$author$project$UI$DatePicker$pickedDayStyle
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('1')
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'grid-column', gridColumn + ('/' + gridColumn)),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					A3(
						$elm$core$Basics$composeR,
						$elm$core$Result$toMaybe,
						A2(
							$elm$core$Basics$composeR,
							$author$project$UI$DatePicker$asValueIn(model),
							A2($elm$core$Basics$composeR, $elm$core$Basics$identity, onChangedState)),
						A3($author$project$Date_Time$NaiveDate$ymd, model.aG, model.ar, 1)))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('1')
				]));
	});
var $author$project$UI$DatePicker$viewDays = F2(
	function (model, config) {
		var numberOfDays = A2($author$project$UI$DatePicker$numberOfDaysInMonth, model.aG, model.ar);
		return A2(
			$elm$core$List$cons,
			A2($author$project$UI$DatePicker$viewFirstDay, model, config),
			A2(
				$elm$core$List$map,
				A2($author$project$UI$DatePicker$viewDay, model, config),
				A2($elm$core$List$range, 2, numberOfDays)));
	});
var $author$project$Translations$Weekdays$fr = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.fr');
};
var $author$project$Translations$Weekdays$mo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.mo');
};
var $author$project$Translations$Weekdays$sa = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.sa');
};
var $author$project$Translations$Weekdays$su = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.su');
};
var $author$project$Translations$Weekdays$th = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.th');
};
var $author$project$Translations$Weekdays$tu = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.tu');
};
var $author$project$Translations$Weekdays$we = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.we');
};
var $author$project$Date_Time$Weekday$translateShort = F2(
	function (translations, weekday) {
		switch (weekday) {
			case 0:
				return $author$project$Translations$Weekdays$mo(translations);
			case 1:
				return $author$project$Translations$Weekdays$tu(translations);
			case 2:
				return $author$project$Translations$Weekdays$we(translations);
			case 3:
				return $author$project$Translations$Weekdays$th(translations);
			case 4:
				return $author$project$Translations$Weekdays$fr(translations);
			case 5:
				return $author$project$Translations$Weekdays$sa(translations);
			default:
				return $author$project$Translations$Weekdays$su(translations);
		}
	});
var $author$project$UI$DatePicker$viewWeekday = F2(
	function (translations, weekday) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Date_Time$Weekday$translateShort, translations, weekday))
				]));
	});
var $author$project$UI$DatePicker$viewWeekdays = function (translations) {
	return A2(
		$elm$core$List$map,
		$author$project$UI$DatePicker$viewWeekday(translations),
		$author$project$Date_Time$Weekday$all);
};
var $author$project$UI$DatePicker$viewWeekdaysAndDays = F3(
	function (translations, model, config) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(7, 2rem)'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-rows', 'repeat(7, 2.75rem)'),
							A2($rtfeldman$elm_css$Css$property, 'grid-gap', '0.5rem'),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$rem(2.75)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
						]))
				]),
			_Utils_ap(
				$author$project$UI$DatePicker$viewWeekdays(translations),
				A2($author$project$UI$DatePicker$viewDays, model, config)));
	});
var $author$project$UI$DatePicker$view = F3(
	function (translations, _v0, config) {
		var model = _v0;
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-date-picker',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$UI$DatePicker$viewMonthAndYear, translations, model, config),
					A3($author$project$UI$DatePicker$viewWeekdaysAndDays, translations, model, config)
				]));
	});
var $author$project$Translations$Buttons$delete = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'buttons.delete');
};
var $author$project$UI$Button$withOnMouseDown = F2(
	function (msg, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				d2: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$UI$DateInput$viewDeleteButton = F2(
	function (translations, config) {
		var _v0 = config.eP;
		if (!_v0.$) {
			var onInput = _v0.a;
			return $author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					config.c6($author$project$UI$DateInput$Collapsed),
					A2(
						$author$project$UI$Button$withOnMouseDown,
						onInput(''),
						$author$project$UI$Button$lightGrey(
							$author$project$Translations$Buttons$delete(translations)))));
		} else {
			return $author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					config.c6($author$project$UI$DateInput$Collapsed),
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$delete(translations))));
		}
	});
var $author$project$UI$DateInput$viewButton = F2(
	function (translations, config) {
		return config.gb ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(0.5))
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$DateInput$viewDeleteButton, translations, config)
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$UI$DateInput$viewDatePicker = F3(
	function (translations, datePicker, config) {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-date-input-picker',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
							A3(
							$rtfeldman$elm_css$Css$padding3,
							$rtfeldman$elm_css$Css$zero,
							$rtfeldman$elm_css$Css$rem(1),
							$rtfeldman$elm_css$Css$rem(1)),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$borderTop($rtfeldman$elm_css$Css$zero),
							A4(
							$rtfeldman$elm_css$Css$borderRadius4,
							$rtfeldman$elm_css$Css$zero,
							$rtfeldman$elm_css$Css$zero,
							$rtfeldman$elm_css$Css$rem(0.5),
							$rtfeldman$elm_css$Css$rem(0.5)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$UI$DatePicker$view,
					translations,
					datePicker,
					$author$project$UI$DatePicker$datePicker(
						A2($elm$core$Basics$composeR, $author$project$UI$DateInput$Expanded, config.c6))),
					A2($author$project$UI$DateInput$viewButton, translations, config)
				]));
	});
var $author$project$UI$DateInput$viewExpandedButton = F4(
	function (translations, config, date, textInput) {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-date-input-button',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					A5($author$project$UI$DateInput$viewButtonTextInput, translations, config, 0, date, textInput),
					A3(
					$author$project$UI$DateInput$viewButtonToggle,
					config.c6($author$project$UI$DateInput$Collapsed),
					config.jo,
					0)
				]));
	});
var $author$project$UI$DateInput$viewExpanded = F5(
	function (translations, date, textInput, datePicker, config) {
		var attributes = A2(
			$author$project$UI$DateInput$setOnEnter,
			config.eO,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(0),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
							$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$batch(config.by)
						]))
				]));
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-date-input',
			attributes,
			_List_fromArray(
				[
					A4($author$project$UI$DateInput$viewExpandedButton, translations, config, date, textInput),
					A3($author$project$UI$DateInput$viewDatePicker, translations, datePicker, config)
				]));
	});
var $author$project$UI$DateInput$view = F5(
	function (translations, state, date, textInput, _v0) {
		var config = _v0;
		if (!state.$) {
			return A4($author$project$UI$DateInput$viewCollapsed, translations, date, textInput, config);
		} else {
			var datePicker = state.a;
			return A5($author$project$UI$DateInput$viewExpanded, translations, date, textInput, datePicker, config);
		}
	});
var $author$project$UI$TextInput$withOnEnter = function (onEnter) {
	return $author$project$UI$TextInput$mapConfig(
		function (c) {
			return _Utils_update(
				c,
				{
					eO: $elm$core$Maybe$Just(onEnter)
				});
		});
};
var $author$project$UI$TimeInput$addOnEnterToTextInput = F2(
	function (maybeMsg, config) {
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return A2($author$project$UI$TextInput$withOnEnter, msg, config);
		} else {
			return config;
		}
	});
var $author$project$UI$TextInput$Datalist = F2(
	function (name, options) {
		return {g_: name, fR: options};
	});
var $author$project$UI$TextInput$withDatalist = F2(
	function (name, options) {
		return $author$project$UI$TextInput$mapConfig(
			function (c) {
				return _Utils_update(
					c,
					{
						dx: $elm$core$Maybe$Just(
							A2($author$project$UI$TextInput$Datalist, name, options))
					});
			});
	});
var $author$project$UI$TimeInput$viewHourSelect = F3(
	function (disabled, h, _v0) {
		var config = _v0;
		var optionList = A2(
			$elm$core$List$map,
			$elm$core$String$fromInt,
			A2($elm$core$List$range, 0, 23));
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TimeInput$addOnEnterToTextInput,
				config.eO,
				A2(
					$author$project$UI$TextInput$disabled,
					disabled,
					A2(
						$author$project$UI$TextInput$withStyle,
						$rtfeldman$elm_css$Css$maxHeight(
							$rtfeldman$elm_css$Css$rem(2.6)),
						A2(
							$author$project$UI$TextInput$withStyle,
							$rtfeldman$elm_css$Css$marginRight(
								$rtfeldman$elm_css$Css$rem(0.5)),
							A2(
								$author$project$UI$TextInput$withStyle,
								$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$rem(4)),
								A3(
									$author$project$UI$TextInput$withDatalist,
									'hour',
									optionList,
									A2(
										$author$project$UI$TextInput$withId,
										'value-input',
										A2(
											$author$project$UI$TextInput$withOnInput,
											config.hZ,
											A2($author$project$UI$TextInput$withValue, h, $author$project$UI$TextInput$singleLine))))))))));
	});
var $author$project$UI$TimeInput$viewMinuteSelect = F3(
	function (disabled, m, _v0) {
		var config = _v0;
		var optionsList = A2(
			$elm$core$List$map,
			$elm$core$String$fromInt,
			A2($elm$core$List$range, 0, 59));
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TimeInput$addOnEnterToTextInput,
				config.eO,
				A2(
					$author$project$UI$TextInput$disabled,
					disabled,
					A2(
						$author$project$UI$TextInput$withStyle,
						$rtfeldman$elm_css$Css$maxHeight(
							$rtfeldman$elm_css$Css$rem(2.6)),
						A2(
							$author$project$UI$TextInput$withStyle,
							$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$rem(0.5)),
							A2(
								$author$project$UI$TextInput$withStyle,
								$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$rem(4)),
								A3(
									$author$project$UI$TextInput$withDatalist,
									'minute',
									optionsList,
									A2(
										$author$project$UI$TextInput$withId,
										'second-value-input',
										A2(
											$author$project$UI$TextInput$withOnInput,
											config.h8,
											A2($author$project$UI$TextInput$withValue, m, $author$project$UI$TextInput$singleLine))))))))));
	});
var $author$project$UI$TimeInput$view = F4(
	function (disabled, h, m, config) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$rtfeldman$elm_css$Css$displayFlex]))
				]),
			_List_fromArray(
				[
					A3($author$project$UI$TimeInput$viewHourSelect, disabled, h, config),
					$rtfeldman$elm_css$Html$Styled$text(':'),
					A3($author$project$UI$TimeInput$viewMinuteSelect, disabled, m, config)
				]));
	});
var $author$project$UI$DateInput$withOnTextInput = F2(
	function (onTextInput, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				eP: $elm$core$Maybe$Just(onTextInput)
			});
	});
var $author$project$UI$DateInput$withStyle = F2(
	function (style, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				by: A2($elm$core$List$cons, style, config.by)
			});
	});
var $author$project$Audit$EditDialog$viewDeadline = F4(
	function (translations, environment, repository, model) {
		var flexDirection_ = ($author$project$Environments$Environment$viewport(environment).ln > 630) ? $rtfeldman$elm_css$Css$row : $rtfeldman$elm_css$Css$column;
		var defaultYear = $author$project$Date_Time$NaiveDate$year(model.bl);
		var defaultMonth = $author$project$Date_Time$NaiveDate$month(model.bl);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$flexDirection(flexDirection_)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(3)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$rem(2)),
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$deadlineTimeFirstLabel(translations))
						])),
					A5(
					$author$project$UI$DateInput$view,
					translations,
					model.cQ,
					$elm$core$Maybe$Just(model.bl),
					model.dy,
					A2(
						$author$project$UI$DateInput$disabled,
						A4($author$project$Audit$EditDialog$disableInput, environment, repository, model.es.gm, model.aq),
						A2(
							$author$project$UI$DateInput$withOnTextInput,
							$author$project$Audit$EditDialog$UserEnteredDateText,
							A2(
								$author$project$UI$DateInput$withStyle,
								$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(18.5)),
								A2(
									$author$project$UI$DateInput$withStyle,
									$rtfeldman$elm_css$Css$marginRight(
										$rtfeldman$elm_css$Css$rem(1)),
									A2(
										$author$project$UI$DateInput$withStyle,
										$rtfeldman$elm_css$Css$flexGrow(
											$rtfeldman$elm_css$Css$int(1)),
										A3($author$project$UI$DateInput$dateInput, defaultYear, defaultMonth, $author$project$Audit$EditDialog$UserChangedEndDateInput))))))),
					A4(
					$author$project$UI$TimeInput$view,
					A4($author$project$Audit$EditDialog$disableInput, environment, repository, model.es.gm, model.aq),
					model.cf,
					model.cj,
					A2($author$project$UI$TimeInput$timeInput, $author$project$Audit$EditDialog$EnteredHour, $author$project$Audit$EditDialog$EnteredMinute))
				]));
	});
var $author$project$UI$BasicDataEditor$colorPicker = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$BasicDataEditor$unwrap,
	function ($) {
		return $.aF;
	});
var $author$project$UI$BasicDataEditor$disableInput = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$BasicDataEditor$unwrap,
	function ($) {
		return $.ey;
	});
var $rtfeldman$elm_css$Html$Styled$form = $rtfeldman$elm_css$Html$Styled$node('form');
var $author$project$UI$BasicDataEditor$GotColorPickerMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Style$Color$calculateContrastColor = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var _v1 = _Utils_Tuple3(
		$elm$core$Basics$round(r * 255),
		$elm$core$Basics$round(g * 255),
		$elm$core$Basics$round(b * 255));
	var r_ = _v1.a;
	var g_ = _v1.b;
	var b_ = _v1.c;
	return (((((r_ * 0.299) + (g_ * 0.587)) + (b_ * 0.114)) > 186) || (a < 0.3)) ? A4($author$project$UI$Style$Color$rgba, 56 / 255, 92 / 255, 107 / 255, 1.0) : A4($author$project$UI$Style$Color$Rgba, 255 / 255, 255 / 255, 255 / 255, 1.0);
};
var $author$project$Translations$ColorPicker$preview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'colorPicker.preview');
};
var $author$project$UI$ColorPicker$EnteredString = function (a) {
	return {$: 4, a: a};
};
var $author$project$UI$ColorPicker$markerAttrs = _List_fromArray(
	[
		$rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$top(
				$rtfeldman$elm_css$Css$px(1)),
				$rtfeldman$elm_css$Css$bottom(
				$rtfeldman$elm_css$Css$px(1)),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
				$rtfeldman$elm_css$Css$backgroundColor(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(6)),
				$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
			]))
	]);
var $author$project$UI$ColorPicker$markerCorrection = 4;
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $rtfeldman$elm_css$VirtualDom$Styled$style = F2(
	function (key, val) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$style, key, val),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
var $author$project$UI$ColorPicker$alphaMarker = function (alpha) {
	var xVal = $elm$core$String$fromInt(
		$elm$core$Basics$round((alpha * $author$project$UI$ColorPicker$widgetWidth) - $author$project$UI$ColorPicker$markerCorrection));
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		A2(
			$elm$core$List$cons,
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'left', xVal + 'px'),
			$author$project$UI$ColorPicker$markerAttrs),
		_List_Nil);
};
var $author$project$UI$ColorPicker$NoOp = {$: 5};
var $author$project$UI$ColorPicker$bubblePreventer = A2(
	$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
	'click',
	$elm$json$Json$Decode$succeed(
		_Utils_Tuple2($author$project$UI$ColorPicker$NoOp, true)));
var $rtfeldman$elm_css$Css$backgroundSize2 = $rtfeldman$elm_css$Css$prop2('background-size');
var $author$project$UI$ColorPicker$checkedBkgStyles = _List_fromArray(
	[
		$rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$backgroundSize2,
				$rtfeldman$elm_css$Css$px(12),
				$rtfeldman$elm_css$Css$px(12)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$px(8))
			])),
		A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-position', '0 0, 0 6px, 6px -6px, -6px 0px'),
		A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-image', 'linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%)')
	]);
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $author$project$UI$Style$Color$hsl = F3(
	function (h, s, l) {
		return A4($author$project$UI$Style$Color$hsla, h, s, l, 1.0);
	});
var $author$project$UI$ColorPicker$hueMarker = function (lastHue) {
	var xVal = $elm$core$String$fromInt(
		$elm$core$Basics$round((lastHue * $author$project$UI$ColorPicker$widgetWidth) - $author$project$UI$ColorPicker$markerCorrection));
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		A2(
			$elm$core$List$cons,
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'left', xVal + 'px'),
			$author$project$UI$ColorPicker$markerAttrs),
		_List_Nil);
};
var $author$project$UI$ColorPicker$HueSlider = {$: 2};
var $author$project$UI$ColorPicker$OnMouseMove = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Svg$Styled$Attributes$class = $rtfeldman$elm_css$VirtualDom$Styled$attribute('class');
var $rtfeldman$elm_css$Svg$Styled$defs = $rtfeldman$elm_css$Svg$Styled$node('defs');
var $rtfeldman$elm_css$Svg$Styled$Attributes$height = $rtfeldman$elm_css$VirtualDom$Styled$attribute('height');
var $rtfeldman$elm_css$Svg$Styled$Attributes$id = $rtfeldman$elm_css$VirtualDom$Styled$attribute('id');
var $rtfeldman$elm_css$Svg$Styled$linearGradient = $rtfeldman$elm_css$Svg$Styled$node('linearGradient');
var $rtfeldman$elm_css$Svg$Styled$Attributes$offset = $rtfeldman$elm_css$VirtualDom$Styled$attribute('offset');
var $rtfeldman$elm_css$Svg$Styled$rect = $rtfeldman$elm_css$Svg$Styled$node('rect');
var $author$project$UI$ColorPicker$sliderStyles = _List_fromArray(
	[
		$rtfeldman$elm_css$Svg$Styled$Attributes$css(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px($author$project$UI$ColorPicker$widgetWidth)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block)
			]))
	]);
var $rtfeldman$elm_css$Svg$Styled$stop = $rtfeldman$elm_css$Svg$Styled$node('stop');
var $rtfeldman$elm_css$Svg$Styled$Attributes$stopColor = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stop-color');
var $rtfeldman$elm_css$Svg$Styled$Attributes$stopOpacity = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stop-opacity');
var $author$project$UI$ColorPicker$OnClick = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$UI$ColorPicker$OnMouseDown = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$UI$ColorPicker$OnMouseUp = {$: 3};
var $author$project$UI$ColorPicker$MouseInfo = F3(
	function (x, y, mousePressed) {
		return {dY: mousePressed, am: x, bf: y};
	});
var $author$project$UI$ColorPicker$decodeMouseInfo = A4(
	$elm$json$Json$Decode$map3,
	$author$project$UI$ColorPicker$MouseInfo,
	A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$neq(0),
		A2($elm$json$Json$Decode$field, 'buttons', $elm$json$Json$Decode$int)));
var $rtfeldman$elm_css$Svg$Styled$Events$on = $rtfeldman$elm_css$Html$Styled$Events$on;
var $author$project$UI$ColorPicker$onClickSvg = function (msgCreator) {
	return A2(
		$rtfeldman$elm_css$Svg$Styled$Events$on,
		'click',
		A2($elm$json$Json$Decode$map, msgCreator, $author$project$UI$ColorPicker$decodeMouseInfo));
};
var $author$project$UI$ColorPicker$onMouseDownSvg = function (msgCreator) {
	return A2(
		$rtfeldman$elm_css$Svg$Styled$Events$on,
		'mousedown',
		A2($elm$json$Json$Decode$map, msgCreator, $author$project$UI$ColorPicker$decodeMouseInfo));
};
var $author$project$UI$ColorPicker$onMouseMoveSvg = function (msgCreator) {
	return A2(
		$rtfeldman$elm_css$Svg$Styled$Events$on,
		'mousemove',
		A2($elm$json$Json$Decode$map, msgCreator, $author$project$UI$ColorPicker$decodeMouseInfo));
};
var $rtfeldman$elm_css$Svg$Styled$Events$onMouseUp = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseup',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$UI$ColorPicker$svgDragAttrs = F3(
	function (currMouseTgt, thisTgt, onMoveMsg) {
		var common = _List_fromArray(
			[
				$author$project$UI$ColorPicker$onMouseDownSvg(
				$author$project$UI$ColorPicker$OnMouseDown(thisTgt)),
				$rtfeldman$elm_css$Svg$Styled$Events$onMouseUp($author$project$UI$ColorPicker$OnMouseUp),
				$author$project$UI$ColorPicker$onClickSvg(
				$author$project$UI$ColorPicker$OnClick(thisTgt))
			]);
		return _Utils_eq(currMouseTgt, thisTgt) ? A2(
			$elm$core$List$cons,
			$author$project$UI$ColorPicker$onMouseMoveSvg(onMoveMsg),
			common) : common;
	});
var $rtfeldman$elm_css$Svg$Styled$Attributes$width = $rtfeldman$elm_css$VirtualDom$Styled$attribute('width');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x1 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x1');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x2 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x2');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y1 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y1');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y2 = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y2');
var $author$project$UI$ColorPicker$huePalette = function (mouseTarget) {
	var stops = _List_fromArray(
		[
			_Utils_Tuple2('0%', '#FF0000'),
			_Utils_Tuple2('17%', '#FF00FF'),
			_Utils_Tuple2('33%', '#0000FF'),
			_Utils_Tuple2('50%', '#00FFFF'),
			_Utils_Tuple2('66%', '#00FF00'),
			_Utils_Tuple2('83%', '#FFFF00'),
			_Utils_Tuple2('100%', '#FF0000')
		]);
	var mkStop = function (_v0) {
		var os = _v0.a;
		var sc = _v0.b;
		return A2(
			$rtfeldman$elm_css$Svg$Styled$stop,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$offset(os),
					$rtfeldman$elm_css$Svg$Styled$Attributes$stopColor(sc),
					$rtfeldman$elm_css$Svg$Styled$Attributes$stopOpacity('1')
				]),
			_List_Nil);
	};
	return A2(
		$rtfeldman$elm_css$Svg$Styled$svg,
		A2(
			$elm$core$List$cons,
			$rtfeldman$elm_css$Svg$Styled$Attributes$class('hue-picker'),
			$author$project$UI$ColorPicker$sliderStyles),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Svg$Styled$defs,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$linearGradient,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$id('gradient-hsv'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$x1('100%'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$y1('0%'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$x2('0%'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$y2('0%')
							]),
						A2($elm$core$List$map, mkStop, stops))
					])),
				A2(
				$rtfeldman$elm_css$Svg$Styled$rect,
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$x('0'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$y('0'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$width(
							$elm$core$String$fromInt($author$project$UI$ColorPicker$widgetWidth)),
							$rtfeldman$elm_css$Svg$Styled$Attributes$height('100%'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('url(#gradient-hsv)')
						]),
					A3(
						$author$project$UI$ColorPicker$svgDragAttrs,
						mouseTarget,
						$author$project$UI$ColorPicker$HueSlider,
						$author$project$UI$ColorPicker$OnMouseMove($author$project$UI$ColorPicker$HueSlider))),
				_List_Nil)
			]));
};
var $author$project$UI$ColorPicker$OpacitySlider = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$ColorPicker$onClickHtml = function (msgCreator) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		A2($elm$json$Json$Decode$map, msgCreator, $author$project$UI$ColorPicker$decodeMouseInfo));
};
var $rtfeldman$elm_css$Html$Styled$Events$onMouseUp = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseup',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$UI$ColorPicker$htmlDragAttrs = F3(
	function (currMouseTgt, thisTgt, onMoveMsg) {
		var common = _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$on,
				'mousedown',
				A2(
					$elm$json$Json$Decode$map,
					$author$project$UI$ColorPicker$OnMouseDown(thisTgt),
					$author$project$UI$ColorPicker$decodeMouseInfo)),
				$rtfeldman$elm_css$Html$Styled$Events$onMouseUp($author$project$UI$ColorPicker$OnMouseUp),
				$author$project$UI$ColorPicker$onClickHtml(
				$author$project$UI$ColorPicker$OnClick(thisTgt))
			]);
		return _Utils_eq(currMouseTgt, thisTgt) ? A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$Events$on,
				'mousemove',
				A2($elm$json$Json$Decode$map, onMoveMsg, $author$project$UI$ColorPicker$decodeMouseInfo)),
			common) : common;
	});
var $author$project$UI$ColorPicker$opacityPalette = F2(
	function (hsla, model) {
		var mouseTarget = $author$project$UI$ColorPicker$OpacitySlider(hsla.Z);
		var mkCol = function (op) {
			return $author$project$UI$Style$Color$toString(
				A4($author$project$UI$Style$Color$hsla, hsla.Z, hsla.dc, hsla.c2, op));
		};
		var grad = 'linear-gradient(0.25turn, ' + (mkCol(0) + (', ' + (mkCol(1) + ')')));
		var overlay = _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100))
					])),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background', grad)
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				overlay,
				A3(
					$author$project$UI$ColorPicker$htmlDragAttrs,
					model.ck,
					mouseTarget,
					$author$project$UI$ColorPicker$OnMouseMove(mouseTarget))),
			_List_Nil);
	});
var $author$project$UI$ColorPicker$pickerIndicator = function (col) {
	var adjustment = 4;
	var _v0 = $author$project$UI$Style$Color$toHsla(col);
	var saturation = _v0.dc;
	var lightness = _v0.c2;
	var borderColor = (lightness > 0.95) ? $author$project$UI$Style$Theme$grey : $author$project$UI$Style$Theme$white;
	var cy_ = ($author$project$UI$ColorPicker$widgetHeight - (lightness * $author$project$UI$ColorPicker$widgetHeight)) - adjustment;
	var cx_ = (saturation * $author$project$UI$ColorPicker$widgetWidth) - adjustment;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
						$rtfeldman$elm_css$Css$top(
						$rtfeldman$elm_css$Css$px(cy_)),
						$rtfeldman$elm_css$Css$left(
						$rtfeldman$elm_css$Css$px(cx_)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$pct(100)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(2),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor(borderColor)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(6)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(6)),
						$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
					]))
			]),
		_List_Nil);
};
var $rtfeldman$elm_css$Css$crosshair = {c: 0, ll: 'crosshair'};
var $author$project$UI$ColorPicker$pickerStyles = _List_fromArray(
	[
		$rtfeldman$elm_css$Html$Styled$Attributes$css(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$crosshair),
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
			]))
	]);
var $author$project$UI$ColorPicker$SatLight = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Svg$Styled$Attributes$display = $rtfeldman$elm_css$VirtualDom$Styled$attribute('display');
var $author$project$UI$ColorPicker$satLightPalette = F3(
	function (hue, colCss, mouseTarget) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$width(
					$elm$core$String$fromInt($author$project$UI$ColorPicker$widgetWidth)),
					$rtfeldman$elm_css$Svg$Styled$Attributes$height(
					$elm$core$String$fromInt($author$project$UI$ColorPicker$widgetHeight)),
					$rtfeldman$elm_css$Svg$Styled$Attributes$class('main-picker'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$display('block')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$defs,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Svg$Styled$linearGradient,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$id('pickerSaturation')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Svg$Styled$stop,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$offset('0'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopColor('#808080'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopOpacity('1')
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Svg$Styled$stop,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$offset('1'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopColor('#808080'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopOpacity('0')
										]),
									_List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Svg$Styled$linearGradient,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$id('pickerBrightness'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$x1('0'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$y1('0'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$x2('0'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$y2('1')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Svg$Styled$stop,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$offset('0'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopColor('#fff'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopOpacity('1')
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Svg$Styled$stop,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$offset('0.499'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopColor('#fff'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopOpacity('0')
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Svg$Styled$stop,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$offset('0.5'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopColor('#000'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopOpacity('0')
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Svg$Styled$stop,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$offset('1'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopColor('#000'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$stopOpacity('1')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Svg$Styled$rect,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$width(
							$elm$core$String$fromInt($author$project$UI$ColorPicker$widgetWidth)),
							$rtfeldman$elm_css$Svg$Styled$Attributes$height(
							$elm$core$String$fromInt($author$project$UI$ColorPicker$widgetHeight)),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill(colCss),
							$rtfeldman$elm_css$Svg$Styled$Attributes$id('picker')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$rect,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$width(
							$elm$core$String$fromInt($author$project$UI$ColorPicker$widgetWidth)),
							$rtfeldman$elm_css$Svg$Styled$Attributes$height(
							$elm$core$String$fromInt($author$project$UI$ColorPicker$widgetHeight)),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('url(#pickerSaturation)')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$rect,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$width(
								$elm$core$String$fromInt($author$project$UI$ColorPicker$widgetWidth)),
								$rtfeldman$elm_css$Svg$Styled$Attributes$height(
								$elm$core$String$fromInt($author$project$UI$ColorPicker$widgetHeight)),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('url(#pickerBrightness)')
							]),
						A3(
							$author$project$UI$ColorPicker$svgDragAttrs,
							mouseTarget,
							$author$project$UI$ColorPicker$SatLight(hue),
							$author$project$UI$ColorPicker$OnMouseMove(
								$author$project$UI$ColorPicker$SatLight(hue)))),
					_List_Nil)
				]));
	});
var $author$project$UI$ColorPicker$sliderContainerStyles = function (name) {
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px($author$project$UI$ColorPicker$widgetWidth)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(12)),
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(8))
				])),
			$rtfeldman$elm_css$Html$Styled$Attributes$class('color-picker-slider ' + name)
		]);
};
var $author$project$UI$ColorPicker$view = F2(
	function (col, _v0) {
		var model = _v0;
		var hsla = $author$project$UI$Style$Color$toHsla(col);
		var hue = A2($elm$core$Maybe$withDefault, hsla.Z, model.Z);
		var colCss = $author$project$UI$Style$Color$toString(
			A3($author$project$UI$Style$Color$hsl, hue, 1, 0.5));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$px(6)),
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$px(5))
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'box-shadow', 'rgba(0, 0, 0, 0.15) 0px 0px 0px 1px, rgba(0, 0, 0, 0.15) 0px 8px 16px'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('color-picker-container'),
					$author$project$UI$ColorPicker$bubblePreventer
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					$author$project$UI$ColorPicker$pickerStyles,
					_List_fromArray(
						[
							A3($author$project$UI$ColorPicker$satLightPalette, hue, colCss, model.ck),
							$author$project$UI$ColorPicker$pickerIndicator(col)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_Utils_ap(
						$author$project$UI$ColorPicker$pickerStyles,
						$author$project$UI$ColorPicker$sliderContainerStyles('hue')),
					_List_fromArray(
						[
							$author$project$UI$ColorPicker$huePalette(model.ck),
							$author$project$UI$ColorPicker$hueMarker(hue)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_Utils_ap(
						$author$project$UI$ColorPicker$checkedBkgStyles,
						_Utils_ap(
							$author$project$UI$ColorPicker$pickerStyles,
							$author$project$UI$ColorPicker$sliderContainerStyles('opacity'))),
					_List_fromArray(
						[
							A2($author$project$UI$ColorPicker$opacityPalette, hsla, model),
							$author$project$UI$ColorPicker$alphaMarker(hsla.eq)
						])),
					$author$project$UI$TextInput$view(
					A2(
						$author$project$UI$TextInput$withValue,
						model.o,
						A2($author$project$UI$TextInput$withOnInput, $author$project$UI$ColorPicker$EnteredString, $author$project$UI$TextInput$singleLine)))
				]));
	});
var $author$project$UI$Bar$withBackgroundColour = F2(
	function (colour, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{gp: colour});
	});
var $author$project$UI$Bar$withTextColour = F2(
	function (colour, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{hm: colour});
	});
var $author$project$UI$BasicDataEditor$viewColorPicker = F2(
	function (translations, colorPicker_) {
		if (!colorPicker_.$) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var withColorPickerModel = colorPicker_.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$UI$Bar$view(
						A2(
							$author$project$UI$Bar$withTextColour,
							$author$project$UI$Style$Color$calculateContrastColor(withColorPickerModel.K),
							A2(
								$author$project$UI$Bar$withBackgroundColour,
								withColorPickerModel.K,
								$author$project$UI$Bar$bar(
									$author$project$Translations$ColorPicker$preview(translations))))),
						A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$UI$BasicDataEditor$GotColorPickerMsg,
						A2($author$project$UI$ColorPicker$view, withColorPickerModel.K, withColorPickerModel.aF))
					]));
		}
	});
var $author$project$UI$BasicDataEditor$UserEnteredDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$Misc$BasicData$description = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'misc.basicData.description');
};
var $author$project$UI$TextInput$multiLine = $author$project$UI$TextInput$MultiLine(
	{dx: $elm$core$Maybe$Nothing, jo: false, fw: '', eO: $elm$core$Maybe$Nothing, d1: $elm$core$Maybe$Nothing, cr: '', dd: _List_Nil, ll: ''});
var $author$project$UI$BasicDataEditor$viewDescription = F3(
	function (translations, disableInput_, description_) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$disabled,
				disableInput_,
				A2(
					$author$project$UI$TextInput$withOnInput,
					$author$project$UI$BasicDataEditor$UserEnteredDescription,
					A2(
						$author$project$UI$TextInput$withPlaceholder,
						$author$project$Translations$Misc$BasicData$description(translations),
						A2($author$project$UI$TextInput$withValue, description_, $author$project$UI$TextInput$multiLine)))));
	});
var $author$project$UI$BasicDataEditor$UserEnteredTitle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Translations$Misc$BasicData$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'misc.basicData.title');
};
var $author$project$UI$BasicDataEditor$viewTitle = F3(
	function (translations, disableInput_, title_) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$disabled,
				disableInput_,
				A2(
					$author$project$UI$TextInput$withOnInput,
					$author$project$UI$BasicDataEditor$UserEnteredTitle,
					A2(
						$author$project$UI$TextInput$withPlaceholder,
						$author$project$Translations$Misc$BasicData$title(translations),
						A2($author$project$UI$TextInput$withValue, title_, $author$project$UI$TextInput$singleLine)))));
	});
var $author$project$UI$BasicDataEditor$viewForm = F2(
	function (translations, editor) {
		var disableInput_ = $author$project$UI$BasicDataEditor$disableInput(editor);
		return A2(
			$rtfeldman$elm_css$Html$Styled$form,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$flexShrink(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$paddingLeft(
							$rtfeldman$elm_css$Css$rem(1.5)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$UI$BasicDataEditor$viewTitle,
					translations,
					disableInput_,
					$author$project$UI$BasicDataEditor$title(editor)),
					A3(
					$author$project$UI$BasicDataEditor$viewDescription,
					translations,
					disableInput_,
					$author$project$UI$BasicDataEditor$description(editor)),
					A2(
					$author$project$UI$BasicDataEditor$viewColorPicker,
					translations,
					$author$project$UI$BasicDataEditor$colorPicker(editor))
				]));
	});
var $author$project$Audit$EditDialog$viewBasicDataTab = F4(
	function (translations, environment, repository, model) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$pct(50))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A2($author$project$Audit$EditDialog$viewFooter, translations, model.aq),
					A2(
						$author$project$UI$Dialog$appendContent,
						A4($author$project$Audit$EditDialog$viewDeadline, translations, environment, repository, model),
						A2(
							$author$project$UI$Dialog$appendContent,
							A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Audit$EditDialog$GotBasicDataEditorMsg,
								A2($author$project$UI$BasicDataEditor$viewForm, translations, model.aQ)),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$UI$BasicDataEditor$viewBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A4($author$project$Audit$EditDialog$viewTabBar, environment, repository, model.es, 0),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Audits$EditDialog$header(translations),
											$author$project$Audit$EditDialog$UserClickedCloseDialog)))))))));
	});
var $author$project$UI$Icons$gear = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M38.92 20.15h-1.119c-.308-1.117-.748-2.184-1.325-3.193l.786-.784c1.045-1.046 1.045-2.747 0-3.792l-1.644-1.644c-1.045-1.044-2.745-1.044-3.791 0l-6.782 6.774c-.505.506-.505 1.329 0 1.839.166.165.36.274.57.331.035.015.065.038.101.052 1.34.539 2.336 1.65 2.717 3.042.332 1.182.179 2.426-.426 3.502-.606 1.074-1.591 1.845-2.776 2.171-1.181.33-2.428.179-3.5-.429-1.076-.602-1.846-1.59-2.171-2.771-.482-1.74.101-3.606 1.477-4.765.548-.461.62-1.277.16-1.83-.461-.549-1.275-.623-1.831-.159-2.155 1.809-3.064 4.735-2.306 7.445.51 1.85 1.722 3.394 3.394 4.338 1.096.621 2.308.938 3.531.938.648 0 1.298-.088 1.94-.268 1.852-.511 3.394-1.721 4.339-3.395.944-1.673 1.181-3.618.67-5.469-.455-1.644-1.449-3.029-2.805-3.974l5.529-5.525c.037-.038.087-.038.122 0l1.643 1.643c.038.034.038.085 0 .121l-2.262 2.262.591.889c.857 1.283 1.449 2.703 1.744 4.215l.209 1.046h3.215c.05 0 .086.037.086.087v2.326c0 .052-.036.086-.086.086h-3.201l-.208 1.046c-.303 1.515-.887 2.928-1.745 4.218l-.591.884 2.264 2.263c.035.036.035.09 0 .124l-1.643 1.645c-.038.034-.087.034-.123 0l-2.263-2.265-.886.592c-1.284.858-2.704 1.448-4.218 1.745l-1.046.208v3.2c0 .05-.035.086-.084.086h-2.329c-.05 0-.085-.036-.085-.086v-3.2l-1.047-.208c-1.514-.303-2.926-.887-4.216-1.745l-.888-.592-2.263 2.265c-.035.034-.086.034-.122 0l-1.643-1.645c-.035-.034-.035-.088 0-.124l2.264-2.263-.591-.884c-.859-1.283-1.448-2.703-1.744-4.218l-.21-1.046h-3.22c-.052 0-.086-.034-.086-.086v-2.326c0-.05.034-.087.086-.087h3.198l.209-1.046c.303-1.512.889-2.926 1.747-4.215l.589-.889-2.263-2.262c-.036-.036-.036-.087 0-.121l1.642-1.643c.036-.038.087-.038.123 0l2.264 2.261.886-.589c1.284-.86 2.703-1.45 4.217-1.746l1.045-.208V9.081c0-.05.035-.089.087-.089h2.328c.049 0 .084.039.084.089v2.139c0 .713.585 1.297 1.299 1.297s1.297-.584 1.297-1.297V9.081c0-1.479-1.203-2.682-2.68-2.682h-2.328c-1.478 0-2.682 1.203-2.682 2.682v1.115c-1.115.309-2.183.752-3.192 1.325l-.786-.784c-1.045-1.044-2.746-1.044-3.792 0l-1.643 1.644c-1.045 1.045-1.045 2.746 0 3.792l.787.784c-.571 1.009-1.017 2.076-1.326 3.193h-1.11c-1.479 0-2.683 1.203-2.683 2.68v2.33c0 1.475 1.204 2.681 2.683 2.681h1.117c.31 1.117.748 2.183 1.325 3.194l-.787.784c-1.044 1.045-1.044 2.748 0 3.792l1.644 1.644c1.046 1.045 2.748 1.045 3.792 0l.786-.786c1.01.569 2.073 1.015 3.192 1.324v1.126c0 1.477 1.204 2.682 2.682 2.682h2.328c1.478 0 2.68-1.205 2.68-2.682v-1.118c1.118-.31 2.184-.75 3.192-1.326l.787.788c1.045 1.044 2.746 1.044 3.792 0l1.642-1.644c1.045-1.046 1.045-2.748 0-3.793l-.784-.783c.568-1.01 1.015-2.078 1.325-3.194h1.125c1.478 0 2.681-1.206 2.681-2.682V22.83c0-1.477-1.203-2.68-2.681-2.68')
						]),
					_List_Nil)
				]));
	});
var $author$project$Translations$Audits$Delete$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'audits.delete.header');
};
var $author$project$Audit$EditDialog$viewDeleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Audits$Delete$header(translations))));
};
var $author$project$UI$Style$Theme$lightestRed = A4($author$project$UI$Style$Color$rgba, 254 / 255, 231 / 255, 232 / 255, 1.0);
var $author$project$Audit$EditDialog$viewDeleteAuditTitleAndDescription = function (audit) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$paddingLeft(
						$rtfeldman$elm_css$Css$rem(1.5))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(audit.aY)
					]))
			]));
};
var $author$project$Audit$EditDialog$viewDeleteDetails = function (audit) {
	return $elm$core$String$isEmpty(audit.aY) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$author$project$Audit$EditDialog$viewDeleteAuditTitleAndDescription(audit)
			]));
};
var $author$project$Audit$EditDialog$UserClickedDelete = {$: 13};
var $author$project$UI$Style$Theme$darkRed = A4($author$project$UI$Style$Color$rgba, 126 / 255, 18 / 255, 18 / 255, 1.0);
var $author$project$UI$Button$darkRed = function (label) {
	return {
		jo: false,
		h2: label,
		bJ: $elm$core$Maybe$Nothing,
		d2: $elm$core$Maybe$Nothing,
		by: _List_fromArray(
			[
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkRed)),
				$rtfeldman$elm_css$Css$color(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
				$rtfeldman$elm_css$Css$backgroundColor(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkRed))
			])
	};
};
var $author$project$UI$Button$disabled = F2(
	function (disabled_, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{jo: disabled_});
	});
var $author$project$Audit$EditDialog$viewDeleteButton = F2(
	function (translations, disabled) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disabled,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Audit$EditDialog$UserClickedDelete,
					$author$project$UI$Button$darkRed(
						$author$project$Translations$Buttons$delete(translations)))));
	});
var $author$project$Audit$EditDialog$viewDeleteFooter = F2(
	function (translations, disableDelete) {
		return $author$project$Audit$EditDialog$footer(
			_List_fromArray(
				[
					$author$project$Audit$EditDialog$viewCancelButton(translations),
					A2($author$project$Audit$EditDialog$viewDeleteButton, translations, disableDelete)
				]));
	});
var $rtfeldman$elm_css$Html$Styled$h4 = $rtfeldman$elm_css$Html$Styled$node('h4');
var $author$project$Translations$Audits$Delete$question = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'audits.delete.question');
};
var $author$project$Audit$EditDialog$viewDeleteQuestion = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Audits$Delete$question(translations))
			]));
};
var $author$project$Audit$EditDialog$viewDeleteTab = F4(
	function (translations, environment, repository, model) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$pct(50))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A2(
						$author$project$Audit$EditDialog$viewDeleteFooter,
						translations,
						$author$project$Environments$Environment$isOffline(environment)),
					A2(
						$author$project$UI$Dialog$appendContent,
						$author$project$Audit$EditDialog$viewDeleteDetails(model.es),
						A2(
							$author$project$UI$Dialog$appendContent,
							$author$project$Audit$EditDialog$viewDeleteQuestion(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$Audit$EditDialog$viewDeleteBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A4($author$project$Audit$EditDialog$viewTabBar, environment, repository, model.es, 2),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Audits$EditDialog$header(translations),
											$author$project$Audit$EditDialog$UserClickedCloseDialog)))))))));
	});
var $author$project$Audit$EditDialog$viewTab = F3(
	function (environment, repository, model) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var _v0 = model.cI;
		switch (_v0) {
			case 0:
				return A4($author$project$Audit$EditDialog$viewBasicDataTab, translations, environment, repository, model);
			case 1:
				var availableUsers = $author$project$Environments$Repository$users(repository);
				return A4($author$project$Audit$EditDialog$viewAuditorsTab, environment, repository, model, availableUsers);
			default:
				return A4($author$project$Audit$EditDialog$viewDeleteTab, translations, environment, repository, model);
		}
	});
var $author$project$Audit$EditDialog$view = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Audit$EditDialog$viewTab, environment, repository, model);
			default:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Audit$EditDialog$viewTab, environment, repository, model);
		}
	});
var $author$project$Archive$ArchivedAudits$getCompletionTimestamp = function (audit) {
	var _v0 = audit.jb;
	if (!_v0.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var posix = _v0.a;
		return $elm$core$Maybe$Just(posix);
	}
};
var $author$project$Archive$ArchivedAudits$auditsWithCompletionTimestamp = function (audits) {
	var addTuple = F2(
		function (value, acc) {
			var _v1 = $author$project$Archive$ArchivedAudits$getCompletionTimestamp(value);
			if (!_v1.$) {
				var completionTimestamp = _v1.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(value, completionTimestamp),
					acc);
			} else {
				return acc;
			}
		});
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortBy,
			function (_v0) {
				var posix = _v0.b;
				return $elm$time$Time$posixToMillis(posix);
			},
			A3($elm$core$List$foldl, addTuple, _List_Nil, audits)));
};
var $author$project$Translations$Archive$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.emptyText');
};
var $author$project$Audit$Audit$belongsToOrganisationUnit = F2(
	function (organisationUnitId, audit) {
		var relatedOrganisationUnitIds = A2(
			$elm$core$List$map,
			function (group) {
				return group.km;
			},
			audit.ff.gt);
		return A2($elm$core$List$member, organisationUnitId, relatedOrganisationUnitIds);
	});
var $author$project$Audit$Audit$auditFilter = F2(
	function (currentOrganisationUnitAndChildren, audit) {
		var filterHelper = F2(
			function (organisationUnitId, bool) {
				return bool ? bool : A2($author$project$Audit$Audit$belongsToOrganisationUnit, organisationUnitId, audit);
			});
		return A3($elm$core$List$foldl, filterHelper, false, currentOrganisationUnitAndChildren);
	});
var $author$project$Utils$Utils$flip = F3(
	function (fn, b, a) {
		return A2(fn, a, b);
	});
var $author$project$OrganisationUnit$Dict$get = $turboMaCk$any_dict$Dict$Any$get;
var $author$project$OrganisationUnit$Hierarchy$unwrap = function (_v0) {
	var data = _v0;
	return data;
};
var $author$project$OrganisationUnit$Hierarchy$getOrganisationUnit = function (organisationUnitId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$OrganisationUnit$Hierarchy$unwrap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.kn;
			},
			$author$project$OrganisationUnit$Dict$get(organisationUnitId)));
};
var $author$project$OrganisationUnit$Ids$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$Utils$Maybe$join = $elm$core$Maybe$andThen($elm$core$Basics$identity);
var $author$project$OrganisationUnit$Hierarchy$getDescendantIdsOf = F2(
	function (organisationUnit, hierarchy) {
		var withFirstChildIdsOf = F2(
			function (organisationUnit_, organisationUnitIds) {
				return A2(
					$elm$core$Maybe$withDefault,
					organisationUnitIds,
					A2(
						$elm$core$Maybe$map,
						function (firstChild) {
							return A2(
								withNextOrganisationUnitIdsOf,
								firstChild,
								A2(
									withFirstChildIdsOf,
									firstChild,
									A2($author$project$OrganisationUnit$Ids$insert, firstChild.km, organisationUnitIds)));
						},
						$author$project$Utils$Maybe$join(
							A2(
								$elm$core$Maybe$map,
								function (firstChildId) {
									return A2($author$project$OrganisationUnit$Hierarchy$getOrganisationUnit, firstChildId, hierarchy);
								},
								organisationUnit_.hV))));
			});
		var withNextOrganisationUnitIdsOf = F2(
			function (organisationUnit_, organisationUnitIds) {
				return A2(
					$elm$core$Maybe$withDefault,
					organisationUnitIds,
					A2(
						$elm$core$Maybe$map,
						function (next) {
							return A2(
								withNextOrganisationUnitIdsOf,
								next,
								A2(
									withFirstChildIdsOf,
									next,
									A2($author$project$OrganisationUnit$Ids$insert, next.km, organisationUnitIds)));
						},
						$author$project$Utils$Maybe$join(
							A2(
								$elm$core$Maybe$map,
								A2($author$project$Utils$Utils$flip, $author$project$OrganisationUnit$Hierarchy$getOrganisationUnit, hierarchy),
								organisationUnit_.ax))));
			});
		return A2(withFirstChildIdsOf, organisationUnit, $author$project$OrganisationUnit$Ids$empty);
	});
var $author$project$OrganisationUnit$OrganisationUnits$unwrap = function (_v0) {
	var data = _v0;
	return data;
};
var $author$project$OrganisationUnit$OrganisationUnits$hierarchy = A2(
	$elm$core$Basics$composeR,
	$author$project$OrganisationUnit$OrganisationUnits$unwrap,
	function ($) {
		return $.a8;
	});
var $author$project$OrganisationUnit$Ids$toList = $turboMaCk$any_set$Set$Any$toList;
var $author$project$Audit$Audit$filterAuditsOfCurrentOrganisationUnit = F3(
	function (organisationUnits, audits, organisationUnit) {
		var currentOrganisationUnitAndChildren = A2(
			$elm$core$List$cons,
			organisationUnit.km,
			$author$project$OrganisationUnit$Ids$toList(
				A2(
					$author$project$OrganisationUnit$Hierarchy$getDescendantIdsOf,
					organisationUnit,
					$author$project$OrganisationUnit$OrganisationUnits$hierarchy(organisationUnits))));
		return A2(
			$elm$core$List$filter,
			$author$project$Audit$Audit$auditFilter(currentOrganisationUnitAndChildren),
			audits);
	});
var $tripokey$elm_fuzzy$Fuzzy$Match = F4(
	function (score, offset, length, keys) {
		return {jR: keys, eK: length, d0: offset, kI: score};
	});
var $tripokey$elm_fuzzy$Fuzzy$Result = F2(
	function (score, matches) {
		return {gW: matches, kI: score};
	});
var $tripokey$elm_fuzzy$Fuzzy$ConfigModel = F4(
	function (addPenalty, movePenalty, removePenalty, insertPenalty) {
		return {e8: addPenalty, fy: insertPenalty, fH: movePenalty, fZ: removePenalty};
	});
var $tripokey$elm_fuzzy$Fuzzy$defaultConfig = A4($tripokey$elm_fuzzy$Fuzzy$ConfigModel, 10, 1000, 10000, 1);
var $tripokey$elm_fuzzy$Fuzzy$dissect = F2(
	function (separators, strings) {
		dissect:
		while (true) {
			if (!separators.b) {
				return strings;
			} else {
				var head = separators.a;
				var tail = separators.b;
				var dissectEntry = function (entry) {
					var separatorLength = $elm$core$String$length(head);
					var slice = F2(
						function (index, _v1) {
							var prevIndex = _v1.a;
							var sum = _v1.b;
							var separatorSlice = _List_fromArray(
								[
									A3($elm$core$String$slice, index, index + separatorLength, entry)
								]);
							var precedingSlice = _Utils_eq(prevIndex, index) ? _List_Nil : _List_fromArray(
								[
									A3($elm$core$String$slice, prevIndex, index, entry)
								]);
							return _Utils_Tuple2(
								index + separatorLength,
								_Utils_ap(
									sum,
									_Utils_ap(precedingSlice, separatorSlice)));
						});
					var indexes = A2($elm$core$String$indexes, head, entry);
					var result = A3(
						$elm$core$List$foldl,
						slice,
						_Utils_Tuple2(0, _List_Nil),
						indexes);
					var lastIndex = result.a;
					var first = result.b;
					var entryLength = $elm$core$String$length(entry);
					var last = _Utils_eq(lastIndex, entryLength) ? _List_Nil : _List_fromArray(
						[
							A3($elm$core$String$slice, lastIndex, entryLength, entry)
						]);
					return _Utils_ap(first, last);
				};
				var dissected = A3(
					$elm$core$List$foldl,
					F2(
						function (e, s) {
							return _Utils_ap(
								s,
								dissectEntry(e));
						}),
					_List_Nil,
					strings);
				var $temp$separators = tail,
					$temp$strings = dissected;
				separators = $temp$separators;
				strings = $temp$strings;
				continue dissect;
			}
		}
	});
var $tripokey$elm_fuzzy$Fuzzy$initialModel = _List_Nil;
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $tripokey$elm_fuzzy$Fuzzy$quickSort = function (entries) {
	if (!entries.b) {
		return _Utils_Tuple2(0, _List_Nil);
	} else {
		var head = entries.a;
		var tail = entries.b;
		var partition = A2(
			$elm$core$List$partition,
			function (e) {
				return _Utils_cmp(e, head) < 0;
			},
			tail);
		var smaller = $tripokey$elm_fuzzy$Fuzzy$quickSort(partition.a);
		var penalty = $elm$core$List$isEmpty(smaller.b) ? 0 : 1;
		var larger = $tripokey$elm_fuzzy$Fuzzy$quickSort(partition.b);
		return _Utils_Tuple2(
			(smaller.a + penalty) + larger.a,
			_Utils_ap(
				smaller.b,
				_Utils_ap(
					_List_fromArray(
						[head]),
					larger.b)));
	}
};
var $tripokey$elm_fuzzy$Fuzzy$distance = F3(
	function (config, needle, hay) {
		var accumulateInsertPenalty = F2(
			function (elem, result) {
				if (!result.a.$) {
					var prev = result.a.a;
					var score = result.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(elem),
						((elem - 1) - prev) + score);
				} else {
					var _v2 = result.a;
					var score = result.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(elem),
						score);
				}
			});
		var accumulate = F2(
			function (c, indexList) {
				var indexes = A2(
					$elm$core$String$indexes,
					$elm$core$String$fromChar(c),
					hay);
				var hayIndex = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (e) {
							return !A2($elm$core$List$member, e, indexList);
						},
						indexes));
				if (!hayIndex.$) {
					var v = hayIndex.a;
					return _Utils_ap(
						indexList,
						_List_fromArray(
							[v]));
				} else {
					return indexList;
				}
			});
		var accumulated = A3($elm$core$String$foldl, accumulate, $tripokey$elm_fuzzy$Fuzzy$initialModel, needle);
		var hPenalty = ($elm$core$String$length(hay) - $elm$core$List$length(accumulated)) * config.e8;
		var nPenalty = ($elm$core$String$length(needle) - $elm$core$List$length(accumulated)) * config.fZ;
		var sorted = $tripokey$elm_fuzzy$Fuzzy$quickSort(accumulated);
		var iPenalty = A3(
			$elm$core$List$foldl,
			accumulateInsertPenalty,
			_Utils_Tuple2($elm$core$Maybe$Nothing, 0),
			sorted.b).b * config.fy;
		var mPenalty = sorted.a * config.fH;
		return A4(
			$tripokey$elm_fuzzy$Fuzzy$Match,
			((mPenalty + hPenalty) + nPenalty) + iPenalty,
			0,
			$elm$core$String$length(hay),
			sorted.b);
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $tripokey$elm_fuzzy$Fuzzy$padHays = F2(
	function (ns, hs) {
		return _Utils_ap(
			hs,
			A2(
				$elm$core$List$repeat,
				ns - $elm$core$List$length(hs),
				''));
	});
var $tripokey$elm_fuzzy$Fuzzy$reduceLeft = F3(
	function (ns, c, hs) {
		return _Utils_Tuple2(
			A3(
				$elm$core$List$foldl,
				F2(
					function (e, sum) {
						return $elm$core$String$length(e) + sum;
					}),
				0,
				A2($elm$core$List$take, c, hs)),
			A2($elm$core$List$drop, c, hs));
	});
var $tripokey$elm_fuzzy$Fuzzy$reduceRight = F3(
	function (ns, c, hs) {
		return A2(
			$elm$core$List$take,
			$elm$core$List$length(hs) - ((ns - c) - 1),
			hs);
	});
var $tripokey$elm_fuzzy$Fuzzy$match = F4(
	function (configs, separators, needle, hay) {
		var reduceHays = F3(
			function (ns, c, hs) {
				return A3(
					$tripokey$elm_fuzzy$Fuzzy$reduceLeft,
					ns,
					c,
					A3(
						$tripokey$elm_fuzzy$Fuzzy$reduceRight,
						ns,
						c,
						A2($tripokey$elm_fuzzy$Fuzzy$padHays, ns, hs)));
			});
		var needles = A2(
			$tripokey$elm_fuzzy$Fuzzy$dissect,
			separators,
			_List_fromArray(
				[needle]));
		var initialResult = A2($tripokey$elm_fuzzy$Fuzzy$Result, 0, _List_Nil);
		var hays = A2(
			$tripokey$elm_fuzzy$Fuzzy$dissect,
			separators,
			_List_fromArray(
				[hay]));
		var accumulateConfig = F2(
			function (c, sum) {
				switch (c.$) {
					case 0:
						var val = c.a;
						return _Utils_update(
							sum,
							{e8: val});
					case 1:
						var val = c.a;
						return _Utils_update(
							sum,
							{fZ: val});
					case 2:
						var val = c.a;
						return _Utils_update(
							sum,
							{fH: val});
					default:
						var val = c.a;
						return _Utils_update(
							sum,
							{fy: val});
				}
			});
		var config = A3($elm$core$List$foldl, accumulateConfig, $tripokey$elm_fuzzy$Fuzzy$defaultConfig, configs);
		var minScore = F2(
			function (n, _v2) {
				var offset = _v2.a;
				var hs = _v2.b;
				var initialPenalty = ((($elm$core$String$length(n) * config.fZ) + ($elm$core$String$length(n) * config.fH)) + ($elm$core$String$length(hay) * config.e8)) + (($elm$core$String$length(hay) * $elm$core$String$length(n)) * config.fy);
				var initialMatch = A4($tripokey$elm_fuzzy$Fuzzy$Match, initialPenalty, offset, 0, _List_Nil);
				var accumulateMatch = F2(
					function (e, _v1) {
						var prev = _v1.a;
						var prevOffset = _v1.b;
						var newOffset = prevOffset + $elm$core$String$length(e);
						var eDistance = A3($tripokey$elm_fuzzy$Fuzzy$distance, config, n, e);
						var newMatch = (_Utils_cmp(eDistance.kI, prev.kI) < 0) ? _Utils_update(
							eDistance,
							{d0: prevOffset}) : prev;
						return _Utils_Tuple2(newMatch, newOffset);
					});
				return A3(
					$elm$core$List$foldl,
					accumulateMatch,
					_Utils_Tuple2(initialMatch, offset),
					hs).a;
			});
		var accumulateResult = F2(
			function (n, _v0) {
				var prev = _v0.a;
				var num = _v0.b;
				var matchResult = A2(
					minScore,
					n,
					A3(
						reduceHays,
						$elm$core$List$length(needles),
						num,
						hays));
				var newResult = _Utils_update(
					prev,
					{
						gW: _Utils_ap(
							prev.gW,
							_List_fromArray(
								[matchResult])),
						kI: matchResult.kI + prev.kI
					});
				return _Utils_Tuple2(newResult, num + 1);
			});
		return A3(
			$elm$core$List$foldl,
			accumulateResult,
			_Utils_Tuple2(initialResult, 0),
			needles).a;
	});
var $author$project$Utils$FuzzySearch$getRankedList = F3(
	function (needleString, aToString, thing) {
		var score = A4(
			$tripokey$elm_fuzzy$Fuzzy$match,
			_List_Nil,
			_List_Nil,
			$elm$core$String$toLower(needleString),
			$elm$core$String$toLower(
				aToString(thing))).kI;
		return _Utils_Tuple2(score, thing);
	});
var $author$project$Utils$FuzzySearch$scoreUnderN = F2(
	function (limit, _v0) {
		var x = _v0.a;
		return _Utils_cmp(x, limit) < 0;
	});
var $author$project$Utils$FuzzySearch$takeN = F2(
	function (maxNumberOfSuggestions, listA) {
		return _Utils_eq(maxNumberOfSuggestions, -1) ? listA : A2($elm$core$List$take, maxNumberOfSuggestions, listA);
	});
var $author$project$Utils$FuzzySearch$fuzzySearch = F3(
	function (config, searchString, things) {
		var rankedList = A2(
			$elm$core$List$map,
			A2($author$project$Utils$FuzzySearch$getRankedList, searchString, config.jP),
			things);
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var tag = _v1.b;
				return tag;
			},
			A2(
				$author$project$Utils$FuzzySearch$takeN,
				config.j2,
				A2(
					$elm$core$List$sortBy,
					function (_v0) {
						var score = _v0.a;
						return score;
					},
					A2(
						$elm$core$List$filter,
						$author$project$Utils$FuzzySearch$scoreUnderN(2500),
						rankedList))));
	});
var $author$project$Environments$Environment$getCurrentOrganisationUnit = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.fk;
	});
var $author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit = function (organisationUnitId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$OrganisationUnit$OrganisationUnits$hierarchy,
		$author$project$OrganisationUnit$Hierarchy$getOrganisationUnit(organisationUnitId));
};
var $author$project$Environments$Environment$getSeeAll = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.f4;
	});
var $author$project$Audit$Audit$filter = F4(
	function (environment, searchValue, organisationUnits, audits) {
		var filteredSearched = $elm$core$String$isEmpty(searchValue) ? audits : A3(
			$author$project$Utils$FuzzySearch$fuzzySearch,
			{
				jP: function (audit) {
					return audit.fw + (' ' + audit.k8);
				},
				j2: -1
			},
			searchValue,
			audits);
		return $author$project$Environments$Environment$getSeeAll(environment) ? filteredSearched : A2(
			$elm$core$Maybe$withDefault,
			filteredSearched,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Audit$Audit$filterAuditsOfCurrentOrganisationUnit, organisationUnits, filteredSearched),
				A2(
					$elm$core$Maybe$andThen,
					A2($author$project$Utils$Utils$flip, $author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, organisationUnits),
					$author$project$Environments$Environment$getCurrentOrganisationUnit(environment))));
	});
var $author$project$OrganisationUnit$Dict$insert = A2(
	$author$project$Utils$Utils$with,
	function ($) {
		return $.km;
	},
	$turboMaCk$any_dict$Dict$Any$insert);
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$mapOrganisationUnits = F2(
	function (fn, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				kn: fn(data.kn)
			});
	});
var $author$project$OrganisationUnit$Modifications$Empty = function (a) {
	return {$: 0, a: a};
};
var $author$project$OrganisationUnit$Modifications$NotEmpty = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$Modifications$withChangedOrganisationUnit = F2(
	function (organisationUnit, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$OrganisationUnit$Modifications$Empty(
				_Utils_update(
					data,
					{
						hC: A2($author$project$OrganisationUnit$Dict$insert, organisationUnit, data.hC)
					}));
		} else {
			var data = modifications.a;
			return $author$project$OrganisationUnit$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						hC: A2($author$project$OrganisationUnit$Dict$insert, organisationUnit, data.hC)
					}));
		}
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$insertOrganisationUnit = function (organisationUnit) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Tuple$mapFirst(
			$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$mapOrganisationUnits(
				$author$project$OrganisationUnit$Dict$insert(organisationUnit))),
		$elm$core$Tuple$mapSecond(
			$author$project$OrganisationUnit$Modifications$withChangedOrganisationUnit(organisationUnit)));
};
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit = F3(
	function (organisationUnitId, fn, acc) {
		return A2(
			$elm$core$Maybe$withDefault,
			acc,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					fn,
					A2($author$project$Utils$Utils$flip, $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$insertOrganisationUnit, acc)),
				A2($author$project$OrganisationUnit$Hierarchy$getOrganisationUnit, organisationUnitId, acc.a)));
	});
var $author$project$OrganisationUnit$OrganisationUnit$withFirstGroup = F2(
	function (firstGroup, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{ao: firstGroup});
	});
var $author$project$OrganisationUnit$OrganisationUnit$withLastGroup = F2(
	function (lastGroup, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{jU: lastGroup});
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$addNewCheckpointGroup = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(payload.kw, payload.kc);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				return acc;
			} else {
				var _v1 = _v0.b;
				return A3(
					$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
					payload.km,
					$author$project$OrganisationUnit$OrganisationUnit$withLastGroup(
						$elm$core$Maybe$Just(payload.cC)),
					acc);
			}
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				return A3(
					$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
					payload.km,
					$author$project$OrganisationUnit$OrganisationUnit$withFirstGroup(
						$elm$core$Maybe$Just(payload.cC)),
					acc);
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return A3(
					$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
					payload.km,
					A2(
						$elm$core$Basics$composeR,
						$author$project$OrganisationUnit$OrganisationUnit$withFirstGroup(
							$elm$core$Maybe$Just(payload.cC)),
						$author$project$OrganisationUnit$OrganisationUnit$withLastGroup(
							$elm$core$Maybe$Just(payload.cC))),
					acc);
			}
		}
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$mapHierarchy = F2(
	function (fn, _v0) {
		var data = _v0.a;
		var modifications = _v0.b;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (hierarchy_) {
				return _Utils_update(
					data,
					{a8: hierarchy_});
			},
			fn(
				_Utils_Tuple2(data.a8, modifications)));
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyCheckpointGroupCreatedEvent = F2(
	function (payload, acc) {
		return A2(
			$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$mapHierarchy,
			$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$addNewCheckpointGroup(payload),
			acc);
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$deleteCheckpointGroup = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(payload.kw, payload.kc);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				return acc;
			} else {
				var _v1 = _v0.b;
				return A3(
					$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
					payload.km,
					$author$project$OrganisationUnit$OrganisationUnit$withLastGroup(payload.kw),
					acc);
			}
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				return A3(
					$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
					payload.km,
					$author$project$OrganisationUnit$OrganisationUnit$withFirstGroup(payload.kc),
					acc);
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return A3(
					$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
					payload.km,
					A2(
						$elm$core$Basics$composeR,
						$author$project$OrganisationUnit$OrganisationUnit$withFirstGroup($elm$core$Maybe$Nothing),
						$author$project$OrganisationUnit$OrganisationUnit$withLastGroup($elm$core$Maybe$Nothing)),
					acc);
			}
		}
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyCheckpointGroupDeletedEvent = F2(
	function (payload, acc) {
		return A2(
			$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$mapHierarchy,
			$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$deleteCheckpointGroup(payload),
			acc);
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$moveCheckpointGroupAfter = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple3(payload.fJ, payload.c4, payload.c5);
		_v0$4:
		while (true) {
			if (_v0.a.$ === 1) {
				if (!_v0.b.$) {
					if (!_v0.c.$) {
						var _v2 = _v0.a;
						return A3(
							$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
							payload.km,
							$author$project$OrganisationUnit$OrganisationUnit$withLastGroup(
								$elm$core$Maybe$Just(payload.cC)),
							acc);
					} else {
						var _v3 = _v0.a;
						var _v4 = _v0.c;
						return A3(
							$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
							payload.km,
							A2(
								$elm$core$Basics$composeR,
								$author$project$OrganisationUnit$OrganisationUnit$withFirstGroup(payload.c4),
								$author$project$OrganisationUnit$OrganisationUnit$withLastGroup(
									$elm$core$Maybe$Just(payload.cC))),
							acc);
					}
				} else {
					break _v0$4;
				}
			} else {
				if (!_v0.b.$) {
					if (_v0.c.$ === 1) {
						var _v1 = _v0.c;
						return A3(
							$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
							payload.km,
							$author$project$OrganisationUnit$OrganisationUnit$withFirstGroup(payload.c4),
							acc);
					} else {
						break _v0$4;
					}
				} else {
					if (!_v0.c.$) {
						var _v5 = _v0.b;
						return A3(
							$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
							payload.km,
							$author$project$OrganisationUnit$OrganisationUnit$withLastGroup(payload.c5),
							acc);
					} else {
						break _v0$4;
					}
				}
			}
		}
		return acc;
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyMoveCheckpointGroupAfterEvent = F2(
	function (payload, acc) {
		return A2(
			$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$mapHierarchy,
			$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$moveCheckpointGroupAfter(payload),
			acc);
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$moveCheckpointGroupBefore = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple3(payload.d_, payload.c4, payload.c5);
		_v0$4:
		while (true) {
			if (!_v0.a.$) {
				if (_v0.b.$ === 1) {
					if (!_v0.c.$) {
						var _v1 = _v0.b;
						return A3(
							$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
							payload.km,
							$author$project$OrganisationUnit$OrganisationUnit$withLastGroup(payload.c5),
							acc);
					} else {
						break _v0$4;
					}
				} else {
					if (_v0.c.$ === 1) {
						var _v2 = _v0.c;
						return A3(
							$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
							payload.km,
							$author$project$OrganisationUnit$OrganisationUnit$withFirstGroup(payload.c4),
							acc);
					} else {
						break _v0$4;
					}
				}
			} else {
				if (_v0.b.$ === 1) {
					if (!_v0.c.$) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return A3(
							$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
							payload.km,
							A2(
								$elm$core$Basics$composeR,
								$author$project$OrganisationUnit$OrganisationUnit$withFirstGroup(
									$elm$core$Maybe$Just(payload.cC)),
								$author$project$OrganisationUnit$OrganisationUnit$withLastGroup(payload.c5)),
							acc);
					} else {
						break _v0$4;
					}
				} else {
					if (!_v0.c.$) {
						var _v5 = _v0.a;
						return A3(
							$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$updateOrganisationUnit,
							payload.km,
							$author$project$OrganisationUnit$OrganisationUnit$withFirstGroup(
								$elm$core$Maybe$Just(payload.cC)),
							acc);
					} else {
						break _v0$4;
					}
				}
			}
		}
		return acc;
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyMoveCheckpointGroupBeforeEvent = F2(
	function (payload, acc) {
		return A2(
			$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$mapHierarchy,
			$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$moveCheckpointGroupBefore(payload),
			acc);
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyEventHelper = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyCheckpointGroupCreatedEvent(payload);
		case 3:
			var payload = event.a;
			return $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyMoveCheckpointGroupBeforeEvent(payload);
		case 4:
			var payload = event.a;
			return $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyMoveCheckpointGroupAfterEvent(payload);
		case 5:
			var payload = event.a;
			return $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyCheckpointGroupDeletedEvent(payload);
		default:
			return $elm$core$Basics$identity;
	}
};
var $author$project$CheckpointData$Events$fold = $author$project$Types$Queue$fold;
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyEventsHelper = F2(
	function (events, acc) {
		return A3($author$project$CheckpointData$Events$fold, $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyEventHelper, acc, events);
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$getChangedOrganisationUnitDictFromModifications = function (modifications) {
	if (!modifications.$) {
		var data = modifications.a;
		return data.hC;
	} else {
		var data = modifications.a;
		return data.hC;
	}
};
var $author$project$OrganisationUnit$Dict$isEmpty = $turboMaCk$any_dict$Dict$Any$isEmpty;
var $author$project$OrganisationUnit$OrganisationUnits$lastEventId = A2(
	$elm$core$Basics$composeR,
	$author$project$OrganisationUnit$OrganisationUnits$unwrap,
	function ($) {
		return $.fD;
	});
var $author$project$OrganisationUnit$Modifications$withLastEventId = F2(
	function (lastEventId, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$OrganisationUnit$Modifications$NotEmpty(
				{hC: data.hC, dB: data.dB, eC: data.eC, fD: lastEventId, eI: data.eI});
		} else {
			var data = modifications.a;
			return $author$project$OrganisationUnit$Modifications$NotEmpty(
				_Utils_update(
					data,
					{fD: lastEventId}));
		}
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$changeModificationsWhenDataHasChanged = function (_v0) {
	var organisationUnits = _v0.a;
	var modifications = _v0.b;
	var _v1 = _Utils_Tuple3(
		$author$project$OrganisationUnit$Dict$isEmpty(
			$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$getChangedOrganisationUnitDictFromModifications(modifications)),
		$author$project$OrganisationUnit$OrganisationUnits$lastEventId(organisationUnits),
		modifications);
	if (((!_v1.a) && (!_v1.b.$)) && (!_v1.c.$)) {
		var lastEventId = _v1.b.a;
		return _Utils_Tuple2(
			organisationUnits,
			A2($author$project$OrganisationUnit$Modifications$withLastEventId, lastEventId, modifications));
	} else {
		return _Utils_Tuple2(organisationUnits, modifications);
	}
};
var $author$project$OrganisationUnit$Modifications$empty = F2(
	function (firstId, lastId) {
		return $author$project$OrganisationUnit$Modifications$Empty(
			{hC: $author$project$OrganisationUnit$Dict$empty, dB: $author$project$OrganisationUnit$Dict$empty, eC: firstId, fD: $elm$core$Maybe$Nothing, eI: lastId});
	});
var $author$project$OrganisationUnit$Hierarchy$firstId = A2(
	$elm$core$Basics$composeR,
	$author$project$OrganisationUnit$Hierarchy$unwrap,
	function ($) {
		return $.eC;
	});
var $author$project$OrganisationUnit$Hierarchy$lastId = A2(
	$elm$core$Basics$composeR,
	$author$project$OrganisationUnit$Hierarchy$unwrap,
	function ($) {
		return $.eI;
	});
var $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyEvents = F2(
	function (events, _v0) {
		var organisationUnits = _v0.a;
		var maybeModifications = _v0.b;
		var modifications = function () {
			if (!maybeModifications.$) {
				var modifications_ = maybeModifications.a;
				return modifications_;
			} else {
				var lastId = $author$project$OrganisationUnit$Hierarchy$lastId(
					$author$project$OrganisationUnit$OrganisationUnits$hierarchy(organisationUnits));
				var firstId = $author$project$OrganisationUnit$Hierarchy$firstId(
					$author$project$OrganisationUnit$OrganisationUnits$hierarchy(organisationUnits));
				return A2($author$project$OrganisationUnit$Modifications$empty, firstId, lastId);
			}
		}();
		return $author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$changeModificationsWhenDataHasChanged(
			A2(
				$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyEventsHelper,
				events,
				_Utils_Tuple2(organisationUnits, modifications)));
	});
var $author$project$File$Operation$CreateOrganisationUnitFloorPlan = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$OrganisationUnit$OrganisationUnit$setAsFirst = function (organisationUnit) {
	return _Utils_update(
		organisationUnit,
		{ay: $elm$core$Maybe$Nothing});
};
var $author$project$OrganisationUnit$OrganisationUnit$setAsLast = function (organisationUnit) {
	return _Utils_update(
		organisationUnit,
		{ax: $elm$core$Maybe$Nothing});
};
var $author$project$OrganisationUnit$OrganisationUnit$setAsRoot = function (organisationUnit) {
	return _Utils_update(
		organisationUnit,
		{fV: $elm$core$Maybe$Nothing});
};
var $author$project$Utils$Triple$mapFirst = F2(
	function (fn, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			fn(a),
			b,
			c);
	});
var $author$project$OrganisationUnit$Hierarchy$mapOrganisationUnits = F2(
	function (fn, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				kn: fn(data.kn)
			});
	});
var $author$project$Utils$Triple$mapSecond = F2(
	function (fn, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			a,
			fn(b),
			c);
	});
var $author$project$OrganisationUnit$Hierarchy$insertOrganisationUnit = function (organisationUnit) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$Triple$mapFirst(
			$author$project$OrganisationUnit$Hierarchy$mapOrganisationUnits(
				$author$project$OrganisationUnit$Dict$insert(organisationUnit))),
		$author$project$Utils$Triple$mapSecond(
			$author$project$OrganisationUnit$Modifications$withChangedOrganisationUnit(organisationUnit)));
};
var $author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit = F3(
	function (organisationUnitId, fn, acc) {
		return A2(
			$elm$core$Maybe$withDefault,
			acc,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					fn,
					A2($author$project$Utils$Utils$flip, $author$project$OrganisationUnit$Hierarchy$insertOrganisationUnit, acc)),
				A2(
					$author$project$OrganisationUnit$Hierarchy$getOrganisationUnit,
					organisationUnitId,
					$author$project$Utils$Triple$first(acc))));
	});
var $author$project$OrganisationUnit$OrganisationUnit$withFirstChild = F2(
	function (firstChildId, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{
				hV: $elm$core$Maybe$Just(firstChildId)
			});
	});
var $author$project$OrganisationUnit$Modifications$withFirstId = F2(
	function (firstId, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$OrganisationUnit$Modifications$Empty(
				_Utils_update(
					data,
					{eC: firstId}));
		} else {
			var data = modifications.a;
			return $author$project$OrganisationUnit$Modifications$NotEmpty(
				_Utils_update(
					data,
					{eC: firstId}));
		}
	});
var $author$project$OrganisationUnit$Hierarchy$withFirstId = F2(
	function (firstId_, _v0) {
		var data = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				data,
				{eC: firstId_}),
			A2($author$project$OrganisationUnit$Modifications$withFirstId, firstId_, modifications),
			fileOperations);
	});
var $author$project$OrganisationUnit$OrganisationUnit$withLastChild = F2(
	function (lastChildId, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{
				fC: $elm$core$Maybe$Just(lastChildId)
			});
	});
var $author$project$OrganisationUnit$Modifications$withLastId = F2(
	function (lastId, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$OrganisationUnit$Modifications$Empty(
				_Utils_update(
					data,
					{eI: lastId}));
		} else {
			var data = modifications.a;
			return $author$project$OrganisationUnit$Modifications$NotEmpty(
				_Utils_update(
					data,
					{eI: lastId}));
		}
	});
var $author$project$OrganisationUnit$Hierarchy$withLastId = F2(
	function (lastId_, _v0) {
		var data = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				data,
				{eI: lastId_}),
			A2($author$project$OrganisationUnit$Modifications$withLastId, lastId_, modifications),
			fileOperations);
	});
var $author$project$OrganisationUnit$OrganisationUnit$withNext = F2(
	function (nextId, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{
				ax: $elm$core$Maybe$Just(nextId)
			});
	});
var $author$project$OrganisationUnit$OrganisationUnit$withParent = F2(
	function (parentId, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{
				fV: $elm$core$Maybe$Just(parentId)
			});
	});
var $author$project$OrganisationUnit$OrganisationUnit$withPrevious = F2(
	function (previousId, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{
				ay: $elm$core$Maybe$Just(previousId)
			});
	});
var $author$project$OrganisationUnit$OrganisationUnit$withRevision = F2(
	function (revision_, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{i: revision_});
	});
var $author$project$OrganisationUnit$Hierarchy$attachOrganisationUnit = function (payload) {
	var _v0 = _Utils_Tuple3(payload.fV, payload.ay, payload.ax);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			if (!_v0.c.$) {
				var parentId = _v0.a.a;
				var previousId = _v0.b.a;
				var nextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						payload.km,
						A2(
							$elm$core$Basics$composeR,
							$author$project$OrganisationUnit$OrganisationUnit$withParent(parentId),
							A2(
								$elm$core$Basics$composeR,
								$author$project$OrganisationUnit$OrganisationUnit$withPrevious(previousId),
								A2(
									$elm$core$Basics$composeR,
									$author$project$OrganisationUnit$OrganisationUnit$withNext(nextId),
									$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.i))))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
							previousId,
							$author$project$OrganisationUnit$OrganisationUnit$withNext(payload.km)),
						A2(
							$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
							nextId,
							$author$project$OrganisationUnit$OrganisationUnit$withPrevious(payload.km))));
			} else {
				var parentId = _v0.a.a;
				var previousId = _v0.b.a;
				var _v1 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						payload.km,
						A2(
							$elm$core$Basics$composeR,
							$author$project$OrganisationUnit$OrganisationUnit$withParent(parentId),
							A2(
								$elm$core$Basics$composeR,
								$author$project$OrganisationUnit$OrganisationUnit$withPrevious(previousId),
								A2(
									$elm$core$Basics$composeR,
									$author$project$OrganisationUnit$OrganisationUnit$setAsLast,
									$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.i))))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
							parentId,
							$author$project$OrganisationUnit$OrganisationUnit$withLastChild(payload.km)),
						A2(
							$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
							previousId,
							$author$project$OrganisationUnit$OrganisationUnit$withNext(payload.km))));
			}
		} else {
			if (!_v0.c.$) {
				var parentId = _v0.a.a;
				var _v2 = _v0.b;
				var nextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						payload.km,
						A2(
							$elm$core$Basics$composeR,
							$author$project$OrganisationUnit$OrganisationUnit$withParent(parentId),
							A2(
								$elm$core$Basics$composeR,
								$author$project$OrganisationUnit$OrganisationUnit$setAsFirst,
								A2(
									$elm$core$Basics$composeR,
									$author$project$OrganisationUnit$OrganisationUnit$withNext(nextId),
									$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.i))))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
							parentId,
							$author$project$OrganisationUnit$OrganisationUnit$withFirstChild(payload.km)),
						A2(
							$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
							nextId,
							$author$project$OrganisationUnit$OrganisationUnit$withPrevious(payload.km))));
			} else {
				var parentId = _v0.a.a;
				var _v3 = _v0.b;
				var _v4 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						payload.km,
						A2(
							$elm$core$Basics$composeR,
							$author$project$OrganisationUnit$OrganisationUnit$withParent(parentId),
							A2(
								$elm$core$Basics$composeR,
								$author$project$OrganisationUnit$OrganisationUnit$setAsFirst,
								A2(
									$elm$core$Basics$composeR,
									$author$project$OrganisationUnit$OrganisationUnit$setAsLast,
									$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.i))))),
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						parentId,
						A2(
							$elm$core$Basics$composeR,
							$author$project$OrganisationUnit$OrganisationUnit$withFirstChild(payload.km),
							$author$project$OrganisationUnit$OrganisationUnit$withLastChild(payload.km))));
			}
		}
	} else {
		if (!_v0.b.$) {
			if (!_v0.c.$) {
				var _v5 = _v0.a;
				var previousId = _v0.b.a;
				var nextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						payload.km,
						A2(
							$elm$core$Basics$composeR,
							$author$project$OrganisationUnit$OrganisationUnit$setAsRoot,
							A2(
								$elm$core$Basics$composeR,
								$author$project$OrganisationUnit$OrganisationUnit$withPrevious(previousId),
								A2(
									$elm$core$Basics$composeR,
									$author$project$OrganisationUnit$OrganisationUnit$withNext(nextId),
									$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.i))))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
							previousId,
							$author$project$OrganisationUnit$OrganisationUnit$withNext(payload.km)),
						A2(
							$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
							nextId,
							$author$project$OrganisationUnit$OrganisationUnit$withPrevious(payload.km))));
			} else {
				var _v6 = _v0.a;
				var previousId = _v0.b.a;
				var _v7 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						payload.km,
						A2(
							$elm$core$Basics$composeR,
							$author$project$OrganisationUnit$OrganisationUnit$setAsRoot,
							A2(
								$elm$core$Basics$composeR,
								$author$project$OrganisationUnit$OrganisationUnit$withPrevious(previousId),
								A2(
									$elm$core$Basics$composeR,
									$author$project$OrganisationUnit$OrganisationUnit$setAsLast,
									$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.i))))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
							previousId,
							$author$project$OrganisationUnit$OrganisationUnit$withNext(payload.km)),
						$author$project$OrganisationUnit$Hierarchy$withLastId(
							$elm$core$Maybe$Just(payload.km))));
			}
		} else {
			if (!_v0.c.$) {
				var _v8 = _v0.a;
				var _v9 = _v0.b;
				var nextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						payload.km,
						A2(
							$elm$core$Basics$composeR,
							$author$project$OrganisationUnit$OrganisationUnit$setAsRoot,
							A2(
								$elm$core$Basics$composeR,
								$author$project$OrganisationUnit$OrganisationUnit$setAsFirst,
								A2(
									$elm$core$Basics$composeR,
									$author$project$OrganisationUnit$OrganisationUnit$withNext(nextId),
									$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.i))))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
							nextId,
							$author$project$OrganisationUnit$OrganisationUnit$withPrevious(payload.km)),
						$author$project$OrganisationUnit$Hierarchy$withFirstId(
							$elm$core$Maybe$Just(payload.km))));
			} else {
				var _v10 = _v0.a;
				var _v11 = _v0.b;
				var _v12 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						payload.km,
						A2(
							$elm$core$Basics$composeR,
							$author$project$OrganisationUnit$OrganisationUnit$setAsRoot,
							A2(
								$elm$core$Basics$composeR,
								$author$project$OrganisationUnit$OrganisationUnit$setAsFirst,
								A2(
									$elm$core$Basics$composeR,
									$author$project$OrganisationUnit$OrganisationUnit$setAsLast,
									$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.i))))),
					A2(
						$elm$core$Basics$composeR,
						$author$project$OrganisationUnit$Hierarchy$withFirstId(
							$elm$core$Maybe$Just(payload.km)),
						$author$project$OrganisationUnit$Hierarchy$withLastId(
							$elm$core$Maybe$Just(payload.km))));
			}
		}
	}
};
var $author$project$OrganisationUnit$Hierarchy$createChild = F2(
	function (payload, _v0) {
		var hierarchy = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		var organisationUnit = {
			K: payload.K,
			aY: payload.aY,
			hV: $elm$core$Maybe$Nothing,
			ao: payload.ao,
			ap: payload.ap,
			fC: $elm$core$Maybe$Nothing,
			jU: payload.jU,
			ax: $elm$core$Maybe$Nothing,
			km: payload.km,
			fV: $elm$core$Maybe$Just(payload.fV),
			ay: payload.ay,
			i: payload.n,
			k8: payload.k8
		};
		var newFileOperations = A2(
			$elm$core$Maybe$withDefault,
			fileOperations,
			A2(
				$elm$core$Maybe$map,
				function (floorPlan) {
					return A2(
						$author$project$File$Operations$enqueue,
						A2($author$project$File$Operation$CreateOrganisationUnitFloorPlan, payload.km, floorPlan),
						fileOperations);
				},
				payload.ap));
		return A2(
			$author$project$OrganisationUnit$Hierarchy$attachOrganisationUnit,
			organisationUnit,
			A2(
				$author$project$OrganisationUnit$Hierarchy$insertOrganisationUnit,
				organisationUnit,
				_Utils_Tuple3(hierarchy, modifications, newFileOperations)));
	});
var $author$project$OrganisationUnit$OrganisationUnits$mapHierarchy = F2(
	function (fn, _v0) {
		var data = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		return A2(
			$author$project$Utils$Triple$mapFirst,
			function (hierarchy_) {
				return _Utils_update(
					data,
					{a8: hierarchy_});
			},
			fn(
				_Utils_Tuple3(data.a8, modifications, fileOperations)));
	});
var $author$project$OrganisationUnit$OrganisationUnits$withLastEventId = F2(
	function (lastEventId_, _v0) {
		var data = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				data,
				{
					fD: $elm$core$Maybe$Just(lastEventId_)
				}),
			A2($author$project$OrganisationUnit$Modifications$withLastEventId, lastEventId_, modifications),
			fileOperations);
	});
var $author$project$OrganisationUnit$OrganisationUnits$applyChildCreatedEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			return acc;
		} else {
			return A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$createChild(payload),
					acc));
		}
	});
var $author$project$OrganisationUnit$OrganisationUnit$withColor = F2(
	function (color_, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{K: color_});
	});
var $author$project$OrganisationUnit$Hierarchy$changeColor = function (payload) {
	return A2(
		$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
		payload.km,
		A2(
			$elm$core$Basics$composeR,
			$author$project$OrganisationUnit$OrganisationUnit$withColor(payload.K),
			$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.n)));
};
var $author$project$OrganisationUnit$OrganisationUnits$applyColorChangedEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			return (_Utils_cmp(payload.n, organisationUnit.i) > 0) ? A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$changeColor(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$OrganisationUnit$Hierarchy$createAfter = F2(
	function (payload, _v0) {
		var hierarchy = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		var organisationUnit = {
			K: payload.K,
			aY: payload.aY,
			hV: $elm$core$Maybe$Nothing,
			ao: payload.ao,
			ap: payload.ap,
			fC: $elm$core$Maybe$Nothing,
			jU: payload.jU,
			ax: payload.ax,
			km: payload.km,
			fV: payload.fV,
			ay: $elm$core$Maybe$Just(payload.ay),
			i: payload.n,
			k8: payload.k8
		};
		var newFileOperations = A2(
			$elm$core$Maybe$withDefault,
			fileOperations,
			A2(
				$elm$core$Maybe$map,
				function (floorPlan) {
					return A2(
						$author$project$File$Operations$enqueue,
						A2($author$project$File$Operation$CreateOrganisationUnitFloorPlan, payload.km, floorPlan),
						fileOperations);
				},
				payload.ap));
		return A2(
			$author$project$OrganisationUnit$Hierarchy$attachOrganisationUnit,
			organisationUnit,
			A2(
				$author$project$OrganisationUnit$Hierarchy$insertOrganisationUnit,
				organisationUnit,
				_Utils_Tuple3(hierarchy, modifications, newFileOperations)));
	});
var $author$project$OrganisationUnit$OrganisationUnits$applyCreatedAfterEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			return acc;
		} else {
			return A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$createAfter(payload),
					acc));
		}
	});
var $author$project$OrganisationUnit$Hierarchy$createBefore = F2(
	function (payload, _v0) {
		var hierarchy = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		var organisationUnit = {
			K: payload.K,
			aY: payload.aY,
			hV: $elm$core$Maybe$Nothing,
			ao: payload.ao,
			ap: payload.ap,
			fC: $elm$core$Maybe$Nothing,
			jU: payload.jU,
			ax: $elm$core$Maybe$Just(payload.ax),
			km: payload.km,
			fV: payload.fV,
			ay: payload.ay,
			i: payload.n,
			k8: payload.k8
		};
		var newFileOperations = A2(
			$elm$core$Maybe$withDefault,
			fileOperations,
			A2(
				$elm$core$Maybe$map,
				function (floorPlan) {
					return A2(
						$author$project$File$Operations$enqueue,
						A2($author$project$File$Operation$CreateOrganisationUnitFloorPlan, payload.km, floorPlan),
						fileOperations);
				},
				payload.ap));
		return A2(
			$author$project$OrganisationUnit$Hierarchy$attachOrganisationUnit,
			organisationUnit,
			A2(
				$author$project$OrganisationUnit$Hierarchy$insertOrganisationUnit,
				organisationUnit,
				_Utils_Tuple3(hierarchy, modifications, newFileOperations)));
	});
var $author$project$OrganisationUnit$OrganisationUnits$applyCreatedBeforeEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			return acc;
		} else {
			return A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$createBefore(payload),
					acc));
		}
	});
var $author$project$OrganisationUnit$Hierarchy$create = F2(
	function (payload, _v0) {
		var hierarchy = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		var organisationUnit = {K: payload.K, aY: payload.aY, hV: $elm$core$Maybe$Nothing, ao: payload.ao, ap: payload.ap, fC: $elm$core$Maybe$Nothing, jU: payload.jU, ax: $elm$core$Maybe$Nothing, km: payload.km, fV: $elm$core$Maybe$Nothing, ay: payload.ay, i: payload.n, k8: payload.k8};
		var newFileOperations = A2(
			$elm$core$Maybe$withDefault,
			fileOperations,
			A2(
				$elm$core$Maybe$map,
				function (floorPlan) {
					return A2(
						$author$project$File$Operations$enqueue,
						A2($author$project$File$Operation$CreateOrganisationUnitFloorPlan, payload.km, floorPlan),
						fileOperations);
				},
				payload.ap));
		return A2(
			$author$project$OrganisationUnit$Hierarchy$attachOrganisationUnit,
			organisationUnit,
			A2(
				$author$project$OrganisationUnit$Hierarchy$insertOrganisationUnit,
				organisationUnit,
				_Utils_Tuple3(hierarchy, modifications, newFileOperations)));
	});
var $author$project$OrganisationUnit$OrganisationUnits$applyCreatedEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			return acc;
		} else {
			return A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$create(payload),
					acc));
		}
	});
var $author$project$OrganisationUnit$OrganisationUnit$removeChildren = function (organisationUnit) {
	return _Utils_update(
		organisationUnit,
		{hV: $elm$core$Maybe$Nothing, fC: $elm$core$Maybe$Nothing});
};
var $author$project$OrganisationUnit$Hierarchy$detachOrganisationUnit = function (payload) {
	var _v0 = _Utils_Tuple3(payload.g1, payload.c5, payload.c4);
	if (!_v0.b.$) {
		if (!_v0.c.$) {
			var oldPreviousId = _v0.b.a;
			var oldNextId = _v0.c.a;
			return A2(
				$elm$core$Basics$composeR,
				A2(
					$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
					oldPreviousId,
					$author$project$OrganisationUnit$OrganisationUnit$withNext(oldNextId)),
				A2(
					$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
					oldNextId,
					$author$project$OrganisationUnit$OrganisationUnit$withPrevious(oldPreviousId)));
		} else {
			if (!_v0.a.$) {
				var oldParentId = _v0.a.a;
				var oldPreviousId = _v0.b.a;
				var _v1 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						oldParentId,
						$author$project$OrganisationUnit$OrganisationUnit$withLastChild(oldPreviousId)),
					A2($author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit, oldPreviousId, $author$project$OrganisationUnit$OrganisationUnit$setAsLast));
			} else {
				var _v5 = _v0.a;
				var oldPreviousId = _v0.b.a;
				var _v6 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2($author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit, oldPreviousId, $author$project$OrganisationUnit$OrganisationUnit$setAsLast),
					$author$project$OrganisationUnit$Hierarchy$withLastId(
						$elm$core$Maybe$Just(oldPreviousId)));
			}
		}
	} else {
		if (!_v0.a.$) {
			if (!_v0.c.$) {
				var oldParentId = _v0.a.a;
				var _v2 = _v0.b;
				var oldNextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
						oldParentId,
						$author$project$OrganisationUnit$OrganisationUnit$withFirstChild(oldNextId)),
					A2($author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit, oldNextId, $author$project$OrganisationUnit$OrganisationUnit$setAsFirst));
			} else {
				var oldParentId = _v0.a.a;
				var _v3 = _v0.b;
				var _v4 = _v0.c;
				return A2($author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit, oldParentId, $author$project$OrganisationUnit$OrganisationUnit$removeChildren);
			}
		} else {
			if (!_v0.c.$) {
				var _v7 = _v0.a;
				var _v8 = _v0.b;
				var oldNextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2($author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit, oldNextId, $author$project$OrganisationUnit$OrganisationUnit$setAsFirst),
					$author$project$OrganisationUnit$Hierarchy$withFirstId(
						$elm$core$Maybe$Just(oldNextId)));
			} else {
				var _v9 = _v0.a;
				var _v10 = _v0.b;
				var _v11 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					$author$project$OrganisationUnit$Hierarchy$withFirstId($elm$core$Maybe$Nothing),
					$author$project$OrganisationUnit$Hierarchy$withLastId($elm$core$Maybe$Nothing));
			}
		}
	}
};
var $author$project$OrganisationUnit$Hierarchy$mapDeletedOrganisationUnits = F2(
	function (fn, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				dB: fn(data.dB)
			});
	});
var $author$project$OrganisationUnit$Dict$remove = $turboMaCk$any_dict$Dict$Any$remove;
var $author$project$OrganisationUnit$Modifications$mapDeletedOrganisationUnits = F2(
	function (fn, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$OrganisationUnit$Modifications$Empty(
				_Utils_update(
					data,
					{
						dB: fn(data.dB)
					}));
		} else {
			var data = modifications.a;
			return $author$project$OrganisationUnit$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						dB: fn(data.dB)
					}));
		}
	});
var $author$project$OrganisationUnit$Modifications$withDeletedOrganisationUnit = A2($elm$core$Basics$composeL, $author$project$OrganisationUnit$Modifications$mapDeletedOrganisationUnits, $author$project$OrganisationUnit$Dict$insert);
var $author$project$OrganisationUnit$Hierarchy$removeOrganisationUnit = F2(
	function (organisationUnitId, _v0) {
		var hierarchy = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		var _v1 = A2($author$project$OrganisationUnit$Hierarchy$getOrganisationUnit, organisationUnitId, hierarchy);
		if (!_v1.$) {
			var organisationUnit = _v1.a;
			var newFileOperations = A2(
				$elm$core$Maybe$withDefault,
				fileOperations,
				A2(
					$elm$core$Maybe$map,
					function (floorPlan) {
						return A2(
							$author$project$File$Operations$enqueue,
							A2($author$project$File$Operation$Delete, false, floorPlan),
							fileOperations);
					},
					organisationUnit.ap));
			return _Utils_Tuple3(
				A2(
					$author$project$OrganisationUnit$Hierarchy$mapDeletedOrganisationUnits,
					$author$project$OrganisationUnit$Dict$insert(organisationUnit),
					A2(
						$author$project$OrganisationUnit$Hierarchy$mapOrganisationUnits,
						$author$project$OrganisationUnit$Dict$remove(organisationUnitId),
						hierarchy)),
				A2($author$project$OrganisationUnit$Modifications$withDeletedOrganisationUnit, organisationUnit, modifications),
				newFileOperations);
		} else {
			return _Utils_Tuple3(hierarchy, modifications, fileOperations);
		}
	});
var $turboMaCk$any_dict$Dict$Any$foldl = F3(
	function (f, acc, _v0) {
		var dict = _v0.cL;
		return A3(
			$elm$core$Dict$foldl,
			F2(
				function (_v1, _v2) {
					var k = _v2.a;
					var v = _v2.b;
					return A2(f, k, v);
				}),
			acc,
			dict);
	});
var $turboMaCk$any_set$Set$Any$foldl = F3(
	function (f, init, _v0) {
		var dict = _v0;
		return A3(
			$turboMaCk$any_dict$Dict$Any$foldl,
			F3(
				function (x, _v1, acc) {
					return A2(f, x, acc);
				}),
			init,
			dict);
	});
var $author$project$OrganisationUnit$Ids$fold = $turboMaCk$any_set$Set$Any$foldl;
var $author$project$OrganisationUnit$Hierarchy$removeOrganisationUnits = F2(
	function (organisationUnitIds, acc) {
		return A3($author$project$OrganisationUnit$Ids$fold, $author$project$OrganisationUnit$Hierarchy$removeOrganisationUnit, acc, organisationUnitIds);
	});
var $author$project$OrganisationUnit$Hierarchy$delete = function (payload) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$OrganisationUnit$Hierarchy$detachOrganisationUnit(payload),
		A2(
			$elm$core$Basics$composeR,
			$author$project$OrganisationUnit$Hierarchy$removeOrganisationUnit(payload.km),
			$author$project$OrganisationUnit$Hierarchy$removeOrganisationUnits(payload.hK)));
};
var $author$project$OrganisationUnit$OrganisationUnits$applyDeletedEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			return (_Utils_cmp(payload.n, organisationUnit.i) > 0) ? A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$delete(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$OrganisationUnit$OrganisationUnit$withDescription = F2(
	function (description, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{aY: description});
	});
var $author$project$OrganisationUnit$Hierarchy$changeDescription = function (payload) {
	return A2(
		$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
		payload.km,
		A2(
			$elm$core$Basics$composeR,
			$author$project$OrganisationUnit$OrganisationUnit$withDescription(payload.aY),
			$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.n)));
};
var $author$project$OrganisationUnit$OrganisationUnits$applyDescriptionChangedEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			return (_Utils_cmp(payload.n, organisationUnit.i) > 0) ? A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$changeDescription(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$OrganisationUnit$Hierarchy$changeFloorPlan = F2(
	function (payload, _v0) {
		var hierarchy = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		var _v1 = A2($author$project$OrganisationUnit$Hierarchy$getOrganisationUnit, payload.km, hierarchy);
		if (!_v1.$) {
			var organisationUnit = _v1.a;
			var newOrganisationUnit = _Utils_update(
				organisationUnit,
				{ap: payload.fI, i: payload.n});
			var newFileOperations = function () {
				var _v2 = _Utils_Tuple2(payload.fI, payload.fM);
				if (!_v2.a.$) {
					if (!_v2.b.$) {
						var newFloorPlan = _v2.a.a;
						var oldFloorPlan = _v2.b.a;
						return A2(
							$author$project$File$Operations$enqueue,
							A2($author$project$File$Operation$Delete, true, oldFloorPlan),
							A2(
								$author$project$File$Operations$enqueue,
								A2($author$project$File$Operation$CreateOrganisationUnitFloorPlan, payload.km, newFloorPlan),
								fileOperations));
					} else {
						var newFloorPlan = _v2.a.a;
						var _v3 = _v2.b;
						return A2(
							$author$project$File$Operations$enqueue,
							A2($author$project$File$Operation$CreateOrganisationUnitFloorPlan, payload.km, newFloorPlan),
							fileOperations);
					}
				} else {
					if (!_v2.b.$) {
						var _v4 = _v2.a;
						var oldFloorPlan = _v2.b.a;
						return A2(
							$author$project$File$Operations$enqueue,
							A2($author$project$File$Operation$Delete, true, oldFloorPlan),
							fileOperations);
					} else {
						var _v5 = _v2.a;
						var _v6 = _v2.b;
						return fileOperations;
					}
				}
			}();
			return A2(
				$author$project$OrganisationUnit$Hierarchy$insertOrganisationUnit,
				newOrganisationUnit,
				_Utils_Tuple3(hierarchy, modifications, newFileOperations));
		} else {
			return _Utils_Tuple3(hierarchy, modifications, fileOperations);
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$applyFloorPlanChangedEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			return (_Utils_cmp(payload.n, organisationUnit.i) > 0) ? A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$changeFloorPlan(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$OrganisationUnit$Hierarchy$moveAfter = function (payload) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$OrganisationUnit$Hierarchy$detachOrganisationUnit(payload),
		$author$project$OrganisationUnit$Hierarchy$attachOrganisationUnit(
			{
				ax: payload.fJ,
				km: payload.km,
				fV: payload.dZ,
				ay: $elm$core$Maybe$Just(payload.d_),
				i: payload.n
			}));
};
var $author$project$OrganisationUnit$OrganisationUnits$applyMovedAfterEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			return (_Utils_cmp(payload.n, organisationUnit.i) > 0) ? A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$moveAfter(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$OrganisationUnit$Hierarchy$moveBefore = function (payload) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$OrganisationUnit$Hierarchy$detachOrganisationUnit(payload),
		$author$project$OrganisationUnit$Hierarchy$attachOrganisationUnit(
			{
				ax: $elm$core$Maybe$Just(payload.fJ),
				km: payload.km,
				fV: payload.dZ,
				ay: payload.d_,
				i: payload.n
			}));
};
var $author$project$OrganisationUnit$OrganisationUnits$applyMovedBeforeEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			return (_Utils_cmp(payload.n, organisationUnit.i) > 0) ? A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$moveBefore(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$OrganisationUnit$Hierarchy$move = function (payload) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$OrganisationUnit$Hierarchy$detachOrganisationUnit(payload),
		$author$project$OrganisationUnit$Hierarchy$attachOrganisationUnit(
			{
				ax: $elm$core$Maybe$Nothing,
				km: payload.km,
				fV: $elm$core$Maybe$Just(payload.dZ),
				ay: payload.d_,
				i: payload.n
			}));
};
var $author$project$OrganisationUnit$OrganisationUnits$applyMovedEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			return (_Utils_cmp(payload.n, organisationUnit.i) > 0) ? A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$move(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$OrganisationUnit$OrganisationUnit$withTitle = F2(
	function (title, organisationUnit) {
		return _Utils_update(
			organisationUnit,
			{k8: title});
	});
var $author$project$OrganisationUnit$Hierarchy$changeTitle = function (payload) {
	return A2(
		$author$project$OrganisationUnit$Hierarchy$updateOrganisationUnit,
		payload.km,
		A2(
			$elm$core$Basics$composeR,
			$author$project$OrganisationUnit$OrganisationUnit$withTitle(payload.k8),
			$author$project$OrganisationUnit$OrganisationUnit$withRevision(payload.n)));
};
var $author$project$OrganisationUnit$OrganisationUnits$applyTitleChangedEvent = F2(
	function (payload, acc) {
		var organisationUnits = acc.a;
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, organisationUnits);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			return (_Utils_cmp(payload.n, organisationUnit.i) > 0) ? A2(
				$author$project$OrganisationUnit$OrganisationUnits$withLastEventId,
				payload.N,
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$mapHierarchy,
					$author$project$OrganisationUnit$Hierarchy$changeTitle(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$applyEventHelper = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyCreatedEvent(payload);
		case 1:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyChildCreatedEvent(payload);
		case 2:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyCreatedBeforeEvent(payload);
		case 3:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyCreatedAfterEvent(payload);
		case 4:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyMovedEvent(payload);
		case 5:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyMovedBeforeEvent(payload);
		case 6:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyMovedAfterEvent(payload);
		case 7:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyTitleChangedEvent(payload);
		case 8:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyDescriptionChangedEvent(payload);
		case 9:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyColorChangedEvent(payload);
		case 10:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyFloorPlanChangedEvent(payload);
		default:
			var payload = event.a;
			return $author$project$OrganisationUnit$OrganisationUnits$applyDeletedEvent(payload);
	}
};
var $author$project$OrganisationUnit$Events$fold = $author$project$Types$Queue$fold;
var $author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper = F2(
	function (events, acc) {
		return A3($author$project$OrganisationUnit$Events$fold, $author$project$OrganisationUnit$OrganisationUnits$applyEventHelper, acc, events);
	});
var $author$project$OrganisationUnit$OrganisationUnits$applyEvents = F2(
	function (events, organisationUnits) {
		var lastId = $author$project$OrganisationUnit$Hierarchy$lastId(
			$author$project$OrganisationUnit$OrganisationUnits$hierarchy(organisationUnits));
		var firstId = $author$project$OrganisationUnit$Hierarchy$firstId(
			$author$project$OrganisationUnit$OrganisationUnits$hierarchy(organisationUnits));
		var modifications = A2($author$project$OrganisationUnit$Modifications$empty, firstId, lastId);
		return A2(
			$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
			events,
			_Utils_Tuple3(organisationUnits, modifications, $author$project$File$Operations$empty));
	});
var $author$project$CheckpointData$Store$events = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$CheckpointData$Events$empty;
		case 1:
			var data = state.a;
			return data.b8;
		case 2:
			var data = state.a;
			return data.b8;
		default:
			var data = state.a;
			return data.b8;
	}
};
var $author$project$OrganisationUnit$Store$events = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$OrganisationUnit$Events$empty;
		case 1:
			var data = state.a;
			return data.b8;
		case 2:
			var data = state.a;
			return data.b8;
		default:
			var data = state.a;
			return data.b8;
	}
};
var $author$project$OrganisationUnit$Store$organisationUnits = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$OrganisationUnit$OrganisationUnits$empty;
		case 1:
			return $author$project$OrganisationUnit$OrganisationUnits$empty;
		case 2:
			var data = state.a;
			return data.kn;
		default:
			var data = state.a;
			return data.kn;
	}
};
var $author$project$Environments$Repository$organisationUnits = function (_v0) {
	var data = _v0;
	var checkpointEvents = $author$project$CheckpointData$Store$events(data.C);
	return A2(
		$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyEvents,
		checkpointEvents,
		function (_v1) {
			var organisationUnits_ = _v1.a;
			var modifications = _v1.b;
			return _Utils_Tuple2(
				organisationUnits_,
				$elm$core$Maybe$Just(modifications));
		}(
			A2(
				$author$project$OrganisationUnit$OrganisationUnits$applyEvents,
				$author$project$OrganisationUnit$Store$events(data.T),
				$author$project$OrganisationUnit$Store$organisationUnits(data.T)))).a;
};
var $author$project$Archive$AuditArchiveContent$UserClickedViewAudit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Translations$Archive$completionTimestamp = F3(
	function (translations, date, time) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'archive.completionTimestamp',
			_List_fromArray(
				[
					_Utils_Tuple2('date', date),
					_Utils_Tuple2('time', time)
				]));
	});
var $author$project$Date_Time$NaiveTime$format = function (_v0) {
	var h = _v0.a;
	var m = _v0.b;
	var mm = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(m));
	var hh = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(h));
	return hh + (':' + mm);
};
var $author$project$OrganisationUnit$Hierarchy$organisationUnits = A2(
	$elm$core$Basics$composeR,
	$author$project$OrganisationUnit$Hierarchy$unwrap,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.kn;
		},
		$author$project$OrganisationUnit$Dict$values));
var $author$project$Archive$AuditArchiveContent$UserClickedEditIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Archive$AuditArchiveContent$viewEditIcon = function (auditId) {
	return A2(
		$author$project$UI$Icon$withOnClickStopPropagation,
		$author$project$Archive$AuditArchiveContent$UserClickedEditIcon(auditId),
		$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle));
};
var $author$project$UI$Table$Row$withId = F2(
	function (id, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{fw: id});
	});
var $author$project$UI$Table$Row$withOnClick = F2(
	function (msg, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				bJ: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$UI$Table$Row$withRightIcon = F2(
	function (icon, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				c9: _List_fromArray(
					[icon])
			});
	});
var $author$project$UI$Table$Row$withSubLabel = F2(
	function (subLabel, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{hh: subLabel});
	});
var $author$project$Archive$AuditArchiveContent$viewRow = F3(
	function (environment, repository, _v0) {
		var audit = _v0.a;
		var completionTimestamp = _v0.b;
		var withEditAudit = function (config) {
			var allowedToEditAudit = A2(
				$elm$core$List$member,
				true,
				A2(
					$elm$core$List$map,
					function (organisationUnitId) {
						return A3(
							$author$project$Auth$Authorization$authorize,
							$author$project$Environments$Environment$userRights(environment),
							7,
							organisationUnitId) || A3(
							$author$project$Auth$Authorization$authorize,
							$author$project$Environments$Environment$userRights(environment),
							9,
							organisationUnitId);
					},
					A2(
						$elm$core$List$map,
						function (organisationUnitId) {
							return organisationUnitId.km;
						},
						$author$project$OrganisationUnit$Hierarchy$organisationUnits(
							$author$project$OrganisationUnit$OrganisationUnits$hierarchy(
								$author$project$Environments$Repository$organisationUnits(repository))))));
			return allowedToEditAudit ? A2(
				$author$project$UI$Table$Row$withRightIcon,
				$author$project$Archive$AuditArchiveContent$viewEditIcon(audit.gm),
				config) : config;
		};
		var timeZone = $author$project$Environments$Environment$timeZone(environment);
		var deadlineTime = $author$project$Date_Time$NaiveTime$format(
			A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, completionTimestamp));
		var deadlineDate = $author$project$Date_Time$NaiveDate$format(
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, completionTimestamp));
		return withEditAudit(
			A2(
				$author$project$UI$Table$Row$withOnClick,
				$author$project$Archive$AuditArchiveContent$UserClickedViewAudit(audit.gm),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					A3(
						$author$project$Translations$Archive$completionTimestamp,
						$author$project$Environments$Environment$translations(environment),
						deadlineDate,
						deadlineTime),
					A2(
						$author$project$UI$Table$Row$withId,
						audit.fw,
						A3(
							$author$project$UI$Table$Row$row,
							$author$project$Environments$Environment$getViewType(environment),
							audit.k8,
							_Utils_Tuple2(audit, completionTimestamp))))));
	});
var $author$project$Archive$AuditArchiveContent$viewTable = F5(
	function (audits, searchValue, takeValue, environment, repository) {
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Archive$emptyText(
					$author$project$Environments$Environment$translations(environment)),
				A2(
					$author$project$UI$Table$fromList,
					A2($author$project$Archive$AuditArchiveContent$viewRow, environment, repository),
					A2(
						$elm$core$List$take,
						takeValue,
						$author$project$Archive$ArchivedAudits$auditsWithCompletionTimestamp(
							A4(
								$author$project$Audit$Audit$filter,
								environment,
								searchValue,
								$author$project$Environments$Repository$organisationUnits(repository),
								$author$project$Audit$Dict$values(audits)))))));
	});
var $author$project$Archive$AuditArchiveContent$viewLoaded = F4(
	function (environment, repository, model, searchValue) {
		var audits = $author$project$Archive$ArchivedAudits$dict(model.aA);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$Archive$AuditArchiveContent$viewTable, audits, searchValue, model.bF, environment, repository),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Archive$AuditArchiveContent$GotEditAuditDialogMsg,
					A3($author$project$Audit$EditDialog$view, environment, repository, model.cN))
				]));
	});
var $author$project$Translations$Archive$loadingAudits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.loadingAudits');
};
var $author$project$Archive$AuditArchiveContent$viewLoading = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Archive$loadingAudits(translations))
			]));
};
var $author$project$Archive$AuditArchiveContent$view = F4(
	function (environment, repository, content, searchValue) {
		switch (content.$) {
			case 0:
				return $author$project$Archive$AuditArchiveContent$viewLoading(environment);
			case 1:
				var model = content.a;
				return A4($author$project$Archive$AuditArchiveContent$viewLoaded, environment, repository, model, searchValue);
			default:
				return $author$project$Archive$AuditArchiveContent$viewError(environment);
		}
	});
var $author$project$Archive$CombinedArchiveContent$viewErrorText = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Archive$error(translations))
			]));
};
var $author$project$Archive$CombinedArchiveContent$viewError = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return A2(
		$author$project$UI$Page$view,
		environment,
		A2(
			$author$project$UI$Page$appendContent,
			$author$project$Archive$CombinedArchiveContent$viewErrorText(translations),
			A2(
				$author$project$UI$Page$withIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedDocument),
				$author$project$UI$Page$page(
					$author$project$Translations$Archive$combinedMainHeader(translations)))));
};
var $author$project$Archive$CombinedArchive$getCompletionTimestamp = function (value) {
	if (!value.$) {
		var audit = value.a;
		var _v1 = audit.jb;
		if (!_v1.$) {
			return $elm$core$Maybe$Nothing;
		} else {
			var posix = _v1.a;
			return $elm$core$Maybe$Just(posix);
		}
	} else {
		var measure = value.a;
		var _v2 = measure.jb;
		if (!_v2.$) {
			return $elm$core$Maybe$Nothing;
		} else {
			var posix = _v2.a;
			return $elm$core$Maybe$Just(posix);
		}
	}
};
var $author$project$Archive$CombinedArchive$valuesWithCompletionTimestamp = function (_v0) {
	var data = _v0;
	var addTuple = F2(
		function (value, acc) {
			var _v2 = $author$project$Archive$CombinedArchive$getCompletionTimestamp(value);
			if (!_v2.$) {
				var completionTimestamp = _v2.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(value, completionTimestamp),
					acc);
			} else {
				return acc;
			}
		});
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortBy,
			function (_v1) {
				var posix = _v1.b;
				return $elm$time$Time$posixToMillis(posix);
			},
			A3($elm$core$List$foldl, addTuple, _List_Nil, data.bd)));
};
var $author$project$Translations$Archive$auditNotFoundText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.auditNotFoundText');
};
var $author$project$Measure$EditDialog$viewDeletedDialog = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Archive$auditNotFoundText(translations))
			]));
};
var $author$project$Measure$EditDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Measure$EditDialog$UserClickedCloseDialog = {$: 1};
var $author$project$Translations$Measures$editDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.editDialogHeader');
};
var $author$project$Measure$EditDialog$CompleteTab = 4;
var $author$project$Measure$EditDialog$footer = function (content) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
					]))
			]),
		content);
};
var $author$project$Measure$EditDialog$UserClickedApplyButton = {$: 4};
var $author$project$Measure$EditDialog$viewApplyButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Measure$EditDialog$UserClickedApplyButton,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$apply(translations))));
};
var $author$project$Measure$EditDialog$UserClickedCancelButton = {$: 3};
var $author$project$Measure$EditDialog$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Measure$EditDialog$UserClickedCancelButton,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$Measure$EditDialog$UserClickedCompleteButton = {$: 5};
var $author$project$Translations$Buttons$complete = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'buttons.complete');
};
var $author$project$UI$Style$Theme$green = A4($author$project$UI$Style$Color$rgba, 79 / 255, 162 / 255, 97 / 255, 1.0);
var $author$project$UI$Button$green = function (label) {
	return {
		jo: false,
		h2: label,
		bJ: $elm$core$Maybe$Nothing,
		d2: $elm$core$Maybe$Nothing,
		by: _List_fromArray(
			[
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$green)),
				$rtfeldman$elm_css$Css$color(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
				$rtfeldman$elm_css$Css$backgroundColor(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$green))
			])
	};
};
var $author$project$Measure$EditDialog$viewCompleteButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Measure$EditDialog$UserClickedCompleteButton,
			$author$project$UI$Button$green(
				$author$project$Translations$Buttons$complete(translations))));
};
var $author$project$Measure$EditDialog$viewFooter = F3(
	function (translations, tab, context) {
		var secondButton = (context === 1) ? $rtfeldman$elm_css$Html$Styled$text('') : ((tab === 4) ? $author$project$Measure$EditDialog$viewCompleteButton(translations) : $author$project$Measure$EditDialog$viewApplyButton(translations));
		return $author$project$Measure$EditDialog$footer(
			_List_fromArray(
				[
					$author$project$Measure$EditDialog$viewCancelButton(translations),
					secondButton
				]));
	});
var $author$project$Measure$EditDialog$ImagesTab = 1;
var $author$project$Measure$EditDialog$InfoTab = 3;
var $author$project$Measure$EditDialog$ResponsibleUsersTab = 2;
var $rtfeldman$elm_css$Svg$Styled$Attributes$stroke = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke');
var $author$project$UI$Icons$strokeColor = A2($elm$core$Basics$composeR, $author$project$UI$Style$Color$toString, $rtfeldman$elm_css$Svg$Styled$Attributes$stroke);
var $rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth = $rtfeldman$elm_css$VirtualDom$Styled$attribute('stroke-width');
var $author$project$UI$Icons$checked = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M11.502 28.423l7.142 7.142 17.854-24.997'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none'),
							$author$project$UI$Icons$strokeColor(color),
							$rtfeldman$elm_css$Svg$Styled$Attributes$strokeWidth('3.5709')
						]),
					_List_Nil)
				]));
	});
var $author$project$Measure$EditDialog$UserClickedTabIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Measure$EditDialog$viewTabBarIcon = F3(
	function (icon, tab, currentTab) {
		return _Utils_eq(tab, currentTab) ? A2(
			$author$project$UI$Icon$withForegroundColor,
			$author$project$UI$Style$Theme$darkGrey,
			$author$project$UI$Icon$unicolor(icon)) : A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$Measure$EditDialog$UserClickedTabIcon(tab),
			A2(
				$author$project$UI$Icon$withForegroundColor,
				$author$project$UI$Style$Theme$grey,
				$author$project$UI$Icon$unicolor(icon)));
	});
var $author$project$Measure$EditDialog$appendComplete = F4(
	function (environment, measure, currentTab, tabBarConfig) {
		return A3(
			$author$project$Auth$Authorization$authorize,
			$author$project$Environments$Environment$userRights(environment),
			5,
			measure.km) ? A2(
			$author$project$UI$TabBar$appendRightIcon,
			A3($author$project$Measure$EditDialog$viewTabBarIcon, $author$project$UI$Icons$checked, 4, currentTab),
			tabBarConfig) : tabBarConfig;
	});
var $author$project$Measure$EditDialog$DeleteTab = 5;
var $author$project$Measure$EditDialog$appendDeleteIcon = F4(
	function (environment, measure, currentTab, tabBarConfig) {
		return A3(
			$author$project$Auth$Authorization$authorize,
			$author$project$Environments$Environment$userRights(environment),
			6,
			measure.km) ? A2(
			$author$project$UI$TabBar$appendRightIcon,
			A3($author$project$Measure$EditDialog$viewTabBarIcon, $author$project$UI$Icons$delete, 5, currentTab),
			tabBarConfig) : tabBarConfig;
	});
var $author$project$UI$Icons$camera = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M35.329 15.547h-5.383c-.613 0-1.115.502-1.115 1.115 0 .614.502 1.115 1.115 1.115h5.383c.867 0 1.573.707 1.573 1.574v13.027c0 .966-.786 1.747-1.746 1.747H12.843c-.966 0-1.746-.787-1.746-1.747V19.351c0-.867.706-1.574 1.573-1.574h5.383c.52 0 .966-.359 1.084-.861l.248-1.071c.272-1.159 1.288-1.97 2.484-1.97h4.268c.613 0 1.115-.502 1.115-1.115s-.502-1.115-1.115-1.115h-4.268c-2.236 0-4.144 1.517-4.652 3.691l-.05.211H12.67c-2.1 0-3.804 1.703-3.804 3.804v13.027c0 2.192 1.784 3.977 3.977 3.977h22.313c2.193 0 3.977-1.785 3.977-3.977V19.351c0-2.101-1.704-3.804-3.804-3.804')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M29.463 24.201c-.613 0-1.114.502-1.114 1.115 0 2.397-1.952 4.348-4.349 4.348-2.397 0-4.348-1.951-4.348-4.348s1.951-4.343 4.348-4.343c.613 0 1.114-.501 1.114-1.114 0-.614-.501-1.116-1.114-1.116-3.624 0-6.579 2.95-6.579 6.579 0 3.63 2.955 6.572 6.579 6.572 3.623 0 6.578-2.949 6.578-6.578 0-.613-.502-1.115-1.115-1.115')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$Icons$info = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M23.998 9.972a2.96 2.96 0 00-2.881 2.946 2.96 2.96 0 002.881 2.946 2.964 2.964 0 002.947-2.946 2.965 2.965 0 00-2.946-2.946m0 7.877a4.935 4.935 0 01-4.929-4.931c0-2.72 2.211-4.934 4.929-4.934a4.938 4.938 0 014.932 4.934 4.937 4.937 0 01-4.933 4.93m-4.389 20.18h9.896v-1.18h-3.17V21.8h-7.793l-.014.914h3.199v14.128h-2.118v1.185zm11.88 1.987H17.626v-5.16h2.113V24.7H16.51l.075-4.887H28.32V34.86h3.168v5.157z')
						]),
					_List_Nil)
				]));
	});
var $author$project$Measure$EditDialog$viewTabBar = F3(
	function (environment, measure, currentTab) {
		return $author$project$UI$TabBar$view(
			A4(
				$author$project$Measure$EditDialog$appendDeleteIcon,
				environment,
				measure,
				currentTab,
				A4(
					$author$project$Measure$EditDialog$appendComplete,
					environment,
					measure,
					currentTab,
					A2(
						$author$project$UI$TabBar$appendRightIcon,
						A3($author$project$Measure$EditDialog$viewTabBarIcon, $author$project$UI$Icons$info, 3, currentTab),
						A2(
							$author$project$UI$TabBar$appendRightIcon,
							A3($author$project$Measure$EditDialog$viewTabBarIcon, $author$project$UI$Icons$user, 2, currentTab),
							A2(
								$author$project$UI$TabBar$appendRightIcon,
								A3($author$project$Measure$EditDialog$viewTabBarIcon, $author$project$UI$Icons$camera, 1, currentTab),
								A2(
									$author$project$UI$TabBar$appendRightIcon,
									A3($author$project$Measure$EditDialog$viewTabBarIcon, $author$project$UI$Icons$tag, 0, currentTab),
									A2(
										$author$project$UI$TabBar$withId,
										measure.fw,
										A2(
											$author$project$UI$TabBar$withSubTitle,
											measure.aY,
											$author$project$UI$TabBar$tabBar(measure.k8))))))))));
	});
var $author$project$Measure$EditDialog$viewBasicDataTab = F5(
	function (translations, environment, basicDataEditor, context, measure) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$pct(52))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Measure$EditDialog$viewFooter, translations, 0, context),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Measure$EditDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A3($author$project$Measure$EditDialog$viewTabBar, environment, measure, 0),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Measures$editDialogHeader(translations),
										$author$project$Measure$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Translations$Measures$Complete$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.complete.header');
};
var $author$project$Measure$EditDialog$viewCompleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$checked),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Measures$Complete$header(translations))));
};
var $author$project$Translations$Measures$Complete$question = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.complete.question');
};
var $author$project$Measure$EditDialog$viewCompleteQuestion = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Measures$Complete$question(translations))
			]));
};
var $author$project$Measure$EditDialog$viewCompleteTab = F4(
	function (translations, environment, context, measure) {
		return A3(
			$author$project$Auth$Authorization$authorize,
			$author$project$Environments$Environment$userRights(environment),
			5,
			measure.km) ? $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$pct(52))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Measure$EditDialog$viewFooter, translations, 4, context),
					A2(
						$author$project$UI$Dialog$appendContent,
						$author$project$Measure$EditDialog$viewCompleteQuestion(translations),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Measure$EditDialog$viewCompleteBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A3($author$project$Measure$EditDialog$viewTabBar, environment, measure, 4),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Measures$editDialogHeader(translations),
										$author$project$Measure$EditDialog$UserClickedCloseDialog)))))))) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Translations$Measures$Delete$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.delete.header');
};
var $author$project$Measure$EditDialog$viewDeleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Measures$Delete$header(translations))));
};
var $author$project$Measure$EditDialog$UserClickedDelete = {$: 19};
var $author$project$Measure$EditDialog$viewDeleteButton = F2(
	function (translations, disabled) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disabled,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Measure$EditDialog$UserClickedDelete,
					$author$project$UI$Button$darkRed(
						$author$project$Translations$Buttons$delete(translations)))));
	});
var $author$project$Measure$EditDialog$viewDeleteFooter = F2(
	function (translations, disableDelete) {
		return $author$project$Measure$EditDialog$footer(
			_List_fromArray(
				[
					$author$project$Measure$EditDialog$viewCancelButton(translations),
					A2($author$project$Measure$EditDialog$viewDeleteButton, translations, disableDelete)
				]));
	});
var $author$project$Translations$Measures$Delete$question = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.delete.question');
};
var $author$project$Measure$EditDialog$viewDeleteQuestion = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Measures$Delete$question(translations))
			]));
};
var $author$project$Measure$EditDialog$viewDeleteTab = F3(
	function (translations, environment, measure) {
		if (A3(
			$author$project$Auth$Authorization$authorize,
			$author$project$Environments$Environment$userRights(environment),
			6,
			measure.km)) {
			var disableDelete = $author$project$Environments$Environment$isOffline(environment);
			return $author$project$UI$Dialog$view(
				A2(
					$author$project$UI$Dialog$appendStyle,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$minWidth(
							$rtfeldman$elm_css$Css$pct(60)),
							$rtfeldman$elm_css$Css$minHeight(
							$rtfeldman$elm_css$Css$pct(52))
						]),
					A2(
						$author$project$UI$Dialog$appendFooter,
						A2($author$project$Measure$EditDialog$viewDeleteFooter, translations, disableDelete),
						A2(
							$author$project$UI$Dialog$appendContent,
							$author$project$Measure$EditDialog$viewDeleteQuestion(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$Measure$EditDialog$viewDeleteBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A3($author$project$Measure$EditDialog$viewTabBar, environment, measure, 5),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Measures$Delete$header(translations),
											$author$project$Measure$EditDialog$UserClickedCloseDialog))))))));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Translations$Measures$Images$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.images.header');
};
var $author$project$UI$ImagesEditor$UserClickedCameraIcon = {$: 0};
var $author$project$UI$ImagesEditor$UserClickedUploadIcon = {$: 1};
var $author$project$UI$Bar$appendRightIcon = F2(
	function (icon, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				c9: A2($elm$core$List$cons, icon, config.c9)
			});
	});
var $author$project$UI$Icons$upload = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M32.532 20.607c-.5.46-1.317.46-1.825 0l-5.412-4.977v12.883c0 .65-.58 1.18-1.287 1.18-.71 0-1.29-.53-1.29-1.18V15.63l-5.425 4.977c-.5.46-1.317.46-1.825 0a1.12 1.12 0 010-1.674l7.623-6.993c.25-.23.58-.348.91-.348.328 0 .658.118.908.348l7.623 6.993a1.12 1.12 0 010 1.674')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M37.829 26.169c-.708 0-1.289.531-1.289 1.182v6.637H11.46V27.35c0-.65-.58-1.182-1.29-1.182-.708 0-1.287.531-1.287 1.182v7.82c0 .65.58 1.181 1.287 1.181h27.651c.716 0 1.296-.531 1.296-1.181v-7.82c0-.65-.58-1.182-1.288-1.182')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$ImagesEditor$withIcons = F2(
	function (disabled_, bar) {
		return disabled_ ? bar : A2(
			$author$project$UI$Bar$appendRightIcon,
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$UI$ImagesEditor$UserClickedUploadIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$upload)),
			A2(
				$author$project$UI$Bar$appendRightIcon,
				A2(
					$author$project$UI$Icon$withOnClick,
					$author$project$UI$ImagesEditor$UserClickedCameraIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$camera)),
				bar));
	});
var $author$project$UI$ImagesEditor$viewBar = F2(
	function (translations, _v0) {
		var disabled_ = _v0.b;
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$ImagesEditor$withIcons,
				disabled_,
				A2(
					$author$project$UI$Bar$withLeftIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$camera),
					$author$project$UI$Bar$bar(
						$author$project$Translations$Measures$Images$header(translations)))));
	});
var $author$project$UI$ImagesEditor$addOnClick = F3(
	function (disabled_, msg, icon) {
		return disabled_ ? icon : A2($author$project$UI$Icon$withOnClick, msg, icon);
	});
var $author$project$UI$ImagesEditor$viewCameraIcon = function (disabled_) {
	return $author$project$UI$Icon$view(
		A3(
			$author$project$UI$ImagesEditor$addOnClick,
			disabled_,
			$author$project$UI$ImagesEditor$UserClickedCameraIcon,
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(12)),
				A2(
					$author$project$UI$Icon$withForegroundColor,
					$author$project$UI$Style$Theme$darkRed,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$camera)))));
};
var $author$project$UI$ImagesEditor$viewUploadIcon = function (disabled_) {
	return $author$project$UI$Icon$view(
		A3(
			$author$project$UI$ImagesEditor$addOnClick,
			disabled_,
			$author$project$UI$ImagesEditor$UserClickedUploadIcon,
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(12)),
				A2(
					$author$project$UI$Icon$withForegroundColor,
					$author$project$UI$Style$Theme$darkRed,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$upload)))));
};
var $author$project$UI$ImagesEditor$viewEmpty = function (disabled_) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
					]))
			]),
		_List_fromArray(
			[
				$author$project$UI$ImagesEditor$viewCameraIcon(disabled_),
				$author$project$UI$ImagesEditor$viewUploadIcon(disabled_)
			]));
};
var $rtfeldman$elm_css$Html$Styled$ul = $rtfeldman$elm_css$Html$Styled$node('ul');
var $rtfeldman$elm_css$Html$Styled$img = $rtfeldman$elm_css$Html$Styled$node('img');
var $rtfeldman$elm_css$Html$Styled$li = $rtfeldman$elm_css$Html$Styled$node('li');
var $rtfeldman$elm_css$Html$Styled$Attributes$src = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'src', url);
};
var $author$project$UI$ImagesEditor$UserClickedDeleteIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Icons$deleteCircle = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M32 58.462C17.406 58.462 5.537 46.592 5.537 32 5.537 17.406 17.406 5.536 32 5.536c14.594 0 26.463 11.87 26.463 26.464 0 14.592-11.869 26.462-26.463 26.462m21.914-48.376C48.054 4.238 40.28 1 32 1c-8.28 0-16.067 3.225-21.914 9.086C4.226 15.932 1 23.719 1 32c0 8.28 3.226 16.066 9.086 21.914C15.933 59.773 23.72 63 32 63c8.28 0 16.067-3.227 21.914-9.086C59.761 48.054 63 40.28 63 32c0-8.281-3.226-16.068-9.086-21.914')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M32 10.535a5.032 5.032 0 015.03 5.026h2.23A7.258 7.258 0 0032 8.304a7.258 7.258 0 00-7.261 7.257h2.23a5.034 5.034 0 015.03-5.026m15.787 15.288h-4.607v23.643H20.825V25.823h-4.61v-5.964h31.57v5.964zm-33.802-8.194v10.425h4.61v23.642h26.812V28.054h4.61V17.63H13.984zm26.16 12.045h-2.23v16.074h2.23V29.674zm-7.028-.002h-2.23v16.075h2.23V29.672zm-7.03.002h-2.23v16.074h2.23V29.674z')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$ImagesEditor$viewDeleteIcon = F2(
	function (disabled_, filename) {
		var onClick = disabled_ ? _List_Nil : _List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Events$onClick(
				$author$project$UI$ImagesEditor$UserClickedDeleteIcon(filename))
			]);
		return A2(
			$author$project$UI$Icons$deleteCircle,
			$author$project$UI$Style$Theme$grey,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$bottom(
								$rtfeldman$elm_css$Css$em(-1)),
								$rtfeldman$elm_css$Css$left(
								$rtfeldman$elm_css$Css$pct(50)),
								$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$rem(-1.25)),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$rem(2.5)),
								A3(
								$rtfeldman$elm_css$Css$border3,
								$rtfeldman$elm_css$Css$em(0.2),
								$rtfeldman$elm_css$Css$solid,
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
								$rtfeldman$elm_css$Css$borderRadius(
								$rtfeldman$elm_css$Css$pct(50)),
								$rtfeldman$elm_css$Css$backgroundColor(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
								$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
							]))
					]),
				onClick));
	});
var $author$project$UI$ImagesEditor$viewImage = F3(
	function (disabled_, alternativeFileLookup_, filename) {
		var content = function () {
			if (!alternativeFileLookup_.$) {
				var lookup = alternativeFileLookup_.a;
				return A2(
					$elm$core$Maybe$withDefault,
					A3(
						$rtfeldman$elm_css$Html$Styled$node,
						'aw-image',
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'filename',
								$author$project$File$Filename$toIdString(filename))
							]),
						_List_Nil),
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var url = _v2.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$maxWidth(
												$rtfeldman$elm_css$Css$rem(13))
											])),
										$rtfeldman$elm_css$Html$Styled$Attributes$src(url)
									]),
								_List_Nil);
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (_v1) {
									var fileData = _v1.b;
									return _Utils_eq(fileData.fw, filename.fw);
								},
								lookup))));
			} else {
				return A3(
					$rtfeldman$elm_css$Html$Styled$node,
					'aw-image',
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
							'filename',
							$author$project$File$Filename$toIdString(filename))
						]),
					_List_Nil);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$rem(20)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(18))
						]))
				]),
			_List_fromArray(
				[
					content,
					A2($author$project$UI$ImagesEditor$viewDeleteIcon, disabled_, filename)
				]));
	});
var $author$project$UI$ImagesEditor$viewImages = F3(
	function (disabled_, alternativeFileLookup_, images_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(auto-fill, minmax(15rem, 1fr))'),
							A2($rtfeldman$elm_css$Css$property, 'grid-gap', '1rem'),
							$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero)
						]))
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$UI$ImagesEditor$viewImage, disabled_, alternativeFileLookup_),
				images_));
	});
var $author$project$UI$ImagesEditor$viewGallery = function (_v0) {
	var images_ = _v0.a;
	var disabled_ = _v0.b;
	var alternativeFileLookup_ = _v0.c;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$paddingBottom(
						$rtfeldman$elm_css$Css$rem(1))
					]))
			]),
		_List_fromArray(
			[
				$elm$core$List$isEmpty(images_) ? $author$project$UI$ImagesEditor$viewEmpty(disabled_) : A3($author$project$UI$ImagesEditor$viewImages, disabled_, alternativeFileLookup_, images_)
			]));
};
var $author$project$Measure$EditDialog$viewImagesTab = F3(
	function (translations, environment, model) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendFooter,
				A3($author$project$Measure$EditDialog$viewFooter, translations, 1, model.aq),
				A2(
					$author$project$UI$Dialog$appendContent,
					A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$Measure$EditDialog$GotImageEditorMsg,
						$author$project$UI$ImagesEditor$viewGallery(model.cY)),
					A2(
						$author$project$UI$Dialog$appendHeader,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Measure$EditDialog$GotImageEditorMsg,
							A2($author$project$UI$ImagesEditor$viewBar, translations, model.cY)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							A3($author$project$Measure$EditDialog$viewTabBar, environment, model.h, 1),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Measures$editDialogHeader(translations),
									$author$project$Measure$EditDialog$UserClickedCloseDialog)))))));
	});
var $author$project$Translations$Measures$Info$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.info.header');
};
var $author$project$Measure$EditDialog$viewInfoBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$info),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Measures$Info$header(translations))));
};
var $author$project$Translations$Measures$Info$deadlineTimestamp = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.info.deadlineTimestamp');
};
var $author$project$Measure$EditDialog$UserEnteredDateText = function (a) {
	return {$: 12, a: a};
};
var $author$project$Translations$Measures$Info$noDeadlineTimestamp = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.info.noDeadlineTimestamp');
};
var $author$project$Date_Time$NaiveDate$toStringDMY = function (_v0) {
	var y = _v0.a;
	var m = _v0.b;
	var d = _v0.c;
	var ys = $elm$core$String$fromInt(y);
	var ms = A3(
		$elm$core$Basics$composeR,
		$author$project$Date_Time$Month$toInt,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromInt,
			A2($elm$core$String$padLeft, 2, '0')),
		m);
	var ds = A3(
		$elm$core$Basics$composeR,
		$elm$core$String$fromInt,
		A2($elm$core$String$padLeft, 2, '0'),
		d);
	return ds + ('-' + (ms + ('-' + ys)));
};
var $author$project$Measure$EditDialog$UserChangedEndDateInput = function (a) {
	return {$: 11, a: a};
};
var $author$project$Measure$EditDialog$UserDeletedDeadline = {$: 15};
var $author$project$UI$Style$Theme$red = A4($author$project$UI$Style$Color$rgba, 204 / 255, 0 / 255, 0 / 255, 1.0);
var $author$project$Measure$EditDialog$viewDeadlineDate = F4(
	function (translations, naiveDate, endDateInput, dateTextInput) {
		var defaultYear = $author$project$Date_Time$NaiveDate$year(naiveDate);
		var defaultMonth = $author$project$Date_Time$NaiveDate$month(naiveDate);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					A5(
					$author$project$UI$DateInput$view,
					translations,
					endDateInput,
					$elm$core$Maybe$Just(naiveDate),
					dateTextInput,
					A2(
						$author$project$UI$DateInput$withOnTextInput,
						$author$project$Measure$EditDialog$UserEnteredDateText,
						A2(
							$author$project$UI$DateInput$withStyle,
							$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$rem(0.8)),
							A2(
								$author$project$UI$DateInput$withStyle,
								$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(1)),
								A2(
									$author$project$UI$DateInput$withStyle,
									$rtfeldman$elm_css$Css$flexGrow(
										$rtfeldman$elm_css$Css$int(1)),
									A3($author$project$UI$DateInput$dateInput, defaultYear, defaultMonth, $author$project$Measure$EditDialog$UserChangedEndDateInput)))))),
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(4)),
						A2(
							$author$project$UI$Icon$withForegroundColor,
							$author$project$UI$Style$Theme$red,
							A2(
								$author$project$UI$Icon$withOnClick,
								$author$project$Measure$EditDialog$UserDeletedDeadline,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete)))))
				]));
	});
var $author$project$Measure$EditDialog$EnteredHour = function (a) {
	return {$: 13, a: a};
};
var $author$project$Measure$EditDialog$EnteredMinute = function (a) {
	return {$: 14, a: a};
};
var $author$project$Measure$EditDialog$viewDeadlineTime = F2(
	function (hourInput, minuteInput) {
		return A4(
			$author$project$UI$TimeInput$view,
			false,
			hourInput,
			minuteInput,
			A2($author$project$UI$TimeInput$timeInput, $author$project$Measure$EditDialog$EnteredHour, $author$project$Measure$EditDialog$EnteredMinute));
	});
var $author$project$Measure$EditDialog$viewInfoValue = F2(
	function (maybeMsg, value) {
		var _v0 = function () {
			if (!maybeMsg.$) {
				var msg = maybeMsg.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
						]),
					$rtfeldman$elm_css$Css$pointer);
			} else {
				return _Utils_Tuple2(_List_Nil, $rtfeldman$elm_css$Css$default);
			}
		}();
		var additionalAttr = _v0.a;
		var cursor_ = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$rem(1.2)),
								$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
								$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
								$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								$rtfeldman$elm_css$Css$cursor(cursor_)
							]))
					]),
				additionalAttr),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(value)
				]));
	});
var $author$project$Measure$EditDialog$viewDeadlineValue = F3(
	function (translations, environment, model) {
		var _v0 = model.bl;
		if (!_v0.$) {
			var msg = function () {
				if (A3(
					$author$project$Auth$Authorization$authorize,
					$author$project$Environments$Environment$userRights(environment),
					5,
					model.h.km)) {
					var _default = $author$project$Date_Time$NaiveDate$toStringDMY(
						A2($author$project$Date_Time$NaiveDate$fromPosix, $elm$time$Time$utc, model.fK));
					return $elm$core$Maybe$Just(
						$author$project$Measure$EditDialog$UserEnteredDateText(_default));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			return A2(
				$author$project$Measure$EditDialog$viewInfoValue,
				msg,
				$author$project$Translations$Measures$Info$noDeadlineTimestamp(translations));
		} else {
			var naiveDate = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1)),
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
							]))
					]),
				_List_fromArray(
					[
						A4($author$project$Measure$EditDialog$viewDeadlineDate, translations, naiveDate, model.cQ, model.dy),
						A2($author$project$Measure$EditDialog$viewDeadlineTime, model.cf, model.cj)
					]));
		}
	});
var $author$project$Measure$EditDialog$viewInfoIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$Icon$unicolor,
	A2(
		$elm$core$Basics$composeR,
		$author$project$UI$Icon$withStyle(
			$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$rem(3))),
		$author$project$UI$Icon$view));
var $rtfeldman$elm_css$Html$Styled$h5 = $rtfeldman$elm_css$Html$Styled$node('h5');
var $author$project$Measure$EditDialog$viewInfoLabel = function (label) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h5,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
						$rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(1))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(label)
			]));
};
var $author$project$Measure$EditDialog$viewDeadlineTimestamp = F3(
	function (translations, environment, model) {
		return _List_fromArray(
			[
				$author$project$Measure$EditDialog$viewInfoIcon($author$project$UI$Icons$info),
				$author$project$Measure$EditDialog$viewInfoLabel(
				$author$project$Translations$Measures$Info$deadlineTimestamp(translations)),
				A3($author$project$Measure$EditDialog$viewDeadlineValue, translations, environment, model)
			]);
	});
var $author$project$Measure$EditDialog$UserClickedOnAudit = function (a) {
	return {$: 21, a: a};
};
var $author$project$Translations$Measures$Info$audit = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.info.audit');
};
var $author$project$UI$Icons$audits = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M37.921 30.965l-.001.002h-5.597c-.574 0-1.042.467-1.042 1.042v5.597l-.008.006H18.021v-3.991h9.001l6.639-6.645V16.463h4.26v14.502zm-4.563 5.921v-3.835h3.833l-3.833 3.835zm-6.336-7.432v-2.478h3.831l-3.831 3.835v-1.357zm11.936-15.075h-5.297V9.346c0-.573-.468-1.042-1.041-1.042H17.205c-.572 0-1.042.469-1.042 1.042 0 .572.468 1.041 1.042 1.041h14.38V24.89l-.002.003h-5.597c-.575 0-1.044.468-1.044 1.041v5.598l-.006.005H11.684v-21.15h1.591c.573 0 1.044-.469 1.044-1.041 0-.573-.471-1.042-1.044-1.042H10.64c-.572 0-1.041.469-1.041 1.042V32.58c0 .574.469 1.041 1.041 1.041h5.297v5.034c0 .573.469 1.041 1.041 1.041h16.38L40 33.051V15.42c0-.572-.47-1.041-1.042-1.041')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M15.514 16.404h12.233c.568 0 1.027-.459 1.027-1.027 0-.568-.459-1.029-1.027-1.029H15.514c-.568 0-1.029.461-1.029 1.029 0 .568.461 1.027 1.029 1.027M15.514 19.824h12.233c.568 0 1.027-.46 1.027-1.028 0-.568-.459-1.027-1.027-1.027H15.514c-.568 0-1.029.459-1.029 1.027 0 .568.461 1.028 1.029 1.028M15.514 23.244h12.233c.568 0 1.027-.459 1.027-1.027 0-.569-.459-1.029-1.027-1.029H15.514c-.568 0-1.029.46-1.029 1.029 0 .568.461 1.027 1.029 1.027')
						]),
					_List_Nil)
				]));
	});
var $author$project$Translations$Measures$Info$unknown = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.info.unknown');
};
var $author$project$Measure$EditDialog$viewInfoAudit = F2(
	function (translations, maybeOriginAudit) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(
				$author$project$Translations$Measures$Info$unknown(translations),
				$elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				function (audit) {
					return _Utils_Tuple2(
						audit.fw + (': ' + audit.k8),
						$elm$core$Maybe$Just(
							$author$project$Measure$EditDialog$UserClickedOnAudit(audit)));
				},
				maybeOriginAudit));
		var value = _v0.a;
		var onClickMsg = _v0.b;
		return _List_fromArray(
			[
				$author$project$Measure$EditDialog$viewInfoIcon($author$project$UI$Icons$audits),
				$author$project$Measure$EditDialog$viewInfoLabel(
				$author$project$Translations$Measures$Info$audit(translations)),
				A2($author$project$Measure$EditDialog$viewInfoValue, onClickMsg, value)
			]);
	});
var $author$project$Translations$Measures$Info$checkpoint = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.info.checkpoint');
};
var $author$project$CheckpointData$Checkpoint$Dict$get = $turboMaCk$any_dict$Dict$Any$get;
var $author$project$CheckpointData$CheckpointData$unwrap = function (_v0) {
	var data = _v0;
	return data;
};
var $author$project$CheckpointData$CheckpointData$getCheckpoint = function (checkpointId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$CheckpointData$CheckpointData$unwrap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.a8;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.i6;
				},
				$author$project$CheckpointData$Checkpoint$Dict$get(checkpointId))));
};
var $author$project$CheckpointData$Checkpoint$Dict$insert = A2(
	$author$project$Utils$Utils$with,
	function ($) {
		return $.i5;
	},
	$turboMaCk$any_dict$Dict$Any$insert);
var $author$project$CheckpointData$CheckpointData$mapCheckpointsHelper = F2(
	function (fn, hierarchy) {
		return _Utils_update(
			hierarchy,
			{
				i6: fn(hierarchy.i6)
			});
	});
var $author$project$CheckpointData$CheckpointData$mapCheckpoints = F2(
	function (fn, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				a8: A2($author$project$CheckpointData$CheckpointData$mapCheckpointsHelper, fn, data.a8)
			});
	});
var $author$project$CheckpointData$Modifications$Empty = function (a) {
	return {$: 0, a: a};
};
var $author$project$CheckpointData$Modifications$NotEmpty = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$Modifications$withChangedCheckpoint = F2(
	function (checkpoint, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$CheckpointData$Modifications$Empty(
				_Utils_update(
					data,
					{
						bX: A2($author$project$CheckpointData$Checkpoint$Dict$insert, checkpoint, data.bX)
					}));
		} else {
			var data = modifications.a;
			return $author$project$CheckpointData$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						bX: A2($author$project$CheckpointData$Checkpoint$Dict$insert, checkpoint, data.bX)
					}));
		}
	});
var $author$project$CheckpointData$CheckpointData$insertCheckpoint = function (checkpoint) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$Triple$mapFirst(
			$author$project$CheckpointData$CheckpointData$mapCheckpoints(
				$author$project$CheckpointData$Checkpoint$Dict$insert(checkpoint))),
		$author$project$Utils$Triple$mapSecond(
			$author$project$CheckpointData$Modifications$withChangedCheckpoint(checkpoint)));
};
var $author$project$CheckpointData$CheckpointData$createCheckpoint = function (payload) {
	var checkpoint = {cC: payload.cC, i5: payload.i5, fg: payload.fg, aY: payload.aY, cT: payload.cT, kc: payload.kc, kw: payload.kw, i: 0, k8: payload.k8};
	return $author$project$CheckpointData$CheckpointData$insertCheckpoint(checkpoint);
};
var $author$project$CheckpointData$CheckpointGroup$Dict$get = $turboMaCk$any_dict$Dict$Any$get;
var $author$project$CheckpointData$CheckpointData$getCheckpointGroup = function (groupId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$CheckpointData$CheckpointData$unwrap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.a8;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gt;
				},
				$author$project$CheckpointData$CheckpointGroup$Dict$get(groupId))));
};
var $author$project$CheckpointData$CheckpointGroup$Dict$insert = A2(
	$author$project$Utils$Utils$with,
	function ($) {
		return $.cC;
	},
	$turboMaCk$any_dict$Dict$Any$insert);
var $author$project$CheckpointData$CheckpointData$mapCheckpointGroupsHelper = F2(
	function (fn, hierarchy) {
		return _Utils_update(
			hierarchy,
			{
				gt: fn(hierarchy.gt)
			});
	});
var $author$project$CheckpointData$CheckpointData$mapCheckpointGroups = F2(
	function (fn, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				a8: A2($author$project$CheckpointData$CheckpointData$mapCheckpointGroupsHelper, fn, data.a8)
			});
	});
var $author$project$CheckpointData$Modifications$withChangedCheckpointGroup = F2(
	function (checkpointGroup, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$CheckpointData$Modifications$Empty(
				_Utils_update(
					data,
					{
						bW: A2($author$project$CheckpointData$CheckpointGroup$Dict$insert, checkpointGroup, data.bW)
					}));
		} else {
			var data = modifications.a;
			return $author$project$CheckpointData$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						bW: A2($author$project$CheckpointData$CheckpointGroup$Dict$insert, checkpointGroup, data.bW)
					}));
		}
	});
var $author$project$CheckpointData$CheckpointData$insertCheckpointGroup = function (checkpointGroup) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$Triple$mapFirst(
			$author$project$CheckpointData$CheckpointData$mapCheckpointGroups(
				$author$project$CheckpointData$CheckpointGroup$Dict$insert(checkpointGroup))),
		$author$project$Utils$Triple$mapSecond(
			$author$project$CheckpointData$Modifications$withChangedCheckpointGroup(checkpointGroup)));
};
var $author$project$CheckpointData$CheckpointData$updateCheckpointGroup = F3(
	function (checkpointGroupId, fn, acc) {
		return A2(
			$elm$core$Maybe$withDefault,
			acc,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					fn,
					A2($author$project$Utils$Utils$flip, $author$project$CheckpointData$CheckpointData$insertCheckpointGroup, acc)),
				A2(
					$author$project$CheckpointData$CheckpointData$getCheckpointGroup,
					checkpointGroupId,
					$author$project$Utils$Triple$first(acc))));
	});
var $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withFirst = F2(
	function (first, checkpointGroup) {
		return _Utils_update(
			checkpointGroup,
			{jC: first});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointGroupFirst = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
		payload.cC,
		$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withFirst(payload.jC));
};
var $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withLast = F2(
	function (last, checkpointGroup) {
		return _Utils_update(
			checkpointGroup,
			{jT: last});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointGroupLast = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
		payload.cC,
		$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withLast(payload.jT));
};
var $author$project$CheckpointData$CheckpointData$updateCheckpoint = F3(
	function (checkpointId, fn, acc) {
		return A2(
			$elm$core$Maybe$withDefault,
			acc,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					fn,
					A2($author$project$Utils$Utils$flip, $author$project$CheckpointData$CheckpointData$insertCheckpoint, acc)),
				A2(
					$author$project$CheckpointData$CheckpointData$getCheckpoint,
					checkpointId,
					$author$project$Utils$Triple$first(acc))));
	});
var $author$project$CheckpointData$Checkpoint$Checkpoint$withNext = F2(
	function (next, checkpoint) {
		return _Utils_update(
			checkpoint,
			{kc: next});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointNext = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpoint,
		payload.i5,
		$author$project$CheckpointData$Checkpoint$Checkpoint$withNext(payload.kc));
};
var $author$project$CheckpointData$EventApplier$createCheckpointHelper = F2(
	function (payload, acc_) {
		var _v0 = payload.kw;
		if (!_v0.$) {
			var prevId = _v0.a;
			return A2(
				$author$project$CheckpointData$CheckpointData$changeCheckpointGroupLast,
				{
					cC: payload.cC,
					jT: $elm$core$Maybe$Just(payload.i5)
				},
				A2(
					$author$project$CheckpointData$CheckpointData$changeCheckpointNext,
					{
						i5: prevId,
						kc: $elm$core$Maybe$Just(payload.i5)
					},
					acc_));
		} else {
			return A2(
				$author$project$CheckpointData$CheckpointData$changeCheckpointGroupLast,
				{
					cC: payload.cC,
					jT: $elm$core$Maybe$Just(payload.i5)
				},
				A2(
					$author$project$CheckpointData$CheckpointData$changeCheckpointGroupFirst,
					{
						cC: payload.cC,
						jC: $elm$core$Maybe$Just(payload.i5)
					},
					acc_));
		}
	});
var $author$project$CheckpointData$EventApplier$mapCheckpointData = F2(
	function (fn, _v0) {
		var data = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		return fn(
			_Utils_Tuple3(data, modifications, fileOperations));
	});
var $author$project$CheckpointData$Modifications$withLastEventId = F2(
	function (lastEventId, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$CheckpointData$Modifications$NotEmpty(
				{bW: data.bW, bX: data.bX, b1: data.b1, b2: data.b2, fD: lastEventId});
		} else {
			var data = modifications.a;
			return $author$project$CheckpointData$Modifications$NotEmpty(
				_Utils_update(
					data,
					{fD: lastEventId}));
		}
	});
var $author$project$CheckpointData$CheckpointData$withLastEventId = F2(
	function (lastEventId_, _v0) {
		var data = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				data,
				{
					fD: $elm$core$Maybe$Just(lastEventId_)
				}),
			A2($author$project$CheckpointData$Modifications$withLastEventId, lastEventId_, modifications),
			fileOperations);
	});
var $author$project$CheckpointData$EventApplier$applyCheckpointCreatedEvent = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, checkpointData);
		if (!_v0.$) {
			return acc;
		} else {
			return A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					A2(
						$elm$core$Basics$composeR,
						$author$project$CheckpointData$CheckpointData$createCheckpoint(payload),
						$author$project$CheckpointData$EventApplier$createCheckpointHelper(payload)),
					acc));
		}
	});
var $author$project$CheckpointData$Checkpoint$Dict$remove = $turboMaCk$any_dict$Dict$Any$remove;
var $author$project$CheckpointData$Checkpoint$Ids$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$CheckpointData$Modifications$mapDeletedCheckpoints = F2(
	function (fn, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$CheckpointData$Modifications$Empty(
				_Utils_update(
					data,
					{
						b2: fn(data.b2)
					}));
		} else {
			var data = modifications.a;
			return $author$project$CheckpointData$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						b2: fn(data.b2)
					}));
		}
	});
var $author$project$CheckpointData$Modifications$withDeletedCheckpoint = A2($elm$core$Basics$composeL, $author$project$CheckpointData$Modifications$mapDeletedCheckpoints, $author$project$CheckpointData$Checkpoint$Ids$insert);
var $author$project$CheckpointData$CheckpointData$removeCheckpoint = function (checkpointId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$Triple$mapFirst(
			$author$project$CheckpointData$CheckpointData$mapCheckpoints(
				$author$project$CheckpointData$Checkpoint$Dict$remove(checkpointId))),
		$author$project$Utils$Triple$mapSecond(
			$author$project$CheckpointData$Modifications$withDeletedCheckpoint(checkpointId)));
};
var $author$project$CheckpointData$CheckpointData$deleteCheckpoint = function (checkpointId) {
	return $author$project$CheckpointData$CheckpointData$removeCheckpoint(checkpointId);
};
var $author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious = F2(
	function (prev, checkpoint) {
		return _Utils_update(
			checkpoint,
			{kw: prev});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointPrev = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpoint,
		payload.i5,
		$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious(payload.kw));
};
var $author$project$CheckpointData$EventApplier$deleteCheckpointHelper = F2(
	function (checkpoint, acc_) {
		var _v0 = _Utils_Tuple2(checkpoint.kw, checkpoint.kc);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var prev = _v0.a.a;
				var next = _v0.b.a;
				return A2(
					$author$project$CheckpointData$CheckpointData$changeCheckpointPrev,
					{
						i5: next,
						kw: $elm$core$Maybe$Just(prev)
					},
					A2(
						$author$project$CheckpointData$CheckpointData$changeCheckpointNext,
						{
							i5: prev,
							kc: $elm$core$Maybe$Just(next)
						},
						acc_));
			} else {
				var prev = _v0.a.a;
				var _v1 = _v0.b;
				return A2(
					$author$project$CheckpointData$CheckpointData$changeCheckpointGroupLast,
					{
						cC: checkpoint.cC,
						jT: $elm$core$Maybe$Just(prev)
					},
					A2(
						$author$project$CheckpointData$CheckpointData$changeCheckpointNext,
						{i5: prev, kc: $elm$core$Maybe$Nothing},
						acc_));
			}
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				var next = _v0.b.a;
				return A2(
					$author$project$CheckpointData$CheckpointData$changeCheckpointGroupFirst,
					{
						cC: checkpoint.cC,
						jC: $elm$core$Maybe$Just(next)
					},
					A2(
						$author$project$CheckpointData$CheckpointData$changeCheckpointPrev,
						{i5: next, kw: $elm$core$Maybe$Nothing},
						acc_));
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return A2(
					$author$project$CheckpointData$CheckpointData$changeCheckpointGroupLast,
					{cC: checkpoint.cC, jT: $elm$core$Maybe$Nothing},
					A2(
						$author$project$CheckpointData$CheckpointData$changeCheckpointGroupFirst,
						{cC: checkpoint.cC, jC: $elm$core$Maybe$Nothing},
						acc_));
			}
		}
	});
var $author$project$CheckpointData$EventApplier$applyCheckpointDeletedEvent = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, checkpointData);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			return (_Utils_cmp(payload.n, checkpoint.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$deleteCheckpointHelper,
					checkpoint,
					A2(
						$author$project$CheckpointData$EventApplier$mapCheckpointData,
						$author$project$CheckpointData$CheckpointData$deleteCheckpoint(payload.i5),
						acc))) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$Checkpoint$Checkpoint$withDescription = F2(
	function (description, checkpoint) {
		return _Utils_update(
			checkpoint,
			{aY: description});
	});
var $author$project$CheckpointData$Checkpoint$Checkpoint$withRevision = F2(
	function (revision, checkpoint) {
		return _Utils_update(
			checkpoint,
			{i: revision});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointDescription = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpoint,
		payload.i5,
		A2(
			$elm$core$Basics$composeR,
			$author$project$CheckpointData$Checkpoint$Checkpoint$withDescription(payload.aY),
			$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n)));
};
var $author$project$CheckpointData$EventApplier$applyCheckpointDescriptionChangedEvent = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, checkpointData);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			return (_Utils_cmp(payload.n, checkpoint.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$changeCheckpointDescription(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$Checkpoint$Checkpoint$addFiles = F2(
	function (files, checkpoint) {
		var removeHelper = F2(
			function (file, filenames) {
				return A2($author$project$File$Filenames$insert, file, filenames);
			});
		return _Utils_update(
			checkpoint,
			{
				cT: A3($elm$core$List$foldl, removeHelper, checkpoint.cT, files)
			});
	});
var $author$project$CheckpointData$Checkpoint$Checkpoint$removeFiles = F2(
	function (files, checkpoint) {
		var removeHelper = F2(
			function (file, filenames) {
				return A2($author$project$File$Filenames$remove, file, filenames);
			});
		return _Utils_update(
			checkpoint,
			{
				cT: A3($elm$core$List$foldl, removeHelper, checkpoint.cT, files)
			});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointFiles = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpoint,
		payload.i5,
		A2(
			$elm$core$Basics$composeR,
			$author$project$CheckpointData$Checkpoint$Checkpoint$addFiles(payload.iM),
			A2(
				$elm$core$Basics$composeR,
				$author$project$CheckpointData$Checkpoint$Checkpoint$removeFiles(payload.jk),
				$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n))));
};
var $author$project$CheckpointData$EventApplier$applyCheckpointFilesChangedEvent = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, checkpointData);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			return (_Utils_cmp(payload.n, checkpoint.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$changeCheckpointFiles(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$CheckpointData$createCheckpointGroup = F2(
	function (payload, acc) {
		var checkpointGroup = {cC: payload.cC, aY: payload.aY, jC: payload.jC, jT: payload.jT, kc: payload.kc, km: payload.km, kw: payload.kw, i: 0, k8: payload.k8};
		return A2($author$project$CheckpointData$CheckpointData$insertCheckpointGroup, checkpointGroup, acc);
	});
var $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withNext = F2(
	function (next, checkpointGroup) {
		return _Utils_update(
			checkpointGroup,
			{kc: next});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointGroupNext = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
		payload.cC,
		$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withNext(payload.kc));
};
var $author$project$CheckpointData$EventApplier$createGroupHelper = F2(
	function (payload, acc_) {
		var _v0 = payload.kw;
		if (!_v0.$) {
			var prevId = _v0.a;
			return A2(
				$author$project$CheckpointData$CheckpointData$changeCheckpointGroupNext,
				{
					cC: prevId,
					kc: $elm$core$Maybe$Just(payload.cC)
				},
				acc_);
		} else {
			return acc_;
		}
	});
var $author$project$CheckpointData$EventApplier$applyCheckpointGroupCreatedEvent = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, checkpointData);
		if (!_v0.$) {
			return acc;
		} else {
			return A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					A2(
						$elm$core$Basics$composeR,
						$author$project$CheckpointData$CheckpointData$createCheckpointGroup(payload),
						$author$project$CheckpointData$EventApplier$createGroupHelper(payload)),
					acc));
		}
	});
var $author$project$CheckpointData$CheckpointGroup$Dict$remove = $turboMaCk$any_dict$Dict$Any$remove;
var $author$project$CheckpointData$CheckpointGroup$Ids$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$CheckpointData$Modifications$mapDeleteCheckpointGroups = F2(
	function (fn, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$CheckpointData$Modifications$Empty(
				_Utils_update(
					data,
					{
						b1: fn(data.b1)
					}));
		} else {
			var data = modifications.a;
			return $author$project$CheckpointData$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						b1: fn(data.b1)
					}));
		}
	});
var $author$project$CheckpointData$Modifications$withDeletedCheckpointGroup = A2($elm$core$Basics$composeL, $author$project$CheckpointData$Modifications$mapDeleteCheckpointGroups, $author$project$CheckpointData$CheckpointGroup$Ids$insert);
var $author$project$CheckpointData$CheckpointData$removeCheckpointGroup = F2(
	function (checkpointGroupId, _v0) {
		var checkpointData = _v0.a;
		var modifications = _v0.b;
		var fileOperations = _v0.c;
		return _Utils_Tuple3(
			A2(
				$author$project$CheckpointData$CheckpointData$mapCheckpointGroups,
				$author$project$CheckpointData$CheckpointGroup$Dict$remove(checkpointGroupId),
				checkpointData),
			A2($author$project$CheckpointData$Modifications$withDeletedCheckpointGroup, checkpointGroupId, modifications),
			fileOperations);
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $turboMaCk$any_dict$Dict$Any$filter = F2(
	function (f, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				cL: A2(
					$elm$core$Dict$filter,
					F2(
						function (_v1, _v2) {
							var k = _v2.a;
							var v = _v2.b;
							return A2(f, k, v);
						}),
					inner.cL)
			});
	});
var $author$project$CheckpointData$Checkpoint$Dict$filter = A2($elm$core$Basics$composeR, $elm$core$Basics$always, $turboMaCk$any_dict$Dict$Any$filter);
var $author$project$CheckpointData$Checkpoint$Ids$isEmpty = $turboMaCk$any_set$Set$Any$isEmpty;
var $author$project$CheckpointData$Checkpoint$Ids$member = $turboMaCk$any_set$Set$Any$member;
var $author$project$CheckpointData$Checkpoint$Dict$removeMany = function (ids) {
	return $author$project$CheckpointData$Checkpoint$Ids$isEmpty(ids) ? $elm$core$Basics$identity : $author$project$CheckpointData$Checkpoint$Dict$filter(
		function (c) {
			return !A2($author$project$CheckpointData$Checkpoint$Ids$member, c.i5, ids);
		});
};
var $author$project$CheckpointData$Checkpoint$Ids$union = $turboMaCk$any_set$Set$Any$union;
var $author$project$CheckpointData$Modifications$withDeletedCheckpoints = A2($elm$core$Basics$composeL, $author$project$CheckpointData$Modifications$mapDeletedCheckpoints, $author$project$CheckpointData$Checkpoint$Ids$union);
var $author$project$CheckpointData$CheckpointData$removeCheckpoints = function (checkpointIds) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$Triple$mapFirst(
			$author$project$CheckpointData$CheckpointData$mapCheckpoints(
				$author$project$CheckpointData$Checkpoint$Dict$removeMany(checkpointIds))),
		$author$project$Utils$Triple$mapSecond(
			$author$project$CheckpointData$Modifications$withDeletedCheckpoints(checkpointIds)));
};
var $author$project$CheckpointData$CheckpointData$deleteCheckpointGroup = function (payload) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$CheckpointData$CheckpointData$removeCheckpointGroup(payload.cC),
		$author$project$CheckpointData$CheckpointData$removeCheckpoints(payload.i6));
};
var $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withPrevious = F2(
	function (prev, checkpointGroup) {
		return _Utils_update(
			checkpointGroup,
			{kw: prev});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointGroupPrev = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
		payload.cC,
		$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withPrevious(payload.kw));
};
var $author$project$CheckpointData$EventApplier$deleteGroupHelper = F2(
	function (group, acc_) {
		var _v0 = _Utils_Tuple2(group.kw, group.kc);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var prev = _v0.a.a;
				var next = _v0.b.a;
				return A2(
					$author$project$CheckpointData$CheckpointData$changeCheckpointGroupPrev,
					{
						cC: next,
						kw: $elm$core$Maybe$Just(prev)
					},
					A2(
						$author$project$CheckpointData$CheckpointData$changeCheckpointGroupNext,
						{
							cC: prev,
							kc: $elm$core$Maybe$Just(next)
						},
						acc_));
			} else {
				var prev = _v0.a.a;
				var _v1 = _v0.b;
				return A2(
					$author$project$CheckpointData$CheckpointData$changeCheckpointGroupNext,
					{cC: prev, kc: $elm$core$Maybe$Nothing},
					acc_);
			}
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				var next = _v0.b.a;
				return A2(
					$author$project$CheckpointData$CheckpointData$changeCheckpointGroupPrev,
					{cC: next, kw: $elm$core$Maybe$Nothing},
					acc_);
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return acc_;
			}
		}
	});
var $author$project$CheckpointData$Checkpoint$Ids$fromList = function (ids) {
	return A2(
		$turboMaCk$any_set$Set$Any$fromList,
		function (id) {
			return $author$project$CheckpointData$Checkpoint$Id$toString(id);
		},
		ids);
};
var $author$project$CheckpointData$CheckpointData$prependPreviousCheckpointsHelper = F3(
	function (hierarchy, acc, checkpointData) {
		return A2(
			$elm$core$Maybe$withDefault,
			acc,
			A2(
				$elm$core$Maybe$map,
				function (checkpoint) {
					return A2(
						$elm$core$Maybe$withDefault,
						A2($elm$core$List$cons, checkpoint, acc),
						A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$CheckpointData$CheckpointData$prependPreviousCheckpointsHelper,
								hierarchy,
								A2($elm$core$List$cons, checkpoint, acc)),
							checkpoint.kw));
				},
				A2($author$project$CheckpointData$CheckpointData$getCheckpoint, checkpointData, hierarchy)));
	});
var $author$project$CheckpointData$CheckpointData$getCheckpointsOf = F2(
	function (checkpointGroupId, checkpointData) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$CheckpointData$CheckpointData$prependPreviousCheckpointsHelper, checkpointData, _List_Nil),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.jT;
					},
					A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, checkpointGroupId, checkpointData))));
	});
var $author$project$CheckpointData$EventApplier$applyCheckpointGroupDeletedEvent = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, checkpointData);
		if (!_v0.$) {
			var checkpointGroup = _v0.a;
			if (_Utils_cmp(payload.n, checkpointGroup.i) > 0) {
				var checkpoints = $author$project$CheckpointData$Checkpoint$Ids$fromList(
					A2(
						$elm$core$List$map,
						function (cp) {
							return cp.i5;
						},
						A2($author$project$CheckpointData$CheckpointData$getCheckpointsOf, checkpointGroup.cC, checkpointData)));
				return A2(
					$author$project$CheckpointData$CheckpointData$withLastEventId,
					payload.N,
					A2(
						$author$project$CheckpointData$EventApplier$mapCheckpointData,
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$CheckpointData$deleteCheckpointGroup(
								{cC: checkpointGroup.cC, i6: checkpoints}),
							$author$project$CheckpointData$EventApplier$deleteGroupHelper(checkpointGroup)),
						acc));
			} else {
				return acc;
			}
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withDescription = F2(
	function (value, checkpointGroup) {
		return _Utils_update(
			checkpointGroup,
			{aY: value});
	});
var $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withRevision = F2(
	function (revision, checkpointGroup) {
		return _Utils_update(
			checkpointGroup,
			{i: revision});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointGroupDescription = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
		payload.cC,
		A2(
			$elm$core$Basics$composeR,
			$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withDescription(payload.aY),
			$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withRevision(payload.n)));
};
var $author$project$CheckpointData$EventApplier$applyCheckpointGroupDescriptionChangedEvent = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, checkpointData);
		if (!_v0.$) {
			var checkpointGroup = _v0.a;
			return (_Utils_cmp(payload.n, checkpointGroup.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$changeCheckpointGroupDescription(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withTitle = F2(
	function (value, checkpointGroup) {
		return _Utils_update(
			checkpointGroup,
			{k8: value});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointGroupTitle = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
		payload.cC,
		A2(
			$elm$core$Basics$composeR,
			$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withTitle(payload.k8),
			$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withRevision(payload.n)));
};
var $author$project$CheckpointData$EventApplier$applyCheckpointGroupTitleChangedEvent = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, checkpointData);
		if (!_v0.$) {
			var checkpointGroup = _v0.a;
			return (_Utils_cmp(payload.n, checkpointGroup.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$changeCheckpointGroupTitle(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$Checkpoint$Checkpoint$withTitle = F2(
	function (title, checkpoint) {
		return _Utils_update(
			checkpoint,
			{k8: title});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointTitle = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpoint,
		payload.i5,
		A2(
			$elm$core$Basics$composeR,
			$author$project$CheckpointData$Checkpoint$Checkpoint$withTitle(payload.k8),
			$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n)));
};
var $author$project$CheckpointData$EventApplier$applyCheckpointTitleChangedEvent = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, checkpointData);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			return (_Utils_cmp(payload.n, checkpoint.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$changeCheckpointTitle(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$Checkpoint$Checkpoint$withCheckpointType = F2(
	function (checkpointType, checkpoint) {
		return _Utils_update(
			checkpoint,
			{fg: checkpointType});
	});
var $author$project$CheckpointData$CheckpointData$changeCheckpointType = function (payload) {
	return A2(
		$author$project$CheckpointData$CheckpointData$updateCheckpoint,
		payload.i5,
		A2(
			$elm$core$Basics$composeR,
			$author$project$CheckpointData$Checkpoint$Checkpoint$withCheckpointType(payload.fg),
			$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n)));
};
var $author$project$CheckpointData$EventApplier$applyCheckpointTypeChangedEvent = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, checkpointData);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			return (_Utils_cmp(payload.n, checkpoint.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$changeCheckpointType(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$Checkpoint$Checkpoint$withCheckpointGroup = F2(
	function (checkpointGroupId, checkpoint) {
		return _Utils_update(
			checkpoint,
			{cC: checkpointGroupId});
	});
var $author$project$CheckpointData$CheckpointData$attachCheckpoint = function (payload) {
	var _v0 = _Utils_Tuple3(payload.fV, payload.ay, payload.ax);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			if (!_v0.c.$) {
				var parentId = _v0.a.a;
				var previousId = _v0.b.a;
				var nextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpoint,
						payload.i5,
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withCheckpointGroup(parentId),
							A2(
								$elm$core$Basics$composeR,
								$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious(payload.ay),
								A2(
									$elm$core$Basics$composeR,
									$author$project$CheckpointData$Checkpoint$Checkpoint$withNext(payload.ax),
									$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n))))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpoint,
							previousId,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withNext(
								$elm$core$Maybe$Just(payload.i5))),
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpoint,
							nextId,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious(
								$elm$core$Maybe$Just(payload.i5)))));
			} else {
				var parentId = _v0.a.a;
				var previousId = _v0.b.a;
				var _v1 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpoint,
						payload.i5,
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withCheckpointGroup(parentId),
							A2(
								$elm$core$Basics$composeR,
								$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious(payload.ay),
								A2(
									$elm$core$Basics$composeR,
									$author$project$CheckpointData$Checkpoint$Checkpoint$withNext($elm$core$Maybe$Nothing),
									$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n))))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
							parentId,
							$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withLast(
								$elm$core$Maybe$Just(payload.i5))),
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpoint,
							previousId,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withNext(
								$elm$core$Maybe$Just(payload.i5)))));
			}
		} else {
			if (!_v0.c.$) {
				var parentId = _v0.a.a;
				var _v2 = _v0.b;
				var nextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpoint,
						payload.i5,
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withCheckpointGroup(parentId),
							A2(
								$elm$core$Basics$composeR,
								$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious($elm$core$Maybe$Nothing),
								A2(
									$elm$core$Basics$composeR,
									$author$project$CheckpointData$Checkpoint$Checkpoint$withNext(payload.ax),
									$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n))))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
							parentId,
							$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withFirst(
								$elm$core$Maybe$Just(payload.i5))),
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpoint,
							nextId,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious(
								$elm$core$Maybe$Just(payload.i5)))));
			} else {
				var parentId = _v0.a.a;
				var _v3 = _v0.b;
				var _v4 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpoint,
						payload.i5,
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withCheckpointGroup(parentId),
							A2(
								$elm$core$Basics$composeR,
								$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious($elm$core$Maybe$Nothing),
								A2(
									$elm$core$Basics$composeR,
									$author$project$CheckpointData$Checkpoint$Checkpoint$withNext($elm$core$Maybe$Nothing),
									$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n))))),
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
						parentId,
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withFirst(
								$elm$core$Maybe$Just(payload.i5)),
							$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withLast(
								$elm$core$Maybe$Just(payload.i5)))));
			}
		}
	} else {
		if (!_v0.b.$) {
			if (!_v0.c.$) {
				var _v5 = _v0.a;
				var previousId = _v0.b.a;
				var nextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpoint,
						payload.i5,
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious(payload.ay),
							A2(
								$elm$core$Basics$composeR,
								$author$project$CheckpointData$Checkpoint$Checkpoint$withNext(payload.ax),
								$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n)))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpoint,
							previousId,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withNext(
								$elm$core$Maybe$Just(payload.i5))),
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpoint,
							nextId,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious(
								$elm$core$Maybe$Just(payload.i5)))));
			} else {
				var _v6 = _v0.a;
				var previousId = _v0.b.a;
				var _v7 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
						payload.cC,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withLast(
							$elm$core$Maybe$Just(payload.i5))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpoint,
							payload.i5,
							A2(
								$elm$core$Basics$composeR,
								$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious(payload.ay),
								A2(
									$elm$core$Basics$composeR,
									$author$project$CheckpointData$Checkpoint$Checkpoint$withNext($elm$core$Maybe$Nothing),
									$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n)))),
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpoint,
							previousId,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withNext(
								$elm$core$Maybe$Just(payload.i5)))));
			}
		} else {
			if (!_v0.c.$) {
				var _v8 = _v0.a;
				var _v9 = _v0.b;
				var nextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
						payload.cC,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withFirst(
							$elm$core$Maybe$Just(payload.i5))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpoint,
							payload.i5,
							A2(
								$elm$core$Basics$composeR,
								$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious($elm$core$Maybe$Nothing),
								A2(
									$elm$core$Basics$composeR,
									$author$project$CheckpointData$Checkpoint$Checkpoint$withNext(payload.ax),
									$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n)))),
						A2(
							$author$project$CheckpointData$CheckpointData$updateCheckpoint,
							nextId,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious(
								$elm$core$Maybe$Just(payload.i5)))));
			} else {
				var _v10 = _v0.a;
				var _v11 = _v0.b;
				var _v12 = _v0.c;
				return A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpoint,
					payload.i5,
					A2(
						$elm$core$Basics$composeR,
						$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious($elm$core$Maybe$Nothing),
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$Checkpoint$Checkpoint$withNext($elm$core$Maybe$Nothing),
							$author$project$CheckpointData$Checkpoint$Checkpoint$withRevision(payload.n))));
			}
		}
	}
};
var $author$project$CheckpointData$CheckpointData$detachCheckpoint = function (payload) {
	var _v0 = _Utils_Tuple3(payload.g1, payload.c5, payload.c4);
	if (!_v0.b.$) {
		if (!_v0.c.$) {
			var oldPreviousId = _v0.b.a;
			var oldNextId = _v0.c.a;
			return A2(
				$elm$core$Basics$composeR,
				A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpoint,
					oldPreviousId,
					$author$project$CheckpointData$Checkpoint$Checkpoint$withNext(payload.c4)),
				A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpoint,
					oldNextId,
					$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious(payload.c5)));
		} else {
			if (!_v0.a.$) {
				var oldParentId = _v0.a.a;
				var oldPreviousId = _v0.b.a;
				var _v1 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
						oldParentId,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withLast(payload.c5)),
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpoint,
						oldPreviousId,
						$author$project$CheckpointData$Checkpoint$Checkpoint$withNext($elm$core$Maybe$Nothing)));
			} else {
				var _v5 = _v0.a;
				var oldPreviousId = _v0.b.a;
				var _v6 = _v0.c;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
						payload.cC,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withLast(payload.c5)),
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpoint,
						oldPreviousId,
						$author$project$CheckpointData$Checkpoint$Checkpoint$withNext($elm$core$Maybe$Nothing)));
			}
		}
	} else {
		if (!_v0.a.$) {
			if (!_v0.c.$) {
				var oldParentId = _v0.a.a;
				var _v2 = _v0.b;
				var oldNextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
						oldParentId,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withFirst(payload.c4)),
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpoint,
						oldNextId,
						$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious($elm$core$Maybe$Nothing)));
			} else {
				var oldParentId = _v0.a.a;
				var _v3 = _v0.b;
				var _v4 = _v0.c;
				return A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
					oldParentId,
					A2(
						$elm$core$Basics$composeR,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withFirst($elm$core$Maybe$Nothing),
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withLast($elm$core$Maybe$Nothing)));
			}
		} else {
			if (!_v0.c.$) {
				var _v7 = _v0.a;
				var _v8 = _v0.b;
				var oldNextId = _v0.c.a;
				return A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
						payload.cC,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withFirst(payload.c4)),
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpoint,
						oldNextId,
						$author$project$CheckpointData$Checkpoint$Checkpoint$withPrevious($elm$core$Maybe$Nothing)));
			} else {
				var _v9 = _v0.a;
				var _v10 = _v0.b;
				var _v11 = _v0.c;
				return $elm$core$Basics$identity;
			}
		}
	}
};
var $author$project$CheckpointData$CheckpointData$moveCheckpoint = function (payload) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$CheckpointData$CheckpointData$detachCheckpoint(
			{cC: payload.dZ, i5: payload.i5, d_: payload.dZ, c4: payload.c4, g1: payload.g1, c5: payload.c5}),
		$author$project$CheckpointData$CheckpointData$attachCheckpoint(
			{
				cC: payload.dZ,
				i5: payload.i5,
				ax: $elm$core$Maybe$Nothing,
				fV: $elm$core$Maybe$Just(payload.dZ),
				ay: payload.d_,
				n: payload.n
			}));
};
var $author$project$CheckpointData$EventApplier$applyMovedCheckpoint = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, checkpointData);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			return (_Utils_cmp(payload.n, checkpoint.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$moveCheckpoint(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$CheckpointData$moveCheckpointAfter = function (payload) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$CheckpointData$CheckpointData$detachCheckpoint(payload),
		$author$project$CheckpointData$CheckpointData$attachCheckpoint(
			{
				cC: payload.cC,
				i5: payload.i5,
				ax: payload.fJ,
				fV: payload.dZ,
				ay: $elm$core$Maybe$Just(payload.d_),
				n: payload.n
			}));
};
var $author$project$CheckpointData$EventApplier$applyMovedCheckpointAfter = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, checkpointData);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			return (_Utils_cmp(payload.n, checkpoint.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$moveCheckpointAfter(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$CheckpointData$moveCheckpointBefore = function (payload) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$CheckpointData$CheckpointData$detachCheckpoint(payload),
		$author$project$CheckpointData$CheckpointData$attachCheckpoint(
			{
				cC: payload.cC,
				i5: payload.i5,
				ax: $elm$core$Maybe$Just(payload.fJ),
				fV: payload.dZ,
				ay: payload.d_,
				n: payload.n
			}));
};
var $author$project$CheckpointData$EventApplier$applyMovedCheckpointBefore = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, checkpointData);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			return (_Utils_cmp(payload.n, checkpoint.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$moveCheckpointBefore(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$CheckpointData$attachCheckpointGroup = function (payload) {
	var _v0 = _Utils_Tuple2(payload.ay, payload.ax);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var previousId = _v0.a.a;
			var nextId = _v0.b.a;
			return A2(
				$elm$core$Basics$composeR,
				A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
					payload.cC,
					A2(
						$elm$core$Basics$composeR,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withPrevious(payload.ay),
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withNext(payload.ax),
							$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withRevision(payload.n)))),
				A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
						previousId,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withNext(
							$elm$core$Maybe$Just(payload.cC))),
					A2(
						$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
						nextId,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withPrevious(
							$elm$core$Maybe$Just(payload.cC)))));
		} else {
			var previousId = _v0.a.a;
			var _v1 = _v0.b;
			return A2(
				$elm$core$Basics$composeR,
				A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
					payload.cC,
					A2(
						$elm$core$Basics$composeR,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withPrevious(payload.ay),
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withNext($elm$core$Maybe$Nothing),
							$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withRevision(payload.n)))),
				A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
					previousId,
					$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withNext(
						$elm$core$Maybe$Just(payload.cC))));
		}
	} else {
		if (!_v0.b.$) {
			var _v2 = _v0.a;
			var nextId = _v0.b.a;
			return A2(
				$elm$core$Basics$composeR,
				A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
					payload.cC,
					A2(
						$elm$core$Basics$composeR,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withPrevious($elm$core$Maybe$Nothing),
						A2(
							$elm$core$Basics$composeR,
							$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withNext(payload.ax),
							$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withRevision(payload.n)))),
				A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
					nextId,
					$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withPrevious(
						$elm$core$Maybe$Just(payload.cC))));
		} else {
			var _v3 = _v0.a;
			var _v4 = _v0.b;
			return A2(
				$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
				payload.cC,
				A2(
					$elm$core$Basics$composeR,
					$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withPrevious(payload.ay),
					A2(
						$elm$core$Basics$composeR,
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withNext(payload.ax),
						$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withRevision(payload.n))));
		}
	}
};
var $author$project$CheckpointData$CheckpointData$detachCheckpointGroup = function (payload) {
	var _v0 = _Utils_Tuple2(payload.c5, payload.c4);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var oldPreviousId = _v0.a.a;
			var oldNextId = _v0.b.a;
			return A2(
				$elm$core$Basics$composeR,
				A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
					oldPreviousId,
					$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withNext(
						$elm$core$Maybe$Just(oldNextId))),
				A2(
					$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
					oldNextId,
					$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withPrevious(
						$elm$core$Maybe$Just(oldPreviousId))));
		} else {
			var oldPreviousId = _v0.a.a;
			var _v1 = _v0.b;
			return A2(
				$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
				oldPreviousId,
				$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withNext($elm$core$Maybe$Nothing));
		}
	} else {
		if (!_v0.b.$) {
			var _v2 = _v0.a;
			var oldNextId = _v0.b.a;
			return A2(
				$author$project$CheckpointData$CheckpointData$updateCheckpointGroup,
				oldNextId,
				$author$project$CheckpointData$CheckpointGroup$CheckpointGroup$withPrevious($elm$core$Maybe$Nothing));
		} else {
			var _v3 = _v0.a;
			var _v4 = _v0.b;
			return $elm$core$Basics$identity;
		}
	}
};
var $author$project$CheckpointData$CheckpointData$moveCheckpointGroupAfter = function (payload) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$CheckpointData$CheckpointData$detachCheckpointGroup(payload),
		$author$project$CheckpointData$CheckpointData$attachCheckpointGroup(
			{
				cC: payload.cC,
				ax: payload.fJ,
				ay: $elm$core$Maybe$Just(payload.d_),
				n: payload.n
			}));
};
var $author$project$CheckpointData$EventApplier$applyMovedCheckpointGroupAfter = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, checkpointData);
		if (!_v0.$) {
			var checkpointGroup = _v0.a;
			return (_Utils_cmp(payload.n, checkpointGroup.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$moveCheckpointGroupAfter(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$CheckpointData$moveCheckpointGroupBefore = function (payload) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$CheckpointData$CheckpointData$detachCheckpointGroup(payload),
		$author$project$CheckpointData$CheckpointData$attachCheckpointGroup(
			{
				cC: payload.cC,
				ax: $elm$core$Maybe$Just(payload.fJ),
				ay: payload.d_,
				n: payload.n
			}));
};
var $author$project$CheckpointData$EventApplier$applyMovedCheckpointGroupBefore = F2(
	function (payload, acc) {
		var checkpointData = acc.a;
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, checkpointData);
		if (!_v0.$) {
			var checkpointGroup = _v0.a;
			return (_Utils_cmp(payload.n, checkpointGroup.i) > 0) ? A2(
				$author$project$CheckpointData$CheckpointData$withLastEventId,
				payload.N,
				A2(
					$author$project$CheckpointData$EventApplier$mapCheckpointData,
					$author$project$CheckpointData$CheckpointData$moveCheckpointGroupBefore(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$CheckpointData$EventApplier$applyEventHelper = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyCheckpointGroupCreatedEvent(payload);
		case 1:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyCheckpointGroupTitleChangedEvent(payload);
		case 2:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyCheckpointGroupDescriptionChangedEvent(payload);
		case 3:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyMovedCheckpointGroupBefore(payload);
		case 4:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyMovedCheckpointGroupAfter(payload);
		case 5:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyCheckpointGroupDeletedEvent(payload);
		case 6:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyCheckpointCreatedEvent(payload);
		case 7:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyCheckpointTypeChangedEvent(payload);
		case 8:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyCheckpointTitleChangedEvent(payload);
		case 9:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyCheckpointDescriptionChangedEvent(payload);
		case 10:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyCheckpointFilesChangedEvent(payload);
		case 11:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyMovedCheckpoint(payload);
		case 12:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyMovedCheckpointBefore(payload);
		case 13:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyMovedCheckpointAfter(payload);
		default:
			var payload = event.a;
			return $author$project$CheckpointData$EventApplier$applyCheckpointDeletedEvent(payload);
	}
};
var $author$project$CheckpointData$EventApplier$applyEventsHelper = F2(
	function (events, acc) {
		return A3($author$project$CheckpointData$Events$fold, $author$project$CheckpointData$EventApplier$applyEventHelper, acc, events);
	});
var $author$project$CheckpointData$Checkpoint$Ids$empty = $turboMaCk$any_set$Set$Any$empty($author$project$CheckpointData$Checkpoint$Id$toString);
var $author$project$CheckpointData$Modifications$empty = $author$project$CheckpointData$Modifications$Empty(
	{bW: $author$project$CheckpointData$CheckpointGroup$Dict$empty, bX: $author$project$CheckpointData$Checkpoint$Dict$empty, b1: $author$project$CheckpointData$CheckpointGroup$Ids$empty, b2: $author$project$CheckpointData$Checkpoint$Ids$empty, fD: $elm$core$Maybe$Nothing});
var $author$project$CheckpointData$EventApplier$applyEvents = F2(
	function (events, checkpointData) {
		var modifications = $author$project$CheckpointData$Modifications$empty;
		return A2(
			$author$project$CheckpointData$EventApplier$applyEventsHelper,
			events,
			_Utils_Tuple3(checkpointData, modifications, $author$project$File$Operations$empty));
	});
var $author$project$CheckpointData$Store$checkpointData = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$CheckpointData$CheckpointData$empty;
		case 1:
			return $author$project$CheckpointData$CheckpointData$empty;
		case 2:
			var data = state.a;
			return data.a;
		default:
			var data = state.a;
			return data.a;
	}
};
var $author$project$Environments$Repository$getCheckpointData = function (_v0) {
	var data = _v0;
	return $author$project$Utils$Triple$first(
		A2(
			$author$project$CheckpointData$EventApplier$applyEvents,
			$author$project$CheckpointData$Store$events(data.C),
			$author$project$CheckpointData$Store$checkpointData(data.C)));
};
var $author$project$UI$Icons$pin = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M34.378 23.036c0 .018-.007.032-.007.051-.006.033-.024.122-.056.264v.014c-.162.716-.402 1.426-.711 2.097-.007.013-.013.026-.013.033-1.2 2.832-3.833 7.208-9.583 12.009-5.75-4.795-8.384-9.177-9.584-12.009-.006-.013-.012-.027-.012-.033-.31-.671-.55-1.375-.71-2.097v-.014c-.032-.142-.051-.231-.058-.264 0-.019-.008-.033-.008-.051-.206-1-.257-2.027-.16-3.046.503-5.254 4.866-9.351 10.144-9.532 2.899-.103 5.641.949 7.726 2.962 2.084 2.013 3.226 4.711 3.226 7.609 0 .67-.064 1.349-.194 2.007m-1.42-11.281c-2.536-2.452-5.878-3.73-9.415-3.614-6.441.226-11.758 5.228-12.377 11.629-.117 1.233-.065 2.464.168 3.678.006.052.031.2.09.433.199.871.484 1.723.858 2.536 1.311 3.084 4.163 7.834 10.325 12.946.407.334.898.503 1.394.503.497 0 .988-.169 1.394-.503 6.163-5.118 9.015-9.862 10.325-12.946.375-.813.665-1.665.859-2.536.058-.233.083-.381.091-.433.147-.793.224-1.612.224-2.419 0-3.53-1.399-6.822-3.936-9.274')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M24.001 14.292c-3.782 0-6.866 3.077-6.866 6.866 0 3.787 3.084 6.866 6.866 6.866.638 0 1.162-.523 1.162-1.162 0-.638-.524-1.161-1.162-1.161-2.504 0-4.543-2.04-4.543-4.543 0-2.505 2.039-4.544 4.543-4.544 2.505 0 4.543 2.039 4.543 4.544 0 1.083-.386 2.13-1.091 2.949-.419.49-.361 1.219.13 1.639.491.419 1.219.362 1.64-.129 1.064-1.239 1.644-2.827 1.644-4.459 0-3.782-3.078-6.866-6.866-6.866')
						]),
					_List_Nil)
				]));
	});
var $author$project$Measure$EditDialog$viewInfoCheckpoint = F3(
	function (translations, repository, checkpointId) {
		var value = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Translations$Measures$Info$unknown(translations),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.k8;
				},
				A2(
					$author$project$CheckpointData$CheckpointData$getCheckpoint,
					checkpointId,
					$author$project$Environments$Repository$getCheckpointData(repository))));
		return _List_fromArray(
			[
				$author$project$Measure$EditDialog$viewInfoIcon($author$project$UI$Icons$pin),
				$author$project$Measure$EditDialog$viewInfoLabel(
				$author$project$Translations$Measures$Info$checkpoint(translations)),
				A2($author$project$Measure$EditDialog$viewInfoValue, $elm$core$Maybe$Nothing, value)
			]);
	});
var $author$project$Translations$Measures$Info$creationTimestamp = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.info.creationTimestamp');
};
var $author$project$Measure$EditDialog$viewInfoCreationTimestamp = F3(
	function (translations, timeZone, creationTimestamp) {
		var creationTime = $author$project$Date_Time$NaiveTime$format(
			A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, creationTimestamp));
		var creationDate = $author$project$Date_Time$NaiveDate$format(
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, creationTimestamp));
		var value = creationDate + (' ' + (creationTime + ' Uhr'));
		return _List_fromArray(
			[
				$author$project$Measure$EditDialog$viewInfoIcon($author$project$UI$Icons$info),
				$author$project$Measure$EditDialog$viewInfoLabel(
				$author$project$Translations$Measures$Info$creationTimestamp(translations)),
				A2($author$project$Measure$EditDialog$viewInfoValue, $elm$core$Maybe$Nothing, value)
			]);
	});
var $author$project$Translations$Measures$Info$auditor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.info.auditor');
};
var $author$project$Environments$Repository$getUser = function (userId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Environments$Repository$users,
		$author$project$User$Dict$get(userId));
};
var $author$project$Measure$EditDialog$viewInfoCreator = F3(
	function (translations, repository, auditorId) {
		var value = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Translations$Measures$Info$unknown(translations),
			A2(
				$elm$core$Maybe$map,
				function (user) {
					return $elm$core$String$isEmpty(
						$elm$core$String$trim(user.g_)) ? user.iK : user.g_;
				},
				A2($author$project$Environments$Repository$getUser, auditorId, repository)));
		return _List_fromArray(
			[
				$author$project$Measure$EditDialog$viewInfoIcon($author$project$UI$Icons$user),
				$author$project$Measure$EditDialog$viewInfoLabel(
				$author$project$Translations$Measures$Info$auditor(translations)),
				A2($author$project$Measure$EditDialog$viewInfoValue, $elm$core$Maybe$Nothing, value)
			]);
	});
var $author$project$Measure$EditDialog$UserClickedOrganisationUnit = {$: 16};
var $author$project$UI$Icons$factory = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M22.484 31.529h-7.509c-.579 0-1.049-.469-1.049-1.049v-4.252c0-.58.47-1.049 1.049-1.049h3.754c.579 0 1.049.469 1.049 1.049 0 .579-.47 1.049-1.049 1.049h-2.706v2.154h5.412v-3.203c0-.58.47-1.049 1.049-1.049s1.049.469 1.049 1.049v4.252c0 .58-.47 1.049-1.049 1.049')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M37.472 37.508h-5.416c-.579 0-1.049-.469-1.049-1.049v-4.667c0-.633-.515-1.149-1.149-1.149s-1.149.516-1.149 1.149v4.667c0 .58-.47 1.049-1.049 1.049H10.528c-.579 0-1.049-.469-1.049-1.049V22.636c0-.258.096-.506.266-.698l5.775-6.486c.29-.325.749-.437 1.155-.284.407.154.677.543.678.977l.011 3.052 4.323-3.869c.307-.275.748-.344 1.125-.176.377.167.621.541.623.954l.013 3.127 4.364-3.906c.307-.275.748-.345 1.125-.177.377.169.621.542.623.955l.022 6.196c.002.58-.466 1.051-1.045 1.053-.607.014-1.051-.466-1.052-1.045l-.014-3.862-4.362 3.905c-.307.275-.748.344-1.125.177-.377-.168-.621-.541-.623-.954l-.014-3.128-4.323 3.869c-.308.276-.748.345-1.125.177-.378-.168-.622-.541-.623-.954l-.01-2.647-3.689 4.143V35.41h15.034v-3.618c0-1.79 1.457-3.246 3.247-3.246 1.79 0 3.247 1.456 3.247 3.246v3.618h3.318l-.005-22.82h-3.313v9.716c0 .578-.47 1.048-1.049 1.048s-1.049-.47-1.049-1.048V11.541c0-.58.47-1.049 1.049-1.049h5.41c.58 0 1.049.469 1.049 1.048l.006 24.919c0 .278-.111.545-.307.742-.198.196-.465.307-.742.307')
						]),
					_List_Nil)
				]));
	});
var $author$project$Environments$Repository$getOrganisationUnit = function (organisationUnitId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Environments$Repository$organisationUnits,
		$author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit(organisationUnitId));
};
var $author$project$Translations$Measures$Info$organisationUnit = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.info.organisationUnit');
};
var $author$project$Measure$EditDialog$viewInfoOrganisationUnit = F5(
	function (translations, environment, measure, repository, organisationUnitId) {
		var value = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Translations$Measures$Info$unknown(translations),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.k8;
				},
				A2($author$project$Environments$Repository$getOrganisationUnit, organisationUnitId, repository)));
		var msg = A3(
			$author$project$Auth$Authorization$authorize,
			$author$project$Environments$Environment$userRights(environment),
			5,
			measure.km) ? $elm$core$Maybe$Just($author$project$Measure$EditDialog$UserClickedOrganisationUnit) : $elm$core$Maybe$Nothing;
		return _List_fromArray(
			[
				$author$project$Measure$EditDialog$viewInfoIcon($author$project$UI$Icons$factory),
				$author$project$Measure$EditDialog$viewInfoLabel(
				$author$project$Translations$Measures$Info$organisationUnit(translations)),
				A2($author$project$Measure$EditDialog$viewInfoValue, msg, value)
			]);
	});
var $author$project$Measure$EditDialog$viewInfoContent = F4(
	function (translations, environment, model, repository) {
		var timeZone = $author$project$Environments$Environment$timeZone(environment);
		var content = function () {
			var _v0 = model.h.h6;
			if (!_v0.$) {
				return _Utils_ap(
					A5($author$project$Measure$EditDialog$viewInfoOrganisationUnit, translations, environment, model.h, repository, model.km),
					_Utils_ap(
						A3($author$project$Measure$EditDialog$viewInfoCreationTimestamp, translations, timeZone, model.h.dw),
						_Utils_ap(
							A3($author$project$Measure$EditDialog$viewDeadlineTimestamp, translations, environment, model),
							A3($author$project$Measure$EditDialog$viewInfoCreator, translations, repository, model.h.jd))));
			} else {
				var issueData = _v0.a;
				return _Utils_ap(
					A5($author$project$Measure$EditDialog$viewInfoOrganisationUnit, translations, environment, model.h, repository, model.km),
					_Utils_ap(
						A3($author$project$Measure$EditDialog$viewInfoCheckpoint, translations, repository, issueData.i5),
						_Utils_ap(
							A2($author$project$Measure$EditDialog$viewInfoAudit, translations, model.fF),
							_Utils_ap(
								A3($author$project$Measure$EditDialog$viewInfoCreator, translations, repository, model.h.jd),
								_Utils_ap(
									A3($author$project$Measure$EditDialog$viewInfoCreationTimestamp, translations, timeZone, model.h.dw),
									A3($author$project$Measure$EditDialog$viewDeadlineTimestamp, translations, environment, model))))));
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '3rem auto auto'),
							A2($rtfeldman$elm_css$Css$property, 'grid-row-gap', '1rem'),
							A2($rtfeldman$elm_css$Css$property, 'align-items', 'center'),
							A2($rtfeldman$elm_css$Css$property, 'justify-items', 'start')
						]))
				]),
			content);
	});
var $author$project$Measure$EditDialog$ReceivedOrganisationUnitNavigationMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$UI$OrganisationUnitNavigation$UserClickedCloseDialog = {$: 0};
var $author$project$UI$Modal$Config = $elm$core$Basics$identity;
var $author$project$UI$Modal$appendContent = F2(
	function (content, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				ai: A2($elm$core$List$cons, content, config.ai)
			});
	});
var $author$project$UI$Modal$appendFooter = F2(
	function (footer, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				eE: A2($elm$core$List$cons, footer, config.eE)
			});
	});
var $author$project$UI$Modal$appendStyle = F2(
	function (styles, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				by: A2($elm$core$List$append, config.by, styles)
			});
	});
var $author$project$UI$Modal$modal = F2(
	function (title, onClose) {
		return {ai: _List_Nil, eE: _List_Nil, gO: _List_Nil, jI: $elm$core$Maybe$Nothing, g4: onClose, by: _List_Nil, k8: title};
	});
var $author$project$Translations$MainMenu$organisationUnitNavigation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'mainMenu.organisationUnitNavigation');
};
var $author$project$UI$Modal$viewBackdrop = A3(
	$rtfeldman$elm_css$Html$Styled$node,
	'aw-modal-backdrop',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$backgroundColor(
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$transparentBlack))
				]))
		]),
	_List_Nil);
var $author$project$UI$Modal$viewContent = function (content) {
	if (!content.b) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-modal-content',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$flexShrink(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
						]))
				]),
			$elm$core$List$reverse(content));
	}
};
var $author$project$UI$Modal$viewFooter = function (footer) {
	if (!footer.b) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-modal-footer',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero)
						]))
				]),
			$elm$core$List$reverse(footer));
	}
};
var $author$project$UI$Modal$viewHeader = function (header) {
	if (!header.b) {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-modal-header',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero)
						]))
				]),
			$elm$core$List$reverse(header));
	}
};
var $author$project$UI$Modal$viewCloseIcon = function (onClose) {
	return $author$project$UI$Icon$view(
		A2(
			$author$project$UI$Icon$withStyle,
			$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$rem(0.2)),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3)),
				A3(
					$elm$core$Basics$composeR,
					$author$project$UI$Icon$withOnClick(onClose),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Icon$withStyle(
							$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero)),
						$author$project$UI$Icon$withStyle(
							$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero))),
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$close)))));
};
var $author$project$UI$Modal$viewIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$Icon$withForegroundColor($author$project$UI$Style$Theme$darkGrey),
	A2(
		$elm$core$Basics$composeR,
		$author$project$UI$Icon$withStyle(
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero)),
		A2(
			$elm$core$Basics$composeR,
			$author$project$UI$Icon$withStyle(
				$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero)),
			A2(
				$elm$core$Basics$composeR,
				$author$project$UI$Icon$withStyle(
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3))),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Icon$withStyle(
						$rtfeldman$elm_css$Css$marginRight(
							$rtfeldman$elm_css$Css$rem(0.2))),
					$author$project$UI$Icon$view)))));
var $author$project$UI$Modal$viewTitle = function (title) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
						$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
						$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(title)
			]));
};
var $author$project$UI$Modal$viewWindowTitleBar = F3(
	function (title, icon, onClose) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$rtfeldman$elm_css$Html$Styled$text(''),
					A2($elm$core$Maybe$map, $author$project$UI$Modal$viewIcon, icon)),
					$author$project$UI$Modal$viewTitle(title),
					$author$project$UI$Modal$viewCloseIcon(onClose)
				]));
	});
var $author$project$UI$Modal$viewWindow = function (config) {
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-modal-window',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$auto),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$rem(1)),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$rem(0.5),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
							$rtfeldman$elm_css$Css$float($rtfeldman$elm_css$Css$left),
							$rtfeldman$elm_css$Css$minWidth(
							$rtfeldman$elm_css$Css$rem(20)),
							$rtfeldman$elm_css$Css$maxWidth(
							$rtfeldman$elm_css$Css$pct(90)),
							$rtfeldman$elm_css$Css$maxHeight(
							$rtfeldman$elm_css$Css$pct(100)),
							A2($rtfeldman$elm_css$Css$property, 'width', 'max-content'),
							$rtfeldman$elm_css$Css$left(
							$rtfeldman$elm_css$Css$pct(50)),
							$rtfeldman$elm_css$Css$right(
							$rtfeldman$elm_css$Css$pct(50)),
							$rtfeldman$elm_css$Css$top(
							$rtfeldman$elm_css$Css$pct(50)),
							$rtfeldman$elm_css$Css$transform(
							A2(
								$rtfeldman$elm_css$Css$translate2,
								$rtfeldman$elm_css$Css$pct(-50),
								$rtfeldman$elm_css$Css$pct(-50)))
						]),
					config.by))
			]),
		_List_fromArray(
			[
				A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$UI$Modal$viewWindowTitleBar, config.k8, config.jI, config.g4),
				A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$UI$Modal$viewHeader, config.gO),
				$author$project$UI$Modal$viewContent(config.ai),
				A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$UI$Modal$viewFooter, config.eE)
			]));
};
var $author$project$UI$Modal$view = function (_v0) {
	var config = _v0;
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-modal',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
						$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(2)),
						$rtfeldman$elm_css$Css$zIndex(
						$rtfeldman$elm_css$Css$int(3))
					]))
			]),
		_List_fromArray(
			[
				$author$project$UI$Modal$viewBackdrop,
				$author$project$UI$Modal$viewWindow(config)
			]));
};
var $author$project$UI$OrganisationStructure$Config = $elm$core$Basics$identity;
var $author$project$UI$OrganisationStructure$NoContent = {$: 0};
var $author$project$UI$OrganisationStructure$NoFunction = {$: 0};
var $author$project$UI$OrganisationUnitNavigation$ReceivedCollapseOrganisationUnitMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$OrganisationUnitNavigation$ReceivedExpandOrganisationUnitMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$OrganisationUnitNavigation$UserSelectedOrganisationUnit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Translations$OrganisationUnits$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'organisationUnits.emptyText');
};
var $author$project$OrganisationUnit$OrganisationUnits$getNextSiblingsOf = F2(
	function (organisationUnitId, organisationUnits) {
		var getNextSiblingsOfHelper = F2(
			function (id, acc) {
				return A2(
					$elm$core$Maybe$withDefault,
					acc,
					A2(
						$elm$core$Maybe$map,
						function (organisationUnit) {
							return A2(
								$elm$core$Maybe$withDefault,
								A2($elm$core$List$cons, organisationUnit, acc),
								A2(
									$elm$core$Maybe$map,
									A2(
										$author$project$Utils$Utils$flip,
										getNextSiblingsOfHelper,
										A2($elm$core$List$cons, organisationUnit, acc)),
									organisationUnit.ax));
						},
						A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, id, organisationUnits)));
			});
		return $elm$core$List$reverse(
			A2(getNextSiblingsOfHelper, organisationUnitId, _List_Nil));
	});
var $author$project$OrganisationUnit$OrganisationUnits$getRootOrganisationUnits = F2(
	function (useRootList, organisationUnits) {
		var data = organisationUnits;
		return useRootList ? A3(
			$elm$core$List$foldl,
			$author$project$Utils$Utils$reduceMaybeList,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (id) {
					return A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, id, organisationUnits);
				},
				data.f2)) : A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$Utils$flip, $author$project$OrganisationUnit$OrganisationUnits$getNextSiblingsOf, organisationUnits),
				$author$project$OrganisationUnit$Hierarchy$firstId(
					$author$project$OrganisationUnit$OrganisationUnits$hierarchy(organisationUnits))));
	});
var $author$project$OrganisationUnit$OrganisationUnits$getPreviousSiblingsOf = F2(
	function (organisationUnitId, organisationUnits) {
		var getPreviousSiblingsOfHelper = F2(
			function (id, acc) {
				return A2(
					$elm$core$Maybe$withDefault,
					acc,
					A2(
						$elm$core$Maybe$map,
						function (organisationUnit) {
							return A2(
								$elm$core$Maybe$withDefault,
								A2($elm$core$List$cons, organisationUnit, acc),
								A2(
									$elm$core$Maybe$map,
									A2(
										$author$project$Utils$Utils$flip,
										getPreviousSiblingsOfHelper,
										A2($elm$core$List$cons, organisationUnit, acc)),
									organisationUnit.ay));
						},
						A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, id, organisationUnits)));
			});
		return $elm$core$List$reverse(
			A2(getPreviousSiblingsOfHelper, organisationUnitId, _List_Nil));
	});
var $author$project$OrganisationUnit$OrganisationUnits$getAllSiblingsOf = F2(
	function (organisationUnitId, organisationUnits) {
		return A2(
			$elm$core$List$append,
			A2($author$project$OrganisationUnit$OrganisationUnits$getNextSiblingsOf, organisationUnitId, organisationUnits),
			A2($author$project$OrganisationUnit$OrganisationUnits$getPreviousSiblingsOf, organisationUnitId, organisationUnits));
	});
var $author$project$UI$OrganisationStructure$allowedToMove = F3(
	function (hoveringOrganisationUnit, draggingOrganisationUnit, dragAndDropConfig) {
		return !A2(
			$elm$core$List$member,
			false,
			A2(
				$elm$core$List$map,
				A2(
					$author$project$Auth$Authorization$authorize,
					$author$project$Environments$Environment$userRights(dragAndDropConfig.ac),
					1),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.km;
					},
					A2(
						$elm$core$List$cons,
						draggingOrganisationUnit,
						A2($author$project$OrganisationUnit$OrganisationUnits$getAllSiblingsOf, hoveringOrganisationUnit.km, dragAndDropConfig.kn)))));
	});
var $author$project$Translations$Rights$notAllowedToMove = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'rights.notAllowedToMove');
};
var $author$project$UI$OrganisationStructure$viewGhost = F2(
	function (translations, dragAndDropConfig) {
		var _v0 = _Utils_Tuple2(dragAndDropConfig.hN.hF, dragAndDropConfig.hN.jf);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var _v1 = _v0.a.a;
			var draggingOrganisationUnit = _v1.a;
			var dragState = _v1.b;
			var _v2 = _v0.b.a;
			var hoveringOrganisationUnit = _v2.a;
			var _v3 = A3($author$project$UI$OrganisationStructure$allowedToMove, hoveringOrganisationUnit, draggingOrganisationUnit, dragAndDropConfig) ? _Utils_Tuple2(draggingOrganisationUnit.K, draggingOrganisationUnit.k8) : _Utils_Tuple2(
				$author$project$UI$Style$Theme$red,
				$author$project$Translations$Rights$notAllowedToMove(translations));
			var ghostColor = _v3.a;
			var ghostText = _v3.b;
			var _v4 = dragState;
			var offset = _v4.d0;
			var dragElementDimension = _v4.jq;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
								$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$px(dragElementDimension.b)),
								$rtfeldman$elm_css$Css$left(
								$rtfeldman$elm_css$Css$px(offset.a)),
								$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$px(offset.b)),
								$rtfeldman$elm_css$Css$backgroundColor(
								$author$project$UI$Style$Color$toCssColor(ghostColor)),
								$rtfeldman$elm_css$Css$borderRadius(
								$rtfeldman$elm_css$Css$rem(0.4)),
								$rtfeldman$elm_css$Css$padding(
								$rtfeldman$elm_css$Css$px(10)),
								$rtfeldman$elm_css$Css$maxWidth(
								$rtfeldman$elm_css$Css$rem(40)),
								$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden),
								$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$hidden)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(ghostText)
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $rtfeldman$elm_css$Css$borderLeft3 = $rtfeldman$elm_css$Css$prop3('border-left');
var $author$project$UI$Bar$appendLeftIconList = F2(
	function (iconList, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				c$: $elm$core$List$reverse(
					A2($elm$core$List$append, config.c$, iconList))
			});
	});
var $author$project$Utils$Maybe$isNothing = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		$elm$core$Basics$always(false)),
	$elm$core$Maybe$withDefault(true));
var $author$project$UI$OrganisationStructure$appendMsgToIcon = F3(
	function (organisationUnit, maybeMsg, iconConfig) {
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return A2(
				$author$project$UI$Icon$withOnClickStopPropagation,
				msg(organisationUnit),
				iconConfig);
		} else {
			return iconConfig;
		}
	});
var $rtfeldman$elm_css$Css$fill = $rtfeldman$elm_css$Css$prop1('fill');
var $author$project$UI$OrganisationStructure$transformIcon = F3(
	function (organisationUnit, contrastColor, iconData) {
		return A3(
			$author$project$UI$OrganisationStructure$appendMsgToIcon,
			organisationUnit,
			iconData.ka,
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$fill(
					$author$project$UI$Style$Color$toCssColor(contrastColor)),
				iconData.jI));
	});
var $author$project$UI$Icons$collapse = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 387.841 392.881', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M191.734,5.851c-2.797-3.199-6.797-5.039-10.958-5.039c-4.242,0-8.242,1.84-10.961,5.039l-122.801,144c-2.238,2.641-3.438,6-3.438,9.359c0,2,0.477,4.078,1.359,6c2.32,5.121,7.438,8.398,13.039,8.398h59.84c1.918,36.48,9.918,69.519,23.84,98.32c13.68,28.242,32.961,52.32,57.281,71.68c43.918,34.961,95.68,47.441,129.438,47.441c6.563,0,12.32-4.398,13.922-10.801c1.598-6.398-1.281-13.039-7.039-16.238c-53.602-29.359-81.762-76.642-88.641-148.801c-0.723-7.922-7.762-13.681-15.68-12.961c-7.922,0.723-13.68,7.762-12.961,15.68c3.441,36.16,11.68,66.402,25.121,92.32c7.84,15.198,17.598,28.961,29.199,41.28c-18.402-6.558-37.762-16.401-55.441-30.479c-46.238-36.719-70-91.281-70.719-162c-0.082-7.84-6.48-14.238-14.402-14.238H89.175l91.762-107.441l91.918,107.441h-42.559c-7.922,0-14.402,6.477-14.402,14.398c0,7.918,6.48,14.398,14.402,14.398h73.758c5.602,0,10.723-3.277,13.043-8.398s1.52-11.121-2.16-15.359L191.734,5.851L191.734,5.851z M191.734,5.851')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$Icons$expand = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 387.841 392.881', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M191.733,386.011l123.203-144c3.68-4.238,4.48-10.238,2.16-15.359s-7.441-8.398-13.043-8.398h-73.758c-7.922,0-14.402,6.48-14.402,14.398c0,7.922,6.48,14.398,14.402,14.398h42.559l-91.918,107.441L89.175,247.05h42.559c7.922,0,14.32-6.398,14.402-14.238c0.719-70.718,24.48-125.281,70.719-162c17.68-14.078,37.039-23.922,55.441-30.48c-11.602,12.32-21.359,26.082-29.199,41.281c-13.441,25.918-21.68,56.16-25.121,92.32c-0.719,7.918,5.039,14.957,12.961,15.68c7.918,0.719,14.957-5.039,15.68-12.961c6.879-72.16,35.039-119.442,88.641-148.801c5.758-3.199,8.637-9.84,7.039-16.238c-1.602-6.403-7.359-10.801-13.922-10.801c-33.758,0-85.52,12.48-129.438,47.441c-24.32,19.36-43.602,43.438-57.281,71.68c-13.922,28.801-21.922,61.84-23.84,98.32h-59.84c-5.602,0-10.719,3.277-13.039,8.398c-0.883,1.922-1.359,4-1.359,6c0,3.359,1.199,6.719,3.438,9.359l122.801,144c2.719,3.199,6.719,5.039,10.961,5.039C184.937,391.05,188.937,389.21,191.733,386.011L191.733,386.011z M191.733,386.011')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$OrganisationStructure$viewChangeIcon = F3(
	function (_v0, organisationUnit, contrastColor) {
		var config = _v0;
		return A2($elm$core$List$member, organisationUnit.km, config.jy) ? A2(
			$author$project$UI$Icon$withOnClickStopPropagation,
			config.i9(organisationUnit.km),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(2)),
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$fill(
						$author$project$UI$Style$Color$toCssColor(contrastColor)),
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$collapse)))) : A2(
			$author$project$UI$Icon$withOnClickStopPropagation,
			config.jx(organisationUnit.km),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(2)),
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$fill(
						$author$project$UI$Style$Color$toCssColor(contrastColor)),
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$expand))));
	});
var $author$project$UI$OrganisationStructure$addLeftIcons = F6(
	function (config, organisationUnit, contrastColor, maybeLeftIcon, numberOfCustomContentElements, barConfig) {
		var changeIcon = ($author$project$Utils$Maybe$isNothing(organisationUnit.hV) && (!numberOfCustomContentElements)) ? _List_Nil : _List_fromArray(
			[
				A3($author$project$UI$OrganisationStructure$viewChangeIcon, config, organisationUnit, contrastColor)
			]);
		var addAdditionalLeftIcon = A2(
			$elm$core$Maybe$withDefault,
			changeIcon,
			A2(
				$elm$core$Maybe$map,
				function (icon) {
					return A2(
						$elm$core$List$cons,
						A3($author$project$UI$OrganisationStructure$transformIcon, organisationUnit, contrastColor, icon),
						changeIcon);
				},
				maybeLeftIcon));
		return A2($author$project$UI$Bar$appendLeftIconList, addAdditionalLeftIcon, barConfig);
	});
var $author$project$UI$Bar$appendRightIconList = F2(
	function (iconList, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				c9: $elm$core$List$reverse(
					A2($elm$core$List$append, config.c9, iconList))
			});
	});
var $rtfeldman$elm_css$Css$borderTop3 = $rtfeldman$elm_css$Css$prop3('border-top');
var $author$project$UI$Style$Theme$black = A4($author$project$UI$Style$Color$rgba, 0 / 255, 0 / 255, 0 / 255, 1.0);
var $author$project$UI$OrganisationStructure$dropIndicator = function (dragAndDropConfig) {
	var _v0 = _Utils_Tuple2(dragAndDropConfig.hN.jf, dragAndDropConfig.hN.hF);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.a.a;
		var hoveringOrganisationUnit = _v1.a;
		var droppableState = _v1.b;
		var _v2 = _v0.b.a;
		var draggingOrganisationUnit = _v2.a;
		if (A3($author$project$UI$OrganisationStructure$allowedToMove, hoveringOrganisationUnit, draggingOrganisationUnit, dragAndDropConfig)) {
			var color_ = _Utils_eq(draggingOrganisationUnit.K, hoveringOrganisationUnit.K) ? $author$project$UI$Style$Theme$black : draggingOrganisationUnit.K;
			switch (droppableState) {
				case 0:
					return _List_fromArray(
						[
							A3(
							$rtfeldman$elm_css$Css$borderTop3,
							$rtfeldman$elm_css$Css$px(4),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor(color_))
						]);
				case 1:
					return _List_fromArray(
						[
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(4),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor(color_))
						]);
				default:
					return _List_fromArray(
						[
							A3(
							$rtfeldman$elm_css$Css$borderBottom3,
							$rtfeldman$elm_css$Css$px(4),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor(color_))
						]);
			}
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$UI$OrganisationStructure$elementToRenderEqualsHoveredElement = F2(
	function (target, maybeDragging) {
		if (!maybeDragging.$) {
			var _v1 = maybeDragging.a;
			var elem = _v1.a;
			return _Utils_eq(elem, target);
		} else {
			return false;
		}
	});
var $author$project$UI$OrganisationStructure$elementToRenderIsNotDraggedElement = F2(
	function (target, maybeDragging) {
		if (!maybeDragging.$) {
			var _v1 = maybeDragging.a;
			var elem = _v1.a;
			return !_Utils_eq(elem, target);
		} else {
			return false;
		}
	});
var $author$project$OrganisationUnit$Hierarchy$isAncestorOfHelper = F4(
	function (organisationUnitId, descendantId, hierarchy, acc) {
		return acc ? acc : A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (parentId) {
					return A4(
						$author$project$OrganisationUnit$Hierarchy$isAncestorOfHelper,
						organisationUnitId,
						parentId,
						hierarchy,
						_Utils_eq(organisationUnitId, parentId));
				},
				$author$project$Utils$Maybe$join(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.fV;
						},
						A2($author$project$OrganisationUnit$Hierarchy$getOrganisationUnit, descendantId, hierarchy)))));
	});
var $author$project$OrganisationUnit$Hierarchy$isAncestorOf = F3(
	function (organisationUnitId, descendantId, hierarchy) {
		return A4($author$project$OrganisationUnit$Hierarchy$isAncestorOfHelper, organisationUnitId, descendantId, hierarchy, false);
	});
var $author$project$UI$OrganisationStructure$isNotDescendant = F3(
	function (target, maybeDragging, organisationUnits) {
		if (!maybeDragging.$) {
			var _v1 = maybeDragging.a;
			var elem = _v1.a;
			return !A3(
				$author$project$OrganisationUnit$Hierarchy$isAncestorOf,
				elem.km,
				target.km,
				$author$project$OrganisationUnit$OrganisationUnits$hierarchy(organisationUnits));
		} else {
			return false;
		}
	});
var $author$project$UI$OrganisationStructure$barAttributes = F2(
	function (dragAndDropConfig, organisationUnit) {
		var additionalCss = (A2($author$project$UI$OrganisationStructure$elementToRenderEqualsHoveredElement, organisationUnit, dragAndDropConfig.hN.jf) && (A2($author$project$UI$OrganisationStructure$elementToRenderIsNotDraggedElement, organisationUnit, dragAndDropConfig.hN.hF) && A3($author$project$UI$OrganisationStructure$isNotDescendant, organisationUnit, dragAndDropConfig.hN.hF, dragAndDropConfig.kn))) ? $author$project$UI$OrganisationStructure$dropIndicator(dragAndDropConfig) : _List_fromArray(
			[
				A3(
				$rtfeldman$elm_css$Css$borderTop3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
				A3(
				$rtfeldman$elm_css$Css$borderBottom3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white))
			]);
		var _v0 = dragAndDropConfig.hN.hF;
		if (!_v0.$) {
			var _v1 = _v0.a;
			var draggedElement = _v1.a;
			return _List_fromArray(
				[
					$author$project$UI$DragAndDrop$MouseEvent$onMouseOver(
					A2(
						$elm$core$Basics$composeL,
						dragAndDropConfig.hL,
						$author$project$UI$DragAndDrop$DragAndDrop$Over(organisationUnit))),
					$author$project$UI$DragAndDrop$MouseEvent$onMouseUp(
					A2(
						$elm$core$Basics$composeL,
						dragAndDropConfig.hM,
						A2($author$project$UI$DragAndDrop$DragAndDrop$Up, draggedElement, organisationUnit))),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$move),
						additionalCss))
				]);
		} else {
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
						additionalCss)),
					$author$project$UI$DragAndDrop$MouseEvent$onMouseDown(
					A2(
						$elm$core$Basics$composeL,
						dragAndDropConfig.hL,
						$author$project$UI$DragAndDrop$DragAndDrop$Down(organisationUnit)))
				]);
		}
	});
var $author$project$UI$Bar$withAttributes = F2(
	function (attributes_, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{gl: attributes_});
	});
var $author$project$UI$Bar$withOnBarClick = F2(
	function (maybeMsg, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{fN: maybeMsg});
	});
var $author$project$UI$Bar$withRightText = F2(
	function (maybeText, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{kE: maybeText});
	});
var $author$project$UI$OrganisationStructure$viewBar = F3(
	function (_v0, numberOfCustomContentElements, organisationUnit) {
		var config = _v0;
		var rightIconList = _Utils_ap(
			config.kC,
			A3(
				$elm$core$List$foldl,
				$author$project$Utils$Utils$reduceMaybeList,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (fn) {
						return fn(organisationUnit);
					},
					config.kD)));
		var dragAndDropBarAttributes = function () {
			var _v1 = config.iN;
			switch (_v1.$) {
				case 0:
					return _List_Nil;
				case 1:
					var dragAndDropConfig = _v1.a;
					return A2($author$project$UI$OrganisationStructure$barAttributes, dragAndDropConfig, organisationUnit);
				default:
					var multiSelectConfig = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (fn) {
								return A2(fn, multiSelectConfig.kP, organisationUnit);
							},
							multiSelectConfig.j0));
			}
		}();
		var contrastColor = $author$project$UI$Style$Color$calculateContrastColor(organisationUnit.K);
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$Bar$withRightText,
				A2(
					$elm$core$Maybe$andThen,
					function (fn) {
						return fn(organisationUnit);
					},
					config.kE),
				A2(
					$author$project$UI$Bar$withAttributes,
					dragAndDropBarAttributes,
					A2(
						$author$project$UI$Bar$withOnBarClick,
						A2(
							$elm$core$Maybe$map,
							function (msg) {
								return msg(organisationUnit);
							},
							config.iY),
						A2(
							$author$project$UI$Bar$appendRightIconList,
							A2(
								$elm$core$List$map,
								A2($author$project$UI$OrganisationStructure$transformIcon, organisationUnit, contrastColor),
								rightIconList),
							A6(
								$author$project$UI$OrganisationStructure$addLeftIcons,
								config,
								organisationUnit,
								contrastColor,
								config.jV,
								numberOfCustomContentElements,
								A2(
									$author$project$UI$Bar$withTextColour,
									contrastColor,
									A2(
										$author$project$UI$Bar$withBackgroundColour,
										organisationUnit.K,
										$author$project$UI$Bar$bar(organisationUnit.k8)))))))));
	});
var $author$project$UI$OrganisationStructure$renderCustomContent = function (content) {
	return content;
};
var $author$project$UI$OrganisationStructure$viewCustomContent = F3(
	function (_v0, content, organisationUnit) {
		var config = _v0;
		return A2($elm$core$List$member, organisationUnit.km, config.jy) ? $author$project$UI$OrganisationStructure$renderCustomContent(content) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$UI$OrganisationStructure$viewChildContent = F2(
	function (_v5, organisationUnit) {
		var config = _v5;
		return A2($elm$core$List$member, organisationUnit.km, config.jy) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A3(
				$elm$core$Maybe$map2,
				$author$project$UI$OrganisationStructure$viewChildren,
				organisationUnit.hV,
				$elm$core$Maybe$Just(config))) : _List_Nil;
	});
var $author$project$UI$OrganisationStructure$viewChildren = F2(
	function (id, _v3) {
		var config = _v3;
		var _v4 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, id, config.kn);
		if (!_v4.$) {
			var firstChild = _v4.a;
			var childrenList = A2($author$project$OrganisationUnit$OrganisationUnits$getNextSiblingsOf, firstChild.km, config.kn);
			return A2(
				$elm$core$List$map,
				$author$project$UI$OrganisationStructure$viewOrganisationUnit(config),
				childrenList);
		} else {
			return _List_Nil;
		}
	});
var $author$project$UI$OrganisationStructure$viewOrganisationUnit = F2(
	function (config, organisationUnit) {
		var config_ = config;
		var _v1 = function () {
			var _v2 = config_.jg;
			if (!_v2.$) {
				return _Utils_Tuple2(
					$rtfeldman$elm_css$Html$Styled$text(''),
					0);
			} else {
				var _function = _v2.a;
				return _function(organisationUnit);
			}
		}();
		var customContent = _v1.a;
		var numberOfCustomContentElements = _v1.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A3($author$project$UI$OrganisationStructure$viewBar, config, numberOfCustomContentElements, organisationUnit),
				A3($author$project$UI$OrganisationStructure$viewSubContent, config, customContent, organisationUnit)));
	});
var $author$project$UI$OrganisationStructure$viewSubContent = F3(
	function (_v0, customContent, organisationUnit) {
		var config = _v0;
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$px(8)),
								A3(
								$rtfeldman$elm_css$Css$borderLeft3,
								$rtfeldman$elm_css$Css$px(2),
								$rtfeldman$elm_css$Css$solid,
								$author$project$UI$Style$Color$toCssColor(organisationUnit.K)),
								$rtfeldman$elm_css$Css$paddingLeft(
								$rtfeldman$elm_css$Css$px(8)),
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$px(8))
							]))
					]),
				A2(
					$elm$core$List$cons,
					A3($author$project$UI$OrganisationStructure$viewCustomContent, config, customContent, organisationUnit),
					A2($author$project$UI$OrganisationStructure$viewChildContent, config, organisationUnit)))
			]);
	});
var $author$project$UI$OrganisationStructure$view = F2(
	function (environment, _v0) {
		var config = _v0;
		var useAllOrganisationUnits = config.kS && A3(
			$author$project$Utils$Utils$flip,
			$author$project$Auth$Authorization$authorizeSetting,
			3,
			$author$project$Environments$Environment$userRights(environment));
		var translations = $author$project$Environments$Environment$translations(environment);
		var listOfRoots = A2($author$project$OrganisationUnit$OrganisationUnits$getRootOrganisationUnits, !useAllOrganisationUnits, config.kn);
		if ($elm$core$List$isEmpty(listOfRoots)) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$OrganisationUnits$emptyText(translations))
					]));
		} else {
			var _v1 = function () {
				var _v2 = config.iN;
				if (_v2.$ === 1) {
					var dragAndDropConfig = _v2.a;
					var _v3 = dragAndDropConfig.hN.hF;
					if (!_v3.$) {
						var _v4 = _v3.a;
						var draggedElement = _v4.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[
									$author$project$UI$DragAndDrop$MouseEvent$onMouseMove(
									A2(
										$elm$core$Basics$composeL,
										dragAndDropConfig.hL,
										$author$project$UI$DragAndDrop$DragAndDrop$Move(draggedElement)))
								]),
							A2($author$project$UI$OrganisationStructure$viewGhost, translations, dragAndDropConfig));
					} else {
						return _Utils_Tuple2(
							_List_Nil,
							A2($author$project$UI$OrganisationStructure$viewGhost, translations, dragAndDropConfig));
					}
				} else {
					return _Utils_Tuple2(
						_List_Nil,
						$rtfeldman$elm_css$Html$Styled$text(''));
				}
			}();
			var mainListener = _v1.a;
			var ghost = _v1.b;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				mainListener,
				A2(
					$elm$core$List$cons,
					ghost,
					A2(
						$elm$core$List$map,
						$author$project$UI$OrganisationStructure$viewOrganisationUnit(config),
						listOfRoots)));
		}
	});
var $author$project$UI$OrganisationUnitNavigation$viewContent = F3(
	function (environment, organisationUnits, model) {
		return A2(
			$author$project$UI$OrganisationStructure$view,
			environment,
			{
				iN: $author$project$UI$OrganisationStructure$NoFunction,
				iY: $elm$core$Maybe$Just($author$project$UI$OrganisationUnitNavigation$UserSelectedOrganisationUnit),
				i9: $author$project$UI$OrganisationUnitNavigation$ReceivedCollapseOrganisationUnitMsg,
				jg: $author$project$UI$OrganisationStructure$NoContent,
				jx: $author$project$UI$OrganisationUnitNavigation$ReceivedExpandOrganisationUnitMsg,
				jy: model.dI,
				jV: $elm$core$Maybe$Nothing,
				kn: organisationUnits,
				kC: _List_Nil,
				kD: _List_Nil,
				kE: $elm$core$Maybe$Nothing,
				kS: true
			});
	});
var $author$project$Translations$Buttons$close = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'buttons.close');
};
var $author$project$UI$OrganisationUnitNavigation$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$UI$OrganisationUnitNavigation$UserClickedCloseDialog,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$UI$OrganisationUnitNavigation$UserDeselectedOrganisationUnit = {$: 4};
var $author$project$Translations$Buttons$deselect = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'buttons.deselect');
};
var $author$project$UI$OrganisationUnitNavigation$viewDeselectButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$UI$OrganisationUnitNavigation$UserDeselectedOrganisationUnit,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$deselect(translations))));
};
var $author$project$UI$OrganisationUnitNavigation$viewFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$UI$OrganisationUnitNavigation$viewDeselectButton(translations),
				$author$project$UI$OrganisationUnitNavigation$viewCloseButton(translations)
			]));
};
var $author$project$UI$OrganisationUnitNavigation$viewDialog = F3(
	function (environment, organisationUnits, model) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var styles = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(70))
			]);
		return $author$project$UI$Modal$view(
			A2(
				$author$project$UI$Modal$appendStyle,
				styles,
				A2(
					$author$project$UI$Modal$appendFooter,
					$author$project$UI$OrganisationUnitNavigation$viewFooter(translations),
					A2(
						$author$project$UI$Modal$appendContent,
						A3($author$project$UI$OrganisationUnitNavigation$viewContent, environment, organisationUnits, model),
						A2(
							$author$project$UI$Modal$modal,
							$author$project$Translations$MainMenu$organisationUnitNavigation(translations),
							$author$project$UI$OrganisationUnitNavigation$UserClickedCloseDialog)))));
	});
var $author$project$UI$OrganisationUnitNavigation$view = F3(
	function (organisationUnits, dialog, environment) {
		if (!dialog.$) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var model = dialog.a;
			return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$UI$OrganisationUnitNavigation$viewDialog, environment, organisationUnits, model);
		}
	});
var $author$project$Measure$EditDialog$viewOrganisationUnitNavigation = F3(
	function (environment, repository, organisationUnitNavigation) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$Measure$EditDialog$ReceivedOrganisationUnitNavigationMsg,
			A3(
				$author$project$UI$OrganisationUnitNavigation$view,
				$author$project$Environments$Repository$organisationUnits(repository),
				organisationUnitNavigation,
				environment));
	});
var $author$project$Measure$EditDialog$viewInfoTab = F3(
	function (environment, model, repository) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$pct(52))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Measure$EditDialog$viewFooter, translations, 3, model.aq),
					A2(
						$author$project$UI$Dialog$appendContent,
						A3($author$project$Measure$EditDialog$viewOrganisationUnitNavigation, environment, repository, model.d3),
						A2(
							$author$project$UI$Dialog$appendContent,
							A4($author$project$Measure$EditDialog$viewInfoContent, translations, environment, model, repository),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$Measure$EditDialog$viewInfoBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A3($author$project$Measure$EditDialog$viewTabBar, environment, model.h, 3),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Measures$editDialogHeader(translations),
											$author$project$Measure$EditDialog$UserClickedCloseDialog)))))))));
	});
var $author$project$Measure$ResponsibleUsersEditor$viewBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$user),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Measures$ResponsibleUsers$header(translations))));
};
var $author$project$Measure$EditDialog$UserSelectedUser = function (a) {
	return {$: 9, a: a};
};
var $author$project$Measure$EditDialog$UserUnselectedUser = function (a) {
	return {$: 10, a: a};
};
var $author$project$Measure$ResponsibleUsersEditor$viewCheckbox = F3(
	function (config, userId, selectedIds) {
		return A2(
			$author$project$UI$Checkbox$withOnCheck,
			A2(
				$author$project$Utils$Bool$ifElse,
				config.kf(userId),
				config.kg(userId)),
			A2(
				$author$project$UI$Checkbox$checked,
				A2($author$project$User$Ids$member, userId, selectedIds),
				A2($author$project$UI$Checkbox$disabled, config.jo, $author$project$UI$Checkbox$unlabeled)));
	});
var $author$project$Measure$ResponsibleUsersEditor$viewRow = F4(
	function (conf, viewType, selectedUsers, user) {
		var label = $elm$core$String$isEmpty(user.g_) ? user.iK : user.g_;
		return A2(
			$author$project$UI$Table$Row$withCheckbox,
			A3($author$project$Measure$ResponsibleUsersEditor$viewCheckbox, conf, user.dk, selectedUsers),
			A2(
				$author$project$UI$Table$Row$withAvatar,
				$author$project$UI$Avatar$icon(
					$author$project$UI$Icon$bicolor($author$project$UI$Icons$userCircleBicolor)),
				A3($author$project$UI$Table$Row$row, viewType, label, user)));
	});
var $author$project$Measure$ResponsibleUsersEditor$viewTable = F3(
	function (conf, environment, selectedUsers) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$elm$core$Basics$composeR,
			$author$project$User$Dict$values,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$sortBy(
					function (u) {
						return $elm$core$String$toLower(
							_Utils_ap(u.g_, u.iK));
					}),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Table$fromList(
						A3(
							$author$project$Measure$ResponsibleUsersEditor$viewRow,
							conf,
							$author$project$Environments$Environment$getViewType(environment),
							selectedUsers)),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Table$withEmptyText(
							$author$project$Translations$Measures$ResponsibleUsers$emptyText(translations)),
						$author$project$UI$Table$view))));
	});
var $author$project$Measure$EditDialog$viewResponsibleUsersTable = function (disabled) {
	return $author$project$Measure$ResponsibleUsersEditor$viewTable(
		{jo: disabled, kf: $author$project$Measure$EditDialog$UserSelectedUser, kg: $author$project$Measure$EditDialog$UserUnselectedUser});
};
var $author$project$Measure$EditDialog$viewResponsibleUsersTab = F5(
	function (environment, responsibleUsers, context, availableUsers, measure) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$pct(52))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Measure$EditDialog$viewFooter, translations, 2, context),
					A2(
						$author$project$UI$Dialog$appendContent,
						A4(
							$author$project$Measure$EditDialog$viewResponsibleUsersTable,
							A3($author$project$Measure$EditDialog$disableInput, environment, measure, context),
							environment,
							responsibleUsers,
							availableUsers),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Measure$ResponsibleUsersEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A3($author$project$Measure$EditDialog$viewTabBar, environment, measure, 2),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Measures$editDialogHeader(translations),
										$author$project$Measure$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Measure$EditDialog$viewDialog = F3(
	function (environment, repository, model) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var _v0 = model.cI;
		switch (_v0) {
			case 0:
				return A5($author$project$Measure$EditDialog$viewBasicDataTab, translations, environment, model.aQ, model.aq, model.h);
			case 1:
				return A3($author$project$Measure$EditDialog$viewImagesTab, translations, environment, model);
			case 2:
				var availableUsers = $author$project$Environments$Repository$users(repository);
				return A5($author$project$Measure$EditDialog$viewResponsibleUsersTab, environment, model.bb, model.aq, availableUsers, model.h);
			case 3:
				return A3($author$project$Measure$EditDialog$viewInfoTab, environment, model, repository);
			case 4:
				return A4($author$project$Measure$EditDialog$viewCompleteTab, translations, environment, model.aq, model.h);
			default:
				return A3($author$project$Measure$EditDialog$viewDeleteTab, translations, environment, model.h);
		}
	});
var $author$project$Measure$EditDialog$view = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Measure$EditDialog$viewDialog, environment, repository, model);
			case 2:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Measure$EditDialog$viewDialog, environment, repository, model);
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy,
					$author$project$Measure$EditDialog$viewDeletedDialog,
					$author$project$Environments$Environment$translations(environment));
		}
	});
var $author$project$Archive$CombinedArchive$valueFilter = F3(
	function (currentOrganisationUnitAndChildren, currentOrganisationUnit, _v0) {
		var value = _v0.a;
		if (!value.$) {
			var audit = value.a;
			var filterHelper = F2(
				function (organisationUnitId, bool) {
					return bool ? bool : A2($author$project$Audit$Audit$belongsToOrganisationUnit, organisationUnitId, audit);
				});
			return A3($elm$core$List$foldl, filterHelper, false, currentOrganisationUnitAndChildren);
		} else {
			var measure = value.a;
			return _Utils_eq(measure.km, currentOrganisationUnit.km);
		}
	});
var $author$project$Archive$CombinedArchive$valueByOrganisationUnitsFilter = F3(
	function (organisationUnits, values_, currentOrganisationUnit) {
		var currentOrganisationUnitAndChildren = A2(
			$elm$core$List$cons,
			currentOrganisationUnit.km,
			$author$project$OrganisationUnit$Ids$toList(
				A2(
					$author$project$OrganisationUnit$Hierarchy$getDescendantIdsOf,
					currentOrganisationUnit,
					$author$project$OrganisationUnit$OrganisationUnits$hierarchy(organisationUnits))));
		return A2(
			$elm$core$List$filter,
			A2($author$project$Archive$CombinedArchive$valueFilter, currentOrganisationUnitAndChildren, currentOrganisationUnit),
			values_);
	});
var $author$project$Archive$CombinedArchive$filter = F4(
	function (environment, searchValue, organisationUnits, values_) {
		var filteredSearched = $elm$core$String$isEmpty(searchValue) ? values_ : A3(
			$author$project$Utils$FuzzySearch$fuzzySearch,
			{
				jP: function (_v0) {
					var value = _v0.a;
					if (!value.$) {
						var audit = value.a;
						return audit.fw + (' ' + audit.k8);
					} else {
						var measure = value.a;
						return measure.fw + (' ' + measure.k8);
					}
				},
				j2: -1
			},
			searchValue,
			values_);
		return $author$project$Environments$Environment$getSeeAll(environment) ? filteredSearched : A2(
			$elm$core$Maybe$withDefault,
			filteredSearched,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Archive$CombinedArchive$valueByOrganisationUnitsFilter, organisationUnits, values_),
				A2(
					$elm$core$Maybe$andThen,
					A2($author$project$Utils$Utils$flip, $author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, organisationUnits),
					$author$project$Environments$Environment$getCurrentOrganisationUnit(environment))));
	});
var $author$project$Archive$CombinedArchiveContent$UserClickedViewAudit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Translations$Archive$auditCompletionTimestamp = F3(
	function (translations, date, time) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'archive.auditCompletionTimestamp',
			_List_fromArray(
				[
					_Utils_Tuple2('date', date),
					_Utils_Tuple2('time', time)
				]));
	});
var $author$project$Archive$CombinedArchiveContent$UserClickedAuditEditIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Archive$CombinedArchiveContent$viewEditAuditIcon = function (auditId) {
	return A2(
		$author$project$UI$Icon$withOnClickStopPropagation,
		$author$project$Archive$CombinedArchiveContent$UserClickedAuditEditIcon(auditId),
		$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle));
};
var $author$project$Archive$CombinedArchiveContent$viewAuditRow = F4(
	function (translations, environment, repository, _v0) {
		var audit = _v0.a;
		var completionTimestamp = _v0.b;
		var withEditAudit = function (config) {
			var allowedToEditAudit = A2(
				$elm$core$List$member,
				true,
				A2(
					$elm$core$List$map,
					function (organisationUnitId) {
						return A3(
							$author$project$Auth$Authorization$authorize,
							$author$project$Environments$Environment$userRights(environment),
							7,
							organisationUnitId) || A3(
							$author$project$Auth$Authorization$authorize,
							$author$project$Environments$Environment$userRights(environment),
							9,
							organisationUnitId);
					},
					A2(
						$elm$core$List$map,
						function (organisationUnitId) {
							return organisationUnitId.km;
						},
						$author$project$OrganisationUnit$Hierarchy$organisationUnits(
							$author$project$OrganisationUnit$OrganisationUnits$hierarchy(
								$author$project$Environments$Repository$organisationUnits(repository))))));
			return allowedToEditAudit ? A2(
				$author$project$UI$Table$Row$withRightIcon,
				$author$project$Archive$CombinedArchiveContent$viewEditAuditIcon(audit.gm),
				config) : config;
		};
		var timeZone = $author$project$Environments$Environment$timeZone(environment);
		var deadlineTime = $author$project$Date_Time$NaiveTime$format(
			A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, completionTimestamp));
		var deadlineDate = $author$project$Date_Time$NaiveDate$format(
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, completionTimestamp));
		return withEditAudit(
			A2(
				$author$project$UI$Table$Row$withOnClick,
				$author$project$Archive$CombinedArchiveContent$UserClickedViewAudit(audit.gm),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					A3($author$project$Translations$Archive$auditCompletionTimestamp, translations, deadlineDate, deadlineTime),
					A2(
						$author$project$UI$Table$Row$withId,
						audit.fw,
						A3(
							$author$project$UI$Table$Row$row,
							$author$project$Environments$Environment$getViewType(environment),
							audit.k8,
							_Utils_Tuple2(
								$author$project$Archive$CombinedArchive$Audit(audit),
								completionTimestamp))))));
	});
var $author$project$Archive$CombinedArchiveContent$UserClickedMeasureEditIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$Archive$measureCompletionTimestamp = F3(
	function (translations, date, time) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'archive.measureCompletionTimestamp',
			_List_fromArray(
				[
					_Utils_Tuple2('date', date),
					_Utils_Tuple2('time', time)
				]));
	});
var $author$project$Archive$CombinedArchiveContent$viewEditMeasureIcon = $author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle);
var $author$project$Archive$CombinedArchiveContent$viewMeasureRow = F3(
	function (translations, environment, _v0) {
		var measure = _v0.a;
		var completionTimestamp = _v0.b;
		var withEditMeasure = function (config) {
			return A3(
				$author$project$Auth$Authorization$authorize,
				$author$project$Environments$Environment$userRights(environment),
				5,
				measure.km) ? A2($author$project$UI$Table$Row$withRightIcon, $author$project$Archive$CombinedArchiveContent$viewEditMeasureIcon, config) : config;
		};
		var timeZone = $author$project$Environments$Environment$timeZone(environment);
		var deadlineTime = $author$project$Date_Time$NaiveTime$format(
			A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, completionTimestamp));
		var deadlineDate = $author$project$Date_Time$NaiveDate$format(
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, completionTimestamp));
		return withEditMeasure(
			A2(
				$author$project$UI$Table$Row$withOnClick,
				$author$project$Archive$CombinedArchiveContent$UserClickedMeasureEditIcon(measure.h5),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					A3($author$project$Translations$Archive$measureCompletionTimestamp, translations, deadlineDate, deadlineTime),
					A2(
						$author$project$UI$Table$Row$withId,
						measure.fw,
						A3(
							$author$project$UI$Table$Row$row,
							$author$project$Environments$Environment$getViewType(environment),
							measure.k8,
							_Utils_Tuple2(
								$author$project$Archive$CombinedArchive$Measure(measure),
								completionTimestamp))))));
	});
var $author$project$Archive$CombinedArchiveContent$viewRow = F3(
	function (environment, repository, _v0) {
		var type_ = _v0.a;
		var completionTimestamp = _v0.b;
		var translations = $author$project$Environments$Environment$translations(environment);
		if (!type_.$) {
			var audit = type_.a;
			return A4(
				$author$project$Archive$CombinedArchiveContent$viewAuditRow,
				translations,
				environment,
				repository,
				_Utils_Tuple2(audit, completionTimestamp));
		} else {
			var measure = type_.a;
			return A3(
				$author$project$Archive$CombinedArchiveContent$viewMeasureRow,
				translations,
				environment,
				_Utils_Tuple2(measure, completionTimestamp));
		}
	});
var $author$project$Archive$CombinedArchiveContent$viewTable = F5(
	function (values, searchValue, takeValue, environment, repository) {
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Archive$emptyText(
					$author$project$Environments$Environment$translations(environment)),
				A2(
					$author$project$UI$Table$fromList,
					A2($author$project$Archive$CombinedArchiveContent$viewRow, environment, repository),
					A2(
						$elm$core$List$take,
						takeValue,
						A4(
							$author$project$Archive$CombinedArchive$filter,
							environment,
							searchValue,
							$author$project$Environments$Repository$organisationUnits(repository),
							values)))));
	});
var $author$project$Archive$CombinedArchiveContent$viewLoaded = F4(
	function (environment, repository, model, searchValue) {
		var values = $author$project$Archive$CombinedArchive$valuesWithCompletionTimestamp(model.an);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$Archive$CombinedArchiveContent$viewTable, values, searchValue, model.bF, environment, repository),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Archive$CombinedArchiveContent$GotEditMeasureDialogMsg,
					A3($author$project$Measure$EditDialog$view, environment, repository, model.cP)),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Archive$CombinedArchiveContent$GotEditAuditDialogMsg,
					A3($author$project$Audit$EditDialog$view, environment, repository, model.cN))
				]));
	});
var $author$project$Translations$Archive$loadingMeasures = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.loadingMeasures');
};
var $author$project$Archive$CombinedArchiveContent$viewLoading = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Archive$loadingMeasures(translations))
			]));
};
var $author$project$Archive$CombinedArchiveContent$view = F4(
	function (environment, repository, content, searchValue) {
		switch (content.$) {
			case 0:
				return $author$project$Archive$CombinedArchiveContent$viewLoading(environment);
			case 1:
				var model = content.a;
				return A4($author$project$Archive$CombinedArchiveContent$viewLoaded, environment, repository, model, searchValue);
			default:
				return $author$project$Archive$CombinedArchiveContent$viewError(environment);
		}
	});
var $author$project$Archive$MeasureArchiveContent$viewErrorText = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Archive$error(translations))
			]));
};
var $author$project$Archive$MeasureArchiveContent$viewError = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return A2(
		$author$project$UI$Page$view,
		environment,
		A2(
			$author$project$UI$Page$appendContent,
			$author$project$Archive$MeasureArchiveContent$viewErrorText(translations),
			A2(
				$author$project$UI$Page$withIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedDocument),
				$author$project$UI$Page$page(
					$author$project$Translations$Archive$measureMainHeader(translations)))));
};
var $author$project$Measure$Measure$filterMeasureOfCurrentOrganisationUnit = F3(
	function (organisationUnits, measures, organisationUnit) {
		var currentOrganisationUnitAndChildren = A2(
			$elm$core$List$cons,
			organisationUnit.km,
			$author$project$OrganisationUnit$Ids$toList(
				A2(
					$author$project$OrganisationUnit$Hierarchy$getDescendantIdsOf,
					organisationUnit,
					$author$project$OrganisationUnit$OrganisationUnits$hierarchy(organisationUnits))));
		return A2(
			$elm$core$List$filter,
			function (measure) {
				return A2($elm$core$List$member, measure.km, currentOrganisationUnitAndChildren);
			},
			measures);
	});
var $author$project$Measure$Measure$filter = F4(
	function (environment, searchValue, organisationUnits, measures) {
		var filteredSearched = $elm$core$String$isEmpty(searchValue) ? measures : A3(
			$author$project$Utils$FuzzySearch$fuzzySearch,
			{
				jP: function (audit) {
					return audit.fw + (' ' + audit.k8);
				},
				j2: -1
			},
			searchValue,
			measures);
		return $author$project$Environments$Environment$getSeeAll(environment) ? filteredSearched : A2(
			$elm$core$Maybe$withDefault,
			filteredSearched,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Measure$Measure$filterMeasureOfCurrentOrganisationUnit, organisationUnits, filteredSearched),
				A2(
					$elm$core$Maybe$andThen,
					A2($author$project$Utils$Utils$flip, $author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, organisationUnits),
					$author$project$Environments$Environment$getCurrentOrganisationUnit(environment))));
	});
var $author$project$Archive$ArchivedMeasures$getCompletionTimestamp = function (measure) {
	var _v0 = measure.jb;
	if (!_v0.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var posix = _v0.a;
		return $elm$core$Maybe$Just(posix);
	}
};
var $author$project$Archive$ArchivedMeasures$measuresWithCompletionTimestamp = function (measures) {
	var addTuple = F2(
		function (value, acc) {
			var _v1 = $author$project$Archive$ArchivedMeasures$getCompletionTimestamp(value);
			if (!_v1.$) {
				var completionTimestamp = _v1.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(value, completionTimestamp),
					acc);
			} else {
				return acc;
			}
		});
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortBy,
			function (_v0) {
				var posix = _v0.b;
				return $elm$time$Time$posixToMillis(posix);
			},
			A3($elm$core$List$foldl, addTuple, _List_Nil, measures)));
};
var $author$project$Archive$MeasureArchiveContent$UserClickedEditIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Archive$MeasureArchiveContent$viewEditIcon = $author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle);
var $author$project$Archive$MeasureArchiveContent$viewRow = F2(
	function (environment, _v0) {
		var measure = _v0.a;
		var completionTimestamp = _v0.b;
		var withEditMeasure = function (config) {
			return A3(
				$author$project$Auth$Authorization$authorize,
				$author$project$Environments$Environment$userRights(environment),
				5,
				measure.km) ? A2($author$project$UI$Table$Row$withRightIcon, $author$project$Archive$MeasureArchiveContent$viewEditIcon, config) : config;
		};
		var timeZone = $author$project$Environments$Environment$timeZone(environment);
		var deadlineTime = $author$project$Date_Time$NaiveTime$format(
			A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, completionTimestamp));
		var deadlineDate = $author$project$Date_Time$NaiveDate$format(
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, completionTimestamp));
		return withEditMeasure(
			A2(
				$author$project$UI$Table$Row$withOnClick,
				$author$project$Archive$MeasureArchiveContent$UserClickedEditIcon(measure.h5),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					A3(
						$author$project$Translations$Archive$completionTimestamp,
						$author$project$Environments$Environment$translations(environment),
						deadlineDate,
						deadlineTime),
					A2(
						$author$project$UI$Table$Row$withId,
						measure.fw,
						A3(
							$author$project$UI$Table$Row$row,
							$author$project$Environments$Environment$getViewType(environment),
							measure.k8,
							_Utils_Tuple2(measure, completionTimestamp))))));
	});
var $author$project$Archive$MeasureArchiveContent$viewTable = F5(
	function (measures, searchValue, takeValue, environment, repository) {
		var organisationUnits = $author$project$Environments$Repository$organisationUnits(repository);
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Archive$emptyText(
					$author$project$Environments$Environment$translations(environment)),
				A2(
					$author$project$UI$Table$fromList,
					$author$project$Archive$MeasureArchiveContent$viewRow(environment),
					A2(
						$elm$core$List$take,
						takeValue,
						$author$project$Archive$ArchivedMeasures$measuresWithCompletionTimestamp(
							A4(
								$author$project$Measure$Measure$filter,
								environment,
								searchValue,
								organisationUnits,
								$author$project$Measure$Dict$values(measures)))))));
	});
var $author$project$Archive$MeasureArchiveContent$viewLoaded = F4(
	function (environment, repository, model, searchValue) {
		var measures = $author$project$Archive$ArchivedMeasures$dict(model.aB);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$Archive$MeasureArchiveContent$viewTable, measures, searchValue, model.bF, environment, repository),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Archive$MeasureArchiveContent$GotEditMeasureDialogMsg,
					A3($author$project$Measure$EditDialog$view, environment, repository, model.cP))
				]));
	});
var $author$project$Archive$MeasureArchiveContent$viewLoading = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Archive$loadingMeasures(translations))
			]));
};
var $author$project$Archive$MeasureArchiveContent$view = F4(
	function (environment, repository, content, searchValue) {
		switch (content.$) {
			case 0:
				return $author$project$Archive$MeasureArchiveContent$viewLoading(environment);
			case 1:
				var model = content.a;
				return A4($author$project$Archive$MeasureArchiveContent$viewLoaded, environment, repository, model, searchValue);
			default:
				return $author$project$Archive$MeasureArchiveContent$viewError(environment);
		}
	});
var $author$project$Translations$Archive$auditBarText = F3(
	function (translations, number1, number2) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'archive.auditBarText',
			_List_fromArray(
				[
					_Utils_Tuple2('number1', number1),
					_Utils_Tuple2('number2', number2)
				]));
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $turboMaCk$any_dict$Dict$Any$size = function (_v0) {
	var dict = _v0.cL;
	return $elm$core$Dict$size(dict);
};
var $author$project$Audit$Dict$size = $turboMaCk$any_dict$Dict$Any$size;
var $author$project$Archive$AuditArchiveContent$getCountText = F2(
	function (translations, content) {
		switch (content.$) {
			case 0:
				return $author$project$Translations$Archive$loadingAudits(translations);
			case 1:
				var model = content.a;
				var numberOfAudits = $elm$core$String$fromInt(
					$author$project$Audit$Dict$size(
						$author$project$Archive$ArchivedAudits$dict(model.aA)));
				var countText = $elm$core$String$fromInt(
					$author$project$Archive$ArchivedAudits$count(model.aA));
				return A3($author$project$Translations$Archive$auditBarText, translations, numberOfAudits, countText);
			default:
				return $author$project$Translations$Archive$error(translations);
		}
	});
var $author$project$Translations$Archive$combinedBarText = F3(
	function (translations, number1, number2) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'archive.combinedBarText',
			_List_fromArray(
				[
					_Utils_Tuple2('number1', number1),
					_Utils_Tuple2('number2', number2)
				]));
	});
var $author$project$Archive$CombinedArchiveContent$getCountText = F2(
	function (translations, content) {
		switch (content.$) {
			case 0:
				return $author$project$Translations$Archive$loadingMeasures(translations);
			case 1:
				var model = content.a;
				var numberOfMeasures = $elm$core$String$fromInt(
					$elm$core$List$length(
						$author$project$Archive$CombinedArchive$values(model.an)));
				var countText = $elm$core$String$fromInt(
					$author$project$Archive$CombinedArchive$count(model.an));
				return A3($author$project$Translations$Archive$combinedBarText, translations, numberOfMeasures, countText);
			default:
				return $author$project$Translations$Archive$error(translations);
		}
	});
var $author$project$Translations$Archive$measureBarText = F3(
	function (translations, number1, number2) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'archive.measureBarText',
			_List_fromArray(
				[
					_Utils_Tuple2('number1', number1),
					_Utils_Tuple2('number2', number2)
				]));
	});
var $author$project$Measure$Dict$size = $turboMaCk$any_dict$Dict$Any$size;
var $author$project$Archive$MeasureArchiveContent$getCountText = F2(
	function (translations, content) {
		switch (content.$) {
			case 0:
				return $author$project$Translations$Archive$loadingMeasures(translations);
			case 1:
				var model = content.a;
				var numberOfMeasures = $elm$core$String$fromInt(
					$author$project$Measure$Dict$size(
						$author$project$Archive$ArchivedMeasures$dict(model.aB)));
				var countText = $elm$core$String$fromInt(
					$author$project$Archive$ArchivedMeasures$count(model.aB));
				return A3($author$project$Translations$Archive$measureBarText, translations, numberOfMeasures, countText);
			default:
				return $author$project$Translations$Archive$error(translations);
		}
	});
var $rtfeldman$elm_css$Css$sticky = {eU: 0, ll: 'sticky'};
var $author$project$UI$Bar$withStyle = F2(
	function (style, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				by: A2($elm$core$List$cons, style, config.by)
			});
	});
var $author$project$Archive$Page$viewBar = F2(
	function (translations, content) {
		var text_ = function () {
			switch (content.$) {
				case 0:
					var content_ = content.a;
					return A2($author$project$Archive$CombinedArchiveContent$getCountText, translations, content_);
				case 1:
					var content_ = content.a;
					return A2($author$project$Archive$AuditArchiveContent$getCountText, translations, content_);
				default:
					var content_ = content.a;
					return A2($author$project$Archive$MeasureArchiveContent$getCountText, translations, content_);
			}
		}();
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(1)),
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
					A2(
						$author$project$UI$Bar$withStyle,
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
						$author$project$UI$Bar$bar(text_)))));
	});
var $author$project$Archive$Page$UserClickedContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Archive$AuditArchiveContent$init = function (environment) {
	return _Utils_Tuple2(
		$author$project$Archive$AuditArchiveContent$ContentLoading,
		A3($author$project$Archive$AuditArchiveContent$getRequest, environment, '', 0));
};
var $author$project$Archive$CombinedArchiveContent$init = function (environment) {
	return _Utils_Tuple2(
		$author$project$Archive$CombinedArchiveContent$ContentLoading,
		A3($author$project$Archive$CombinedArchiveContent$getRequest, environment, '', 0));
};
var $author$project$Archive$MeasureArchiveContent$init = function (environment) {
	return _Utils_Tuple2(
		$author$project$Archive$MeasureArchiveContent$ContentLoading,
		A3($author$project$Archive$MeasureArchiveContent$getRequest, environment, '', 0));
};
var $author$project$Archive$Page$viewContentIcons = F2(
	function (environment, content) {
		var _v0 = function () {
			switch (content.$) {
				case 0:
					return _Utils_Tuple3($author$project$UI$Style$Theme$green, $author$project$UI$Style$Theme$grey, $author$project$UI$Style$Theme$grey);
				case 1:
					return _Utils_Tuple3($author$project$UI$Style$Theme$grey, $author$project$UI$Style$Theme$green, $author$project$UI$Style$Theme$grey);
				default:
					return _Utils_Tuple3($author$project$UI$Style$Theme$grey, $author$project$UI$Style$Theme$grey, $author$project$UI$Style$Theme$green);
			}
		}();
		var combinedColor = _v0.a;
		var auditColor = _v0.b;
		var measureColor = _v0.c;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$minWidth(
							$rtfeldman$elm_css$Css$rem(12))
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withOnClick,
						$author$project$Archive$Page$UserClickedContent(
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Archive$Page$GotCombinedArchiveContentMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Archive$Page$CombinedArchive,
									$author$project$Archive$CombinedArchiveContent$init(environment)))),
						A2(
							$author$project$UI$Icon$withStyle,
							$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$rem(4)),
							A2(
								$author$project$UI$Icon$withForegroundColor,
								combinedColor,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedDocument))))),
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withOnClick,
						$author$project$Archive$Page$UserClickedContent(
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Archive$Page$GotAuditArchiveContentMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Archive$Page$AuditArchive,
									$author$project$Archive$AuditArchiveContent$init(environment)))),
						A2(
							$author$project$UI$Icon$withStyle,
							$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$rem(4)),
							A2(
								$author$project$UI$Icon$withForegroundColor,
								auditColor,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$audits))))),
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withOnClick,
						$author$project$Archive$Page$UserClickedContent(
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Archive$Page$GotMeasureArchiveContentMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Archive$Page$MeasureArchive,
									$author$project$Archive$MeasureArchiveContent$init(environment)))),
						A2(
							$author$project$UI$Icon$withStyle,
							$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$rem(4)),
							A2(
								$author$project$UI$Icon$withForegroundColor,
								measureColor,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList)))))
				]));
	});
var $author$project$Archive$Page$EnteredSearchString = function (a) {
	return {$: 6, a: a};
};
var $author$project$Archive$Page$SearchOnEnter = {$: 7};
var $author$project$Translations$FuzzySearch$search = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'fuzzySearch.search');
};
var $author$project$Archive$Page$viewSearch = F2(
	function (translations, searchValue) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withStyle,
				$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(50)),
				A2(
					$author$project$UI$TextInput$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3)),
					A2(
						$author$project$UI$TextInput$withOnEnter,
						$author$project$Archive$Page$SearchOnEnter,
						A2(
							$author$project$UI$TextInput$withOnInput,
							$author$project$Archive$Page$EnteredSearchString,
							A2(
								$author$project$UI$TextInput$withPlaceholder,
								$author$project$Translations$FuzzySearch$search(translations),
								A2($author$project$UI$TextInput$withValue, searchValue, $author$project$UI$TextInput$singleLine)))))));
	});
var $author$project$Archive$Page$UserDeselectedSeeAll = {$: 5};
var $author$project$Archive$Page$UserSelectedSeeAll = {$: 4};
var $author$project$UI$Icons$eyeCircle = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M32 58.462C17.406 58.462 5.537 46.592 5.537 32 5.537 17.406 17.406 5.536 32 5.536c14.594 0 26.463 11.87 26.463 26.464 0 14.592-11.869 26.462-26.463 26.462m21.914-48.376C48.054 4.238 40.28 1 32 1c-8.28 0-16.067 3.225-21.914 9.086C4.226 15.932 1 23.719 1 32c0 8.28 3.226 16.066 9.086 21.914C15.933 59.773 23.72 63 32 63c8.28 0 16.067-3.227 21.914-9.086C59.761 48.054 63 40.28 63 32c0-8.281-3.226-16.068-9.086-21.914')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M44.65 36.363c-2.93 2.331-7.542 5.109-12.928 5.109-5.815 0-11.487-3.191-16.873-9.484.849-1.003 2.406-2.677 4.494-4.344 2.928-2.33 7.54-5.108 12.927-5.108 5.815 0 11.487 3.19 16.873 9.485-.85 1.002-2.408 2.685-4.493 4.342m7.632-5.318c-6.228-7.658-12.952-11.547-20.004-11.547-2.794 0-5.622.623-8.416 1.843-2.197.968-4.376 2.307-6.471 3.981-3.543 2.836-5.631 5.663-5.715 5.782-.405.555-.388 1.313.042 1.851 6.219 7.667 12.952 11.547 20.004 11.547 2.795 0 5.621-.623 8.416-1.844 2.197-.967 4.377-2.306 6.472-3.981 3.542-2.836 5.63-5.663 5.714-5.781.404-.555.388-1.312-.042-1.851')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M37.588 30.486c-.832 0-1.514.682-1.514 1.514 0 2.247-1.826 4.074-4.074 4.074-2.247 0-4.073-1.827-4.073-4.074s1.826-4.074 4.073-4.074c.833 0 1.515-.681 1.515-1.514s-.682-1.515-1.515-1.515c-3.921 0-7.103 3.19-7.103 7.103s3.182 7.103 7.103 7.103c3.922 0 7.103-3.19 7.103-7.103 0-.832-.682-1.514-1.515-1.514')
						]),
					_List_Nil)
				]));
	});
var $author$project$Translations$Settings$seeAll = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'settings.seeAll');
};
var $author$project$Archive$Page$viewSeeAllOption = function (environment) {
	var text_ = ($author$project$Environments$Environment$viewport(environment).ln > 500) ? $author$project$Translations$Settings$seeAll(
		$author$project$Environments$Environment$translations(environment)) : '';
	var _v0 = $author$project$Environments$Environment$getSeeAll(environment) ? _Utils_Tuple2(
		$author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3)),
				A2(
					$author$project$UI$Icon$withForegroundColor,
					$author$project$UI$Style$Theme$green,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$eyeCircle)))),
		$author$project$Archive$Page$UserDeselectedSeeAll) : _Utils_Tuple2(
		$author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3)),
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$eyeCircle))),
		$author$project$Archive$Page$UserSelectedSeeAll);
	var icon = _v0.a;
	var msg = _v0.b;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(0.2)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
					])),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
			]),
		_List_fromArray(
			[
				icon,
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$rem(0.6)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(text_)
					]))
			]));
};
var $author$project$Archive$Page$viewHeader = F4(
	function (translations, searchValue, environment, content) {
		var seeAllOption = function () {
			var _v0 = $author$project$Environments$Environment$getCurrentOrganisationUnit(environment);
			if (_v0.$ === 1) {
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				return $author$project$Archive$Page$viewSeeAllOption(environment);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(0.5))
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Archive$Page$viewSearch, translations, searchValue),
					A2($author$project$Archive$Page$viewContentIcons, environment, content),
					seeAllOption
				]));
	});
var $author$project$UI$Page$withAttributeMsg = F2(
	function (attributeMsg, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{fc: attributeMsg});
	});
var $author$project$Archive$Page$view = F3(
	function (environment, repository, _v0) {
		var model = _v0;
		var translations = $author$project$Environments$Environment$translations(environment);
		var attributeMsg = function () {
			var _v3 = $author$project$Environments$Environment$platform(environment);
			if (!_v3.$) {
				return $author$project$Utils$ScrollInfo$onScroll($author$project$Archive$Page$ScrollEvent);
			} else {
				return _List_Nil;
			}
		}();
		var _v1 = function () {
			var _v2 = model.ai;
			switch (_v2.$) {
				case 0:
					var content = _v2.a;
					return _Utils_Tuple2(
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Archive$Page$GotCombinedArchiveContentMsg,
							A4($author$project$Archive$CombinedArchiveContent$view, environment, repository, content, model.aN)),
						$author$project$Translations$Archive$combinedMainHeader(translations));
				case 1:
					var content = _v2.a;
					return _Utils_Tuple2(
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Archive$Page$GotAuditArchiveContentMsg,
							A4($author$project$Archive$AuditArchiveContent$view, environment, repository, content, model.aN)),
						$author$project$Translations$Archive$auditMainHeader(translations));
				default:
					var content = _v2.a;
					return _Utils_Tuple2(
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Archive$Page$GotMeasureArchiveContentMsg,
							A4($author$project$Archive$MeasureArchiveContent$view, environment, repository, content, model.aN)),
						$author$project$Translations$Archive$measureMainHeader(translations));
			}
		}();
		var html = _v1.a;
		var header = _v1.b;
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$withAttributeMsg,
				attributeMsg,
				A2(
					$author$project$UI$Page$appendContent,
					html,
					A2(
						$author$project$UI$Page$appendContent,
						A2($author$project$Archive$Page$viewBar, translations, model.ai),
						A2(
							$author$project$UI$Page$appendHeader,
							A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$Archive$Page$viewHeader, translations, model.aN, environment, model.ai),
							A2(
								$author$project$UI$Page$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedDocument),
								$author$project$UI$Page$page(header)))))));
	});
var $author$project$Page$Page$archive = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 11) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotArchivePageMsg,
		kZ: $elm$core$Maybe$Just($author$project$Archive$Page$subscriptions),
		le: $author$project$Archive$Page$update,
		lm: $author$project$Archive$Page$view
	});
var $author$project$Page$Page$GotAuditPageMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audit$Page$GotEditAuditDialogMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Audit$Page$subscriptions = function (_v0) {
	var page = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Audit$Page$GotEditAuditDialogMsg,
				$author$project$Audit$EditDialog$subscriptions(page.cN))
			]));
};
var $author$project$Audit$Page$Page = $elm$core$Basics$identity;
var $author$project$Audit$Page$enteredSearchString = F4(
	function (newSearchString, environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{aN: newSearchString}),
			ae: repository
		};
	});
var $author$project$Audit$Page$editAuditDialog = function (_v0) {
	var model = _v0;
	return model.cN;
};
var $author$project$Audit$Page$withEditAuditDialog = F2(
	function (editDialog_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{cN: editDialog_});
	});
var $author$project$Audit$Page$gotEditAuditDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$Audit$EditDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$Audit$Page$editAuditDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Audit$Page$GotEditAuditDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$Audit$Page$withEditAuditDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$Audit$Page$GotExecutePlanDialogMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audit$Page$executePlanDialog = function (_v0) {
	var model = _v0;
	return model.eA;
};
var $author$project$Audit$EditDialog$EditAudit = 0;
var $author$project$Audit$Page$openEditAuditAfterCreate = F4(
	function (dialogMsg, environment, repository, page) {
		if (dialogMsg.$ === 5) {
			var command = dialogMsg.a;
			if (!command.$) {
				var createPayload = command.a;
				return A2(
					$elm$core$Maybe$withDefault,
					page,
					A2(
						$elm$core$Maybe$map,
						function (audit) {
							return A2(
								$author$project$Audit$Page$withEditAuditDialog,
								A5(
									$author$project$Audit$EditDialog$show,
									environment,
									repository,
									0,
									$author$project$Environments$Environment$timeZone(environment),
									audit),
								page);
						},
						A2($author$project$Environments$Repository$getAudit, createPayload.gm, repository)));
			} else {
				return page;
			}
		} else {
			return page;
		}
	});
var $author$project$Audit$ExecutePlanDialog$CreatedAuditCommand = function (a) {
	return {$: 5, a: a};
};
var $author$project$Audit$ExecutePlanDialog$HandlingCommand = 2;
var $author$project$Audit$Command$create = F2(
	function (environment, model) {
		return A2(
			$author$project$Audit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Audit$Command$Create(
						{gm: model.gm, bT: model.bT, ff: model.ff, L: commandId_, M: commandTimestamp, dw: model.dw, hI: model.hI, aY: model.aY, dH: model.dH, fw: '', d5: model.d5, d6: model.d6, k8: model.k8});
				}));
	});
var $author$project$CheckpointData$CheckpointData$prependPreviousCheckpointGroupsHelper = F3(
	function (checkpointData, acc, checkpointGroupId) {
		return A2(
			$elm$core$Maybe$withDefault,
			acc,
			A2(
				$elm$core$Maybe$map,
				function (checkpointGroup) {
					return A2(
						$elm$core$Maybe$withDefault,
						A2($elm$core$List$cons, checkpointGroup, acc),
						A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$CheckpointData$CheckpointData$prependPreviousCheckpointGroupsHelper,
								checkpointData,
								A2($elm$core$List$cons, checkpointGroup, acc)),
							checkpointGroup.kw));
				},
				A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, checkpointGroupId, checkpointData)));
	});
var $author$project$CheckpointData$CheckpointData$getCheckpointGroupAndPrev = F2(
	function (lastGroup, checkpointData) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$CheckpointData$CheckpointData$prependPreviousCheckpointGroupsHelper, checkpointData, _List_Nil),
				lastGroup));
	});
var $author$project$CheckpointData$CheckpointGroup$Ids$toList = $turboMaCk$any_set$Set$Any$toList;
var $author$project$Audit$ExecutePlanDialog$filterAndSetOrder = F3(
	function (checkpointGroupIds, repository, organisationUnitId) {
		var idList = $author$project$CheckpointData$CheckpointGroup$Ids$toList(checkpointGroupIds);
		var checkpointGroups = function () {
			var _v2 = A2($author$project$Environments$Repository$getOrganisationUnit, organisationUnitId, repository);
			if (!_v2.$) {
				var organisationUnit = _v2.a;
				return A2(
					$author$project$CheckpointData$CheckpointData$getCheckpointGroupAndPrev,
					organisationUnit.jU,
					$author$project$Environments$Repository$getCheckpointData(repository));
			} else {
				return _List_Nil;
			}
		}();
		var filteredGroups = A2(
			$elm$core$List$filter,
			function (group) {
				return A2($elm$core$List$member, group.cC, idList);
			},
			checkpointGroups);
		var changePrev = F2(
			function (currentGroup, _v1) {
				var prevGroup = _v1.a;
				var acc = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(currentGroup.cC),
					A2(
						$elm$core$List$cons,
						_Utils_update(
							currentGroup,
							{kw: prevGroup}),
						acc));
			});
		var changeNext = F2(
			function (currentGroup, _v0) {
				var nextGroup = _v0.a;
				var acc = _v0.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(currentGroup.cC),
					A2(
						$elm$core$List$cons,
						_Utils_update(
							currentGroup,
							{kc: nextGroup}),
						acc));
			});
		return A3(
			$elm$core$List$foldl,
			changeNext,
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			A3(
				$elm$core$List$foldl,
				changePrev,
				_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
				filteredGroups).b).b;
	});
var $author$project$Audit$Id$from = $elm$core$Basics$identity;
var $author$project$Utils$List$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $author$project$Utils$List$uniqueBy = F2(
	function (f, list) {
		return A4($author$project$Utils$List$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$Audit$ExecutePlanDialog$createAuditCreateCommand = F4(
	function (environment, repository, plan, timeNow) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Audit$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var auditId = _v0.a;
		var newEnvironment = _v0.b;
		var deadline = $elm$time$Time$millisToPosix(
			7200000 + (86400000 + $elm$time$Time$posixToMillis(timeNow)));
		var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
		var filteredCheckpointGroups = $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				A2($author$project$Audit$ExecutePlanDialog$filterAndSetOrder, plan.gt, repository),
				A2(
					$author$project$Utils$List$uniqueBy,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$map,
						function (group) {
							return group.km;
						},
						A3(
							$elm$core$List$foldl,
							$author$project$Utils$Utils$reduceMaybeList,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Utils$Utils$flip, $author$project$CheckpointData$CheckpointData$getCheckpointGroup, checkpointData),
								$author$project$CheckpointData$CheckpointGroup$Ids$toList(plan.gt)))))));
		var foundCheckpointGroupIds = A2(
			$elm$core$List$map,
			function (checkpointGroup) {
				return checkpointGroup.cC;
			},
			filteredCheckpointGroups);
		var checkpoints = $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				A2($author$project$Utils$Utils$flip, $author$project$CheckpointData$CheckpointData$getCheckpointsOf, checkpointData),
				foundCheckpointGroupIds));
		var checkpointHierarchy = {gt: filteredCheckpointGroups, i6: checkpoints};
		return A2(
			$author$project$Audit$Command$create,
			newEnvironment,
			{gm: auditId, bT: plan.bT, ff: checkpointHierarchy, dw: timeNow, hI: deadline, aY: plan.aY, dH: $elm$core$Maybe$Nothing, d5: plan.d5, d6: plan.i, k8: plan.k8});
	});
var $author$project$Audit$ExecutePlanDialog$createAuditCommand = F5(
	function (plan, timeNow, environment, repository, dialog) {
		switch (dialog) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				var _v1 = A4($author$project$Audit$ExecutePlanDialog$createAuditCreateCommand, environment, repository, plan, timeNow);
				var newEnvironment = _v1.a;
				var task = _v1.b;
				return {
					ab: A2($elm$core$Task$perform, $author$project$Audit$ExecutePlanDialog$CreatedAuditCommand, task),
					jn: 2,
					ac: newEnvironment,
					ae: repository
				};
		}
	});
var $author$project$Audit$ExecutePlanDialog$Hidden = 0;
var $author$project$Utils$Triple$with = F4(
	function (firstFn, secondFn, thirdFn, value) {
		return _Utils_Tuple3(
			firstFn(value),
			secondFn(value),
			thirdFn(value));
	});
var $author$project$Audit$Audit$handleCommand = F3(
	function (command, environment, maybeAudit) {
		var acc = {
			cD: $author$project$Audit$Commands$empty,
			ac: environment,
			b8: $author$project$Audit$Events$empty,
			cb: $author$project$File$Operations$empty,
			au: $author$project$Audit$Audit$NotModified(maybeAudit)
		};
		return A2(
			$elm$core$Result$map,
			A3(
				$author$project$Utils$Triple$with,
				function ($) {
					return $.b8;
				},
				function ($) {
					return $.cb;
				},
				function ($) {
					return $.ac;
				}),
			A2($author$project$Audit$Audit$handleCommandHelper, command, acc));
	});
var $author$project$Audit$Commands$singleton = $author$project$Types$Queue$singleton;
var $author$project$Environments$Repository$saveAuditCommandAndEventsAndFileOperations = function (command) {
	return $author$project$Environments$Repository$saveAuditCommandsAndEventsAndFileOperations(
		$author$project$Audit$Commands$singleton(command));
};
var $author$project$Audit$ExecutePlanDialog$createdAuditCommand = F4(
	function (command, environment, repository, dialog) {
		switch (dialog) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				var _v1 = A3($author$project$Audit$Audit$handleCommand, command, environment, $elm$core$Maybe$Nothing);
				if (_v1.$ === 1) {
					var error = _v1.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$auditErrorToString(error)),
						gH: 'Audit.ExecutePlanDialog.elm',
						gK: 'createdAuditCommand',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: 0,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				} else {
					var _v3 = _v1.a;
					var events = _v3.a;
					var fileOperations = _v3.b;
					var newEnvironment = _v3.c;
					if ($author$project$Audit$Events$isEmpty(events)) {
						return {ab: $elm$core$Platform$Cmd$none, jn: 0, ac: newEnvironment, ae: repository};
					} else {
						var _v4 = A4($author$project$Environments$Repository$saveAuditCommandAndEventsAndFileOperations, command, events, fileOperations, repository);
						var newRepository = _v4.a;
						var cmd = _v4.b;
						return {ab: cmd, jn: 0, ac: newEnvironment, ae: newRepository};
					}
				}
		}
	});
var $author$project$Audit$ExecutePlanDialog$CreateAuditCommand = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Plan$Plan$NotModified = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Plan$Changed = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Plan$Plan$planFromModification = function (modification) {
	switch (modification.$) {
		case 0:
			var maybePlan = modification.a;
			return maybePlan;
		case 1:
			var plan = modification.a;
			return $elm$core$Maybe$Just(plan);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$Plan$applyAuditorsChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (!_v0.$) {
			var plan = _v0.a;
			if (_Utils_eq(payload.d5, plan.d5) && (_Utils_cmp(payload.n, plan.i) > 0)) {
				var withNewUsers = A2($author$project$User$Ids$union, plan.bT, payload.ge);
				var withRemovedUsers = A2($author$project$User$Ids$diff, withNewUsers, payload.g9);
				var newPlan = _Utils_update(
					plan,
					{bT: withRemovedUsers, i: payload.n});
				return A2($author$project$Plan$Plan$Changed, newPlan, payload.N);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$CheckpointData$CheckpointGroup$Ids$diff = $turboMaCk$any_set$Set$Any$diff;
var $author$project$CheckpointData$CheckpointGroup$Ids$union = $turboMaCk$any_set$Set$Any$union;
var $author$project$Plan$Plan$applyCheckpointGroupsChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (!_v0.$) {
			var plan = _v0.a;
			if (_Utils_eq(payload.d5, plan.d5) && (_Utils_cmp(payload.n, plan.i) > 0)) {
				var withNewCheckpointGroups = A2($author$project$CheckpointData$CheckpointGroup$Ids$union, plan.gt, payload.e7);
				var withRemovedCheckpointGroups = A2($author$project$CheckpointData$CheckpointGroup$Ids$diff, withNewCheckpointGroups, payload.fY);
				var newPlan = _Utils_update(
					plan,
					{gt: withRemovedCheckpointGroups, i: payload.n});
				return A2($author$project$Plan$Plan$Changed, newPlan, payload.N);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Plan$Plan$applyCreatedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (_v0.$ === 1) {
			var newPlan = {bT: payload.bT, gt: payload.gt, aY: payload.aY, fr: payload.fr, d5: payload.d5, i: 0, k8: payload.k8};
			return A2($author$project$Plan$Plan$Changed, newPlan, payload.N);
		} else {
			return modification;
		}
	});
var $author$project$Plan$Plan$Deleted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Plan$Plan$applyDeletedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (!_v0.$) {
			var plan = _v0.a;
			return (_Utils_eq(payload.d5, plan.d5) && (_Utils_cmp(payload.n, plan.i) > 0)) ? A2($author$project$Plan$Plan$Deleted, plan.d5, payload.N) : modification;
		} else {
			return modification;
		}
	});
var $author$project$Plan$Plan$applyDescriptionChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (!_v0.$) {
			var plan = _v0.a;
			if (_Utils_eq(payload.d5, plan.d5) && (_Utils_cmp(payload.n, plan.i) > 0)) {
				var newPlan = _Utils_update(
					plan,
					{aY: payload.aY, i: payload.n});
				return A2($author$project$Plan$Plan$Changed, newPlan, payload.N);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Plan$Plan$applyExecutionAddedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (!_v0.$) {
			var plan = _v0.a;
			if (_Utils_eq(payload.d5, plan.d5) && (_Utils_cmp(payload.n, plan.i) > 0)) {
				var newPlan = _Utils_update(
					plan,
					{
						fr: A2(
							$elm$core$List$append,
							plan.fr,
							$elm$core$List$singleton(payload.jw)),
						i: payload.n
					});
				return A2($author$project$Plan$Plan$Changed, newPlan, payload.N);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Plan$Plan$applyExecutionChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (!_v0.$) {
			var plan = _v0.a;
			if (_Utils_eq(payload.d5, plan.d5) && (_Utils_cmp(payload.n, plan.i) > 0)) {
				var updateExecution = function (oldExecution) {
					return _Utils_eq(oldExecution.dH, payload.jw.dH) ? payload.jw : oldExecution;
				};
				var newPlan = _Utils_update(
					plan,
					{
						fr: A2($elm$core$List$map, updateExecution, plan.fr),
						i: payload.n
					});
				return A2($author$project$Plan$Plan$Changed, newPlan, payload.N);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Plan$Plan$applyExecutionRemovedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (!_v0.$) {
			var plan = _v0.a;
			if (_Utils_eq(payload.d5, plan.d5) && (_Utils_cmp(payload.n, plan.i) > 0)) {
				var newPlan = _Utils_update(
					plan,
					{
						fr: A2(
							$elm$core$List$filter,
							function (execution) {
								return !_Utils_eq(execution.dH, payload.dH);
							},
							plan.fr),
						i: payload.n
					});
				return A2($author$project$Plan$Plan$Changed, newPlan, payload.N);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Plan$Plan$applyPlanExecutedEvent = function (modification) {
	return modification;
};
var $author$project$Plan$Plan$applyTitleChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (!_v0.$) {
			var plan = _v0.a;
			if (_Utils_eq(payload.d5, plan.d5) && (_Utils_cmp(payload.n, plan.i) > 0)) {
				var newPlan = _Utils_update(
					plan,
					{i: payload.n, k8: payload.k8});
				return A2($author$project$Plan$Plan$Changed, newPlan, payload.N);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Plan$Plan$applyEventHelper = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $author$project$Plan$Plan$applyCreatedEvent(payload);
		case 1:
			var payload = event.a;
			return $author$project$Plan$Plan$applyTitleChangedEvent(payload);
		case 2:
			var payload = event.a;
			return $author$project$Plan$Plan$applyDescriptionChangedEvent(payload);
		case 3:
			var payload = event.a;
			return $author$project$Plan$Plan$applyExecutionAddedEvent(payload);
		case 4:
			var payload = event.a;
			return $author$project$Plan$Plan$applyExecutionChangedEvent(payload);
		case 5:
			var payload = event.a;
			return $author$project$Plan$Plan$applyExecutionRemovedEvent(payload);
		case 6:
			var payload = event.a;
			return $author$project$Plan$Plan$applyAuditorsChangedEvent(payload);
		case 7:
			var payload = event.a;
			return $author$project$Plan$Plan$applyCheckpointGroupsChangedEvent(payload);
		case 8:
			var payload = event.a;
			return $author$project$Plan$Plan$applyDeletedEvent(payload);
		default:
			return $author$project$Plan$Plan$applyPlanExecutedEvent;
	}
};
var $author$project$Plan$Plan$applyEvent = function (event) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Plan$Plan$NotModified,
		$author$project$Plan$Plan$applyEventHelper(event));
};
var $author$project$Plan$Dict$get = $turboMaCk$any_dict$Dict$Any$get;
var $author$project$Plan$Plans$get = function (planId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Plan$Plans$dict,
		$author$project$Plan$Dict$get(planId));
};
var $author$project$Plan$Dict$insert = A2(
	$author$project$Utils$Utils$with,
	function ($) {
		return $.d5;
	},
	$turboMaCk$any_dict$Dict$Any$insert);
var $author$project$Plan$Plans$insert = F2(
	function (plan, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				cL: A2($author$project$Plan$Dict$insert, plan, data.cL)
			});
	});
var $author$project$Plan$Event$planId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.d5;
		case 1:
			var payload = event.a;
			return payload.d5;
		case 2:
			var payload = event.a;
			return payload.d5;
		case 3:
			var payload = event.a;
			return payload.d5;
		case 4:
			var payload = event.a;
			return payload.d5;
		case 5:
			var payload = event.a;
			return payload.d5;
		case 6:
			var payload = event.a;
			return payload.d5;
		case 7:
			var payload = event.a;
			return payload.d5;
		case 8:
			var payload = event.a;
			return payload.d5;
		default:
			var payload = event.a;
			return payload.d5;
	}
};
var $author$project$Plan$Dict$remove = $turboMaCk$any_dict$Dict$Any$remove;
var $author$project$Plan$Plans$remove = F2(
	function (planId, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				cL: A2($author$project$Plan$Dict$remove, planId, data.cL)
			});
	});
var $author$project$Plan$Modifications$NotEmpty = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Ids$empty = $turboMaCk$any_set$Set$Any$empty($author$project$Plan$Id$toString);
var $author$project$Plan$Ids$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$Plan$Dict$singleton = function (plan) {
	return A2($author$project$Plan$Dict$insert, plan, $author$project$Plan$Dict$empty);
};
var $author$project$Plan$Ids$singleton = function (id) {
	return A2($author$project$Plan$Ids$insert, id, $author$project$Plan$Ids$empty);
};
var $author$project$Plan$Modifications$with = F2(
	function (modification, modifications) {
		var _v0 = _Utils_Tuple2(modification, modifications);
		switch (_v0.a.$) {
			case 0:
				return modifications;
			case 1:
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var plan = _v1.a;
					var eventId = _v1.b;
					var _v2 = _v0.b;
					return $author$project$Plan$Modifications$NotEmpty(
						{
							bh: $author$project$Plan$Dict$singleton(plan),
							dA: $author$project$Plan$Ids$empty,
							fD: eventId
						});
				} else {
					var _v3 = _v0.a;
					var plan = _v3.a;
					var eventId = _v3.b;
					var data = _v0.b.a;
					return $author$project$Plan$Modifications$NotEmpty(
						_Utils_update(
							data,
							{
								bh: A2($author$project$Plan$Dict$insert, plan, data.bh),
								fD: eventId
							}));
				}
			default:
				if (!_v0.b.$) {
					var _v4 = _v0.a;
					var planId = _v4.a;
					var eventId = _v4.b;
					var _v5 = _v0.b;
					return $author$project$Plan$Modifications$NotEmpty(
						{
							bh: $author$project$Plan$Dict$empty,
							dA: $author$project$Plan$Ids$singleton(planId),
							fD: eventId
						});
				} else {
					var _v6 = _v0.a;
					var planId = _v6.a;
					var eventId = _v6.b;
					var data = _v0.b.a;
					return $author$project$Plan$Modifications$NotEmpty(
						_Utils_update(
							data,
							{
								bh: A2($author$project$Plan$Dict$remove, planId, data.bh),
								dA: A2($author$project$Plan$Ids$insert, planId, data.dA),
								fD: eventId
							}));
				}
		}
	});
var $author$project$Plan$Plans$withLastEventId = F2(
	function (eventId, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				fD: $elm$core$Maybe$Just(eventId)
			});
	});
var $author$project$Plan$Plans$applyEvent = F2(
	function (event, _v0) {
		var plans = _v0.a;
		var modifications = _v0.b;
		var modification = A2(
			$author$project$Plan$Plan$applyEvent,
			event,
			A2(
				$author$project$Plan$Plans$get,
				$author$project$Plan$Event$planId(event),
				plans));
		switch (modification.$) {
			case 0:
				return _Utils_Tuple2(plans, modifications);
			case 1:
				var plan = modification.a;
				var eventId = modification.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Plan$Plans$withLastEventId,
						eventId,
						A2($author$project$Plan$Plans$insert, plan, plans)),
					A2($author$project$Plan$Modifications$with, modification, modifications));
			default:
				var planId = modification.a;
				var eventId = modification.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Plan$Plans$withLastEventId,
						eventId,
						A2($author$project$Plan$Plans$remove, planId, plans)),
					A2($author$project$Plan$Modifications$with, modification, modifications));
		}
	});
var $author$project$Plan$Modifications$Empty = {$: 0};
var $author$project$Plan$Modifications$empty = $author$project$Plan$Modifications$Empty;
var $author$project$Plan$Events$fold = $author$project$Types$Queue$fold;
var $author$project$Plan$Plans$applyEvents = F2(
	function (events, plans) {
		return A3(
			$author$project$Plan$Events$fold,
			$author$project$Plan$Plans$applyEvent,
			_Utils_Tuple2(plans, $author$project$Plan$Modifications$empty),
			events);
	});
var $author$project$Plan$Store$events = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Plan$Events$empty;
		case 1:
			var data = state.a;
			return data.b8;
		case 2:
			var data = state.a;
			return data.b8;
		default:
			var data = state.a;
			return data.b8;
	}
};
var $author$project$Plan$Store$plans = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Plan$Plans$empty;
		case 1:
			return $author$project$Plan$Plans$empty;
		case 2:
			var data = state.a;
			return data.aL;
		default:
			var data = state.a;
			return data.aL;
	}
};
var $author$project$Environments$Repository$getPlan = F2(
	function (planId, _v0) {
		var data = _v0;
		return A2(
			$author$project$Plan$Plans$get,
			planId,
			A2(
				$author$project$Plan$Plans$applyEvents,
				$author$project$Plan$Store$events(data.U),
				$author$project$Plan$Store$plans(data.U)).a);
	});
var $author$project$Plan$Plan$DoesNotExist = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Events$singleton = $author$project$Types$Queue$singleton;
var $author$project$Plan$Plan$handleAddExecutionCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Plan$Plan$DoesNotExist(payload.d5));
		} else {
			var plan = _v0.a;
			return A2($elm$core$List$member, payload.jw, plan.fr) ? $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Plan$Events$empty, environment)) : $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Plan$Events$singleton(
							$author$project$Plan$Event$ExecutionAdded(
								{L: payload.L, M: payload.M, N: eventId, jw: payload.jw, d5: payload.d5, n: plan.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $turboMaCk$any_dict$Dict$Any$intersect = F2(
	function (_v0, _v1) {
		var inner = _v0;
		var dict = _v1.cL;
		return _Utils_update(
			inner,
			{
				cL: A2($elm$core$Dict$intersect, inner.cL, dict)
			});
	});
var $turboMaCk$any_set$Set$Any$intersect = F2(
	function (_v0, _v1) {
		var d1 = _v0;
		var d2 = _v1;
		return A2($turboMaCk$any_dict$Dict$Any$intersect, d1, d2);
	});
var $author$project$User$Ids$intersect = $turboMaCk$any_set$Set$Any$intersect;
var $author$project$Plan$Plan$handleChangeAuditorsCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Plan$Plan$DoesNotExist(payload.d5));
		} else {
			var plan = _v0.a;
			var removeAuditors = A2($author$project$User$Ids$intersect, payload.g9, plan.bT);
			var addAuditors = A2($author$project$User$Ids$diff, payload.ge, plan.bT);
			return ($author$project$User$Ids$isEmpty(addAuditors) && $author$project$User$Ids$isEmpty(removeAuditors)) ? $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Plan$Events$empty, environment)) : $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Plan$Events$singleton(
							$author$project$Plan$Event$AuditorsChanged(
								{ge: payload.ge, L: payload.L, M: payload.M, N: eventId, d5: payload.d5, g9: payload.g9, n: plan.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$CheckpointData$CheckpointGroup$Ids$intersect = $turboMaCk$any_set$Set$Any$intersect;
var $author$project$CheckpointData$CheckpointGroup$Ids$isEmpty = $turboMaCk$any_set$Set$Any$isEmpty;
var $author$project$Plan$Plan$handleChangeCheckpointGroupsCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Plan$Plan$DoesNotExist(payload.d5));
		} else {
			var plan = _v0.a;
			var removeCheckpointGroups = A2($author$project$CheckpointData$CheckpointGroup$Ids$intersect, payload.fY, plan.gt);
			var addCheckpointGroups = A2($author$project$CheckpointData$CheckpointGroup$Ids$diff, payload.e7, plan.gt);
			return ($author$project$CheckpointData$CheckpointGroup$Ids$isEmpty(addCheckpointGroups) && $author$project$CheckpointData$CheckpointGroup$Ids$isEmpty(removeCheckpointGroups)) ? $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Plan$Events$empty, environment)) : $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Plan$Events$singleton(
							$author$project$Plan$Event$CheckpointGroupsChanged(
								{e7: payload.e7, L: payload.L, M: payload.M, N: eventId, d5: payload.d5, fY: payload.fY, n: plan.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Plan$Plan$handleChangeDescriptionCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Plan$Plan$DoesNotExist(payload.d5));
		} else {
			var plan = _v0.a;
			return _Utils_eq(plan.aY, payload.aY) ? $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Plan$Events$empty, environment)) : $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Plan$Events$singleton(
							$author$project$Plan$Event$DescriptionChanged(
								{L: payload.L, M: payload.M, aY: payload.aY, N: eventId, d5: payload.d5, n: plan.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Plan$Plan$handleChangeExecutionCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Plan$Plan$DoesNotExist(payload.d5));
		} else {
			var plan = _v0.a;
			return A2($elm$core$List$member, payload.jw, plan.fr) ? $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Plan$Events$empty, environment)) : $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Plan$Events$singleton(
							$author$project$Plan$Event$ExecutionChanged(
								{L: payload.L, M: payload.M, N: eventId, jw: payload.jw, d5: payload.d5, n: plan.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Plan$Plan$handleChangeTitleCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Plan$Plan$DoesNotExist(payload.d5));
		} else {
			var plan = _v0.a;
			return _Utils_eq(plan.k8, payload.k8) ? $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Plan$Events$empty, environment)) : $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Plan$Events$singleton(
							$author$project$Plan$Event$TitleChanged(
								{L: payload.L, M: payload.M, N: eventId, d5: payload.d5, k8: payload.k8, n: plan.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Plan$Plan$AlreadyExists = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Plan$handleCreateCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Plan$Events$singleton(
							$author$project$Plan$Event$Created(
								{bT: payload.bT, gt: payload.gt, L: payload.L, M: payload.M, aY: payload.aY, N: eventId, fr: payload.fr, d5: payload.d5, k8: payload.k8, n: 0}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		} else {
			var plan = _v0.a;
			return $elm$core$Result$Err(
				$author$project$Plan$Plan$AlreadyExists(plan.d5));
		}
	});
var $author$project$Plan$Plan$handleDeleteCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Plan$Events$empty, environment));
		} else {
			var plan = _v0.a;
			return $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Plan$Events$singleton(
							$author$project$Plan$Event$Deleted(
								{L: payload.L, M: payload.M, N: eventId, d5: payload.d5, n: plan.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Plan$Plan$handleExecutePlanCommand = F2(
	function (environment, _v0) {
		return $elm$core$Result$Ok(
			_Utils_Tuple2($author$project$Plan$Events$empty, environment));
	});
var $author$project$Plan$Plan$handleRemoveExecutionCommand = F3(
	function (payload, environment, modification) {
		var _v0 = $author$project$Plan$Plan$planFromModification(modification);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$Plan$Plan$DoesNotExist(payload.d5));
		} else {
			var plan = _v0.a;
			return (!$elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function (execution) {
						return _Utils_eq(execution.dH, payload.dH);
					},
					plan.fr))) ? $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Plan$Events$empty, environment)) : $elm$core$Result$Ok(
				A2(
					$elm$core$Tuple$mapFirst,
					function (eventId) {
						return $author$project$Plan$Events$singleton(
							$author$project$Plan$Event$ExecutionRemoved(
								{L: payload.L, M: payload.M, N: eventId, dH: payload.dH, d5: payload.d5, n: plan.i + 1}));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(environment))));
		}
	});
var $author$project$Plan$Plan$applyEvents = F2(
	function (events, modification) {
		return A3($author$project$Plan$Events$fold, $author$project$Plan$Plan$applyEventHelper, modification, events);
	});
var $author$project$Plan$Commands$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$Plan$Events$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$Plan$Events$merge = $author$project$Types$Queue$merge;
var $author$project$Plan$Plan$mapCommandResult = F3(
	function (command, acc, _v0) {
		var events = _v0.a;
		var environment = _v0.b;
		return $author$project$Plan$Events$isEmpty(events) ? _Utils_update(
			acc,
			{ac: environment}) : _Utils_update(
			acc,
			{
				cD: A2($author$project$Plan$Commands$enqueue, command, acc.cD),
				ac: environment,
				b8: A2($author$project$Plan$Events$merge, acc.b8, events),
				au: A2($author$project$Plan$Plan$applyEvents, events, acc.au)
			});
	});
var $author$project$Plan$Plan$handleCommandHelper = F2(
	function (command, acc) {
		switch (command.$) {
			case 0:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Plan$Plan$mapCommandResult, command, acc),
					A3($author$project$Plan$Plan$handleCreateCommand, payload, acc.ac, acc.au));
			case 1:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Plan$Plan$mapCommandResult, command, acc),
					A3($author$project$Plan$Plan$handleChangeTitleCommand, payload, acc.ac, acc.au));
			case 2:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Plan$Plan$mapCommandResult, command, acc),
					A3($author$project$Plan$Plan$handleChangeDescriptionCommand, payload, acc.ac, acc.au));
			case 3:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Plan$Plan$mapCommandResult, command, acc),
					A3($author$project$Plan$Plan$handleAddExecutionCommand, payload, acc.ac, acc.au));
			case 4:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Plan$Plan$mapCommandResult, command, acc),
					A3($author$project$Plan$Plan$handleChangeExecutionCommand, payload, acc.ac, acc.au));
			case 5:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Plan$Plan$mapCommandResult, command, acc),
					A3($author$project$Plan$Plan$handleRemoveExecutionCommand, payload, acc.ac, acc.au));
			case 6:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Plan$Plan$mapCommandResult, command, acc),
					A3($author$project$Plan$Plan$handleChangeAuditorsCommand, payload, acc.ac, acc.au));
			case 7:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Plan$Plan$mapCommandResult, command, acc),
					A3($author$project$Plan$Plan$handleChangeCheckpointGroupsCommand, payload, acc.ac, acc.au));
			case 8:
				var payload = command.a;
				return A2(
					$elm$core$Result$map,
					A2($author$project$Plan$Plan$mapCommandResult, command, acc),
					A3($author$project$Plan$Plan$handleDeleteCommand, payload, acc.ac, acc.au));
			default:
				return A2(
					$elm$core$Result$map,
					A2($author$project$Plan$Plan$mapCommandResult, command, acc),
					A2($author$project$Plan$Plan$handleExecutePlanCommand, acc.ac, acc.au));
		}
	});
var $author$project$Plan$Plan$handleCommand = F3(
	function (command, environment, maybePlan) {
		var acc = {
			cD: $author$project$Plan$Commands$empty,
			ac: environment,
			b8: $author$project$Plan$Events$empty,
			au: $author$project$Plan$Plan$NotModified(maybePlan)
		};
		return A2(
			$elm$core$Result$map,
			A2(
				$author$project$Utils$Tuple$with,
				function ($) {
					return $.b8;
				},
				function ($) {
					return $.ac;
				}),
			A2($author$project$Plan$Plan$handleCommandHelper, command, acc));
	});
var $author$project$Environments$ErrorHandling$ToString$planErrorToString = function (err) {
	if (!err.$) {
		var id = err.a;
		return 'Plan.DoesNotExist' + $author$project$Plan$Id$toString(id);
	} else {
		var id = err.a;
		return 'Plan.AlreadyExists' + $author$project$Plan$Id$toString(id);
	}
};
var $author$project$Environments$Repository$planStore = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.U;
	});
var $author$project$Plan$Store$NotReady = 0;
var $author$project$Plan$Store$SaveCommandsAndEvents = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Plan$Store$Saving = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$Commands$merge = $author$project$Types$Queue$merge;
var $author$project$Plan$Store$saveCommandsAndEvents = F3(
	function (commands_, events_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Plan$Store$Saving(
							{
								cD: A2($author$project$Plan$Commands$merge, data.cD, commands_),
								b8: A2($author$project$Plan$Events$merge, data.b8, events_),
								aL: $author$project$Plan$Plans$empty
							}),
						$author$project$Plan$Store$send(
							A2($author$project$Plan$Store$SaveCommandsAndEvents, commands_, events_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Plan$Store$Saving(
							_Utils_update(
								data,
								{
									cD: A2($author$project$Plan$Commands$merge, data.cD, commands_),
									b8: A2($author$project$Plan$Events$merge, data.b8, events_)
								})),
						$author$project$Plan$Store$send(
							A2($author$project$Plan$Store$SaveCommandsAndEvents, commands_, events_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$withPlanStore = F2(
	function (planStore_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{U: planStore_});
	});
var $author$project$Environments$Repository$setPlanStore = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withPlanStore);
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Environments$Repository$savePlanCommandsAndEvents = F3(
	function (commands, events, repository) {
		return A2(
			$elm$core$Result$withDefault,
			_Utils_Tuple2(repository, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst(
					$author$project$Environments$Repository$setPlanStore(repository)),
				A3(
					$author$project$Plan$Store$saveCommandsAndEvents,
					commands,
					events,
					$author$project$Environments$Repository$planStore(repository))));
	});
var $author$project$Plan$Commands$singleton = $author$project$Types$Queue$singleton;
var $author$project$Environments$Repository$savePlanCommandAndEvents = function (command) {
	return $author$project$Environments$Repository$savePlanCommandsAndEvents(
		$author$project$Plan$Commands$singleton(command));
};
var $author$project$Audit$ExecutePlanDialog$createdExecutePlanCommand = F5(
	function (plan, command, environment, repository, dialog) {
		switch (dialog) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				var _v1 = A3(
					$author$project$Plan$Plan$handleCommand,
					command,
					environment,
					A2($author$project$Environments$Repository$getPlan, plan.d5, repository));
				if (_v1.$ === 1) {
					var error = _v1.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$planErrorToString(error)),
						gH: 'Audit.ExecutePlanDialog.elm',
						gK: 'createdExecutePlanCommand',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: 0,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				} else {
					var _v3 = _v1.a;
					var events = _v3.a;
					var newEnvironment = _v3.b;
					if ($author$project$Plan$Events$isEmpty(events)) {
						return {ab: $elm$core$Platform$Cmd$none, jn: 0, ac: newEnvironment, ae: repository};
					} else {
						var _v4 = A3($author$project$Environments$Repository$savePlanCommandAndEvents, command, events, repository);
						var newRepository = _v4.a;
						var cmd = _v4.b;
						return {
							ab: $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$perform,
										$author$project$Audit$ExecutePlanDialog$CreateAuditCommand(plan),
										$elm$time$Time$now),
										cmd
									])),
							jn: 2,
							ac: newEnvironment,
							ae: newRepository
						};
					}
				}
		}
	});
var $author$project$Audit$ExecutePlanDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: 0, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$ExecutePlanDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: 0, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$ExecutePlanDialog$userClickedCreateButton = F4(
	function (planId, environment, repository, dialog) {
		switch (dialog) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var _v1 = A2($author$project$Environments$Repository$getPlan, planId, repository);
				if (_v1.$ === 1) {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				} else {
					var plan = _v1.a;
					return {
						ab: A2(
							$elm$core$Task$perform,
							$author$project$Audit$ExecutePlanDialog$CreateAuditCommand(plan),
							$elm$time$Time$now),
						jn: 2,
						ac: environment,
						ae: repository
					};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$ExecutePlanDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Audit$ExecutePlanDialog$userClickedCloseDialog;
		case 1:
			return $author$project$Audit$ExecutePlanDialog$userClickedCancelButton;
		case 2:
			var planId = msg.a;
			return $author$project$Audit$ExecutePlanDialog$userClickedCreateButton(planId);
		case 3:
			var plan = msg.a;
			var command = msg.b;
			return A2($author$project$Audit$ExecutePlanDialog$createdExecutePlanCommand, plan, command);
		case 4:
			var plan = msg.a;
			var posix = msg.b;
			return A2($author$project$Audit$ExecutePlanDialog$createAuditCommand, plan, posix);
		default:
			var command = msg.a;
			return $author$project$Audit$ExecutePlanDialog$createdAuditCommand(command);
	}
};
var $author$project$Audit$Page$withExecutePlanDialog = F2(
	function (executePlanDialog_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{eA: executePlanDialog_});
	});
var $author$project$Audit$Page$gotExecutePlanDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$Audit$ExecutePlanDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$Audit$Page$executePlanDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Audit$Page$GotExecutePlanDialogMsg, result.ab),
			ac: result.ac,
			ak: A2(
				$author$project$Audit$Page$withExecutePlanDialog,
				result.jn,
				A4($author$project$Audit$Page$openEditAuditAfterCreate, dialogMsg, result.ac, result.ae, page)),
			ae: result.ae
		};
	});
var $author$project$Audit$Page$receivedNowTimestamp = F4(
	function (now, environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{fK: now}),
			ae: repository
		};
	});
var $author$project$Audit$Page$scrollEvent = F4(
	function (scrollInfo, environment, repository, page) {
		var model = page;
		var auditCount = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (audit) {
					return _Utils_eq(audit.jb, $author$project$Audit$CompletionStatus$Open);
				},
				$author$project$Audit$Dict$values(
					$author$project$Environments$Repository$audits(repository))));
		return (((scrollInfo.kM - scrollInfo.kN) <= 2000) && (_Utils_cmp(model.bF, auditCount) < 0)) ? {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{bF: model.bF + 100}),
			ae: repository
		} : {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
	});
var $author$project$Audit$Page$userClickedEditIcon = F4(
	function (auditId, environment, repository, page) {
		var updatedPage = function () {
			var _v0 = A2($author$project$Environments$Repository$getAudit, auditId, repository);
			if (!_v0.$) {
				var audit = _v0.a;
				return A2(
					$author$project$Audit$Page$withEditAuditDialog,
					A5(
						$author$project$Audit$EditDialog$show,
						environment,
						repository,
						0,
						$author$project$Environments$Environment$timeZone(environment),
						audit),
					page);
			} else {
				return page;
			}
		}();
		return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: updatedPage, ae: repository};
	});
var $author$project$Audit$ExecutePlanDialog$Visible = 1;
var $author$project$Audit$ExecutePlanDialog$show = 1;
var $author$project$Audit$Page$userClickedExecutePlan = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2($author$project$Audit$Page$withExecutePlanDialog, $author$project$Audit$ExecutePlanDialog$show, page),
			ae: repository
		};
	});
var $author$project$Audit$Page$userClickedLoadMore = F3(
	function (environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{bF: model.bF + 100}),
			ae: repository
		};
	});
var $author$project$Audit$Page$checkAuditRight = F4(
	function (auditId, environment, repository, right) {
		return A2(
			$elm$core$List$member,
			true,
			A2(
				$elm$core$List$map,
				function (organisationUnitId) {
					return A3(
						$author$project$Auth$Authorization$authorize,
						$author$project$Environments$Environment$userRights(environment),
						right,
						organisationUnitId);
				},
				A2(
					$elm$core$List$map,
					function (checkpointGroup) {
						return checkpointGroup.km;
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (audit) {
								return audit.ff.gt;
							},
							A2($author$project$Environments$Repository$getAudit, auditId, repository))))));
	});
var $author$project$Audit$Page$userClickedOnAudit = F4(
	function (auditId, environment, repository, page) {
		var route = A4($author$project$Audit$Page$checkAuditRight, auditId, environment, repository, 8) ? $author$project$Environments$Route$PerformAudit : $author$project$Environments$Route$ViewArchivedAudit;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2(
				$author$project$Environments$Environment$navigateTo,
				route(auditId),
				environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$Audit$Page$userDeselectedSeeAll = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$setSeeAll, false, environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$Audit$Page$userSelectedSeeAll = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$setSeeAll, true, environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$Audit$Page$update = function (msg) {
	switch (msg.$) {
		case 0:
			var auditId = msg.a;
			return $author$project$Audit$Page$userClickedEditIcon(auditId);
		case 1:
			var auditId = msg.a;
			return $author$project$Audit$Page$userClickedOnAudit(auditId);
		case 2:
			return $author$project$Audit$Page$userClickedExecutePlan;
		case 3:
			var dialogMsg = msg.a;
			return $author$project$Audit$Page$gotExecutePlanDialogMsg(dialogMsg);
		case 4:
			var dialogMsg = msg.a;
			return $author$project$Audit$Page$gotEditAuditDialogMsg(dialogMsg);
		case 5:
			return $author$project$Audit$Page$userSelectedSeeAll;
		case 6:
			return $author$project$Audit$Page$userDeselectedSeeAll;
		case 7:
			var string = msg.a;
			return $author$project$Audit$Page$enteredSearchString(string);
		case 8:
			var now = msg.a;
			return $author$project$Audit$Page$receivedNowTimestamp(now);
		case 9:
			var scrollInfo = msg.a;
			return $author$project$Audit$Page$scrollEvent(scrollInfo);
		default:
			return $author$project$Audit$Page$userClickedLoadMore;
	}
};
var $author$project$Audit$Page$ScrollEvent = function (a) {
	return {$: 9, a: a};
};
var $author$project$Translations$Audits$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'audits.header');
};
var $elm$virtual_dom$VirtualDom$lazy6 = _VirtualDom_lazy6;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5 = F6(
	function (fn, arg1, arg2, arg3, arg4, arg5) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A5(fn, arg1, arg2, arg3, arg4, arg5));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy5 = F6(
	function (fn, arg1, arg2, arg3, arg4, arg5) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A7($elm$virtual_dom$VirtualDom$lazy6, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5, fn, arg1, arg2, arg3, arg4, arg5));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy5 = $rtfeldman$elm_css$VirtualDom$Styled$lazy5;
var $elm$virtual_dom$VirtualDom$lazy7 = _VirtualDom_lazy7;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp6 = F7(
	function (fn, arg1, arg2, arg3, arg4, arg5, arg6) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A6(fn, arg1, arg2, arg3, arg4, arg5, arg6));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy6 = F7(
	function (fn, arg1, arg2, arg3, arg4, arg5, arg6) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A8($elm$virtual_dom$VirtualDom$lazy7, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp6, fn, arg1, arg2, arg3, arg4, arg5, arg6));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy6 = $rtfeldman$elm_css$VirtualDom$Styled$lazy6;
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2 = F3(
	function (fn, arg1, arg2) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A2(fn, arg1, arg2));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy2 = F3(
	function (fn, arg1, arg2) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A4($elm$virtual_dom$VirtualDom$lazy3, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2, fn, arg1, arg2));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy2 = $rtfeldman$elm_css$VirtualDom$Styled$lazy2;
var $author$project$Audit$ExecutePlanDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Plans$executePlan = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.executePlan');
};
var $author$project$UI$Icons$plan = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M14.635 11.971l.168-.069V9.723c0-.619.501-1.121 1.12-1.121.617 0 1.12.502 1.12 1.121v2.125l3.357.058h10.558V9.724c0-.619.502-1.121 1.12-1.121.619 0 1.119.502 1.119 1.121v2.222c3.371.358 6.003 3.215 6.003 6.678v12.057c0 3.767-1.928 6.717-4.386 6.717-.619 0-1.119-.5-1.119-1.118 0-.62.5-1.121 1.119-1.121.993 0 2.147-1.955 2.147-4.478V18.624c0-.23-.034-.45-.066-.671H11.106c-.032.221-.067.441-.067.671v12.057c0 2.47 2.011 4.478 4.478 4.478h13.919c.617 0 1.119.501 1.119 1.121 0 .618-.502 1.118-1.119 1.118H15.517c-3.703 0-6.717-3.012-6.717-6.717V18.624c0-3.404 2.548-6.218 5.835-6.653')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M33.902 25.575h-3.791c-.311 0-.561-.25-.561-.56v-3.266c0-.308.25-.559.561-.559h3.791c.309 0 .56.251.56.559v3.266c0 .31-.251.56-.56.56M25.896 25.575h-3.791c-.31 0-.56-.25-.56-.56v-3.266c0-.308.25-.559.56-.559h3.791c.309 0 .56.251.56.559v3.266c0 .31-.251.56-.56.56M17.892 25.575h-3.793c-.31 0-.56-.25-.56-.56v-3.266c0-.308.25-.559.56-.559h3.793c.308 0 .559.251.559.559v3.266c0 .31-.251.56-.559.56M34.461 32.284c0 .31-.25.559-.56.559h-3.79c-.31 0-.561-.249-.561-.559v-3.265c0-.31.251-.56.561-.56h3.79c.31 0 .56.25.56.56v3.265zM26.456 32.284c0 .31-.251.559-.56.559h-3.791c-.309 0-.56-.249-.56-.559v-3.265c0-.31.251-.56.56-.56h3.791c.309 0 .56.25.56.56v3.265zM18.451 32.284c0 .31-.251.559-.559.559h-3.793c-.309 0-.56-.249-.56-.559v-3.265c0-.31.251-.56.56-.56h3.793c.308 0 .559.25.559.56v3.265z')
						]),
					_List_Nil)
				]));
	});
var $author$project$Audit$ExecutePlanDialog$UserClickedCancelButton = {$: 1};
var $author$project$Audit$ExecutePlanDialog$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Audit$ExecutePlanDialog$UserClickedCancelButton,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$Audit$ExecutePlanDialog$viewFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
						A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto 1fr'),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Audit$ExecutePlanDialog$viewCancelButton(translations)
			]));
};
var $author$project$Translations$Plans$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.emptyText');
};
var $author$project$Audit$ExecutePlanDialog$filterByCurrentOrganisationUnit = F3(
	function (environment, repository, organisationUnitId) {
		var _v0 = _Utils_Tuple2(
			$author$project$Environments$Environment$getCurrentOrganisationUnit(environment),
			$author$project$Environments$Environment$getSeeAll(environment));
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return true;
		} else {
			if (_v0.b) {
				return true;
			} else {
				var currentOrganisationUnit = _v0.a.a;
				var hierarchy = $author$project$OrganisationUnit$OrganisationUnits$hierarchy(
					$author$project$Environments$Repository$organisationUnits(repository));
				return _Utils_eq(organisationUnitId, currentOrganisationUnit) || A3($author$project$OrganisationUnit$Hierarchy$isAncestorOf, currentOrganisationUnit, organisationUnitId, hierarchy);
			}
		}
	});
var $author$project$Audit$ExecutePlanDialog$filterPlans = F3(
	function (environment, repository, plan) {
		return A2(
			$elm$core$List$member,
			true,
			A2(
				$elm$core$List$map,
				function (organisationUnitId) {
					return A3(
						$author$project$Auth$Authorization$authorize,
						$author$project$Environments$Environment$userRights(environment),
						7,
						organisationUnitId);
				},
				A2(
					$elm$core$List$filter,
					function (organisationUnitId) {
						return A3($author$project$Audit$ExecutePlanDialog$filterByCurrentOrganisationUnit, environment, repository, organisationUnitId);
					},
					A2(
						$elm$core$List$map,
						function (checkpointGroup) {
							return checkpointGroup.km;
						},
						A3(
							$elm$core$List$foldl,
							$author$project$Utils$Utils$reduceMaybeList,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (checkpointGroupId) {
									return A2(
										$author$project$CheckpointData$CheckpointData$getCheckpointGroup,
										checkpointGroupId,
										$author$project$Environments$Repository$getCheckpointData(repository));
								},
								$author$project$CheckpointData$CheckpointGroup$Ids$toList(plan.gt)))))));
	});
var $author$project$Environments$Repository$plans = function (_v0) {
	var data = _v0;
	return $author$project$Plan$Plans$dict(
		A2(
			$author$project$Plan$Plans$applyEvents,
			$author$project$Plan$Store$events(data.U),
			$author$project$Plan$Store$plans(data.U)).a);
};
var $author$project$Audit$ExecutePlanDialog$UserClickedCreateButton = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Icons$checkedCircle = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M32 58.462C17.406 58.462 5.537 46.592 5.537 32 5.537 17.406 17.406 5.536 32 5.536c14.594 0 26.463 11.87 26.463 26.464 0 14.592-11.869 26.462-26.463 26.462m21.914-48.376C48.054 4.238 40.28 1 32 1c-8.28 0-16.067 3.225-21.914 9.086C4.226 15.932 1 23.719 1 32c0 8.28 3.226 16.066 9.086 21.914C15.933 59.773 23.72 63 32 63c8.28 0 16.067-3.227 21.914-9.086C59.761 48.054 63 40.28 63 32c0-8.281-3.226-16.068-9.086-21.914')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M48.081 24.132l-5.475-5.514a2.278 2.278 0 00-3.21-.012l-7.755 7.718a2.278 2.278 0 00-.012 3.21 2.282 2.282 0 003.21.013l6.145-6.12 2.288 2.304-14.94 14.867-7.592-7.628 2.303-2.292 3.688 3.715a2.28 2.28 0 003.211.011 2.278 2.278 0 00.012-3.209l-5.288-5.324a2.235 2.235 0 00-1.598-.669h-.013a2.29 2.29 0 00-1.599.655l-5.526 5.488a2.26 2.26 0 00-.013 3.198l10.776 10.84c.43.427.995.666 1.6.666h.012c.603 0 1.171-.239 1.6-.654L48.069 27.33a2.26 2.26 0 00.012-3.197')
						]),
					_List_Nil)
				]));
	});
var $author$project$Audit$ExecutePlanDialog$viewSelect = function (plan) {
	return A2(
		$author$project$UI$Icon$withOnClick,
		$author$project$Audit$ExecutePlanDialog$UserClickedCreateButton(plan.d5),
		$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedCircle));
};
var $author$project$Audit$ExecutePlanDialog$viewRow = F2(
	function (viewType, plan) {
		return A2(
			$author$project$UI$Table$Row$withRightIcon,
			$author$project$Audit$ExecutePlanDialog$viewSelect(plan),
			A2(
				$author$project$UI$Table$Row$withSubLabel,
				plan.aY,
				A3($author$project$UI$Table$Row$row, viewType, plan.k8, plan)));
	});
var $author$project$Audit$ExecutePlanDialog$viewTable = F3(
	function (translations, environment, repository) {
		return A3(
			$elm$core$Basics$composeR,
			$author$project$Environments$Repository$plans,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Plan$Dict$values,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						A2($author$project$Audit$ExecutePlanDialog$filterPlans, environment, repository)),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$sortBy(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.k8;
								},
								$elm$core$String$toLower)),
						A2(
							$elm$core$Basics$composeR,
							$author$project$UI$Table$fromList(
								$author$project$Audit$ExecutePlanDialog$viewRow(
									$author$project$Environments$Environment$getViewType(environment))),
							A2(
								$elm$core$Basics$composeR,
								$author$project$UI$Table$withEmptyText(
									$author$project$Translations$Plans$emptyText(translations)),
								$author$project$UI$Table$view))))),
			repository);
	});
var $author$project$UI$Modal$withIcon = F2(
	function (icon, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				jI: $elm$core$Maybe$Just(icon)
			});
	});
var $author$project$Audit$ExecutePlanDialog$viewDialog = F2(
	function (environment, repository) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Modal$view(
			A2(
				$author$project$UI$Modal$appendFooter,
				$author$project$Audit$ExecutePlanDialog$viewFooter(translations),
				A2(
					$author$project$UI$Modal$appendContent,
					A3($author$project$Audit$ExecutePlanDialog$viewTable, translations, environment, repository),
					A2(
						$author$project$UI$Modal$withIcon,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$plan),
						A2(
							$author$project$UI$Modal$modal,
							$author$project$Translations$Plans$executePlan(translations),
							$author$project$Audit$ExecutePlanDialog$UserClickedCloseDialog)))));
	});
var $author$project$Audit$ExecutePlanDialog$view = F3(
	function (environment, repository, dialog) {
		switch (dialog) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				return A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Audit$ExecutePlanDialog$viewDialog, environment, repository);
			default:
				return A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Audit$ExecutePlanDialog$viewDialog, environment, repository);
		}
	});
var $author$project$Translations$Misc$overviewBar = F3(
	function (translations, number1, number2) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'misc.overviewBar',
			_List_fromArray(
				[
					_Utils_Tuple2('number1', number1),
					_Utils_Tuple2('number2', number2)
				]));
	});
var $author$project$Audit$Page$UserClickedExecutePlan = {$: 2};
var $author$project$UI$Icons$add = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M33.06 22.555h-7.614v-7.614c0-.798-.648-1.446-1.447-1.446-.797 0-1.445.648-1.445 1.446v7.614H14.94c-.798 0-1.445.646-1.445 1.445s.647 1.446 1.445 1.446h7.614v7.614c0 .798.648 1.445 1.445 1.445.799 0 1.447-.647 1.447-1.445v-7.614h7.613c.798 0 1.445-.647 1.445-1.446 0-.799-.647-1.445-1.445-1.445')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$Bar$withRightIcon = F2(
	function (icon, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				c9: _List_fromArray(
					[icon])
			});
	});
var $author$project$Audit$Page$viewExecutePlanIcon = F3(
	function (environment, repository, bar) {
		var allowedToCreateAudit = A2(
			$elm$core$List$member,
			true,
			A2(
				$elm$core$List$map,
				function (organisationUnitId) {
					return A3(
						$author$project$Auth$Authorization$authorize,
						$author$project$Environments$Environment$userRights(environment),
						7,
						organisationUnitId);
				},
				A2(
					$elm$core$List$map,
					function (organisationUnitId) {
						return organisationUnitId.km;
					},
					$author$project$OrganisationUnit$Hierarchy$organisationUnits(
						$author$project$OrganisationUnit$OrganisationUnits$hierarchy(
							$author$project$Environments$Repository$organisationUnits(repository))))));
		return allowedToCreateAudit ? A2(
			$author$project$UI$Bar$withRightIcon,
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Audit$Page$UserClickedExecutePlan,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
			bar) : bar;
	});
var $author$project$Audit$Page$viewBar = F5(
	function (translations, environment, repository, searchValue, takeValue) {
		var audits = A4(
			$author$project$Audit$Audit$filter,
			environment,
			searchValue,
			$author$project$Environments$Repository$organisationUnits(repository),
			A2(
				$elm$core$List$filter,
				function (audit) {
					return _Utils_eq(audit.jb, $author$project$Audit$CompletionStatus$Open);
				},
				$author$project$Audit$Dict$values(
					$author$project$Environments$Repository$audits(repository))));
		var editedTakeValue = (($elm$core$List$length(audits) - takeValue) < 25) ? $elm$core$List$length(audits) : takeValue;
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(1)),
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
					A2(
						$author$project$UI$Bar$withStyle,
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
						A3(
							$author$project$Audit$Page$viewExecutePlanIcon,
							environment,
							repository,
							$author$project$UI$Bar$bar(
								A3(
									$author$project$Translations$Misc$overviewBar,
									translations,
									$elm$core$String$fromInt(editedTakeValue),
									$elm$core$String$fromInt(
										$elm$core$List$length(audits)))))))));
	});
var $author$project$Audit$Page$EnteredSearchString = function (a) {
	return {$: 7, a: a};
};
var $author$project$Audit$Page$viewSearch = F2(
	function (translations, searchValue) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withStyle,
				$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(50)),
				A2(
					$author$project$UI$TextInput$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3)),
					A2(
						$author$project$UI$TextInput$withOnInput,
						$author$project$Audit$Page$EnteredSearchString,
						A2(
							$author$project$UI$TextInput$withPlaceholder,
							$author$project$Translations$FuzzySearch$search(translations),
							A2($author$project$UI$TextInput$withValue, searchValue, $author$project$UI$TextInput$singleLine))))));
	});
var $author$project$Audit$Page$UserDeselectedSeeAll = {$: 6};
var $author$project$Audit$Page$UserSelectedSeeAll = {$: 5};
var $author$project$Audit$Page$viewSeeAllOption = function (environment) {
	var _v0 = $author$project$Environments$Environment$getSeeAll(environment) ? _Utils_Tuple2(
		$author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3)),
				A2(
					$author$project$UI$Icon$withForegroundColor,
					$author$project$UI$Style$Theme$green,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$eyeCircle)))),
		$author$project$Audit$Page$UserDeselectedSeeAll) : _Utils_Tuple2(
		$author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3)),
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$eyeCircle))),
		$author$project$Audit$Page$UserSelectedSeeAll);
	var icon = _v0.a;
	var msg = _v0.b;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(0.2))
					])),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
			]),
		_List_fromArray(
			[
				icon,
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$rem(0.6)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$Settings$seeAll(
							$author$project$Environments$Environment$translations(environment)))
					]))
			]));
};
var $author$project$Audit$Page$viewHeader = F3(
	function (translations, searchValue, environment) {
		var seeAllOption = function () {
			var _v0 = $author$project$Environments$Environment$getCurrentOrganisationUnit(environment);
			if (_v0.$ === 1) {
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				return $author$project$Audit$Page$viewSeeAllOption(environment);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Audit$Page$viewSearch, translations, searchValue),
					seeAllOption
				]));
	});
var $author$project$UI$Table$appendLastElement = F2(
	function (htmlMsg, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				c_: _Utils_ap(config.c_, htmlMsg)
			});
	});
var $author$project$Translations$Audits$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'audits.emptyText');
};
var $author$project$Audit$Page$UserClickedLoadMore = {$: 10};
var $author$project$Translations$Audits$loadMore = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'audits.loadMore',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Audit$Page$viewLastElement = F4(
	function (translations, environment, takeValue, audits) {
		var _v0 = $author$project$Environments$Environment$platform(environment);
		if (!_v0.$) {
			return _List_Nil;
		} else {
			if (_Utils_cmp(
				takeValue,
				$elm$core$List$length(audits)) > -1) {
				return _List_Nil;
			} else {
				var text = (($elm$core$List$length(audits) - takeValue) > 125) ? '100' : $elm$core$String$fromInt(
					$elm$core$List$length(audits) - takeValue);
				return _List_fromArray(
					[
						$author$project$UI$Button$view(
						A2(
							$author$project$UI$Button$withOnClick,
							$author$project$Audit$Page$UserClickedLoadMore,
							$author$project$UI$Button$darkGrey(
								A2($author$project$Translations$Audits$loadMore, translations, text))))
					]);
			}
		}
	});
var $author$project$Audit$Page$UserClickedOnAudit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$Page$UserClickedEditIcon = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audit$Page$viewEditIcon = function (auditId) {
	return A2(
		$author$project$UI$Icon$withOnClickStopPropagation,
		$author$project$Audit$Page$UserClickedEditIcon(auditId),
		$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle));
};
var $author$project$UI$Table$Row$withBeamColor = F2(
	function (color_, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{gq: color_});
	});
var $author$project$UI$Style$Theme$yellow = A4($author$project$UI$Style$Color$rgba, 237 / 255, 212 / 255, 0 / 255, 1.0);
var $author$project$Audit$Page$viewRow = F4(
	function (environment, repository, now, audit) {
		var withEditAudit = function (config) {
			return (A4($author$project$Audit$Page$checkAuditRight, audit.gm, environment, repository, 8) || A4($author$project$Audit$Page$checkAuditRight, audit.gm, environment, repository, 9)) ? A2(
				$author$project$UI$Table$Row$withRightIcon,
				$author$project$Audit$Page$viewEditIcon(audit.gm),
				config) : config;
		};
		var timeZone = $author$project$Environments$Environment$timeZone(environment);
		var deadlineTime = $author$project$Date_Time$NaiveTime$format(
			A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, audit.hI));
		var deadlineDate = $author$project$Date_Time$NaiveDate$format(
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, audit.hI));
		var subLabel = deadlineDate + (' ' + (deadlineTime + ' Uhr'));
		var beamColor = (_Utils_cmp(
			$elm$time$Time$posixToMillis(audit.hI),
			$elm$time$Time$posixToMillis(now)) < 0) ? $author$project$UI$Style$Theme$lightRed : (_Utils_eq(
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, audit.hI),
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, now)) ? $author$project$UI$Style$Theme$yellow : $author$project$UI$Style$Theme$green);
		return withEditAudit(
			A2(
				$author$project$UI$Table$Row$withId,
				audit.fw,
				A2(
					$author$project$UI$Table$Row$withBeamColor,
					beamColor,
					A2(
						$author$project$UI$Table$Row$withOnClick,
						$author$project$Audit$Page$UserClickedOnAudit(audit.gm),
						A2(
							$author$project$UI$Table$Row$withSubLabel,
							subLabel,
							A2(
								$author$project$UI$Table$Row$withId,
								audit.fw,
								A3(
									$author$project$UI$Table$Row$row,
									$author$project$Environments$Environment$getViewType(environment),
									audit.k8,
									audit)))))));
	});
var $author$project$Audit$Page$viewTable = F6(
	function (translations, searchValue, now, takeValue, environment, repository) {
		var audits = A4(
			$author$project$Audit$Audit$filter,
			environment,
			searchValue,
			$author$project$Environments$Repository$organisationUnits(repository),
			A2(
				$elm$core$List$filter,
				function (audit) {
					return _Utils_eq(audit.jb, $author$project$Audit$CompletionStatus$Open);
				},
				$author$project$Audit$Dict$values(
					$author$project$Environments$Repository$audits(repository))));
		var editedTakeValue = (($elm$core$List$length(audits) - takeValue) < 25) ? $elm$core$List$length(audits) : takeValue;
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$appendLastElement,
				A4($author$project$Audit$Page$viewLastElement, translations, environment, editedTakeValue, audits),
				A2(
					$author$project$UI$Table$withEmptyText,
					$author$project$Translations$Audits$emptyText(
						$author$project$Environments$Environment$translations(environment)),
					A2(
						$author$project$UI$Table$fromList,
						A3($author$project$Audit$Page$viewRow, environment, repository, now),
						A2(
							$elm$core$List$filter,
							function (audit) {
								return _Utils_eq(audit.jb, $author$project$Audit$CompletionStatus$Open);
							},
							A2(
								$elm$core$List$take,
								editedTakeValue,
								A2(
									$elm$core$List$sortBy,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.hI;
										},
										$elm$time$Time$posixToMillis),
									audits)))))));
	});
var $author$project$Audit$Page$view = F3(
	function (environment, repository, _v0) {
		var model = _v0;
		var translations = $author$project$Environments$Environment$translations(environment);
		var attributeMsg = function () {
			var _v1 = $author$project$Environments$Environment$platform(environment);
			if (!_v1.$) {
				return $author$project$Utils$ScrollInfo$onScroll($author$project$Audit$Page$ScrollEvent);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$withAttributeMsg,
				attributeMsg,
				A2(
					$author$project$UI$Page$appendContent,
					A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$Audit$Page$GotEditAuditDialogMsg,
						A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Audit$EditDialog$view, environment, repository, model.cN)),
					A2(
						$author$project$UI$Page$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Audit$Page$GotExecutePlanDialogMsg,
							A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Audit$ExecutePlanDialog$view, environment, repository, model.eA)),
						A2(
							$author$project$UI$Page$appendContent,
							A7($rtfeldman$elm_css$Html$Styled$Lazy$lazy6, $author$project$Audit$Page$viewTable, translations, model.aN, model.fK, model.bF, environment, repository),
							A2(
								$author$project$UI$Page$appendContent,
								A6($rtfeldman$elm_css$Html$Styled$Lazy$lazy5, $author$project$Audit$Page$viewBar, translations, environment, repository, model.aN, model.bF),
								A2(
									$author$project$UI$Page$appendHeader,
									A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Audit$Page$viewHeader, translations, model.aN, environment),
									A2(
										$author$project$UI$Page$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$audits),
										$author$project$UI$Page$page(
											$author$project$Translations$Audits$header(translations))))))))));
	});
var $author$project$Page$Page$audits = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 2) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotAuditPageMsg,
		kZ: $elm$core$Maybe$Just($author$project$Audit$Page$subscriptions),
		le: $author$project$Audit$Page$update,
		lm: $author$project$Audit$Page$view
	});
var $author$project$Page$Page$GotEventStreamPageMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$EventStream$Page$GotErrorModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$EventStream$Page$subscriptions = function (_v0) {
	return A2($elm$core$Platform$Sub$map, $author$project$EventStream$Page$GotErrorModalMsg, $author$project$Environments$ErrorHandling$ErrorModal$subscriptions);
};
var $author$project$EventStream$Page$Page = $elm$core$Basics$identity;
var $author$project$EventStream$Page$withCommandContent = F2(
	function (commandContent, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{gu: commandContent});
	});
var $author$project$EventStream$Page$changeCommandContent = F4(
	function (contentState, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2($author$project$EventStream$Page$withCommandContent, contentState, page),
			ae: repository
		};
	});
var $author$project$EventStream$Page$withErrorContent = F2(
	function (errorContent, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{gD: errorContent});
	});
var $author$project$EventStream$Page$changeErrorContent = F4(
	function (contentState, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2($author$project$EventStream$Page$withErrorContent, contentState, page),
			ae: repository
		};
	});
var $author$project$EventStream$Page$withWaringContent = F2(
	function (warningContent, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{hp: warningContent});
	});
var $author$project$EventStream$Page$changeWarningContent = F4(
	function (contentState, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2($author$project$EventStream$Page$withWaringContent, contentState, page),
			ae: repository
		};
	});
var $author$project$EventStream$EventStream$Connected = function (a) {
	return {$: 4, a: a};
};
var $author$project$EventStream$SyncWarning$Hidden = 0;
var $author$project$EventStream$SyncWarning$defaultWarningConfig = {h9: 0, f9: _List_Nil};
var $author$project$EventStream$EventStream$clearWarnings = function (state) {
	if (state.$ === 4) {
		var data = state.a;
		return $author$project$EventStream$EventStream$Connected(
			_Utils_update(
				data,
				{m: $author$project$EventStream$SyncWarning$defaultWarningConfig}));
	} else {
		return state;
	}
};
var $author$project$Environments$Repository$eventStream = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.j;
	});
var $author$project$Environments$Repository$withEventStream = F2(
	function (eventStream_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{j: eventStream_});
	});
var $author$project$Environments$Repository$setEventStream = F2(
	function (repo, es) {
		return A3($author$project$Utils$Utils$flip, $author$project$Environments$Repository$withEventStream, repo, es);
	});
var $author$project$EventStream$Page$deleteAllWarnings = F3(
	function (environment, repository, page) {
		var newRepository = A2(
			$author$project$Environments$Repository$setEventStream,
			repository,
			$author$project$EventStream$EventStream$clearWarnings(
				$author$project$Environments$Repository$eventStream(repository)));
		return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: newRepository};
	});
var $author$project$EventStream$EventStream$removeWarning = F2(
	function (syncWarning, state) {
		if (state.$ === 4) {
			var data = state.a;
			var oldConfig = data.m;
			var newConfig = _Utils_update(
				oldConfig,
				{
					f9: A2(
						$elm$core$List$filter,
						function (warning) {
							return !_Utils_eq(warning, syncWarning);
						},
						data.m.f9)
				});
			return $author$project$EventStream$EventStream$Connected(
				_Utils_update(
					data,
					{m: newConfig}));
		} else {
			return state;
		}
	});
var $author$project$EventStream$Page$deleteSyncWarning = F4(
	function (syncWarning, environment, repository, page) {
		var newRepository = A2(
			$author$project$Environments$Repository$setEventStream,
			repository,
			A2(
				$author$project$EventStream$EventStream$removeWarning,
				syncWarning,
				$author$project$Environments$Repository$eventStream(repository)));
		return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: newRepository};
	});
var $author$project$Utils$CopyToClipboard$CopyJson = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$CopyToClipboard$copyToClipboardOutbox = _Platform_outgoingPort('copyToClipboardOutbox', $elm$core$Basics$identity);
var $author$project$Utils$CopyToClipboard$encodeOutMsg = function (msg) {
	if (!msg.$) {
		var text = msg.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('COPY_TEXT')),
					_Utils_Tuple2(
					'text',
					$elm$json$Json$Encode$string(text))
				]));
	} else {
		var value = msg.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('COPY_JSON')),
					_Utils_Tuple2('json', value)
				]));
	}
};
var $author$project$Utils$CopyToClipboard$copyJson = function (json) {
	return $author$project$Utils$CopyToClipboard$copyToClipboardOutbox(
		$author$project$Utils$CopyToClipboard$encodeOutMsg(
			$author$project$Utils$CopyToClipboard$CopyJson(json)));
};
var $author$project$Environments$ErrorHandling$Id$toString = function (_v0) {
	var id = _v0;
	return $NoRedInk$elm_uuid$Prng$Uuid$toString(id);
};
var $author$project$Environments$ErrorHandling$Id$encode = A2($elm$core$Basics$composeR, $author$project$Environments$ErrorHandling$Id$toString, $elm$json$Json$Encode$string);
var $author$project$Environments$ErrorHandling$Error$decodeErrorToString = function (err) {
	switch (err.$) {
		case 0:
			var string = err.a;
			var error = err.b;
			return 'Field: <' + (string + ('>, ' + $author$project$Environments$ErrorHandling$Error$decodeErrorToString(error)));
		case 1:
			var _int = err.a;
			var error = err.b;
			return 'Index: ' + ($elm$core$String$fromInt(_int) + (', ' + $author$project$Environments$ErrorHandling$Error$decodeErrorToString(error)));
		case 2:
			var errors = err.a;
			return 'OneOf: ' + A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $author$project$Environments$ErrorHandling$Error$decodeErrorToString, errors));
		default:
			var string = err.a;
			var value = err.b;
			return 'Failure: ' + string;
	}
};
var $author$project$Environments$ErrorHandling$Error$encodeErrorType = function (errorType) {
	switch (errorType.$) {
		case 0:
			var error = errorType.a;
			var censoredFields = A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$map,
					function (str) {
						return A2($elm$core$String$contains, '\"name\"', str) ? '\n                \"name\": \"***\"' : str;
					},
					A2(
						$elm$core$List$map,
						function (str) {
							return A2($elm$core$String$contains, 'emailAddress', str) ? '\n                \"emailAddress\": \"***\"' : str;
						},
						A2(
							$elm$core$List$map,
							function (str) {
								return A2($elm$core$String$contains, 'password', str) ? '\n                \"password\": \"***\"' : str;
							},
							A2(
								$elm$core$String$split,
								',',
								$elm$json$Json$Decode$errorToString(error))))));
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('DECODE_ERROR')),
						_Utils_Tuple2(
						'error',
						$elm$json$Json$Encode$string(
							$author$project$Environments$ErrorHandling$Error$decodeErrorToString(error))),
						_Utils_Tuple2(
						'error_string',
						$elm$json$Json$Encode$string(censoredFields))
					]));
		case 1:
			var string = errorType.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('OTHER_ERROR')),
						_Utils_Tuple2(
						'error',
						$elm$json$Json$Encode$string(string))
					]));
		case 2:
			var string = errorType.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('COMMAND_HANDLING_ERROR')),
						_Utils_Tuple2(
						'error',
						$elm$json$Json$Encode$string(string))
					]));
		default:
			var _int = errorType.a;
			var string = errorType.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('HTTP_ERROR')),
						_Utils_Tuple2(
						'responseStatus',
						$elm$json$Json$Encode$int(_int)),
						_Utils_Tuple2(
						'responseMessage',
						$elm$json$Json$Encode$string(string))
					]));
	}
};
var $author$project$Environments$App$toString = function (state) {
	if (!state) {
		return 'Active';
	} else {
		return 'Inactive';
	}
};
var $author$project$Environments$Flags$Platform$toString = function (platform) {
	switch (platform.$) {
		case 0:
			var string = platform.a;
			return 'Web: ' + string;
		case 1:
			var string = platform.a;
			return 'Android: ' + string;
		default:
			var string = platform.a;
			return 'IOS: ' + string;
	}
};
var $author$project$Environments$Network$toString = function (state) {
	if (!state) {
		return 'Online';
	} else {
		return 'Offline';
	}
};
var $author$project$Environments$ErrorHandling$Error$encodeMetaData = function (metadata) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user',
				A2($author$project$Utils$Encode$maybe, $author$project$User$Id$encode, metadata.lh)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Environments$App$toString(metadata.dn))),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Environments$Network$toString(metadata.c3))),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(metadata.J)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(metadata.er)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Environments$Flags$Platform$toString(metadata.eT)))
			]));
};
var $author$project$Environments$ErrorHandling$Error$encodeError = function (error) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$Environments$ErrorHandling$Id$encode(error.fw)),
				_Utils_Tuple2(
				'errorType',
				$author$project$Environments$ErrorHandling$Error$encodeErrorType(error.gE)),
				_Utils_Tuple2(
				'additionalInformation',
				$elm$json$Json$Encode$string(error.gg)),
				_Utils_Tuple2(
				'file',
				$elm$json$Json$Encode$string(error.gH)),
				_Utils_Tuple2(
				'function',
				$elm$json$Json$Encode$string(error.gK)),
				_Utils_Tuple2(
				'metaData',
				$author$project$Environments$ErrorHandling$Error$encodeMetaData(error.j7))
			]));
};
var $author$project$Environments$ErrorHandling$ErrorModal$Hidden = {$: 0};
var $author$project$Environments$ErrorHandling$ErrorModal$userClickedCloseDialog = function (_v0) {
	return $author$project$Environments$ErrorHandling$ErrorModal$Hidden;
};
var $author$project$Environments$ErrorHandling$ErrorModal$update = F2(
	function (msg, dialog) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					$author$project$Environments$ErrorHandling$ErrorModal$userClickedCloseDialog(dialog),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(dialog, $elm$core$Platform$Cmd$none);
			default:
				var error = msg.a;
				return _Utils_Tuple2(
					dialog,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Environments$ErrorHandling$ErrorModal$ReceivedCopyMsg,
						$author$project$Utils$CopyToClipboard$copyJson(
							$author$project$Environments$ErrorHandling$Error$encodeError(error))));
		}
	});
var $author$project$EventStream$Page$withErrorModalDialog = F2(
	function (dialog, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{fq: dialog});
	});
var $author$project$EventStream$Page$gotErrorModalMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var page_ = page;
		var _v0 = A2($author$project$Environments$ErrorHandling$ErrorModal$update, dialogMsg, page_.fq);
		var newDialog = _v0.a;
		var cmd = _v0.b;
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$EventStream$Page$GotErrorModalMsg, cmd),
			ac: environment,
			ak: A2($author$project$EventStream$Page$withErrorModalDialog, newDialog, page),
			ae: repository
		};
	});
var $author$project$Environments$ErrorHandling$ErrorModal$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Environments$ErrorHandling$ErrorModal$visible = function (error) {
	return $author$project$Environments$ErrorHandling$ErrorModal$Visible(error);
};
var $author$project$EventStream$Page$openErrorModal = F4(
	function (err, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2(
				$author$project$EventStream$Page$withErrorModalDialog,
				$author$project$Environments$ErrorHandling$ErrorModal$visible(err),
				page),
			ae: repository
		};
	});
var $author$project$Environments$Environment$changedAppState = F2(
	function (app, state) {
		return A2(
			$author$project$Environments$Environment$map,
			function (model) {
				return _Utils_update(
					model,
					{dn: app});
			},
			state);
	});
var $author$project$Environments$Environment$changedNetworkState = F2(
	function (network, state) {
		return A2(
			$author$project$Environments$Environment$map,
			function (model) {
				return _Utils_update(
					model,
					{c3: network});
			},
			state);
	});
var $author$project$Environments$Environment$Thin = 1;
var $author$project$Environments$Environment$gotResizeEvent = F2(
	function (newViewport, state) {
		var viewType = (newViewport.ln > 550) ? 0 : 1;
		switch (state.$) {
			case 0:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedSession(
					_Utils_update(
						model,
						{
							J: {Y: newViewport.Y, be: viewType, ln: newViewport.ln}
						}));
			case 1:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedSession(
					_Utils_update(
						model,
						{
							J: {Y: newViewport.Y, be: viewType, ln: newViewport.ln}
						}));
			case 2:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{
							J: {Y: newViewport.Y, be: viewType, ln: newViewport.ln}
						}));
			default:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{
							J: {Y: newViewport.Y, be: viewType, ln: newViewport.ln}
						}));
		}
	});
var $author$project$Environments$Environment$gotViewport = F2(
	function (viewport_, state) {
		var viewType = (viewport_.J.ln > 550) ? 0 : 1;
		switch (state.$) {
			case 0:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedSession(
					_Utils_update(
						model,
						{
							J: {Y: viewport_.J.Y, be: viewType, ln: viewport_.J.ln}
						}));
			case 1:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedSession(
					_Utils_update(
						model,
						{
							J: {Y: viewport_.J.Y, be: viewType, ln: viewport_.J.ln}
						}));
			case 2:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{
							J: {Y: viewport_.J.Y, be: viewType, ln: viewport_.J.ln}
						}));
			default:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{
							J: {Y: viewport_.J.Y, be: viewType, ln: viewport_.J.ln}
						}));
		}
	});
var $author$project$Environments$Environment$loadedUserRights = F2(
	function (userRights_, state) {
		switch (state.$) {
			case 0:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedSession(
					_Utils_update(
						model,
						{cy: userRights_}));
			case 1:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedSession(
					_Utils_update(
						model,
						{cy: userRights_}));
			case 2:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{cy: userRights_}));
			default:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{cy: userRights_}));
		}
	});
var $author$project$Environments$Environment$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'Environments.Environmentm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$Environments$Environment$receivedSession = F2(
	function (session_, state) {
		switch (state.$) {
			case 0:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedSession(
					_Utils_update(
						model,
						{aO: session_}));
			case 1:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedSession(
					_Utils_update(
						model,
						{aO: session_}));
			case 2:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{aO: session_}));
			default:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{aO: session_}));
		}
	});
var $author$project$Date_Time$NaiveTime$toPosix = function (naiveTime) {
	return $elm$time$Time$millisToPosix(
		$author$project$Date_Time$NaiveTime$toMillis(naiveTime));
};
var $author$project$Environments$Environment$receivedTimeZone = F2(
	function (timeZone_, state) {
		var offset_ = function () {
			var _v1 = A2($author$project$Date_Time$NaiveTime$hm, 12, 0);
			if (!_v1.$) {
				var value = _v1.a;
				var timePosix = $author$project$Date_Time$NaiveTime$toPosix(value);
				var utc = $author$project$Date_Time$NaiveTime$toMillis(
					A2($author$project$Date_Time$NaiveTime$fromPosix, $elm$time$Time$utc, timePosix));
				var millisInLocalTime = $author$project$Date_Time$NaiveTime$toMillis(
					A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone_, timePosix));
				var result = millisInLocalTime - utc;
				return result;
			} else {
				return 0;
			}
		}();
		switch (state.$) {
			case 0:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedTranslations(
					_Utils_update(
						model,
						{
							cw: {d0: offset_, el: timeZone_}
						}));
			case 1:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{
							cw: {d0: offset_, el: timeZone_}
						}));
			case 2:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedTranslations(
					_Utils_update(
						model,
						{
							cw: {d0: offset_, el: timeZone_}
						}));
			default:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{
							cw: {d0: offset_, el: timeZone_}
						}));
		}
	});
var $author$project$Environments$Environment$receivedTranslations = F2(
	function (translations_, state) {
		switch (state.$) {
			case 0:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedTranslations(
					_Utils_update(
						model,
						{dj: translations_}));
			case 1:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{dj: translations_}));
			case 2:
				var model = state.a;
				return $author$project$Environments$Environment$LoadedTranslations(
					_Utils_update(
						model,
						{dj: translations_}));
			default:
				var model = state.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{dj: translations_}));
		}
	});
var $author$project$Environments$Environment$removedData = function (state) {
	return state;
};
var $author$project$Environments$Environment$getRequiredEnvironmentUpdate = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.bL;
	});
var $author$project$Environments$Environment$savedUserRights = function (environment) {
	var _v0 = $author$project$Environments$Environment$getRequiredEnvironmentUpdate(environment);
	if (_v0 === 1) {
		switch (environment.$) {
			case 0:
				var model = environment.a;
				return $author$project$Environments$Environment$LoadedSession(
					_Utils_update(
						model,
						{bL: 0}));
			case 1:
				var model = environment.a;
				return $author$project$Environments$Environment$LoadedSession(
					_Utils_update(
						model,
						{bL: 0}));
			case 2:
				var model = environment.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{bL: 0}));
			default:
				var model = environment.a;
				return $author$project$Environments$Environment$Loaded(
					_Utils_update(
						model,
						{bL: 0}));
		}
	} else {
		return environment;
	}
};
var $author$project$Auth$Session$Expired = {$: 4};
var $author$project$Auth$Session$expired = $author$project$Auth$Session$Expired;
var $author$project$Environments$Environment$sessionExpired = function (state) {
	switch (state.$) {
		case 0:
			var model = state.a;
			return $author$project$Environments$Environment$LoadedSession(
				_Utils_update(
					model,
					{aO: $author$project$Auth$Session$expired}));
		case 1:
			var model = state.a;
			return $author$project$Environments$Environment$LoadedSession(
				_Utils_update(
					model,
					{aO: $author$project$Auth$Session$expired}));
		case 2:
			var model = state.a;
			return $author$project$Environments$Environment$Loaded(
				_Utils_update(
					model,
					{aO: $author$project$Auth$Session$expired}));
		default:
			var model = state.a;
			return $author$project$Environments$Environment$Loaded(
				_Utils_update(
					model,
					{aO: $author$project$Auth$Session$expired}));
	}
};
var $author$project$Environments$Environment$update = function (msg) {
	switch (msg.$) {
		case 0:
			var app = msg.a;
			return $author$project$Environments$Environment$changedAppState(app);
		case 1:
			var network = msg.a;
			return $author$project$Environments$Environment$changedNetworkState(network);
		case 2:
			if (!msg.a.$) {
				var translations_ = msg.a.a;
				return $author$project$Environments$Environment$receivedTranslations(translations_);
			} else {
				return $elm$core$Basics$identity;
			}
		case 3:
			var zone = msg.a;
			return $author$project$Environments$Environment$receivedTimeZone(zone);
		case 4:
			var viewport_ = msg.a;
			return $author$project$Environments$Environment$gotViewport(viewport_);
		case 5:
			var newViewport = msg.a;
			return $author$project$Environments$Environment$gotResizeEvent(newViewport);
		case 6:
			var session_ = msg.a;
			return $author$project$Environments$Environment$receivedSession(session_);
		case 7:
			return $author$project$Environments$Environment$sessionExpired;
		case 8:
			return $author$project$Environments$Environment$savedUserRights;
		case 9:
			var userRights_ = msg.a;
			return $author$project$Environments$Environment$loadedUserRights(userRights_);
		case 10:
			return $author$project$Environments$Environment$removedData;
		default:
			var err = msg.a;
			return $author$project$Environments$Environment$receivedErrorMsg(err);
	}
};
var $author$project$EventStream$Page$receivedEnvironmentMsg = F4(
	function (environmentMsg, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$update, environmentMsg, environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$EventStream$Page$ReceivedRepositoryMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$File$Files$fromList = A2($elm$core$Basics$composeR, $author$project$File$Dict$fromList, $elm$core$Basics$identity);
var $author$project$File$Filenames$toList = $turboMaCk$any_set$Set$Any$toList;
var $author$project$Audit$Audits$filenameToTripleList = function (record) {
	return A2(
		$elm$core$List$map,
		function (filename) {
			return _Utils_Tuple2(record.bK, filename);
		},
		$author$project$File$Filenames$toList(record.cT));
};
var $author$project$Audit$Audits$getFiles = function (audit) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function (record) {
				var _v0 = record.ll;
				if (_v0.$ === 8) {
					var filename = _v0.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(record.bK, filename),
						$author$project$Audit$Audits$filenameToTripleList(record));
				} else {
					return $author$project$Audit$Audits$filenameToTripleList(record);
				}
			},
			$author$project$Audit$Record$Records$values(audit.io)));
};
var $author$project$File$File$remoteRecordImage = F3(
	function (auditId, recordId, filename_) {
		return $author$project$File$File$RecordImage(
			{gm: auditId, dA: false, P: filename_, bK: recordId, kU: 1});
	});
var $author$project$Audit$Audits$files = function (audits) {
	return A3(
		$elm$core$Basics$composeR,
		$author$project$Audit$Dict$values,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$concatMap(
				function (audit) {
					return A2(
						$elm$core$List$map,
						function (_v0) {
							var recordId = _v0.a;
							var filename = _v0.b;
							return A3($author$project$File$File$remoteRecordImage, audit.gm, recordId, filename);
						},
						$author$project$Audit$Audits$getFiles(audit));
				}),
			$author$project$File$Files$fromList),
		$author$project$Audit$Audits$dict(audits));
};
var $author$project$Audit$Store$commands = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Audit$Commands$empty;
		case 1:
			var data = state.a;
			return data.cD;
		case 2:
			var data = state.a;
			return data.cD;
		default:
			var data = state.a;
			return data.cD;
	}
};
var $author$project$Audit$Store$hasCommands = A2(
	$elm$core$Basics$composeR,
	$author$project$Audit$Store$commands,
	A2($elm$core$Basics$composeR, $author$project$Audit$Commands$isEmpty, $elm$core$Basics$not));
var $author$project$Audit$Store$isReady = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Audit$Store$SaveAudits = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$Store$saveAudits = F2(
	function (audits_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Audit$Store$Loaded(
							{aC: audits_, cD: $author$project$Audit$Commands$empty, b8: $author$project$Audit$Events$empty}),
						$author$project$Audit$Store$send(
							$author$project$Audit$Store$SaveAudits(audits_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Audit$Store$Loaded(
							_Utils_update(
								data,
								{aC: audits_})),
						$author$project$Audit$Store$send(
							$author$project$Audit$Store$SaveAudits(audits_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Audit$Store$SaveModifications = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audit$Store$saveModifications = F3(
	function (audits_, modifications, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Audit$Store$Loaded(
							{aC: audits_, cD: $author$project$Audit$Commands$empty, b8: $author$project$Audit$Events$empty}),
						$author$project$Audit$Store$send(
							$author$project$Audit$Store$SaveModifications(modifications))));
			case 2:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Audit$Store$Loaded(
							{aC: audits_, cD: $author$project$Audit$Commands$empty, b8: $author$project$Audit$Events$empty}),
						$author$project$Audit$Store$send(
							$author$project$Audit$Store$SaveModifications(modifications))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$File$File$remoteMeasureImage = F3(
	function (measureId, organisationUnitId, filename_) {
		return $author$project$File$File$MeasureImage(
			{dA: false, P: filename_, h5: measureId, km: organisationUnitId, kU: 1});
	});
var $author$project$File$Files$applyRemoteCreateMeasureImage = F4(
	function (measureId, organisationUnitId, filename, _v0) {
		var files = _v0.a;
		var modifications = _v0.b;
		if (A2($author$project$File$Files$member, filename, files)) {
			return _Utils_Tuple2(files, modifications);
		} else {
			var newFile = A3($author$project$File$File$remoteMeasureImage, measureId, organisationUnitId, filename);
			return _Utils_Tuple2(
				A2($author$project$File$Files$insert, newFile, files),
				A2($author$project$File$Modifications$withChanged, newFile, modifications));
		}
	});
var $author$project$File$File$remoteOrganisationUnitFile = F2(
	function (organisationUnitId, filename_) {
		return $author$project$File$File$OrganisationUnitFile(
			{dA: false, fs: 0, P: filename_, km: organisationUnitId, kU: 1});
	});
var $author$project$File$Files$applyRemoteCreateOrganisationUnitAvatar = F3(
	function (organisationUnitId, filename, _v0) {
		var files = _v0.a;
		var modifications = _v0.b;
		if (A2($author$project$File$Files$member, filename, files)) {
			return _Utils_Tuple2(files, modifications);
		} else {
			var newFile = A2($author$project$File$File$remoteOrganisationUnitFile, organisationUnitId, filename);
			return _Utils_Tuple2(
				A2($author$project$File$Files$insert, newFile, files),
				A2($author$project$File$Modifications$withChanged, newFile, modifications));
		}
	});
var $author$project$File$Files$applyRemoteCreateRecordImage = F4(
	function (auditId, recordId, filename, _v0) {
		var files = _v0.a;
		var modifications = _v0.b;
		if (A2($author$project$File$Files$member, filename, files)) {
			return _Utils_Tuple2(files, modifications);
		} else {
			var newFile = A3($author$project$File$File$remoteRecordImage, auditId, recordId, filename);
			return _Utils_Tuple2(
				A2($author$project$File$Files$insert, newFile, files),
				A2($author$project$File$Modifications$withChanged, newFile, modifications));
		}
	});
var $author$project$File$File$remoteUserAvatar = F2(
	function (userId, filename_) {
		return $author$project$File$File$UserAvatar(
			{dA: false, P: filename_, kU: 1, dk: userId});
	});
var $author$project$File$Files$applyRemoteCreateUserAvatar = F3(
	function (userId, filename, _v0) {
		var files = _v0.a;
		var modifications = _v0.b;
		if (A2($author$project$File$Files$member, filename, files)) {
			return _Utils_Tuple2(files, modifications);
		} else {
			var newFile = A2($author$project$File$File$remoteUserAvatar, userId, filename);
			return _Utils_Tuple2(
				A2($author$project$File$Files$insert, newFile, files),
				A2($author$project$File$Modifications$withChanged, newFile, modifications));
		}
	});
var $author$project$File$Files$applyRemoteOperation = function (operation) {
	switch (operation.$) {
		case 0:
			var userId = operation.a;
			var filename = operation.b;
			return A2($author$project$File$Files$applyRemoteCreateUserAvatar, userId, filename);
		case 1:
			var organisationUnitId = operation.a;
			var filename = operation.b;
			return A2($author$project$File$Files$applyRemoteCreateOrganisationUnitAvatar, organisationUnitId, filename);
		case 2:
			var measureId = operation.a;
			var organisationUnitId = operation.b;
			var filename = operation.c;
			return A3($author$project$File$Files$applyRemoteCreateMeasureImage, measureId, organisationUnitId, filename);
		case 3:
			var auditId = operation.a;
			var recordId = operation.b;
			var filename = operation.c;
			return A3($author$project$File$Files$applyRemoteCreateRecordImage, auditId, recordId, filename);
		default:
			var deleteFromServer = operation.a;
			var filename = operation.b;
			return A2($author$project$File$Files$applyDeleteOperation, deleteFromServer, filename);
	}
};
var $author$project$File$Files$applyRemoteOperations = F2(
	function (operations, acc) {
		return A3($author$project$File$Operations$fold, $author$project$File$Files$applyRemoteOperation, acc, operations);
	});
var $author$project$File$Store$saveRemoteOperations = F2(
	function (newOperations, state) {
		switch (state.$) {
			case 0:
				var data = state.a;
				return _Utils_Tuple2(
					$author$project$File$Store$Loading(
						_Utils_update(
							data,
							{
								V: A2($author$project$File$Operations$merge, data.V, newOperations)
							})),
					$elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				var _v1 = A2(
					$author$project$File$Files$applyRemoteOperations,
					newOperations,
					_Utils_Tuple2(data.cT, $author$project$File$Modifications$empty));
				var newFiles = _v1.a;
				var modifications = _v1.b;
				var newSynchronization = A2($author$project$File$Synchronization$withFiles, newFiles, data.b);
				return _Utils_Tuple2(
					$author$project$File$Store$Saving(
						{cT: newFiles, Q: $author$project$File$Operations$empty, V: $author$project$File$Operations$empty, b: newSynchronization}),
					$author$project$File$Store$send(
						$author$project$File$Store$SaveModifications(modifications)));
			default:
				var data = state.a;
				return _Utils_Tuple2(
					$author$project$File$Store$Saving(
						_Utils_update(
							data,
							{
								V: A2($author$project$File$Operations$merge, data.V, newOperations)
							})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$File$Store$NotReady = 0;
var $author$project$File$Store$SaveFiles = function (a) {
	return {$: 1, a: a};
};
var $author$project$File$Dict$fold = F2(
	function (fn, acc) {
		return A2(
			$turboMaCk$any_dict$Dict$Any$foldl,
			$elm$core$Basics$always(fn),
			acc);
	});
var $author$project$File$Files$fold = F2(
	function (fn, acc) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$File$Files$unwrap,
			A2($author$project$File$Dict$fold, fn, acc));
	});
var $author$project$File$File$isRecordImage = function (file) {
	if (file.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$File$File$restored = function (file) {
	switch (file.$) {
		case 0:
			var data = file.a;
			return $author$project$File$File$UserAvatar(
				_Utils_update(
					data,
					{dA: false}));
		case 1:
			var data = file.a;
			return $author$project$File$File$OrganisationUnitFile(
				_Utils_update(
					data,
					{dA: false}));
		case 2:
			var data = file.a;
			return $author$project$File$File$MeasureImage(
				_Utils_update(
					data,
					{dA: false}));
		default:
			var data = file.a;
			return $author$project$File$File$RecordImage(
				_Utils_update(
					data,
					{dA: false}));
	}
};
var $author$project$File$Store$mergeRecordFile = F2(
	function (file, files) {
		return $author$project$File$File$isRecordImage(file) ? (A2(
			$author$project$File$Files$member,
			$author$project$File$File$filename(file),
			files) ? A2(
			$author$project$File$Files$insert,
			$author$project$File$File$restored(file),
			files) : A2(
			$author$project$File$Files$insert,
			$author$project$File$File$deleted(file),
			files)) : A2($author$project$File$Files$insert, file, files);
	});
var $author$project$File$Store$mergeRecordFiles = F2(
	function (files, remoteFiles) {
		return A3($author$project$File$Files$fold, $author$project$File$Store$mergeRecordFile, remoteFiles, files);
	});
var $author$project$File$Store$saveRemoteRecordFiles = F2(
	function (remoteFiles, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				var newFiles = A2($author$project$File$Store$mergeRecordFiles, data.cT, remoteFiles);
				var newSynchronization = A2($author$project$File$Synchronization$withFiles, newFiles, data.b);
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$File$Store$Saving(
							{cT: newFiles, Q: $author$project$File$Operations$empty, V: $author$project$File$Operations$empty, b: newSynchronization}),
						$author$project$File$Store$send(
							$author$project$File$Store$SaveFiles(newFiles))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$EventStream$EventStream$AuditsNotUpToDate = 4;
var $author$project$EventStream$EventStream$NotConnected = 0;
var $author$project$EventStream$EventStream$takeAuditEvents = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(0);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(0);
		case 3:
			return $elm$core$Result$Err(0);
		default:
			var data = state.a;
			return (data.A === 1) ? $elm$core$Result$Ok(
				_Utils_Tuple2(
					data.s,
					$author$project$EventStream$EventStream$Connected(
						_Utils_update(
							data,
							{s: $author$project$Audit$Events$empty})))) : $elm$core$Result$Err(4);
	}
};
var $author$project$Audit$Service$NotFetched = 1;
var $author$project$Audit$Service$SendingCommand = {$: 2};
var $author$project$Audit$Service$takeAudits = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(1);
		case 1:
			return $elm$core$Result$Err(1);
		case 2:
			return $elm$core$Result$Err(1);
		case 3:
			var audits = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(audits, $author$project$Audit$Service$Idle));
		default:
			var audits = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(audits, $author$project$Audit$Service$SendingCommand));
	}
};
var $author$project$Environments$Repository$withAuditService = F2(
	function (auditService_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{bg: auditService_});
	});
var $author$project$Environments$Repository$applyAuditEvents = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Audit$Store$hasCommands(data.aa)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		if (!$author$project$Audit$Store$isReady(data.aa)) {
			return _Utils_Tuple3(environment, repository, cmds);
		} else {
			var _v1 = _Utils_Tuple2(
				$author$project$EventStream$EventStream$takeAuditEvents(data.j),
				$author$project$Audit$Service$takeAudits(data.bg));
			_v1$2:
			while (true) {
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var _v2 = _v1.a.a;
						var events = _v2.a;
						var newEventStream = _v2.b;
						var _v3 = _v1.b.a;
						var serviceAudits = _v3.a;
						var newAuditService = _v3.b;
						var newAudits = $author$project$Utils$Triple$first(
							A2($author$project$Audit$Audits$applyEvents, events, serviceAudits));
						var auditFiles = $author$project$Audit$Audits$files(newAudits);
						var _v4 = _Utils_Tuple2(
							A2($author$project$Audit$Store$saveAudits, newAudits, data.aa),
							A2($author$project$File$Store$saveRemoteRecordFiles, auditFiles, data.ad));
						if ((!_v4.a.$) && (!_v4.b.$)) {
							var _v5 = _v4.a.a;
							var newAuditStore = _v5.a;
							var auditStoreCmd = _v5.b;
							var _v6 = _v4.b.a;
							var newFileStore = _v6.a;
							var fileStoreCmd = _v6.b;
							return _Utils_Tuple3(
								environment,
								A2(
									$author$project$Environments$Repository$withFileStore,
									newFileStore,
									A2(
										$author$project$Environments$Repository$withAuditStore,
										newAuditStore,
										A2(
											$author$project$Environments$Repository$withAuditService,
											newAuditService,
											A2($author$project$Environments$Repository$withEventStream, newEventStream, repository)))),
								A2(
									$elm$core$List$cons,
									auditStoreCmd,
									A2($elm$core$List$cons, fileStoreCmd, cmds)));
						} else {
							return _Utils_Tuple3(environment, repository, cmds);
						}
					} else {
						if (_v1.b.a === 1) {
							var _v7 = _v1.a.a;
							var events = _v7.a;
							var newEventStream = _v7.b;
							var _v8 = _v1.b.a;
							if ($author$project$Audit$Events$isEmpty(events)) {
								return _Utils_Tuple3(
									environment,
									A2($author$project$Environments$Repository$withEventStream, newEventStream, repository),
									cmds);
							} else {
								var _v9 = A2(
									$author$project$Audit$Audits$applyEvents,
									events,
									$author$project$Audit$Store$audits(data.aa));
								var newAudits = _v9.a;
								var modifications = _v9.b;
								var fileOperations = _v9.c;
								var _v10 = A2($author$project$File$Store$saveRemoteOperations, fileOperations, data.ad);
								var newFileStore = _v10.a;
								var fileStoreCmd = _v10.b;
								var _v11 = A3($author$project$Audit$Store$saveModifications, newAudits, modifications, data.aa);
								if (!_v11.$) {
									var _v12 = _v11.a;
									var newAuditStore = _v12.a;
									var auditStoreCmd = _v12.b;
									return _Utils_Tuple3(
										environment,
										A2(
											$author$project$Environments$Repository$withFileStore,
											newFileStore,
											A2(
												$author$project$Environments$Repository$withAuditStore,
												newAuditStore,
												A2($author$project$Environments$Repository$withEventStream, newEventStream, repository))),
										A2(
											$elm$core$List$cons,
											auditStoreCmd,
											A2($elm$core$List$cons, fileStoreCmd, cmds)));
								} else {
									return _Utils_Tuple3(environment, repository, cmds);
								}
							}
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return _Utils_Tuple3(environment, repository, cmds);
		}
	}
};
var $author$project$CheckpointData$Store$commands = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$CheckpointData$Commands$empty;
		case 1:
			var data = state.a;
			return data.cD;
		case 2:
			var data = state.a;
			return data.cD;
		default:
			var data = state.a;
			return data.cD;
	}
};
var $author$project$CheckpointData$Commands$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$CheckpointData$Store$hasCommands = A2(
	$elm$core$Basics$composeR,
	$author$project$CheckpointData$Store$commands,
	A2($elm$core$Basics$composeR, $author$project$CheckpointData$Commands$isEmpty, $elm$core$Basics$not));
var $author$project$CheckpointData$Events$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$CheckpointData$Store$isReady = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$CheckpointData$Store$NotReady = 0;
var $author$project$CheckpointData$Store$SaveCheckpointData = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$Store$Saving = function (a) {
	return {$: 3, a: a};
};
var $author$project$CheckpointData$Store$saveCheckpointData = F2(
	function (checkpointData_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$CheckpointData$Store$Saving(
							{a: checkpointData_, cD: $author$project$CheckpointData$Commands$empty, b8: $author$project$CheckpointData$Events$empty}),
						$author$project$CheckpointData$Store$send(
							$author$project$CheckpointData$Store$SaveCheckpointData(checkpointData_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$CheckpointData$Store$Saving(
							_Utils_update(
								data,
								{a: checkpointData_})),
						$author$project$CheckpointData$Store$send(
							$author$project$CheckpointData$Store$SaveCheckpointData(checkpointData_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$CheckpointData$Store$SaveModifications = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Store$saveModifications = F3(
	function (checkpointData_, modifications, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$CheckpointData$Store$Saving(
							{a: checkpointData_, cD: $author$project$CheckpointData$Commands$empty, b8: $author$project$CheckpointData$Events$empty}),
						$author$project$CheckpointData$Store$send(
							$author$project$CheckpointData$Store$SaveModifications(modifications))));
			case 2:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$CheckpointData$Store$Saving(
							{a: checkpointData_, cD: $author$project$CheckpointData$Commands$empty, b8: $author$project$CheckpointData$Events$empty}),
						$author$project$CheckpointData$Store$send(
							$author$project$CheckpointData$Store$SaveModifications(modifications))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$OrganisationUnit$Store$NotReady = 0;
var $author$project$OrganisationUnit$Store$SaveModifications = function (a) {
	return {$: 2, a: a};
};
var $author$project$OrganisationUnit$Store$Saving = function (a) {
	return {$: 3, a: a};
};
var $author$project$OrganisationUnit$Store$saveModifications = F3(
	function (organisationUnits_, modifications, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$OrganisationUnit$Store$Saving(
							{cD: $author$project$OrganisationUnit$Commands$empty, b8: $author$project$OrganisationUnit$Events$empty, kn: organisationUnits_}),
						$author$project$OrganisationUnit$Store$send(
							$author$project$OrganisationUnit$Store$SaveModifications(modifications))));
			case 2:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$OrganisationUnit$Store$Saving(
							{cD: $author$project$OrganisationUnit$Commands$empty, b8: $author$project$OrganisationUnit$Events$empty, kn: organisationUnits_}),
						$author$project$OrganisationUnit$Store$send(
							$author$project$OrganisationUnit$Store$SaveModifications(modifications))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$OrganisationUnit$Store$SaveOrganisationUnits = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$Store$saveOrganisationUnits = F2(
	function (organisationUnits_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$OrganisationUnit$Store$Saving(
							{cD: $author$project$OrganisationUnit$Commands$empty, b8: $author$project$OrganisationUnit$Events$empty, kn: organisationUnits_}),
						$author$project$OrganisationUnit$Store$send(
							$author$project$OrganisationUnit$Store$SaveOrganisationUnits(organisationUnits_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$OrganisationUnit$Store$Saving(
							_Utils_update(
								data,
								{kn: organisationUnits_})),
						$author$project$OrganisationUnit$Store$send(
							$author$project$OrganisationUnit$Store$SaveOrganisationUnits(organisationUnits_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$CheckpointData$Service$NotFetched = 1;
var $author$project$CheckpointData$Service$NotReady = 0;
var $author$project$CheckpointData$Service$SendingCommand = {$: 2};
var $author$project$CheckpointData$Service$takeCheckpointData = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(1);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(1);
		case 3:
			var checkpointData = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(checkpointData, $author$project$CheckpointData$Service$Idle));
		default:
			var checkpointData = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(checkpointData, $author$project$CheckpointData$Service$SendingCommand));
	}
};
var $author$project$EventStream$EventStream$CheckpointDataNotUpToDate = 7;
var $author$project$EventStream$EventStream$takeCheckpointDataEvents = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(0);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(0);
		case 3:
			return $elm$core$Result$Err(0);
		default:
			var data = state.a;
			return (data.B === 1) ? $elm$core$Result$Ok(
				_Utils_Tuple2(
					data.t,
					$author$project$EventStream$EventStream$Connected(
						_Utils_update(
							data,
							{t: $author$project$CheckpointData$Events$empty})))) : $elm$core$Result$Err(7);
	}
};
var $author$project$Environments$Repository$withCheckpointDataService = F2(
	function (checkpointDataService_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{bj: checkpointDataService_});
	});
var $author$project$Environments$Repository$withCheckpointDataStore = F2(
	function (checkpointDataStore_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{C: checkpointDataStore_});
	});
var $author$project$Environments$Repository$withOrganisationUnitStore = F2(
	function (organisationUnitStore_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{T: organisationUnitStore_});
	});
var $author$project$Environments$Repository$applyCheckpointDataEvents = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$CheckpointData$Store$hasCommands(data.C)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		if (!$author$project$CheckpointData$Store$isReady(data.C)) {
			return _Utils_Tuple3(environment, repository, cmds);
		} else {
			var _v1 = _Utils_Tuple2(
				$author$project$EventStream$EventStream$takeCheckpointDataEvents(data.j),
				$author$project$CheckpointData$Service$takeCheckpointData(data.bj));
			_v1$2:
			while (true) {
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var _v2 = _v1.a.a;
						var events = _v2.a;
						var newEventStream = _v2.b;
						var _v3 = _v1.b.a;
						var serviceCheckpointData = _v3.a;
						var newCheckpointDataService = _v3.b;
						var newOrganisationUnits = A2(
							$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyEvents,
							events,
							_Utils_Tuple2(
								$author$project$Environments$Repository$organisationUnits(repository),
								$elm$core$Maybe$Nothing)).a;
						var newCheckpointData = $author$project$Utils$Triple$first(
							A2($author$project$CheckpointData$EventApplier$applyEvents, events, serviceCheckpointData));
						var _v4 = _Utils_Tuple2(
							A2($author$project$CheckpointData$Store$saveCheckpointData, newCheckpointData, data.C),
							A2($author$project$OrganisationUnit$Store$saveOrganisationUnits, newOrganisationUnits, data.T));
						if ((!_v4.a.$) && (!_v4.b.$)) {
							var _v5 = _v4.a.a;
							var newCheckpointDataStore = _v5.a;
							var checkpointDataStoreCmd = _v5.b;
							var _v6 = _v4.b.a;
							var newOrganisationUnitStore = _v6.a;
							var organisationUnitStoreCmd = _v6.b;
							return _Utils_Tuple3(
								environment,
								A2(
									$author$project$Environments$Repository$withOrganisationUnitStore,
									newOrganisationUnitStore,
									A2(
										$author$project$Environments$Repository$withCheckpointDataStore,
										newCheckpointDataStore,
										A2(
											$author$project$Environments$Repository$withCheckpointDataService,
											newCheckpointDataService,
											A2($author$project$Environments$Repository$withEventStream, newEventStream, repository)))),
								A2(
									$elm$core$List$cons,
									checkpointDataStoreCmd,
									A2($elm$core$List$cons, organisationUnitStoreCmd, cmds)));
						} else {
							return _Utils_Tuple3(environment, repository, cmds);
						}
					} else {
						if (_v1.b.a === 1) {
							var _v7 = _v1.a.a;
							var events = _v7.a;
							var newEventStream = _v7.b;
							var _v8 = _v1.b.a;
							if ($author$project$CheckpointData$Events$isEmpty(events)) {
								return _Utils_Tuple3(
									environment,
									A2($author$project$Environments$Repository$withEventStream, newEventStream, repository),
									cmds);
							} else {
								var checkpointData = $author$project$CheckpointData$Store$checkpointData(data.C);
								var _v9 = A2(
									$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyEvents,
									events,
									_Utils_Tuple2(
										$author$project$Environments$Repository$organisationUnits(repository),
										$elm$core$Maybe$Nothing));
								var newOrganisationUnits = _v9.a;
								var organisationUnitModifications = _v9.b;
								var _v10 = A2($author$project$CheckpointData$EventApplier$applyEvents, events, checkpointData);
								var newCheckpointData = _v10.a;
								var modifications = _v10.b;
								var fileOperations = _v10.c;
								var _v11 = A2($author$project$File$Store$saveRemoteOperations, fileOperations, data.ad);
								var newFileStore = _v11.a;
								var fileStoreCmd = _v11.b;
								var _v12 = _Utils_Tuple2(
									A3($author$project$CheckpointData$Store$saveModifications, newCheckpointData, modifications, data.C),
									A3($author$project$OrganisationUnit$Store$saveModifications, newOrganisationUnits, organisationUnitModifications, data.T));
								if ((!_v12.a.$) && (!_v12.b.$)) {
									var _v13 = _v12.a.a;
									var newCheckpointDataStore = _v13.a;
									var checkpointDataStoreCmd = _v13.b;
									var _v14 = _v12.b.a;
									var newOrganisationUnitStore = _v14.a;
									var organisationUnitStoreCmd = _v14.b;
									return _Utils_Tuple3(
										environment,
										A2(
											$author$project$Environments$Repository$withOrganisationUnitStore,
											newOrganisationUnitStore,
											A2(
												$author$project$Environments$Repository$withCheckpointDataStore,
												newCheckpointDataStore,
												A2($author$project$Environments$Repository$withEventStream, newEventStream, repository))),
										A2(
											$elm$core$List$cons,
											checkpointDataStoreCmd,
											A2($elm$core$List$cons, organisationUnitStoreCmd, cmds)));
								} else {
									return _Utils_Tuple3(environment, repository, cmds);
								}
							}
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return _Utils_Tuple3(environment, repository, cmds);
		}
	}
};
var $author$project$Measure$Measures$values = A2($elm$core$Basics$composeR, $author$project$Measure$Measures$dict, $author$project$Measure$Dict$values);
var $author$project$Measure$Measures$files = A2(
	$elm$core$Basics$composeR,
	$author$project$Measure$Measures$values,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$concatMap(
			function (measure) {
				return A2(
					$elm$core$List$map,
					A2($author$project$File$File$remoteMeasureImage, measure.h5, measure.km),
					measure.fx);
			}),
		$author$project$File$Files$fromList));
var $author$project$Measure$Store$commands = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Measure$Commands$empty;
		case 1:
			var data = state.a;
			return data.cD;
		case 2:
			var data = state.a;
			return data.cD;
		default:
			var data = state.a;
			return data.cD;
	}
};
var $author$project$Measure$Store$hasCommands = A2(
	$elm$core$Basics$composeR,
	$author$project$Measure$Store$commands,
	A2($elm$core$Basics$composeR, $author$project$Measure$Commands$isEmpty, $elm$core$Basics$not));
var $author$project$Measure$Store$isReady = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Measure$Store$SaveMeasures = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$Store$saveMeasures = F2(
	function (measures_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Measure$Store$Saving(
							{cD: $author$project$Measure$Commands$empty, b8: $author$project$Measure$Events$empty, aI: measures_}),
						$author$project$Measure$Store$send(
							$author$project$Measure$Store$SaveMeasures(measures_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Measure$Store$Saving(
							_Utils_update(
								data,
								{aI: measures_})),
						$author$project$Measure$Store$send(
							$author$project$Measure$Store$SaveMeasures(measures_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Measure$Store$SaveModifications = function (a) {
	return {$: 2, a: a};
};
var $author$project$Measure$Store$saveModifications = F3(
	function (measures_, modifications, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Measure$Store$Saving(
							{cD: $author$project$Measure$Commands$empty, b8: $author$project$Measure$Events$empty, aI: measures_}),
						$author$project$Measure$Store$send(
							$author$project$Measure$Store$SaveModifications(modifications))));
			case 2:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Measure$Store$Saving(
							{cD: $author$project$Measure$Commands$empty, b8: $author$project$Measure$Events$empty, aI: measures_}),
						$author$project$Measure$Store$send(
							$author$project$Measure$Store$SaveModifications(modifications))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$File$File$isMeasureImage = function (file) {
	if (file.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$File$Store$mergeMeasureFile = F2(
	function (file, files) {
		return $author$project$File$File$isMeasureImage(file) ? (A2(
			$author$project$File$Files$member,
			$author$project$File$File$filename(file),
			files) ? A2(
			$author$project$File$Files$insert,
			$author$project$File$File$restored(file),
			files) : A2(
			$author$project$File$Files$insert,
			$author$project$File$File$deleted(file),
			files)) : A2($author$project$File$Files$insert, file, files);
	});
var $author$project$File$Store$mergeMeasureFiles = F2(
	function (files, remoteFiles) {
		return A3($author$project$File$Files$fold, $author$project$File$Store$mergeMeasureFile, remoteFiles, files);
	});
var $author$project$File$Store$saveRemoteMeasureFiles = F2(
	function (remoteFiles, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				var newFiles = A2($author$project$File$Store$mergeMeasureFiles, data.cT, remoteFiles);
				var newSynchronization = A2($author$project$File$Synchronization$withFiles, newFiles, data.b);
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$File$Store$Saving(
							{cT: newFiles, Q: $author$project$File$Operations$empty, V: $author$project$File$Operations$empty, b: newSynchronization}),
						$author$project$File$Store$send(
							$author$project$File$Store$SaveFiles(newFiles))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$EventStream$EventStream$MeasuresNotUpToDate = 5;
var $author$project$EventStream$EventStream$takeMeasureEvents = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(0);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(0);
		case 3:
			return $elm$core$Result$Err(0);
		default:
			var data = state.a;
			return (data.D === 1) ? $elm$core$Result$Ok(
				_Utils_Tuple2(
					data.u,
					$author$project$EventStream$EventStream$Connected(
						_Utils_update(
							data,
							{u: $author$project$Measure$Events$empty})))) : $elm$core$Result$Err(5);
	}
};
var $author$project$Measure$Service$NotFetched = 1;
var $author$project$Measure$Service$SendingCommand = {$: 2};
var $author$project$Measure$Service$takeMeasures = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(1);
		case 1:
			return $elm$core$Result$Err(1);
		case 2:
			return $elm$core$Result$Err(1);
		case 3:
			var measures = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(measures, $author$project$Measure$Service$Idle));
		default:
			var measures = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(measures, $author$project$Measure$Service$SendingCommand));
	}
};
var $author$project$Environments$Repository$withMeasureService = F2(
	function (measureService_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{bo: measureService_});
	});
var $author$project$Environments$Repository$applyMeasureEvents = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Measure$Store$hasCommands(data.R)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		if (!$author$project$Measure$Store$isReady(data.R)) {
			return _Utils_Tuple3(environment, repository, cmds);
		} else {
			var _v1 = _Utils_Tuple2(
				$author$project$EventStream$EventStream$takeMeasureEvents(data.j),
				$author$project$Measure$Service$takeMeasures(data.bo));
			_v1$2:
			while (true) {
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var _v2 = _v1.a.a;
						var events = _v2.a;
						var newEventStream = _v2.b;
						var _v3 = _v1.b.a;
						var serviceMeasures = _v3.a;
						var newMeasureService = _v3.b;
						var newMeasures = $author$project$Utils$Triple$first(
							A2($author$project$Measure$Measures$applyEvents, events, serviceMeasures));
						var measureFiles = $author$project$Measure$Measures$files(newMeasures);
						var _v4 = _Utils_Tuple2(
							A2($author$project$Measure$Store$saveMeasures, newMeasures, data.R),
							A2($author$project$File$Store$saveRemoteMeasureFiles, measureFiles, data.ad));
						if ((!_v4.a.$) && (!_v4.b.$)) {
							var _v5 = _v4.a.a;
							var newMeasureStore = _v5.a;
							var measureStoreCmd = _v5.b;
							var _v6 = _v4.b.a;
							var newFileStore = _v6.a;
							var fileStoreCmd = _v6.b;
							return _Utils_Tuple3(
								environment,
								A2(
									$author$project$Environments$Repository$withFileStore,
									newFileStore,
									A2(
										$author$project$Environments$Repository$withMeasureStore,
										newMeasureStore,
										A2(
											$author$project$Environments$Repository$withMeasureService,
											newMeasureService,
											A2($author$project$Environments$Repository$withEventStream, newEventStream, repository)))),
								A2(
									$elm$core$List$cons,
									measureStoreCmd,
									A2($elm$core$List$cons, fileStoreCmd, cmds)));
						} else {
							return _Utils_Tuple3(environment, repository, cmds);
						}
					} else {
						if (_v1.b.a === 1) {
							var _v7 = _v1.a.a;
							var events = _v7.a;
							var newEventStream = _v7.b;
							var _v8 = _v1.b.a;
							if ($author$project$Measure$Events$isEmpty(events)) {
								return _Utils_Tuple3(
									environment,
									A2($author$project$Environments$Repository$withEventStream, newEventStream, repository),
									cmds);
							} else {
								var _v9 = A2(
									$author$project$Measure$Measures$applyEvents,
									events,
									$author$project$Measure$Store$measures(data.R));
								var newMeasures = _v9.a;
								var modifications = _v9.b;
								var fileOperations = _v9.c;
								var _v10 = A2($author$project$File$Store$saveRemoteOperations, fileOperations, data.ad);
								var newFileStore = _v10.a;
								var fileStoreCmd = _v10.b;
								var _v11 = A3($author$project$Measure$Store$saveModifications, newMeasures, modifications, data.R);
								if (!_v11.$) {
									var _v12 = _v11.a;
									var newMeasureStore = _v12.a;
									var measureStoreCmd = _v12.b;
									return _Utils_Tuple3(
										environment,
										A2(
											$author$project$Environments$Repository$withFileStore,
											newFileStore,
											A2(
												$author$project$Environments$Repository$withMeasureStore,
												newMeasureStore,
												A2($author$project$Environments$Repository$withEventStream, newEventStream, repository))),
										A2(
											$elm$core$List$cons,
											measureStoreCmd,
											A2($elm$core$List$cons, fileStoreCmd, cmds)));
								} else {
									return _Utils_Tuple3(environment, repository, cmds);
								}
							}
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return _Utils_Tuple3(environment, repository, cmds);
		}
	}
};
var $author$project$Environments$Environment$CompleteSyncNeeded = 2;
var $author$project$Environments$Environment$RecalculateUserRights = 1;
var $author$project$Auth$UserRights$getRightsFromUserRights = F2(
	function (organisationUnitId, userRights) {
		switch (userRights.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				var data = userRights.a;
				return A2($author$project$Auth$UserRights$getRightSetFromMatrix, organisationUnitId, data.h4);
		}
	});
var $author$project$Environments$Environment$setRequiredEnvironmentUpdate = F2(
	function (requiredEnvironmentUpdate, state) {
		return A2(
			$author$project$Environments$Environment$map,
			function (model) {
				return _Utils_update(
					model,
					{bL: requiredEnvironmentUpdate});
			},
			state);
	});
var $author$project$OrganisationUnit$Events$toList = $author$project$Types$Queue$toList;
var $author$project$Environments$Repository$checkIfVisibilityChanges = F2(
	function (environment, events) {
		var filterEvent = F3(
			function (movedOrganisationUnit, newParentOrganisationUnit, env) {
				var rightMatrix = $author$project$Environments$Environment$userRights(environment);
				var newParentOrganisationUnitIsVisible = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (organisationUnitId) {
							return $author$project$Utils$Maybe$isJust(
								A2($author$project$Auth$UserRights$getRightsFromUserRights, organisationUnitId, rightMatrix));
						},
						newParentOrganisationUnit));
				var movedOrganisationUnitIsVisible = $author$project$Utils$Maybe$isJust(
					A2($author$project$Auth$UserRights$getRightsFromUserRights, movedOrganisationUnit, rightMatrix));
				var completeSyncIsNotTriggered = !($author$project$Environments$Environment$getRequiredEnvironmentUpdate(env) === 2);
				return (completeSyncIsNotTriggered && (movedOrganisationUnitIsVisible && newParentOrganisationUnitIsVisible)) ? env : ((completeSyncIsNotTriggered && ((!movedOrganisationUnitIsVisible) && newParentOrganisationUnitIsVisible)) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 2, env) : ((completeSyncIsNotTriggered && (movedOrganisationUnitIsVisible && (!newParentOrganisationUnitIsVisible))) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 2, env) : env));
			});
		var filterEvents = F2(
			function (event, env) {
				switch (event.$) {
					case 0:
						return (!($author$project$Environments$Environment$getRequiredEnvironmentUpdate(env) === 2)) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 1, env) : env;
					case 1:
						return (!($author$project$Environments$Environment$getRequiredEnvironmentUpdate(env) === 2)) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 1, env) : env;
					case 2:
						return (!($author$project$Environments$Environment$getRequiredEnvironmentUpdate(env) === 2)) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 1, env) : env;
					case 3:
						return (!($author$project$Environments$Environment$getRequiredEnvironmentUpdate(env) === 2)) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 1, env) : env;
					case 5:
						var payload = event.a;
						return A3(filterEvent, payload.km, payload.dZ, env);
					case 6:
						var payload = event.a;
						return A3(filterEvent, payload.km, payload.dZ, env);
					case 11:
						return (!($author$project$Environments$Environment$getRequiredEnvironmentUpdate(env) === 2)) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 2, env) : env;
					default:
						return env;
				}
			});
		return A3(
			$elm$core$List$foldl,
			filterEvents,
			environment,
			$author$project$OrganisationUnit$Events$toList(events));
	});
var $author$project$OrganisationUnit$OrganisationUnits$files = A2(
	$elm$core$Basics$composeR,
	$author$project$OrganisationUnit$OrganisationUnits$hierarchy,
	A2(
		$elm$core$Basics$composeR,
		$author$project$OrganisationUnit$Hierarchy$organisationUnits,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap(
				function (organisationUnit) {
					return A2(
						$elm$core$Maybe$map,
						$author$project$File$File$remoteOrganisationUnitFile(organisationUnit.km),
						organisationUnit.ap);
				}),
			$author$project$File$Files$fromList)));
var $author$project$OrganisationUnit$Store$commands = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$OrganisationUnit$Commands$empty;
		case 1:
			var data = state.a;
			return data.cD;
		case 2:
			var data = state.a;
			return data.cD;
		default:
			var data = state.a;
			return data.cD;
	}
};
var $author$project$OrganisationUnit$Commands$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$OrganisationUnit$Store$hasCommands = A2(
	$elm$core$Basics$composeR,
	$author$project$OrganisationUnit$Store$commands,
	A2($elm$core$Basics$composeR, $author$project$OrganisationUnit$Commands$isEmpty, $elm$core$Basics$not));
var $author$project$OrganisationUnit$Events$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$OrganisationUnit$Store$isReady = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$File$File$isOrganisationUnitFile = function (file) {
	if (file.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$File$Store$mergeOrganisationUnitFile = F2(
	function (file, files) {
		return $author$project$File$File$isOrganisationUnitFile(file) ? (A2(
			$author$project$File$Files$member,
			$author$project$File$File$filename(file),
			files) ? A2(
			$author$project$File$Files$insert,
			$author$project$File$File$restored(file),
			files) : A2(
			$author$project$File$Files$insert,
			$author$project$File$File$deleted(file),
			files)) : A2($author$project$File$Files$insert, file, files);
	});
var $author$project$File$Store$mergeOrganisationUnitFiles = F2(
	function (files, remoteFiles) {
		return A3($author$project$File$Files$fold, $author$project$File$Store$mergeOrganisationUnitFile, remoteFiles, files);
	});
var $author$project$File$Store$saveRemoteOrganisationUnitFiles = F2(
	function (remoteFiles, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				var newFiles = A2($author$project$File$Store$mergeOrganisationUnitFiles, data.cT, remoteFiles);
				var newSynchronization = A2($author$project$File$Synchronization$withFiles, newFiles, data.b);
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$File$Store$Saving(
							{cT: newFiles, Q: $author$project$File$Operations$empty, V: $author$project$File$Operations$empty, b: newSynchronization}),
						$author$project$File$Store$send(
							$author$project$File$Store$SaveFiles(newFiles))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$EventStream$EventStream$OrganisationUnitsNotUpToDate = 2;
var $author$project$EventStream$EventStream$takeOrganisationUnitEvents = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(0);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(0);
		case 3:
			return $elm$core$Result$Err(0);
		default:
			var data = state.a;
			return (data.E === 1) ? $elm$core$Result$Ok(
				_Utils_Tuple2(
					data.v,
					$author$project$EventStream$EventStream$Connected(
						_Utils_update(
							data,
							{v: $author$project$OrganisationUnit$Events$empty})))) : $elm$core$Result$Err(2);
	}
};
var $author$project$OrganisationUnit$Service$NotFetched = 1;
var $author$project$OrganisationUnit$Service$NotReady = 0;
var $author$project$OrganisationUnit$Service$SendingCommand = {$: 2};
var $author$project$OrganisationUnit$Service$takeOrganisationUnits = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(1);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(1);
		case 3:
			var organisationUnits = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(organisationUnits, $author$project$OrganisationUnit$Service$Idle));
		default:
			var organisationUnits = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(organisationUnits, $author$project$OrganisationUnit$Service$SendingCommand));
	}
};
var $author$project$Environments$Repository$withOrganisationUnitService = F2(
	function (organisationUnitService_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{br: organisationUnitService_});
	});
var $author$project$Environments$Repository$applyOrganisationUnitEvents = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$OrganisationUnit$Store$hasCommands(data.T)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		if (!$author$project$OrganisationUnit$Store$isReady(data.T)) {
			return _Utils_Tuple3(environment, repository, cmds);
		} else {
			var _v1 = _Utils_Tuple2(
				$author$project$EventStream$EventStream$takeOrganisationUnitEvents(data.j),
				$author$project$OrganisationUnit$Service$takeOrganisationUnits(data.br));
			_v1$2:
			while (true) {
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var _v2 = _v1.a.a;
						var events = _v2.a;
						var newEventStream = _v2.b;
						var _v3 = _v1.b.a;
						var serviceOrganisationUnits = _v3.a;
						var newOrganisationUnitService = _v3.b;
						var newOrganisationUnits = $author$project$Utils$Triple$first(
							A2($author$project$OrganisationUnit$OrganisationUnits$applyEvents, events, serviceOrganisationUnits));
						var checkpointEvents = $author$project$CheckpointData$Store$events(data.C);
						var updatedOrganisationUnits = A2(
							$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyEvents,
							checkpointEvents,
							_Utils_Tuple2(newOrganisationUnits, $elm$core$Maybe$Nothing)).a;
						var newOrganisationUnitFiles = $author$project$OrganisationUnit$OrganisationUnits$files(updatedOrganisationUnits);
						var _v4 = _Utils_Tuple2(
							A2($author$project$OrganisationUnit$Store$saveOrganisationUnits, updatedOrganisationUnits, data.T),
							A2($author$project$File$Store$saveRemoteOrganisationUnitFiles, newOrganisationUnitFiles, data.ad));
						if ((!_v4.a.$) && (!_v4.b.$)) {
							var _v5 = _v4.a.a;
							var newOrganisationUnitStore = _v5.a;
							var organisationUnitStoreCmd = _v5.b;
							var _v6 = _v4.b.a;
							var newFileStore = _v6.a;
							var fileStoreCmd = _v6.b;
							return _Utils_Tuple3(
								environment,
								A2(
									$author$project$Environments$Repository$withFileStore,
									newFileStore,
									A2(
										$author$project$Environments$Repository$withOrganisationUnitStore,
										newOrganisationUnitStore,
										A2(
											$author$project$Environments$Repository$withOrganisationUnitService,
											newOrganisationUnitService,
											A2($author$project$Environments$Repository$withEventStream, newEventStream, repository)))),
								A2(
									$elm$core$List$cons,
									organisationUnitStoreCmd,
									A2($elm$core$List$cons, fileStoreCmd, cmds)));
						} else {
							return _Utils_Tuple3(environment, repository, cmds);
						}
					} else {
						if (_v1.b.a === 1) {
							var _v7 = _v1.a.a;
							var events = _v7.a;
							var newEventStream = _v7.b;
							var _v8 = _v1.b.a;
							if ($author$project$OrganisationUnit$Events$isEmpty(events)) {
								return _Utils_Tuple3(
									environment,
									A2($author$project$Environments$Repository$withEventStream, newEventStream, repository),
									cmds);
							} else {
								var newEnvironment = A2($author$project$Environments$Repository$checkIfVisibilityChanges, environment, events);
								var checkpointEvents = $author$project$CheckpointData$Store$events(data.C);
								var _v9 = A2(
									$author$project$OrganisationUnit$OrganisationUnits$applyEvents,
									events,
									$author$project$OrganisationUnit$Store$organisationUnits(data.T));
								var newOrganisationUnits = _v9.a;
								var modifications = _v9.b;
								var fileOperations = _v9.c;
								var _v10 = A2($author$project$File$Store$saveRemoteOperations, fileOperations, data.ad);
								var newFileStore = _v10.a;
								var fileStoreCmd = _v10.b;
								var _v11 = A2(
									$author$project$EventCrossApplier$CheckpointDataEventApplierToOrganisationUnit$applyEvents,
									checkpointEvents,
									_Utils_Tuple2(
										newOrganisationUnits,
										$elm$core$Maybe$Just(modifications)));
								var updatedOrganisationUnits = _v11.a;
								var updatedModifications = _v11.b;
								var _v12 = A3($author$project$OrganisationUnit$Store$saveModifications, updatedOrganisationUnits, updatedModifications, data.T);
								if (!_v12.$) {
									var _v13 = _v12.a;
									var newOrganisationUnitStore = _v13.a;
									var organisationUnitStoreCmd = _v13.b;
									return _Utils_Tuple3(
										newEnvironment,
										A2(
											$author$project$Environments$Repository$withFileStore,
											newFileStore,
											A2(
												$author$project$Environments$Repository$withOrganisationUnitStore,
												newOrganisationUnitStore,
												A2($author$project$Environments$Repository$withEventStream, newEventStream, repository))),
										A2(
											$elm$core$List$cons,
											organisationUnitStoreCmd,
											A2($elm$core$List$cons, fileStoreCmd, cmds)));
								} else {
									return _Utils_Tuple3(environment, repository, cmds);
								}
							}
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return _Utils_Tuple3(environment, repository, cmds);
		}
	}
};
var $author$project$Plan$Store$commands = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Plan$Commands$empty;
		case 1:
			var data = state.a;
			return data.cD;
		case 2:
			var data = state.a;
			return data.cD;
		default:
			var data = state.a;
			return data.cD;
	}
};
var $author$project$Plan$Commands$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$Plan$Store$hasCommands = A2(
	$elm$core$Basics$composeR,
	$author$project$Plan$Store$commands,
	A2($elm$core$Basics$composeR, $author$project$Plan$Commands$isEmpty, $elm$core$Basics$not));
var $author$project$Plan$Store$isReady = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Plan$Store$SaveModifications = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$Store$saveModifications = F3(
	function (plans_, modifications, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Plan$Store$Saving(
							{cD: $author$project$Plan$Commands$empty, b8: $author$project$Plan$Events$empty, aL: plans_}),
						$author$project$Plan$Store$send(
							$author$project$Plan$Store$SaveModifications(modifications))));
			case 2:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Plan$Store$Saving(
							{cD: $author$project$Plan$Commands$empty, b8: $author$project$Plan$Events$empty, aL: plans_}),
						$author$project$Plan$Store$send(
							$author$project$Plan$Store$SaveModifications(modifications))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Plan$Store$SavePlans = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Store$savePlans = F2(
	function (plans_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Plan$Store$Saving(
							{cD: $author$project$Plan$Commands$empty, b8: $author$project$Plan$Events$empty, aL: plans_}),
						$author$project$Plan$Store$send(
							$author$project$Plan$Store$SavePlans(plans_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Plan$Store$Saving(
							_Utils_update(
								data,
								{aL: plans_})),
						$author$project$Plan$Store$send(
							$author$project$Plan$Store$SavePlans(plans_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$EventStream$EventStream$PlansNotUpToDate = 3;
var $author$project$EventStream$EventStream$takePlanEvents = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(0);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(0);
		case 3:
			return $elm$core$Result$Err(0);
		default:
			var data = state.a;
			return (data.F === 1) ? $elm$core$Result$Ok(
				_Utils_Tuple2(
					data.w,
					$author$project$EventStream$EventStream$Connected(
						_Utils_update(
							data,
							{w: $author$project$Plan$Events$empty})))) : $elm$core$Result$Err(3);
	}
};
var $author$project$Plan$Service$NotFetched = 1;
var $author$project$Plan$Service$NotReady = 0;
var $author$project$Plan$Service$SendingCommand = {$: 2};
var $author$project$Plan$Service$takePlans = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(1);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(1);
		case 3:
			var plans = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(plans, $author$project$Plan$Service$Idle));
		default:
			var plans = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(plans, $author$project$Plan$Service$SendingCommand));
	}
};
var $author$project$Environments$Repository$withPlanService = F2(
	function (planService_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{bt: planService_});
	});
var $author$project$Environments$Repository$applyPlanEvents = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Plan$Store$hasCommands(data.U)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		if (!$author$project$Plan$Store$isReady(data.U)) {
			return _Utils_Tuple3(environment, repository, cmds);
		} else {
			var _v1 = _Utils_Tuple2(
				$author$project$EventStream$EventStream$takePlanEvents(data.j),
				$author$project$Plan$Service$takePlans(data.bt));
			_v1$2:
			while (true) {
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var _v2 = _v1.a.a;
						var events = _v2.a;
						var newEventStream = _v2.b;
						var _v3 = _v1.b.a;
						var servicePlans = _v3.a;
						var newPlanService = _v3.b;
						var newPlans = A2($author$project$Plan$Plans$applyEvents, events, servicePlans).a;
						var _v4 = A2($author$project$Plan$Store$savePlans, newPlans, data.U);
						if (!_v4.$) {
							var _v5 = _v4.a;
							var newPlanStore = _v5.a;
							var planStoreCmd = _v5.b;
							return _Utils_Tuple3(
								environment,
								A2(
									$author$project$Environments$Repository$withPlanStore,
									newPlanStore,
									A2(
										$author$project$Environments$Repository$withPlanService,
										newPlanService,
										A2($author$project$Environments$Repository$withEventStream, newEventStream, repository))),
								A2($elm$core$List$cons, planStoreCmd, cmds));
						} else {
							return _Utils_Tuple3(environment, repository, cmds);
						}
					} else {
						if (_v1.b.a === 1) {
							var _v6 = _v1.a.a;
							var events = _v6.a;
							var newEventStream = _v6.b;
							var _v7 = _v1.b.a;
							if ($author$project$Plan$Events$isEmpty(events)) {
								return _Utils_Tuple3(
									environment,
									A2($author$project$Environments$Repository$withEventStream, newEventStream, repository),
									cmds);
							} else {
								var _v8 = A2(
									$author$project$Plan$Plans$applyEvents,
									events,
									$author$project$Plan$Store$plans(data.U));
								var newPlans = _v8.a;
								var modifications = _v8.b;
								var _v9 = A3($author$project$Plan$Store$saveModifications, newPlans, modifications, data.U);
								if (!_v9.$) {
									var _v10 = _v9.a;
									var newPlanStore = _v10.a;
									var planStoreCmd = _v10.b;
									return _Utils_Tuple3(
										environment,
										A2(
											$author$project$Environments$Repository$withPlanStore,
											newPlanStore,
											A2($author$project$Environments$Repository$withEventStream, newEventStream, repository)),
										A2($elm$core$List$cons, planStoreCmd, cmds));
								} else {
									return _Utils_Tuple3(environment, repository, cmds);
								}
							}
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return _Utils_Tuple3(environment, repository, cmds);
		}
	}
};
var $author$project$OrganisationUnit$Ids$union = $turboMaCk$any_set$Set$Any$union;
var $author$project$Rights$Team$Dict$get = $turboMaCk$any_dict$Dict$Any$get;
var $author$project$Rights$Rights$unwrap = function (_v0) {
	var data = _v0;
	return data;
};
var $author$project$Rights$Rights$getTeam = function (teamId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Rights$Rights$unwrap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dg;
			},
			$author$project$Rights$Team$Dict$get(teamId)));
};
var $author$project$Rights$Team$Dict$insert = A2(
	$author$project$Utils$Utils$with,
	function ($) {
		return $.k1;
	},
	$turboMaCk$any_dict$Dict$Any$insert);
var $author$project$Rights$Rights$mapTeams = F2(
	function (fn, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				dg: fn(data.dg)
			});
	});
var $author$project$Rights$Modifications$Empty = function (a) {
	return {$: 0, a: a};
};
var $author$project$Rights$Modifications$NotEmpty = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Modifications$withChangedTeam = F2(
	function (team, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$Rights$Modifications$Empty(
				_Utils_update(
					data,
					{
						bZ: A2($author$project$Rights$Team$Dict$insert, team, data.bZ)
					}));
		} else {
			var data = modifications.a;
			return $author$project$Rights$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						bZ: A2($author$project$Rights$Team$Dict$insert, team, data.bZ)
					}));
		}
	});
var $author$project$Rights$Rights$insertTeam = function (team) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Tuple$mapFirst(
			$author$project$Rights$Rights$mapTeams(
				$author$project$Rights$Team$Dict$insert(team))),
		$elm$core$Tuple$mapSecond(
			$author$project$Rights$Modifications$withChangedTeam(team)));
};
var $author$project$Rights$Rights$updateTeam = F3(
	function (teamId, fn, acc) {
		return A2(
			$elm$core$Maybe$withDefault,
			acc,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					fn,
					A2($author$project$Utils$Utils$flip, $author$project$Rights$Rights$insertTeam, acc)),
				A2($author$project$Rights$Rights$getTeam, teamId, acc.a)));
	});
var $author$project$Rights$Rights$addTeamOrganisationUnits = function (payload) {
	return A2(
		$author$project$Rights$Rights$updateTeam,
		payload.k1,
		function (team) {
			return _Utils_update(
				team,
				{
					kn: A2($author$project$OrganisationUnit$Ids$union, payload.kn, team.kn),
					i: payload.n
				});
		});
};
var $author$project$Rights$EventApplier$mapRights = F2(
	function (fn, _v0) {
		var data = _v0.a;
		var modifications = _v0.b;
		return fn(
			_Utils_Tuple2(data, modifications));
	});
var $author$project$Rights$Modifications$withLastEventId = F2(
	function (lastEventId, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$Rights$Modifications$NotEmpty(
				{bY: data.bY, bZ: data.bZ, b3: data.b3, b4: data.b4, fD: lastEventId});
		} else {
			var data = modifications.a;
			return $author$project$Rights$Modifications$NotEmpty(
				_Utils_update(
					data,
					{fD: lastEventId}));
		}
	});
var $author$project$Rights$Rights$withLastEventId = F2(
	function (lastEventId_, _v0) {
		var data = _v0.a;
		var modifications = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				data,
				{
					fD: $elm$core$Maybe$Just(lastEventId_)
				}),
			A2($author$project$Rights$Modifications$withLastEventId, lastEventId_, modifications));
	});
var $author$project$Rights$EventApplier$applyOrganisationUnitsAddedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, rights);
		if (!_v0.$) {
			var role = _v0.a;
			return (_Utils_cmp(payload.n, role.i) > 0) ? A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$addTeamOrganisationUnits(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$OrganisationUnit$Ids$diff = $turboMaCk$any_set$Set$Any$diff;
var $author$project$Rights$Rights$removeTeamOrganisationUnits = function (payload) {
	return A2(
		$author$project$Rights$Rights$updateTeam,
		payload.k1,
		function (team) {
			return _Utils_update(
				team,
				{
					kn: A2($author$project$OrganisationUnit$Ids$diff, team.kn, payload.kn)
				});
		});
};
var $author$project$Rights$EventApplier$applyOrganisationUnitsRemovedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, rights);
		if (!_v0.$) {
			var role = _v0.a;
			return (_Utils_cmp(payload.n, role.i) > 0) ? A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$removeTeamOrganisationUnits(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$Rights$Role$Dict$get = $turboMaCk$any_dict$Dict$Any$get;
var $author$project$Rights$Rights$getRole = function (roleId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Rights$Rights$unwrap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.db;
			},
			$author$project$Rights$Role$Dict$get(roleId)));
};
var $author$project$Rights$Role$Dict$insert = A2(
	$author$project$Utils$Utils$with,
	function ($) {
		return $.hc;
	},
	$turboMaCk$any_dict$Dict$Any$insert);
var $author$project$Rights$Rights$mapRoles = F2(
	function (fn, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				db: fn(data.db)
			});
	});
var $author$project$Rights$Modifications$withChangedRole = F2(
	function (role, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$Rights$Modifications$Empty(
				_Utils_update(
					data,
					{
						bY: A2($author$project$Rights$Role$Dict$insert, role, data.bY)
					}));
		} else {
			var data = modifications.a;
			return $author$project$Rights$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						bY: A2($author$project$Rights$Role$Dict$insert, role, data.bY)
					}));
		}
	});
var $author$project$Rights$Rights$insertRole = function (role) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Tuple$mapFirst(
			$author$project$Rights$Rights$mapRoles(
				$author$project$Rights$Role$Dict$insert(role))),
		$elm$core$Tuple$mapSecond(
			$author$project$Rights$Modifications$withChangedRole(role)));
};
var $author$project$Rights$Rights$updateRole = F3(
	function (roleId, fn, acc) {
		return A2(
			$elm$core$Maybe$withDefault,
			acc,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					fn,
					A2($author$project$Utils$Utils$flip, $author$project$Rights$Rights$insertRole, acc)),
				A2($author$project$Rights$Rights$getRole, roleId, acc.a)));
	});
var $author$project$Rights$Rights$addRoleRights = function (payload) {
	return A2(
		$author$project$Rights$Rights$updateRole,
		payload.hc,
		function (role) {
			return _Utils_update(
				role,
				{
					i: payload.n,
					kF: A2($elm$core$List$append, role.kF, payload.kF)
				});
		});
};
var $author$project$Rights$EventApplier$applyRightsAddedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, rights);
		if (!_v0.$) {
			var role = _v0.a;
			return (_Utils_cmp(payload.n, role.i) > 0) ? A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$addRoleRights(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$Rights$Rights$removeRoleRights = function (payload) {
	return A2(
		$author$project$Rights$Rights$updateRole,
		payload.hc,
		function (role) {
			return _Utils_update(
				role,
				{
					kF: A2(
						$elm$core$List$filter,
						function (right) {
							return !A2($elm$core$List$member, right, payload.kF);
						},
						role.kF)
				});
		});
};
var $author$project$Rights$EventApplier$applyRightsRemovedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, rights);
		if (!_v0.$) {
			var role = _v0.a;
			return (_Utils_cmp(payload.n, role.i) > 0) ? A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$removeRoleRights(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$Rights$Rights$createRole = F2(
	function (payload, acc) {
		var role = {aY: payload.aY, i: 0, kF: payload.kF, hc: payload.hc, k8: payload.k8};
		return A2($author$project$Rights$Rights$insertRole, role, acc);
	});
var $author$project$Rights$EventApplier$applyRoleCreatedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, rights);
		if (!_v0.$) {
			return acc;
		} else {
			return A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$createRole(payload),
					acc));
		}
	});
var $author$project$Rights$Role$Dict$remove = $turboMaCk$any_dict$Dict$Any$remove;
var $author$project$Rights$Role$Ids$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$Rights$Modifications$mapDeleteRoles = F2(
	function (fn, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$Rights$Modifications$Empty(
				_Utils_update(
					data,
					{
						b3: fn(data.b3)
					}));
		} else {
			var data = modifications.a;
			return $author$project$Rights$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						b3: fn(data.b3)
					}));
		}
	});
var $author$project$Rights$Modifications$withDeletedRole = A2($elm$core$Basics$composeL, $author$project$Rights$Modifications$mapDeleteRoles, $author$project$Rights$Role$Ids$insert);
var $author$project$Rights$Rights$removeRole = function (roleId) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Tuple$mapFirst(
			$author$project$Rights$Rights$mapRoles(
				$author$project$Rights$Role$Dict$remove(roleId))),
		$elm$core$Tuple$mapSecond(
			$author$project$Rights$Modifications$withDeletedRole(roleId)));
};
var $author$project$Rights$Rights$deleteRole = function (payload) {
	return $author$project$Rights$Rights$removeRole(payload.hc);
};
var $author$project$Rights$EventApplier$applyRoleDeletedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, rights);
		if (!_v0.$) {
			var role = _v0.a;
			return (_Utils_cmp(payload.n, role.i) > 0) ? A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$deleteRole(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$Rights$Rights$changeRoleDescription = function (payload) {
	return A2(
		$author$project$Rights$Rights$updateRole,
		payload.hc,
		function (role) {
			return _Utils_update(
				role,
				{aY: payload.aY, i: payload.n});
		});
};
var $author$project$Rights$EventApplier$applyRoleDescriptionChangedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, rights);
		if (!_v0.$) {
			var role = _v0.a;
			return (_Utils_cmp(payload.n, role.i) > 0) ? A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$changeRoleDescription(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$Rights$Rights$changeRoleTitle = function (payload) {
	return A2(
		$author$project$Rights$Rights$updateRole,
		payload.hc,
		function (role) {
			return _Utils_update(
				role,
				{i: payload.n, k8: payload.k8});
		});
};
var $author$project$Rights$EventApplier$applyRoleTitleChangedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, rights);
		if (!_v0.$) {
			var role = _v0.a;
			return (_Utils_cmp(payload.n, role.i) > 0) ? A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$changeRoleTitle(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$Rights$Rights$createTeam = F2(
	function (payload, acc) {
		var team = {aY: payload.aY, kn: payload.kn, i: 0, k1: payload.k1, k8: payload.k8};
		return A2($author$project$Rights$Rights$insertTeam, team, acc);
	});
var $author$project$Rights$EventApplier$applyTeamCreatedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, rights);
		if (!_v0.$) {
			return acc;
		} else {
			return A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$createTeam(payload),
					acc));
		}
	});
var $author$project$Rights$Team$Dict$remove = $turboMaCk$any_dict$Dict$Any$remove;
var $author$project$Rights$Team$Ids$insert = $turboMaCk$any_set$Set$Any$insert;
var $author$project$Rights$Modifications$mapDeletedTeams = F2(
	function (fn, modifications) {
		if (!modifications.$) {
			var data = modifications.a;
			return $author$project$Rights$Modifications$Empty(
				_Utils_update(
					data,
					{
						b4: fn(data.b4)
					}));
		} else {
			var data = modifications.a;
			return $author$project$Rights$Modifications$NotEmpty(
				_Utils_update(
					data,
					{
						b4: fn(data.b4)
					}));
		}
	});
var $author$project$Rights$Modifications$withDeletedTeam = A2($elm$core$Basics$composeL, $author$project$Rights$Modifications$mapDeletedTeams, $author$project$Rights$Team$Ids$insert);
var $author$project$Rights$Rights$removeTeam = function (teamId) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Tuple$mapFirst(
			$author$project$Rights$Rights$mapTeams(
				$author$project$Rights$Team$Dict$remove(teamId))),
		$elm$core$Tuple$mapSecond(
			$author$project$Rights$Modifications$withDeletedTeam(teamId)));
};
var $author$project$Rights$Rights$deleteTeam = function (payload) {
	return $author$project$Rights$Rights$removeTeam(payload.k1);
};
var $author$project$Rights$EventApplier$applyTeamDeletedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, rights);
		if (!_v0.$) {
			var role = _v0.a;
			return (_Utils_cmp(payload.n, role.i) > 0) ? A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$deleteTeam(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$Rights$Rights$changeTeamDescription = function (payload) {
	return A2(
		$author$project$Rights$Rights$updateTeam,
		payload.k1,
		function (team) {
			return _Utils_update(
				team,
				{aY: payload.aY, i: payload.n});
		});
};
var $author$project$Rights$EventApplier$applyTeamDescriptionChangedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, rights);
		if (!_v0.$) {
			var role = _v0.a;
			return (_Utils_cmp(payload.n, role.i) > 0) ? A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$changeTeamDescription(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$Rights$Rights$changeTeamTitle = function (payload) {
	return A2(
		$author$project$Rights$Rights$updateTeam,
		payload.k1,
		function (team) {
			return _Utils_update(
				team,
				{i: payload.n, k8: payload.k8});
		});
};
var $author$project$Rights$EventApplier$applyTeamTitleChangedEvent = F2(
	function (payload, acc) {
		var rights = acc.a;
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, rights);
		if (!_v0.$) {
			var role = _v0.a;
			return (_Utils_cmp(payload.n, role.i) > 0) ? A2(
				$author$project$Rights$Rights$withLastEventId,
				payload.N,
				A2(
					$author$project$Rights$EventApplier$mapRights,
					$author$project$Rights$Rights$changeTeamTitle(payload),
					acc)) : acc;
		} else {
			return acc;
		}
	});
var $author$project$Rights$EventApplier$applyEventHelper = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyRoleCreatedEvent(payload);
		case 1:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyRoleTitleChangedEvent(payload);
		case 2:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyRoleDescriptionChangedEvent(payload);
		case 3:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyRightsAddedEvent(payload);
		case 4:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyRightsRemovedEvent(payload);
		case 5:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyRoleDeletedEvent(payload);
		case 6:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyTeamCreatedEvent(payload);
		case 7:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyTeamTitleChangedEvent(payload);
		case 8:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyTeamDescriptionChangedEvent(payload);
		case 9:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyOrganisationUnitsAddedEvent(payload);
		case 10:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyOrganisationUnitsRemovedEvent(payload);
		default:
			var payload = event.a;
			return $author$project$Rights$EventApplier$applyTeamDeletedEvent(payload);
	}
};
var $author$project$Rights$Events$fold = $author$project$Types$Queue$fold;
var $author$project$Rights$EventApplier$applyEventsHelper = F2(
	function (events, acc) {
		return A3($author$project$Rights$Events$fold, $author$project$Rights$EventApplier$applyEventHelper, acc, events);
	});
var $author$project$Rights$Team$Ids$empty = $turboMaCk$any_set$Set$Any$empty($author$project$Rights$Team$Id$toString);
var $author$project$Rights$Modifications$empty = $author$project$Rights$Modifications$Empty(
	{bY: $author$project$Rights$Role$Dict$empty, bZ: $author$project$Rights$Team$Dict$empty, b3: $author$project$Rights$Role$Ids$empty, b4: $author$project$Rights$Team$Ids$empty, fD: $elm$core$Maybe$Nothing});
var $author$project$Rights$EventApplier$applyEvents = F2(
	function (events, rights) {
		var modifications = $author$project$Rights$Modifications$empty;
		return A2(
			$author$project$Rights$EventApplier$applyEventsHelper,
			events,
			_Utils_Tuple2(rights, modifications));
	});
var $author$project$Rights$Role$Ids$member = $turboMaCk$any_set$Set$Any$member;
var $author$project$User$TeamRoles$toList = $turboMaCk$any_set$Set$Any$toList;
var $author$project$Rights$Role$Ids$union = $turboMaCk$any_set$Set$Any$union;
var $author$project$Environments$Repository$roleBelongsToUser = F2(
	function (user, roleId) {
		return A2(
			$author$project$Rights$Role$Ids$member,
			roleId,
			A3(
				$elm$core$List$foldl,
				$author$project$Rights$Role$Ids$union,
				$author$project$Rights$Role$Ids$empty,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kH;
					},
					$author$project$User$TeamRoles$toList(user.k2))));
	});
var $author$project$Environments$Repository$teamBelongsToUser = F2(
	function (user, teamId) {
		return A2(
			$elm$core$List$member,
			teamId,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.k1;
				},
				$author$project$User$TeamRoles$toList(user.k2)));
	});
var $author$project$Rights$Events$toList = $author$project$Types$Queue$toList;
var $author$project$Environments$Repository$checkIfUserTeamOrRoleChanged = F3(
	function (environment, repository, events) {
		var filterEventsFunction = F3(
			function (user, event, env) {
				switch (event.$) {
					case 3:
						var payload = event.a;
						return (A2($author$project$Environments$Repository$roleBelongsToUser, user, payload.hc) && (!($author$project$Environments$Environment$getRequiredEnvironmentUpdate(env) === 2))) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 1, env) : env;
					case 4:
						var payload = event.a;
						return (A2($author$project$Environments$Repository$roleBelongsToUser, user, payload.hc) && (!($author$project$Environments$Environment$getRequiredEnvironmentUpdate(env) === 2))) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 1, env) : env;
					case 5:
						var payload = event.a;
						return (A2($author$project$Environments$Repository$roleBelongsToUser, user, payload.hc) && (!($author$project$Environments$Environment$getRequiredEnvironmentUpdate(env) === 2))) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 1, env) : env;
					case 9:
						var payload = event.a;
						return A2($author$project$Environments$Repository$teamBelongsToUser, user, payload.k1) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 2, env) : env;
					case 10:
						var payload = event.a;
						return A2($author$project$Environments$Repository$teamBelongsToUser, user, payload.k1) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 2, env) : env;
					case 11:
						var payload = event.a;
						return A2($author$project$Environments$Repository$teamBelongsToUser, user, payload.k1) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 2, env) : env;
					default:
						return env;
				}
			});
		return A2(
			$elm$core$Maybe$withDefault,
			environment,
			A2(
				$elm$core$Maybe$map,
				function (user) {
					return A3(
						$elm$core$List$foldl,
						filterEventsFunction(user),
						environment,
						$author$project$Rights$Events$toList(events));
				},
				A2(
					$elm$core$Maybe$andThen,
					function (userId) {
						return A2($author$project$Environments$Repository$getUser, userId, repository);
					},
					$author$project$Auth$Session$maybeUserId(
						$author$project$Environments$Environment$session(environment)))));
	});
var $author$project$Rights$Store$commands = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Rights$Commands$empty;
		case 1:
			var data = state.a;
			return data.cD;
		case 2:
			var data = state.a;
			return data.cD;
		default:
			var data = state.a;
			return data.cD;
	}
};
var $author$project$Rights$Commands$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$Rights$Store$hasCommands = A2(
	$elm$core$Basics$composeR,
	$author$project$Rights$Store$commands,
	A2($elm$core$Basics$composeR, $author$project$Rights$Commands$isEmpty, $elm$core$Basics$not));
var $author$project$Rights$Events$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$Rights$Store$isReady = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Rights$Store$rights = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Rights$Rights$empty;
		case 1:
			return $author$project$Rights$Rights$empty;
		case 2:
			var data = state.a;
			return data.kF;
		default:
			var data = state.a;
			return data.kF;
	}
};
var $author$project$Rights$Store$NotReady = 0;
var $author$project$Rights$Store$SaveModifications = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Store$Saving = function (a) {
	return {$: 3, a: a};
};
var $author$project$Rights$Store$saveModifications = F3(
	function (rights_, modifications, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Rights$Store$Saving(
							{cD: $author$project$Rights$Commands$empty, b8: $author$project$Rights$Events$empty, kF: rights_}),
						$author$project$Rights$Store$send(
							$author$project$Rights$Store$SaveModifications(modifications))));
			case 2:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Rights$Store$Saving(
							{cD: $author$project$Rights$Commands$empty, b8: $author$project$Rights$Events$empty, kF: rights_}),
						$author$project$Rights$Store$send(
							$author$project$Rights$Store$SaveModifications(modifications))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Rights$Store$SaveRights = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Store$saveRights = F2(
	function (rights_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Rights$Store$Saving(
							{cD: $author$project$Rights$Commands$empty, b8: $author$project$Rights$Events$empty, kF: rights_}),
						$author$project$Rights$Store$send(
							$author$project$Rights$Store$SaveRights(rights_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Rights$Store$Saving(
							_Utils_update(
								data,
								{kF: rights_})),
						$author$project$Rights$Store$send(
							$author$project$Rights$Store$SaveRights(rights_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Rights$Service$NotFetched = 1;
var $author$project$Rights$Service$NotReady = 0;
var $author$project$Rights$Service$SendingCommand = {$: 2};
var $author$project$Rights$Service$takeRights = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(1);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(1);
		case 3:
			var rights = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(rights, $author$project$Rights$Service$Idle));
		default:
			var rights = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(rights, $author$project$Rights$Service$SendingCommand));
	}
};
var $author$project$EventStream$EventStream$RightsNotUpToDate = 8;
var $author$project$EventStream$EventStream$takeRightsEvents = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(0);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(0);
		case 3:
			return $elm$core$Result$Err(0);
		default:
			var data = state.a;
			return (data.G === 1) ? $elm$core$Result$Ok(
				_Utils_Tuple2(
					data.x,
					$author$project$EventStream$EventStream$Connected(
						_Utils_update(
							data,
							{x: $author$project$Rights$Events$empty})))) : $elm$core$Result$Err(8);
	}
};
var $author$project$Environments$Repository$withRightsService = F2(
	function (rightsService_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{bM: rightsService_});
	});
var $author$project$Environments$Repository$withRightsStore = F2(
	function (rightsStore_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{al: rightsStore_});
	});
var $author$project$Environments$Repository$applyRightsEvents = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Rights$Store$hasCommands(data.al)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		if (!$author$project$Rights$Store$isReady(data.al)) {
			return _Utils_Tuple3(environment, repository, cmds);
		} else {
			var _v1 = _Utils_Tuple2(
				$author$project$EventStream$EventStream$takeRightsEvents(data.j),
				$author$project$Rights$Service$takeRights(data.bM));
			_v1$2:
			while (true) {
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var _v2 = _v1.a.a;
						var events = _v2.a;
						var newEventStream = _v2.b;
						var _v3 = _v1.b.a;
						var serviceRights = _v3.a;
						var newRightsService = _v3.b;
						var newRights = A2($author$project$Rights$EventApplier$applyEvents, events, serviceRights).a;
						var newEnvironment = A3($author$project$Environments$Repository$checkIfUserTeamOrRoleChanged, environment, repository, events);
						var _v4 = A2($author$project$Rights$Store$saveRights, newRights, data.al);
						if (!_v4.$) {
							var _v5 = _v4.a;
							var newRightsStore = _v5.a;
							var rightsStoreCmd = _v5.b;
							return _Utils_Tuple3(
								newEnvironment,
								A2(
									$author$project$Environments$Repository$withRightsStore,
									newRightsStore,
									A2(
										$author$project$Environments$Repository$withRightsService,
										newRightsService,
										A2($author$project$Environments$Repository$withEventStream, newEventStream, repository))),
								A2($elm$core$List$cons, rightsStoreCmd, cmds));
						} else {
							return _Utils_Tuple3(environment, repository, cmds);
						}
					} else {
						if (_v1.b.a === 1) {
							var _v6 = _v1.a.a;
							var events = _v6.a;
							var newEventStream = _v6.b;
							var _v7 = _v1.b.a;
							if ($author$project$Rights$Events$isEmpty(events)) {
								return _Utils_Tuple3(
									environment,
									A2($author$project$Environments$Repository$withEventStream, newEventStream, repository),
									cmds);
							} else {
								var rights = $author$project$Rights$Store$rights(data.al);
								var newEnvironment = A3($author$project$Environments$Repository$checkIfUserTeamOrRoleChanged, environment, repository, events);
								var _v8 = A2($author$project$Rights$EventApplier$applyEvents, events, rights);
								var newRights = _v8.a;
								var modifications = _v8.b;
								var _v9 = A3($author$project$Rights$Store$saveModifications, newRights, modifications, data.al);
								if (!_v9.$) {
									var _v10 = _v9.a;
									var newRightsStore = _v10.a;
									var rightsStoreCmd = _v10.b;
									return _Utils_Tuple3(
										newEnvironment,
										A2(
											$author$project$Environments$Repository$withRightsStore,
											newRightsStore,
											A2($author$project$Environments$Repository$withEventStream, newEventStream, repository)),
										A2($elm$core$List$cons, rightsStoreCmd, cmds));
								} else {
									return _Utils_Tuple3(environment, repository, cmds);
								}
							}
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return _Utils_Tuple3(environment, repository, cmds);
		}
	}
};
var $author$project$Tenant$Tenant$NotModified = function (a) {
	return {$: 0, a: a};
};
var $author$project$Tenant$Tenant$Changed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tenant$Tenant$tenantFromModification = function (modification) {
	if (!modification.$) {
		var maybeTenant = modification.a;
		return maybeTenant;
	} else {
		var tenant = modification.a;
		return $elm$core$Maybe$Just(tenant);
	}
};
var $author$project$Tenant$Tenant$applyCountryChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(modification);
		if (!_v0.$) {
			var tenant = _v0.a;
			if (_Utils_eq(payload.k5, tenant.k5) && (_Utils_cmp(payload.n, tenant.i) > 0)) {
				var newCountry = function () {
					var _v1 = payload.gw;
					if (!_v1.$) {
						var str = _v1.a;
						return str;
					} else {
						return '';
					}
				}();
				var newTenant = _Utils_update(
					tenant,
					{
						gw: newCountry,
						fD: $elm$core$Maybe$Just(payload.N),
						i: payload.n
					});
				return $author$project$Tenant$Tenant$Changed(newTenant);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Tenant$Tenant$applyHouseNumberChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(modification);
		if (!_v0.$) {
			var tenant = _v0.a;
			if (_Utils_eq(payload.k5, tenant.k5) && (_Utils_cmp(payload.n, tenant.i) > 0)) {
				var newHouseNumber = function () {
					var _v1 = payload.gP;
					if (!_v1.$) {
						var str = _v1.a;
						return str;
					} else {
						return '';
					}
				}();
				var newTenant = _Utils_update(
					tenant,
					{
						gP: newHouseNumber,
						fD: $elm$core$Maybe$Just(payload.N),
						i: payload.n
					});
				return $author$project$Tenant$Tenant$Changed(newTenant);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Tenant$Tenant$applyLimitationsChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(modification);
		if (!_v0.$) {
			var tenant = _v0.a;
			if (_Utils_eq(payload.k5, tenant.k5) && (_Utils_cmp(payload.n, tenant.i) > 0)) {
				var newTenant = _Utils_update(
					tenant,
					{
						fD: $elm$core$Maybe$Just(payload.N),
						jW: payload.jW,
						i: payload.n
					});
				return $author$project$Tenant$Tenant$Changed(newTenant);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Tenant$Tenant$applyLocationChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(modification);
		if (!_v0.$) {
			var tenant = _v0.a;
			if (_Utils_eq(payload.k5, tenant.k5) && (_Utils_cmp(payload.n, tenant.i) > 0)) {
				var newLocation = function () {
					var _v1 = payload.gV;
					if (!_v1.$) {
						var str = _v1.a;
						return str;
					} else {
						return '';
					}
				}();
				var newTenant = _Utils_update(
					tenant,
					{
						fD: $elm$core$Maybe$Just(payload.N),
						gV: newLocation,
						i: payload.n
					});
				return $author$project$Tenant$Tenant$Changed(newTenant);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Tenant$Tenant$applyLogoChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(modification);
		if (!_v0.$) {
			var tenant = _v0.a;
			if (_Utils_eq(payload.k5, tenant.k5) && (_Utils_cmp(payload.n, tenant.i) > 0)) {
				var newTenant = _Utils_update(
					tenant,
					{
						fD: $elm$core$Maybe$Just(payload.N),
						jX: payload.jX,
						i: payload.n
					});
				return $author$project$Tenant$Tenant$Changed(newTenant);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Tenant$Tenant$applyPhoneNumberChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(modification);
		if (!_v0.$) {
			var tenant = _v0.a;
			if (_Utils_eq(payload.k5, tenant.k5) && (_Utils_cmp(payload.n, tenant.i) > 0)) {
				var newPhoneNumber = function () {
					var _v1 = payload.g7;
					if (!_v1.$) {
						var str = _v1.a;
						return str;
					} else {
						return '';
					}
				}();
				var newTenant = _Utils_update(
					tenant,
					{
						fD: $elm$core$Maybe$Just(payload.N),
						g7: newPhoneNumber,
						i: payload.n
					});
				return $author$project$Tenant$Tenant$Changed(newTenant);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Tenant$Tenant$applyRoadChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(modification);
		if (!_v0.$) {
			var tenant = _v0.a;
			if (_Utils_eq(payload.k5, tenant.k5) && (_Utils_cmp(payload.n, tenant.i) > 0)) {
				var newRoad = function () {
					var _v1 = payload.hb;
					if (!_v1.$) {
						var str = _v1.a;
						return str;
					} else {
						return '';
					}
				}();
				var newTenant = _Utils_update(
					tenant,
					{
						fD: $elm$core$Maybe$Just(payload.N),
						i: payload.n,
						hb: newRoad
					});
				return $author$project$Tenant$Tenant$Changed(newTenant);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Tenant$Tenant$applyTenantCreatedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(modification);
		if (!_v0.$) {
			var tenant = _v0.a;
			if (_Utils_eq(payload.k5, tenant.k5) && (_Utils_cmp(payload.n, tenant.i) > 0)) {
				var newTenant = _Utils_update(
					tenant,
					{
						fD: $elm$core$Maybe$Just(payload.N),
						i: payload.n
					});
				return $author$project$Tenant$Tenant$Changed(newTenant);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Tenant$Tenant$applyUrlChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(modification);
		if (!_v0.$) {
			var tenant = _v0.a;
			if (_Utils_eq(payload.k5, tenant.k5) && (_Utils_cmp(payload.n, tenant.i) > 0)) {
				var newUrl = function () {
					var _v1 = payload.lg;
					if (!_v1.$) {
						var str = _v1.a;
						return str;
					} else {
						return '';
					}
				}();
				var newTenant = _Utils_update(
					tenant,
					{
						fD: $elm$core$Maybe$Just(payload.N),
						i: payload.n,
						lg: newUrl
					});
				return $author$project$Tenant$Tenant$Changed(newTenant);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Tenant$Tenant$applyZipCodeChangedEvent = F2(
	function (payload, modification) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(modification);
		if (!_v0.$) {
			var tenant = _v0.a;
			if (_Utils_eq(payload.k5, tenant.k5) && (_Utils_cmp(payload.n, tenant.i) > 0)) {
				var newZipCode = function () {
					var _v1 = payload.hr;
					if (!_v1.$) {
						var str = _v1.a;
						return str;
					} else {
						return '';
					}
				}();
				var newTenant = _Utils_update(
					tenant,
					{
						fD: $elm$core$Maybe$Just(payload.N),
						i: payload.n,
						hr: newZipCode
					});
				return $author$project$Tenant$Tenant$Changed(newTenant);
			} else {
				return modification;
			}
		} else {
			return modification;
		}
	});
var $author$project$Tenant$Tenant$applyEventHelper = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return $author$project$Tenant$Tenant$applyTenantCreatedEvent(payload);
		case 1:
			var payload = event.a;
			return $author$project$Tenant$Tenant$applyRoadChangedEvent(payload);
		case 2:
			var payload = event.a;
			return $author$project$Tenant$Tenant$applyHouseNumberChangedEvent(payload);
		case 3:
			var payload = event.a;
			return $author$project$Tenant$Tenant$applyZipCodeChangedEvent(payload);
		case 4:
			var payload = event.a;
			return $author$project$Tenant$Tenant$applyLocationChangedEvent(payload);
		case 5:
			var payload = event.a;
			return $author$project$Tenant$Tenant$applyCountryChangedEvent(payload);
		case 6:
			var payload = event.a;
			return $author$project$Tenant$Tenant$applyPhoneNumberChangedEvent(payload);
		case 7:
			var payload = event.a;
			return $author$project$Tenant$Tenant$applyUrlChangedEvent(payload);
		case 8:
			var payload = event.a;
			return $author$project$Tenant$Tenant$applyLogoChangedEvent(payload);
		default:
			var payload = event.a;
			return $author$project$Tenant$Tenant$applyLimitationsChangedEvent(payload);
	}
};
var $author$project$Tenant$Tenant$applyEvent = F2(
	function (event, maybeTenant) {
		return A2(
			$author$project$Tenant$Tenant$applyEventHelper,
			event,
			$author$project$Tenant$Tenant$NotModified(maybeTenant));
	});
var $author$project$Tenant$Tenant$NotEmpty = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tenant$Tenant$with = F2(
	function (modification, modifications) {
		var _v0 = _Utils_Tuple2(modification, modifications);
		if (!_v0.a.$) {
			return modifications;
		} else {
			if (!_v0.b.$) {
				var tenant = _v0.a.a;
				var _v1 = _v0.b;
				return $author$project$Tenant$Tenant$NotEmpty(
					{bh: tenant});
			} else {
				var tenant = _v0.a.a;
				var data = _v0.b.a;
				return $author$project$Tenant$Tenant$NotEmpty(
					_Utils_update(
						data,
						{bh: tenant}));
			}
		}
	});
var $author$project$Tenant$Tenant$applyModificationHelper = F2(
	function (event, _v0) {
		var tenant = _v0.a;
		var modifications = _v0.b;
		var modification = A2($author$project$Tenant$Tenant$applyEvent, event, tenant);
		if (!modification.$) {
			return _Utils_Tuple2(tenant, modifications);
		} else {
			var tenant_ = modification.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(tenant_),
				A2($author$project$Tenant$Tenant$with, modification, modifications));
		}
	});
var $author$project$Tenant$Tenant$Empty = {$: 0};
var $author$project$Tenant$Tenant$empty = $author$project$Tenant$Tenant$Empty;
var $author$project$Tenant$Events$fold = $author$project$Types$Queue$fold;
var $author$project$Tenant$Tenant$applyModification = F2(
	function (events, tenant) {
		return A3(
			$author$project$Tenant$Events$fold,
			$author$project$Tenant$Tenant$applyModificationHelper,
			_Utils_Tuple2(tenant, $author$project$Tenant$Tenant$empty),
			events);
	});
var $author$project$Tenant$Store$commands = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Tenant$Commands$empty;
		case 1:
			var data = state.a;
			return data.cD;
		case 2:
			var data = state.a;
			return data.cD;
		default:
			var data = state.a;
			return data.cD;
	}
};
var $author$project$Tenant$Commands$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$Tenant$Store$hasCommands = A2(
	$elm$core$Basics$composeR,
	$author$project$Tenant$Store$commands,
	A2($elm$core$Basics$composeR, $author$project$Tenant$Commands$isEmpty, $elm$core$Basics$not));
var $author$project$Tenant$Events$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$Tenant$Store$isReady = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Tenant$Store$NotReady = 0;
var $author$project$Tenant$Store$SaveModifications = function (a) {
	return {$: 2, a: a};
};
var $author$project$Tenant$Store$Saving = function (a) {
	return {$: 3, a: a};
};
var $author$project$Tenant$Store$saveModifications = F3(
	function (maybeTenant, modifications, state) {
		var _v0 = _Utils_Tuple2(state, maybeTenant);
		_v0$2:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 1:
						var newTenant = _v0.b.a;
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$author$project$Tenant$Store$Saving(
									{
										cD: $author$project$Tenant$Commands$empty,
										b8: $author$project$Tenant$Events$empty,
										iC: $elm$core$Maybe$Just(newTenant)
									}),
								$author$project$Tenant$Store$send(
									$author$project$Tenant$Store$SaveModifications(modifications))));
					case 2:
						var data = _v0.a.a;
						var newTenant = _v0.b.a;
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$author$project$Tenant$Store$Saving(
									{
										cD: $author$project$Tenant$Commands$empty,
										b8: $author$project$Tenant$Events$empty,
										iC: $elm$core$Maybe$Just(newTenant)
									}),
								$author$project$Tenant$Store$send(
									$author$project$Tenant$Store$SaveModifications(modifications))));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Result$Err(0);
	});
var $author$project$Tenant$Store$SaveTenant = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tenant$Store$saveTenant = F2(
	function (maybeTenant, state) {
		var _v0 = _Utils_Tuple2(state, maybeTenant);
		_v0$2:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 1:
						var newTenant = _v0.b.a;
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$author$project$Tenant$Store$Saving(
									{
										cD: $author$project$Tenant$Commands$empty,
										b8: $author$project$Tenant$Events$empty,
										iC: $elm$core$Maybe$Just(newTenant)
									}),
								$author$project$Tenant$Store$send(
									$author$project$Tenant$Store$SaveTenant(newTenant))));
					case 2:
						var data = _v0.a.a;
						var newTenant = _v0.b.a;
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$author$project$Tenant$Store$Saving(
									_Utils_update(
										data,
										{
											cD: $author$project$Tenant$Commands$empty,
											b8: $author$project$Tenant$Events$empty,
											iC: $elm$core$Maybe$Just(newTenant)
										})),
								$author$project$Tenant$Store$send(
									$author$project$Tenant$Store$SaveTenant(newTenant))));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Result$Err(0);
	});
var $author$project$Tenant$Service$NotFetched = 1;
var $author$project$Tenant$Service$NotReady = 0;
var $author$project$Tenant$Service$SendingCommand = {$: 2};
var $author$project$Tenant$Service$takeTenant = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(1);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(1);
		case 3:
			var tenant = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(tenant, $author$project$Tenant$Service$Idle));
		default:
			var tenant = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(tenant, $author$project$Tenant$Service$SendingCommand));
	}
};
var $author$project$EventStream$EventStream$TenantNotUpToDate = 6;
var $author$project$EventStream$EventStream$takeTenantEvents = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(0);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(0);
		case 3:
			return $elm$core$Result$Err(0);
		default:
			var data = state.a;
			return (data.H === 1) ? $elm$core$Result$Ok(
				_Utils_Tuple2(
					data.y,
					$author$project$EventStream$EventStream$Connected(
						_Utils_update(
							data,
							{y: $author$project$Tenant$Events$empty})))) : $elm$core$Result$Err(6);
	}
};
var $author$project$Tenant$Store$tenant = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			var data = state.a;
			return data.iC;
		default:
			var data = state.a;
			return data.iC;
	}
};
var $author$project$Environments$Repository$withTenantService = F2(
	function (tenantService_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{bz: tenantService_});
	});
var $author$project$Environments$Repository$withTenantStore = F2(
	function (tenantStore_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{ag: tenantStore_});
	});
var $author$project$Environments$Repository$applyTenantEvents = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Tenant$Store$hasCommands(data.ag)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		if (!$author$project$Tenant$Store$isReady(data.ag)) {
			return _Utils_Tuple3(environment, repository, cmds);
		} else {
			var _v1 = _Utils_Tuple2(
				$author$project$EventStream$EventStream$takeTenantEvents(data.j),
				$author$project$Tenant$Service$takeTenant(data.bz));
			_v1$2:
			while (true) {
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var _v2 = _v1.a.a;
						var events = _v2.a;
						var newEventStream = _v2.b;
						var _v3 = _v1.b.a;
						var serviceTenant = _v3.a;
						var newTenantService = _v3.b;
						var newTenant = A2(
							$author$project$Tenant$Tenant$applyModification,
							events,
							$elm$core$Maybe$Just(serviceTenant)).a;
						var _v4 = A2($author$project$Tenant$Store$saveTenant, newTenant, data.ag);
						if (!_v4.$) {
							var _v5 = _v4.a;
							var newTenantStore = _v5.a;
							var tenantStoreCmd = _v5.b;
							return _Utils_Tuple3(
								environment,
								A2(
									$author$project$Environments$Repository$withTenantStore,
									newTenantStore,
									A2(
										$author$project$Environments$Repository$withTenantService,
										newTenantService,
										A2($author$project$Environments$Repository$withEventStream, newEventStream, repository))),
								A2($elm$core$List$cons, tenantStoreCmd, cmds));
						} else {
							return _Utils_Tuple3(environment, repository, cmds);
						}
					} else {
						if (_v1.b.a === 1) {
							var _v6 = _v1.a.a;
							var events = _v6.a;
							var newEventStream = _v6.b;
							var _v7 = _v1.b.a;
							if ($author$project$Tenant$Events$isEmpty(events)) {
								return _Utils_Tuple3(
									environment,
									A2($author$project$Environments$Repository$withEventStream, newEventStream, repository),
									cmds);
							} else {
								var _v8 = A2(
									$author$project$Tenant$Tenant$applyModification,
									events,
									$author$project$Tenant$Store$tenant(data.ag));
								var newTenant = _v8.a;
								var modifications = _v8.b;
								var _v9 = A3($author$project$Tenant$Store$saveModifications, newTenant, modifications, data.ag);
								if (!_v9.$) {
									var _v10 = _v9.a;
									var newTenantStore = _v10.a;
									var tenantStoreCmd = _v10.b;
									return _Utils_Tuple3(
										environment,
										A2(
											$author$project$Environments$Repository$withTenantStore,
											newTenantStore,
											A2($author$project$Environments$Repository$withEventStream, newEventStream, repository)),
										A2($elm$core$List$cons, tenantStoreCmd, cmds));
								} else {
									return _Utils_Tuple3(environment, repository, cmds);
								}
							}
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return _Utils_Tuple3(environment, repository, cmds);
		}
	}
};
var $author$project$User$Events$toList = $author$project$Types$Queue$toList;
var $author$project$Environments$Repository$checkIfUserTeamRolesChanged = F3(
	function (environment, repository, events) {
		var filterEventsFunction = F3(
			function (user, event, env) {
				switch (event.$) {
					case 4:
						var payload = event.a;
						return _Utils_eq(user.dk, payload.dk) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 2, env) : env;
					case 5:
						var payload = event.a;
						return _Utils_eq(user.dk, payload.dk) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 1, env) : env;
					case 6:
						var payload = event.a;
						return _Utils_eq(user.dk, payload.dk) ? A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 2, env) : env;
					default:
						return env;
				}
			});
		return A2(
			$elm$core$Maybe$withDefault,
			environment,
			A2(
				$elm$core$Maybe$map,
				function (user) {
					return A3(
						$elm$core$List$foldl,
						filterEventsFunction(user),
						environment,
						$author$project$User$Events$toList(events));
				},
				A2(
					$elm$core$Maybe$andThen,
					function (userId) {
						return A2($author$project$Environments$Repository$getUser, userId, repository);
					},
					$author$project$Auth$Session$maybeUserId(
						$author$project$Environments$Environment$session(environment)))));
	});
var $author$project$User$Users$values = A2($elm$core$Basics$composeR, $author$project$User$Users$dict, $author$project$User$Dict$values);
var $author$project$User$Users$files = A2(
	$elm$core$Basics$composeR,
	$author$project$User$Users$values,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filterMap(
			function (user) {
				return A2(
					$elm$core$Maybe$map,
					$author$project$File$File$remoteUserAvatar(user.dk),
					user.iX);
			}),
		$author$project$File$Files$fromList));
var $author$project$User$Store$commands = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$User$Commands$empty;
		case 1:
			var data = state.a;
			return data.cD;
		case 2:
			var data = state.a;
			return data.cD;
		default:
			var data = state.a;
			return data.cD;
	}
};
var $author$project$User$Commands$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$User$Store$hasCommands = A2(
	$elm$core$Basics$composeR,
	$author$project$User$Store$commands,
	A2($elm$core$Basics$composeR, $author$project$User$Commands$isEmpty, $elm$core$Basics$not));
var $author$project$User$Events$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$User$Store$isReady = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$User$Store$NotReady = 0;
var $author$project$User$Store$SaveModifications = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$Store$Saving = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$Store$saveModifications = F3(
	function (newUsers, modifications, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$User$Store$Saving(
							{cD: $author$project$User$Commands$empty, b8: $author$project$User$Events$empty, lk: newUsers}),
						$author$project$User$Store$send(
							$author$project$User$Store$SaveModifications(modifications))));
			case 2:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$User$Store$Saving(
							{cD: $author$project$User$Commands$empty, b8: $author$project$User$Events$empty, lk: newUsers}),
						$author$project$User$Store$send(
							$author$project$User$Store$SaveModifications(modifications))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$File$File$isUserAvatar = function (file) {
	if (!file.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$File$Store$mergeUserFile = F2(
	function (file, files) {
		return $author$project$File$File$isUserAvatar(file) ? (A2(
			$author$project$File$Files$member,
			$author$project$File$File$filename(file),
			files) ? A2(
			$author$project$File$Files$insert,
			$author$project$File$File$restored(file),
			files) : A2(
			$author$project$File$Files$insert,
			$author$project$File$File$deleted(file),
			files)) : A2($author$project$File$Files$insert, file, files);
	});
var $author$project$File$Store$mergeRemoteUserFiles = F2(
	function (files, remoteUserFiles) {
		return A3($author$project$File$Files$fold, $author$project$File$Store$mergeUserFile, remoteUserFiles, files);
	});
var $author$project$File$Store$saveRemoteUserFiles = F2(
	function (remoteFiles, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				var newFiles = A2($author$project$File$Store$mergeRemoteUserFiles, data.cT, remoteFiles);
				var newSynchronization = A2($author$project$File$Synchronization$withFiles, newFiles, data.b);
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$File$Store$Saving(
							{cT: newFiles, Q: $author$project$File$Operations$empty, V: $author$project$File$Operations$empty, b: newSynchronization}),
						$author$project$File$Store$send(
							$author$project$File$Store$SaveFiles(newFiles))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$User$Store$SaveUsers = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$Store$saveUsers = F2(
	function (newUsers, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$User$Store$Saving(
							{cD: $author$project$User$Commands$empty, b8: $author$project$User$Events$empty, lk: newUsers}),
						$author$project$User$Store$send(
							$author$project$User$Store$SaveUsers(newUsers))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$User$Store$Saving(
							_Utils_update(
								data,
								{cD: $author$project$User$Commands$empty, b8: $author$project$User$Events$empty, lk: newUsers})),
						$author$project$User$Store$send(
							$author$project$User$Store$SaveUsers(newUsers))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$EventStream$EventStream$UsersNotUpToDate = 1;
var $author$project$EventStream$EventStream$takeUserEvents = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(0);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(0);
		case 3:
			return $elm$core$Result$Err(0);
		default:
			var data = state.a;
			return (data.I === 1) ? $elm$core$Result$Ok(
				_Utils_Tuple2(
					data.z,
					$author$project$EventStream$EventStream$Connected(
						_Utils_update(
							data,
							{z: $author$project$User$Events$empty})))) : $elm$core$Result$Err(1);
	}
};
var $author$project$User$Service$NotFetched = 1;
var $author$project$User$Service$NotReady = 0;
var $author$project$User$Service$SendingCommand = {$: 2};
var $author$project$User$Service$takeUsers = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Result$Err(1);
		case 1:
			return $elm$core$Result$Err(0);
		case 2:
			return $elm$core$Result$Err(1);
		case 3:
			var users = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(users, $author$project$User$Service$Idle));
		default:
			var users = state.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(users, $author$project$User$Service$SendingCommand));
	}
};
var $author$project$Environments$Repository$withUserService = F2(
	function (userService_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{bA: userService_});
	});
var $author$project$Environments$Repository$withUserStore = F2(
	function (userStore_, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{ah: userStore_});
	});
var $author$project$Environments$Repository$applyUserEvents = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$User$Store$hasCommands(data.ah)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		if (!$author$project$User$Store$isReady(data.ah)) {
			return _Utils_Tuple3(environment, repository, cmds);
		} else {
			var _v1 = _Utils_Tuple2(
				$author$project$EventStream$EventStream$takeUserEvents(data.j),
				$author$project$User$Service$takeUsers(data.bA));
			_v1$2:
			while (true) {
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var _v2 = _v1.a.a;
						var events = _v2.a;
						var newEventStream = _v2.b;
						var _v3 = _v1.b.a;
						var serviceUsers = _v3.a;
						var newUserService = _v3.b;
						var newUsers = $author$project$Utils$Triple$first(
							A2($author$project$User$Users$applyEvents, events, serviceUsers));
						var userFiles = $author$project$User$Users$files(newUsers);
						var newEnvironment = A3($author$project$Environments$Repository$checkIfUserTeamRolesChanged, environment, repository, events);
						var _v4 = _Utils_Tuple2(
							A2($author$project$User$Store$saveUsers, newUsers, data.ah),
							A2($author$project$File$Store$saveRemoteUserFiles, userFiles, data.ad));
						if ((!_v4.a.$) && (!_v4.b.$)) {
							var _v5 = _v4.a.a;
							var newUserStore = _v5.a;
							var userStoreCmd = _v5.b;
							var _v6 = _v4.b.a;
							var newFileStore = _v6.a;
							var fileStoreCmd = _v6.b;
							return _Utils_Tuple3(
								newEnvironment,
								A2(
									$author$project$Environments$Repository$withFileStore,
									newFileStore,
									A2(
										$author$project$Environments$Repository$withUserStore,
										newUserStore,
										A2(
											$author$project$Environments$Repository$withUserService,
											newUserService,
											A2($author$project$Environments$Repository$withEventStream, newEventStream, repository)))),
								A2(
									$elm$core$List$cons,
									userStoreCmd,
									A2($elm$core$List$cons, fileStoreCmd, cmds)));
						} else {
							return _Utils_Tuple3(environment, repository, cmds);
						}
					} else {
						if (_v1.b.a === 1) {
							var _v7 = _v1.a.a;
							var events = _v7.a;
							var newEventStream = _v7.b;
							var _v8 = _v1.b.a;
							if ($author$project$User$Events$isEmpty(events)) {
								return _Utils_Tuple3(
									environment,
									A2($author$project$Environments$Repository$withEventStream, newEventStream, repository),
									cmds);
							} else {
								var newEnvironment = A3($author$project$Environments$Repository$checkIfUserTeamRolesChanged, environment, repository, events);
								var _v9 = A2(
									$author$project$User$Users$applyEvents,
									events,
									$author$project$User$Store$users(data.ah));
								var newUsers = _v9.a;
								var userModifications = _v9.b;
								var fileOperations = _v9.c;
								var _v10 = A2($author$project$File$Store$saveRemoteOperations, fileOperations, data.ad);
								var newFileStore = _v10.a;
								var fileStoreCmd = _v10.b;
								var _v11 = A3($author$project$User$Store$saveModifications, newUsers, userModifications, data.ah);
								if (!_v11.$) {
									var _v12 = _v11.a;
									var newUserStore = _v12.a;
									var userStoreCmd = _v12.b;
									return _Utils_Tuple3(
										newEnvironment,
										A2(
											$author$project$Environments$Repository$withFileStore,
											newFileStore,
											A2(
												$author$project$Environments$Repository$withUserStore,
												newUserStore,
												A2($author$project$Environments$Repository$withEventStream, newEventStream, repository))),
										A2(
											$elm$core$List$cons,
											userStoreCmd,
											A2($elm$core$List$cons, fileStoreCmd, cmds)));
								} else {
									return _Utils_Tuple3(environment, repository, cmds);
								}
							}
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return _Utils_Tuple3(environment, repository, cmds);
		}
	}
};
var $author$project$Environments$Environment$CompleteSyncStarted = 3;
var $author$project$EventStream$EventStream$Connect = function (a) {
	return {$: 0, a: a};
};
var $author$project$EventStream$EventStream$Connecting = {$: 2};
var $author$project$EventStream$EventStream$encodeConnectParameters = function (parameters) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, parameters.lj)),
				_Utils_Tuple2(
				'organisationUnitEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, parameters.kl)),
				_Utils_Tuple2(
				'planEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, parameters.kq)),
				_Utils_Tuple2(
				'auditEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, parameters.iU)),
				_Utils_Tuple2(
				'measureEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, parameters.j4)),
				_Utils_Tuple2(
				'tenantEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, parameters.k4)),
				_Utils_Tuple2(
				'checkpointDataEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, parameters.i4)),
				_Utils_Tuple2(
				'rightEventId',
				A2($author$project$Utils$Encode$maybe, $author$project$Types$EventId$encode, parameters.kB))
			]));
};
var $author$project$EventStream$EventStream$encodeOutMsg = function (outMsg) {
	if (!outMsg.$) {
		var parameters = outMsg.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('CONNECT')),
					_Utils_Tuple2(
					'parameters',
					$author$project$EventStream$EventStream$encodeConnectParameters(parameters))
				]));
	} else {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('DISCONNECT'))
				]));
	}
};
var $author$project$EventStream$EventStream$eventStreamOutbox = _Platform_outgoingPort('eventStreamOutbox', $elm$core$Basics$identity);
var $author$project$EventStream$EventStream$connect = function (parameters) {
	return _Utils_Tuple2(
		$author$project$EventStream$EventStream$Connecting,
		$author$project$EventStream$EventStream$eventStreamOutbox(
			$author$project$EventStream$EventStream$encodeOutMsg(
				$author$project$EventStream$EventStream$Connect(parameters))));
};
var $author$project$Audit$Service$lastEventId = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 3:
			var audits = state.a;
			return $author$project$Audit$Audits$lastEventId(audits);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			var audits = state.a;
			return $author$project$Audit$Audits$lastEventId(audits);
	}
};
var $author$project$Audit$Store$lastEventId = A2($elm$core$Basics$composeR, $author$project$Audit$Store$audits, $author$project$Audit$Audits$lastEventId);
var $author$project$CheckpointData$CheckpointData$lastEventId = A2(
	$elm$core$Basics$composeR,
	$author$project$CheckpointData$CheckpointData$unwrap,
	function ($) {
		return $.fD;
	});
var $author$project$CheckpointData$Service$lastEventId = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 3:
			var checkpointGroups = state.a;
			return $author$project$CheckpointData$CheckpointData$lastEventId(checkpointGroups);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			var checkpointData = state.a;
			return $author$project$CheckpointData$CheckpointData$lastEventId(checkpointData);
	}
};
var $author$project$CheckpointData$Store$lastEventId = A2($elm$core$Basics$composeR, $author$project$CheckpointData$Store$checkpointData, $author$project$CheckpointData$CheckpointData$lastEventId);
var $author$project$Measure$Service$lastEventId = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			var measures = state.a;
			return $author$project$Measure$Measures$lastEventId(measures);
		default:
			var measures = state.a;
			return $author$project$Measure$Measures$lastEventId(measures);
	}
};
var $author$project$Measure$Store$lastEventId = A2($elm$core$Basics$composeR, $author$project$Measure$Store$measures, $author$project$Measure$Measures$lastEventId);
var $author$project$OrganisationUnit$Service$lastEventId = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 3:
			var organisationUnits = state.a;
			return $author$project$OrganisationUnit$OrganisationUnits$lastEventId(organisationUnits);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			var organisationUnits = state.a;
			return $author$project$OrganisationUnit$OrganisationUnits$lastEventId(organisationUnits);
	}
};
var $author$project$OrganisationUnit$Store$lastEventId = A2($elm$core$Basics$composeR, $author$project$OrganisationUnit$Store$organisationUnits, $author$project$OrganisationUnit$OrganisationUnits$lastEventId);
var $author$project$Plan$Service$lastEventId = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			var plans = state.a;
			return $author$project$Plan$Plans$lastEventId(plans);
		default:
			var plans = state.a;
			return $author$project$Plan$Plans$lastEventId(plans);
	}
};
var $author$project$Plan$Store$lastEventId = A2($elm$core$Basics$composeR, $author$project$Plan$Store$plans, $author$project$Plan$Plans$lastEventId);
var $author$project$Rights$Rights$lastEventId = A2(
	$elm$core$Basics$composeR,
	$author$project$Rights$Rights$unwrap,
	function ($) {
		return $.fD;
	});
var $author$project$Rights$Service$lastEventId = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 3:
			var rights = state.a;
			return $author$project$Rights$Rights$lastEventId(rights);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			var rights = state.a;
			return $author$project$Rights$Rights$lastEventId(rights);
	}
};
var $author$project$Rights$Store$lastEventId = A2($elm$core$Basics$composeR, $author$project$Rights$Store$rights, $author$project$Rights$Rights$lastEventId);
var $author$project$Tenant$Service$lastEventId = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			var tenant = state.a;
			return tenant.fD;
		default:
			var tenant = state.a;
			return tenant.fD;
	}
};
var $author$project$Tenant$Tenant$lastEventId = function ($) {
	return $.fD;
};
var $author$project$Tenant$Store$lastEventId = A2(
	$elm$core$Basics$composeR,
	$author$project$Tenant$Store$tenant,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map($author$project$Tenant$Tenant$lastEventId),
		$elm$core$Maybe$withDefault($elm$core$Maybe$Nothing)));
var $author$project$User$Service$lastEventId = function (state) {
	switch (state.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			var users = state.a;
			return $author$project$User$Users$lastEventId(users);
		default:
			var users = state.a;
			return $author$project$User$Users$lastEventId(users);
	}
};
var $author$project$User$Store$lastEventId = A2($elm$core$Basics$composeR, $author$project$User$Store$users, $author$project$User$Users$lastEventId);
var $author$project$Utils$Maybe$orElse = F2(
	function (a, b) {
		if (b.$ === 1) {
			return a;
		} else {
			return b;
		}
	});
var $author$project$Environments$Repository$eventStreamConnectParameters = function (_v0) {
	var data = _v0;
	var userEventId = A2(
		$author$project$Utils$Maybe$orElse,
		$author$project$User$Store$lastEventId(data.ah),
		$author$project$User$Service$lastEventId(data.bA));
	var tenantEventId = A2(
		$author$project$Utils$Maybe$orElse,
		$author$project$Tenant$Store$lastEventId(data.ag),
		$author$project$Tenant$Service$lastEventId(data.bz));
	var rightEventId = A2(
		$author$project$Utils$Maybe$orElse,
		$author$project$Rights$Store$lastEventId(data.al),
		$author$project$Rights$Service$lastEventId(data.bM));
	var planEventId = A2(
		$author$project$Utils$Maybe$orElse,
		$author$project$Plan$Store$lastEventId(data.U),
		$author$project$Plan$Service$lastEventId(data.bt));
	var organisationUnitEventId = A2(
		$author$project$Utils$Maybe$orElse,
		$author$project$OrganisationUnit$Store$lastEventId(data.T),
		$author$project$OrganisationUnit$Service$lastEventId(data.br));
	var measureEventId = A2(
		$author$project$Utils$Maybe$orElse,
		$author$project$Measure$Store$lastEventId(data.R),
		$author$project$Measure$Service$lastEventId(data.bo));
	var checkpointDataEventId = A2(
		$author$project$Utils$Maybe$orElse,
		$author$project$CheckpointData$Store$lastEventId(data.C),
		$author$project$CheckpointData$Service$lastEventId(data.bj));
	var auditEventId = A2(
		$author$project$Utils$Maybe$orElse,
		$author$project$Audit$Store$lastEventId(data.aa),
		$author$project$Audit$Service$lastEventId(data.bg));
	return {iU: auditEventId, i4: checkpointDataEventId, j4: measureEventId, kl: organisationUnitEventId, kq: planEventId, kB: rightEventId, k4: tenantEventId, lj: userEventId};
};
var $author$project$Environments$App$isActive = $elm$core$Basics$eq(0);
var $author$project$Environments$Environment$isActive = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.dn;
		},
		$author$project$Environments$App$isActive));
var $author$project$EventStream$EventStream$isDisconnected = $elm$core$Basics$eq($author$project$EventStream$EventStream$Disconnected);
var $author$project$Audit$Store$isLoaded = $elm$core$Basics$neq($author$project$Audit$Store$Loading);
var $author$project$CheckpointData$Store$isLoaded = $elm$core$Basics$neq($author$project$CheckpointData$Store$Loading);
var $author$project$Measure$Store$isLoaded = $elm$core$Basics$neq($author$project$Measure$Store$Loading);
var $author$project$OrganisationUnit$Store$isLoaded = $elm$core$Basics$neq($author$project$OrganisationUnit$Store$Loading);
var $author$project$Plan$Store$isLoaded = $elm$core$Basics$neq($author$project$Plan$Store$Loading);
var $author$project$Tenant$Store$isLoaded = $elm$core$Basics$neq($author$project$Tenant$Store$Loading);
var $author$project$User$Store$isLoaded = $elm$core$Basics$neq($author$project$User$Store$Loading);
var $author$project$Audit$Service$Fetching = {$: 1};
var $author$project$Audit$Service$isNotFetching = $elm$core$Basics$neq($author$project$Audit$Service$Fetching);
var $author$project$CheckpointData$Service$Fetching = {$: 1};
var $author$project$CheckpointData$Service$isNotFetching = $elm$core$Basics$neq($author$project$CheckpointData$Service$Fetching);
var $author$project$Measure$Service$Fetching = {$: 1};
var $author$project$Measure$Service$isNotFetching = $elm$core$Basics$neq($author$project$Measure$Service$Fetching);
var $author$project$OrganisationUnit$Service$Fetching = {$: 1};
var $author$project$OrganisationUnit$Service$isNotFetching = $elm$core$Basics$neq($author$project$OrganisationUnit$Service$Fetching);
var $author$project$Plan$Service$Fetching = {$: 1};
var $author$project$Plan$Service$isNotFetching = $elm$core$Basics$neq($author$project$Plan$Service$Fetching);
var $author$project$Tenant$Service$isNotFetching = function (state) {
	switch (state.$) {
		case 0:
			return true;
		case 1:
			return false;
		case 2:
			return true;
		case 3:
			return true;
		default:
			return true;
	}
};
var $author$project$User$Service$isNotFetching = function (state) {
	switch (state.$) {
		case 0:
			return true;
		case 1:
			return false;
		case 2:
			return true;
		case 3:
			return true;
		default:
			return true;
	}
};
var $author$project$Auth$Session$Unauthorized = {$: 3};
var $author$project$Auth$Session$isUnauthorized = $elm$core$Basics$eq($author$project$Auth$Session$Unauthorized);
var $author$project$Auth$Session$isUnknown = $elm$core$Basics$eq($author$project$Auth$Session$Unknown);
var $author$project$Environments$Repository$connectToEventStream = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isActive(environment) && ($author$project$Environments$Environment$isOnline(environment) && ((!$author$project$Auth$Session$isUnauthorized(
		$author$project$Environments$Environment$session(environment))) && ((!$author$project$Auth$Session$isUnknown(
		$author$project$Environments$Environment$session(environment))) && (($author$project$Environments$Environment$getRequiredEnvironmentUpdate(environment) !== 3) && ($author$project$EventStream$EventStream$isDisconnected(data.j) && ($author$project$User$Store$isLoaded(data.ah) && ($author$project$User$Service$isNotFetching(data.bA) && ($author$project$OrganisationUnit$Store$isLoaded(data.T) && ($author$project$OrganisationUnit$Service$isNotFetching(data.br) && ($author$project$Plan$Store$isLoaded(data.U) && ($author$project$Plan$Service$isNotFetching(data.bt) && ($author$project$Audit$Store$isLoaded(data.aa) && ($author$project$Audit$Service$isNotFetching(data.bg) && ($author$project$Measure$Store$isLoaded(data.R) && ($author$project$Measure$Service$isNotFetching(data.bo) && ($author$project$Tenant$Store$isLoaded(data.ag) && ($author$project$Tenant$Service$isNotFetching(data.bz) && ($author$project$CheckpointData$Store$isLoaded(data.C) && $author$project$CheckpointData$Service$isNotFetching(data.bj)))))))))))))))))))) {
		var _v1 = A2(
			$elm$core$Tuple$mapSecond,
			A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds),
			A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Environments$Repository$setEventStream(repository),
				$author$project$EventStream$EventStream$connect(
					$author$project$Environments$Repository$eventStreamConnectParameters(repository))));
		var newRepository = _v1.a;
		var cmdMsg = _v1.b;
		return _Utils_Tuple3(environment, newRepository, cmdMsg);
	} else {
		return _Utils_Tuple3(environment, repository, cmds);
	}
};
var $author$project$EventStream$EventStream$Disconnect = {$: 1};
var $author$project$EventStream$EventStream$disconnect = function (state) {
	switch (state.$) {
		case 0:
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		case 1:
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		default:
			return _Utils_Tuple2(
				$author$project$EventStream$EventStream$Disconnected,
				$author$project$EventStream$EventStream$eventStreamOutbox(
					$author$project$EventStream$EventStream$encodeOutMsg($author$project$EventStream$EventStream$Disconnect)));
	}
};
var $author$project$EventStream$EventStream$Error = {$: 1};
var $author$project$EventStream$EventStream$isError = $elm$core$Basics$eq($author$project$EventStream$EventStream$Error);
var $author$project$Environments$Environment$isInactive = A2($elm$core$Basics$composeR, $author$project$Environments$Environment$isActive, $elm$core$Basics$not);
var $author$project$Environments$Repository$disconnectFromEventStream = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isInactive(environment) || $author$project$EventStream$EventStream$isError(data.j)) {
		var _v1 = A2(
			$elm$core$Tuple$mapSecond,
			A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds),
			A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Environments$Repository$setEventStream(repository),
				$author$project$EventStream$EventStream$disconnect(
					$author$project$Environments$Repository$eventStream(repository))));
		var newRepository = _v1.a;
		var cmdMsg = _v1.b;
		return _Utils_Tuple3(environment, newRepository, cmdMsg);
	} else {
		if ($author$project$Environments$Environment$isOnline(environment) || $author$project$EventStream$EventStream$isDisconnected(data.j)) {
			return _Utils_Tuple3(environment, repository, cmds);
		} else {
			var _v2 = A2(
				$elm$core$Tuple$mapSecond,
				A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds),
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$Repository$setEventStream(repository),
					$author$project$EventStream$EventStream$disconnect(
						$author$project$Environments$Repository$eventStream(repository))));
			var newRepository = _v2.a;
			var cmdMsg = _v2.b;
			return _Utils_Tuple3(environment, newRepository, cmdMsg);
		}
	}
};
var $author$project$EventStream$EventStream$auditsOutOfDate = function (status) {
	switch (status.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		default:
			var data = status.a;
			return data.A === 2;
	}
};
var $author$project$Audit$Service$AlreadyFetched = 2;
var $author$project$Utils$Http$GetAudits = 6;
var $author$project$Audit$Service$NotReady = 0;
var $author$project$Auth$Session$UserCredentials = F2(
	function (tenantId, userId) {
		return {k5: tenantId, dk: userId};
	});
var $author$project$Auth$Session$userCredentials = function (session) {
	switch (session.$) {
		case 1:
			var tenantId = session.a;
			var userId = session.b;
			return $elm$core$Maybe$Just(
				A2($author$project$Auth$Session$UserCredentials, tenantId, userId));
		case 2:
			var tenantId = session.a;
			var userID = session.b;
			return $elm$core$Maybe$Just(
				A2($author$project$Auth$Session$UserCredentials, tenantId, userID));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Audit$Service$fetch = F3(
	function (environment, toMsg, state) {
		switch (state.$) {
			case 0:
				var cmdMsg = function () {
					var _v1 = $author$project$Auth$Session$userCredentials(
						$author$project$Environments$Environment$session(environment));
					if (!_v1.$) {
						return A3(
							$author$project$Utils$Http$sendGet,
							$author$project$Environments$Environment$baseUri(environment) + '/audits/query',
							_List_Nil,
							6);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Audit$Service$Fetching,
						A2($elm$core$Platform$Cmd$map, toMsg, cmdMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				return $elm$core$Result$Err(2);
			default:
				return $elm$core$Result$Err(2);
		}
	});
var $author$project$Audit$Store$isLoading = $elm$core$Basics$eq($author$project$Audit$Store$Loading);
var $author$project$Audit$Store$isUninitialized = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$Utils$Triple$mapThird = F2(
	function (fn, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			a,
			b,
			fn(c));
	});
var $author$project$Environments$Repository$setAuditService = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withAuditService);
var $author$project$Environments$Repository$fetchAudits = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	return ($author$project$Environments$Environment$isOffline(environment) || $author$project$Audit$Store$isLoading(data.aa)) ? _Utils_Tuple3(environment, repository, cmds) : (($author$project$Audit$Store$isUninitialized(data.aa) || $author$project$EventStream$EventStream$auditsOutOfDate(data.j)) ? A2(
		$elm$core$Result$withDefault,
		_Utils_Tuple3(environment, repository, cmds),
		A2(
			$elm$core$Result$map,
			$author$project$Utils$Triple$mapThird(
				A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
			A2(
				$elm$core$Result$map,
				$author$project$Utils$Triple$mapSecond(
					$author$project$Environments$Repository$setAuditService(repository)),
				A3($author$project$Audit$Service$fetch, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bg)))) : _Utils_Tuple3(environment, repository, cmds));
};
var $author$project$EventStream$EventStream$checkpointDataOutOfDate = function (status) {
	switch (status.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		default:
			var data = status.a;
			return data.B === 2;
	}
};
var $author$project$CheckpointData$Service$AlreadyFetched = 2;
var $author$project$Utils$Http$GetCheckpointGroups = 15;
var $author$project$CheckpointData$Service$fetch = F3(
	function (environment, toMsg, state) {
		switch (state.$) {
			case 0:
				var cmdMsg = function () {
					var _v1 = $author$project$Auth$Session$userCredentials(
						$author$project$Environments$Environment$session(environment));
					if (!_v1.$) {
						return A3(
							$author$project$Utils$Http$sendGet,
							$author$project$Environments$Environment$baseUri(environment) + '/checkpoint-groups/query',
							_List_Nil,
							15);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$CheckpointData$Service$Fetching,
						A2($elm$core$Platform$Cmd$map, toMsg, cmdMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				return $elm$core$Result$Err(2);
			default:
				return $elm$core$Result$Err(2);
		}
	});
var $author$project$CheckpointData$Store$isLoading = $elm$core$Basics$eq($author$project$CheckpointData$Store$Loading);
var $author$project$CheckpointData$Store$isUninitialized = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$Environments$Repository$setCheckpointDataService = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withCheckpointDataService);
var $author$project$Environments$Repository$fetchCheckpointData = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	return ($author$project$Environments$Environment$isOffline(environment) || $author$project$CheckpointData$Store$isLoading(data.C)) ? _Utils_Tuple3(environment, repository, cmds) : (($author$project$CheckpointData$Store$isUninitialized(data.C) || $author$project$EventStream$EventStream$checkpointDataOutOfDate(data.j)) ? A2(
		$elm$core$Result$withDefault,
		_Utils_Tuple3(environment, repository, cmds),
		A2(
			$elm$core$Result$map,
			$author$project$Utils$Triple$mapThird(
				A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
			A2(
				$elm$core$Result$map,
				$author$project$Utils$Triple$mapSecond(
					$author$project$Environments$Repository$setCheckpointDataService(repository)),
				A3($author$project$CheckpointData$Service$fetch, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bj)))) : _Utils_Tuple3(environment, repository, cmds));
};
var $author$project$Measure$Service$AlreadyFetched = 2;
var $author$project$Utils$Http$GetMeasures = 10;
var $author$project$Measure$Service$NotReady = 0;
var $author$project$Measure$Service$fetch = F3(
	function (environment, toMsg, state) {
		switch (state.$) {
			case 0:
				var cmdMsg = function () {
					var _v1 = $author$project$Auth$Session$userCredentials(
						$author$project$Environments$Environment$session(environment));
					if (!_v1.$) {
						return A3(
							$author$project$Utils$Http$sendGet,
							$author$project$Environments$Environment$baseUri(environment) + '/measures/query',
							_List_Nil,
							10);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Measure$Service$Fetching,
						A2($elm$core$Platform$Cmd$map, toMsg, cmdMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				return $elm$core$Result$Err(2);
			default:
				return $elm$core$Result$Err(2);
		}
	});
var $author$project$Measure$Store$isLoading = $elm$core$Basics$eq($author$project$Measure$Store$Loading);
var $author$project$Measure$Store$isUninitialized = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$EventStream$EventStream$measuresOutOfDate = function (status) {
	switch (status.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		default:
			var data = status.a;
			return data.D === 2;
	}
};
var $author$project$Environments$Repository$setMeasureService = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withMeasureService);
var $author$project$Environments$Repository$fetchMeasures = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	return ($author$project$Environments$Environment$isOffline(environment) || $author$project$Measure$Store$isLoading(data.R)) ? _Utils_Tuple3(environment, repository, cmds) : (($author$project$Measure$Store$isUninitialized(data.R) || $author$project$EventStream$EventStream$measuresOutOfDate(data.j)) ? A2(
		$elm$core$Result$withDefault,
		_Utils_Tuple3(environment, repository, cmds),
		A2(
			$elm$core$Result$map,
			$author$project$Utils$Triple$mapThird(
				A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
			A2(
				$elm$core$Result$map,
				$author$project$Utils$Triple$mapSecond(
					$author$project$Environments$Repository$setMeasureService(repository)),
				A3($author$project$Measure$Service$fetch, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bo)))) : _Utils_Tuple3(environment, repository, cmds));
};
var $author$project$OrganisationUnit$Service$AlreadyFetched = 2;
var $author$project$Utils$Http$GetOrganisationUnits = 2;
var $author$project$OrganisationUnit$Service$fetch = F3(
	function (environment, toMsg, state) {
		switch (state.$) {
			case 0:
				var cmdMsg = function () {
					var _v1 = $author$project$Auth$Session$userCredentials(
						$author$project$Environments$Environment$session(environment));
					if (!_v1.$) {
						return A3(
							$author$project$Utils$Http$sendGet,
							$author$project$Environments$Environment$baseUri(environment) + '/organisation-units/query',
							_List_Nil,
							2);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$OrganisationUnit$Service$Fetching,
						A2($elm$core$Platform$Cmd$map, toMsg, cmdMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				return $elm$core$Result$Err(2);
			default:
				return $elm$core$Result$Err(2);
		}
	});
var $author$project$OrganisationUnit$Store$isLoading = $elm$core$Basics$eq($author$project$OrganisationUnit$Store$Loading);
var $author$project$OrganisationUnit$Store$isUninitialized = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$EventStream$EventStream$organisationUnitsOutOfDate = function (status) {
	switch (status.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		default:
			var data = status.a;
			return data.E === 2;
	}
};
var $author$project$Environments$Repository$setOrganisationUnitService = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withOrganisationUnitService);
var $author$project$Environments$Repository$fetchOrganisationUnits = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	return ($author$project$Environments$Environment$isOffline(environment) || $author$project$OrganisationUnit$Store$isLoading(data.T)) ? _Utils_Tuple3(environment, repository, cmds) : (($author$project$OrganisationUnit$Store$isUninitialized(data.T) || $author$project$EventStream$EventStream$organisationUnitsOutOfDate(data.j)) ? A2(
		$elm$core$Result$withDefault,
		_Utils_Tuple3(environment, repository, cmds),
		A2(
			$elm$core$Result$map,
			$author$project$Utils$Triple$mapThird(
				A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
			A2(
				$elm$core$Result$map,
				$author$project$Utils$Triple$mapSecond(
					$author$project$Environments$Repository$setOrganisationUnitService(repository)),
				A3($author$project$OrganisationUnit$Service$fetch, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.br)))) : _Utils_Tuple3(environment, repository, cmds));
};
var $author$project$Plan$Service$AlreadyFetched = 2;
var $author$project$Utils$Http$GetPlans = 4;
var $author$project$Plan$Service$fetch = F3(
	function (environment, toMsg, state) {
		switch (state.$) {
			case 0:
				var cmdMsg = function () {
					var _v1 = $author$project$Auth$Session$userCredentials(
						$author$project$Environments$Environment$session(environment));
					if (!_v1.$) {
						return A3(
							$author$project$Utils$Http$sendGet,
							$author$project$Environments$Environment$baseUri(environment) + '/plans/query',
							_List_Nil,
							4);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Plan$Service$Fetching,
						A2($elm$core$Platform$Cmd$map, toMsg, cmdMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				return $elm$core$Result$Err(2);
			default:
				return $elm$core$Result$Err(2);
		}
	});
var $author$project$Plan$Store$isLoading = $elm$core$Basics$eq($author$project$Plan$Store$Loading);
var $author$project$Plan$Store$isUninitialized = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$EventStream$EventStream$plansOutOfDate = function (status) {
	switch (status.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		default:
			var data = status.a;
			return data.F === 2;
	}
};
var $author$project$Environments$Repository$setPlanService = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withPlanService);
var $author$project$Environments$Repository$fetchPlans = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	return ($author$project$Environments$Environment$isOffline(environment) || $author$project$Plan$Store$isLoading(data.U)) ? _Utils_Tuple3(environment, repository, cmds) : (($author$project$Plan$Store$isUninitialized(data.U) || $author$project$EventStream$EventStream$plansOutOfDate(data.j)) ? A2(
		$elm$core$Result$withDefault,
		_Utils_Tuple3(environment, repository, cmds),
		A2(
			$elm$core$Result$map,
			$author$project$Utils$Triple$mapThird(
				A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
			A2(
				$elm$core$Result$map,
				$author$project$Utils$Triple$mapSecond(
					$author$project$Environments$Repository$setPlanService(repository)),
				A3($author$project$Plan$Service$fetch, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bt)))) : _Utils_Tuple3(environment, repository, cmds));
};
var $author$project$Rights$Service$AlreadyFetched = 2;
var $author$project$Rights$Service$Fetching = {$: 1};
var $author$project$Utils$Http$GetRights = 17;
var $author$project$Rights$Service$fetch = F3(
	function (environment, toMsg, state) {
		switch (state.$) {
			case 0:
				var cmdMsg = function () {
					var _v1 = $author$project$Auth$Session$userCredentials(
						$author$project$Environments$Environment$session(environment));
					if (!_v1.$) {
						return A3(
							$author$project$Utils$Http$sendGet,
							$author$project$Environments$Environment$baseUri(environment) + '/rights/query',
							_List_Nil,
							17);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Rights$Service$Fetching,
						A2($elm$core$Platform$Cmd$map, toMsg, cmdMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				return $elm$core$Result$Err(2);
			default:
				return $elm$core$Result$Err(2);
		}
	});
var $author$project$Rights$Store$isLoading = $elm$core$Basics$eq($author$project$Rights$Store$Loading);
var $author$project$Rights$Store$isUninitialized = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$EventStream$EventStream$rightsOutOfDate = function (status) {
	switch (status.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		default:
			var data = status.a;
			return data.G === 2;
	}
};
var $author$project$Environments$Repository$setRightsService = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withRightsService);
var $author$project$Environments$Repository$fetchRights = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	return ($author$project$Environments$Environment$isOffline(environment) || $author$project$Rights$Store$isLoading(data.al)) ? _Utils_Tuple3(environment, repository, cmds) : (($author$project$Rights$Store$isUninitialized(data.al) || $author$project$EventStream$EventStream$rightsOutOfDate(data.j)) ? A2(
		$elm$core$Result$withDefault,
		_Utils_Tuple3(environment, repository, cmds),
		A2(
			$elm$core$Result$map,
			$author$project$Utils$Triple$mapThird(
				A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
			A2(
				$elm$core$Result$map,
				$author$project$Utils$Triple$mapSecond(
					$author$project$Environments$Repository$setRightsService(repository)),
				A3($author$project$Rights$Service$fetch, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bM)))) : _Utils_Tuple3(environment, repository, cmds));
};
var $author$project$Tenant$Service$AlreadyFetched = 2;
var $author$project$Tenant$Service$Fetching = {$: 1};
var $author$project$Utils$Http$GetTenant = 13;
var $author$project$Tenant$Service$fetch = F3(
	function (environment, toMsg, state) {
		switch (state.$) {
			case 0:
				var cmdMsg = function () {
					var _v1 = $author$project$Auth$Session$userCredentials(
						$author$project$Environments$Environment$session(environment));
					if (!_v1.$) {
						var credentials = _v1.a;
						return A3(
							$author$project$Utils$Http$sendGet,
							$author$project$Environments$Environment$baseUri(environment) + ('/tenants/query/' + $author$project$Tenant$Id$toString(credentials.k5)),
							_List_Nil,
							13);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Tenant$Service$Fetching,
						A2($elm$core$Platform$Cmd$map, toMsg, cmdMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				return $elm$core$Result$Err(2);
			default:
				return $elm$core$Result$Err(2);
		}
	});
var $author$project$Tenant$Store$isLoading = $elm$core$Basics$eq($author$project$Tenant$Store$Loading);
var $author$project$Tenant$Store$isUninitialized = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$Environments$Repository$setTenantService = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withTenantService);
var $author$project$EventStream$EventStream$tenantOutOfDate = function (status) {
	switch (status.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		default:
			var data = status.a;
			return data.H === 2;
	}
};
var $author$project$Environments$Repository$fetchTenant = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	return ($author$project$Environments$Environment$isOffline(environment) || $author$project$Tenant$Store$isLoading(data.ag)) ? _Utils_Tuple3(environment, repository, cmds) : (($author$project$Tenant$Store$isUninitialized(data.ag) || $author$project$EventStream$EventStream$tenantOutOfDate(data.j)) ? A2(
		$elm$core$Result$withDefault,
		_Utils_Tuple3(environment, repository, cmds),
		A2(
			$elm$core$Result$map,
			$author$project$Utils$Triple$mapThird(
				A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
			A2(
				$elm$core$Result$map,
				$author$project$Utils$Triple$mapSecond(
					$author$project$Environments$Repository$setTenantService(repository)),
				A3($author$project$Tenant$Service$fetch, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bz)))) : _Utils_Tuple3(environment, repository, cmds));
};
var $author$project$User$Service$AlreadyFetched = 2;
var $author$project$User$Service$Fetching = {$: 1};
var $author$project$Utils$Http$GetUsers = 0;
var $author$project$User$Service$fetch = F3(
	function (environment, toMsg, state) {
		switch (state.$) {
			case 0:
				var cmdMsg = function () {
					var _v1 = $author$project$Auth$Session$userCredentials(
						$author$project$Environments$Environment$session(environment));
					if (!_v1.$) {
						return A3(
							$author$project$Utils$Http$sendGet,
							$author$project$Environments$Environment$baseUri(environment) + '/users/query',
							_List_Nil,
							0);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$User$Service$Fetching,
						A2($elm$core$Platform$Cmd$map, toMsg, cmdMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				return $elm$core$Result$Err(2);
			default:
				return $elm$core$Result$Err(2);
		}
	});
var $author$project$User$Store$isLoading = $elm$core$Basics$eq($author$project$User$Store$Loading);
var $author$project$User$Store$isUninitialized = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$Environments$Repository$setUserService = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withUserService);
var $author$project$EventStream$EventStream$usersOutOfDate = function (status) {
	switch (status.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		default:
			var data = status.a;
			return data.I === 2;
	}
};
var $author$project$Environments$Repository$fetchUsers = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	return ($author$project$Environments$Environment$isOffline(environment) || $author$project$User$Store$isLoading(data.ah)) ? _Utils_Tuple3(environment, repository, cmds) : (($author$project$User$Store$isUninitialized(data.ah) || $author$project$EventStream$EventStream$usersOutOfDate(data.j)) ? A2(
		$elm$core$Result$withDefault,
		_Utils_Tuple3(environment, repository, cmds),
		A2(
			$elm$core$Result$map,
			$author$project$Utils$Triple$mapThird(
				A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
			A2(
				$elm$core$Result$map,
				$author$project$Utils$Triple$mapSecond(
					$author$project$Environments$Repository$setUserService(repository)),
				A3($author$project$User$Service$fetch, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bA)))) : _Utils_Tuple3(environment, repository, cmds));
};
var $author$project$Types$Queue$dequeue = function (_v0) {
	var front = _v0.a;
	var rear = _v0.b;
	if (!front.b) {
		return _Utils_Tuple2(
			$elm$core$Maybe$Nothing,
			A2($author$project$Types$Queue$Queue, _List_Nil, _List_Nil));
	} else {
		var head = front.a;
		var tail = front.b;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(head),
			A2($author$project$Types$Queue$queue, tail, rear));
	}
};
var $author$project$Audit$Commands$dequeue = $author$project$Types$Queue$dequeue;
var $author$project$Audit$Store$Saving = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audit$Store$Uninitialized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$Store$setCommands = F2(
	function (state, commands_) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				var data = state.a;
				return $author$project$Audit$Store$Uninitialized(
					_Utils_update(
						data,
						{cD: commands_}));
			case 2:
				var data = state.a;
				return $author$project$Audit$Store$Loaded(
					_Utils_update(
						data,
						{cD: commands_}));
			default:
				var data = state.a;
				return $author$project$Audit$Store$Saving(
					_Utils_update(
						data,
						{cD: commands_}));
		}
	});
var $author$project$Audit$Store$dequeueCommands = function (state) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$author$project$Audit$Store$setCommands(state),
		$author$project$Audit$Commands$dequeue(
			$author$project$Audit$Store$commands(state)));
};
var $author$project$Audit$Service$FetchedAndSendingCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Audit$Service$getCommandData = F2(
	function (command, environment) {
		var baseUrl = $author$project$Environments$Environment$baseUri(environment) + '/audits/command';
		switch (command.$) {
			case 0:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/create',
					_List_fromArray(
						[
							{
							bn: 'x-plan-id',
							ll: $author$project$Plan$Id$toString(payload.d5)
						}
						]));
			case 1:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/record-checkpoint',
					_List_fromArray(
						[
							{
							bn: 'x-audit-id',
							ll: $author$project$Audit$Id$toString(payload.gm)
						}
						]));
			case 2:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-title',
					_List_fromArray(
						[
							{
							bn: 'x-audit-id',
							ll: $author$project$Audit$Id$toString(payload.gm)
						}
						]));
			case 3:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-description',
					_List_fromArray(
						[
							{
							bn: 'x-audit-id',
							ll: $author$project$Audit$Id$toString(payload.gm)
						}
						]));
			case 4:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-deadline',
					_List_fromArray(
						[
							{
							bn: 'x-audit-id',
							ll: $author$project$Audit$Id$toString(payload.gm)
						}
						]));
			case 5:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-auditors',
					_List_fromArray(
						[
							{
							bn: 'x-audit-id',
							ll: $author$project$Audit$Id$toString(payload.gm)
						}
						]));
			case 6:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/add-record-files',
					_List_fromArray(
						[
							{
							bn: 'x-audit-id',
							ll: $author$project$Audit$Id$toString(payload.gm)
						}
						]));
			case 7:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/remove-record-files',
					_List_fromArray(
						[
							{
							bn: 'x-audit-id',
							ll: $author$project$Audit$Id$toString(payload.gm)
						}
						]));
			case 8:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/complete',
					_List_fromArray(
						[
							{
							bn: 'x-audit-id',
							ll: $author$project$Audit$Id$toString(payload.gm)
						}
						]));
			default:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/delete',
					_List_fromArray(
						[
							{
							bn: 'x-audit-id',
							ll: $author$project$Audit$Id$toString(payload.gm)
						}
						]));
		}
	});
var $author$project$Audit$Service$sendCommandHelper = F3(
	function (command, environment, toMsg) {
		var _v0 = $author$project$Auth$Session$userCredentials(
			$author$project$Environments$Environment$session(environment));
		if (!_v0.$) {
			var _v1 = A2($author$project$Audit$Service$getCommandData, command, environment);
			var url = _v1.a;
			var header = _v1.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				toMsg,
				A4(
					$author$project$Utils$Http$sendPost,
					url,
					9,
					$author$project$Audit$Command$encode(command),
					header));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Audit$Service$sendCommand = F4(
	function (command, environment, toMsg, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Audit$Service$SendingCommand,
						A3($author$project$Audit$Service$sendCommandHelper, command, environment, toMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				var audits = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Audit$Service$FetchedAndSendingCommand(audits),
						A3($author$project$Audit$Service$sendCommandHelper, command, environment, toMsg)));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$sendAuditCommands = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isOffline(environment)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		var _v1 = $author$project$Audit$Store$dequeueCommands(data.aa);
		if (!_v1.a.$) {
			var command = _v1.a.a;
			var newAuditStore = _v1.b;
			return A2(
				$elm$core$Result$withDefault,
				_Utils_Tuple3(environment, repository, cmds),
				A2(
					$elm$core$Result$map,
					$author$project$Utils$Triple$mapThird(
						A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Triple$mapSecond(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Environments$Repository$setAuditService(repository),
								$author$project$Environments$Repository$withAuditStore(newAuditStore))),
						A4($author$project$Audit$Service$sendCommand, command, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bg))));
		} else {
			var _v2 = _v1.a;
			var newAuditStore = _v1.b;
			return _Utils_Tuple3(
				environment,
				A2($author$project$Environments$Repository$withAuditStore, newAuditStore, repository),
				cmds);
		}
	}
};
var $author$project$CheckpointData$Commands$dequeue = $author$project$Types$Queue$dequeue;
var $author$project$CheckpointData$Store$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Store$Uninitialized = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$Store$setCommands = F2(
	function (state, commands_) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				var data = state.a;
				return $author$project$CheckpointData$Store$Uninitialized(
					_Utils_update(
						data,
						{cD: commands_}));
			case 2:
				var data = state.a;
				return $author$project$CheckpointData$Store$Loaded(
					_Utils_update(
						data,
						{cD: commands_}));
			default:
				var data = state.a;
				return $author$project$CheckpointData$Store$Saving(
					_Utils_update(
						data,
						{cD: commands_}));
		}
	});
var $author$project$CheckpointData$Store$dequeueCommands = function (state) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$author$project$CheckpointData$Store$setCommands(state),
		$author$project$CheckpointData$Commands$dequeue(
			$author$project$CheckpointData$Store$commands(state)));
};
var $author$project$CheckpointData$Service$FetchedAndSendingCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Http$SendCheckpointGroupsCommand = 16;
var $author$project$CheckpointData$Service$sendCommandUrl = F2(
	function (command, environment) {
		var baseUrl = $author$project$Environments$Environment$baseUri(environment) + '/checkpoint-groups/command';
		switch (command.$) {
			case 0:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/create-checkpoint-group',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						},
							{
							bn: 'x-checkpoint-group-id',
							ll: $author$project$CheckpointData$CheckpointGroup$Id$toString(payload.cC)
						}
						]));
			case 1:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-checkpoint-group-title',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-group-id',
							ll: $author$project$CheckpointData$CheckpointGroup$Id$toString(payload.cC)
						}
						]));
			case 2:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-checkpoint-group-description',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-group-id',
							ll: $author$project$CheckpointData$CheckpointGroup$Id$toString(payload.cC)
						}
						]));
			case 3:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/move-before-checkpoint-group',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-group-id',
							ll: $author$project$CheckpointData$CheckpointGroup$Id$toString(payload.cC)
						}
						]));
			case 4:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/move-after-checkpoint-group',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-group-id',
							ll: $author$project$CheckpointData$CheckpointGroup$Id$toString(payload.cC)
						}
						]));
			case 5:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/delete-checkpoint-group',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-group-id',
							ll: $author$project$CheckpointData$CheckpointGroup$Id$toString(payload.cC)
						}
						]));
			case 6:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/create-checkpoint',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-group-id',
							ll: $author$project$CheckpointData$CheckpointGroup$Id$toString(payload.cC)
						}
						]));
			case 7:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-checkpoint-type',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-id',
							ll: $author$project$CheckpointData$Checkpoint$Id$toString(payload.i5)
						}
						]));
			case 8:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-checkpoint-title',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-id',
							ll: $author$project$CheckpointData$Checkpoint$Id$toString(payload.i5)
						}
						]));
			case 9:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-checkpoint-description',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-id',
							ll: $author$project$CheckpointData$Checkpoint$Id$toString(payload.i5)
						}
						]));
			case 10:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-checkpoint-files',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-id',
							ll: $author$project$CheckpointData$Checkpoint$Id$toString(payload.i5)
						}
						]));
			case 11:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/move-checkpoint',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-id',
							ll: $author$project$CheckpointData$Checkpoint$Id$toString(payload.i5)
						}
						]));
			case 12:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/move-before-checkpoint',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-id',
							ll: $author$project$CheckpointData$Checkpoint$Id$toString(payload.i5)
						}
						]));
			case 13:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/move-after-checkpoint',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-id',
							ll: $author$project$CheckpointData$Checkpoint$Id$toString(payload.i5)
						}
						]));
			default:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/delete-checkpoint',
					_List_fromArray(
						[
							{
							bn: 'x-checkpoint-id',
							ll: $author$project$CheckpointData$Checkpoint$Id$toString(payload.i5)
						}
						]));
		}
	});
var $author$project$CheckpointData$Service$sendCommandHelper = F3(
	function (environment, toMsg, command) {
		var _v0 = $author$project$Auth$Session$userCredentials(
			$author$project$Environments$Environment$session(environment));
		if (!_v0.$) {
			var _v1 = A2($author$project$CheckpointData$Service$sendCommandUrl, command, environment);
			var url = _v1.a;
			var header = _v1.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				toMsg,
				A4(
					$author$project$Utils$Http$sendPost,
					url,
					16,
					$author$project$CheckpointData$Command$encode(command),
					header));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$CheckpointData$Service$sendCommand = F4(
	function (command, environment, toMsg, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$CheckpointData$Service$SendingCommand,
						A3($author$project$CheckpointData$Service$sendCommandHelper, environment, toMsg, command)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				var checkpointData = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$CheckpointData$Service$FetchedAndSendingCommand(checkpointData),
						A3($author$project$CheckpointData$Service$sendCommandHelper, environment, toMsg, command)));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$sendCheckpointDataCommands = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isOffline(environment)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		var _v1 = $author$project$CheckpointData$Store$dequeueCommands(data.C);
		if (!_v1.a.$) {
			var command = _v1.a.a;
			var newCheckpointDataStore = _v1.b;
			return A2(
				$elm$core$Result$withDefault,
				_Utils_Tuple3(environment, repository, cmds),
				A2(
					$elm$core$Result$map,
					$author$project$Utils$Triple$mapThird(
						A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Triple$mapSecond(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Environments$Repository$setCheckpointDataService(repository),
								$author$project$Environments$Repository$withCheckpointDataStore(newCheckpointDataStore))),
						A4($author$project$CheckpointData$Service$sendCommand, command, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bj))));
		} else {
			var _v2 = _v1.a;
			var newCheckpointDataStore = _v1.b;
			return _Utils_Tuple3(
				environment,
				A2($author$project$Environments$Repository$withCheckpointDataStore, newCheckpointDataStore, repository),
				cmds);
		}
	}
};
var $author$project$Measure$Commands$dequeue = $author$project$Types$Queue$dequeue;
var $author$project$Measure$Store$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Measure$Store$Uninitialized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$Store$setCommands = F2(
	function (state, commands_) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				var data = state.a;
				return $author$project$Measure$Store$Uninitialized(
					_Utils_update(
						data,
						{cD: commands_}));
			case 2:
				var data = state.a;
				return $author$project$Measure$Store$Loaded(
					_Utils_update(
						data,
						{cD: commands_}));
			default:
				var data = state.a;
				return $author$project$Measure$Store$Saving(
					_Utils_update(
						data,
						{cD: commands_}));
		}
	});
var $author$project$Measure$Store$dequeueCommands = function (state) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$author$project$Measure$Store$setCommands(state),
		$author$project$Measure$Commands$dequeue(
			$author$project$Measure$Store$commands(state)));
};
var $author$project$Measure$Service$FetchedAndSendingCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Measure$Service$getCommandData = F2(
	function (command, environment) {
		var baseUrl = $author$project$Environments$Environment$baseUri(environment) + '/measures/command';
		switch (command.$) {
			case 0:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/create',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						}
						]));
			case 1:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-title',
					_List_fromArray(
						[
							{
							bn: 'x-measure-id',
							ll: $author$project$Measure$Id$toString(payload.h5)
						}
						]));
			case 2:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-description',
					_List_fromArray(
						[
							{
							bn: 'x-measure-id',
							ll: $author$project$Measure$Id$toString(payload.h5)
						}
						]));
			case 3:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-responsible-users',
					_List_fromArray(
						[
							{
							bn: 'x-measure-id',
							ll: $author$project$Measure$Id$toString(payload.h5)
						}
						]));
			case 4:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-deadline',
					_List_fromArray(
						[
							{
							bn: 'x-measure-id',
							ll: $author$project$Measure$Id$toString(payload.h5)
						}
						]));
			case 5:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-organisation-unit',
					_List_fromArray(
						[
							{
							bn: 'x-measure-id',
							ll: $author$project$Measure$Id$toString(payload.h5)
						}
						]));
			case 6:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/add-images',
					_List_fromArray(
						[
							{
							bn: 'x-measure-id',
							ll: $author$project$Measure$Id$toString(payload.h5)
						}
						]));
			case 7:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/remove-images',
					_List_fromArray(
						[
							{
							bn: 'x-measure-id',
							ll: $author$project$Measure$Id$toString(payload.h5)
						}
						]));
			case 8:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/complete',
					_List_fromArray(
						[
							{
							bn: 'x-measure-id',
							ll: $author$project$Measure$Id$toString(payload.h5)
						}
						]));
			default:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/delete',
					_List_fromArray(
						[
							{
							bn: 'x-measure-id',
							ll: $author$project$Measure$Id$toString(payload.h5)
						}
						]));
		}
	});
var $author$project$Measure$Service$sendCommandHelper = F3(
	function (command, environment, toMsg) {
		var _v0 = $author$project$Auth$Session$userCredentials(
			$author$project$Environments$Environment$session(environment));
		if (!_v0.$) {
			var _v1 = A2($author$project$Measure$Service$getCommandData, command, environment);
			var url = _v1.a;
			var header = _v1.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				toMsg,
				A4(
					$author$project$Utils$Http$sendPost,
					url,
					12,
					$author$project$Measure$Command$encode(command),
					header));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Measure$Service$sendCommand = F4(
	function (command, environment, toMsg, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Measure$Service$SendingCommand,
						A3($author$project$Measure$Service$sendCommandHelper, command, environment, toMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				var measures = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Measure$Service$FetchedAndSendingCommand(measures),
						A3($author$project$Measure$Service$sendCommandHelper, command, environment, toMsg)));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$sendMeasureCommands = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isOffline(environment)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		var _v1 = $author$project$Measure$Store$dequeueCommands(data.R);
		if (!_v1.a.$) {
			var command = _v1.a.a;
			var newMeasureStore = _v1.b;
			return A2(
				$elm$core$Result$withDefault,
				_Utils_Tuple3(environment, repository, cmds),
				A2(
					$elm$core$Result$map,
					$author$project$Utils$Triple$mapThird(
						A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Triple$mapSecond(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Environments$Repository$setMeasureService(repository),
								$author$project$Environments$Repository$withMeasureStore(newMeasureStore))),
						A4($author$project$Measure$Service$sendCommand, command, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bo))));
		} else {
			var _v2 = _v1.a;
			var newMeasureStore = _v1.b;
			return _Utils_Tuple3(
				environment,
				A2($author$project$Environments$Repository$withMeasureStore, newMeasureStore, repository),
				cmds);
		}
	}
};
var $author$project$OrganisationUnit$Commands$dequeue = $author$project$Types$Queue$dequeue;
var $author$project$OrganisationUnit$Store$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$OrganisationUnit$Store$Uninitialized = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$Store$setCommands = F2(
	function (state, commands_) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				var data = state.a;
				return $author$project$OrganisationUnit$Store$Uninitialized(
					_Utils_update(
						data,
						{cD: commands_}));
			case 2:
				var data = state.a;
				return $author$project$OrganisationUnit$Store$Loaded(
					_Utils_update(
						data,
						{cD: commands_}));
			default:
				var data = state.a;
				return $author$project$OrganisationUnit$Store$Saving(
					_Utils_update(
						data,
						{cD: commands_}));
		}
	});
var $author$project$OrganisationUnit$Store$dequeueCommands = function (state) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$author$project$OrganisationUnit$Store$setCommands(state),
		$author$project$OrganisationUnit$Commands$dequeue(
			$author$project$OrganisationUnit$Store$commands(state)));
};
var $author$project$OrganisationUnit$Service$FetchedAndSendingCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Http$SendOrganisationUnitCommand = 3;
var $author$project$OrganisationUnit$Service$getCommandData = F2(
	function (command, environment) {
		var baseUrl = $author$project$Environments$Environment$baseUri(environment) + '/organisation-units/command';
		switch (command.$) {
			case 0:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/create',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						}
						]));
			case 1:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/create-child',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.fV)
						}
						]));
			case 2:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/create-before',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.ax)
						}
						]));
			case 3:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/create-after',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.ay)
						}
						]));
			case 4:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/move',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						}
						]));
			case 5:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/move-before',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						}
						]));
			case 6:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/move-after',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						}
						]));
			case 7:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-title',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						}
						]));
			case 8:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-description',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						}
						]));
			case 9:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-color',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						}
						]));
			case 10:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-floor-plan',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						}
						]));
			default:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/delete',
					_List_fromArray(
						[
							{
							bn: 'x-organisation-unit-id',
							ll: $author$project$OrganisationUnit$Id$toString(payload.km)
						}
						]));
		}
	});
var $author$project$OrganisationUnit$Service$sendCommandHelper = F3(
	function (command, environment, toMsg) {
		var _v0 = $author$project$Auth$Session$userCredentials(
			$author$project$Environments$Environment$session(environment));
		if (!_v0.$) {
			var _v1 = A2($author$project$OrganisationUnit$Service$getCommandData, command, environment);
			var url = _v1.a;
			var header = _v1.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				toMsg,
				A4(
					$author$project$Utils$Http$sendPost,
					url,
					3,
					$author$project$OrganisationUnit$Command$encode(command),
					header));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$OrganisationUnit$Service$sendCommand = F4(
	function (command, environment, toMsg, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$OrganisationUnit$Service$SendingCommand,
						A3($author$project$OrganisationUnit$Service$sendCommandHelper, command, environment, toMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				var organisationUnits = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$OrganisationUnit$Service$FetchedAndSendingCommand(organisationUnits),
						A3($author$project$OrganisationUnit$Service$sendCommandHelper, command, environment, toMsg)));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$sendOrganisationUnitCommands = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isOffline(environment)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		var _v1 = $author$project$OrganisationUnit$Store$dequeueCommands(data.T);
		if (!_v1.a.$) {
			var command = _v1.a.a;
			var newOrganisationUnitStore = _v1.b;
			return A2(
				$elm$core$Result$withDefault,
				_Utils_Tuple3(environment, repository, cmds),
				A2(
					$elm$core$Result$map,
					$author$project$Utils$Triple$mapThird(
						A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Triple$mapSecond(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Environments$Repository$setOrganisationUnitService(repository),
								$author$project$Environments$Repository$withOrganisationUnitStore(newOrganisationUnitStore))),
						A4($author$project$OrganisationUnit$Service$sendCommand, command, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.br))));
		} else {
			var _v2 = _v1.a;
			var newOrganisationUnitStore = _v1.b;
			return _Utils_Tuple3(
				environment,
				A2($author$project$Environments$Repository$withOrganisationUnitStore, newOrganisationUnitStore, repository),
				cmds);
		}
	}
};
var $author$project$Plan$Commands$dequeue = $author$project$Types$Queue$dequeue;
var $author$project$Plan$Store$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$Store$Uninitialized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Store$setCommands = F2(
	function (state, commands_) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				var data = state.a;
				return $author$project$Plan$Store$Uninitialized(
					_Utils_update(
						data,
						{cD: commands_}));
			case 2:
				var data = state.a;
				return $author$project$Plan$Store$Loaded(
					_Utils_update(
						data,
						{cD: commands_}));
			default:
				var data = state.a;
				return $author$project$Plan$Store$Saving(
					_Utils_update(
						data,
						{cD: commands_}));
		}
	});
var $author$project$Plan$Store$dequeueCommands = function (state) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$author$project$Plan$Store$setCommands(state),
		$author$project$Plan$Commands$dequeue(
			$author$project$Plan$Store$commands(state)));
};
var $author$project$Plan$Service$FetchedAndSendingCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Http$SendPlanCommand = 5;
var $author$project$Plan$Service$getCommandData = F2(
	function (command, environment) {
		var baseUrl = $author$project$Environments$Environment$baseUri(environment) + '/plans/command';
		switch (command.$) {
			case 0:
				return _Utils_Tuple2(baseUrl + '/create', _List_Nil);
			case 1:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-title',
					_List_fromArray(
						[
							{
							bn: 'x-plan-id',
							ll: $author$project$Plan$Id$toString(payload.d5)
						}
						]));
			case 2:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-description',
					_List_fromArray(
						[
							{
							bn: 'x-plan-id',
							ll: $author$project$Plan$Id$toString(payload.d5)
						}
						]));
			case 3:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/add-execution',
					_List_fromArray(
						[
							{
							bn: 'x-plan-id',
							ll: $author$project$Plan$Id$toString(payload.d5)
						}
						]));
			case 4:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-execution',
					_List_fromArray(
						[
							{
							bn: 'x-plan-id',
							ll: $author$project$Plan$Id$toString(payload.d5)
						}
						]));
			case 5:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/remove-execution',
					_List_fromArray(
						[
							{
							bn: 'x-plan-id',
							ll: $author$project$Plan$Id$toString(payload.d5)
						}
						]));
			case 6:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-auditors',
					_List_fromArray(
						[
							{
							bn: 'x-plan-id',
							ll: $author$project$Plan$Id$toString(payload.d5)
						}
						]));
			case 7:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/change-checkpoint-groups',
					_List_fromArray(
						[
							{
							bn: 'x-plan-id',
							ll: $author$project$Plan$Id$toString(payload.d5)
						}
						]));
			case 8:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/delete',
					_List_fromArray(
						[
							{
							bn: 'x-plan-id',
							ll: $author$project$Plan$Id$toString(payload.d5)
						}
						]));
			default:
				var payload = command.a;
				return _Utils_Tuple2(
					baseUrl + '/execute-manuel',
					_List_fromArray(
						[
							{
							bn: 'x-plan-id',
							ll: $author$project$Plan$Id$toString(payload.d5)
						}
						]));
		}
	});
var $author$project$Plan$Service$sendCommandHelper = F3(
	function (command, environment, toMsg) {
		var _v0 = $author$project$Auth$Session$userCredentials(
			$author$project$Environments$Environment$session(environment));
		if (!_v0.$) {
			var _v1 = A2($author$project$Plan$Service$getCommandData, command, environment);
			var url = _v1.a;
			var header = _v1.b;
			return A2(
				$elm$core$Platform$Cmd$map,
				toMsg,
				A4(
					$author$project$Utils$Http$sendPost,
					url,
					5,
					$author$project$Plan$Command$encode(command),
					header));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Plan$Service$sendCommand = F4(
	function (command, environment, toMsg, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Plan$Service$SendingCommand,
						A3($author$project$Plan$Service$sendCommandHelper, command, environment, toMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				var plans = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Plan$Service$FetchedAndSendingCommand(plans),
						A3($author$project$Plan$Service$sendCommandHelper, command, environment, toMsg)));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$sendPlanCommands = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isOffline(environment)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		var _v1 = $author$project$Plan$Store$dequeueCommands(data.U);
		if (!_v1.a.$) {
			var command = _v1.a.a;
			var newPlanStore = _v1.b;
			return A2(
				$elm$core$Result$withDefault,
				_Utils_Tuple3(environment, repository, cmds),
				A2(
					$elm$core$Result$map,
					$author$project$Utils$Triple$mapThird(
						A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Triple$mapSecond(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Environments$Repository$setPlanService(repository),
								$author$project$Environments$Repository$withPlanStore(newPlanStore))),
						A4($author$project$Plan$Service$sendCommand, command, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bt))));
		} else {
			var _v2 = _v1.a;
			var newPlanStore = _v1.b;
			return _Utils_Tuple3(
				environment,
				A2($author$project$Environments$Repository$withPlanStore, newPlanStore, repository),
				cmds);
		}
	}
};
var $author$project$Rights$Commands$dequeue = $author$project$Types$Queue$dequeue;
var $author$project$Rights$Store$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Store$Uninitialized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Store$setCommands = F2(
	function (state, commands_) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				var data = state.a;
				return $author$project$Rights$Store$Uninitialized(
					_Utils_update(
						data,
						{cD: commands_}));
			case 2:
				var data = state.a;
				return $author$project$Rights$Store$Loaded(
					_Utils_update(
						data,
						{cD: commands_}));
			default:
				var data = state.a;
				return $author$project$Rights$Store$Saving(
					_Utils_update(
						data,
						{cD: commands_}));
		}
	});
var $author$project$Rights$Store$dequeueCommands = function (state) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$author$project$Rights$Store$setCommands(state),
		$author$project$Rights$Commands$dequeue(
			$author$project$Rights$Store$commands(state)));
};
var $author$project$Rights$Service$FetchedAndSendingCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Http$SendRightsCommand = 18;
var $author$project$Rights$Service$sendCommandUrl = F2(
	function (command, environment) {
		var baseUrl = $author$project$Environments$Environment$baseUri(environment) + '/rights/command';
		switch (command.$) {
			case 0:
				return baseUrl + '/create-role';
			case 1:
				return baseUrl + '/change-role-title';
			case 2:
				return baseUrl + '/change-role-description';
			case 3:
				return baseUrl + '/add-rights';
			case 4:
				return baseUrl + '/remove-rights';
			case 5:
				return baseUrl + '/delete-role';
			case 6:
				return baseUrl + '/create-team';
			case 7:
				return baseUrl + '/change-team-title';
			case 8:
				return baseUrl + '/change-team-description';
			case 9:
				return baseUrl + '/add-organisation-unit';
			case 10:
				return baseUrl + '/remove-organisation-unit';
			default:
				return baseUrl + '/delete-team';
		}
	});
var $author$project$Rights$Service$sendCommandHelper = F3(
	function (environment, toMsg, command) {
		var _v0 = $author$project$Auth$Session$userCredentials(
			$author$project$Environments$Environment$session(environment));
		if (!_v0.$) {
			return A2(
				$elm$core$Platform$Cmd$map,
				toMsg,
				A4(
					$author$project$Utils$Http$sendPost,
					A2($author$project$Rights$Service$sendCommandUrl, command, environment),
					18,
					$author$project$Rights$Command$encode(command),
					_List_Nil));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Rights$Service$sendCommand = F4(
	function (command, environment, toMsg, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Rights$Service$SendingCommand,
						A3($author$project$Rights$Service$sendCommandHelper, environment, toMsg, command)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				var rights = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Rights$Service$FetchedAndSendingCommand(rights),
						A3($author$project$Rights$Service$sendCommandHelper, environment, toMsg, command)));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$sendRightsCommands = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isOffline(environment)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		var _v1 = $author$project$Rights$Store$dequeueCommands(data.al);
		if (!_v1.a.$) {
			var command = _v1.a.a;
			var newRightsStore = _v1.b;
			return A2(
				$elm$core$Result$withDefault,
				_Utils_Tuple3(environment, repository, cmds),
				A2(
					$elm$core$Result$map,
					$author$project$Utils$Triple$mapThird(
						A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Triple$mapSecond(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Environments$Repository$setRightsService(repository),
								$author$project$Environments$Repository$withRightsStore(newRightsStore))),
						A4($author$project$Rights$Service$sendCommand, command, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bM))));
		} else {
			var _v2 = _v1.a;
			var newRightsStore = _v1.b;
			return _Utils_Tuple3(
				environment,
				A2($author$project$Environments$Repository$withRightsStore, newRightsStore, repository),
				cmds);
		}
	}
};
var $author$project$Tenant$Commands$dequeue = $author$project$Types$Queue$dequeue;
var $author$project$Tenant$Store$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Tenant$Store$Uninitialized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tenant$Store$setCommands = F2(
	function (state, commands_) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				var data = state.a;
				return $author$project$Tenant$Store$Uninitialized(
					_Utils_update(
						data,
						{cD: commands_}));
			case 2:
				var data = state.a;
				return $author$project$Tenant$Store$Loaded(
					_Utils_update(
						data,
						{cD: commands_}));
			default:
				var data = state.a;
				return $author$project$Tenant$Store$Loaded(
					_Utils_update(
						data,
						{cD: commands_}));
		}
	});
var $author$project$Tenant$Store$dequeueCommands = function (state) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$author$project$Tenant$Store$setCommands(state),
		$author$project$Tenant$Commands$dequeue(
			$author$project$Tenant$Store$commands(state)));
};
var $author$project$Tenant$Service$FetchedAndSendingCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Http$SendTenantCommand = 14;
var $author$project$Tenant$Service$sendCommandUrl = F2(
	function (command, environment) {
		var baseUrl = $author$project$Environments$Environment$baseUri(environment) + '/tenants/command';
		switch (command.$) {
			case 0:
				return baseUrl + '/change-road';
			case 1:
				return baseUrl + '/change-house-number';
			case 2:
				return baseUrl + '/change-zip-code';
			case 3:
				return baseUrl + '/change-location';
			case 4:
				return baseUrl + '/change-country';
			case 5:
				return baseUrl + '/change-phone-number';
			case 6:
				return baseUrl + '/change-url';
			default:
				return baseUrl + '/change-logo';
		}
	});
var $author$project$Tenant$Service$sendCommandHelper = F3(
	function (command, environment, toMsg) {
		var _v0 = $author$project$Auth$Session$userCredentials(
			$author$project$Environments$Environment$session(environment));
		if (!_v0.$) {
			return A2(
				$elm$core$Platform$Cmd$map,
				toMsg,
				A4(
					$author$project$Utils$Http$sendPost,
					A2($author$project$Tenant$Service$sendCommandUrl, command, environment),
					14,
					$author$project$Tenant$Command$encode(command),
					_List_Nil));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Tenant$Service$sendCommand = F4(
	function (command, environment, toMsg, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Tenant$Service$SendingCommand,
						A3($author$project$Tenant$Service$sendCommandHelper, command, environment, toMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				var tenant = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$Tenant$Service$FetchedAndSendingCommand(tenant),
						A3($author$project$Tenant$Service$sendCommandHelper, command, environment, toMsg)));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$sendTenantCommands = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isOffline(environment)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		var _v1 = $author$project$Tenant$Store$dequeueCommands(data.ag);
		if (!_v1.a.$) {
			var command = _v1.a.a;
			var newTenantStore = _v1.b;
			return A2(
				$elm$core$Result$withDefault,
				_Utils_Tuple3(environment, repository, cmds),
				A2(
					$elm$core$Result$map,
					$author$project$Utils$Triple$mapThird(
						A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Triple$mapSecond(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Environments$Repository$setTenantService(repository),
								$author$project$Environments$Repository$withTenantStore(newTenantStore))),
						A4($author$project$Tenant$Service$sendCommand, command, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bz))));
		} else {
			var _v2 = _v1.a;
			var newTenantStore = _v1.b;
			return _Utils_Tuple3(
				environment,
				A2($author$project$Environments$Repository$withTenantStore, newTenantStore, repository),
				cmds);
		}
	}
};
var $author$project$User$Commands$dequeue = $author$project$Types$Queue$dequeue;
var $author$project$User$Store$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$Store$Uninitialized = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$Store$setCommands = F2(
	function (state, commands_) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				var data = state.a;
				return $author$project$User$Store$Uninitialized(
					_Utils_update(
						data,
						{cD: commands_}));
			case 2:
				var data = state.a;
				return $author$project$User$Store$Loaded(
					_Utils_update(
						data,
						{cD: commands_}));
			default:
				var data = state.a;
				return $author$project$User$Store$Loaded(
					_Utils_update(
						data,
						{cD: commands_}));
		}
	});
var $author$project$User$Store$dequeueCommands = function (state) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$author$project$User$Store$setCommands(state),
		$author$project$User$Commands$dequeue(
			$author$project$User$Store$commands(state)));
};
var $author$project$User$Service$FetchedAndSendingCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Http$SendUserCommand = 1;
var $author$project$User$Service$sendCommandUrl = F2(
	function (command, environment) {
		var baseUrl = $author$project$Environments$Environment$baseUri(environment) + '/users/command';
		switch (command.$) {
			case 0:
				return baseUrl + '/create';
			case 1:
				return baseUrl + '/change-email-address';
			case 2:
				return baseUrl + '/change-password';
			case 3:
				return baseUrl + '/rename';
			case 4:
				return baseUrl + '/add-team-role';
			case 5:
				return baseUrl + '/change-team-role';
			case 6:
				return baseUrl + '/remove-team-role';
			case 7:
				return baseUrl + '/change-avatar';
			case 8:
				return baseUrl + '/change-entry-organisation-unit';
			default:
				return baseUrl + '/delete';
		}
	});
var $author$project$User$Service$sendCommandHelper = F3(
	function (command, environment, toMsg) {
		var _v0 = $author$project$Auth$Session$userCredentials(
			$author$project$Environments$Environment$session(environment));
		if (!_v0.$) {
			return A2(
				$elm$core$Platform$Cmd$map,
				toMsg,
				A4(
					$author$project$Utils$Http$sendPost,
					A2($author$project$User$Service$sendCommandUrl, command, environment),
					1,
					$author$project$User$Command$encode(command),
					_List_Nil));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$User$Service$sendCommand = F4(
	function (command, environment, toMsg, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$User$Service$SendingCommand,
						A3($author$project$User$Service$sendCommandHelper, command, environment, toMsg)));
			case 1:
				return $elm$core$Result$Err(0);
			case 2:
				return $elm$core$Result$Err(0);
			case 3:
				var users = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple3(
						environment,
						$author$project$User$Service$FetchedAndSendingCommand(users),
						A3($author$project$User$Service$sendCommandHelper, command, environment, toMsg)));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$sendUserCommands = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isOffline(environment)) {
		return _Utils_Tuple3(environment, repository, cmds);
	} else {
		var _v1 = $author$project$User$Store$dequeueCommands(data.ah);
		if (!_v1.a.$) {
			var command = _v1.a.a;
			var newUserStore = _v1.b;
			return A2(
				$elm$core$Result$withDefault,
				_Utils_Tuple3(environment, repository, cmds),
				A2(
					$elm$core$Result$map,
					$author$project$Utils$Triple$mapThird(
						A2($author$project$Utils$Utils$flip, $elm$core$List$cons, cmds)),
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Triple$mapSecond(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Environments$Repository$setUserService(repository),
								$author$project$Environments$Repository$withUserStore(newUserStore))),
						A4($author$project$User$Service$sendCommand, command, environment, $author$project$Environments$Repository$ReceivedHttpResponse, data.bA))));
		} else {
			var _v2 = _v1.a;
			var newUserStore = _v1.b;
			return _Utils_Tuple3(
				environment,
				A2($author$project$Environments$Repository$withUserStore, newUserStore, repository),
				cmds);
		}
	}
};
var $author$project$File$Synchronization$Stopped = {$: 0};
var $author$project$File$Synchronization$isStopped = $elm$core$Basics$eq($author$project$File$Synchronization$Stopped);
var $author$project$File$Synchronization$stopped = $author$project$File$Synchronization$Stopped;
var $author$project$File$Store$synchronization = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$File$Synchronization$stopped;
		case 1:
			var data = state.a;
			return data.b;
		default:
			var data = state.a;
			return data.b;
	}
};
var $author$project$File$Store$isSynchronizationStopped = A2($elm$core$Basics$composeR, $author$project$File$Store$synchronization, $author$project$File$Synchronization$isStopped);
var $author$project$File$Store$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$File$Store$DeleteFile = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$File$Store$DownloadFile = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$File$Store$UploadFile = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$File$File$getAuditFilePath = F2(
	function (auditId, recordId) {
		return 'audits/' + ($author$project$Audit$Id$toString(auditId) + ('/records/' + $author$project$Audit$Record$Id$toString(recordId)));
	});
var $author$project$File$File$toPath = function (file) {
	switch (file.$) {
		case 0:
			var userAvatarData = file.a;
			return 'users/' + $author$project$User$Id$toString(userAvatarData.dk);
		case 1:
			var organisationUnitData = file.a;
			return 'organisationUnits/' + $author$project$OrganisationUnit$Id$toString(organisationUnitData.km);
		case 2:
			var measureImageData = file.a;
			return 'organisationUnits/' + ($author$project$OrganisationUnit$Id$toString(measureImageData.km) + ('/measures/' + $author$project$Measure$Id$toString(measureImageData.h5)));
		default:
			var recordImageData = file.a;
			return A2($author$project$File$File$getAuditFilePath, recordImageData.gm, recordImageData.bK);
	}
};
var $author$project$File$Store$sendSynchronizationTask = F2(
	function (environment, synchronizationTask) {
		switch (synchronizationTask.$) {
			case 0:
				var file = synchronizationTask.a;
				return $author$project$File$Store$send(
					A3(
						$author$project$File$Store$UploadFile,
						$author$project$Environments$Environment$apiVersion(environment),
						$author$project$File$File$toPath(file),
						file));
			case 1:
				var file = synchronizationTask.a;
				return $author$project$File$Store$send(
					A3(
						$author$project$File$Store$DownloadFile,
						$author$project$Environments$Environment$apiVersion(environment),
						$author$project$File$File$toPath(file),
						file));
			default:
				var file = synchronizationTask.a;
				return $author$project$File$Store$send(
					A3(
						$author$project$File$Store$DeleteFile,
						$author$project$Environments$Environment$apiVersion(environment),
						$author$project$File$File$toPath(file),
						file));
		}
	});
var $author$project$File$Synchronization$start = F2(
	function (files, state) {
		switch (state.$) {
			case 0:
				return $author$project$File$Synchronization$Started(
					$author$project$File$SynchronizationTasks$fromFiles(files));
			case 1:
				return state;
			default:
				return state;
		}
	});
var $author$project$Utils$Tuple$swap = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	return _Utils_Tuple2(b, a);
};
var $author$project$File$SynchronizationTasks$dequeue = $author$project$Types$Queue$dequeue;
var $author$project$File$Synchronization$synchronize = function (state) {
	switch (state.$) {
		case 0:
			return _Utils_Tuple2($elm$core$Maybe$Nothing, state);
		case 1:
			var synchronizationTasks = state.a;
			var _v1 = $author$project$File$SynchronizationTasks$dequeue(synchronizationTasks);
			if (_v1.a.$ === 1) {
				var _v2 = _v1.a;
				var newSynchronizationTasks = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$File$Synchronization$Started(newSynchronizationTasks));
			} else {
				var synchronizationTask = _v1.a;
				var newSynchronizationTasks = _v1.b;
				return _Utils_Tuple2(
					synchronizationTask,
					$author$project$File$Synchronization$Synchronizing(newSynchronizationTasks));
			}
		default:
			return _Utils_Tuple2($elm$core$Maybe$Nothing, state);
	}
};
var $author$project$File$Store$startSynchronization = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				var _v1 = A2(
					$elm$core$Tuple$mapSecond,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$author$project$File$Store$sendSynchronizationTask(environment)),
						$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none)),
					$author$project$Utils$Tuple$swap(
						$author$project$File$Synchronization$synchronize(
							A2($author$project$File$Synchronization$start, data.cT, data.b))));
				var newSynchronization = _v1.a;
				var synchronizationCmd = _v1.b;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$File$Store$Loaded(
							_Utils_update(
								data,
								{b: newSynchronization})),
						synchronizationCmd));
			default:
				var data = state.a;
				var newSynchronization = A2($author$project$File$Synchronization$start, data.cT, data.b);
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$File$Store$Saving(
							_Utils_update(
								data,
								{b: newSynchronization})),
						$elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Environments$Repository$startFileSynchronization = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	if ($author$project$Environments$Environment$isActive(environment) && ($author$project$Environments$Environment$isOnline(environment) && $author$project$File$Store$isSynchronizationStopped(data.ad))) {
		var _v1 = A2($author$project$File$Store$startSynchronization, environment, data.ad);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var newFileStore = _v2.a;
			var fileStoreCmd = _v2.b;
			return _Utils_Tuple3(
				environment,
				A2($author$project$Environments$Repository$withFileStore, newFileStore, repository),
				A2($elm$core$List$cons, fileStoreCmd, cmds));
		} else {
			return _Utils_Tuple3(environment, repository, cmds);
		}
	} else {
		return _Utils_Tuple3(environment, repository, cmds);
	}
};
var $author$project$Environments$Repository$setFileStore = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withFileStore);
var $author$project$File$Store$withSynchronization = F2(
	function (synchronization_, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				var data = state.a;
				return $author$project$File$Store$Loaded(
					_Utils_update(
						data,
						{b: synchronization_}));
			default:
				var data = state.a;
				return $author$project$File$Store$Saving(
					_Utils_update(
						data,
						{b: synchronization_}));
		}
	});
var $author$project$File$Store$stopSynchronization = $author$project$File$Store$withSynchronization($author$project$File$Synchronization$stopped);
var $author$project$Environments$Repository$stopFileSynchronization = function (_v0) {
	var environment = _v0.a;
	var repository = _v0.b;
	var data = repository;
	var cmds = _v0.c;
	return ($author$project$Environments$Environment$isOnline(environment) || $author$project$File$Store$isSynchronizationStopped(data.ad)) ? _Utils_Tuple3(environment, repository, cmds) : _Utils_Tuple3(
		environment,
		A2(
			$author$project$Environments$Repository$setFileStore,
			repository,
			$author$project$File$Store$stopSynchronization(data.ad)),
		cmds);
};
var $author$project$Audit$Store$loadedData = F3(
	function (data, state, environment) {
		if (!state.$) {
			return ($author$project$Utils$Maybe$isJust(
				$author$project$Audit$Audits$lastEventId(data.aC)) || $author$project$Environments$Environment$isOffline(environment)) ? $author$project$Audit$Store$Loaded(
				{aC: data.aC, cD: data.cD, b8: data.b8}) : $author$project$Audit$Store$Uninitialized(
				{cD: data.cD, b8: data.b8});
		} else {
			return state;
		}
	});
var $author$project$Audit$Store$noChange = $elm$core$Basics$identity;
var $author$project$Audit$Store$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'Audit.Store.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$Audit$Event$commandId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.L;
		case 1:
			var payload = event.a;
			return payload.L;
		case 2:
			var payload = event.a;
			return payload.L;
		case 3:
			var payload = event.a;
			return payload.L;
		case 4:
			var payload = event.a;
			return payload.L;
		case 5:
			var payload = event.a;
			return payload.L;
		case 6:
			var payload = event.a;
			return payload.L;
		case 7:
			var payload = event.a;
			return payload.L;
		case 8:
			var payload = event.a;
			return payload.L;
		default:
			var payload = event.a;
			return payload.L;
	}
};
var $author$project$Audit$Events$fromList = $author$project$Types$Queue$fromList;
var $author$project$Audit$Events$toList = $author$project$Types$Queue$toList;
var $author$project$Audit$Event$version = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.n;
		case 1:
			var payload = event.a;
			return payload.n;
		case 2:
			var payload = event.a;
			return payload.n;
		case 3:
			var payload = event.a;
			return payload.n;
		case 4:
			var payload = event.a;
			return payload.n;
		case 5:
			var payload = event.a;
			return payload.n;
		case 6:
			var payload = event.a;
			return payload.n;
		case 7:
			var payload = event.a;
			return payload.n;
		case 8:
			var payload = event.a;
			return payload.n;
		default:
			var payload = event.a;
			return payload.n;
	}
};
var $author$project$Audit$Store$removeEvent = F4(
	function (commandId, auditId, eventVersion, data) {
		return _Utils_update(
			data,
			{
				b8: $author$project$Audit$Events$fromList(
					A2(
						$elm$core$List$filter,
						function (event) {
							return !(_Utils_eq(
								$author$project$Audit$Event$commandId(event),
								commandId) && (_Utils_eq(
								$author$project$Audit$Event$auditId(event),
								auditId) && _Utils_eq(
								$author$project$Audit$Event$version(event),
								eventVersion)));
						},
						$author$project$Audit$Events$toList(data.b8)))
			});
	});
var $author$project$Audit$Store$removedCommandAndEvent = F4(
	function (state, commandId, auditId, eventVersion) {
		switch (state.$) {
			case 0:
				return $author$project$Audit$Store$Loading;
			case 1:
				var record = state.a;
				return $author$project$Audit$Store$Uninitialized(
					A4($author$project$Audit$Store$removeEvent, commandId, auditId, eventVersion, record));
			case 2:
				var data = state.a;
				return $author$project$Audit$Store$Loaded(
					A4($author$project$Audit$Store$removeEvent, commandId, auditId, eventVersion, data));
			default:
				var data = state.a;
				return $author$project$Audit$Store$Saving(
					A4($author$project$Audit$Store$removeEvent, commandId, auditId, eventVersion, data));
		}
	});
var $author$project$Audit$Store$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var data = msg.a;
				return _Utils_Tuple2(
					environment,
					A3($author$project$Audit$Store$loadedData, data, state, environment));
			case 1:
				return _Utils_Tuple2(
					environment,
					$author$project$Audit$Store$noChange(state));
			case 2:
				return _Utils_Tuple2(
					environment,
					$author$project$Audit$Store$noChange(state));
			case 3:
				return _Utils_Tuple2(
					environment,
					$author$project$Audit$Store$noChange(state));
			case 4:
				return _Utils_Tuple2(
					environment,
					$author$project$Audit$Store$noChange(state));
			case 5:
				var commandId = msg.a;
				var auditId = msg.b;
				var eventVersion = msg.c;
				return _Utils_Tuple2(
					environment,
					A4($author$project$Audit$Store$removedCommandAndEvent, state, commandId, auditId, eventVersion));
			default:
				var err = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Audit$Store$receivedErrorMsg, err, environment),
					state);
		}
	});
var $author$project$Environments$Repository$receivedAuditStoreMsg = F3(
	function (storeMsg, environment, repository) {
		var _v0 = A3(
			$author$project$Audit$Store$update,
			storeMsg,
			environment,
			$author$project$Environments$Repository$auditStore(repository));
		var newEnvironment = _v0.a;
		var newState = _v0.b;
		return _Utils_Tuple3(
			newEnvironment,
			A2($author$project$Environments$Repository$withAuditStore, newState, repository),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Environments$Repository$checkpointDataStore = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.C;
	});
var $author$project$CheckpointData$Store$loadedData = F2(
	function (data, state) {
		switch (state.$) {
			case 0:
				return $author$project$Utils$Maybe$isJust(
					$author$project$CheckpointData$CheckpointData$lastEventId(data.a)) ? $author$project$CheckpointData$Store$Loaded(
					{a: data.a, cD: data.cD, b8: data.b8}) : $author$project$CheckpointData$Store$Uninitialized(
					{cD: data.cD, b8: data.b8});
			case 1:
				return state;
			case 2:
				return state;
			default:
				return state;
		}
	});
var $author$project$CheckpointData$Store$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'CheckpointData.Store.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$CheckpointData$Store$removedCommand = $elm$core$Basics$identity;
var $author$project$CheckpointData$Event$commandId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.L;
		case 1:
			var payload = event.a;
			return payload.L;
		case 2:
			var payload = event.a;
			return payload.L;
		case 3:
			var payload = event.a;
			return payload.L;
		case 4:
			var payload = event.a;
			return payload.L;
		case 5:
			var payload = event.a;
			return payload.L;
		case 6:
			var payload = event.a;
			return payload.L;
		case 7:
			var payload = event.a;
			return payload.L;
		case 8:
			var payload = event.a;
			return payload.L;
		case 9:
			var payload = event.a;
			return payload.L;
		case 10:
			var payload = event.a;
			return payload.L;
		case 11:
			var payload = event.a;
			return payload.L;
		case 12:
			var payload = event.a;
			return payload.L;
		case 13:
			var payload = event.a;
			return payload.L;
		default:
			var payload = event.a;
			return payload.L;
	}
};
var $author$project$CheckpointData$Events$fromList = $author$project$Types$Queue$fromList;
var $author$project$CheckpointData$Events$toList = $author$project$Types$Queue$toList;
var $author$project$CheckpointData$Event$version = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.n;
		case 1:
			var payload = event.a;
			return payload.n;
		case 2:
			var payload = event.a;
			return payload.n;
		case 3:
			var payload = event.a;
			return payload.n;
		case 4:
			var payload = event.a;
			return payload.n;
		case 5:
			var payload = event.a;
			return payload.n;
		case 6:
			var payload = event.a;
			return payload.n;
		case 7:
			var payload = event.a;
			return payload.n;
		case 8:
			var payload = event.a;
			return payload.n;
		case 9:
			var payload = event.a;
			return payload.n;
		case 10:
			var payload = event.a;
			return payload.n;
		case 11:
			var payload = event.a;
			return payload.n;
		case 12:
			var payload = event.a;
			return payload.n;
		case 13:
			var payload = event.a;
			return payload.n;
		default:
			var payload = event.a;
			return payload.n;
	}
};
var $author$project$CheckpointData$Store$removeEvent = F3(
	function (commandId, eventVersion, data) {
		return _Utils_update(
			data,
			{
				b8: $author$project$CheckpointData$Events$fromList(
					A2(
						$elm$core$List$filter,
						function (event) {
							return !(_Utils_eq(
								$author$project$CheckpointData$Event$commandId(event),
								commandId) && _Utils_eq(
								$author$project$CheckpointData$Event$version(event),
								eventVersion));
						},
						$author$project$CheckpointData$Events$toList(data.b8)))
			});
	});
var $author$project$CheckpointData$Store$removedCommandAndEvent = F3(
	function (state, commandId, eventVersion) {
		switch (state.$) {
			case 0:
				return $author$project$CheckpointData$Store$Loading;
			case 1:
				var record = state.a;
				return $author$project$CheckpointData$Store$Uninitialized(
					A3($author$project$CheckpointData$Store$removeEvent, commandId, eventVersion, record));
			case 2:
				var data = state.a;
				return $author$project$CheckpointData$Store$Loaded(
					A3($author$project$CheckpointData$Store$removeEvent, commandId, eventVersion, data));
			default:
				var data = state.a;
				return $author$project$CheckpointData$Store$Saving(
					A3($author$project$CheckpointData$Store$removeEvent, commandId, eventVersion, data));
		}
	});
var $author$project$CheckpointData$Store$savedCheckpointData = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$CheckpointData$Store$Loaded(data);
	}
};
var $author$project$CheckpointData$Store$savedCommandsAndEvents = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$CheckpointData$Store$Loaded(data);
	}
};
var $author$project$CheckpointData$Store$savedModifications = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$CheckpointData$Store$Loaded(data);
	}
};
var $author$project$CheckpointData$Store$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var data = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$CheckpointData$Store$loadedData, data, state));
			case 1:
				return _Utils_Tuple2(
					environment,
					$author$project$CheckpointData$Store$savedCheckpointData(state));
			case 2:
				return _Utils_Tuple2(
					environment,
					$author$project$CheckpointData$Store$savedModifications(state));
			case 3:
				return _Utils_Tuple2(
					environment,
					$author$project$CheckpointData$Store$savedCommandsAndEvents(state));
			case 4:
				return _Utils_Tuple2(
					environment,
					$author$project$CheckpointData$Store$removedCommand(state));
			case 5:
				var commandId = msg.a;
				var eventVersion = msg.b;
				return _Utils_Tuple2(
					environment,
					A3($author$project$CheckpointData$Store$removedCommandAndEvent, state, commandId, eventVersion));
			default:
				var err = msg.a;
				return _Utils_Tuple2(
					A2($author$project$CheckpointData$Store$receivedErrorMsg, err, environment),
					state);
		}
	});
var $author$project$Environments$Repository$receivedCheckpointDataStoreMsg = F3(
	function (storeMsg, environment, repository) {
		var _v0 = A3(
			$author$project$CheckpointData$Store$update,
			storeMsg,
			environment,
			$author$project$Environments$Repository$checkpointDataStore(repository));
		var newEnvironment = _v0.a;
		var newState = _v0.b;
		return _Utils_Tuple3(
			newEnvironment,
			A2($author$project$Environments$Repository$withCheckpointDataStore, newState, repository),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$EventStream$EventStream$Reconnecting = function (a) {
	return {$: 3, a: a};
};
var $author$project$EventStream$EventStream$reconnect = F2(
	function (previousTries, parameters) {
		return _Utils_Tuple2(
			$author$project$EventStream$EventStream$Reconnecting(previousTries),
			$author$project$EventStream$EventStream$eventStreamOutbox(
				$author$project$EventStream$EventStream$encodeOutMsg(
					$author$project$EventStream$EventStream$Connect(parameters))));
	});
var $author$project$EventStream$EventStream$Unknown = 0;
var $author$project$Audit$Events$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$EventStream$EventStream$receivedAuditEvent = F2(
	function (event, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{
						s: $author$project$Audit$Events$singleton(event),
						A: 0,
						t: $author$project$CheckpointData$Events$empty,
						B: 0,
						u: $author$project$Measure$Events$empty,
						D: 0,
						v: $author$project$OrganisationUnit$Events$empty,
						E: 0,
						w: $author$project$Plan$Events$empty,
						F: 0,
						x: $author$project$Rights$Events$empty,
						G: 0,
						y: $author$project$Tenant$Events$empty,
						H: 0,
						z: $author$project$User$Events$empty,
						I: 0,
						m: $author$project$EventStream$SyncWarning$defaultWarningConfig
					});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{
							s: A2($author$project$Audit$Events$enqueue, event, data.s)
						}));
		}
	});
var $author$project$EventStream$EventStream$receivedAuditStatus = F2(
	function (auditStatus, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{s: $author$project$Audit$Events$empty, A: auditStatus, t: $author$project$CheckpointData$Events$empty, B: 0, u: $author$project$Measure$Events$empty, D: 0, v: $author$project$OrganisationUnit$Events$empty, E: 0, w: $author$project$Plan$Events$empty, F: 0, x: $author$project$Rights$Events$empty, G: 0, y: $author$project$Tenant$Events$empty, H: 0, z: $author$project$User$Events$empty, I: 0, m: $author$project$EventStream$SyncWarning$defaultWarningConfig});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{A: auditStatus}));
		}
	});
var $author$project$CheckpointData$Events$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$CheckpointData$Events$singleton = $author$project$Types$Queue$singleton;
var $author$project$EventStream$EventStream$receivedCheckpointDataEvent = F2(
	function (event, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{
						s: $author$project$Audit$Events$empty,
						A: 0,
						t: $author$project$CheckpointData$Events$singleton(event),
						B: 0,
						u: $author$project$Measure$Events$empty,
						D: 0,
						v: $author$project$OrganisationUnit$Events$empty,
						E: 0,
						w: $author$project$Plan$Events$empty,
						F: 0,
						x: $author$project$Rights$Events$empty,
						G: 0,
						y: $author$project$Tenant$Events$empty,
						H: 0,
						z: $author$project$User$Events$empty,
						I: 0,
						m: $author$project$EventStream$SyncWarning$defaultWarningConfig
					});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{
							t: A2($author$project$CheckpointData$Events$enqueue, event, data.t)
						}));
		}
	});
var $author$project$EventStream$EventStream$receivedCheckpointDataStatus = F2(
	function (checkpointDataStatus, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{s: $author$project$Audit$Events$empty, A: 0, t: $author$project$CheckpointData$Events$empty, B: checkpointDataStatus, u: $author$project$Measure$Events$empty, D: 0, v: $author$project$OrganisationUnit$Events$empty, E: 0, w: $author$project$Plan$Events$empty, F: 0, x: $author$project$Rights$Events$empty, G: 0, y: $author$project$Tenant$Events$empty, H: 0, z: $author$project$User$Events$empty, I: 0, m: $author$project$EventStream$SyncWarning$defaultWarningConfig});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{B: checkpointDataStatus}));
		}
	});
var $author$project$EventStream$EventStream$receivedErrorMsg = F2(
	function (err, environment) {
		if (A2(
			$elm$core$String$contains,
			'isTrusted',
			$author$project$Environments$ErrorHandling$Error$decodeErrorToString(err)) || A2(
			$elm$core$String$contains,
			'timed out',
			$author$project$Environments$ErrorHandling$Error$decodeErrorToString(err))) {
			return environment;
		} else {
			var _v0 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Environments$ErrorHandling$Id$from,
				$author$project$Environments$Environment$generateUuid(environment));
			var newId = _v0.a;
			var newEnvironment = _v0.b;
			var newError = {
				gg: '',
				gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
				gH: 'EventStream.EventStream.elm',
				gK: 'receivedErrorMsg',
				fw: newId
			};
			return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
		}
	});
var $author$project$EventStream$EventStream$receivedMeasureEvent = F2(
	function (event, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{
						s: $author$project$Audit$Events$empty,
						A: 0,
						t: $author$project$CheckpointData$Events$empty,
						B: 0,
						u: $author$project$Measure$Events$singleton(event),
						D: 0,
						v: $author$project$OrganisationUnit$Events$empty,
						E: 0,
						w: $author$project$Plan$Events$empty,
						F: 0,
						x: $author$project$Rights$Events$empty,
						G: 0,
						y: $author$project$Tenant$Events$empty,
						H: 0,
						z: $author$project$User$Events$empty,
						I: 0,
						m: $author$project$EventStream$SyncWarning$defaultWarningConfig
					});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{
							u: A2($author$project$Measure$Events$enqueue, event, data.u)
						}));
		}
	});
var $author$project$EventStream$EventStream$receivedMeasureStatus = F2(
	function (measureStatus, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{s: $author$project$Audit$Events$empty, A: 0, t: $author$project$CheckpointData$Events$empty, B: 0, u: $author$project$Measure$Events$empty, D: measureStatus, v: $author$project$OrganisationUnit$Events$empty, E: 0, w: $author$project$Plan$Events$empty, F: 0, x: $author$project$Rights$Events$empty, G: 0, y: $author$project$Tenant$Events$empty, H: 0, z: $author$project$User$Events$empty, I: 0, m: $author$project$EventStream$SyncWarning$defaultWarningConfig});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{D: measureStatus}));
		}
	});
var $author$project$OrganisationUnit$Events$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$OrganisationUnit$Events$singleton = $author$project$Types$Queue$singleton;
var $author$project$EventStream$EventStream$receivedOrganisationUnitEvent = F2(
	function (event, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{
						s: $author$project$Audit$Events$empty,
						A: 0,
						t: $author$project$CheckpointData$Events$empty,
						B: 0,
						u: $author$project$Measure$Events$empty,
						D: 0,
						v: $author$project$OrganisationUnit$Events$singleton(event),
						E: 0,
						w: $author$project$Plan$Events$empty,
						F: 0,
						x: $author$project$Rights$Events$empty,
						G: 0,
						y: $author$project$Tenant$Events$empty,
						H: 0,
						z: $author$project$User$Events$empty,
						I: 0,
						m: $author$project$EventStream$SyncWarning$defaultWarningConfig
					});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{
							v: A2($author$project$OrganisationUnit$Events$enqueue, event, data.v)
						}));
		}
	});
var $author$project$EventStream$EventStream$receivedOrganisationUnitStatus = F2(
	function (organisationUnitStatus, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{s: $author$project$Audit$Events$empty, A: 0, t: $author$project$CheckpointData$Events$empty, B: 0, u: $author$project$Measure$Events$empty, D: 0, v: $author$project$OrganisationUnit$Events$empty, E: organisationUnitStatus, w: $author$project$Plan$Events$empty, F: 0, x: $author$project$Rights$Events$empty, G: 0, y: $author$project$Tenant$Events$empty, H: 0, z: $author$project$User$Events$empty, I: 0, m: $author$project$EventStream$SyncWarning$defaultWarningConfig});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{E: organisationUnitStatus}));
		}
	});
var $author$project$Plan$Events$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$EventStream$EventStream$receivedPlanEvent = F2(
	function (event, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{
						s: $author$project$Audit$Events$empty,
						A: 0,
						t: $author$project$CheckpointData$Events$empty,
						B: 0,
						u: $author$project$Measure$Events$empty,
						D: 0,
						v: $author$project$OrganisationUnit$Events$empty,
						E: 0,
						w: $author$project$Plan$Events$singleton(event),
						F: 0,
						x: $author$project$Rights$Events$empty,
						G: 0,
						y: $author$project$Tenant$Events$empty,
						H: 0,
						z: $author$project$User$Events$empty,
						I: 0,
						m: $author$project$EventStream$SyncWarning$defaultWarningConfig
					});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{
							w: A2($author$project$Plan$Events$enqueue, event, data.w)
						}));
		}
	});
var $author$project$EventStream$EventStream$receivedPlanStatus = F2(
	function (planStatus, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{s: $author$project$Audit$Events$empty, A: 0, t: $author$project$CheckpointData$Events$empty, B: 0, u: $author$project$Measure$Events$empty, D: 0, v: $author$project$OrganisationUnit$Events$empty, E: 0, w: $author$project$Plan$Events$empty, F: planStatus, x: $author$project$Rights$Events$empty, G: 0, y: $author$project$Tenant$Events$empty, H: 0, z: $author$project$User$Events$empty, I: 0, m: $author$project$EventStream$SyncWarning$defaultWarningConfig});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{F: planStatus}));
		}
	});
var $author$project$Rights$Events$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$Rights$Events$singleton = $author$project$Types$Queue$singleton;
var $author$project$EventStream$EventStream$receivedRightsEvent = F2(
	function (event, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{
						s: $author$project$Audit$Events$empty,
						A: 0,
						t: $author$project$CheckpointData$Events$empty,
						B: 0,
						u: $author$project$Measure$Events$empty,
						D: 0,
						v: $author$project$OrganisationUnit$Events$empty,
						E: 0,
						w: $author$project$Plan$Events$empty,
						F: 0,
						x: $author$project$Rights$Events$singleton(event),
						G: 0,
						y: $author$project$Tenant$Events$empty,
						H: 0,
						z: $author$project$User$Events$empty,
						I: 0,
						m: $author$project$EventStream$SyncWarning$defaultWarningConfig
					});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{
							x: A2($author$project$Rights$Events$enqueue, event, data.x)
						}));
		}
	});
var $author$project$EventStream$EventStream$receivedRightsStatus = F2(
	function (rightsStatus, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{s: $author$project$Audit$Events$empty, A: 0, t: $author$project$CheckpointData$Events$empty, B: 0, u: $author$project$Measure$Events$empty, D: 0, v: $author$project$OrganisationUnit$Events$empty, E: 0, w: $author$project$Plan$Events$empty, F: 0, x: $author$project$Rights$Events$empty, G: rightsStatus, y: $author$project$Tenant$Events$empty, H: 0, z: $author$project$User$Events$empty, I: 0, m: $author$project$EventStream$SyncWarning$defaultWarningConfig});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{G: rightsStatus}));
		}
	});
var $author$project$EventStream$EventStream$receivedStatus = F3(
	function (status, environment, state) {
		var _v0 = _Utils_Tuple2(status, state);
		_v0$7:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					switch (_v0.b.$) {
						case 2:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return _Utils_Tuple2(
								environment,
								$author$project$EventStream$EventStream$Connected(
									{s: $author$project$Audit$Events$empty, A: 0, t: $author$project$CheckpointData$Events$empty, B: 0, u: $author$project$Measure$Events$empty, D: 0, v: $author$project$OrganisationUnit$Events$empty, E: 0, w: $author$project$Plan$Events$empty, F: 0, x: $author$project$Rights$Events$empty, G: 0, y: $author$project$Tenant$Events$empty, H: 0, z: $author$project$User$Events$empty, I: 0, m: $author$project$EventStream$SyncWarning$defaultWarningConfig}));
						case 3:
							var _v3 = _v0.a;
							return _Utils_Tuple2(
								environment,
								$author$project$EventStream$EventStream$Connected(
									{s: $author$project$Audit$Events$empty, A: 0, t: $author$project$CheckpointData$Events$empty, B: 0, u: $author$project$Measure$Events$empty, D: 0, v: $author$project$OrganisationUnit$Events$empty, E: 0, w: $author$project$Plan$Events$empty, F: 0, x: $author$project$Rights$Events$empty, G: 0, y: $author$project$Tenant$Events$empty, H: 0, z: $author$project$User$Events$empty, I: 0, m: $author$project$EventStream$SyncWarning$defaultWarningConfig}));
						default:
							break _v0$7;
					}
				case 0:
					var _v4 = _v0.a;
					return _Utils_Tuple2(environment, $author$project$EventStream$EventStream$Disconnected);
				default:
					switch (_v0.b.$) {
						case 0:
							var _v5 = _v0.b;
							return _Utils_Tuple2(environment, state);
						case 4:
							return _Utils_Tuple2(
								environment,
								$author$project$EventStream$EventStream$Reconnecting(1));
						case 2:
							var _v6 = _v0.b;
							return _Utils_Tuple2(
								environment,
								$author$project$EventStream$EventStream$Reconnecting(1));
						case 3:
							var error = _v0.a.a;
							var tries = _v0.b.a;
							if ($author$project$Environments$Environment$isOffline(environment) || $author$project$Environments$Environment$isInactive(environment)) {
								return _Utils_Tuple2(environment, $author$project$EventStream$EventStream$Disconnected);
							} else {
								if (tries <= 5) {
									return _Utils_Tuple2(
										environment,
										$author$project$EventStream$EventStream$Reconnecting(tries + 1));
								} else {
									if (A2($elm$core$String$contains, 'isTrusted', error)) {
										return _Utils_Tuple2(environment, $author$project$EventStream$EventStream$Error);
									} else {
										if (A2($elm$core$String$contains, 'timed out', error)) {
											return _Utils_Tuple2(environment, state);
										} else {
											var _v7 = A2(
												$elm$core$Tuple$mapFirst,
												$author$project$Environments$ErrorHandling$Id$from,
												$author$project$Environments$Environment$generateUuid(environment));
											var newId = _v7.a;
											var newEnvironment = _v7.b;
											var newError = {
												gg: 'Received \'Error Status\' from port',
												gE: $author$project$Environments$ErrorHandling$Error$OtherError('EventStreamError: ' + error),
												gH: 'EventStream.EventStream.elm',
												gK: 'decodeStatus',
												fw: newId
											};
											return _Utils_Tuple2(
												A2($author$project$Environments$Environment$addError, newError, newEnvironment),
												$author$project$EventStream$EventStream$Error);
										}
									}
								}
							}
						default:
							break _v0$7;
					}
			}
		}
		return _Utils_Tuple2(environment, state);
	});
var $author$project$Tenant$Events$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$Tenant$Events$singleton = $author$project$Types$Queue$singleton;
var $author$project$EventStream$EventStream$receivedTenantEvent = F2(
	function (event, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{
						s: $author$project$Audit$Events$empty,
						A: 0,
						t: $author$project$CheckpointData$Events$empty,
						B: 0,
						u: $author$project$Measure$Events$empty,
						D: 0,
						v: $author$project$OrganisationUnit$Events$empty,
						E: 0,
						w: $author$project$Plan$Events$empty,
						F: 0,
						x: $author$project$Rights$Events$empty,
						G: 0,
						y: $author$project$Tenant$Events$singleton(event),
						H: 0,
						z: $author$project$User$Events$empty,
						I: 0,
						m: $author$project$EventStream$SyncWarning$defaultWarningConfig
					});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{
							y: A2($author$project$Tenant$Events$enqueue, event, data.y)
						}));
		}
	});
var $author$project$EventStream$EventStream$receivedTenantStatus = F2(
	function (tenantStatus, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{s: $author$project$Audit$Events$empty, A: 0, t: $author$project$CheckpointData$Events$empty, B: 0, u: $author$project$Measure$Events$empty, D: 0, v: $author$project$OrganisationUnit$Events$empty, E: 0, w: $author$project$Plan$Events$empty, F: 0, x: $author$project$Rights$Events$empty, G: 0, y: $author$project$Tenant$Events$empty, H: tenantStatus, z: $author$project$User$Events$empty, I: 0, m: $author$project$EventStream$SyncWarning$defaultWarningConfig});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{H: tenantStatus}));
		}
	});
var $author$project$User$Events$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$User$Events$singleton = $author$project$Types$Queue$singleton;
var $author$project$EventStream$EventStream$receivedUserEvent = F2(
	function (event, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{
						s: $author$project$Audit$Events$empty,
						A: 0,
						t: $author$project$CheckpointData$Events$empty,
						B: 0,
						u: $author$project$Measure$Events$empty,
						D: 0,
						v: $author$project$OrganisationUnit$Events$empty,
						E: 0,
						w: $author$project$Plan$Events$empty,
						F: 0,
						x: $author$project$Rights$Events$empty,
						G: 0,
						y: $author$project$Tenant$Events$empty,
						H: 0,
						z: $author$project$User$Events$singleton(event),
						I: 0,
						m: $author$project$EventStream$SyncWarning$defaultWarningConfig
					});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{
							z: A2($author$project$User$Events$enqueue, event, data.z)
						}));
		}
	});
var $author$project$EventStream$EventStream$receivedUserStatus = F2(
	function (userStatus, state) {
		switch (state.$) {
			case 0:
				return state;
			case 1:
				return state;
			case 2:
				return $author$project$EventStream$EventStream$Connected(
					{s: $author$project$Audit$Events$empty, A: 0, t: $author$project$CheckpointData$Events$empty, B: 0, u: $author$project$Measure$Events$empty, D: 0, v: $author$project$OrganisationUnit$Events$empty, E: 0, w: $author$project$Plan$Events$empty, F: 0, x: $author$project$Rights$Events$empty, G: 0, y: $author$project$Tenant$Events$empty, H: 0, z: $author$project$User$Events$empty, I: userStatus, m: $author$project$EventStream$SyncWarning$defaultWarningConfig});
			case 3:
				return state;
			default:
				var data = state.a;
				return $author$project$EventStream$EventStream$Connected(
					_Utils_update(
						data,
						{I: userStatus}));
		}
	});
var $author$project$EventStream$EventStream$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var status = msg.a;
				return A3($author$project$EventStream$EventStream$receivedStatus, status, environment, state);
			case 1:
				var status = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedUserStatus, status, state));
			case 2:
				var event = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedUserEvent, event, state));
			case 3:
				var status = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedOrganisationUnitStatus, status, state));
			case 4:
				var event = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedOrganisationUnitEvent, event, state));
			case 5:
				var status = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedPlanStatus, status, state));
			case 6:
				var event = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedPlanEvent, event, state));
			case 7:
				var status = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedAuditStatus, status, state));
			case 8:
				var event = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedAuditEvent, event, state));
			case 9:
				var status = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedMeasureStatus, status, state));
			case 10:
				var event = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedMeasureEvent, event, state));
			case 11:
				var status = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedTenantStatus, status, state));
			case 12:
				var event = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedTenantEvent, event, state));
			case 13:
				var status = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedCheckpointDataStatus, status, state));
			case 14:
				var event = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedCheckpointDataEvent, event, state));
			case 15:
				var status = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedRightsStatus, status, state));
			case 16:
				var event = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$EventStream$EventStream$receivedRightsEvent, event, state));
			default:
				var err = msg.a;
				return _Utils_Tuple2(
					A2($author$project$EventStream$EventStream$receivedErrorMsg, err, environment),
					$author$project$EventStream$EventStream$Reconnecting(1));
		}
	});
var $author$project$Environments$Repository$receivedEventStreamMsg = F3(
	function (eventStreamMsg, environment, repository) {
		var _v0 = A3(
			$author$project$EventStream$EventStream$update,
			eventStreamMsg,
			environment,
			$author$project$Environments$Repository$eventStream(repository));
		var newEnvironment = _v0.a;
		var newEventStream = _v0.b;
		var _v1 = function () {
			if (newEventStream.$ === 3) {
				var tries = newEventStream.a;
				return A2(
					$author$project$EventStream$EventStream$reconnect,
					tries,
					$author$project$Environments$Repository$eventStreamConnectParameters(repository));
			} else {
				return _Utils_Tuple2(newEventStream, $elm$core$Platform$Cmd$none);
			}
		}();
		var state = _v1.a;
		var cmd_ = _v1.b;
		return _Utils_Tuple3(
			newEnvironment,
			A2($author$project$Environments$Repository$withEventStream, state, repository),
			A2($elm$core$Platform$Cmd$map, $author$project$Environments$Repository$ReceivedEventStreamMsg, cmd_));
	});
var $author$project$File$Synchronization$synchronized = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		default:
			var synchronizationTasks = state.a;
			return $author$project$File$Synchronization$Started(synchronizationTasks);
	}
};
var $author$project$File$Store$deletedFile = F3(
	function (environment, filename, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				var newFiles = A2($author$project$File$Files$remove, filename, data.cT);
				var _v1 = A2(
					$elm$core$Tuple$mapSecond,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$author$project$File$Store$sendSynchronizationTask(environment)),
						$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none)),
					$author$project$Utils$Tuple$swap(
						$author$project$File$Synchronization$synchronize(
							$author$project$File$Synchronization$synchronized(data.b))));
				var newSynchronization = _v1.a;
				var synchronizationCmd = _v1.b;
				return _Utils_Tuple2(
					$author$project$File$Store$Loaded(
						_Utils_update(
							data,
							{cT: newFiles, b: newSynchronization})),
					synchronizationCmd);
			default:
				var data = state.a;
				var newSynchronization = $author$project$File$Synchronization$synchronized(data.b);
				var newFiles = A2($author$project$File$Files$remove, filename, data.cT);
				return _Utils_Tuple2(
					$author$project$File$Store$Saving(
						_Utils_update(
							data,
							{cT: newFiles, b: newSynchronization})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$File$File$synchronized = function (file) {
	switch (file.$) {
		case 0:
			var data = file.a;
			return $author$project$File$File$UserAvatar(
				_Utils_update(
					data,
					{kU: 2}));
		case 1:
			var data = file.a;
			return $author$project$File$File$OrganisationUnitFile(
				_Utils_update(
					data,
					{kU: 2}));
		case 2:
			var data = file.a;
			return $author$project$File$File$MeasureImage(
				_Utils_update(
					data,
					{kU: 2}));
		default:
			var data = file.a;
			return $author$project$File$File$RecordImage(
				_Utils_update(
					data,
					{kU: 2}));
	}
};
var $author$project$File$Store$downloadedFile = F3(
	function (environment, file, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				var newFile = $author$project$File$File$synchronized(file);
				var newFiles = A2($author$project$File$Files$insert, newFile, data.cT);
				var _v1 = A2(
					$elm$core$Tuple$mapSecond,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$author$project$File$Store$sendSynchronizationTask(environment)),
						$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none)),
					$author$project$Utils$Tuple$swap(
						$author$project$File$Synchronization$synchronize(
							$author$project$File$Synchronization$synchronized(data.b))));
				var newSynchronization = _v1.a;
				var synchronizationCmd = _v1.b;
				return _Utils_Tuple2(
					$author$project$File$Store$Loaded(
						{cT: newFiles, b: newSynchronization}),
					synchronizationCmd);
			default:
				var data = state.a;
				var newSynchronization = $author$project$File$Synchronization$synchronized(data.b);
				var newFile = $author$project$File$File$synchronized(file);
				var newFiles = A2($author$project$File$Files$insert, newFile, data.cT);
				return _Utils_Tuple2(
					$author$project$File$Store$Saving(
						_Utils_update(
							data,
							{cT: newFiles, b: newSynchronization})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$File$Store$errorDownloadingFile = F4(
	function (environment, status, file, state) {
		return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
	});
var $author$project$File$Operations$isEmpty = $author$project$Types$Queue$isEmpty;
var $author$project$File$Store$loadedFiles = F2(
	function (files, state) {
		switch (state.$) {
			case 0:
				var data = state.a;
				if ($author$project$File$Operations$isEmpty(data.Q) && $author$project$File$Operations$isEmpty(data.V)) {
					return _Utils_Tuple2(
						$author$project$File$Store$Loaded(
							{cT: files, b: $author$project$File$Synchronization$stopped}),
						$elm$core$Platform$Cmd$none);
				} else {
					var _v1 = A2(
						$author$project$File$Files$applyRemoteOperations,
						data.V,
						A2(
							$author$project$File$Files$applyLocalOperations,
							data.Q,
							_Utils_Tuple2(files, $author$project$File$Modifications$empty)));
					var newFiles = _v1.a;
					var modifications = _v1.b;
					return _Utils_Tuple2(
						$author$project$File$Store$Saving(
							{cT: newFiles, Q: $author$project$File$Operations$empty, V: $author$project$File$Operations$empty, b: $author$project$File$Synchronization$stopped}),
						$author$project$File$Store$send(
							$author$project$File$Store$SaveModifications(modifications)));
				}
			case 1:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$File$Store$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'File.Store.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$File$Store$savedFiles = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			default:
				var data = state.a;
				if ($author$project$File$Operations$isEmpty(data.Q) && $author$project$File$Operations$isEmpty(data.V)) {
					var _v1 = A2(
						$elm$core$Tuple$mapSecond,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$author$project$File$Store$sendSynchronizationTask(environment)),
							$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none)),
						$author$project$Utils$Tuple$swap(
							$author$project$File$Synchronization$synchronize(data.b)));
					var newSynchronization = _v1.a;
					var synchronizationCmd = _v1.b;
					return _Utils_Tuple2(
						$author$project$File$Store$Loaded(
							{cT: data.cT, b: newSynchronization}),
						synchronizationCmd);
				} else {
					var _v2 = A2(
						$author$project$File$Files$applyRemoteOperations,
						data.V,
						A2(
							$author$project$File$Files$applyLocalOperations,
							data.Q,
							_Utils_Tuple2(data.cT, $author$project$File$Modifications$empty)));
					var newFiles = _v2.a;
					var modifications = _v2.b;
					var newSynchronization = A2($author$project$File$Synchronization$withFiles, newFiles, data.b);
					return _Utils_Tuple2(
						$author$project$File$Store$Saving(
							{cT: newFiles, Q: $author$project$File$Operations$empty, V: $author$project$File$Operations$empty, b: newSynchronization}),
						$author$project$File$Store$send(
							$author$project$File$Store$SaveModifications(modifications)));
				}
		}
	});
var $author$project$File$Store$savedModifications = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			default:
				var data = state.a;
				if ($author$project$File$Operations$isEmpty(data.Q) && $author$project$File$Operations$isEmpty(data.V)) {
					var _v1 = A2(
						$elm$core$Tuple$mapSecond,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$author$project$File$Store$sendSynchronizationTask(environment)),
							$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none)),
						$author$project$Utils$Tuple$swap(
							$author$project$File$Synchronization$synchronize(data.b)));
					var newSynchronization = _v1.a;
					var synchronizationCmd = _v1.b;
					return _Utils_Tuple2(
						$author$project$File$Store$Loaded(
							{cT: data.cT, b: newSynchronization}),
						synchronizationCmd);
				} else {
					var _v2 = A2(
						$author$project$File$Files$applyRemoteOperations,
						data.V,
						A2(
							$author$project$File$Files$applyLocalOperations,
							data.Q,
							_Utils_Tuple2(data.cT, $author$project$File$Modifications$empty)));
					var newFiles = _v2.a;
					var modifications = _v2.b;
					var newSynchronization = A2($author$project$File$Synchronization$withFiles, newFiles, data.b);
					return _Utils_Tuple2(
						$author$project$File$Store$Saving(
							{cT: newFiles, Q: $author$project$File$Operations$empty, V: $author$project$File$Operations$empty, b: newSynchronization}),
						$author$project$File$Store$send(
							$author$project$File$Store$SaveModifications(modifications)));
				}
		}
	});
var $author$project$File$Store$uploadedFile = F3(
	function (environment, file, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				var newFile = $author$project$File$File$synchronized(file);
				var newFiles = A2($author$project$File$Files$insert, newFile, data.cT);
				var _v1 = A2(
					$elm$core$Tuple$mapSecond,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$author$project$File$Store$sendSynchronizationTask(environment)),
						$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none)),
					$author$project$Utils$Tuple$swap(
						$author$project$File$Synchronization$synchronize(
							$author$project$File$Synchronization$synchronized(data.b))));
				var newSynchronization = _v1.a;
				var synchronizationCmd = _v1.b;
				return _Utils_Tuple2(
					$author$project$File$Store$Loaded(
						{cT: newFiles, b: newSynchronization}),
					synchronizationCmd);
			default:
				var data = state.a;
				var newSynchronization = $author$project$File$Synchronization$synchronized(data.b);
				var newFile = $author$project$File$File$synchronized(file);
				var newFiles = A2($author$project$File$Files$insert, newFile, data.cT);
				return _Utils_Tuple2(
					$author$project$File$Store$Saving(
						_Utils_update(
							data,
							{cT: newFiles, b: newSynchronization})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$File$Store$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var files = msg.a;
				return A2(
					$author$project$Utils$Triple$fromTuple,
					environment,
					A2($author$project$File$Store$loadedFiles, files, state));
			case 1:
				return A2(
					$author$project$Utils$Triple$fromTuple,
					environment,
					A2($author$project$File$Store$savedFiles, environment, state));
			case 2:
				return A2(
					$author$project$Utils$Triple$fromTuple,
					environment,
					A2($author$project$File$Store$savedModifications, environment, state));
			case 3:
				var file = msg.a;
				return A2(
					$author$project$Utils$Triple$fromTuple,
					environment,
					A3($author$project$File$Store$uploadedFile, environment, file, state));
			case 4:
				var file = msg.a;
				return A2(
					$author$project$Utils$Triple$fromTuple,
					environment,
					A3($author$project$File$Store$downloadedFile, environment, file, state));
			case 5:
				var status = msg.a;
				var file = msg.b;
				return A4($author$project$File$Store$errorDownloadingFile, environment, status, file, state);
			case 6:
				var filename = msg.a;
				return A2(
					$author$project$Utils$Triple$fromTuple,
					environment,
					A3($author$project$File$Store$deletedFile, environment, filename, state));
			default:
				var err = msg.a;
				return A2(
					$author$project$Utils$Triple$fromTuple,
					A2($author$project$File$Store$receivedErrorMsg, err, environment),
					_Utils_Tuple2(state, $elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Environments$Repository$receivedFileStoreMsg = F3(
	function (storeMsg, environment, repository) {
		var _v0 = A2(
			$author$project$Utils$Triple$mapThird,
			$elm$core$Platform$Cmd$map($author$project$Environments$Repository$ReceivedFileStoreMsg),
			A2(
				$author$project$Utils$Triple$mapSecond,
				$author$project$Environments$Repository$setFileStore(repository),
				A3(
					$author$project$File$Store$update,
					storeMsg,
					environment,
					$author$project$Environments$Repository$fileStore(repository))));
		var newEnvironment = _v0.a;
		var newRepository = _v0.b;
		var cmdMsg = _v0.c;
		return _Utils_Tuple3(newEnvironment, newRepository, cmdMsg);
	});
var $author$project$EventStream$SyncWarning$Audit = function (a) {
	return {$: 3, a: a};
};
var $author$project$EventStream$SyncWarning$Visible = 1;
var $author$project$EventStream$EventStream$addWarning = F2(
	function (syncWarning, state) {
		if (state.$ === 4) {
			var data = state.a;
			var newWaningConfig = {
				h9: 1,
				f9: A2($elm$core$List$cons, syncWarning, data.m.f9)
			};
			return $author$project$EventStream$EventStream$Connected(
				_Utils_update(
					data,
					{m: newWaningConfig}));
		} else {
			return state;
		}
	});
var $author$project$Environments$Repository$addEventStreamWarning = F2(
	function (syncWarning, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				j: A2($author$project$EventStream$EventStream$addWarning, syncWarning, data.j)
			});
	});
var $author$project$Environments$Repository$auditService = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.bg;
	});
var $author$project$Environments$ErrorHandling$Http$canCommandAndEventBeRemoved = F2(
	function (status, message) {
		switch (status) {
			case 400:
				return {dS: true, d7: true, d8: true};
			case 404:
				return A2($elm$core$String$contains, 'does not exist', message) ? {dS: false, d7: true, d8: true} : {dS: true, d7: false, d8: false};
			case 409:
				return A2($elm$core$String$contains, 'does not exist', message) ? {dS: true, d7: false, d8: false} : {dS: true, d7: true, d8: true};
			default:
				return {dS: true, d7: false, d8: false};
		}
	});
var $author$project$Environments$Repository$checkpointDataService = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.bj;
	});
var $author$project$Audit$Command$commandId = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return payload.L;
		case 1:
			var payload = command.a;
			return payload.L;
		case 2:
			var payload = command.a;
			return payload.L;
		case 3:
			var payload = command.a;
			return payload.L;
		case 4:
			var payload = command.a;
			return payload.L;
		case 5:
			var payload = command.a;
			return payload.L;
		case 6:
			var payload = command.a;
			return payload.L;
		case 7:
			var payload = command.a;
			return payload.L;
		case 8:
			var payload = command.a;
			return payload.L;
		default:
			var payload = command.a;
			return payload.L;
	}
};
var $author$project$CheckpointData$Command$commandId = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return payload.L;
		case 1:
			var payload = command.a;
			return payload.L;
		case 2:
			var payload = command.a;
			return payload.L;
		case 3:
			var payload = command.a;
			return payload.L;
		case 4:
			var payload = command.a;
			return payload.L;
		case 5:
			var payload = command.a;
			return payload.L;
		case 6:
			var payload = command.a;
			return payload.L;
		case 7:
			var payload = command.a;
			return payload.L;
		case 8:
			var payload = command.a;
			return payload.L;
		case 9:
			var payload = command.a;
			return payload.L;
		case 10:
			var payload = command.a;
			return payload.L;
		case 11:
			var payload = command.a;
			return payload.L;
		case 12:
			var payload = command.a;
			return payload.L;
		case 13:
			var payload = command.a;
			return payload.L;
		default:
			var payload = command.a;
			return payload.L;
	}
};
var $author$project$Measure$Command$commandId = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return payload.L;
		case 1:
			var payload = command.a;
			return payload.L;
		case 2:
			var payload = command.a;
			return payload.L;
		case 3:
			var payload = command.a;
			return payload.L;
		case 4:
			var payload = command.a;
			return payload.L;
		case 5:
			var payload = command.a;
			return payload.L;
		case 6:
			var payload = command.a;
			return payload.L;
		case 7:
			var payload = command.a;
			return payload.L;
		case 8:
			var payload = command.a;
			return payload.L;
		default:
			var payload = command.a;
			return payload.L;
	}
};
var $author$project$OrganisationUnit$Command$commandId = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return payload.L;
		case 1:
			var payload = command.a;
			return payload.L;
		case 2:
			var payload = command.a;
			return payload.L;
		case 3:
			var payload = command.a;
			return payload.L;
		case 4:
			var payload = command.a;
			return payload.L;
		case 5:
			var payload = command.a;
			return payload.L;
		case 6:
			var payload = command.a;
			return payload.L;
		case 7:
			var payload = command.a;
			return payload.L;
		case 8:
			var payload = command.a;
			return payload.L;
		case 9:
			var payload = command.a;
			return payload.L;
		case 10:
			var payload = command.a;
			return payload.L;
		default:
			var payload = command.a;
			return payload.L;
	}
};
var $author$project$Plan$Command$commandId = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return payload.L;
		case 1:
			var payload = command.a;
			return payload.L;
		case 2:
			var payload = command.a;
			return payload.L;
		case 3:
			var payload = command.a;
			return payload.L;
		case 4:
			var payload = command.a;
			return payload.L;
		case 5:
			var payload = command.a;
			return payload.L;
		case 6:
			var payload = command.a;
			return payload.L;
		case 7:
			var payload = command.a;
			return payload.L;
		case 8:
			var payload = command.a;
			return payload.L;
		default:
			var payload = command.a;
			return payload.L;
	}
};
var $author$project$Rights$Command$commandId = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return payload.L;
		case 1:
			var payload = command.a;
			return payload.L;
		case 2:
			var payload = command.a;
			return payload.L;
		case 3:
			var payload = command.a;
			return payload.L;
		case 4:
			var payload = command.a;
			return payload.L;
		case 5:
			var payload = command.a;
			return payload.L;
		case 6:
			var payload = command.a;
			return payload.L;
		case 7:
			var payload = command.a;
			return payload.L;
		case 8:
			var payload = command.a;
			return payload.L;
		case 9:
			var payload = command.a;
			return payload.L;
		case 10:
			var payload = command.a;
			return payload.L;
		default:
			var payload = command.a;
			return payload.L;
	}
};
var $author$project$Tenant$Command$commandId = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return payload.L;
		case 1:
			var payload = command.a;
			return payload.L;
		case 2:
			var payload = command.a;
			return payload.L;
		case 3:
			var payload = command.a;
			return payload.L;
		case 4:
			var payload = command.a;
			return payload.L;
		case 5:
			var payload = command.a;
			return payload.L;
		case 6:
			var payload = command.a;
			return payload.L;
		default:
			var payload = command.a;
			return payload.L;
	}
};
var $author$project$User$Command$commandId = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return payload.L;
		case 1:
			var payload = command.a;
			return payload.L;
		case 2:
			var payload = command.a;
			return payload.L;
		case 3:
			var payload = command.a;
			return payload.L;
		case 4:
			var payload = command.a;
			return payload.L;
		case 5:
			var payload = command.a;
			return payload.L;
		case 6:
			var payload = command.a;
			return payload.L;
		case 7:
			var payload = command.a;
			return payload.L;
		case 8:
			var payload = command.a;
			return payload.L;
		default:
			var payload = command.a;
			return payload.L;
	}
};
var $author$project$Environments$Repository$measureService = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.bo;
	});
var $author$project$Environments$Repository$organisationUnitService = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.br;
	});
var $author$project$Environments$Repository$organisationUnitStore = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.T;
	});
var $author$project$Environments$Repository$planService = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.bt;
	});
var $author$project$Audit$Service$Fetched = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audit$Service$receivedAuditsResponse = F2(
	function (audits, state) {
		switch (state.$) {
			case 0:
				return $author$project$Audit$Service$Fetched(audits);
			case 1:
				return $author$project$Audit$Service$Fetched(audits);
			case 2:
				return $author$project$Audit$Service$FetchedAndSendingCommand(audits);
			case 3:
				return $author$project$Audit$Service$Fetched(audits);
			default:
				return $author$project$Audit$Service$FetchedAndSendingCommand(audits);
		}
	});
var $author$project$Audit$Service$receivedBadResponse = F2(
	function (status, state) {
		if (status === 500) {
			return state;
		} else {
			switch (state.$) {
				case 2:
					return $author$project$Audit$Service$Idle;
				case 4:
					return $author$project$Audit$Service$Idle;
				default:
					return state;
			}
		}
	});
var $author$project$CheckpointData$Service$receivedBadResponse = F2(
	function (status, state) {
		if (status === 500) {
			return state;
		} else {
			switch (state.$) {
				case 2:
					return $author$project$CheckpointData$Service$Idle;
				case 4:
					return $author$project$CheckpointData$Service$Idle;
				default:
					return state;
			}
		}
	});
var $author$project$Measure$Service$receivedBadResponse = F2(
	function (status, state) {
		if (status === 500) {
			return state;
		} else {
			switch (state.$) {
				case 2:
					return $author$project$Measure$Service$Idle;
				case 4:
					return $author$project$Measure$Service$Idle;
				default:
					return state;
			}
		}
	});
var $author$project$OrganisationUnit$Service$receivedBadResponse = F2(
	function (status, state) {
		if (status === 500) {
			return state;
		} else {
			switch (state.$) {
				case 2:
					return $author$project$OrganisationUnit$Service$Idle;
				case 4:
					return $author$project$OrganisationUnit$Service$Idle;
				default:
					return state;
			}
		}
	});
var $author$project$Plan$Service$receivedBadResponse = F2(
	function (status, state) {
		if (status === 500) {
			return state;
		} else {
			switch (state.$) {
				case 2:
					return $author$project$Plan$Service$Idle;
				case 4:
					return $author$project$Plan$Service$Idle;
				default:
					return state;
			}
		}
	});
var $author$project$Rights$Service$receivedBadResponse = F2(
	function (status, state) {
		if (status === 500) {
			return state;
		} else {
			switch (state.$) {
				case 2:
					return $author$project$Rights$Service$Idle;
				case 4:
					return $author$project$Rights$Service$Idle;
				default:
					return state;
			}
		}
	});
var $author$project$Tenant$Service$receivedBadResponse = F2(
	function (status, state) {
		if (status === 500) {
			return state;
		} else {
			switch (state.$) {
				case 2:
					return $author$project$Tenant$Service$Idle;
				case 4:
					return $author$project$Tenant$Service$Idle;
				default:
					return state;
			}
		}
	});
var $author$project$User$Service$receivedBadResponse = F2(
	function (status, state) {
		if (status === 500) {
			return state;
		} else {
			switch (state.$) {
				case 2:
					return $author$project$User$Service$Idle;
				case 4:
					return $author$project$User$Service$Idle;
				default:
					return state;
			}
		}
	});
var $author$project$CheckpointData$Service$Fetched = function (a) {
	return {$: 3, a: a};
};
var $author$project$CheckpointData$Service$receivedCheckpointDataResponse = F2(
	function (checkpointData, state) {
		switch (state.$) {
			case 0:
				return $author$project$CheckpointData$Service$Fetched(checkpointData);
			case 1:
				return $author$project$CheckpointData$Service$Fetched(checkpointData);
			case 2:
				return $author$project$CheckpointData$Service$FetchedAndSendingCommand(checkpointData);
			case 3:
				return $author$project$CheckpointData$Service$Fetched(checkpointData);
			default:
				return $author$project$CheckpointData$Service$FetchedAndSendingCommand(checkpointData);
		}
	});
var $author$project$Audit$Service$receivedCommandResponse = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return $author$project$Audit$Service$Idle;
		case 3:
			return state;
		default:
			var audits = state.a;
			return $author$project$Audit$Service$Fetched(audits);
	}
};
var $author$project$CheckpointData$Service$receivedCommandResponse = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return $author$project$CheckpointData$Service$Idle;
		case 3:
			return state;
		default:
			var checkpointData = state.a;
			return $author$project$CheckpointData$Service$Fetched(checkpointData);
	}
};
var $author$project$Measure$Service$Fetched = function (a) {
	return {$: 3, a: a};
};
var $author$project$Measure$Service$receivedCommandResponse = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return $author$project$Measure$Service$Idle;
		case 3:
			return state;
		default:
			var measures = state.a;
			return $author$project$Measure$Service$Fetched(measures);
	}
};
var $author$project$OrganisationUnit$Service$Fetched = function (a) {
	return {$: 3, a: a};
};
var $author$project$OrganisationUnit$Service$receivedCommandResponse = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return $author$project$OrganisationUnit$Service$Idle;
		case 3:
			return state;
		default:
			var organisationUnits = state.a;
			return $author$project$OrganisationUnit$Service$Fetched(organisationUnits);
	}
};
var $author$project$Plan$Service$Fetched = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$Service$receivedCommandResponse = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return $author$project$Plan$Service$Idle;
		case 3:
			return state;
		default:
			var plans = state.a;
			return $author$project$Plan$Service$Fetched(plans);
	}
};
var $author$project$Rights$Service$Fetched = function (a) {
	return {$: 3, a: a};
};
var $author$project$Rights$Service$receivedCommandResponse = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return $author$project$Rights$Service$Idle;
		case 3:
			return state;
		default:
			var rights = state.a;
			return $author$project$Rights$Service$Fetched(rights);
	}
};
var $author$project$Tenant$Service$Fetched = function (a) {
	return {$: 3, a: a};
};
var $author$project$Tenant$Service$receivedCommandResponse = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return $author$project$Tenant$Service$Idle;
		case 3:
			return state;
		default:
			var tenant = state.a;
			return $author$project$Tenant$Service$Fetched(tenant);
	}
};
var $author$project$User$Service$Fetched = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$Service$receivedCommandResponse = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return $author$project$User$Service$Idle;
		case 3:
			return state;
		default:
			var users = state.a;
			return $author$project$User$Service$Fetched(users);
	}
};
var $author$project$Measure$Service$receivedMeasureResponse = F2(
	function (measures, state) {
		switch (state.$) {
			case 0:
				return $author$project$Measure$Service$Fetched(measures);
			case 1:
				return $author$project$Measure$Service$Fetched(measures);
			case 2:
				return $author$project$Measure$Service$FetchedAndSendingCommand(measures);
			case 3:
				return $author$project$Measure$Service$Fetched(measures);
			default:
				return $author$project$Measure$Service$FetchedAndSendingCommand(measures);
		}
	});
var $author$project$OrganisationUnit$Service$receivedOrganisationUnitResponse = F2(
	function (organisationUnits, state) {
		switch (state.$) {
			case 0:
				return $author$project$OrganisationUnit$Service$Fetched(organisationUnits);
			case 1:
				return $author$project$OrganisationUnit$Service$Fetched(organisationUnits);
			case 2:
				return $author$project$OrganisationUnit$Service$FetchedAndSendingCommand(organisationUnits);
			case 3:
				return $author$project$OrganisationUnit$Service$Fetched(organisationUnits);
			default:
				return $author$project$OrganisationUnit$Service$FetchedAndSendingCommand(organisationUnits);
		}
	});
var $author$project$Plan$Service$receivedPlanResponse = F2(
	function (plans, state) {
		switch (state.$) {
			case 0:
				return $author$project$Plan$Service$Fetched(plans);
			case 1:
				return $author$project$Plan$Service$Fetched(plans);
			case 2:
				return $author$project$Plan$Service$FetchedAndSendingCommand(plans);
			case 3:
				return $author$project$Plan$Service$Fetched(plans);
			default:
				return $author$project$Plan$Service$FetchedAndSendingCommand(plans);
		}
	});
var $author$project$Rights$Service$receivedRightsResponse = F2(
	function (rights, state) {
		switch (state.$) {
			case 0:
				return $author$project$Rights$Service$Fetched(rights);
			case 1:
				return $author$project$Rights$Service$Fetched(rights);
			case 2:
				return $author$project$Rights$Service$FetchedAndSendingCommand(rights);
			case 3:
				return $author$project$Rights$Service$Fetched(rights);
			default:
				return $author$project$Rights$Service$FetchedAndSendingCommand(rights);
		}
	});
var $author$project$Tenant$Service$receivedTenantResponse = F2(
	function (tenant, state) {
		switch (state.$) {
			case 0:
				return $author$project$Tenant$Service$Fetched(tenant);
			case 1:
				return $author$project$Tenant$Service$Fetched(tenant);
			case 2:
				return $author$project$Tenant$Service$FetchedAndSendingCommand(tenant);
			case 3:
				return $author$project$Tenant$Service$Fetched(tenant);
			default:
				return $author$project$Tenant$Service$FetchedAndSendingCommand(tenant);
		}
	});
var $author$project$User$Service$receivedUserResponse = F2(
	function (users, state) {
		switch (state.$) {
			case 0:
				return $author$project$User$Service$Fetched(users);
			case 1:
				return $author$project$User$Service$Fetched(users);
			case 2:
				return $author$project$User$Service$FetchedAndSendingCommand(users);
			case 3:
				return $author$project$User$Service$Fetched(users);
			default:
				return $author$project$User$Service$FetchedAndSendingCommand(users);
		}
	});
var $author$project$Audit$Store$RemoveCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Audit$Store$removeCommand = F3(
	function (commandId, environment, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Audit$Store$Loaded(
						{aC: $author$project$Audit$Audits$empty, cD: data.cD, b8: data.b8}),
					$author$project$Audit$Store$send(
						$author$project$Audit$Store$RemoveCommand(commandId)));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Audit$Store$send(
						$author$project$Audit$Store$RemoveCommand(commandId)));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Audit$Store$send(
						$author$project$Audit$Store$RemoveCommand(commandId)));
		}
	});
var $author$project$CheckpointData$Store$RemoveCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$CheckpointData$Store$removeCommand = F3(
	function (commandId, environment, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$CheckpointData$Store$Loaded(
						{a: $author$project$CheckpointData$CheckpointData$empty, cD: data.cD, b8: data.b8}),
					$author$project$CheckpointData$Store$send(
						$author$project$CheckpointData$Store$RemoveCommand(commandId)));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$CheckpointData$Store$send(
						$author$project$CheckpointData$Store$RemoveCommand(commandId)));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$CheckpointData$Store$send(
						$author$project$CheckpointData$Store$RemoveCommand(commandId)));
		}
	});
var $author$project$Measure$Store$RemoveCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Measure$Store$removeCommand = F3(
	function (commandId, environment, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Measure$Store$Loaded(
						{cD: data.cD, b8: data.b8, aI: $author$project$Measure$Measures$empty}),
					$author$project$Measure$Store$send(
						$author$project$Measure$Store$RemoveCommand(commandId)));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Measure$Store$send(
						$author$project$Measure$Store$RemoveCommand(commandId)));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Measure$Store$send(
						$author$project$Measure$Store$RemoveCommand(commandId)));
		}
	});
var $author$project$OrganisationUnit$Store$RemoveCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$OrganisationUnit$Store$removeCommand = F3(
	function (commandId, environment, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$OrganisationUnit$Store$Loaded(
						{cD: data.cD, b8: data.b8, kn: $author$project$OrganisationUnit$OrganisationUnits$empty}),
					$author$project$OrganisationUnit$Store$send(
						$author$project$OrganisationUnit$Store$RemoveCommand(commandId)));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$OrganisationUnit$Store$send(
						$author$project$OrganisationUnit$Store$RemoveCommand(commandId)));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$OrganisationUnit$Store$send(
						$author$project$OrganisationUnit$Store$RemoveCommand(commandId)));
		}
	});
var $author$project$Plan$Store$RemoveCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Plan$Store$removeCommand = F3(
	function (commandId, environment, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Plan$Store$Loaded(
						{cD: data.cD, b8: data.b8, aL: $author$project$Plan$Plans$empty}),
					$author$project$Plan$Store$send(
						$author$project$Plan$Store$RemoveCommand(commandId)));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Plan$Store$send(
						$author$project$Plan$Store$RemoveCommand(commandId)));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Plan$Store$send(
						$author$project$Plan$Store$RemoveCommand(commandId)));
		}
	});
var $author$project$Rights$Store$RemoveCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Rights$Store$removeCommand = F3(
	function (commandId, environment, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Rights$Store$Loaded(
						{cD: data.cD, b8: data.b8, kF: $author$project$Rights$Rights$empty}),
					$author$project$Rights$Store$send(
						$author$project$Rights$Store$RemoveCommand(commandId)));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Rights$Store$send(
						$author$project$Rights$Store$RemoveCommand(commandId)));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Rights$Store$send(
						$author$project$Rights$Store$RemoveCommand(commandId)));
		}
	});
var $author$project$Tenant$Store$RemoveCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Tenant$Store$removeCommand = F3(
	function (commandId, environment, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Tenant$Store$Loaded(
						{cD: data.cD, b8: data.b8, iC: $elm$core$Maybe$Nothing}),
					$author$project$Tenant$Store$send(
						$author$project$Tenant$Store$RemoveCommand(commandId)));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Tenant$Store$send(
						$author$project$Tenant$Store$RemoveCommand(commandId)));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Tenant$Store$send(
						$author$project$Tenant$Store$RemoveCommand(commandId)));
		}
	});
var $author$project$User$Store$RemoveCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$Store$removeCommand = F3(
	function (commandId, environment, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$User$Store$Loaded(
						{cD: data.cD, b8: data.b8, lk: $author$project$User$Users$empty}),
					$author$project$User$Store$send(
						$author$project$User$Store$RemoveCommand(commandId)));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$User$Store$send(
						$author$project$User$Store$RemoveCommand(commandId)));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$User$Store$send(
						$author$project$User$Store$RemoveCommand(commandId)));
		}
	});
var $author$project$Audit$Store$RemoveCommandAndEvent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Audit$Store$removeCommandAndMaybeEvent = F3(
	function (commandId, environment, state) {
		var maybeEvent = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (event) {
					return _Utils_eq(
						$author$project$Audit$Event$commandId(event),
						commandId);
				},
				$author$project$Audit$Events$toList(
					$author$project$Audit$Store$events(state))));
		var cmd = function () {
			if (!maybeEvent.$) {
				var event = maybeEvent.a;
				return A3(
					$author$project$Audit$Store$RemoveCommandAndEvent,
					commandId,
					$author$project$Audit$Event$auditId(event),
					$author$project$Audit$Event$version(event));
			} else {
				return $author$project$Audit$Store$RemoveCommand(commandId);
			}
		}();
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Audit$Store$Loaded(
						{aC: $author$project$Audit$Audits$empty, cD: data.cD, b8: data.b8}),
					$author$project$Audit$Store$send(cmd));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Audit$Store$send(cmd));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Audit$Store$send(cmd));
		}
	});
var $author$project$CheckpointData$Store$RemoveCommandAndEvent = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$CheckpointData$Store$removeCommandAndMaybeEvent = F3(
	function (commandId, environment, state) {
		var maybeEvent = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (event) {
					return _Utils_eq(
						$author$project$CheckpointData$Event$commandId(event),
						commandId);
				},
				$author$project$CheckpointData$Events$toList(
					$author$project$CheckpointData$Store$events(state))));
		var cmd = function () {
			if (!maybeEvent.$) {
				var event = maybeEvent.a;
				return A2(
					$author$project$CheckpointData$Store$RemoveCommandAndEvent,
					commandId,
					$author$project$CheckpointData$Event$version(event));
			} else {
				return $author$project$CheckpointData$Store$RemoveCommand(commandId);
			}
		}();
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$CheckpointData$Store$Loaded(
						{a: $author$project$CheckpointData$CheckpointData$empty, cD: data.cD, b8: data.b8}),
					$author$project$CheckpointData$Store$send(cmd));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$CheckpointData$Store$send(cmd));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$CheckpointData$Store$send(cmd));
		}
	});
var $author$project$Measure$Store$RemoveCommandAndEvent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Measure$Event$commandId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.L;
		case 1:
			var payload = event.a;
			return payload.L;
		case 2:
			var payload = event.a;
			return payload.L;
		case 3:
			var payload = event.a;
			return payload.L;
		case 4:
			var payload = event.a;
			return payload.L;
		case 5:
			var payload = event.a;
			return payload.L;
		case 6:
			var payload = event.a;
			return payload.L;
		case 7:
			var payload = event.a;
			return payload.L;
		case 8:
			var payload = event.a;
			return payload.L;
		default:
			var payload = event.a;
			return payload.L;
	}
};
var $author$project$Measure$Events$toList = $author$project$Types$Queue$toList;
var $author$project$Measure$Event$version = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.n;
		case 1:
			var payload = event.a;
			return payload.n;
		case 2:
			var payload = event.a;
			return payload.n;
		case 3:
			var payload = event.a;
			return payload.n;
		case 4:
			var payload = event.a;
			return payload.n;
		case 5:
			var payload = event.a;
			return payload.n;
		case 6:
			var payload = event.a;
			return payload.n;
		case 7:
			var payload = event.a;
			return payload.n;
		case 8:
			var payload = event.a;
			return payload.n;
		default:
			var payload = event.a;
			return payload.n;
	}
};
var $author$project$Measure$Store$removeCommandAndMaybeEvent = F3(
	function (commandId, environment, state) {
		var maybeEvent = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (event) {
					return _Utils_eq(
						$author$project$Measure$Event$commandId(event),
						commandId);
				},
				$author$project$Measure$Events$toList(
					$author$project$Measure$Store$events(state))));
		var cmd = function () {
			if (!maybeEvent.$) {
				var event = maybeEvent.a;
				return A3(
					$author$project$Measure$Store$RemoveCommandAndEvent,
					commandId,
					$author$project$Measure$Event$measureId(event),
					$author$project$Measure$Event$version(event));
			} else {
				return $author$project$Measure$Store$RemoveCommand(commandId);
			}
		}();
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Measure$Store$Loaded(
						{cD: data.cD, b8: data.b8, aI: $author$project$Measure$Measures$empty}),
					$author$project$Measure$Store$send(cmd));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Measure$Store$send(cmd));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Measure$Store$send(cmd));
		}
	});
var $author$project$OrganisationUnit$Store$RemoveCommandAndEvent = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$OrganisationUnit$Event$commandId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.L;
		case 1:
			var payload = event.a;
			return payload.L;
		case 2:
			var payload = event.a;
			return payload.L;
		case 3:
			var payload = event.a;
			return payload.L;
		case 4:
			var payload = event.a;
			return payload.L;
		case 5:
			var payload = event.a;
			return payload.L;
		case 6:
			var payload = event.a;
			return payload.L;
		case 7:
			var payload = event.a;
			return payload.L;
		case 8:
			var payload = event.a;
			return payload.L;
		case 9:
			var payload = event.a;
			return payload.L;
		case 10:
			var payload = event.a;
			return payload.L;
		default:
			var payload = event.a;
			return payload.L;
	}
};
var $author$project$OrganisationUnit$Event$version = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.n;
		case 1:
			var payload = event.a;
			return payload.n;
		case 2:
			var payload = event.a;
			return payload.n;
		case 3:
			var payload = event.a;
			return payload.n;
		case 4:
			var payload = event.a;
			return payload.n;
		case 5:
			var payload = event.a;
			return payload.n;
		case 6:
			var payload = event.a;
			return payload.n;
		case 7:
			var payload = event.a;
			return payload.n;
		case 8:
			var payload = event.a;
			return payload.n;
		case 9:
			var payload = event.a;
			return payload.n;
		case 10:
			var payload = event.a;
			return payload.n;
		default:
			var payload = event.a;
			return payload.n;
	}
};
var $author$project$OrganisationUnit$Store$removeCommandAndMaybeEvent = F3(
	function (commandId, environment, state) {
		var maybeEvent = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (event) {
					return _Utils_eq(
						$author$project$OrganisationUnit$Event$commandId(event),
						commandId);
				},
				$author$project$OrganisationUnit$Events$toList(
					$author$project$OrganisationUnit$Store$events(state))));
		var cmd = function () {
			if (!maybeEvent.$) {
				var event = maybeEvent.a;
				return A2(
					$author$project$OrganisationUnit$Store$RemoveCommandAndEvent,
					commandId,
					$author$project$OrganisationUnit$Event$version(event));
			} else {
				return $author$project$OrganisationUnit$Store$RemoveCommand(commandId);
			}
		}();
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$OrganisationUnit$Store$Loaded(
						{cD: data.cD, b8: data.b8, kn: $author$project$OrganisationUnit$OrganisationUnits$empty}),
					$author$project$OrganisationUnit$Store$send(cmd));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$OrganisationUnit$Store$send(cmd));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$OrganisationUnit$Store$send(cmd));
		}
	});
var $author$project$Plan$Store$RemoveCommandAndEvent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Plan$Event$commandId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.L;
		case 1:
			var payload = event.a;
			return payload.L;
		case 2:
			var payload = event.a;
			return payload.L;
		case 3:
			var payload = event.a;
			return payload.L;
		case 4:
			var payload = event.a;
			return payload.L;
		case 5:
			var payload = event.a;
			return payload.L;
		case 6:
			var payload = event.a;
			return payload.L;
		case 7:
			var payload = event.a;
			return payload.L;
		case 8:
			var payload = event.a;
			return payload.L;
		default:
			var payload = event.a;
			return payload.L;
	}
};
var $author$project$Plan$Events$toList = $author$project$Types$Queue$toList;
var $author$project$Plan$Event$version = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.n;
		case 1:
			var payload = event.a;
			return payload.n;
		case 2:
			var payload = event.a;
			return payload.n;
		case 3:
			var payload = event.a;
			return payload.n;
		case 4:
			var payload = event.a;
			return payload.n;
		case 5:
			var payload = event.a;
			return payload.n;
		case 6:
			var payload = event.a;
			return payload.n;
		case 7:
			var payload = event.a;
			return payload.n;
		case 8:
			var payload = event.a;
			return payload.n;
		default:
			var payload = event.a;
			return payload.n;
	}
};
var $author$project$Plan$Store$removeCommandAndMaybeEvent = F3(
	function (commandId, environment, state) {
		var maybeEvent = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (event) {
					return _Utils_eq(
						$author$project$Plan$Event$commandId(event),
						commandId);
				},
				$author$project$Plan$Events$toList(
					$author$project$Plan$Store$events(state))));
		var cmd = function () {
			if (!maybeEvent.$) {
				var event = maybeEvent.a;
				return A3(
					$author$project$Plan$Store$RemoveCommandAndEvent,
					commandId,
					$author$project$Plan$Event$planId(event),
					$author$project$Plan$Event$version(event));
			} else {
				return $author$project$Plan$Store$RemoveCommand(commandId);
			}
		}();
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Plan$Store$Loaded(
						{cD: data.cD, b8: data.b8, aL: $author$project$Plan$Plans$empty}),
					$author$project$Plan$Store$send(cmd));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Plan$Store$send(cmd));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Plan$Store$send(cmd));
		}
	});
var $author$project$Rights$Store$RemoveCommandAndEvent = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Rights$Event$commandId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.L;
		case 1:
			var payload = event.a;
			return payload.L;
		case 2:
			var payload = event.a;
			return payload.L;
		case 3:
			var payload = event.a;
			return payload.L;
		case 4:
			var payload = event.a;
			return payload.L;
		case 5:
			var payload = event.a;
			return payload.L;
		case 6:
			var payload = event.a;
			return payload.L;
		case 7:
			var payload = event.a;
			return payload.L;
		case 8:
			var payload = event.a;
			return payload.L;
		case 9:
			var payload = event.a;
			return payload.L;
		case 10:
			var payload = event.a;
			return payload.L;
		default:
			var payload = event.a;
			return payload.L;
	}
};
var $author$project$Rights$Store$events = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Rights$Events$empty;
		case 1:
			var data = state.a;
			return data.b8;
		case 2:
			var data = state.a;
			return data.b8;
		default:
			var data = state.a;
			return data.b8;
	}
};
var $author$project$Rights$Event$version = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.n;
		case 1:
			var payload = event.a;
			return payload.n;
		case 2:
			var payload = event.a;
			return payload.n;
		case 3:
			var payload = event.a;
			return payload.n;
		case 4:
			var payload = event.a;
			return payload.n;
		case 5:
			var payload = event.a;
			return payload.n;
		case 6:
			var payload = event.a;
			return payload.n;
		case 7:
			var payload = event.a;
			return payload.n;
		case 8:
			var payload = event.a;
			return payload.n;
		case 9:
			var payload = event.a;
			return payload.n;
		case 10:
			var payload = event.a;
			return payload.n;
		default:
			var payload = event.a;
			return payload.n;
	}
};
var $author$project$Rights$Store$removeCommandAndMaybeEvent = F3(
	function (commandId, environment, state) {
		var maybeEvent = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (event) {
					return _Utils_eq(
						$author$project$Rights$Event$commandId(event),
						commandId);
				},
				$author$project$Rights$Events$toList(
					$author$project$Rights$Store$events(state))));
		var cmd = function () {
			if (!maybeEvent.$) {
				var event = maybeEvent.a;
				return A2(
					$author$project$Rights$Store$RemoveCommandAndEvent,
					commandId,
					$author$project$Rights$Event$version(event));
			} else {
				return $author$project$Rights$Store$RemoveCommand(commandId);
			}
		}();
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Rights$Store$Loaded(
						{cD: data.cD, b8: data.b8, kF: $author$project$Rights$Rights$empty}),
					$author$project$Rights$Store$send(cmd));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Rights$Store$send(cmd));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Rights$Store$send(cmd));
		}
	});
var $author$project$Tenant$Store$RemoveCommandAndEvent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Tenant$Event$commandId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.L;
		case 1:
			var payload = event.a;
			return payload.L;
		case 2:
			var payload = event.a;
			return payload.L;
		case 3:
			var payload = event.a;
			return payload.L;
		case 4:
			var payload = event.a;
			return payload.L;
		case 5:
			var payload = event.a;
			return payload.L;
		case 6:
			var payload = event.a;
			return payload.L;
		case 7:
			var payload = event.a;
			return payload.L;
		case 8:
			var payload = event.a;
			return payload.L;
		default:
			var payload = event.a;
			return payload.L;
	}
};
var $author$project$Tenant$Store$events = function (state) {
	switch (state.$) {
		case 0:
			return $author$project$Tenant$Events$empty;
		case 1:
			var data = state.a;
			return data.b8;
		case 2:
			var data = state.a;
			return data.b8;
		default:
			var data = state.a;
			return data.b8;
	}
};
var $author$project$Tenant$Event$tenantId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.k5;
		case 1:
			var payload = event.a;
			return payload.k5;
		case 2:
			var payload = event.a;
			return payload.k5;
		case 3:
			var payload = event.a;
			return payload.k5;
		case 4:
			var payload = event.a;
			return payload.k5;
		case 5:
			var payload = event.a;
			return payload.k5;
		case 6:
			var payload = event.a;
			return payload.k5;
		case 7:
			var payload = event.a;
			return payload.k5;
		case 8:
			var payload = event.a;
			return payload.k5;
		default:
			var payload = event.a;
			return payload.k5;
	}
};
var $author$project$Tenant$Events$toList = $author$project$Types$Queue$toList;
var $author$project$Tenant$Event$version = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.n;
		case 1:
			var payload = event.a;
			return payload.n;
		case 2:
			var payload = event.a;
			return payload.n;
		case 3:
			var payload = event.a;
			return payload.n;
		case 4:
			var payload = event.a;
			return payload.n;
		case 5:
			var payload = event.a;
			return payload.n;
		case 6:
			var payload = event.a;
			return payload.n;
		case 7:
			var payload = event.a;
			return payload.n;
		case 8:
			var payload = event.a;
			return payload.n;
		default:
			var payload = event.a;
			return payload.n;
	}
};
var $author$project$Tenant$Store$removeCommandAndMaybeEvent = F3(
	function (commandId, environment, state) {
		var maybeEvent = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (event) {
					return _Utils_eq(
						$author$project$Tenant$Event$commandId(event),
						commandId);
				},
				$author$project$Tenant$Events$toList(
					$author$project$Tenant$Store$events(state))));
		var cmd = function () {
			if (!maybeEvent.$) {
				var event = maybeEvent.a;
				return A3(
					$author$project$Tenant$Store$RemoveCommandAndEvent,
					commandId,
					$author$project$Tenant$Event$tenantId(event),
					$author$project$Tenant$Event$version(event));
			} else {
				return $author$project$Tenant$Store$RemoveCommand(commandId);
			}
		}();
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Tenant$Store$Loaded(
						{cD: data.cD, b8: data.b8, iC: $elm$core$Maybe$Nothing}),
					$author$project$Tenant$Store$send(cmd));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Tenant$Store$send(cmd));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$Tenant$Store$send(cmd));
		}
	});
var $author$project$User$Store$RemoveCommandAndEvent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$User$Event$commandId = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.L;
		case 1:
			var payload = event.a;
			return payload.L;
		case 2:
			var payload = event.a;
			return payload.L;
		case 3:
			var payload = event.a;
			return payload.L;
		case 4:
			var payload = event.a;
			return payload.L;
		case 5:
			var payload = event.a;
			return payload.L;
		case 6:
			var payload = event.a;
			return payload.L;
		case 7:
			var payload = event.a;
			return payload.L;
		case 8:
			var payload = event.a;
			return payload.L;
		default:
			var payload = event.a;
			return payload.L;
	}
};
var $author$project$User$Event$version = function (event) {
	switch (event.$) {
		case 0:
			var payload = event.a;
			return payload.n;
		case 1:
			var payload = event.a;
			return payload.n;
		case 2:
			var payload = event.a;
			return payload.n;
		case 3:
			var payload = event.a;
			return payload.n;
		case 4:
			var payload = event.a;
			return payload.n;
		case 5:
			var payload = event.a;
			return payload.n;
		case 6:
			var payload = event.a;
			return payload.n;
		case 7:
			var payload = event.a;
			return payload.n;
		case 8:
			var payload = event.a;
			return payload.n;
		default:
			var payload = event.a;
			return payload.n;
	}
};
var $author$project$User$Store$removeCommandAndMaybeEvent = F3(
	function (commandId, environment, state) {
		var maybeEvent = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (event) {
					return _Utils_eq(
						$author$project$User$Event$commandId(event),
						commandId);
				},
				$author$project$User$Events$toList(
					$author$project$User$Store$events(state))));
		var cmd = function () {
			if (!maybeEvent.$) {
				var event = maybeEvent.a;
				return A3(
					$author$project$User$Store$RemoveCommandAndEvent,
					commandId,
					$author$project$User$Event$userId(event),
					$author$project$User$Event$version(event));
			} else {
				return $author$project$User$Store$RemoveCommand(commandId);
			}
		}();
		switch (state.$) {
			case 0:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 1:
				var data = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$User$Store$Loaded(
						{cD: data.cD, b8: data.b8, lk: $author$project$User$Users$empty}),
					$author$project$User$Store$send(cmd));
			case 2:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$User$Store$send(cmd));
			default:
				return _Utils_Tuple3(
					environment,
					state,
					$author$project$User$Store$send(cmd));
		}
	});
var $author$project$Audit$Store$removeNothing = F3(
	function (_v0, environment, state) {
		return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
	});
var $author$project$CheckpointData$Store$removeNothing = F3(
	function (_v0, environment, state) {
		return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
	});
var $author$project$Measure$Store$removeNothing = F3(
	function (_v0, environment, state) {
		return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
	});
var $author$project$OrganisationUnit$Store$removeNothing = F3(
	function (_v0, environment, state) {
		return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
	});
var $author$project$Plan$Store$removeNothing = F3(
	function (_v0, environment, state) {
		return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
	});
var $author$project$Rights$Store$removeNothing = F3(
	function (_v0, environment, state) {
		return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
	});
var $author$project$Tenant$Store$removeNothing = F3(
	function (_v0, environment, state) {
		return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
	});
var $author$project$User$Store$removeNothing = F3(
	function (_v0, environment, state) {
		return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
	});
var $author$project$Environments$Repository$rightsService = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.bM;
	});
var $author$project$Environments$Repository$rightsStore = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.al;
	});
var $author$project$Environments$Repository$setAuditStore = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withAuditStore);
var $author$project$Environments$Repository$setCheckpointDataStore = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withCheckpointDataStore);
var $author$project$Environments$Environment$setCurrentOrganisationUnit = F2(
	function (state, maybeOuId) {
		return A2(
			$author$project$Environments$Environment$map,
			function (model) {
				return _Utils_update(
					model,
					{fk: maybeOuId});
			},
			state);
	});
var $author$project$Environments$Repository$setMeasureStore = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withMeasureStore);
var $author$project$Environments$Repository$setOrganisationUnitStore = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withOrganisationUnitStore);
var $author$project$Environments$Repository$setRightsStore = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withRightsStore);
var $author$project$Environments$Repository$setTenantStore = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withTenantStore);
var $author$project$Environments$Repository$setUserStore = $author$project$Utils$Utils$flip($author$project$Environments$Repository$withUserStore);
var $author$project$Environments$Repository$tenantService = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.bz;
	});
var $author$project$Environments$Repository$tenantStore = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.ag;
	});
var $author$project$Environments$Repository$userService = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.bA;
	});
var $author$project$Environments$Repository$userStore = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Repository$unwrap,
	function ($) {
		return $.ah;
	});
var $author$project$Environments$Repository$receivedHttpResponse = F3(
	function (httpMsg, environment, repository) {
		switch (httpMsg.$) {
			case 0:
				var resultType = httpMsg.a;
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v1.a;
				var updatedEnvironment = _v1.b;
				var newError = {
					gg: 'Unknown return from Javascript in http handler. index.js -> initHttpPort',
					gE: $author$project$Environments$ErrorHandling$Error$OtherError(resultType),
					gH: 'repository.elm',
					gK: 'receivedHttpResponse',
					fw: newId
				};
				return _Utils_Tuple3(
					A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					repository,
					$elm$core$Platform$Cmd$none);
			case 1:
				var decodeError = httpMsg.a;
				var _v2 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v2.a;
				var updatedEnvironment = _v2.b;
				var newError = {
					gg: 'Error while Decoding incoming http request',
					gE: $author$project$Environments$ErrorHandling$Error$DecodeError(decodeError),
					gH: 'repository.elm',
					gK: 'receivedHttpResponse',
					fw: newId
				};
				return _Utils_Tuple3(
					A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					repository,
					$elm$core$Platform$Cmd$none);
			case 2:
				var status = httpMsg.a;
				var responseMessage = httpMsg.b;
				var resultType = httpMsg.c;
				if (status === 401) {
					return _Utils_Tuple3(
						$author$project$Environments$Environment$sessionExpired(environment),
						repository,
						$elm$core$Platform$Cmd$none);
				} else {
					if ((status === 404) && (resultType === 'GET_AUDIT')) {
						return _Utils_Tuple3(environment, repository, $elm$core$Platform$Cmd$none);
					} else {
						var _v3 = A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Environments$ErrorHandling$Id$from,
							$author$project$Environments$Environment$generateUuid(environment));
						var newId = _v3.a;
						var updatedEnvironment = _v3.b;
						var newError = {
							gg: resultType,
							gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
							gH: 'repository.elm',
							gK: 'receivedHttpResponse',
							fw: newId
						};
						return _Utils_Tuple3(
							A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
							repository,
							$elm$core$Platform$Cmd$none);
					}
				}
			case 3:
				var users_ = httpMsg.a;
				var newUserService = A2(
					$author$project$User$Service$receivedUserResponse,
					users_,
					$author$project$Environments$Repository$userService(repository));
				var newEnvironment = A2(
					$author$project$Environments$Environment$setCurrentOrganisationUnit,
					environment,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.hT;
							},
							A2(
								$elm$core$Maybe$andThen,
								function (userId) {
									return A2($author$project$User$Users$get, userId, users_);
								},
								$author$project$Auth$Session$maybeUserId(
									$author$project$Environments$Environment$session(environment))))));
				return _Utils_Tuple3(
					newEnvironment,
					A2($author$project$Environments$Repository$setUserService, repository, newUserService),
					$elm$core$Platform$Cmd$none);
			case 4:
				var command = httpMsg.a;
				return function (updatedRepository) {
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setUserStore(updatedRepository),
						A3(
							$author$project$User$Store$removeCommand,
							$author$project$User$Command$commandId(command),
							environment,
							$author$project$Environments$Repository$userStore(updatedRepository)));
				}(
					A2(
						$author$project$Environments$Repository$setUserService,
						repository,
						$author$project$User$Service$receivedCommandResponse(
							$author$project$Environments$Repository$userService(repository))));
			case 5:
				var status = httpMsg.a;
				var resultType = httpMsg.b;
				var responseMessage = httpMsg.c;
				var failedCommand = httpMsg.d;
				if (status === 401) {
					return _Utils_Tuple3(
						$author$project$Environments$Environment$sessionExpired(environment),
						repository,
						$elm$core$Platform$Cmd$none);
				} else {
					var updatedRepository = A2(
						$author$project$Environments$Repository$setUserService,
						repository,
						A2(
							$author$project$User$Service$receivedBadResponse,
							status,
							$author$project$Environments$Repository$userService(repository)));
					var canBeRemovedResult = A2($author$project$Environments$ErrorHandling$Http$canCommandAndEventBeRemoved, status, responseMessage);
					var storeFunction = (canBeRemovedResult.d7 && canBeRemovedResult.d8) ? $author$project$User$Store$removeCommandAndMaybeEvent : ((canBeRemovedResult.d7 && (!canBeRemovedResult.d8)) ? $author$project$User$Store$removeCommand : $author$project$User$Store$removeNothing);
					var _v4 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v4.a;
					var updatedEnvironment = _v4.b;
					var newError = {
						gg: resultType,
						gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
						gH: 'repository.elm',
						gK: 'receivedHttpResponse',
						fw: newId
					};
					var environmentWithErr = canBeRemovedResult.dS ? A2($author$project$Environments$Environment$addError, newError, updatedEnvironment) : updatedEnvironment;
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setUserStore(updatedRepository),
						A3(
							storeFunction,
							$author$project$User$Command$commandId(failedCommand),
							environmentWithErr,
							$author$project$Environments$Repository$userStore(updatedRepository)));
				}
			case 6:
				var organisationUnits_ = httpMsg.a;
				var newOrganisationUnitService = A2(
					$author$project$OrganisationUnit$Service$receivedOrganisationUnitResponse,
					organisationUnits_,
					$author$project$Environments$Repository$organisationUnitService(repository));
				return _Utils_Tuple3(
					environment,
					A2($author$project$Environments$Repository$setOrganisationUnitService, repository, newOrganisationUnitService),
					$elm$core$Platform$Cmd$none);
			case 7:
				var command = httpMsg.a;
				return function (newRepository) {
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setOrganisationUnitStore(newRepository),
						A3(
							$author$project$OrganisationUnit$Store$removeCommand,
							$author$project$OrganisationUnit$Command$commandId(command),
							environment,
							$author$project$Environments$Repository$organisationUnitStore(newRepository)));
				}(
					A2(
						$author$project$Environments$Repository$setOrganisationUnitService,
						repository,
						$author$project$OrganisationUnit$Service$receivedCommandResponse(
							$author$project$Environments$Repository$organisationUnitService(repository))));
			case 8:
				var status = httpMsg.a;
				var resultType = httpMsg.b;
				var responseMessage = httpMsg.c;
				var failedCommand = httpMsg.d;
				if (status === 401) {
					return _Utils_Tuple3(
						$author$project$Environments$Environment$sessionExpired(environment),
						repository,
						$elm$core$Platform$Cmd$none);
				} else {
					var updatedRepository = A2(
						$author$project$Environments$Repository$setOrganisationUnitService,
						repository,
						A2(
							$author$project$OrganisationUnit$Service$receivedBadResponse,
							status,
							$author$project$Environments$Repository$organisationUnitService(repository)));
					var canBeRemovedResult = A2($author$project$Environments$ErrorHandling$Http$canCommandAndEventBeRemoved, status, responseMessage);
					var storeFunction = (canBeRemovedResult.d7 && canBeRemovedResult.d8) ? $author$project$OrganisationUnit$Store$removeCommandAndMaybeEvent : ((canBeRemovedResult.d7 && (!canBeRemovedResult.d8)) ? $author$project$OrganisationUnit$Store$removeCommand : $author$project$OrganisationUnit$Store$removeNothing);
					var _v5 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v5.a;
					var updatedEnvironment = _v5.b;
					var newError = {
						gg: resultType,
						gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
						gH: 'repository.elm',
						gK: 'receivedHttpResponse',
						fw: newId
					};
					var environmentWithErr = canBeRemovedResult.dS ? A2($author$project$Environments$Environment$addError, newError, updatedEnvironment) : updatedEnvironment;
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setOrganisationUnitStore(updatedRepository),
						A3(
							storeFunction,
							$author$project$OrganisationUnit$Command$commandId(failedCommand),
							environmentWithErr,
							$author$project$Environments$Repository$organisationUnitStore(updatedRepository)));
				}
			case 9:
				var plans_ = httpMsg.a;
				var newPlanService = A2(
					$author$project$Plan$Service$receivedPlanResponse,
					plans_,
					$author$project$Environments$Repository$planService(repository));
				return _Utils_Tuple3(
					environment,
					A2($author$project$Environments$Repository$setPlanService, repository, newPlanService),
					$elm$core$Platform$Cmd$none);
			case 10:
				var command = httpMsg.a;
				return function (updatedRepository) {
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setPlanStore(updatedRepository),
						A3(
							$author$project$Plan$Store$removeCommand,
							$author$project$Plan$Command$commandId(command),
							environment,
							$author$project$Environments$Repository$planStore(updatedRepository)));
				}(
					A2(
						$author$project$Environments$Repository$setPlanService,
						repository,
						$author$project$Plan$Service$receivedCommandResponse(
							$author$project$Environments$Repository$planService(repository))));
			case 11:
				var status = httpMsg.a;
				var resultType = httpMsg.b;
				var responseMessage = httpMsg.c;
				var failedCommand = httpMsg.d;
				if (status === 401) {
					return _Utils_Tuple3(
						$author$project$Environments$Environment$sessionExpired(environment),
						repository,
						$elm$core$Platform$Cmd$none);
				} else {
					var updatedRepository = A2(
						$author$project$Environments$Repository$setPlanService,
						repository,
						A2(
							$author$project$Plan$Service$receivedBadResponse,
							status,
							$author$project$Environments$Repository$planService(repository)));
					var canBeRemovedResult = A2($author$project$Environments$ErrorHandling$Http$canCommandAndEventBeRemoved, status, responseMessage);
					var storeFunction = (canBeRemovedResult.d7 && canBeRemovedResult.d8) ? $author$project$Plan$Store$removeCommandAndMaybeEvent : ((canBeRemovedResult.d7 && (!canBeRemovedResult.d8)) ? $author$project$Plan$Store$removeCommand : $author$project$Plan$Store$removeNothing);
					var _v6 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v6.a;
					var updatedEnvironment = _v6.b;
					var newError = {
						gg: resultType,
						gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
						gH: 'repository.elm',
						gK: 'receivedHttpResponse',
						fw: newId
					};
					var environmentWithErr = canBeRemovedResult.dS ? A2($author$project$Environments$Environment$addError, newError, updatedEnvironment) : updatedEnvironment;
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setPlanStore(updatedRepository),
						A3(
							storeFunction,
							$author$project$Plan$Command$commandId(failedCommand),
							environmentWithErr,
							$author$project$Environments$Repository$planStore(updatedRepository)));
				}
			case 12:
				var audits_ = httpMsg.a;
				var newAuditService = A2(
					$author$project$Audit$Service$receivedAuditsResponse,
					audits_,
					$author$project$Environments$Repository$auditService(repository));
				return _Utils_Tuple3(
					environment,
					A2($author$project$Environments$Repository$setAuditService, repository, newAuditService),
					$elm$core$Platform$Cmd$none);
			case 15:
				var command = httpMsg.a;
				return function (updatedRepository) {
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setAuditStore(updatedRepository),
						A3(
							$author$project$Audit$Store$removeCommand,
							$author$project$Audit$Command$commandId(command),
							environment,
							$author$project$Environments$Repository$auditStore(updatedRepository)));
				}(
					A2(
						$author$project$Environments$Repository$setAuditService,
						repository,
						$author$project$Audit$Service$receivedCommandResponse(
							$author$project$Environments$Repository$auditService(repository))));
			case 16:
				var status = httpMsg.a;
				var resultType = httpMsg.b;
				var responseMessage = httpMsg.c;
				var failedCommand = httpMsg.d;
				if (status === 401) {
					return _Utils_Tuple3(
						$author$project$Environments$Environment$sessionExpired(environment),
						repository,
						$elm$core$Platform$Cmd$none);
				} else {
					var updatedRepository = A2(
						$author$project$Environments$Repository$setAuditService,
						repository,
						A2(
							$author$project$Audit$Service$receivedBadResponse,
							status,
							$author$project$Environments$Repository$auditService(repository)));
					var canBeRemovedResult = A2($author$project$Environments$ErrorHandling$Http$canCommandAndEventBeRemoved, status, responseMessage);
					var storeFunction = (canBeRemovedResult.d7 && canBeRemovedResult.d8) ? $author$project$Audit$Store$removeCommandAndMaybeEvent : ((canBeRemovedResult.d7 && (!canBeRemovedResult.d8)) ? $author$project$Audit$Store$removeCommand : $author$project$Audit$Store$removeNothing);
					var _v7 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v7.a;
					var updatedEnvironment = _v7.b;
					var _v8 = function () {
						if (canBeRemovedResult.dS) {
							var newError = {
								gg: resultType,
								gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
								gH: 'repository.elm',
								gK: 'receivedHttpResponse',
								fw: newId
							};
							return _Utils_Tuple2(
								A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
								updatedRepository);
						} else {
							return _Utils_Tuple2(
								updatedEnvironment,
								A2(
									$author$project$Environments$Repository$addEventStreamWarning,
									{
										ja: $author$project$EventStream$SyncWarning$Audit(failedCommand),
										j5: responseMessage,
										kU: status
									},
									updatedRepository));
						}
					}();
					var environmentWithErr = _v8.a;
					var repositoryWithWarning = _v8.b;
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setAuditStore(repositoryWithWarning),
						A3(
							storeFunction,
							$author$project$Audit$Command$commandId(failedCommand),
							environmentWithErr,
							$author$project$Environments$Repository$auditStore(repositoryWithWarning)));
				}
			case 17:
				var measures_ = httpMsg.a;
				var newMeasureService = A2(
					$author$project$Measure$Service$receivedMeasureResponse,
					measures_,
					$author$project$Environments$Repository$measureService(repository));
				return _Utils_Tuple3(
					environment,
					A2($author$project$Environments$Repository$setMeasureService, repository, newMeasureService),
					$elm$core$Platform$Cmd$none);
			case 19:
				var command = httpMsg.a;
				return function (updatedRepository) {
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setMeasureStore(updatedRepository),
						A3(
							$author$project$Measure$Store$removeCommand,
							$author$project$Measure$Command$commandId(command),
							environment,
							$author$project$Environments$Repository$measureStore(updatedRepository)));
				}(
					A2(
						$author$project$Environments$Repository$setMeasureService,
						repository,
						$author$project$Measure$Service$receivedCommandResponse(
							$author$project$Environments$Repository$measureService(repository))));
			case 20:
				var status = httpMsg.a;
				var resultType = httpMsg.b;
				var responseMessage = httpMsg.c;
				var failedCommand = httpMsg.d;
				if (status === 401) {
					return _Utils_Tuple3(
						$author$project$Environments$Environment$sessionExpired(environment),
						repository,
						$elm$core$Platform$Cmd$none);
				} else {
					var updatedRepository = A2(
						$author$project$Environments$Repository$setMeasureService,
						repository,
						A2(
							$author$project$Measure$Service$receivedBadResponse,
							status,
							$author$project$Environments$Repository$measureService(repository)));
					var canBeRemovedResult = A2($author$project$Environments$ErrorHandling$Http$canCommandAndEventBeRemoved, status, responseMessage);
					var storeFunction = (canBeRemovedResult.d7 && canBeRemovedResult.d8) ? $author$project$Measure$Store$removeCommandAndMaybeEvent : ((canBeRemovedResult.d7 && (!canBeRemovedResult.d8)) ? $author$project$Measure$Store$removeCommand : $author$project$Measure$Store$removeNothing);
					var _v9 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v9.a;
					var updatedEnvironment = _v9.b;
					var newError = {
						gg: resultType,
						gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
						gH: 'repository.elm',
						gK: 'receivedHttpResponse',
						fw: newId
					};
					var environmentWithErr = canBeRemovedResult.dS ? A2($author$project$Environments$Environment$addError, newError, updatedEnvironment) : updatedEnvironment;
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setMeasureStore(updatedRepository),
						A3(
							storeFunction,
							$author$project$Measure$Command$commandId(failedCommand),
							environmentWithErr,
							$author$project$Environments$Repository$measureStore(updatedRepository)));
				}
			case 21:
				var tenant = httpMsg.a;
				var newTenantService = A2(
					$author$project$Tenant$Service$receivedTenantResponse,
					tenant,
					$author$project$Environments$Repository$tenantService(repository));
				return _Utils_Tuple3(
					environment,
					A2($author$project$Environments$Repository$setTenantService, repository, newTenantService),
					$elm$core$Platform$Cmd$none);
			case 22:
				var command = httpMsg.a;
				return function (updatedRepository) {
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setTenantStore(updatedRepository),
						A3(
							$author$project$Tenant$Store$removeCommand,
							$author$project$Tenant$Command$commandId(command),
							environment,
							$author$project$Environments$Repository$tenantStore(updatedRepository)));
				}(
					A2(
						$author$project$Environments$Repository$setTenantService,
						repository,
						$author$project$Tenant$Service$receivedCommandResponse(
							$author$project$Environments$Repository$tenantService(repository))));
			case 23:
				var status = httpMsg.a;
				var resultType = httpMsg.b;
				var responseMessage = httpMsg.c;
				var failedCommand = httpMsg.d;
				if (status === 401) {
					return _Utils_Tuple3(
						$author$project$Environments$Environment$sessionExpired(environment),
						repository,
						$elm$core$Platform$Cmd$none);
				} else {
					var updatedRepository = A2(
						$author$project$Environments$Repository$setTenantService,
						repository,
						A2(
							$author$project$Tenant$Service$receivedBadResponse,
							status,
							$author$project$Environments$Repository$tenantService(repository)));
					var canBeRemovedResult = A2($author$project$Environments$ErrorHandling$Http$canCommandAndEventBeRemoved, status, responseMessage);
					var storeFunction = (canBeRemovedResult.d7 && canBeRemovedResult.d8) ? $author$project$Tenant$Store$removeCommandAndMaybeEvent : ((canBeRemovedResult.d7 && (!canBeRemovedResult.d8)) ? $author$project$Tenant$Store$removeCommand : $author$project$Tenant$Store$removeNothing);
					var _v10 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v10.a;
					var updatedEnvironment = _v10.b;
					var newError = {
						gg: resultType,
						gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
						gH: 'repository.elm',
						gK: 'receivedHttpResponse',
						fw: newId
					};
					var environmentWithErr = canBeRemovedResult.dS ? A2($author$project$Environments$Environment$addError, newError, updatedEnvironment) : updatedEnvironment;
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setTenantStore(updatedRepository),
						A3(
							storeFunction,
							$author$project$Tenant$Command$commandId(failedCommand),
							environmentWithErr,
							$author$project$Environments$Repository$tenantStore(updatedRepository)));
				}
			case 24:
				var checkpointData_ = httpMsg.a;
				var newCheckpointDataService = A2(
					$author$project$CheckpointData$Service$receivedCheckpointDataResponse,
					checkpointData_,
					$author$project$Environments$Repository$checkpointDataService(repository));
				return _Utils_Tuple3(
					environment,
					A2($author$project$Environments$Repository$setCheckpointDataService, repository, newCheckpointDataService),
					$elm$core$Platform$Cmd$none);
			case 25:
				var command = httpMsg.a;
				return function (updatedRepository) {
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setCheckpointDataStore(updatedRepository),
						A3(
							$author$project$CheckpointData$Store$removeCommand,
							$author$project$CheckpointData$Command$commandId(command),
							environment,
							$author$project$Environments$Repository$checkpointDataStore(updatedRepository)));
				}(
					A2(
						$author$project$Environments$Repository$setCheckpointDataService,
						repository,
						$author$project$CheckpointData$Service$receivedCommandResponse(
							$author$project$Environments$Repository$checkpointDataService(repository))));
			case 26:
				var status = httpMsg.a;
				var resultType = httpMsg.b;
				var responseMessage = httpMsg.c;
				var failedCommand = httpMsg.d;
				if (status === 401) {
					return _Utils_Tuple3(
						$author$project$Environments$Environment$sessionExpired(environment),
						repository,
						$elm$core$Platform$Cmd$none);
				} else {
					var updatedRepository = A2(
						$author$project$Environments$Repository$setCheckpointDataService,
						repository,
						A2(
							$author$project$CheckpointData$Service$receivedBadResponse,
							status,
							$author$project$Environments$Repository$checkpointDataService(repository)));
					var canBeRemovedResult = A2($author$project$Environments$ErrorHandling$Http$canCommandAndEventBeRemoved, status, responseMessage);
					var storeFunction = (canBeRemovedResult.d7 && canBeRemovedResult.d8) ? $author$project$CheckpointData$Store$removeCommandAndMaybeEvent : ((canBeRemovedResult.d7 && (!canBeRemovedResult.d8)) ? $author$project$CheckpointData$Store$removeCommand : $author$project$CheckpointData$Store$removeNothing);
					var _v11 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v11.a;
					var updatedEnvironment = _v11.b;
					var newError = {
						gg: resultType,
						gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
						gH: 'repository.elm',
						gK: 'receivedHttpResponse',
						fw: newId
					};
					var environmentWithErr = canBeRemovedResult.dS ? A2($author$project$Environments$Environment$addError, newError, updatedEnvironment) : updatedEnvironment;
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setCheckpointDataStore(updatedRepository),
						A3(
							storeFunction,
							$author$project$CheckpointData$Command$commandId(failedCommand),
							environmentWithErr,
							$author$project$Environments$Repository$checkpointDataStore(updatedRepository)));
				}
			case 27:
				var rights_ = httpMsg.a;
				var newRightsService = A2(
					$author$project$Rights$Service$receivedRightsResponse,
					rights_,
					$author$project$Environments$Repository$rightsService(repository));
				return _Utils_Tuple3(
					A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 1, environment),
					A2($author$project$Environments$Repository$setRightsService, repository, newRightsService),
					$elm$core$Platform$Cmd$none);
			case 28:
				var command = httpMsg.a;
				return function (updatedRepository) {
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setRightsStore(updatedRepository),
						A3(
							$author$project$Rights$Store$removeCommand,
							$author$project$Rights$Command$commandId(command),
							environment,
							$author$project$Environments$Repository$rightsStore(updatedRepository)));
				}(
					A2(
						$author$project$Environments$Repository$setRightsService,
						repository,
						$author$project$Rights$Service$receivedCommandResponse(
							$author$project$Environments$Repository$rightsService(repository))));
			case 29:
				var status = httpMsg.a;
				var resultType = httpMsg.b;
				var responseMessage = httpMsg.c;
				var failedCommand = httpMsg.d;
				if (status === 401) {
					return _Utils_Tuple3(
						$author$project$Environments$Environment$sessionExpired(environment),
						repository,
						$elm$core$Platform$Cmd$none);
				} else {
					var updatedRepository = A2(
						$author$project$Environments$Repository$setRightsService,
						repository,
						A2(
							$author$project$Rights$Service$receivedBadResponse,
							status,
							$author$project$Environments$Repository$rightsService(repository)));
					var canBeRemovedResult = A2($author$project$Environments$ErrorHandling$Http$canCommandAndEventBeRemoved, status, responseMessage);
					var storeFunction = (canBeRemovedResult.d7 && canBeRemovedResult.d8) ? $author$project$Rights$Store$removeCommandAndMaybeEvent : ((canBeRemovedResult.d7 && (!canBeRemovedResult.d8)) ? $author$project$Rights$Store$removeCommand : $author$project$Rights$Store$removeNothing);
					var _v12 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v12.a;
					var updatedEnvironment = _v12.b;
					var newError = {
						gg: resultType,
						gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
						gH: 'repository.elm',
						gK: 'receivedHttpResponse',
						fw: newId
					};
					var environmentWithErr = canBeRemovedResult.dS ? A2($author$project$Environments$Environment$addError, newError, updatedEnvironment) : updatedEnvironment;
					return A2(
						$author$project$Utils$Triple$mapSecond,
						$author$project$Environments$Repository$setRightsStore(updatedRepository),
						A3(
							storeFunction,
							$author$project$Rights$Command$commandId(failedCommand),
							environmentWithErr,
							$author$project$Environments$Repository$rightsStore(updatedRepository)));
				}
			default:
				return _Utils_Tuple3(environment, repository, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Measure$Store$loadedData = F3(
	function (data, state, environment) {
		switch (state.$) {
			case 0:
				return ($author$project$Utils$Maybe$isJust(
					$author$project$Measure$Measures$lastEventId(data.aI)) || $author$project$Environments$Environment$isOffline(environment)) ? $author$project$Measure$Store$Loaded(
					{cD: data.cD, b8: data.b8, aI: data.aI}) : $author$project$Measure$Store$Uninitialized(
					{cD: data.cD, b8: data.b8});
			case 1:
				return state;
			case 2:
				return state;
			default:
				return state;
		}
	});
var $author$project$Measure$Store$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'Measure.Store.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$Measure$Store$removedCommand = $elm$core$Basics$identity;
var $author$project$Measure$Events$fromList = $author$project$Types$Queue$fromList;
var $author$project$Measure$Store$removeEvent = F4(
	function (commandId, measureId, eventVersion, data) {
		return _Utils_update(
			data,
			{
				b8: $author$project$Measure$Events$fromList(
					A2(
						$elm$core$List$filter,
						function (event) {
							return !(_Utils_eq(
								$author$project$Measure$Event$commandId(event),
								commandId) && (_Utils_eq(
								$author$project$Measure$Event$measureId(event),
								measureId) && _Utils_eq(
								$author$project$Measure$Event$version(event),
								eventVersion)));
						},
						$author$project$Measure$Events$toList(data.b8)))
			});
	});
var $author$project$Measure$Store$removedCommandAndEvent = F4(
	function (state, commandId, measureId, eventVersion) {
		switch (state.$) {
			case 0:
				return $author$project$Measure$Store$Loading;
			case 1:
				var record = state.a;
				return $author$project$Measure$Store$Uninitialized(
					A4($author$project$Measure$Store$removeEvent, commandId, measureId, eventVersion, record));
			case 2:
				var data = state.a;
				return $author$project$Measure$Store$Loaded(
					A4($author$project$Measure$Store$removeEvent, commandId, measureId, eventVersion, data));
			default:
				var data = state.a;
				return $author$project$Measure$Store$Saving(
					A4($author$project$Measure$Store$removeEvent, commandId, measureId, eventVersion, data));
		}
	});
var $author$project$Measure$Store$savedCommandsAndEvents = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Measure$Store$Loaded(data);
	}
};
var $author$project$Measure$Store$savedMeasures = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Measure$Store$Loaded(data);
	}
};
var $author$project$Measure$Store$savedModifications = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Measure$Store$Loaded(data);
	}
};
var $author$project$Measure$Store$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var data = msg.a;
				return _Utils_Tuple2(
					environment,
					A3($author$project$Measure$Store$loadedData, data, state, environment));
			case 1:
				return _Utils_Tuple2(
					environment,
					$author$project$Measure$Store$savedMeasures(state));
			case 2:
				return _Utils_Tuple2(
					environment,
					$author$project$Measure$Store$savedModifications(state));
			case 3:
				return _Utils_Tuple2(
					environment,
					$author$project$Measure$Store$savedCommandsAndEvents(state));
			case 4:
				return _Utils_Tuple2(
					environment,
					$author$project$Measure$Store$removedCommand(state));
			case 5:
				var commandId = msg.a;
				var measureId = msg.b;
				var eventVersion = msg.c;
				return _Utils_Tuple2(
					environment,
					A4($author$project$Measure$Store$removedCommandAndEvent, state, commandId, measureId, eventVersion));
			default:
				var err = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Measure$Store$receivedErrorMsg, err, environment),
					state);
		}
	});
var $author$project$Environments$Repository$receivedMeasureStoreMsg = F3(
	function (storeMsg, environment, repository) {
		var _v0 = A3(
			$author$project$Measure$Store$update,
			storeMsg,
			environment,
			$author$project$Environments$Repository$measureStore(repository));
		var newEnvironment = _v0.a;
		var newState = _v0.b;
		return _Utils_Tuple3(
			newEnvironment,
			A2($author$project$Environments$Repository$withMeasureStore, newState, repository),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$OrganisationUnit$Store$loadedData = F2(
	function (data, state) {
		switch (state.$) {
			case 0:
				return $author$project$Utils$Maybe$isJust(
					$author$project$OrganisationUnit$OrganisationUnits$lastEventId(data.kn)) ? $author$project$OrganisationUnit$Store$Loaded(
					{cD: data.cD, b8: data.b8, kn: data.kn}) : $author$project$OrganisationUnit$Store$Uninitialized(
					{cD: data.cD, b8: data.b8});
			case 1:
				return state;
			case 2:
				return state;
			default:
				return state;
		}
	});
var $author$project$OrganisationUnit$Store$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'OrganisationUnit.Store.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$OrganisationUnit$Store$removedCommand = $elm$core$Basics$identity;
var $author$project$OrganisationUnit$Events$fromList = $author$project$Types$Queue$fromList;
var $author$project$OrganisationUnit$Store$removeEvent = F3(
	function (commandId, eventVersion, data) {
		return _Utils_update(
			data,
			{
				b8: $author$project$OrganisationUnit$Events$fromList(
					A2(
						$elm$core$List$filter,
						function (event) {
							return !(_Utils_eq(
								$author$project$OrganisationUnit$Event$commandId(event),
								commandId) && _Utils_eq(
								$author$project$OrganisationUnit$Event$version(event),
								eventVersion));
						},
						$author$project$OrganisationUnit$Events$toList(data.b8)))
			});
	});
var $author$project$OrganisationUnit$Store$removedCommandAndEvent = F3(
	function (state, commandId, eventVersion) {
		switch (state.$) {
			case 0:
				return $author$project$OrganisationUnit$Store$Loading;
			case 1:
				var record = state.a;
				return $author$project$OrganisationUnit$Store$Uninitialized(
					A3($author$project$OrganisationUnit$Store$removeEvent, commandId, eventVersion, record));
			case 2:
				var data = state.a;
				return $author$project$OrganisationUnit$Store$Loaded(
					A3($author$project$OrganisationUnit$Store$removeEvent, commandId, eventVersion, data));
			default:
				var data = state.a;
				return $author$project$OrganisationUnit$Store$Saving(
					A3($author$project$OrganisationUnit$Store$removeEvent, commandId, eventVersion, data));
		}
	});
var $author$project$OrganisationUnit$Store$savedCommandsAndEvents = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$OrganisationUnit$Store$Loaded(data);
	}
};
var $author$project$OrganisationUnit$Store$savedModifications = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$OrganisationUnit$Store$Loaded(data);
	}
};
var $author$project$OrganisationUnit$Store$savedOrganisationUnits = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$OrganisationUnit$Store$Loaded(data);
	}
};
var $author$project$OrganisationUnit$Store$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var data = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$OrganisationUnit$Store$loadedData, data, state));
			case 1:
				return _Utils_Tuple2(
					environment,
					$author$project$OrganisationUnit$Store$savedOrganisationUnits(state));
			case 2:
				return _Utils_Tuple2(
					environment,
					$author$project$OrganisationUnit$Store$savedModifications(state));
			case 3:
				return _Utils_Tuple2(
					environment,
					$author$project$OrganisationUnit$Store$savedCommandsAndEvents(state));
			case 4:
				return _Utils_Tuple2(
					environment,
					$author$project$OrganisationUnit$Store$removedCommand(state));
			case 5:
				var commandId = msg.a;
				var eventVersion = msg.b;
				return _Utils_Tuple2(
					environment,
					A3($author$project$OrganisationUnit$Store$removedCommandAndEvent, state, commandId, eventVersion));
			default:
				var err = msg.a;
				return _Utils_Tuple2(
					A2($author$project$OrganisationUnit$Store$receivedErrorMsg, err, environment),
					state);
		}
	});
var $author$project$Environments$Repository$receivedOrganisationUnitStoreMsg = F3(
	function (storeMsg, environment, repository) {
		var _v0 = A3(
			$author$project$OrganisationUnit$Store$update,
			storeMsg,
			environment,
			$author$project$Environments$Repository$organisationUnitStore(repository));
		var newEnvironment = _v0.a;
		var newState = _v0.b;
		return _Utils_Tuple3(
			newEnvironment,
			A2($author$project$Environments$Repository$withOrganisationUnitStore, newState, repository),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Plan$Store$loadedData = F2(
	function (data, state) {
		switch (state.$) {
			case 0:
				return $author$project$Utils$Maybe$isJust(
					$author$project$Plan$Plans$lastEventId(data.aL)) ? $author$project$Plan$Store$Loaded(
					{cD: data.cD, b8: data.b8, aL: data.aL}) : $author$project$Plan$Store$Uninitialized(
					{cD: data.cD, b8: data.b8});
			case 1:
				return state;
			case 2:
				return state;
			default:
				return state;
		}
	});
var $author$project$Plan$Store$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'Plan.Store.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$Plan$Store$removedCommand = $elm$core$Basics$identity;
var $author$project$Plan$Events$fromList = $author$project$Types$Queue$fromList;
var $author$project$Plan$Store$removeEvent = F4(
	function (commandId, planId, eventVersion, data) {
		return _Utils_update(
			data,
			{
				b8: $author$project$Plan$Events$fromList(
					A2(
						$elm$core$List$filter,
						function (event) {
							return !(_Utils_eq(
								$author$project$Plan$Event$commandId(event),
								commandId) && (_Utils_eq(
								$author$project$Plan$Event$planId(event),
								planId) && _Utils_eq(
								$author$project$Plan$Event$version(event),
								eventVersion)));
						},
						$author$project$Plan$Events$toList(data.b8)))
			});
	});
var $author$project$Plan$Store$removedCommandAndEvent = F4(
	function (state, commandId, planId, eventVersion) {
		switch (state.$) {
			case 0:
				return $author$project$Plan$Store$Loading;
			case 1:
				var record = state.a;
				return $author$project$Plan$Store$Uninitialized(
					A4($author$project$Plan$Store$removeEvent, commandId, planId, eventVersion, record));
			case 2:
				var data = state.a;
				return $author$project$Plan$Store$Loaded(
					A4($author$project$Plan$Store$removeEvent, commandId, planId, eventVersion, data));
			default:
				var data = state.a;
				return $author$project$Plan$Store$Saving(
					A4($author$project$Plan$Store$removeEvent, commandId, planId, eventVersion, data));
		}
	});
var $author$project$Plan$Store$savedCommandsAndEvents = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Plan$Store$Loaded(data);
	}
};
var $author$project$Plan$Store$savedModifications = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Plan$Store$Loaded(data);
	}
};
var $author$project$Plan$Store$savedPlans = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Plan$Store$Loaded(data);
	}
};
var $author$project$Plan$Store$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var data = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$Plan$Store$loadedData, data, state));
			case 1:
				return _Utils_Tuple2(
					environment,
					$author$project$Plan$Store$savedPlans(state));
			case 2:
				return _Utils_Tuple2(
					environment,
					$author$project$Plan$Store$savedModifications(state));
			case 3:
				return _Utils_Tuple2(
					environment,
					$author$project$Plan$Store$savedCommandsAndEvents(state));
			case 4:
				return _Utils_Tuple2(
					environment,
					$author$project$Plan$Store$removedCommand(state));
			case 5:
				var commandId = msg.a;
				var planId = msg.b;
				var eventVersion = msg.c;
				return _Utils_Tuple2(
					environment,
					A4($author$project$Plan$Store$removedCommandAndEvent, state, commandId, planId, eventVersion));
			default:
				var err = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Plan$Store$receivedErrorMsg, err, environment),
					state);
		}
	});
var $author$project$Environments$Repository$receivedPlanStoreMsg = F3(
	function (storeMsg, environment, repository) {
		var _v0 = A3(
			$author$project$Plan$Store$update,
			storeMsg,
			environment,
			$author$project$Environments$Repository$planStore(repository));
		var newEnvironment = _v0.a;
		var newState = _v0.b;
		return _Utils_Tuple3(
			newEnvironment,
			A2($author$project$Environments$Repository$withPlanStore, newState, repository),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Rights$Store$loadedData = F2(
	function (data, state) {
		switch (state.$) {
			case 0:
				return $author$project$Utils$Maybe$isJust(
					$author$project$Rights$Rights$lastEventId(data.kF)) ? $author$project$Rights$Store$Loaded(
					{cD: data.cD, b8: data.b8, kF: data.kF}) : $author$project$Rights$Store$Uninitialized(
					{cD: data.cD, b8: data.b8});
			case 1:
				return state;
			case 2:
				return state;
			default:
				return state;
		}
	});
var $author$project$Rights$Store$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'Rights.Store.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$Rights$Store$removedCommand = $elm$core$Basics$identity;
var $author$project$Rights$Events$fromList = $author$project$Types$Queue$fromList;
var $author$project$Rights$Store$removeEvent = F3(
	function (commandId, eventVersion, data) {
		return _Utils_update(
			data,
			{
				b8: $author$project$Rights$Events$fromList(
					A2(
						$elm$core$List$filter,
						function (event) {
							return !(_Utils_eq(
								$author$project$Rights$Event$commandId(event),
								commandId) && _Utils_eq(
								$author$project$Rights$Event$version(event),
								eventVersion));
						},
						$author$project$Rights$Events$toList(data.b8)))
			});
	});
var $author$project$Rights$Store$removedCommandAndEvent = F3(
	function (state, commandId, eventVersion) {
		switch (state.$) {
			case 0:
				return $author$project$Rights$Store$Loading;
			case 1:
				var record = state.a;
				return $author$project$Rights$Store$Uninitialized(
					A3($author$project$Rights$Store$removeEvent, commandId, eventVersion, record));
			case 2:
				var data = state.a;
				return $author$project$Rights$Store$Loaded(
					A3($author$project$Rights$Store$removeEvent, commandId, eventVersion, data));
			default:
				var data = state.a;
				return $author$project$Rights$Store$Saving(
					A3($author$project$Rights$Store$removeEvent, commandId, eventVersion, data));
		}
	});
var $author$project$Rights$Store$savedCommandsAndEvents = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Rights$Store$Loaded(data);
	}
};
var $author$project$Rights$Store$savedModifications = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Rights$Store$Loaded(data);
	}
};
var $author$project$Rights$Store$savedRights = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Rights$Store$Loaded(data);
	}
};
var $author$project$Rights$Store$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var data = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$Rights$Store$loadedData, data, state));
			case 1:
				return _Utils_Tuple2(
					environment,
					$author$project$Rights$Store$savedRights(state));
			case 2:
				return _Utils_Tuple2(
					environment,
					$author$project$Rights$Store$savedModifications(state));
			case 3:
				return _Utils_Tuple2(
					environment,
					$author$project$Rights$Store$savedCommandsAndEvents(state));
			case 4:
				return _Utils_Tuple2(
					environment,
					$author$project$Rights$Store$removedCommand(state));
			case 5:
				var commandId = msg.a;
				var eventVersion = msg.b;
				return _Utils_Tuple2(
					environment,
					A3($author$project$Rights$Store$removedCommandAndEvent, state, commandId, eventVersion));
			default:
				var err = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Rights$Store$receivedErrorMsg, err, environment),
					state);
		}
	});
var $author$project$Environments$Repository$receivedRightsStoreMsg = F3(
	function (storeMsg, environment, repository) {
		var _v0 = A3(
			$author$project$Rights$Store$update,
			storeMsg,
			environment,
			$author$project$Environments$Repository$rightsStore(repository));
		var newEnvironment = _v0.a;
		var newState = _v0.b;
		return _Utils_Tuple3(
			newEnvironment,
			A2($author$project$Environments$Repository$withRightsStore, newState, repository),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Tenant$Store$loadedData = F2(
	function (data, state) {
		switch (state.$) {
			case 0:
				return $author$project$Utils$Maybe$isJust(
					A3(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$Tenant$Tenant$lastEventId),
						$elm$core$Maybe$withDefault($elm$core$Maybe$Nothing),
						data.iC)) ? $author$project$Tenant$Store$Loaded(
					{cD: data.cD, b8: data.b8, iC: data.iC}) : $author$project$Tenant$Store$Uninitialized(
					{cD: data.cD, b8: data.b8});
			case 1:
				return state;
			case 2:
				return state;
			default:
				return state;
		}
	});
var $author$project$Tenant$Store$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'Tenant.Store.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$Tenant$Store$removedCommand = $elm$core$Basics$identity;
var $author$project$Tenant$Events$fromList = $author$project$Types$Queue$fromList;
var $author$project$Tenant$Store$removeEvent = F4(
	function (commandId, tenantId, eventVersion, data) {
		return _Utils_update(
			data,
			{
				b8: $author$project$Tenant$Events$fromList(
					A2(
						$elm$core$List$filter,
						function (event) {
							return !(_Utils_eq(
								$author$project$Tenant$Event$commandId(event),
								commandId) && (_Utils_eq(
								$author$project$Tenant$Event$tenantId(event),
								tenantId) && _Utils_eq(
								$author$project$Tenant$Event$version(event),
								eventVersion)));
						},
						$author$project$Tenant$Events$toList(data.b8)))
			});
	});
var $author$project$Tenant$Store$removedCommandAndEvent = F4(
	function (state, commandId, tenantId, eventVersion) {
		switch (state.$) {
			case 0:
				return $author$project$Tenant$Store$Loading;
			case 1:
				var record = state.a;
				return $author$project$Tenant$Store$Uninitialized(
					A4($author$project$Tenant$Store$removeEvent, commandId, tenantId, eventVersion, record));
			case 2:
				var data = state.a;
				return $author$project$Tenant$Store$Loaded(
					A4($author$project$Tenant$Store$removeEvent, commandId, tenantId, eventVersion, data));
			default:
				var data = state.a;
				return $author$project$Tenant$Store$Saving(
					A4($author$project$Tenant$Store$removeEvent, commandId, tenantId, eventVersion, data));
		}
	});
var $author$project$Tenant$Store$savedCommandsAndEvents = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Tenant$Store$Loaded(data);
	}
};
var $author$project$Tenant$Store$savedModifications = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Tenant$Store$Loaded(data);
	}
};
var $author$project$Tenant$Store$savedTenant = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$Tenant$Store$Loaded(data);
	}
};
var $author$project$Tenant$Store$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var data = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$Tenant$Store$loadedData, data, state));
			case 1:
				return _Utils_Tuple2(
					environment,
					$author$project$Tenant$Store$savedTenant(state));
			case 2:
				return _Utils_Tuple2(
					environment,
					$author$project$Tenant$Store$savedModifications(state));
			case 3:
				return _Utils_Tuple2(
					environment,
					$author$project$Tenant$Store$savedCommandsAndEvents(state));
			case 4:
				return _Utils_Tuple2(
					environment,
					$author$project$Tenant$Store$removedCommand(state));
			case 5:
				var commandId = msg.a;
				var tenantId = msg.b;
				var eventVersion = msg.c;
				return _Utils_Tuple2(
					environment,
					A4($author$project$Tenant$Store$removedCommandAndEvent, state, commandId, tenantId, eventVersion));
			default:
				var err = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Tenant$Store$receivedErrorMsg, err, environment),
					state);
		}
	});
var $author$project$Environments$Repository$receivedTenantStoreMsg = F3(
	function (storeMsg, environment, repository) {
		var _v0 = A3(
			$author$project$Tenant$Store$update,
			storeMsg,
			environment,
			$author$project$Environments$Repository$tenantStore(repository));
		var newEnvironment = _v0.a;
		var newState = _v0.b;
		return _Utils_Tuple3(
			newEnvironment,
			A2($author$project$Environments$Repository$withTenantStore, newState, repository),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$User$Store$isLoadedDataMsg = function (msg) {
	if (!msg.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$User$Store$loadedData = F2(
	function (data, state) {
		switch (state.$) {
			case 0:
				return $author$project$Utils$Maybe$isJust(
					$author$project$User$Users$lastEventId(data.lk)) ? $author$project$User$Store$Loaded(
					{cD: data.cD, b8: data.b8, lk: data.lk}) : $author$project$User$Store$Uninitialized(
					{cD: data.cD, b8: data.b8});
			case 1:
				return state;
			case 2:
				return state;
			default:
				return state;
		}
	});
var $author$project$User$Store$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'User.Store.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$User$Store$removedCommand = $elm$core$Basics$identity;
var $author$project$User$Events$fromList = $author$project$Types$Queue$fromList;
var $author$project$User$Store$removeEvent = F4(
	function (commandId, userId, eventVersion, data) {
		return _Utils_update(
			data,
			{
				b8: $author$project$User$Events$fromList(
					A2(
						$elm$core$List$filter,
						function (event) {
							return !(_Utils_eq(
								$author$project$User$Event$commandId(event),
								commandId) && (_Utils_eq(
								$author$project$User$Event$userId(event),
								userId) && _Utils_eq(
								$author$project$User$Event$version(event),
								eventVersion)));
						},
						$author$project$User$Events$toList(data.b8)))
			});
	});
var $author$project$User$Store$removedCommandAndEvent = F4(
	function (state, commandId, userId, eventVersion) {
		switch (state.$) {
			case 0:
				return $author$project$User$Store$Loading;
			case 1:
				var record = state.a;
				return $author$project$User$Store$Uninitialized(
					A4($author$project$User$Store$removeEvent, commandId, userId, eventVersion, record));
			case 2:
				var data = state.a;
				return $author$project$User$Store$Loaded(
					A4($author$project$User$Store$removeEvent, commandId, userId, eventVersion, data));
			default:
				var data = state.a;
				return $author$project$User$Store$Saving(
					A4($author$project$User$Store$removeEvent, commandId, userId, eventVersion, data));
		}
	});
var $author$project$User$Store$savedCommandsAndEvents = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$User$Store$Loaded(data);
	}
};
var $author$project$User$Store$savedModifications = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$User$Store$Loaded(data);
	}
};
var $author$project$User$Store$savedUsers = function (state) {
	switch (state.$) {
		case 0:
			return state;
		case 1:
			return state;
		case 2:
			return state;
		default:
			var data = state.a;
			return $author$project$User$Store$Loaded(data);
	}
};
var $author$project$User$Store$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var data = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$User$Store$loadedData, data, state));
			case 1:
				return _Utils_Tuple2(
					environment,
					$author$project$User$Store$savedUsers(state));
			case 2:
				return _Utils_Tuple2(
					environment,
					$author$project$User$Store$savedModifications(state));
			case 3:
				return _Utils_Tuple2(
					environment,
					$author$project$User$Store$savedCommandsAndEvents(state));
			case 4:
				return _Utils_Tuple2(
					environment,
					$author$project$User$Store$removedCommand(state));
			case 5:
				var commandId = msg.a;
				var userId = msg.b;
				var eventVersion = msg.c;
				return _Utils_Tuple2(
					environment,
					A4($author$project$User$Store$removedCommandAndEvent, state, commandId, userId, eventVersion));
			default:
				var err = msg.a;
				return _Utils_Tuple2(
					A2($author$project$User$Store$receivedErrorMsg, err, environment),
					state);
		}
	});
var $author$project$Environments$Repository$receivedUserStoreMsg = F3(
	function (storeMsg, environment, repository) {
		var _v0 = A3(
			$author$project$User$Store$update,
			storeMsg,
			environment,
			$author$project$Environments$Repository$userStore(repository));
		var newEnvironment = _v0.a;
		var newState = _v0.b;
		var newRepository = A2($author$project$Environments$Repository$withUserStore, newState, repository);
		var userEntryOrganisationUnit = $author$project$User$Store$isLoadedDataMsg(storeMsg) ? A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hT;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (userId) {
						return A2($author$project$Environments$Repository$getUser, userId, newRepository);
					},
					$author$project$Auth$Session$maybeUserId(
						$author$project$Environments$Environment$session(newEnvironment))))) : $author$project$Environments$Environment$getCurrentOrganisationUnit(environment);
		return _Utils_Tuple3(
			A2($author$project$Environments$Environment$setCurrentOrganisationUnit, newEnvironment, userEntryOrganisationUnit),
			newRepository,
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Environments$Repository$updateHelper = function (msg) {
	switch (msg.$) {
		case 1:
			var eventStreamMsg = msg.a;
			return $author$project$Environments$Repository$receivedEventStreamMsg(eventStreamMsg);
		case 0:
			var storeMsg = msg.a;
			return $author$project$Environments$Repository$receivedFileStoreMsg(storeMsg);
		case 2:
			var storeMsg = msg.a;
			return $author$project$Environments$Repository$receivedUserStoreMsg(storeMsg);
		case 3:
			var storeMsg = msg.a;
			return $author$project$Environments$Repository$receivedOrganisationUnitStoreMsg(storeMsg);
		case 4:
			var storeMsg = msg.a;
			return $author$project$Environments$Repository$receivedPlanStoreMsg(storeMsg);
		case 5:
			var storeMsg = msg.a;
			return $author$project$Environments$Repository$receivedAuditStoreMsg(storeMsg);
		case 6:
			var storeMsg = msg.a;
			return $author$project$Environments$Repository$receivedMeasureStoreMsg(storeMsg);
		case 7:
			var storeMsg = msg.a;
			return $author$project$Environments$Repository$receivedTenantStoreMsg(storeMsg);
		case 8:
			var storeMsg = msg.a;
			return $author$project$Environments$Repository$receivedCheckpointDataStoreMsg(storeMsg);
		case 9:
			var storeMsg = msg.a;
			return $author$project$Environments$Repository$receivedRightsStoreMsg(storeMsg);
		default:
			var httpMsg = msg.a;
			return $author$project$Environments$Repository$receivedHttpResponse(httpMsg);
	}
};
var $author$project$Environments$Repository$update = F2(
	function (msg, environment) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Environments$Repository$updateHelper, msg, environment),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Utils$Triple$mapThird($elm$core$List$singleton),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Environments$Repository$fetchUsers,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Environments$Repository$sendUserCommands,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Environments$Repository$applyUserEvents,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Environments$Repository$fetchRights,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Environments$Repository$sendRightsCommands,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Environments$Repository$applyRightsEvents,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Environments$Repository$fetchOrganisationUnits,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Environments$Repository$sendOrganisationUnitCommands,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Environments$Repository$applyOrganisationUnitEvents,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Environments$Repository$fetchCheckpointData,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Environments$Repository$sendCheckpointDataCommands,
															A2(
																$elm$core$Basics$composeR,
																$author$project$Environments$Repository$applyCheckpointDataEvents,
																A2(
																	$elm$core$Basics$composeR,
																	$author$project$Environments$Repository$fetchPlans,
																	A2(
																		$elm$core$Basics$composeR,
																		$author$project$Environments$Repository$sendPlanCommands,
																		A2(
																			$elm$core$Basics$composeR,
																			$author$project$Environments$Repository$applyPlanEvents,
																			A2(
																				$elm$core$Basics$composeR,
																				$author$project$Environments$Repository$fetchAudits,
																				A2(
																					$elm$core$Basics$composeR,
																					$author$project$Environments$Repository$sendAuditCommands,
																					A2(
																						$elm$core$Basics$composeR,
																						$author$project$Environments$Repository$applyAuditEvents,
																						A2(
																							$elm$core$Basics$composeR,
																							$author$project$Environments$Repository$fetchMeasures,
																							A2(
																								$elm$core$Basics$composeR,
																								$author$project$Environments$Repository$sendMeasureCommands,
																								A2(
																									$elm$core$Basics$composeR,
																									$author$project$Environments$Repository$applyMeasureEvents,
																									A2(
																										$elm$core$Basics$composeR,
																										$author$project$Environments$Repository$fetchTenant,
																										A2(
																											$elm$core$Basics$composeR,
																											$author$project$Environments$Repository$sendTenantCommands,
																											A2(
																												$elm$core$Basics$composeR,
																												$author$project$Environments$Repository$applyTenantEvents,
																												A2(
																													$elm$core$Basics$composeR,
																													$author$project$Environments$Repository$connectToEventStream,
																													A2(
																														$elm$core$Basics$composeR,
																														$author$project$Environments$Repository$disconnectFromEventStream,
																														A2(
																															$elm$core$Basics$composeR,
																															$author$project$Environments$Repository$startFileSynchronization,
																															A2(
																																$elm$core$Basics$composeR,
																																$author$project$Environments$Repository$stopFileSynchronization,
																																$author$project$Utils$Triple$mapThird($elm$core$Platform$Cmd$batch)))))))))))))))))))))))))))))));
	});
var $author$project$EventStream$Page$receivedRepositoryMsg = F4(
	function (repositoryMsg, environment, repository, page) {
		var _v0 = A3($author$project$Environments$Repository$update, repositoryMsg, environment, repository);
		var newEnvironment = _v0.a;
		var newRepository = _v0.b;
		var cmd_ = _v0.c;
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$EventStream$Page$ReceivedRepositoryMsg, cmd_),
			ac: newEnvironment,
			ak: page,
			ae: newRepository
		};
	});
var $author$project$Environments$Repository$reconnectEventStreamHelper = function (repository) {
	var data = repository;
	var _v0 = A2(
		$author$project$EventStream$EventStream$reconnect,
		1,
		$author$project$Environments$Repository$eventStreamConnectParameters(repository));
	var state = _v0.a;
	var cmd_ = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			data,
			{j: state}),
		A2($elm$core$Platform$Cmd$map, $author$project$Environments$Repository$ReceivedEventStreamMsg, cmd_));
};
var $author$project$Environments$Repository$reconnectEventStream = function (repository) {
	var _v0 = $author$project$Environments$Repository$eventStream(repository);
	switch (_v0.$) {
		case 1:
			return $author$project$Environments$Repository$reconnectEventStreamHelper(repository);
		case 0:
			return $author$project$Environments$Repository$reconnectEventStreamHelper(repository);
		default:
			return _Utils_Tuple2(repository, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$EventStream$Page$reconnectEventStream = F3(
	function (environment, repository, page) {
		var _v0 = $author$project$Environments$Repository$reconnectEventStream(repository);
		var newRepository = _v0.a;
		var cmd_ = _v0.b;
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$EventStream$Page$ReceivedRepositoryMsg, cmd_),
			ac: environment,
			ak: page,
			ae: newRepository
		};
	});
var $author$project$EventStream$Page$ReceivedEnvironmentMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Environments$Environment$RemoveData = {$: 5};
var $author$project$Environments$Environment$resetData = function (state) {
	return _Utils_Tuple2(
		A2(
			$author$project$Environments$Environment$map,
			function (model) {
				return _Utils_update(
					model,
					{bL: 3});
			},
			state),
		$author$project$Environments$Environment$send($author$project$Environments$Environment$RemoveData));
};
var $author$project$EventStream$Page$userClickedStartCompleteSynchronisation = F3(
	function (environment, repository, page) {
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$EventStream$Page$ReceivedRepositoryMsg),
			A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Environments$Repository$setEventStream(repository),
				$author$project$EventStream$EventStream$disconnect(
					$author$project$Environments$Repository$eventStream(repository))));
		var newRepository = _v0.a;
		var repositoryCmd = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$EventStream$Page$ReceivedEnvironmentMsg),
			$author$project$Environments$Environment$resetData(environment));
		var newEnvironment = _v1.a;
		var environmentCmd = _v1.b;
		return {
			ab: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[repositoryCmd, environmentCmd])),
			ac: newEnvironment,
			ak: page,
			ae: newRepository
		};
	});
var $author$project$EventStream$Page$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$EventStream$Page$reconnectEventStream;
		case 1:
			var repositoryMsg = msg.a;
			return $author$project$EventStream$Page$receivedRepositoryMsg(repositoryMsg);
		case 2:
			var environmentMsg = msg.a;
			return $author$project$EventStream$Page$receivedEnvironmentMsg(environmentMsg);
		case 3:
			var contentState = msg.a;
			return $author$project$EventStream$Page$changeCommandContent(contentState);
		case 4:
			var contentState = msg.a;
			return $author$project$EventStream$Page$changeWarningContent(contentState);
		case 5:
			var contentState = msg.a;
			return $author$project$EventStream$Page$changeErrorContent(contentState);
		case 6:
			var err = msg.a;
			return $author$project$EventStream$Page$openErrorModal(err);
		case 7:
			var dialogMsg = msg.a;
			return $author$project$EventStream$Page$gotErrorModalMsg(dialogMsg);
		case 8:
			var syncWarning = msg.a;
			return $author$project$EventStream$Page$deleteSyncWarning(syncWarning);
		case 9:
			return $author$project$EventStream$Page$deleteAllWarnings;
		default:
			return $author$project$EventStream$Page$userClickedStartCompleteSynchronisation;
	}
};
var $author$project$Translations$Synchronisation$overview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.overview');
};
var $author$project$UI$Icons$sync = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 387.84 392.881', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M387.067,195.761c-0.16-7.84-6.559-14.16-14.398-14.16l-132.641,0.16c-0.961-0.16-1.918-0.32-2.88-0.32c-7.921,0-14.401,6.48-14.401,14.398c0,16.88-13.68,30.563-30.558,30.563c-16.879,0-30.559-13.684-30.559-30.563s13.68-30.558,30.559-30.558c7.921,0,14.401-6.481,14.401-14.403c0-7.918-6.479-14.398-14.401-14.398c-27.918,0-51.36,19.359-57.68,45.359l-105.281,0.082c3.761-54.64,34.64-104.082,82.8-131.281c68.879-38.961,154.244-22.398,204.244,35.121l-41.044-7.601c-7.841-1.442-15.358,3.679-16.797,11.52c-1.44,7.84,3.68,15.36,11.521,16.801l74.957,13.922c0.883,0.156,1.762,0.238,2.641,0.238c6.642,0,12.563-4.559,14-11.281l0.16-0.719c0-0.16,0.082-0.32,0.082-0.559V108l13.758-74.16c1.441-7.84-3.68-15.359-11.521-16.8c-7.839-1.438-15.358,3.679-16.801,11.519l-7.438,40.32c-24.801-29.437-57.762-50.797-95.68-61.359C194.59-6.238,142.59,0.082,97.868,25.442C36.349,60.402-1.171,125.999,0.028,196.719c0.161,7.841,6.563,14.16,14.403,14.16l120.238-0.16c6.559,25.603,29.84,44.563,57.441,44.563c27.68,0,50.958-19.039,57.52-44.641l108.238-0.16c-3.758,54.641-34.641,104.077-82.801,131.28c-38.078,21.521-82.238,26.957-124.398,15.197c-32.32-8.961-60.398-27.197-81.52-52.318l42.961,5.681c7.918,1.039,15.118-4.48,16.161-12.398c1.039-7.924-4.481-15.121-12.403-16.16l-75.597-10c-7.922-1.043-15.122,4.48-16.161,12.398l-10,75.602c-1.043,7.918,4.481,15.115,12.399,16.16c0.64,0.076,1.281,0.158,1.922,0.158c7.117,0,13.277-5.279,14.238-12.479l5.199-39.44c24.723,29.121,57.52,50.16,95.039,60.641c17.121,4.719,34.563,7.121,51.839,7.121c32.801,0,65.121-8.479,94.48-25.045C350.747,332.08,388.271,266.479,387.067,195.761L387.067,195.761z')
						]),
					_List_Nil)
				]));
	});
var $author$project$Environments$ErrorHandling$ErrorModal$UserClickedCloseDialog = {$: 0};
var $author$project$Environments$ErrorHandling$ErrorModal$viewAdditionalMsg = F2(
	function (additionalInformation, errorType) {
		var secondContend = function () {
			if (!errorType.$) {
				var error = errorType.a;
				var censoredFields = A2(
					$elm$core$String$join,
					',',
					A2(
						$elm$core$List$map,
						function (str) {
							return A2($elm$core$String$contains, '\"name\"', str) ? '\n                \"name\": \"***\"' : str;
						},
						A2(
							$elm$core$List$map,
							function (str) {
								return A2($elm$core$String$contains, 'emailAddress', str) ? '\n                \"emailAddress\": \"***\"' : str;
							},
							A2(
								$elm$core$List$map,
								function (str) {
									return A2($elm$core$String$contains, 'password', str) ? '\n                \"password\": \"***\"' : str;
								},
								A2(
									$elm$core$String$split,
									',',
									$elm$json$Json$Decode$errorToString(error))))));
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$property, 'white-space', 'pre-wrap')
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(censoredFields)
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(additionalInformation)
						])),
					secondContend
				]));
	});
var $author$project$Environments$ErrorHandling$ErrorModal$viewFileAndFunction = F2(
	function (file, _function) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('File:' + file)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Function: ' + _function)
						]))
				]));
	});
var $author$project$Environments$ErrorHandling$ErrorModal$viewId = function (id) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						'Error Id: ' + $author$project$Environments$ErrorHandling$Id$toString(id))
					]))
			]));
};
var $author$project$Environments$ErrorHandling$ErrorModal$viewMetaData = function (metaData) {
	var userIdText = function () {
		var _v0 = metaData.lh;
		if (!_v0.$) {
			var userId = _v0.a;
			return $author$project$User$Id$toString(userId);
		} else {
			return 'Unknown';
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('User Id:')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(userIdText)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('App State')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Environments$App$toString(metaData.dn))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Network State')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Environments$Network$toString(metaData.c3))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('ViewPort')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(metaData.J)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Api Version')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(metaData.er))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Platform')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Environments$Flags$Platform$toString(metaData.eT))
					]))
			]));
};
var $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node('a');
var $author$project$Translations$AboutModal$errorHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'aboutModal.errorHeader');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$target = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('target');
var $author$project$Translations$AboutModal$toSupportForm = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'aboutModal.toSupportForm');
};
var $author$project$Environments$ErrorHandling$ErrorModal$viewSupport = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$AboutModal$errorHeader(translations))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href('https://hosting.awenko.de/trustservice/AWENKO24ftsm'),
						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$AboutModal$toSupportForm(translations))
					]))
			]));
};
var $author$project$Environments$ErrorHandling$ErrorModal$viewType = function (errorType_) {
	var content = function () {
		switch (errorType_.$) {
			case 0:
				var err = errorType_.a;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Decode Error')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Environments$ErrorHandling$Error$decodeErrorToString(err))
							]))
					]);
			case 1:
				var string = errorType_.a;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Other Error')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(string)
							]))
					]);
			case 2:
				var string = errorType_.a;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Command Handling Error')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(string)
							]))
					]);
			default:
				var _int = errorType_.a;
				var string = errorType_.b;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('HttpError')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(_int))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(string)
							]))
					]);
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		content);
};
var $author$project$Environments$ErrorHandling$ErrorModal$viewContent = F2(
	function (translations, error) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$h4,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$margin(
							$rtfeldman$elm_css$Css$rem(0.6))
						]))
				]),
			_List_fromArray(
				[
					$author$project$Environments$ErrorHandling$ErrorModal$viewSupport(translations),
					$author$project$Environments$ErrorHandling$ErrorModal$viewId(error.fw),
					$author$project$Environments$ErrorHandling$ErrorModal$viewType(error.gE),
					A2($author$project$Environments$ErrorHandling$ErrorModal$viewFileAndFunction, error.gH, error.gK),
					A2($author$project$Environments$ErrorHandling$ErrorModal$viewAdditionalMsg, error.gg, error.gE),
					$author$project$Environments$ErrorHandling$ErrorModal$viewMetaData(error.j7)
				]));
	});
var $author$project$Environments$ErrorHandling$ErrorModal$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Environments$ErrorHandling$ErrorModal$UserClickedCloseDialog,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$Environments$ErrorHandling$ErrorModal$CopyToClipboard = function (a) {
	return {$: 2, a: a};
};
var $author$project$Translations$ErrorHandling$copyError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'errorHandling.copyError');
};
var $author$project$Environments$ErrorHandling$ErrorModal$viewCopyButton = F2(
	function (translations, error) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withOnClick,
				$author$project$Environments$ErrorHandling$ErrorModal$CopyToClipboard(error),
				$author$project$UI$Button$darkGrey(
					$author$project$Translations$ErrorHandling$copyError(translations))));
	});
var $author$project$Environments$ErrorHandling$ErrorModal$viewFooter = F2(
	function (translations, error) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Environments$ErrorHandling$ErrorModal$viewCloseButton(translations),
					A2($author$project$Environments$ErrorHandling$ErrorModal$viewCopyButton, translations, error)
				]));
	});
var $author$project$Environments$ErrorHandling$ErrorModal$viewDialog = F2(
	function (translations, error) {
		return $author$project$UI$Modal$view(
			A2(
				$author$project$UI$Modal$appendStyle,
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$rem(0.5),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkRed)),
						A2($rtfeldman$elm_css$Css$property, 'user-select', 'text')
					]),
				A2(
					$author$project$UI$Modal$appendFooter,
					A2($author$project$Environments$ErrorHandling$ErrorModal$viewFooter, translations, error),
					A2(
						$author$project$UI$Modal$appendContent,
						A2($author$project$Environments$ErrorHandling$ErrorModal$viewContent, translations, error),
						A2($author$project$UI$Modal$modal, 'An Error Occurred', $author$project$Environments$ErrorHandling$ErrorModal$UserClickedCloseDialog)))));
	});
var $author$project$Environments$ErrorHandling$ErrorModal$view = F2(
	function (translations, dialog) {
		if (!dialog.$) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var error = dialog.a;
			return A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Environments$ErrorHandling$ErrorModal$viewDialog, translations, error);
		}
	});
var $author$project$EventStream$Page$ChangeCommandContent = function (a) {
	return {$: 3, a: a};
};
var $author$project$EventStream$Page$Collapsed = 1;
var $author$project$EventStream$Page$Expanded = 0;
var $author$project$Environments$Repository$commandSummary = function (repository) {
	var userCommands = $author$project$User$Store$commands(
		$author$project$Environments$Repository$userStore(repository));
	var tenantCommands = $author$project$Tenant$Store$commands(
		$author$project$Environments$Repository$tenantStore(repository));
	var rightsCommands = $author$project$Rights$Store$commands(
		$author$project$Environments$Repository$rightsStore(repository));
	var planCommands = $author$project$Plan$Store$commands(
		$author$project$Environments$Repository$planStore(repository));
	var organisationUnitCommands = $author$project$OrganisationUnit$Store$commands(
		$author$project$Environments$Repository$organisationUnitStore(repository));
	var measureCommands = $author$project$Measure$Store$commands(
		$author$project$Environments$Repository$measureStore(repository));
	var checkpointDataCommands = $author$project$CheckpointData$Store$commands(
		$author$project$Environments$Repository$checkpointDataStore(repository));
	var auditCommands = $author$project$Audit$Store$commands(
		$author$project$Environments$Repository$auditStore(repository));
	return {iT: auditCommands, i3: checkpointDataCommands, j3: measureCommands, kk: organisationUnitCommands, kp: planCommands, kG: rightsCommands, k3: tenantCommands, li: userCommands};
};
var $author$project$Audit$Commands$toList = $author$project$Types$Queue$toList;
var $author$project$CheckpointData$Commands$toList = $author$project$Types$Queue$toList;
var $author$project$Measure$Commands$toList = $author$project$Types$Queue$toList;
var $author$project$OrganisationUnit$Commands$toList = $author$project$Types$Queue$toList;
var $author$project$Plan$Commands$toList = $author$project$Types$Queue$toList;
var $author$project$Rights$Commands$toList = $author$project$Types$Queue$toList;
var $author$project$Tenant$Commands$toList = $author$project$Types$Queue$toList;
var $author$project$User$Commands$toList = $author$project$Types$Queue$toList;
var $author$project$EventStream$Page$countCommands = function (commandSummary) {
	var unsynchronizedUserCommands = $elm$core$List$length(
		$author$project$User$Commands$toList(commandSummary.li));
	var unsynchronizedTenantCommands = $elm$core$List$length(
		$author$project$Tenant$Commands$toList(commandSummary.k3));
	var unsynchronizedRightsCommands = $elm$core$List$length(
		$author$project$Rights$Commands$toList(commandSummary.kG));
	var unsynchronizedPlanCommands = $elm$core$List$length(
		$author$project$Plan$Commands$toList(commandSummary.kp));
	var unsynchronizedOrganisationUnitCommands = $elm$core$List$length(
		$author$project$OrganisationUnit$Commands$toList(commandSummary.kk));
	var unsynchronizedMeasureCommands = $elm$core$List$length(
		$author$project$Measure$Commands$toList(commandSummary.j3));
	var unsynchronizedCheckpointDataCommands = $elm$core$List$length(
		$author$project$CheckpointData$Commands$toList(commandSummary.i3));
	var unsynchronizedAuditCommands = $elm$core$List$length(
		$author$project$Audit$Commands$toList(commandSummary.iT));
	return ((((((unsynchronizedUserCommands + unsynchronizedOrganisationUnitCommands) + unsynchronizedPlanCommands) + unsynchronizedAuditCommands) + unsynchronizedMeasureCommands) + unsynchronizedTenantCommands) + unsynchronizedCheckpointDataCommands) + unsynchronizedRightsCommands;
};
var $author$project$Translations$Synchronisation$Page$unsynchronisedChanges = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'synchronisation.page.unsynchronisedChanges',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Translations$MainMenu$audits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'mainMenu.audits');
};
var $author$project$Translations$Synchronisation$Page$checkpointData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.checkpointData');
};
var $rtfeldman$elm_css$Css$firstChild = $rtfeldman$elm_css$Css$pseudoClass('first-child');
var $author$project$Translations$MainMenu$measures = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'mainMenu.measures');
};
var $author$project$Translations$Settings$organisationUnits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'settings.organisationUnits');
};
var $author$project$Translations$Settings$plans = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'settings.plans');
};
var $author$project$Translations$Rights$rights = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'rights.rights');
};
var $author$project$Translations$Tenant$tenant = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.tenant');
};
var $author$project$Translations$Settings$users = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'settings.users');
};
var $author$project$EventStream$Page$viewInfoRow = F2(
	function (leftText, _v0) {
		var rightText = _v0.a;
		var rightColor = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$rem(0.5)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$rem(0.4))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(leftText)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor(rightColor)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(rightText)
						]))
				]));
	});
var $author$project$EventStream$Page$viewCommandTable = F2(
	function (translations, commandSummary) {
		var rightText = function (_int) {
			return _Utils_Tuple2(
				$elm$core$String$fromInt(_int),
				(_int > 0) ? $author$project$UI$Style$Theme$red : $author$project$UI$Style$Theme$darkGrey);
		};
		var unsynchronizedAuditCommands = rightText(
			$elm$core$List$length(
				$author$project$Audit$Commands$toList(commandSummary.iT)));
		var unsynchronizedCheckpointDataCommands = rightText(
			$elm$core$List$length(
				$author$project$CheckpointData$Commands$toList(commandSummary.i3)));
		var unsynchronizedMeasureCommands = rightText(
			$elm$core$List$length(
				$author$project$Measure$Commands$toList(commandSummary.j3)));
		var unsynchronizedOrganisationUnitCommands = rightText(
			$elm$core$List$length(
				$author$project$OrganisationUnit$Commands$toList(commandSummary.kk)));
		var unsynchronizedPlanCommands = rightText(
			$elm$core$List$length(
				$author$project$Plan$Commands$toList(commandSummary.kp)));
		var unsynchronizedRightsCommands = rightText(
			$elm$core$List$length(
				$author$project$Rights$Commands$toList(commandSummary.kG)));
		var unsynchronizedTenantCommands = rightText(
			$elm$core$List$length(
				$author$project$Tenant$Commands$toList(commandSummary.k3)));
		var unsynchronizedUserCommands = rightText(
			$elm$core$List$length(
				$author$project$User$Commands$toList(commandSummary.li)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$firstChild(
							_List_fromArray(
								[
									A3(
									$rtfeldman$elm_css$Css$borderTop3,
									$rtfeldman$elm_css$Css$px(1),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Settings$users(translations),
					unsynchronizedUserCommands),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Settings$organisationUnits(translations),
					unsynchronizedOrganisationUnitCommands),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Settings$plans(translations),
					unsynchronizedPlanCommands),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$MainMenu$audits(translations),
					unsynchronizedAuditCommands),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$MainMenu$measures(translations),
					unsynchronizedMeasureCommands),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Tenant$tenant(translations),
					unsynchronizedTenantCommands),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Synchronisation$Page$checkpointData(translations),
					unsynchronizedCheckpointDataCommands),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Rights$rights(translations),
					unsynchronizedRightsCommands)
				]));
	});
var $author$project$EventStream$Page$viewCommands = F3(
	function (translations, repository, _v0) {
		var page = _v0;
		var commandSummary = $author$project$Environments$Repository$commandSummary(repository);
		var _v1 = function () {
			var _v2 = page.gu;
			if (!_v2) {
				return _Utils_Tuple2(
					A2($author$project$EventStream$Page$viewCommandTable, translations, commandSummary),
					$elm$core$Maybe$Just(
						$author$project$EventStream$Page$ChangeCommandContent(1)));
			} else {
				return _Utils_Tuple2(
					$rtfeldman$elm_css$Html$Styled$text(''),
					$elm$core$Maybe$Just(
						$author$project$EventStream$Page$ChangeCommandContent(0)));
			}
		}();
		var table = _v1.a;
		var msg = _v1.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Bar$view(
					A2(
						$author$project$UI$Bar$withOnBarClick,
						msg,
						$author$project$UI$Bar$bar(
							A2(
								$author$project$Translations$Synchronisation$Page$unsynchronisedChanges,
								translations,
								$elm$core$String$fromInt(
									$author$project$EventStream$Page$countCommands(commandSummary)))))),
					table
				]));
	});
var $author$project$EventStream$Page$ChangeErrorContent = function (a) {
	return {$: 5, a: a};
};
var $author$project$Translations$Synchronisation$Page$error = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.error');
};
var $author$project$Environments$Environment$errors = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.ez;
	});
var $author$project$Translations$Synchronisation$Page$noError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.noError');
};
var $author$project$EventStream$Page$OpenErrorModal = function (a) {
	return {$: 6, a: a};
};
var $author$project$EventStream$Page$viewErrorRow = F2(
	function (viewType, err) {
		var label = function () {
			var _v0 = err.gE;
			switch (_v0.$) {
				case 0:
					return 'DecodeError';
				case 1:
					var string = _v0.a;
					return 'OtherError: ' + string;
				case 2:
					var string = _v0.a;
					return 'CommandHandlingError: ' + string;
				default:
					var status = _v0.a;
					return 'HttpError: ' + $elm$core$String$fromInt(status);
			}
		}();
		return A2(
			$author$project$UI$Table$Row$withOnClick,
			$author$project$EventStream$Page$OpenErrorModal(err),
			A2(
				$author$project$UI$Table$Row$withRightIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$eyeCircle),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					$author$project$Environments$ErrorHandling$Id$toString(err.fw),
					A3($author$project$UI$Table$Row$row, viewType, label, err))));
	});
var $author$project$EventStream$Page$viewErrorTable = F3(
	function (translations, viewType, errors) {
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Synchronisation$Page$noError(translations),
				A2(
					$author$project$UI$Table$fromList,
					$author$project$EventStream$Page$viewErrorRow(viewType),
					errors)));
	});
var $author$project$EventStream$Page$viewErrors = F3(
	function (translations, environment, _v0) {
		var page = _v0;
		var _v1 = function () {
			var _v2 = page.gD;
			if (!_v2) {
				return _Utils_Tuple2(
					A3(
						$author$project$EventStream$Page$viewErrorTable,
						translations,
						$author$project$Environments$Environment$getViewType(environment),
						$author$project$Environments$Environment$errors(environment)),
					$elm$core$Maybe$Just(
						$author$project$EventStream$Page$ChangeErrorContent(1)));
			} else {
				return _Utils_Tuple2(
					$rtfeldman$elm_css$Html$Styled$text(''),
					$elm$core$Maybe$Just(
						$author$project$EventStream$Page$ChangeErrorContent(0)));
			}
		}();
		var table = _v1.a;
		var msg = _v1.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Bar$view(
					A2(
						$author$project$UI$Bar$withOnBarClick,
						msg,
						$author$project$UI$Bar$bar(
							$author$project$Translations$Synchronisation$Page$error(translations) + (': ' + $elm$core$String$fromInt(
								$elm$core$List$length(
									$author$project$Environments$Environment$errors(environment))))))),
					table
				]));
	});
var $author$project$Translations$Synchronisation$Page$status = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.status');
};
var $author$project$EventStream$Page$viewMainBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withStyle,
			$rtfeldman$elm_css$Css$zIndex(
				$rtfeldman$elm_css$Css$int(1)),
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
					$author$project$UI$Bar$bar(
						$author$project$Translations$Synchronisation$Page$status(translations))))));
};
var $author$project$Translations$Synchronisation$Page$connecting = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.connecting');
};
var $author$project$Translations$Synchronisation$Page$disconnected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.disconnected');
};
var $author$project$UI$Style$Theme$orange = A4($author$project$UI$Style$Color$rgba, 245 / 255, 121 / 255, 0 / 255, 1.0);
var $author$project$Translations$Synchronisation$Page$reconnecting = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.reconnecting');
};
var $author$project$Translations$Synchronisation$Page$synchronization = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.synchronization');
};
var $author$project$Translations$Synchronisation$Page$tries = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.tries');
};
var $author$project$EventStream$Page$UserClickedStartCompleteSynchronisation = {$: 10};
var $author$project$Translations$Synchronisation$Page$completeSyncText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.completeSyncText');
};
var $author$project$Translations$Synchronisation$Page$connected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.connected');
};
var $author$project$Translations$Synchronisation$Page$outOfDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.outOfDate');
};
var $author$project$Translations$Synchronisation$Page$startCompleteSynchronisation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.startCompleteSynchronisation');
};
var $author$project$Translations$Synchronisation$Page$unknown = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.unknown');
};
var $author$project$Translations$Synchronisation$Page$upToDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.upToDate');
};
var $author$project$UI$Button$withStyle = F2(
	function (style, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				by: A2($elm$core$List$cons, style, config.by)
			});
	});
var $author$project$EventStream$Page$viewConnected = F4(
	function (translations, environment, syncLabel, record) {
		var dataStatusToString = function (status) {
			switch (status) {
				case 0:
					return _Utils_Tuple2(
						$author$project$Translations$Synchronisation$Page$unknown(translations),
						$author$project$UI$Style$Theme$orange);
				case 1:
					return _Utils_Tuple2(
						$author$project$Translations$Synchronisation$Page$upToDate(translations),
						$author$project$UI$Style$Theme$green);
				default:
					return _Utils_Tuple2(
						$author$project$Translations$Synchronisation$Page$outOfDate(translations),
						$author$project$UI$Style$Theme$red);
			}
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$firstChild(
							_List_fromArray(
								[
									A3(
									$rtfeldman$elm_css$Css$borderTop3,
									$rtfeldman$elm_css$Css$px(1),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
								])),
							$rtfeldman$elm_css$Css$lastChild(
							_List_fromArray(
								[
									A3(
									$rtfeldman$elm_css$Css$borderBottom3,
									$rtfeldman$elm_css$Css$px(1),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					syncLabel,
					_Utils_Tuple2(
						$author$project$Translations$Synchronisation$Page$connected(translations),
						$author$project$UI$Style$Theme$green)),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Settings$users(translations),
					dataStatusToString(record.I)),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Settings$organisationUnits(translations),
					dataStatusToString(record.E)),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Settings$plans(translations),
					dataStatusToString(record.F)),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$MainMenu$audits(translations),
					dataStatusToString(record.A)),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$MainMenu$measures(translations),
					dataStatusToString(record.D)),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Tenant$tenant(translations),
					dataStatusToString(record.H)),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Synchronisation$Page$checkpointData(translations),
					dataStatusToString(record.B)),
					A2(
					$author$project$EventStream$Page$viewInfoRow,
					$author$project$Translations$Rights$rights(translations),
					dataStatusToString(record.G)),
					$author$project$UI$Button$view(
					A2(
						$author$project$UI$Button$withOnClick,
						$author$project$EventStream$Page$UserClickedStartCompleteSynchronisation,
						A2(
							$author$project$UI$Button$disabled,
							$author$project$Environments$Environment$isOffline(environment),
							A2(
								$author$project$UI$Button$withStyle,
								$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(1)),
								$author$project$UI$Button$darkRed(
									$author$project$Translations$Synchronisation$Page$startCompleteSynchronisation(translations)))))),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$orange)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Synchronisation$Page$completeSyncText(translations))
						]))
				]));
	});
var $author$project$EventStream$Page$ReconnectEventStream = {$: 0};
var $author$project$EventStream$Page$viewReconnectButton = function (environment) {
	var _v0 = ($author$project$Environments$Environment$isInactive(environment) || $author$project$Environments$Environment$isOffline(environment)) ? _Utils_Tuple2('Can`t Reconnect, App is offline', true) : _Utils_Tuple2('Try Reconnect', false);
	var label = _v0.a;
	var disabled = _v0.b;
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$disabled,
			disabled,
			A2(
				$author$project$UI$Button$withStyle,
				$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$rem(0.6)),
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$EventStream$Page$ReconnectEventStream,
					$author$project$UI$Button$green(label)))));
};
var $author$project$EventStream$Page$viewMainContent = F3(
	function (translations, environment, repository) {
		var syncLabel = $author$project$Translations$Synchronisation$Page$synchronization(translations) + (' ' + $author$project$Translations$Synchronisation$Page$status(translations));
		var eventStreamState = $author$project$Environments$Repository$eventStream(repository);
		switch (eventStreamState.$) {
			case 0:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$EventStream$Page$viewInfoRow,
							syncLabel,
							_Utils_Tuple2(
								$author$project$Translations$Synchronisation$Page$disconnected(translations),
								$author$project$UI$Style$Theme$darkGrey)),
							$author$project$EventStream$Page$viewReconnectButton(environment)
						]));
			case 1:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$EventStream$Page$viewInfoRow,
							syncLabel,
							_Utils_Tuple2(
								$author$project$Translations$Synchronisation$Page$error(translations),
								$author$project$UI$Style$Theme$red)),
							$author$project$EventStream$Page$viewReconnectButton(environment)
						]));
			case 2:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$EventStream$Page$viewInfoRow,
							syncLabel,
							_Utils_Tuple2(
								$author$project$Translations$Synchronisation$Page$connecting(translations),
								$author$project$UI$Style$Theme$orange))
						]));
			case 3:
				var tries = eventStreamState.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$EventStream$Page$viewInfoRow,
							syncLabel,
							_Utils_Tuple2(
								$author$project$Translations$Synchronisation$Page$reconnecting(translations),
								$author$project$UI$Style$Theme$orange)),
							A2(
							$author$project$EventStream$Page$viewInfoRow,
							$author$project$Translations$Synchronisation$Page$tries(translations),
							_Utils_Tuple2(
								$elm$core$String$fromInt(tries),
								$author$project$UI$Style$Theme$orange))
						]));
			default:
				var record = eventStreamState.a;
				return A4($author$project$EventStream$Page$viewConnected, translations, environment, syncLabel, record);
		}
	});
var $author$project$EventStream$Page$ChangeWarningContent = function (a) {
	return {$: 4, a: a};
};
var $author$project$EventStream$Page$DeleteAllWarnings = {$: 9};
var $author$project$EventStream$Page$DeleteSyncWarning = function (a) {
	return {$: 8, a: a};
};
var $author$project$Translations$Synchronisation$Page$noWarnings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.noWarnings');
};
var $author$project$Translations$CheckpointTypes$date = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.date');
};
var $author$project$Translations$CheckpointTypes$image = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.image');
};
var $author$project$Translations$CheckpointTypes$individualData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.individualData');
};
var $author$project$Translations$CheckpointTypes$multiSelect = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.multiSelect');
};
var $author$project$Translations$CheckpointTypes$number = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.number');
};
var $author$project$Translations$CheckpointTypes$select = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.select');
};
var $author$project$Translations$CheckpointTypes$signature = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.signature');
};
var $author$project$Translations$CheckpointTypes$textMemo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.textMemo');
};
var $author$project$Translations$CheckpointTypes$textRow = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.textRow');
};
var $author$project$Translations$CheckpointTypes$time = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.time');
};
var $author$project$Date_Time$NaiveTime$toString = function (_v0) {
	var h = _v0.a;
	var m = _v0.b;
	var mm = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(m));
	var hh = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(h));
	return hh + (':' + mm);
};
var $author$project$Translations$CheckpointTypes$checkbox = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.checkbox');
};
var $author$project$Translations$CheckpointTypes$info = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.info');
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$toText = F2(
	function (translations, cpType) {
		switch (cpType.$) {
			case 0:
				return $author$project$Translations$CheckpointTypes$number(translations);
			case 1:
				return $author$project$Translations$CheckpointTypes$textRow(translations);
			case 2:
				return $author$project$Translations$CheckpointTypes$textMemo(translations);
			case 3:
				return $author$project$Translations$CheckpointTypes$checkbox(translations);
			case 4:
				return $author$project$Translations$CheckpointTypes$individualData(translations);
			case 5:
				return $author$project$Translations$CheckpointTypes$select(translations);
			case 6:
				return $author$project$Translations$CheckpointTypes$multiSelect(translations);
			case 7:
				return $author$project$Translations$CheckpointTypes$date(translations);
			case 8:
				return $author$project$Translations$CheckpointTypes$image(translations);
			case 9:
				return $author$project$Translations$CheckpointTypes$info(translations);
			case 10:
				return $author$project$Translations$CheckpointTypes$signature(translations);
			default:
				return $author$project$Translations$CheckpointTypes$time(translations);
		}
	});
var $author$project$Translations$Synchronisation$Warnings$unknown = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.warnings.unknown');
};
var $author$project$EventStream$SyncWarning$commandToText = F2(
	function (translations, commandType) {
		switch (commandType.$) {
			case 0:
				var command = commandType.a;
				switch (command.$) {
					case 0:
						var payload = command.a;
						return payload.iK + (': ' + 'Erstellen');
					case 1:
						var payload = command.a;
						return payload.cl + (': ' + ('Email ändern zu ' + $author$project$User$EmailAddress$toString(payload.ju)));
					case 2:
						var payload = command.a;
						return payload.cl + (': ' + 'Password ändern');
					case 3:
						var payload = command.a;
						return payload.cl + (': ' + ('Namen ändern zu ' + payload.g_));
					case 4:
						var payload = command.a;
						return payload.cl + (': ' + 'zu einem Team hinzufügen');
					case 5:
						var payload = command.a;
						return payload.cl + (': ' + 'Rollen an einem Team ändern');
					case 6:
						var payload = command.a;
						return payload.cl + (': ' + 'von einem Team entfernen');
					case 7:
						var payload = command.a;
						return payload.cl + (': ' + 'Profilbild ändern');
					case 8:
						var payload = command.a;
						return payload.cl + (': ' + 'Einstiegsorganisationseinheit ändern');
					default:
						var payload = command.a;
						return payload.iK + (': ' + 'Löschen');
				}
			case 1:
				var command = commandType.a;
				switch (command.$) {
					case 0:
						var payload = command.a;
						return payload.k8 + (': ' + 'Erstellen');
					case 1:
						var payload = command.a;
						return payload.k8 + (': ' + ('Unterorganistionseinheit ' + (payload.k8 + ' erstellen')));
					case 2:
						var payload = command.a;
						return payload.k8 + (': ' + ('bevor eine Organisationseinheit  ' + (payload.k8 + ' erstellen')));
					case 3:
						var payload = command.a;
						return payload.k8 + (': ' + ('hinter ein Organisationseinheit ' + (payload.k8 + ' erstellen')));
					case 4:
						var payload = command.a;
						return payload.l + (': ' + 'verschieben');
					case 5:
						var payload = command.a;
						return payload.l + (': ' + 'vor eine andere Organisationseinheit verschieben');
					case 6:
						var payload = command.a;
						return payload.l + (': ' + 'hinter eine andere Organisationseinheit verschieben');
					case 7:
						var payload = command.a;
						return payload.l + (': ' + ('Titel ändern zu ' + payload.k8));
					case 8:
						var payload = command.a;
						return payload.l + (': ' + ('Beschreibung ändern zu ' + payload.aY));
					case 9:
						var payload = command.a;
						return payload.l + (': ' + 'Farbe ändern');
					case 10:
						var payload = command.a;
						return payload.l + (': ' + 'Grundriss ändern');
					default:
						var payload = command.a;
						return payload.l + (': ' + 'Löschen');
				}
			case 2:
				var command = commandType.a;
				switch (command.$) {
					case 0:
						var payload = command.a;
						return payload.k8 + (': ' + 'Erstellen');
					case 1:
						var payload = command.a;
						return payload.l + (': ' + ('Titel ändern zu ' + payload.k8));
					case 2:
						var payload = command.a;
						return payload.l + (': ' + ('Beschreibung ändern zu ' + payload.aY));
					case 3:
						var payload = command.a;
						return payload.l + (': ' + ('Ausführung ' + (payload.jw.k8 + ' hinzufügen')));
					case 4:
						var payload = command.a;
						return payload.l + (': ' + 'Ausführung ändern');
					case 5:
						var payload = command.a;
						return payload.l + (': ' + 'Ausführung entfernen');
					case 6:
						var payload = command.a;
						return payload.l + (': ' + 'Verantwortliche Nutzer ändern');
					case 7:
						var payload = command.a;
						return payload.l + (': ' + 'Prüfgruppen hinzufügen');
					case 8:
						var payload = command.a;
						return payload.l + (': ' + 'Löschen');
					default:
						var payload = command.a;
						return payload.l + (': ' + 'Manuell Ausführen');
				}
			case 3:
				var command = commandType.a;
				switch (command.$) {
					case 0:
						var payload = command.a;
						return payload.k8 + (': ' + 'Erstellen');
					case 1:
						var payload = command.a;
						var recordedData = function () {
							var _v5 = payload.ct.ll;
							switch (_v5.$) {
								case 0:
									var _float = _v5.a;
									return $author$project$Translations$CheckpointTypes$number(translations) + (' ' + $elm$core$String$fromFloat(_float));
								case 1:
									var string = _v5.a;
									return $author$project$Translations$CheckpointTypes$textRow(translations) + (' ' + string);
								case 2:
									var string = _v5.a;
									return $author$project$Translations$CheckpointTypes$textMemo(translations) + (' ' + string);
								case 3:
									var bool = _v5.a;
									var boolStr = bool ? 'Wahr' : 'Falsch';
									return $author$project$Translations$CheckpointTypes$textMemo(translations) + (' ' + boolStr);
								case 4:
									var string = _v5.a;
									return $author$project$Translations$CheckpointTypes$individualData(translations) + (' ' + string);
								case 5:
									var option = _v5.a;
									return $author$project$Translations$CheckpointTypes$select(translations) + (' ' + option.hl);
								case 6:
									var options = _v5.a;
									var optionsText = A2(
										$elm$core$String$join,
										', ',
										A2(
											$elm$core$List$map,
											function ($) {
												return $.hl;
											},
											options));
									return $author$project$Translations$CheckpointTypes$multiSelect(translations) + (' ' + optionsText);
								case 7:
									var naiveDate = _v5.a;
									return $author$project$Translations$CheckpointTypes$date(translations) + (' ' + $author$project$Date_Time$NaiveDate$toStringDMY(naiveDate));
								case 8:
									var filename = _v5.a;
									return $author$project$Translations$CheckpointTypes$image(translations) + (' ' + filename.g_);
								case 9:
									var filename = _v5.a;
									return $author$project$Translations$CheckpointTypes$signature(translations) + (' ' + filename.g_);
								default:
									var naiveTime = _v5.a;
									return $author$project$Translations$CheckpointTypes$time(translations) + (' ' + $author$project$Date_Time$NaiveTime$toString(naiveTime));
							}
						}();
						return payload.k + (' | ' + (payload.l + (': ' + ('erfassen von ' + recordedData))));
					case 2:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + ('Titel ändern zu ' + payload.k8))));
					case 3:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + ('Beschreibung ändern zu ' + payload.aY))));
					case 4:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Termin ändern')));
					case 5:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Verantwortliche Nutzer ändern')));
					case 6:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Erfassungsdatein hinzufügen')));
					case 7:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Erfassungsdatein entfernen')));
					case 8:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Abschließen')));
					default:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Löschen')));
				}
			case 4:
				var command = commandType.a;
				switch (command.$) {
					case 0:
						var payload = command.a;
						return payload.k8 + (': ' + 'Erstellen');
					case 1:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + ('Titel ändern zu ' + payload.k8))));
					case 2:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + ('Beschreibung ändern zu ' + payload.aY))));
					case 3:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Verantwortliche Nutzer ändern')));
					case 4:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Termin ändern')));
					case 5:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Organisationseinheit ändern')));
					case 6:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Datein hinzufügen')));
					case 7:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Datein entfernen')));
					case 8:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Abschließen')));
					default:
						var payload = command.a;
						return payload.k + (' | ' + (payload.l + (': ' + 'Löschen')));
				}
			case 5:
				return $author$project$Translations$Synchronisation$Warnings$unknown(translations);
			case 6:
				var command = commandType.a;
				switch (command.$) {
					case 0:
						var payload = command.a;
						return payload.k8 + (': ' + 'Prüfgruppe erstellen');
					case 1:
						var payload = command.a;
						return payload.l + (': ' + ('Prüfgruppe Titel ändern zu ' + payload.k8));
					case 2:
						var payload = command.a;
						return payload.l + (': ' + ('Prüfgruppe Beschreibung ändern zu ' + payload.aY));
					case 3:
						var payload = command.a;
						return payload.l + (': ' + 'Prüfpunktgruppe vor eine andere verschieben');
					case 4:
						var payload = command.a;
						return payload.l + (': ' + 'Prüfpunktgruppe hinter eine andere verschieben');
					case 5:
						var payload = command.a;
						return payload.l + (': ' + 'Prüfgruppe löschen');
					case 6:
						var payload = command.a;
						return payload.k8 + (': ' + 'Prüfpunkt erstellen');
					case 7:
						var payload = command.a;
						return payload.l + (': ' + ('Prüfpunkttype ändern zu ' + A2($author$project$CheckpointData$Checkpoint$CheckpointType$toText, translations, payload.fg)));
					case 8:
						var payload = command.a;
						return payload.l + (': ' + ('Prüfpunkt Titel ändern zu ' + payload.k8));
					case 9:
						var payload = command.a;
						return payload.l + (': ' + ('Prüfpunkt Beschreibung ändern zu ' + payload.aY));
					case 10:
						var payload = command.a;
						return payload.l + (': ' + 'Prüfpunkt Datein ändern');
					case 11:
						var payload = command.a;
						return payload.l + (': ' + 'Prüfpunkt in eine andere Prüfgruppe verschieben');
					case 12:
						var payload = command.a;
						return payload.l + (': ' + 'Prüfpunkt vor eine andere verschieben');
					case 13:
						var payload = command.a;
						return payload.l + (': ' + 'Prüfpunkt hinter eine andere verschieben');
					default:
						var payload = command.a;
						return payload.l + (': ' + 'Prüfpunkt löschen');
				}
			default:
				var command = commandType.a;
				switch (command.$) {
					case 0:
						var payload = command.a;
						return payload.k8 + (': ' + 'Rolle erstellen');
					case 1:
						var payload = command.a;
						return payload.l + (': ' + ('Rolle Titel ändern zu ' + payload.k8));
					case 2:
						var payload = command.a;
						return payload.l + (': ' + ('Rolle Beschreibung ändern zu ' + payload.aY));
					case 3:
						var payload = command.a;
						return payload.l + (': ' + 'Rolle Rechte hinzufügen');
					case 4:
						var payload = command.a;
						return payload.l + (': ' + 'Rolle Rechte entfernen');
					case 5:
						var payload = command.a;
						return payload.l + (': ' + 'Rolle löschen');
					case 6:
						var payload = command.a;
						return payload.k8 + (': ' + 'Team erstellen');
					case 7:
						var payload = command.a;
						return payload.l + (': ' + ('Team Titel ändern zu ' + payload.k8));
					case 8:
						var payload = command.a;
						return payload.l + (': ' + ('Team Beschreibung ändern zu ' + payload.aY));
					case 9:
						var payload = command.a;
						return payload.l + (': ' + 'Organisationseinheit zu Team hinzufügen');
					case 10:
						var payload = command.a;
						return payload.l + (': ' + 'Organisationseinheit vom team entfernen');
					default:
						var payload = command.a;
						return payload.l + (': ' + 'Team löschen');
				}
		}
	});
var $author$project$Translations$Synchronisation$Warnings$deleted = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.warnings.deleted');
};
var $author$project$Translations$Synchronisation$Warnings$notFound = F2(
	function (translations, error) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'synchronisation.warnings.notFound',
			_List_fromArray(
				[
					_Utils_Tuple2('error', error)
				]));
	});
var $author$project$EventStream$SyncWarning$errorString = F3(
	function (translations, status, message) {
		if (status === 404) {
			return A2($elm$core$String$contains, 'does not exist', message) ? $author$project$Translations$Synchronisation$Warnings$deleted(translations) : A2($author$project$Translations$Synchronisation$Warnings$notFound, translations, message);
		} else {
			return $elm$core$String$fromInt(status) + (' | ' + message);
		}
	});
var $author$project$EventStream$SyncWarning$typeString = function (commandType) {
	switch (commandType.$) {
		case 0:
			return $author$project$Translations$Settings$users;
		case 1:
			return $author$project$Translations$Settings$organisationUnits;
		case 2:
			return $author$project$Translations$Settings$plans;
		case 3:
			return $author$project$Translations$Measures$Info$audit;
		case 4:
			return $author$project$Translations$MainMenu$measures;
		case 5:
			return $author$project$Translations$Tenant$tenant;
		case 6:
			return $author$project$Translations$Synchronisation$Page$checkpointData;
		default:
			return $author$project$Translations$Rights$rights;
	}
};
var $author$project$EventStream$SyncWarning$viewLabels = F2(
	function (translations, syncWarning) {
		return A2($author$project$EventStream$SyncWarning$typeString, syncWarning.ja, translations) + (': ' + A3($author$project$EventStream$SyncWarning$errorString, translations, syncWarning.kU, syncWarning.j5));
	});
var $author$project$EventStream$SyncWarning$viewRow = F4(
	function (translations, viewType, deleteMsg, syncWarning) {
		return A2(
			$author$project$UI$Table$Row$withSubLabel,
			A2($author$project$EventStream$SyncWarning$commandToText, translations, syncWarning.ja),
			A2(
				$author$project$UI$Table$Row$withRightIcon,
				A2(
					$author$project$UI$Icon$withOnClick,
					deleteMsg(syncWarning),
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$deleteCircle)),
				A3(
					$author$project$UI$Table$Row$row,
					viewType,
					A2($author$project$EventStream$SyncWarning$viewLabels, translations, syncWarning),
					syncWarning)));
	});
var $author$project$EventStream$Page$viewWarningsTable = F3(
	function (translations, environment, warnings) {
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Synchronisation$Page$noWarnings(translations),
				A2(
					$author$project$UI$Table$fromList,
					A3(
						$author$project$EventStream$SyncWarning$viewRow,
						translations,
						$author$project$Environments$Environment$getViewType(environment),
						$author$project$EventStream$Page$DeleteSyncWarning),
					warnings)));
	});
var $author$project$Translations$Synchronisation$Page$warnings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.page.warnings');
};
var $author$project$EventStream$Page$viewWarnings = F4(
	function (translations, environment, repository, _v0) {
		var page = _v0;
		var eventStream = $author$project$Environments$Repository$eventStream(repository);
		if (eventStream.$ === 4) {
			var data = eventStream.a;
			var _v2 = function () {
				var _v3 = page.hp;
				if (!_v3) {
					return _Utils_Tuple2(
						A3($author$project$EventStream$Page$viewWarningsTable, translations, environment, data.m.f9),
						$elm$core$Maybe$Just(
							$author$project$EventStream$Page$ChangeWarningContent(1)));
				} else {
					return _Utils_Tuple2(
						$rtfeldman$elm_css$Html$Styled$text(''),
						$elm$core$Maybe$Just(
							$author$project$EventStream$Page$ChangeWarningContent(0)));
				}
			}();
			var table = _v2.a;
			var msg = _v2.b;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$UI$Bar$view(
						A2(
							$author$project$UI$Bar$withRightIcon,
							A2(
								$author$project$UI$Icon$withOnClick,
								$author$project$EventStream$Page$DeleteAllWarnings,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete)),
							A2(
								$author$project$UI$Bar$withOnBarClick,
								msg,
								$author$project$UI$Bar$bar(
									$author$project$Translations$Synchronisation$Page$warnings(translations) + (': ' + $elm$core$String$fromInt(
										$elm$core$List$length(data.m.f9))))))),
						table
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('test');
		}
	});
var $author$project$EventStream$Page$view = F3(
	function (environment, repository, page) {
		var page_ = page;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$EventStream$Page$GotErrorModalMsg,
					A3(
						$rtfeldman$elm_css$Html$Styled$Lazy$lazy2,
						$author$project$Environments$ErrorHandling$ErrorModal$view,
						$author$project$Environments$Environment$translations(environment),
						page_.fq)),
				A2(
					$author$project$UI$Page$appendContent,
					A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$EventStream$Page$viewErrors, translations, environment, page),
					A2(
						$author$project$UI$Page$appendContent,
						A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$EventStream$Page$viewWarnings, translations, environment, repository, page),
						A2(
							$author$project$UI$Page$appendContent,
							A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$EventStream$Page$viewCommands, translations, repository, page),
							A2(
								$author$project$UI$Page$appendContent,
								A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$EventStream$Page$viewMainContent, translations, environment, repository),
								A2(
									$author$project$UI$Page$appendContent,
									A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$EventStream$Page$viewMainBar, translations),
									A2(
										$author$project$UI$Page$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$sync),
										$author$project$UI$Page$page(
											$author$project$Translations$Synchronisation$overview(translations))))))))));
	});
var $author$project$Page$Page$eventStream = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 10) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotEventStreamPageMsg,
		kZ: $elm$core$Maybe$Just($author$project$EventStream$Page$subscriptions),
		le: $author$project$EventStream$Page$update,
		lm: $author$project$EventStream$Page$view
	});
var $author$project$Page$Page$GotFloorPlanPageMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$FloorPlan$noChange = F3(
	function (environment, repository, page) {
		return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
	});
var $author$project$Page$FloorPlan$update = function (msg) {
	return $author$project$Page$FloorPlan$noChange;
};
var $author$project$Translations$MainMenu$floorPlan = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'mainMenu.floorPlan');
};
var $author$project$UI$Icons$floorPlan = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M38.659 7.999H9.34C8.6 7.999 8 8.601 8 9.34v29.322c0 .737.6 1.339 1.34 1.339h19.275c.74 0 1.34-.602 1.34-1.339V25.629c0-.739-.6-1.341-1.34-1.341h-8.416c-.741 0-1.341.602-1.341 1.341 0 .741.6 1.342 1.341 1.342h7.075v10.347h-7.363v-5.715c0-.741-.601-1.341-1.341-1.341-.741 0-1.341.6-1.341 1.341v5.715h-6.548V10.683h11.977v3.29h-7.074c-.742 0-1.342.599-1.342 1.341s.6 1.342 1.342 1.342h7.074v4.629c0 .742.601 1.342 1.341 1.342.741 0 1.341-.6 1.341-1.342V10.683h11.978v9.262h-5.375v-4.631c0-.742-.601-1.341-1.341-1.341-.741 0-1.342.599-1.342 1.341v5.971c0 .742.601 1.342 1.342 1.342h6.716v14.691h-2.189c-.739 0-1.339.601-1.339 1.344 0 .737.6 1.339 1.339 1.339h3.53c.741 0 1.341-.602 1.341-1.339V9.34c0-.739-.6-1.341-1.341-1.341')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$FloorPlan$viewFile = function (_v0) {
	var fileId = _v0.gI;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
					]))
			]),
		_List_fromArray(
			[
				A3(
				$rtfeldman$elm_css$Html$Styled$node,
				'aw-image',
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
						'filename',
						$author$project$File$Id$toString(fileId))
					]),
				_List_Nil)
			]));
};
var $author$project$Page$FloorPlan$view = F3(
	function (environment, _v0, _v1) {
		var model = _v1;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendHeader,
				A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Page$FloorPlan$viewFile, model),
				A2(
					$author$project$UI$Page$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$floorPlan),
					$author$project$UI$Page$page(
						$author$project$Translations$MainMenu$floorPlan(translations)))));
	});
var $author$project$Page$Page$floorPlan = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 9) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotFloorPlanPageMsg,
		kZ: $elm$core$Maybe$Nothing,
		le: $author$project$Page$FloorPlan$update,
		lm: $author$project$Page$FloorPlan$view
	});
var $author$project$Archive$Page$init = function (environment) {
	var _v0 = $author$project$Archive$CombinedArchiveContent$init(environment);
	var content = _v0.a;
	var contentCmd = _v0.b;
	return _Utils_Tuple3(
		environment,
		{
			ai: $author$project$Archive$Page$CombinedArchive(content),
			aN: ''
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Archive$Page$GotCombinedArchiveContentMsg, contentCmd));
};
var $author$project$Archive$ViewArchivedAudit$Hidden = 0;
var $author$project$Archive$ViewArchivedAudit$LoadingAudit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Archive$ViewArchivedAudit$GotGetAuditResult = function (a) {
	return {$: 5, a: a};
};
var $author$project$Archive$ViewArchivedAudit$getAuditRequest = F2(
	function (auditId, environment) {
		var baseUrl = A3(
			$elm$core$String$replace,
			'baseUri',
			$author$project$Environments$Environment$baseUri(environment),
			'baseUri/audits/query/' + $author$project$Audit$Id$toString(auditId));
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Archive$ViewArchivedAudit$GotGetAuditResult,
			A3($author$project$Utils$Http$sendGet, baseUrl, _List_Nil, 7));
	});
var $author$project$Archive$ViewArchivedAudit$init = F2(
	function (environment, auditId) {
		return _Utils_Tuple3(
			environment,
			$author$project$Archive$ViewArchivedAudit$LoadingAudit(0),
			A2($author$project$Archive$ViewArchivedAudit$getAuditRequest, auditId, environment));
	});
var $author$project$Audit$Page$ReceivedNowTimestamp = function (a) {
	return {$: 8, a: a};
};
var $author$project$Audit$ExecutePlanDialog$hidden = 0;
var $author$project$Audit$Page$init = function (environment) {
	return _Utils_Tuple3(
		environment,
		{
			cN: $author$project$Audit$EditDialog$Hidden,
			eA: $author$project$Audit$ExecutePlanDialog$hidden,
			bF: 100,
			fK: $elm$time$Time$millisToPosix(0),
			aN: ''
		},
		A2($elm$core$Task$perform, $author$project$Audit$Page$ReceivedNowTimestamp, $elm$time$Time$now));
};
var $author$project$Audit$PerformAuditPage$Hidden = {$: 0};
var $author$project$Audit$PerformAuditPage$Page = $elm$core$Basics$identity;
var $author$project$Audit$CompleteAudit$Hidden = 0;
var $author$project$Audit$CompleteAudit$hidden = 0;
var $author$project$Audit$RecordModal$Hidden = {$: 0};
var $author$project$Audit$RecordModal$hidden = $author$project$Audit$RecordModal$Hidden;
var $author$project$Measure$CreateDialog$Hidden = {$: 0};
var $author$project$Measure$CreateDialog$hidden = $author$project$Measure$CreateDialog$Hidden;
var $author$project$Audit$PerformAuditPage$init = F2(
	function (environment, auditId) {
		return _Utils_Tuple3(
			environment,
			{gm: auditId, bk: _List_Nil, gv: $author$project$Audit$CompleteAudit$hidden, cN: $author$project$Audit$EditDialog$hidden, dV: $author$project$Measure$CreateDialog$hidden, fG: $author$project$Audit$PerformAuditPage$Hidden, dW: $author$project$Measure$EditDialog$hidden, eW: $author$project$Audit$RecordModal$hidden, ee: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$CheckpointHistory$CheckpointOverview$Page = $elm$core$Basics$identity;
var $author$project$CheckpointHistory$CheckpointOverview$init = F2(
	function (environment, checkpointOverviewEntryPoint) {
		return _Utils_Tuple3(
			environment,
			{b9: checkpointOverviewEntryPoint.b9, ca: checkpointOverviewEntryPoint.ca, aN: ''},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$CheckpointHistory$Page$PageLoading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$Http$GetCheckpointHistory = 20;
var $author$project$CheckpointHistory$Page$GotGetCheckpointHistoryResult = function (a) {
	return {$: 0, a: a};
};
var $author$project$CheckpointHistory$Page$getRequest = F2(
	function (environment, checkpointId) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$CheckpointHistory$Page$GotGetCheckpointHistoryResult,
			A3(
				$author$project$Utils$Http$sendGet,
				$author$project$Environments$Environment$baseUri(environment) + ('/audits/query/checkpoint-history/' + $author$project$CheckpointData$Checkpoint$Id$toString(checkpointId)),
				_List_Nil,
				20));
	});
var $author$project$CheckpointHistory$Page$init = F2(
	function (environment, checkpointId) {
		return _Utils_Tuple3(
			environment,
			$author$project$CheckpointHistory$Page$PageLoading(checkpointId),
			A2($author$project$CheckpointHistory$Page$getRequest, environment, checkpointId));
	});
var $author$project$Environments$ErrorHandling$ErrorModal$hidden = $author$project$Environments$ErrorHandling$ErrorModal$Hidden;
var $author$project$EventStream$Page$init = function (environment) {
	return _Utils_Tuple3(
		environment,
		{gu: 1, gD: 1, fq: $author$project$Environments$ErrorHandling$ErrorModal$hidden, hp: 1},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Measure$Page$Page = $elm$core$Basics$identity;
var $author$project$Measure$Page$ReceivedNowTimestamp = function (a) {
	return {$: 7, a: a};
};
var $author$project$Measure$Page$init = function (environment) {
	return _Utils_Tuple3(
		environment,
		{
			cO: $author$project$Measure$EditDialog$hidden,
			bF: 100,
			dV: $author$project$Measure$CreateDialog$hidden,
			fK: $elm$time$Time$millisToPosix(0),
			aN: ''
		},
		A2($elm$core$Task$perform, $author$project$Measure$Page$ReceivedNowTimestamp, $elm$time$Time$now));
};
var $author$project$OrganisationUnit$Page$Hidden = {$: 1};
var $author$project$OrganisationUnit$Page$Page = $elm$core$Basics$identity;
var $author$project$UI$DragAndDrop$DragAndDrop$emptyDnd = {hF: $elm$core$Maybe$Nothing, jf: $elm$core$Maybe$Nothing, gT: $elm$core$Maybe$Nothing, gU: $elm$core$Maybe$Nothing};
var $author$project$OrganisationUnit$CreateDialog$Hidden = {$: 0};
var $author$project$OrganisationUnit$CreateDialog$hidden = $author$project$OrganisationUnit$CreateDialog$Hidden;
var $author$project$OrganisationUnit$EditDialog$Hidden = {$: 0};
var $author$project$OrganisationUnit$EditDialog$hidden = $author$project$OrganisationUnit$EditDialog$Hidden;
var $author$project$OrganisationUnit$Page$init = function (environment) {
	return _Utils_Tuple3(
		environment,
		{fi: $author$project$OrganisationUnit$CreateDialog$hidden, hN: $author$project$UI$DragAndDrop$DragAndDrop$emptyDnd, gB: $author$project$OrganisationUnit$Page$Hidden, cO: $author$project$OrganisationUnit$EditDialog$hidden, dI: _List_Nil},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Page$FloorPlan$Page = $elm$core$Basics$identity;
var $author$project$Page$FloorPlan$init = F2(
	function (environment, fileId) {
		return _Utils_Tuple3(
			environment,
			{gI: fileId},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$MainMenu$Page = $elm$core$Basics$identity;
var $author$project$Page$MainMenu$ReceivedNowTimestamp = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Modals$ConfirmOpenSettings$Hidden = 0;
var $author$project$Page$Modals$ConfirmOpenSettings$hidden = 0;
var $author$project$Page$MainMenu$init = function (environment) {
	return _Utils_Tuple3(
		environment,
		{
			dv: $author$project$Page$Modals$ConfirmOpenSettings$hidden,
			fK: $elm$time$Time$millisToPosix(0)
		},
		A2($elm$core$Task$perform, $author$project$Page$MainMenu$ReceivedNowTimestamp, $elm$time$Time$now));
};
var $author$project$Page$OrganisationUnitOverview$Page = $elm$core$Basics$identity;
var $author$project$Page$OrganisationUnitOverview$ReceivedNowTimestamp = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$OrganisationUnitOverview$init = function (environment) {
	return _Utils_Tuple3(
		environment,
		{
			eB: false,
			fK: $elm$time$Time$millisToPosix(0),
			aN: ''
		},
		A2($elm$core$Task$perform, $author$project$Page$OrganisationUnitOverview$ReceivedNowTimestamp, $elm$time$Time$now));
};
var $author$project$Page$Page404$Page = 0;
var $author$project$Page$Page404$init = function (environment) {
	return _Utils_Tuple3(environment, 0, $elm$core$Platform$Cmd$none);
};
var $author$project$Page$Settings$Page = $elm$core$Basics$identity;
var $author$project$Tenant$EditModal$Hidden = {$: 0};
var $author$project$Tenant$EditModal$hidden = $author$project$Tenant$EditModal$Hidden;
var $author$project$Page$Settings$init = function (environment) {
	return _Utils_Tuple3(environment, $author$project$Tenant$EditModal$hidden, $elm$core$Platform$Cmd$none);
};
var $author$project$Plan$Page$Loading = {$: 0};
var $author$project$Plan$Page$ReceivedDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Date_Time$NaiveDate$today = function (timeZone) {
	return A2(
		$elm$core$Task$map,
		$author$project$Date_Time$NaiveDate$fromPosix(timeZone),
		$elm$time$Time$now);
};
var $author$project$Plan$Page$init = function (environment) {
	return _Utils_Tuple3(
		environment,
		$author$project$Plan$Page$Loading,
		A2(
			$elm$core$Task$perform,
			$author$project$Plan$Page$ReceivedDate,
			$author$project$Date_Time$NaiveDate$today(
				$author$project$Environments$Environment$timeZone(environment))));
};
var $author$project$Rights$Role$Page$Page = $elm$core$Basics$identity;
var $author$project$Rights$Role$CreateDialog$Hidden = {$: 0};
var $author$project$Rights$Role$CreateDialog$hidden = $author$project$Rights$Role$CreateDialog$Hidden;
var $author$project$Rights$Role$EditDialog$Hidden = {$: 0};
var $author$project$Rights$Role$EditDialog$hidden = $author$project$Rights$Role$EditDialog$Hidden;
var $author$project$Rights$Role$Page$init = function (environment) {
	return _Utils_Tuple3(
		environment,
		{fi: $author$project$Rights$Role$CreateDialog$hidden, cO: $author$project$Rights$Role$EditDialog$hidden},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Rights$Team$Page$Page = $elm$core$Basics$identity;
var $author$project$Rights$Team$CreateDialog$Hidden = {$: 0};
var $author$project$Rights$Team$CreateDialog$hidden = $author$project$Rights$Team$CreateDialog$Hidden;
var $author$project$Rights$Team$EditDialog$Hidden = {$: 0};
var $author$project$Rights$Team$EditDialog$hidden = $author$project$Rights$Team$EditDialog$Hidden;
var $author$project$Rights$Team$Page$init = function (environment) {
	return _Utils_Tuple3(
		environment,
		{fi: $author$project$Rights$Team$CreateDialog$hidden, cO: $author$project$Rights$Team$EditDialog$hidden},
		$elm$core$Platform$Cmd$none);
};
var $author$project$User$Page$Hidden = {$: 1};
var $author$project$User$Page$Page = $elm$core$Basics$identity;
var $author$project$User$CreateDialog$Hidden = {$: 0};
var $author$project$User$CreateDialog$hidden = $author$project$User$CreateDialog$Hidden;
var $author$project$User$EditDialog$Hidden = {$: 0};
var $author$project$User$EditDialog$hidden = $author$project$User$EditDialog$Hidden;
var $author$project$User$Page$init = function (environment) {
	return _Utils_Tuple3(
		environment,
		{fi: $author$project$User$CreateDialog$hidden, cO: $author$project$User$EditDialog$hidden, ho: $author$project$User$Page$Hidden},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Page$Page$GotMainMenuMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Environments$Route$Settings = {$: 4};
var $author$project$Page$Modals$ConfirmOpenSettings$Visible = 1;
var $author$project$Page$Modals$ConfirmOpenSettings$visible = 1;
var $author$project$Page$MainMenu$update = F4(
	function (msg, environment, repository, page) {
		var model = page;
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					ac: A2($author$project$Environments$Environment$navigateTo, route, environment),
					ak: page,
					ae: repository
				};
			case 1:
				var today = msg.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					ac: environment,
					ak: _Utils_update(
						model,
						{fK: today}),
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
			case 3:
				var viewType = $author$project$Environments$Environment$getViewType(environment);
				if (!viewType) {
					return {
						ab: $elm$core$Platform$Cmd$none,
						ac: A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Settings, environment),
						ak: page,
						ae: repository
					};
				} else {
					return {
						ab: $elm$core$Platform$Cmd$none,
						ac: environment,
						ak: _Utils_update(
							model,
							{dv: $author$project$Page$Modals$ConfirmOpenSettings$visible}),
						ae: repository
					};
				}
			default:
				var confirmSettingsMsg = msg.a;
				if (!confirmSettingsMsg) {
					return {
						ab: $elm$core$Platform$Cmd$none,
						ac: environment,
						ak: _Utils_update(
							model,
							{dv: $author$project$Page$Modals$ConfirmOpenSettings$hidden}),
						ae: repository
					};
				} else {
					return {
						ab: $elm$core$Platform$Cmd$none,
						ac: A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Settings, environment),
						ak: _Utils_update(
							model,
							{dv: $author$project$Page$Modals$ConfirmOpenSettings$hidden}),
						ae: repository
					};
				}
		}
	});
var $author$project$Page$MainMenu$ReceivedSettingsConfirmModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Translations$MainMenu$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'mainMenu.header');
};
var $author$project$UI$Icons$home = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M41.963 22.08L24.954 6.871c-.039-.039-.08-.073-.128-.104-.242-.22-.554-.341-.885-.341-.324 0-.636.119-.88.336L6.039 21.982c-.54.482-.589 1.319-.106 1.869.251.28.61.44.986.44.324 0 .637-.118.881-.334l.299-.268 15.85-14.177 11.075 9.902v18.659c0 .47-.178.763-.264.844h-5.314c-.025 0-.046-.022-.046-.048v-9.01c0-1.483-1.208-2.689-2.69-2.689h-5.424c-1.483 0-2.691 1.206-2.691 2.689v9.025c0 .026-.022.048-.048.048h-5.37c-.112 0-.206-.094-.206-.204V25.837c0-.728-.589-1.318-1.317-1.318-.716 0-1.295.573-1.314 1.285h-.003v12.924c0 1.57 1.277 2.846 2.847 2.846h5.372c1.481 0 2.689-1.207 2.689-2.69v-9.025c0-.025.022-.048.048-.048h5.424c.026 0 .048.023.048.048v9.025c0 1.483 1.206 2.69 2.689 2.69h5.372c1.595 0 2.847-1.531 2.847-3.486V21.781l2.538 2.275c.242.213.555.333.88.333.376 0 .735-.162.99-.447.468-.544.415-1.378-.118-1.862')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Modals$ConfirmOpenSettings$UserClickedCloseDialog = 0;
var $author$project$Translations$Sidebar$confirmOpenSettings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.confirmOpenSettings');
};
var $author$project$Translations$Sidebar$confirmOpenSettingsText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.confirmOpenSettingsText');
};
var $author$project$Page$Modals$ConfirmOpenSettings$viewContent = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Sidebar$confirmOpenSettingsText(translations))
			]));
};
var $author$project$Page$Modals$ConfirmOpenSettings$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			0,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$Page$Modals$ConfirmOpenSettings$UserClickedNext = 1;
var $author$project$Translations$Buttons$next = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'buttons.next');
};
var $author$project$Page$Modals$ConfirmOpenSettings$viewNextButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			1,
			$author$project$UI$Button$green(
				$author$project$Translations$Buttons$next(translations))));
};
var $author$project$Page$Modals$ConfirmOpenSettings$viewFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Page$Modals$ConfirmOpenSettings$viewCloseButton(translations),
				$author$project$Page$Modals$ConfirmOpenSettings$viewNextButton(translations)
			]));
};
var $author$project$Page$Modals$ConfirmOpenSettings$viewDialog = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return $author$project$UI$Modal$view(
		A2(
			$author$project$UI$Modal$appendFooter,
			$author$project$Page$Modals$ConfirmOpenSettings$viewFooter(translations),
			A2(
				$author$project$UI$Modal$appendContent,
				$author$project$Page$Modals$ConfirmOpenSettings$viewContent(translations),
				A2(
					$author$project$UI$Modal$modal,
					$author$project$Translations$Sidebar$confirmOpenSettings(translations),
					0))));
};
var $author$project$Page$Modals$ConfirmOpenSettings$view = F2(
	function (environment, dialog) {
		if (!dialog) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			return A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Page$Modals$ConfirmOpenSettings$viewDialog, environment);
		}
	});
var $rtfeldman$elm_css$Css$Structure$PseudoElement = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
};
var $rtfeldman$elm_css$Css$before = $rtfeldman$elm_css$Css$pseudoElement('before');
var $author$project$Environments$Route$FloorPlan = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$MainMenu$UserClickedTile = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$backgroundImage = $rtfeldman$elm_css$Css$prop1('background-image');
var $rtfeldman$elm_css$Css$collectStops = $elm$core$List$map(
	function (_v0) {
		var c = _v0.a;
		var len = _v0.b;
		return A2(
			$elm$core$String$append,
			c.ll,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$String$cons(' '),
						function ($) {
							return $.ll;
						}),
					len)));
	});
var $rtfeldman$elm_css$Css$linearGradient = F3(
	function (firstStop, secondStop, otherStops) {
		return {
			$7: 0,
			d: 0,
			ll: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'linear-gradient',
				$rtfeldman$elm_css$Css$collectStops(
					_Utils_ap(
						_List_fromArray(
							[firstStop, secondStop]),
						otherStops)))
		};
	});
var $rtfeldman$elm_css$Css$stop = function (c) {
	return _Utils_Tuple2(c, $elm$core$Maybe$Nothing);
};
var $author$project$Page$MainMenu$viewTile = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-tile',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$backgroundImage(
						A3(
							$rtfeldman$elm_css$Css$linearGradient,
							$rtfeldman$elm_css$Css$stop(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
							$rtfeldman$elm_css$Css$stop(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
							_List_Nil)),
						$rtfeldman$elm_css$Css$firstChild(
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$property, 'grid-row', '1 / 1'),
								A2($rtfeldman$elm_css$Css$property, 'grid-column', '1 / 1')
							]))
					])),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
			]));
};
var $rtfeldman$elm_css$Css$flex3 = $rtfeldman$elm_css$Css$prop3('flex');
var $author$project$Page$MainMenu$viewTileIcon = function (icon) {
	return $author$project$UI$Icon$view(
		A2(
			$author$project$UI$Icon$withStyle,
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$padding(
					$rtfeldman$elm_css$Css$rem(1)),
				A2(
					$author$project$UI$Icon$withStyle,
					A3(
						$rtfeldman$elm_css$Css$flex3,
						$rtfeldman$elm_css$Css$int(1),
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$zero),
					A2(
						$author$project$UI$Icon$withForegroundColor,
						$author$project$UI$Style$Theme$grey,
						$author$project$UI$Icon$unicolor(icon))))));
};
var $rtfeldman$elm_css$Css$margin3 = $rtfeldman$elm_css$Css$prop3('margin');
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $author$project$Page$MainMenu$viewTileLabel = function (description) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$margin3,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$rem(0.5),
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$paddingTop(
						$rtfeldman$elm_css$Css$rem(0.5)),
						A3(
						$rtfeldman$elm_css$Css$borderTop3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
						$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
						$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
						$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(description)
			]));
};
var $author$project$Page$MainMenu$viewTileMarker = function (color) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(0.5)),
						A4(
						$rtfeldman$elm_css$Css$borderRadius4,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$rem(0.5),
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor(color))
					]))
			]),
		_List_Nil);
};
var $author$project$Page$MainMenu$viewFloorPlanTile = F2(
	function (translations, organisationUnit) {
		var _v0 = organisationUnit.ap;
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var filename = _v0.a;
			return A2(
				$author$project$Page$MainMenu$viewTile,
				$author$project$Page$MainMenu$UserClickedTile(
					$author$project$Environments$Route$FloorPlan(filename.fw)),
				_List_fromArray(
					[
						$author$project$Page$MainMenu$viewTileIcon($author$project$UI$Icons$floorPlan),
						$author$project$Page$MainMenu$viewTileLabel(
						$author$project$Translations$MainMenu$floorPlan(translations)),
						$author$project$Page$MainMenu$viewTileMarker($author$project$UI$Style$Theme$grey)
					]));
		}
	});
var $author$project$Page$MainMenu$determineCurrentOrganisationUnit = F3(
	function (translations, repository, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$rtfeldman$elm_css$Html$Styled$text(''),
			A2(
				$elm$core$Maybe$map,
				function (organisationUnit) {
					return A2($author$project$Page$MainMenu$viewFloorPlanTile, translations, organisationUnit);
				},
				A2($author$project$Environments$Repository$getOrganisationUnit, id, repository)));
	});
var $author$project$Page$MainMenu$determineFloorPlanTile = F3(
	function (translations, environment, repository) {
		return A2(
			$elm$core$Maybe$withDefault,
			$rtfeldman$elm_css$Html$Styled$text(''),
			A2(
				$elm$core$Maybe$map,
				function (id) {
					return A3($author$project$Page$MainMenu$determineCurrentOrganisationUnit, translations, repository, id);
				},
				$author$project$Environments$Environment$getCurrentOrganisationUnit(environment)));
	});
var $author$project$Translations$Archive$archive = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.archive');
};
var $author$project$Page$MainMenu$viewDisableTileIcon = function (icon) {
	return $author$project$UI$Icon$view(
		A2(
			$author$project$UI$Icon$withStyle,
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$padding(
					$rtfeldman$elm_css$Css$rem(1)),
				A2(
					$author$project$UI$Icon$withStyle,
					A3(
						$rtfeldman$elm_css$Css$flex3,
						$rtfeldman$elm_css$Css$int(1),
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$zero),
					A2(
						$author$project$UI$Icon$withForegroundColor,
						$author$project$UI$Style$Theme$grey,
						$author$project$UI$Icon$unicolor(icon))))));
};
var $author$project$Page$MainMenu$viewDisabledTile = A2(
	$rtfeldman$elm_css$Html$Styled$node,
	'aw-disabled-tile',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0.5)),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed),
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$rem(0.5)),
					$rtfeldman$elm_css$Css$backgroundImage(
					A3(
						$rtfeldman$elm_css$Css$linearGradient,
						$rtfeldman$elm_css$Css$stop(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
						$rtfeldman$elm_css$Css$stop(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
						_List_Nil)),
					$rtfeldman$elm_css$Css$firstChild(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'grid-row', '1 / 1'),
							A2($rtfeldman$elm_css$Css$property, 'grid-column', '1 / 1')
						]))
				]))
		]));
var $author$project$Page$MainMenu$viewArchiveTile = F2(
	function (translations, environment) {
		return $author$project$Environments$Environment$isOffline(environment) ? $author$project$Page$MainMenu$viewDisabledTile(
			_List_fromArray(
				[
					$author$project$Page$MainMenu$viewDisableTileIcon($author$project$UI$Icons$checkedDocument),
					$author$project$Page$MainMenu$viewTileLabel(
					$author$project$Translations$Archive$archive(translations)),
					$author$project$Page$MainMenu$viewTileMarker($author$project$UI$Style$Theme$grey)
				])) : A2(
			$author$project$Page$MainMenu$viewTile,
			$author$project$Page$MainMenu$UserClickedTile($author$project$Environments$Route$Archive),
			_List_fromArray(
				[
					$author$project$Page$MainMenu$viewTileIcon($author$project$UI$Icons$checkedDocument),
					$author$project$Page$MainMenu$viewTileLabel(
					$author$project$Translations$Archive$archive(translations)),
					$author$project$Page$MainMenu$viewTileMarker($author$project$UI$Style$Theme$grey)
				]));
	});
var $author$project$Environments$Route$Audits = {$: 2};
var $author$project$Page$MainMenu$viewTilePile = F2(
	function (text_, color_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
							$rtfeldman$elm_css$Css$top(
							$rtfeldman$elm_css$Css$rem(-0.5)),
							$rtfeldman$elm_css$Css$right(
							$rtfeldman$elm_css$Css$rem(-0.5)),
							$rtfeldman$elm_css$Css$minWidth(
							$rtfeldman$elm_css$Css$rem(1.75)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$rem(0.25)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$rem(1.25)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$num(1)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor(color_))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(text_)
				]));
	});
var $author$project$Page$MainMenu$viewAuditsTile = F3(
	function (environment, repository, model) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var filteredAudits = A4(
			$author$project$Audit$Audit$filter,
			environment,
			'',
			$author$project$Environments$Repository$organisationUnits(repository),
			A2(
				$elm$core$List$filter,
				function (audit) {
					return _Utils_eq(audit.jb, $author$project$Audit$CompletionStatus$Open);
				},
				$author$project$Audit$Dict$values(
					$author$project$Environments$Repository$audits(repository))));
		var _v0 = $elm$core$List$length(filteredAudits);
		if (!_v0) {
			return A2(
				$author$project$Page$MainMenu$viewTile,
				$author$project$Page$MainMenu$UserClickedTile($author$project$Environments$Route$Audits),
				_List_fromArray(
					[
						$author$project$Page$MainMenu$viewTileIcon($author$project$UI$Icons$audits),
						$author$project$Page$MainMenu$viewTileLabel(
						$author$project$Translations$MainMenu$audits(translations)),
						$author$project$Page$MainMenu$viewTileMarker($author$project$UI$Style$Theme$grey)
					]));
		} else {
			var numberOfAudits = _v0;
			var timeZone = $author$project$Environments$Environment$timeZone(environment);
			var color_ = A2(
				$elm$core$Maybe$withDefault,
				$author$project$UI$Style$Theme$grey,
				A2(
					$elm$core$Maybe$map,
					function (audit) {
						return (_Utils_cmp(
							$elm$time$Time$posixToMillis(audit.hI),
							$elm$time$Time$posixToMillis(model.fK)) < 0) ? $author$project$UI$Style$Theme$lightRed : (_Utils_eq(
							A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, audit.hI),
							A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, model.fK)) ? $author$project$UI$Style$Theme$yellow : $author$project$UI$Style$Theme$green);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$sortBy,
							function (audit) {
								return $elm$time$Time$posixToMillis(audit.hI);
							},
							filteredAudits))));
			return A2(
				$author$project$Page$MainMenu$viewTile,
				$author$project$Page$MainMenu$UserClickedTile($author$project$Environments$Route$Audits),
				_List_fromArray(
					[
						$author$project$Page$MainMenu$viewTileIcon($author$project$UI$Icons$audits),
						$author$project$Page$MainMenu$viewTileLabel(
						$author$project$Translations$MainMenu$audits(translations)),
						$author$project$Page$MainMenu$viewTileMarker(color_),
						A2(
						$author$project$Page$MainMenu$viewTilePile,
						$elm$core$String$fromInt(numberOfAudits),
						color_)
					]));
		}
	});
var $author$project$Environments$Route$CheckpointOverview = function (a) {
	return {$: 13, a: a};
};
var $author$project$Translations$CheckpointHistory$checkpointOverview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointHistory.checkpointOverview');
};
var $author$project$UI$Icons$windows = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M21.273,22.898l-10.893,0c-0.896,0 -1.625,-0.728 -1.625,-1.624l0,-10.893c0,-0.896 0.729,-1.625 1.625,-1.625l10.894,0c0.896,0 1.624,0.729 1.624,1.625l0,10.894c-0.001,0.895 -0.729,1.623 -1.625,1.623Zm-10.23,-2.285l9.568,0l0,-9.568l-9.568,0l0,9.568Z')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M37.619,22.898l-10.894,0c-0.896,0 -1.625,-0.728 -1.625,-1.624l0,-10.893c0,-0.896 0.729,-1.625 1.625,-1.625l10.895,0c0.896,0 1.625,0.729 1.625,1.625l0,10.894c-0.001,0.895 -0.729,1.623 -1.626,1.623Zm-10.228,-2.285l9.567,0l0,-9.568l-9.567,0l0,9.568Z')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M21.273,39.244l-10.893,0c-0.896,0 -1.625,-0.729 -1.625,-1.624l0,-10.893c0,-0.896 0.729,-1.625 1.625,-1.625l10.894,0c0.896,0 1.624,0.729 1.624,1.625l0,10.893c-0.001,0.896 -0.729,1.624 -1.625,1.624Zm-10.23,-2.287l9.568,0l0,-9.568l-9.568,0l0,9.568Z')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M37.619,39.244l-10.894,0c-0.896,0 -1.625,-0.729 -1.625,-1.624l0,-10.893c0,-0.896 0.729,-1.625 1.625,-1.625l10.895,0c0.896,0 1.625,0.729 1.625,1.625l0,10.893c-0.001,0.896 -0.729,1.624 -1.626,1.624Zm-10.228,-2.287l9.567,0l0,-9.568l-9.567,0l0,9.568Z')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$MainMenu$viewCheckpointOverview = F2(
	function (translations, environment) {
		if ($author$project$Environments$Environment$isOffline(environment)) {
			return $author$project$Page$MainMenu$viewDisabledTile(
				_List_fromArray(
					[
						$author$project$Page$MainMenu$viewDisableTileIcon($author$project$UI$Icons$windows),
						$author$project$Page$MainMenu$viewTileLabel(
						$author$project$Translations$CheckpointHistory$checkpointOverview(translations)),
						$author$project$Page$MainMenu$viewTileMarker($author$project$UI$Style$Theme$grey)
					]));
		} else {
			var checkpointOverviewEntryPoint = {b9: $author$project$CheckpointData$CheckpointGroup$Ids$empty, ca: $author$project$OrganisationUnit$Ids$empty};
			return A2(
				$author$project$Page$MainMenu$viewTile,
				$author$project$Page$MainMenu$UserClickedTile(
					$author$project$Environments$Route$CheckpointOverview(checkpointOverviewEntryPoint)),
				_List_fromArray(
					[
						$author$project$Page$MainMenu$viewTileIcon($author$project$UI$Icons$windows),
						$author$project$Page$MainMenu$viewTileLabel(
						$author$project$Translations$CheckpointHistory$checkpointOverview(translations)),
						$author$project$Page$MainMenu$viewTileMarker($author$project$UI$Style$Theme$grey)
					]));
		}
	});
var $author$project$Environments$Route$EventStream = {$: 10};
var $author$project$Translations$Synchronisation$synchronisation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.synchronisation');
};
var $author$project$Page$MainMenu$viewEventStreamTile = F3(
	function (translations, environment, repository) {
		var tilePile = function () {
			var _v4 = $author$project$Environments$Repository$eventStream(repository);
			if (_v4.$ === 4) {
				var data = _v4.a;
				return ($elm$core$List$length(data.m.f9) > 0) ? A2(
					$author$project$Page$MainMenu$viewTilePile,
					$elm$core$String$fromInt(
						$elm$core$List$length(data.m.f9)),
					$author$project$UI$Style$Theme$yellow) : $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}();
		var color = function () {
			var _v0 = _Utils_Tuple2(
				$author$project$Environments$Environment$isOffline(environment),
				$author$project$Environments$Repository$eventStream(repository));
			if (_v0.a) {
				return $author$project$UI$Style$Theme$grey;
			} else {
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.b;
						return $author$project$UI$Style$Theme$grey;
					case 1:
						var _v2 = _v0.b;
						return $author$project$UI$Style$Theme$red;
					case 2:
						var _v3 = _v0.b;
						return $author$project$UI$Style$Theme$yellow;
					case 3:
						return $author$project$UI$Style$Theme$orange;
					default:
						return $author$project$UI$Style$Theme$green;
				}
			}
		}();
		return A2(
			$author$project$Page$MainMenu$viewTile,
			$author$project$Page$MainMenu$UserClickedTile($author$project$Environments$Route$EventStream),
			_List_fromArray(
				[
					$author$project$Page$MainMenu$viewTileIcon($author$project$UI$Icons$sync),
					$author$project$Page$MainMenu$viewTileLabel(
					$author$project$Translations$Synchronisation$synchronisation(translations)),
					$author$project$Page$MainMenu$viewTileMarker(color),
					tilePile
				]));
	});
var $author$project$Environments$Route$Measures = {$: 1};
var $author$project$Environments$Repository$measures = function (_v0) {
	var data = _v0;
	return $author$project$Measure$Measures$dict(
		$author$project$Utils$Triple$first(
			A2(
				$author$project$Measure$Measures$applyEvents,
				$author$project$Measure$Store$events(data.R),
				$author$project$Measure$Store$measures(data.R))));
};
var $author$project$Page$MainMenu$viewMeasuresTile = F3(
	function (environment, repository, model) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var organisationUnits = $author$project$Environments$Repository$organisationUnits(repository);
		var filteredMeasures = A4(
			$author$project$Measure$Measure$filter,
			environment,
			'',
			organisationUnits,
			A2(
				$elm$core$List$filter,
				function (measure) {
					return _Utils_eq(measure.jb, $author$project$Measure$CompletionStatus$Open);
				},
				$author$project$Measure$Dict$values(
					$author$project$Environments$Repository$measures(repository))));
		var _v0 = $elm$core$List$length(filteredMeasures);
		if (!_v0) {
			return A2(
				$author$project$Page$MainMenu$viewTile,
				$author$project$Page$MainMenu$UserClickedTile($author$project$Environments$Route$Measures),
				_List_fromArray(
					[
						$author$project$Page$MainMenu$viewTileIcon($author$project$UI$Icons$taskList),
						$author$project$Page$MainMenu$viewTileLabel(
						$author$project$Translations$MainMenu$measures(translations)),
						$author$project$Page$MainMenu$viewTileMarker($author$project$UI$Style$Theme$grey)
					]));
		} else {
			var numberOfMeasures = _v0;
			var timeZone = $author$project$Environments$Environment$timeZone(environment);
			var color_ = A2(
				$elm$core$Maybe$withDefault,
				$author$project$UI$Style$Theme$grey,
				A2(
					$elm$core$Maybe$map,
					function (deadlineTimestamp) {
						return (_Utils_cmp(
							$elm$time$Time$posixToMillis(deadlineTimestamp),
							$elm$time$Time$posixToMillis(model.fK)) < 0) ? $author$project$UI$Style$Theme$lightRed : (_Utils_eq(
							A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, deadlineTimestamp),
							A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, model.fK)) ? $author$project$UI$Style$Theme$yellow : $author$project$UI$Style$Theme$green);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$sortBy,
							function (deadlineTimestamp) {
								return $elm$time$Time$posixToMillis(deadlineTimestamp);
							},
							A3(
								$elm$core$List$foldl,
								$author$project$Utils$Utils$reduceMaybeList,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.hI;
									},
									filteredMeasures))))));
			return A2(
				$author$project$Page$MainMenu$viewTile,
				$author$project$Page$MainMenu$UserClickedTile($author$project$Environments$Route$Measures),
				_List_fromArray(
					[
						$author$project$Page$MainMenu$viewTileIcon($author$project$UI$Icons$taskList),
						$author$project$Page$MainMenu$viewTileLabel(
						$author$project$Translations$MainMenu$measures(translations)),
						$author$project$Page$MainMenu$viewTileMarker(color_),
						A2(
						$author$project$Page$MainMenu$viewTilePile,
						$elm$core$String$fromInt(numberOfMeasures),
						color_)
					]));
		}
	});
var $author$project$Page$MainMenu$viewTiles = F4(
	function (translations, environment, repository, model) {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-tiles',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(auto-fill, minmax(10rem, 1fr))'),
							A2($rtfeldman$elm_css$Css$property, 'grid-gap', '1rem'),
							A2($rtfeldman$elm_css$Css$property, 'grid-auto-rows', '1fr'),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(0.5)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(300)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$before(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$property, 'content', '\'\''),
									$rtfeldman$elm_css$Css$paddingBottom(
									$rtfeldman$elm_css$Css$pct(100)),
									$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
									A2($rtfeldman$elm_css$Css$property, 'grid-row', '1 / 1'),
									A2($rtfeldman$elm_css$Css$property, 'grid-column', '1 / 1')
								]))
						]))
				]),
			_List_fromArray(
				[
					A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$MainMenu$viewMeasuresTile, environment, repository, model),
					A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$MainMenu$viewAuditsTile, environment, repository, model),
					A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$MainMenu$determineFloorPlanTile, translations, environment, repository),
					A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$MainMenu$viewEventStreamTile, translations, environment, repository),
					A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Page$MainMenu$viewArchiveTile, translations, environment),
					A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Page$MainMenu$viewCheckpointOverview, translations, environment)
				]));
	});
var $author$project$Page$MainMenu$view = F3(
	function (environment, repository, _v0) {
		var model = _v0;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$MainMenu$ReceivedSettingsConfirmModalMsg,
					A2($author$project$Page$Modals$ConfirmOpenSettings$view, environment, model.dv)),
				A2(
					$author$project$UI$Page$appendContent,
					A4($author$project$Page$MainMenu$viewTiles, translations, environment, repository, model),
					A2(
						$author$project$UI$Page$withIcon,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$home),
						$author$project$UI$Page$page(
							$author$project$Translations$MainMenu$header(translations))))));
	});
var $author$project$Page$Page$mainMenu = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (!mainMsg.$) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotMainMenuMsg,
		kZ: $elm$core$Maybe$Nothing,
		le: $author$project$Page$MainMenu$update,
		lm: $author$project$Page$MainMenu$view
	});
var $author$project$Page$Page$GotMeasurePageMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$Page$GotEditDialogMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$Page$GotMeasureCreateDialogMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Measure$CreateDialog$GotImageEditorMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Measure$CreateDialog$subscriptions = function (dialog) {
	if (dialog.$ === 1) {
		return A2($elm$core$Platform$Sub$map, $author$project$Measure$CreateDialog$GotImageEditorMsg, $author$project$UI$ImagesEditor$subscriptions);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Measure$Page$subscriptions = function (_v0) {
	var page = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Measure$Page$GotEditDialogMsg,
				$author$project$Measure$EditDialog$subscriptions(page.cO)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Measure$Page$GotMeasureCreateDialogMsg,
				$author$project$Measure$CreateDialog$subscriptions(page.dV))
			]));
};
var $author$project$Measure$Page$enteredSearchString = F4(
	function (newSearchString, environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{aN: newSearchString}),
			ae: repository
		};
	});
var $author$project$Measure$Page$gotEditDialogMsg = F4(
	function (msg, environment, repository, _v0) {
		var page = _v0;
		var result = A4($author$project$Measure$EditDialog$update, msg, environment, repository, page.cO);
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Measure$Page$GotEditDialogMsg, result.ab),
			ac: result.ac,
			ak: _Utils_update(
				page,
				{cO: result.jn}),
			ae: result.ae
		};
	});
var $author$project$Measure$CreateDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Measure$CreateDialog$NoDeadline = {$: 0};
var $author$project$Measure$CreateDialog$WithDeadline = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Measure$CreateDialog$addNaiveTimeToDeadlineState = F2(
	function (newTime, deadlineState) {
		if (!deadlineState.$) {
			return $author$project$Measure$CreateDialog$NoDeadline;
		} else {
			var naiveDate = deadlineState.a;
			return A2($author$project$Measure$CreateDialog$WithDeadline, naiveDate, newTime);
		}
	});
var $author$project$Measure$CreateDialog$addHourValue = F3(
	function (environment, hourInput, model) {
		if ($elm$core$String$isEmpty(hourInput)) {
			return _Utils_update(
				model,
				{cf: hourInput});
		} else {
			if ($elm$core$String$isEmpty(model.cj)) {
				var _v0 = $elm$core$String$toInt(hourInput);
				if (_v0.$ === 1) {
					return model;
				} else {
					var hour = _v0.a;
					return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
						model,
						{cf: hourInput}) : model;
				}
			} else {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(hourInput),
					$elm$core$String$toInt(model.cj));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var hour = _v1.a.a;
					var minute = _v1.b.a;
					var _v2 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
					if (!_v2.$) {
						var naiveTime = _v2.a;
						var newTime = A2(
							$author$project$Date_Time$NaiveTime$toUtcTime,
							$author$project$Environments$Environment$timeOffset(environment),
							naiveTime);
						return _Utils_update(
							model,
							{
								bl: A2($author$project$Measure$CreateDialog$addNaiveTimeToDeadlineState, newTime, model.bl),
								cf: hourInput
							});
					} else {
						return model;
					}
				} else {
					return model;
				}
			}
		}
	});
var $author$project$Measure$CreateDialog$enteredHour = F4(
	function (input, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						A3($author$project$Measure$CreateDialog$addHourValue, environment, input, model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$addMinuteValue = F3(
	function (environment, minuteInput, model) {
		if ($elm$core$String$isEmpty(minuteInput)) {
			return _Utils_update(
				model,
				{cj: minuteInput});
		} else {
			if ($elm$core$String$isEmpty(model.cf)) {
				var _v0 = $elm$core$String$toInt(minuteInput);
				if (_v0.$ === 1) {
					return model;
				} else {
					var hour = _v0.a;
					return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
						model,
						{cj: minuteInput}) : model;
				}
			} else {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(model.cf),
					$elm$core$String$toInt(minuteInput));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var hour = _v1.a.a;
					var minute = _v1.b.a;
					var _v2 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
					if (!_v2.$) {
						var naiveTime = _v2.a;
						var newTime = A2(
							$author$project$Date_Time$NaiveTime$toUtcTime,
							$author$project$Environments$Environment$timeOffset(environment),
							naiveTime);
						return _Utils_update(
							model,
							{
								bl: A2($author$project$Measure$CreateDialog$addNaiveTimeToDeadlineState, newTime, model.bl),
								cj: minuteInput
							});
					} else {
						return model;
					}
				} else {
					return model;
				}
			}
		}
	});
var $author$project$Measure$CreateDialog$enteredMinute = F4(
	function (input, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						A3($author$project$Measure$CreateDialog$addMinuteValue, environment, input, model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$gotCurrentPosix = F4(
	function (now, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						_Utils_update(
							model,
							{fK: now})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$gotImageEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = A3($author$project$UI$ImagesEditor$update, editorMsg, environment, model.cY);
				var newEnvironment = _v1.a;
				var newImageEditor = _v1.b;
				var imageEditorCmd = _v1.c;
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Measure$CreateDialog$GotImageEditorMsg, imageEditorCmd),
					jn: $author$project$Measure$CreateDialog$Visible(
						_Utils_update(
							model,
							{cY: newImageEditor})),
					ac: newEnvironment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$GotMeasureCommand = function (a) {
	return {$: 18, a: a};
};
var $author$project$Measure$Command$create = F2(
	function (environment, model) {
		return A2(
			$author$project$Measure$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Measure$Command$Create(
						{L: commandId_, M: commandTimestamp, dw: model.dw, jd: model.jd, hI: model.hI, aY: model.aY, fw: '', fx: model.fx, h5: model.h5, h6: model.h6, km: model.km, bb: model.bb, k8: model.k8});
				}));
	});
var $author$project$Measure$CreateDialog$gotMeasure = F4(
	function (measure, environment, repository, dialog) {
		var _v0 = A2($author$project$Measure$Command$create, environment, measure);
		var newEnvironment = _v0.a;
		var createMeasureCommand = _v0.b;
		return {
			ab: A2($elm$core$Task$perform, $author$project$Measure$CreateDialog$GotMeasureCommand, createMeasureCommand),
			jn: dialog,
			ac: newEnvironment,
			ae: repository
		};
	});
var $author$project$Measure$Measure$handleCommand = F3(
	function (command, environment, maybeMeasure) {
		var acc = {
			cD: $author$project$Measure$Commands$empty,
			ac: environment,
			b8: $author$project$Measure$Events$empty,
			cb: $author$project$File$Operations$empty,
			au: $author$project$Measure$Measure$NotModified(maybeMeasure)
		};
		return A2(
			$elm$core$Result$map,
			A3(
				$author$project$Utils$Triple$with,
				function ($) {
					return $.b8;
				},
				function ($) {
					return $.cb;
				},
				function ($) {
					return $.ac;
				}),
			A2($author$project$Measure$Measure$handleCommandHelper, command, acc));
	});
var $author$project$Measure$Commands$singleton = $author$project$Types$Queue$singleton;
var $author$project$Environments$Repository$saveMeasureCommandAndEventsAndFileOperations = function (command) {
	return $author$project$Environments$Repository$saveMeasureCommandsAndEventsAndFileOperations(
		$author$project$Measure$Commands$singleton(command));
};
var $author$project$Measure$CreateDialog$gotMeasureCommand = F4(
	function (command, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				var model = dialog.a;
				var _v1 = A3(
					$author$project$Measure$Measure$handleCommand,
					command,
					environment,
					A2($author$project$Environments$Repository$getMeasure, model.h5, repository));
				if (_v1.$ === 1) {
					var error = _v1.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$measureErrorToString(error)),
						gH: 'Measure.CreateDialog.elm',
						gK: 'gotMeasureCommand',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: $author$project$Measure$CreateDialog$Hidden,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				} else {
					var _v3 = _v1.a;
					var events = _v3.a;
					var fileOperations = _v3.b;
					var newEnvironment = _v3.c;
					if ($author$project$Measure$Events$isEmpty(events)) {
						return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$CreateDialog$Hidden, ac: newEnvironment, ae: repository};
					} else {
						var _v4 = A4($author$project$Environments$Repository$saveMeasureCommandAndEventsAndFileOperations, command, events, fileOperations, repository);
						var newRepository = _v4.a;
						var cmd = _v4.b;
						return {ab: cmd, jn: $author$project$Measure$CreateDialog$Hidden, ac: newEnvironment, ae: newRepository};
					}
				}
		}
	});
var $author$project$Measure$CreateDialog$receivedOrganisationUnitNavigationMsg = F4(
	function (msg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var organisationUnitId = function () {
					switch (msg.$) {
						case 3:
							var organisationUnit = msg.a;
							return $elm$core$Maybe$Just(organisationUnit.km);
						case 4:
							return $elm$core$Maybe$Nothing;
						default:
							return model.km;
					}
				}();
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								km: organisationUnitId,
								d3: A2($author$project$UI$OrganisationUnitNavigation$update, msg, model.d3)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$addNaiveDateToDeadlineState = F2(
	function (newDate, deadlineState) {
		if (!deadlineState.$) {
			return A2($author$project$Measure$CreateDialog$WithDeadline, newDate, $author$project$Date_Time$NaiveTime$mid);
		} else {
			var naiveTime = deadlineState.b;
			return A2($author$project$Measure$CreateDialog$WithDeadline, newDate, naiveTime);
		}
	});
var $author$project$Measure$CreateDialog$userChangedEndDateInput = F4(
	function (state, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = function () {
					var _v2 = $author$project$UI$DateInput$maybeDatePickerDate(state);
					if (!_v2.$) {
						var newDate = _v2.a;
						return _Utils_Tuple2(
							A2($author$project$Measure$CreateDialog$addNaiveDateToDeadlineState, newDate, model.bl),
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple2(model.bl, model.dy);
					}
				}();
				var deadlineDate = _v1.a;
				var dateTextInput = _v1.b;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						_Utils_update(
							model,
							{dy: dateTextInput, bl: deadlineDate, cQ: state})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Measure$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$Measure$CreateDialog$GotMeasure = function (a) {
	return {$: 17, a: a};
};
var $author$project$Measure$Measure$create = function (model) {
	return A2(
		$elm$core$Task$map,
		function (creationTimestamp) {
			return {jb: $author$project$Measure$CompletionStatus$Open, dw: creationTimestamp, jd: model.jd, hI: model.hI, aY: model.aY, fw: model.fw, fx: model.fx, h5: model.h5, h6: model.h6, km: model.km, bb: model.bb, i: 0, k8: model.k8};
		},
		$elm$time$Time$now);
};
var $author$project$Measure$CreateDialog$createCreateCommands = F2(
	function (environment, model) {
		var _v0 = model.km;
		if (!_v0.$) {
			var organisationUnitId = _v0.a;
			var deadlineTimestamp = function () {
				var _v1 = model.bl;
				if (!_v1.$) {
					return $elm$core$Maybe$Nothing;
				} else {
					var naiveDate = _v1.a;
					var naiveTime = _v1.b;
					return $elm$core$Maybe$Just(
						$elm$time$Time$millisToPosix(
							$elm$time$Time$posixToMillis(
								$author$project$Date_Time$NaiveDate$toPosix(naiveDate)) + $author$project$Date_Time$NaiveTime$toMillis(naiveTime)));
				}
			}();
			var createMeasureTask = $author$project$Measure$Measure$create(
				{
					jd: model.jd,
					hI: deadlineTimestamp,
					aY: $author$project$UI$BasicDataEditor$description(model.aQ),
					fw: '',
					fx: $author$project$UI$ImagesEditor$images(model.cY),
					h5: model.h5,
					h6: model.h6,
					km: organisationUnitId,
					bb: model.bb,
					k8: $author$project$UI$BasicDataEditor$title(model.aQ)
				});
			return _Utils_Tuple2(
				environment,
				A2($elm$core$Task$perform, $author$project$Measure$CreateDialog$GotMeasure, createMeasureTask));
		} else {
			return _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Measure$CreateDialog$userClickedCreateButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = A2($author$project$Measure$CreateDialog$createCreateCommands, environment, model);
				var newEnvironment = _v1.a;
				var recordCheckpointCommand = _v1.b;
				return {
					ab: recordCheckpointCommand,
					jn: $author$project$Measure$CreateDialog$HandlingCommands(model),
					ac: newEnvironment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$ImagesStep = 1;
var $author$project$Measure$CreateDialog$ResponsibleUsersStep = 2;
var $author$project$Measure$CreateDialog$switchStep = F2(
	function (step, model) {
		if (_Utils_eq(model.b0, step)) {
			return model;
		} else {
			var _v0 = model.b0;
			switch (_v0) {
				case 0:
					var title = $elm$core$String$trim(
						$author$project$UI$BasicDataEditor$title(model.aQ));
					var description = $elm$core$String$trim(
						$author$project$UI$BasicDataEditor$description(model.aQ));
					return $elm$core$String$isEmpty(title) ? model : _Utils_update(
						model,
						{
							aQ: A2(
								$author$project$UI$BasicDataEditor$withDescription,
								description,
								A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ)),
							b0: step
						});
				case 1:
					return _Utils_update(
						model,
						{b0: step});
				default:
					return _Utils_update(
						model,
						{b0: step});
			}
		}
	});
var $author$project$Measure$CreateDialog$nextStep = function (model) {
	var _v0 = model.b0;
	switch (_v0) {
		case 0:
			return A2($author$project$Measure$CreateDialog$switchStep, 1, model);
		case 1:
			return A2($author$project$Measure$CreateDialog$switchStep, 2, model);
		default:
			return model;
	}
};
var $author$project$Measure$CreateDialog$userClickedNextButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						$author$project$Measure$CreateDialog$nextStep(model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$BasicDataStep = 0;
var $author$project$Measure$CreateDialog$userClickedStepIcon = F4(
	function (step, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return ((!model.b0) && ($author$project$Utils$Maybe$isNothing(model.km) || $elm$core$String$isEmpty(
					$author$project$UI$BasicDataEditor$title(model.aQ)))) ? {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(model),
					ac: environment,
					ae: repository
				} : {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						A2($author$project$Measure$CreateDialog$switchStep, step, model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$userDeletedDeadline = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						_Utils_update(
							model,
							{bl: $author$project$Measure$CreateDialog$NoDeadline})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$userEnteredDateText = F4(
	function (input, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = function () {
					var _v2 = model.bl;
					if (!_v2.$) {
						return _Utils_Tuple2(
							$elm$core$String$fromInt(
								$author$project$Date_Time$NaiveTime$hour(
									A2(
										$author$project$Date_Time$NaiveTime$fromPosix,
										$author$project$Environments$Environment$timeZone(environment),
										$elm$time$Time$millisToPosix(
											$author$project$Date_Time$NaiveTime$toMillis($author$project$Date_Time$NaiveTime$mid))))),
							'00');
					} else {
						return _Utils_Tuple2(model.cf, model.cj);
					}
				}();
				var hourInput = _v1.a;
				var minuteInput = _v1.b;
				var _v3 = function () {
					var _v4 = $author$project$UI$DateInput$inputToNaivDate(
						A3($elm$core$String$replace, '.', '-', input));
					if (!_v4.$) {
						var dateValue = _v4.a;
						return _Utils_Tuple3(
							A2($author$project$Measure$CreateDialog$addNaiveDateToDeadlineState, dateValue, model.bl),
							$elm$core$Maybe$Nothing,
							A2($author$project$UI$DateInput$updateDatePicker, dateValue, model.cQ));
					} else {
						return _Utils_Tuple3(
							model.bl,
							$elm$core$Maybe$Just(input),
							model.cQ);
					}
				}();
				var deadlineDate = _v3.a;
				var dateTextInput = _v3.b;
				var endDateInput = _v3.c;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						_Utils_update(
							model,
							{dy: dateTextInput, bl: deadlineDate, cQ: endDateInput, cf: hourInput, cj: minuteInput})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$userLickedOrganisationUnit = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								d3: $author$project$UI$OrganisationUnitNavigation$visible(false)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$userSelectedUser = F4(
	function (userId, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								bb: A2($author$project$User$Ids$insert, userId, model.bb)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$userUnselectedUser = F4(
	function (userId, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Measure$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								bb: A2($author$project$User$Ids$remove, userId, model.bb)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Measure$CreateDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			var now = msg.a;
			return $author$project$Measure$CreateDialog$gotCurrentPosix(now);
		case 1:
			return $author$project$Measure$CreateDialog$userClickedCloseDialog;
		case 2:
			return $author$project$Measure$CreateDialog$userClickedNextButton;
		case 3:
			var step = msg.a;
			return $author$project$Measure$CreateDialog$userClickedStepIcon(step);
		case 4:
			return $author$project$Measure$CreateDialog$userClickedCancelButton;
		case 5:
			return $author$project$Measure$CreateDialog$userClickedCreateButton;
		case 6:
			var editorMsg = msg.a;
			return $author$project$Measure$CreateDialog$gotBasicDataEditorMsg(editorMsg);
		case 7:
			var editorMsg = msg.a;
			return $author$project$Measure$CreateDialog$gotImageEditorMsg(editorMsg);
		case 8:
			var userId = msg.a;
			return $author$project$Measure$CreateDialog$userSelectedUser(userId);
		case 9:
			var userId = msg.a;
			return $author$project$Measure$CreateDialog$userUnselectedUser(userId);
		case 10:
			var state = msg.a;
			return $author$project$Measure$CreateDialog$userChangedEndDateInput(state);
		case 11:
			var text = msg.a;
			return $author$project$Measure$CreateDialog$userEnteredDateText(text);
		case 12:
			var input = msg.a;
			return $author$project$Measure$CreateDialog$enteredHour(input);
		case 13:
			var input = msg.a;
			return $author$project$Measure$CreateDialog$enteredMinute(input);
		case 14:
			return $author$project$Measure$CreateDialog$userDeletedDeadline;
		case 15:
			return $author$project$Measure$CreateDialog$userLickedOrganisationUnit;
		case 16:
			var navigationMsg = msg.a;
			return $author$project$Measure$CreateDialog$receivedOrganisationUnitNavigationMsg(navigationMsg);
		case 17:
			var measure = msg.a;
			return $author$project$Measure$CreateDialog$gotMeasure(measure);
		default:
			var command = msg.a;
			return $author$project$Measure$CreateDialog$gotMeasureCommand(command);
	}
};
var $author$project$Measure$Page$gotMeasureCreateDialogMsg = F4(
	function (dialogMsg, environment, repository, _v0) {
		var model = _v0;
		var result = A4($author$project$Measure$CreateDialog$update, dialogMsg, environment, repository, model.dV);
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Measure$Page$GotMeasureCreateDialogMsg, result.ab),
			ac: result.ac,
			ak: _Utils_update(
				model,
				{dV: result.jn}),
			ae: result.ae
		};
	});
var $author$project$Measure$Page$receivedNowTimestamp = F4(
	function (now, environment, repository, _v0) {
		var page = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$setSeeAll, false, environment),
			ak: _Utils_update(
				page,
				{fK: now}),
			ae: repository
		};
	});
var $author$project$Measure$Page$scrollEvent = F4(
	function (scrollInfo, environment, repository, page) {
		var model = page;
		var measureCount = $elm$core$List$length(
			$author$project$Measure$Dict$values(
				$author$project$Environments$Repository$measures(repository)));
		return (((scrollInfo.kM - scrollInfo.kN) <= 200) && (_Utils_cmp(model.bF, measureCount) < 0)) ? {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{bF: model.bF + 100}),
			ae: repository
		} : {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
	});
var $author$project$Measure$Id$from = $elm$core$Basics$identity;
var $author$project$Measure$CreateDialog$GotCurrentPosix = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$ImagesEditor$default = A3($author$project$UI$ImagesEditor$Editor, _List_Nil, false, $elm$core$Maybe$Nothing);
var $author$project$Measure$CreateDialog$show = function (data) {
	return _Utils_Tuple2(
		$author$project$Measure$CreateDialog$Visible(
			{
				aQ: $author$project$UI$BasicDataEditor$default,
				jd: data.jd,
				b0: 0,
				dy: $elm$core$Maybe$Nothing,
				bl: $author$project$Measure$CreateDialog$NoDeadline,
				cQ: $author$project$UI$DateInput$collapsed,
				cf: '',
				cY: $author$project$UI$ImagesEditor$default,
				h5: data.h5,
				h6: data.h6,
				cj: '',
				fK: $elm$time$Time$millisToPosix(0),
				km: data.km,
				d3: $author$project$UI$OrganisationUnitNavigation$hidden,
				bb: $author$project$User$Ids$empty
			}),
		A2($elm$core$Task$perform, $author$project$Measure$CreateDialog$GotCurrentPosix, $elm$time$Time$now));
};
var $author$project$Measure$Page$userClickedCreateTask = F3(
	function (environment, repository, _v0) {
		var page = _v0;
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Measure$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var measureId = _v1.a;
		var newEnvironment = _v1.b;
		var _v2 = function () {
			var _v3 = $author$project$Auth$Session$maybeUserId(
				$author$project$Environments$Environment$session(environment));
			if (!_v3.$) {
				var userId = _v3.a;
				return $author$project$Measure$CreateDialog$show(
					{
						jd: userId,
						h5: measureId,
						h6: $author$project$Measure$MeasureType$Task,
						km: $author$project$Environments$Environment$getCurrentOrganisationUnit(environment)
					});
			} else {
				return _Utils_Tuple2(page.dV, $elm$core$Platform$Cmd$none);
			}
		}();
		var measureCreateDialog = _v2.a;
		var createDialogCmd = _v2.b;
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Measure$Page$GotMeasureCreateDialogMsg, createDialogCmd),
			ac: newEnvironment,
			ak: _Utils_update(
				page,
				{dV: measureCreateDialog}),
			ae: repository
		};
	});
var $author$project$Measure$EditDialog$EditMeasure = 0;
var $author$project$Measure$Page$userClickedEditIcon = F4(
	function (measure, environment, repository, _v0) {
		var page = _v0;
		var _v1 = A4($author$project$Measure$EditDialog$show, environment, repository, 0, measure);
		var editDialog = _v1.a;
		var editDialogMsg = _v1.b;
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Measure$Page$GotEditDialogMsg, editDialogMsg),
			ac: environment,
			ak: _Utils_update(
				page,
				{cO: editDialog}),
			ae: repository
		};
	});
var $author$project$Measure$Page$userClickedLoadMore = F3(
	function (environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{bF: model.bF + 100}),
			ae: repository
		};
	});
var $author$project$Measure$Page$userDeselectedSeeAll = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$setSeeAll, false, environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$Measure$Page$userSelectedSeeAll = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$setSeeAll, true, environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$Measure$Page$update = function (msg) {
	switch (msg.$) {
		case 0:
			var measure = msg.a;
			return $author$project$Measure$Page$userClickedEditIcon(measure);
		case 1:
			var dialogMsg = msg.a;
			return $author$project$Measure$Page$gotEditDialogMsg(dialogMsg);
		case 2:
			return $author$project$Measure$Page$userClickedCreateTask;
		case 3:
			var dialogMsg = msg.a;
			return $author$project$Measure$Page$gotMeasureCreateDialogMsg(dialogMsg);
		case 4:
			return $author$project$Measure$Page$userSelectedSeeAll;
		case 5:
			return $author$project$Measure$Page$userDeselectedSeeAll;
		case 6:
			var string = msg.a;
			return $author$project$Measure$Page$enteredSearchString(string);
		case 7:
			var now = msg.a;
			return $author$project$Measure$Page$receivedNowTimestamp(now);
		case 8:
			var scrollInfo = msg.a;
			return $author$project$Measure$Page$scrollEvent(scrollInfo);
		default:
			return $author$project$Measure$Page$userClickedLoadMore;
	}
};
var $author$project$Translations$Measures$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.header');
};
var $author$project$Measure$Page$UserClickedCreateTask = {$: 2};
var $author$project$Auth$Authorization$authorize_Maybe = F3(
	function (userRights, right, maybeOrganisationUnit) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Auth$Authorization$authorizeSetting, userRights, 3),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Auth$Authorization$authorize, userRights, right),
				maybeOrganisationUnit));
	});
var $author$project$Measure$Page$appendAddIcon = F2(
	function (environment, config) {
		return A3(
			$author$project$Auth$Authorization$authorize_Maybe,
			$author$project$Environments$Environment$userRights(environment),
			4,
			$author$project$Environments$Environment$getCurrentOrganisationUnit(environment)) ? A2(
			$author$project$UI$Bar$withRightIcon,
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Measure$Page$UserClickedCreateTask,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
			config) : config;
	});
var $author$project$Measure$Page$viewBar = F5(
	function (translations, environment, repository, searchValue, takeValue) {
		var organisationUnits = $author$project$Environments$Repository$organisationUnits(repository);
		var measures = A4(
			$author$project$Measure$Measure$filter,
			environment,
			searchValue,
			organisationUnits,
			$author$project$Measure$Dict$values(
				$author$project$Environments$Repository$measures(repository)));
		var editedTakeValue = (($elm$core$List$length(measures) - takeValue) < 25) ? $elm$core$List$length(measures) : takeValue;
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(1)),
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
					A2(
						$author$project$UI$Bar$withStyle,
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
						A2(
							$author$project$Measure$Page$appendAddIcon,
							environment,
							$author$project$UI$Bar$bar(
								A3(
									$author$project$Translations$Misc$overviewBar,
									translations,
									$elm$core$String$fromInt(editedTakeValue),
									$elm$core$String$fromInt(
										$elm$core$List$length(measures)))))))));
	});
var $author$project$Measure$Page$viewEditDialog = F2(
	function (environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Measure$EditDialog$view, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Measure$Page$GotEditDialogMsg));
	});
var $author$project$Measure$Page$EnteredSearchString = function (a) {
	return {$: 6, a: a};
};
var $author$project$Measure$Page$viewSearch = F2(
	function (translations, searchValue) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withStyle,
				$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(50)),
				A2(
					$author$project$UI$TextInput$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3)),
					A2(
						$author$project$UI$TextInput$withOnInput,
						$author$project$Measure$Page$EnteredSearchString,
						A2(
							$author$project$UI$TextInput$withPlaceholder,
							$author$project$Translations$FuzzySearch$search(translations),
							A2($author$project$UI$TextInput$withValue, searchValue, $author$project$UI$TextInput$singleLine))))));
	});
var $author$project$Measure$Page$UserDeselectedSeeAll = {$: 5};
var $author$project$Measure$Page$UserSelectedSeeAll = {$: 4};
var $author$project$Measure$Page$viewSeeAllOption = function (environment) {
	var _v0 = $author$project$Environments$Environment$getSeeAll(environment) ? _Utils_Tuple2(
		$author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3)),
				A2(
					$author$project$UI$Icon$withForegroundColor,
					$author$project$UI$Style$Theme$green,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$eyeCircle)))),
		$author$project$Measure$Page$UserDeselectedSeeAll) : _Utils_Tuple2(
		$author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3)),
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$eyeCircle))),
		$author$project$Measure$Page$UserSelectedSeeAll);
	var icon = _v0.a;
	var msg = _v0.b;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(0.2))
					])),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
			]),
		_List_fromArray(
			[
				icon,
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$rem(0.6)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$Settings$seeAll(
							$author$project$Environments$Environment$translations(environment)))
					]))
			]));
};
var $author$project$Measure$Page$viewHeader = F3(
	function (translations, environment, searchValue) {
		var seeAllOption = function () {
			var _v0 = $author$project$Environments$Environment$getCurrentOrganisationUnit(environment);
			if (_v0.$ === 1) {
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				return $author$project$Measure$Page$viewSeeAllOption(environment);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Measure$Page$viewSearch, translations, searchValue),
					seeAllOption
				]));
	});
var $author$project$Measure$CreateDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Measure$CreateDialog$UserClickedCloseDialog = {$: 1};
var $author$project$Translations$Measures$createDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.createDialogHeader');
};
var $author$project$Measure$CreateDialog$UserClickedCancelButton = {$: 4};
var $author$project$Measure$CreateDialog$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Measure$CreateDialog$UserClickedCancelButton,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$Measure$CreateDialog$UserClickedCreateButton = {$: 5};
var $author$project$Translations$Buttons$create = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'buttons.create');
};
var $author$project$Measure$CreateDialog$viewCreateButton = F2(
	function (translations, disable) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disable,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Measure$CreateDialog$UserClickedCreateButton,
					$author$project$UI$Button$green(
						$author$project$Translations$Buttons$create(translations)))));
	});
var $author$project$Measure$CreateDialog$UserClickedNextButton = {$: 2};
var $author$project$Measure$CreateDialog$viewNextButton = F2(
	function (translations, disable) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disable,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Measure$CreateDialog$UserClickedNextButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$next(translations)))));
	});
var $author$project$Measure$CreateDialog$viewRightButton = F3(
	function (translations, disableRightBtn, currentStep) {
		return (currentStep === 2) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Measure$CreateDialog$viewCreateButton, translations, disableRightBtn)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Measure$CreateDialog$viewNextButton, translations, disableRightBtn)
				]));
	});
var $author$project$UI$Icons$cameraCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63.001 32.001c0 17.122-13.879 31-31.001 31-17.121 0-31-13.878-31-31 0-17.121 13.879-31 31-31 17.122 0 31.001 13.879 31.001 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M46.672 20.053h-6.97c-.795 0-1.445.65-1.445 1.444 0 .795.65 1.444 1.444 1.444h6.971c1.123 0 2.037.916 2.037 2.038V41.85a2.264 2.264 0 01-2.26 2.262H17.551a2.264 2.264 0 01-2.261-2.262V24.98c0-1.123.914-2.039 2.037-2.039h6.971c.674 0 1.251-.465 1.404-1.115l.321-1.387a3.287 3.287 0 013.217-2.55h5.527c.794 0 1.444-.65 1.444-1.445 0-.794-.65-1.444-1.444-1.444h-5.527a6.155 6.155 0 00-6.024 4.78l-.065.273h-5.824a4.927 4.927 0 00-4.926 4.926V41.85c0 2.838 2.31 5.15 5.15 5.15h28.896c2.84 0 5.15-2.312 5.15-5.15V24.98a4.927 4.927 0 00-4.926-4.927')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M39.075 31.261c-.794 0-1.443.65-1.443 1.444A5.638 5.638 0 0132 38.335a5.637 5.637 0 01-5.63-5.63A5.632 5.632 0 0132 27.08c.794 0 1.443-.648 1.443-1.442 0-.795-.649-1.446-1.443-1.446-4.693 0-8.52 3.821-8.52 8.52 0 4.701 3.827 8.511 8.52 8.511 4.692 0 8.52-3.819 8.52-8.518 0-.794-.65-1.444-1.445-1.444')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$Icons$tagCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63.001 32.001c0 17.122-13.879 31-31.001 31-17.121 0-31-13.878-31-31 0-17.121 13.879-31 31-31 17.122 0 31.001 13.879 31.001 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M50.712 13.285c-1.252-1.254-2.98-1.981-4.864-2.048-1.79-.07-3.621.433-5.279 1.451-.737.45-.966 1.409-.518 2.137.45.734 1.408.966 2.131.516 2.258-1.383 4.859-1.322 6.327.147.866.864 1.262 2.117 1.116 3.526-.157 1.529-.906 3.033-2.12 4.243-1.21 1.21-2.72 1.96-4.242 2.117-1.409.139-2.661-.26-3.525-1.116-.563-.562-1.305-.863-2.091-.863-.796 0-1.539.312-2.1.863-.563.563-.867 1.306-.867 2.102 0 .795.312 1.537.875 2.099.562.561 1.305.865 2.092.865.793 0 1.538-.314 2.1-.865.121-.122.232-.251.328-.39.821.295 1.703.451 2.638.451.284 0 .579-.016.87-.043.027 0 .051-.01.08-.01l.268 3.881c.059.883-.268 1.746-.892 2.377L28.545 49.203c-.813.812-2.142.812-2.954 0L14.794 38.407c-.397-.395-.612-.926-.612-1.477 0-.561.215-1.081.612-1.477l14.49-14.484c.621-.624 1.484-.95 2.366-.891l12.865.857c.86.059 1.604-.589 1.66-1.452.065-.857-.586-1.598-1.45-1.66l-12.868-.854c-1.769-.122-3.516.536-4.77 1.796L12.6 33.247c-.985.987-1.521 2.29-1.521 3.683 0 1.392.545 2.693 1.521 3.681l10.787 10.786c1.011 1.01 2.349 1.52 3.679 1.52 1.33 0 2.664-.51 3.682-1.52l14.484-14.485c1.262-1.262 1.92-3.006 1.798-4.787l-.308-4.546c1.09-.521 2.1-1.236 2.997-2.128 1.712-1.711 2.782-3.888 3.009-6.128.232-2.355-.485-4.498-2.016-6.038z')
						]),
					_List_Nil)
				]));
	});
var $author$project$Measure$CreateDialog$UserClickedStepIcon = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Css$Addition = 0;
var $rtfeldman$elm_css$Css$plus = 0;
var $author$project$UI$Icon$withBackgroundColor = F2(
	function (color, config) {
		if (!config.$) {
			return config;
		} else {
			var options = config.a;
			return $author$project$UI$Icon$Bicolor(
				_Utils_update(
					options,
					{go: color}));
		}
	});
var $author$project$Measure$CreateDialog$viewStepIcon = F3(
	function (icon, step, currentStep) {
		var _v0 = _Utils_eq(step, currentStep) ? _Utils_Tuple2($author$project$UI$Style$Theme$white, $author$project$UI$Style$Theme$darkGrey) : _Utils_Tuple2($author$project$UI$Style$Theme$darkGrey, $author$project$UI$Style$Theme$lightGrey);
		var foregroundColor_ = _v0.a;
		var backgroundColor_ = _v0.b;
		return $author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Measure$CreateDialog$UserClickedStepIcon(step),
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(1)),
					A2(
						$author$project$UI$Icon$withBackgroundColor,
						backgroundColor_,
						A2(
							$author$project$UI$Icon$withForegroundColor,
							foregroundColor_,
							A2(
								$author$project$UI$Icon$withStyle,
								$rtfeldman$elm_css$Css$height(
									A3(
										$rtfeldman$elm_css$Css$calc,
										$rtfeldman$elm_css$Css$rem(2.5),
										$rtfeldman$elm_css$Css$plus,
										$rtfeldman$elm_css$Css$px(2))),
								A2(
									$author$project$UI$Icon$withStyle,
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									$author$project$UI$Icon$bicolor(icon))))))));
	});
var $author$project$Measure$CreateDialog$viewStepLine = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$pct(50)),
					$rtfeldman$elm_css$Css$right(
					$rtfeldman$elm_css$Css$rem(1)),
					$rtfeldman$elm_css$Css$left(
					$rtfeldman$elm_css$Css$rem(1)),
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
				]))
		]),
	_List_Nil);
var $author$project$Measure$CreateDialog$viewSteps = function (currentStep) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Measure$CreateDialog$viewStepLine,
				A3($author$project$Measure$CreateDialog$viewStepIcon, $author$project$UI$Icons$tagCircleBicolor, 0, currentStep),
				A3($author$project$Measure$CreateDialog$viewStepIcon, $author$project$UI$Icons$cameraCircleBicolor, 1, currentStep),
				A3($author$project$Measure$CreateDialog$viewStepIcon, $author$project$UI$Icons$userCircleBicolor, 2, currentStep)
			]));
};
var $author$project$Measure$CreateDialog$viewFooter = F3(
	function (translations, disableRightBtn, currentStep) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto 1fr'),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Measure$CreateDialog$viewCancelButton(translations),
					$author$project$Measure$CreateDialog$viewSteps(currentStep),
					A3($author$project$Measure$CreateDialog$viewRightButton, translations, disableRightBtn, currentStep)
				]));
	});
var $author$project$Measure$CreateDialog$UserEnteredDateText = function (a) {
	return {$: 11, a: a};
};
var $author$project$Measure$CreateDialog$UserChangedEndDateInput = function (a) {
	return {$: 10, a: a};
};
var $author$project$Measure$CreateDialog$UserDeletedDeadline = {$: 14};
var $author$project$Measure$CreateDialog$viewDeadlineDate = F4(
	function (translations, naiveDate, endDateInput, dateTextInput) {
		var defaultYear = $author$project$Date_Time$NaiveDate$year(naiveDate);
		var defaultMonth = $author$project$Date_Time$NaiveDate$month(naiveDate);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					A5(
					$author$project$UI$DateInput$view,
					translations,
					endDateInput,
					$elm$core$Maybe$Just(naiveDate),
					dateTextInput,
					A2(
						$author$project$UI$DateInput$withOnTextInput,
						$author$project$Measure$CreateDialog$UserEnteredDateText,
						A2(
							$author$project$UI$DateInput$withStyle,
							$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$rem(0.8)),
							A2(
								$author$project$UI$DateInput$withStyle,
								$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(1)),
								A2(
									$author$project$UI$DateInput$withStyle,
									$rtfeldman$elm_css$Css$flexGrow(
										$rtfeldman$elm_css$Css$int(1)),
									A3($author$project$UI$DateInput$dateInput, defaultYear, defaultMonth, $author$project$Measure$CreateDialog$UserChangedEndDateInput)))))),
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(4)),
						A2(
							$author$project$UI$Icon$withForegroundColor,
							$author$project$UI$Style$Theme$red,
							A2(
								$author$project$UI$Icon$withOnClick,
								$author$project$Measure$CreateDialog$UserDeletedDeadline,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete)))))
				]));
	});
var $author$project$Measure$CreateDialog$EnteredHour = function (a) {
	return {$: 12, a: a};
};
var $author$project$Measure$CreateDialog$EnteredMinute = function (a) {
	return {$: 13, a: a};
};
var $author$project$Measure$CreateDialog$viewDeadlineTime = F2(
	function (hourInput, minuteInput) {
		return A4(
			$author$project$UI$TimeInput$view,
			false,
			hourInput,
			minuteInput,
			A2($author$project$UI$TimeInput$timeInput, $author$project$Measure$CreateDialog$EnteredHour, $author$project$Measure$CreateDialog$EnteredMinute));
	});
var $author$project$Measure$CreateDialog$viewInfoValue = F2(
	function (maybeMsg, value) {
		var additionalAttr = function () {
			if (!maybeMsg.$) {
				var msg = maybeMsg.a;
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$rem(1.2)),
								$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
								$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
								$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				additionalAttr),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(value)
				]));
	});
var $author$project$Measure$CreateDialog$viewDeadlineValue = F2(
	function (translations, model) {
		var _v0 = model.bl;
		if (!_v0.$) {
			var _default = $author$project$Date_Time$NaiveDate$toStringDMY(
				A2($author$project$Date_Time$NaiveDate$fromPosix, $elm$time$Time$utc, model.fK));
			return A2(
				$author$project$Measure$CreateDialog$viewInfoValue,
				$elm$core$Maybe$Just(
					$author$project$Measure$CreateDialog$UserEnteredDateText(_default)),
				$author$project$Translations$Measures$Info$noDeadlineTimestamp(translations));
		} else {
			var naiveDate = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1)),
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
							]))
					]),
				_List_fromArray(
					[
						A4($author$project$Measure$CreateDialog$viewDeadlineDate, translations, naiveDate, model.cQ, model.dy),
						A2($author$project$Measure$CreateDialog$viewDeadlineTime, model.cf, model.cj)
					]));
		}
	});
var $author$project$Measure$CreateDialog$viewInfoIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$UI$Icon$unicolor,
	A2(
		$elm$core$Basics$composeR,
		$author$project$UI$Icon$withStyle(
			$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$rem(3))),
		$author$project$UI$Icon$view));
var $author$project$Measure$CreateDialog$viewInfoLabel = function (label) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h5,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
						$rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(1))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(label)
			]));
};
var $author$project$Measure$CreateDialog$viewDeadlineTimestamp = F2(
	function (translations, model) {
		return _List_fromArray(
			[
				$author$project$Measure$CreateDialog$viewInfoIcon($author$project$UI$Icons$info),
				$author$project$Measure$CreateDialog$viewInfoLabel(
				$author$project$Translations$Measures$Info$deadlineTimestamp(translations)),
				A2($author$project$Measure$CreateDialog$viewDeadlineValue, translations, model)
			]);
	});
var $author$project$Measure$CreateDialog$UserClickedOrganisationUnit = {$: 15};
var $author$project$Translations$Measures$noOrganisationUnit = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.noOrganisationUnit');
};
var $author$project$Measure$CreateDialog$viewInfoOrganisationUnit = F3(
	function (translations, repository, maybeOrganisationUnitId) {
		var value = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Translations$Measures$noOrganisationUnit(translations),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.k8;
				},
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						function (organisationUnitId) {
							return A2($author$project$Environments$Repository$getOrganisationUnit, organisationUnitId, repository);
						},
						maybeOrganisationUnitId))));
		var organisationUnitLabel = $author$project$Translations$Measures$Info$organisationUnit(translations) + '*';
		return _List_fromArray(
			[
				$author$project$Measure$CreateDialog$viewInfoIcon($author$project$UI$Icons$factory),
				$author$project$Measure$CreateDialog$viewInfoLabel(organisationUnitLabel),
				A2(
				$author$project$Measure$CreateDialog$viewInfoValue,
				$elm$core$Maybe$Just($author$project$Measure$CreateDialog$UserClickedOrganisationUnit),
				value)
			]);
	});
var $author$project$Measure$CreateDialog$viewOrganisationUnitAndDeadline = F3(
	function (translations, repository, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '3rem auto auto'),
							A2($rtfeldman$elm_css$Css$property, 'grid-row-gap', '1rem'),
							A2($rtfeldman$elm_css$Css$property, 'align-items', 'center'),
							A2($rtfeldman$elm_css$Css$property, 'justify-items', 'start')
						]))
				]),
			_Utils_ap(
				A3($author$project$Measure$CreateDialog$viewInfoOrganisationUnit, translations, repository, model.km),
				A2($author$project$Measure$CreateDialog$viewDeadlineTimestamp, translations, model)));
	});
var $author$project$Measure$CreateDialog$ReceivedOrganisationUnitNavigationMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Measure$CreateDialog$viewOrganisationUnitNavigation = F3(
	function (environment, repository, organisationUnitNavigation) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$Measure$CreateDialog$ReceivedOrganisationUnitNavigationMsg,
			A3(
				$author$project$UI$OrganisationUnitNavigation$view,
				$author$project$Environments$Repository$organisationUnits(repository),
				organisationUnitNavigation,
				environment));
	});
var $author$project$Measure$CreateDialog$viewBasicDataStep = F4(
	function (environment, repository, disableRightBtn, model) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendFooter,
				A3($author$project$Measure$CreateDialog$viewFooter, translations, disableRightBtn, 0),
				A2(
					$author$project$UI$Dialog$appendContent,
					A3($author$project$Measure$CreateDialog$viewOrganisationUnitNavigation, environment, repository, model.d3),
					A2(
						$author$project$UI$Dialog$appendContent,
						A3($author$project$Measure$CreateDialog$viewOrganisationUnitAndDeadline, translations, repository, model),
						A2(
							$author$project$UI$Dialog$appendContent,
							A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Measure$CreateDialog$GotBasicDataEditorMsg,
								A2($author$project$UI$BasicDataEditor$viewForm, translations, model.aQ)),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$UI$BasicDataEditor$viewBar(translations),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Measures$createDialogHeader(translations),
										$author$project$Measure$CreateDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Measure$CreateDialog$viewImagesStep = F3(
	function (translations, disableRightBtn, imageEditor) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendFooter,
				A3($author$project$Measure$CreateDialog$viewFooter, translations, disableRightBtn, 1),
				A2(
					$author$project$UI$Dialog$appendContent,
					A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$Measure$CreateDialog$GotImageEditorMsg,
						$author$project$UI$ImagesEditor$viewGallery(imageEditor)),
					A2(
						$author$project$UI$Dialog$appendHeader,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Measure$CreateDialog$GotImageEditorMsg,
							A2($author$project$UI$ImagesEditor$viewBar, translations, imageEditor)),
						A2(
							$author$project$UI$Dialog$withIcon,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
							A2(
								$author$project$UI$Dialog$dialog,
								$author$project$Translations$Measures$createDialogHeader(translations),
								$author$project$Measure$CreateDialog$UserClickedCloseDialog))))));
	});
var $author$project$Measure$CreateDialog$UserSelectedUser = function (a) {
	return {$: 8, a: a};
};
var $author$project$Measure$CreateDialog$UserUnselectedUser = function (a) {
	return {$: 9, a: a};
};
var $author$project$Measure$CreateDialog$viewResponsibleUsersTable = $author$project$Measure$ResponsibleUsersEditor$viewTable(
	{jo: false, kf: $author$project$Measure$CreateDialog$UserSelectedUser, kg: $author$project$Measure$CreateDialog$UserUnselectedUser});
var $author$project$Measure$CreateDialog$viewResponsibleUsersStep = F4(
	function (environment, disableRightBtn, responsibleUsers, availableUsers) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendFooter,
				A3($author$project$Measure$CreateDialog$viewFooter, translations, disableRightBtn, 2),
				A2(
					$author$project$UI$Dialog$appendContent,
					A3($author$project$Measure$CreateDialog$viewResponsibleUsersTable, environment, responsibleUsers, availableUsers),
					A2(
						$author$project$UI$Dialog$appendHeader,
						$author$project$Measure$ResponsibleUsersEditor$viewBar(translations),
						A2(
							$author$project$UI$Dialog$withIcon,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
							A2(
								$author$project$UI$Dialog$dialog,
								$author$project$Translations$Measures$createDialogHeader(translations),
								$author$project$Measure$CreateDialog$UserClickedCloseDialog))))));
	});
var $author$project$Measure$CreateDialog$viewDialog = F3(
	function (environment, repository, model) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var disableRightBtn = $author$project$Utils$Maybe$isNothing(model.km) || $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(model.aQ));
		var _v0 = model.b0;
		switch (_v0) {
			case 0:
				return A4($author$project$Measure$CreateDialog$viewBasicDataStep, environment, repository, disableRightBtn, model);
			case 1:
				return A3($author$project$Measure$CreateDialog$viewImagesStep, translations, disableRightBtn, model.cY);
			default:
				return A4(
					$author$project$Measure$CreateDialog$viewResponsibleUsersStep,
					environment,
					disableRightBtn,
					model.bb,
					$author$project$Environments$Repository$users(repository));
		}
	});
var $author$project$Measure$CreateDialog$view = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Measure$CreateDialog$viewDialog, environment, repository, model);
			default:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Measure$CreateDialog$viewDialog, environment, repository, model);
		}
	});
var $author$project$Measure$Page$viewMeasureCreateDialog = F2(
	function (environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Measure$CreateDialog$view, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Measure$Page$GotMeasureCreateDialogMsg));
	});
var $author$project$Measure$Page$ScrollEvent = function (a) {
	return {$: 8, a: a};
};
var $author$project$Translations$Measures$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'measures.emptyText');
};
var $author$project$Measure$Page$UserClickedLoadMore = {$: 9};
var $author$project$Translations$Measures$loadMore = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'measures.loadMore',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Measure$Page$viewLastElement = F4(
	function (translations, environment, takeValue, measures) {
		var _v0 = $author$project$Environments$Environment$platform(environment);
		if (!_v0.$) {
			return _List_Nil;
		} else {
			if (_Utils_cmp(
				takeValue,
				$elm$core$List$length(measures)) > -1) {
				return _List_Nil;
			} else {
				var text = (($elm$core$List$length(measures) - takeValue) > 125) ? '100' : $elm$core$String$fromInt(
					$elm$core$List$length(measures) - takeValue);
				return _List_fromArray(
					[
						$author$project$UI$Button$view(
						A2(
							$author$project$UI$Button$withOnClick,
							$author$project$Measure$Page$UserClickedLoadMore,
							$author$project$UI$Button$darkGrey(
								A2($author$project$Translations$Measures$loadMore, translations, text))))
					]);
			}
		}
	});
var $author$project$Measure$Page$UserClickedEditIcon = function (a) {
	return {$: 0, a: a};
};
var $author$project$Measure$Page$viewRightIcon = F2(
	function (environment, measure) {
		return (A3(
			$author$project$Auth$Authorization$authorize,
			$author$project$Environments$Environment$userRights(environment),
			5,
			measure.km) || A3(
			$author$project$Auth$Authorization$authorize,
			$author$project$Environments$Environment$userRights(environment),
			6,
			measure.km)) ? $author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle) : $author$project$UI$Icon$unicolor($author$project$UI$Icons$info);
	});
var $author$project$Measure$Page$viewRow = F3(
	function (environment, now, measure) {
		var timeZone = $author$project$Environments$Environment$timeZone(environment);
		var subLabel = function () {
			var _v1 = measure.hI;
			if (!_v1.$) {
				var deadlineTimestamp = _v1.a;
				var deadlineTime = $author$project$Date_Time$NaiveTime$format(
					A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, deadlineTimestamp));
				var deadlineDate = $author$project$Date_Time$NaiveDate$format(
					A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, deadlineTimestamp));
				return $elm$core$String$isEmpty(measure.aY) ? (deadlineDate + (' ' + (deadlineTime + ' Uhr'))) : (deadlineDate + (' ' + (deadlineTime + (' Uhr | ' + measure.aY))));
			} else {
				return measure.aY;
			}
		}();
		var beamColor = function () {
			var _v0 = measure.hI;
			if (!_v0.$) {
				var deadlineTimestamp = _v0.a;
				return (_Utils_cmp(
					$elm$time$Time$posixToMillis(deadlineTimestamp),
					$elm$time$Time$posixToMillis(now)) < 0) ? $author$project$UI$Style$Theme$lightRed : (_Utils_eq(
					A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, deadlineTimestamp),
					A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, now)) ? $author$project$UI$Style$Theme$yellow : $author$project$UI$Style$Theme$green);
			} else {
				return $author$project$UI$Style$Theme$grey;
			}
		}();
		return A2(
			$author$project$UI$Table$Row$withRightIcon,
			A2($author$project$Measure$Page$viewRightIcon, environment, measure),
			A2(
				$author$project$UI$Table$Row$withBeamColor,
				beamColor,
				A2(
					$author$project$UI$Table$Row$withOnClick,
					$author$project$Measure$Page$UserClickedEditIcon(measure),
					A2(
						$author$project$UI$Table$Row$withSubLabel,
						subLabel,
						A2(
							$author$project$UI$Table$Row$withId,
							measure.fw,
							A3(
								$author$project$UI$Table$Row$row,
								$author$project$Environments$Environment$getViewType(environment),
								measure.k8,
								measure))))));
	});
var $author$project$UI$Table$withAttributeMsg = F2(
	function (attributeMsg, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{fc: attributeMsg});
	});
var $author$project$Measure$Page$viewTable = F6(
	function (translations, environment, repository, searchValue, now, takeValue) {
		var organisationUnits = $author$project$Environments$Repository$organisationUnits(repository);
		var audits = A4(
			$author$project$Measure$Measure$filter,
			environment,
			searchValue,
			organisationUnits,
			$author$project$Measure$Dict$values(
				$author$project$Environments$Repository$measures(repository)));
		var editedTakeValue = (($elm$core$List$length(audits) - takeValue) < 25) ? $elm$core$List$length(audits) : takeValue;
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$appendLastElement,
				A4($author$project$Measure$Page$viewLastElement, translations, environment, editedTakeValue, audits),
				A2(
					$author$project$UI$Table$withAttributeMsg,
					$author$project$Utils$ScrollInfo$onScroll($author$project$Measure$Page$ScrollEvent),
					A2(
						$author$project$UI$Table$withEmptyText,
						$author$project$Translations$Measures$emptyText(
							$author$project$Environments$Environment$translations(environment)),
						A2(
							$author$project$UI$Table$fromList,
							A2($author$project$Measure$Page$viewRow, environment, now),
							A2(
								$elm$core$List$take,
								editedTakeValue,
								A2(
									$elm$core$List$sortBy,
									function (t) {
										return $elm$time$Time$posixToMillis(
											A2($elm$core$Maybe$withDefault, t.dw, t.hI));
									},
									A4(
										$author$project$Measure$Measure$filter,
										environment,
										searchValue,
										organisationUnits,
										A2(
											$elm$core$List$filter,
											function (measure) {
												return _Utils_eq(measure.jb, $author$project$Measure$CompletionStatus$Open);
											},
											$author$project$Measure$Dict$values(
												$author$project$Environments$Repository$measures(repository)))))))))));
	});
var $author$project$Measure$Page$view = F3(
	function (environment, repository, _v0) {
		var model = _v0;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				A3($author$project$Measure$Page$viewMeasureCreateDialog, environment, repository, model.dV),
				A2(
					$author$project$UI$Page$appendContent,
					A3($author$project$Measure$Page$viewEditDialog, environment, repository, model.cO),
					A2(
						$author$project$UI$Page$appendContent,
						A7($rtfeldman$elm_css$Html$Styled$Lazy$lazy6, $author$project$Measure$Page$viewTable, translations, environment, repository, model.aN, model.fK, model.bF),
						A2(
							$author$project$UI$Page$appendContent,
							A6($rtfeldman$elm_css$Html$Styled$Lazy$lazy5, $author$project$Measure$Page$viewBar, translations, environment, repository, model.aN, model.bF),
							A2(
								$author$project$UI$Page$appendHeader,
								A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Measure$Page$viewHeader, translations, environment, model.aN),
								A2(
									$author$project$UI$Page$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
									$author$project$UI$Page$page(
										$author$project$Translations$Measures$header(translations)))))))));
	});
var $author$project$Page$Page$measures = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 1) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotMeasurePageMsg,
		kZ: $elm$core$Maybe$Just($author$project$Measure$Page$subscriptions),
		le: $author$project$Measure$Page$update,
		lm: $author$project$Measure$Page$view
	});
var $author$project$Page$Page$GotOrganisationUnitPageMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$OrganisationUnit$Page$GotCreateDialogMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$Page$GotEditDialogMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$OrganisationUnit$Page$createDialog = function (_v0) {
	var page = _v0;
	return page.fi;
};
var $author$project$OrganisationUnit$Page$editDialog = function (_v0) {
	var page = _v0;
	return page.cO;
};
var $author$project$OrganisationUnit$CreateDialog$GotFloorPlanEditorMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$OrganisationUnit$FloorPlanEditor$GotImageEditorMsg = $elm$core$Basics$identity;
var $author$project$UI$ImageEditor$ReceivedUnknownMsg = {$: 6};
var $author$project$UI$ImageEditor$ImageSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$UI$ImageEditor$InvalidFileType = {$: 5};
var $author$project$UI$ImageEditor$PhotoTaken = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$ImageEditor$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'PHOTO_TAKEN':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$UI$ImageEditor$PhotoTaken,
					A2($elm$json$Json$Decode$field, 'filename', $author$project$File$Filename$decode));
			case 'IMAGE_SELECTED':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$UI$ImageEditor$ImageSelected,
					A2($elm$json$Json$Decode$field, 'filename', $author$project$File$Filename$decode));
			case 'INVALID_FILE_TYPE':
				return $elm$json$Json$Decode$succeed($author$project$UI$ImageEditor$InvalidFileType);
			default:
				return $elm$json$Json$Decode$succeed($author$project$UI$ImageEditor$ReceivedUnknownMsg);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$UI$ImageEditor$imageEditorInbox = _Platform_incomingPort('imageEditorInbox', $elm$json$Json$Decode$value);
var $author$project$UI$ImageEditor$subscriptions = $author$project$UI$ImageEditor$imageEditorInbox(
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$UI$ImageEditor$decodeMsg),
		$elm$core$Result$withDefault($author$project$UI$ImageEditor$ReceivedUnknownMsg)));
var $author$project$OrganisationUnit$FloorPlanEditor$subscriptions = A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$UI$ImageEditor$subscriptions);
var $author$project$OrganisationUnit$CreateDialog$subscriptions = function (dialog) {
	if (dialog.$ === 1) {
		return A2($elm$core$Platform$Sub$map, $author$project$OrganisationUnit$CreateDialog$GotFloorPlanEditorMsg, $author$project$OrganisationUnit$FloorPlanEditor$subscriptions);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$OrganisationUnit$EditDialog$GotFloorPlanEditorMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$OrganisationUnit$EditDialog$subscriptions = function (dialog) {
	if (dialog.$ === 1) {
		return A2($elm$core$Platform$Sub$map, $author$project$OrganisationUnit$EditDialog$GotFloorPlanEditorMsg, $author$project$OrganisationUnit$FloorPlanEditor$subscriptions);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$OrganisationUnit$Page$subscriptions = function (page) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$OrganisationUnit$Page$GotCreateDialogMsg,
				$author$project$OrganisationUnit$CreateDialog$subscriptions(
					$author$project$OrganisationUnit$Page$createDialog(page))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$OrganisationUnit$Page$GotEditDialogMsg,
				$author$project$OrganisationUnit$EditDialog$subscriptions(
					$author$project$OrganisationUnit$Page$editDialog(page)))
			]));
};
var $author$project$OrganisationUnit$Page$withDuplicateModal = F2(
	function (duplicateModal, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{gB: duplicateModal});
	});
var $author$project$OrganisationUnit$Page$closeDuplicateOrganisationUnitModal = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2($author$project$OrganisationUnit$Page$withDuplicateModal, $author$project$OrganisationUnit$Page$Hidden, page),
			ae: repository
		};
	});
var $author$project$Environments$ErrorHandling$ToString$checkpointDataErrorToString = function (err) {
	switch (err.$) {
		case 0:
			var id = err.a;
			return 'CheckpointData.CommandHandler.CheckpointGroupDoesNotExist: ' + $author$project$CheckpointData$CheckpointGroup$Id$toString(id);
		case 1:
			var id = err.a;
			return 'CheckpointData.CommandHandler.CheckpointGroupAlreadyExists: ' + $author$project$CheckpointData$CheckpointGroup$Id$toString(id);
		case 2:
			var id = err.a;
			return 'CheckpointData.CommandHandler.CheckpointDoesNotExist: ' + $author$project$CheckpointData$Checkpoint$Id$toString(id);
		default:
			var id = err.a;
			return 'CheckpointData.CommandHandler.CheckpointAlreadyExists: ' + $author$project$CheckpointData$Checkpoint$Id$toString(id);
	}
};
var $author$project$CheckpointData$Commands$fromList = $author$project$Types$Queue$fromList;
var $author$project$CheckpointData$Commands$fold = $author$project$Types$Queue$fold;
var $author$project$CheckpointData$CommandHandler$CheckpointDoesNotExist = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Commands$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$CheckpointData$CommandHandler$handleChangeCheckpointDescriptionCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, acc.a);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			if (_Utils_eq(checkpoint.aY, payload.aY)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$CheckpointData$Event$CheckpointDescriptionChanged(
					{i5: payload.i5, L: payload.L, M: payload.M, aY: payload.aY, N: eventId, n: checkpoint.i + 1});
				var _v2 = A2(
					$author$project$CheckpointData$EventApplier$applyEventsHelper,
					$author$project$CheckpointData$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.a;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newCheckpointData = _v2.a;
				var newModification = _v2.b;
				var fileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						a: newCheckpointData,
						cD: A2(
							$author$project$CheckpointData$Commands$enqueue,
							$author$project$CheckpointData$Command$ChangeCheckpointDescription(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
						cb: fileOperations,
						g: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointDoesNotExist(payload.i5));
		}
	});
var $author$project$CheckpointData$CommandHandler$handleChangeCheckpointFilesCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, acc.a);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$CheckpointData$Event$CheckpointFilesChanged(
				{iM: payload.iM, i5: payload.i5, L: payload.L, M: payload.M, jk: payload.jk, N: eventId, n: checkpoint.i + 1});
			var _v2 = A2(
				$author$project$CheckpointData$EventApplier$applyEventsHelper,
				$author$project$CheckpointData$Events$singleton(event),
				A4(
					$author$project$Utils$Triple$with,
					function ($) {
						return $.a;
					},
					function ($) {
						return $.g;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newCheckpointData = _v2.a;
			var newModification = _v2.b;
			var fileOperations = _v2.c;
			return $elm$core$Result$Ok(
				{
					a: newCheckpointData,
					cD: A2(
						$author$project$CheckpointData$Commands$enqueue,
						$author$project$CheckpointData$Command$ChangeCheckpointFiles(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
					cb: fileOperations,
					g: newModification
				});
		} else {
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointDoesNotExist(payload.i5));
		}
	});
var $author$project$CheckpointData$CommandHandler$CheckpointGroupDoesNotExist = function (a) {
	return {$: 0, a: a};
};
var $author$project$CheckpointData$CommandHandler$handleChangeCheckpointGroupDescriptionCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, acc.a);
		if (!_v0.$) {
			var checkpointGroup = _v0.a;
			if (_Utils_eq(checkpointGroup.aY, payload.aY)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$CheckpointData$Event$CheckpointGroupDescriptionChanged(
					{cC: payload.cC, L: payload.L, M: payload.M, aY: payload.aY, N: eventId, n: checkpointGroup.i + 1});
				var _v2 = A2(
					$author$project$CheckpointData$EventApplier$applyEventsHelper,
					$author$project$CheckpointData$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.a;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newCheckpointData = _v2.a;
				var newModification = _v2.b;
				var fileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						a: newCheckpointData,
						cD: A2(
							$author$project$CheckpointData$Commands$enqueue,
							$author$project$CheckpointData$Command$ChangeCheckpointGroupDescription(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
						cb: fileOperations,
						g: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointGroupDoesNotExist(payload.cC));
		}
	});
var $author$project$CheckpointData$CommandHandler$handleChangeCheckpointGroupTitleCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, acc.a);
		if (!_v0.$) {
			var checkpointGroup = _v0.a;
			if (_Utils_eq(checkpointGroup.k8, payload.k8)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$CheckpointData$Event$CheckpointGroupTitleChanged(
					{cC: payload.cC, L: payload.L, M: payload.M, N: eventId, k8: payload.k8, n: checkpointGroup.i + 1});
				var _v2 = A2(
					$author$project$CheckpointData$EventApplier$applyEventsHelper,
					$author$project$CheckpointData$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.a;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newCheckpointData = _v2.a;
				var newModification = _v2.b;
				var fileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						a: newCheckpointData,
						cD: A2(
							$author$project$CheckpointData$Commands$enqueue,
							$author$project$CheckpointData$Command$ChangeCheckpointGroupTitle(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
						cb: fileOperations,
						g: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointGroupDoesNotExist(payload.cC));
		}
	});
var $author$project$CheckpointData$CommandHandler$handleChangeCheckpointTitleCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, acc.a);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			if (_Utils_eq(checkpoint.k8, payload.k8)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$CheckpointData$Event$CheckpointTitleChanged(
					{i5: payload.i5, L: payload.L, M: payload.M, N: eventId, k8: payload.k8, n: checkpoint.i + 1});
				var _v2 = A2(
					$author$project$CheckpointData$EventApplier$applyEventsHelper,
					$author$project$CheckpointData$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.a;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newCheckpointData = _v2.a;
				var newModification = _v2.b;
				var fileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						a: newCheckpointData,
						cD: A2(
							$author$project$CheckpointData$Commands$enqueue,
							$author$project$CheckpointData$Command$ChangeCheckpointTitle(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
						cb: fileOperations,
						g: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointDoesNotExist(payload.i5));
		}
	});
var $author$project$CheckpointData$CommandHandler$handleChangeCheckpointTypeCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, acc.a);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			if (_Utils_eq(checkpoint.fg, payload.fg)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$CheckpointData$Event$CheckpointTypeChanged(
					{i5: payload.i5, fg: payload.fg, L: payload.L, M: payload.M, N: eventId, n: checkpoint.i + 1});
				var _v2 = A2(
					$author$project$CheckpointData$EventApplier$applyEventsHelper,
					$author$project$CheckpointData$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.a;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newCheckpointData = _v2.a;
				var newModification = _v2.b;
				var fileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						a: newCheckpointData,
						cD: A2(
							$author$project$CheckpointData$Commands$enqueue,
							$author$project$CheckpointData$Command$ChangeCheckpointType(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
						cb: fileOperations,
						g: newModification
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointDoesNotExist(payload.i5));
		}
	});
var $author$project$CheckpointData$CommandHandler$CheckpointAlreadyExists = function (a) {
	return {$: 3, a: a};
};
var $author$project$CheckpointData$CommandHandler$handleCreateCheckpointCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, acc.a);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointAlreadyExists(checkpoint.i5));
		} else {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$CheckpointData$Event$CheckpointCreated(
				{cC: payload.cC, i5: payload.i5, fg: payload.fg, L: payload.L, M: payload.M, aY: payload.aY, N: eventId, cT: payload.cT, kc: payload.kc, kw: payload.kw, k8: payload.k8, n: 0});
			var _v2 = A2(
				$author$project$CheckpointData$EventApplier$applyEventsHelper,
				$author$project$CheckpointData$Events$singleton(event),
				A4(
					$author$project$Utils$Triple$with,
					function ($) {
						return $.a;
					},
					function ($) {
						return $.g;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newCheckpointData = _v2.a;
			var newModification = _v2.b;
			var fileOperations = _v2.c;
			return $elm$core$Result$Ok(
				{
					a: newCheckpointData,
					cD: A2(
						$author$project$CheckpointData$Commands$enqueue,
						$author$project$CheckpointData$Command$CreateCheckpoint(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
					cb: fileOperations,
					g: newModification
				});
		}
	});
var $author$project$CheckpointData$CommandHandler$CheckpointGroupAlreadyExists = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$CommandHandler$handleCreateCheckpointGroupCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, acc.a);
		if (!_v0.$) {
			var checkpointGroup = _v0.a;
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointGroupAlreadyExists(checkpointGroup.cC));
		} else {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$CheckpointData$Event$CheckpointGroupCreated(
				{cC: payload.cC, L: payload.L, M: payload.M, aY: payload.aY, N: eventId, jC: payload.jC, jT: payload.jT, kc: payload.kc, km: payload.km, kw: payload.kw, k8: payload.k8, n: 0});
			var _v2 = A2(
				$author$project$CheckpointData$EventApplier$applyEventsHelper,
				$author$project$CheckpointData$Events$singleton(event),
				A4(
					$author$project$Utils$Triple$with,
					function ($) {
						return $.a;
					},
					function ($) {
						return $.g;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newCheckpointData = _v2.a;
			var newModification = _v2.b;
			var fileOperations = _v2.c;
			return $elm$core$Result$Ok(
				{
					a: newCheckpointData,
					cD: A2(
						$author$project$CheckpointData$Commands$enqueue,
						$author$project$CheckpointData$Command$CreateCheckpointGroup(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
					cb: fileOperations,
					g: newModification
				});
		}
	});
var $author$project$CheckpointData$CommandHandler$handleDeleteCheckpointCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, acc.a);
		if (!_v0.$) {
			var checkpoint = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$CheckpointData$Event$CheckpointDeleted(
				{i5: payload.i5, L: payload.L, M: payload.M, N: eventId, n: checkpoint.i + 1});
			var _v2 = A2(
				$author$project$CheckpointData$EventApplier$applyEventsHelper,
				$author$project$CheckpointData$Events$singleton(event),
				A4(
					$author$project$Utils$Triple$with,
					function ($) {
						return $.a;
					},
					function ($) {
						return $.g;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newCheckpointData = _v2.a;
			var newModification = _v2.b;
			var fileOperations = _v2.c;
			return $elm$core$Result$Ok(
				{
					a: newCheckpointData,
					cD: A2(
						$author$project$CheckpointData$Commands$enqueue,
						$author$project$CheckpointData$Command$DeleteCheckpoint(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
					cb: fileOperations,
					g: newModification
				});
		} else {
			return $elm$core$Result$Ok(acc);
		}
	});
var $author$project$CheckpointData$CommandHandler$handleDeleteCheckpointGroupCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, acc.a);
		if (!_v0.$) {
			var checkpointGroup = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$CheckpointData$Event$CheckpointGroupDeleted(
				{cC: payload.cC, L: payload.L, M: payload.M, N: eventId, kc: payload.kc, km: payload.km, kw: payload.kw, n: checkpointGroup.i + 1});
			var _v2 = A2(
				$author$project$CheckpointData$EventApplier$applyEventsHelper,
				$author$project$CheckpointData$Events$singleton(event),
				A4(
					$author$project$Utils$Triple$with,
					function ($) {
						return $.a;
					},
					function ($) {
						return $.g;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newCheckpointData = _v2.a;
			var newModification = _v2.b;
			var fileOperations = _v2.c;
			return $elm$core$Result$Ok(
				{
					a: newCheckpointData,
					cD: A2(
						$author$project$CheckpointData$Commands$enqueue,
						$author$project$CheckpointData$Command$DeleteCheckpointGroup(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
					cb: fileOperations,
					g: newModification
				});
		} else {
			return $elm$core$Result$Ok(acc);
		}
	});
var $author$project$CheckpointData$CommandHandler$handleMoveCheckpointAfterCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple3(
			A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, acc.a),
			A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, acc.a),
			A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.ay, acc.a));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var checkpoint = _v0.a.a;
					var parent = _v0.b.a;
					var previous = _v0.c.a;
					var _v1 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(acc.ac));
					var eventId = _v1.a;
					var newEnvironment = _v1.b;
					var event = $author$project$CheckpointData$Event$MovedCheckpointAfter(
						{
							cC: parent.cC,
							i5: payload.i5,
							L: payload.L,
							M: payload.M,
							N: eventId,
							fJ: previous.kc,
							dZ: $elm$core$Maybe$Just(parent.cC),
							d_: payload.ay,
							c4: checkpoint.kc,
							g1: $elm$core$Maybe$Just(checkpoint.cC),
							c5: checkpoint.kw,
							n: checkpoint.i + 1
						});
					var _v2 = A2(
						$author$project$CheckpointData$EventApplier$applyEventsHelper,
						$author$project$CheckpointData$Events$singleton(event),
						A4(
							$author$project$Utils$Triple$with,
							function ($) {
								return $.a;
							},
							function ($) {
								return $.g;
							},
							function ($) {
								return $.cb;
							},
							acc));
					var newCheckpointData = _v2.a;
					var newModification = _v2.b;
					var fileOperations = _v2.c;
					return $elm$core$Result$Ok(
						{
							a: newCheckpointData,
							cD: A2(
								$author$project$CheckpointData$Commands$enqueue,
								$author$project$CheckpointData$Command$MoveCheckpointAfter(payload),
								acc.cD),
							ac: newEnvironment,
							b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
							cb: fileOperations,
							g: newModification
						});
				} else {
					var _v5 = _v0.c;
					return $elm$core$Result$Err(
						$author$project$CheckpointData$CommandHandler$CheckpointDoesNotExist(payload.ay));
				}
			} else {
				var _v4 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$CheckpointData$CommandHandler$CheckpointGroupDoesNotExist(payload.cC));
			}
		} else {
			var _v3 = _v0.a;
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointDoesNotExist(payload.i5));
		}
	});
var $author$project$CheckpointData$CommandHandler$handleMoveCheckpointBeforeCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple3(
			A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, acc.a),
			A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, acc.a),
			A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.ax, acc.a));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var checkpoint = _v0.a.a;
					var parent = _v0.b.a;
					var next = _v0.c.a;
					var _v1 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Types$EventId$from,
						$author$project$Environments$Environment$generateUuid(acc.ac));
					var eventId = _v1.a;
					var newEnvironment = _v1.b;
					var event = $author$project$CheckpointData$Event$MovedCheckpointBefore(
						{
							cC: parent.cC,
							i5: payload.i5,
							L: payload.L,
							M: payload.M,
							N: eventId,
							fJ: payload.ax,
							dZ: $elm$core$Maybe$Just(parent.cC),
							d_: next.kw,
							c4: checkpoint.kc,
							g1: $elm$core$Maybe$Just(checkpoint.cC),
							c5: checkpoint.kw,
							n: checkpoint.i + 1
						});
					var _v2 = A2(
						$author$project$CheckpointData$EventApplier$applyEventsHelper,
						$author$project$CheckpointData$Events$singleton(event),
						A4(
							$author$project$Utils$Triple$with,
							function ($) {
								return $.a;
							},
							function ($) {
								return $.g;
							},
							function ($) {
								return $.cb;
							},
							acc));
					var newCheckpointData = _v2.a;
					var newModification = _v2.b;
					var fileOperations = _v2.c;
					return $elm$core$Result$Ok(
						{
							a: newCheckpointData,
							cD: A2(
								$author$project$CheckpointData$Commands$enqueue,
								$author$project$CheckpointData$Command$MoveCheckpointBefore(payload),
								acc.cD),
							ac: newEnvironment,
							b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
							cb: fileOperations,
							g: newModification
						});
				} else {
					var _v5 = _v0.c;
					return $elm$core$Result$Err(
						$author$project$CheckpointData$CommandHandler$CheckpointDoesNotExist(payload.ax));
				}
			} else {
				var _v4 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$CheckpointData$CommandHandler$CheckpointGroupDoesNotExist(payload.cC));
			}
		} else {
			var _v3 = _v0.a;
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointDoesNotExist(payload.i5));
		}
	});
var $author$project$CheckpointData$CommandHandler$handleMoveCheckpointCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$CheckpointData$CheckpointData$getCheckpoint, payload.i5, acc.a),
			A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, acc.a));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var checkpoint = _v0.a.a;
				var parent = _v0.b.a;
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$CheckpointData$Event$MovedCheckpoint(
					{
						i5: payload.i5,
						L: payload.L,
						M: payload.M,
						N: eventId,
						dZ: payload.cC,
						d_: parent.jT,
						c4: checkpoint.kc,
						g1: $elm$core$Maybe$Just(checkpoint.cC),
						c5: checkpoint.kw,
						n: checkpoint.i + 1
					});
				var _v2 = A2(
					$author$project$CheckpointData$EventApplier$applyEventsHelper,
					$author$project$CheckpointData$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.a;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newCheckpointData = _v2.a;
				var newModification = _v2.b;
				var fileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						a: newCheckpointData,
						cD: A2(
							$author$project$CheckpointData$Commands$enqueue,
							$author$project$CheckpointData$Command$MoveCheckpoint(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
						cb: fileOperations,
						g: newModification
					});
			} else {
				var _v4 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$CheckpointData$CommandHandler$CheckpointGroupDoesNotExist(payload.cC));
			}
		} else {
			var _v3 = _v0.a;
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointDoesNotExist(payload.i5));
		}
	});
var $author$project$CheckpointData$CommandHandler$handleMoveCheckpointGroupAfterCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, acc.a),
			A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.ay, acc.a));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var checkpointGroup = _v0.a.a;
				var previous = _v0.b.a;
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$CheckpointData$Event$MovedCheckpointGroupAfter(
					{cC: payload.cC, L: payload.L, M: payload.M, N: eventId, fJ: previous.kc, d_: payload.ay, c4: checkpointGroup.kc, c5: checkpointGroup.kw, km: payload.km, n: checkpointGroup.i + 1});
				var _v2 = A2(
					$author$project$CheckpointData$EventApplier$applyEventsHelper,
					$author$project$CheckpointData$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.a;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newCheckpointData = _v2.a;
				var newModification = _v2.b;
				var fileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						a: newCheckpointData,
						cD: A2(
							$author$project$CheckpointData$Commands$enqueue,
							$author$project$CheckpointData$Command$MoveCheckpointGroupAfter(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
						cb: fileOperations,
						g: newModification
					});
			} else {
				var _v4 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$CheckpointData$CommandHandler$CheckpointGroupDoesNotExist(payload.ay));
			}
		} else {
			var _v3 = _v0.a;
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointGroupDoesNotExist(payload.cC));
		}
	});
var $author$project$CheckpointData$CommandHandler$handleMoveCheckpointGroupBeforeCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, acc.a),
			A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.ax, acc.a));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var checkpointGroup = _v0.a.a;
				var next = _v0.b.a;
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$CheckpointData$Event$MovedCheckpointGroupBefore(
					{cC: payload.cC, L: payload.L, M: payload.M, N: eventId, fJ: payload.ax, d_: next.kw, c4: checkpointGroup.kc, c5: checkpointGroup.kw, km: payload.km, n: checkpointGroup.i + 1});
				var _v2 = A2(
					$author$project$CheckpointData$EventApplier$applyEventsHelper,
					$author$project$CheckpointData$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.a;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newCheckpointData = _v2.a;
				var newModification = _v2.b;
				var fileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						a: newCheckpointData,
						cD: A2(
							$author$project$CheckpointData$Commands$enqueue,
							$author$project$CheckpointData$Command$MoveCheckpointGroupBefore(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$CheckpointData$Events$enqueue, event, acc.b8),
						cb: fileOperations,
						g: newModification
					});
			} else {
				var _v4 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$CheckpointData$CommandHandler$CheckpointGroupDoesNotExist(payload.ax));
			}
		} else {
			var _v3 = _v0.a;
			return $elm$core$Result$Err(
				$author$project$CheckpointData$CommandHandler$CheckpointGroupDoesNotExist(payload.cC));
		}
	});
var $author$project$CheckpointData$CommandHandler$handleCommandHelper = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleCreateCheckpointGroupCommand(payload);
		case 1:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleChangeCheckpointGroupTitleCommand(payload);
		case 2:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleChangeCheckpointGroupDescriptionCommand(payload);
		case 3:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleMoveCheckpointGroupBeforeCommand(payload);
		case 4:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleMoveCheckpointGroupAfterCommand(payload);
		case 5:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleDeleteCheckpointGroupCommand(payload);
		case 6:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleCreateCheckpointCommand(payload);
		case 7:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleChangeCheckpointTypeCommand(payload);
		case 8:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleChangeCheckpointTitleCommand(payload);
		case 9:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleChangeCheckpointDescriptionCommand(payload);
		case 10:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleChangeCheckpointFilesCommand(payload);
		case 12:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleMoveCheckpointBeforeCommand(payload);
		case 11:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleMoveCheckpointCommand(payload);
		case 13:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleMoveCheckpointAfterCommand(payload);
		default:
			var payload = command.a;
			return $author$project$CheckpointData$CommandHandler$handleDeleteCheckpointCommand(payload);
	}
};
var $author$project$CheckpointData$CommandHandler$handleCommands = F3(
	function (commands, environment, checkpointData) {
		var modifications = $author$project$CheckpointData$Modifications$empty;
		var acc = $elm$core$Result$Ok(
			{a: checkpointData, cD: $author$project$CheckpointData$Commands$empty, ac: environment, b8: $author$project$CheckpointData$Events$empty, cb: $author$project$File$Operations$empty, g: modifications});
		return A2(
			$elm$core$Result$map,
			function (resultData) {
				return {cD: resultData.cD, ac: resultData.ac, b8: resultData.b8, cb: resultData.cb};
			},
			A3(
				$author$project$CheckpointData$Commands$fold,
				A2($elm$core$Basics$composeR, $author$project$CheckpointData$CommandHandler$handleCommandHelper, $elm$core$Result$andThen),
				acc,
				commands));
	});
var $author$project$CheckpointData$Store$SaveCommandsAndEvents = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$CheckpointData$Commands$merge = $author$project$Types$Queue$merge;
var $author$project$CheckpointData$Events$merge = $author$project$Types$Queue$merge;
var $author$project$CheckpointData$Store$saveCommandsAndEvents = F3(
	function (commands_, events_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$CheckpointData$Store$Saving(
							{
								a: $author$project$CheckpointData$CheckpointData$empty,
								cD: A2($author$project$CheckpointData$Commands$merge, data.cD, commands_),
								b8: A2($author$project$CheckpointData$Events$merge, data.b8, events_)
							}),
						$author$project$CheckpointData$Store$send(
							A2($author$project$CheckpointData$Store$SaveCommandsAndEvents, commands_, events_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$CheckpointData$Store$Saving(
							_Utils_update(
								data,
								{
									cD: A2($author$project$CheckpointData$Commands$merge, data.cD, commands_),
									b8: A2($author$project$CheckpointData$Events$merge, data.b8, events_)
								})),
						$author$project$CheckpointData$Store$send(
							A2($author$project$CheckpointData$Store$SaveCommandsAndEvents, commands_, events_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations = F4(
	function (commands, events, fileOperations, repository) {
		var _v0 = A3(
			$author$project$CheckpointData$Store$saveCommandsAndEvents,
			commands,
			events,
			$author$project$Environments$Repository$checkpointDataStore(repository));
		if (!_v0.$) {
			var _v1 = _v0.a;
			var newCheckpointDataStore = _v1.a;
			var checkpointDataStoreCmd = _v1.b;
			var _v2 = A2(
				$author$project$File$Store$saveLocalOperations,
				fileOperations,
				$author$project$Environments$Repository$fileStore(repository));
			var newFileStore = _v2.a;
			var fileStoreCmd = _v2.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Environments$Repository$withFileStore,
					newFileStore,
					A2($author$project$Environments$Repository$withCheckpointDataStore, newCheckpointDataStore, repository)),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[checkpointDataStoreCmd, fileStoreCmd])));
		} else {
			return _Utils_Tuple2(repository, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$OrganisationUnit$Page$createdDuplicateCheckpointCommands = F4(
	function (checkpointDataCommands, environment, repository, _v0) {
		var page = _v0;
		var result = A3(
			$author$project$CheckpointData$CommandHandler$handleCommands,
			$author$project$CheckpointData$Commands$fromList(checkpointDataCommands),
			environment,
			$author$project$Environments$Repository$getCheckpointData(repository));
		if (result.$ === 1) {
			var error = result.a;
			var _v2 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Environments$ErrorHandling$Id$from,
				$author$project$Environments$Environment$generateUuid(environment));
			var newId = _v2.a;
			var newEnvironment = _v2.b;
			var newError = {
				gg: 'Commands are generated from OrganisationUnit.Duplicator',
				gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
					$author$project$Environments$ErrorHandling$ToString$checkpointDataErrorToString(error)),
				gH: 'OrganisationUnit.FloorPlan.elm',
				gK: 'createdDuplicateCheckpointCommands',
				fw: newId
			};
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
				ak: page,
				ae: repository
			};
		} else {
			var resultData = result.a;
			if ($author$project$CheckpointData$Commands$isEmpty(resultData.cD) || $author$project$CheckpointData$Events$isEmpty(resultData.b8)) {
				return {ab: $elm$core$Platform$Cmd$none, ac: resultData.ac, ak: page, ae: repository};
			} else {
				var _v3 = A4($author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations, resultData.cD, resultData.b8, resultData.cb, repository);
				var newRepository = _v3.a;
				var cmd = _v3.b;
				return {ab: cmd, ac: resultData.ac, ak: page, ae: newRepository};
			}
		}
	});
var $author$project$OrganisationUnit$Commands$fromList = $author$project$Types$Queue$fromList;
var $author$project$OrganisationUnit$Commands$fold = $author$project$Types$Queue$fold;
var $author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist = function (a) {
	return {$: 0, a: a};
};
var $author$project$OrganisationUnit$Commands$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$OrganisationUnit$OrganisationUnits$handleChangeColorCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			if (_Utils_eq(organisationUnit.K, payload.K)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$OrganisationUnit$Event$ColorChanged(
					{K: payload.K, L: payload.L, M: payload.M, N: eventId, km: payload.km, n: organisationUnit.i + 1});
				var _v2 = A2(
					$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
					$author$project$OrganisationUnit$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.kn;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newOrganisationUnits = _v2.a;
				var newModification = _v2.b;
				var newFileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$OrganisationUnit$Commands$enqueue,
							$author$project$OrganisationUnit$Command$ChangeColor(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						g: newModification,
						kn: newOrganisationUnits
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.km));
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$handleChangeDescriptionCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			if (_Utils_eq(organisationUnit.aY, payload.aY)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$OrganisationUnit$Event$DescriptionChanged(
					{L: payload.L, M: payload.M, aY: payload.aY, N: eventId, km: payload.km, n: organisationUnit.i + 1});
				var _v2 = A2(
					$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
					$author$project$OrganisationUnit$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.kn;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newOrganisationUnits = _v2.a;
				var newModification = _v2.b;
				var newFileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$OrganisationUnit$Commands$enqueue,
							$author$project$OrganisationUnit$Command$ChangeDescription(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						g: newModification,
						kn: newOrganisationUnits
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.km));
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$handleChangeFloorPlanCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			if (_Utils_eq(organisationUnit.ap, payload.fI)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$OrganisationUnit$Event$FloorPlanChanged(
					{L: payload.L, M: payload.M, N: eventId, fI: payload.fI, fM: payload.fM, km: payload.km, n: organisationUnit.i + 1});
				var _v2 = A2(
					$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
					$author$project$OrganisationUnit$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.kn;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newOrganisationUnits = _v2.a;
				var newModification = _v2.b;
				var newFileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$OrganisationUnit$Commands$enqueue,
							$author$project$OrganisationUnit$Command$ChangeFloorPlan(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						g: newModification,
						kn: newOrganisationUnits
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.km));
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$handleChangeTitleCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			if (_Utils_eq(organisationUnit.k8, payload.k8)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$OrganisationUnit$Event$TitleChanged(
					{L: payload.L, M: payload.M, N: eventId, km: payload.km, k8: payload.k8, n: organisationUnit.i + 1});
				var _v2 = A2(
					$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
					$author$project$OrganisationUnit$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.kn;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newOrganisationUnits = _v2.a;
				var newModification = _v2.b;
				var newFileOperations = _v2.c;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$OrganisationUnit$Commands$enqueue,
							$author$project$OrganisationUnit$Command$ChangeTitle(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						g: newModification,
						kn: newOrganisationUnits
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.km));
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitAlreadyExists = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$OrganisationUnits$handleCreateAfterCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn),
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.ay, acc.kn));
		if (!_v0.a.$) {
			var organisationUnit = _v0.a.a;
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitAlreadyExists(organisationUnit.km));
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var previous = _v0.b.a;
				var _v2 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v2.a;
				var newEnvironment = _v2.b;
				var event = $author$project$OrganisationUnit$Event$CreatedAfter(
					{K: payload.K, L: payload.L, M: payload.M, aY: payload.aY, N: eventId, ao: payload.ao, ap: payload.ap, jU: payload.jU, ax: previous.ax, km: payload.km, fV: previous.fV, ay: payload.ay, k8: payload.k8, n: 0});
				var _v3 = A2(
					$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
					$author$project$OrganisationUnit$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.kn;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newOrganisationUnits = _v3.a;
				var newModification = _v3.b;
				var newFileOperations = _v3.c;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$OrganisationUnit$Commands$enqueue,
							$author$project$OrganisationUnit$Command$CreateAfter(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						g: newModification,
						kn: newOrganisationUnits
					});
			} else {
				var _v4 = _v0.a;
				var _v5 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.ay));
			}
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$handleCreateBeforeCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn),
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.ax, acc.kn));
		if (!_v0.a.$) {
			var organisationUnit = _v0.a.a;
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitAlreadyExists(organisationUnit.km));
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var next = _v0.b.a;
				var _v2 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v2.a;
				var newEnvironment = _v2.b;
				var event = $author$project$OrganisationUnit$Event$CreatedBefore(
					{K: payload.K, L: payload.L, M: payload.M, aY: payload.aY, N: eventId, ao: payload.ao, ap: payload.ap, jU: payload.jU, ax: payload.ax, km: payload.km, fV: next.fV, ay: next.ay, k8: payload.k8, n: 0});
				var _v3 = A2(
					$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
					$author$project$OrganisationUnit$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.kn;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newOrganisationUnits = _v3.a;
				var newModification = _v3.b;
				var newFileOperations = _v3.c;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$OrganisationUnit$Commands$enqueue,
							$author$project$OrganisationUnit$Command$CreateBefore(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						g: newModification,
						kn: newOrganisationUnits
					});
			} else {
				var _v4 = _v0.a;
				var _v5 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.ax));
			}
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$handleCreateChildCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn),
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.fV, acc.kn));
		if (!_v0.a.$) {
			var organisationUnit = _v0.a.a;
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitAlreadyExists(organisationUnit.km));
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var parent = _v0.b.a;
				var _v2 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v2.a;
				var newEnvironment = _v2.b;
				var event = $author$project$OrganisationUnit$Event$ChildCreated(
					{K: payload.K, L: payload.L, M: payload.M, aY: payload.aY, N: eventId, ao: payload.ao, ap: payload.ap, jU: payload.jU, km: payload.km, fV: payload.fV, ay: parent.fC, k8: payload.k8, n: 0});
				var _v3 = A2(
					$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
					$author$project$OrganisationUnit$Events$singleton(event),
					A4(
						$author$project$Utils$Triple$with,
						function ($) {
							return $.kn;
						},
						function ($) {
							return $.g;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newOrganisationUnits = _v3.a;
				var newModification = _v3.b;
				var newFileOperations = _v3.c;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$OrganisationUnit$Commands$enqueue,
							$author$project$OrganisationUnit$Command$CreateChild(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						g: newModification,
						kn: newOrganisationUnits
					});
			} else {
				var _v4 = _v0.a;
				var _v5 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.fV));
			}
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$handleCreateCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitAlreadyExists(organisationUnit.km));
		} else {
			var previousId = $author$project$OrganisationUnit$Hierarchy$lastId(
				$author$project$OrganisationUnit$OrganisationUnits$hierarchy(acc.kn));
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$OrganisationUnit$Event$Created(
				{K: payload.K, L: payload.L, M: payload.M, aY: payload.aY, N: eventId, ao: payload.ao, ap: payload.ap, jU: payload.jU, km: payload.km, ay: previousId, k8: payload.k8, n: 0});
			var _v2 = A2(
				$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
				$author$project$OrganisationUnit$Events$singleton(event),
				A4(
					$author$project$Utils$Triple$with,
					function ($) {
						return $.kn;
					},
					function ($) {
						return $.g;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newOrganisationUnits = _v2.a;
			var newModification = _v2.b;
			var newFileOperations = _v2.c;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$OrganisationUnit$Commands$enqueue,
						$author$project$OrganisationUnit$Command$Create(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
					cb: newFileOperations,
					g: newModification,
					kn: newOrganisationUnits
				});
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$getDescendantIdsOf = function (organisationUnit) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$OrganisationUnit$OrganisationUnits$hierarchy,
		$author$project$OrganisationUnit$Hierarchy$getDescendantIdsOf(organisationUnit));
};
var $author$project$OrganisationUnit$OrganisationUnits$handleDeleteCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn);
		if (!_v0.$) {
			var organisationUnit = _v0.a;
			var descendantOrganisationUnitIds = A2($author$project$OrganisationUnit$OrganisationUnits$getDescendantIdsOf, organisationUnit, acc.kn);
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$OrganisationUnit$Event$Deleted(
				{L: payload.L, M: payload.M, hK: descendantOrganisationUnitIds, N: eventId, c4: organisationUnit.ax, g1: organisationUnit.fV, c5: organisationUnit.ay, km: payload.km, n: organisationUnit.i + 1});
			var _v2 = A2(
				$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
				$author$project$OrganisationUnit$Events$singleton(event),
				A4(
					$author$project$Utils$Triple$with,
					function ($) {
						return $.kn;
					},
					function ($) {
						return $.g;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newOrganisationUnits = _v2.a;
			var newModification = _v2.b;
			var newFileOperations = _v2.c;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$OrganisationUnit$Commands$enqueue,
						$author$project$OrganisationUnit$Command$Delete(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
					cb: newFileOperations,
					g: newModification,
					kn: newOrganisationUnits
				});
		} else {
			return $elm$core$Result$Ok(acc);
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$CannotBeDescendantOfItself = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$OrganisationUnit$OrganisationUnits$CannotBeMovedAfterItself = function (a) {
	return {$: 4, a: a};
};
var $author$project$OrganisationUnit$OrganisationUnits$isAncestorOf = F2(
	function (organisationUnitId, descendantId) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$OrganisationUnit$OrganisationUnits$hierarchy,
			A2($author$project$OrganisationUnit$Hierarchy$isAncestorOf, organisationUnitId, descendantId));
	});
var $author$project$OrganisationUnit$OrganisationUnits$handleMoveAfterCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn),
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.ay, acc.kn));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var organisationUnit = _v0.a.a;
				var previous = _v0.b.a;
				if (_Utils_eq(payload.km, payload.ay)) {
					return $elm$core$Result$Err(
						$author$project$OrganisationUnit$OrganisationUnits$CannotBeMovedAfterItself(payload.km));
				} else {
					if (A3($author$project$OrganisationUnit$OrganisationUnits$isAncestorOf, payload.km, payload.ay, acc.kn)) {
						return $elm$core$Result$Err(
							A2($author$project$OrganisationUnit$OrganisationUnits$CannotBeDescendantOfItself, payload.km, payload.ay));
					} else {
						if (_Utils_eq(
							organisationUnit.ay,
							$elm$core$Maybe$Just(payload.ay))) {
							return $elm$core$Result$Ok(acc);
						} else {
							var _v1 = A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Types$EventId$from,
								$author$project$Environments$Environment$generateUuid(acc.ac));
							var eventId = _v1.a;
							var newEnvironment = _v1.b;
							var event = $author$project$OrganisationUnit$Event$MovedAfter(
								{L: payload.L, M: payload.M, N: eventId, fJ: previous.ax, dZ: previous.fV, d_: payload.ay, c4: organisationUnit.ax, g1: organisationUnit.fV, c5: organisationUnit.ay, km: organisationUnit.km, n: organisationUnit.i + 1});
							var _v2 = A2(
								$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
								$author$project$OrganisationUnit$Events$singleton(event),
								A4(
									$author$project$Utils$Triple$with,
									function ($) {
										return $.kn;
									},
									function ($) {
										return $.g;
									},
									function ($) {
										return $.cb;
									},
									acc));
							var newOrganisationUnits = _v2.a;
							var newModification = _v2.b;
							var newFileOperations = _v2.c;
							return $elm$core$Result$Ok(
								{
									cD: A2(
										$author$project$OrganisationUnit$Commands$enqueue,
										$author$project$OrganisationUnit$Command$MoveAfter(payload),
										acc.cD),
									ac: newEnvironment,
									b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
									cb: newFileOperations,
									g: newModification,
									kn: newOrganisationUnits
								});
						}
					}
				}
			} else {
				var _v4 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.ay));
			}
		} else {
			var _v3 = _v0.a;
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.km));
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$CannotBeMovedBeforeItself = function (a) {
	return {$: 3, a: a};
};
var $author$project$OrganisationUnit$OrganisationUnits$handleMoveBeforeCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn),
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.ax, acc.kn));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var organisationUnit = _v0.a.a;
				var next = _v0.b.a;
				if (_Utils_eq(payload.km, payload.ax)) {
					return $elm$core$Result$Err(
						$author$project$OrganisationUnit$OrganisationUnits$CannotBeMovedBeforeItself(payload.km));
				} else {
					if (A3($author$project$OrganisationUnit$OrganisationUnits$isAncestorOf, payload.km, payload.ax, acc.kn)) {
						return $elm$core$Result$Err(
							A2($author$project$OrganisationUnit$OrganisationUnits$CannotBeDescendantOfItself, payload.km, payload.ax));
					} else {
						if (_Utils_eq(
							organisationUnit.ax,
							$elm$core$Maybe$Just(payload.ax))) {
							return $elm$core$Result$Ok(acc);
						} else {
							var _v1 = A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Types$EventId$from,
								$author$project$Environments$Environment$generateUuid(acc.ac));
							var eventId = _v1.a;
							var newEnvironment = _v1.b;
							var event = $author$project$OrganisationUnit$Event$MovedBefore(
								{L: payload.L, M: payload.M, N: eventId, fJ: payload.ax, dZ: next.fV, d_: next.ay, c4: organisationUnit.ax, g1: organisationUnit.fV, c5: organisationUnit.ay, km: organisationUnit.km, n: organisationUnit.i + 1});
							var _v2 = A2(
								$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
								$author$project$OrganisationUnit$Events$singleton(event),
								A4(
									$author$project$Utils$Triple$with,
									function ($) {
										return $.kn;
									},
									function ($) {
										return $.g;
									},
									function ($) {
										return $.cb;
									},
									acc));
							var newOrganisationUnits = _v2.a;
							var newModification = _v2.b;
							var newFileOperations = _v2.c;
							return $elm$core$Result$Ok(
								{
									cD: A2(
										$author$project$OrganisationUnit$Commands$enqueue,
										$author$project$OrganisationUnit$Command$MoveBefore(payload),
										acc.cD),
									ac: newEnvironment,
									b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
									cb: newFileOperations,
									g: newModification,
									kn: newOrganisationUnits
								});
						}
					}
				}
			} else {
				var _v4 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.ax));
			}
		} else {
			var _v3 = _v0.a;
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.km));
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$handleMoveCommand = F2(
	function (payload, acc) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.km, acc.kn),
			A2($author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit, payload.fV, acc.kn));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var organisationUnit = _v0.a.a;
				var parent = _v0.b.a;
				if (_Utils_eq(
					parent.fC,
					$elm$core$Maybe$Just(payload.km))) {
					return $elm$core$Result$Ok(acc);
				} else {
					if (_Utils_eq(payload.km, payload.fV)) {
						return $elm$core$Result$Err(
							A2($author$project$OrganisationUnit$OrganisationUnits$CannotBeDescendantOfItself, payload.km, payload.fV));
					} else {
						if (A3($author$project$OrganisationUnit$OrganisationUnits$isAncestorOf, payload.km, payload.fV, acc.kn)) {
							return $elm$core$Result$Err(
								A2($author$project$OrganisationUnit$OrganisationUnits$CannotBeDescendantOfItself, payload.km, payload.fV));
						} else {
							var _v1 = A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Types$EventId$from,
								$author$project$Environments$Environment$generateUuid(acc.ac));
							var eventId = _v1.a;
							var newEnvironment = _v1.b;
							var event = $author$project$OrganisationUnit$Event$Moved(
								{L: payload.L, M: payload.M, N: eventId, dZ: payload.fV, d_: parent.fC, c4: organisationUnit.ax, g1: organisationUnit.fV, c5: organisationUnit.ay, km: organisationUnit.km, n: organisationUnit.i + 1});
							var _v2 = A2(
								$author$project$OrganisationUnit$OrganisationUnits$applyEventsHelper,
								$author$project$OrganisationUnit$Events$singleton(event),
								A4(
									$author$project$Utils$Triple$with,
									function ($) {
										return $.kn;
									},
									function ($) {
										return $.g;
									},
									function ($) {
										return $.cb;
									},
									acc));
							var newOrganisationUnits = _v2.a;
							var newModification = _v2.b;
							var newFileOperations = _v2.c;
							return $elm$core$Result$Ok(
								{
									cD: A2(
										$author$project$OrganisationUnit$Commands$enqueue,
										$author$project$OrganisationUnit$Command$Move(payload),
										acc.cD),
									ac: newEnvironment,
									b8: A2($author$project$OrganisationUnit$Events$enqueue, event, acc.b8),
									cb: newFileOperations,
									g: newModification,
									kn: newOrganisationUnits
								});
						}
					}
				}
			} else {
				var _v4 = _v0.b;
				return $elm$core$Result$Err(
					$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.fV));
			}
		} else {
			var _v3 = _v0.a;
			return $elm$core$Result$Err(
				$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(payload.km));
		}
	});
var $author$project$OrganisationUnit$OrganisationUnits$handleCommandHelper = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleCreateCommand(payload);
		case 1:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleCreateChildCommand(payload);
		case 2:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleCreateBeforeCommand(payload);
		case 3:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleCreateAfterCommand(payload);
		case 4:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleMoveCommand(payload);
		case 5:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleMoveBeforeCommand(payload);
		case 6:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleMoveAfterCommand(payload);
		case 7:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleChangeTitleCommand(payload);
		case 8:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleChangeDescriptionCommand(payload);
		case 9:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleChangeColorCommand(payload);
		case 10:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleChangeFloorPlanCommand(payload);
		default:
			var payload = command.a;
			return $author$project$OrganisationUnit$OrganisationUnits$handleDeleteCommand(payload);
	}
};
var $author$project$OrganisationUnit$OrganisationUnits$handleCommands = F3(
	function (commands, environment, organisationUnits) {
		var data = organisationUnits;
		var lastId = $author$project$OrganisationUnit$Hierarchy$lastId(data.a8);
		var firstId = $author$project$OrganisationUnit$Hierarchy$firstId(data.a8);
		var modifications = A2($author$project$OrganisationUnit$Modifications$empty, firstId, lastId);
		var acc = $elm$core$Result$Ok(
			{cD: $author$project$OrganisationUnit$Commands$empty, ac: environment, b8: $author$project$OrganisationUnit$Events$empty, cb: $author$project$File$Operations$empty, g: modifications, kn: organisationUnits});
		return A2(
			$elm$core$Result$map,
			function (resultData) {
				return {cD: resultData.cD, ac: resultData.ac, b8: resultData.b8, cb: resultData.cb};
			},
			A3(
				$author$project$OrganisationUnit$Commands$fold,
				A2($elm$core$Basics$composeR, $author$project$OrganisationUnit$OrganisationUnits$handleCommandHelper, $elm$core$Result$andThen),
				acc,
				commands));
	});
var $author$project$Environments$ErrorHandling$ToString$organisationUnitErrorToString = function (err) {
	switch (err.$) {
		case 0:
			var id = err.a;
			return 'OrganisationUnit.OrganisationUnitDoesNotExist: ' + $author$project$OrganisationUnit$Id$toString(id);
		case 1:
			var id = err.a;
			return 'OrganisationUnit.OrganisationUnitAlreadyExists: ' + $author$project$OrganisationUnit$Id$toString(id);
		case 2:
			var id1 = err.a;
			var id2 = err.b;
			return 'OrganisationUnit.CannotBeDescendantOfItself: ' + ($author$project$OrganisationUnit$Id$toString(id1) + (', ' + $author$project$OrganisationUnit$Id$toString(id2)));
		case 3:
			var id = err.a;
			return 'OrganisationUnit.CannotBeMovedBeforeItself: ' + $author$project$OrganisationUnit$Id$toString(id);
		default:
			var id = err.a;
			return 'OrganisationUnit.CannotBeMovedAfterItself: ' + $author$project$OrganisationUnit$Id$toString(id);
	}
};
var $author$project$OrganisationUnit$Store$SaveCommandsAndEvents = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$OrganisationUnit$Commands$merge = $author$project$Types$Queue$merge;
var $author$project$OrganisationUnit$Events$merge = $author$project$Types$Queue$merge;
var $author$project$OrganisationUnit$Store$saveCommandsAndEvents = F3(
	function (commands_, events_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$OrganisationUnit$Store$Saving(
							{
								cD: A2($author$project$OrganisationUnit$Commands$merge, data.cD, commands_),
								b8: A2($author$project$OrganisationUnit$Events$merge, data.b8, events_),
								kn: $author$project$OrganisationUnit$OrganisationUnits$empty
							}),
						$author$project$OrganisationUnit$Store$send(
							A2($author$project$OrganisationUnit$Store$SaveCommandsAndEvents, commands_, events_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$OrganisationUnit$Store$Saving(
							_Utils_update(
								data,
								{
									cD: A2($author$project$OrganisationUnit$Commands$merge, data.cD, commands_),
									b8: A2($author$project$OrganisationUnit$Events$merge, data.b8, events_)
								})),
						$author$project$OrganisationUnit$Store$send(
							A2($author$project$OrganisationUnit$Store$SaveCommandsAndEvents, commands_, events_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$saveOrganisationUnitCommandsAndEventsAndFileOperations = F4(
	function (commands, events, fileOperations, repository) {
		var _v0 = A3(
			$author$project$OrganisationUnit$Store$saveCommandsAndEvents,
			commands,
			events,
			$author$project$Environments$Repository$organisationUnitStore(repository));
		if (!_v0.$) {
			var _v1 = _v0.a;
			var newOrganisationUnitStore = _v1.a;
			var organisationUnitStoreCmd = _v1.b;
			var _v2 = A2(
				$author$project$File$Store$saveLocalOperations,
				fileOperations,
				$author$project$Environments$Repository$fileStore(repository));
			var newFileStore = _v2.a;
			var fileStoreCmd = _v2.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Environments$Repository$withFileStore,
					newFileStore,
					A2($author$project$Environments$Repository$withOrganisationUnitStore, newOrganisationUnitStore, repository)),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[organisationUnitStoreCmd, fileStoreCmd])));
		} else {
			return _Utils_Tuple2(repository, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$OrganisationUnit$Page$createdDuplicateCommands = F5(
	function (checkpointDataCmdMsg, ouCommands, environment, repository, _v0) {
		var page = _v0;
		var result = A3(
			$author$project$OrganisationUnit$OrganisationUnits$handleCommands,
			$author$project$OrganisationUnit$Commands$fromList(ouCommands),
			environment,
			$author$project$Environments$Repository$organisationUnits(repository));
		if (result.$ === 1) {
			var error = result.a;
			var _v2 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Environments$ErrorHandling$Id$from,
				$author$project$Environments$Environment$generateUuid(environment));
			var newId = _v2.a;
			var newEnvironment = _v2.b;
			var newError = {
				gg: 'Commands are generated from OrganisationUnit.Duplicator',
				gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
					$author$project$Environments$ErrorHandling$ToString$organisationUnitErrorToString(error)),
				gH: 'OrganisationUnit.FloorPlan.elm',
				gK: 'createdDuplicateCommands',
				fw: newId
			};
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
				ak: page,
				ae: repository
			};
		} else {
			var resultData = result.a;
			if ($author$project$OrganisationUnit$Commands$isEmpty(resultData.cD) || $author$project$OrganisationUnit$Events$isEmpty(resultData.b8)) {
				return {ab: $elm$core$Platform$Cmd$none, ac: resultData.ac, ak: page, ae: repository};
			} else {
				var _v3 = A4($author$project$Environments$Repository$saveOrganisationUnitCommandsAndEventsAndFileOperations, resultData.cD, resultData.b8, resultData.cb, repository);
				var newRepository = _v3.a;
				var cmd = _v3.b;
				return {
					ab: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd, checkpointDataCmdMsg])),
					ac: resultData.ac,
					ak: page,
					ae: newRepository
				};
			}
		}
	});
var $author$project$OrganisationUnit$Page$createdMoveCommand = F4(
	function (command, environment, repository, _v0) {
		var page = _v0;
		var result = A3(
			$author$project$OrganisationUnit$OrganisationUnits$handleCommands,
			$author$project$OrganisationUnit$Commands$fromList(
				_List_fromArray(
					[command])),
			environment,
			$author$project$Environments$Repository$organisationUnits(repository));
		if (result.$ === 1) {
			var error = result.a;
			var _v2 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Environments$ErrorHandling$Id$from,
				$author$project$Environments$Environment$generateUuid(environment));
			var newId = _v2.a;
			var newEnvironment = _v2.b;
			var newError = {
				gg: '',
				gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
					$author$project$Environments$ErrorHandling$ToString$organisationUnitErrorToString(error)),
				gH: 'OrganisationUnit.FloorPlan.elm',
				gK: 'createdMoveCommand',
				fw: newId
			};
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
				ak: page,
				ae: repository
			};
		} else {
			var resultData = result.a;
			if ($author$project$OrganisationUnit$Commands$isEmpty(resultData.cD) || $author$project$OrganisationUnit$Events$isEmpty(resultData.b8)) {
				return {ab: $elm$core$Platform$Cmd$none, ac: resultData.ac, ak: page, ae: repository};
			} else {
				var _v3 = A4($author$project$Environments$Repository$saveOrganisationUnitCommandsAndEventsAndFileOperations, resultData.cD, resultData.b8, resultData.cb, repository);
				var newRepository = _v3.a;
				var cmd = _v3.b;
				return {ab: cmd, ac: resultData.ac, ak: page, ae: newRepository};
			}
		}
	});
var $author$project$UI$DragAndDrop$DragAndDrop$customOffset = _Utils_Tuple2(4, 4);
var $author$project$UI$DragAndDrop$DragAndDrop$tupleAdd = F2(
	function (_v0, _v1) {
		var a = _v0.a;
		var b = _v0.b;
		var x = _v1.a;
		var y = _v1.b;
		return _Utils_Tuple2(a + x, b + y);
	});
var $author$project$UI$DragAndDrop$DragAndDrop$createInitialOffset = function (_v0) {
	var clientPos = _v0.i7;
	var targetsOffset = _v0.k$;
	return A2($author$project$UI$DragAndDrop$DragAndDrop$tupleAdd, clientPos, $author$project$UI$DragAndDrop$DragAndDrop$customOffset);
};
var $author$project$UI$DragAndDrop$DragAndDrop$initialMouseEventToDragState = function (mouseEvent) {
	return {
		jq: mouseEvent.iB,
		gQ: mouseEvent.i7,
		gR: $author$project$UI$DragAndDrop$DragAndDrop$createInitialOffset(mouseEvent),
		d0: $author$project$UI$DragAndDrop$DragAndDrop$createInitialOffset(mouseEvent)
	};
};
var $author$project$UI$DragAndDrop$DragAndDrop$AfterHoveredElement = 2;
var $author$project$UI$DragAndDrop$DragAndDrop$BeforeHoveredElement = 0;
var $author$project$UI$DragAndDrop$DragAndDrop$MiddleHoveredElement = 1;
var $author$project$UI$DragAndDrop$DragAndDrop$calculateDropLocation = F2(
	function (_v0, _v1) {
		var y = _v0.b;
		var height = _v1.b;
		return (_Utils_cmp(height * 0.33, y) > 0) ? 0 : ((_Utils_cmp(height * 0.66, y) < 0) ? 2 : 1);
	});
var $author$project$UI$DragAndDrop$DragAndDrop$mouseEventToDroppableState = function (_v0) {
	var targetsSize = _v0.iB;
	var offsetPos = _v0.g0;
	return A2($author$project$UI$DragAndDrop$DragAndDrop$calculateDropLocation, offsetPos, targetsSize);
};
var $author$project$UI$DragAndDrop$DragAndDrop$updateDragState = F2(
	function (_v0, oldDragState) {
		var clientPos = _v0.i7;
		var initialOffset = oldDragState.gR;
		var initialCursorOffset = oldDragState.gQ;
		return _Utils_update(
			oldDragState,
			{
				d0: A2($author$project$UI$DragAndDrop$DragAndDrop$tupleAdd, clientPos, $author$project$UI$DragAndDrop$DragAndDrop$customOffset)
			});
	});
var $author$project$UI$DragAndDrop$DragAndDrop$calculateDnd = F2(
	function (dndEvent, dnd) {
		switch (dndEvent.$) {
			case 3:
				var hoveredElement = dndEvent.a;
				var mouseEvent = dndEvent.b;
				var _v1 = dnd.hF;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var dragElem = _v2.a;
					var dragState = _v2.b;
					var newDropState = $author$project$UI$DragAndDrop$DragAndDrop$mouseEventToDroppableState(mouseEvent);
					var newDragState = A2($author$project$UI$DragAndDrop$DragAndDrop$updateDragState, mouseEvent, dragState);
					return _Utils_update(
						dnd,
						{
							hF: $elm$core$Maybe$Just(
								_Utils_Tuple2(dragElem, newDragState)),
							jf: $elm$core$Maybe$Just(
								_Utils_Tuple2(hoveredElement, newDropState))
						});
				} else {
					return dnd;
				}
			case 0:
				var element = dndEvent.a;
				var mouseEvent = dndEvent.b;
				var dragState = _Utils_Tuple2(
					element,
					$author$project$UI$DragAndDrop$DragAndDrop$initialMouseEventToDragState(mouseEvent));
				return _Utils_update(
					$author$project$UI$DragAndDrop$DragAndDrop$emptyDnd,
					{
						hF: $elm$core$Maybe$Just(dragState)
					});
			case 1:
				var currentlyMovingElement = dndEvent.a;
				var mouseEvent = dndEvent.b;
				var _v3 = _Utils_Tuple2(dnd.hF, dnd.jf);
				if (!_v3.a.$) {
					if (!_v3.b.$) {
						var _v4 = _v3.a.a;
						var dragElement = _v4.a;
						var dragState = _v4.b;
						var _v5 = _v3.b.a;
						var hoveredElement = _v5.a;
						var newDropState = $author$project$UI$DragAndDrop$DragAndDrop$mouseEventToDroppableState(mouseEvent);
						var newDragState = A2($author$project$UI$DragAndDrop$DragAndDrop$updateDragState, mouseEvent, dragState);
						return _Utils_update(
							dnd,
							{
								hF: $elm$core$Maybe$Just(
									_Utils_Tuple2(dragElement, newDragState)),
								jf: $elm$core$Maybe$Just(
									_Utils_Tuple2(hoveredElement, newDropState))
							});
					} else {
						var _v6 = _v3.a.a;
						var dragState = _v6.b;
						var _v7 = _v3.b;
						var newDragState = A2($author$project$UI$DragAndDrop$DragAndDrop$updateDragState, mouseEvent, dragState);
						return _Utils_update(
							dnd,
							{
								hF: $elm$core$Maybe$Just(
									_Utils_Tuple2(currentlyMovingElement, newDragState))
							});
					}
				} else {
					return dnd;
				}
			case 2:
				var draggedElement = dndEvent.a;
				var hoveredElement = dndEvent.b;
				return _Utils_update(
					dnd,
					{
						hF: $elm$core$Maybe$Nothing,
						jf: $elm$core$Maybe$Nothing,
						gT: $elm$core$Maybe$Just(draggedElement),
						gU: $elm$core$Maybe$Just(hoveredElement)
					});
			default:
				return $author$project$UI$DragAndDrop$DragAndDrop$emptyDnd;
		}
	});
var $author$project$OrganisationUnit$Page$dnDEvent = F4(
	function (dndEvent, environment, repository, _v0) {
		var page = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				page,
				{
					hN: A2($author$project$UI$DragAndDrop$DragAndDrop$calculateDnd, dndEvent, page.hN)
				}),
			ae: repository
		};
	});
var $author$project$OrganisationUnit$Page$CreatedMoveCommand = function (a) {
	return {$: 14, a: a};
};
var $author$project$OrganisationUnit$Command$commandHelper = F2(
	function (environment, buildCommand) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Types$CommandId$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var commandId_ = _v0.a;
		var newEnvironment = _v0.b;
		return _Utils_Tuple2(
			newEnvironment,
			A2(
				$elm$core$Task$map,
				buildCommand(commandId_),
				$elm$time$Time$now));
	});
var $author$project$OrganisationUnit$Command$move = F2(
	function (environment, payload) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$Move(
						{L: commandId_, M: commandTimestamp, km: payload.km, fV: payload.fV, l: payload.l});
				}));
	});
var $author$project$OrganisationUnit$Command$moveAfter = F2(
	function (environment, model) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$MoveAfter(
						{L: commandId_, M: commandTimestamp, km: model.km, fV: model.fV, ay: model.ay, l: model.l});
				}));
	});
var $author$project$OrganisationUnit$Command$moveBefore = F2(
	function (environment, model) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$MoveBefore(
						{L: commandId_, M: commandTimestamp, ax: model.ax, km: model.km, fV: model.fV, l: model.l});
				}));
	});
var $author$project$OrganisationUnit$Page$createMoveCommand = F4(
	function (environment, dragged, target, droppableState) {
		switch (droppableState) {
			case 0:
				return _Utils_eq(
					target.ay,
					$elm$core$Maybe$Just(dragged.km)) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$Task$perform, $author$project$OrganisationUnit$Page$CreatedMoveCommand, task);
					},
					A2(
						$author$project$OrganisationUnit$Command$moveBefore,
						environment,
						{ax: target.km, km: dragged.km, fV: target.fV, l: dragged.k8}));
			case 1:
				return _Utils_eq(
					target.fC,
					$elm$core$Maybe$Just(dragged.km)) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$Task$perform, $author$project$OrganisationUnit$Page$CreatedMoveCommand, task);
					},
					A2(
						$author$project$OrganisationUnit$Command$move,
						environment,
						{km: dragged.km, fV: target.km, l: dragged.k8}));
			default:
				return _Utils_eq(
					target.ax,
					$elm$core$Maybe$Just(dragged.km)) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$Task$perform, $author$project$OrganisationUnit$Page$CreatedMoveCommand, task);
					},
					A2(
						$author$project$OrganisationUnit$Command$moveAfter,
						environment,
						{km: dragged.km, fV: target.fV, ay: target.km, l: dragged.k8}));
		}
	});
var $author$project$UI$DragAndDrop$DragAndDrop$toDroppableState = function (dnd) {
	var _v0 = dnd.jf;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var dropstate = _v1.b;
		return $elm$core$Maybe$Just(dropstate);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$OrganisationUnit$Page$checkDragAndDropAction = F4(
	function (environment, repository, dndEvent, dnd) {
		if (dndEvent.$ === 2) {
			var dragged = dndEvent.a;
			var target = dndEvent.b;
			var targetIsAncestor = A3(
				$author$project$OrganisationUnit$Hierarchy$isAncestorOf,
				dragged.km,
				target.km,
				$author$project$OrganisationUnit$OrganisationUnits$hierarchy(
					$author$project$Environments$Repository$organisationUnits(repository)));
			var allowedToMove = A2(
				$elm$core$List$member,
				false,
				A2(
					$elm$core$List$map,
					A2(
						$author$project$Auth$Authorization$authorize,
						$author$project$Environments$Environment$userRights(environment),
						1),
					A2(
						$elm$core$List$map,
						function ($) {
							return $.km;
						},
						A2(
							$elm$core$List$cons,
							dragged,
							A2(
								$author$project$OrganisationUnit$OrganisationUnits$getAllSiblingsOf,
								target.km,
								$author$project$Environments$Repository$organisationUnits(repository))))));
			return (_Utils_eq(dragged.km, target.km) || (targetIsAncestor || allowedToMove)) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(environment, $elm$core$Platform$Cmd$none),
				A2(
					$elm$core$Maybe$map,
					function (droppableState) {
						return A4($author$project$OrganisationUnit$Page$createMoveCommand, environment, dragged, target, droppableState);
					},
					$author$project$UI$DragAndDrop$DragAndDrop$toDroppableState(dnd)));
		} else {
			return _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$OrganisationUnit$Page$dnDEventDragEnd = F4(
	function (dndEvent, environment, repository, _v0) {
		var page = _v0;
		var _v1 = A4($author$project$OrganisationUnit$Page$checkDragAndDropAction, environment, repository, dndEvent, page.hN);
		var newEnvironment = _v1.a;
		var cmd = _v1.b;
		return {
			ab: cmd,
			ac: newEnvironment,
			ak: _Utils_update(
				page,
				{
					hN: A2($author$project$UI$DragAndDrop$DragAndDrop$calculateDnd, dndEvent, page.hN)
				}),
			ae: repository
		};
	});
var $author$project$OrganisationUnit$Page$gotCollapseOrganisationUnitMsg = F4(
	function (organisationUnitId, environment, repository, _v0) {
		var page = _v0;
		var updatedPage = _Utils_update(
			page,
			{
				dI: A2($author$project$UI$OrganisationStructure$collapseOrganisationUnit, organisationUnitId, page.dI)
			});
		return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: updatedPage, ae: repository};
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$commands = function (_v0) {
	var editor = _v0;
	return editor.a7;
};
var $author$project$OrganisationUnit$CreateDialog$updateCommandTimestamp = F3(
	function (posix, index, command) {
		var updatedPosix = $elm$time$Time$millisToPosix(
			(index * 1000) + $elm$time$Time$posixToMillis(posix));
		switch (command.$) {
			case 0:
				var payload = command.a;
				return $author$project$CheckpointData$Command$CreateCheckpointGroup(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 1:
				var payload = command.a;
				return $author$project$CheckpointData$Command$ChangeCheckpointGroupTitle(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 2:
				var payload = command.a;
				return $author$project$CheckpointData$Command$ChangeCheckpointGroupDescription(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 3:
				var payload = command.a;
				return $author$project$CheckpointData$Command$MoveCheckpointGroupBefore(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 4:
				var payload = command.a;
				return $author$project$CheckpointData$Command$MoveCheckpointGroupAfter(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 5:
				var payload = command.a;
				return $author$project$CheckpointData$Command$DeleteCheckpointGroup(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 6:
				var payload = command.a;
				return $author$project$CheckpointData$Command$CreateCheckpoint(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 7:
				var payload = command.a;
				return $author$project$CheckpointData$Command$ChangeCheckpointType(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 8:
				var payload = command.a;
				return $author$project$CheckpointData$Command$ChangeCheckpointTitle(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 9:
				var payload = command.a;
				return $author$project$CheckpointData$Command$ChangeCheckpointDescription(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 10:
				var payload = command.a;
				return $author$project$CheckpointData$Command$ChangeCheckpointFiles(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 11:
				var payload = command.a;
				return $author$project$CheckpointData$Command$MoveCheckpoint(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 12:
				var payload = command.a;
				return $author$project$CheckpointData$Command$MoveCheckpointBefore(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			case 13:
				var payload = command.a;
				return $author$project$CheckpointData$Command$MoveCheckpointAfter(
					_Utils_update(
						payload,
						{M: updatedPosix}));
			default:
				var payload = command.a;
				return $author$project$CheckpointData$Command$DeleteCheckpoint(
					_Utils_update(
						payload,
						{M: updatedPosix}));
		}
	});
var $author$project$OrganisationUnit$CreateDialog$createdCommands = F4(
	function (commands, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				var model = dialog.a;
				var _v1 = A3(
					$author$project$OrganisationUnit$OrganisationUnits$handleCommands,
					$author$project$OrganisationUnit$Commands$fromList(commands),
					environment,
					$author$project$Environments$Repository$organisationUnits(repository));
				if (_v1.$ === 1) {
					var error = _v1.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$organisationUnitErrorToString(error)),
						gH: 'OrganisationUnit.CreateDialog.elm',
						gK: 'createdCommands',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: dialog,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				} else {
					var organisationUnitData = _v1.a;
					if (($author$project$OrganisationUnit$Commands$isEmpty(organisationUnitData.cD) || $author$project$OrganisationUnit$Events$isEmpty(organisationUnitData.b8)) && $elm$core$List$isEmpty(
						$author$project$OrganisationUnit$CheckpointGroupEditor$commands(model.cB))) {
						return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$OrganisationUnit$CreateDialog$Hidden, ac: organisationUnitData.ac, ae: repository};
					} else {
						var checkpointDataCommands = A2(
							$elm$core$List$indexedMap,
							$author$project$OrganisationUnit$CreateDialog$updateCommandTimestamp(model.fX),
							$author$project$OrganisationUnit$CheckpointGroupEditor$commands(model.cB));
						var _v3 = A3(
							$author$project$CheckpointData$CommandHandler$handleCommands,
							$author$project$CheckpointData$Commands$fromList(checkpointDataCommands),
							organisationUnitData.ac,
							$author$project$Environments$Repository$getCheckpointData(repository));
						if (!_v3.$) {
							var checkpointData = _v3.a;
							var _v4 = A4($author$project$Environments$Repository$saveOrganisationUnitCommandsAndEventsAndFileOperations, organisationUnitData.cD, organisationUnitData.b8, organisationUnitData.cb, repository);
							var newRepository = _v4.a;
							var cmd = _v4.b;
							var _v5 = A4($author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations, checkpointData.cD, checkpointData.b8, checkpointData.cb, newRepository);
							var newRepository2 = _v5.a;
							var cmd2 = _v5.b;
							return {
								ab: $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[cmd, cmd2])),
								jn: $author$project$OrganisationUnit$CreateDialog$Hidden,
								ac: checkpointData.ac,
								ae: newRepository2
							};
						} else {
							var error = _v3.a;
							var _v6 = A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Environments$ErrorHandling$Id$from,
								$author$project$Environments$Environment$generateUuid(organisationUnitData.ac));
							var newId = _v6.a;
							var newEnvironment = _v6.b;
							var newError = {
								gg: '',
								gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
									$author$project$Environments$ErrorHandling$ToString$checkpointDataErrorToString(error)),
								gH: 'OrganisationUnit.CreateDialog.elm',
								gK: 'createdCommands',
								fw: newId
							};
							var _v7 = A4($author$project$Environments$Repository$saveOrganisationUnitCommandsAndEventsAndFileOperations, organisationUnitData.cD, organisationUnitData.b8, organisationUnitData.cb, repository);
							var newRepository = _v7.a;
							var cmd = _v7.b;
							return {
								ab: cmd,
								jn: $author$project$OrganisationUnit$CreateDialog$Hidden,
								ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
								ae: newRepository
							};
						}
					}
				}
		}
	});
var $author$project$OrganisationUnit$CreateDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$CreateDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var editor = A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ);
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$OrganisationUnit$CreateDialog$Visible(
						_Utils_update(
							model,
							{aQ: editor})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$CreateDialog$GotCheckpointGroupEditorMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$Editor = $elm$core$Basics$identity;
var $author$project$OrganisationUnit$CheckpointGroupEditor$checkpointGroupDnDEvent = F4(
	function (dnDEventMsg, environment, repository, _v0) {
		var editor = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			X: _Utils_update(
				editor,
				{
					a6: A2($author$project$UI$DragAndDrop$DragAndDrop$calculateDnd, dnDEventMsg, editor.a6)
				}),
			ac: environment,
			ae: repository
		};
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$CreatedMoveCommand = function (a) {
	return {$: 12, a: a};
};
var $author$project$CheckpointData$Command$commandHelper = F2(
	function (environment, buildCommand) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Types$CommandId$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var commandId_ = _v0.a;
		var newEnvironment = _v0.b;
		return _Utils_Tuple2(
			newEnvironment,
			A2(
				$elm$core$Task$map,
				buildCommand(commandId_),
				$elm$time$Time$now));
	});
var $author$project$CheckpointData$Command$moveCheckpointAfter = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$MoveCheckpointAfter(
						{cC: model.cC, i5: model.i5, L: commandId_, M: commandTimestamp, ay: model.ay, l: model.l});
				}));
	});
var $author$project$CheckpointData$Command$moveCheckpointBefore = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$MoveCheckpointBefore(
						{cC: model.cC, i5: model.i5, L: commandId_, M: commandTimestamp, ax: model.ax, l: model.l});
				}));
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$createMoveCheckpointCommand = F4(
	function (environment, dragged, target, droppableState) {
		switch (droppableState) {
			case 0:
				return _Utils_eq(
					target.kw,
					$elm$core$Maybe$Just(dragged.i5)) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$Task$perform, $author$project$OrganisationUnit$CheckpointGroupEditor$CreatedMoveCommand, task);
					},
					A2(
						$author$project$CheckpointData$Command$moveCheckpointBefore,
						environment,
						{cC: target.cC, i5: dragged.i5, ax: target.i5, l: dragged.k8}));
			case 1:
				return _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_eq(
					target.kc,
					$elm$core$Maybe$Just(dragged.i5)) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$Task$perform, $author$project$OrganisationUnit$CheckpointGroupEditor$CreatedMoveCommand, task);
					},
					A2(
						$author$project$CheckpointData$Command$moveCheckpointAfter,
						environment,
						{cC: target.cC, i5: dragged.i5, ay: target.i5, l: dragged.k8}));
		}
	});
var $author$project$CheckpointData$Command$moveCheckpointGroupAfter = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$MoveCheckpointGroupAfter(
						{cC: model.cC, L: commandId_, M: commandTimestamp, km: model.km, ay: model.ay, l: model.l});
				}));
	});
var $author$project$CheckpointData$Command$moveCheckpointGroupBefore = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$MoveCheckpointGroupBefore(
						{cC: model.cC, L: commandId_, M: commandTimestamp, ax: model.ax, km: model.km, l: model.l});
				}));
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$createMoveCheckpointGroupCommand = F5(
	function (environment, organisationUnitId_, dragged, target, droppableState) {
		switch (droppableState) {
			case 0:
				return _Utils_eq(
					target.kw,
					$elm$core$Maybe$Just(dragged.cC)) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$Task$perform, $author$project$OrganisationUnit$CheckpointGroupEditor$CreatedMoveCommand, task);
					},
					A2(
						$author$project$CheckpointData$Command$moveCheckpointGroupBefore,
						environment,
						{cC: dragged.cC, ax: target.cC, km: organisationUnitId_, l: dragged.k8}));
			case 1:
				return _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_eq(
					target.kc,
					$elm$core$Maybe$Just(dragged.cC)) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$Task$perform, $author$project$OrganisationUnit$CheckpointGroupEditor$CreatedMoveCommand, task);
					},
					A2(
						$author$project$CheckpointData$Command$moveCheckpointGroupAfter,
						environment,
						{cC: dragged.cC, km: organisationUnitId_, ay: target.cC, l: dragged.k8}));
		}
	});
var $author$project$CheckpointData$Command$moveCheckpoint = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$MoveCheckpoint(
						{cC: model.cC, i5: model.i5, L: commandId_, M: commandTimestamp, l: model.l});
				}));
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$createMoveCheckpointOverGroupCommand = F4(
	function (environment, dragged, target, droppableState) {
		switch (droppableState) {
			case 0:
				return _Utils_eq(target.cC, dragged.cC) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$Task$perform, $author$project$OrganisationUnit$CheckpointGroupEditor$CreatedMoveCommand, task);
					},
					A2(
						$author$project$CheckpointData$Command$moveCheckpoint,
						environment,
						{cC: target.cC, i5: dragged.i5, l: dragged.k8}));
			case 1:
				return _Utils_eq(
					target.jT,
					$elm$core$Maybe$Just(dragged.i5)) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$Task$perform, $author$project$OrganisationUnit$CheckpointGroupEditor$CreatedMoveCommand, task);
					},
					A2(
						$author$project$CheckpointData$Command$moveCheckpoint,
						environment,
						{cC: target.cC, i5: dragged.i5, l: dragged.k8}));
			default:
				return _Utils_eq(target.cC, dragged.cC) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$Task$perform, $author$project$OrganisationUnit$CheckpointGroupEditor$CreatedMoveCommand, task);
					},
					A2(
						$author$project$CheckpointData$Command$moveCheckpoint,
						environment,
						{cC: target.cC, i5: dragged.i5, l: dragged.k8}));
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$createMoveCommand = F5(
	function (environment, organisationUnitId_, dragged, target, droppableState) {
		var _v0 = _Utils_Tuple2(dragged, target);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var draggedGroup = _v0.a.a;
				var targetGroup = _v0.b.a;
				return A5($author$project$OrganisationUnit$CheckpointGroupEditor$createMoveCheckpointGroupCommand, environment, organisationUnitId_, draggedGroup, targetGroup, droppableState);
			} else {
				return _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none);
			}
		} else {
			if (!_v0.b.$) {
				var draggedCheckpoint = _v0.a.a;
				var targetGroup = _v0.b.a;
				return A4($author$project$OrganisationUnit$CheckpointGroupEditor$createMoveCheckpointOverGroupCommand, environment, draggedCheckpoint, targetGroup, droppableState);
			} else {
				var draggedCheckpoint = _v0.a.a;
				var targetCheckpoint = _v0.b.a;
				return A4($author$project$OrganisationUnit$CheckpointGroupEditor$createMoveCheckpointCommand, environment, draggedCheckpoint, targetCheckpoint, droppableState);
			}
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$checkDragAndDropAction = F4(
	function (environment, organisationUnitId_, dndEvent, dnd) {
		if (dndEvent.$ === 2) {
			var dragged = dndEvent.a;
			var target = dndEvent.b;
			return _Utils_eq(dragged, target) ? _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none) : A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(environment, $elm$core$Platform$Cmd$none),
				A2(
					$elm$core$Maybe$map,
					function (droppableState) {
						return A5($author$project$OrganisationUnit$CheckpointGroupEditor$createMoveCommand, environment, organisationUnitId_, dragged, target, droppableState);
					},
					$author$project$UI$DragAndDrop$DragAndDrop$toDroppableState(dnd)));
		} else {
			return _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$checkpointGroupDnDEventDragEnd = F4(
	function (dnDEventMsg, environment, repository, _v0) {
		var editor = _v0;
		var _v1 = A4($author$project$OrganisationUnit$CheckpointGroupEditor$checkDragAndDropAction, environment, editor.km, dnDEventMsg, editor.a6);
		var newEnvironment = _v1.a;
		var cmd = _v1.b;
		return {
			ab: cmd,
			X: _Utils_update(
				editor,
				{
					a6: A2($author$project$UI$DragAndDrop$DragAndDrop$calculateDnd, dnDEventMsg, editor.a6)
				}),
			ac: newEnvironment,
			ae: repository
		};
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$changeLastWhenLastGroupIsChanged = F5(
	function (environment, previousCommands, command, repository, last_) {
		switch (command.$) {
			case 4:
				var payload = command.a;
				if (_Utils_eq(
					$elm$core$Maybe$Just(payload.ay),
					last_)) {
					return $elm$core$Maybe$Just(payload.cC);
				} else {
					if (_Utils_eq(
						$elm$core$Maybe$Just(payload.cC),
						last_)) {
						var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
						var tempResult = A3(
							$author$project$CheckpointData$CommandHandler$handleCommands,
							$author$project$CheckpointData$Commands$fromList(previousCommands),
							environment,
							checkpointData);
						var tempCheckpointData = function () {
							if (!tempResult.$) {
								var result = tempResult.a;
								return $author$project$Utils$Triple$first(
									A2($author$project$CheckpointData$EventApplier$applyEvents, result.b8, checkpointData));
							} else {
								return checkpointData;
							}
						}();
						return A2(
							$elm$core$Maybe$withDefault,
							last_,
							A2(
								$elm$core$Maybe$map,
								function (group) {
									return group.kw;
								},
								A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, tempCheckpointData)));
					} else {
						return last_;
					}
				}
			case 3:
				var payload = command.a;
				if (_Utils_eq(
					$elm$core$Maybe$Just(payload.cC),
					last_)) {
					var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
					var tempResult = A3(
						$author$project$CheckpointData$CommandHandler$handleCommands,
						$author$project$CheckpointData$Commands$fromList(previousCommands),
						environment,
						checkpointData);
					var tempCheckpointData = function () {
						if (!tempResult.$) {
							var result = tempResult.a;
							return $author$project$Utils$Triple$first(
								A2($author$project$CheckpointData$EventApplier$applyEvents, result.b8, checkpointData));
						} else {
							return checkpointData;
						}
					}();
					return A2(
						$elm$core$Maybe$withDefault,
						last_,
						A2(
							$elm$core$Maybe$map,
							function (group) {
								return group.kw;
							},
							A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, payload.cC, tempCheckpointData)));
				} else {
					return last_;
				}
			default:
				return last_;
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$withLast = F2(
	function (last_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{jT: last_});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$createdMoveCommand = F4(
	function (command, environment, repository, _v0) {
		var editor = _v0;
		var newEditor = _Utils_update(
			editor,
			{
				a7: _Utils_ap(
					editor.a7,
					_List_fromArray(
						[command]))
			});
		return {
			ab: $elm$core$Platform$Cmd$none,
			X: A2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$withLast,
				A5($author$project$OrganisationUnit$CheckpointGroupEditor$changeLastWhenLastGroupIsChanged, environment, editor.a7, command, repository, editor.jT),
				newEditor),
			ac: environment,
			ae: repository
		};
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$collapse = F2(
	function (id, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				cR: A2(
					$elm$core$List$filter,
					function (id_) {
						return !_Utils_eq(id_, id);
					},
					model.cR)
			});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$gotCollapseMsg = F4(
	function (id, environment, repository, editor) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			X: A2($author$project$OrganisationUnit$CheckpointGroupEditor$collapse, id, editor),
			ac: environment,
			ae: repository
		};
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$GotCreateCheckpointDialogMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$appendCommands = F2(
	function (commands_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{
				a7: A2($elm$core$List$append, editor.a7, commands_)
			});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$createCheckpointDialog = function (_v0) {
	var editor = _v0;
	return editor.fh;
};
var $author$project$CheckpointData$Checkpoint$CreateDialog$Hidden = {$: 0};
var $author$project$CheckpointData$Checkpoint$CreateDialog$createdCreateCommand = F4(
	function (_v0, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$Checkpoint$CreateDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$Checkpoint$CreateDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$CheckpointData$Checkpoint$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$Editor = $elm$core$Basics$identity;
var $author$project$CheckpointData$Checkpoint$TypeEditor$gotAddOptionMsg = function (editor) {
	var type_ = editor;
	var highestId = function (options) {
		var _v1 = $elm$core$List$head(
			$elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.fw;
					},
					options)));
		if (!_v1.$) {
			var option = _v1.a;
			return option.fw;
		} else {
			return 0;
		}
	};
	var createNewOption = function (listOption) {
		return A2(
			$author$project$CheckpointData$Checkpoint$CheckpointType$Option,
			highestId(listOption) + 1,
			'');
	};
	switch (type_.$) {
		case 5:
			var model = type_.a;
			return $author$project$CheckpointData$Checkpoint$CheckpointType$SelectType(
				_Utils_update(
					model,
					{
						fR: _Utils_ap(
							model.fR,
							_List_fromArray(
								[
									createNewOption(model.fR)
								]))
					}));
		case 6:
			var model = type_.a;
			return $author$project$CheckpointData$Checkpoint$CheckpointType$MultiSelectType(
				_Utils_update(
					model,
					{
						fR: _Utils_ap(
							model.fR,
							_List_fromArray(
								[
									createNewOption(model.fR)
								]))
					}));
		default:
			return editor;
	}
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$gotDeleteOptionMsg = F2(
	function (id, editor) {
		var type_ = editor;
		var updateOptions = function (list) {
			return A2(
				$elm$core$List$filter,
				function (option) {
					return !_Utils_eq(option.fw, id);
				},
				list);
		};
		switch (type_.$) {
			case 5:
				var model = type_.a;
				return $author$project$CheckpointData$Checkpoint$CheckpointType$SelectType(
					_Utils_update(
						model,
						{
							fR: updateOptions(model.fR)
						}));
			case 6:
				var model = type_.a;
				return $author$project$CheckpointData$Checkpoint$CheckpointType$MultiSelectType(
					_Utils_update(
						model,
						{
							fR: updateOptions(model.fR)
						}));
			default:
				return editor;
		}
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$gotEnteredInfoTextMsg = F2(
	function (value, editor) {
		var type_ = editor;
		if (type_.$ === 9) {
			var model = type_.a;
			return $author$project$CheckpointData$Checkpoint$CheckpointType$InfoType(
				_Utils_update(
					model,
					{hl: value}));
		} else {
			return editor;
		}
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$gotUpdateOptionMsg = F3(
	function (id, newText, editor) {
		var type_ = editor;
		var updateOption = function (option) {
			return (_Utils_eq(option.fw, id) && ($elm$core$String$length(newText) < 100)) ? _Utils_update(
				option,
				{hl: newText}) : option;
		};
		switch (type_.$) {
			case 5:
				var model = type_.a;
				return $author$project$CheckpointData$Checkpoint$CheckpointType$SelectType(
					_Utils_update(
						model,
						{
							fR: A2($elm$core$List$map, updateOption, model.fR)
						}));
			case 6:
				var model = type_.a;
				return $author$project$CheckpointData$Checkpoint$CheckpointType$MultiSelectType(
					_Utils_update(
						model,
						{
							fR: A2($elm$core$List$map, updateOption, model.fR)
						}));
			default:
				return editor;
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointType$numberModel = function (int_) {
	return (int_ <= 0) ? {hJ: 0} : {hJ: int_};
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$withType = F2(
	function (newType, _v0) {
		return newType;
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$gotUserEnteredDecimalDigitMsg = F2(
	function (inputValue, editor) {
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(inputValue)) ? A2(
			$author$project$CheckpointData$Checkpoint$TypeEditor$withType,
			$author$project$CheckpointData$Checkpoint$CheckpointType$NumberType(
				$author$project$CheckpointData$Checkpoint$CheckpointType$numberModel(0)),
			editor) : A2(
			$elm$core$Maybe$withDefault,
			editor,
			A2(
				$elm$core$Maybe$map,
				function (_int) {
					return A2(
						$author$project$CheckpointData$Checkpoint$TypeEditor$withType,
						$author$project$CheckpointData$Checkpoint$CheckpointType$NumberType(
							$author$project$CheckpointData$Checkpoint$CheckpointType$numberModel(_int)),
						editor);
				},
				$elm$core$String$toInt(inputValue)));
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$updateType = F2(
	function (newType, _v0) {
		var oldType = _v0;
		var _v1 = _Utils_Tuple2(oldType, newType);
		_v1$2:
		while (true) {
			switch (_v1.a.$) {
				case 5:
					if (_v1.b.$ === 6) {
						var oldModel = _v1.a.a;
						return $author$project$CheckpointData$Checkpoint$CheckpointType$MultiSelectType(oldModel);
					} else {
						break _v1$2;
					}
				case 6:
					if (_v1.b.$ === 5) {
						var oldModel = _v1.a.a;
						return $author$project$CheckpointData$Checkpoint$CheckpointType$SelectType(oldModel);
					} else {
						break _v1$2;
					}
				default:
					break _v1$2;
			}
		}
		return newType;
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$gotUserEnteredTypeMsg = F2(
	function (maybeType, editor) {
		return A2(
			$elm$core$Maybe$withDefault,
			editor,
			A2(
				$elm$core$Maybe$map,
				function (typeValue) {
					return A2($author$project$CheckpointData$Checkpoint$TypeEditor$updateType, typeValue, editor);
				},
				maybeType));
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$update = F3(
	function (msg, environment, editor) {
		switch (msg.$) {
			case 0:
				var newType = msg.a;
				return _Utils_Tuple2(
					A2($author$project$CheckpointData$Checkpoint$TypeEditor$gotUserEnteredTypeMsg, newType, editor),
					environment);
			case 1:
				var inputValue = msg.a;
				return _Utils_Tuple2(
					A2($author$project$CheckpointData$Checkpoint$TypeEditor$gotUserEnteredDecimalDigitMsg, inputValue, editor),
					environment);
			case 2:
				return _Utils_Tuple2(
					$author$project$CheckpointData$Checkpoint$TypeEditor$gotAddOptionMsg(editor),
					environment);
			case 3:
				var id = msg.a;
				var newText = msg.b;
				return _Utils_Tuple2(
					A3($author$project$CheckpointData$Checkpoint$TypeEditor$gotUpdateOptionMsg, id, newText, editor),
					environment);
			case 4:
				var id = msg.a;
				return _Utils_Tuple2(
					A2($author$project$CheckpointData$Checkpoint$TypeEditor$gotDeleteOptionMsg, id, editor),
					environment);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					A2($author$project$CheckpointData$Checkpoint$TypeEditor$gotEnteredInfoTextMsg, value, editor),
					environment);
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$gotTypeEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = A3($author$project$CheckpointData$Checkpoint$TypeEditor$update, editorMsg, environment, model.em);
				var newEditor = _v1.a;
				var newEnvironment = _v1.b;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$CheckpointData$Checkpoint$CreateDialog$Visible(
						_Utils_update(
							model,
							{em: newEditor})),
					ac: newEnvironment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$Checkpoint$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$Checkpoint$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$CreatedCreateCommand = function (a) {
	return {$: 7, a: a};
};
var $author$project$CheckpointData$Checkpoint$CreateDialog$HandlingCommand = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Command$createCheckpoint = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$CreateCheckpoint(
						{cC: model.cC, i5: model.i5, fg: model.fg, L: commandId_, M: commandTimestamp, aY: model.aY, cT: model.cT, kc: model.kc, kw: model.kw, k8: model.k8});
				}));
	});
var $author$project$CheckpointData$Checkpoint$Id$from = $elm$core$Basics$identity;
var $author$project$CheckpointData$Checkpoint$TypeEditor$getType = function (_v0) {
	var type_ = _v0;
	return type_;
};
var $author$project$CheckpointData$Checkpoint$CreateDialog$createCommand = F2(
	function (environment, model) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$CheckpointData$Checkpoint$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var checkpointId = _v0.a;
		var newEnvironment = _v0.b;
		return A2(
			$author$project$CheckpointData$Command$createCheckpoint,
			newEnvironment,
			{
				cC: model.fe.cC,
				i5: checkpointId,
				fg: $author$project$CheckpointData$Checkpoint$TypeEditor$getType(model.em),
				aY: $author$project$UI$BasicDataEditor$description(model.aQ),
				cT: $author$project$File$Filenames$empty,
				kc: $elm$core$Maybe$Nothing,
				kw: model.fe.jT,
				k8: $author$project$UI$BasicDataEditor$title(model.aQ)
			});
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$userClickedCreateButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var title = $author$project$UI$BasicDataEditor$title(model.aQ);
				if ($elm$core$String$isEmpty(title)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				} else {
					var _v1 = A2($author$project$CheckpointData$Checkpoint$CreateDialog$createCommand, environment, model);
					var newEnvironment = _v1.a;
					var task = _v1.b;
					return {
						ab: A2($elm$core$Task$perform, $author$project$CheckpointData$Checkpoint$CreateDialog$CreatedCreateCommand, task),
						jn: $author$project$CheckpointData$Checkpoint$CreateDialog$HandlingCommand(model),
						ac: newEnvironment,
						ae: repository
					};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$TypeStep = 1;
var $author$project$CheckpointData$Checkpoint$CreateDialog$switchStep = F2(
	function (step, model) {
		if (_Utils_eq(model.b0, step)) {
			return model;
		} else {
			var _v0 = model.b0;
			if (!_v0) {
				var title = $author$project$UI$BasicDataEditor$title(model.aQ);
				return $elm$core$String$isEmpty(title) ? model : _Utils_update(
					model,
					{
						aQ: A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ),
						b0: step
					});
			} else {
				return _Utils_update(
					model,
					{b0: step});
			}
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$nextStep = function (model) {
	var _v0 = model.b0;
	if (!_v0) {
		return A2($author$project$CheckpointData$Checkpoint$CreateDialog$switchStep, 1, model);
	} else {
		return model;
	}
};
var $author$project$CheckpointData$Checkpoint$CreateDialog$userClickedNextButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$CheckpointData$Checkpoint$CreateDialog$Visible(
						$author$project$CheckpointData$Checkpoint$CreateDialog$nextStep(model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$userClickedStepIcon = F4(
	function (step, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$CheckpointData$Checkpoint$CreateDialog$Visible(
						A2($author$project$CheckpointData$Checkpoint$CreateDialog$switchStep, step, model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$CheckpointData$Checkpoint$CreateDialog$userClickedCloseDialog;
		case 1:
			return $author$project$CheckpointData$Checkpoint$CreateDialog$userClickedNextButton;
		case 2:
			var step = msg.a;
			return $author$project$CheckpointData$Checkpoint$CreateDialog$userClickedStepIcon(step);
		case 3:
			return $author$project$CheckpointData$Checkpoint$CreateDialog$userClickedCancelButton;
		case 4:
			return $author$project$CheckpointData$Checkpoint$CreateDialog$userClickedCreateButton;
		case 5:
			var editorMsg = msg.a;
			return $author$project$CheckpointData$Checkpoint$CreateDialog$gotBasicDataEditorMsg(editorMsg);
		case 6:
			var editorMsg = msg.a;
			return $author$project$CheckpointData$Checkpoint$CreateDialog$gotTypeEditorMsg(editorMsg);
		default:
			var command = msg.a;
			return $author$project$CheckpointData$Checkpoint$CreateDialog$createdCreateCommand(command);
	}
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$withCreateCheckpointDialog = F2(
	function (createDialog_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{fh: createDialog_});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$gotCreateCheckpointDialogMsg = F4(
	function (dialogMsg, environment, repository, editor) {
		if (dialogMsg.$ === 7) {
			var command = dialogMsg.a;
			var result = A4(
				$author$project$CheckpointData$Checkpoint$CreateDialog$update,
				dialogMsg,
				environment,
				repository,
				$author$project$OrganisationUnit$CheckpointGroupEditor$createCheckpointDialog(editor));
			var newEditor = A2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$appendCommands,
				_List_fromArray(
					[command]),
				A2($author$project$OrganisationUnit$CheckpointGroupEditor$withCreateCheckpointDialog, result.jn, editor));
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CheckpointGroupEditor$GotCreateCheckpointDialogMsg, result.ab),
				X: newEditor,
				ac: result.ac,
				ae: result.ae
			};
		} else {
			var result = A4(
				$author$project$CheckpointData$Checkpoint$CreateDialog$update,
				dialogMsg,
				environment,
				repository,
				$author$project$OrganisationUnit$CheckpointGroupEditor$createCheckpointDialog(editor));
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CheckpointGroupEditor$GotCreateCheckpointDialogMsg, result.ab),
				X: A2($author$project$OrganisationUnit$CheckpointGroupEditor$withCreateCheckpointDialog, result.jn, editor),
				ac: result.ac,
				ae: result.ae
			};
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$GotCreateGroupDialogMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$appendFirstAndLast = F2(
	function (command, editor) {
		if (!command.$) {
			var createCheckpointGroupPayload = command.a;
			return A2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$withLast,
				$elm$core$Maybe$Just(createCheckpointGroupPayload.cC),
				editor);
		} else {
			return editor;
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$createGroupDialog = function (_v0) {
	var editor = _v0;
	return editor.fj;
};
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$Hidden = {$: 0};
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$createdCreateCommand = F4(
	function (_v0, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$CreateDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$CheckpointData$CheckpointGroup$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$CreatedCreateCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$HandlingCommand = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Command$createCheckpointGroup = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$CreateCheckpointGroup(
						{cC: model.cC, L: commandId_, M: commandTimestamp, aY: model.aY, jC: model.jC, jT: model.jT, kc: model.kc, km: model.km, kw: model.kw, k8: model.k8});
				}));
	});
var $author$project$CheckpointData$CheckpointGroup$Id$from = $elm$core$Basics$identity;
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$createCommand = F2(
	function (environment, model) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$CheckpointData$CheckpointGroup$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var checkpointGroupId = _v0.a;
		var newEnvironment = _v0.b;
		return A2(
			$author$project$CheckpointData$Command$createCheckpointGroup,
			newEnvironment,
			{
				cC: checkpointGroupId,
				aY: $author$project$UI$BasicDataEditor$description(model.aQ),
				cT: $author$project$File$Filenames$empty,
				jC: $elm$core$Maybe$Nothing,
				jT: $elm$core$Maybe$Nothing,
				kc: $elm$core$Maybe$Nothing,
				km: model.km,
				kw: model.gy,
				k8: $author$project$UI$BasicDataEditor$title(model.aQ)
			});
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$userClickedCreateButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var title = $author$project$UI$BasicDataEditor$title(model.aQ);
				if ($elm$core$String$isEmpty(title)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				} else {
					var _v1 = A2($author$project$CheckpointData$CheckpointGroup$CreateDialog$createCommand, environment, model);
					var newEnvironment = _v1.a;
					var task = _v1.b;
					return {
						ab: A2($elm$core$Task$perform, $author$project$CheckpointData$CheckpointGroup$CreateDialog$CreatedCreateCommand, task),
						jn: $author$project$CheckpointData$CheckpointGroup$CreateDialog$HandlingCommand(model),
						ac: newEnvironment,
						ae: repository
					};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$CheckpointData$CheckpointGroup$CreateDialog$userClickedCloseDialog;
		case 1:
			return $author$project$CheckpointData$CheckpointGroup$CreateDialog$userClickedCancelButton;
		case 2:
			return $author$project$CheckpointData$CheckpointGroup$CreateDialog$userClickedCreateButton;
		case 3:
			var editorMsg = msg.a;
			return $author$project$CheckpointData$CheckpointGroup$CreateDialog$gotBasicDataEditorMsg(editorMsg);
		default:
			var command = msg.a;
			return $author$project$CheckpointData$CheckpointGroup$CreateDialog$createdCreateCommand(command);
	}
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$withCreateGroupDialog = F2(
	function (createDialog_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{fj: createDialog_});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$gotCreateGroupDialogMsg = F4(
	function (dialogMsg, environment, repository, editor) {
		if (dialogMsg.$ === 4) {
			var command = dialogMsg.a;
			var result = A4(
				$author$project$CheckpointData$CheckpointGroup$CreateDialog$update,
				dialogMsg,
				environment,
				repository,
				$author$project$OrganisationUnit$CheckpointGroupEditor$createGroupDialog(editor));
			var newEditor = A2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$appendFirstAndLast,
				command,
				A2(
					$author$project$OrganisationUnit$CheckpointGroupEditor$appendCommands,
					_List_fromArray(
						[command]),
					A2($author$project$OrganisationUnit$CheckpointGroupEditor$withCreateGroupDialog, result.jn, editor)));
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CheckpointGroupEditor$GotCreateGroupDialogMsg, result.ab),
				X: newEditor,
				ac: environment,
				ae: repository
			};
		} else {
			var result = A4(
				$author$project$CheckpointData$CheckpointGroup$CreateDialog$update,
				dialogMsg,
				environment,
				repository,
				$author$project$OrganisationUnit$CheckpointGroupEditor$createGroupDialog(editor));
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CheckpointGroupEditor$GotCreateGroupDialogMsg, result.ab),
				X: A2($author$project$OrganisationUnit$CheckpointGroupEditor$withCreateGroupDialog, result.jn, editor),
				ac: result.ac,
				ae: result.ae
			};
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$GotEditCheckpointDialogMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$editCheckpointDialog = function (_v0) {
	var editor = _v0;
	return editor.fo;
};
var $author$project$CheckpointData$Checkpoint$EditDialog$Hidden = {$: 0};
var $author$project$CheckpointData$Checkpoint$EditDialog$createdCommands = F4(
	function (_v0, environment, _v1, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$Checkpoint$EditDialog$Hidden, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$Checkpoint$EditDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$CheckpointData$Checkpoint$EditDialog$Visible(
						_Utils_update(
							model,
							{
								aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
							})),
					ac: environment
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$gotTypeEditorMsg = F4(
	function (editorMsg, environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				var model = dialog.a;
				var _v2 = A3($author$project$CheckpointData$Checkpoint$TypeEditor$update, editorMsg, environment, model.em);
				var newEditor = _v2.a;
				var newEnvironment = _v2.b;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$CheckpointData$Checkpoint$EditDialog$Visible(
						_Utils_update(
							model,
							{em: newEditor})),
					ac: newEnvironment
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$CreatedCommands = function (a) {
	return {$: 8, a: a};
};
var $author$project$CheckpointData$Checkpoint$EditDialog$Deleted = {$: 3};
var $author$project$CheckpointData$Checkpoint$EditDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Command$changeCheckpointDescription = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$ChangeCheckpointDescription(
						{i5: model.i5, L: commandId_, M: commandTimestamp, aY: model.aY, l: model.l});
				}));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$withChangeDescriptionCommand = F3(
	function (checkpoint, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		if ($elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$description(basicDataEditor)) || _Utils_eq(
			$author$project$UI$BasicDataEditor$description(basicDataEditor),
			checkpoint.aY)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {
				i5: checkpoint.i5,
				aY: $author$project$UI$BasicDataEditor$description(basicDataEditor),
				l: checkpoint.k8
			};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$CheckpointData$Command$changeCheckpointDescription, environment, data));
		}
	});
var $author$project$CheckpointData$Command$changeCheckpointTitle = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$ChangeCheckpointTitle(
						{i5: model.i5, L: commandId_, M: commandTimestamp, k8: model.k8, l: model.l});
				}));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$withChangeTitleCommand = F3(
	function (checkpoint, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		if ($elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor)) || _Utils_eq(
			$author$project$UI$BasicDataEditor$title(basicDataEditor),
			checkpoint.k8)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {
				i5: checkpoint.i5,
				k8: $author$project$UI$BasicDataEditor$title(basicDataEditor),
				l: checkpoint.k8
			};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$CheckpointData$Command$changeCheckpointTitle, environment, data));
		}
	});
var $author$project$CheckpointData$Command$changeCheckpointType = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$ChangeCheckpointType(
						{i5: model.i5, fg: model.fg, L: commandId_, M: commandTimestamp, l: model.l});
				}));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$withChangeTypeCommand = F3(
	function (checkpoint, typeEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		if (_Utils_eq(
			$author$project$CheckpointData$Checkpoint$TypeEditor$getType(typeEditor),
			checkpoint.fg)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {
				i5: checkpoint.i5,
				fg: $author$project$CheckpointData$Checkpoint$TypeEditor$getType(typeEditor),
				l: checkpoint.k8
			};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$CheckpointData$Command$changeCheckpointType, environment, data));
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$createCommands = F3(
	function (environment, checkpoint, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A3(
				$author$project$CheckpointData$Checkpoint$EditDialog$withChangeTypeCommand,
				checkpoint,
				model.em,
				A3(
					$author$project$CheckpointData$Checkpoint$EditDialog$withChangeDescriptionCommand,
					checkpoint,
					model.aQ,
					A3(
						$author$project$CheckpointData$Checkpoint$EditDialog$withChangeTitleCommand,
						checkpoint,
						model.aQ,
						_Utils_Tuple2(environment, _List_Nil)))));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$userClickedApplyButton = F3(
	function (environment, tempCheckpointData, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				var model = dialog.a;
				var _v1 = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, model.bi.i5, tempCheckpointData);
				if (_v1.$ === 1) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$Checkpoint$EditDialog$Deleted, ac: environment};
				} else {
					var checkpoint = _v1.a;
					var _v2 = A3($author$project$CheckpointData$Checkpoint$EditDialog$createCommands, environment, checkpoint, model);
					var newEnvironment = _v2.a;
					var tasks = _v2.b;
					return {
						ab: A2(
							$elm$core$Task$perform,
							$author$project$CheckpointData$Checkpoint$EditDialog$CreatedCommands,
							$elm$core$Task$sequence(tasks)),
						jn: $author$project$CheckpointData$Checkpoint$EditDialog$HandlingCommands(model),
						ac: newEnvironment
					};
				}
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$userClickedCancelButton = F3(
	function (environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$Checkpoint$EditDialog$Hidden, ac: environment};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$userClickedCloseButton = F3(
	function (environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$Checkpoint$EditDialog$Hidden, ac: environment};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$Checkpoint$EditDialog$Hidden, ac: environment};
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$userClickedCloseDialog = F3(
	function (environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$Checkpoint$EditDialog$Hidden, ac: environment};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$Checkpoint$EditDialog$Hidden, ac: environment};
		}
	});
var $author$project$CheckpointData$Command$deleteCheckpoint = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$DeleteCheckpoint(
						{i5: model.i5, L: commandId_, M: commandTimestamp, l: model.l});
				}));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$userClickedDeleteButton = F3(
	function (environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				var model = dialog.a;
				var data = {i5: model.bi.i5, l: model.bi.k8};
				var _v2 = A2(
					$elm$core$Tuple$mapSecond,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Task$sequence,
							$elm$core$Task$perform($author$project$CheckpointData$Checkpoint$EditDialog$CreatedCommands))),
					A2($author$project$CheckpointData$Command$deleteCheckpoint, environment, data));
				var newEnvironment = _v2.a;
				var cmd = _v2.b;
				return {
					ab: cmd,
					jn: $author$project$CheckpointData$Checkpoint$EditDialog$HandlingCommands(model),
					ac: newEnvironment
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$BasicDataTab = 0;
var $author$project$CheckpointData$Checkpoint$EditDialog$switchTab = F2(
	function (tab, model) {
		if (_Utils_eq(model.cI, tab)) {
			return model;
		} else {
			if (!model.cI) {
				var title = $author$project$UI$BasicDataEditor$title(model.aQ);
				return _Utils_update(
					model,
					{
						aQ: A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ),
						cI: tab
					});
			} else {
				return _Utils_update(
					model,
					{cI: tab});
			}
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$userClickedTabIcon = F4(
	function (tab, environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$CheckpointData$Checkpoint$EditDialog$Visible(
						A2($author$project$CheckpointData$Checkpoint$EditDialog$switchTab, tab, model)),
					ac: environment
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$CheckpointData$Checkpoint$EditDialog$userClickedCloseDialog;
		case 1:
			var tab = msg.a;
			return $author$project$CheckpointData$Checkpoint$EditDialog$userClickedTabIcon(tab);
		case 2:
			return $author$project$CheckpointData$Checkpoint$EditDialog$userClickedCancelButton;
		case 3:
			return $author$project$CheckpointData$Checkpoint$EditDialog$userClickedApplyButton;
		case 4:
			return $author$project$CheckpointData$Checkpoint$EditDialog$userClickedDeleteButton;
		case 5:
			return $author$project$CheckpointData$Checkpoint$EditDialog$userClickedCloseButton;
		case 6:
			var editorMsg = msg.a;
			return $author$project$CheckpointData$Checkpoint$EditDialog$gotBasicDataEditorMsg(editorMsg);
		case 7:
			var editorMsg = msg.a;
			return $author$project$CheckpointData$Checkpoint$EditDialog$gotTypeEditorMsg(editorMsg);
		default:
			var commands = msg.a;
			return $author$project$CheckpointData$Checkpoint$EditDialog$createdCommands(commands);
	}
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$withEditCheckpointDialog = F2(
	function (editDialog_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{fo: editDialog_});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$gotEditCheckpointDialogMsg = F4(
	function (dialogMsg, environment, repository, editor) {
		var model = editor;
		var tempCheckpointData = function () {
			var _v1 = A3(
				$author$project$CheckpointData$CommandHandler$handleCommands,
				$author$project$CheckpointData$Commands$fromList(model.a7),
				environment,
				$author$project$Environments$Repository$getCheckpointData(repository));
			if (!_v1.$) {
				var result = _v1.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$Repository$getCheckpointData,
					A4($author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations, result.cD, result.b8, result.cb, repository)).a;
			} else {
				return $author$project$Environments$Repository$getCheckpointData(repository);
			}
		}();
		if (dialogMsg.$ === 8) {
			var commands_ = dialogMsg.a;
			var result = A4(
				$author$project$CheckpointData$Checkpoint$EditDialog$update,
				dialogMsg,
				environment,
				tempCheckpointData,
				$author$project$OrganisationUnit$CheckpointGroupEditor$editCheckpointDialog(editor));
			var newEditor = A2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$appendCommands,
				commands_,
				A2($author$project$OrganisationUnit$CheckpointGroupEditor$withEditCheckpointDialog, result.jn, editor));
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CheckpointGroupEditor$GotEditCheckpointDialogMsg, result.ab),
				X: newEditor,
				ac: result.ac,
				ae: repository
			};
		} else {
			var result = A4(
				$author$project$CheckpointData$Checkpoint$EditDialog$update,
				dialogMsg,
				environment,
				tempCheckpointData,
				$author$project$OrganisationUnit$CheckpointGroupEditor$editCheckpointDialog(editor));
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CheckpointGroupEditor$GotEditCheckpointDialogMsg, result.ab),
				X: A2($author$project$OrganisationUnit$CheckpointGroupEditor$withEditCheckpointDialog, result.jn, editor),
				ac: result.ac,
				ae: repository
			};
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$GotEditGroupDialogMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$editGroupDialog = function (_v0) {
	var editor = _v0;
	return editor.fp;
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$last = function (_v0) {
	var editor = _v0;
	return editor.jT;
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$Hidden = {$: 0};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$createdCommands = F4(
	function (_v0, environment, _v1, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$Hidden, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$createdDeleteCommand = F4(
	function (_v0, environment, _v1, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$Hidden, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$Visible(
						_Utils_update(
							model,
							{
								aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
							})),
					ac: environment
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$CreatedCommands = function (a) {
	return {$: 7, a: a};
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$Deleted = {$: 3};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Command$changeCheckpointGroupDescription = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$ChangeCheckpointGroupDescription(
						{cC: model.cC, L: commandId_, M: commandTimestamp, aY: model.aY, l: model.l});
				}));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$withChangeDescriptionCommand = F3(
	function (checkpointGroup, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var _v1 = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$description(basicDataEditor));
		if (_v1 === '') {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var description = _v1;
			return _Utils_eq(description, checkpointGroup.aY) ? _Utils_Tuple2(environment, tasks) : A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2(
					$author$project$CheckpointData$Command$changeCheckpointGroupDescription,
					environment,
					{cC: checkpointGroup.cC, aY: description, l: checkpointGroup.k8}));
		}
	});
var $author$project$CheckpointData$Command$changeCheckpointGroupTitle = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$ChangeCheckpointGroupTitle(
						{cC: model.cC, L: commandId_, M: commandTimestamp, k8: model.k8, l: model.l});
				}));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$withChangeTitleCommand = F3(
	function (checkpointGroup, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var _v1 = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		if (_v1 === '') {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var title = _v1;
			return _Utils_eq(title, checkpointGroup.k8) ? _Utils_Tuple2(environment, tasks) : A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2(
					$author$project$CheckpointData$Command$changeCheckpointGroupTitle,
					environment,
					{cC: checkpointGroup.cC, k8: title, l: checkpointGroup.k8}));
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$createCommands = F3(
	function (environment, checkpointGroup, model) {
		return A3(
			$author$project$CheckpointData$CheckpointGroup$EditDialog$withChangeDescriptionCommand,
			checkpointGroup,
			model.aQ,
			A3(
				$author$project$CheckpointData$CheckpointGroup$EditDialog$withChangeTitleCommand,
				checkpointGroup,
				model.aQ,
				_Utils_Tuple2(environment, _List_Nil)));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedApplyButton = F3(
	function (environment, tempCheckpointData, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				var model = dialog.a;
				var _v1 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, model.cC, tempCheckpointData);
				if (_v1.$ === 1) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$Deleted, ac: environment};
				} else {
					var checkpointGroup = _v1.a;
					var _v2 = A3($author$project$CheckpointData$CheckpointGroup$EditDialog$createCommands, environment, checkpointGroup, model);
					var newEnvironment = _v2.a;
					var task = _v2.b;
					return {
						ab: A2(
							$elm$core$Task$perform,
							$author$project$CheckpointData$CheckpointGroup$EditDialog$CreatedCommands,
							$elm$core$Task$sequence(task)),
						jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$HandlingCommands(model),
						ac: newEnvironment
					};
				}
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedCancelButton = F3(
	function (environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$Hidden, ac: environment};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedCloseButton = F3(
	function (environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$Hidden, ac: environment};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$Hidden, ac: environment};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedCloseDialog = F3(
	function (environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$Hidden, ac: environment};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$Hidden, ac: environment};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$CreatedDeleteCommand = function (a) {
	return {$: 8, a: a};
};
var $author$project$CheckpointData$Command$deleteCheckpointGroup = F2(
	function (environment, model) {
		return A2(
			$author$project$CheckpointData$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$CheckpointData$Command$DeleteCheckpointGroup(
						{cC: model.cC, L: commandId_, M: commandTimestamp, kc: model.kc, km: model.km, kw: model.kw, l: model.l});
				}));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedDeleteButton = F3(
	function (environment, tempCheckpointData, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				var model = dialog.a;
				var _v1 = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, model.cC, tempCheckpointData);
				if (!_v1.$) {
					var checkpointGroup = _v1.a;
					var data = {cC: checkpointGroup.cC, kc: checkpointGroup.kc, km: checkpointGroup.km, kw: checkpointGroup.kw, l: checkpointGroup.k8};
					var _v2 = A2($author$project$CheckpointData$Command$deleteCheckpointGroup, environment, data);
					var newEnvironment = _v2.a;
					var task = _v2.b;
					return {
						ab: A2($elm$core$Task$perform, $author$project$CheckpointData$CheckpointGroup$EditDialog$CreatedDeleteCommand, task),
						jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$HandlingCommands(model),
						ac: newEnvironment
					};
				} else {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
				}
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$BasicDataTab = 0;
var $author$project$CheckpointData$CheckpointGroup$EditDialog$switchTab = F2(
	function (tab, model) {
		if (_Utils_eq(model.cI, tab)) {
			return model;
		} else {
			if (!model.cI) {
				var title = $author$project$UI$BasicDataEditor$title(model.aQ);
				return _Utils_update(
					model,
					{
						aQ: A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ),
						cI: tab
					});
			} else {
				return _Utils_update(
					model,
					{cI: tab});
			}
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedTabIcon = F4(
	function (tab, environment, _v0, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$CheckpointData$CheckpointGroup$EditDialog$Visible(
						A2($author$project$CheckpointData$CheckpointGroup$EditDialog$switchTab, tab, model)),
					ac: environment
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment};
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedCloseDialog;
		case 1:
			var tab = msg.a;
			return $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedTabIcon(tab);
		case 2:
			return $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedCancelButton;
		case 3:
			return $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedApplyButton;
		case 4:
			return $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedDeleteButton;
		case 5:
			return $author$project$CheckpointData$CheckpointGroup$EditDialog$userClickedCloseButton;
		case 6:
			var editorMsg = msg.a;
			return $author$project$CheckpointData$CheckpointGroup$EditDialog$gotBasicDataEditorMsg(editorMsg);
		case 7:
			var command = msg.a;
			return $author$project$CheckpointData$CheckpointGroup$EditDialog$createdCommands(command);
		default:
			var command = msg.a;
			return $author$project$CheckpointData$CheckpointGroup$EditDialog$createdDeleteCommand(command);
	}
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$withEditGroupDialog = F2(
	function (editDialog_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{fp: editDialog_});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$gotEditGroupDialogMsg = F4(
	function (dialogMsg, environment, repository, editor) {
		var model = editor;
		var tempCheckpointData = function () {
			var _v2 = A3(
				$author$project$CheckpointData$CommandHandler$handleCommands,
				$author$project$CheckpointData$Commands$fromList(model.a7),
				environment,
				$author$project$Environments$Repository$getCheckpointData(repository));
			if (!_v2.$) {
				var result = _v2.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$Repository$getCheckpointData,
					A4($author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations, result.cD, result.b8, result.cb, repository)).a;
			} else {
				return $author$project$Environments$Repository$getCheckpointData(repository);
			}
		}();
		switch (dialogMsg.$) {
			case 7:
				var commands_ = dialogMsg.a;
				var result = A4(
					$author$project$CheckpointData$CheckpointGroup$EditDialog$update,
					dialogMsg,
					environment,
					tempCheckpointData,
					$author$project$OrganisationUnit$CheckpointGroupEditor$editGroupDialog(editor));
				var newEditor = A2(
					$author$project$OrganisationUnit$CheckpointGroupEditor$appendCommands,
					commands_,
					A2($author$project$OrganisationUnit$CheckpointGroupEditor$withEditGroupDialog, result.jn, editor));
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CheckpointGroupEditor$GotEditGroupDialogMsg, result.ab),
					X: newEditor,
					ac: result.ac,
					ae: repository
				};
			case 8:
				var command_ = dialogMsg.a;
				var result = A4(
					$author$project$CheckpointData$CheckpointGroup$EditDialog$update,
					dialogMsg,
					environment,
					tempCheckpointData,
					$author$project$OrganisationUnit$CheckpointGroupEditor$editGroupDialog(editor));
				var newLast = function () {
					if (command_.$ === 5) {
						var payload = command_.a;
						return $author$project$Utils$Maybe$isJust(payload.kc) ? $author$project$OrganisationUnit$CheckpointGroupEditor$last(editor) : payload.kw;
					} else {
						return $author$project$OrganisationUnit$CheckpointGroupEditor$last(editor);
					}
				}();
				var newEditor = A2(
					$author$project$OrganisationUnit$CheckpointGroupEditor$withLast,
					newLast,
					A2(
						$author$project$OrganisationUnit$CheckpointGroupEditor$appendCommands,
						_List_fromArray(
							[command_]),
						A2($author$project$OrganisationUnit$CheckpointGroupEditor$withEditGroupDialog, result.jn, editor)));
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CheckpointGroupEditor$GotEditGroupDialogMsg, result.ab),
					X: newEditor,
					ac: result.ac,
					ae: repository
				};
			default:
				var result = A4(
					$author$project$CheckpointData$CheckpointGroup$EditDialog$update,
					dialogMsg,
					environment,
					tempCheckpointData,
					$author$project$OrganisationUnit$CheckpointGroupEditor$editGroupDialog(editor));
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CheckpointGroupEditor$GotEditGroupDialogMsg, result.ab),
					X: A2($author$project$OrganisationUnit$CheckpointGroupEditor$withEditGroupDialog, result.jn, editor),
					ac: result.ac,
					ae: repository
				};
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$expand = F2(
	function (id, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				cR: A2($elm$core$List$cons, id, model.cR)
			});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$gotExpandMsg = F4(
	function (id, environment, repository, editor) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			X: A2($author$project$OrganisationUnit$CheckpointGroupEditor$expand, id, editor),
			ac: environment,
			ae: repository
		};
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$BasicDataStep = 0;
var $author$project$CheckpointData$Checkpoint$CheckpointType$defaultNumberModel = {hJ: 0};
var $author$project$CheckpointData$Checkpoint$TypeEditor$default = $author$project$CheckpointData$Checkpoint$CheckpointType$NumberType($author$project$CheckpointData$Checkpoint$CheckpointType$defaultNumberModel);
var $author$project$CheckpointData$Checkpoint$CreateDialog$show = function (checkpointGroup) {
	return $author$project$CheckpointData$Checkpoint$CreateDialog$Visible(
		{aQ: $author$project$UI$BasicDataEditor$default, fe: checkpointGroup, b0: 0, em: $author$project$CheckpointData$Checkpoint$TypeEditor$default});
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$userClickedCreateCheckpointIcon = F4(
	function (checkpointGroup, environment, repository, editor) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			X: A2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$withCreateCheckpointDialog,
				$author$project$CheckpointData$Checkpoint$CreateDialog$show(checkpointGroup),
				editor),
			ac: environment,
			ae: repository
		};
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$unwrap = function (_v0) {
	var editor = _v0;
	return editor;
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$organisationUnitId = A2(
	$elm$core$Basics$composeR,
	$author$project$OrganisationUnit$CheckpointGroupEditor$unwrap,
	function ($) {
		return $.km;
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$show = F2(
	function (organisationUnitId, currentLastValue) {
		return $author$project$CheckpointData$CheckpointGroup$CreateDialog$Visible(
			{aQ: $author$project$UI$BasicDataEditor$default, gy: currentLastValue, km: organisationUnitId});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$userClickedCreateGroupIcon = F3(
	function (environment, repository, editor) {
		var organisationUnitId_ = $author$project$OrganisationUnit$CheckpointGroupEditor$organisationUnitId(editor);
		var currentlyLast = $author$project$OrganisationUnit$CheckpointGroupEditor$last(editor);
		return {
			ab: $elm$core$Platform$Cmd$none,
			X: A2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$withCreateGroupDialog,
				A2($author$project$CheckpointData$CheckpointGroup$CreateDialog$show, organisationUnitId_, currentlyLast),
				editor),
			ac: environment,
			ae: repository
		};
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$init = function (type_) {
	return type_;
};
var $author$project$CheckpointData$Checkpoint$EditDialog$show = function (checkpoint) {
	return $author$project$CheckpointData$Checkpoint$EditDialog$Visible(
		{
			aQ: $author$project$UI$BasicDataEditor$from(checkpoint),
			bi: checkpoint,
			cI: 0,
			em: $author$project$CheckpointData$Checkpoint$TypeEditor$init(checkpoint.fg)
		});
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$userClickedEditCheckpointIcon = F4(
	function (checkpointTemplate, environment, repository, editor) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			X: A2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$withEditCheckpointDialog,
				$author$project$CheckpointData$Checkpoint$EditDialog$show(checkpointTemplate),
				editor),
			ac: environment,
			ae: repository
		};
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$show = function (checkpointGroup) {
	return $author$project$CheckpointData$CheckpointGroup$EditDialog$Visible(
		{
			aQ: $author$project$UI$BasicDataEditor$from(checkpointGroup),
			cC: checkpointGroup.cC,
			cI: 0
		});
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$userClickedEditGroupIcon = F4(
	function (checkpointGroup, environment, repository, editor) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			X: A2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$withEditGroupDialog,
				$author$project$CheckpointData$CheckpointGroup$EditDialog$show(checkpointGroup),
				editor),
			ac: environment,
			ae: repository
		};
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$OrganisationUnit$CheckpointGroupEditor$userClickedCreateGroupIcon;
		case 1:
			var checkpointGroup = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$userClickedEditGroupIcon(checkpointGroup);
		case 2:
			var parent = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$userClickedCreateCheckpointIcon(parent);
		case 3:
			var checkpoint = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$userClickedEditCheckpointIcon(checkpoint);
		case 4:
			var dialogMsg = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$gotCreateGroupDialogMsg(dialogMsg);
		case 5:
			var dialogMsg = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$gotEditGroupDialogMsg(dialogMsg);
		case 6:
			var dialogMsg = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$gotCreateCheckpointDialogMsg(dialogMsg);
		case 7:
			var dialogMsg = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$gotEditCheckpointDialogMsg(dialogMsg);
		case 8:
			var id = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$gotExpandMsg(id);
		case 9:
			var id = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$gotCollapseMsg(id);
		case 10:
			var dnDEventMsg = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$checkpointGroupDnDEvent(dnDEventMsg);
		case 11:
			var dnDEventMsg = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$checkpointGroupDnDEventDragEnd(dnDEventMsg);
		default:
			var command = msg.a;
			return $author$project$OrganisationUnit$CheckpointGroupEditor$createdMoveCommand(command);
	}
};
var $author$project$OrganisationUnit$CreateDialog$gotCheckpointGroupEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var result = A4($author$project$OrganisationUnit$CheckpointGroupEditor$update, editorMsg, environment, repository, model.cB);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CreateDialog$GotCheckpointGroupEditorMsg, result.ab),
					jn: $author$project$OrganisationUnit$CreateDialog$Visible(
						_Utils_update(
							model,
							{cB: result.X})),
					ac: result.ac,
					ae: result.ae
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$CreateDialog$CreatedCommands = function (a) {
	return {$: 9, a: a};
};
var $author$project$OrganisationUnit$CreateDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$BasicDataEditor$color = function (editor) {
	var _v0 = $author$project$UI$BasicDataEditor$colorPicker(editor);
	if (!_v0.$) {
		return A4($author$project$UI$Style$Color$rgba, 56 / 255, 92 / 255, 107 / 255, 0.75);
	} else {
		var withColorPickerModel = _v0.a;
		return withColorPickerModel.K;
	}
};
var $author$project$OrganisationUnit$Command$createChild = F2(
	function (environment, model) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$CreateChild(
						{K: model.K, L: commandId_, M: commandTimestamp, aY: model.aY, ao: model.ao, ap: model.ap, jU: model.jU, km: model.km, fV: model.fV, k8: model.k8});
				}));
	});
var $author$project$UI$ImageEditor$image = function (_v0) {
	var config = _v0;
	return config.bH;
};
var $author$project$OrganisationUnit$FloorPlanEditor$floorPlan = function (_v0) {
	var config = _v0;
	return $author$project$UI$ImageEditor$image(config.cY);
};
var $author$project$OrganisationUnit$CreateDialog$withCreateChildCommand = F3(
	function (parentId, model, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var title = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$title(model.aQ));
		var description = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$description(model.aQ));
		return A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$OrganisationUnit$Command$createChild,
				environment,
				{
					K: $author$project$UI$BasicDataEditor$color(model.aQ),
					aY: description,
					ao: $elm$core$Maybe$Nothing,
					ap: $author$project$OrganisationUnit$FloorPlanEditor$floorPlan(model.cU),
					jU: $elm$core$Maybe$Nothing,
					km: model.km,
					fV: parentId,
					k8: title
				}));
	});
var $author$project$OrganisationUnit$CreateDialog$createChildCommands = F3(
	function (parentId, environment, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A3(
				$author$project$OrganisationUnit$CreateDialog$withCreateChildCommand,
				parentId,
				model,
				_Utils_Tuple2(environment, _List_Nil)));
	});
var $author$project$OrganisationUnit$Command$create = F2(
	function (environment, model) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$Create(
						{K: model.K, L: commandId_, M: commandTimestamp, aY: model.aY, ao: model.ao, ap: model.ap, jU: model.jU, km: model.km, k8: model.k8});
				}));
	});
var $author$project$OrganisationUnit$CreateDialog$withCreateCommand = F2(
	function (model, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var title = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$title(model.aQ));
		var description = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$description(model.aQ));
		return A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$OrganisationUnit$Command$create,
				environment,
				{
					K: $author$project$UI$BasicDataEditor$color(model.aQ),
					aY: description,
					ao: $elm$core$Maybe$Nothing,
					ap: $author$project$OrganisationUnit$FloorPlanEditor$floorPlan(model.cU),
					jU: $elm$core$Maybe$Nothing,
					km: model.km,
					k8: title
				}));
	});
var $author$project$OrganisationUnit$CreateDialog$createCommands = F2(
	function (environment, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A2(
				$author$project$OrganisationUnit$CreateDialog$withCreateCommand,
				model,
				_Utils_Tuple2(environment, _List_Nil)));
	});
var $author$project$OrganisationUnit$CreateDialog$gotCurrentTimestamp = F4(
	function (posix, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 2:
				var model = dialog.a;
				var _v1 = function () {
					var _v2 = model.gx;
					if (!_v2.$) {
						return A2($author$project$OrganisationUnit$CreateDialog$createCommands, environment, model);
					} else {
						var parentId = _v2.a;
						return A3($author$project$OrganisationUnit$CreateDialog$createChildCommands, parentId, environment, model);
					}
				}();
				var newEnvironment = _v1.a;
				var tasks = _v1.b;
				return {
					ab: A2(
						$elm$core$Task$perform,
						$author$project$OrganisationUnit$CreateDialog$CreatedCommands,
						$elm$core$Task$sequence(tasks)),
					jn: $author$project$OrganisationUnit$CreateDialog$HandlingCommands(
						_Utils_update(
							model,
							{fX: posix})),
					ac: newEnvironment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$FloorPlanEditor$Editor = $elm$core$Basics$identity;
var $author$project$UI$ImageEditor$Editor = $elm$core$Basics$identity;
var $author$project$UI$ImageEditor$SelectImage = 1;
var $author$project$UI$ImageEditor$TakePhoto = 0;
var $author$project$UI$ImageEditor$encodeOutMsg = function (outMsg) {
	if (!outMsg) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('TAKE_PHOTO'))
				]));
	} else {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('SELECT_IMAGE'))
				]));
	}
};
var $author$project$UI$ImageEditor$imageEditorOutbox = _Platform_outgoingPort('imageEditorOutbox', $elm$core$Basics$identity);
var $author$project$UI$ImageEditor$send = A2($elm$core$Basics$composeR, $author$project$UI$ImageEditor$encodeOutMsg, $author$project$UI$ImageEditor$imageEditorOutbox);
var $author$project$UI$ImageEditor$update = F2(
	function (msg, editor) {
		var config = editor;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						config,
						{cA: false}),
					$author$project$UI$ImageEditor$send(0));
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						config,
						{cA: false}),
					$author$project$UI$ImageEditor$send(1));
			case 2:
				var filename = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						config,
						{bH: $elm$core$Maybe$Nothing, cA: false}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var filename = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						config,
						{
							bH: $elm$core$Maybe$Just(filename)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var filename = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						config,
						{
							bH: $elm$core$Maybe$Just(filename)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(editor, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						config,
						{cA: true}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$OrganisationUnit$FloorPlanEditor$gotImageEditorMsg = F2(
	function (editorMsg, _v0) {
		var config = _v0;
		var _v1 = A2($author$project$UI$ImageEditor$update, editorMsg, config.cY);
		var newConfig = _v1.a;
		var imageEditorCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				config,
				{cY: newConfig}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, imageEditorCmd));
	});
var $author$project$OrganisationUnit$FloorPlanEditor$update = function (msg) {
	var editorMsg = msg;
	return $author$project$OrganisationUnit$FloorPlanEditor$gotImageEditorMsg(editorMsg);
};
var $author$project$OrganisationUnit$CreateDialog$gotFloorPlanEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = A2($author$project$OrganisationUnit$FloorPlanEditor$update, editorMsg, model.cU);
				var editor = _v1.a;
				var editorCmd = _v1.b;
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$CreateDialog$GotFloorPlanEditorMsg, editorCmd),
					jn: $author$project$OrganisationUnit$CreateDialog$Visible(
						_Utils_update(
							model,
							{cU: editor})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$CreateDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$OrganisationUnit$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$CreateDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$OrganisationUnit$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$CreateDialog$GotCurrentTimestamp = function (a) {
	return {$: 3, a: a};
};
var $author$project$OrganisationUnit$CreateDialog$userClickedCreateButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return $author$project$Utils$String$isBlank(
					$author$project$UI$BasicDataEditor$title(model.aQ)) ? {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository} : {
					ab: A2($elm$core$Task$perform, $author$project$OrganisationUnit$CreateDialog$GotCurrentTimestamp, $elm$time$Time$now),
					jn: $author$project$OrganisationUnit$CreateDialog$HandlingCommands(model),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$CreateDialog$CheckpointGroupsStep = 1;
var $author$project$OrganisationUnit$CreateDialog$FloorPlanStep = 2;
var $author$project$OrganisationUnit$CreateDialog$switchStep = F2(
	function (step, model) {
		if (_Utils_eq(model.b0, step)) {
			return model;
		} else {
			var _v0 = model.b0;
			switch (_v0) {
				case 0:
					var title = $elm$core$String$trim(
						$author$project$UI$BasicDataEditor$title(model.aQ));
					var description = $elm$core$String$trim(
						$author$project$UI$BasicDataEditor$description(model.aQ));
					return $elm$core$String$isEmpty(title) ? model : _Utils_update(
						model,
						{
							aQ: A2(
								$author$project$UI$BasicDataEditor$withDescription,
								description,
								A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ)),
							b0: step
						});
				case 1:
					return _Utils_update(
						model,
						{b0: step});
				default:
					return _Utils_update(
						model,
						{b0: step});
			}
		}
	});
var $author$project$OrganisationUnit$CreateDialog$nextStep = function (model) {
	var _v0 = model.b0;
	switch (_v0) {
		case 0:
			return A2($author$project$OrganisationUnit$CreateDialog$switchStep, 1, model);
		case 1:
			return A2($author$project$OrganisationUnit$CreateDialog$switchStep, 2, model);
		default:
			return model;
	}
};
var $author$project$OrganisationUnit$CreateDialog$userClickedNextButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$OrganisationUnit$CreateDialog$Visible(
						$author$project$OrganisationUnit$CreateDialog$nextStep(model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$CreateDialog$userClickedStepIcon = F4(
	function (step, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$OrganisationUnit$CreateDialog$Visible(
						A2($author$project$OrganisationUnit$CreateDialog$switchStep, step, model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$CreateDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$OrganisationUnit$CreateDialog$userClickedCloseDialog;
		case 1:
			return $author$project$OrganisationUnit$CreateDialog$userClickedCancelButton;
		case 2:
			return $author$project$OrganisationUnit$CreateDialog$userClickedCreateButton;
		case 3:
			var posix = msg.a;
			return $author$project$OrganisationUnit$CreateDialog$gotCurrentTimestamp(posix);
		case 4:
			return $author$project$OrganisationUnit$CreateDialog$userClickedNextButton;
		case 5:
			var step = msg.a;
			return $author$project$OrganisationUnit$CreateDialog$userClickedStepIcon(step);
		case 6:
			var editorMsg = msg.a;
			return $author$project$OrganisationUnit$CreateDialog$gotBasicDataEditorMsg(editorMsg);
		case 7:
			var editorMsg = msg.a;
			return $author$project$OrganisationUnit$CreateDialog$gotCheckpointGroupEditorMsg(editorMsg);
		case 8:
			var editorMsg = msg.a;
			return $author$project$OrganisationUnit$CreateDialog$gotFloorPlanEditorMsg(editorMsg);
		default:
			var commands = msg.a;
			return $author$project$OrganisationUnit$CreateDialog$createdCommands(commands);
	}
};
var $author$project$OrganisationUnit$Page$withCreateDialog = F2(
	function (createDialog_, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{fi: createDialog_});
	});
var $author$project$OrganisationUnit$Page$gotCreateDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$OrganisationUnit$CreateDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$OrganisationUnit$Page$createDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$Page$GotCreateDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$OrganisationUnit$Page$withCreateDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$OrganisationUnit$EditDialog$Deleted = {$: 3};
var $author$project$OrganisationUnit$EditDialog$createdCommands = F4(
	function (commands, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 2:
				var model = dialog.a;
				var _v1 = A3(
					$author$project$OrganisationUnit$OrganisationUnits$handleCommands,
					$author$project$OrganisationUnit$Commands$fromList(commands),
					environment,
					$author$project$Environments$Repository$organisationUnits(repository));
				if (_v1.$ === 1) {
					if (!_v1.a.$) {
						var organisationUnitId = _v1.a.a;
						if (_Utils_eq(model.bq.km, organisationUnitId)) {
							return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$OrganisationUnit$EditDialog$Deleted, ac: environment, ae: repository};
						} else {
							var _v2 = A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Environments$ErrorHandling$Id$from,
								$author$project$Environments$Environment$generateUuid(environment));
							var newId = _v2.a;
							var newEnvironment = _v2.b;
							var newError = {
								gg: '',
								gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
									$author$project$Environments$ErrorHandling$ToString$organisationUnitErrorToString(
										$author$project$OrganisationUnit$OrganisationUnits$OrganisationUnitDoesNotExist(organisationUnitId))),
								gH: 'OrganisationUnit.EditDialog.elm',
								gK: 'createdCommands',
								fw: newId
							};
							return {
								ab: $elm$core$Platform$Cmd$none,
								jn: $author$project$OrganisationUnit$EditDialog$Hidden,
								ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
								ae: repository
							};
						}
					} else {
						var error = _v1.a;
						var _v3 = A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Environments$ErrorHandling$Id$from,
							$author$project$Environments$Environment$generateUuid(environment));
						var newId = _v3.a;
						var newEnvironment = _v3.b;
						var newError = {
							gg: '',
							gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
								$author$project$Environments$ErrorHandling$ToString$organisationUnitErrorToString(error)),
							gH: 'OrganisationUnit.EditDialog.elm',
							gK: 'createdCommands',
							fw: newId
						};
						return {
							ab: $elm$core$Platform$Cmd$none,
							jn: $author$project$OrganisationUnit$EditDialog$Hidden,
							ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
							ae: repository
						};
					}
				} else {
					var resultData = _v1.a;
					if (($author$project$OrganisationUnit$Commands$isEmpty(resultData.cD) || $author$project$OrganisationUnit$Events$isEmpty(resultData.b8)) && $elm$core$List$isEmpty(
						$author$project$OrganisationUnit$CheckpointGroupEditor$commands(model.cB))) {
						return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$OrganisationUnit$EditDialog$Hidden, ac: resultData.ac, ae: repository};
					} else {
						var checkpointDateCommands = $author$project$OrganisationUnit$CheckpointGroupEditor$commands(model.cB);
						var _v4 = A3(
							$author$project$CheckpointData$CommandHandler$handleCommands,
							$author$project$CheckpointData$Commands$fromList(checkpointDateCommands),
							resultData.ac,
							$author$project$Environments$Repository$getCheckpointData(repository));
						if (!_v4.$) {
							var resultData2 = _v4.a;
							var _v5 = A4($author$project$Environments$Repository$saveOrganisationUnitCommandsAndEventsAndFileOperations, resultData.cD, resultData.b8, resultData.cb, repository);
							var newRepository = _v5.a;
							var cmd = _v5.b;
							var _v6 = A4($author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations, resultData2.cD, resultData2.b8, resultData2.cb, newRepository);
							var newRepository2 = _v6.a;
							var cmd2 = _v6.b;
							return {
								ab: $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[cmd, cmd2])),
								jn: $author$project$OrganisationUnit$EditDialog$Hidden,
								ac: resultData2.ac,
								ae: newRepository2
							};
						} else {
							var error = _v4.a;
							var _v7 = A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Environments$ErrorHandling$Id$from,
								$author$project$Environments$Environment$generateUuid(resultData.ac));
							var newId = _v7.a;
							var newEnvironment = _v7.b;
							var newError = {
								gg: '',
								gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
									$author$project$Environments$ErrorHandling$ToString$checkpointDataErrorToString(error)),
								gH: 'OrganisationUnit.EditDialog.elm',
								gK: 'createdCommands',
								fw: newId
							};
							var _v8 = A4($author$project$Environments$Repository$saveOrganisationUnitCommandsAndEventsAndFileOperations, resultData.cD, resultData.b8, resultData.cb, repository);
							var newRepository = _v8.a;
							var cmd = _v8.b;
							return {
								ab: cmd,
								jn: $author$project$OrganisationUnit$EditDialog$Hidden,
								ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
								ae: newRepository
							};
						}
					}
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$EditDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$EditDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var editor = A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ);
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$OrganisationUnit$EditDialog$Visible(
						_Utils_update(
							model,
							{aQ: editor})),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$EditDialog$GotCheckpointGroupEditorMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$OrganisationUnit$EditDialog$gotCheckpointGroupEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var result = A4($author$project$OrganisationUnit$CheckpointGroupEditor$update, editorMsg, environment, repository, model.cB);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$EditDialog$GotCheckpointGroupEditorMsg, result.ab),
					jn: $author$project$OrganisationUnit$EditDialog$Visible(
						_Utils_update(
							model,
							{cB: result.X})),
					ac: result.ac,
					ae: result.ae
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$EditDialog$gotFloorPlanEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = A2($author$project$OrganisationUnit$FloorPlanEditor$update, editorMsg, model.cU);
				var editor = _v1.a;
				var editorCmd = _v1.b;
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$EditDialog$GotFloorPlanEditorMsg, editorCmd),
					jn: $author$project$OrganisationUnit$EditDialog$Visible(
						_Utils_update(
							model,
							{cU: editor})),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$EditDialog$CreatedCommands = function (a) {
	return {$: 9, a: a};
};
var $author$project$OrganisationUnit$EditDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$OrganisationUnit$Command$changeColor = F2(
	function (environment, model) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$ChangeColor(
						{K: model.K, L: commandId_, M: commandTimestamp, km: model.km, l: model.l});
				}));
	});
var $author$project$OrganisationUnit$EditDialog$withChangeColorCommand = F3(
	function (organisationUnit, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$OrganisationUnit$Command$changeColor,
				environment,
				{
					K: $author$project$UI$BasicDataEditor$color(basicDataEditor),
					km: organisationUnit.km,
					l: organisationUnit.k8
				}));
	});
var $author$project$OrganisationUnit$Command$changeDescription = F2(
	function (environment, model) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$ChangeDescription(
						{L: commandId_, M: commandTimestamp, aY: model.aY, km: model.km, l: model.l});
				}));
	});
var $author$project$OrganisationUnit$EditDialog$withChangeDescriptionCommand = F3(
	function (organisationUnit, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$OrganisationUnit$Command$changeDescription,
				environment,
				{
					aY: $author$project$UI$BasicDataEditor$description(basicDataEditor),
					km: organisationUnit.km,
					l: organisationUnit.k8
				}));
	});
var $author$project$OrganisationUnit$Command$changeFloorPlan = F2(
	function (environment, model) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$ChangeFloorPlan(
						{L: commandId_, M: commandTimestamp, fI: model.fI, fM: model.fM, km: model.km, l: model.l});
				}));
	});
var $author$project$OrganisationUnit$EditDialog$withChangeFloorPlanCommand = F3(
	function (organisationUnit, floorPlanEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(
			organisationUnit.ap,
			$author$project$OrganisationUnit$FloorPlanEditor$floorPlan(floorPlanEditor)) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$OrganisationUnit$Command$changeFloorPlan,
				environment,
				{
					fI: $author$project$OrganisationUnit$FloorPlanEditor$floorPlan(floorPlanEditor),
					fM: organisationUnit.ap,
					km: organisationUnit.km,
					l: organisationUnit.k8
				}));
	});
var $author$project$OrganisationUnit$Command$changeTitle = F2(
	function (environment, model) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$ChangeTitle(
						{L: commandId_, M: commandTimestamp, km: model.km, k8: model.k8, l: model.l});
				}));
	});
var $author$project$OrganisationUnit$EditDialog$withChangeTitleCommand = F3(
	function (organisationUnit, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var _v1 = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		if (_v1 === '') {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var title = _v1;
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2(
					$author$project$OrganisationUnit$Command$changeTitle,
					environment,
					{km: organisationUnit.km, k8: title, l: organisationUnit.k8}));
		}
	});
var $author$project$OrganisationUnit$EditDialog$createCommands = F2(
	function (environment, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A3(
				$author$project$OrganisationUnit$EditDialog$withChangeFloorPlanCommand,
				model.bq,
				model.cU,
				A3(
					$author$project$OrganisationUnit$EditDialog$withChangeColorCommand,
					model.bq,
					model.aQ,
					A3(
						$author$project$OrganisationUnit$EditDialog$withChangeDescriptionCommand,
						model.bq,
						model.aQ,
						A3(
							$author$project$OrganisationUnit$EditDialog$withChangeTitleCommand,
							model.bq,
							model.aQ,
							_Utils_Tuple2(environment, _List_Nil))))));
	});
var $author$project$OrganisationUnit$EditDialog$userClickedApplyButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				if ($author$project$Utils$String$isBlank(
					$author$project$UI$BasicDataEditor$title(model.aQ))) {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				} else {
					var _v1 = A2($author$project$OrganisationUnit$EditDialog$createCommands, environment, model);
					var newEnvironment = _v1.a;
					var tasks = _v1.b;
					return {
						ab: A2(
							$elm$core$Task$perform,
							$author$project$OrganisationUnit$EditDialog$CreatedCommands,
							$elm$core$Task$sequence(tasks)),
						jn: $author$project$OrganisationUnit$EditDialog$HandlingCommands(model),
						ac: newEnvironment,
						ae: repository
					};
				}
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$EditDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$OrganisationUnit$EditDialog$Hidden, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$EditDialog$userClickedCloseButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$OrganisationUnit$EditDialog$Hidden, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$OrganisationUnit$EditDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$EditDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$OrganisationUnit$EditDialog$Hidden, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$OrganisationUnit$EditDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$Command$delete = F3(
	function (environment, organisationUnitId, titleForError) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$Delete(
						{L: commandId_, M: commandTimestamp, km: organisationUnitId, l: titleForError});
				}));
	});
var $author$project$OrganisationUnit$EditDialog$userClickedDeleteButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = A3($author$project$OrganisationUnit$Command$delete, environment, model.bq.km, model.bq.k8);
				var newEnvironment = _v1.a;
				var task = _v1.b;
				return {
					ab: A3(
						$elm$core$Basics$composeR,
						$elm$core$Task$sequence,
						$elm$core$Task$perform($author$project$OrganisationUnit$EditDialog$CreatedCommands),
						_List_fromArray(
							[task])),
					jn: $author$project$OrganisationUnit$EditDialog$HandlingCommands(model),
					ac: newEnvironment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$EditDialog$switchTab = F2(
	function (tab, model) {
		if (_Utils_eq(model.cI, tab)) {
			return model;
		} else {
			var _v0 = model.cI;
			switch (_v0) {
				case 0:
					var title = $elm$core$String$trim(
						$author$project$UI$BasicDataEditor$title(model.aQ));
					var description = $elm$core$String$trim(
						$author$project$UI$BasicDataEditor$description(model.aQ));
					return $elm$core$String$isEmpty(title) ? model : _Utils_update(
						model,
						{
							aQ: A2(
								$author$project$UI$BasicDataEditor$withDescription,
								description,
								A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ)),
							cI: tab
						});
				case 1:
					return _Utils_update(
						model,
						{cI: tab});
				case 2:
					return _Utils_update(
						model,
						{cI: tab});
				default:
					return _Utils_update(
						model,
						{cI: tab});
			}
		}
	});
var $author$project$OrganisationUnit$EditDialog$userClickedTabIcon = F4(
	function (tab, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$OrganisationUnit$EditDialog$Visible(
						A2($author$project$OrganisationUnit$EditDialog$switchTab, tab, model)),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$EditDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$OrganisationUnit$EditDialog$userClickedCloseDialog;
		case 1:
			var tab = msg.a;
			return $author$project$OrganisationUnit$EditDialog$userClickedTabIcon(tab);
		case 2:
			return $author$project$OrganisationUnit$EditDialog$userClickedCancelButton;
		case 3:
			return $author$project$OrganisationUnit$EditDialog$userClickedApplyButton;
		case 4:
			return $author$project$OrganisationUnit$EditDialog$userClickedDeleteButton;
		case 5:
			return $author$project$OrganisationUnit$EditDialog$userClickedCloseButton;
		case 6:
			var editorMsg = msg.a;
			return $author$project$OrganisationUnit$EditDialog$gotBasicDataEditorMsg(editorMsg);
		case 7:
			var editorMsg = msg.a;
			return $author$project$OrganisationUnit$EditDialog$gotCheckpointGroupEditorMsg(editorMsg);
		case 8:
			var editorMsg = msg.a;
			return $author$project$OrganisationUnit$EditDialog$gotFloorPlanEditorMsg(editorMsg);
		default:
			var commands = msg.a;
			return $author$project$OrganisationUnit$EditDialog$createdCommands(commands);
	}
};
var $author$project$OrganisationUnit$Page$withEditDialog = F2(
	function (editDialog_, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{cO: editDialog_});
	});
var $author$project$OrganisationUnit$Page$gotEditDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$OrganisationUnit$EditDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$OrganisationUnit$Page$editDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$OrganisationUnit$Page$GotEditDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$OrganisationUnit$Page$withEditDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$OrganisationUnit$Page$gotExpandOrganisationUnitMsg = F4(
	function (organisationUnitId, environment, repository, _v0) {
		var page = _v0;
		var updatedPage = _Utils_update(
			page,
			{
				dI: A2($author$project$UI$OrganisationStructure$expandOrganisationUnit, organisationUnitId, page.dI)
			});
		return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: updatedPage, ae: repository};
	});
var $author$project$OrganisationUnit$Id$from = $elm$core$Basics$identity;
var $author$project$OrganisationUnit$CreateDialog$BasicDataStep = 0;
var $author$project$OrganisationUnit$CreateDialog$CreateChild = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$CreateDialog$CreateRoot = {$: 0};
var $author$project$CheckpointData$Checkpoint$CreateDialog$hidden = $author$project$CheckpointData$Checkpoint$CreateDialog$Hidden;
var $author$project$CheckpointData$Checkpoint$EditDialog$hidden = $author$project$CheckpointData$Checkpoint$EditDialog$Hidden;
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$hidden = $author$project$CheckpointData$CheckpointGroup$CreateDialog$Hidden;
var $author$project$CheckpointData$CheckpointGroup$EditDialog$hidden = $author$project$CheckpointData$CheckpointGroup$EditDialog$Hidden;
var $author$project$OrganisationUnit$CheckpointGroupEditor$checkpointGroupEditor = function (payload) {
	return {a6: $author$project$UI$DragAndDrop$DragAndDrop$emptyDnd, a7: _List_Nil, fh: $author$project$CheckpointData$Checkpoint$CreateDialog$hidden, fj: $author$project$CheckpointData$CheckpointGroup$CreateDialog$hidden, fo: $author$project$CheckpointData$Checkpoint$EditDialog$hidden, fp: $author$project$CheckpointData$CheckpointGroup$EditDialog$hidden, cR: _List_Nil, jT: payload.jT, km: payload.km};
};
var $author$project$UI$ImageEditor$default = {eG: _List_Nil, bH: $elm$core$Maybe$Nothing, gb: false, cA: false};
var $author$project$OrganisationUnit$FloorPlanEditor$default = {cY: $author$project$UI$ImageEditor$default};
var $author$project$UI$ColorPicker$newModel = function (initColor) {
	var _v0 = $author$project$UI$Style$Color$toHsla(initColor);
	var hue = _v0.Z;
	var saturation = _v0.dc;
	var lightness = _v0.c2;
	var alpha = _v0.eq;
	return {
		Z: $elm$core$Maybe$Just(hue),
		ck: $author$project$UI$ColorPicker$Unpressed,
		o: $author$project$UI$Style$Color$toHex(initColor)
	};
};
var $author$project$UI$ColorPicker$init = function (initColor) {
	return $author$project$UI$ColorPicker$newModel(initColor);
};
var $author$project$UI$BasicDataEditor$defaultColor = function () {
	var color_ = A4($author$project$UI$Style$Color$rgba, 56 / 255, 92 / 255, 107 / 255, 0.75);
	return {
		aF: $author$project$UI$BasicDataEditor$WithColorPicker(
			{
				K: color_,
				aF: $author$project$UI$ColorPicker$init(color_)
			}),
		aY: '',
		ey: false,
		k8: ''
	};
}();
var $author$project$OrganisationUnit$CreateDialog$show = F2(
	function (organisationUnitId, maybeParentId) {
		var groupEditorInit = {jC: $elm$core$Maybe$Nothing, jT: $elm$core$Maybe$Nothing, km: organisationUnitId};
		var context = function () {
			if (!maybeParentId.$) {
				var parentId = maybeParentId.a;
				return $author$project$OrganisationUnit$CreateDialog$CreateChild(parentId);
			} else {
				return $author$project$OrganisationUnit$CreateDialog$CreateRoot;
			}
		}();
		return $author$project$OrganisationUnit$CreateDialog$Visible(
			{
				aQ: $author$project$UI$BasicDataEditor$defaultColor,
				cB: $author$project$OrganisationUnit$CheckpointGroupEditor$checkpointGroupEditor(groupEditorInit),
				gx: context,
				b0: 0,
				cU: $author$project$OrganisationUnit$FloorPlanEditor$default,
				km: organisationUnitId,
				fX: $elm$time$Time$millisToPosix(0)
			});
	});
var $author$project$OrganisationUnit$Page$userClickedCreateChildIcon = F4(
	function (organisationUnit, environment, repository, page) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$OrganisationUnit$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newOrganisationUnitId = _v0.a;
		var newEnvironment = _v0.b;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: newEnvironment,
			ak: A2(
				$author$project$OrganisationUnit$Page$withCreateDialog,
				A2(
					$author$project$OrganisationUnit$CreateDialog$show,
					newOrganisationUnitId,
					$elm$core$Maybe$Just(organisationUnit.km)),
				page),
			ae: repository
		};
	});
var $author$project$OrganisationUnit$Page$userClickedCreateRootIcon = F3(
	function (environment, repository, page) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$OrganisationUnit$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newOrganisationUnitId = _v0.a;
		var newEnvironment = _v0.b;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: newEnvironment,
			ak: A2(
				$author$project$OrganisationUnit$Page$withCreateDialog,
				A2($author$project$OrganisationUnit$CreateDialog$show, newOrganisationUnitId, $elm$core$Maybe$Nothing),
				page),
			ae: repository
		};
	});
var $author$project$OrganisationUnit$Page$Visible = function (a) {
	return {$: 0, a: a};
};
var $author$project$OrganisationUnit$Page$userClickedDuplicateOrganisationUnit = F4(
	function (organisationUnit, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2(
				$author$project$OrganisationUnit$Page$withDuplicateModal,
				$author$project$OrganisationUnit$Page$Visible(organisationUnit),
				page),
			ae: repository
		};
	});
var $author$project$OrganisationUnit$EditDialog$BasicDataTab = 0;
var $author$project$UI$BasicDataEditor$withColorPicker = F2(
	function (color_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				aF: $author$project$UI$BasicDataEditor$WithColorPicker(
					{
						K: color_,
						aF: $author$project$UI$ColorPicker$init(color_)
					})
			});
	});
var $author$project$UI$BasicDataEditor$fromWithColor = function (model) {
	return A2(
		$author$project$UI$BasicDataEditor$withColorPicker,
		model.K,
		A2(
			$author$project$UI$BasicDataEditor$withDescription,
			model.aY,
			A2($author$project$UI$BasicDataEditor$withTitle, model.k8, $author$project$UI$BasicDataEditor$default)));
};
var $author$project$UI$ImageEditor$from = function (maybeFile) {
	return {eG: _List_Nil, bH: maybeFile, gb: false, cA: false};
};
var $author$project$OrganisationUnit$FloorPlanEditor$withFloorPlan = function (floorPlan_) {
	return {
		cY: $author$project$UI$ImageEditor$from(floorPlan_)
	};
};
var $author$project$OrganisationUnit$EditDialog$show = function (organisationUnit) {
	var groupEditorInit = {jC: organisationUnit.ao, jT: organisationUnit.jU, km: organisationUnit.km};
	return $author$project$OrganisationUnit$EditDialog$Visible(
		{
			aQ: $author$project$UI$BasicDataEditor$fromWithColor(organisationUnit),
			cB: $author$project$OrganisationUnit$CheckpointGroupEditor$checkpointGroupEditor(groupEditorInit),
			cI: 0,
			cU: $author$project$OrganisationUnit$FloorPlanEditor$withFloorPlan(organisationUnit.ap),
			bq: organisationUnit
		});
};
var $author$project$OrganisationUnit$Page$userClickedEditIcon = F4(
	function (organisationUnit, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2(
				$author$project$OrganisationUnit$Page$withEditDialog,
				$author$project$OrganisationUnit$EditDialog$show(organisationUnit),
				page),
			ae: repository
		};
	});
var $author$project$OrganisationUnit$Page$CreatedDuplicateCheckpointCommands = function (a) {
	return {$: 11, a: a};
};
var $author$project$OrganisationUnit$Page$CreatedDuplicateOrganisationUnitCommands = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$OrganisationUnit$Command$createAfter = F2(
	function (environment, model) {
		return A2(
			$author$project$OrganisationUnit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$OrganisationUnit$Command$CreateAfter(
						{K: model.K, L: commandId_, M: commandTimestamp, aY: model.aY, ao: model.ao, ap: model.ap, jU: model.jU, km: model.km, ay: model.ay, k8: model.k8});
				}));
	});
var $author$project$OrganisationUnit$Duplicator$duplicateCheckpoint = F3(
	function (checkpointGroupId, checkpoint, _v0) {
		var cmdList = _v0.a;
		var maybePrev = _v0.b;
		var environment = _v0.c;
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$CheckpointData$Checkpoint$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v1.a;
		var newEnvironment1 = _v1.b;
		var _v2 = A2(
			$author$project$CheckpointData$Command$createCheckpoint,
			newEnvironment1,
			{cC: checkpointGroupId, i5: newId, fg: checkpoint.fg, aY: checkpoint.aY, cT: $author$project$File$Filenames$empty, kc: $elm$core$Maybe$Nothing, kw: maybePrev, k8: checkpoint.k8});
		var newEnvironment2 = _v2.a;
		var newCmd = _v2.b;
		return _Utils_Tuple3(
			_Utils_ap(
				cmdList,
				_List_fromArray(
					[newCmd])),
			$elm$core$Maybe$Just(newId),
			newEnvironment2);
	});
var $author$project$OrganisationUnit$Duplicator$duplicateCheckpointGroup = F4(
	function (organisationUnitId, checkpointData, checkpointGroup, _v0) {
		var cmdList = _v0.a;
		var maybePrev = _v0.b;
		var environment = _v0.c;
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$CheckpointData$CheckpointGroup$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v1.a;
		var newEnvironment1 = _v1.b;
		var _v2 = A2(
			$author$project$CheckpointData$Command$createCheckpointGroup,
			newEnvironment1,
			{cC: newId, aY: checkpointGroup.k8, jC: $elm$core$Maybe$Nothing, jT: $elm$core$Maybe$Nothing, kc: $elm$core$Maybe$Nothing, km: organisationUnitId, kw: maybePrev, k8: checkpointGroup.k8});
		var newEnvironment2 = _v2.a;
		var newCmd = _v2.b;
		var _v3 = A3(
			$elm$core$List$foldl,
			$author$project$OrganisationUnit$Duplicator$duplicateCheckpoint(newId),
			_Utils_Tuple3(
				_List_fromArray(
					[newCmd]),
				$elm$core$Maybe$Nothing,
				newEnvironment2),
			A2($author$project$CheckpointData$CheckpointData$getCheckpointsOf, checkpointGroup.cC, checkpointData));
		var checkpointCommands = _v3.a;
		var newEnvironment3 = _v3.c;
		return _Utils_Tuple3(
			A2($elm$core$List$append, cmdList, checkpointCommands),
			$elm$core$Maybe$Just(newId),
			newEnvironment3);
	});
var $author$project$Translations$OrganisationUnits$DuplicateOrganisationUnit$duplicateName = F2(
	function (translations, title) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'organisationUnits.duplicateOrganisationUnit.duplicateName',
			_List_fromArray(
				[
					_Utils_Tuple2('title', title)
				]));
	});
var $author$project$OrganisationUnit$Duplicator$duplicateChildren = F4(
	function (repository, parentId, organisationUnit, _v0) {
		var ouCommands = _v0.a;
		var checkpointDataCommands = _v0.b;
		var environment = _v0.c;
		var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$OrganisationUnit$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v1.a;
		var newEnvironment1 = _v1.b;
		var _v2 = A2(
			$author$project$OrganisationUnit$Command$createChild,
			newEnvironment1,
			{
				K: organisationUnit.K,
				aY: organisationUnit.aY,
				ao: $elm$core$Maybe$Nothing,
				ap: $elm$core$Maybe$Nothing,
				jU: $elm$core$Maybe$Nothing,
				km: newId,
				fV: parentId,
				k8: A2(
					$author$project$Translations$OrganisationUnits$DuplicateOrganisationUnit$duplicateName,
					$author$project$Environments$Environment$translations(environment),
					organisationUnit.k8)
			});
		var newEnvironment2 = _v2.a;
		var newCmd = _v2.b;
		var _v3 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple3(_List_Nil, _List_Nil, newEnvironment2),
			A2(
				$elm$core$Maybe$map,
				function (firstId) {
					return A3(
						$elm$core$List$foldl,
						A2($author$project$OrganisationUnit$Duplicator$duplicateChildren, repository, newId),
						_Utils_Tuple3(_List_Nil, _List_Nil, newEnvironment2),
						A2(
							$author$project$OrganisationUnit$OrganisationUnits$getNextSiblingsOf,
							firstId,
							$author$project$Environments$Repository$organisationUnits(repository)));
				},
				organisationUnit.hV));
		var organisationUnitCommands = _v3.a;
		var checkpointCommands = _v3.b;
		var newEnvironment3 = _v3.c;
		var _v4 = A3(
			$elm$core$List$foldl,
			A2($author$project$OrganisationUnit$Duplicator$duplicateCheckpointGroup, newId, checkpointData),
			_Utils_Tuple3(checkpointCommands, $elm$core$Maybe$Nothing, newEnvironment3),
			A2($author$project$CheckpointData$CheckpointData$getCheckpointGroupAndPrev, organisationUnit.jU, checkpointData));
		var newCheckpointDataCommands = _v4.a;
		var newEnvironment4 = _v4.c;
		return _Utils_Tuple3(
			A2(
				$elm$core$List$append,
				ouCommands,
				A2($elm$core$List$cons, newCmd, organisationUnitCommands)),
			A2($elm$core$List$append, checkpointDataCommands, newCheckpointDataCommands),
			newEnvironment4);
	});
var $author$project$OrganisationUnit$Duplicator$duplicateOrganisationUnit = F3(
	function (environment, repository, organisationUnit) {
		var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$OrganisationUnit$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment1 = _v0.b;
		var _v1 = function () {
			var _v2 = organisationUnit.fV;
			if (!_v2.$) {
				return A2(
					$author$project$OrganisationUnit$Command$createAfter,
					newEnvironment1,
					{
						K: organisationUnit.K,
						aY: organisationUnit.aY,
						ao: $elm$core$Maybe$Nothing,
						ap: $elm$core$Maybe$Nothing,
						jU: $elm$core$Maybe$Nothing,
						km: newId,
						ay: organisationUnit.km,
						k8: A2(
							$author$project$Translations$OrganisationUnits$DuplicateOrganisationUnit$duplicateName,
							$author$project$Environments$Environment$translations(environment),
							organisationUnit.k8)
					});
			} else {
				return A2(
					$author$project$OrganisationUnit$Command$create,
					newEnvironment1,
					{
						K: organisationUnit.K,
						aY: organisationUnit.aY,
						ao: $elm$core$Maybe$Nothing,
						ap: $elm$core$Maybe$Nothing,
						jU: $elm$core$Maybe$Nothing,
						km: newId,
						k8: A2(
							$author$project$Translations$OrganisationUnits$DuplicateOrganisationUnit$duplicateName,
							$author$project$Environments$Environment$translations(environment),
							organisationUnit.k8)
					});
			}
		}();
		var newEnvironment2 = _v1.a;
		var createStartCmd = _v1.b;
		var _v3 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple3(_List_Nil, _List_Nil, newEnvironment2),
			A2(
				$elm$core$Maybe$map,
				function (firstId) {
					return A3(
						$elm$core$List$foldl,
						A2($author$project$OrganisationUnit$Duplicator$duplicateChildren, repository, newId),
						_Utils_Tuple3(_List_Nil, _List_Nil, newEnvironment2),
						A2(
							$author$project$OrganisationUnit$OrganisationUnits$getNextSiblingsOf,
							firstId,
							$author$project$Environments$Repository$organisationUnits(repository)));
				},
				organisationUnit.hV));
		var organisationUnitCommands = _v3.a;
		var checkpointCommands = _v3.b;
		var newEnvironment3 = _v3.c;
		var _v4 = A3(
			$elm$core$List$foldl,
			A2($author$project$OrganisationUnit$Duplicator$duplicateCheckpointGroup, newId, checkpointData),
			_Utils_Tuple3(_List_Nil, $elm$core$Maybe$Nothing, newEnvironment3),
			A2($author$project$CheckpointData$CheckpointData$getCheckpointGroupAndPrev, organisationUnit.jU, checkpointData));
		var startCheckpointsCommands = _v4.a;
		var newEnvironment4 = _v4.c;
		return _Utils_Tuple3(
			A2($elm$core$List$cons, createStartCmd, organisationUnitCommands),
			A2($elm$core$List$append, startCheckpointsCommands, checkpointCommands),
			newEnvironment4);
	});
var $author$project$OrganisationUnit$Duplicator$duplicate = F3(
	function (environment, repository, organisationUnitId) {
		var maybeStart = A2($author$project$Environments$Repository$getOrganisationUnit, organisationUnitId, repository);
		var result = function () {
			if (!maybeStart.$) {
				var organisationUnit = maybeStart.a;
				return A3($author$project$OrganisationUnit$Duplicator$duplicateOrganisationUnit, environment, repository, organisationUnit);
			} else {
				return _Utils_Tuple3(_List_Nil, _List_Nil, environment);
			}
		}();
		return result;
	});
var $author$project$OrganisationUnit$Page$userConfirmedDuplicateOrganisationUnit = F4(
	function (organisationUnit, environment, repository, page) {
		var _v0 = A3($author$project$OrganisationUnit$Duplicator$duplicate, environment, repository, organisationUnit.km);
		var ouTasks = _v0.a;
		var checkpointDataTasks = _v0.b;
		var newEnvironment = _v0.c;
		var checkpointDataCmdMsg = A2(
			$elm$core$Task$perform,
			$author$project$OrganisationUnit$Page$CreatedDuplicateCheckpointCommands,
			$elm$core$Task$sequence(checkpointDataTasks));
		return {
			ab: A2(
				$elm$core$Task$perform,
				$author$project$OrganisationUnit$Page$CreatedDuplicateOrganisationUnitCommands(checkpointDataCmdMsg),
				$elm$core$Task$sequence(ouTasks)),
			ac: newEnvironment,
			ak: A2($author$project$OrganisationUnit$Page$withDuplicateModal, $author$project$OrganisationUnit$Page$Hidden, page),
			ae: repository
		};
	});
var $author$project$OrganisationUnit$Page$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$OrganisationUnit$Page$userClickedCreateRootIcon;
		case 1:
			var dialogMsg = msg.a;
			return $author$project$OrganisationUnit$Page$gotCreateDialogMsg(dialogMsg);
		case 2:
			var organisationUnit = msg.a;
			return $author$project$OrganisationUnit$Page$userClickedEditIcon(organisationUnit);
		case 3:
			var dialogMsg = msg.a;
			return $author$project$OrganisationUnit$Page$gotEditDialogMsg(dialogMsg);
		case 4:
			var organisationUnitId = msg.a;
			return $author$project$OrganisationUnit$Page$gotCollapseOrganisationUnitMsg(organisationUnitId);
		case 5:
			var organisationUnitId = msg.a;
			return $author$project$OrganisationUnit$Page$gotExpandOrganisationUnitMsg(organisationUnitId);
		case 6:
			var organisationUnit = msg.a;
			return $author$project$OrganisationUnit$Page$userClickedCreateChildIcon(organisationUnit);
		case 7:
			var organisationUnit = msg.a;
			return $author$project$OrganisationUnit$Page$userClickedDuplicateOrganisationUnit(organisationUnit);
		case 8:
			return $author$project$OrganisationUnit$Page$closeDuplicateOrganisationUnitModal;
		case 9:
			var organisationUnit = msg.a;
			return $author$project$OrganisationUnit$Page$userConfirmedDuplicateOrganisationUnit(organisationUnit);
		case 10:
			var checkpointDataCmdMsg = msg.a;
			var ouCommands = msg.b;
			return A2($author$project$OrganisationUnit$Page$createdDuplicateCommands, checkpointDataCmdMsg, ouCommands);
		case 11:
			var checkpointDataCommands = msg.a;
			return $author$project$OrganisationUnit$Page$createdDuplicateCheckpointCommands(checkpointDataCommands);
		case 12:
			var dnDEventMsg = msg.a;
			return $author$project$OrganisationUnit$Page$dnDEvent(dnDEventMsg);
		case 13:
			var dnDEventMsg = msg.a;
			return $author$project$OrganisationUnit$Page$dnDEventDragEnd(dnDEventMsg);
		default:
			var command = msg.a;
			return $author$project$OrganisationUnit$Page$createdMoveCommand(command);
	}
};
var $author$project$Translations$OrganisationUnits$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'organisationUnits.header');
};
var $author$project$OrganisationUnit$Page$UserClickedCreateRootIcon = {$: 0};
var $author$project$Translations$Misc$overview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'misc.overview');
};
var $author$project$OrganisationUnit$Page$viewBar = F2(
	function (translations, environment) {
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(1)),
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
					A2(
						$author$project$UI$Bar$withStyle,
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
						A2(
							$author$project$UI$Bar$withRightIcon,
							A2(
								$author$project$UI$Icon$withOnClick,
								$author$project$OrganisationUnit$Page$UserClickedCreateRootIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
							$author$project$UI$Bar$bar(
								$author$project$Translations$Misc$overview(translations)))))));
	});
var $author$project$OrganisationUnit$CreateDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$OrganisationUnit$CreateDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$OrganisationUnits$createDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'organisationUnits.createDialogHeader');
};
var $author$project$OrganisationUnit$CreateDialog$UserClickedCancelButton = {$: 1};
var $author$project$OrganisationUnit$CreateDialog$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$OrganisationUnit$CreateDialog$UserClickedCancelButton,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$OrganisationUnit$CreateDialog$UserClickedCreateButton = {$: 2};
var $author$project$OrganisationUnit$CreateDialog$viewCreateButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$OrganisationUnit$CreateDialog$UserClickedCreateButton,
			$author$project$UI$Button$green(
				$author$project$Translations$Buttons$create(translations))));
};
var $author$project$OrganisationUnit$CreateDialog$UserClickedNextButton = {$: 4};
var $author$project$OrganisationUnit$CreateDialog$viewNextButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$OrganisationUnit$CreateDialog$UserClickedNextButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$next(translations)))));
	});
var $author$project$OrganisationUnit$CreateDialog$viewRightButton = F3(
	function (translations, disableBtn, currentStep) {
		return (currentStep === 2) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
						]))
				]),
			_List_fromArray(
				[
					$author$project$OrganisationUnit$CreateDialog$viewCreateButton(translations)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$OrganisationUnit$CreateDialog$viewNextButton, translations, disableBtn)
				]));
	});
var $author$project$UI$Icons$floorPlanCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63.001 32.001c0 17.122-13.879 31-31.001 31-17.121 0-31-13.878-31-31 0-17.121 13.879-31 31-31 17.122 0 31.001 13.879 31.001 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M48.541 13.944H15.457c-.835 0-1.512.68-1.512 1.513v33.087c0 .832.677 1.512 1.512 1.512h21.751c.835 0 1.512-.68 1.512-1.512V33.838c0-.833-.677-1.513-1.512-1.513h-9.497c-.836 0-1.513.68-1.513 1.513 0 .836.677 1.514 1.513 1.514h7.984v11.676h-8.309v-6.449c0-.836-.678-1.513-1.513-1.513-.836 0-1.513.677-1.513 1.513v6.449h-7.39V16.973h13.516v3.712h-7.983c-.837 0-1.514.676-1.514 1.514 0 .837.677 1.514 1.514 1.514h7.983v5.223c0 .837.678 1.514 1.513 1.514.836 0 1.513-.677 1.513-1.514V16.973h13.516v10.451h-6.065v-5.225c0-.838-.679-1.514-1.513-1.514-.836 0-1.515.676-1.515 1.514v6.737c0 .837.679 1.514 1.515 1.514h7.578v16.578h-2.47c-.834 0-1.511.679-1.511 1.516 0 .832.677 1.512 1.511 1.512h3.983c.837 0 1.514-.68 1.514-1.512V15.457c0-.833-.677-1.513-1.514-1.513')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$Icons$pinCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63 32c0 17.121-13.879 31-31 31C14.878 63 1 49.121 1 32 1 14.879 14.878 1 32 1c17.121 0 31 13.879 31 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M43.74 30.91c0 .02-.008.036-.008.057a8.808 8.808 0 01-.063.3v.015a12.064 12.064 0 01-.819 2.41c-1.357 3.203-4.336 8.154-10.84 13.585-6.505-5.425-9.485-10.382-10.843-13.586a.14.14 0 01-.013-.037 11.7 11.7 0 01-.803-2.372v-.016c-.037-.16-.058-.261-.066-.299 0-.021-.009-.037-.009-.057a11.62 11.62 0 01-.181-3.446C20.664 21.52 25.6 16.886 31.57 16.68a11.868 11.868 0 018.74 3.35 11.856 11.856 0 013.65 8.608c0 .758-.073 1.526-.22 2.27m-1.606-12.76c-2.869-2.775-6.65-4.22-10.65-4.09-7.287.256-13.302 5.915-14.002 13.156a14.658 14.658 0 00.19 4.16c.007.06.035.227.102.49a14.7 14.7 0 00.97 2.87c1.483 3.488 4.71 8.862 11.68 14.645a2.473 2.473 0 003.154 0c6.972-5.79 10.199-11.157 11.68-14.646.425-.92.753-1.883.972-2.868.066-.264.094-.431.103-.49.166-.897.254-1.824.254-2.737a14.47 14.47 0 00-4.453-10.49')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M32 21.018c-4.278 0-7.767 3.48-7.767 7.767 0 4.284 3.489 7.767 7.767 7.767a1.32 1.32 0 001.315-1.314c0-.722-.593-1.314-1.315-1.314a5.147 5.147 0 01-5.14-5.139 5.147 5.147 0 015.14-5.14 5.146 5.146 0 015.14 5.14c0 1.225-.437 2.41-1.235 3.336a1.31 1.31 0 00.147 1.854c.556.474 1.38.41 1.855-.146a7.75 7.75 0 001.86-5.044c0-4.278-3.482-7.767-7.767-7.767')
						]),
					_List_Nil)
				]));
	});
var $author$project$OrganisationUnit$CreateDialog$UserClickedStepIcon = function (a) {
	return {$: 5, a: a};
};
var $author$project$OrganisationUnit$CreateDialog$viewStepIcon = F4(
	function (icon, step, currentStep, platform) {
		var marginRight_ = function () {
			if (!platform.$) {
				return $rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$rem(1));
			} else {
				return $rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$rem(0.6));
			}
		}();
		var calcRem = function () {
			if (!platform.$) {
				return $rtfeldman$elm_css$Css$rem(2.5);
			} else {
				return $rtfeldman$elm_css$Css$rem(1.5);
			}
		}();
		var _v0 = _Utils_eq(step, currentStep) ? _Utils_Tuple2($author$project$UI$Style$Theme$white, $author$project$UI$Style$Theme$darkGrey) : _Utils_Tuple2($author$project$UI$Style$Theme$darkGrey, $author$project$UI$Style$Theme$lightGrey);
		var foregroundColor_ = _v0.a;
		var backgroundColor_ = _v0.b;
		return $author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$OrganisationUnit$CreateDialog$UserClickedStepIcon(step),
				A2(
					$author$project$UI$Icon$withStyle,
					marginRight_,
					A2(
						$author$project$UI$Icon$withBackgroundColor,
						backgroundColor_,
						A2(
							$author$project$UI$Icon$withForegroundColor,
							foregroundColor_,
							A2(
								$author$project$UI$Icon$withStyle,
								$rtfeldman$elm_css$Css$height(
									A3(
										$rtfeldman$elm_css$Css$calc,
										calcRem,
										$rtfeldman$elm_css$Css$plus,
										$rtfeldman$elm_css$Css$px(2))),
								A2(
									$author$project$UI$Icon$withStyle,
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									$author$project$UI$Icon$bicolor(icon))))))));
	});
var $author$project$OrganisationUnit$CreateDialog$viewSteps = F2(
	function (currentStep, platform) {
		var marginLeft_ = function () {
			if (!platform.$) {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(0.8))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
							]),
						marginLeft_))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$top(
									$rtfeldman$elm_css$Css$pct(50)),
									$rtfeldman$elm_css$Css$right(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$left(
									$rtfeldman$elm_css$Css$rem(1)),
									A3(
									$rtfeldman$elm_css$Css$border3,
									$rtfeldman$elm_css$Css$px(1),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
								]))
						]),
					_List_Nil),
					A4($author$project$OrganisationUnit$CreateDialog$viewStepIcon, $author$project$UI$Icons$tagCircleBicolor, 0, currentStep, platform),
					A4($author$project$OrganisationUnit$CreateDialog$viewStepIcon, $author$project$UI$Icons$pinCircleBicolor, 1, currentStep, platform),
					A4($author$project$OrganisationUnit$CreateDialog$viewStepIcon, $author$project$UI$Icons$floorPlanCircleBicolor, 2, currentStep, platform)
				]));
	});
var $author$project$OrganisationUnit$CreateDialog$viewFooter = F4(
	function (translations, platform, disableBtn, currentStep) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto 1fr'),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$OrganisationUnit$CreateDialog$viewCancelButton(translations),
					A2($author$project$OrganisationUnit$CreateDialog$viewSteps, currentStep, platform),
					A3($author$project$OrganisationUnit$CreateDialog$viewRightButton, translations, disableBtn, currentStep)
				]));
	});
var $author$project$OrganisationUnit$CreateDialog$viewBasicDataStep = F3(
	function (translations, platform, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$OrganisationUnit$CreateDialog$viewFooter, translations, platform, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$OrganisationUnit$CreateDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$OrganisationUnits$createDialogHeader(translations),
									$author$project$OrganisationUnit$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$UserClickedCreateGroupIcon = {$: 0};
var $author$project$Translations$Checkpoints$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.header');
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$appendRightIcon,
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$OrganisationUnit$CheckpointGroupEditor$UserClickedCreateGroupIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
			A2(
				$author$project$UI$Bar$withLeftIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$pin),
				$author$project$UI$Bar$bar(
					$author$project$Translations$Checkpoints$header(translations)))));
};
var $author$project$UI$Table$appendStyle = F2(
	function (style, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				dd: A2($elm$core$List$cons, style, config.dd)
			});
	});
var $author$project$Translations$Checkpoints$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.emptyText');
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$CheckpointGroup = function (a) {
	return {$: 0, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$toCheckpointGroupElement = $author$project$OrganisationUnit$CheckpointGroupEditor$CheckpointGroup;
var $author$project$OrganisationUnit$CheckpointGroupEditor$CheckpointGroupDnDEvent = function (a) {
	return {$: 10, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$CheckpointGroupDnDEventDragEnd = function (a) {
	return {$: 11, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$Collapse = function (a) {
	return {$: 9, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$Expand = function (a) {
	return {$: 8, a: a};
};
var $author$project$UI$Table$Row$Row = 0;
var $author$project$UI$Table$Row$appendContent = F2(
	function (htmlList, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{gi: htmlList});
	});
var $author$project$UI$Table$Row$appendRightIcon = F2(
	function (icon, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				c9: A2($elm$core$List$cons, icon, config.c9)
			});
	});
var $author$project$UI$Table$Row$changeSubLabelDirection = F2(
	function (subLabelDirection, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{hi: subLabelDirection});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$elementTitle = function (checkpointElement) {
	if (!checkpointElement.$) {
		var checkpointGroup = checkpointElement.a;
		return checkpointGroup.k8;
	} else {
		var checkpoint = checkpointElement.a;
		return checkpoint.k8;
	}
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$checkpointGroupToDragElem = function (_v0) {
	var currentlyDragging = _v0.hF;
	if (!currentlyDragging.$) {
		var _v2 = currentlyDragging.a;
		var checkpointElement = _v2.a;
		var dragState = _v2.b;
		var _v3 = dragState;
		var offset = _v3.d0;
		var dragElementDimension = _v3.jq;
		var leftOffset = offset.a / 2;
		var topOffset = offset.b / 2;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
							$rtfeldman$elm_css$Css$left(
							$rtfeldman$elm_css$Css$px(leftOffset)),
							$rtfeldman$elm_css$Css$top(
							$rtfeldman$elm_css$Css$px(topOffset)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$rem(0.4)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$px(10)),
							$rtfeldman$elm_css$Css$maxWidth(
							$rtfeldman$elm_css$Css$rem(40)),
							$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$hidden),
							$rtfeldman$elm_css$Css$margin(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$OrganisationUnit$CheckpointGroupEditor$elementTitle(checkpointElement))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$dropIndicator = function (dnd) {
	var _v0 = _Utils_Tuple2(dnd.jf, dnd.hF);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.a.a;
		var hovering = _v1.a;
		var droppableState = _v1.b;
		switch (droppableState) {
			case 0:
				return _List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$borderTop3,
						$rtfeldman$elm_css$Css$px(2),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]);
			case 1:
				if (!hovering.$) {
					return _List_fromArray(
						[
							A3(
							$rtfeldman$elm_css$Css$borderTop3,
							$rtfeldman$elm_css$Css$px(2),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							A3(
							$rtfeldman$elm_css$Css$borderBottom3,
							$rtfeldman$elm_css$Css$px(2),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
						]);
				} else {
					return _List_Nil;
				}
			default:
				return _List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$borderBottom3,
						$rtfeldman$elm_css$Css$px(2),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Translations$Checkpoints$numberOfCheckpoints = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'checkpoints.numberOfCheckpoints',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewAvatar = $author$project$UI$Avatar$icon(
	$author$project$UI$Icon$bicolor($author$project$UI$Icons$pinCircleBicolor));
var $author$project$OrganisationUnit$CheckpointGroupEditor$UserClickedCreateCheckpointIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewCreateIcon = function (checkpointGroup) {
	return A2(
		$author$project$UI$Icon$withOnClickStopPropagation,
		$author$project$OrganisationUnit$CheckpointGroupEditor$UserClickedCreateCheckpointIcon(checkpointGroup),
		$author$project$UI$Icon$unicolor($author$project$UI$Icons$add));
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$UserClickedEditGroupIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewEditGroupIcon = function (checkpointGroup) {
	return A2(
		$author$project$UI$Icon$withOnClickStopPropagation,
		$author$project$OrganisationUnit$CheckpointGroupEditor$UserClickedEditGroupIcon(checkpointGroup),
		$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle));
};
var $author$project$Translations$Checkpoints$noCheckpoints = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.noCheckpoints');
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$Checkpoint = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$toCheckpointElement = $author$project$OrganisationUnit$CheckpointGroupEditor$Checkpoint;
var $author$project$OrganisationUnit$CheckpointGroupEditor$UserClickedEditCheckpointIcon = function (a) {
	return {$: 3, a: a};
};
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewEditCheckpointIcon = function (checkpoint) {
	return A2(
		$author$project$UI$Icon$withOnClickStopPropagation,
		$author$project$OrganisationUnit$CheckpointGroupEditor$UserClickedEditCheckpointIcon(checkpoint),
		$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle));
};
var $author$project$UI$Table$Row$DragAndDrop = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Table$Row$withDragAndDrop = F2(
	function (dragAndDropConfig, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				hN: $author$project$UI$Table$Row$DragAndDrop(dragAndDropConfig)
			});
	});
var $author$project$UI$Table$Row$withLabelColor = F2(
	function (color, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{fB: color});
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewCheckpoint = F4(
	function (translations, viewType, _v0, checkpointElement) {
		var model = _v0;
		if (!checkpointElement.$) {
			return A3($author$project$UI$Table$Row$row, viewType, '', checkpointElement);
		} else {
			var checkpoint = checkpointElement.a;
			var dragAndDropConfig = {
				hL: $author$project$OrganisationUnit$CheckpointGroupEditor$CheckpointGroupDnDEvent,
				hM: $author$project$OrganisationUnit$CheckpointGroupEditor$CheckpointGroupDnDEventDragEnd,
				hN: model.a6,
				hO: $author$project$OrganisationUnit$CheckpointGroupEditor$dropIndicator(model.a6),
				iG: $author$project$OrganisationUnit$CheckpointGroupEditor$checkpointGroupToDragElem
			};
			return A2(
				$author$project$UI$Table$Row$withDragAndDrop,
				dragAndDropConfig,
				A2(
					$author$project$UI$Table$Row$withRightIcon,
					$author$project$OrganisationUnit$CheckpointGroupEditor$viewEditCheckpointIcon(checkpoint),
					A2(
						$author$project$UI$Table$Row$withAvatar,
						$author$project$OrganisationUnit$CheckpointGroupEditor$viewAvatar,
						A2(
							$author$project$UI$Table$Row$withLabelColor,
							$author$project$UI$Style$Theme$darkGrey,
							A2(
								$author$project$UI$Table$Row$changeSubLabelDirection,
								0,
								A2(
									$author$project$UI$Table$Row$withSubLabel,
									A2($author$project$CheckpointData$Checkpoint$CheckpointType$toText, translations, checkpoint.fg),
									A3($author$project$UI$Table$Row$row, viewType, checkpoint.k8, checkpointElement)))))));
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewSubContent = F5(
	function (translations, viewType, editor, checkpointGroup, checkpointData) {
		var checkpointList = A2($author$project$CheckpointData$CheckpointData$getCheckpointsOf, checkpointGroup.cC, checkpointData);
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Checkpoints$noCheckpoints(translations),
				A2(
					$author$project$UI$Table$appendStyle,
					$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$rem(1)),
					A2(
						$author$project$UI$Table$appendStyle,
						$rtfeldman$elm_css$Css$marginLeft(
							$rtfeldman$elm_css$Css$rem(2)),
						A2(
							$author$project$UI$Table$fromList,
							A3($author$project$OrganisationUnit$CheckpointGroupEditor$viewCheckpoint, translations, viewType, editor),
							A2($elm$core$List$map, $author$project$OrganisationUnit$CheckpointGroupEditor$toCheckpointElement, checkpointList))))));
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewCheckpointGroupRow = F5(
	function (translations, viewType, checkpointData, editor, checkpointElement) {
		var model = editor;
		if (!checkpointElement.$) {
			var checkpointGroup = checkpointElement.a;
			var subLabel = A2(
				$author$project$Translations$Checkpoints$numberOfCheckpoints,
				translations,
				$elm$core$String$fromInt(
					$elm$core$List$length(
						A2($author$project$CheckpointData$CheckpointData$getCheckpointsOf, checkpointGroup.cC, checkpointData))));
			var dragAndDropConfig = {
				hL: $author$project$OrganisationUnit$CheckpointGroupEditor$CheckpointGroupDnDEvent,
				hM: $author$project$OrganisationUnit$CheckpointGroupEditor$CheckpointGroupDnDEventDragEnd,
				hN: model.a6,
				hO: $author$project$OrganisationUnit$CheckpointGroupEditor$dropIndicator(model.a6),
				iG: $author$project$OrganisationUnit$CheckpointGroupEditor$checkpointGroupToDragElem
			};
			var _v1 = A2($elm$core$List$member, checkpointGroup.cC, model.cR) ? _Utils_Tuple2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$Collapse(checkpointGroup.cC),
				$elm$core$Maybe$Just(
					A5($author$project$OrganisationUnit$CheckpointGroupEditor$viewSubContent, translations, viewType, editor, checkpointGroup, checkpointData))) : _Utils_Tuple2(
				$author$project$OrganisationUnit$CheckpointGroupEditor$Expand(checkpointGroup.cC),
				$elm$core$Maybe$Nothing);
			var onClickMsg = _v1.a;
			var subContent = _v1.b;
			return A2(
				$author$project$UI$Table$Row$withDragAndDrop,
				dragAndDropConfig,
				A2(
					$author$project$UI$Table$Row$appendContent,
					subContent,
					A2(
						$author$project$UI$Table$Row$appendRightIcon,
						$author$project$OrganisationUnit$CheckpointGroupEditor$viewCreateIcon(checkpointGroup),
						A2(
							$author$project$UI$Table$Row$withRightIcon,
							$author$project$OrganisationUnit$CheckpointGroupEditor$viewEditGroupIcon(checkpointGroup),
							A2(
								$author$project$UI$Table$Row$withOnClick,
								onClickMsg,
								A2(
									$author$project$UI$Table$Row$withAvatar,
									$author$project$OrganisationUnit$CheckpointGroupEditor$viewAvatar,
									A2(
										$author$project$UI$Table$Row$withLabelColor,
										$author$project$UI$Style$Theme$darkGrey,
										A2(
											$author$project$UI$Table$Row$changeSubLabelDirection,
											0,
											A2(
												$author$project$UI$Table$Row$withSubLabel,
												subLabel,
												A3($author$project$UI$Table$Row$row, viewType, checkpointGroup.k8, checkpointElement))))))))));
		} else {
			return A3($author$project$UI$Table$Row$row, viewType, '', checkpointElement);
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewContent = F3(
	function (environment, repository, editor) {
		var model = editor;
		var viewType = $author$project$Environments$Environment$getViewType(environment);
		var translations = $author$project$Environments$Environment$translations(environment);
		var _v0 = A3(
			$author$project$CheckpointData$CommandHandler$handleCommands,
			$author$project$CheckpointData$Commands$fromList(model.a7),
			environment,
			$author$project$Environments$Repository$getCheckpointData(repository));
		if (!_v0.$) {
			var result = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Environments$Repository$getCheckpointData,
				A4($author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations, result.cD, result.b8, result.cb, repository));
			var checkpointData = _v1.a;
			return A3(
				$elm$core$Basics$composeR,
				$author$project$UI$Table$fromList(
					A4($author$project$OrganisationUnit$CheckpointGroupEditor$viewCheckpointGroupRow, translations, viewType, checkpointData, editor)),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Table$withEmptyText(
						$author$project$Translations$Checkpoints$emptyText(translations)),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Table$appendStyle(
							$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(1))),
						A2(
							$elm$core$Basics$composeR,
							$author$project$UI$Table$appendStyle(
								$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$rem(1))),
							$author$project$UI$Table$view))),
				A2(
					$elm$core$List$map,
					$author$project$OrganisationUnit$CheckpointGroupEditor$toCheckpointGroupElement,
					A2($author$project$CheckpointData$CheckpointData$getCheckpointGroupAndPrev, model.jT, checkpointData)));
		} else {
			var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
			return A3(
				$elm$core$Basics$composeR,
				$author$project$UI$Table$fromList(
					A4($author$project$OrganisationUnit$CheckpointGroupEditor$viewCheckpointGroupRow, translations, viewType, checkpointData, editor)),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Table$withEmptyText(
						$author$project$Translations$Checkpoints$emptyText(translations)),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Table$appendStyle(
							$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(1))),
						A2(
							$elm$core$Basics$composeR,
							$author$project$UI$Table$appendStyle(
								$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$rem(1))),
							$author$project$UI$Table$view))),
				A2(
					$elm$core$List$map,
					$author$project$OrganisationUnit$CheckpointGroupEditor$toCheckpointGroupElement,
					A2($author$project$CheckpointData$CheckpointData$getCheckpointGroupAndPrev, model.jT, checkpointData)));
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Checkpoints$CheckpointDialog$createHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.checkpointDialog.createHeader');
};
var $author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedCancelButton = {$: 3};
var $author$project$CheckpointData$Checkpoint$CreateDialog$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedCancelButton,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedCreateButton = {$: 4};
var $author$project$CheckpointData$Checkpoint$CreateDialog$viewCreateButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedCreateButton,
			$author$project$UI$Button$green(
				$author$project$Translations$Buttons$create(translations))));
};
var $author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedNextButton = {$: 1};
var $author$project$CheckpointData$Checkpoint$CreateDialog$viewNextButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedNextButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$next(translations)))));
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$viewRightButton = F3(
	function (translations, disableBtn, currentStep) {
		if (!currentStep) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
							]))
					]),
				_List_fromArray(
					[
						A2($author$project$CheckpointData$Checkpoint$CreateDialog$viewNextButton, translations, disableBtn)
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
							]))
					]),
				_List_fromArray(
					[
						$author$project$CheckpointData$Checkpoint$CreateDialog$viewCreateButton(translations)
					]));
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedStepIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$Checkpoint$CreateDialog$viewStepIcon = F4(
	function (icon, step, currentStep, platform) {
		var marginRight_ = function () {
			if (!step) {
				if (!platform.$) {
					return $rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(1));
				} else {
					return $rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(0.2));
				}
			} else {
				return $rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero);
			}
		}();
		var calcRem = function () {
			if (!platform.$) {
				return $rtfeldman$elm_css$Css$rem(2.5);
			} else {
				return $rtfeldman$elm_css$Css$rem(1.3);
			}
		}();
		var _v0 = _Utils_eq(step, currentStep) ? _Utils_Tuple2($author$project$UI$Style$Theme$white, $author$project$UI$Style$Theme$darkGrey) : _Utils_Tuple2($author$project$UI$Style$Theme$darkGrey, $author$project$UI$Style$Theme$lightGrey);
		var foregroundColor_ = _v0.a;
		var backgroundColor_ = _v0.b;
		return $author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedStepIcon(step),
				A2(
					$author$project$UI$Icon$withStyle,
					marginRight_,
					A2(
						$author$project$UI$Icon$withBackgroundColor,
						backgroundColor_,
						A2(
							$author$project$UI$Icon$withForegroundColor,
							foregroundColor_,
							A2(
								$author$project$UI$Icon$withStyle,
								$rtfeldman$elm_css$Css$height(
									A3(
										$rtfeldman$elm_css$Css$calc,
										calcRem,
										$rtfeldman$elm_css$Css$plus,
										$rtfeldman$elm_css$Css$px(2))),
								A2(
									$author$project$UI$Icon$withStyle,
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									$author$project$UI$Icon$bicolor(icon))))))));
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$viewSteps = F2(
	function (currentStep, platform) {
		var marginLeft_ = function () {
			if (!platform.$) {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(0.6))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
							]),
						marginLeft_))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$top(
									$rtfeldman$elm_css$Css$pct(50)),
									$rtfeldman$elm_css$Css$right(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$left(
									$rtfeldman$elm_css$Css$rem(1)),
									A3(
									$rtfeldman$elm_css$Css$border3,
									$rtfeldman$elm_css$Css$px(1),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
								]))
						]),
					_List_Nil),
					A4($author$project$CheckpointData$Checkpoint$CreateDialog$viewStepIcon, $author$project$UI$Icons$pinCircleBicolor, 0, currentStep, platform),
					A4($author$project$CheckpointData$Checkpoint$CreateDialog$viewStepIcon, $author$project$UI$Icons$tagCircleBicolor, 1, currentStep, platform)
				]));
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$viewFooter = F4(
	function (translations, platform, disableBtn, currentStep) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto 1fr'),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$CheckpointData$Checkpoint$CreateDialog$viewCancelButton(translations),
					A2($author$project$CheckpointData$Checkpoint$CreateDialog$viewSteps, currentStep, platform),
					A3($author$project$CheckpointData$Checkpoint$CreateDialog$viewRightButton, translations, disableBtn, currentStep)
				]));
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$viewBasicDataStep = F3(
	function (translations, platform, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(32)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$CheckpointData$Checkpoint$CreateDialog$viewFooter, translations, platform, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$CheckpointData$Checkpoint$CreateDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Checkpoints$CheckpointDialog$createHeader(translations),
									$author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$GotTypeEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Translations$CheckpointTypes$cpType = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.cpType');
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$tag),
			$author$project$UI$Bar$bar(
				$author$project$Translations$CheckpointTypes$cpType(translations))));
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$UserEnteredType = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Select$Config = $elm$core$Basics$identity;
var $author$project$UI$Select$custom = function (_v0) {
	var toValue = _v0.la;
	var fromValue = _v0.jD;
	var toText = _v0.k9;
	return {jo: false, jD: fromValue, eO: $elm$core$Maybe$Nothing, d1: $elm$core$Maybe$Nothing, ef: $elm$core$Maybe$Nothing, by: _List_Nil, k9: toText, la: toValue};
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$defaultInfoModel = {hl: ''};
var $author$project$CheckpointData$Checkpoint$CheckpointType$defaultMultiSelectModel = {fR: _List_Nil};
var $author$project$CheckpointData$Checkpoint$CheckpointType$defaultSelectModel = {fR: _List_Nil};
var $author$project$CheckpointData$Checkpoint$CheckpointType$defaultIndividualDataModel = {bd: _List_Nil};
var $author$project$CheckpointData$Checkpoint$CheckpointType$stringToType = function (string) {
	switch (string) {
		case 'number':
			return $elm$core$Maybe$Just(
				$author$project$CheckpointData$Checkpoint$CheckpointType$NumberType($author$project$CheckpointData$Checkpoint$CheckpointType$defaultNumberModel));
		case 'textRow':
			return $elm$core$Maybe$Just($author$project$CheckpointData$Checkpoint$CheckpointType$TextRowType);
		case 'textMemo':
			return $elm$core$Maybe$Just($author$project$CheckpointData$Checkpoint$CheckpointType$TextMemoType);
		case 'checkbox':
			return $elm$core$Maybe$Just($author$project$CheckpointData$Checkpoint$CheckpointType$CheckboxType);
		case 'individualData':
			return $elm$core$Maybe$Just(
				$author$project$CheckpointData$Checkpoint$CheckpointType$IndividualDataType($author$project$CheckpointData$Checkpoint$CheckpointType$defaultIndividualDataModel));
		case 'select':
			return $elm$core$Maybe$Just(
				$author$project$CheckpointData$Checkpoint$CheckpointType$SelectType($author$project$CheckpointData$Checkpoint$CheckpointType$defaultSelectModel));
		case 'multiSelect':
			return $elm$core$Maybe$Just(
				$author$project$CheckpointData$Checkpoint$CheckpointType$MultiSelectType($author$project$CheckpointData$Checkpoint$CheckpointType$defaultMultiSelectModel));
		case 'date':
			return $elm$core$Maybe$Just($author$project$CheckpointData$Checkpoint$CheckpointType$DateType);
		case 'image':
			return $elm$core$Maybe$Just($author$project$CheckpointData$Checkpoint$CheckpointType$ImageType);
		case 'info':
			return $elm$core$Maybe$Just(
				$author$project$CheckpointData$Checkpoint$CheckpointType$InfoType($author$project$CheckpointData$Checkpoint$CheckpointType$defaultInfoModel));
		case 'signature':
			return $elm$core$Maybe$Just($author$project$CheckpointData$Checkpoint$CheckpointType$SignatureType);
		case 'time':
			return $elm$core$Maybe$Just($author$project$CheckpointData$Checkpoint$CheckpointType$TimeType);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$CheckpointData$Checkpoint$CheckpointType$toParseValue = function (cpType) {
	switch (cpType.$) {
		case 0:
			return 'number';
		case 1:
			return 'textRow';
		case 2:
			return 'textMemo';
		case 3:
			return 'checkbox';
		case 4:
			return 'individualData';
		case 5:
			return 'select';
		case 6:
			return 'multiSelect';
		case 7:
			return 'date';
		case 8:
			return 'image';
		case 9:
			return 'info';
		case 10:
			return 'signature';
		default:
			return 'time';
	}
};
var $rtfeldman$elm_css$Html$Styled$select = $rtfeldman$elm_css$Html$Styled$node('select');
var $author$project$UI$Select$onEnterHelper = function (msg) {
	var isEnterKey = function (keyCode) {
		return (keyCode === 13) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('');
	};
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$andThen, isEnterKey, $rtfeldman$elm_css$Html$Styled$Events$keyCode));
};
var $author$project$UI$Select$setOnEnter = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2($elm$core$Basics$composeR, $author$project$UI$Select$onEnterHelper, $elm$core$List$cons)),
	$elm$core$Maybe$withDefault($elm$core$Basics$identity));
var $author$project$UI$Select$setOnInput = function (config) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Basics$identity,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$composeR(config.jD),
				A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Html$Styled$Events$onInput, $elm$core$List$cons)),
			config.d1));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$selected = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
var $author$project$UI$Select$viewOption = F2(
	function (config, data) {
		var value_ = config.la(data);
		var text_ = config.k9(data);
		var isSelected = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(value_),
				config.ef));
		return A2(
			$rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$value(value_),
					$rtfeldman$elm_css$Html$Styled$Attributes$selected(isSelected)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(text_)
				]));
	});
var $author$project$UI$Select$viewOptions = function (config) {
	return $elm$core$List$map(
		$author$project$UI$Select$viewOption(config));
};
var $author$project$UI$Select$viewSelect = function (config) {
	var _v0 = config.jo ? _Utils_Tuple2(
		$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.5)),
		$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed)) : _Utils_Tuple2(
		$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(1)),
		$author$project$Utils$CSS$changeCursor(config.d1));
	var opacity_ = _v0.a;
	var disabledCursor = _v0.b;
	var attributes = A2(
		$author$project$UI$Select$setOnEnter,
		config.eO,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, '-moz-appearance', 'none'),
						A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
						A2($rtfeldman$elm_css$Css$property, 'appearance', 'none'),
						opacity_,
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
						$rtfeldman$elm_css$Css$focus(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$borderColor(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								A2(
								$rtfeldman$elm_css$Css$pseudoElement,
								'-ms-value',
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Css$pseudoElement,
						'-ms-expand',
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
							])),
						disabledCursor
					]))
			]));
	return A2(
		$elm$core$Basics$composeR,
		$author$project$UI$Select$viewOptions(config),
		$rtfeldman$elm_css$Html$Styled$select(
			A2($author$project$UI$Select$setOnInput, config, attributes)));
};
var $author$project$UI$Select$viewToggle = $author$project$UI$Icon$view(
	A2(
		$author$project$UI$Icon$withStyle,
		$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none),
		A2(
			$author$project$UI$Icon$withStyle,
			$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$rem(0.75)),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$right(
					$rtfeldman$elm_css$Css$rem(0.5)),
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$top(
						$rtfeldman$elm_css$Css$rem(1)),
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
						A2(
							$author$project$UI$Icon$withForegroundColor,
							$author$project$UI$Style$Theme$darkGrey,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$arrowDown))))))));
var $author$project$UI$Select$view = F2(
	function (data, _v0) {
		var config = _v0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
							$rtfeldman$elm_css$Css$batch(config.by)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$Select$viewSelect, config, data),
					$author$project$UI$Select$viewToggle
				]));
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$UserEnteredInfoText = function (a) {
	return {$: 5, a: a};
};
var $author$project$Translations$CheckpointTypes$enterInfoText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.enterInfoText');
};
var $author$project$Translations$CheckpointTypes$enterText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.enterText');
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewEnterText = function (str) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(str)
			]));
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewInfo = F2(
	function (translations, model) {
		return _List_fromArray(
			[
				$author$project$CheckpointData$Checkpoint$TypeEditor$viewEnterText(
				$author$project$Translations$CheckpointTypes$enterInfoText(translations)),
				$author$project$UI$TextInput$view(
				A2(
					$author$project$UI$TextInput$withOnInput,
					$author$project$CheckpointData$Checkpoint$TypeEditor$UserEnteredInfoText,
					A2(
						$author$project$UI$TextInput$withPlaceholder,
						$author$project$Translations$CheckpointTypes$enterText(translations),
						A2($author$project$UI$TextInput$withValue, model.hl, $author$project$UI$TextInput$multiLine))))
			]);
	});
var $author$project$Translations$CheckpointTypes$values = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.values');
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$AddOption = {$: 2};
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewAddOption = A2(
	$author$project$UI$Icon$withOnClick,
	$author$project$CheckpointData$Checkpoint$TypeEditor$AddOption,
	$author$project$UI$Icon$unicolor($author$project$UI$Icons$add));
var $author$project$Translations$CheckpointTypes$noOptions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.noOptions');
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$DeleteOption = function (a) {
	return {$: 4, a: a};
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$UpdateOption = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Translations$CheckpointTypes$enterValue = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.EnterValue');
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewOption = F2(
	function (translations, option) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$margin(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(4)),
							A3(
							$rtfeldman$elm_css$Css$borderBottom3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$TextInput$view(
					A2(
						$author$project$UI$TextInput$withStyle,
						$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(0)),
						A2(
							$author$project$UI$TextInput$withPlaceholder,
							$author$project$Translations$CheckpointTypes$enterValue(translations),
							A2(
								$author$project$UI$TextInput$withValue,
								option.hl,
								A2(
									$author$project$UI$TextInput$withOnInput,
									$author$project$CheckpointData$Checkpoint$TypeEditor$UpdateOption(option.fw),
									$author$project$UI$TextInput$singleLine))))),
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$rem(4)),
						A2(
							$author$project$UI$Icon$withForegroundColor,
							$author$project$UI$Style$Theme$red,
							A2(
								$author$project$UI$Icon$withOnClick,
								$author$project$CheckpointData$Checkpoint$TypeEditor$DeleteOption(option.fw),
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete)))))
				]));
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewOptionList = F2(
	function (translations, options) {
		return $elm$core$List$isEmpty(options) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$CheckpointTypes$noOptions(translations))
					]))
			]) : A2(
			$elm$core$List$map,
			$author$project$CheckpointData$Checkpoint$TypeEditor$viewOption(translations),
			options);
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewMultiSelect = F2(
	function (translations, model) {
		return _Utils_ap(
			_List_fromArray(
				[
					$author$project$UI$Bar$view(
					A2(
						$author$project$UI$Bar$withStyle,
						$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(1)),
						A2(
							$author$project$UI$Bar$withRightIcon,
							$author$project$CheckpointData$Checkpoint$TypeEditor$viewAddOption,
							$author$project$UI$Bar$bar(
								$author$project$Translations$CheckpointTypes$values(translations)))))
				]),
			A2($author$project$CheckpointData$Checkpoint$TypeEditor$viewOptionList, translations, model.fR));
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$UserEnteredDecimalDigit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$CheckpointTypes$enterNumberOfDigits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointTypes.enterNumberOfDigits');
};
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewNumberModel = F2(
	function (translations, model) {
		return _List_fromArray(
			[
				$author$project$CheckpointData$Checkpoint$TypeEditor$viewEnterText(
				$author$project$Translations$CheckpointTypes$enterNumberOfDigits(translations)),
				$author$project$UI$TextInput$view(
				A2(
					$author$project$UI$TextInput$withOnInput,
					$author$project$CheckpointData$Checkpoint$TypeEditor$UserEnteredDecimalDigit,
					A2(
						$author$project$UI$TextInput$withPlaceholder,
						$author$project$Translations$CheckpointTypes$enterNumberOfDigits(translations),
						A2(
							$author$project$UI$TextInput$withValue,
							$elm$core$String$fromInt(model.hJ),
							$author$project$UI$TextInput$singleLine))))
			]);
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewSelect = F2(
	function (translations, model) {
		return _Utils_ap(
			_List_fromArray(
				[
					$author$project$UI$Bar$view(
					A2(
						$author$project$UI$Bar$withStyle,
						$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(1)),
						A2(
							$author$project$UI$Bar$withRightIcon,
							$author$project$CheckpointData$Checkpoint$TypeEditor$viewAddOption,
							$author$project$UI$Bar$bar(
								$author$project$Translations$CheckpointTypes$values(translations)))))
				]),
			A2($author$project$CheckpointData$Checkpoint$TypeEditor$viewOptionList, translations, model.fR));
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewAdditionalContent = F2(
	function (translations, type_) {
		switch (type_.$) {
			case 0:
				var numberModel = type_.a;
				return A2($author$project$CheckpointData$Checkpoint$TypeEditor$viewNumberModel, translations, numberModel);
			case 1:
				return _List_Nil;
			case 2:
				return _List_Nil;
			case 3:
				return _List_Nil;
			case 4:
				var individualDataModel = type_.a;
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('ToDo')
					]);
			case 5:
				var selectModel = type_.a;
				return A2($author$project$CheckpointData$Checkpoint$TypeEditor$viewSelect, translations, selectModel);
			case 6:
				var multiSelectModel = type_.a;
				return A2($author$project$CheckpointData$Checkpoint$TypeEditor$viewMultiSelect, translations, multiSelectModel);
			case 7:
				return _List_Nil;
			case 8:
				return _List_Nil;
			case 9:
				var infoModel = type_.a;
				return A2($author$project$CheckpointData$Checkpoint$TypeEditor$viewInfo, translations, infoModel);
			case 10:
				return _List_Nil;
			default:
				return _List_Nil;
		}
	});
var $author$project$UI$Select$withOnInput = F2(
	function (onInput, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				d1: $elm$core$Maybe$Just(onInput)
			});
	});
var $author$project$UI$Select$withSelected = F2(
	function (selectedData, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				ef: $elm$core$Maybe$Just(
					config.la(selectedData))
			});
	});
var $author$project$UI$Select$withStyle = F2(
	function (style, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				by: A2($elm$core$List$cons, style, config.by)
			});
	});
var $author$project$CheckpointData$Checkpoint$TypeEditor$viewForm = F2(
	function (translations, _v0) {
		var type_ = _v0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$UI$Select$view,
						_List_fromArray(
							[
								$author$project$CheckpointData$Checkpoint$CheckpointType$NumberType($author$project$CheckpointData$Checkpoint$CheckpointType$defaultNumberModel),
								$author$project$CheckpointData$Checkpoint$CheckpointType$TextRowType,
								$author$project$CheckpointData$Checkpoint$CheckpointType$TextMemoType,
								$author$project$CheckpointData$Checkpoint$CheckpointType$CheckboxType,
								$author$project$CheckpointData$Checkpoint$CheckpointType$SelectType($author$project$CheckpointData$Checkpoint$CheckpointType$defaultSelectModel),
								$author$project$CheckpointData$Checkpoint$CheckpointType$MultiSelectType($author$project$CheckpointData$Checkpoint$CheckpointType$defaultMultiSelectModel),
								$author$project$CheckpointData$Checkpoint$CheckpointType$DateType,
								$author$project$CheckpointData$Checkpoint$CheckpointType$ImageType,
								$author$project$CheckpointData$Checkpoint$CheckpointType$InfoType($author$project$CheckpointData$Checkpoint$CheckpointType$defaultInfoModel),
								$author$project$CheckpointData$Checkpoint$CheckpointType$SignatureType,
								$author$project$CheckpointData$Checkpoint$CheckpointType$TimeType
							]),
						A2(
							$author$project$UI$Select$withStyle,
							$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1)),
							A2(
								$author$project$UI$Select$withSelected,
								type_,
								A2(
									$author$project$UI$Select$withOnInput,
									$author$project$CheckpointData$Checkpoint$TypeEditor$UserEnteredType,
									$author$project$UI$Select$custom(
										{
											jD: $author$project$CheckpointData$Checkpoint$CheckpointType$stringToType,
											k9: $author$project$CheckpointData$Checkpoint$CheckpointType$toText(translations),
											la: $author$project$CheckpointData$Checkpoint$CheckpointType$toParseValue
										})))))
					]),
				A2($author$project$CheckpointData$Checkpoint$TypeEditor$viewAdditionalContent, translations, type_)));
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$viewTypeStep = F3(
	function (translations, platform, typeEditor) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(32)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$CheckpointData$Checkpoint$CreateDialog$viewFooter, translations, platform, false, 1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$CheckpointData$Checkpoint$CreateDialog$GotTypeEditorMsg,
							A2($author$project$CheckpointData$Checkpoint$TypeEditor$viewForm, translations, typeEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$CheckpointData$Checkpoint$TypeEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Checkpoints$CheckpointDialog$createHeader(translations),
									$author$project$CheckpointData$Checkpoint$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$viewDialog = F3(
	function (translations, platform, model) {
		var _v0 = model.b0;
		if (!_v0) {
			return A3($author$project$CheckpointData$Checkpoint$CreateDialog$viewBasicDataStep, translations, platform, model.aQ);
		} else {
			return A3($author$project$CheckpointData$Checkpoint$CreateDialog$viewTypeStep, translations, platform, model.em);
		}
	});
var $author$project$CheckpointData$Checkpoint$CreateDialog$view = F2(
	function (environment, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A4(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy3,
					$author$project$CheckpointData$Checkpoint$CreateDialog$viewDialog,
					$author$project$Environments$Environment$translations(environment),
					$author$project$Environments$Environment$platform(environment),
					model);
			default:
				var model = dialog.a;
				return A4(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy3,
					$author$project$CheckpointData$Checkpoint$CreateDialog$viewDialog,
					$author$project$Environments$Environment$translations(environment),
					$author$project$Environments$Environment$platform(environment),
					model);
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewCreateCheckpointDialog = function (environment) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$CheckpointData$Checkpoint$CreateDialog$view(environment),
		$rtfeldman$elm_css$Html$Styled$map($author$project$OrganisationUnit$CheckpointGroupEditor$GotCreateCheckpointDialogMsg));
};
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Checkpoints$CheckpointGroupDialog$createHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.checkpointGroupDialog.createHeader');
};
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$UserClickedCancelButton = {$: 1};
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$CheckpointData$CheckpointGroup$CreateDialog$UserClickedCancelButton,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$UserClickedCreateButton = {$: 2};
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$viewCreateButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$CheckpointData$CheckpointGroup$CreateDialog$UserClickedCreateButton,
					$author$project$UI$Button$green(
						$author$project$Translations$Buttons$create(translations)))));
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$viewFooter = F2(
	function (translations, disableBtn) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto'),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$CheckpointData$CheckpointGroup$CreateDialog$viewCancelButton(translations),
					A2($author$project$CheckpointData$CheckpointGroup$CreateDialog$viewCreateButton, translations, disableBtn)
				]));
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$viewBasicDataStep = F2(
	function (translations, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendFooter,
				A2($author$project$CheckpointData$CheckpointGroup$CreateDialog$viewFooter, translations, disableBtn),
				A2(
					$author$project$UI$Dialog$appendContent,
					A2(
						$rtfeldman$elm_css$Html$Styled$map,
						$author$project$CheckpointData$CheckpointGroup$CreateDialog$GotBasicDataEditorMsg,
						A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
					A2(
						$author$project$UI$Dialog$appendHeader,
						$author$project$UI$BasicDataEditor$viewBar(translations),
						A2(
							$author$project$UI$Dialog$withIcon,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
							A2(
								$author$project$UI$Dialog$dialog,
								$author$project$Translations$Checkpoints$CheckpointGroupDialog$createHeader(translations),
								$author$project$CheckpointData$CheckpointGroup$CreateDialog$UserClickedCloseDialog))))));
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$viewDialog = F2(
	function (translations, model) {
		return A2($author$project$CheckpointData$CheckpointGroup$CreateDialog$viewBasicDataStep, translations, model.aQ);
	});
var $author$project$CheckpointData$CheckpointGroup$CreateDialog$view = F2(
	function (translations, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$CheckpointData$CheckpointGroup$CreateDialog$viewDialog, translations, model);
			default:
				var model = dialog.a;
				return A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$CheckpointData$CheckpointGroup$CreateDialog$viewDialog, translations, model);
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewCreateGroupDialog = function (translations) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$CheckpointData$CheckpointGroup$CreateDialog$view(translations),
		$rtfeldman$elm_css$Html$Styled$map($author$project$OrganisationUnit$CheckpointGroupEditor$GotCreateGroupDialogMsg));
};
var $author$project$CheckpointData$Checkpoint$EditDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Checkpoints$CheckpointDialog$editHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.checkpointDialog.editHeader');
};
var $author$project$Translations$Checkpoints$Delete$deletedCheckpoint = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.delete.deletedCheckpoint');
};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDeleted = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Checkpoints$Delete$deletedCheckpoint(translations))
			]));
};
var $author$project$CheckpointData$Checkpoint$EditDialog$UserClickedCloseButton = {$: 5};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$CheckpointData$Checkpoint$EditDialog$UserClickedCloseButton,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDeletedFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$CheckpointData$Checkpoint$EditDialog$viewCloseButton(translations)
			]));
};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDeletedDialog = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return $author$project$UI$Dialog$view(
		A2(
			$author$project$UI$Dialog$appendFooter,
			$author$project$CheckpointData$Checkpoint$EditDialog$viewDeletedFooter(translations),
			A2(
				$author$project$UI$Dialog$appendContent,
				$author$project$CheckpointData$Checkpoint$EditDialog$viewDeleted(translations),
				A2(
					$author$project$UI$Dialog$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
					A2(
						$author$project$UI$Dialog$dialog,
						$author$project$Translations$Checkpoints$CheckpointDialog$editHeader(translations),
						$author$project$CheckpointData$Checkpoint$EditDialog$UserClickedCloseDialog)))));
};
var $author$project$CheckpointData$Checkpoint$EditDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$CheckpointData$Checkpoint$EditDialog$DeleteTab = 2;
var $author$project$CheckpointData$Checkpoint$EditDialog$UserClickedApplyButton = {$: 3};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewApplyButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$CheckpointData$Checkpoint$EditDialog$UserClickedApplyButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$apply(translations)))));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$UserClickedCancelButton = {$: 2};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$CheckpointData$Checkpoint$EditDialog$UserClickedCancelButton,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$CheckpointData$Checkpoint$EditDialog$UserClickedDeleteButton = {$: 4};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$CheckpointData$Checkpoint$EditDialog$UserClickedDeleteButton,
			$author$project$UI$Button$darkRed(
				$author$project$Translations$Buttons$delete(translations))));
};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewFooter = F3(
	function (translations, disableBtn, tab) {
		var rightButton = (tab === 2) ? $author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteButton(translations) : A2($author$project$CheckpointData$Checkpoint$EditDialog$viewApplyButton, translations, disableBtn);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$CheckpointData$Checkpoint$EditDialog$viewCancelButton(translations),
					rightButton
				]));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$TypeTab = 1;
var $author$project$CheckpointData$Checkpoint$EditDialog$viewTabBarAvatar = A2(
	$author$project$UI$Avatar$withStyle,
	$rtfeldman$elm_css$Css$height(
		$rtfeldman$elm_css$Css$rem(4)),
	A2(
		$author$project$UI$Avatar$withStyle,
		$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$rem(4)),
		$author$project$UI$Avatar$icon(
			$author$project$UI$Icon$bicolor($author$project$UI$Icons$pinCircleBicolor))));
var $author$project$CheckpointData$Checkpoint$EditDialog$UserClickedTabIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewTabBarIcon = F3(
	function (icon, tab, currentTab) {
		return _Utils_eq(tab, currentTab) ? A2(
			$author$project$UI$Icon$withForegroundColor,
			$author$project$UI$Style$Theme$darkGrey,
			$author$project$UI$Icon$unicolor(icon)) : A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$CheckpointData$Checkpoint$EditDialog$UserClickedTabIcon(tab),
			A2(
				$author$project$UI$Icon$withForegroundColor,
				$author$project$UI$Style$Theme$grey,
				$author$project$UI$Icon$unicolor(icon)));
	});
var $author$project$UI$TabBar$withAvatar = F2(
	function (avatar, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				iX: $elm$core$Maybe$Just(avatar)
			});
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$viewTabBar = F2(
	function (basicDataEditor, currentTab) {
		return $author$project$UI$TabBar$view(
			A2(
				$author$project$UI$TabBar$appendRightIcon,
				A3($author$project$CheckpointData$Checkpoint$EditDialog$viewTabBarIcon, $author$project$UI$Icons$delete, 2, currentTab),
				A2(
					$author$project$UI$TabBar$appendRightIcon,
					A3($author$project$CheckpointData$Checkpoint$EditDialog$viewTabBarIcon, $author$project$UI$Icons$tag, 1, currentTab),
					A2(
						$author$project$UI$TabBar$appendRightIcon,
						A3($author$project$CheckpointData$Checkpoint$EditDialog$viewTabBarIcon, $author$project$UI$Icons$pin, 0, currentTab),
						A2(
							$author$project$UI$TabBar$withAvatar,
							$author$project$CheckpointData$Checkpoint$EditDialog$viewTabBarAvatar,
							A2(
								$author$project$UI$TabBar$withSubTitle,
								$author$project$UI$BasicDataEditor$description(basicDataEditor),
								$author$project$UI$TabBar$tabBar(
									$author$project$UI$BasicDataEditor$title(basicDataEditor))))))));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$viewBasicDataTab = F2(
	function (translations, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(36)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$CheckpointData$Checkpoint$EditDialog$viewFooter, translations, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$CheckpointData$Checkpoint$EditDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$CheckpointData$Checkpoint$EditDialog$viewTabBar, basicDataEditor, 0),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Checkpoints$CheckpointDialog$editHeader(translations),
										$author$project$CheckpointData$Checkpoint$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Checkpoints$CheckpointDialog$editHeader(translations))));
};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteAvatar = $author$project$UI$Avatar$view(
	A2(
		$author$project$UI$Avatar$withStyle,
		$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
		A2(
			$author$project$UI$Avatar$withStyle,
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
			$author$project$UI$Avatar$icon(
				$author$project$UI$Icon$bicolor($author$project$UI$Icons$pinCircleBicolor)))));
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteTitle = function (checkpoint) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$paddingLeft(
						$rtfeldman$elm_css$Css$rem(1.5))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1.2)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(checkpoint.k8)
					]))
			]));
};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteDetails = function (checkpoint) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteAvatar,
				$author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteTitle(checkpoint)
			]));
};
var $author$project$Translations$Checkpoints$Delete$questionCheckpoint = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.delete.questionCheckpoint');
};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteQuestion = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Checkpoints$Delete$questionCheckpoint(translations))
			]));
};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteTab = F3(
	function (translations, basicDataEditor, checkpoint) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(36)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$CheckpointData$Checkpoint$EditDialog$viewFooter, translations, false, 2),
					A2(
						$author$project$UI$Dialog$appendContent,
						$author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteDetails(checkpoint),
						A2(
							$author$project$UI$Dialog$appendContent,
							$author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteQuestion(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A2($author$project$CheckpointData$Checkpoint$EditDialog$viewTabBar, basicDataEditor, 2),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Checkpoints$CheckpointDialog$editHeader(translations),
											$author$project$CheckpointData$Checkpoint$EditDialog$UserClickedCloseDialog)))))))));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$GotTypeEditorMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$CheckpointData$Checkpoint$EditDialog$viewTypeTab = F3(
	function (translations, typeEditor, basicDataEditor) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(36)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$CheckpointData$Checkpoint$EditDialog$viewFooter, translations, false, 1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$CheckpointData$Checkpoint$EditDialog$GotTypeEditorMsg,
							A2($author$project$CheckpointData$Checkpoint$TypeEditor$viewForm, translations, typeEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$CheckpointData$Checkpoint$TypeEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$CheckpointData$Checkpoint$EditDialog$viewTabBar, basicDataEditor, 1),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Checkpoints$CheckpointDialog$editHeader(translations),
										$author$project$CheckpointData$Checkpoint$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$viewTab = F3(
	function (environment, model, checkpoint) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var _v0 = model.cI;
		switch (_v0) {
			case 0:
				return A2($author$project$CheckpointData$Checkpoint$EditDialog$viewBasicDataTab, translations, model.aQ);
			case 1:
				return A3($author$project$CheckpointData$Checkpoint$EditDialog$viewTypeTab, translations, model.em, model.aQ);
			default:
				return A3($author$project$CheckpointData$Checkpoint$EditDialog$viewDeleteTab, translations, model.aQ, checkpoint);
		}
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$viewDialog = F3(
	function (environment, tempCheckpointData, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$CheckpointData$Checkpoint$EditDialog$viewDeletedDialog(environment),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$CheckpointData$Checkpoint$EditDialog$viewTab, environment, model),
				A2($author$project$CheckpointData$CheckpointData$getCheckpoint, model.bi.i5, tempCheckpointData)));
	});
var $author$project$CheckpointData$Checkpoint$EditDialog$view = F3(
	function (environment, tempCheckpointData, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$CheckpointData$Checkpoint$EditDialog$viewDialog, environment, tempCheckpointData, model);
			case 2:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$CheckpointData$Checkpoint$EditDialog$viewDialog, environment, tempCheckpointData, model);
			default:
				return A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$CheckpointData$Checkpoint$EditDialog$viewDeletedDialog, environment);
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewEditCheckpointDialog = F2(
	function (environment, tempCheckpointData) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$CheckpointData$Checkpoint$EditDialog$view, environment, tempCheckpointData),
			$rtfeldman$elm_css$Html$Styled$map($author$project$OrganisationUnit$CheckpointGroupEditor$GotEditCheckpointDialogMsg));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Checkpoints$CheckpointGroupDialog$editHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.checkpointGroupDialog.editHeader');
};
var $author$project$Translations$Checkpoints$Delete$deletedCheckpointGroup = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.delete.deletedCheckpointGroup');
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleted = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Checkpoints$Delete$deletedCheckpointGroup(translations))
			]));
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedCloseButton = {$: 5};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedCloseButton,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeletedFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$CheckpointData$CheckpointGroup$EditDialog$viewCloseButton(translations)
			]));
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeletedDialog = function (translations) {
	return $author$project$UI$Dialog$view(
		A2(
			$author$project$UI$Dialog$appendFooter,
			$author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeletedFooter(translations),
			A2(
				$author$project$UI$Dialog$appendContent,
				$author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleted(translations),
				A2(
					$author$project$UI$Dialog$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
					A2(
						$author$project$UI$Dialog$dialog,
						$author$project$Translations$Checkpoints$CheckpointGroupDialog$editHeader(translations),
						$author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedCloseDialog)))));
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$DeleteTab = 1;
var $author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedApplyButton = {$: 3};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewApplyButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedApplyButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$apply(translations)))));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedCancelButton = {$: 2};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedCancelButton,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedDeleteButton = {$: 4};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedDeleteButton,
			$author$project$UI$Button$darkRed(
				$author$project$Translations$Buttons$delete(translations))));
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewFooter = F3(
	function (translations, disableBtn, tab) {
		var rightButton = (tab === 1) ? $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteButton(translations) : A2($author$project$CheckpointData$CheckpointGroup$EditDialog$viewApplyButton, translations, disableBtn);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$CheckpointData$CheckpointGroup$EditDialog$viewCancelButton(translations),
					rightButton
				]));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewTabBarAvatar = A2(
	$author$project$UI$Avatar$withStyle,
	$rtfeldman$elm_css$Css$height(
		$rtfeldman$elm_css$Css$rem(4)),
	A2(
		$author$project$UI$Avatar$withStyle,
		$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$rem(4)),
		$author$project$UI$Avatar$icon(
			$author$project$UI$Icon$bicolor($author$project$UI$Icons$pinCircleBicolor))));
var $author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedTabIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewTabBarIcon = F3(
	function (icon, tab, currentTab) {
		return _Utils_eq(tab, currentTab) ? A2(
			$author$project$UI$Icon$withForegroundColor,
			$author$project$UI$Style$Theme$darkGrey,
			$author$project$UI$Icon$unicolor(icon)) : A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedTabIcon(tab),
			A2(
				$author$project$UI$Icon$withForegroundColor,
				$author$project$UI$Style$Theme$grey,
				$author$project$UI$Icon$unicolor(icon)));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewTabBar = F2(
	function (basicDataEditor, currentTab) {
		return $author$project$UI$TabBar$view(
			A2(
				$author$project$UI$TabBar$appendRightIcon,
				A3($author$project$CheckpointData$CheckpointGroup$EditDialog$viewTabBarIcon, $author$project$UI$Icons$delete, 1, currentTab),
				A2(
					$author$project$UI$TabBar$appendRightIcon,
					A3($author$project$CheckpointData$CheckpointGroup$EditDialog$viewTabBarIcon, $author$project$UI$Icons$pin, 0, currentTab),
					A2(
						$author$project$UI$TabBar$withAvatar,
						$author$project$CheckpointData$CheckpointGroup$EditDialog$viewTabBarAvatar,
						A2(
							$author$project$UI$TabBar$withSubTitle,
							$author$project$UI$BasicDataEditor$description(basicDataEditor),
							$author$project$UI$TabBar$tabBar(
								$author$project$UI$BasicDataEditor$title(basicDataEditor)))))));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewBasicDataTab = F2(
	function (translations, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(36)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$CheckpointData$CheckpointGroup$EditDialog$viewFooter, translations, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$CheckpointData$CheckpointGroup$EditDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$CheckpointData$CheckpointGroup$EditDialog$viewTabBar, basicDataEditor, 0),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Checkpoints$CheckpointGroupDialog$editHeader(translations),
										$author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Translations$Checkpoints$Delete$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.delete.header');
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Checkpoints$Delete$header(translations))));
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteAvatar = $author$project$UI$Avatar$view(
	A2(
		$author$project$UI$Avatar$withStyle,
		$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
		A2(
			$author$project$UI$Avatar$withStyle,
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
			$author$project$UI$Avatar$icon(
				$author$project$UI$Icon$bicolor($author$project$UI$Icons$pinCircleBicolor)))));
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteTitle = F4(
	function (translations, tempCheckpointData, checkpointGroup, basicDataEditor) {
		var checkpoints = A2(
			$author$project$Translations$Checkpoints$numberOfCheckpoints,
			translations,
			$elm$core$String$fromInt(
				$elm$core$List$length(
					A2($author$project$CheckpointData$CheckpointData$getCheckpointsOf, checkpointGroup.cC, tempCheckpointData))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$flexShrink(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$paddingLeft(
							$rtfeldman$elm_css$Css$rem(1.5))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$em(1.2)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$UI$BasicDataEditor$title(basicDataEditor))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(checkpoints)
						]))
				]));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteDetails = F4(
	function (translations, tempCheckpointData, basicDataEditor, checkpointGroup) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
						]))
				]),
			_List_fromArray(
				[
					$author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteAvatar,
					A4($author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteTitle, translations, tempCheckpointData, checkpointGroup, basicDataEditor)
				]));
	});
var $author$project$Translations$Checkpoints$Delete$deleteCheckpointGroupQuestion = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpoints.delete.deleteCheckpointGroupQuestion');
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteQuestion = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Checkpoints$Delete$deleteCheckpointGroupQuestion(translations))
			]));
};
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteTab = F4(
	function (translations, tempCheckpointData, checkpointGroup, basicDataEditor) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(36)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$CheckpointData$CheckpointGroup$EditDialog$viewFooter, translations, false, 1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A4($author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteDetails, translations, tempCheckpointData, basicDataEditor, checkpointGroup),
						A2(
							$author$project$UI$Dialog$appendContent,
							$author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteQuestion(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A2($author$project$CheckpointData$CheckpointGroup$EditDialog$viewTabBar, basicDataEditor, 1),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Checkpoints$CheckpointGroupDialog$createHeader(translations),
											$author$project$CheckpointData$CheckpointGroup$EditDialog$UserClickedCloseDialog)))))))));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewTab = F4(
	function (translations, model, tempCheckpointData, checkpointGroup) {
		var _v0 = model.cI;
		if (!_v0) {
			return A2($author$project$CheckpointData$CheckpointGroup$EditDialog$viewBasicDataTab, translations, model.aQ);
		} else {
			return A4($author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeleteTab, translations, tempCheckpointData, checkpointGroup, model.aQ);
		}
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDialog = F3(
	function (translations, tempCheckpointData, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeletedDialog(translations),
			A2(
				$elm$core$Maybe$map,
				A3($author$project$CheckpointData$CheckpointGroup$EditDialog$viewTab, translations, model, tempCheckpointData),
				A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, model.cC, tempCheckpointData)));
	});
var $author$project$CheckpointData$CheckpointGroup$EditDialog$view = F3(
	function (translations, tempCheckpointData, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDialog, translations, tempCheckpointData, model);
			case 2:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDialog, translations, tempCheckpointData, model);
			default:
				return A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$CheckpointData$CheckpointGroup$EditDialog$viewDeletedDialog, translations);
		}
	});
var $author$project$OrganisationUnit$CheckpointGroupEditor$viewEditGroupDialog = F2(
	function (translations, tempCheckpointData) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$CheckpointData$CheckpointGroup$EditDialog$view, translations, tempCheckpointData),
			$rtfeldman$elm_css$Html$Styled$map($author$project$OrganisationUnit$CheckpointGroupEditor$GotEditGroupDialogMsg));
	});
var $author$project$OrganisationUnit$CreateDialog$viewCheckpointGroupsStep = F4(
	function (translations, environment, repository, checkpointGroupEditor) {
		var editGroupDialog = function () {
			var tempCheckpointData = function () {
				var _v1 = A3(
					$author$project$CheckpointData$CommandHandler$handleCommands,
					$author$project$CheckpointData$Commands$fromList(
						$author$project$OrganisationUnit$CheckpointGroupEditor$commands(checkpointGroupEditor)),
					environment,
					$author$project$Environments$Repository$getCheckpointData(repository));
				if (!_v1.$) {
					var result = _v1.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$Repository$getCheckpointData,
						A4($author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations, result.cD, result.b8, result.cb, repository)).a;
				} else {
					return $author$project$Environments$Repository$getCheckpointData(repository);
				}
			}();
			return A3(
				$author$project$OrganisationUnit$CheckpointGroupEditor$viewEditGroupDialog,
				translations,
				tempCheckpointData,
				$author$project$OrganisationUnit$CheckpointGroupEditor$editGroupDialog(checkpointGroupEditor));
		}();
		var editCheckpointDialog = function () {
			var tempCheckpointData = function () {
				var _v0 = A3(
					$author$project$CheckpointData$CommandHandler$handleCommands,
					$author$project$CheckpointData$Commands$fromList(
						$author$project$OrganisationUnit$CheckpointGroupEditor$commands(checkpointGroupEditor)),
					environment,
					$author$project$Environments$Repository$getCheckpointData(repository));
				if (!_v0.$) {
					var result = _v0.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$Repository$getCheckpointData,
						A4($author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations, result.cD, result.b8, result.cb, repository)).a;
				} else {
					return $author$project$Environments$Repository$getCheckpointData(repository);
				}
			}();
			return A3(
				$author$project$OrganisationUnit$CheckpointGroupEditor$viewEditCheckpointDialog,
				environment,
				tempCheckpointData,
				$author$project$OrganisationUnit$CheckpointGroupEditor$editCheckpointDialog(checkpointGroupEditor));
		}();
		var createGroupDialog = A2(
			$author$project$OrganisationUnit$CheckpointGroupEditor$viewCreateGroupDialog,
			translations,
			$author$project$OrganisationUnit$CheckpointGroupEditor$createGroupDialog(checkpointGroupEditor));
		var createCheckpointDialog = A2(
			$author$project$OrganisationUnit$CheckpointGroupEditor$viewCreateCheckpointDialog,
			environment,
			$author$project$OrganisationUnit$CheckpointGroupEditor$createCheckpointDialog(checkpointGroupEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4(
						$author$project$OrganisationUnit$CreateDialog$viewFooter,
						translations,
						$author$project$Environments$Environment$platform(environment),
						false,
						1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2($rtfeldman$elm_css$Html$Styled$map, $author$project$OrganisationUnit$CreateDialog$GotCheckpointGroupEditorMsg, editCheckpointDialog),
						A2(
							$author$project$UI$Dialog$appendContent,
							A2($rtfeldman$elm_css$Html$Styled$map, $author$project$OrganisationUnit$CreateDialog$GotCheckpointGroupEditorMsg, createCheckpointDialog),
							A2(
								$author$project$UI$Dialog$appendContent,
								A2($rtfeldman$elm_css$Html$Styled$map, $author$project$OrganisationUnit$CreateDialog$GotCheckpointGroupEditorMsg, editGroupDialog),
								A2(
									$author$project$UI$Dialog$appendContent,
									A2($rtfeldman$elm_css$Html$Styled$map, $author$project$OrganisationUnit$CreateDialog$GotCheckpointGroupEditorMsg, createGroupDialog),
									A2(
										$author$project$UI$Dialog$appendContent,
										A2(
											$rtfeldman$elm_css$Html$Styled$map,
											$author$project$OrganisationUnit$CreateDialog$GotCheckpointGroupEditorMsg,
											A3($author$project$OrganisationUnit$CheckpointGroupEditor$viewContent, environment, repository, checkpointGroupEditor)),
										A2(
											$author$project$UI$Dialog$appendHeader,
											A2(
												$rtfeldman$elm_css$Html$Styled$map,
												$author$project$OrganisationUnit$CreateDialog$GotCheckpointGroupEditorMsg,
												$author$project$OrganisationUnit$CheckpointGroupEditor$viewBar(translations)),
											A2(
												$author$project$UI$Dialog$withIcon,
												$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
												A2(
													$author$project$UI$Dialog$dialog,
													$author$project$Translations$OrganisationUnits$createDialogHeader(translations),
													$author$project$OrganisationUnit$CreateDialog$UserClickedCloseDialog)))))))))));
	});
var $author$project$Translations$OrganisationUnits$FloorPlan$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'organisationUnits.floorPlan.header');
};
var $author$project$OrganisationUnit$FloorPlanEditor$viewBar = F2(
	function (translations, _v0) {
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$Bar$withLeftIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$floorPlan),
				$author$project$UI$Bar$bar(
					$author$project$Translations$OrganisationUnits$FloorPlan$header(translations))));
	});
var $author$project$UI$ImageEditor$UserClickedCameraIcon = {$: 0};
var $author$project$UI$Icons$cameraCircle = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M46.672 20.053h-6.971c-.794 0-1.444.65-1.444 1.444 0 .795.65 1.444 1.444 1.444h6.971c1.123 0 2.037.916 2.037 2.038V41.85c0 1.251-1.018 2.262-2.261 2.262H17.552c-1.251 0-2.261-1.019-2.261-2.262V24.979c0-1.122.914-2.038 2.037-2.038h6.971c.674 0 1.251-.465 1.404-1.115l.321-1.387c.352-1.501 1.668-2.551 3.217-2.551h5.527c.794 0 1.444-.65 1.444-1.444 0-.794-.65-1.444-1.444-1.444h-5.527c-2.896 0-5.367 1.965-6.024 4.78l-.065.273h-5.824c-2.72 0-4.926 2.206-4.926 4.926V41.85c0 2.838 2.31 5.15 5.15 5.15h28.896c2.84 0 5.15-2.312 5.15-5.15V24.979c0-2.72-2.206-4.926-4.926-4.926')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M39.075 31.261c-.794 0-1.443.65-1.443 1.444 0 3.104-2.527 5.63-5.632 5.63-3.104 0-5.63-2.526-5.63-5.63 0-3.105 2.526-5.625 5.63-5.625.794 0 1.443-.648 1.443-1.442 0-.795-.649-1.446-1.443-1.446-4.693 0-8.52 3.821-8.52 8.52 0 4.701 3.827 8.511 8.52 8.511 4.692 0 8.519-3.819 8.519-8.518 0-.794-.65-1.444-1.444-1.444')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M32 58.464c-14.594 0-26.463-11.871-26.463-26.465C5.537 17.407 17.406 5.536 32 5.536c14.594 0 26.463 11.871 26.463 26.463 0 14.594-11.869 26.465-26.463 26.465m21.915-48.378C48.055 4.239 40.278 1 32 1c-8.28 0-16.068 3.226-21.915 9.086-5.86 5.847-9.084 13.633-9.084 21.913 0 8.28 3.224 16.068 9.084 21.917C15.932 59.774 23.72 63 32 63c8.278 0 16.066-3.226 21.915-9.084 5.845-5.862 9.084-13.637 9.084-21.917 0-8.28-3.224-16.066-9.084-21.913')
						]),
					_List_Nil)
				]));
	});
var $rtfeldman$elm_css$Css$margin2 = $rtfeldman$elm_css$Css$prop2('margin');
var $author$project$UI$ImageEditor$viewCameraIcon = $author$project$UI$Icon$view(
	A2(
		$author$project$UI$Icon$withOnClick,
		$author$project$UI$ImageEditor$UserClickedCameraIcon,
		A2(
			$author$project$UI$Icon$withStyle,
			A2(
				$rtfeldman$elm_css$Css$margin2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$rem(1)),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(5)),
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$rem(5)),
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$cameraCircle))))));
var $author$project$UI$ImageEditor$UserClickedUploadIcon = {$: 1};
var $author$project$UI$Icons$uploadCircle = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M32 58.464c-14.594 0-26.463-11.871-26.463-26.465C5.537 17.407 17.406 5.536 32 5.536c14.594 0 26.463 11.871 26.463 26.463 0 14.594-11.869 26.465-26.463 26.465m21.915-48.378C48.055 4.239 40.278 1 32 1c-8.28 0-16.068 3.226-21.915 9.086-5.86 5.847-9.084 13.633-9.084 21.913 0 8.28 3.224 16.068 9.084 21.917C15.932 59.774 23.72 63 32 63c8.278 0 16.066-3.226 21.915-9.084 5.845-5.862 9.084-13.637 9.084-21.917 0-8.28-3.224-16.066-9.084-21.913')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M42.301 26.079c-.604.606-1.59.606-2.203 0l-6.534-6.551v16.957c0 .855-.7 1.554-1.555 1.554-.857 0-1.556-.699-1.556-1.554V19.528l-6.551 6.551c-.605.606-1.59.606-2.204 0-.605-.606-.605-1.591 0-2.204l9.204-9.204c.303-.303.7-.458 1.099-.458.396 0 .794.155 1.097.458l9.203 9.204c.606.604.606 1.591 0 2.204')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M48.697 33.399c-.855 0-1.556.7-1.556 1.556v8.736H16.859v-8.736c0-.856-.701-1.556-1.557-1.556-.855 0-1.555.7-1.555 1.556v10.293c0 .856.7 1.555 1.555 1.555h33.386c.864 0 1.565-.699 1.565-1.555V34.955c0-.856-.701-1.556-1.556-1.556')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$ImageEditor$viewUploadIcon = $author$project$UI$Icon$view(
	A2(
		$author$project$UI$Icon$withOnClick,
		$author$project$UI$ImageEditor$UserClickedUploadIcon,
		A2(
			$author$project$UI$Icon$withStyle,
			A2(
				$rtfeldman$elm_css$Css$margin2,
				$rtfeldman$elm_css$Css$zero,
				$rtfeldman$elm_css$Css$rem(1)),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(5)),
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$rem(5)),
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$uploadCircle))))));
var $author$project$UI$ImageEditor$viewEmpty = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	_List_fromArray(
		[$author$project$UI$ImageEditor$viewCameraIcon, $author$project$UI$ImageEditor$viewUploadIcon]));
var $author$project$UI$ImageEditor$UserClickedDeleteIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$ImageEditor$viewDeleteIcon = function (filename) {
	return $author$project$UI$Icon$view(
		A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$UI$ImageEditor$UserClickedDeleteIcon(filename),
			A2(
				$author$project$UI$Icon$withStyle,
				A2(
					$rtfeldman$elm_css$Css$margin2,
					$rtfeldman$elm_css$Css$zero,
					$rtfeldman$elm_css$Css$rem(1)),
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(5)),
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$rem(5)),
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$deleteCircle))))));
};
var $author$project$UI$ImageEditor$viewIcons = F2(
	function (filename, withDelete_) {
		var css = $rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
				]));
		return withDelete_ ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[css]),
			_List_fromArray(
				[
					$author$project$UI$ImageEditor$viewDeleteIcon(filename),
					$author$project$UI$ImageEditor$viewCameraIcon,
					$author$project$UI$ImageEditor$viewUploadIcon
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[css]),
			_List_fromArray(
				[$author$project$UI$ImageEditor$viewCameraIcon, $author$project$UI$ImageEditor$viewUploadIcon]));
	});
var $author$project$UI$ImageEditor$viewImage = F3(
	function (filename, withDelete_, styles) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							A3(
							$rtfeldman$elm_css$Html$Styled$node,
							'aw-image',
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
									'filename',
									$author$project$File$Filename$toIdString(filename)),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(styles)
								]),
							_List_Nil)
						])),
					A2($author$project$UI$ImageEditor$viewIcons, filename, withDelete_)
				]));
	});
var $author$project$Translations$Files$wrongFileTypeMsg = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'files.wrongFileTypeMsg');
};
var $author$project$UI$ImageEditor$viewWrongFileType = F2(
	function (translations, wrongFileTypeMsg) {
		return wrongFileTypeMsg ? A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkRed)),
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$Files$wrongFileTypeMsg(translations))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$UI$ImageEditor$view = F2(
	function (translations, _v0) {
		var config = _v0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$pct(100)),
							$rtfeldman$elm_css$Css$paddingBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = config.bH;
					if (!_v1.$) {
						var image_ = _v1.a;
						return A3($author$project$UI$ImageEditor$viewImage, image_, config.gb, config.eG);
					} else {
						return $author$project$UI$ImageEditor$viewEmpty;
					}
				}(),
					A2($author$project$UI$ImageEditor$viewWrongFileType, translations, config.cA)
				]));
	});
var $author$project$UI$ImageEditor$withDelete = function (_v0) {
	var config = _v0;
	return _Utils_update(
		config,
		{gb: true});
};
var $author$project$OrganisationUnit$FloorPlanEditor$viewContent = F2(
	function (translations, _v0) {
		var config = _v0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$UI$ImageEditor$view,
				translations,
				$author$project$UI$ImageEditor$withDelete(config.cY)));
	});
var $author$project$OrganisationUnit$CreateDialog$viewFloorPlanStep = F3(
	function (translations, platform, floorPlanEditor) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$OrganisationUnit$CreateDialog$viewFooter, translations, platform, false, 2),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$OrganisationUnit$CreateDialog$GotFloorPlanEditorMsg,
							A2($author$project$OrganisationUnit$FloorPlanEditor$viewContent, translations, floorPlanEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$OrganisationUnit$CreateDialog$GotFloorPlanEditorMsg,
								A2($author$project$OrganisationUnit$FloorPlanEditor$viewBar, translations, floorPlanEditor)),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$OrganisationUnits$createDialogHeader(translations),
									$author$project$OrganisationUnit$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$OrganisationUnit$CreateDialog$viewDialog = F4(
	function (translations, environment, repository, model) {
		var _v0 = model.b0;
		switch (_v0) {
			case 0:
				return A3(
					$author$project$OrganisationUnit$CreateDialog$viewBasicDataStep,
					translations,
					$author$project$Environments$Environment$platform(environment),
					model.aQ);
			case 1:
				return A4($author$project$OrganisationUnit$CreateDialog$viewCheckpointGroupsStep, translations, environment, repository, model.cB);
			default:
				return A3(
					$author$project$OrganisationUnit$CreateDialog$viewFloorPlanStep,
					translations,
					$author$project$Environments$Environment$platform(environment),
					model.cU);
		}
	});
var $author$project$OrganisationUnit$CreateDialog$view = F4(
	function (translations, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$OrganisationUnit$CreateDialog$viewDialog, translations, environment, repository, model);
			default:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$OrganisationUnit$CreateDialog$viewDialog, translations, environment, repository, model);
		}
	});
var $author$project$OrganisationUnit$Page$viewCreateDialog = F3(
	function (translations, environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A3($author$project$OrganisationUnit$CreateDialog$view, translations, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$OrganisationUnit$Page$GotCreateDialogMsg));
	});
var $author$project$OrganisationUnit$Page$CloseDuplicateOrganisationUnitModal = {$: 8};
var $author$project$Translations$OrganisationUnits$DuplicateOrganisationUnit$modalHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'organisationUnits.duplicateOrganisationUnit.modalHeader');
};
var $author$project$Translations$OrganisationUnits$DuplicateOrganisationUnit$modalText = F2(
	function (translations, titel) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'organisationUnits.duplicateOrganisationUnit.modalText',
			_List_fromArray(
				[
					_Utils_Tuple2('titel', titel)
				]));
	});
var $author$project$OrganisationUnit$Page$viewContent = F2(
	function (translations, organisationUnit) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$h4,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Translations$OrganisationUnits$DuplicateOrganisationUnit$modalText, translations, organisationUnit.k8))
				]));
	});
var $author$project$OrganisationUnit$Page$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$OrganisationUnit$Page$CloseDuplicateOrganisationUnitModal,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$OrganisationUnit$Page$UserConfirmedDuplicateOrganisationUnit = function (a) {
	return {$: 9, a: a};
};
var $author$project$OrganisationUnit$Page$viewNextButton = F2(
	function (translations, organisationUnit) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withOnClick,
				$author$project$OrganisationUnit$Page$UserConfirmedDuplicateOrganisationUnit(organisationUnit),
				$author$project$UI$Button$green(
					$author$project$Translations$Buttons$next(translations))));
	});
var $author$project$OrganisationUnit$Page$viewFooter = F2(
	function (translations, organisationUnit) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$OrganisationUnit$Page$viewCloseButton(translations),
					A2($author$project$OrganisationUnit$Page$viewNextButton, translations, organisationUnit)
				]));
	});
var $author$project$OrganisationUnit$Page$viewDuplicateOuModal = F2(
	function (translations, duplicateModal) {
		if (!duplicateModal.$) {
			var organisationUnit = duplicateModal.a;
			return $author$project$UI$Modal$view(
				A2(
					$author$project$UI$Modal$appendFooter,
					A2($author$project$OrganisationUnit$Page$viewFooter, translations, organisationUnit),
					A2(
						$author$project$UI$Modal$appendContent,
						A2($author$project$OrganisationUnit$Page$viewContent, translations, organisationUnit),
						A2(
							$author$project$UI$Modal$modal,
							$author$project$Translations$OrganisationUnits$DuplicateOrganisationUnit$modalHeader(translations),
							$author$project$OrganisationUnit$Page$CloseDuplicateOrganisationUnitModal))));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$OrganisationUnit$EditDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$OrganisationUnits$editDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'organisationUnits.editDialogHeader');
};
var $author$project$Translations$OrganisationUnits$Delete$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'organisationUnits.delete.header');
};
var $author$project$OrganisationUnit$EditDialog$viewDeletedBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$OrganisationUnits$Delete$header(translations))));
};
var $author$project$OrganisationUnit$EditDialog$UserClickedCloseButton = {$: 5};
var $author$project$OrganisationUnit$EditDialog$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$OrganisationUnit$EditDialog$UserClickedCloseButton,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$OrganisationUnit$EditDialog$viewDeletedFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$OrganisationUnit$EditDialog$viewCloseButton(translations)
			]));
};
var $author$project$OrganisationUnit$EditDialog$viewDeletedDialog = function (translations) {
	return $author$project$UI$Dialog$view(
		A2(
			$author$project$UI$Dialog$appendFooter,
			$author$project$OrganisationUnit$EditDialog$viewDeletedFooter(translations),
			A2(
				$author$project$UI$Dialog$appendHeader,
				$author$project$OrganisationUnit$EditDialog$viewDeletedBar(translations),
				A2(
					$author$project$UI$Dialog$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
					A2(
						$author$project$UI$Dialog$dialog,
						$author$project$Translations$OrganisationUnits$editDialogHeader(translations),
						$author$project$OrganisationUnit$EditDialog$UserClickedCloseDialog)))));
};
var $author$project$OrganisationUnit$EditDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$OrganisationUnit$EditDialog$DeleteTab = 3;
var $author$project$OrganisationUnit$EditDialog$UserClickedApplyButton = {$: 3};
var $author$project$OrganisationUnit$EditDialog$viewApplyButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$OrganisationUnit$EditDialog$UserClickedApplyButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$apply(translations)))));
	});
var $author$project$OrganisationUnit$EditDialog$UserClickedCancelButton = {$: 2};
var $author$project$OrganisationUnit$EditDialog$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$OrganisationUnit$EditDialog$UserClickedCancelButton,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$OrganisationUnit$EditDialog$UserClickedDeleteButton = {$: 4};
var $author$project$OrganisationUnit$EditDialog$viewDeleteButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$OrganisationUnit$EditDialog$UserClickedDeleteButton,
			$author$project$UI$Button$darkRed(
				$author$project$Translations$Buttons$delete(translations))));
};
var $author$project$OrganisationUnit$EditDialog$viewFooter = F3(
	function (translations, disableBtn, currentTab) {
		var rightButton = (currentTab === 3) ? $author$project$OrganisationUnit$EditDialog$viewDeleteButton(translations) : A2($author$project$OrganisationUnit$EditDialog$viewApplyButton, translations, disableBtn);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$OrganisationUnit$EditDialog$viewCancelButton(translations),
					rightButton
				]));
	});
var $author$project$OrganisationUnit$EditDialog$CheckpointsTab = 1;
var $author$project$OrganisationUnit$EditDialog$FloorPlanTab = 2;
var $author$project$OrganisationUnit$EditDialog$UserClickedTabIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$OrganisationUnit$EditDialog$viewTabBarIcon = F3(
	function (icon, tab, currentTab) {
		var color = _Utils_eq(tab, currentTab) ? $author$project$UI$Style$Theme$darkGrey : $author$project$UI$Style$Theme$grey;
		return A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$OrganisationUnit$EditDialog$UserClickedTabIcon(tab),
			A2(
				$author$project$UI$Icon$withForegroundColor,
				color,
				$author$project$UI$Icon$unicolor(icon)));
	});
var $author$project$OrganisationUnit$EditDialog$viewTabBar = F2(
	function (organisationUnit, currentTab) {
		return $author$project$UI$TabBar$view(
			A2(
				$author$project$UI$TabBar$appendRightIcon,
				A3($author$project$OrganisationUnit$EditDialog$viewTabBarIcon, $author$project$UI$Icons$delete, 3, currentTab),
				A2(
					$author$project$UI$TabBar$appendRightIcon,
					A3($author$project$OrganisationUnit$EditDialog$viewTabBarIcon, $author$project$UI$Icons$floorPlan, 2, currentTab),
					A2(
						$author$project$UI$TabBar$appendRightIcon,
						A3($author$project$OrganisationUnit$EditDialog$viewTabBarIcon, $author$project$UI$Icons$pin, 1, currentTab),
						A2(
							$author$project$UI$TabBar$appendRightIcon,
							A3($author$project$OrganisationUnit$EditDialog$viewTabBarIcon, $author$project$UI$Icons$home, 0, currentTab),
							A2(
								$author$project$UI$TabBar$withSubTitle,
								organisationUnit.aY,
								$author$project$UI$TabBar$tabBar(organisationUnit.k8)))))));
	});
var $author$project$OrganisationUnit$EditDialog$viewBasicDataTab = F3(
	function (translations, basicDataEditor, organisationUnit) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$OrganisationUnit$EditDialog$viewFooter, translations, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$OrganisationUnit$EditDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$OrganisationUnit$EditDialog$viewTabBar, organisationUnit, 0),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$OrganisationUnits$editDialogHeader(translations),
										$author$project$OrganisationUnit$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$OrganisationUnit$EditDialog$viewCheckpointsTab = F5(
	function (translations, environment, repository, checkpointGroupEditor, organisationUnit) {
		var editGroupDialog = function () {
			var tempCheckpointData = function () {
				var _v1 = A3(
					$author$project$CheckpointData$CommandHandler$handleCommands,
					$author$project$CheckpointData$Commands$fromList(
						$author$project$OrganisationUnit$CheckpointGroupEditor$commands(checkpointGroupEditor)),
					environment,
					$author$project$Environments$Repository$getCheckpointData(repository));
				if (!_v1.$) {
					var result = _v1.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$Repository$getCheckpointData,
						A4($author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations, result.cD, result.b8, result.cb, repository)).a;
				} else {
					return $author$project$Environments$Repository$getCheckpointData(repository);
				}
			}();
			return A3(
				$author$project$OrganisationUnit$CheckpointGroupEditor$viewEditGroupDialog,
				translations,
				tempCheckpointData,
				$author$project$OrganisationUnit$CheckpointGroupEditor$editGroupDialog(checkpointGroupEditor));
		}();
		var editCheckpointDialog = function () {
			var tempCheckpointData = function () {
				var _v0 = A3(
					$author$project$CheckpointData$CommandHandler$handleCommands,
					$author$project$CheckpointData$Commands$fromList(
						$author$project$OrganisationUnit$CheckpointGroupEditor$commands(checkpointGroupEditor)),
					environment,
					$author$project$Environments$Repository$getCheckpointData(repository));
				if (!_v0.$) {
					var result = _v0.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$Repository$getCheckpointData,
						A4($author$project$Environments$Repository$saveCheckpointDataCommandsAndEventsAndFileOperations, result.cD, result.b8, result.cb, repository)).a;
				} else {
					return $author$project$Environments$Repository$getCheckpointData(repository);
				}
			}();
			return A3(
				$author$project$OrganisationUnit$CheckpointGroupEditor$viewEditCheckpointDialog,
				environment,
				tempCheckpointData,
				$author$project$OrganisationUnit$CheckpointGroupEditor$editCheckpointDialog(checkpointGroupEditor));
		}();
		var createGroupDialog = A2(
			$author$project$OrganisationUnit$CheckpointGroupEditor$viewCreateGroupDialog,
			translations,
			$author$project$OrganisationUnit$CheckpointGroupEditor$createGroupDialog(checkpointGroupEditor));
		var createCheckpointDialog = A2(
			$author$project$OrganisationUnit$CheckpointGroupEditor$viewCreateCheckpointDialog,
			environment,
			$author$project$OrganisationUnit$CheckpointGroupEditor$createCheckpointDialog(checkpointGroupEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$OrganisationUnit$EditDialog$viewFooter, translations, false, 2),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2($rtfeldman$elm_css$Html$Styled$map, $author$project$OrganisationUnit$EditDialog$GotCheckpointGroupEditorMsg, editCheckpointDialog),
						A2(
							$author$project$UI$Dialog$appendContent,
							A2($rtfeldman$elm_css$Html$Styled$map, $author$project$OrganisationUnit$EditDialog$GotCheckpointGroupEditorMsg, createCheckpointDialog),
							A2(
								$author$project$UI$Dialog$appendContent,
								A2($rtfeldman$elm_css$Html$Styled$map, $author$project$OrganisationUnit$EditDialog$GotCheckpointGroupEditorMsg, editGroupDialog),
								A2(
									$author$project$UI$Dialog$appendContent,
									A2($rtfeldman$elm_css$Html$Styled$map, $author$project$OrganisationUnit$EditDialog$GotCheckpointGroupEditorMsg, createGroupDialog),
									A2(
										$author$project$UI$Dialog$appendContent,
										A2(
											$rtfeldman$elm_css$Html$Styled$map,
											$author$project$OrganisationUnit$EditDialog$GotCheckpointGroupEditorMsg,
											A3($author$project$OrganisationUnit$CheckpointGroupEditor$viewContent, environment, repository, checkpointGroupEditor)),
										A2(
											$author$project$UI$Dialog$appendHeader,
											A2(
												$rtfeldman$elm_css$Html$Styled$map,
												$author$project$OrganisationUnit$EditDialog$GotCheckpointGroupEditorMsg,
												$author$project$OrganisationUnit$CheckpointGroupEditor$viewBar(translations)),
											A2(
												$author$project$UI$Dialog$appendHeader,
												A2($author$project$OrganisationUnit$EditDialog$viewTabBar, organisationUnit, 1),
												A2(
													$author$project$UI$Dialog$withIcon,
													$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
													A2(
														$author$project$UI$Dialog$dialog,
														$author$project$Translations$OrganisationUnits$editDialogHeader(translations),
														$author$project$OrganisationUnit$EditDialog$UserClickedCloseDialog))))))))))));
	});
var $author$project$OrganisationUnit$EditDialog$viewDeleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$OrganisationUnits$Delete$header(translations))));
};
var $author$project$UI$Icons$factoryCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63 32c0 17.121-13.879 31-31 31C14.878 63 1 49.121 1 32 1 14.879 14.878 1 32 1c17.121 0 31 13.879 31 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M28.371 39.206h-9.513c-.733 0-1.328-.594-1.328-1.328v-5.387c0-.735.595-1.329 1.328-1.329h4.757c.733 0 1.328.594 1.328 1.329 0 .734-.595 1.328-1.328 1.328h-3.428v2.73h6.855v-4.058c0-.735.596-1.329 1.329-1.329.734 0 1.329.594 1.329 1.329v5.387c0 .734-.595 1.328-1.329 1.328')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M47.358 46.78h-6.861c-.733 0-1.329-.594-1.329-1.328V39.54c0-.803-.652-1.456-1.456-1.456-.802 0-1.455.653-1.455 1.456v5.912c0 .734-.595 1.328-1.329 1.328H13.226c-.734 0-1.329-.594-1.329-1.328V27.94c0-.326.12-.64.336-.884l7.317-8.217c.366-.411.948-.553 1.463-.359.514.195.856.688.858 1.238l.014 3.866 5.477-4.901c.389-.349.947-.435 1.425-.224.477.213.786.686.789 1.209l.017 3.961 5.528-4.947c.389-.349.947-.437 1.425-.225.478.214.787.687.789 1.21l.028 7.85c.003.734-.59 1.331-1.324 1.334-.769.017-1.331-.591-1.333-1.325l-.018-4.891-5.525 4.945c-.389.349-.947.436-1.425.225-.478-.213-.787-.685-.789-1.209l-.018-3.962-5.477 4.901c-.39.349-.947.437-1.425.224-.479-.212-.788-.685-.789-1.208l-.013-3.353-4.673 5.248v15.677H33.6V39.54c0-2.268 1.845-4.113 4.112-4.113 2.269 0 4.114 1.845 4.114 4.113v4.583h4.203l-.006-28.909h-4.197v12.308c0 .733-.596 1.329-1.329 1.329s-1.329-.596-1.329-1.329V13.885c0-.734.596-1.328 1.329-1.328h6.854c.734 0 1.328.594 1.328 1.327l.007 31.568c0 .351-.139.69-.388.939-.25.249-.588.389-.94.389')
						]),
					_List_Nil)
				]));
	});
var $author$project$OrganisationUnit$EditDialog$viewDeleteFloorPlan = $author$project$UI$Icon$view(
	A2(
		$author$project$UI$Icon$withStyle,
		$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
		A2(
			$author$project$UI$Icon$withStyle,
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(4)),
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$rem(4)),
					$author$project$UI$Icon$bicolor($author$project$UI$Icons$factoryCircleBicolor))))));
var $author$project$OrganisationUnit$EditDialog$viewDeleteOrganisationUnitTitleAndDescription = function (organisationUnit) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$paddingLeft(
						$rtfeldman$elm_css$Css$rem(1.5))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1.2)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(organisationUnit.k8)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(organisationUnit.aY)
					]))
			]));
};
var $author$project$OrganisationUnit$EditDialog$viewDeleteDetails = function (organisationUnit) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$author$project$OrganisationUnit$EditDialog$viewDeleteFloorPlan,
				$author$project$OrganisationUnit$EditDialog$viewDeleteOrganisationUnitTitleAndDescription(organisationUnit)
			]));
};
var $author$project$Translations$OrganisationUnits$Delete$question = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'organisationUnits.delete.question');
};
var $author$project$OrganisationUnit$EditDialog$viewDeleteQuestion = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$OrganisationUnits$Delete$question(translations))
			]));
};
var $author$project$OrganisationUnit$EditDialog$viewDeleteTab = F2(
	function (translations, organisationUnit) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$OrganisationUnit$EditDialog$viewFooter, translations, false, 3),
					A2(
						$author$project$UI$Dialog$appendContent,
						$author$project$OrganisationUnit$EditDialog$viewDeleteDetails(organisationUnit),
						A2(
							$author$project$UI$Dialog$appendContent,
							$author$project$OrganisationUnit$EditDialog$viewDeleteQuestion(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$OrganisationUnit$EditDialog$viewDeleteBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A2($author$project$OrganisationUnit$EditDialog$viewTabBar, organisationUnit, 3),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$OrganisationUnits$editDialogHeader(translations),
											$author$project$OrganisationUnit$EditDialog$UserClickedCloseDialog)))))))));
	});
var $author$project$OrganisationUnit$EditDialog$viewFloorPlanTab = F3(
	function (translations, floorPlanEditor, organisationUnit) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(60))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$OrganisationUnit$EditDialog$viewFooter, translations, false, 2),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$OrganisationUnit$EditDialog$GotFloorPlanEditorMsg,
							A2($author$project$OrganisationUnit$FloorPlanEditor$viewContent, translations, floorPlanEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$OrganisationUnit$EditDialog$GotFloorPlanEditorMsg,
								A2($author$project$OrganisationUnit$FloorPlanEditor$viewBar, translations, floorPlanEditor)),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$OrganisationUnit$EditDialog$viewTabBar, organisationUnit, 2),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$OrganisationUnits$editDialogHeader(translations),
										$author$project$OrganisationUnit$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$OrganisationUnit$EditDialog$viewTab = F5(
	function (translations, environment, repository, model, organisationUnit) {
		var _v0 = model.cI;
		switch (_v0) {
			case 0:
				return A3($author$project$OrganisationUnit$EditDialog$viewBasicDataTab, translations, model.aQ, organisationUnit);
			case 1:
				return A5($author$project$OrganisationUnit$EditDialog$viewCheckpointsTab, translations, environment, repository, model.cB, organisationUnit);
			case 2:
				return A3($author$project$OrganisationUnit$EditDialog$viewFloorPlanTab, translations, model.cU, organisationUnit);
			default:
				return A2($author$project$OrganisationUnit$EditDialog$viewDeleteTab, translations, organisationUnit);
		}
	});
var $author$project$OrganisationUnit$EditDialog$viewDialog = F4(
	function (translations, environment, repository, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$OrganisationUnit$EditDialog$viewDeletedDialog(translations),
			A2(
				$elm$core$Maybe$map,
				A4($author$project$OrganisationUnit$EditDialog$viewTab, translations, environment, repository, model),
				A2(
					$author$project$OrganisationUnit$OrganisationUnits$getOrganisationUnit,
					model.bq.km,
					$author$project$Environments$Repository$organisationUnits(repository))));
	});
var $author$project$OrganisationUnit$EditDialog$view = F4(
	function (translations, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$OrganisationUnit$EditDialog$viewDialog, translations, environment, repository, model);
			case 2:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$OrganisationUnit$EditDialog$viewDialog, translations, environment, repository, model);
			default:
				return A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$OrganisationUnit$EditDialog$viewDeletedDialog, translations);
		}
	});
var $author$project$OrganisationUnit$Page$viewEditDialog = F3(
	function (translations, environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A3($author$project$OrganisationUnit$EditDialog$view, translations, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$OrganisationUnit$Page$GotEditDialogMsg));
	});
var $author$project$OrganisationUnit$Page$DnDEvent = function (a) {
	return {$: 12, a: a};
};
var $author$project$OrganisationUnit$Page$DnDEventDragEnd = function (a) {
	return {$: 13, a: a};
};
var $author$project$UI$OrganisationStructure$DragAndDrop = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$OrganisationStructure$DragAndDropConfig = F5(
	function (dndEvent, dndEventDragEnd, dragAndDrop, organisationUnits, environment) {
		return {hL: dndEvent, hM: dndEventDragEnd, hN: dragAndDrop, ac: environment, kn: organisationUnits};
	});
var $author$project$OrganisationUnit$Page$ReceivedCollapseOrganisationUnitMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$OrganisationUnit$Page$ReceivedExpandOrganisationUnitMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$OrganisationUnit$Page$UserClickedCreateChildIcon = function (a) {
	return {$: 6, a: a};
};
var $author$project$OrganisationUnit$Page$addCreateChildIcon = F2(
	function (environment, organisationUnit) {
		return A3(
			$author$project$Auth$Authorization$authorize,
			$author$project$Environments$Environment$userRights(environment),
			1,
			organisationUnit.km) ? $elm$core$Maybe$Just(
			{
				jI: $author$project$UI$Icon$unicolor($author$project$UI$Icons$add),
				ka: $elm$core$Maybe$Just($author$project$OrganisationUnit$Page$UserClickedCreateChildIcon)
			}) : $elm$core$Maybe$Nothing;
	});
var $author$project$OrganisationUnit$Page$addDuplicateIcon = F3(
	function (environment, repository, organisationUnit) {
		return $elm$core$Maybe$Nothing;
	});
var $author$project$OrganisationUnit$Page$UserClickedEditIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Icons$edit = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M31.068 15.493L15.497 31.064c-.396.396-.396 1.04 0 1.441.197.198.457.3.717.3.26 0 .52-.102.718-.3l15.572-15.571c.395-.396.395-1.041 0-1.441-.397-.397-1.041-.397-1.436 0')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M36.105 12.076l-.175-.182c-1.057-1.058-2.459-1.639-3.952-1.639-1.492 0-2.9.581-3.952 1.639L11.363 28.551c-.164.164-.266.378-.294.61l-.809 7.452c-.033.306.074.611.295.831.193.193.453.301.717.301.035 0 .074 0 .108-.006l7.452-.808c.233-.023.448-.13.612-.294l12.981-12.982c.395-.396.395-1.041 0-1.442-.396-.397-1.041-.397-1.441 0L18.262 34.939l-5.842.64.633-5.841 16.41-16.401c.672-.675 1.565-1.043 2.515-1.043.95 0 1.843.368 2.517 1.043l.17.169c.672.672 1.039 1.566 1.039 2.515 0 .949-.367 1.843-1.039 2.516l-.549.548c-.396.397-.396 1.04 0 1.443.395.394 1.039.394 1.442 0l.547-.548c1.058-1.058 1.641-2.46 1.641-3.953 0-1.493-.583-2.9-1.641-3.951')
						]),
					_List_Nil)
				]));
	});
var $author$project$OrganisationUnit$Page$addEditIcon = F2(
	function (environment, organisationUnit) {
		return A3(
			$author$project$Auth$Authorization$authorize,
			$author$project$Environments$Environment$userRights(environment),
			1,
			organisationUnit.km) ? $elm$core$Maybe$Just(
			{
				jI: $author$project$UI$Icon$unicolor($author$project$UI$Icons$edit),
				ka: $elm$core$Maybe$Just($author$project$OrganisationUnit$Page$UserClickedEditIcon)
			}) : $elm$core$Maybe$Nothing;
	});
var $author$project$OrganisationUnit$Page$viewHierarchy = F3(
	function (environment, repository, _v0) {
		var dragAndDrop = _v0.hN;
		var expandedOrganisationUnitList = _v0.dI;
		var dragAndDropConfig = A5(
			$author$project$UI$OrganisationStructure$DragAndDropConfig,
			$author$project$OrganisationUnit$Page$DnDEvent,
			$author$project$OrganisationUnit$Page$DnDEventDragEnd,
			dragAndDrop,
			$author$project$Environments$Repository$organisationUnits(repository),
			environment);
		return A2(
			$author$project$UI$OrganisationStructure$view,
			environment,
			{
				iN: $author$project$UI$OrganisationStructure$DragAndDrop(dragAndDropConfig),
				iY: $elm$core$Maybe$Nothing,
				i9: $author$project$OrganisationUnit$Page$ReceivedCollapseOrganisationUnitMsg,
				jg: $author$project$UI$OrganisationStructure$NoContent,
				jx: $author$project$OrganisationUnit$Page$ReceivedExpandOrganisationUnitMsg,
				jy: expandedOrganisationUnitList,
				jV: $elm$core$Maybe$Nothing,
				kn: $author$project$Environments$Repository$organisationUnits(repository),
				kC: _List_Nil,
				kD: _List_fromArray(
					[
						A2($author$project$OrganisationUnit$Page$addDuplicateIcon, environment, repository),
						$author$project$OrganisationUnit$Page$addEditIcon(environment),
						$author$project$OrganisationUnit$Page$addCreateChildIcon(environment)
					]),
				kE: $elm$core$Maybe$Nothing,
				kS: true
			});
	});
var $author$project$OrganisationUnit$Page$view = F3(
	function (environment, repository, page_) {
		var page = page_;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				A2($author$project$OrganisationUnit$Page$viewDuplicateOuModal, translations, page.gB),
				A2(
					$author$project$UI$Page$appendContent,
					A4($author$project$OrganisationUnit$Page$viewEditDialog, translations, environment, repository, page.cO),
					A2(
						$author$project$UI$Page$appendContent,
						A4($author$project$OrganisationUnit$Page$viewCreateDialog, translations, environment, repository, page.fi),
						A2(
							$author$project$UI$Page$appendContent,
							A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$OrganisationUnit$Page$viewHierarchy, environment, repository, page_),
							A2(
								$author$project$UI$Page$appendContent,
								A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$OrganisationUnit$Page$viewBar, translations, environment),
								A2(
									$author$project$UI$Page$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$factory),
									$author$project$UI$Page$page(
										$author$project$Translations$OrganisationUnits$header(translations)))))))));
	});
var $author$project$Page$Page$organisationUnits = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 6) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotOrganisationUnitPageMsg,
		kZ: $elm$core$Maybe$Just($author$project$OrganisationUnit$Page$subscriptions),
		le: $author$project$OrganisationUnit$Page$update,
		lm: $author$project$OrganisationUnit$Page$view
	});
var $author$project$Page$Page$GotOUOverviewPageMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$OrganisationUnitOverview$changeFilterRelevant = F4(
	function (filterRelevant, environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{eB: filterRelevant}),
			ae: repository
		};
	});
var $author$project$Page$OrganisationUnitOverview$enteredSearchString = F4(
	function (newSearchString, environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{aN: newSearchString}),
			ae: repository
		};
	});
var $author$project$Page$OrganisationUnitOverview$receivedNowTimestamp = F4(
	function (today, environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{fK: today}),
			ae: repository
		};
	});
var $author$project$Page$OrganisationUnitOverview$userClickedCreateIcon = F4(
	function (organisationUnit, environment, repository, page) {
		var newEnvironment = A2(
			$author$project$Environments$Environment$navigateTo,
			$author$project$Environments$Route$MainMenu,
			A2(
				$author$project$Environments$Environment$setCurrentOrganisationUnit,
				environment,
				$elm$core$Maybe$Just(organisationUnit.km)));
		return {ab: $elm$core$Platform$Cmd$none, ac: newEnvironment, ak: page, ae: repository};
	});
var $author$project$Page$OrganisationUnitOverview$update = function (msg) {
	switch (msg.$) {
		case 0:
			var today = msg.a;
			return $author$project$Page$OrganisationUnitOverview$receivedNowTimestamp(today);
		case 1:
			var organisationUnit = msg.a;
			return $author$project$Page$OrganisationUnitOverview$userClickedCreateIcon(organisationUnit);
		case 2:
			var bool = msg.a;
			return $author$project$Page$OrganisationUnitOverview$changeFilterRelevant(bool);
		default:
			var string = msg.a;
			return $author$project$Page$OrganisationUnitOverview$enteredSearchString(string);
	}
};
var $author$project$Translations$Sidebar$ouOverview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.ouOverview');
};
var $author$project$Page$OrganisationUnitOverview$UserClickedOrganisationUnitTile = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$OUTiles$Config = $elm$core$Basics$identity;
var $author$project$UI$OUTiles$Grid = {$: 0};
var $author$project$UI$OUTiles$ouTilesGrid = function (organisationUnitIds) {
	return {g3: $elm$core$Maybe$Nothing, fS: organisationUnitIds, fW: $elm$core$Maybe$Nothing, e4: $author$project$UI$OUTiles$Grid, gc: false, gd: false};
};
var $author$project$Audit$Audit$filterByOrganisationUnit = F2(
	function (organisationUnitId, audits) {
		return A2(
			$elm$core$List$filter,
			$author$project$Audit$Audit$belongsToOrganisationUnit(organisationUnitId),
			audits);
	});
var $author$project$Measure$Measure$filterByOrganisationUnit = F2(
	function (organisationUnitId, measures) {
		return A2(
			$elm$core$List$filter,
			function (measure) {
				return _Utils_eq(measure.km, organisationUnitId);
			},
			measures);
	});
var $author$project$Page$OrganisationUnitOverview$pileFunction = F4(
	function (repository, timeZone, today, organisationUnit) {
		var measureDeadlines = A2(
			$elm$core$List$map,
			function ($) {
				return $.hI;
			},
			A2(
				$author$project$Measure$Measure$filterByOrganisationUnit,
				organisationUnit.km,
				A2(
					$elm$core$List$filter,
					function (measure) {
						return _Utils_eq(measure.jb, $author$project$Measure$CompletionStatus$Open);
					},
					$author$project$Measure$Dict$values(
						$author$project$Environments$Repository$measures(repository)))));
		var auditDeadlines = A2(
			$elm$core$List$map,
			function ($) {
				return $.hI;
			},
			A2(
				$author$project$Audit$Audit$filterByOrganisationUnit,
				organisationUnit.km,
				A2(
					$elm$core$List$filter,
					function (audit) {
						return _Utils_eq(audit.jb, $author$project$Audit$CompletionStatus$Open);
					},
					$author$project$Audit$Dict$values(
						$author$project$Environments$Repository$audits(repository)))));
		var color = A2(
			$elm$core$Maybe$withDefault,
			$author$project$UI$Style$Theme$grey,
			A2(
				$elm$core$Maybe$map,
				function (deadlineTimestamp) {
					return (_Utils_cmp(
						$elm$time$Time$posixToMillis(deadlineTimestamp),
						$elm$time$Time$posixToMillis(today)) < 0) ? $author$project$UI$Style$Theme$lightRed : (_Utils_eq(
						A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, deadlineTimestamp),
						A2($author$project$Date_Time$NaiveDate$fromPosix, $elm$time$Time$utc, today)) ? $author$project$UI$Style$Theme$yellow : $author$project$UI$Style$Theme$green);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$sortBy,
						function (deadlineTimestamp) {
							return $elm$time$Time$posixToMillis(deadlineTimestamp);
						},
						A2(
							$elm$core$List$append,
							auditDeadlines,
							A3($elm$core$List$foldl, $author$project$Utils$Utils$reduceMaybeList, _List_Nil, measureDeadlines))))));
		var sum = $elm$core$List$length(auditDeadlines) + $elm$core$List$length(measureDeadlines);
		return _Utils_Tuple2(sum, color);
	});
var $author$project$OrganisationUnit$Hierarchy$getDeletedOrganisationUnit = function (organisationUnitId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$OrganisationUnit$Hierarchy$unwrap,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dB;
			},
			$author$project$OrganisationUnit$Dict$get(organisationUnitId)));
};
var $author$project$OrganisationUnit$OrganisationUnits$getDeletedOrganisationUnit = function (organisationUnitId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$OrganisationUnit$OrganisationUnits$hierarchy,
		$author$project$OrganisationUnit$Hierarchy$getDeletedOrganisationUnit(organisationUnitId));
};
var $author$project$Environments$Repository$getDeletedOrganisationUnit = function (organisationUnitId) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Environments$Repository$organisationUnits,
		$author$project$OrganisationUnit$OrganisationUnits$getDeletedOrganisationUnit(organisationUnitId));
};
var $author$project$UI$OUTiles$appendMsg = F2(
	function (maybeMsg, organisationUnit) {
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					msg(organisationUnit))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$UI$OUTiles$determineColors = F2(
	function (organisationUnit, _v0) {
		var config_ = _v0;
		if (config_.gd) {
			var iconColor = _Utils_eq(
				$author$project$UI$Style$Color$calculateContrastColor(organisationUnit.K),
				$author$project$UI$Style$Theme$white) ? $author$project$UI$Style$Theme$lightGrey : $author$project$UI$Style$Theme$darkGrey;
			return {eu: $author$project$UI$Style$Theme$lightGrey, eF: iconColor, e_: organisationUnit.K};
		} else {
			var _v1 = config_.e4;
			if (!_v1.$) {
				return {eu: $author$project$UI$Style$Theme$white, eF: $author$project$UI$Style$Theme$grey, e_: $author$project$UI$Style$Theme$lightGrey};
			} else {
				var organisationUnitId = _v1.a;
				return _Utils_eq(organisationUnitId, organisationUnit.km) ? {eu: $author$project$UI$Style$Theme$white, eF: $author$project$UI$Style$Theme$darkGrey, e_: $author$project$UI$Style$Theme$grey} : {eu: $author$project$UI$Style$Theme$white, eF: $author$project$UI$Style$Theme$grey, e_: $author$project$UI$Style$Theme$lightGrey};
			}
		}
	});
var $author$project$UI$OUTiles$viewTileIcon = F3(
	function (cursor_, color_, icon) {
		return $author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withStyle,
				cursor_,
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(1)),
					A2(
						$author$project$UI$Icon$withStyle,
						A3(
							$rtfeldman$elm_css$Css$flex3,
							$rtfeldman$elm_css$Css$int(1),
							$rtfeldman$elm_css$Css$zero,
							$rtfeldman$elm_css$Css$zero),
						A2(
							$author$project$UI$Icon$withForegroundColor,
							color_,
							$author$project$UI$Icon$unicolor(icon))))));
	});
var $author$project$UI$OUTiles$viewTileLabel = function (description) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$margin3,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$rem(0.5),
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$paddingTop(
						$rtfeldman$elm_css$Css$rem(0.5)),
						A3(
						$rtfeldman$elm_css$Css$borderTop3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
						$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
						$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
						$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(description)
			]));
};
var $author$project$UI$OUTiles$viewTileMarker = function (color) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(0.5)),
						A4(
						$rtfeldman$elm_css$Css$borderRadius4,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$rem(0.5),
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor(color))
					]))
			]),
		_List_Nil);
};
var $author$project$UI$OUTiles$viewPile = F2(
	function (text_, color_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
							$rtfeldman$elm_css$Css$top(
							$rtfeldman$elm_css$Css$rem(-0.5)),
							$rtfeldman$elm_css$Css$right(
							$rtfeldman$elm_css$Css$rem(-0.5)),
							$rtfeldman$elm_css$Css$minWidth(
							$rtfeldman$elm_css$Css$rem(1.75)),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$rem(0.25)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$rem(1.25)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$lineHeight(
							$rtfeldman$elm_css$Css$num(1)),
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor(color_))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(text_)
				]));
	});
var $author$project$UI$OUTiles$viewTilePile = F2(
	function (organisationUnit, _v0) {
		var config_ = _v0;
		var _v1 = config_.fW;
		if (!_v1.$) {
			var _function = _v1.a;
			var _v2 = _function(organisationUnit);
			var number = _v2.a;
			var color = _v2.b;
			return A2(
				$author$project$UI$OUTiles$viewPile,
				$elm$core$String$fromInt(number),
				color);
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$UI$OUTiles$viewTile = F2(
	function (organisationUnit, config) {
		var config_ = config;
		var viewStyle = function () {
			var _v1 = config_.e4;
			if (!_v1.$) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(10)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$rem(10)),
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$rem(1))
					]);
			}
		}();
		var cursor_ = function () {
			var _v0 = config_.g3;
			if (!_v0.$) {
				return $rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer);
			} else {
				return $rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default);
			}
		}();
		var colors = A2($author$project$UI$OUTiles$determineColors, organisationUnit, config);
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-tile',
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							viewStyle,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									cursor_,
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
									$rtfeldman$elm_css$Css$borderRadius(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$backgroundImage(
									A3(
										$rtfeldman$elm_css$Css$linearGradient,
										$rtfeldman$elm_css$Css$stop(
											$author$project$UI$Style$Color$toCssColor(colors.e_)),
										$rtfeldman$elm_css$Css$stop(
											$author$project$UI$Style$Color$toCssColor(colors.eu)),
										_List_Nil)),
									$rtfeldman$elm_css$Css$firstChild(
									_List_fromArray(
										[
											A2($rtfeldman$elm_css$Css$property, 'grid-row', '1 / 1'),
											A2($rtfeldman$elm_css$Css$property, 'grid-column', '1 / 1')
										]))
								])))
					]),
				A2($author$project$UI$OUTiles$appendMsg, config_.g3, organisationUnit)),
			_List_fromArray(
				[
					A3($author$project$UI$OUTiles$viewTileIcon, cursor_, colors.eF, $author$project$UI$Icons$factory),
					$author$project$UI$OUTiles$viewTileLabel(organisationUnit.k8),
					$author$project$UI$OUTiles$viewTileMarker($author$project$UI$Style$Theme$lightGrey),
					A2($author$project$UI$OUTiles$viewTilePile, organisationUnit, config)
				]));
	});
var $author$project$UI$OUTiles$viewOrganisationUnit = F2(
	function (config, maybeOrganisationUnit) {
		return A2($author$project$UI$OUTiles$viewTile, maybeOrganisationUnit, config);
	});
var $author$project$UI$OUTiles$view = F2(
	function (repository, config) {
		var config_ = config;
		var viewStyle = function () {
			var _v0 = config_.e4;
			if (!_v0.$) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$auto),
						A2($rtfeldman$elm_css$Css$property, 'grid-auto-flow', 'column')
					]);
			}
		}();
		var deletedOrganisationUnits = config_.gc ? A2(
			$elm$core$List$map,
			A2($author$project$Utils$Utils$flip, $author$project$Environments$Repository$getDeletedOrganisationUnit, repository),
			config_.fS) : _List_Nil;
		var organisationUnits = A2(
			$elm$core$List$sortBy,
			function (ou) {
				return $elm$core$String$toLower(ou.k8);
			},
			A3(
				$elm$core$List$foldl,
				$author$project$Utils$Utils$reduceMaybeList,
				_List_Nil,
				A2(
					$elm$core$List$append,
					deletedOrganisationUnits,
					A2(
						$elm$core$List$map,
						A2($author$project$Utils$Utils$flip, $author$project$Environments$Repository$getOrganisationUnit, repository),
						config_.fS))));
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'ou-tiles',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						viewStyle,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
								A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(auto-fill, minmax(10rem, 1fr))'),
								A2($rtfeldman$elm_css$Css$property, 'grid-gap', '1rem'),
								A2($rtfeldman$elm_css$Css$property, 'grid-auto-rows', '1fr'),
								$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(0.5)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(300)),
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								$rtfeldman$elm_css$Css$before(
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$property, 'content', '\'\''),
										$rtfeldman$elm_css$Css$paddingBottom(
										$rtfeldman$elm_css$Css$pct(100)),
										$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
										A2($rtfeldman$elm_css$Css$property, 'grid-row', '1 / 1'),
										A2($rtfeldman$elm_css$Css$property, 'grid-column', '1 / 1')
									]))
							])))
				]),
			A2(
				$elm$core$List$map,
				$author$project$UI$OUTiles$viewOrganisationUnit(config),
				organisationUnits));
	});
var $author$project$UI$OUTiles$withOnClickMsg = F2(
	function (maybeMsg, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{g3: maybeMsg});
	});
var $author$project$UI$OUTiles$withOrganisationUnitColor = F2(
	function (bool, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{gd: bool});
	});
var $author$project$UI$OUTiles$withPileFunction = F2(
	function (maybeMsg, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fW: maybeMsg});
	});
var $author$project$Page$OrganisationUnitOverview$viewGrid = F4(
	function (translations, timeZone, repository, model) {
		var organisationUnits = $author$project$Environments$Repository$organisationUnits(repository);
		var organisationUnitIds = $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (organisationUnit) {
					return A2(
						$elm$core$List$cons,
						organisationUnit.km,
						$author$project$OrganisationUnit$Ids$toList(
							A2($author$project$OrganisationUnit$OrganisationUnits$getDescendantIdsOf, organisationUnit, organisationUnits)));
				},
				A2($author$project$OrganisationUnit$OrganisationUnits$getRootOrganisationUnits, true, organisationUnits)));
		var content = $elm$core$List$isEmpty(organisationUnitIds) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$OrganisationUnits$emptyText(translations))
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$UI$OUTiles$view,
				repository,
				A2(
					$author$project$UI$OUTiles$withOrganisationUnitColor,
					true,
					A2(
						$author$project$UI$OUTiles$withPileFunction,
						$elm$core$Maybe$Just(
							A3($author$project$Page$OrganisationUnitOverview$pileFunction, repository, timeZone, model.fK)),
						A2(
							$author$project$UI$OUTiles$withOnClickMsg,
							$elm$core$Maybe$Just($author$project$Page$OrganisationUnitOverview$UserClickedOrganisationUnitTile),
							$author$project$UI$OUTiles$ouTilesGrid(organisationUnitIds)))))
			]);
		return A3($rtfeldman$elm_css$Html$Styled$node, 'ou-overview', _List_Nil, content);
	});
var $author$project$Page$OrganisationUnitOverview$ChangeFilterRelevant = function (a) {
	return {$: 2, a: a};
};
var $author$project$Translations$OrganisationUnits$filterRelevant = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'organisationUnits.filterRelevant');
};
var $author$project$Page$OrganisationUnitOverview$viewFilterRelevant = F2(
	function (translations, filterRelevant) {
		var _v0 = filterRelevant ? _Utils_Tuple2(
			$author$project$UI$Icon$view(
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3)),
					A2(
						$author$project$UI$Icon$withForegroundColor,
						$author$project$UI$Style$Theme$green,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$eyeCircle)))),
			$author$project$Page$OrganisationUnitOverview$ChangeFilterRelevant(false)) : _Utils_Tuple2(
			$author$project$UI$Icon$view(
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3)),
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$eyeCircle))),
			$author$project$Page$OrganisationUnitOverview$ChangeFilterRelevant(true));
		var icon = _v0.a;
		var msg = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(0.2))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					icon,
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
									$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$rem(0.6)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$OrganisationUnits$filterRelevant(translations))
						]))
				]));
	});
var $author$project$Page$OrganisationUnitOverview$EnteredSearchString = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$OrganisationUnitOverview$viewSearch = F2(
	function (translations, searchValue) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withStyle,
				$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(40)),
				A2(
					$author$project$UI$TextInput$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3)),
					A2(
						$author$project$UI$TextInput$withOnInput,
						$author$project$Page$OrganisationUnitOverview$EnteredSearchString,
						A2(
							$author$project$UI$TextInput$withPlaceholder,
							$author$project$Translations$FuzzySearch$search(translations),
							A2($author$project$UI$TextInput$withValue, searchValue, $author$project$UI$TextInput$singleLine))))));
	});
var $author$project$Page$OrganisationUnitOverview$viewHeader = F2(
	function (translations, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Page$OrganisationUnitOverview$viewSearch, translations, model.aN),
					A2($author$project$Page$OrganisationUnitOverview$viewFilterRelevant, translations, model.eB)
				]));
	});
var $author$project$Page$OrganisationUnitOverview$view = F3(
	function (environment, repository, _v0) {
		var model = _v0;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendHeader,
				A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Page$OrganisationUnitOverview$viewHeader, translations, model),
				A2(
					$author$project$UI$Page$appendContent,
					A5(
						$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
						$author$project$Page$OrganisationUnitOverview$viewGrid,
						translations,
						$author$project$Environments$Environment$timeZone(environment),
						repository,
						model),
					A2(
						$author$project$UI$Page$withIcon,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$factory),
						$author$project$UI$Page$page(
							$author$project$Translations$Sidebar$ouOverview(translations))))));
	});
var $author$project$Page$Page$ouOverview = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 8) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotOUOverviewPageMsg,
		kZ: $elm$core$Maybe$Nothing,
		le: $author$project$Page$OrganisationUnitOverview$update,
		lm: $author$project$Page$OrganisationUnitOverview$view
	});
var $author$project$Page$Page$GotPage404Msg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$Page404$update = F4(
	function (msg, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$MainMenu, environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$Page$Page404$UserClickedReturnToMainMenu = 0;
var $author$project$Translations$Page404$button = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'page404.button');
};
var $author$project$Translations$Page404$text = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'page404.text');
};
var $author$project$Page$Page404$viewContent = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(50)),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$Page404$text(translations))
					])),
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withStyle,
					$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(50)),
					A2(
						$author$project$UI$Button$withOnClick,
						0,
						$author$project$UI$Button$darkGrey(
							$author$project$Translations$Page404$button(translations)))))
			]));
};
var $author$project$Page$Page404$view = F3(
	function (environment, _v0, _v1) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				$author$project$Page$Page404$viewContent(translations),
				A2(
					$author$project$UI$Page$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$info),
					$author$project$UI$Page$page('404 - Not Found'))));
	});
var $author$project$Page$Page$page404 = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 17) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotPage404Msg,
		kZ: $elm$core$Maybe$Nothing,
		le: $author$project$Page$Page404$update,
		lm: $author$project$Page$Page404$view
	});
var $author$project$Page$Page$GotPerformAuditPageMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audit$PerformAuditPage$GotMeasureCreateDialogMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Audit$PerformAuditPage$GotMeasureEditDialogMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Audit$PerformAuditPage$GotRecordModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Audit$RecordModal$GotCanvasMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Audit$RecordModal$GotImageEditorMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$UI$Canvas$Canvas$AnimationFrame = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Canvas$Canvas$ReceivedUnknownMsg = {$: 5};
var $author$project$UI$Canvas$Canvas$canvasInbox = _Platform_incomingPort('canvasInbox', $elm$json$Json$Decode$value);
var $author$project$UI$Canvas$Canvas$ReceivedBlobSavedMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$UI$Canvas$Canvas$decodeMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		if (type_ === 'BLOB_SAVED') {
			return A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'filename',
				$author$project$File$Filename$decode,
				$elm$json$Json$Decode$succeed($author$project$UI$Canvas$Canvas$ReceivedBlobSavedMsg));
		} else {
			return $elm$json$Json$Decode$succeed($author$project$UI$Canvas$Canvas$ReceivedUnknownMsg);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$UI$Canvas$Canvas$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$browser$Browser$Events$onAnimationFrameDelta($author$project$UI$Canvas$Canvas$AnimationFrame),
				$author$project$UI$Canvas$Canvas$canvasInbox(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$UI$Canvas$Canvas$decodeMsg),
					$elm$core$Result$withDefault($author$project$UI$Canvas$Canvas$ReceivedUnknownMsg)))
			]));
};
var $author$project$Audit$RecordModal$subscriptions = function (dialog) {
	if (dialog.$ === 1) {
		var config = dialog.a;
		switch (config.$) {
			case 5:
				return A2($elm$core$Platform$Sub$map, $author$project$Audit$RecordModal$GotImageEditorMsg, $author$project$UI$ImageEditor$subscriptions);
			case 6:
				var signatureModel = config.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Audit$RecordModal$GotCanvasMsg,
					$author$project$UI$Canvas$Canvas$subscriptions(signatureModel.dr));
			default:
				return $elm$core$Platform$Sub$none;
		}
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Audit$PerformAuditPage$subscriptions = function (_v0) {
	var page = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Audit$PerformAuditPage$GotMeasureCreateDialogMsg,
				$author$project$Measure$CreateDialog$subscriptions(page.dV)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Audit$PerformAuditPage$GotMeasureEditDialogMsg,
				$author$project$Measure$EditDialog$subscriptions(page.dW)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Audit$PerformAuditPage$GotRecordModalMsg,
				$author$project$Audit$RecordModal$subscriptions(page.eW))
			]));
};
var $author$project$Audit$PerformAuditPage$closeMeasureDialog = F3(
	function (environment, repository, _v0) {
		var page = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				page,
				{fG: $author$project$Audit$PerformAuditPage$Hidden}),
			ae: repository
		};
	});
var $author$project$Audit$PerformAuditPage$focusedInput = F3(
	function (environment, repository, page) {
		return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
	});
var $author$project$Audit$PerformAuditPage$gotCollapseCheckpointGroup = F4(
	function (checkpointGroupId, environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{
					bk: A2($elm$core$List$cons, checkpointGroupId, model.bk)
				}),
			ae: repository
		};
	});
var $author$project$Audit$PerformAuditPage$noChange = F3(
	function (environment, repository, page) {
		return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
	});
var $author$project$Audit$Record$Records$getRecordFor = F2(
	function (checkpointId, records) {
		return A2(
			$elm$core$Maybe$andThen,
			A2($author$project$Utils$Utils$flip, $author$project$Audit$Record$Records$get, records),
			A2(
				$turboMaCk$any_dict$Dict$Any$get,
				checkpointId,
				$author$project$Audit$Record$Records$unwrap(records).ev));
	});
var $author$project$Audit$PerformAuditPage$isUnrecorded = F2(
	function (audit, cp) {
		var _v0 = A2($author$project$Audit$Record$Records$getRecordFor, cp.i5, audit.io);
		if (!_v0.$) {
			return 0;
		} else {
			return 1;
		}
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Audit$PerformAuditPage$recordCount = F2(
	function (auditId, repository) {
		var _v0 = A2($author$project$Environments$Repository$getAudit, auditId, repository);
		if (!_v0.$) {
			var audit = _v0.a;
			var numberOfRecorded = $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					$author$project$Audit$PerformAuditPage$isUnrecorded(audit),
					A2(
						$elm$core$List$filter,
						function (cp) {
							var _v1 = cp.fg;
							if (_v1.$ === 9) {
								return false;
							} else {
								return true;
							}
						},
						audit.ff.i6)));
			return {
				ew: $elm$core$List$length(audit.ff.i6),
				dX: numberOfRecorded
			};
		} else {
			return {ew: -1, dX: -1};
		}
	});
var $author$project$Audit$PerformAuditPage$withCompleteModal = F2(
	function (completeModal_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{gv: completeModal_});
	});
var $author$project$Audit$PerformAuditPage$gotCommand = F4(
	function (command, environment, repository, page) {
		var model = page;
		var _v0 = A3(
			$author$project$Audit$Audit$handleCommand,
			command,
			environment,
			A2($author$project$Environments$Repository$getAudit, model.gm, repository));
		if (_v0.$ === 1) {
			var error = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Environments$ErrorHandling$Id$from,
				$author$project$Environments$Environment$generateUuid(environment));
			var newId = _v1.a;
			var newEnvironment = _v1.b;
			var newError = {
				gg: 'Commands are generated from OrganisationUnit.Duplicator',
				gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
					$author$project$Environments$ErrorHandling$ToString$auditErrorToString(error)),
				gH: 'Audit.PerformAuditPage.elm',
				gK: 'gotCommand',
				fw: newId
			};
			return A3(
				$author$project$Audit$PerformAuditPage$noChange,
				A2($author$project$Environments$Environment$addError, newError, newEnvironment),
				repository,
				page);
		} else {
			var _v2 = _v0.a;
			var newEvents = _v2.a;
			var fileOperations = _v2.b;
			var newEnvironment = _v2.c;
			if ($author$project$Audit$Events$isEmpty(newEvents)) {
				return {ab: $elm$core$Platform$Cmd$none, ac: newEnvironment, ak: page, ae: repository};
			} else {
				var newEnvironment2 = function () {
					if (command.$ === 8) {
						return A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Audits, newEnvironment);
					} else {
						return newEnvironment;
					}
				}();
				var _v3 = A4($author$project$Environments$Repository$saveAuditCommandAndEventsAndFileOperations, command, newEvents, fileOperations, repository);
				var newRepository = _v3.a;
				var cmd = _v3.b;
				var recordCount_ = A2($author$project$Audit$PerformAuditPage$recordCount, model.gm, newRepository);
				var newPage = (!recordCount_.dX) ? A2($author$project$Audit$PerformAuditPage$withCompleteModal, $author$project$Audit$CompleteAudit$hidden, page) : page;
				return {ab: cmd, ac: newEnvironment2, ak: newPage, ae: newRepository};
			}
		}
	});
var $author$project$Audit$PerformAuditPage$GotCommand = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$Command$complete = F4(
	function (environment, auditId_, idForError, titleForError) {
		return A2(
			$author$project$Audit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Audit$Command$Complete(
						{gm: auditId_, L: commandId_, M: commandTimestamp, k: idForError, l: titleForError});
				}));
	});
var $author$project$Audit$PerformAuditPage$createCompleteCommand = F3(
	function (environment, repository, _v0) {
		var model = _v0;
		var recordCount_ = A2($author$project$Audit$PerformAuditPage$recordCount, model.gm, repository);
		var _v1 = _Utils_Tuple2(
			A2($author$project$Environments$Repository$getAudit, model.gm, repository),
			recordCount_.dX);
		if ((!_v1.a.$) && (!_v1.b)) {
			var audit = _v1.a.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$Task$perform, $author$project$Audit$PerformAuditPage$GotCommand, task);
				},
				A4($author$project$Audit$Command$complete, environment, model.gm, audit.fw, audit.k8));
		} else {
			return _Utils_Tuple2(environment, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Audit$CompleteAudit$closeDialog = 0;
var $author$project$Audit$CompleteAudit$update = function (msg) {
	return $author$project$Audit$CompleteAudit$closeDialog;
};
var $author$project$Audit$PerformAuditPage$gotCompleteAuditMsg = F4(
	function (modalMsg, environment, repository, page) {
		if (modalMsg === 2) {
			var _v1 = A3($author$project$Audit$PerformAuditPage$createCompleteCommand, environment, repository, page);
			var newEnvironment = _v1.a;
			var cmd = _v1.b;
			return {
				ab: cmd,
				ac: newEnvironment,
				ak: A2(
					$author$project$Audit$PerformAuditPage$withCompleteModal,
					$author$project$Audit$CompleteAudit$update(modalMsg),
					page),
				ae: repository
			};
		} else {
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: A2(
					$author$project$Audit$PerformAuditPage$withCompleteModal,
					$author$project$Audit$CompleteAudit$update(modalMsg),
					page),
				ae: repository
			};
		}
	});
var $author$project$Audit$PerformAuditPage$GotEditAuditDialogMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Audit$PerformAuditPage$editAuditDialog = function (_v0) {
	var model = _v0;
	return model.cN;
};
var $author$project$Audit$PerformAuditPage$withEditAuditDialog = F2(
	function (editDialog_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{cN: editDialog_});
	});
var $author$project$Audit$PerformAuditPage$gotEditAuditDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$Audit$EditDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$Audit$PerformAuditPage$editAuditDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Audit$PerformAuditPage$GotEditAuditDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$Audit$PerformAuditPage$withEditAuditDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$Audit$PerformAuditPage$gotExpandCheckpointGroup = F4(
	function (checkpointGroupId, environment, repository, _v0) {
		var model = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				model,
				{
					bk: A2(
						$elm$core$List$filter,
						function (id) {
							return !_Utils_eq(id, checkpointGroupId);
						},
						model.bk)
				}),
			ae: repository
		};
	});
var $author$project$Audit$PerformAuditPage$gotMeasureCreateDialogMsg = F4(
	function (dialogMsg, environment, repository, _v0) {
		var model = _v0;
		var result = A4($author$project$Measure$CreateDialog$update, dialogMsg, environment, repository, model.dV);
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Audit$PerformAuditPage$GotMeasureCreateDialogMsg, result.ab),
			ac: result.ac,
			ak: _Utils_update(
				model,
				{dV: result.jn}),
			ae: result.ae
		};
	});
var $author$project$Audit$PerformAuditPage$gotMeasureEditDialogMsg = F4(
	function (dialogMsg, environment, repository, _v0) {
		var model = _v0;
		var result = A4($author$project$Measure$EditDialog$update, dialogMsg, environment, repository, model.dW);
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Audit$PerformAuditPage$GotMeasureEditDialogMsg, result.ab),
			ac: result.ac,
			ak: _Utils_update(
				model,
				{dW: result.jn}),
			ae: result.ae
		};
	});
var $author$project$Audit$PerformAuditPage$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$PerformAuditPage$createMeasureData = F3(
	function (record, repository, _v0) {
		var model = _v0;
		var organisationUnitId = function () {
			var _v1 = model.ee;
			if (!_v1.$) {
				var id = _v1.a;
				return A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.km;
					},
					A2($author$project$Environments$Repository$getOrganisationUnit, id, repository));
			} else {
				var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
				return A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.km;
					},
					A2(
						$elm$core$Maybe$andThen,
						function (checkpointGroup) {
							return A2($author$project$Environments$Repository$getOrganisationUnit, checkpointGroup.km, repository);
						},
						A2(
							$elm$core$Maybe$andThen,
							function (checkpoint) {
								return A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, checkpoint.cC, checkpointData);
							},
							A2($author$project$CheckpointData$CheckpointData$getCheckpoint, record.i5, checkpointData))));
			}
		}();
		return {km: organisationUnitId, ct: record};
	});
var $author$project$Audit$Command$recordCheckpoint = F5(
	function (environment, auditId_, idForError, titleForError, record) {
		return A2(
			$author$project$Audit$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Audit$Command$RecordCheckpoint(
						{gm: auditId_, L: commandId_, M: commandTimestamp, k: idForError, ct: record, l: titleForError});
				}));
	});
var $author$project$Audit$PerformAuditPage$gotRecord = F4(
	function (record, environment, repository, page) {
		var model = page;
		var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
		var maybeOrganisationUnit = $author$project$Utils$Maybe$isJust(model.ee) ? model.ee : A2(
			$elm$core$Maybe$map,
			function (checkpointGroup) {
				return checkpointGroup.km;
			},
			A2(
				$elm$core$Maybe$andThen,
				function (checkpoint) {
					return A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, checkpoint.cC, checkpointData);
				},
				A2($author$project$CheckpointData$CheckpointData$getCheckpoint, record.i5, checkpointData)));
		var userCanCreateMeasure = A3(
			$author$project$Auth$Authorization$authorize_Maybe,
			$author$project$Environments$Environment$userRights(environment),
			4,
			maybeOrganisationUnit);
		var newPage = function () {
			var _v2 = _Utils_Tuple2(record.ll, userCanCreateMeasure);
			if (((_v2.a.$ === 3) && (!_v2.a.a)) && _v2.b) {
				return _Utils_update(
					model,
					{
						fG: $author$project$Audit$PerformAuditPage$Visible(
							A3($author$project$Audit$PerformAuditPage$createMeasureData, record, repository, page))
					});
			} else {
				return model;
			}
		}();
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2('unknown', 'unknown'),
			A2(
				$elm$core$Maybe$map,
				function (audit) {
					return _Utils_Tuple2(audit.fw, audit.k8);
				},
				A2($author$project$Environments$Repository$getAudit, model.gm, repository)));
		var idForError = _v0.a;
		var titleForError = _v0.b;
		var _v1 = A5($author$project$Audit$Command$recordCheckpoint, environment, model.gm, idForError, titleForError, record);
		var newEnvironment = _v1.a;
		var createCommandTask = _v1.b;
		return {
			ab: A2($elm$core$Task$perform, $author$project$Audit$PerformAuditPage$GotCommand, createCommandTask),
			ac: newEnvironment,
			ak: newPage,
			ae: repository
		};
	});
var $author$project$Audit$CompleteAudit$Visible = 1;
var $author$project$Audit$CompleteAudit$visible = 1;
var $author$project$Audit$PerformAuditPage$openCompleteModal = F3(
	function (modalMsg, repository, page) {
		var model = page;
		var recordCount_ = A2($author$project$Audit$PerformAuditPage$recordCount, model.gm, repository);
		if (modalMsg.$ === 4) {
			return (!recordCount_.dX) ? A2($author$project$Audit$PerformAuditPage$withCompleteModal, $author$project$Audit$CompleteAudit$visible, page) : page;
		} else {
			return page;
		}
	});
var $author$project$Audit$PerformAuditPage$recordModal = function (_v0) {
	var model = _v0;
	return model.eW;
};
var $author$project$Audit$RecordModal$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audit$RecordModal$RecordDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audit$RecordModal$updateDatePicker = F2(
	function (state, config) {
		if (config.$ === 3) {
			var model = config.a;
			var _v1 = function () {
				var _v2 = $author$project$UI$DateInput$maybeDatePickerDate(state);
				if (!_v2.$) {
					var newDate = _v2.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(newDate),
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple2(model.ll, model.o);
				}
			}();
			var date = _v1.a;
			var textInput = _v1.b;
			return $author$project$Audit$RecordModal$RecordDate(
				_Utils_update(
					model,
					{cJ: state, o: textInput, ll: date}));
		} else {
			return config;
		}
	});
var $author$project$Audit$RecordModal$changedDatePickerMsg = F4(
	function (datePicker, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var config = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Audit$RecordModal$Visible(
						A2($author$project$Audit$RecordModal$updateDatePicker, datePicker, config)),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$ids = function (config) {
	switch (config.$) {
		case 0:
			var model = config.a;
			return {gm: model.gm, i5: model.i5, dk: model.dk};
		case 1:
			var model = config.a;
			return {gm: model.gm, i5: model.i5, dk: model.dk};
		case 2:
			var model = config.a;
			return {gm: model.gm, i5: model.i5, dk: model.dk};
		case 3:
			var model = config.a;
			return {gm: model.gm, i5: model.i5, dk: model.dk};
		case 4:
			var model = config.a;
			return {gm: model.gm, i5: model.i5, dk: model.dk};
		case 5:
			var model = config.a;
			return {gm: model.gm, i5: model.i5, dk: model.dk};
		default:
			var model = config.a;
			return {gm: model.gm, i5: model.i5, dk: model.dk};
	}
};
var $author$project$Audit$RecordModal$createdCommand = F4(
	function (command, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 2:
				var config = dialog.a;
				var ids_ = $author$project$Audit$RecordModal$ids(config);
				var _v1 = A3(
					$author$project$Audit$Audit$handleCommand,
					command,
					environment,
					A2($author$project$Environments$Repository$getAudit, ids_.gm, repository));
				if (_v1.$ === 1) {
					var error = _v1.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$auditErrorToString(error)),
						gH: 'CheckpointHelper.RecordModal.elm',
						gK: 'createdCommand',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: $author$project$Audit$RecordModal$Hidden,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				} else {
					var _v3 = _v1.a;
					var events = _v3.a;
					var fileOperations = _v3.b;
					var newEnvironment = _v3.c;
					if ($author$project$Audit$Events$isEmpty(events)) {
						return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Audit$RecordModal$Hidden, ac: newEnvironment, ae: repository};
					} else {
						var _v4 = A4($author$project$Environments$Repository$saveAuditCommandAndEventsAndFileOperations, command, events, fileOperations, repository);
						var newRepository = _v4.a;
						var cmd = _v4.b;
						return {ab: cmd, jn: $author$project$Audit$RecordModal$Hidden, ac: newEnvironment, ae: newRepository};
					}
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$RecordTime = function (a) {
	return {$: 4, a: a};
};
var $author$project$Audit$RecordModal$addHourValue = F2(
	function (hourInput, config) {
		if (config.$ === 4) {
			var model = config.a;
			var newModel = function () {
				if ($elm$core$String$isEmpty(hourInput)) {
					return _Utils_update(
						model,
						{cf: hourInput, ll: $elm$core$Maybe$Nothing});
				} else {
					if ($elm$core$String$isEmpty(model.cj)) {
						var _v1 = $elm$core$String$toInt(hourInput);
						if (_v1.$ === 1) {
							return model;
						} else {
							var hour = _v1.a;
							return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
								model,
								{cf: hourInput, ll: $elm$core$Maybe$Nothing}) : model;
						}
					} else {
						var _v2 = _Utils_Tuple2(
							$elm$core$String$toInt(hourInput),
							$elm$core$String$toInt(model.cj));
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var hour = _v2.a.a;
							var minute = _v2.b.a;
							var _v3 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
							if (!_v3.$) {
								var naiveTime = _v3.a;
								return _Utils_update(
									model,
									{
										cf: hourInput,
										ll: $elm$core$Maybe$Just(naiveTime)
									});
							} else {
								return model;
							}
						} else {
							return model;
						}
					}
				}
			}();
			return $author$project$Audit$RecordModal$RecordTime(newModel);
		} else {
			return config;
		}
	});
var $author$project$Audit$RecordModal$enteredHour = F4(
	function (input, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Audit$RecordModal$Visible(
						A2($author$project$Audit$RecordModal$addHourValue, input, model)),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$addMinuteValue = F2(
	function (minuteInput, config) {
		if (config.$ === 4) {
			var model = config.a;
			var newModel = function () {
				if ($elm$core$String$isEmpty(minuteInput)) {
					return _Utils_update(
						model,
						{cj: minuteInput, ll: $elm$core$Maybe$Nothing});
				} else {
					if ($elm$core$String$isEmpty(model.cf)) {
						var _v1 = $elm$core$String$toInt(minuteInput);
						if (_v1.$ === 1) {
							return model;
						} else {
							var hour = _v1.a;
							return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
								model,
								{cj: minuteInput, ll: $elm$core$Maybe$Nothing}) : model;
						}
					} else {
						var _v2 = _Utils_Tuple2(
							$elm$core$String$toInt(model.cf),
							$elm$core$String$toInt(minuteInput));
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var hour = _v2.a.a;
							var minute = _v2.b.a;
							var _v3 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
							if (!_v3.$) {
								var naiveTime = _v3.a;
								return _Utils_update(
									model,
									{
										cj: minuteInput,
										ll: $elm$core$Maybe$Just(naiveTime)
									});
							} else {
								return model;
							}
						} else {
							return model;
						}
					}
				}
			}();
			return $author$project$Audit$RecordModal$RecordTime(newModel);
		} else {
			return config;
		}
	});
var $author$project$Audit$RecordModal$enteredMinute = F4(
	function (input, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Audit$RecordModal$Visible(
						A2($author$project$Audit$RecordModal$addMinuteValue, input, model)),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$RecordNumber = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audit$RecordModal$RecordTextMemo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audit$RecordModal$RecordTextRow = function (a) {
	return {$: 1, a: a};
};
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Audit$RecordModal$addTextInput = F2(
	function (input, config) {
		switch (config.$) {
			case 0:
				var model = config.a;
				var transformedString = A3(
					$elm$core$String$replace,
					'-',
					'',
					A3($elm$core$String$replace, ',', '.', input));
				var _v1 = $elm$core$String$toFloat(transformedString);
				if (!_v1.$) {
					return $author$project$Audit$RecordModal$RecordNumber(
						_Utils_update(
							model,
							{
								o: $elm$core$Maybe$Just(input)
							}));
				} else {
					return (($elm$core$String$trim(input) === '-') || (input === '')) ? $author$project$Audit$RecordModal$RecordNumber(
						_Utils_update(
							model,
							{
								o: $elm$core$Maybe$Just(input)
							})) : $author$project$Audit$RecordModal$RecordNumber(model);
				}
			case 1:
				var model = config.a;
				return ($elm$core$String$length(input) > 50) ? config : $author$project$Audit$RecordModal$RecordTextRow(
					_Utils_update(
						model,
						{
							o: $elm$core$Maybe$Just(input)
						}));
			case 2:
				var model = config.a;
				return $author$project$Audit$RecordModal$RecordTextMemo(
					_Utils_update(
						model,
						{
							o: $elm$core$Maybe$Just(input)
						}));
			case 3:
				var model = config.a;
				var _v2 = function () {
					var _v3 = $author$project$UI$DateInput$inputToNaivDate(
						A3($elm$core$String$replace, '.', '-', input));
					if (!_v3.$) {
						var dateValue = _v3.a;
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(dateValue),
							$elm$core$Maybe$Nothing,
							A2($author$project$UI$DateInput$updateDatePicker, dateValue, model.cJ));
					} else {
						return _Utils_Tuple3(
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(input),
							model.cJ);
					}
				}();
				var value = _v2.a;
				var textInput = _v2.b;
				var datePicker = _v2.c;
				return $author$project$Audit$RecordModal$RecordDate(
					_Utils_update(
						model,
						{cJ: datePicker, o: textInput, ll: value}));
			default:
				return config;
		}
	});
var $author$project$Audit$RecordModal$enteredText = F4(
	function (input, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var config = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Audit$RecordModal$Visible(
						A2($author$project$Audit$RecordModal$addTextInput, input, config)),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$RecordSignature = function (a) {
	return {$: 6, a: a};
};
var $author$project$Audit$RecordModal$UserClickedCreateButton = {$: 2};
var $author$project$UI$Canvas$Canvas$controlPoint = F2(
	function (_v0, _v1) {
		var x1 = _v0.a;
		var y1 = _v0.b;
		var x2 = _v1.a;
		var y2 = _v1.b;
		return _Utils_Tuple2(x1 + ((x2 - x1) / 2), y1 + ((y2 - y1) / 2));
	});
var $joakin$elm_canvas$Canvas$Settings$Line$RoundCap = 1;
var $joakin$elm_canvas$Canvas$Settings$Line$RoundJoin = 1;
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {eq: a, iZ: b, jE: g, kz: r};
};
var $author$project$UI$Style$Color$uiColorToColor = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return A4($avh4$elm_color$Color$rgba, r, g, b, a);
};
var $author$project$UI$Canvas$Canvas$getShadowColor = function (color) {
	var _v0 = $avh4$elm_color$Color$toRgba(
		$author$project$UI$Style$Color$uiColorToColor(color));
	var red = _v0.kz;
	var green = _v0.jE;
	var blue = _v0.iZ;
	return A4($avh4$elm_color$Color$rgba, red, green, blue, 0.2);
};
var $joakin$elm_canvas$Canvas$Internal$Canvas$SettingCommand = function (a) {
	return {$: 0, a: a};
};
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$field = F2(
	function (name, value) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('field')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2('value', value)
				]));
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$lineCap = function (cap) {
	return A2(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$field,
		'lineCap',
		$elm$json$Json$Encode$string(cap));
};
var $joakin$elm_canvas$Canvas$Settings$Line$lineCapToString = function (cap) {
	switch (cap) {
		case 0:
			return 'butt';
		case 1:
			return 'round';
		default:
			return 'square';
	}
};
var $joakin$elm_canvas$Canvas$Settings$Line$lineCap = function (cap) {
	return $joakin$elm_canvas$Canvas$Internal$Canvas$SettingCommand(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$lineCap(
			$joakin$elm_canvas$Canvas$Settings$Line$lineCapToString(cap)));
};
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$lineJoin = function (join) {
	return A2(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$field,
		'lineJoin',
		$elm$json$Json$Encode$string(join));
};
var $joakin$elm_canvas$Canvas$Settings$Line$lineJoinToString = function (join) {
	switch (join) {
		case 0:
			return 'bevel';
		case 1:
			return 'round';
		default:
			return 'miter';
	}
};
var $joakin$elm_canvas$Canvas$Settings$Line$lineJoin = function (join) {
	return $joakin$elm_canvas$Canvas$Internal$Canvas$SettingCommand(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$lineJoin(
			$joakin$elm_canvas$Canvas$Settings$Line$lineJoinToString(join)));
};
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$lineWidth = function (value) {
	return A2(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$field,
		'lineWidth',
		$elm$json$Json$Encode$float(value));
};
var $joakin$elm_canvas$Canvas$Settings$Line$lineWidth = function (width) {
	return $joakin$elm_canvas$Canvas$Internal$Canvas$SettingCommand(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$lineWidth(width));
};
var $joakin$elm_canvas$Canvas$Internal$Canvas$SettingCommands = function (a) {
	return {$: 1, a: a};
};
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$shadowBlur = function (value) {
	return A2(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$field,
		'shadowBlur',
		$elm$json$Json$Encode$float(value));
};
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$shadowColor = function (color) {
	return A2(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$field,
		'shadowColor',
		$elm$json$Json$Encode$string(
			$avh4$elm_color$Color$toCssString(color)));
};
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$shadowOffsetX = function (value) {
	return A2(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$field,
		'shadowOffsetX',
		$elm$json$Json$Encode$float(value));
};
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$shadowOffsetY = function (value) {
	return A2(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$field,
		'shadowOffsetY',
		$elm$json$Json$Encode$float(value));
};
var $joakin$elm_canvas$Canvas$Settings$Advanced$shadow = function (_v0) {
	var blur = _v0.i_;
	var color = _v0.K;
	var offset = _v0.d0;
	var _v1 = offset;
	var x = _v1.a;
	var y = _v1.b;
	return $joakin$elm_canvas$Canvas$Internal$Canvas$SettingCommands(
		_List_fromArray(
			[
				$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$shadowBlur(blur),
				$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$shadowColor(color),
				$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$shadowOffsetX(x),
				$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$shadowOffsetY(y)
			]));
};
var $joakin$elm_canvas$Canvas$Internal$Canvas$DrawableShapes = function (a) {
	return {$: 1, a: a};
};
var $joakin$elm_canvas$Canvas$Internal$Canvas$NotSpecified = {$: 0};
var $joakin$elm_canvas$Canvas$Internal$Canvas$Renderable = $elm$core$Basics$identity;
var $joakin$elm_canvas$Canvas$Internal$Canvas$Fill = function (a) {
	return {$: 1, a: a};
};
var $joakin$elm_canvas$Canvas$Internal$Canvas$FillAndStroke = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $joakin$elm_canvas$Canvas$Internal$Canvas$Stroke = function (a) {
	return {$: 2, a: a};
};
var $joakin$elm_canvas$Canvas$mergeDrawOp = F2(
	function (op1, op2) {
		var _v0 = _Utils_Tuple2(op1, op2);
		_v0$7:
		while (true) {
			switch (_v0.b.$) {
				case 3:
					var _v1 = _v0.b;
					var c = _v1.a;
					var sc = _v1.b;
					return A2($joakin$elm_canvas$Canvas$Internal$Canvas$FillAndStroke, c, sc);
				case 1:
					switch (_v0.a.$) {
						case 1:
							var c = _v0.b.a;
							return $joakin$elm_canvas$Canvas$Internal$Canvas$Fill(c);
						case 2:
							var c1 = _v0.a.a;
							var c2 = _v0.b.a;
							return A2($joakin$elm_canvas$Canvas$Internal$Canvas$FillAndStroke, c2, c1);
						case 3:
							var _v2 = _v0.a;
							var sc = _v2.b;
							var c2 = _v0.b.a;
							return A2($joakin$elm_canvas$Canvas$Internal$Canvas$FillAndStroke, c2, sc);
						default:
							break _v0$7;
					}
				case 2:
					switch (_v0.a.$) {
						case 2:
							var c = _v0.b.a;
							return $joakin$elm_canvas$Canvas$Internal$Canvas$Stroke(c);
						case 1:
							var c1 = _v0.a.a;
							var c2 = _v0.b.a;
							return A2($joakin$elm_canvas$Canvas$Internal$Canvas$FillAndStroke, c1, c2);
						case 3:
							var _v3 = _v0.a;
							var c = _v3.a;
							var sc2 = _v0.b.a;
							return A2($joakin$elm_canvas$Canvas$Internal$Canvas$FillAndStroke, c, sc2);
						default:
							break _v0$7;
					}
				default:
					if (!_v0.a.$) {
						break _v0$7;
					} else {
						var whatever = _v0.a;
						var _v5 = _v0.b;
						return whatever;
					}
			}
		}
		var _v4 = _v0.a;
		var whatever = _v0.b;
		return whatever;
	});
var $joakin$elm_canvas$Canvas$addSettingsToRenderable = F2(
	function (settings, renderable) {
		var addSetting = F2(
			function (setting, _v1) {
				var r = _v1;
				switch (setting.$) {
					case 0:
						var cmd = setting.a;
						return _Utils_update(
							r,
							{
								cD: A2($elm$core$List$cons, cmd, r.cD)
							});
					case 1:
						var cmds = setting.a;
						return _Utils_update(
							r,
							{
								cD: A3($elm$core$List$foldl, $elm$core$List$cons, r.cD, cmds)
							});
					case 3:
						var f = setting.a;
						return _Utils_update(
							r,
							{
								b6: f(r.b6)
							});
					default:
						var op = setting.a;
						return _Utils_update(
							r,
							{
								b5: A2($joakin$elm_canvas$Canvas$mergeDrawOp, r.b5, op)
							});
				}
			});
		return A3($elm$core$List$foldl, addSetting, renderable, settings);
	});
var $joakin$elm_canvas$Canvas$shapes = F2(
	function (settings, ss) {
		return A2(
			$joakin$elm_canvas$Canvas$addSettingsToRenderable,
			settings,
			{
				cD: _List_Nil,
				b5: $joakin$elm_canvas$Canvas$Internal$Canvas$NotSpecified,
				b6: $joakin$elm_canvas$Canvas$Internal$Canvas$DrawableShapes(ss)
			});
	});
var $joakin$elm_canvas$Canvas$Internal$Canvas$SettingDrawOp = function (a) {
	return {$: 2, a: a};
};
var $joakin$elm_canvas$Canvas$Settings$stroke = function (color) {
	return $joakin$elm_canvas$Canvas$Internal$Canvas$SettingDrawOp(
		$joakin$elm_canvas$Canvas$Internal$Canvas$Stroke(color));
};
var $author$project$UI$Canvas$Canvas$drawLine = F2(
	function (_v0, line) {
		var pencilColor = _v0.eR;
		var pencilSize = _v0.eS;
		return A2(
			$joakin$elm_canvas$Canvas$shapes,
			_List_fromArray(
				[
					$joakin$elm_canvas$Canvas$Settings$Line$lineCap(1),
					$joakin$elm_canvas$Canvas$Settings$Line$lineJoin(1),
					$joakin$elm_canvas$Canvas$Settings$Line$lineWidth(pencilSize),
					$joakin$elm_canvas$Canvas$Settings$Advanced$shadow(
					{
						i_: 10,
						K: $author$project$UI$Canvas$Canvas$getShadowColor(pencilColor),
						d0: _Utils_Tuple2(0, 0)
					}),
					$joakin$elm_canvas$Canvas$Settings$stroke(
					$author$project$UI$Style$Color$uiColorToColor(pencilColor))
				]),
			line);
	});
var $joakin$elm_canvas$Canvas$Internal$Canvas$Path = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $joakin$elm_canvas$Canvas$path = F2(
	function (startingPoint, segments) {
		return A2($joakin$elm_canvas$Canvas$Internal$Canvas$Path, startingPoint, segments);
	});
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $joakin$elm_canvas$Canvas$Internal$Canvas$QuadraticCurveTo = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $joakin$elm_canvas$Canvas$quadraticCurveTo = F2(
	function (controlPoint, point) {
		return A2($joakin$elm_canvas$Canvas$Internal$Canvas$QuadraticCurveTo, controlPoint, point);
	});
var $author$project$UI$Canvas$Canvas$drawPoint = F2(
	function (newPoint, model) {
		var drawingPointer = model.cM;
		var pending = model.cq;
		if (!drawingPointer.$) {
			var previousMidpoint = drawingPointer.a.eV;
			var lastPoint = drawingPointer.a.eJ;
			var newMidPoint = A2($author$project$UI$Canvas$Canvas$controlPoint, lastPoint, newPoint);
			return _Utils_update(
				model,
				{
					cM: $elm$core$Maybe$Just(
						{eJ: newPoint, eV: newMidPoint}),
					cq: A2(
						$elm$core$Array$push,
						A2(
							$author$project$UI$Canvas$Canvas$drawLine,
							model,
							_List_fromArray(
								[
									A2(
									$joakin$elm_canvas$Canvas$path,
									previousMidpoint,
									_List_fromArray(
										[
											A2($joakin$elm_canvas$Canvas$quadraticCurveTo, lastPoint, newMidPoint)
										]))
								])),
						pending)
				});
		} else {
			return model;
		}
	});
var $author$project$UI$Canvas$Canvas$finalPoint = F2(
	function (point, model) {
		var drawingPointer = model.cM;
		var pending = model.cq;
		if (!drawingPointer.$) {
			var previousMidpoint = drawingPointer.a.eV;
			var lastPoint = drawingPointer.a.eJ;
			return _Utils_update(
				model,
				{
					cM: $elm$core$Maybe$Nothing,
					cq: A2(
						$elm$core$Array$push,
						A2(
							$author$project$UI$Canvas$Canvas$drawLine,
							model,
							_List_fromArray(
								[
									A2(
									$joakin$elm_canvas$Canvas$path,
									previousMidpoint,
									_List_fromArray(
										[
											A2($joakin$elm_canvas$Canvas$quadraticCurveTo, lastPoint, point)
										]))
								])),
						pending)
				});
		} else {
			return model;
		}
	});
var $author$project$UI$Canvas$Canvas$flushPendingToDraw = function (model) {
	var pending = model.cq;
	return _Utils_update(
		model,
		{
			cq: $elm$core$Array$empty,
			f8: $elm$core$Array$toList(pending)
		});
};
var $author$project$UI$Canvas$Canvas$incFrames = function (model) {
	var frames = model.fu;
	return _Utils_update(
		model,
		{fu: frames + 1});
};
var $author$project$UI$Canvas$Canvas$initialPoint = F2(
	function (_v0, model) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_update(
			model,
			{
				cM: $elm$core$Maybe$Just(
					{
						eJ: _Utils_Tuple2(x, y),
						eV: _Utils_Tuple2(x, y)
					})
			});
	});
var $author$project$UI$Canvas$Canvas$selectColor = F2(
	function (pencilSize, model) {
		return _Utils_update(
			model,
			{eR: pencilSize});
	});
var $author$project$UI$Canvas$Canvas$selectSize = F2(
	function (pencilSize, model) {
		return _Utils_update(
			model,
			{eS: pencilSize});
	});
var $author$project$UI$Canvas$Canvas$update = F2(
	function (msg, state) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					$author$project$UI$Canvas$Canvas$flushPendingToDraw(
						$author$project$UI$Canvas$Canvas$incFrames(state)),
					$elm$core$Platform$Cmd$none);
			case 1:
				var point = msg.a;
				return _Utils_Tuple2(
					A2($author$project$UI$Canvas$Canvas$initialPoint, point, state),
					$elm$core$Platform$Cmd$none);
			case 2:
				var point = msg.a;
				return _Utils_Tuple2(
					A2($author$project$UI$Canvas$Canvas$drawPoint, point, state),
					$elm$core$Platform$Cmd$none);
			case 3:
				var point = msg.a;
				return _Utils_Tuple2(
					A2($author$project$UI$Canvas$Canvas$finalPoint, point, state),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 6:
				var color = msg.a;
				return _Utils_Tuple2(
					A2($author$project$UI$Canvas$Canvas$selectColor, color, state),
					$elm$core$Platform$Cmd$none);
			default:
				var size = msg.a;
				return _Utils_Tuple2(
					A2($author$project$UI$Canvas$Canvas$selectSize, size, state),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Audit$RecordModal$updateCanvas = F2(
	function (msg, config) {
		if (config.$ === 6) {
			var signatureModel = config.a;
			var _v1 = function () {
				if (msg.$ === 4) {
					var filename = msg.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(filename),
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always($author$project$Audit$RecordModal$UserClickedCreateButton),
							$elm$core$Task$succeed(0)));
				} else {
					return _Utils_Tuple2(signatureModel.eM, $elm$core$Platform$Cmd$none);
				}
			}();
			var newFilename = _v1.a;
			var savedCommand = _v1.b;
			var _v3 = A2($author$project$UI$Canvas$Canvas$update, msg, signatureModel.dr);
			var newCanvas = _v3.a;
			var canvasCmd = _v3.b;
			return _Utils_Tuple2(
				$author$project$Audit$RecordModal$RecordSignature(
					_Utils_update(
						signatureModel,
						{dr: newCanvas, eM: newFilename})),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Audit$RecordModal$GotCanvasMsg, canvasCmd),
							savedCommand
						])));
		} else {
			return _Utils_Tuple2(config, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Audit$RecordModal$gotCanvasMsg = F4(
	function (canvasMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var config = dialog.a;
				var _v1 = A2($author$project$Audit$RecordModal$updateCanvas, canvasMsg, config);
				var newConfig = _v1.a;
				var imageEditorCmd = _v1.b;
				return {
					ab: imageEditorCmd,
					jn: $author$project$Audit$RecordModal$Visible(newConfig),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$CreatedCommand = function (a) {
	return {$: 4, a: a};
};
var $author$project$Audit$RecordModal$gotGotRecordMsg = F4(
	function (record_, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 2:
				var config = dialog.a;
				var ids_ = $author$project$Audit$RecordModal$ids(config);
				var _v1 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2('unknown', 'unknown'),
					A2(
						$elm$core$Maybe$map,
						function (audit) {
							return _Utils_Tuple2(audit.fw, audit.k8);
						},
						A2($author$project$Environments$Repository$getAudit, ids_.gm, repository)));
				var idForError = _v1.a;
				var titleForError = _v1.b;
				var _v2 = A5($author$project$Audit$Command$recordCheckpoint, environment, ids_.gm, idForError, titleForError, record_);
				var newEnvironment = _v2.a;
				var task = _v2.b;
				return {
					ab: A2($elm$core$Task$perform, $author$project$Audit$RecordModal$CreatedCommand, task),
					jn: dialog,
					ac: newEnvironment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$RecordImage = function (a) {
	return {$: 5, a: a};
};
var $author$project$Audit$RecordModal$updateImageEditor = F2(
	function (msg, config) {
		if (config.$ === 5) {
			var imageModel = config.a;
			var _v1 = A2($author$project$UI$ImageEditor$update, msg, imageModel.cY);
			var newImageEditor = _v1.a;
			var imageEditorCmd = _v1.b;
			return _Utils_Tuple2(
				$author$project$Audit$RecordModal$RecordImage(
					_Utils_update(
						imageModel,
						{cY: newImageEditor})),
				A2($elm$core$Platform$Cmd$map, $author$project$Audit$RecordModal$GotImageEditorMsg, imageEditorCmd));
		} else {
			return _Utils_Tuple2(config, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Audit$RecordModal$gotImageEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var config = dialog.a;
				var _v1 = A2($author$project$Audit$RecordModal$updateImageEditor, editorMsg, config);
				var newConfig = _v1.a;
				var imageEditorCmd = _v1.b;
				return {
					ab: imageEditorCmd,
					jn: $author$project$Audit$RecordModal$Visible(newConfig),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Audit$RecordModal$Hidden, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Audit$RecordModal$Hidden, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$GotRecord = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audit$RecordModal$HandlingCommand = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audit$Record$Id$from = $elm$core$Basics$identity;
var $author$project$Audit$Record$Record$create = F4(
	function (value_, environment, checkpointId, auditorId) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Audit$Record$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var recordId = _v0.a;
		var newEnvironment = _v0.b;
		return _Utils_Tuple2(
			newEnvironment,
			A2(
				$elm$core$Task$map,
				function (recordTimestamp) {
					return {iW: auditorId, i5: checkpointId, cT: $author$project$File$Filenames$empty, bK: recordId, g8: recordTimestamp, ll: value_};
				},
				$elm$time$Time$now));
	});
var $author$project$CheckpointData$Checkpoint$Value$dateValue = $author$project$CheckpointData$Checkpoint$Value$DateValue;
var $author$project$CheckpointData$Checkpoint$Value$imageValue = $author$project$CheckpointData$Checkpoint$Value$ImageValue;
var $author$project$CheckpointData$Checkpoint$Value$numberValue = $author$project$CheckpointData$Checkpoint$Value$NumberValue;
var $myrho$elm_round$Round$funNum = F3(
	function (fun, s, fl) {
		return A2(
			$elm$core$Maybe$withDefault,
			0 / 0,
			$elm$core$String$toFloat(
				A2(fun, s, fl)));
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $myrho$elm_round$Round$roundNum = $myrho$elm_round$Round$funNum($myrho$elm_round$Round$round);
var $author$project$CheckpointData$Checkpoint$Value$signatureValue = $author$project$CheckpointData$Checkpoint$Value$SignatureValue;
var $author$project$CheckpointData$Checkpoint$Value$textMemoValue = $author$project$CheckpointData$Checkpoint$Value$TextMemoValue;
var $author$project$CheckpointData$Checkpoint$Value$textRowValue = $author$project$CheckpointData$Checkpoint$Value$TextRowValue;
var $author$project$CheckpointData$Checkpoint$Value$timeValue = $author$project$CheckpointData$Checkpoint$Value$TimeValue;
var $author$project$Audit$RecordModal$createValue = function (config) {
	switch (config.$) {
		case 0:
			var model = config.a;
			var fn = function (value) {
				var transformedString = A3($elm$core$String$replace, ',', '.', value);
				var _v1 = $elm$core$String$toFloat(transformedString);
				if (!_v1.$) {
					var _float = _v1.a;
					return $elm$core$Maybe$Just(
						A2($myrho$elm_round$Round$roundNum, model.kd.hJ, _float));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			};
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					function (input) {
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Maybe$map,
								function (_float) {
									return $elm$core$Maybe$Just(
										$author$project$CheckpointData$Checkpoint$Value$numberValue(_float));
								},
								fn(input)));
					},
					model.o));
		case 1:
			var model = config.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					function (input) {
						return $elm$core$String$isEmpty(
							$elm$core$String$trim(input)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							$author$project$CheckpointData$Checkpoint$Value$textRowValue(input));
					},
					model.o));
		case 2:
			var model = config.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					function (input) {
						return $elm$core$String$isEmpty(
							$elm$core$String$trim(input)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							$author$project$CheckpointData$Checkpoint$Value$textMemoValue(input));
					},
					model.o));
		case 3:
			var model = config.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Just(
					$author$project$CheckpointData$Checkpoint$Value$dateValue(model.lb)),
				A2(
					$elm$core$Maybe$map,
					function (date) {
						return $elm$core$Maybe$Just(
							$author$project$CheckpointData$Checkpoint$Value$dateValue(date));
					},
					model.ll));
		case 4:
			var model = config.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Just(
					$author$project$CheckpointData$Checkpoint$Value$timeValue(model.fK)),
				A2(
					$elm$core$Maybe$map,
					function (time) {
						return $elm$core$Maybe$Just(
							$author$project$CheckpointData$Checkpoint$Value$timeValue(time));
					},
					model.ll));
		case 5:
			var model = config.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					function (image) {
						return $elm$core$Maybe$Just(
							$author$project$CheckpointData$Checkpoint$Value$imageValue(image));
					},
					$author$project$UI$ImageEditor$image(model.cY)));
		default:
			var signatureModel = config.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					function (signature) {
						return $elm$core$Maybe$Just(
							$author$project$CheckpointData$Checkpoint$Value$signatureValue(signature));
					},
					signatureModel.eM));
	}
};
var $author$project$Audit$RecordModal$record = function (config) {
	switch (config.$) {
		case 0:
			var model = config.a;
			return model.ct;
		case 1:
			var model = config.a;
			return model.ct;
		case 2:
			var model = config.a;
			return model.ct;
		case 3:
			var model = config.a;
			return model.ct;
		case 4:
			var model = config.a;
			return model.ct;
		case 5:
			var model = config.a;
			return model.ct;
		default:
			var model = config.a;
			return model.ct;
	}
};
var $author$project$Audit$RecordModal$createRecord = F4(
	function (config, environment, repository, dialog) {
		var maybeValue = $author$project$Audit$RecordModal$createValue(config);
		var maybeRecord = $author$project$Audit$RecordModal$record(config);
		var _v0 = _Utils_Tuple2(maybeValue, maybeRecord);
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		} else {
			if (_v0.b.$ === 1) {
				var value = _v0.a.a;
				var _v2 = _v0.b;
				var ids_ = $author$project$Audit$RecordModal$ids(config);
				var _v3 = A4($author$project$Audit$Record$Record$create, value, environment, ids_.i5, ids_.dk);
				var newEnvironment = _v3.a;
				var record_ = _v3.b;
				return {
					ab: A2($elm$core$Task$perform, $author$project$Audit$RecordModal$GotRecord, record_),
					jn: $author$project$Audit$RecordModal$HandlingCommand(config),
					ac: newEnvironment,
					ae: repository
				};
			} else {
				var value = _v0.a.a;
				var record_ = _v0.b.a;
				if (_Utils_eq(value, record_.ll)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				} else {
					var ids_ = $author$project$Audit$RecordModal$ids(config);
					var _v4 = A4($author$project$Audit$Record$Record$create, value, environment, ids_.i5, ids_.dk);
					var newEnvironment = _v4.a;
					var newRecord = _v4.b;
					return {
						ab: A2($elm$core$Task$perform, $author$project$Audit$RecordModal$GotRecord, newRecord),
						jn: $author$project$Audit$RecordModal$HandlingCommand(config),
						ac: newEnvironment,
						ae: repository
					};
				}
			}
		}
	});
var $author$project$Audit$RecordModal$userClickedCreateButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var config = dialog.a;
				return A4($author$project$Audit$RecordModal$createRecord, config, environment, repository, dialog);
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$UI$Canvas$Canvas$SaveBlob = 0;
var $author$project$UI$Canvas$Canvas$canvasOutbox = _Platform_outgoingPort('canvasOutbox', $elm$core$Basics$identity);
var $author$project$UI$Canvas$Canvas$encodeOutMsg = function (outMsg) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('SAVE'))
			]));
};
var $author$project$UI$Canvas$Canvas$send = A2($elm$core$Basics$composeR, $author$project$UI$Canvas$Canvas$encodeOutMsg, $author$project$UI$Canvas$Canvas$canvasOutbox);
var $author$project$UI$Canvas$Canvas$saveBlob = $author$project$UI$Canvas$Canvas$send(0);
var $author$project$Audit$RecordModal$userClickedSaveBlob = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var config = dialog.a;
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Audit$RecordModal$GotCanvasMsg, $author$project$UI$Canvas$Canvas$saveBlob),
					jn: $author$project$Audit$RecordModal$Visible(config),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Audit$RecordModal$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Audit$RecordModal$userClickedCloseDialog;
		case 1:
			return $author$project$Audit$RecordModal$userClickedCancelButton;
		case 2:
			return $author$project$Audit$RecordModal$userClickedCreateButton;
		case 3:
			var record_ = msg.a;
			return $author$project$Audit$RecordModal$gotGotRecordMsg(record_);
		case 4:
			var command = msg.a;
			return $author$project$Audit$RecordModal$createdCommand(command);
		case 5:
			var input = msg.a;
			return $author$project$Audit$RecordModal$enteredText(input);
		case 6:
			var state = msg.a;
			return $author$project$Audit$RecordModal$changedDatePickerMsg(state);
		case 7:
			var input = msg.a;
			return $author$project$Audit$RecordModal$enteredHour(input);
		case 8:
			var input = msg.a;
			return $author$project$Audit$RecordModal$enteredMinute(input);
		case 9:
			var editorMsg = msg.a;
			return $author$project$Audit$RecordModal$gotImageEditorMsg(editorMsg);
		case 10:
			var canvasMsg = msg.a;
			return $author$project$Audit$RecordModal$gotCanvasMsg(canvasMsg);
		default:
			return $author$project$Audit$RecordModal$userClickedSaveBlob;
	}
};
var $author$project$Audit$PerformAuditPage$withRecordModal = F2(
	function (recordModal_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{eW: recordModal_});
	});
var $author$project$Audit$PerformAuditPage$gotRecordModalMsg = F4(
	function (modalMsg, environment, repository, page) {
		var result = A4(
			$author$project$Audit$RecordModal$update,
			modalMsg,
			environment,
			repository,
			$author$project$Audit$PerformAuditPage$recordModal(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Audit$PerformAuditPage$GotRecordModalMsg, result.ab),
			ac: result.ac,
			ak: A3(
				$author$project$Audit$PerformAuditPage$openCompleteModal,
				modalMsg,
				result.ae,
				A2($author$project$Audit$PerformAuditPage$withRecordModal, result.jn, page)),
			ae: result.ae
		};
	});
var $author$project$Audit$PerformAuditPage$FocusedInput = function (a) {
	return {$: 15, a: a};
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Translations$Record$auditErr = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'record.auditErr');
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Audit$RecordModal$showRecordDate = function (config) {
	var value_ = function () {
		var _v0 = config.ct;
		if (!_v0.$) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(config.lb);
		}
	}();
	return $author$project$Audit$RecordModal$Visible(
		$author$project$Audit$RecordModal$RecordDate(
			{gm: config.gm, i5: config.i5, cJ: $author$project$UI$DateInput$collapsed, ct: config.ct, o: $elm$core$Maybe$Nothing, lb: config.lb, dk: config.dk, ll: value_}));
};
var $author$project$Audit$RecordModal$showRecordImage = function (config) {
	return $author$project$Audit$RecordModal$Visible(
		$author$project$Audit$RecordModal$RecordImage(
			{gm: config.gm, i5: config.i5, cY: $author$project$UI$ImageEditor$default, ct: config.ct, dk: config.dk}));
};
var $author$project$Audit$RecordModal$showRecordNumber = function (config) {
	return $author$project$Audit$RecordModal$Visible(
		$author$project$Audit$RecordModal$RecordNumber(
			{gm: config.gm, i5: config.i5, kd: config.kd, ct: config.ct, o: $elm$core$Maybe$Nothing, dk: config.dk}));
};
var $author$project$UI$Canvas$Canvas$canvas = {cM: $elm$core$Maybe$Nothing, fu: 0, fv: 500, eR: $author$project$UI$Style$Theme$black, eS: 1, cq: $elm$core$Array$empty, f8: _List_Nil, ga: 500, e6: false};
var $author$project$Audit$RecordModal$showRecordSignature = function (config) {
	return $author$project$Audit$RecordModal$Visible(
		$author$project$Audit$RecordModal$RecordSignature(
			{gm: config.gm, dr: $author$project$UI$Canvas$Canvas$canvas, i5: config.i5, eM: $elm$core$Maybe$Nothing, ct: config.ct, dk: config.dk}));
};
var $author$project$Audit$RecordModal$showRecordTextMemo = function (config) {
	return $author$project$Audit$RecordModal$Visible(
		$author$project$Audit$RecordModal$RecordTextMemo(
			{gm: config.gm, i5: config.i5, ct: config.ct, o: $elm$core$Maybe$Nothing, dk: config.dk}));
};
var $author$project$Audit$RecordModal$showRecordTextRow = function (config) {
	return $author$project$Audit$RecordModal$Visible(
		$author$project$Audit$RecordModal$RecordTextRow(
			{gm: config.gm, i5: config.i5, ct: config.ct, o: $elm$core$Maybe$Nothing, dk: config.dk}));
};
var $author$project$Audit$RecordModal$intToFormattedString = function (value) {
	var str = $elm$core$String$fromInt(value);
	return (value < 10) ? ('0' + str) : str;
};
var $author$project$Audit$RecordModal$getHourAndMinuteValues = function (config) {
	var minuteValue = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Audit$RecordModal$intToFormattedString(
			$author$project$Date_Time$NaiveTime$minute(config.fK)),
		A2(
			$elm$core$Maybe$map,
			function (record_) {
				var _v1 = record_.ll;
				if (_v1.$ === 10) {
					var time = _v1.a;
					return $author$project$Audit$RecordModal$intToFormattedString(
						$author$project$Date_Time$NaiveTime$minute(time));
				} else {
					return $author$project$Audit$RecordModal$intToFormattedString(
						$author$project$Date_Time$NaiveTime$minute(config.fK));
				}
			},
			config.ct));
	var hourValue = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Audit$RecordModal$intToFormattedString(
			$author$project$Date_Time$NaiveTime$hour(config.fK)),
		A2(
			$elm$core$Maybe$map,
			function (record_) {
				var _v0 = record_.ll;
				if (_v0.$ === 10) {
					var time = _v0.a;
					return $author$project$Audit$RecordModal$intToFormattedString(
						$author$project$Date_Time$NaiveTime$hour(time));
				} else {
					return $author$project$Audit$RecordModal$intToFormattedString(
						$author$project$Date_Time$NaiveTime$hour(config.fK));
				}
			},
			config.ct));
	return _Utils_Tuple2(hourValue, minuteValue);
};
var $author$project$Audit$RecordModal$showRecordTime = function (config) {
	var value_ = function () {
		var _v1 = config.ct;
		if (!_v1.$) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(config.fK);
		}
	}();
	var _v0 = $author$project$Audit$RecordModal$getHourAndMinuteValues(config);
	var hourValue = _v0.a;
	var minuteValue = _v0.b;
	return $author$project$Audit$RecordModal$Visible(
		$author$project$Audit$RecordModal$RecordTime(
			{gm: config.gm, i5: config.i5, cf: hourValue, cj: minuteValue, fK: config.fK, ct: config.ct, dk: config.dk, ll: value_}));
};
var $author$project$Audit$PerformAuditPage$renderRecordModal = F6(
	function (environment, type_, checkpoint, now, audit, userId) {
		var record = A2($author$project$Audit$Record$Records$getRecordFor, checkpoint.i5, audit.io);
		switch (type_.$) {
			case 0:
				var numberModel = type_.a;
				return $author$project$Audit$RecordModal$showRecordNumber(
					{gm: audit.gm, i5: checkpoint.i5, kd: numberModel, ct: record, dk: userId});
			case 1:
				return $author$project$Audit$RecordModal$showRecordTextRow(
					{gm: audit.gm, i5: checkpoint.i5, ct: record, dk: userId});
			case 2:
				return $author$project$Audit$RecordModal$showRecordTextMemo(
					{gm: audit.gm, i5: checkpoint.i5, ct: record, dk: userId});
			case 7:
				var date = A2($author$project$Date_Time$NaiveDate$fromPosix, $elm$time$Time$utc, now);
				return $author$project$Audit$RecordModal$showRecordDate(
					{gm: audit.gm, i5: checkpoint.i5, ct: record, lb: date, dk: userId});
			case 11:
				var time = A2(
					$author$project$Date_Time$NaiveTime$fromPosix,
					$elm$time$Time$utc,
					$elm$time$Time$millisToPosix(
						$author$project$Environments$Environment$timeOffset(environment) + $elm$time$Time$posixToMillis(now)));
				return $author$project$Audit$RecordModal$showRecordTime(
					{gm: audit.gm, i5: checkpoint.i5, fK: time, ct: record, dk: userId});
			case 8:
				return $author$project$Audit$RecordModal$showRecordImage(
					{gm: audit.gm, i5: checkpoint.i5, ct: record, dk: userId});
			case 10:
				return $author$project$Audit$RecordModal$showRecordSignature(
					{gm: audit.gm, i5: checkpoint.i5, ct: record, dk: userId});
			default:
				return $author$project$Audit$RecordModal$hidden;
		}
	});
var $author$project$Translations$Record$userErr = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'record.userErr');
};
var $author$project$Audit$RecordModal$ErrorModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audit$RecordModal$viewError = $author$project$Audit$RecordModal$ErrorModal;
var $author$project$Audit$PerformAuditPage$openRecordModal = F5(
	function (checkpoint, now, environment, repository, page) {
		var model = page;
		var translations = $author$project$Environments$Environment$translations(environment);
		var _v0 = _Utils_Tuple2(
			$author$project$Auth$Session$maybeUserId(
				$author$project$Environments$Environment$session(environment)),
			A2($author$project$Environments$Repository$getAudit, model.gm, repository));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var userId = _v0.a.a;
				var audit = _v0.b.a;
				var recordModal_ = A6($author$project$Audit$PerformAuditPage$renderRecordModal, environment, checkpoint.fg, checkpoint, now, audit, userId);
				return {
					ab: A2(
						$elm$core$Task$attempt,
						$author$project$Audit$PerformAuditPage$FocusedInput,
						$elm$browser$Browser$Dom$focus('value-input')),
					ac: environment,
					ak: A2($author$project$Audit$PerformAuditPage$withRecordModal, recordModal_, page),
					ae: repository
				};
			} else {
				var _v2 = _v0.b;
				return {
					ab: A2(
						$elm$core$Task$attempt,
						$author$project$Audit$PerformAuditPage$FocusedInput,
						$elm$browser$Browser$Dom$focus('value-input')),
					ac: environment,
					ak: A2(
						$author$project$Audit$PerformAuditPage$withRecordModal,
						$author$project$Audit$RecordModal$viewError(
							$author$project$Translations$Record$auditErr(translations)),
						page),
					ae: repository
				};
			}
		} else {
			var _v1 = _v0.a;
			return {
				ab: A2(
					$elm$core$Task$attempt,
					$author$project$Audit$PerformAuditPage$FocusedInput,
					$elm$browser$Browser$Dom$focus('value-input')),
				ac: environment,
				ak: A2(
					$author$project$Audit$PerformAuditPage$withRecordModal,
					$author$project$Audit$RecordModal$viewError(
						$author$project$Translations$Record$userErr(translations)),
					page),
				ae: repository
			};
		}
	});
var $author$project$Audit$PerformAuditPage$userClickedAddMeasure = F4(
	function (measureData, environment, repository, _v0) {
		var page = _v0;
		var measureType = $author$project$Measure$MeasureType$Issue(
			{gm: page.gm, i5: measureData.ct.i5, bK: measureData.ct.bK});
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Measure$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var measureId = _v1.a;
		var newEnvironment = _v1.b;
		var _v2 = $author$project$Measure$CreateDialog$show(
			{jd: measureData.ct.iW, h5: measureId, h6: measureType, km: measureData.km});
		var measureCreateDialog = _v2.a;
		var createDialogCmd = _v2.b;
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Audit$PerformAuditPage$GotMeasureCreateDialogMsg, createDialogCmd),
			ac: newEnvironment,
			ak: _Utils_update(
				page,
				{dV: measureCreateDialog}),
			ae: repository
		};
	});
var $author$project$Audit$PerformAuditPage$userClickedCloseNotFoundModal = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$MainMenu, environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$Audit$PerformAuditPage$userClickedCompleteAudit = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2($author$project$Audit$PerformAuditPage$withCompleteModal, $author$project$Audit$CompleteAudit$visible, page),
			ae: repository
		};
	});
var $author$project$Audit$PerformAuditPage$userClickedEditAuditIcon = F4(
	function (audit, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2(
				$author$project$Audit$PerformAuditPage$withEditAuditDialog,
				A5(
					$author$project$Audit$EditDialog$show,
					environment,
					repository,
					0,
					$author$project$Environments$Environment$timeZone(environment),
					audit),
				page),
			ae: repository
		};
	});
var $author$project$Audit$PerformAuditPage$userClickedEditMeasure = F4(
	function (measure, environment, repository, _v0) {
		var model = _v0;
		var _v1 = A4($author$project$Measure$EditDialog$show, environment, repository, 0, measure);
		var measureEditDialog = _v1.a;
		var editMeasureCmd = _v1.b;
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Audit$PerformAuditPage$GotMeasureEditDialogMsg, editMeasureCmd),
			ac: environment,
			ak: _Utils_update(
				model,
				{dW: measureEditDialog}),
			ae: repository
		};
	});
var $author$project$Audit$PerformAuditPage$OpenRecordModal = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Audit$PerformAuditPage$userClickedOpenRecordModal = F4(
	function (checkpoint, environment, repository, page) {
		return {
			ab: A2(
				$elm$core$Task$perform,
				$author$project$Audit$PerformAuditPage$OpenRecordModal(checkpoint),
				$elm$time$Time$now),
			ac: environment,
			ak: page,
			ae: repository
		};
	});
var $author$project$Audit$PerformAuditPage$withSelectedOrganisationUnit = F2(
	function (maybeOrganisationUnit, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{ee: maybeOrganisationUnit});
	});
var $author$project$Audit$PerformAuditPage$userClickedOrganisationUnitTile = F4(
	function (organisationUnit, environment, repository, page) {
		var model = page;
		var _v0 = model.ee;
		if (!_v0.$) {
			var selectedOrganisationUnit = _v0.a;
			return _Utils_eq(selectedOrganisationUnit, organisationUnit.km) ? {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: A2($author$project$Audit$PerformAuditPage$withSelectedOrganisationUnit, $elm$core$Maybe$Nothing, page),
				ae: repository
			} : {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: A2(
					$author$project$Audit$PerformAuditPage$withSelectedOrganisationUnit,
					$elm$core$Maybe$Just(organisationUnit.km),
					page),
				ae: repository
			};
		} else {
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: A2(
					$author$project$Audit$PerformAuditPage$withSelectedOrganisationUnit,
					$elm$core$Maybe$Just(organisationUnit.km),
					page),
				ae: repository
			};
		}
	});
var $author$project$Audit$PerformAuditPage$GotRecord = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audit$PerformAuditPage$userEnteredCheckboxValue = F5(
	function (checkpoint, value, environment, repository, page) {
		var _v0 = $author$project$Auth$Session$maybeUserId(
			$author$project$Environments$Environment$session(environment));
		if (!_v0.$) {
			var userId = _v0.a;
			var _v1 = A4(
				$author$project$Audit$Record$Record$create,
				$author$project$CheckpointData$Checkpoint$Value$CheckboxValue(value),
				environment,
				checkpoint.i5,
				userId);
			var newEnvironment = _v1.a;
			var createRecordTask = _v1.b;
			return {
				ab: A2($elm$core$Task$perform, $author$project$Audit$PerformAuditPage$GotRecord, createRecordTask),
				ac: newEnvironment,
				ak: page,
				ae: repository
			};
		} else {
			return A3($author$project$Audit$PerformAuditPage$noChange, environment, repository, page);
		}
	});
var $author$project$Audit$PerformAuditPage$createMultiSelectFromRecord = F8(
	function (options, userId, checkpoint, option, value, environment, repository, page) {
		if (value) {
			var newOptions = A2($elm$core$List$cons, option, options);
			var _v0 = A4(
				$author$project$Audit$Record$Record$create,
				$author$project$CheckpointData$Checkpoint$Value$MultiSelectValue(newOptions),
				environment,
				checkpoint.i5,
				userId);
			var newEnvironment = _v0.a;
			var createRecordTask = _v0.b;
			return {
				ab: A2($elm$core$Task$perform, $author$project$Audit$PerformAuditPage$GotRecord, createRecordTask),
				ac: newEnvironment,
				ak: page,
				ae: repository
			};
		} else {
			if ($elm$core$List$length(options) === 1) {
				return A3($author$project$Audit$PerformAuditPage$noChange, environment, repository, page);
			} else {
				var newOptions = A2(
					$elm$core$List$filter,
					function (option_) {
						return !_Utils_eq(option_.fw, option.fw);
					},
					options);
				var _v1 = A4(
					$author$project$Audit$Record$Record$create,
					$author$project$CheckpointData$Checkpoint$Value$MultiSelectValue(newOptions),
					environment,
					checkpoint.i5,
					userId);
				var newEnvironment = _v1.a;
				var createRecordTask = _v1.b;
				return {
					ab: A2($elm$core$Task$perform, $author$project$Audit$PerformAuditPage$GotRecord, createRecordTask),
					ac: newEnvironment,
					ak: page,
					ae: repository
				};
			}
		}
	});
var $author$project$Audit$PerformAuditPage$createMultiSelectWithoutRecord = F7(
	function (userId, checkpoint, option, value, environment, repository, page) {
		if (value) {
			var _v0 = A4(
				$author$project$Audit$Record$Record$create,
				$author$project$CheckpointData$Checkpoint$Value$MultiSelectValue(
					_List_fromArray(
						[option])),
				environment,
				checkpoint.i5,
				userId);
			var newEnvironment = _v0.a;
			var createRecordTask = _v0.b;
			return {
				ab: A2($elm$core$Task$perform, $author$project$Audit$PerformAuditPage$GotRecord, createRecordTask),
				ac: newEnvironment,
				ak: page,
				ae: repository
			};
		} else {
			return A3($author$project$Audit$PerformAuditPage$noChange, environment, repository, page);
		}
	});
var $author$project$Audit$PerformAuditPage$createMultiselectRecord = F7(
	function (userId, checkpoint, option, value, environment, repository, page) {
		var page_ = page;
		var maybeRecord = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				function (audit) {
					return A2($author$project$Audit$Record$Records$getRecordFor, checkpoint.i5, audit.io);
				},
				A2($author$project$Environments$Repository$getAudit, page_.gm, repository)));
		if (!maybeRecord.$) {
			var record = maybeRecord.a;
			var _v1 = record.ll;
			if (_v1.$ === 6) {
				var options = _v1.a;
				return A8($author$project$Audit$PerformAuditPage$createMultiSelectFromRecord, options, userId, checkpoint, option, value, environment, repository, page);
			} else {
				return A7($author$project$Audit$PerformAuditPage$createMultiSelectWithoutRecord, userId, checkpoint, option, value, environment, repository, page);
			}
		} else {
			return A7($author$project$Audit$PerformAuditPage$createMultiSelectWithoutRecord, userId, checkpoint, option, value, environment, repository, page);
		}
	});
var $author$project$Audit$PerformAuditPage$createSelectRecord = F7(
	function (userId, checkpoint, option, value, environment, repository, page) {
		if (value) {
			var _v0 = A4(
				$author$project$Audit$Record$Record$create,
				$author$project$CheckpointData$Checkpoint$Value$SelectValue(option),
				environment,
				checkpoint.i5,
				userId);
			var newEnvironment = _v0.a;
			var createRecordTask = _v0.b;
			return {
				ab: A2($elm$core$Task$perform, $author$project$Audit$PerformAuditPage$GotRecord, createRecordTask),
				ac: newEnvironment,
				ak: page,
				ae: repository
			};
		} else {
			return A3($author$project$Audit$PerformAuditPage$noChange, environment, repository, page);
		}
	});
var $author$project$Audit$PerformAuditPage$userSelectedOption = F6(
	function (checkpoint, option, value, environment, repository, page) {
		var _v0 = $author$project$Auth$Session$maybeUserId(
			$author$project$Environments$Environment$session(environment));
		if (!_v0.$) {
			var userId = _v0.a;
			var _v1 = checkpoint.fg;
			switch (_v1.$) {
				case 5:
					return A7($author$project$Audit$PerformAuditPage$createSelectRecord, userId, checkpoint, option, value, environment, repository, page);
				case 6:
					return A7($author$project$Audit$PerformAuditPage$createMultiselectRecord, userId, checkpoint, option, value, environment, repository, page);
				default:
					return A3($author$project$Audit$PerformAuditPage$noChange, environment, repository, page);
			}
		} else {
			return A3($author$project$Audit$PerformAuditPage$noChange, environment, repository, page);
		}
	});
var $author$project$Audit$PerformAuditPage$update = function (msg) {
	switch (msg.$) {
		case 0:
			var record = msg.a;
			return $author$project$Audit$PerformAuditPage$gotRecord(record);
		case 1:
			var command = msg.a;
			return $author$project$Audit$PerformAuditPage$gotCommand(command);
		case 2:
			var organisationUnit = msg.a;
			return $author$project$Audit$PerformAuditPage$userClickedOrganisationUnitTile(organisationUnit);
		case 3:
			var id = msg.a;
			return $author$project$Audit$PerformAuditPage$gotCollapseCheckpointGroup(id);
		case 4:
			var id = msg.a;
			return $author$project$Audit$PerformAuditPage$gotExpandCheckpointGroup(id);
		case 5:
			return $author$project$Audit$PerformAuditPage$userClickedCloseNotFoundModal;
		case 6:
			var audit = msg.a;
			return $author$project$Audit$PerformAuditPage$userClickedEditAuditIcon(audit);
		case 7:
			var dialogMsg = msg.a;
			return $author$project$Audit$PerformAuditPage$gotEditAuditDialogMsg(dialogMsg);
		case 8:
			return $author$project$Audit$PerformAuditPage$userClickedCompleteAudit;
		case 9:
			var modalMsg = msg.a;
			return $author$project$Audit$PerformAuditPage$gotCompleteAuditMsg(modalMsg);
		case 10:
			var checkpoint = msg.a;
			return $author$project$Audit$PerformAuditPage$userClickedOpenRecordModal(checkpoint);
		case 11:
			var checkpoint = msg.a;
			var now = msg.b;
			return A2($author$project$Audit$PerformAuditPage$openRecordModal, checkpoint, now);
		case 12:
			var modalMsg = msg.a;
			return $author$project$Audit$PerformAuditPage$gotRecordModalMsg(modalMsg);
		case 13:
			var checkpoint = msg.a;
			var option = msg.b;
			var bool = msg.c;
			return A3($author$project$Audit$PerformAuditPage$userSelectedOption, checkpoint, option, bool);
		case 14:
			var checkpoint = msg.a;
			var bool = msg.b;
			return A2($author$project$Audit$PerformAuditPage$userEnteredCheckboxValue, checkpoint, bool);
		case 15:
			return $author$project$Audit$PerformAuditPage$focusedInput;
		case 16:
			return $author$project$Audit$PerformAuditPage$closeMeasureDialog;
		case 17:
			var measureData = msg.a;
			return $author$project$Audit$PerformAuditPage$userClickedAddMeasure(measureData);
		case 18:
			var dialogMsg = msg.a;
			return $author$project$Audit$PerformAuditPage$gotMeasureCreateDialogMsg(dialogMsg);
		case 19:
			var measure = msg.a;
			return $author$project$Audit$PerformAuditPage$userClickedEditMeasure(measure);
		default:
			var dialogMsg = msg.a;
			return $author$project$Audit$PerformAuditPage$gotMeasureEditDialogMsg(dialogMsg);
	}
};
var $author$project$UI$Page$appendContentList = F2(
	function (contentList, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				ai: A3($elm$core$List$foldl, $elm$core$List$cons, config.ai, contentList)
			});
	});
var $author$project$Translations$PerformAudit$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'performAudit.header');
};
var $author$project$Audit$PerformAuditPage$UserClickedCloseNotFoundModal = {$: 5};
var $author$project$Translations$PerformAudit$notFoundHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'performAudit.notFoundHeader');
};
var $author$project$Translations$PerformAudit$backToMainMenu = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'performAudit.backToMainMenu');
};
var $author$project$Audit$PerformAuditPage$viewCloseAuditNotFoundButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Audit$PerformAuditPage$UserClickedCloseNotFoundModal,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$PerformAudit$backToMainMenu(translations))));
};
var $author$project$Audit$PerformAuditPage$viewFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Audit$PerformAuditPage$viewCloseAuditNotFoundButton(translations)
			]));
};
var $author$project$Translations$PerformAudit$notFoundText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'performAudit.notFoundText');
};
var $author$project$Audit$PerformAuditPage$viewNotFoundContent = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$PerformAudit$notFoundText(translations))
			]));
};
var $author$project$Audit$PerformAuditPage$viewAuditNotFoundDialog = function (translations) {
	return $author$project$UI$Modal$view(
		A2(
			$author$project$UI$Modal$appendFooter,
			$author$project$Audit$PerformAuditPage$viewFooter(translations),
			A2(
				$author$project$UI$Modal$appendContent,
				$author$project$Audit$PerformAuditPage$viewNotFoundContent(translations),
				A2(
					$author$project$UI$Modal$modal,
					$author$project$Translations$PerformAudit$notFoundHeader(translations),
					$author$project$Audit$PerformAuditPage$UserClickedCloseNotFoundModal))));
};
var $author$project$Audit$PerformAuditPage$GotCompleteAuditMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Audit$CompleteAudit$UserClickedCloseDialog = 0;
var $author$project$Translations$PerformAudit$completeAudit = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'performAudit.completeAudit');
};
var $author$project$Translations$PerformAudit$confirmText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'performAudit.confirmText');
};
var $author$project$Audit$CompleteAudit$viewContent = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$PerformAudit$confirmText(translations))
			]));
};
var $author$project$Audit$CompleteAudit$UserClickedCancelButton = 1;
var $author$project$Audit$CompleteAudit$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			1,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$Audit$CompleteAudit$UserClickedCompleteButton = 2;
var $author$project$Audit$CompleteAudit$viewCompleteButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			2,
			$author$project$UI$Button$green(
				$author$project$Translations$Buttons$complete(translations))));
};
var $author$project$Audit$CompleteAudit$viewFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Audit$CompleteAudit$viewCancelButton(translations),
				$author$project$Audit$CompleteAudit$viewCompleteButton(translations)
			]));
};
var $author$project$Audit$CompleteAudit$viewDialog = function (translations) {
	return $author$project$UI$Modal$view(
		A2(
			$author$project$UI$Modal$appendFooter,
			$author$project$Audit$CompleteAudit$viewFooter(translations),
			A2(
				$author$project$UI$Modal$appendContent,
				$author$project$Audit$CompleteAudit$viewContent(translations),
				A2(
					$author$project$UI$Modal$modal,
					$author$project$Translations$PerformAudit$completeAudit(translations),
					0))));
};
var $author$project$Audit$CompleteAudit$view = F2(
	function (translations, dialog) {
		if (!dialog) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			return A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Audit$CompleteAudit$viewDialog, translations);
		}
	});
var $author$project$Audit$PerformAuditPage$viewCompleteModal = function (translations) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Audit$CompleteAudit$view(translations),
		$rtfeldman$elm_css$Html$Styled$map($author$project$Audit$PerformAuditPage$GotCompleteAuditMsg));
};
var $author$project$Audit$PerformAuditPage$UserClickedOrganisationUnitTile = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audit$PerformAuditPage$addBewOrganisationUnitId = F2(
	function (group, idList) {
		return A2($elm$core$List$member, group.km, idList) ? idList : A2($elm$core$List$cons, group.km, idList);
	});
var $author$project$Translations$PerformAudit$noOrganisationUnitErr = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'performAudit.noOrganisationUnitErr');
};
var $author$project$Audit$PerformAuditPage$pileMarkerFunction = F2(
	function (audit, organisationUnit) {
		var groupIdList = A2(
			$elm$core$List$map,
			function (group) {
				return group.cC;
			},
			A2(
				$elm$core$List$filter,
				function (group) {
					return _Utils_eq(group.km, organisationUnit.km);
				},
				audit.ff.gt));
		var numberOfUnrecorded = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$author$project$Audit$PerformAuditPage$isUnrecorded(audit),
				A2(
					$elm$core$List$filter,
					function (cp) {
						var _v0 = cp.fg;
						if (_v0.$ === 9) {
							return false;
						} else {
							return true;
						}
					},
					A2(
						$elm$core$List$filter,
						function (cp) {
							return A2($elm$core$List$member, cp.cC, groupIdList);
						},
						audit.ff.i6))));
		var color = (!numberOfUnrecorded) ? $author$project$UI$Style$Theme$green : $author$project$UI$Style$Theme$red;
		return _Utils_Tuple2(numberOfUnrecorded, color);
	});
var $author$project$UI$OUTiles$withDeletedOrganisationUnits = F2(
	function (bool, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{gc: bool});
	});
var $author$project$Audit$PerformAuditPage$renderOrganisationUnitOverview = F3(
	function (organisationUnitIds, audit, repository) {
		return _List_fromArray(
			[
				A2(
				$author$project$UI$OUTiles$view,
				repository,
				A2(
					$author$project$UI$OUTiles$withDeletedOrganisationUnits,
					true,
					A2(
						$author$project$UI$OUTiles$withPileFunction,
						$elm$core$Maybe$Just(
							$author$project$Audit$PerformAuditPage$pileMarkerFunction(audit)),
						A2(
							$author$project$UI$OUTiles$withOnClickMsg,
							$elm$core$Maybe$Just($author$project$Audit$PerformAuditPage$UserClickedOrganisationUnitTile),
							$author$project$UI$OUTiles$ouTilesGrid(organisationUnitIds)))))
			]);
	});
var $author$project$Translations$PerformAudit$loadCheckpointGroupsError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'performAudit.loadCheckpointGroupsError');
};
var $author$project$UI$OUTiles$Row = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$OUTiles$ouTilesRow = F2(
	function (selectedOrganisationUnit, organisationUnitIds) {
		return {
			g3: $elm$core$Maybe$Nothing,
			fS: organisationUnitIds,
			fW: $elm$core$Maybe$Nothing,
			e4: $author$project$UI$OUTiles$Row(selectedOrganisationUnit),
			gc: false,
			gd: false
		};
	});
var $author$project$Audit$PerformAuditPage$sortCheckpointGroups = function (checkpointGroups) {
	var addPrevGroup = F2(
		function (prevGroupId, acc) {
			var _v2 = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (group) {
						return _Utils_eq(group.cC, prevGroupId);
					},
					checkpointGroups));
			if (_v2.$ === 1) {
				return acc;
			} else {
				var prevGroup = _v2.a;
				return A2(
					checkPreviousGroup,
					prevGroup.kw,
					A2($elm$core$List$cons, prevGroup, acc));
			}
		});
	var checkPreviousGroup = F2(
		function (maybePreviousId, acc) {
			if (maybePreviousId.$ === 1) {
				return acc;
			} else {
				var prevGroupId = maybePreviousId.a;
				return A2(addPrevGroup, prevGroupId, acc);
			}
		});
	var _v0 = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (group) {
				return $author$project$Utils$Maybe$isNothing(group.kc);
			},
			checkpointGroups));
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var lastGroup = _v0.a;
		return A2(
			checkPreviousGroup,
			lastGroup.kw,
			_List_fromArray(
				[lastGroup]));
	}
};
var $author$project$Audit$PerformAuditPage$CollapseCheckpointGroup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audit$PerformAuditPage$ExpandCheckpointGroup = function (a) {
	return {$: 4, a: a};
};
var $author$project$Audit$PerformAuditPage$viewBar = F2(
	function (checkpointGroup, _v0) {
		var model = _v0;
		var msg = A2($elm$core$List$member, checkpointGroup.cC, model.bk) ? $author$project$Audit$PerformAuditPage$ExpandCheckpointGroup(checkpointGroup.cC) : $author$project$Audit$PerformAuditPage$CollapseCheckpointGroup(checkpointGroup.cC);
		var margin = (A2($elm$core$List$member, checkpointGroup.cC, model.bk) || $author$project$Utils$Maybe$isNothing(checkpointGroup.jC)) ? $rtfeldman$elm_css$Css$rem(1) : $rtfeldman$elm_css$Css$rem(0);
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$marginBottom(margin),
				A2(
					$author$project$UI$Bar$withOnBarClick,
					$elm$core$Maybe$Just(msg),
					$author$project$UI$Bar$bar(checkpointGroup.k8))));
	});
var $author$project$Audit$PerformAuditPage$UserClickedOpenRecordModal = function (a) {
	return {$: 10, a: a};
};
var $author$project$Audit$PerformAuditPage$UserEnteredCheckboxValue = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Audit$PerformAuditPage$UserSelectOption = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$Config = $elm$core$Basics$identity;
var $author$project$CheckpointData$Checkpoint$CheckpointRow$checkpointRow = function (checkpoint) {
	return {fa: $elm$core$Maybe$Nothing, gr: $elm$core$Maybe$Nothing, bi: checkpoint, g3: $elm$core$Maybe$Nothing, ct: $elm$core$Maybe$Nothing, he: $elm$core$Maybe$Nothing};
};
var $author$project$CheckpointData$Checkpoint$CheckpointRow$addOnClickMsg = F3(
	function (msg, type_, attributes) {
		if (!msg.$) {
			var msg_ = msg.a;
			switch (type_.$) {
				case 0:
					return A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg_),
						attributes);
				case 1:
					return A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg_),
						attributes);
				case 2:
					return A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg_),
						attributes);
				case 3:
					return attributes;
				case 4:
					return A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg_),
						attributes);
				case 5:
					return attributes;
				case 6:
					return attributes;
				case 7:
					return A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg_),
						attributes);
				case 8:
					return A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg_),
						attributes);
				case 9:
					return attributes;
				case 10:
					return A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg_),
						attributes);
				default:
					return A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Events$onClick(msg_),
						attributes);
			}
		} else {
			return attributes;
		}
	});
var $rtfeldman$elm_css$Css$nthChild = function (str) {
	return $rtfeldman$elm_css$Css$pseudoClass('nth-child(' + (str + ')'));
};
var $author$project$Translations$Record$parsingError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'record.parsingError');
};
var $author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan = F3(
	function (styles, color_, string) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor(color_))
							]),
						styles))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(string)
				]));
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$addMsgToIcon = F3(
	function (_v0, value, iconConfig) {
		var config_ = _v0;
		var _v1 = config_.gr;
		if (!_v1.$) {
			var msg = _v1.a;
			return A2(
				$author$project$UI$Icon$withOnClick,
				A2(msg, config_.bi, value),
				iconConfig);
		} else {
			return iconConfig;
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewChecked = F2(
	function (maybeBool, config) {
		var color = A2(
			$elm$core$Maybe$withDefault,
			$author$project$UI$Style$Theme$grey,
			A2(
				$elm$core$Maybe$map,
				function (bool) {
					return bool ? $author$project$UI$Style$Theme$green : $author$project$UI$Style$Theme$grey;
				},
				maybeBool));
		return $author$project$UI$Icon$view(
			A3(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$addMsgToIcon,
				config,
				true,
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3)),
					A2(
						$author$project$UI$Icon$withForegroundColor,
						color,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedCircle)))));
	});
var $author$project$UI$Icons$uncheckedCircle = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M32 58.464c-14.594 0-26.463-11.871-26.463-26.465C5.537 17.407 17.406 5.536 32 5.536c14.594 0 26.463 11.871 26.463 26.463 0 14.594-11.869 26.465-26.463 26.465m21.915-48.378C48.055 4.239 40.278 1 32 1c-8.28 0-16.068 3.226-21.915 9.086-5.86 5.847-9.084 13.633-9.084 21.913 0 8.28 3.224 16.068 9.084 21.917C15.932 59.774 23.72 63 32 63c8.278 0 16.066-3.226 21.915-9.084 5.845-5.862 9.084-13.637 9.084-21.917 0-8.28-3.224-16.066-9.084-21.913')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M24.16 48.628a2.214 2.214 0 01-1.564-.647l-6.575-6.576a2.21 2.21 0 010-3.128L22.297 32l-6.276-6.275a2.21 2.21 0 010-3.128l6.575-6.578c.83-.83 2.299-.831 3.128 0L32 22.294l6.275-6.273a2.213 2.213 0 013.128-.002l6.576 6.576a2.212 2.212 0 11-3.127 3.13l-5.013-5.012-6.275 6.275a2.21 2.21 0 01-3.128 0L24.16 20.71l-3.447 3.45 6.275 6.274a2.213 2.213 0 010 3.129l-6.275 6.276 3.447 3.448 6.277-6.277a2.213 2.213 0 013.128.002l6.275 6.274 3.448-3.45-6.275-6.273a2.213 2.213 0 010-3.13l2.762-2.762a2.213 2.213 0 013.129 3.129L41.704 32l6.276 6.275a2.211 2.211 0 010 3.128l-6.576 6.578a2.213 2.213 0 01-3.128 0L32 41.705l-6.277 6.276a2.212 2.212 0 01-1.564.647')
						]),
					_List_Nil)
				]));
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewUnchecked = F2(
	function (maybeBool, config) {
		var color = A2(
			$elm$core$Maybe$withDefault,
			$author$project$UI$Style$Theme$grey,
			A2(
				$elm$core$Maybe$map,
				function (bool) {
					return (!bool) ? $author$project$UI$Style$Theme$red : $author$project$UI$Style$Theme$grey;
				},
				maybeBool));
		return $author$project$UI$Icon$view(
			A3(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$addMsgToIcon,
				config,
				false,
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3)),
					A2(
						$author$project$UI$Icon$withForegroundColor,
						color,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$uncheckedCircle)))));
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewCheckbox = F2(
	function (translations, config) {
		var config_ = config;
		var _v0 = config_.ct;
		if (!_v0.$) {
			var record = _v0.a;
			var _v1 = record.ll;
			if (_v1.$ === 3) {
				var bool = _v1.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$CheckpointData$Checkpoint$CheckpointRow$viewChecked,
							$elm$core$Maybe$Just(bool),
							config),
							A2(
							$author$project$CheckpointData$Checkpoint$CheckpointRow$viewUnchecked,
							$elm$core$Maybe$Just(bool),
							config)
						]));
			} else {
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$red,
					$author$project$Translations$Record$parsingError(translations));
			}
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewChecked, $elm$core$Maybe$Nothing, config),
						A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewUnchecked, $elm$core$Maybe$Nothing, config)
					]));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewDate = F2(
	function (translations, _v0) {
		var config_ = _v0;
		var _v1 = config_.ct;
		if (!_v1.$) {
			var record = _v1.a;
			var _v2 = record.ll;
			if (_v2.$ === 7) {
				var date = _v2.a;
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$black,
					$author$project$Date_Time$NaiveDate$format(date));
			} else {
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$red,
					$author$project$Translations$Record$parsingError(translations));
			}
		} else {
			return A3(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
				_List_Nil,
				$author$project$UI$Style$Theme$grey,
				$author$project$Translations$CheckpointTypes$date(translations));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewFloat = F3(
	function (translations, _v0, floatModel) {
		var config_ = _v0;
		var _v1 = config_.ct;
		if (!_v1.$) {
			var record = _v1.a;
			var _v2 = record.ll;
			if (!_v2.$) {
				var value = _v2.a;
				var trimmedFloat = A3(
					$elm$core$String$replace,
					'.',
					',',
					A2($myrho$elm_round$Round$round, floatModel.hJ, value));
				return A3($author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan, _List_Nil, $author$project$UI$Style$Theme$black, trimmedFloat);
			} else {
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$red,
					$author$project$Translations$Record$parsingError(translations));
			}
		} else {
			return A3(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
				_List_Nil,
				$author$project$UI$Style$Theme$grey,
				$author$project$Translations$CheckpointTypes$number(translations));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewImageContent = F3(
	function (record, image, alternativeFileLookup) {
		if (!alternativeFileLookup.$) {
			var lookup = alternativeFileLookup.a;
			var content = A2(
				$elm$core$Maybe$withDefault,
				$rtfeldman$elm_css$Html$Styled$text('loading file'),
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						var url = _v2.b;
						return A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$maxWidth(
											$rtfeldman$elm_css$Css$rem(13))
										])),
									$rtfeldman$elm_css$Html$Styled$Attributes$src(url)
								]),
							_List_Nil);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (_v1) {
								var recordId = _v1.a;
								return _Utils_eq(recordId, record.bK);
							},
							lookup))));
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[content]))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
							]))
					]),
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Html$Styled$node,
						'aw-image',
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
								'filename',
								$author$project$File$Filename$toIdString(image))
							]),
						_List_Nil)
					]));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewImage = F2(
	function (translations, _v0) {
		var config_ = _v0;
		var _v1 = config_.ct;
		if (!_v1.$) {
			var record = _v1.a;
			var _v2 = record.ll;
			if (_v2.$ === 8) {
				var image = _v2.a;
				return A3($author$project$CheckpointData$Checkpoint$CheckpointRow$viewImageContent, record, image, config_.fa);
			} else {
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$red,
					$author$project$Translations$Record$parsingError(translations));
			}
		} else {
			return A3(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
				_List_Nil,
				$author$project$UI$Style$Theme$grey,
				$author$project$Translations$CheckpointTypes$image(translations));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewIndividualData = F3(
	function (translations, _v0, individualDataModel) {
		var config_ = _v0;
		return $rtfeldman$elm_css$Html$Styled$text('*** ToDo IndividualData');
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewInfo = F2(
	function (translations, infoModel) {
		return $elm$core$String$isEmpty(infoModel.hl) ? A3(
			$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
			_List_Nil,
			$author$project$UI$Style$Theme$grey,
			$author$project$Translations$CheckpointTypes$info(translations)) : A3($author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan, _List_Nil, $author$project$UI$Style$Theme$black, infoModel.hl);
	});
var $rtfeldman$elm_css$Css$flexWrap = $rtfeldman$elm_css$Css$prop1('flex-wrap');
var $rtfeldman$elm_css$Css$start = $rtfeldman$elm_css$Css$prop1('start');
var $author$project$CheckpointData$Checkpoint$CheckpointRow$addMsgToOption = F3(
	function (_v0, option, checkboxConfig) {
		var config_ = _v0;
		var _v1 = config_.he;
		if (!_v1.$) {
			var msg = _v1.a;
			return A2(
				$author$project$UI$Checkbox$withOnCheck,
				A2(msg, config_.bi, option),
				checkboxConfig);
		} else {
			return A2($author$project$UI$Checkbox$disabled, true, checkboxConfig);
		}
	});
var $author$project$UI$Checkbox$labeled = function (label) {
	return $author$project$UI$Checkbox$Labeled(
		{cZ: false, cg: false, h2: label, cp: $elm$core$Maybe$Nothing, by: _List_Nil});
};
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewOption = F3(
	function (selectedOptions, config, option) {
		var isSelected = A2($elm$core$List$member, option, selectedOptions);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginRight(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Checkbox$view(
					A3(
						$author$project$CheckpointData$Checkpoint$CheckpointRow$addMsgToOption,
						config,
						option,
						A2(
							$author$project$UI$Checkbox$checked,
							isSelected,
							$author$project$UI$Checkbox$labeled(option.hl))))
				]));
	});
var $rtfeldman$elm_css$Css$wrap = {eD: 0, ft: 0, ll: 'wrap'};
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewMultiSelect = F3(
	function (translations, config, multiSelectModel) {
		var config_ = config;
		var cssList = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
				$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$start),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$rem(1))
			]);
		var _v0 = config_.ct;
		if (!_v0.$) {
			var record = _v0.a;
			var _v1 = record.ll;
			if (_v1.$ === 6) {
				var options = _v1.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(cssList)
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewOption, options, config),
						multiSelectModel.fR));
			} else {
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$red,
					$author$project$Translations$Record$parsingError(translations));
			}
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(cssList)
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewOption, _List_Nil, config),
					multiSelectModel.fR));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewSelect = F3(
	function (translations, config, selectModel) {
		var config_ = config;
		var cssList = _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
				$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$start),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$rem(1))
			]);
		var _v0 = config_.ct;
		if (!_v0.$) {
			var record = _v0.a;
			var _v1 = record.ll;
			if (_v1.$ === 5) {
				var value = _v1.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(cssList)
						]),
					A2(
						$elm$core$List$map,
						A2(
							$author$project$CheckpointData$Checkpoint$CheckpointRow$viewOption,
							_List_fromArray(
								[value]),
							config),
						selectModel.fR));
			} else {
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$red,
					$author$project$Translations$Record$parsingError(translations));
			}
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(cssList)
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewOption, _List_Nil, config),
					selectModel.fR));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewSignature = F2(
	function (translations, _v0) {
		var config_ = _v0;
		var _v1 = config_.ct;
		if (!_v1.$) {
			var record = _v1.a;
			var _v2 = record.ll;
			if (_v2.$ === 9) {
				var signature = _v2.a;
				return A3($author$project$CheckpointData$Checkpoint$CheckpointRow$viewImageContent, record, signature, config_.fa);
			} else {
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$red,
					$author$project$Translations$Record$parsingError(translations));
			}
		} else {
			return A3(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
				_List_Nil,
				$author$project$UI$Style$Theme$grey,
				$author$project$Translations$CheckpointTypes$signature(translations));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewTextMemo = F2(
	function (translations, _v0) {
		var config_ = _v0;
		var _v1 = config_.ct;
		if (!_v1.$) {
			var record = _v1.a;
			var _v2 = record.ll;
			if (_v2.$ === 2) {
				var value = _v2.a;
				return A3($author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan, _List_Nil, $author$project$UI$Style$Theme$black, value);
			} else {
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$red,
					$author$project$Translations$Record$parsingError(translations));
			}
		} else {
			return A3(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
				_List_Nil,
				$author$project$UI$Style$Theme$grey,
				$author$project$Translations$CheckpointTypes$textMemo(translations));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewTextRow = F2(
	function (translations, _v0) {
		var config_ = _v0;
		var _v1 = config_.ct;
		if (!_v1.$) {
			var record = _v1.a;
			var _v2 = record.ll;
			if (_v2.$ === 1) {
				var value = _v2.a;
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap)
						]),
					$author$project$UI$Style$Theme$black,
					value);
			} else {
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$red,
					$author$project$Translations$Record$parsingError(translations));
			}
		} else {
			return A3(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
				_List_Nil,
				$author$project$UI$Style$Theme$grey,
				$author$project$Translations$CheckpointTypes$textRow(translations));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewTime = F2(
	function (translations, _v0) {
		var config_ = _v0;
		var _v1 = config_.ct;
		if (!_v1.$) {
			var record = _v1.a;
			var _v2 = record.ll;
			if (_v2.$ === 10) {
				var time = _v2.a;
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$black,
					$author$project$Date_Time$NaiveTime$toString(time));
			} else {
				return A3(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
					_List_Nil,
					$author$project$UI$Style$Theme$red,
					$author$project$Translations$Record$parsingError(translations));
			}
		} else {
			return A3(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$renderSpan,
				_List_Nil,
				$author$project$UI$Style$Theme$grey,
				$author$project$Translations$CheckpointTypes$time(translations));
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewType = F3(
	function (translations, config, type_) {
		switch (type_.$) {
			case 0:
				var numberModel = type_.a;
				return A3($author$project$CheckpointData$Checkpoint$CheckpointRow$viewFloat, translations, config, numberModel);
			case 1:
				return A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewTextRow, translations, config);
			case 2:
				return A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewTextMemo, translations, config);
			case 3:
				return A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewCheckbox, translations, config);
			case 4:
				var individualDataModel = type_.a;
				return A3($author$project$CheckpointData$Checkpoint$CheckpointRow$viewIndividualData, translations, config, individualDataModel);
			case 5:
				var selectModel = type_.a;
				return A3($author$project$CheckpointData$Checkpoint$CheckpointRow$viewSelect, translations, config, selectModel);
			case 6:
				var multiSelectModel = type_.a;
				return A3($author$project$CheckpointData$Checkpoint$CheckpointRow$viewMultiSelect, translations, config, multiSelectModel);
			case 7:
				return A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewDate, translations, config);
			case 8:
				return A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewImage, translations, config);
			case 9:
				var infoModel = type_.a;
				return A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewInfo, translations, infoModel);
			case 10:
				return A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewSignature, translations, config);
			default:
				return A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewTime, translations, config);
		}
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewCheckpointContent = F3(
	function (translations, config, type_) {
		var additionalTypeStyle = function () {
			if (type_.$ === 9) {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(1))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto),
								$rtfeldman$elm_css$Css$maxHeight(
								$rtfeldman$elm_css$Css$rem(12)),
								$rtfeldman$elm_css$Css$marginRight(
								$rtfeldman$elm_css$Css$rem(1))
							]),
						additionalTypeStyle))
				]),
			_List_fromArray(
				[
					A3($author$project$CheckpointData$Checkpoint$CheckpointRow$viewType, translations, config, type_)
				]));
	});
var $rtfeldman$elm_css$Css$flexBasis = $rtfeldman$elm_css$Css$prop1('flex-basis');
var $author$project$CheckpointData$Checkpoint$CheckpointRow$viewCheckpointTitle = F2(
	function (translations, _v0) {
		var config_ = _v0;
		var subLabel = $elm$core$String$isEmpty(config_.bi.aY) ? A2($author$project$CheckpointData$Checkpoint$CheckpointType$toText, translations, config_.bi.fg) : (A2($author$project$CheckpointData$Checkpoint$CheckpointType$toText, translations, config_.bi.fg) + (' | ' + config_.bi.aY));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$flexShrink(
							$rtfeldman$elm_css$Css$int(0)),
							$rtfeldman$elm_css$Css$flexBasis(
							$rtfeldman$elm_css$Css$pct(50))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(700)),
									$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(config_.bi.k8)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(500)),
									$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(subLabel)
						]))
				]));
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$view = F2(
	function (translations, config) {
		var config_ = config;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A3(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$addOnClickMsg,
				config_.g3,
				config_.bi.fg,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$minHeight(
								$rtfeldman$elm_css$Css$rem(4)),
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
								A2(
								$rtfeldman$elm_css$Css$nthChild,
								'even',
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$backgroundColor(
										$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
									])),
								$rtfeldman$elm_css$Css$lastChild(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$rem(1))
									]))
							]))
					])),
			_List_fromArray(
				[
					A2($author$project$CheckpointData$Checkpoint$CheckpointRow$viewCheckpointTitle, translations, config),
					A3($author$project$CheckpointData$Checkpoint$CheckpointRow$viewCheckpointContent, translations, config, config_.bi.fg)
				]));
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$withCheckBoxMsg = F2(
	function (msg, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{gr: msg});
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$withOnClickMsg = F2(
	function (msg, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{g3: msg});
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$withRecord = F2(
	function (record, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{ct: record});
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$withSelectMsg = F2(
	function (msg, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{he: msg});
	});
var $author$project$Audit$PerformAuditPage$viewCheckpoint = F3(
	function (translations, records, checkpoint) {
		var record = A2($author$project$Audit$Record$Records$getRecordFor, checkpoint.i5, records);
		return A2(
			$author$project$CheckpointData$Checkpoint$CheckpointRow$view,
			translations,
			A2(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$withSelectMsg,
				$elm$core$Maybe$Just($author$project$Audit$PerformAuditPage$UserSelectOption),
				A2(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$withCheckBoxMsg,
					$elm$core$Maybe$Just($author$project$Audit$PerformAuditPage$UserEnteredCheckboxValue),
					A2(
						$author$project$CheckpointData$Checkpoint$CheckpointRow$withOnClickMsg,
						$elm$core$Maybe$Just(
							$author$project$Audit$PerformAuditPage$UserClickedOpenRecordModal(checkpoint)),
						A2(
							$author$project$CheckpointData$Checkpoint$CheckpointRow$withRecord,
							record,
							$author$project$CheckpointData$Checkpoint$CheckpointRow$checkpointRow(checkpoint))))));
	});
var $author$project$Audit$PerformAuditPage$viewCheckpoints = F3(
	function (translations, checkpointGroup, audit) {
		var checkpointList = A2(
			$elm$core$List$filter,
			function (checkpoint) {
				return _Utils_eq(checkpoint.cC, checkpointGroup.cC);
			},
			audit.ff.i6);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				A2($author$project$Audit$PerformAuditPage$viewCheckpoint, translations, audit.io),
				checkpointList));
	});
var $author$project$Audit$PerformAuditPage$viewCheckpointGroup = F4(
	function (translations, page, audit, checkpointGroup) {
		var model = page;
		var subContent = A2($elm$core$List$member, checkpointGroup.cC, model.bk) ? $rtfeldman$elm_css$Html$Styled$text('') : A3($author$project$Audit$PerformAuditPage$viewCheckpoints, translations, checkpointGroup, audit);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Audit$PerformAuditPage$viewBar, checkpointGroup, page),
					subContent
				]));
	});
var $author$project$Audit$PerformAuditPage$renderRecordContent = F7(
	function (translations, page, repository, audit, organisationUnitIds, selectedOrganisationUnit, onClickTileMsg) {
		var unsortedCheckpointGroups = A2(
			$elm$core$List$filter,
			function (group) {
				return _Utils_eq(selectedOrganisationUnit, group.km);
			},
			audit.ff.gt);
		var sortedCheckpointGroups = $author$project$Audit$PerformAuditPage$sortCheckpointGroups(unsortedCheckpointGroups);
		var checkpointGroups = _Utils_eq(
			$elm$core$List$length(unsortedCheckpointGroups),
			$elm$core$List$length(sortedCheckpointGroups)) ? sortedCheckpointGroups : unsortedCheckpointGroups;
		var content = $elm$core$List$isEmpty(checkpointGroups) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$PerformAudit$loadCheckpointGroupsError(translations))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			A2(
				$elm$core$List$map,
				A3($author$project$Audit$PerformAuditPage$viewCheckpointGroup, translations, page, audit),
				checkpointGroups));
		return _List_fromArray(
			[
				A2(
				$author$project$UI$OUTiles$view,
				repository,
				A2(
					$author$project$UI$OUTiles$withDeletedOrganisationUnits,
					true,
					A2(
						$author$project$UI$OUTiles$withPileFunction,
						$elm$core$Maybe$Just(
							$author$project$Audit$PerformAuditPage$pileMarkerFunction(audit)),
						A2(
							$author$project$UI$OUTiles$withOnClickMsg,
							onClickTileMsg,
							A2($author$project$UI$OUTiles$ouTilesRow, selectedOrganisationUnit, organisationUnitIds))))),
				content
			]);
	});
var $author$project$Audit$PerformAuditPage$viewContent = F4(
	function (translations, page, repository, audit) {
		var model = page;
		var organisationUnitIds = A3($elm$core$List$foldl, $author$project$Audit$PerformAuditPage$addBewOrganisationUnitId, _List_Nil, audit.ff.gt);
		if (!organisationUnitIds.b) {
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$PerformAudit$noOrganisationUnitErr(translations))
				]);
		} else {
			if (!organisationUnitIds.b.b) {
				var singleOrganisationUnit = organisationUnitIds.a;
				return A7($author$project$Audit$PerformAuditPage$renderRecordContent, translations, page, repository, audit, organisationUnitIds, singleOrganisationUnit, $elm$core$Maybe$Nothing);
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					A3($author$project$Audit$PerformAuditPage$renderOrganisationUnitOverview, organisationUnitIds, audit, repository),
					A2(
						$elm$core$Maybe$map,
						function (selectedOrganisationUnit) {
							return A7(
								$author$project$Audit$PerformAuditPage$renderRecordContent,
								translations,
								page,
								repository,
								audit,
								organisationUnitIds,
								selectedOrganisationUnit,
								$elm$core$Maybe$Just($author$project$Audit$PerformAuditPage$UserClickedOrganisationUnitTile));
						},
						model.ee));
			}
		}
	});
var $author$project$Audit$PerformAuditPage$viewEditAuditDialog = F2(
	function (environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Audit$EditDialog$view, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Audit$PerformAuditPage$GotEditAuditDialogMsg));
	});
var $author$project$Audit$PerformAuditPage$viewMeasureCreateDialog = F2(
	function (environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Measure$CreateDialog$view, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Audit$PerformAuditPage$GotMeasureCreateDialogMsg));
	});
var $author$project$Audit$PerformAuditPage$CloseMeasureDialog = {$: 16};
var $author$project$Measure$Dict$toList = $turboMaCk$any_dict$Dict$Any$values;
var $author$project$Audit$PerformAuditPage$UserClickedAddMeasure = function (a) {
	return {$: 17, a: a};
};
var $author$project$Translations$PerformAudit$createMeasure = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'performAudit.createMeasure');
};
var $author$project$Audit$PerformAuditPage$viewCreateBar = F2(
	function (translations, measureData) {
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$Bar$withRightIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$add),
				A2(
					$author$project$UI$Bar$withOnBarClick,
					$elm$core$Maybe$Just(
						$author$project$Audit$PerformAuditPage$UserClickedAddMeasure(measureData)),
					$author$project$UI$Bar$bar(
						$author$project$Translations$PerformAudit$createMeasure(translations)))));
	});
var $author$project$Audit$PerformAuditPage$UserClickedEditMeasure = function (a) {
	return {$: 19, a: a};
};
var $author$project$Audit$PerformAuditPage$viewEditMeasureIcon = $author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle);
var $author$project$Audit$PerformAuditPage$viewMeasureRow = F3(
	function (viewType, timeZone, measure) {
		var subLabel = function () {
			var _v0 = measure.hI;
			if (!_v0.$) {
				var deadlineTimestamp = _v0.a;
				var deadlineTime = $author$project$Date_Time$NaiveTime$format(
					A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, deadlineTimestamp));
				var deadlineDate = $author$project$Date_Time$NaiveDate$format(
					A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, deadlineTimestamp));
				return $elm$core$String$isEmpty(measure.aY) ? (deadlineDate + (' ' + (deadlineTime + ' Uhr'))) : (deadlineDate + (' ' + (deadlineTime + (' Uhr | ' + measure.aY))));
			} else {
				return measure.aY;
			}
		}();
		return A2(
			$author$project$UI$Table$Row$withRightIcon,
			$author$project$Audit$PerformAuditPage$viewEditMeasureIcon,
			A2(
				$author$project$UI$Table$Row$withOnClick,
				$author$project$Audit$PerformAuditPage$UserClickedEditMeasure(measure),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					subLabel,
					A2(
						$author$project$UI$Table$Row$withId,
						measure.fw,
						A3($author$project$UI$Table$Row$row, viewType, measure.k8, measure)))));
	});
var $author$project$Audit$PerformAuditPage$viewMeasureDialogContent = F4(
	function (translations, environment, repository, measureData) {
		var recordMeasures = A2(
			$elm$core$List$filter,
			function (measure) {
				var _v0 = measure.h6;
				if (_v0.$ === 1) {
					var data = _v0.a;
					return _Utils_eq(data.bK, measureData.ct.bK);
				} else {
					return false;
				}
			},
			$author$project$Measure$Dict$toList(
				$author$project$Environments$Repository$measures(repository)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Audit$PerformAuditPage$viewCreateBar, translations, measureData),
					$author$project$UI$Table$view(
					A2(
						$author$project$UI$Table$fromList,
						A2(
							$author$project$Audit$PerformAuditPage$viewMeasureRow,
							$author$project$Environments$Environment$getViewType(environment),
							$author$project$Environments$Environment$timeZone(environment)),
						recordMeasures))
				]));
	});
var $author$project$Audit$PerformAuditPage$viewCloseMeasureDialogButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Audit$PerformAuditPage$CloseMeasureDialog,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$Audit$PerformAuditPage$viewMeasureDialogFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Audit$PerformAuditPage$viewCloseMeasureDialogButton(translations)
			]));
};
var $author$project$Audit$PerformAuditPage$viewMeasureDialog = F4(
	function (translations, environment, repository, measureDialog) {
		if (!measureDialog.$) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var data = measureDialog.a;
			return $author$project$UI$Dialog$view(
				A2(
					$author$project$UI$Dialog$appendStyle,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(60))
						]),
					A2(
						$author$project$UI$Dialog$appendFooter,
						$author$project$Audit$PerformAuditPage$viewMeasureDialogFooter(translations),
						A2(
							$author$project$UI$Dialog$appendContent,
							A4($author$project$Audit$PerformAuditPage$viewMeasureDialogContent, translations, environment, repository, data),
							A2(
								$author$project$UI$Dialog$dialog,
								$author$project$Translations$MainMenu$measures(translations),
								$author$project$Audit$PerformAuditPage$CloseMeasureDialog)))));
		}
	});
var $author$project$Audit$PerformAuditPage$viewMeasureEditDialog = F2(
	function (environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Measure$EditDialog$view, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Audit$PerformAuditPage$GotMeasureEditDialogMsg));
	});
var $author$project$Audit$RecordModal$UserClickedCloseDialog = {$: 0};
var $author$project$Audit$RecordModal$UserClickedSaveBlob = {$: 11};
var $author$project$CheckpointData$Checkpoint$Value$optionsToString = function (options) {
	var stingList = A2(
		$elm$core$List$map,
		function (option) {
			return option.hl;
		},
		options);
	return A2($elm$core$String$join, ',', stingList);
};
var $author$project$CheckpointData$Checkpoint$Value$toString = function (value) {
	switch (value.$) {
		case 0:
			var _float = value.a;
			return $elm$core$String$fromFloat(_float);
		case 1:
			var string = value.a;
			return string;
		case 2:
			var string = value.a;
			return string;
		case 3:
			var bool = value.a;
			return bool ? 'True' : 'False';
		case 4:
			var string = value.a;
			return string;
		case 5:
			var option = value.a;
			return option.hl;
		case 6:
			var options = value.a;
			return $author$project$CheckpointData$Checkpoint$Value$optionsToString(options);
		case 7:
			var date = value.a;
			return $author$project$Date_Time$NaiveDate$toStringYMD(date);
		case 8:
			var filename = value.a;
			return $author$project$File$Filename$toIdString(filename);
		case 9:
			var filename = value.a;
			return $author$project$File$Filename$toIdString(filename);
		default:
			var time = value.a;
			return $author$project$Date_Time$NaiveTime$toString(time);
	}
};
var $author$project$Audit$RecordModal$disabledBtn = function (config) {
	switch (config.$) {
		case 0:
			var model = config.a;
			var _v1 = model.o;
			if (!_v1.$) {
				var textInput = _v1.a;
				var transformedInput = A3($elm$core$String$replace, ',', '.', textInput);
				return $author$project$Utils$Maybe$isNothing(
					$elm$core$String$toFloat(transformedInput)) ? true : A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (record_) {
							return _Utils_eq(
								$author$project$CheckpointData$Checkpoint$Value$toString(record_.ll),
								textInput);
						},
						model.ct));
			} else {
				return true;
			}
		case 1:
			var model = config.a;
			var _v2 = model.o;
			if (!_v2.$) {
				var textInput = _v2.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$core$String$isEmpty(
						$elm$core$String$trim(textInput)),
					A2(
						$elm$core$Maybe$map,
						function (record_) {
							return _Utils_eq(
								$elm$core$String$trim(
									$author$project$CheckpointData$Checkpoint$Value$toString(record_.ll)),
								$elm$core$String$trim(textInput)) || $elm$core$String$isEmpty(
								$elm$core$String$trim(textInput));
						},
						model.ct));
			} else {
				return true;
			}
		case 2:
			var model = config.a;
			var _v3 = model.o;
			if (!_v3.$) {
				var textInput = _v3.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$core$String$isEmpty(
						$elm$core$String$trim(textInput)),
					A2(
						$elm$core$Maybe$map,
						function (record_) {
							return _Utils_eq(
								$elm$core$String$trim(
									$author$project$CheckpointData$Checkpoint$Value$toString(record_.ll)),
								$elm$core$String$trim(textInput)) || $elm$core$String$isEmpty(
								$elm$core$String$trim(textInput));
						},
						model.ct));
			} else {
				return true;
			}
		case 3:
			var model = config.a;
			var _v4 = model.ll;
			if (!_v4.$) {
				var date = _v4.a;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (record_) {
							return _Utils_eq(
								$author$project$CheckpointData$Checkpoint$Value$toString(record_.ll),
								$author$project$Date_Time$NaiveDate$toStringYMD(date));
						},
						model.ct));
			} else {
				return true;
			}
		case 4:
			var model = config.a;
			var _v5 = model.ll;
			if (!_v5.$) {
				var time = _v5.a;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (record_) {
							return _Utils_eq(
								$author$project$CheckpointData$Checkpoint$Value$toString(record_.ll),
								$author$project$Date_Time$NaiveTime$toString(time));
						},
						model.ct));
			} else {
				return true;
			}
		case 5:
			var model = config.a;
			var _v6 = $author$project$UI$ImageEditor$image(model.cY);
			if (!_v6.$) {
				var image = _v6.a;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (record_) {
							return _Utils_eq(
								$author$project$CheckpointData$Checkpoint$Value$toString(record_.ll),
								$author$project$File$Filename$toIdString(image));
						},
						model.ct));
			} else {
				return true;
			}
		default:
			var signatureModel = config.a;
			return false;
	}
};
var $author$project$Audit$RecordModal$modalHeader = F2(
	function (translations, config) {
		switch (config.$) {
			case 0:
				return $author$project$Translations$CheckpointTypes$number(translations);
			case 1:
				return $author$project$Translations$CheckpointTypes$textRow(translations);
			case 2:
				return $author$project$Translations$CheckpointTypes$textMemo(translations);
			case 3:
				return $author$project$Translations$CheckpointTypes$date(translations);
			case 4:
				return $author$project$Translations$CheckpointTypes$time(translations);
			case 5:
				return $author$project$Translations$CheckpointTypes$image(translations);
			default:
				return $author$project$Translations$CheckpointTypes$signature(translations);
		}
	});
var $author$project$Audit$RecordModal$ChangedDatePickerMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Audit$RecordModal$EnteredTextInput = function (a) {
	return {$: 5, a: a};
};
var $author$project$UI$DateInput$withId = F2(
	function (id, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{fw: id});
	});
var $author$project$UI$DateInput$withOnEnter = F2(
	function (onInput, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{eO: onInput});
	});
var $author$project$Audit$RecordModal$viewRecordDate = F2(
	function (translations, model) {
		var dateValue = A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Just(model.lb),
				A2(
					$elm$core$Maybe$map,
					function (record_) {
						var _v0 = record_.ll;
						if (_v0.$ === 7) {
							var date = _v0.a;
							return $elm$core$Maybe$Just(date);
						} else {
							return $elm$core$Maybe$Just(model.lb);
						}
					},
					model.ct)),
			A2(
				$elm$core$Maybe$map,
				function (date) {
					return $elm$core$Maybe$Just(date);
				},
				model.ll));
		return A5(
			$author$project$UI$DateInput$view,
			translations,
			model.cJ,
			dateValue,
			model.o,
			A2(
				$author$project$UI$DateInput$withId,
				'value-input',
				A2(
					$author$project$UI$DateInput$withOnEnter,
					$elm$core$Maybe$Just($author$project$Audit$RecordModal$UserClickedCreateButton),
					A2(
						$author$project$UI$DateInput$withOnTextInput,
						$author$project$Audit$RecordModal$EnteredTextInput,
						A3(
							$author$project$UI$DateInput$dateInput,
							$author$project$Date_Time$NaiveDate$year(model.lb),
							$author$project$Date_Time$NaiveDate$month(model.lb),
							$author$project$Audit$RecordModal$ChangedDatePickerMsg)))));
	});
var $author$project$Audit$RecordModal$viewRecordImage = F2(
	function (translations, imageModel) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$Audit$RecordModal$GotImageEditorMsg,
			A2($author$project$UI$ImageEditor$view, translations, imageModel.cY));
	});
var $author$project$Audit$RecordModal$viewRecordNumber = function (model) {
	var text = A3(
		$elm$core$String$replace,
		'.',
		',',
		A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (record_) {
						var _v0 = record_.ll;
						if (!_v0.$) {
							var _float = _v0.a;
							return A2($myrho$elm_round$Round$round, model.kd.hJ, _float);
						} else {
							return '';
						}
					},
					model.ct)),
			A2(
				$elm$core$Maybe$map,
				function (value) {
					return value;
				},
				model.o)));
	return $author$project$UI$TextInput$view(
		A2(
			$author$project$UI$TextInput$withId,
			'value-input',
			A2(
				$author$project$UI$TextInput$withOnEnter,
				$author$project$Audit$RecordModal$UserClickedCreateButton,
				A2(
					$author$project$UI$TextInput$withOnInput,
					$author$project$Audit$RecordModal$EnteredTextInput,
					A2($author$project$UI$TextInput$withValue, text, $author$project$UI$TextInput$singleLine)))));
};
var $author$project$UI$Canvas$Canvas$setHeight = F2(
	function (height_, state) {
		return _Utils_update(
			state,
			{fv: height_});
	});
var $author$project$UI$Canvas$Canvas$setWidth = F2(
	function (width_, state) {
		return _Utils_update(
			state,
			{ga: width_});
	});
var $author$project$UI$Canvas$Canvas$EndAt = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$Canvas$Canvas$MoveAt = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Canvas$Canvas$SelectColor = function (a) {
	return {$: 6, a: a};
};
var $author$project$UI$Canvas$Canvas$SelectSize = function (a) {
	return {$: 7, a: a};
};
var $author$project$UI$Canvas$Canvas$StartAt = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Style$Theme$blue = A4($author$project$UI$Style$Color$rgba, 52 / 255, 101 / 255, 164 / 255, 1.0);
var $author$project$UI$Style$Theme$brown = A4($author$project$UI$Style$Color$rgba, 193 / 255, 125 / 255, 17 / 255, 1.0);
var $author$project$UI$Style$Theme$charcoal = A4($author$project$UI$Style$Color$rgba, 85 / 255, 87 / 255, 83 / 255, 1.0);
var $author$project$UI$Canvas$CustomElements$col = function (btns) {
	return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, btns);
};
var $author$project$UI$Canvas$CustomElements$colorButton = F3(
	function (msg, selectedColor, color) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'border-radius', '50%'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$style,
					'background-color',
					$author$project$UI$Style$Color$toString(color)),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'block'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '40px'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', '40px'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin', '5px'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'border', '2px solid white'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$style,
					'box-shadow',
					_Utils_eq(selectedColor, color) ? 'rgba(0, 0, 0, 0.4) 0px 4px 6px' : 'none'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'transition', 'transform 0.2s linear'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'outline', 'none'),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$style,
					'transform',
					_Utils_eq(selectedColor, color) ? 'translateY(-6px)' : 'none'),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					msg(color))
				]),
			_List_Nil);
	});
var $author$project$UI$Style$Theme$darkBlue = A4($author$project$UI$Style$Color$rgba, 32 / 255, 74 / 255, 135 / 255, 1.0);
var $author$project$UI$Style$Theme$darkBrown = A4($author$project$UI$Style$Color$rgba, 143 / 255, 89 / 255, 2 / 255, 1.0);
var $author$project$UI$Style$Theme$darkCharcoal = A4($author$project$UI$Style$Color$rgba, 46 / 255, 52 / 255, 54 / 255, 1.0);
var $author$project$UI$Style$Theme$darkGreen = A4($author$project$UI$Style$Color$rgba, 40 / 255, 113 / 255, 55 / 255, 1.0);
var $author$project$UI$Style$Theme$darkOrange = A4($author$project$UI$Style$Color$rgba, 206 / 255, 92 / 255, 0 / 255, 1.0);
var $author$project$UI$Style$Theme$darkPurple = A4($author$project$UI$Style$Color$rgba, 92 / 255, 53 / 255, 102 / 255, 1.0);
var $author$project$UI$Style$Theme$darkYellow = A4($author$project$UI$Style$Color$rgba, 196 / 255, 160 / 255, 0 / 255, 1.0);
var $author$project$UI$Style$Theme$lightBlue = A4($author$project$UI$Style$Color$rgba, 114 / 255, 159 / 255, 207 / 255, 1.0);
var $author$project$UI$Style$Theme$lightBrown = A4($author$project$UI$Style$Color$rgba, 233 / 255, 185 / 255, 110 / 255, 1.0);
var $author$project$UI$Style$Theme$lightCharcoal = A4($author$project$UI$Style$Color$rgba, 136 / 255, 138 / 255, 133 / 255, 1.0);
var $author$project$UI$Style$Theme$lightGreen = A4($author$project$UI$Style$Color$rgba, 138 / 255, 226 / 255, 52 / 255, 1.0);
var $author$project$UI$Style$Theme$lightOrange = A4($author$project$UI$Style$Color$rgba, 252 / 255, 175 / 255, 62 / 255, 1.0);
var $author$project$UI$Style$Theme$lightPurple = A4($author$project$UI$Style$Color$rgba, 173 / 255, 127 / 255, 168 / 255, 1.0);
var $author$project$UI$Style$Theme$lightYellow = A4($author$project$UI$Style$Color$rgba, 255 / 255, 233 / 255, 79 / 255, 1.0);
var $author$project$UI$Style$Theme$purple = A4($author$project$UI$Style$Color$rgba, 117 / 255, 80 / 255, 123 / 255, 1.0);
var $author$project$UI$Canvas$CustomElements$colorButtons = F3(
	function (msg, withCustomElements, selectedColor) {
		if (withCustomElements) {
			var layout = function (colors) {
				return A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($author$project$UI$Canvas$CustomElements$colorButton, msg, selectedColor)),
						$author$project$UI$Canvas$CustomElements$col),
					colors);
			};
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'flex'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'flex-direction', 'row'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'justify-content', 'space-around')
					]),
				layout(
					_List_fromArray(
						[
							_List_fromArray(
							[$author$project$UI$Style$Theme$lightRed, $author$project$UI$Style$Theme$red, $author$project$UI$Style$Theme$darkRed]),
							_List_fromArray(
							[$author$project$UI$Style$Theme$lightOrange, $author$project$UI$Style$Theme$orange, $author$project$UI$Style$Theme$darkOrange]),
							_List_fromArray(
							[$author$project$UI$Style$Theme$lightYellow, $author$project$UI$Style$Theme$yellow, $author$project$UI$Style$Theme$darkYellow]),
							_List_fromArray(
							[$author$project$UI$Style$Theme$lightGreen, $author$project$UI$Style$Theme$green, $author$project$UI$Style$Theme$darkGreen]),
							_List_fromArray(
							[$author$project$UI$Style$Theme$lightBlue, $author$project$UI$Style$Theme$blue, $author$project$UI$Style$Theme$darkBlue]),
							_List_fromArray(
							[$author$project$UI$Style$Theme$lightPurple, $author$project$UI$Style$Theme$purple, $author$project$UI$Style$Theme$darkPurple]),
							_List_fromArray(
							[$author$project$UI$Style$Theme$lightBrown, $author$project$UI$Style$Theme$brown, $author$project$UI$Style$Theme$darkBrown]),
							_List_fromArray(
							[$author$project$UI$Style$Theme$white, $author$project$UI$Style$Theme$lightGrey, $author$project$UI$Style$Theme$grey]),
							_List_fromArray(
							[$author$project$UI$Style$Theme$darkGrey, $author$project$UI$Style$Theme$lightCharcoal, $author$project$UI$Style$Theme$charcoal]),
							_List_fromArray(
							[$author$project$UI$Style$Theme$darkCharcoal, $author$project$UI$Style$Theme$black])
						])));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var $rtfeldman$elm_css$Html$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$defaultOptions = {kx: true, kX: false};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$Event = F6(
	function (keys, button, clientPos, offsetPos, pagePos, screenPos) {
		return {i$: button, i7: clientPos, jR: keys, g0: offsetPos, ko: pagePos, kJ: screenPos};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$BackButton = 4;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$ErrorButton = 0;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$ForwardButton = 5;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$MainButton = 1;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$MiddleButton = 2;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$SecondButton = 3;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonFromId = function (id) {
	switch (id) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		default:
			return 0;
	}
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonDecoder = A2(
	$elm$json$Json$Decode$map,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonFromId,
	A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
var $mpizenberg$elm_pointer_events$Internal$Decode$clientPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$Keys = F4(
	function (alt, ctrl, meta, shift) {
		return {iQ: alt, je: ctrl, j6: meta, kR: shift};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $mpizenberg$elm_pointer_events$Internal$Decode$keys = A5(
	$elm$json$Json$Decode$map4,
	$mpizenberg$elm_pointer_events$Internal$Decode$Keys,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $elm$json$Json$Decode$map6 = _Json_map6;
var $mpizenberg$elm_pointer_events$Internal$Decode$offsetPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$pagePos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$screenPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'screenX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'screenY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$eventDecoder = A7($elm$json$Json$Decode$map6, $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$Event, $mpizenberg$elm_pointer_events$Internal$Decode$keys, $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonDecoder, $mpizenberg$elm_pointer_events$Internal$Decode$clientPos, $mpizenberg$elm_pointer_events$Internal$Decode$offsetPos, $mpizenberg$elm_pointer_events$Internal$Decode$pagePos, $mpizenberg$elm_pointer_events$Internal$Decode$screenPos);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onWithOptions = F3(
	function (event, options, tag) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (ev) {
					return {
						j5: tag(ev),
						kx: options.kx,
						kX: options.kX
					};
				},
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$eventDecoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onDown = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onWithOptions, 'mousedown', $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onMove = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onWithOptions, 'mousemove', $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Event = F4(
	function (keys, changedTouches, targetTouches, touches) {
		return {i2: changedTouches, jR: keys, k_: targetTouches, lc: touches};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Touch = F4(
	function (identifier, clientPos, pagePos, screenPos) {
		return {i7: clientPos, jJ: identifier, ko: pagePos, kJ: screenPos};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder = A5(
	$elm$json$Json$Decode$map4,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Touch,
	A2($elm$json$Json$Decode$field, 'identifier', $elm$json$Json$Decode$int),
	$mpizenberg$elm_pointer_events$Internal$Decode$clientPos,
	$mpizenberg$elm_pointer_events$Internal$Decode$pagePos,
	$mpizenberg$elm_pointer_events$Internal$Decode$screenPos);
var $mpizenberg$elm_pointer_events$Internal$Decode$all = A2(
	$elm$core$List$foldr,
	$elm$json$Json$Decode$map2($elm$core$List$cons),
	$elm$json$Json$Decode$succeed(_List_Nil));
var $mpizenberg$elm_pointer_events$Internal$Decode$dynamicListOf = function (itemDecoder) {
	var decodeOne = function (n) {
		return A2(
			$elm$json$Json$Decode$field,
			$elm$core$String$fromInt(n),
			itemDecoder);
	};
	var decodeN = function (n) {
		return $mpizenberg$elm_pointer_events$Internal$Decode$all(
			A2(
				$elm$core$List$map,
				decodeOne,
				A2($elm$core$List$range, 0, n - 1)));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decodeN,
		A2($elm$json$Json$Decode$field, 'length', $elm$json$Json$Decode$int));
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder = $mpizenberg$elm_pointer_events$Internal$Decode$dynamicListOf;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$eventDecoder = A5(
	$elm$json$Json$Decode$map4,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Event,
	$mpizenberg$elm_pointer_events$Internal$Decode$keys,
	A2(
		$elm$json$Json$Decode$field,
		'changedTouches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'targetTouches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'touches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)));
var $author$project$UI$Canvas$Canvas$offsetDecoder = A2(
	$elm$json$Json$Decode$field,
	'target',
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (top, left) {
				return _Utils_Tuple2(left, top);
			}),
		A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float)));
var $author$project$UI$Canvas$Canvas$eventCustomDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (event, offset) {
			return {gF: event, hk: offset};
		}),
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$eventDecoder,
	$author$project$UI$Canvas$Canvas$offsetDecoder);
var $author$project$UI$Canvas$Canvas$onTouch = F2(
	function (event, customEventToMsg) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (ev) {
					return {
						j5: customEventToMsg(ev),
						kx: true,
						kX: true
					};
				},
				$author$project$UI$Canvas$Canvas$eventCustomDecoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onUp = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onWithOptions, 'mouseup', $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$defaultOptions);
var $author$project$UI$Canvas$CustomElements$getShadowColor = function (color) {
	var _v0 = $avh4$elm_color$Color$toRgba(
		$author$project$UI$Style$Color$uiColorToColor(color));
	var red = _v0.kz;
	var green = _v0.jE;
	var blue = _v0.iZ;
	return A4($avh4$elm_color$Color$rgba, red, green, blue, 0.2);
};
var $author$project$UI$Canvas$CustomElements$sizeControls = F4(
	function (msg, withCustomElements, selectedColor, selectedSize) {
		if (withCustomElements) {
			var inc = 10;
			var brushes = 6;
			var buttonSize = brushes * inc;
			var controls = A2(
				$elm$core$List$map,
				function (i) {
					var size = A2($elm$core$Basics$max, 2, i * inc);
					return A2(
						$rtfeldman$elm_css$Html$Styled$button,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, '-webkit-appearance', 'none'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, '-moz-appearance', 'none'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'block'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', 'transparent'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'border', 'none'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin', '5px'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding', '0'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$style,
								'min-width',
								$elm$core$String$fromInt(30) + 'px'),
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$style,
								'min-height',
								$elm$core$String$fromInt(buttonSize) + 'px'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'outline', 'none'),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								msg(size))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'border-radius', '50%'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$style,
										'background-color',
										$author$project$UI$Style$Color$toString(selectedColor)),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$style,
										'border',
										'3px solid ' + $avh4$elm_color$Color$toCssString(
											$author$project$UI$Canvas$CustomElements$getShadowColor($author$project$UI$Style$Theme$white))),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$style,
										'width',
										$elm$core$String$fromInt(size) + 'px'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$style,
										'height',
										$elm$core$String$fromInt(size) + 'px'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin', '0 auto'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$style,
										'box-shadow',
										_Utils_eq(selectedSize, size) ? 'rgba(0, 0, 0, 0.4) 0px 4px 6px' : 'none'),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'transition', 'transform 0.2s linear'),
										A2(
										$rtfeldman$elm_css$Html$Styled$Attributes$style,
										'transform',
										_Utils_eq(selectedSize, size) ? 'translateY(-6px)' : 'none')
									]),
								_List_Nil)
							]));
				},
				A2($elm$core$List$range, 0, brushes));
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'flex'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'flex-direction', 'row'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'justify-content', 'space-around'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'align-items', 'center')
					]),
				controls);
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$html$Html$canvas = _VirtualDom_node('canvas');
var $joakin$elm_canvas$Canvas$cnvs = A2($elm$html$Html$canvas, _List_Nil, _List_Nil);
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$commands = function (list) {
	return A2(
		$elm$html$Html$Attributes$property,
		'cmds',
		A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, list));
};
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$empty = _List_Nil;
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn = F2(
	function (name, args) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('function')),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'args',
					A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, args))
				]));
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$beginPath = A2($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn, 'beginPath', _List_Nil);
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fillStyle = function (color) {
	return A2(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$field,
		'fillStyle',
		$elm$json$Json$Encode$string(
			$avh4$elm_color$Color$toCssString(color)));
};
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$clearRect = F4(
	function (x, y, width, height) {
		return A2(
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
			'clearRect',
			_List_fromArray(
				[
					$elm$json$Json$Encode$float(x),
					$elm$json$Json$Encode$float(y),
					$elm$json$Json$Encode$float(width),
					$elm$json$Json$Encode$float(height)
				]));
	});
var $joakin$elm_canvas$Canvas$renderClear = F4(
	function (_v0, w, h, cmds) {
		var x = _v0.a;
		var y = _v0.b;
		return A2(
			$elm$core$List$cons,
			A4($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$clearRect, x, y, w, h),
			cmds);
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$arc = F6(
	function (x, y, radius, startAngle, endAngle, anticlockwise) {
		return A2(
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
			'arc',
			_List_fromArray(
				[
					$elm$json$Json$Encode$float(x),
					$elm$json$Json$Encode$float(y),
					$elm$json$Json$Encode$float(radius),
					$elm$json$Json$Encode$float(startAngle),
					$elm$json$Json$Encode$float(endAngle),
					$elm$json$Json$Encode$bool(anticlockwise)
				]));
	});
var $elm$core$Basics$pi = _Basics_pi;
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$circle = F3(
	function (x, y, r) {
		return A6($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$arc, x, y, r, 0, 2 * $elm$core$Basics$pi, false);
	});
var $elm$core$Basics$cos = _Basics_cos;
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$moveTo = F2(
	function (x, y) {
		return A2(
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
			'moveTo',
			_List_fromArray(
				[
					$elm$json$Json$Encode$float(x),
					$elm$json$Json$Encode$float(y)
				]));
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$rect = F4(
	function (x, y, w, h) {
		return A2(
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
			'rect',
			_List_fromArray(
				[
					$elm$json$Json$Encode$float(x),
					$elm$json$Json$Encode$float(y),
					$elm$json$Json$Encode$float(w),
					$elm$json$Json$Encode$float(h)
				]));
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$arcTo = F5(
	function (x1, y1, x2, y2, radius) {
		return A2(
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
			'arcTo',
			_List_fromArray(
				[
					$elm$json$Json$Encode$float(x1),
					$elm$json$Json$Encode$float(y1),
					$elm$json$Json$Encode$float(x2),
					$elm$json$Json$Encode$float(y2),
					$elm$json$Json$Encode$float(radius)
				]));
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$bezierCurveTo = F6(
	function (cp1x, cp1y, cp2x, cp2y, x, y) {
		return A2(
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
			'bezierCurveTo',
			_List_fromArray(
				[
					$elm$json$Json$Encode$float(cp1x),
					$elm$json$Json$Encode$float(cp1y),
					$elm$json$Json$Encode$float(cp2x),
					$elm$json$Json$Encode$float(cp2y),
					$elm$json$Json$Encode$float(x),
					$elm$json$Json$Encode$float(y)
				]));
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$lineTo = F2(
	function (x, y) {
		return A2(
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
			'lineTo',
			_List_fromArray(
				[
					$elm$json$Json$Encode$float(x),
					$elm$json$Json$Encode$float(y)
				]));
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$quadraticCurveTo = F4(
	function (cpx, cpy, x, y) {
		return A2(
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
			'quadraticCurveTo',
			_List_fromArray(
				[
					$elm$json$Json$Encode$float(cpx),
					$elm$json$Json$Encode$float(cpy),
					$elm$json$Json$Encode$float(x),
					$elm$json$Json$Encode$float(y)
				]));
	});
var $joakin$elm_canvas$Canvas$renderLineSegment = F2(
	function (segment, cmds) {
		switch (segment.$) {
			case 0:
				var _v1 = segment.a;
				var x = _v1.a;
				var y = _v1.b;
				var _v2 = segment.b;
				var x2 = _v2.a;
				var y2 = _v2.b;
				var radius = segment.c;
				return A2(
					$elm$core$List$cons,
					A5($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$arcTo, x, y, x2, y2, radius),
					cmds);
			case 1:
				var _v3 = segment.a;
				var cp1x = _v3.a;
				var cp1y = _v3.b;
				var _v4 = segment.b;
				var cp2x = _v4.a;
				var cp2y = _v4.b;
				var _v5 = segment.c;
				var x = _v5.a;
				var y = _v5.b;
				return A2(
					$elm$core$List$cons,
					A6($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$bezierCurveTo, cp1x, cp1y, cp2x, cp2y, x, y),
					cmds);
			case 2:
				var _v6 = segment.a;
				var x = _v6.a;
				var y = _v6.b;
				return A2(
					$elm$core$List$cons,
					A2($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$lineTo, x, y),
					cmds);
			case 3:
				var _v7 = segment.a;
				var x = _v7.a;
				var y = _v7.b;
				return A2(
					$elm$core$List$cons,
					A2($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$moveTo, x, y),
					cmds);
			default:
				var _v8 = segment.a;
				var cpx = _v8.a;
				var cpy = _v8.b;
				var _v9 = segment.b;
				var x = _v9.a;
				var y = _v9.b;
				return A2(
					$elm$core$List$cons,
					A4($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$quadraticCurveTo, cpx, cpy, x, y),
					cmds);
		}
	});
var $elm$core$Basics$sin = _Basics_sin;
var $joakin$elm_canvas$Canvas$renderShape = F2(
	function (shape, cmds) {
		switch (shape.$) {
			case 0:
				var _v1 = shape.a;
				var x = _v1.a;
				var y = _v1.b;
				var w = shape.b;
				var h = shape.c;
				return A2(
					$elm$core$List$cons,
					A4($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$rect, x, y, w, h),
					A2(
						$elm$core$List$cons,
						A2($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$moveTo, x, y),
						cmds));
			case 1:
				var _v2 = shape.a;
				var x = _v2.a;
				var y = _v2.b;
				var r = shape.b;
				return A2(
					$elm$core$List$cons,
					A3($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$circle, x, y, r),
					A2(
						$elm$core$List$cons,
						A2($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$moveTo, x + r, y),
						cmds));
			case 2:
				var _v3 = shape.a;
				var x = _v3.a;
				var y = _v3.b;
				var segments = shape.b;
				return A3(
					$elm$core$List$foldl,
					$joakin$elm_canvas$Canvas$renderLineSegment,
					A2(
						$elm$core$List$cons,
						A2($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$moveTo, x, y),
						cmds),
					segments);
			default:
				var _v4 = shape.a;
				var x = _v4.a;
				var y = _v4.b;
				var radius = shape.b;
				var startAngle = shape.c;
				var endAngle = shape.d;
				var anticlockwise = shape.e;
				return A2(
					$elm$core$List$cons,
					A2(
						$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$moveTo,
						x + (radius * $elm$core$Basics$cos(endAngle)),
						y + (radius * $elm$core$Basics$sin(endAngle))),
					A2(
						$elm$core$List$cons,
						A6($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$arc, x, y, radius, startAngle, endAngle, anticlockwise),
						A2(
							$elm$core$List$cons,
							A2(
								$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$moveTo,
								x + (radius * $elm$core$Basics$cos(startAngle)),
								y + (radius * $elm$core$Basics$sin(startAngle))),
							cmds)));
		}
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$NonZero = 0;
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fillRuleToString = function (fillRule) {
	if (!fillRule) {
		return 'nonzero';
	} else {
		return 'evenodd';
	}
};
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fill = function (fillRule) {
	return A2(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
		'fill',
		_List_fromArray(
			[
				$elm$json$Json$Encode$string(
				$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fillRuleToString(fillRule))
			]));
};
var $joakin$elm_canvas$Canvas$renderShapeFill = F2(
	function (maybeColor, cmds) {
		return A2(
			$elm$core$List$cons,
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fill(0),
			function () {
				if (!maybeColor.$) {
					var color = maybeColor.a;
					return A2(
						$elm$core$List$cons,
						$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fillStyle(color),
						cmds);
				} else {
					return cmds;
				}
			}());
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$stroke = A2($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn, 'stroke', _List_Nil);
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$strokeStyle = function (color) {
	return A2(
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$field,
		'strokeStyle',
		$elm$json$Json$Encode$string(
			$avh4$elm_color$Color$toCssString(color)));
};
var $joakin$elm_canvas$Canvas$renderShapeStroke = F2(
	function (maybeColor, cmds) {
		return A2(
			$elm$core$List$cons,
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$stroke,
			function () {
				if (!maybeColor.$) {
					var color = maybeColor.a;
					return A2(
						$elm$core$List$cons,
						$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$strokeStyle(color),
						cmds);
				} else {
					return cmds;
				}
			}());
	});
var $joakin$elm_canvas$Canvas$renderShapeDrawOp = F2(
	function (drawOp, cmds) {
		switch (drawOp.$) {
			case 0:
				return A2(
					$joakin$elm_canvas$Canvas$renderShapeStroke,
					$elm$core$Maybe$Nothing,
					A2($joakin$elm_canvas$Canvas$renderShapeFill, $elm$core$Maybe$Nothing, cmds));
			case 1:
				var c = drawOp.a;
				return A2(
					$joakin$elm_canvas$Canvas$renderShapeFill,
					$elm$core$Maybe$Just(c),
					cmds);
			case 2:
				var c = drawOp.a;
				return A2(
					$joakin$elm_canvas$Canvas$renderShapeStroke,
					$elm$core$Maybe$Just(c),
					cmds);
			default:
				var fc = drawOp.a;
				var sc = drawOp.b;
				return A2(
					$joakin$elm_canvas$Canvas$renderShapeStroke,
					$elm$core$Maybe$Just(sc),
					A2(
						$joakin$elm_canvas$Canvas$renderShapeFill,
						$elm$core$Maybe$Just(fc),
						cmds));
		}
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fillText = F4(
	function (text, x, y, maybeMaxWidth) {
		if (maybeMaxWidth.$ === 1) {
			return A2(
				$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
				'fillText',
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(text),
						$elm$json$Json$Encode$float(x),
						$elm$json$Json$Encode$float(y)
					]));
		} else {
			var maxWidth = maybeMaxWidth.a;
			return A2(
				$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
				'fillText',
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(text),
						$elm$json$Json$Encode$float(x),
						$elm$json$Json$Encode$float(y),
						$elm$json$Json$Encode$float(maxWidth)
					]));
		}
	});
var $joakin$elm_canvas$Canvas$renderTextFill = F5(
	function (txt, x, y, maybeColor, cmds) {
		return A2(
			$elm$core$List$cons,
			A4($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fillText, txt.hl, x, y, txt.gX),
			function () {
				if (!maybeColor.$) {
					var color = maybeColor.a;
					return A2(
						$elm$core$List$cons,
						$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fillStyle(color),
						cmds);
				} else {
					return cmds;
				}
			}());
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$strokeText = F4(
	function (text, x, y, maybeMaxWidth) {
		if (maybeMaxWidth.$ === 1) {
			return A2(
				$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
				'strokeText',
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(text),
						$elm$json$Json$Encode$float(x),
						$elm$json$Json$Encode$float(y)
					]));
		} else {
			var maxWidth = maybeMaxWidth.a;
			return A2(
				$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
				'strokeText',
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(text),
						$elm$json$Json$Encode$float(x),
						$elm$json$Json$Encode$float(y),
						$elm$json$Json$Encode$float(maxWidth)
					]));
		}
	});
var $joakin$elm_canvas$Canvas$renderTextStroke = F5(
	function (txt, x, y, maybeColor, cmds) {
		return A2(
			$elm$core$List$cons,
			A4($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$strokeText, txt.hl, x, y, txt.gX),
			function () {
				if (!maybeColor.$) {
					var color = maybeColor.a;
					return A2(
						$elm$core$List$cons,
						$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$strokeStyle(color),
						cmds);
				} else {
					return cmds;
				}
			}());
	});
var $joakin$elm_canvas$Canvas$renderTextDrawOp = F3(
	function (drawOp, txt, cmds) {
		var _v0 = txt.ih;
		var x = _v0.a;
		var y = _v0.b;
		switch (drawOp.$) {
			case 0:
				return A5(
					$joakin$elm_canvas$Canvas$renderTextStroke,
					txt,
					x,
					y,
					$elm$core$Maybe$Nothing,
					A5($joakin$elm_canvas$Canvas$renderTextFill, txt, x, y, $elm$core$Maybe$Nothing, cmds));
			case 1:
				var c = drawOp.a;
				return A5(
					$joakin$elm_canvas$Canvas$renderTextFill,
					txt,
					x,
					y,
					$elm$core$Maybe$Just(c),
					cmds);
			case 2:
				var c = drawOp.a;
				return A5(
					$joakin$elm_canvas$Canvas$renderTextStroke,
					txt,
					x,
					y,
					$elm$core$Maybe$Just(c),
					cmds);
			default:
				var fc = drawOp.a;
				var sc = drawOp.b;
				return A5(
					$joakin$elm_canvas$Canvas$renderTextStroke,
					txt,
					x,
					y,
					$elm$core$Maybe$Just(sc),
					A5(
						$joakin$elm_canvas$Canvas$renderTextFill,
						txt,
						x,
						y,
						$elm$core$Maybe$Just(fc),
						cmds));
		}
	});
var $joakin$elm_canvas$Canvas$renderText = F3(
	function (drawOp, txt, cmds) {
		return A3($joakin$elm_canvas$Canvas$renderTextDrawOp, drawOp, txt, cmds);
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$drawImage = F9(
	function (sx, sy, sw, sh, dx, dy, dw, dh, imageObj) {
		return A2(
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn,
			'drawImage',
			_List_fromArray(
				[
					imageObj,
					$elm$json$Json$Encode$float(sx),
					$elm$json$Json$Encode$float(sy),
					$elm$json$Json$Encode$float(sw),
					$elm$json$Json$Encode$float(sh),
					$elm$json$Json$Encode$float(dx),
					$elm$json$Json$Encode$float(dy),
					$elm$json$Json$Encode$float(dw),
					$elm$json$Json$Encode$float(dh)
				]));
	});
var $joakin$elm_canvas$Canvas$Internal$Texture$drawTexture = F4(
	function (x, y, t, cmds) {
		return A2(
			$elm$core$List$cons,
			function () {
				if (!t.$) {
					var image = t.a;
					return A9($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$drawImage, 0, 0, image.ln, image.Y, x, y, image.ln, image.Y, image.fA);
				} else {
					var sprite = t.a;
					var image = t.b;
					return A9($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$drawImage, sprite.am, sprite.bf, sprite.ln, sprite.Y, x, y, sprite.ln, sprite.Y, image.fA);
				}
			}(),
			cmds);
	});
var $joakin$elm_canvas$Canvas$renderTexture = F3(
	function (_v0, t, cmds) {
		var x = _v0.a;
		var y = _v0.b;
		return A4($joakin$elm_canvas$Canvas$Internal$Texture$drawTexture, x, y, t, cmds);
	});
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$restore = A2($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn, 'restore', _List_Nil);
var $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$save = A2($joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fn, 'save', _List_Nil);
var $joakin$elm_canvas$Canvas$renderDrawable = F3(
	function (drawable, drawOp, cmds) {
		switch (drawable.$) {
			case 0:
				var txt = drawable.a;
				return A3($joakin$elm_canvas$Canvas$renderText, drawOp, txt, cmds);
			case 1:
				var ss = drawable.a;
				return A2(
					$joakin$elm_canvas$Canvas$renderShapeDrawOp,
					drawOp,
					A3(
						$elm$core$List$foldl,
						$joakin$elm_canvas$Canvas$renderShape,
						A2($elm$core$List$cons, $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$beginPath, cmds),
						ss));
			case 2:
				var p = drawable.a;
				var t = drawable.b;
				return A3($joakin$elm_canvas$Canvas$renderTexture, p, t, cmds);
			case 3:
				var p = drawable.a;
				var w = drawable.b;
				var h = drawable.c;
				return A4($joakin$elm_canvas$Canvas$renderClear, p, w, h, cmds);
			default:
				var renderables = drawable.a;
				return A3($joakin$elm_canvas$Canvas$renderGroup, drawOp, renderables, cmds);
		}
	});
var $joakin$elm_canvas$Canvas$renderGroup = F3(
	function (drawOp, renderables, cmds) {
		var cmdsWithDraw = function () {
			switch (drawOp.$) {
				case 0:
					return cmds;
				case 1:
					var c = drawOp.a;
					return A2(
						$elm$core$List$cons,
						$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fillStyle(c),
						cmds);
				case 2:
					var c = drawOp.a;
					return A2(
						$elm$core$List$cons,
						$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$strokeStyle(c),
						cmds);
				default:
					var fc = drawOp.a;
					var sc = drawOp.b;
					return A2(
						$elm$core$List$cons,
						$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$fillStyle(fc),
						A2(
							$elm$core$List$cons,
							$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$strokeStyle(sc),
							cmds));
			}
		}();
		return A3(
			$elm$core$List$foldl,
			$joakin$elm_canvas$Canvas$renderOne(drawOp),
			cmdsWithDraw,
			renderables);
	});
var $joakin$elm_canvas$Canvas$renderOne = F3(
	function (parentDrawOp, _v0, cmds) {
		var commands = _v0.cD;
		var drawable = _v0.b6;
		var drawOp = _v0.b5;
		return A2(
			$elm$core$List$cons,
			$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$restore,
			A3(
				$joakin$elm_canvas$Canvas$renderDrawable,
				drawable,
				A2($joakin$elm_canvas$Canvas$mergeDrawOp, parentDrawOp, drawOp),
				_Utils_ap(
					commands,
					A2($elm$core$List$cons, $joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$save, cmds))));
	});
var $joakin$elm_canvas$Canvas$render = function (entities) {
	return A3(
		$elm$core$List$foldl,
		$joakin$elm_canvas$Canvas$renderOne($joakin$elm_canvas$Canvas$Internal$Canvas$NotSpecified),
		$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$empty,
		entities);
};
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $joakin$elm_canvas$Canvas$Internal$Texture$TImage = function (a) {
	return {$: 0, a: a};
};
var $joakin$elm_canvas$Canvas$Internal$Texture$decodeTextureImage = A2(
	$elm$json$Json$Decode$andThen,
	function (image) {
		return A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (tagName, width, height) {
					return (tagName === 'IMG') ? $elm$core$Maybe$Just(
						$joakin$elm_canvas$Canvas$Internal$Texture$TImage(
							{Y: height, fA: image, ln: width})) : $elm$core$Maybe$Nothing;
				}),
			A2($elm$json$Json$Decode$field, 'tagName', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$float));
	},
	$elm$json$Json$Decode$value);
var $joakin$elm_canvas$Canvas$Internal$Texture$decodeImageLoadEvent = A2($elm$json$Json$Decode$field, 'target', $joakin$elm_canvas$Canvas$Internal$Texture$decodeTextureImage);
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $joakin$elm_canvas$Canvas$renderTextureSource = function (textureSource) {
	var url = textureSource.a;
	var onLoad = textureSource.b;
	return _Utils_Tuple2(
		url,
		A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src(url),
					A2($elm$html$Html$Attributes$attribute, 'crossorigin', 'anonymous'),
					A2($elm$html$Html$Attributes$style, 'display', 'none'),
					A2(
					$elm$html$Html$Events$on,
					'load',
					A2($elm$json$Json$Decode$map, onLoad, $joakin$elm_canvas$Canvas$Internal$Texture$decodeImageLoadEvent)),
					A2(
					$elm$html$Html$Events$on,
					'error',
					$elm$json$Json$Decode$succeed(
						onLoad($elm$core$Maybe$Nothing)))
				]),
			_List_Nil));
};
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $joakin$elm_canvas$Canvas$toHtmlWith = F3(
	function (options, attrs, entities) {
		return A3(
			$elm$html$Html$Keyed$node,
			'elm-canvas',
			A2(
				$elm$core$List$cons,
				$joakin$elm_canvas$Canvas$Internal$CustomElementJsonApi$commands(
					$joakin$elm_canvas$Canvas$render(entities)),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$height(options.Y),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$width(options.ln),
						attrs))),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('__canvas', $joakin$elm_canvas$Canvas$cnvs),
				A2($elm$core$List$map, $joakin$elm_canvas$Canvas$renderTextureSource, options.iE)));
	});
var $joakin$elm_canvas$Canvas$toHtml = F3(
	function (_v0, attrs, entities) {
		var w = _v0.a;
		var h = _v0.b;
		return A3(
			$joakin$elm_canvas$Canvas$toHtmlWith,
			{Y: h, iE: _List_Nil, ln: w},
			attrs,
			entities);
	});
var $author$project$UI$Canvas$Canvas$calculateOffset = function (number) {
	return (number < 500) ? (number * 0.1) : ((number < 1000) ? (number * 0.25) : ((number < 1500) ? (number * 0.25) : ((number < 2000) ? (number * 0.3) : (number * 0.35))));
};
var $author$project$UI$Canvas$Canvas$touchCoordinates = F2(
	function (environment, _v0) {
		var event = _v0.gF;
		var targetOffset = _v0.hk;
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			A2(
				$elm$core$Maybe$map,
				function (touch) {
					var _v1 = targetOffset;
					var x2 = _v1.a;
					var y2 = _v1.b;
					var _v2 = touch.i7;
					var x = _v2.a;
					var y = _v2.b;
					var _v3 = $author$project$Environments$Environment$viewport(environment);
					var width = _v3.ln;
					var height = _v3.Y;
					var _v4 = _Utils_Tuple2(
						$author$project$UI$Canvas$Canvas$calculateOffset(width),
						$author$project$UI$Canvas$Canvas$calculateOffset(height));
					var additionalXOffset = _v4.a;
					var additionalYOffset = _v4.b;
					return _Utils_Tuple2(x - (x2 + additionalXOffset), y - (y2 + additionalYOffset));
				},
				$elm$core$List$head(event.i2)));
	});
var $author$project$UI$Canvas$Canvas$view = F2(
	function (environment, _v0) {
		var width_ = _v0.ga;
		var height_ = _v0.fv;
		var pencilColor = _v0.eR;
		var pencilSize = _v0.eS;
		var toDraw = _v0.f8;
		var withCustomElements = _v0.e6;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$fromUnstyled(
					A3(
						$joakin$elm_canvas$Canvas$toHtml,
						_Utils_Tuple2(width_, height_),
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'touch-action', 'none'),
								A2($elm$html$Html$Attributes$style, 'border', '2px solid grey'),
								A2($elm$html$Html$Attributes$style, 'border-radius', '1rem'),
								A2($elm$html$Html$Attributes$style, 'display', 'block'),
								A2(
								$elm$html$Html$Attributes$style,
								'width',
								$elm$core$String$fromInt(width_) + 'px'),
								A2(
								$elm$html$Html$Attributes$style,
								'height',
								$elm$core$String$fromInt(height_) + 'px'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onDown(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.g0;
									},
									$author$project$UI$Canvas$Canvas$StartAt)),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onMove(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.g0;
									},
									$author$project$UI$Canvas$Canvas$MoveAt)),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$onUp(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.g0;
									},
									$author$project$UI$Canvas$Canvas$EndAt)),
								A2(
								$author$project$UI$Canvas$Canvas$onTouch,
								'touchstart',
								A2(
									$elm$core$Basics$composeR,
									$author$project$UI$Canvas$Canvas$touchCoordinates(environment),
									$author$project$UI$Canvas$Canvas$StartAt)),
								A2(
								$author$project$UI$Canvas$Canvas$onTouch,
								'touchmove',
								A2(
									$elm$core$Basics$composeR,
									$author$project$UI$Canvas$Canvas$touchCoordinates(environment),
									$author$project$UI$Canvas$Canvas$MoveAt)),
								A2(
								$author$project$UI$Canvas$Canvas$onTouch,
								'touchend',
								A2(
									$elm$core$Basics$composeR,
									$author$project$UI$Canvas$Canvas$touchCoordinates(environment),
									$author$project$UI$Canvas$Canvas$EndAt))
							]),
						toDraw)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Attributes$style,
							'max-width',
							$elm$core$String$fromInt(width_ - 20) + 'px'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding', '10px')
						]),
					_List_fromArray(
						[
							A4($author$project$UI$Canvas$CustomElements$sizeControls, $author$project$UI$Canvas$Canvas$SelectSize, withCustomElements, pencilColor, pencilSize),
							A3($author$project$UI$Canvas$CustomElements$colorButtons, $author$project$UI$Canvas$Canvas$SelectColor, withCustomElements, pencilColor)
						]))
				]));
	});
var $author$project$Audit$RecordModal$viewRecordSignature = F3(
	function (translations, environment, signatureModel) {
		var viewPort = $author$project$Environments$Environment$viewport(environment);
		var width_ = (viewPort.ln >= 620) ? 500 : (viewPort.ln * 0.7);
		var height_ = width_ * 0.7;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Audit$RecordModal$GotCanvasMsg,
					A2(
						$author$project$UI$Canvas$Canvas$view,
						environment,
						A2(
							$author$project$UI$Canvas$Canvas$setHeight,
							$elm$core$Basics$round(height_),
							A2(
								$author$project$UI$Canvas$Canvas$setWidth,
								$elm$core$Basics$round(width_),
								signatureModel.dr))))
				]));
	});
var $author$project$Audit$RecordModal$viewRecordTextRow = function (model) {
	var text = A2(
		$elm$core$Maybe$withDefault,
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (record_) {
					var _v0 = record_.ll;
					if (_v0.$ === 1) {
						var string = _v0.a;
						return string;
					} else {
						return '';
					}
				},
				model.ct)),
		A2(
			$elm$core$Maybe$map,
			function (value) {
				return value;
			},
			model.o));
	return $author$project$UI$TextInput$view(
		A2(
			$author$project$UI$TextInput$withId,
			'value-input',
			A2(
				$author$project$UI$TextInput$withOnEnter,
				$author$project$Audit$RecordModal$UserClickedCreateButton,
				A2(
					$author$project$UI$TextInput$withOnInput,
					$author$project$Audit$RecordModal$EnteredTextInput,
					A2($author$project$UI$TextInput$withValue, text, $author$project$UI$TextInput$singleLine)))));
};
var $author$project$Audit$RecordModal$viewRecordTextmemo = function (model) {
	var text = A2(
		$elm$core$Maybe$withDefault,
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (record_) {
					var _v0 = record_.ll;
					if (_v0.$ === 2) {
						var string = _v0.a;
						return string;
					} else {
						return '';
					}
				},
				model.ct)),
		A2(
			$elm$core$Maybe$map,
			function (value) {
				return value;
			},
			model.o));
	return $author$project$UI$TextInput$view(
		A2(
			$author$project$UI$TextInput$withId,
			'value-input',
			A2(
				$author$project$UI$TextInput$withOnInput,
				$author$project$Audit$RecordModal$EnteredTextInput,
				A2($author$project$UI$TextInput$withValue, text, $author$project$UI$TextInput$multiLine))));
};
var $author$project$Audit$RecordModal$EnteredHour = function (a) {
	return {$: 7, a: a};
};
var $author$project$Audit$RecordModal$EnteredMinute = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$textAlignLast = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlignLast',
		'text-align-last',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$UI$TimeInput$withOnEnter = F2(
	function (onInput, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{eO: onInput});
	});
var $author$project$Audit$RecordModal$viewRecordTime = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$textAlignLast($rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				A4(
				$author$project$UI$TimeInput$view,
				false,
				model.cf,
				model.cj,
				A2(
					$author$project$UI$TimeInput$withOnEnter,
					$elm$core$Maybe$Just($author$project$Audit$RecordModal$UserClickedCreateButton),
					A2($author$project$UI$TimeInput$timeInput, $author$project$Audit$RecordModal$EnteredHour, $author$project$Audit$RecordModal$EnteredMinute)))
			]));
};
var $author$project$Audit$RecordModal$viewContent = F3(
	function (translations, environment, config_) {
		switch (config_.$) {
			case 0:
				var numberModel = config_.a;
				return $author$project$Audit$RecordModal$viewRecordNumber(numberModel);
			case 1:
				var textRowModel = config_.a;
				return $author$project$Audit$RecordModal$viewRecordTextRow(textRowModel);
			case 2:
				var textMemoModel = config_.a;
				return $author$project$Audit$RecordModal$viewRecordTextmemo(textMemoModel);
			case 3:
				var dateModel = config_.a;
				return A2($author$project$Audit$RecordModal$viewRecordDate, translations, dateModel);
			case 4:
				var timeModel = config_.a;
				return $author$project$Audit$RecordModal$viewRecordTime(timeModel);
			case 5:
				var imageModel = config_.a;
				return A2($author$project$Audit$RecordModal$viewRecordImage, translations, imageModel);
			default:
				var signatureModel = config_.a;
				return A3($author$project$Audit$RecordModal$viewRecordSignature, translations, environment, signatureModel);
		}
	});
var $author$project$Audit$RecordModal$UserClickedCancelButton = {$: 1};
var $author$project$Audit$RecordModal$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Audit$RecordModal$UserClickedCancelButton,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$Audit$RecordModal$viewCreateButton = F3(
	function (translations, disableBtn, msg) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					msg,
					$author$project$UI$Button$green(
						$author$project$Translations$Buttons$create(translations)))));
	});
var $author$project$Audit$RecordModal$viewFooter = F3(
	function (translations, disableBtn, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto'),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Audit$RecordModal$viewCancelButton(translations),
					A3($author$project$Audit$RecordModal$viewCreateButton, translations, disableBtn, msg)
				]));
	});
var $author$project$Audit$RecordModal$viewDialog = F3(
	function (translations, environment, config) {
		var createButtonMsg = function () {
			if (config.$ === 6) {
				return $author$project$Audit$RecordModal$UserClickedSaveBlob;
			} else {
				return $author$project$Audit$RecordModal$UserClickedCreateButton;
			}
		}();
		return $author$project$UI$Modal$view(
			A2(
				$author$project$UI$Modal$appendFooter,
				A3(
					$author$project$Audit$RecordModal$viewFooter,
					translations,
					$author$project$Audit$RecordModal$disabledBtn(config),
					createButtonMsg),
				A2(
					$author$project$UI$Modal$appendContent,
					A3($author$project$Audit$RecordModal$viewContent, translations, environment, config),
					A2(
						$author$project$UI$Modal$withIcon,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$edit),
						A2(
							$author$project$UI$Modal$modal,
							A2($author$project$Audit$RecordModal$modalHeader, translations, config),
							$author$project$Audit$RecordModal$UserClickedCloseDialog)))));
	});
var $author$project$Audit$RecordModal$viewErrorText = function (text_) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_Nil,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(text_)
			]));
};
var $author$project$Audit$RecordModal$viewErrorModal = F2(
	function (translations, text_) {
		return $author$project$UI$Modal$view(
			A2(
				$author$project$UI$Modal$appendFooter,
				A3($author$project$Audit$RecordModal$viewFooter, translations, true, $author$project$Audit$RecordModal$UserClickedCreateButton),
				A2(
					$author$project$UI$Modal$appendContent,
					$author$project$Audit$RecordModal$viewErrorText(text_),
					A2(
						$author$project$UI$Modal$withIcon,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
						A2(
							$author$project$UI$Modal$modal,
							$author$project$Translations$Checkpoints$CheckpointGroupDialog$createHeader(translations),
							$author$project$Audit$RecordModal$UserClickedCloseDialog)))));
	});
var $author$project$Audit$RecordModal$view = F3(
	function (translations, environment, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var config = dialog.a;
				return A3($author$project$Audit$RecordModal$viewDialog, translations, environment, config);
			case 2:
				var config = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Audit$RecordModal$viewDialog, translations, environment, config);
			default:
				var err = dialog.a;
				return A2($author$project$Audit$RecordModal$viewErrorModal, translations, err);
		}
	});
var $author$project$Audit$PerformAuditPage$viewRecordModal = F2(
	function (translations, environment) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Audit$RecordModal$view, translations, environment),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Audit$PerformAuditPage$GotRecordModalMsg));
	});
var $author$project$Audit$PerformAuditPage$UserClickedCompleteAudit = {$: 8};
var $author$project$UI$TabBar$withRightIcon = F2(
	function (icon, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				c9: _List_fromArray(
					[icon])
			});
	});
var $author$project$Audit$PerformAuditPage$tabBarWithIcon = F3(
	function (repository, audit, tabBar) {
		var recordCount_ = A2($author$project$Audit$PerformAuditPage$recordCount, audit.gm, repository);
		if (!recordCount_.dX) {
			var icon = A2(
				$author$project$UI$Icon$withForegroundColor,
				$author$project$UI$Style$Theme$green,
				A2(
					$author$project$UI$Icon$withOnClick,
					$author$project$Audit$PerformAuditPage$UserClickedCompleteAudit,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedCircle)));
			return A2($author$project$UI$TabBar$withRightIcon, icon, tabBar);
		} else {
			return tabBar;
		}
	});
var $author$project$Audit$PerformAuditPage$UserClickedEditAuditIcon = function (a) {
	return {$: 6, a: a};
};
var $author$project$Audit$PerformAuditPage$viewEditAuditIcon = function (audit) {
	return A2(
		$author$project$UI$Icon$withOnClick,
		$author$project$Audit$PerformAuditPage$UserClickedEditAuditIcon(audit),
		$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle));
};
var $author$project$Audit$PerformAuditPage$viewTabBar = F3(
	function (environment, repository, audit) {
		var withEditAudit = function (config) {
			var allowedToEditAudit = A2(
				$elm$core$List$member,
				true,
				A2(
					$elm$core$List$map,
					function (organisationUnitId) {
						return A3(
							$author$project$Auth$Authorization$authorize,
							$author$project$Environments$Environment$userRights(environment),
							7,
							organisationUnitId) || A3(
							$author$project$Auth$Authorization$authorize,
							$author$project$Environments$Environment$userRights(environment),
							9,
							organisationUnitId);
					},
					A2(
						$elm$core$List$map,
						function (organisationUnitId) {
							return organisationUnitId.km;
						},
						$author$project$OrganisationUnit$Hierarchy$organisationUnits(
							$author$project$OrganisationUnit$OrganisationUnits$hierarchy(
								$author$project$Environments$Repository$organisationUnits(repository))))));
			return allowedToEditAudit ? A2(
				$author$project$UI$TabBar$appendRightIcon,
				$author$project$Audit$PerformAuditPage$viewEditAuditIcon(audit),
				config) : config;
		};
		var timeZone = $author$project$Environments$Environment$timeZone(environment);
		var deadlineTime = $author$project$Date_Time$NaiveTime$format(
			A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, audit.hI));
		var deadlineDate = $author$project$Date_Time$NaiveDate$format(
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, audit.hI));
		var subLabel = deadlineDate + (' | ' + (deadlineTime + ' Uhr'));
		return $author$project$UI$TabBar$view(
			withEditAudit(
				A3(
					$author$project$Audit$PerformAuditPage$tabBarWithIcon,
					repository,
					audit,
					A2(
						$author$project$UI$TabBar$withId,
						audit.fw,
						A2(
							$author$project$UI$TabBar$withSubTitle,
							subLabel,
							$author$project$UI$TabBar$tabBar(audit.k8))))));
	});
var $author$project$Audit$PerformAuditPage$view = F3(
	function (environment, repository, page) {
		var model = page;
		var translations = $author$project$Environments$Environment$translations(environment);
		var _v0 = A2(
			$author$project$Audit$Dict$get,
			model.gm,
			$author$project$Environments$Repository$audits(repository));
		if (!_v0.$) {
			var audit = _v0.a;
			return A2(
				$author$project$UI$Page$view,
				environment,
				A2(
					$author$project$UI$Page$appendContent,
					A3($author$project$Audit$PerformAuditPage$viewMeasureEditDialog, environment, repository, model.dW),
					A2(
						$author$project$UI$Page$appendContent,
						A3($author$project$Audit$PerformAuditPage$viewMeasureCreateDialog, environment, repository, model.dV),
						A2(
							$author$project$UI$Page$appendContent,
							A4($author$project$Audit$PerformAuditPage$viewMeasureDialog, translations, environment, repository, model.fG),
							A2(
								$author$project$UI$Page$appendContent,
								A3($author$project$Audit$PerformAuditPage$viewEditAuditDialog, environment, repository, model.cN),
								A2(
									$author$project$UI$Page$appendContent,
									A2($author$project$Audit$PerformAuditPage$viewCompleteModal, translations, model.gv),
									A2(
										$author$project$UI$Page$appendContent,
										A3($author$project$Audit$PerformAuditPage$viewRecordModal, translations, environment, model.eW),
										A2(
											$author$project$UI$Page$appendContentList,
											A4($author$project$Audit$PerformAuditPage$viewContent, translations, page, repository, audit),
											A2(
												$author$project$UI$Page$appendHeader,
												A3($author$project$Audit$PerformAuditPage$viewTabBar, environment, repository, audit),
												A2(
													$author$project$UI$Page$withIcon,
													$author$project$UI$Icon$unicolor($author$project$UI$Icons$audits),
													$author$project$UI$Page$page(
														$author$project$Translations$PerformAudit$header(translations))))))))))));
		} else {
			return A2(
				$author$project$UI$Page$view,
				environment,
				A2(
					$author$project$UI$Page$appendContent,
					$author$project$Audit$PerformAuditPage$viewAuditNotFoundDialog(translations),
					A2(
						$author$project$UI$Page$withIcon,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$audits),
						$author$project$UI$Page$page(
							$author$project$Translations$PerformAudit$header(translations)))));
		}
	});
var $author$project$Page$Page$performAudit = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 3) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotPerformAuditPageMsg,
		kZ: $elm$core$Maybe$Just($author$project$Audit$PerformAuditPage$subscriptions),
		le: $author$project$Audit$PerformAuditPage$update,
		lm: $author$project$Audit$PerformAuditPage$view
	});
var $author$project$Page$Page$GotPlanPageMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Plan$Page$GotCreateDialogMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$CreateDialog$Hidden = {$: 0};
var $author$project$Plan$CreateDialog$hidden = $author$project$Plan$CreateDialog$Hidden;
var $author$project$Plan$Page$createDialog = function (page) {
	if (!page.$) {
		return $author$project$Plan$CreateDialog$hidden;
	} else {
		var model = page.a;
		return model.fi;
	}
};
var $author$project$Plan$CreateDialog$createdCreateCommand = F4(
	function (command, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				var _v1 = A3($author$project$Plan$Plan$handleCommand, command, environment, $elm$core$Maybe$Nothing);
				if (_v1.$ === 1) {
					var error = _v1.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$planErrorToString(error)),
						gH: 'Plan.CreateDialog.elm',
						gK: 'createdCreateCommand',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: $author$project$Plan$CreateDialog$Hidden,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				} else {
					var _v3 = _v1.a;
					var events = _v3.a;
					var newEnvironment = _v3.b;
					if ($author$project$Plan$Events$isEmpty(events)) {
						return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$CreateDialog$Hidden, ac: newEnvironment, ae: repository};
					} else {
						var _v4 = A3($author$project$Environments$Repository$savePlanCommandAndEvents, command, events, repository);
						var newRepository = _v4.a;
						var cmd = _v4.b;
						return {ab: cmd, jn: $author$project$Plan$CreateDialog$Hidden, ac: newEnvironment, ae: newRepository};
					}
				}
		}
	});
var $author$project$Plan$CreateDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$CreateDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CheckpointGroupEditor$Editor = $elm$core$Basics$identity;
var $author$project$Plan$CheckpointGroupEditor$collapseOrganisationUnit = F2(
	function (ouId, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{
				ca: A2(
					$elm$core$List$filter,
					function (id) {
						return !_Utils_eq(id, ouId);
					},
					editor.ca)
			});
	});
var $author$project$CheckpointData$CheckpointGroup$Ids$remove = $turboMaCk$any_set$Set$Any$remove;
var $author$project$Plan$CheckpointGroupEditor$deselectCheckpointGroup = F2(
	function (groupId, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{
				bv: A2($author$project$CheckpointData$CheckpointGroup$Ids$remove, groupId, editor.bv)
			});
	});
var $author$project$Plan$CheckpointGroupEditor$expandOrganisationUnit = F2(
	function (ouId, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{
				ca: A2($elm$core$List$cons, ouId, editor.ca)
			});
	});
var $author$project$Plan$CheckpointGroupEditor$selectCheckpointGroup = F2(
	function (groupId, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{
				bv: A2($author$project$CheckpointData$CheckpointGroup$Ids$insert, groupId, editor.bv)
			});
	});
var $author$project$Plan$CheckpointGroupEditor$update = function (msg) {
	switch (msg.$) {
		case 0:
			var ouId = msg.a;
			return $author$project$Plan$CheckpointGroupEditor$expandOrganisationUnit(ouId);
		case 1:
			var ouId = msg.a;
			return $author$project$Plan$CheckpointGroupEditor$collapseOrganisationUnit(ouId);
		case 2:
			var groupId = msg.a;
			return $author$project$Plan$CheckpointGroupEditor$selectCheckpointGroup(groupId);
		default:
			var groupId = msg.a;
			return $author$project$Plan$CheckpointGroupEditor$deselectCheckpointGroup(groupId);
	}
};
var $author$project$Plan$CreateDialog$gotCheckpointGroupEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								cX: A2($author$project$Plan$CheckpointGroupEditor$update, editorMsg, model.cX)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$GotExecutionCreateMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Plan$Execution$CreateModal$Hidden = {$: 0};
var $author$project$Plan$Execution$CreateModal$createdCreateExecution = F4(
	function (_v0, environment, repository, dialog) {
		if (!dialog.$) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$CreateModal$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$CreateModal$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$CreateModal$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Execution$CreateModal$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (!dialog.$) {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		} else {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Plan$Execution$CreateModal$Visible(
					_Utils_update(
						model,
						{
							aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
						})),
				ac: environment,
				ae: repository
			};
		}
	});
var $author$project$Plan$Schedule$ScheduleEditor$Editor = $elm$core$Basics$identity;
var $author$project$Date_Time$Month$numberOfDays = function (month) {
	switch (month) {
		case 1:
			return 29;
		case 3:
			return 30;
		case 5:
			return 30;
		case 8:
			return 30;
		case 10:
			return 30;
		default:
			return 31;
	}
};
var $author$project$Date_Time$Weekdays$remove = F2(
	function (weekday, _v0) {
		var value = _v0;
		var i = $author$project$Date_Time$Weekdays$weekdayToInt(weekday);
		return (-i) + (value | i);
	});
var $author$project$Plan$Schedule$ScheduleEditor$userEnteredCreatingTimeHour = F3(
	function (environment, hourInput, model) {
		if ($elm$core$String$isEmpty(hourInput)) {
			return _Utils_update(
				model,
				{aT: hourInput});
		} else {
			if ($elm$core$String$isEmpty(model.aU)) {
				var _v0 = $elm$core$String$toInt(hourInput);
				if (_v0.$ === 1) {
					return model;
				} else {
					var hour = _v0.a;
					return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
						model,
						{aT: hourInput}) : model;
				}
			} else {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(hourInput),
					$elm$core$String$toInt(model.aU));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var hour = _v1.a.a;
					var minute = _v1.b.a;
					var _v2 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
					if (!_v2.$) {
						var naiveTime = _v2.a;
						return _Utils_update(
							model,
							{
								aT: hourInput,
								aV: A2(
									$author$project$Date_Time$NaiveTime$toUtcTime,
									$author$project$Environments$Environment$timeOffset(environment),
									naiveTime)
							});
					} else {
						return model;
					}
				} else {
					return model;
				}
			}
		}
	});
var $author$project$Plan$Schedule$ScheduleEditor$userEnteredCreatingTimeMinute = F3(
	function (environment, minuteInput, model) {
		if ($elm$core$String$isEmpty(minuteInput)) {
			return _Utils_update(
				model,
				{aU: minuteInput});
		} else {
			if ($elm$core$String$isEmpty(model.aT)) {
				var _v0 = $elm$core$String$toInt(minuteInput);
				if (_v0.$ === 1) {
					return model;
				} else {
					var hour = _v0.a;
					return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
						model,
						{aU: minuteInput}) : model;
				}
			} else {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(model.aT),
					$elm$core$String$toInt(minuteInput));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var hour = _v1.a.a;
					var minute = _v1.b.a;
					var _v2 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
					if (!_v2.$) {
						var naiveTime = _v2.a;
						return _Utils_update(
							model,
							{
								aU: minuteInput,
								aV: A2(
									$author$project$Date_Time$NaiveTime$toUtcTime,
									$author$project$Environments$Environment$timeOffset(environment),
									naiveTime)
							});
					} else {
						return model;
					}
				} else {
					return model;
				}
			}
		}
	});
var $author$project$Plan$Schedule$ScheduleEditor$userEnteredDeadlineTimeHour = F3(
	function (environment, hourInput, model) {
		if ($elm$core$String$isEmpty(hourInput)) {
			return _Utils_update(
				model,
				{aW: hourInput});
		} else {
			if ($elm$core$String$isEmpty(model.aX)) {
				var _v0 = $elm$core$String$toInt(hourInput);
				if (_v0.$ === 1) {
					return model;
				} else {
					var hour = _v0.a;
					return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
						model,
						{aW: hourInput}) : model;
				}
			} else {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(hourInput),
					$elm$core$String$toInt(model.aX));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var hour = _v1.a.a;
					var minute = _v1.b.a;
					var _v2 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
					if (!_v2.$) {
						var naiveTime = _v2.a;
						return _Utils_update(
							model,
							{
								aW: hourInput,
								ex: A2(
									$author$project$Date_Time$NaiveTime$toUtcTime,
									$author$project$Environments$Environment$timeOffset(environment),
									naiveTime)
							});
					} else {
						return model;
					}
				} else {
					return model;
				}
			}
		}
	});
var $author$project$Plan$Schedule$ScheduleEditor$userEnteredDeadlineTimeMinute = F3(
	function (environment, minuteInput, model) {
		if ($elm$core$String$isEmpty(minuteInput)) {
			return _Utils_update(
				model,
				{aX: minuteInput});
		} else {
			if ($elm$core$String$isEmpty(model.aW)) {
				var _v0 = $elm$core$String$toInt(minuteInput);
				if (_v0.$ === 1) {
					return model;
				} else {
					var hour = _v0.a;
					return ((hour < 60) && (_Utils_cmp(hour, -1) > -1)) ? _Utils_update(
						model,
						{aX: minuteInput}) : model;
				}
			} else {
				var _v1 = _Utils_Tuple2(
					$elm$core$String$toInt(model.aW),
					$elm$core$String$toInt(minuteInput));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var hour = _v1.a.a;
					var minute = _v1.b.a;
					var _v2 = A2($author$project$Date_Time$NaiveTime$hm, hour, minute);
					if (!_v2.$) {
						var naiveTime = _v2.a;
						return _Utils_update(
							model,
							{
								aX: minuteInput,
								ex: A2(
									$author$project$Date_Time$NaiveTime$toUtcTime,
									$author$project$Environments$Environment$timeOffset(environment),
									naiveTime)
							});
					} else {
						return model;
					}
				} else {
					return model;
				}
			}
		}
	});
var $author$project$Plan$Schedule$ScheduleEditor$update = F3(
	function (environment, msg, _v0) {
		var editor = _v0;
		switch (msg.$) {
			case 0:
				if (msg.a === 3) {
					var _v2 = msg.a;
					return _Utils_update(
						editor,
						{
							dz: A3(
								$elm$core$Basics$composeR,
								$author$project$Date_Time$Month$numberOfDays,
								$elm$core$Basics$min(editor.dz),
								editor.gZ),
							as: 3
						});
				} else {
					var frequency = msg.a;
					return _Utils_update(
						editor,
						{as: frequency});
				}
			case 1:
				var interval = msg.a;
				return _Utils_update(
					editor,
					{a0: interval});
			case 2:
				var weekday = msg.a;
				return _Utils_update(
					editor,
					{
						hq: A2($author$project$Date_Time$Weekdays$insert, weekday, editor.hq)
					});
			case 3:
				var weekday = msg.a;
				return _Utils_update(
					editor,
					{
						hq: A2($author$project$Date_Time$Weekdays$remove, weekday, editor.hq)
					});
			case 4:
				var day = msg.a;
				return _Utils_update(
					editor,
					{dz: day});
			case 5:
				var month = msg.a;
				return _Utils_update(
					editor,
					{
						dz: A3(
							$elm$core$Basics$composeR,
							$author$project$Date_Time$Month$numberOfDays,
							$elm$core$Basics$min(editor.dz),
							month),
						gZ: month
					});
			case 6:
				var input = msg.a;
				return A3($author$project$Plan$Schedule$ScheduleEditor$userEnteredCreatingTimeHour, environment, input, editor);
			case 7:
				var input = msg.a;
				return A3($author$project$Plan$Schedule$ScheduleEditor$userEnteredCreatingTimeMinute, environment, input, editor);
			case 8:
				var input = msg.a;
				return A3($author$project$Plan$Schedule$ScheduleEditor$userEnteredDeadlineTimeHour, environment, input, editor);
			case 9:
				var input = msg.a;
				return A3($author$project$Plan$Schedule$ScheduleEditor$userEnteredDeadlineTimeMinute, environment, input, editor);
			case 10:
				var dateInput = msg.a;
				var _v3 = function () {
					var _v4 = $author$project$UI$DateInput$maybeDatePickerDate(dateInput);
					if (!_v4.$) {
						var newDate = _v4.a;
						return _Utils_Tuple2(newDate, $elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple2(editor.a2, editor.bO);
					}
				}();
				var startDate = _v3.a;
				var startDateTextInput = _v3.b;
				return _Utils_update(
					editor,
					{a2: startDate, bc: dateInput, bO: startDateTextInput});
			case 11:
				var input = msg.a;
				var _v5 = function () {
					var _v6 = $author$project$UI$DateInput$inputToNaivDate(
						A3($elm$core$String$replace, '.', '-', input));
					if (!_v6.$) {
						var dateValue = _v6.a;
						return _Utils_Tuple3(
							dateValue,
							$elm$core$Maybe$Nothing,
							A2($author$project$UI$DateInput$updateDatePicker, dateValue, editor.bc));
					} else {
						return _Utils_Tuple3(
							editor.a2,
							$elm$core$Maybe$Just(input),
							editor.bc);
					}
				}();
				var startDate = _v5.a;
				var startDateTextInput = _v5.b;
				var startDateInput = _v5.c;
				return _Utils_update(
					editor,
					{a2: startDate, bc: startDateInput, bO: startDateTextInput});
			case 12:
				var dateInput = msg.a;
				var _v7 = function () {
					var _v8 = $author$project$UI$DateInput$maybeDatePickerDate(dateInput);
					if (!_v8.$) {
						var newDate = _v8.a;
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(newDate),
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple2(editor.aZ, editor.bE);
					}
				}();
				var endDate = _v7.a;
				var endDateTextInput = _v7.b;
				return _Utils_update(
					editor,
					{aZ: endDate, cQ: dateInput, bE: endDateTextInput});
			default:
				var input = msg.a;
				var _v9 = function () {
					var _v10 = $author$project$UI$DateInput$inputToNaivDate(
						A3($elm$core$String$replace, '.', '-', input));
					if (!_v10.$) {
						var dateValue = _v10.a;
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(dateValue),
							$elm$core$Maybe$Nothing,
							A2($author$project$UI$DateInput$updateDatePicker, dateValue, editor.cQ));
					} else {
						return $elm$core$String$isEmpty(input) ? _Utils_Tuple3(
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(input),
							editor.cQ) : _Utils_Tuple3(
							editor.aZ,
							$elm$core$Maybe$Just(input),
							editor.cQ);
					}
				}();
				var endDate = _v9.a;
				var endDateTextInput = _v9.b;
				var endDateInput = _v9.c;
				return _Utils_update(
					editor,
					{aZ: endDate, cQ: endDateInput, bE: endDateTextInput});
		}
	});
var $author$project$Plan$Execution$CreateModal$gotScheduleEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (!dialog.$) {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		} else {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Plan$Execution$CreateModal$Visible(
					_Utils_update(
						model,
						{
							ec: A3($author$project$Plan$Schedule$ScheduleEditor$update, environment, editorMsg, model.ec)
						})),
				ac: environment,
				ae: repository
			};
		}
	});
var $author$project$Plan$Execution$CreateModal$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		if (!dialog.$) {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$CreateModal$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$CreateModal$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		if (!dialog.$) {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$CreateModal$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$CreateModal$CreatedCreateExecution = function (a) {
	return {$: 7, a: a};
};
var $author$project$Plan$Execution$Id$from = $elm$core$Basics$identity;
var $author$project$Plan$Execution$CreateModal$createExecution = F3(
	function (environment, schedule, model) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Plan$Execution$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var executionId = _v0.a;
		var newEnvironment = _v0.b;
		return _Utils_Tuple2(
			newEnvironment,
			A4(
				$author$project$Plan$Execution$Execution$Execution,
				executionId,
				$author$project$UI$BasicDataEditor$title(model.aQ),
				$author$project$UI$BasicDataEditor$description(model.aQ),
				schedule));
	});
var $author$project$Plan$Schedule$Schedule$daily = $author$project$Plan$Schedule$Schedule$Daily;
var $author$project$Date_Time$Weekdays$isEmpty = function (_v0) {
	var value = _v0;
	return !value;
};
var $author$project$Plan$Schedule$Schedule$monthly = $author$project$Plan$Schedule$Schedule$Monthly;
var $author$project$Plan$Schedule$Schedule$weekly = $author$project$Plan$Schedule$Schedule$Weekly;
var $author$project$Plan$Schedule$Schedule$yearly = $author$project$Plan$Schedule$Schedule$Yearly;
var $author$project$Plan$Schedule$ScheduleEditor$schedule = function (_v0) {
	var editor = _v0;
	var _v1 = editor.as;
	switch (_v1) {
		case 0:
			return $elm$core$Maybe$Just(
				$author$project$Plan$Schedule$Schedule$daily(
					{aV: editor.aV, ex: editor.ex, aZ: editor.aZ, a0: editor.a0, a2: editor.a2, el: editor.el}));
		case 1:
			return $author$project$Date_Time$Weekdays$isEmpty(editor.hq) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Plan$Schedule$Schedule$weekly(
					{aV: editor.aV, ex: editor.ex, aZ: editor.aZ, a0: editor.a0, a2: editor.a2, el: editor.el, hq: editor.hq}));
		case 2:
			return $elm$core$Maybe$Just(
				$author$project$Plan$Schedule$Schedule$monthly(
					{aV: editor.aV, dz: editor.dz, ex: editor.ex, aZ: editor.aZ, a0: editor.a0, a2: editor.a2, el: editor.el}));
		default:
			return $elm$core$Maybe$Just(
				$author$project$Plan$Schedule$Schedule$yearly(
					{aV: editor.aV, dz: editor.dz, ex: editor.ex, aZ: editor.aZ, a0: editor.a0, gZ: editor.gZ, a2: editor.a2, el: editor.el}));
	}
};
var $author$project$Plan$Execution$CreateModal$userClickedCreateButton = F3(
	function (environment, repository, dialog) {
		if (!dialog.$) {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		} else {
			var model = dialog.a;
			var _v1 = _Utils_Tuple2(
				$elm$core$String$trim(
					$author$project$UI$BasicDataEditor$title(model.aQ)),
				$author$project$Plan$Schedule$ScheduleEditor$schedule(model.ec));
			_v1$0:
			while (true) {
				if (_v1.b.$ === 1) {
					if (_v1.a === '') {
						break _v1$0;
					} else {
						var _v2 = _v1.b;
						return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
					}
				} else {
					if (_v1.a === '') {
						break _v1$0;
					} else {
						var schedule = _v1.b.a;
						var _v3 = A3($author$project$Plan$Execution$CreateModal$createExecution, environment, schedule, model);
						var newEnvironment = _v3.a;
						var execution = _v3.b;
						return {
							ab: A2(
								$elm$core$Task$perform,
								$elm$core$Basics$identity,
								$elm$core$Task$succeed(
									$author$project$Plan$Execution$CreateModal$CreatedCreateExecution(execution))),
							jn: dialog,
							ac: newEnvironment,
							ae: repository
						};
					}
				}
			}
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$CreateModal$ScheduleStep = 1;
var $author$project$Plan$Execution$CreateModal$switchStep = F2(
	function (step, model) {
		if (_Utils_eq(model.b0, step)) {
			return model;
		} else {
			var _v0 = model.b0;
			if (!_v0) {
				var title = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$title(model.aQ));
				var description = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$description(model.aQ));
				return $elm$core$String$isEmpty(title) ? model : _Utils_update(
					model,
					{
						aQ: A2(
							$author$project$UI$BasicDataEditor$withDescription,
							description,
							A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ)),
						b0: step
					});
			} else {
				return _Utils_update(
					model,
					{b0: step});
			}
		}
	});
var $author$project$Plan$Execution$CreateModal$nextStep = function (model) {
	var _v0 = model.b0;
	if (!_v0) {
		return A2($author$project$Plan$Execution$CreateModal$switchStep, 1, model);
	} else {
		return model;
	}
};
var $author$project$Plan$Execution$CreateModal$userClickedNextButton = F3(
	function (environment, repository, dialog) {
		if (!dialog.$) {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		} else {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Plan$Execution$CreateModal$Visible(
					$author$project$Plan$Execution$CreateModal$nextStep(model)),
				ac: environment,
				ae: repository
			};
		}
	});
var $author$project$Plan$Execution$CreateModal$userClickedStepIcon = F4(
	function (step, environment, repository, dialog) {
		if (!dialog.$) {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		} else {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Plan$Execution$CreateModal$Visible(
					A2($author$project$Plan$Execution$CreateModal$switchStep, step, model)),
				ac: environment,
				ae: repository
			};
		}
	});
var $author$project$Plan$Execution$CreateModal$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Plan$Execution$CreateModal$userClickedCloseDialog;
		case 1:
			return $author$project$Plan$Execution$CreateModal$userClickedNextButton;
		case 2:
			var step = msg.a;
			return $author$project$Plan$Execution$CreateModal$userClickedStepIcon(step);
		case 3:
			return $author$project$Plan$Execution$CreateModal$userClickedCancelButton;
		case 4:
			return $author$project$Plan$Execution$CreateModal$userClickedCreateButton;
		case 5:
			var editorMsg = msg.a;
			return $author$project$Plan$Execution$CreateModal$gotBasicDataEditorMsg(editorMsg);
		case 6:
			var editorMsg = msg.a;
			return $author$project$Plan$Execution$CreateModal$gotScheduleEditorMsg(editorMsg);
		default:
			var execution = msg.a;
			return $author$project$Plan$Execution$CreateModal$createdCreateExecution(execution);
	}
};
var $author$project$Plan$CreateDialog$gotExecutionCreateMsg = F4(
	function (dialogMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var updatedExecution = function () {
					if (dialogMsg.$ === 7) {
						var execution = dialogMsg.a;
						return A2(
							$elm$core$List$append,
							model.fr,
							$elm$core$List$singleton(execution));
					} else {
						return model.fr;
					}
				}();
				var result = A4($author$project$Plan$Execution$CreateModal$update, dialogMsg, environment, repository, model.dF);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Plan$CreateDialog$GotExecutionCreateMsg, result.ab),
					jn: $author$project$Plan$CreateDialog$Visible(
						_Utils_update(
							model,
							{dF: result.jn, fr: updatedExecution})),
					ac: result.ac,
					ae: result.ae
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$GotExecutionEditMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Plan$Execution$EditModal$Hidden = {$: 0};
var $author$project$Plan$Execution$EditModal$closeDialog = F4(
	function (_v0, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$EditModal$Hidden, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$EditModal$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$EditModal$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$EditModal$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Execution$EditModal$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$Execution$EditModal$Visible(
						_Utils_update(
							model,
							{
								aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$EditModal$gotScheduleEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$Execution$EditModal$Visible(
						_Utils_update(
							model,
							{
								ec: A3($author$project$Plan$Schedule$ScheduleEditor$update, environment, editorMsg, model.ec)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$EditModal$ChangedExecution = function (a) {
	return {$: 8, a: a};
};
var $author$project$Plan$Execution$EditModal$changeExecution = F2(
	function (schedule, model) {
		var execution = model.jw;
		return _Utils_update(
			execution,
			{
				aY: $author$project$UI$BasicDataEditor$description(model.aQ),
				hd: schedule,
				k8: $author$project$UI$BasicDataEditor$title(model.aQ)
			});
	});
var $author$project$Plan$Execution$EditModal$userClickedApplyButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = $author$project$Plan$Schedule$ScheduleEditor$schedule(model.ec);
				if (!_v1.$) {
					var schedule = _v1.a;
					if ($elm$core$String$isEmpty(
						$author$project$UI$BasicDataEditor$title(model.aQ)) || (_Utils_eq(
						$author$project$UI$BasicDataEditor$title(model.aQ),
						model.jw.k8) && (_Utils_eq(
						$author$project$UI$BasicDataEditor$description(model.aQ),
						model.jw.aY) && _Utils_eq(schedule, model.jw.hd)))) {
						return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
					} else {
						var execution = A2($author$project$Plan$Execution$EditModal$changeExecution, schedule, model);
						return {
							ab: A2(
								$elm$core$Task$perform,
								$elm$core$Basics$identity,
								$elm$core$Task$succeed(
									$author$project$Plan$Execution$EditModal$ChangedExecution(execution))),
							jn: dialog,
							ac: environment,
							ae: repository
						};
					}
				} else {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$EditModal$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$EditModal$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$EditModal$userClickedCloseButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$EditModal$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$EditModal$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$EditModal$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$EditModal$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$Execution$EditModal$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$EditModal$Deleteexecution = function (a) {
	return {$: 9, a: a};
};
var $author$project$Plan$Execution$EditModal$userClickedDeleteButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: A2(
						$elm$core$Task$perform,
						$elm$core$Basics$identity,
						$elm$core$Task$succeed(
							$author$project$Plan$Execution$EditModal$Deleteexecution(model.jw))),
					jn: $author$project$Plan$Execution$EditModal$Hidden,
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$EditModal$BasicDataTab = 0;
var $author$project$Plan$Execution$EditModal$ScheduleTab = 1;
var $author$project$Plan$Execution$EditModal$switchTab = F2(
	function (tab, model) {
		if (_Utils_eq(model.cI, tab)) {
			return model;
		} else {
			if (!model.cI) {
				var title = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$title(model.aQ));
				var description = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$description(model.aQ));
				return $elm$core$String$isEmpty(title) ? model : _Utils_update(
					model,
					{
						aQ: A2(
							$author$project$UI$BasicDataEditor$withDescription,
							description,
							A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ)),
						cI: tab
					});
			} else {
				if (model.cI === 1) {
					return $author$project$Utils$Maybe$isNothing(
						$author$project$Plan$Schedule$ScheduleEditor$schedule(model.ec)) ? model : ($author$project$Utils$Maybe$isNothing(
						$author$project$Plan$Schedule$ScheduleEditor$schedule(model.ec)) ? model : _Utils_update(
						model,
						{cI: tab}));
				} else {
					return _Utils_update(
						model,
						{cI: tab});
				}
			}
		}
	});
var $author$project$Plan$Execution$EditModal$userClickedTabIcon = F4(
	function (tab, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$Execution$EditModal$Visible(
						A2($author$project$Plan$Execution$EditModal$switchTab, tab, model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$EditModal$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Plan$Execution$EditModal$userClickedCloseDialog;
		case 1:
			var tab = msg.a;
			return $author$project$Plan$Execution$EditModal$userClickedTabIcon(tab);
		case 2:
			return $author$project$Plan$Execution$EditModal$userClickedCancelButton;
		case 3:
			return $author$project$Plan$Execution$EditModal$userClickedApplyButton;
		case 4:
			return $author$project$Plan$Execution$EditModal$userClickedDeleteButton;
		case 5:
			return $author$project$Plan$Execution$EditModal$userClickedCloseButton;
		case 6:
			var editorMsg = msg.a;
			return $author$project$Plan$Execution$EditModal$gotBasicDataEditorMsg(editorMsg);
		case 7:
			var editorMsg = msg.a;
			return $author$project$Plan$Execution$EditModal$gotScheduleEditorMsg(editorMsg);
		case 8:
			var execution = msg.a;
			return $author$project$Plan$Execution$EditModal$closeDialog(execution);
		default:
			var execution = msg.a;
			return $author$project$Plan$Execution$EditModal$closeDialog(execution);
	}
};
var $author$project$Plan$CreateDialog$gotExecutionEditMsg = F4(
	function (dialogMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var updatedExecutions = function () {
					switch (dialogMsg.$) {
						case 8:
							var changedExecution = dialogMsg.a;
							var replaceExecution = function (oldExecution) {
								return _Utils_eq(oldExecution.dH, changedExecution.dH) ? changedExecution : oldExecution;
							};
							return A2($elm$core$List$map, replaceExecution, model.fr);
						case 9:
							var deletedExecution = dialogMsg.a;
							return A2(
								$elm$core$List$filter,
								function (execution) {
									return !_Utils_eq(execution.dH, deletedExecution.dH);
								},
								model.fr);
						default:
							return model.fr;
					}
				}();
				var result = A4($author$project$Plan$Execution$EditModal$update, dialogMsg, environment, repository, model.dG);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Plan$CreateDialog$GotExecutionEditMsg, result.ab),
					jn: $author$project$Plan$CreateDialog$Visible(
						_Utils_update(
							model,
							{dG: result.jn, fr: updatedExecutions})),
					ac: result.ac,
					ae: result.ae
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Execution$CreateModal$BasicDataStep = 0;
var $author$project$Plan$Schedule$ScheduleEditor$default = function (today) {
	var deadlineTime = A3($author$project$Date_Time$NaiveTime$NaiveTime, 18, 0, 0);
	var creatingTime = A3($author$project$Date_Time$NaiveTime$NaiveTime, 6, 0, 0);
	return {
		aT: $elm$core$String$fromInt(
			$author$project$Date_Time$NaiveTime$hour(creatingTime)),
		aU: $elm$core$String$fromInt(
			$author$project$Date_Time$NaiveTime$minute(creatingTime)),
		aV: creatingTime,
		dz: $author$project$Date_Time$NaiveDate$day(today),
		aW: $elm$core$String$fromInt(
			$author$project$Date_Time$NaiveTime$hour(deadlineTime)),
		aX: $elm$core$String$fromInt(
			$author$project$Date_Time$NaiveTime$minute(deadlineTime)),
		ex: deadlineTime,
		aZ: $elm$core$Maybe$Nothing,
		cQ: $author$project$UI$DateInput$collapsed,
		bE: $elm$core$Maybe$Nothing,
		as: 0,
		a0: 1,
		gZ: $author$project$Date_Time$NaiveDate$month(today),
		a2: today,
		bc: $author$project$UI$DateInput$collapsed,
		bO: $elm$core$Maybe$Nothing,
		el: 'Europe/Berlin',
		lb: today,
		hq: $author$project$Date_Time$Weekdays$empty
	};
};
var $author$project$Plan$Execution$CreateModal$show = function (today) {
	return $author$project$Plan$Execution$CreateModal$Visible(
		{
			aQ: $author$project$UI$BasicDataEditor$default,
			b0: 0,
			ec: $author$project$Plan$Schedule$ScheduleEditor$default(today)
		});
};
var $author$project$Plan$CreateDialog$userClickedCrateExecution = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								dF: $author$project$Plan$Execution$CreateModal$show(model.lb)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$CreatedCreateCommand = function (a) {
	return {$: 13, a: a};
};
var $author$project$Plan$CreateDialog$HandlingCommand = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$CheckpointGroupEditor$unwrap = function (_v0) {
	var editor = _v0;
	return editor;
};
var $author$project$Plan$CheckpointGroupEditor$checkpointGroupIds = A2(
	$elm$core$Basics$composeR,
	$author$project$Plan$CheckpointGroupEditor$unwrap,
	function ($) {
		return $.bv;
	});
var $author$project$Plan$Command$commandHelper = F2(
	function (environment, buildCommand) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Types$CommandId$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var commandId_ = _v0.a;
		var newEnvironment = _v0.b;
		return _Utils_Tuple2(
			newEnvironment,
			A2(
				$elm$core$Task$map,
				buildCommand(commandId_),
				$elm$time$Time$now));
	});
var $author$project$Plan$Command$create = F2(
	function (environment, model) {
		return A2(
			$author$project$Plan$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Plan$Command$Create(
						{bT: model.bT, gt: model.gt, L: commandId_, M: commandTimestamp, aY: model.aY, fr: model.fr, d5: model.d5, k8: model.k8});
				}));
	});
var $author$project$Plan$Id$from = $elm$core$Basics$identity;
var $author$project$Plan$CreateDialog$createCommand = F2(
	function (environment, model) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Plan$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var planId = _v0.a;
		var newEnvironment = _v0.b;
		return A2(
			$author$project$Plan$Command$create,
			newEnvironment,
			{
				bT: model.cv,
				gt: $author$project$Plan$CheckpointGroupEditor$checkpointGroupIds(model.cX),
				aY: $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$description(model.aQ)),
				fr: model.fr,
				d5: planId,
				k8: $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$title(model.aQ))
			});
	});
var $author$project$Plan$CreateDialog$userClickedCreateButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$title(model.aQ));
				if (_v1 === '') {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				} else {
					var _v2 = A2($author$project$Plan$CreateDialog$createCommand, environment, model);
					var newEnvironment = _v2.a;
					var task = _v2.b;
					return {
						ab: A2($elm$core$Task$perform, $author$project$Plan$CreateDialog$CreatedCreateCommand, task),
						jn: $author$project$Plan$CreateDialog$HandlingCommand(model),
						ac: newEnvironment,
						ae: repository
					};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Schedule$Schedule$creatingTime = function (schedule) {
	switch (schedule.$) {
		case 0:
			var model = schedule.a;
			return model.aV;
		case 1:
			var model = schedule.a;
			return model.aV;
		case 2:
			var model = schedule.a;
			return model.aV;
		default:
			var model = schedule.a;
			return model.aV;
	}
};
var $author$project$Plan$Schedule$Schedule$day = function (schedule) {
	switch (schedule.$) {
		case 2:
			var model = schedule.a;
			return $elm$core$Maybe$Just(model.dz);
		case 3:
			var model = schedule.a;
			return $elm$core$Maybe$Just(model.dz);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$Schedule$Schedule$deadlineTime = function (schedule) {
	switch (schedule.$) {
		case 0:
			var model = schedule.a;
			return model.ex;
		case 1:
			var model = schedule.a;
			return model.ex;
		case 2:
			var model = schedule.a;
			return model.ex;
		default:
			var model = schedule.a;
			return model.ex;
	}
};
var $author$project$Plan$Schedule$Schedule$endDate = function (schedule) {
	switch (schedule.$) {
		case 0:
			var model = schedule.a;
			return model.aZ;
		case 1:
			var model = schedule.a;
			return model.aZ;
		case 2:
			var model = schedule.a;
			return model.aZ;
		default:
			var model = schedule.a;
			return model.aZ;
	}
};
var $author$project$Plan$Schedule$Schedule$frequency = function (schedule) {
	switch (schedule.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Plan$Schedule$Schedule$interval = function (schedule) {
	switch (schedule.$) {
		case 0:
			var model = schedule.a;
			return model.a0;
		case 1:
			var model = schedule.a;
			return model.a0;
		case 2:
			var model = schedule.a;
			return model.a0;
		default:
			var model = schedule.a;
			return model.a0;
	}
};
var $author$project$Plan$Schedule$Schedule$month = function (schedule) {
	if (schedule.$ === 3) {
		var model = schedule.a;
		return $elm$core$Maybe$Just(model.gZ);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$Schedule$Schedule$startDate = function (schedule) {
	switch (schedule.$) {
		case 0:
			var model = schedule.a;
			return model.a2;
		case 1:
			var model = schedule.a;
			return model.a2;
		case 2:
			var model = schedule.a;
			return model.a2;
		default:
			var model = schedule.a;
			return model.a2;
	}
};
var $author$project$Plan$Schedule$Schedule$timeZone = function (schedule) {
	switch (schedule.$) {
		case 0:
			var model = schedule.a;
			return model.el;
		case 1:
			var model = schedule.a;
			return model.el;
		case 2:
			var model = schedule.a;
			return model.el;
		default:
			var model = schedule.a;
			return model.el;
	}
};
var $author$project$Plan$Schedule$Schedule$weekdays = function (schedule) {
	if (schedule.$ === 1) {
		var model = schedule.a;
		return $elm$core$Maybe$Just(model.hq);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plan$Schedule$ScheduleEditor$withSchedule = F3(
	function (schedule_, environment, _v0) {
		var editor = _v0;
		var hourOffset = (3600000 / $author$project$Environments$Environment$timeOffset(environment)) | 0;
		var deadlineTime = $author$project$Plan$Schedule$Schedule$deadlineTime(schedule_);
		var creatingTime = $author$project$Plan$Schedule$Schedule$creatingTime(schedule_);
		return _Utils_update(
			editor,
			{
				aT: $elm$core$String$fromInt(
					$author$project$Date_Time$NaiveTime$hour(creatingTime) + hourOffset),
				aU: $elm$core$String$fromInt(
					$author$project$Date_Time$NaiveTime$minute(creatingTime)),
				aV: $author$project$Plan$Schedule$Schedule$creatingTime(schedule_),
				dz: A2(
					$elm$core$Maybe$withDefault,
					1,
					$author$project$Plan$Schedule$Schedule$day(schedule_)),
				aW: $elm$core$String$fromInt(
					$author$project$Date_Time$NaiveTime$hour(deadlineTime) + hourOffset),
				aX: $elm$core$String$fromInt(
					$author$project$Date_Time$NaiveTime$minute(deadlineTime)),
				ex: $author$project$Plan$Schedule$Schedule$deadlineTime(schedule_),
				aZ: $author$project$Plan$Schedule$Schedule$endDate(schedule_),
				cQ: $author$project$UI$DateInput$collapsed,
				as: $author$project$Plan$Schedule$Schedule$frequency(schedule_),
				a0: $author$project$Plan$Schedule$Schedule$interval(schedule_),
				gZ: A2(
					$elm$core$Maybe$withDefault,
					editor.gZ,
					$author$project$Plan$Schedule$Schedule$month(schedule_)),
				a2: $author$project$Plan$Schedule$Schedule$startDate(schedule_),
				bc: $author$project$UI$DateInput$collapsed,
				el: $author$project$Plan$Schedule$Schedule$timeZone(schedule_),
				hq: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Date_Time$Weekdays$empty,
					$author$project$Plan$Schedule$Schedule$weekdays(schedule_))
			});
	});
var $author$project$Plan$Schedule$ScheduleEditor$fromSchedule = F3(
	function (today, environment, schedule_) {
		return A3(
			$author$project$Plan$Schedule$ScheduleEditor$withSchedule,
			schedule_,
			environment,
			$author$project$Plan$Schedule$ScheduleEditor$default(today));
	});
var $author$project$Plan$Execution$EditModal$show = F3(
	function (execution, environment, today) {
		return $author$project$Plan$Execution$EditModal$Visible(
			{
				aQ: $author$project$UI$BasicDataEditor$from(execution),
				cI: 0,
				jw: execution,
				ec: A3($author$project$Plan$Schedule$ScheduleEditor$fromSchedule, today, environment, execution.hd)
			});
	});
var $author$project$Plan$CreateDialog$userClickedEditExecution = F4(
	function (execution, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								dG: A3($author$project$Plan$Execution$EditModal$show, execution, environment, model.lb)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$AuditorsStep = 3;
var $author$project$Plan$CreateDialog$CheckpointGroupsStep = 2;
var $author$project$Plan$CreateDialog$ExecutionStep = 1;
var $author$project$Plan$CreateDialog$switchStep = F2(
	function (step, model) {
		if (_Utils_eq(model.b0, step)) {
			return model;
		} else {
			var _v0 = model.b0;
			switch (_v0) {
				case 0:
					var title = $elm$core$String$trim(
						$author$project$UI$BasicDataEditor$title(model.aQ));
					var description = $elm$core$String$trim(
						$author$project$UI$BasicDataEditor$description(model.aQ));
					return $elm$core$String$isEmpty(title) ? model : _Utils_update(
						model,
						{
							aQ: A2(
								$author$project$UI$BasicDataEditor$withDescription,
								description,
								A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ)),
							b0: step
						});
				case 1:
					return _Utils_update(
						model,
						{b0: step});
				case 2:
					return $author$project$CheckpointData$CheckpointGroup$Ids$isEmpty(
						$author$project$Plan$CheckpointGroupEditor$checkpointGroupIds(model.cX)) ? model : _Utils_update(
						model,
						{b0: step});
				default:
					return _Utils_update(
						model,
						{b0: step});
			}
		}
	});
var $author$project$Plan$CreateDialog$nextStep = function (model) {
	var _v0 = model.b0;
	switch (_v0) {
		case 0:
			return A2($author$project$Plan$CreateDialog$switchStep, 1, model);
		case 1:
			return A2($author$project$Plan$CreateDialog$switchStep, 2, model);
		case 2:
			return A2($author$project$Plan$CreateDialog$switchStep, 3, model);
		default:
			return model;
	}
};
var $author$project$Plan$CreateDialog$userClickedNextButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$CreateDialog$Visible(
						$author$project$Plan$CreateDialog$nextStep(model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$userClickedStepIcon = F4(
	function (step, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$CreateDialog$Visible(
						A2($author$project$Plan$CreateDialog$switchStep, step, model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$userSelectedAuditor = F4(
	function (auditorId, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								cv: A2($author$project$User$Ids$insert, auditorId, model.cv)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$userUnselectedAuditor = F4(
	function (auditorId, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								cv: A2($author$project$User$Ids$remove, auditorId, model.cv)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Plan$CreateDialog$userClickedCloseDialog;
		case 1:
			return $author$project$Plan$CreateDialog$userClickedNextButton;
		case 2:
			var step = msg.a;
			return $author$project$Plan$CreateDialog$userClickedStepIcon(step);
		case 3:
			return $author$project$Plan$CreateDialog$userClickedCancelButton;
		case 4:
			return $author$project$Plan$CreateDialog$userClickedCreateButton;
		case 5:
			var editorMsg = msg.a;
			return $author$project$Plan$CreateDialog$gotBasicDataEditorMsg(editorMsg);
		case 6:
			return $author$project$Plan$CreateDialog$userClickedCrateExecution;
		case 7:
			var dialogMsg = msg.a;
			return $author$project$Plan$CreateDialog$gotExecutionCreateMsg(dialogMsg);
		case 8:
			var execution = msg.a;
			return $author$project$Plan$CreateDialog$userClickedEditExecution(execution);
		case 9:
			var dialogMsg = msg.a;
			return $author$project$Plan$CreateDialog$gotExecutionEditMsg(dialogMsg);
		case 10:
			var editorMsg = msg.a;
			return $author$project$Plan$CreateDialog$gotCheckpointGroupEditorMsg(editorMsg);
		case 11:
			var auditorId = msg.a;
			return $author$project$Plan$CreateDialog$userSelectedAuditor(auditorId);
		case 12:
			var auditorId = msg.a;
			return $author$project$Plan$CreateDialog$userUnselectedAuditor(auditorId);
		default:
			var command = msg.a;
			return $author$project$Plan$CreateDialog$createdCreateCommand(command);
	}
};
var $author$project$Plan$Page$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Page$withCreateDialog = F2(
	function (createDialog_, page) {
		if (!page.$) {
			return page;
		} else {
			var model = page.a;
			return $author$project$Plan$Page$Loaded(
				_Utils_update(
					model,
					{fi: createDialog_}));
		}
	});
var $author$project$Plan$Page$gotCreateDialogMessage = F4(
	function (msg, environment, repository, page) {
		var result = A4(
			$author$project$Plan$CreateDialog$update,
			msg,
			environment,
			repository,
			$author$project$Plan$Page$createDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Plan$Page$GotCreateDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$Plan$Page$withCreateDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$Plan$Page$GotEditDialogMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Plan$EditDialog$Hidden = {$: 0};
var $author$project$Plan$EditDialog$hidden = $author$project$Plan$EditDialog$Hidden;
var $author$project$Plan$Page$editDialog = function (page) {
	if (!page.$) {
		return $author$project$Plan$EditDialog$hidden;
	} else {
		var model = page.a;
		return model.cO;
	}
};
var $author$project$Plan$EditDialog$Deleted = {$: 3};
var $author$project$Plan$Commands$fromList = $author$project$Types$Queue$fromList;
var $author$project$Plan$Commands$fold = $author$project$Types$Queue$fold;
var $author$project$Plan$Plan$handleCommands = F3(
	function (commands, environment, maybePlan) {
		var acc = $elm$core$Result$Ok(
			{
				cD: $author$project$Plan$Commands$empty,
				ac: environment,
				b8: $author$project$Plan$Events$empty,
				au: $author$project$Plan$Plan$NotModified(maybePlan)
			});
		return A2(
			$elm$core$Result$map,
			A3(
				$author$project$Utils$Triple$with,
				function ($) {
					return $.cD;
				},
				function ($) {
					return $.b8;
				},
				function ($) {
					return $.ac;
				}),
			A3(
				$author$project$Plan$Commands$fold,
				A2($elm$core$Basics$composeR, $author$project$Plan$Plan$handleCommandHelper, $elm$core$Result$andThen),
				acc,
				commands));
	});
var $author$project$Plan$EditDialog$createdCommands = F4(
	function (commands, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 2:
				var model = dialog.a;
				var _v1 = A3(
					$author$project$Plan$Plan$handleCommands,
					$author$project$Plan$Commands$fromList(commands),
					environment,
					A2($author$project$Environments$Repository$getPlan, model.aK.d5, repository));
				if (_v1.$ === 1) {
					if (!_v1.a.$) {
						return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$EditDialog$Deleted, ac: environment, ae: repository};
					} else {
						var msg = _v1.a.a;
						var _v2 = A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Environments$ErrorHandling$Id$from,
							$author$project$Environments$Environment$generateUuid(environment));
						var newId = _v2.a;
						var newEnvironment = _v2.b;
						var newError = {
							gg: '',
							gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
								$author$project$Environments$ErrorHandling$ToString$planErrorToString(
									$author$project$Plan$Plan$DoesNotExist(msg))),
							gH: 'Plan.EditDialog.elm',
							gK: 'createdCommands',
							fw: newId
						};
						return {
							ab: $elm$core$Platform$Cmd$none,
							jn: $author$project$Plan$EditDialog$Hidden,
							ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
							ae: repository
						};
					}
				} else {
					var _v3 = _v1.a;
					var newCommands = _v3.a;
					var newEvents = _v3.b;
					var newEnvironment = _v3.c;
					if ($author$project$Plan$Commands$isEmpty(newCommands) || $author$project$Plan$Events$isEmpty(newEvents)) {
						return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$EditDialog$Hidden, ac: newEnvironment, ae: repository};
					} else {
						var _v4 = A3($author$project$Environments$Repository$savePlanCommandsAndEvents, newCommands, newEvents, repository);
						var newRepository = _v4.a;
						var cmd = _v4.b;
						return {ab: cmd, jn: $author$project$Plan$EditDialog$Hidden, ac: newEnvironment, ae: newRepository};
					}
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$EditDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$EditDialog$Visible(
						_Utils_update(
							model,
							{
								aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
							})),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$gotCheckpointGroupEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$EditDialog$Visible(
						_Utils_update(
							model,
							{
								cX: A2($author$project$Plan$CheckpointGroupEditor$update, editorMsg, model.cX)
							})),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$GotExecutionCreateMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Plan$EditDialog$gotExecutionCreateMsg = F4(
	function (dialogMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var updatedExecutions = function () {
					if (dialogMsg.$ === 7) {
						var execution = dialogMsg.a;
						return A2(
							$elm$core$List$append,
							model.av,
							$elm$core$List$singleton(execution));
					} else {
						return model.av;
					}
				}();
				var result = A4($author$project$Plan$Execution$CreateModal$update, dialogMsg, environment, repository, model.dF);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Plan$EditDialog$GotExecutionCreateMsg, result.ab),
					jn: $author$project$Plan$EditDialog$Visible(
						_Utils_update(
							model,
							{dF: result.jn, av: updatedExecutions})),
					ac: result.ac,
					ae: result.ae
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$GotExecutionEditMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Plan$EditDialog$gotExecutionEditMsg = F4(
	function (dialogMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var result = A4($author$project$Plan$Execution$EditModal$update, dialogMsg, environment, repository, model.dG);
				var idsOfNew = A2(
					$elm$core$List$map,
					function (execution) {
						return execution.dH;
					},
					model.av);
				switch (dialogMsg.$) {
					case 8:
						var changedExecution = dialogMsg.a;
						var updateExecution = function (newExecution) {
							return _Utils_eq(newExecution.dH, changedExecution.dH) ? changedExecution : newExecution;
						};
						var _v2 = A2($elm$core$List$member, changedExecution.dH, idsOfNew) ? _Utils_Tuple2(
							A2($elm$core$List$map, updateExecution, model.av),
							model.aS) : (A2(
							$elm$core$List$member,
							changedExecution.dH,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.dH;
								},
								model.aS)) ? _Utils_Tuple2(
							model.av,
							A2($elm$core$List$map, updateExecution, model.aS)) : _Utils_Tuple2(
							model.av,
							A2(
								$elm$core$List$append,
								model.aS,
								$elm$core$List$singleton(changedExecution))));
						var newExecutions = _v2.a;
						var changedExecutions = _v2.b;
						return {
							ab: A2($elm$core$Platform$Cmd$map, $author$project$Plan$EditDialog$GotExecutionEditMsg, result.ab),
							jn: $author$project$Plan$EditDialog$Visible(
								_Utils_update(
									model,
									{aS: changedExecutions, dG: result.jn, av: newExecutions})),
							ac: result.ac,
							ae: result.ae
						};
					case 9:
						var deletedExecution = dialogMsg.a;
						var _v3 = A2($elm$core$List$member, deletedExecution.dH, idsOfNew) ? _Utils_Tuple3(
							A2(
								$elm$core$List$filter,
								function (execution) {
									return !_Utils_eq(execution.dH, deletedExecution.dH);
								},
								model.av),
							A2(
								$elm$core$List$filter,
								function (execution) {
									return !_Utils_eq(execution.dH, deletedExecution.dH);
								},
								model.aS),
							model.cK) : _Utils_Tuple3(
							model.av,
							model.aS,
							A2(
								$elm$core$List$append,
								model.cK,
								$elm$core$List$singleton(deletedExecution.dH)));
						var newExecutions = _v3.a;
						var changedExecutions = _v3.b;
						var deletedExecutions = _v3.c;
						return {
							ab: A2($elm$core$Platform$Cmd$map, $author$project$Plan$EditDialog$GotExecutionEditMsg, result.ab),
							jn: $author$project$Plan$EditDialog$Visible(
								_Utils_update(
									model,
									{aS: changedExecutions, cK: deletedExecutions, dG: result.jn, av: newExecutions})),
							ac: result.ac,
							ae: result.ae
						};
					default:
						return {
							ab: A2($elm$core$Platform$Cmd$map, $author$project$Plan$EditDialog$GotExecutionEditMsg, result.ab),
							jn: $author$project$Plan$EditDialog$Visible(
								_Utils_update(
									model,
									{dG: result.jn})),
							ac: result.ac,
							ae: result.ae
						};
				}
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$CreatedCommands = function (a) {
	return {$: 14, a: a};
};
var $author$project$Plan$EditDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$Command$addExecution = F4(
	function (environment, planId, titleForError, execution) {
		return A2(
			$author$project$Plan$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Plan$Command$AddExecution(
						{L: commandId_, M: commandTimestamp, jw: execution, d5: planId, l: titleForError});
				}));
	});
var $author$project$Plan$EditDialog$withAddedExecutionCommand = F3(
	function (plan, newExecutions, acc) {
		var createAddCommands = F2(
			function (execution, _v0) {
				var environment_ = _v0.a;
				var tasks_ = _v0.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$List$cons, task, tasks_);
					},
					A4($author$project$Plan$Command$addExecution, environment_, plan.d5, plan.k8, execution));
			});
		return A3($elm$core$List$foldl, createAddCommands, acc, newExecutions);
	});
var $author$project$Plan$Command$addCheckpointGroups = F2(
	function (environment, model) {
		return A2(
			$author$project$Plan$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Plan$Command$ChangeCheckpointGroups(
						{e7: model.e7, L: commandId_, M: commandTimestamp, d5: model.d5, fY: model.fY, l: model.l});
				}));
	});
var $author$project$Plan$EditDialog$withChangeCheckpointGroupsCommand = F3(
	function (plan, selectedCheckpointGroups, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var removeCheckpointGroups = A2($author$project$CheckpointData$CheckpointGroup$Ids$diff, plan.gt, selectedCheckpointGroups);
		var newCheckpointGroups = A2($author$project$CheckpointData$CheckpointGroup$Ids$diff, selectedCheckpointGroups, plan.gt);
		return ($author$project$CheckpointData$CheckpointGroup$Ids$isEmpty(newCheckpointGroups) && $author$project$CheckpointData$CheckpointGroup$Ids$isEmpty(removeCheckpointGroups)) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$Plan$Command$addCheckpointGroups,
				environment,
				{e7: newCheckpointGroups, d5: plan.d5, fY: removeCheckpointGroups, l: plan.k8}));
	});
var $author$project$Plan$Command$changeDescription = F2(
	function (environment, model) {
		return A2(
			$author$project$Plan$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Plan$Command$ChangeDescription(
						{L: commandId_, M: commandTimestamp, aY: model.aY, d5: model.d5, l: model.l});
				}));
	});
var $author$project$Plan$EditDialog$withChangeDescriptionCommand = F3(
	function (plan, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(
			$author$project$UI$BasicDataEditor$description(basicDataEditor),
			plan.aY) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$Plan$Command$changeDescription,
				environment,
				{
					aY: $elm$core$String$trim(
						$author$project$UI$BasicDataEditor$description(basicDataEditor)),
					d5: plan.d5,
					l: plan.k8
				}));
	});
var $author$project$Plan$Command$changeTitle = F2(
	function (environment, model) {
		return A2(
			$author$project$Plan$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Plan$Command$ChangeTitle(
						{L: commandId_, M: commandTimestamp, d5: model.d5, k8: model.k8, l: model.l});
				}));
	});
var $author$project$Plan$EditDialog$withChangeTitleCommand = F3(
	function (plan, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var _v1 = $elm$core$String$trim(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		if (_v1 === '') {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var title = _v1;
			return _Utils_eq(title, plan.k8) ? _Utils_Tuple2(environment, tasks) : A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2(
					$author$project$Plan$Command$changeTitle,
					environment,
					{d5: plan.d5, k8: title, l: plan.k8}));
		}
	});
var $author$project$Plan$Command$addAuditors = F2(
	function (environment, model) {
		return A2(
			$author$project$Plan$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Plan$Command$ChangeAuditors(
						{ge: model.ge, L: commandId_, M: commandTimestamp, d5: model.d5, g9: model.g9, l: model.l});
				}));
	});
var $author$project$Plan$EditDialog$withChangedAuditorsCommand = F3(
	function (plan, selectedAuditors, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var removedUsers = A2($author$project$User$Ids$diff, plan.bT, selectedAuditors);
		var newAddedUsers = A2($author$project$User$Ids$diff, selectedAuditors, plan.bT);
		return ($author$project$User$Ids$isEmpty(newAddedUsers) && $author$project$User$Ids$isEmpty(removedUsers)) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$Plan$Command$addAuditors,
				environment,
				{ge: newAddedUsers, d5: plan.d5, g9: removedUsers, l: plan.k8}));
	});
var $author$project$Plan$Command$removeExecution = F4(
	function (environment, planId, titleForError, executionId) {
		return A2(
			$author$project$Plan$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Plan$Command$RemoveExecution(
						{L: commandId_, M: commandTimestamp, dH: executionId, d5: planId, l: titleForError});
				}));
	});
var $author$project$Plan$EditDialog$withDeleteExecutionCommand = F3(
	function (plan, deletedExecutions, acc) {
		var createAddCommands = F2(
			function (executionId, _v0) {
				var environment_ = _v0.a;
				var tasks_ = _v0.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$List$cons, task, tasks_);
					},
					A4($author$project$Plan$Command$removeExecution, environment_, plan.d5, plan.k8, executionId));
			});
		return A3($elm$core$List$foldl, createAddCommands, acc, deletedExecutions);
	});
var $author$project$Plan$Command$changeExecution = F4(
	function (environment, planId, titleForError, execution) {
		return A2(
			$author$project$Plan$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Plan$Command$ChangeExecution(
						{L: commandId_, M: commandTimestamp, jw: execution, d5: planId, l: titleForError});
				}));
	});
var $author$project$Plan$EditDialog$withEditExecutionCommand = F3(
	function (plan, changedExecutions, acc) {
		var createAddCommands = F2(
			function (execution, _v0) {
				var environment_ = _v0.a;
				var tasks_ = _v0.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$List$cons, task, tasks_);
					},
					A4($author$project$Plan$Command$changeExecution, environment_, plan.d5, plan.k8, execution));
			});
		return A3($elm$core$List$foldl, createAddCommands, acc, changedExecutions);
	});
var $author$project$Plan$EditDialog$createCommands = F2(
	function (environment, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A3(
				$author$project$Plan$EditDialog$withChangeCheckpointGroupsCommand,
				model.aK,
				$author$project$Plan$CheckpointGroupEditor$checkpointGroupIds(model.cX),
				A3(
					$author$project$Plan$EditDialog$withChangedAuditorsCommand,
					model.aK,
					model.cv,
					A3(
						$author$project$Plan$EditDialog$withDeleteExecutionCommand,
						model.aK,
						model.cK,
						A3(
							$author$project$Plan$EditDialog$withEditExecutionCommand,
							model.aK,
							model.aS,
							A3(
								$author$project$Plan$EditDialog$withAddedExecutionCommand,
								model.aK,
								model.av,
								A3(
									$author$project$Plan$EditDialog$withChangeDescriptionCommand,
									model.aK,
									model.aQ,
									A3(
										$author$project$Plan$EditDialog$withChangeTitleCommand,
										model.aK,
										model.aQ,
										_Utils_Tuple2(environment, _List_Nil)))))))));
	});
var $author$project$Plan$EditDialog$userClickedApplyButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				if ($author$project$Utils$String$isBlank(
					$author$project$UI$BasicDataEditor$title(model.aQ))) {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				} else {
					var _v1 = A2($author$project$Plan$EditDialog$createCommands, environment, model);
					var newEnvironment = _v1.a;
					var tasks = _v1.b;
					return {
						ab: A2(
							$elm$core$Task$perform,
							$author$project$Plan$EditDialog$CreatedCommands,
							$elm$core$Task$sequence(tasks)),
						jn: $author$project$Plan$EditDialog$HandlingCommands(model),
						ac: newEnvironment,
						ae: repository
					};
				}
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$EditDialog$Hidden, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$userClickedCloseButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$EditDialog$Hidden, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$EditDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$EditDialog$Hidden, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Plan$EditDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$userClickedCreateExecution = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$EditDialog$Visible(
						_Utils_update(
							model,
							{
								dF: $author$project$Plan$Execution$CreateModal$show(model.lb)
							})),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$Command$delete = F3(
	function (environment, planId, titleForError) {
		return A2(
			$author$project$Plan$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Plan$Command$Delete(
						{L: commandId_, M: commandTimestamp, d5: planId, l: titleForError});
				}));
	});
var $author$project$Plan$EditDialog$userClickedDeleteButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = A3($author$project$Plan$Command$delete, environment, model.aK.d5, model.aK.k8);
				var newEnvironment = _v1.a;
				var task = _v1.b;
				return {
					ab: A2(
						$elm$core$Task$perform,
						$author$project$Plan$EditDialog$CreatedCommands,
						$elm$core$Task$sequence(
							_List_fromArray(
								[task]))),
					jn: $author$project$Plan$EditDialog$HandlingCommands(model),
					ac: newEnvironment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$userClickedEditExecution = F4(
	function (execution, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$EditDialog$Visible(
						_Utils_update(
							model,
							{
								dG: A3($author$project$Plan$Execution$EditModal$show, execution, environment, model.lb)
							})),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$BasicDataTab = 0;
var $author$project$Plan$EditDialog$CheckpointGroupTab = 2;
var $author$project$Plan$EditDialog$switchTab = F2(
	function (tab, model) {
		if (_Utils_eq(model.cI, tab)) {
			return model;
		} else {
			if (!model.cI) {
				var title = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$title(model.aQ));
				var description = $elm$core$String$trim(
					$author$project$UI$BasicDataEditor$description(model.aQ));
				return $elm$core$String$isEmpty(title) ? model : _Utils_update(
					model,
					{
						aQ: A2(
							$author$project$UI$BasicDataEditor$withDescription,
							description,
							A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ)),
						cI: tab
					});
			} else {
				if (model.cI === 2) {
					return $author$project$CheckpointData$CheckpointGroup$Ids$isEmpty(
						$author$project$Plan$CheckpointGroupEditor$checkpointGroupIds(model.cX)) ? model : _Utils_update(
						model,
						{cI: tab});
				} else {
					return _Utils_update(
						model,
						{cI: tab});
				}
			}
		}
	});
var $author$project$Plan$EditDialog$userClickedTabIcon = F4(
	function (tab, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$EditDialog$Visible(
						A2($author$project$Plan$EditDialog$switchTab, tab, model)),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$userSelectedAuditor = F4(
	function (auditorId, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$EditDialog$Visible(
						_Utils_update(
							model,
							{
								cv: A2($author$project$User$Ids$insert, auditorId, model.cv)
							})),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$userUnselectedAuditor = F4(
	function (auditorId, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Plan$EditDialog$Visible(
						_Utils_update(
							model,
							{
								cv: A2($author$project$User$Ids$remove, auditorId, model.cv)
							})),
					ac: environment,
					ae: repository
				};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Plan$EditDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Plan$EditDialog$userClickedCloseDialog;
		case 1:
			var tab = msg.a;
			return $author$project$Plan$EditDialog$userClickedTabIcon(tab);
		case 2:
			return $author$project$Plan$EditDialog$userClickedCancelButton;
		case 3:
			return $author$project$Plan$EditDialog$userClickedApplyButton;
		case 4:
			return $author$project$Plan$EditDialog$userClickedDeleteButton;
		case 5:
			return $author$project$Plan$EditDialog$userClickedCloseButton;
		case 6:
			var editorMsg = msg.a;
			return $author$project$Plan$EditDialog$gotBasicDataEditorMsg(editorMsg);
		case 7:
			return $author$project$Plan$EditDialog$userClickedCreateExecution;
		case 8:
			var dialogMsg = msg.a;
			return $author$project$Plan$EditDialog$gotExecutionCreateMsg(dialogMsg);
		case 9:
			var execution = msg.a;
			return $author$project$Plan$EditDialog$userClickedEditExecution(execution);
		case 10:
			var dialogMsg = msg.a;
			return $author$project$Plan$EditDialog$gotExecutionEditMsg(dialogMsg);
		case 11:
			var editorMsg = msg.a;
			return $author$project$Plan$EditDialog$gotCheckpointGroupEditorMsg(editorMsg);
		case 12:
			var auditorId = msg.a;
			return $author$project$Plan$EditDialog$userSelectedAuditor(auditorId);
		case 13:
			var auditorId = msg.a;
			return $author$project$Plan$EditDialog$userUnselectedAuditor(auditorId);
		default:
			var commands = msg.a;
			return $author$project$Plan$EditDialog$createdCommands(commands);
	}
};
var $author$project$Plan$Page$withEditDialog = F2(
	function (editDialog_, page) {
		if (!page.$) {
			return page;
		} else {
			var model = page.a;
			return $author$project$Plan$Page$Loaded(
				_Utils_update(
					model,
					{cO: editDialog_}));
		}
	});
var $author$project$Plan$Page$gotEditDialogMessage = F4(
	function (msg, environment, repository, page) {
		var result = A4(
			$author$project$Plan$EditDialog$update,
			msg,
			environment,
			repository,
			$author$project$Plan$Page$editDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Plan$Page$GotEditDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$Plan$Page$withEditDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$Plan$Page$receivedDate = F4(
	function (today, environment, repository, page) {
		if (!page.$) {
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: $author$project$Plan$Page$Loaded(
					{fi: $author$project$Plan$CreateDialog$hidden, cO: $author$project$Plan$EditDialog$hidden, lb: today}),
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		}
	});
var $author$project$Plan$CreateDialog$BasicDataStep = 0;
var $author$project$Plan$CheckpointGroupEditor$default = {ca: _List_Nil, bv: $author$project$CheckpointData$CheckpointGroup$Ids$empty};
var $author$project$Plan$Execution$CreateModal$hidden = $author$project$Plan$Execution$CreateModal$Hidden;
var $author$project$Plan$Execution$EditModal$hidden = $author$project$Plan$Execution$EditModal$Hidden;
var $author$project$Plan$CreateDialog$show = function (today) {
	return $author$project$Plan$CreateDialog$Visible(
		{aQ: $author$project$UI$BasicDataEditor$default, b0: 0, dF: $author$project$Plan$Execution$CreateModal$hidden, dG: $author$project$Plan$Execution$EditModal$hidden, fr: _List_Nil, cX: $author$project$Plan$CheckpointGroupEditor$default, cv: $author$project$User$Ids$empty, lb: today});
};
var $author$project$Plan$Page$userClickedCreateIcon = F3(
	function (environment, repository, page) {
		if (!page.$) {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		} else {
			var model = page.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: A2(
					$author$project$Plan$Page$withCreateDialog,
					$author$project$Plan$CreateDialog$show(model.lb),
					page),
				ae: repository
			};
		}
	});
var $author$project$Plan$CheckpointGroupEditor$from = function (ids) {
	return {ca: _List_Nil, bv: ids};
};
var $author$project$Plan$EditDialog$show = F2(
	function (plan, today) {
		return $author$project$Plan$EditDialog$Visible(
			{
				aQ: $author$project$UI$BasicDataEditor$from(plan),
				aS: _List_Nil,
				cI: 0,
				cK: _List_Nil,
				dF: $author$project$Plan$Execution$CreateModal$hidden,
				dG: $author$project$Plan$Execution$EditModal$hidden,
				cX: $author$project$Plan$CheckpointGroupEditor$from(plan.gt),
				av: _List_Nil,
				aK: plan,
				cv: plan.bT,
				lb: today
			});
	});
var $author$project$Plan$Page$userClickedEditIcon = F4(
	function (plan, environment, repository, page) {
		if (!page.$) {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		} else {
			var model = page.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: A2(
					$author$project$Plan$Page$withEditDialog,
					A2($author$project$Plan$EditDialog$show, plan, model.lb),
					page),
				ae: repository
			};
		}
	});
var $author$project$Plan$Page$update = function (msg) {
	switch (msg.$) {
		case 0:
			var today = msg.a;
			return $author$project$Plan$Page$receivedDate(today);
		case 1:
			return $author$project$Plan$Page$userClickedCreateIcon;
		case 2:
			var dialogMsg = msg.a;
			return $author$project$Plan$Page$gotCreateDialogMessage(dialogMsg);
		case 3:
			var plan = msg.a;
			return $author$project$Plan$Page$userClickedEditIcon(plan);
		default:
			var dialogMsg = msg.a;
			return $author$project$Plan$Page$gotEditDialogMessage(dialogMsg);
	}
};
var $author$project$Translations$Plans$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.header');
};
var $author$project$Plan$Page$UserClickedCreateIcon = {$: 1};
var $author$project$Plan$Page$viewActionBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withStyle,
			$rtfeldman$elm_css$Css$zIndex(
				$rtfeldman$elm_css$Css$int(1)),
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
					A2(
						$author$project$UI$Bar$withRightIcon,
						A2(
							$author$project$UI$Icon$withOnClick,
							$author$project$Plan$Page$UserClickedCreateIcon,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
						$author$project$UI$Bar$bar(
							$author$project$Translations$Misc$overview(translations)))))));
};
var $author$project$Plan$CreateDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Plans$createDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.createDialogHeader');
};
var $author$project$Plan$CreateDialog$UserSelectedAuditor = function (a) {
	return {$: 11, a: a};
};
var $author$project$Plan$CreateDialog$UserUnselectedAuditor = function (a) {
	return {$: 12, a: a};
};
var $author$project$Translations$Plans$Auditors$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.auditors.emptyText');
};
var $author$project$Plan$AuditorEditor$viewCheckbox = F3(
	function (config, auditorId, selectedIds) {
		return A2(
			$author$project$UI$Checkbox$withOnCheck,
			A2(
				$author$project$Utils$Bool$ifElse,
				config.kf(auditorId),
				config.kg(auditorId)),
			A2(
				$author$project$UI$Checkbox$checked,
				A2($author$project$User$Ids$member, auditorId, selectedIds),
				$author$project$UI$Checkbox$unlabeled));
	});
var $author$project$Plan$AuditorEditor$viewRow = F4(
	function (conf, viewType, selectedAuditors, auditor) {
		var label = $elm$core$String$isEmpty(auditor.g_) ? auditor.iK : auditor.g_;
		return A2(
			$author$project$UI$Table$Row$withCheckbox,
			A3($author$project$Plan$AuditorEditor$viewCheckbox, conf, auditor.dk, selectedAuditors),
			A2(
				$author$project$UI$Table$Row$withAvatar,
				$author$project$UI$Avatar$icon(
					$author$project$UI$Icon$bicolor($author$project$UI$Icons$userCircleBicolor)),
				A3($author$project$UI$Table$Row$row, viewType, label, auditor)));
	});
var $author$project$Plan$AuditorEditor$viewTable = F3(
	function (conf, environment, selectedAuditors) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$elm$core$Basics$composeR,
			$author$project$User$Dict$values,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$sortBy(
					function (u) {
						return $elm$core$String$toLower(
							_Utils_ap(u.g_, u.iK));
					}),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Table$fromList(
						A3(
							$author$project$Plan$AuditorEditor$viewRow,
							conf,
							$author$project$Environments$Environment$getViewType(environment),
							selectedAuditors)),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Table$withEmptyText(
							$author$project$Translations$Plans$Auditors$emptyText(translations)),
						$author$project$UI$Table$view))));
	});
var $author$project$Plan$CreateDialog$viewAuditorTable = $author$project$Plan$AuditorEditor$viewTable(
	{kf: $author$project$Plan$CreateDialog$UserSelectedAuditor, kg: $author$project$Plan$CreateDialog$UserUnselectedAuditor});
var $author$project$Translations$Plans$Auditors$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.auditors.header');
};
var $author$project$Plan$AuditorEditor$viewBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$user),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Plans$Auditors$header(translations))));
};
var $author$project$Plan$CreateDialog$UserClickedCancelButton = {$: 3};
var $author$project$Plan$CreateDialog$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Plan$CreateDialog$UserClickedCancelButton,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$Plan$CreateDialog$UserClickedCreateButton = {$: 4};
var $author$project$Plan$CreateDialog$viewCreateButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Plan$CreateDialog$UserClickedCreateButton,
			$author$project$UI$Button$green(
				$author$project$Translations$Buttons$create(translations))));
};
var $author$project$Plan$CreateDialog$UserClickedNextButton = {$: 1};
var $author$project$Plan$CreateDialog$viewNextButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Plan$CreateDialog$UserClickedNextButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$next(translations)))));
	});
var $author$project$Plan$CreateDialog$viewRightButton = F3(
	function (translations, disableBtn, currentStep) {
		return (currentStep === 3) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Plan$CreateDialog$viewCreateButton(translations)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Plan$CreateDialog$viewNextButton, translations, disableBtn)
				]));
	});
var $author$project$UI$Icons$clockCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63.001 32.001c0 17.122-13.879 31-31.001 31-17.121 0-31-13.878-31-31 0-17.121 13.879-31 31-31 17.122 0 31.001 13.879 31.001 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M44.982 19.38a1.335 1.335 0 00-1.884 0l-4.053 4.07a1.345 1.345 0 000 1.892 1.334 1.334 0 001.883 0l3.078-3.095c4.991 5.97 4.696 14.921-.9 20.543-5.908 5.932-15.523 5.932-21.43 0-5.908-5.933-5.908-15.586 0-21.52a15.074 15.074 0 0113.84-4.13c.7.148 1.408-.312 1.557-1.037a1.337 1.337 0 00-1.028-1.58 17.733 17.733 0 00-16.266 4.856 17.837 17.837 0 00-5.213 12.65 17.82 17.82 0 005.219 12.65c3.368 3.383 7.837 5.243 12.598 5.243 4.764 0 9.231-1.86 12.599-5.242A17.803 17.803 0 0050.2 32.029c0-4.78-1.853-9.268-5.22-12.65')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M31.046 20.914v10.559l-5.301 5.325a1.347 1.347 0 000 1.891c.258.26.598.394.938.394.34 0 .68-.134.94-.394l5.69-5.716c.03-.03.06-.067.089-.099a.158.158 0 00.03-.045c.014-.02.03-.034.045-.058.015-.015.02-.037.036-.059.009-.016.022-.038.03-.06s.022-.037.03-.058c.008-.023.021-.037.027-.059l.024-.059.023-.068c.006-.021.006-.037.014-.06.007-.022.015-.044.015-.065.007-.024.007-.046.007-.075 0-.023.008-.037.008-.058.007-.046.007-.092.007-.136v-11.1a1.325 1.325 0 00-1.32-1.335c-.734 0-1.332.602-1.332 1.335')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$Icons$planCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63 32c0 17.121-13.879 31-31 31C14.878 63 1 49.121 1 32 1 14.879 14.878 1 32 1c17.121 0 31 13.879 31 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M20.513 18.21l.21-.087v-2.717a1.397 1.397 0 112.792 0v2.65l4.186.072h13.163v-2.72a1.396 1.396 0 112.792 0v2.77c4.202.446 7.484 4.008 7.484 8.326v15.032c0 4.697-2.404 8.375-5.468 8.375a1.395 1.395 0 110-2.792c1.238 0 2.676-2.437 2.676-5.583V26.504c0-.287-.042-.561-.082-.837H16.113c-.04.276-.083.55-.083.837v15.032a5.59 5.59 0 005.583 5.583h17.353a1.396 1.396 0 010 2.792H21.613c-4.617 0-8.375-3.756-8.375-8.375V26.504c0-4.244 3.177-7.753 7.275-8.295')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M44.534 35.17h-4.726a.697.697 0 01-.7-.698V30.4c0-.384.312-.697.7-.697h4.726c.386 0 .699.313.699.697v4.072a.698.698 0 01-.699.698m-9.981 0h-4.727a.697.697 0 01-.698-.698V30.4c0-.384.312-.697.698-.697h4.727c.385 0 .698.313.698.697v4.072a.698.698 0 01-.698.698m-9.98 0h-4.728a.697.697 0 01-.699-.698V30.4c0-.384.312-.697.699-.697h4.729c.384 0 .697.313.697.697v4.072a.698.698 0 01-.697.698m20.657 8.365a.696.696 0 01-.698.697h-4.725c-.387 0-.7-.31-.7-.697v-4.07c0-.387.313-.7.7-.7h4.725c.387 0 .698.313.698.7v4.07zm-9.98 0a.697.697 0 01-.698.697h-4.727a.697.697 0 01-.698-.697v-4.07c0-.387.313-.7.698-.7h4.727c.385 0 .698.313.698.7v4.07zm-9.98 0a.697.697 0 01-.697.697h-4.73a.697.697 0 01-.698-.697v-4.07c0-.387.313-.7.699-.7h4.729c.384 0 .697.313.697.7v4.07z')
						]),
					_List_Nil)
				]));
	});
var $author$project$Plan$CreateDialog$UserClickedStepIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$CreateDialog$viewStepIcon = F4(
	function (icon, step, currentStep, platform) {
		var marginRight_ = function () {
			if (step === 3) {
				return $rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero);
			} else {
				if (!platform.$) {
					return $rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(1));
				} else {
					return $rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(0.2));
				}
			}
		}();
		var calcRem = function () {
			if (!platform.$) {
				return $rtfeldman$elm_css$Css$rem(2.5);
			} else {
				return $rtfeldman$elm_css$Css$rem(1.3);
			}
		}();
		var _v0 = _Utils_eq(step, currentStep) ? _Utils_Tuple2($author$project$UI$Style$Theme$white, $author$project$UI$Style$Theme$darkGrey) : _Utils_Tuple2($author$project$UI$Style$Theme$darkGrey, $author$project$UI$Style$Theme$lightGrey);
		var foregroundColor_ = _v0.a;
		var backgroundColor_ = _v0.b;
		return $author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Plan$CreateDialog$UserClickedStepIcon(step),
				A2(
					$author$project$UI$Icon$withStyle,
					marginRight_,
					A2(
						$author$project$UI$Icon$withBackgroundColor,
						backgroundColor_,
						A2(
							$author$project$UI$Icon$withForegroundColor,
							foregroundColor_,
							A2(
								$author$project$UI$Icon$withStyle,
								$rtfeldman$elm_css$Css$height(
									A3(
										$rtfeldman$elm_css$Css$calc,
										calcRem,
										$rtfeldman$elm_css$Css$plus,
										$rtfeldman$elm_css$Css$px(2))),
								A2(
									$author$project$UI$Icon$withStyle,
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									$author$project$UI$Icon$bicolor(icon))))))));
	});
var $author$project$Plan$CreateDialog$viewSteps = F2(
	function (currentStep, platform) {
		var marginLeft_ = function () {
			if (!platform.$) {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(0.8))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
							]),
						marginLeft_))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$top(
									$rtfeldman$elm_css$Css$pct(50)),
									$rtfeldman$elm_css$Css$right(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$left(
									$rtfeldman$elm_css$Css$rem(1)),
									A3(
									$rtfeldman$elm_css$Css$border3,
									$rtfeldman$elm_css$Css$px(1),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
								]))
						]),
					_List_Nil),
					A4($author$project$Plan$CreateDialog$viewStepIcon, $author$project$UI$Icons$planCircleBicolor, 0, currentStep, platform),
					A4($author$project$Plan$CreateDialog$viewStepIcon, $author$project$UI$Icons$clockCircleBicolor, 1, currentStep, platform),
					A4($author$project$Plan$CreateDialog$viewStepIcon, $author$project$UI$Icons$factoryCircleBicolor, 2, currentStep, platform),
					A4($author$project$Plan$CreateDialog$viewStepIcon, $author$project$UI$Icons$userCircleBicolor, 3, currentStep, platform)
				]));
	});
var $author$project$Plan$CreateDialog$viewFooter = F4(
	function (translations, platform, disableBtn, currentStep) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto 1fr'),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Plan$CreateDialog$viewCancelButton(translations),
					A2($author$project$Plan$CreateDialog$viewSteps, currentStep, platform),
					A3($author$project$Plan$CreateDialog$viewRightButton, translations, disableBtn, currentStep)
				]));
	});
var $author$project$Plan$CreateDialog$viewAuditorsStep = F4(
	function (environment, platform, selectedAuditors, availableAuditors) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$Plan$CreateDialog$viewFooter, translations, platform, false, 3),
					A2(
						$author$project$UI$Dialog$appendContent,
						A3($author$project$Plan$CreateDialog$viewAuditorTable, environment, selectedAuditors, availableAuditors),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Plan$AuditorEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Plans$createDialogHeader(translations),
									$author$project$Plan$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$Plan$CreateDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Plan$CreateDialog$viewBasicDataStep = F3(
	function (translations, platform, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$Plan$CreateDialog$viewFooter, translations, platform, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Plan$CreateDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Plans$createDialogHeader(translations),
									$author$project$Plan$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$Plan$CreateDialog$GotCheckpointGroupEditorMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Plan$CheckpointGroupEditor$viewBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$factory),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Checkpoints$header(translations))));
};
var $author$project$Plan$CheckpointGroupEditor$CollapseOrganisationUnit = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$OrganisationStructure$Content = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$CheckpointGroupEditor$ExpandOrganisationUnit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$CheckpointGroupEditor$numberOfCheckpointGroups = F2(
	function (selectedCheckpointGroups, organisationUnitId) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (checkpointGroup) {
					return _Utils_eq(checkpointGroup.km, organisationUnitId);
				},
				selectedCheckpointGroups));
	});
var $author$project$Plan$CheckpointGroupEditor$renderCheckpointGroupCounter = F3(
	function (repository, selectedCheckpointGroups, organisationUnit) {
		var numberOfGroups = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$author$project$Plan$CheckpointGroupEditor$numberOfCheckpointGroups(selectedCheckpointGroups),
				A2(
					$elm$core$List$cons,
					organisationUnit.km,
					$author$project$OrganisationUnit$Ids$toList(
						A2(
							$author$project$OrganisationUnit$Hierarchy$getDescendantIdsOf,
							organisationUnit,
							$author$project$OrganisationUnit$OrganisationUnits$hierarchy(
								$author$project$Environments$Repository$organisationUnits(repository)))))));
		return (!numberOfGroups) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$elm$core$String$fromInt(numberOfGroups));
	});
var $author$project$Plan$CheckpointGroupEditor$DeselectCheckpointGroup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$CheckpointGroupEditor$SelectCheckpointGroup = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointData$CheckpointGroup$Ids$member = $turboMaCk$any_set$Set$Any$member;
var $author$project$Plan$CheckpointGroupEditor$viewTileIcon = function (icon) {
	return $author$project$UI$Icon$view(
		A2(
			$author$project$UI$Icon$withStyle,
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$padding(
					$rtfeldman$elm_css$Css$rem(1)),
				A2(
					$author$project$UI$Icon$withStyle,
					A3(
						$rtfeldman$elm_css$Css$flex3,
						$rtfeldman$elm_css$Css$int(1),
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$zero),
					A2(
						$author$project$UI$Icon$withForegroundColor,
						$author$project$UI$Style$Theme$grey,
						$author$project$UI$Icon$unicolor(icon))))));
};
var $author$project$Plan$CheckpointGroupEditor$viewTileLabel = function (description) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$margin3,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$rem(0.5),
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$paddingTop(
						$rtfeldman$elm_css$Css$rem(0.5)),
						A3(
						$rtfeldman$elm_css$Css$borderTop3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
						$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
						$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
						$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(description)
			]));
};
var $author$project$Plan$CheckpointGroupEditor$viewTileMarker = function (color) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(0.5)),
						A4(
						$rtfeldman$elm_css$Css$borderRadius4,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$rem(0.5),
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor(color))
					]))
			]),
		_List_Nil);
};
var $author$project$Plan$CheckpointGroupEditor$viewTile = F2(
	function (selectedGroups, checkpointGroup) {
		var _v0 = A2($author$project$CheckpointData$CheckpointGroup$Ids$member, checkpointGroup.cC, selectedGroups) ? _Utils_Tuple2(
			$author$project$UI$Style$Theme$green,
			$author$project$Plan$CheckpointGroupEditor$DeselectCheckpointGroup(checkpointGroup.cC)) : _Utils_Tuple2(
			$author$project$UI$Style$Theme$grey,
			$author$project$Plan$CheckpointGroupEditor$SelectCheckpointGroup(checkpointGroup.cC));
		var tileColor = _v0.a;
		var msg = _v0.b;
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-tile',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$rem(0.5)),
							$rtfeldman$elm_css$Css$backgroundImage(
							A3(
								$rtfeldman$elm_css$Css$linearGradient,
								$rtfeldman$elm_css$Css$stop(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
								$rtfeldman$elm_css$Css$stop(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
								_List_Nil)),
							$rtfeldman$elm_css$Css$firstChild(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$property, 'grid-row', '1 / 1'),
									A2($rtfeldman$elm_css$Css$property, 'grid-column', '1 / 1')
								]))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					$author$project$Plan$CheckpointGroupEditor$viewTileIcon($author$project$UI$Icons$pin),
					$author$project$Plan$CheckpointGroupEditor$viewTileLabel(checkpointGroup.k8),
					$author$project$Plan$CheckpointGroupEditor$viewTileMarker(tileColor)
				]));
	});
var $author$project$Plan$CheckpointGroupEditor$viewTiles = F3(
	function (checkpointData, _v0, organisationUnit) {
		var model = _v0;
		var checkpointGroups = A2($author$project$CheckpointData$CheckpointData$getCheckpointGroupAndPrev, organisationUnit.jU, checkpointData);
		return $elm$core$List$isEmpty(checkpointGroups) ? _Utils_Tuple2(
			$rtfeldman$elm_css$Html$Styled$text(''),
			0) : _Utils_Tuple2(
			A3(
				$rtfeldman$elm_css$Html$Styled$node,
				'checkpointGroups',
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
								A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(auto-fill, minmax(8rem, 1fr))'),
								A2($rtfeldman$elm_css$Css$property, 'grid-gap', '1rem'),
								A2($rtfeldman$elm_css$Css$property, 'grid-auto-rows', '1fr'),
								$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(0.5)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(300)),
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1)),
								$rtfeldman$elm_css$Css$before(
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$property, 'content', '\'\''),
										$rtfeldman$elm_css$Css$paddingBottom(
										$rtfeldman$elm_css$Css$pct(100)),
										$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
										A2($rtfeldman$elm_css$Css$property, 'grid-row', '1 / 1'),
										A2($rtfeldman$elm_css$Css$property, 'grid-column', '1 / 1')
									]))
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Plan$CheckpointGroupEditor$viewTile(model.bv),
					checkpointGroups)),
			$elm$core$List$length(checkpointGroups));
	});
var $author$project$Plan$CheckpointGroupEditor$viewContent = F3(
	function (environment, repository, editor) {
		var editor_ = editor;
		var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
		var checkpointGroupList = A3(
			$elm$core$List$foldl,
			$author$project$Utils$Utils$reduceMaybeList,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (id) {
					return A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, id, checkpointData);
				},
				$author$project$CheckpointData$CheckpointGroup$Ids$toList(editor_.bv)));
		return A2(
			$author$project$UI$OrganisationStructure$view,
			environment,
			{
				iN: $author$project$UI$OrganisationStructure$NoFunction,
				iY: $elm$core$Maybe$Nothing,
				i9: $author$project$Plan$CheckpointGroupEditor$CollapseOrganisationUnit,
				jg: $author$project$UI$OrganisationStructure$Content(
					A2($author$project$Plan$CheckpointGroupEditor$viewTiles, checkpointData, editor)),
				jx: $author$project$Plan$CheckpointGroupEditor$ExpandOrganisationUnit,
				jy: editor_.ca,
				jV: $elm$core$Maybe$Nothing,
				kn: $author$project$Environments$Repository$organisationUnits(repository),
				kC: _List_Nil,
				kD: _List_Nil,
				kE: $elm$core$Maybe$Just(
					A2($author$project$Plan$CheckpointGroupEditor$renderCheckpointGroupCounter, repository, checkpointGroupList)),
				kS: true
			});
	});
var $author$project$Plan$CreateDialog$viewCheckpointGroupsStep = F5(
	function (translations, environment, platform, repository, checkpointGroupEditor) {
		var disableBtn = $author$project$CheckpointData$CheckpointGroup$Ids$isEmpty(
			$author$project$Plan$CheckpointGroupEditor$checkpointGroupIds(checkpointGroupEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$Plan$CreateDialog$viewFooter, translations, platform, disableBtn, 2),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Plan$CreateDialog$GotCheckpointGroupEditorMsg,
							A3($author$project$Plan$CheckpointGroupEditor$viewContent, environment, repository, checkpointGroupEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Plan$CheckpointGroupEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Plans$createDialogHeader(translations),
									$author$project$Plan$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$Plan$Execution$CreateModal$GotBasicDataEditorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Plan$Execution$CreateModal$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Plans$Schedule$createDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.createDialogHeader');
};
var $author$project$Plan$Execution$CreateModal$UserClickedCancelButton = {$: 3};
var $author$project$Plan$Execution$CreateModal$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Plan$Execution$CreateModal$UserClickedCancelButton,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$Plan$Execution$CreateModal$UserClickedCreateButton = {$: 4};
var $author$project$Plan$Execution$CreateModal$viewCreateButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Plan$Execution$CreateModal$UserClickedCreateButton,
			$author$project$UI$Button$green(
				$author$project$Translations$Buttons$create(translations))));
};
var $author$project$Plan$Execution$CreateModal$UserClickedNextButton = {$: 1};
var $author$project$Plan$Execution$CreateModal$viewNextButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Plan$Execution$CreateModal$UserClickedNextButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$next(translations)))));
	});
var $author$project$Plan$Execution$CreateModal$viewRightButton = F3(
	function (translations, disableBtn, currentStep) {
		return (currentStep === 1) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Plan$Execution$CreateModal$viewCreateButton(translations)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Plan$Execution$CreateModal$viewNextButton, translations, disableBtn)
				]));
	});
var $author$project$Plan$Execution$CreateModal$UserClickedStepIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$Execution$CreateModal$viewStepIcon = F4(
	function (icon, step, currentStep, platform) {
		var marginRight_ = function () {
			if (step === 1) {
				return $rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero);
			} else {
				if (!platform.$) {
					return $rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(1));
				} else {
					return $rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(0.2));
				}
			}
		}();
		var calcRem = function () {
			if (!platform.$) {
				return $rtfeldman$elm_css$Css$rem(2.5);
			} else {
				return $rtfeldman$elm_css$Css$rem(1.3);
			}
		}();
		var _v0 = _Utils_eq(step, currentStep) ? _Utils_Tuple2($author$project$UI$Style$Theme$white, $author$project$UI$Style$Theme$darkGrey) : _Utils_Tuple2($author$project$UI$Style$Theme$darkGrey, $author$project$UI$Style$Theme$lightGrey);
		var foregroundColor_ = _v0.a;
		var backgroundColor_ = _v0.b;
		return $author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Plan$Execution$CreateModal$UserClickedStepIcon(step),
				A2(
					$author$project$UI$Icon$withStyle,
					marginRight_,
					A2(
						$author$project$UI$Icon$withBackgroundColor,
						backgroundColor_,
						A2(
							$author$project$UI$Icon$withForegroundColor,
							foregroundColor_,
							A2(
								$author$project$UI$Icon$withStyle,
								$rtfeldman$elm_css$Css$height(
									A3(
										$rtfeldman$elm_css$Css$calc,
										calcRem,
										$rtfeldman$elm_css$Css$plus,
										$rtfeldman$elm_css$Css$px(2))),
								A2(
									$author$project$UI$Icon$withStyle,
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									$author$project$UI$Icon$bicolor(icon))))))));
	});
var $author$project$Plan$Execution$CreateModal$viewSteps = F2(
	function (currentStep, platform) {
		var marginLeft_ = function () {
			if (!platform.$) {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(0.8))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
							]),
						marginLeft_))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$top(
									$rtfeldman$elm_css$Css$pct(50)),
									$rtfeldman$elm_css$Css$right(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$left(
									$rtfeldman$elm_css$Css$rem(1)),
									A3(
									$rtfeldman$elm_css$Css$border3,
									$rtfeldman$elm_css$Css$px(1),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
								]))
						]),
					_List_Nil),
					A4($author$project$Plan$Execution$CreateModal$viewStepIcon, $author$project$UI$Icons$planCircleBicolor, 0, currentStep, platform),
					A4($author$project$Plan$Execution$CreateModal$viewStepIcon, $author$project$UI$Icons$clockCircleBicolor, 1, currentStep, platform)
				]));
	});
var $author$project$Plan$Execution$CreateModal$viewFooter = F4(
	function (translations, platform, disableBtn, currentStep) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto 1fr'),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Plan$Execution$CreateModal$viewCancelButton(translations),
					A2($author$project$Plan$Execution$CreateModal$viewSteps, currentStep, platform),
					A3($author$project$Plan$Execution$CreateModal$viewRightButton, translations, disableBtn, currentStep)
				]));
	});
var $author$project$Plan$Execution$CreateModal$viewBasicDataStep = F3(
	function (translations, platform, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(46))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$Plan$Execution$CreateModal$viewFooter, translations, platform, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Plan$Execution$CreateModal$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Plans$Schedule$createDialogHeader(translations),
									$author$project$Plan$Execution$CreateModal$UserClickedCloseDialog)))))));
	});
var $author$project$Plan$Execution$CreateModal$GotScheduleEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$UI$Icons$clock = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M35.313 12.687c-.465-.464-1.219-.464-1.692 0l-3.639 3.641c-.465.464-.465 1.22 0 1.691.463.464 1.219.464 1.691 0l2.764-2.767c4.482 5.339 4.217 13.343-.809 18.37-5.305 5.305-13.939 5.305-19.243 0-5.306-5.305-5.306-13.938 0-19.244 3.261-3.262 7.911-4.642 12.427-3.693.629.132 1.265-.279 1.399-.928.133-.644-.279-1.28-.923-1.413-5.31-1.113-10.776.512-14.607 4.343C9.664 15.711 8 19.729 8 23.999c0 4.271 1.664 8.289 4.686 11.313C15.711 38.337 19.724 40 23.999 40c4.278 0 8.29-1.663 11.314-4.688C38.336 32.288 40 28.277 40 23.999c0-4.275-1.664-8.288-4.687-11.312')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M22.799 14.06v9.442l-4.761 4.762c-.464.464-.464 1.219 0 1.691.232.232.537.352.843.352.305 0 .61-.12.843-.352l5.111-5.112c.026-.027.053-.06.079-.088.013-.013.02-.026.027-.04.013-.019.027-.031.041-.052.013-.014.018-.033.032-.053.008-.014.02-.034.027-.053.007-.02.02-.034.027-.053.007-.02.019-.033.024-.052.009-.022.015-.036.022-.053l.02-.061c.006-.019.006-.033.013-.053.006-.02.013-.04.013-.059.007-.021.007-.041.007-.067 0-.02.007-.033.007-.052.006-.041.006-.082.006-.121V14.06c.007-.656-.531-1.194-1.186-1.194-.658 0-1.195.538-1.195 1.194')
						]),
					_List_Nil)
				]));
	});
var $author$project$Translations$Plans$Schedule$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.header');
};
var $author$project$Plan$Schedule$ScheduleEditor$viewBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$clock),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Plans$Schedule$header(translations))));
};
var $author$project$Plan$Schedule$ScheduleEditor$UserEnteredCreatingTimeHour = function (a) {
	return {$: 6, a: a};
};
var $author$project$Plan$Schedule$ScheduleEditor$UserEnteredCreatingTimeMinute = function (a) {
	return {$: 7, a: a};
};
var $author$project$Translations$Plans$Schedule$creatingTimeFirstLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.creatingTimeFirstLabel');
};
var $author$project$Translations$Plans$Schedule$creatingTimeSecondLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.creatingTimeSecondLabel');
};
var $author$project$Plan$Schedule$ScheduleEditor$viewCreatingTime = F3(
	function (translations, hourInput, minuteInput) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(8)),
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$creatingTimeFirstLabel(translations))
						])),
					A4(
					$author$project$UI$TimeInput$view,
					false,
					hourInput,
					minuteInput,
					A2($author$project$UI$TimeInput$timeInput, $author$project$Plan$Schedule$ScheduleEditor$UserEnteredCreatingTimeHour, $author$project$Plan$Schedule$ScheduleEditor$UserEnteredCreatingTimeMinute)),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(2.5)),
									$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$creatingTimeSecondLabel(translations))
						]))
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$UserSelectedDay = function (a) {
	return {$: 4, a: a};
};
var $author$project$Translations$Plans$Schedule$Monthly$dayLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.monthly.dayLabel');
};
var $author$project$Translations$Plans$Schedule$Monthly$dayText = F2(
	function (translations, day) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'plans.schedule.monthly.dayText',
			_List_fromArray(
				[
					_Utils_Tuple2('day', day)
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$viewDay = F2(
	function (translations, day) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(8)),
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$Monthly$dayLabel(translations))
						])),
					A2(
					$author$project$UI$Select$view,
					A2($elm$core$List$range, 1, 31),
					A2(
						$author$project$UI$Select$withStyle,
						$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
						A2(
							$author$project$UI$Select$withOnInput,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(day),
								$author$project$Plan$Schedule$ScheduleEditor$UserSelectedDay),
							A2(
								$author$project$UI$Select$withSelected,
								day,
								$author$project$UI$Select$custom(
									{
										jD: $elm$core$String$toInt,
										k9: A2(
											$elm$core$Basics$composeR,
											$elm$core$String$fromInt,
											$author$project$Translations$Plans$Schedule$Monthly$dayText(translations)),
										la: $elm$core$String$fromInt
									})))))
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$UserSelectedMonth = function (a) {
	return {$: 5, a: a};
};
var $author$project$Date_Time$Month$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $author$project$Translations$Plans$Schedule$Yearly$dayText = F2(
	function (translations, day) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'plans.schedule.yearly.dayText',
			_List_fromArray(
				[
					_Utils_Tuple2('day', day)
				]));
	});
var $author$project$Translations$Plans$Schedule$Yearly$monthLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.yearly.monthLabel');
};
var $author$project$Plan$Schedule$ScheduleEditor$viewDayAndMonth = F3(
	function (translations, day, month) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(8)),
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$Yearly$monthLabel(translations))
						])),
					A2(
					$author$project$UI$Select$view,
					A2(
						$elm$core$List$range,
						1,
						$author$project$Date_Time$Month$numberOfDays(month)),
					A2(
						$author$project$UI$Select$withStyle,
						$rtfeldman$elm_css$Css$marginRight(
							$rtfeldman$elm_css$Css$rem(1)),
						A2(
							$author$project$UI$Select$withStyle,
							$rtfeldman$elm_css$Css$flexGrow(
								$rtfeldman$elm_css$Css$int(1)),
							A2(
								$author$project$UI$Select$withOnInput,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$withDefault(day),
									$author$project$Plan$Schedule$ScheduleEditor$UserSelectedDay),
								A2(
									$author$project$UI$Select$withSelected,
									day,
									$author$project$UI$Select$custom(
										{
											jD: $elm$core$String$toInt,
											k9: A2(
												$elm$core$Basics$composeR,
												$elm$core$String$fromInt,
												$author$project$Translations$Plans$Schedule$Yearly$dayText(translations)),
											la: $elm$core$String$fromInt
										})))))),
					A2(
					$author$project$UI$Select$view,
					$author$project$Date_Time$Month$all,
					A2(
						$author$project$UI$Select$withStyle,
						$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
						A2(
							$author$project$UI$Select$withOnInput,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(month),
								$author$project$Plan$Schedule$ScheduleEditor$UserSelectedMonth),
							A2(
								$author$project$UI$Select$withSelected,
								month,
								$author$project$UI$Select$custom(
									{
										jD: $author$project$Date_Time$Month$fromString,
										k9: $author$project$Date_Time$Month$translate(translations),
										la: $author$project$Date_Time$Month$toString
									})))))
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$UserEnteredDeadlineTimeHour = function (a) {
	return {$: 8, a: a};
};
var $author$project$Plan$Schedule$ScheduleEditor$UserEnteredDeadlineTimeMinute = function (a) {
	return {$: 9, a: a};
};
var $author$project$Translations$Plans$Schedule$deadlineTimeSecondLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.deadlineTimeSecondLabel');
};
var $author$project$Plan$Schedule$ScheduleEditor$viewDeadlineTime = F3(
	function (translations, hourInput, minuteInput) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(8)),
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$deadlineTimeFirstLabel(translations))
						])),
					A4(
					$author$project$UI$TimeInput$view,
					false,
					hourInput,
					minuteInput,
					A2($author$project$UI$TimeInput$timeInput, $author$project$Plan$Schedule$ScheduleEditor$UserEnteredDeadlineTimeHour, $author$project$Plan$Schedule$ScheduleEditor$UserEnteredDeadlineTimeMinute)),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(2.5)),
									$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$deadlineTimeSecondLabel(translations))
						]))
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$UserChangedEndDateInput = function (a) {
	return {$: 12, a: a};
};
var $author$project$Plan$Schedule$ScheduleEditor$UserEnteredEndDateText = function (a) {
	return {$: 13, a: a};
};
var $author$project$Translations$Plans$Schedule$endDateLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.endDateLabel');
};
var $author$project$UI$DateInput$withDelete = function (_v0) {
	var config = _v0;
	return _Utils_update(
		config,
		{gb: true});
};
var $author$project$Plan$Schedule$ScheduleEditor$viewEndDate = F5(
	function (translations, today, endDateInput, endDate, endDateTextInput) {
		var defaultYear = $author$project$Date_Time$NaiveDate$year(today);
		var defaultMonth = $author$project$Date_Time$NaiveDate$month(today);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(8)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$rem(2)),
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$endDateLabel(translations))
						])),
					A5(
					$author$project$UI$DateInput$view,
					translations,
					endDateInput,
					endDate,
					endDateTextInput,
					$author$project$UI$DateInput$withDelete(
						A2(
							$author$project$UI$DateInput$withStyle,
							$rtfeldman$elm_css$Css$flexGrow(
								$rtfeldman$elm_css$Css$int(1)),
							A2(
								$author$project$UI$DateInput$withOnTextInput,
								$author$project$Plan$Schedule$ScheduleEditor$UserEnteredEndDateText,
								A3($author$project$UI$DateInput$dateInput, defaultYear, defaultMonth, $author$project$Plan$Schedule$ScheduleEditor$UserChangedEndDateInput)))))
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$UserSelectedFrequency = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plan$Schedule$Frequency$all = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Translations$Plans$Schedule$frequencyLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.frequencyLabel');
};
var $author$project$Translations$Plans$Schedule$Frequencies$daily = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.frequencies.daily');
};
var $author$project$Translations$Plans$Schedule$Frequencies$monthly = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.frequencies.monthly');
};
var $author$project$Translations$Plans$Schedule$Frequencies$weekly = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.frequencies.weekly');
};
var $author$project$Translations$Plans$Schedule$Frequencies$yearly = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.frequencies.yearly');
};
var $author$project$Plan$Schedule$Frequency$translate = F2(
	function (translations, frequency) {
		switch (frequency) {
			case 0:
				return $author$project$Translations$Plans$Schedule$Frequencies$daily(translations);
			case 1:
				return $author$project$Translations$Plans$Schedule$Frequencies$weekly(translations);
			case 2:
				return $author$project$Translations$Plans$Schedule$Frequencies$monthly(translations);
			default:
				return $author$project$Translations$Plans$Schedule$Frequencies$yearly(translations);
		}
	});
var $author$project$Plan$Schedule$ScheduleEditor$viewFrequency = F2(
	function (translations, frequency) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(8)),
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$frequencyLabel(translations))
						])),
					A2(
					$author$project$UI$Select$view,
					$author$project$Plan$Schedule$Frequency$all,
					A2(
						$author$project$UI$Select$withStyle,
						$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
						A2(
							$author$project$UI$Select$withOnInput,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(frequency),
								$author$project$Plan$Schedule$ScheduleEditor$UserSelectedFrequency),
							A2(
								$author$project$UI$Select$withSelected,
								frequency,
								$author$project$UI$Select$custom(
									{
										jD: $author$project$Plan$Schedule$Frequency$fromString,
										k9: $author$project$Plan$Schedule$Frequency$translate(translations),
										la: $author$project$Plan$Schedule$Frequency$toString
									})))))
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$UserSelectedInterval = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$Plans$Schedule$Daily$intervalLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.daily.intervalLabel');
};
var $author$project$Translations$Plans$Schedule$Monthly$intervalLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.monthly.intervalLabel');
};
var $author$project$Translations$Plans$Schedule$Weekly$intervalLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.weekly.intervalLabel');
};
var $author$project$Translations$Plans$Schedule$Yearly$intervalLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.yearly.intervalLabel');
};
var $author$project$Translations$Plans$Schedule$Daily$intervalText = F2(
	function (translations, interval) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'plans.schedule.daily.intervalText',
			_List_fromArray(
				[
					_Utils_Tuple2('interval', interval)
				]));
	});
var $author$project$Translations$Plans$Schedule$Monthly$intervalText = F2(
	function (translations, interval) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'plans.schedule.monthly.intervalText',
			_List_fromArray(
				[
					_Utils_Tuple2('interval', interval)
				]));
	});
var $author$project$Translations$Plans$Schedule$Weekly$intervalText = F2(
	function (translations, interval) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'plans.schedule.weekly.intervalText',
			_List_fromArray(
				[
					_Utils_Tuple2('interval', interval)
				]));
	});
var $author$project$Translations$Plans$Schedule$Yearly$intervalText = F2(
	function (translations, interval) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'plans.schedule.yearly.intervalText',
			_List_fromArray(
				[
					_Utils_Tuple2('interval', interval)
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$viewInterval = F3(
	function (translations, frequency, interval) {
		var _v0 = function () {
			switch (frequency) {
				case 0:
					return _Utils_Tuple2(
						$author$project$Translations$Plans$Schedule$Daily$intervalLabel(translations),
						$author$project$Translations$Plans$Schedule$Daily$intervalText(translations));
				case 1:
					return _Utils_Tuple2(
						$author$project$Translations$Plans$Schedule$Weekly$intervalLabel(translations),
						$author$project$Translations$Plans$Schedule$Weekly$intervalText(translations));
				case 2:
					return _Utils_Tuple2(
						$author$project$Translations$Plans$Schedule$Monthly$intervalLabel(translations),
						$author$project$Translations$Plans$Schedule$Monthly$intervalText(translations));
				default:
					return _Utils_Tuple2(
						$author$project$Translations$Plans$Schedule$Yearly$intervalLabel(translations),
						$author$project$Translations$Plans$Schedule$Yearly$intervalText(translations));
			}
		}();
		var label = _v0.a;
		var toText = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(8)),
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					A2(
					$author$project$UI$Select$view,
					A2($elm$core$List$range, 1, 400),
					A2(
						$author$project$UI$Select$withStyle,
						$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
						A2(
							$author$project$UI$Select$withOnInput,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(interval),
								$author$project$Plan$Schedule$ScheduleEditor$UserSelectedInterval),
							A2(
								$author$project$UI$Select$withSelected,
								interval,
								$author$project$UI$Select$custom(
									{
										jD: $elm$core$String$toInt,
										k9: A2($elm$core$Basics$composeR, $elm$core$String$fromInt, toText),
										la: $elm$core$String$fromInt
									})))))
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$UserChangedStartDateInput = function (a) {
	return {$: 10, a: a};
};
var $author$project$Plan$Schedule$ScheduleEditor$UserEnteredStartDateText = function (a) {
	return {$: 11, a: a};
};
var $author$project$Translations$Plans$Schedule$startDateLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.startDateLabel');
};
var $author$project$Plan$Schedule$ScheduleEditor$viewStartDate = F5(
	function (translations, today, startDateInput, startDate, startDateTextInput) {
		var defaultYear = $author$project$Date_Time$NaiveDate$year(today);
		var defaultMonth = $author$project$Date_Time$NaiveDate$month(today);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(8)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$rem(2)),
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$startDateLabel(translations))
						])),
					A5(
					$author$project$UI$DateInput$view,
					translations,
					startDateInput,
					$elm$core$Maybe$Just(startDate),
					startDateTextInput,
					A2(
						$author$project$UI$DateInput$withStyle,
						$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
						A2(
							$author$project$UI$DateInput$withOnTextInput,
							$author$project$Plan$Schedule$ScheduleEditor$UserEnteredStartDateText,
							A3($author$project$UI$DateInput$dateInput, defaultYear, defaultMonth, $author$project$Plan$Schedule$ScheduleEditor$UserChangedStartDateInput))))
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$UserSelectedWeekday = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plan$Schedule$ScheduleEditor$UserUnselectedWeekday = function (a) {
	return {$: 3, a: a};
};
var $author$project$Translations$Weekdays$friday = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.friday');
};
var $author$project$Translations$Weekdays$monday = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.monday');
};
var $author$project$Translations$Weekdays$saturday = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.saturday');
};
var $author$project$Translations$Weekdays$sunday = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.sunday');
};
var $author$project$Translations$Weekdays$thursday = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.thursday');
};
var $author$project$Translations$Weekdays$tuesday = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.tuesday');
};
var $author$project$Translations$Weekdays$wednesday = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'weekdays.wednesday');
};
var $author$project$Date_Time$Weekday$translate = F2(
	function (translations, weekday) {
		switch (weekday) {
			case 0:
				return $author$project$Translations$Weekdays$monday(translations);
			case 1:
				return $author$project$Translations$Weekdays$tuesday(translations);
			case 2:
				return $author$project$Translations$Weekdays$wednesday(translations);
			case 3:
				return $author$project$Translations$Weekdays$thursday(translations);
			case 4:
				return $author$project$Translations$Weekdays$friday(translations);
			case 5:
				return $author$project$Translations$Weekdays$saturday(translations);
			default:
				return $author$project$Translations$Weekdays$sunday(translations);
		}
	});
var $author$project$Plan$Schedule$ScheduleEditor$viewWeekday = F3(
	function (translations, selectedWeekdays, weekday) {
		return $author$project$UI$Checkbox$view(
			A2(
				$author$project$UI$Checkbox$withOnCheck,
				A2(
					$author$project$Utils$Bool$ifElse,
					$author$project$Plan$Schedule$ScheduleEditor$UserSelectedWeekday(weekday),
					$author$project$Plan$Schedule$ScheduleEditor$UserUnselectedWeekday(weekday)),
				A2(
					$author$project$UI$Checkbox$checked,
					A2($author$project$Date_Time$Weekdays$member, weekday, selectedWeekdays),
					$author$project$UI$Checkbox$labeled(
						A2($author$project$Date_Time$Weekday$translate, translations, weekday)))));
	});
var $author$project$Translations$Plans$Schedule$Weekly$weekdayLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.weekly.weekdayLabel');
};
var $author$project$Plan$Schedule$ScheduleEditor$viewWeekdays = F2(
	function (translations, selectedWeekdays) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$stretch),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$minWidth(
									$rtfeldman$elm_css$Css$rem(8)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$rem(2)),
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$rem(0.5)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Plans$Schedule$Weekly$weekdayLabel(translations))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
									A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(auto-fill, minmax(10rem, 1fr))'),
									A2($rtfeldman$elm_css$Css$property, 'grid-gap', '1rem'),
									$rtfeldman$elm_css$Css$flexGrow(
									$rtfeldman$elm_css$Css$int(1))
								]))
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Plan$Schedule$ScheduleEditor$viewWeekday, translations, selectedWeekdays),
						$author$project$Date_Time$Weekday$all))
				]));
	});
var $author$project$Plan$Schedule$ScheduleEditor$viewForm = F2(
	function (translations, _v0) {
		var editor = _v0;
		var _v1 = editor.as;
		switch (_v1) {
			case 0:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Plan$Schedule$ScheduleEditor$viewFrequency, translations, editor.as),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewInterval, translations, editor.as, editor.a0),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewCreatingTime, translations, editor.aT, editor.aU),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewDeadlineTime, translations, editor.aW, editor.aX),
							A5($author$project$Plan$Schedule$ScheduleEditor$viewStartDate, translations, editor.lb, editor.bc, editor.a2, editor.bO),
							A5($author$project$Plan$Schedule$ScheduleEditor$viewEndDate, translations, editor.lb, editor.cQ, editor.aZ, editor.bE)
						]));
			case 1:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Plan$Schedule$ScheduleEditor$viewFrequency, translations, editor.as),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewInterval, translations, editor.as, editor.a0),
							A2($author$project$Plan$Schedule$ScheduleEditor$viewWeekdays, translations, editor.hq),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewCreatingTime, translations, editor.aT, editor.aU),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewDeadlineTime, translations, editor.aW, editor.aX),
							A5($author$project$Plan$Schedule$ScheduleEditor$viewStartDate, translations, editor.lb, editor.bc, editor.a2, editor.bO),
							A5($author$project$Plan$Schedule$ScheduleEditor$viewEndDate, translations, editor.lb, editor.cQ, editor.aZ, editor.bE)
						]));
			case 2:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Plan$Schedule$ScheduleEditor$viewFrequency, translations, editor.as),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewInterval, translations, editor.as, editor.a0),
							A2($author$project$Plan$Schedule$ScheduleEditor$viewDay, translations, editor.dz),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewCreatingTime, translations, editor.aT, editor.aU),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewDeadlineTime, translations, editor.aW, editor.aX),
							A5($author$project$Plan$Schedule$ScheduleEditor$viewStartDate, translations, editor.lb, editor.bc, editor.a2, editor.bO),
							A5($author$project$Plan$Schedule$ScheduleEditor$viewEndDate, translations, editor.lb, editor.cQ, editor.aZ, editor.bE)
						]));
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Plan$Schedule$ScheduleEditor$viewFrequency, translations, editor.as),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewInterval, translations, editor.as, editor.a0),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewDayAndMonth, translations, editor.dz, editor.gZ),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewCreatingTime, translations, editor.aT, editor.aU),
							A3($author$project$Plan$Schedule$ScheduleEditor$viewDeadlineTime, translations, editor.aW, editor.aX),
							A5($author$project$Plan$Schedule$ScheduleEditor$viewStartDate, translations, editor.lb, editor.bc, editor.a2, editor.bO),
							A5($author$project$Plan$Schedule$ScheduleEditor$viewEndDate, translations, editor.lb, editor.cQ, editor.aZ, editor.bE)
						]));
		}
	});
var $author$project$Plan$Execution$CreateModal$viewScheduleStep = F3(
	function (translations, platform, scheduleEditor) {
		var disableBtn = function () {
			var _v0 = $author$project$Plan$Schedule$ScheduleEditor$schedule(scheduleEditor);
			if (!_v0.$) {
				return false;
			} else {
				return true;
			}
		}();
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(46))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$Plan$Execution$CreateModal$viewFooter, translations, platform, disableBtn, 1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Plan$Execution$CreateModal$GotScheduleEditorMsg,
							A2($author$project$Plan$Schedule$ScheduleEditor$viewForm, translations, scheduleEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Plan$Schedule$ScheduleEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Plans$Schedule$createDialogHeader(translations),
									$author$project$Plan$Execution$CreateModal$UserClickedCloseDialog)))))));
	});
var $author$project$Plan$Execution$CreateModal$viewDialog = F3(
	function (translations, platform, model) {
		var _v0 = model.b0;
		if (!_v0) {
			return A3($author$project$Plan$Execution$CreateModal$viewBasicDataStep, translations, platform, model.aQ);
		} else {
			return A3($author$project$Plan$Execution$CreateModal$viewScheduleStep, translations, platform, model.ec);
		}
	});
var $author$project$Plan$Execution$CreateModal$view = F3(
	function (translations, environment, dialog) {
		if (!dialog.$) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var model = dialog.a;
			return A4(
				$rtfeldman$elm_css$Html$Styled$Lazy$lazy3,
				$author$project$Plan$Execution$CreateModal$viewDialog,
				translations,
				$author$project$Environments$Environment$platform(environment),
				model);
		}
	});
var $author$project$Plan$Execution$EditModal$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Plans$Schedule$editDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.editDialogHeader');
};
var $author$project$Translations$Plans$Schedule$deleted = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.deleted');
};
var $author$project$Plan$Execution$EditModal$viewDeleted = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Plans$Schedule$deleted(translations))
			]));
};
var $author$project$Plan$Execution$EditModal$UserClickedCloseButton = {$: 5};
var $author$project$Plan$Execution$EditModal$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Plan$Execution$EditModal$UserClickedCloseButton,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$Plan$Execution$EditModal$viewDeletedFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Plan$Execution$EditModal$viewCloseButton(translations)
			]));
};
var $author$project$Plan$Execution$EditModal$viewDeletedDialog = function (translations) {
	return $author$project$UI$Dialog$view(
		A2(
			$author$project$UI$Dialog$appendFooter,
			$author$project$Plan$Execution$EditModal$viewDeletedFooter(translations),
			A2(
				$author$project$UI$Dialog$appendContent,
				$author$project$Plan$Execution$EditModal$viewDeleted(translations),
				A2(
					$author$project$UI$Dialog$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
					A2(
						$author$project$UI$Dialog$dialog,
						$author$project$Translations$Plans$Schedule$editDialogHeader(translations),
						$author$project$Plan$Execution$EditModal$UserClickedCloseDialog)))));
};
var $author$project$Plan$Execution$EditModal$GotBasicDataEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Plan$Execution$EditModal$DeleteTab = 2;
var $author$project$Plan$Execution$EditModal$UserClickedApplyButton = {$: 3};
var $author$project$Plan$Execution$EditModal$viewApplyButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Plan$Execution$EditModal$UserClickedApplyButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$apply(translations)))));
	});
var $author$project$Plan$Execution$EditModal$UserClickedCancelButton = {$: 2};
var $author$project$Plan$Execution$EditModal$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Plan$Execution$EditModal$UserClickedCancelButton,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$Plan$Execution$EditModal$UserClickedDeleteButton = {$: 4};
var $author$project$Plan$Execution$EditModal$viewDeleteButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Plan$Execution$EditModal$UserClickedDeleteButton,
			$author$project$UI$Button$darkRed(
				$author$project$Translations$Buttons$delete(translations))));
};
var $author$project$Plan$Execution$EditModal$viewFooter = F3(
	function (translations, disableBtn, tab) {
		var rightButton = (tab === 2) ? $author$project$Plan$Execution$EditModal$viewDeleteButton(translations) : A2($author$project$Plan$Execution$EditModal$viewApplyButton, translations, disableBtn);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Plan$Execution$EditModal$viewCancelButton(translations),
					rightButton
				]));
	});
var $author$project$Plan$Execution$EditModal$UserClickedTabIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$Execution$EditModal$viewTabBarIcon = F3(
	function (icon, tab, currentTab) {
		return _Utils_eq(tab, currentTab) ? A2(
			$author$project$UI$Icon$withForegroundColor,
			$author$project$UI$Style$Theme$darkGrey,
			$author$project$UI$Icon$unicolor(icon)) : A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$Plan$Execution$EditModal$UserClickedTabIcon(tab),
			A2(
				$author$project$UI$Icon$withForegroundColor,
				$author$project$UI$Style$Theme$grey,
				$author$project$UI$Icon$unicolor(icon)));
	});
var $author$project$Plan$Execution$EditModal$viewTabBar = F2(
	function (execution, currentTab) {
		return $author$project$UI$TabBar$view(
			A2(
				$author$project$UI$TabBar$appendRightIcon,
				A3($author$project$Plan$Execution$EditModal$viewTabBarIcon, $author$project$UI$Icons$delete, 2, currentTab),
				A2(
					$author$project$UI$TabBar$appendRightIcon,
					A3($author$project$Plan$Execution$EditModal$viewTabBarIcon, $author$project$UI$Icons$clock, 1, currentTab),
					A2(
						$author$project$UI$TabBar$appendRightIcon,
						A3($author$project$Plan$Execution$EditModal$viewTabBarIcon, $author$project$UI$Icons$plan, 0, currentTab),
						A2(
							$author$project$UI$TabBar$withSubTitle,
							execution.aY,
							$author$project$UI$TabBar$tabBar(execution.k8))))));
	});
var $author$project$Plan$Execution$EditModal$viewBasicDataTab = F3(
	function (translations, basicDataEditor, execution) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(46))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Plan$Execution$EditModal$viewFooter, translations, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Plan$Execution$EditModal$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$Plan$Execution$EditModal$viewTabBar, execution, 0),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Plans$Schedule$editDialogHeader(translations),
										$author$project$Plan$Execution$EditModal$UserClickedCloseDialog))))))));
	});
var $author$project$Translations$Plans$Delete$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.delete.header');
};
var $author$project$Plan$Execution$EditModal$viewDeleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Plans$Delete$header(translations))));
};
var $author$project$Plan$Execution$EditModal$viewDeletePlanAvatar = $author$project$UI$Avatar$view(
	A2(
		$author$project$UI$Avatar$withStyle,
		$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
		A2(
			$author$project$UI$Avatar$withStyle,
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
			$author$project$UI$Avatar$icon(
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$plan)))));
var $author$project$Plan$Execution$EditModal$viewDeletePlanTitleAndDescription = function (execution) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$paddingLeft(
						$rtfeldman$elm_css$Css$rem(1.5))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1.2)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(execution.k8)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(execution.aY)
					]))
			]));
};
var $author$project$Plan$Execution$EditModal$viewDeleteDetails = function (execution) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$author$project$Plan$Execution$EditModal$viewDeletePlanAvatar,
				$author$project$Plan$Execution$EditModal$viewDeletePlanTitleAndDescription(execution)
			]));
};
var $author$project$Translations$Plans$Schedule$deleteQuestion = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.schedule.deleteQuestion');
};
var $author$project$Plan$Execution$EditModal$viewDeleteQuestion = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Plans$Schedule$deleteQuestion(translations))
			]));
};
var $author$project$Plan$Execution$EditModal$viewDeleteTab = F2(
	function (translations, model) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(46)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$rem(20))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Plan$Execution$EditModal$viewFooter, translations, false, 2),
					A2(
						$author$project$UI$Dialog$appendContent,
						$author$project$Plan$Execution$EditModal$viewDeleteDetails(model.jw),
						A2(
							$author$project$UI$Dialog$appendContent,
							$author$project$Plan$Execution$EditModal$viewDeleteQuestion(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$Plan$Execution$EditModal$viewDeleteBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A2($author$project$Plan$Execution$EditModal$viewTabBar, model.jw, 2),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Plans$Schedule$editDialogHeader(translations),
											$author$project$Plan$Execution$EditModal$UserClickedCloseDialog)))))))));
	});
var $author$project$Plan$Execution$EditModal$GotScheduleEditorMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Plan$Execution$EditModal$viewScheduleTab = F3(
	function (translations, scheduleEditor, execution) {
		var disableBtn = function () {
			var _v0 = $author$project$Plan$Schedule$ScheduleEditor$schedule(scheduleEditor);
			if (!_v0.$) {
				return false;
			} else {
				return true;
			}
		}();
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(46))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Plan$Execution$EditModal$viewFooter, translations, disableBtn, 1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Plan$Execution$EditModal$GotScheduleEditorMsg,
							A2($author$project$Plan$Schedule$ScheduleEditor$viewForm, translations, scheduleEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Plan$Schedule$ScheduleEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$Plan$Execution$EditModal$viewTabBar, execution, 1),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Plans$Schedule$editDialogHeader(translations),
										$author$project$Plan$Execution$EditModal$UserClickedCloseDialog))))))));
	});
var $author$project$Plan$Execution$EditModal$viewDialog = F2(
	function (translations, model) {
		var _v0 = model.cI;
		switch (_v0) {
			case 0:
				return A3($author$project$Plan$Execution$EditModal$viewBasicDataTab, translations, model.aQ, model.jw);
			case 1:
				return A3($author$project$Plan$Execution$EditModal$viewScheduleTab, translations, model.ec, model.jw);
			default:
				return A2($author$project$Plan$Execution$EditModal$viewDeleteTab, translations, model);
		}
	});
var $author$project$Plan$Execution$EditModal$view = F2(
	function (translations, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Plan$Execution$EditModal$viewDialog, translations, model);
			default:
				return A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Plan$Execution$EditModal$viewDeletedDialog, translations);
		}
	});
var $author$project$Plan$CreateDialog$UserClickedCrateExecution = {$: 6};
var $author$project$Translations$Plans$Execution$execution = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.execution.execution');
};
var $author$project$Plan$CreateDialog$viewExecutionBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withRightIcon,
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Plan$CreateDialog$UserClickedCrateExecution,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
			A2(
				$author$project$UI$Bar$withLeftIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$clock),
				$author$project$UI$Bar$bar(
					$author$project$Translations$Plans$Execution$execution(translations)))));
};
var $author$project$Translations$Plans$Execution$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.execution.emptyText');
};
var $author$project$Plan$CreateDialog$UserClickedEditExecution = function (a) {
	return {$: 8, a: a};
};
var $author$project$Plan$CreateDialog$viewExecutionRow = F2(
	function (viewType, execution) {
		return A2(
			$author$project$UI$Table$Row$withRightIcon,
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Plan$CreateDialog$UserClickedEditExecution(execution),
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle)),
			A2(
				$author$project$UI$Table$Row$withSubLabel,
				execution.aY,
				A3($author$project$UI$Table$Row$row, viewType, execution.k8, execution)));
	});
var $author$project$Plan$CreateDialog$viewExecutionTable = F3(
	function (translations, viewType, executions) {
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Plans$Execution$emptyText(translations),
				A2(
					$author$project$UI$Table$fromList,
					$author$project$Plan$CreateDialog$viewExecutionRow(viewType),
					A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.k8;
						},
						executions))));
	});
var $author$project$Plan$CreateDialog$viewExecutionStep = F3(
	function (translations, environment, model) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4(
						$author$project$Plan$CreateDialog$viewFooter,
						translations,
						$author$project$Environments$Environment$platform(environment),
						false,
						1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Plan$CreateDialog$GotExecutionEditMsg,
							A2($author$project$Plan$Execution$EditModal$view, translations, model.dG)),
						A2(
							$author$project$UI$Dialog$appendContent,
							A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Plan$CreateDialog$GotExecutionCreateMsg,
								A3($author$project$Plan$Execution$CreateModal$view, translations, environment, model.dF)),
							A2(
								$author$project$UI$Dialog$appendContent,
								A3(
									$author$project$Plan$CreateDialog$viewExecutionTable,
									translations,
									$author$project$Environments$Environment$getViewType(environment),
									model.fr),
								A2(
									$author$project$UI$Dialog$appendHeader,
									$author$project$Plan$CreateDialog$viewExecutionBar(translations),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Plans$createDialogHeader(translations),
											$author$project$Plan$CreateDialog$UserClickedCloseDialog)))))))));
	});
var $author$project$Plan$CreateDialog$viewDialog = F4(
	function (translations, environment, repository, model) {
		var platform = $author$project$Environments$Environment$platform(environment);
		var _v0 = model.b0;
		switch (_v0) {
			case 0:
				return A3($author$project$Plan$CreateDialog$viewBasicDataStep, translations, platform, model.aQ);
			case 1:
				return A3($author$project$Plan$CreateDialog$viewExecutionStep, translations, environment, model);
			case 2:
				return A5($author$project$Plan$CreateDialog$viewCheckpointGroupsStep, translations, environment, platform, repository, model.cX);
			default:
				return A4(
					$author$project$Plan$CreateDialog$viewAuditorsStep,
					environment,
					platform,
					model.cv,
					$author$project$Environments$Repository$users(repository));
		}
	});
var $author$project$Plan$CreateDialog$view = F4(
	function (translations, repository, environment, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$Plan$CreateDialog$viewDialog, translations, environment, repository, model);
			default:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$Plan$CreateDialog$viewDialog, translations, environment, repository, model);
		}
	});
var $author$project$Plan$Page$viewCreateDialog = F3(
	function (translations, repository, environment) {
		return A2(
			$elm$core$Basics$composeR,
			A3($author$project$Plan$CreateDialog$view, translations, repository, environment),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Plan$Page$GotCreateDialogMsg));
	});
var $author$project$Plan$EditDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Plans$editDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.editDialogHeader');
};
var $author$project$Translations$Plans$deleted = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.deleted');
};
var $author$project$Plan$EditDialog$viewDeleted = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Plans$deleted(translations))
			]));
};
var $author$project$Plan$EditDialog$UserClickedCloseButton = {$: 5};
var $author$project$Plan$EditDialog$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Plan$EditDialog$UserClickedCloseButton,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$Plan$EditDialog$viewDeletedFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Plan$EditDialog$viewCloseButton(translations)
			]));
};
var $author$project$Plan$EditDialog$viewDeletedDialog = function (translations) {
	return $author$project$UI$Dialog$view(
		A2(
			$author$project$UI$Dialog$appendFooter,
			$author$project$Plan$EditDialog$viewDeletedFooter(translations),
			A2(
				$author$project$UI$Dialog$appendContent,
				$author$project$Plan$EditDialog$viewDeleted(translations),
				A2(
					$author$project$UI$Dialog$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
					A2(
						$author$project$UI$Dialog$dialog,
						$author$project$Translations$Plans$editDialogHeader(translations),
						$author$project$Plan$EditDialog$UserClickedCloseDialog)))));
};
var $author$project$Plan$EditDialog$AuditorsTab = 3;
var $author$project$Plan$EditDialog$UserSelectedAuditor = function (a) {
	return {$: 12, a: a};
};
var $author$project$Plan$EditDialog$UserUnselectedAuditor = function (a) {
	return {$: 13, a: a};
};
var $author$project$Plan$EditDialog$viewAuditorsTable = $author$project$Plan$AuditorEditor$viewTable(
	{kf: $author$project$Plan$EditDialog$UserSelectedAuditor, kg: $author$project$Plan$EditDialog$UserUnselectedAuditor});
var $author$project$Plan$EditDialog$DeleteTab = 4;
var $author$project$Plan$EditDialog$UserClickedApplyButton = {$: 3};
var $author$project$Plan$EditDialog$viewApplyButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Plan$EditDialog$UserClickedApplyButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$apply(translations)))));
	});
var $author$project$Plan$EditDialog$UserClickedCancelButton = {$: 2};
var $author$project$Plan$EditDialog$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Plan$EditDialog$UserClickedCancelButton,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$Plan$EditDialog$UserClickedDeleteButton = {$: 4};
var $author$project$Plan$EditDialog$viewDeleteButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Plan$EditDialog$UserClickedDeleteButton,
			$author$project$UI$Button$darkRed(
				$author$project$Translations$Buttons$delete(translations))));
};
var $author$project$Plan$EditDialog$viewFooter = F3(
	function (translations, disableBtn, tab) {
		var rightButton = (tab === 4) ? $author$project$Plan$EditDialog$viewDeleteButton(translations) : A2($author$project$Plan$EditDialog$viewApplyButton, translations, disableBtn);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Plan$EditDialog$viewCancelButton(translations),
					rightButton
				]));
	});
var $author$project$Plan$EditDialog$ExecutionTab = 1;
var $author$project$Plan$EditDialog$UserClickedTabIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plan$EditDialog$viewTabBarIcon = F3(
	function (icon, tab, currentTab) {
		return _Utils_eq(tab, currentTab) ? A2(
			$author$project$UI$Icon$withForegroundColor,
			$author$project$UI$Style$Theme$darkGrey,
			$author$project$UI$Icon$unicolor(icon)) : A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$Plan$EditDialog$UserClickedTabIcon(tab),
			A2(
				$author$project$UI$Icon$withForegroundColor,
				$author$project$UI$Style$Theme$grey,
				$author$project$UI$Icon$unicolor(icon)));
	});
var $author$project$Plan$EditDialog$viewTabBar = F2(
	function (plan, currentTab) {
		return $author$project$UI$TabBar$view(
			A2(
				$author$project$UI$TabBar$appendRightIcon,
				A3($author$project$Plan$EditDialog$viewTabBarIcon, $author$project$UI$Icons$delete, 4, currentTab),
				A2(
					$author$project$UI$TabBar$appendRightIcon,
					A3($author$project$Plan$EditDialog$viewTabBarIcon, $author$project$UI$Icons$user, 3, currentTab),
					A2(
						$author$project$UI$TabBar$appendRightIcon,
						A3($author$project$Plan$EditDialog$viewTabBarIcon, $author$project$UI$Icons$factory, 2, currentTab),
						A2(
							$author$project$UI$TabBar$appendRightIcon,
							A3($author$project$Plan$EditDialog$viewTabBarIcon, $author$project$UI$Icons$clock, 1, currentTab),
							A2(
								$author$project$UI$TabBar$appendRightIcon,
								A3($author$project$Plan$EditDialog$viewTabBarIcon, $author$project$UI$Icons$plan, 0, currentTab),
								A2(
									$author$project$UI$TabBar$withSubTitle,
									plan.aY,
									$author$project$UI$TabBar$tabBar(plan.k8))))))));
	});
var $author$project$Plan$EditDialog$viewAuditorsTab = F4(
	function (environment, auditors, selectedAuditors, plan) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Plan$EditDialog$viewFooter, translations, false, 3),
					A2(
						$author$project$UI$Dialog$appendContent,
						A3($author$project$Plan$EditDialog$viewAuditorsTable, environment, selectedAuditors, auditors),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Plan$AuditorEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$Plan$EditDialog$viewTabBar, plan, 3),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Plans$editDialogHeader(translations),
										$author$project$Plan$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Plan$EditDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Plan$EditDialog$viewBasicDataTab = F3(
	function (translations, basicDataEditor, plan) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Plan$EditDialog$viewFooter, translations, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Plan$EditDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$Plan$EditDialog$viewTabBar, plan, 0),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Plans$editDialogHeader(translations),
										$author$project$Plan$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Plan$EditDialog$GotCheckpointGroupEditorMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Plan$EditDialog$viewCheckpointGroupTab = F5(
	function (translations, environment, repository, checkpointGroupEditor, plan) {
		var disableBtn = $author$project$CheckpointData$CheckpointGroup$Ids$isEmpty(
			$author$project$Plan$CheckpointGroupEditor$checkpointGroupIds(checkpointGroupEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Plan$EditDialog$viewFooter, translations, disableBtn, 2),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Plan$EditDialog$GotCheckpointGroupEditorMsg,
							A3($author$project$Plan$CheckpointGroupEditor$viewContent, environment, repository, checkpointGroupEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Plan$CheckpointGroupEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$Plan$EditDialog$viewTabBar, plan, 2),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Plans$editDialogHeader(translations),
										$author$project$Plan$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Plan$EditDialog$viewDeleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Plans$Delete$header(translations))));
};
var $author$project$Plan$EditDialog$viewDeletePlanAvatar = $author$project$UI$Avatar$view(
	A2(
		$author$project$UI$Avatar$withStyle,
		$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
		A2(
			$author$project$UI$Avatar$withStyle,
			$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
			$author$project$UI$Avatar$icon(
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$plan)))));
var $author$project$Plan$EditDialog$viewDeletePlanTitleAndDescription = function (plan) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$paddingLeft(
						$rtfeldman$elm_css$Css$rem(1.5))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1.2)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(plan.k8)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(plan.aY)
					]))
			]));
};
var $author$project$Plan$EditDialog$viewDeleteDetails = function (plan) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$author$project$Plan$EditDialog$viewDeletePlanAvatar,
				$author$project$Plan$EditDialog$viewDeletePlanTitleAndDescription(plan)
			]));
};
var $author$project$Translations$Plans$Delete$question = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'plans.delete.question');
};
var $author$project$Plan$EditDialog$viewDeleteQuestion = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Plans$Delete$question(translations))
			]));
};
var $author$project$Plan$EditDialog$viewDeleteTab = F2(
	function (translations, plan) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Plan$EditDialog$viewFooter, translations, false, 4),
					A2(
						$author$project$UI$Dialog$appendContent,
						$author$project$Plan$EditDialog$viewDeleteDetails(plan),
						A2(
							$author$project$UI$Dialog$appendContent,
							$author$project$Plan$EditDialog$viewDeleteQuestion(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$Plan$EditDialog$viewDeleteBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A2($author$project$Plan$EditDialog$viewTabBar, plan, 4),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Plans$editDialogHeader(translations),
											$author$project$Plan$EditDialog$UserClickedCloseDialog)))))))));
	});
var $author$project$Plan$EditDialog$UserClickedCreateExecution = {$: 7};
var $author$project$Plan$EditDialog$viewExecutionBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withRightIcon,
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Plan$EditDialog$UserClickedCreateExecution,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
			A2(
				$author$project$UI$Bar$withLeftIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$clock),
				$author$project$UI$Bar$bar(
					$author$project$Translations$Plans$Execution$execution(translations)))));
};
var $author$project$Plan$EditDialog$replaceEditedExecutions = F2(
	function (changedExecutions, planExecutions) {
		var idsOfEdited = A2(
			$elm$core$List$map,
			function (execution) {
				return execution.dH;
			},
			changedExecutions);
		return A2(
			$elm$core$List$append,
			changedExecutions,
			A2(
				$elm$core$List$filter,
				function (execution) {
					return !A2($elm$core$List$member, execution.dH, idsOfEdited);
				},
				planExecutions));
	});
var $author$project$Plan$EditDialog$UserClickedEditExecution = function (a) {
	return {$: 9, a: a};
};
var $author$project$Plan$EditDialog$viewExecutionRow = F2(
	function (viewType, execution) {
		return A2(
			$author$project$UI$Table$Row$withRightIcon,
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Plan$EditDialog$UserClickedEditExecution(execution),
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle)),
			A2(
				$author$project$UI$Table$Row$withSubLabel,
				execution.aY,
				A3($author$project$UI$Table$Row$row, viewType, execution.k8, execution)));
	});
var $author$project$Plan$EditDialog$viewExecutionTable = F4(
	function (translations, viewType, model, plan) {
		var executions = A2(
			$elm$core$List$filter,
			function (execution) {
				return !A2($elm$core$List$member, execution.dH, model.cK);
			},
			A2(
				$author$project$Plan$EditDialog$replaceEditedExecutions,
				model.aS,
				A2($elm$core$List$append, model.av, plan.fr)));
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Plans$Execution$emptyText(translations),
				A2(
					$author$project$UI$Table$fromList,
					$author$project$Plan$EditDialog$viewExecutionRow(viewType),
					A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.k8;
						},
						executions))));
	});
var $author$project$Plan$EditDialog$viewExecutionTab = F4(
	function (translations, environment, model, plan) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90)),
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Plan$EditDialog$viewFooter, translations, false, 1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Plan$EditDialog$GotExecutionEditMsg,
							A2($author$project$Plan$Execution$EditModal$view, translations, model.dG)),
						A2(
							$author$project$UI$Dialog$appendContent,
							A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Plan$EditDialog$GotExecutionCreateMsg,
								A3($author$project$Plan$Execution$CreateModal$view, translations, environment, model.dF)),
							A2(
								$author$project$UI$Dialog$appendContent,
								A4(
									$author$project$Plan$EditDialog$viewExecutionTable,
									translations,
									$author$project$Environments$Environment$getViewType(environment),
									model,
									plan),
								A2(
									$author$project$UI$Dialog$appendHeader,
									$author$project$Plan$EditDialog$viewExecutionBar(translations),
									A2(
										$author$project$UI$Dialog$appendHeader,
										A2($author$project$Plan$EditDialog$viewTabBar, plan, 1),
										A2(
											$author$project$UI$Dialog$withIcon,
											$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
											A2(
												$author$project$UI$Dialog$dialog,
												$author$project$Translations$Plans$editDialogHeader(translations),
												$author$project$Plan$EditDialog$UserClickedCloseDialog))))))))));
	});
var $author$project$Plan$EditDialog$viewTab = F4(
	function (translations, environment, repository, model) {
		var _v0 = model.cI;
		switch (_v0) {
			case 0:
				return A2($author$project$Plan$EditDialog$viewBasicDataTab, translations, model.aQ);
			case 1:
				return A3($author$project$Plan$EditDialog$viewExecutionTab, translations, environment, model);
			case 2:
				return A4($author$project$Plan$EditDialog$viewCheckpointGroupTab, translations, environment, repository, model.cX);
			case 3:
				var users = $author$project$Environments$Repository$users(repository);
				return A3($author$project$Plan$EditDialog$viewAuditorsTab, environment, users, model.cv);
			default:
				return $author$project$Plan$EditDialog$viewDeleteTab(translations);
		}
	});
var $author$project$Plan$EditDialog$viewDialog = F4(
	function (translations, environment, repository, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Plan$EditDialog$viewDeletedDialog(translations),
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Plan$EditDialog$viewTab, translations, environment, repository, model),
				A2($author$project$Environments$Repository$getPlan, model.aK.d5, repository)));
	});
var $author$project$Plan$EditDialog$view = F4(
	function (translations, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$Plan$EditDialog$viewDialog, translations, environment, repository, model);
			case 2:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$Plan$EditDialog$viewDialog, translations, environment, repository, model);
			default:
				return A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Plan$EditDialog$viewDeletedDialog, translations);
		}
	});
var $author$project$Plan$Page$viewEditDialog = F3(
	function (translations, repository, environment) {
		return A2(
			$elm$core$Basics$composeR,
			A3($author$project$Plan$EditDialog$view, translations, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Plan$Page$GotEditDialogMsg));
	});
var $author$project$Plan$Page$UserClickedEditIcon = function (a) {
	return {$: 3, a: a};
};
var $author$project$Plan$Page$viewEditIcon = function (plan) {
	return $author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle);
};
var $author$project$Plan$Page$viewRow = F2(
	function (viewType, plan) {
		return A2(
			$author$project$UI$Table$Row$withOnClick,
			$author$project$Plan$Page$UserClickedEditIcon(plan),
			A2(
				$author$project$UI$Table$Row$withRightIcon,
				$author$project$Plan$Page$viewEditIcon(plan),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					plan.aY,
					A3($author$project$UI$Table$Row$row, viewType, plan.k8, plan))));
	});
var $author$project$Plan$Page$viewTable = F2(
	function (translations, viewType) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Environments$Repository$plans,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Plan$Dict$values,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$sortBy(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.k8;
							},
							$elm$core$String$toLower)),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Table$fromList(
							$author$project$Plan$Page$viewRow(viewType)),
						A2(
							$elm$core$Basics$composeR,
							$author$project$UI$Table$withEmptyText(
								$author$project$Translations$Plans$emptyText(translations)),
							$author$project$UI$Table$view)))));
	});
var $author$project$Plan$Page$view = F3(
	function (environment, repository, page) {
		if (!page.$) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var model = page.a;
			var translations = $author$project$Environments$Environment$translations(environment);
			return A2(
				$author$project$UI$Page$view,
				environment,
				A2(
					$author$project$UI$Page$appendContent,
					A4($author$project$Plan$Page$viewEditDialog, translations, repository, environment, model.cO),
					A2(
						$author$project$UI$Page$appendContent,
						A4($author$project$Plan$Page$viewCreateDialog, translations, repository, environment, model.fi),
						A2(
							$author$project$UI$Page$appendContent,
							A4(
								$rtfeldman$elm_css$Html$Styled$Lazy$lazy3,
								$author$project$Plan$Page$viewTable,
								translations,
								$author$project$Environments$Environment$getViewType(environment),
								repository),
							A2(
								$author$project$UI$Page$appendContent,
								A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Plan$Page$viewActionBar, translations),
								A2(
									$author$project$UI$Page$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$plan),
									$author$project$UI$Page$page(
										$author$project$Translations$Plans$header(translations))))))));
		}
	});
var $author$project$Page$Page$plans = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 7) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotPlanPageMsg,
		kZ: $elm$core$Maybe$Nothing,
		le: $author$project$Plan$Page$update,
		lm: $author$project$Plan$Page$view
	});
var $author$project$Page$Page$GotRolePageMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Rights$Role$Page$GotCreateDialogMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Role$Page$createDialog = function (_v0) {
	var page = _v0;
	return page.fi;
};
var $author$project$Rights$Role$CreateDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Role$CreateDialog$addMultipleRights = F4(
	function (newRights, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var newSelectedRights = _Utils_eq(
				model.aw,
				_List_fromArray(
					[3])) ? model.aw : A2(
				$author$project$Utils$List$uniqueBy,
				$elm$core$Basics$identity,
				A2($elm$core$List$append, model.aw, newRights));
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$CreateDialog$Visible(
					_Utils_update(
						model,
						{aw: newSelectedRights})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$CommandHandler$RoleAlreadyExists = function (a) {
	return {$: 1, a: a};
};
var $author$project$Environments$Repository$getRights = function (_v0) {
	var data = _v0;
	return A2(
		$author$project$Rights$EventApplier$applyEvents,
		$author$project$Rights$Store$events(data.al),
		$author$project$Rights$Store$rights(data.al)).a;
};
var $author$project$Rights$Commands$fold = $author$project$Types$Queue$fold;
var $author$project$Rights$CommandHandler$TeamDoesNotExist = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Commands$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$OrganisationUnit$Ids$isEmpty = $turboMaCk$any_set$Set$Any$isEmpty;
var $author$project$Rights$CommandHandler$handleAddOrganisationUnitsCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, acc.kF);
		if (!_v0.$) {
			var team = _v0.a;
			var newOrganisationUnitsId = A2($author$project$OrganisationUnit$Ids$diff, payload.kn, team.kn);
			if ($author$project$OrganisationUnit$Ids$isEmpty(newOrganisationUnitsId)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Rights$Event$OrganisationUnitsAdded(
					{L: payload.L, M: payload.M, N: eventId, kn: payload.kn, k1: payload.k1, n: team.i + 1});
				var _v2 = A2(
					$author$project$Rights$EventApplier$applyEventsHelper,
					$author$project$Rights$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.kF;
						},
						function ($) {
							return $.g;
						},
						acc));
				var newRights = _v2.a;
				var newModification = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Rights$Commands$enqueue,
							$author$project$Rights$Command$AddOrganisationUnits(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
						g: newModification,
						kF: newRights
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Rights$CommandHandler$TeamDoesNotExist(payload.k1));
		}
	});
var $author$project$Rights$CommandHandler$RoleDoesNotExist = function (a) {
	return {$: 0, a: a};
};
var $author$project$Rights$CommandHandler$handleAddRightsCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, acc.kF);
		if (!_v0.$) {
			var role = _v0.a;
			var newRightsList = A2(
				$elm$core$List$filter,
				function (newRight) {
					return !A2($elm$core$List$member, newRight, role.kF);
				},
				payload.kF);
			if ($elm$core$List$isEmpty(newRightsList)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Rights$Event$RightsAdded(
					{L: payload.L, M: payload.M, N: eventId, kF: payload.kF, hc: payload.hc, n: role.i + 1});
				var _v2 = A2(
					$author$project$Rights$EventApplier$applyEventsHelper,
					$author$project$Rights$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.kF;
						},
						function ($) {
							return $.g;
						},
						acc));
				var newRights = _v2.a;
				var newModification = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Rights$Commands$enqueue,
							$author$project$Rights$Command$AddRights(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
						g: newModification,
						kF: newRights
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Rights$CommandHandler$RoleDoesNotExist(payload.hc));
		}
	});
var $author$project$Rights$CommandHandler$handleChangeRoleDescriptionCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, acc.kF);
		if (!_v0.$) {
			var role = _v0.a;
			if (_Utils_eq(role.aY, payload.aY)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Rights$Event$RoleDescriptionChanged(
					{L: payload.L, M: payload.M, aY: payload.aY, N: eventId, hc: payload.hc, n: role.i + 1});
				var _v2 = A2(
					$author$project$Rights$EventApplier$applyEventsHelper,
					$author$project$Rights$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.kF;
						},
						function ($) {
							return $.g;
						},
						acc));
				var newRights = _v2.a;
				var newModification = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Rights$Commands$enqueue,
							$author$project$Rights$Command$ChangeRoleDescription(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
						g: newModification,
						kF: newRights
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Rights$CommandHandler$RoleDoesNotExist(payload.hc));
		}
	});
var $author$project$Rights$CommandHandler$handleChangeRoleTitleCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, acc.kF);
		if (!_v0.$) {
			var role = _v0.a;
			if (_Utils_eq(role.k8, payload.k8)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Rights$Event$RoleTitleChanged(
					{L: payload.L, M: payload.M, N: eventId, hc: payload.hc, k8: payload.k8, n: role.i + 1});
				var _v2 = A2(
					$author$project$Rights$EventApplier$applyEventsHelper,
					$author$project$Rights$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.kF;
						},
						function ($) {
							return $.g;
						},
						acc));
				var newRights = _v2.a;
				var newModification = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Rights$Commands$enqueue,
							$author$project$Rights$Command$ChangeRoleTitle(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
						g: newModification,
						kF: newRights
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Rights$CommandHandler$RoleDoesNotExist(payload.hc));
		}
	});
var $author$project$Rights$CommandHandler$handleChangeTeamDescriptionCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, acc.kF);
		if (!_v0.$) {
			var team = _v0.a;
			if (_Utils_eq(team.aY, payload.aY)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Rights$Event$TeamDescriptionChanged(
					{L: payload.L, M: payload.M, aY: payload.aY, N: eventId, k1: payload.k1, n: team.i + 1});
				var _v2 = A2(
					$author$project$Rights$EventApplier$applyEventsHelper,
					$author$project$Rights$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.kF;
						},
						function ($) {
							return $.g;
						},
						acc));
				var newRights = _v2.a;
				var newModification = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Rights$Commands$enqueue,
							$author$project$Rights$Command$ChangeTeamDescription(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
						g: newModification,
						kF: newRights
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Rights$CommandHandler$TeamDoesNotExist(payload.k1));
		}
	});
var $author$project$Rights$CommandHandler$handleChangeTeamTitleCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, acc.kF);
		if (!_v0.$) {
			var team = _v0.a;
			if (_Utils_eq(team.k8, payload.k8)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Rights$Event$TeamTitleChanged(
					{L: payload.L, M: payload.M, N: eventId, k1: payload.k1, k8: payload.k8, n: team.i + 1});
				var _v2 = A2(
					$author$project$Rights$EventApplier$applyEventsHelper,
					$author$project$Rights$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.kF;
						},
						function ($) {
							return $.g;
						},
						acc));
				var newRights = _v2.a;
				var newModification = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Rights$Commands$enqueue,
							$author$project$Rights$Command$ChangeTeamTitle(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
						g: newModification,
						kF: newRights
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Rights$CommandHandler$TeamDoesNotExist(payload.k1));
		}
	});
var $author$project$Rights$CommandHandler$handleCreateRoleCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, acc.kF);
		if (!_v0.$) {
			var role = _v0.a;
			return $elm$core$Result$Err(
				$author$project$Rights$CommandHandler$RoleAlreadyExists(role.hc));
		} else {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Rights$Event$RoleCreated(
				{L: payload.L, M: payload.M, aY: payload.aY, N: eventId, kF: payload.kF, hc: payload.hc, k8: payload.k8, n: 0});
			var _v2 = A2(
				$author$project$Rights$EventApplier$applyEventsHelper,
				$author$project$Rights$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.kF;
					},
					function ($) {
						return $.g;
					},
					acc));
			var newRights = _v2.a;
			var newModification = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Rights$Commands$enqueue,
						$author$project$Rights$Command$CreateRole(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
					g: newModification,
					kF: newRights
				});
		}
	});
var $author$project$Rights$CommandHandler$TeamAlreadyExists = function (a) {
	return {$: 3, a: a};
};
var $author$project$Rights$CommandHandler$handleCreateTeamCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, acc.kF);
		if (!_v0.$) {
			var team = _v0.a;
			return $elm$core$Result$Err(
				$author$project$Rights$CommandHandler$TeamAlreadyExists(team.k1));
		} else {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Rights$Event$TeamCreated(
				{L: payload.L, M: payload.M, aY: payload.aY, N: eventId, kn: payload.kn, k1: payload.k1, k8: payload.k8, n: 0});
			var _v2 = A2(
				$author$project$Rights$EventApplier$applyEventsHelper,
				$author$project$Rights$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.kF;
					},
					function ($) {
						return $.g;
					},
					acc));
			var newRights = _v2.a;
			var newModification = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Rights$Commands$enqueue,
						$author$project$Rights$Command$CreateTeam(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
					g: newModification,
					kF: newRights
				});
		}
	});
var $author$project$Rights$CommandHandler$handleDeleteRoleCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, acc.kF);
		if (!_v0.$) {
			var role = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Rights$Event$RoleDeleted(
				{L: payload.L, M: payload.M, N: eventId, hc: payload.hc, n: role.i + 1});
			var _v2 = A2(
				$author$project$Rights$EventApplier$applyEventsHelper,
				$author$project$Rights$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.kF;
					},
					function ($) {
						return $.g;
					},
					acc));
			var newRights = _v2.a;
			var newModification = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Rights$Commands$enqueue,
						$author$project$Rights$Command$DeleteRole(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
					g: newModification,
					kF: newRights
				});
		} else {
			return $elm$core$Result$Ok(acc);
		}
	});
var $author$project$Rights$CommandHandler$handleDeleteTeamCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, acc.kF);
		if (!_v0.$) {
			var team = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Rights$Event$TeamDeleted(
				{L: payload.L, M: payload.M, N: eventId, k1: payload.k1, n: team.i + 1});
			var _v2 = A2(
				$author$project$Rights$EventApplier$applyEventsHelper,
				$author$project$Rights$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.kF;
					},
					function ($) {
						return $.g;
					},
					acc));
			var newRights = _v2.a;
			var newModification = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Rights$Commands$enqueue,
						$author$project$Rights$Command$DeleteTeam(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
					g: newModification,
					kF: newRights
				});
		} else {
			return $elm$core$Result$Ok(acc);
		}
	});
var $author$project$Rights$CommandHandler$handleRemoveOrganisationUnitsCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getTeam, payload.k1, acc.kF);
		if (!_v0.$) {
			var team = _v0.a;
			var oldOrganisationUnitsId = A2($author$project$OrganisationUnit$Ids$diff, payload.kn, team.kn);
			if (!$author$project$OrganisationUnit$Ids$isEmpty(oldOrganisationUnitsId)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Rights$Event$OrganisationUnitsRemoved(
					{L: payload.L, M: payload.M, N: eventId, kn: payload.kn, k1: payload.k1, n: team.i + 1});
				var _v2 = A2(
					$author$project$Rights$EventApplier$applyEventsHelper,
					$author$project$Rights$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.kF;
						},
						function ($) {
							return $.g;
						},
						acc));
				var newRights = _v2.a;
				var newModification = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Rights$Commands$enqueue,
							$author$project$Rights$Command$RemoveOrganisationUnits(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
						g: newModification,
						kF: newRights
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Rights$CommandHandler$TeamDoesNotExist(payload.k1));
		}
	});
var $author$project$Rights$CommandHandler$handleRemoveRightsCommand = F2(
	function (payload, acc) {
		var _v0 = A2($author$project$Rights$Rights$getRole, payload.hc, acc.kF);
		if (!_v0.$) {
			var role = _v0.a;
			var oldRightsList = A2(
				$elm$core$List$filter,
				function (newRight) {
					return A2($elm$core$List$member, newRight, role.kF);
				},
				payload.kF);
			if ($elm$core$List$isEmpty(oldRightsList)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$Rights$Event$RightsRemoved(
					{L: payload.L, M: payload.M, N: eventId, kF: payload.kF, hc: payload.hc, n: role.i + 1});
				var _v2 = A2(
					$author$project$Rights$EventApplier$applyEventsHelper,
					$author$project$Rights$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.kF;
						},
						function ($) {
							return $.g;
						},
						acc));
				var newRights = _v2.a;
				var newModification = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$Rights$Commands$enqueue,
							$author$project$Rights$Command$RemoveRights(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$Rights$Events$enqueue, event, acc.b8),
						g: newModification,
						kF: newRights
					});
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Rights$CommandHandler$RoleDoesNotExist(payload.hc));
		}
	});
var $author$project$Rights$CommandHandler$handleCommandHelper = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleCreateRoleCommand(payload);
		case 1:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleChangeRoleTitleCommand(payload);
		case 2:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleChangeRoleDescriptionCommand(payload);
		case 3:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleAddRightsCommand(payload);
		case 4:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleRemoveRightsCommand(payload);
		case 5:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleDeleteRoleCommand(payload);
		case 6:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleCreateTeamCommand(payload);
		case 7:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleChangeTeamTitleCommand(payload);
		case 8:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleChangeTeamDescriptionCommand(payload);
		case 9:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleAddOrganisationUnitsCommand(payload);
		case 10:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleRemoveOrganisationUnitsCommand(payload);
		default:
			var payload = command.a;
			return $author$project$Rights$CommandHandler$handleDeleteTeamCommand(payload);
	}
};
var $author$project$Rights$CommandHandler$handleCommands = F3(
	function (commands, environment, rights) {
		var modifications = $author$project$Rights$Modifications$empty;
		var acc = $elm$core$Result$Ok(
			{cD: $author$project$Rights$Commands$empty, ac: environment, b8: $author$project$Rights$Events$empty, g: modifications, kF: rights});
		return A2(
			$elm$core$Result$map,
			function (resultData) {
				return {cD: resultData.cD, ac: resultData.ac, b8: resultData.b8};
			},
			A3(
				$author$project$Rights$Commands$fold,
				A2($elm$core$Basics$composeR, $author$project$Rights$CommandHandler$handleCommandHelper, $elm$core$Result$andThen),
				acc,
				commands));
	});
var $author$project$Environments$ErrorHandling$ToString$rightsErrorToString = function (err) {
	switch (err.$) {
		case 0:
			var id = err.a;
			return 'Rights.RoleDoesNotExist' + $author$project$Rights$Role$Id$toString(id);
		case 1:
			var id = err.a;
			return 'Rights.RoleDoesNotExist' + $author$project$Rights$Role$Id$toString(id);
		case 2:
			var id = err.a;
			return 'Rights.RoleDoesNotExist' + $author$project$Rights$Team$Id$toString(id);
		default:
			var id = err.a;
			return 'Rights.RoleDoesNotExist' + $author$project$Rights$Team$Id$toString(id);
	}
};
var $author$project$Rights$Store$SaveCommandsAndEvents = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Rights$Commands$merge = $author$project$Types$Queue$merge;
var $author$project$Rights$Events$merge = $author$project$Types$Queue$merge;
var $author$project$Rights$Store$saveCommandsAndEvents = F3(
	function (commands_, events_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Rights$Store$Saving(
							{
								cD: A2($author$project$Rights$Commands$merge, data.cD, commands_),
								b8: A2($author$project$Rights$Events$merge, data.b8, events_),
								kF: $author$project$Rights$Rights$empty
							}),
						$author$project$Rights$Store$send(
							A2($author$project$Rights$Store$SaveCommandsAndEvents, commands_, events_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Rights$Store$Saving(
							_Utils_update(
								data,
								{
									cD: A2($author$project$Rights$Commands$merge, data.cD, commands_),
									b8: A2($author$project$Rights$Events$merge, data.b8, events_)
								})),
						$author$project$Rights$Store$send(
							A2($author$project$Rights$Store$SaveCommandsAndEvents, commands_, events_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$saveRightsCommandsAndEvents = F3(
	function (commands, events, repository) {
		var _v0 = A3(
			$author$project$Rights$Store$saveCommandsAndEvents,
			commands,
			events,
			$author$project$Environments$Repository$rightsStore(repository));
		if (!_v0.$) {
			var _v1 = _v0.a;
			var newRightsStore = _v1.a;
			var rightsStoreCmd = _v1.b;
			return _Utils_Tuple2(
				A2($author$project$Environments$Repository$withRightsStore, newRightsStore, repository),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[rightsStoreCmd])));
		} else {
			return _Utils_Tuple2(repository, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Rights$Commands$singleton = $author$project$Types$Queue$singleton;
var $author$project$Rights$Role$CreateDialog$createdCreateCommand = F4(
	function (command, environment, repository, dialog) {
		if (dialog.$ === 2) {
			var _v1 = A3(
				$author$project$Rights$CommandHandler$handleCommands,
				$author$project$Rights$Commands$singleton(command),
				environment,
				$author$project$Environments$Repository$getRights(repository));
			if (_v1.$ === 1) {
				if (_v1.a.$ === 1) {
					var msg = _v1.a.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$rightsErrorToString(
								$author$project$Rights$CommandHandler$RoleAlreadyExists(msg))),
						gH: 'Rights.Role.EditDialog.elm',
						gK: 'createdCommands',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: $author$project$Rights$Role$CreateDialog$Hidden,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				} else {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Role$CreateDialog$Hidden, ac: environment, ae: repository};
				}
			} else {
				var resultData = _v1.a;
				if ($author$project$Rights$Commands$isEmpty(resultData.cD) || $author$project$Rights$Events$isEmpty(resultData.b8)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Role$CreateDialog$Hidden, ac: environment, ae: repository};
				} else {
					var _v3 = A3($author$project$Environments$Repository$saveRightsCommandsAndEvents, resultData.cD, resultData.b8, repository);
					var newRepository = _v3.a;
					var cmd = _v3.b;
					return {ab: cmd, jn: $author$project$Rights$Role$CreateDialog$Hidden, ac: resultData.ac, ae: newRepository};
				}
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$CreateDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$CreateDialog$Visible(
					_Utils_update(
						model,
						{
							aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$CreateDialog$removeMultipleRights = F4(
	function (newRights, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$CreateDialog$Visible(
					_Utils_update(
						model,
						{
							aw: A2(
								$elm$core$List$filter,
								function (r) {
									return !A2($elm$core$List$member, r, newRights);
								},
								model.aw)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$CreateDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Role$CreateDialog$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$CreateDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Role$CreateDialog$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$CreateDialog$CreatedCreateCommand = function (a) {
	return {$: 9, a: a};
};
var $author$project$Rights$Role$CreateDialog$HandlingCommand = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Command$commandHelper = F2(
	function (environment, buildCommand) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Types$CommandId$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var commandId_ = _v0.a;
		var newEnvironment = _v0.b;
		return _Utils_Tuple2(
			newEnvironment,
			A2(
				$elm$core$Task$map,
				buildCommand(commandId_),
				$elm$time$Time$now));
	});
var $author$project$Rights$Command$createRole = F2(
	function (environment, model) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$CreateRole(
						{L: commandId_, M: commandTimestamp, aY: model.aY, kF: model.kF, hc: model.hc, k8: model.k8});
				}));
	});
var $author$project$Rights$Role$Id$from = $elm$core$Basics$identity;
var $author$project$Rights$Role$CreateDialog$createCommand = F2(
	function (environment, model) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Rights$Role$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var roleId = _v0.a;
		var newEnvironment = _v0.b;
		return A2(
			$author$project$Rights$Command$createRole,
			newEnvironment,
			{
				aY: $author$project$UI$BasicDataEditor$description(model.aQ),
				kF: model.aw,
				hc: roleId,
				k8: $author$project$UI$BasicDataEditor$title(model.aQ)
			});
	});
var $author$project$Rights$Role$CreateDialog$userClickedCreateButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var title = $author$project$UI$BasicDataEditor$title(model.aQ);
			if ($elm$core$String$isEmpty(title)) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				var _v1 = A2($author$project$Rights$Role$CreateDialog$createCommand, environment, model);
				var newEnvironment = _v1.a;
				var task = _v1.b;
				return {
					ab: A2($elm$core$Task$perform, $author$project$Rights$Role$CreateDialog$CreatedCreateCommand, task),
					jn: $author$project$Rights$Role$CreateDialog$HandlingCommand(model),
					ac: newEnvironment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$CreateDialog$RightsStep = 1;
var $author$project$Rights$Role$CreateDialog$switchStep = F2(
	function (step, model) {
		if (_Utils_eq(model.b0, step)) {
			return model;
		} else {
			var _v0 = model.b0;
			if (!_v0) {
				var title = $author$project$UI$BasicDataEditor$title(model.aQ);
				return $elm$core$String$isEmpty(title) ? model : _Utils_update(
					model,
					{
						aQ: A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ),
						b0: step
					});
			} else {
				return _Utils_update(
					model,
					{b0: step});
			}
		}
	});
var $author$project$Rights$Role$CreateDialog$nextStep = function (model) {
	var _v0 = model.b0;
	if (!_v0) {
		return A2($author$project$Rights$Role$CreateDialog$switchStep, 1, model);
	} else {
		return model;
	}
};
var $author$project$Rights$Role$CreateDialog$userClickedNextButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$CreateDialog$Visible(
					$author$project$Rights$Role$CreateDialog$nextStep(model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$CreateDialog$userClickedRight = F5(
	function (right, bool, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var newRights = (bool && (right === 3)) ? _List_fromArray(
				[right]) : ((bool && _Utils_eq(
				model.aw,
				_List_fromArray(
					[3]))) ? model.aw : (bool ? A2($elm$core$List$cons, right, model.aw) : A2(
				$elm$core$List$filter,
				function (r) {
					return !_Utils_eq(r, right);
				},
				model.aw)));
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$CreateDialog$Visible(
					_Utils_update(
						model,
						{aw: newRights})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$CreateDialog$userClickedStepIcon = F4(
	function (step, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$CreateDialog$Visible(
					A2($author$project$Rights$Role$CreateDialog$switchStep, step, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$CreateDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Rights$Role$CreateDialog$userClickedCloseDialog;
		case 1:
			return $author$project$Rights$Role$CreateDialog$userClickedNextButton;
		case 2:
			var step = msg.a;
			return $author$project$Rights$Role$CreateDialog$userClickedStepIcon(step);
		case 3:
			return $author$project$Rights$Role$CreateDialog$userClickedCancelButton;
		case 4:
			return $author$project$Rights$Role$CreateDialog$userClickedCreateButton;
		case 5:
			var editorMsg = msg.a;
			return $author$project$Rights$Role$CreateDialog$gotBasicDataEditorMsg(editorMsg);
		case 6:
			var right = msg.a;
			var bool = msg.b;
			return A2($author$project$Rights$Role$CreateDialog$userClickedRight, right, bool);
		case 7:
			var rights = msg.a;
			return $author$project$Rights$Role$CreateDialog$addMultipleRights(rights);
		case 8:
			var rights = msg.a;
			return $author$project$Rights$Role$CreateDialog$removeMultipleRights(rights);
		default:
			var command = msg.a;
			return $author$project$Rights$Role$CreateDialog$createdCreateCommand(command);
	}
};
var $author$project$Rights$Role$Page$withCreateDialog = F2(
	function (createDialog_, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{fi: createDialog_});
	});
var $author$project$Rights$Role$Page$gotCreateDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$Rights$Role$CreateDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$Rights$Role$Page$createDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Rights$Role$Page$GotCreateDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$Rights$Role$Page$withCreateDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$Rights$Role$Page$GotEditDialogMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Rights$Role$Page$editDialog = function (_v0) {
	var page = _v0;
	return page.cO;
};
var $author$project$Rights$Role$EditDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Role$EditDialog$addMultipleRights = F4(
	function (newRights, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var newSelectedRights = _Utils_eq(
				model.aw,
				_List_fromArray(
					[3])) ? model.aw : A2(
				$author$project$Utils$List$uniqueBy,
				$elm$core$Basics$identity,
				A2($elm$core$List$append, model.aw, newRights));
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$EditDialog$Visible(
					_Utils_update(
						model,
						{aw: newSelectedRights})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$EditDialog$Deleted = {$: 3};
var $author$project$Rights$Commands$fromList = $author$project$Types$Queue$fromList;
var $author$project$Rights$Role$EditDialog$createdCommands = F4(
	function (commands, environment, repository, dialog) {
		if (dialog.$ === 2) {
			var _v1 = A3(
				$author$project$Rights$CommandHandler$handleCommands,
				$author$project$Rights$Commands$fromList(commands),
				environment,
				$author$project$Environments$Repository$getRights(repository));
			if (_v1.$ === 1) {
				if (_v1.a.$ === 1) {
					var msg = _v1.a.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$rightsErrorToString(
								$author$project$Rights$CommandHandler$RoleAlreadyExists(msg))),
						gH: 'Rights.Role.EditDialog.elm',
						gK: 'createdCommands',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: $author$project$Rights$Role$EditDialog$Hidden,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				} else {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Role$EditDialog$Deleted, ac: environment, ae: repository};
				}
			} else {
				var resultData = _v1.a;
				if ($author$project$Rights$Commands$isEmpty(resultData.cD) || $author$project$Rights$Events$isEmpty(resultData.b8)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Role$EditDialog$Hidden, ac: environment, ae: repository};
				} else {
					var _v3 = A3($author$project$Environments$Repository$saveRightsCommandsAndEvents, resultData.cD, resultData.b8, repository);
					var newRepository = _v3.a;
					var cmd = _v3.b;
					return {ab: cmd, jn: $author$project$Rights$Role$EditDialog$Hidden, ac: resultData.ac, ae: newRepository};
				}
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$EditDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$EditDialog$Visible(
					_Utils_update(
						model,
						{
							aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$EditDialog$removeMultipleRights = F4(
	function (newRights, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$EditDialog$Visible(
					_Utils_update(
						model,
						{
							aw: A2(
								$elm$core$List$filter,
								function (r) {
									return !A2($elm$core$List$member, r, newRights);
								},
								model.aw)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$EditDialog$CreatedCommands = function (a) {
	return {$: 10, a: a};
};
var $author$project$Rights$Role$EditDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Command$addRights = F2(
	function (environment, model) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$AddRights(
						{L: commandId_, M: commandTimestamp, kF: model.kF, hc: model.hc, l: model.l});
				}));
	});
var $author$project$Rights$Role$EditDialog$withAddRightsCommand = F3(
	function (role, rights, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var newRights = A2(
			$elm$core$List$filter,
			function (r) {
				return !A2($elm$core$List$member, r, role.kF);
			},
			rights);
		if ($elm$core$List$isEmpty(newRights)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {kF: newRights, hc: role.hc, l: role.k8};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$Rights$Command$addRights, environment, data));
		}
	});
var $author$project$Rights$Command$changeRoleDescription = F2(
	function (environment, model) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$ChangeRoleDescription(
						{L: commandId_, M: commandTimestamp, aY: model.aY, hc: model.hc, l: model.l});
				}));
	});
var $author$project$Rights$Role$EditDialog$withChangeDescriptionCommand = F3(
	function (role, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		if (_Utils_eq(
			$author$project$UI$BasicDataEditor$description(basicDataEditor),
			role.aY)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {
				aY: $author$project$UI$BasicDataEditor$description(basicDataEditor),
				hc: role.hc,
				l: role.k8
			};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$Rights$Command$changeRoleDescription, environment, data));
		}
	});
var $author$project$Rights$Command$changeRoleTitle = F2(
	function (environment, model) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$ChangeRoleTitle(
						{L: commandId_, M: commandTimestamp, hc: model.hc, k8: model.k8, l: model.l});
				}));
	});
var $author$project$Rights$Role$EditDialog$withChangeTitleCommand = F3(
	function (role, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		if ($elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor)) || _Utils_eq(
			$author$project$UI$BasicDataEditor$title(basicDataEditor),
			role.k8)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {
				hc: role.hc,
				k8: $author$project$UI$BasicDataEditor$title(basicDataEditor),
				l: role.k8
			};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$Rights$Command$changeRoleTitle, environment, data));
		}
	});
var $author$project$Rights$Command$removeRights = F2(
	function (environment, model) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$RemoveRights(
						{L: commandId_, M: commandTimestamp, kF: model.kF, hc: model.hc, l: model.l});
				}));
	});
var $author$project$Rights$Role$EditDialog$withRemoveRightsCommand = F3(
	function (role, rights, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var removeRights = A2(
			$elm$core$List$filter,
			function (r) {
				return !A2($elm$core$List$member, r, rights);
			},
			role.kF);
		if ($elm$core$List$isEmpty(removeRights)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {kF: removeRights, hc: role.hc, l: role.k8};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$Rights$Command$removeRights, environment, data));
		}
	});
var $author$project$Rights$Role$EditDialog$createCommands = F3(
	function (environment, role, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A3(
				$author$project$Rights$Role$EditDialog$withRemoveRightsCommand,
				role,
				model.aw,
				A3(
					$author$project$Rights$Role$EditDialog$withAddRightsCommand,
					role,
					model.aw,
					A3(
						$author$project$Rights$Role$EditDialog$withChangeDescriptionCommand,
						role,
						model.aQ,
						A3(
							$author$project$Rights$Role$EditDialog$withChangeTitleCommand,
							role,
							model.aQ,
							_Utils_Tuple2(environment, _List_Nil))))));
	});
var $author$project$Rights$Role$EditDialog$userClickedApplyButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var _v1 = A2(
				$author$project$Rights$Rights$getRole,
				model.d9.hc,
				$author$project$Environments$Repository$getRights(repository));
			if (_v1.$ === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Role$EditDialog$Deleted, ac: environment, ae: repository};
			} else {
				var role = _v1.a;
				var _v2 = A3($author$project$Rights$Role$EditDialog$createCommands, environment, role, model);
				var newEnvironment = _v2.a;
				var tasks = _v2.b;
				return {
					ab: A2(
						$elm$core$Task$perform,
						$author$project$Rights$Role$EditDialog$CreatedCommands,
						$elm$core$Task$sequence(tasks)),
					jn: $author$project$Rights$Role$EditDialog$HandlingCommands(model),
					ac: newEnvironment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$EditDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Role$EditDialog$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$EditDialog$userClickedCloseButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Role$EditDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$EditDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Role$EditDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Command$deleteRole = F3(
	function (environment, roleId, titleForError) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$DeleteRole(
						{L: commandId_, M: commandTimestamp, hc: roleId, l: titleForError});
				}));
	});
var $author$project$Rights$Role$EditDialog$userClickedDeleteButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var _v1 = A2(
				$elm$core$Tuple$mapSecond,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$singleton,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Task$sequence,
						$elm$core$Task$perform($author$project$Rights$Role$EditDialog$CreatedCommands))),
				A3($author$project$Rights$Command$deleteRole, environment, model.d9.hc, model.d9.k8));
			var newEnvironment = _v1.a;
			var cmd = _v1.b;
			return {
				ab: cmd,
				jn: $author$project$Rights$Role$EditDialog$HandlingCommands(model),
				ac: newEnvironment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$EditDialog$userClickedRight = F5(
	function (right, bool, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var newRights = (bool && (right === 3)) ? _List_fromArray(
				[right]) : ((bool && _Utils_eq(
				model.aw,
				_List_fromArray(
					[3]))) ? model.aw : (bool ? A2($elm$core$List$cons, right, model.aw) : A2(
				$elm$core$List$filter,
				function (r) {
					return !_Utils_eq(r, right);
				},
				model.aw)));
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$EditDialog$Visible(
					_Utils_update(
						model,
						{aw: newRights})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$EditDialog$BasicDataTab = 0;
var $author$project$Rights$Role$EditDialog$switchTab = F2(
	function (tab, model) {
		if (_Utils_eq(model.cI, tab)) {
			return model;
		} else {
			if (!model.cI) {
				var title = $author$project$UI$BasicDataEditor$title(model.aQ);
				return _Utils_update(
					model,
					{
						aQ: A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ),
						cI: tab
					});
			} else {
				return _Utils_update(
					model,
					{cI: tab});
			}
		}
	});
var $author$project$Rights$Role$EditDialog$userClickedTabIcon = F4(
	function (tab, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Role$EditDialog$Visible(
					A2($author$project$Rights$Role$EditDialog$switchTab, tab, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Role$EditDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Rights$Role$EditDialog$userClickedCloseDialog;
		case 1:
			var tab = msg.a;
			return $author$project$Rights$Role$EditDialog$userClickedTabIcon(tab);
		case 2:
			return $author$project$Rights$Role$EditDialog$userClickedCancelButton;
		case 3:
			return $author$project$Rights$Role$EditDialog$userClickedApplyButton;
		case 4:
			return $author$project$Rights$Role$EditDialog$userClickedDeleteButton;
		case 5:
			return $author$project$Rights$Role$EditDialog$userClickedCloseButton;
		case 6:
			var editorMsg = msg.a;
			return $author$project$Rights$Role$EditDialog$gotBasicDataEditorMsg(editorMsg);
		case 7:
			var right = msg.a;
			var bool = msg.b;
			return A2($author$project$Rights$Role$EditDialog$userClickedRight, right, bool);
		case 8:
			var rights = msg.a;
			return $author$project$Rights$Role$EditDialog$addMultipleRights(rights);
		case 9:
			var rights = msg.a;
			return $author$project$Rights$Role$EditDialog$removeMultipleRights(rights);
		default:
			var commands = msg.a;
			return $author$project$Rights$Role$EditDialog$createdCommands(commands);
	}
};
var $author$project$Rights$Role$Page$withEditDialog = F2(
	function (editDialog_, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{cO: editDialog_});
	});
var $author$project$Rights$Role$Page$gotEditDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$Rights$Role$EditDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$Rights$Role$Page$editDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Rights$Role$Page$GotEditDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$Rights$Role$Page$withEditDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$Rights$Role$CreateDialog$BasicDataStep = 0;
var $author$project$Rights$Role$CreateDialog$show = $author$project$Rights$Role$CreateDialog$Visible(
	{aQ: $author$project$UI$BasicDataEditor$default, b0: 0, aw: _List_Nil});
var $author$project$Rights$Role$Page$userClickedCreateIcon = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2($author$project$Rights$Role$Page$withCreateDialog, $author$project$Rights$Role$CreateDialog$show, page),
			ae: repository
		};
	});
var $author$project$Rights$Role$EditDialog$show = function (role) {
	return $author$project$Rights$Role$EditDialog$Visible(
		{
			aQ: $author$project$UI$BasicDataEditor$from(role),
			cI: 0,
			d9: role,
			aw: role.kF
		});
};
var $author$project$Rights$Role$Page$userClickedEditIcon = F4(
	function (role, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2(
				$author$project$Rights$Role$Page$withEditDialog,
				$author$project$Rights$Role$EditDialog$show(role),
				page),
			ae: repository
		};
	});
var $author$project$Rights$Role$Page$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Rights$Role$Page$userClickedCreateIcon;
		case 1:
			var dialogMsg = msg.a;
			return $author$project$Rights$Role$Page$gotCreateDialogMsg(dialogMsg);
		case 2:
			var role = msg.a;
			return $author$project$Rights$Role$Page$userClickedEditIcon(role);
		default:
			var dialogMsg = msg.a;
			return $author$project$Rights$Role$Page$gotEditDialogMsg(dialogMsg);
	}
};
var $author$project$Translations$Role$pageHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.pageHeader');
};
var $author$project$UI$Icons$roles = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M17.21 13.835l.01-.064.002-.041c.198-4.295 3.009-4.934 4.672-4.934 2.034.045 4.568.937 4.75 4.902l.008.205.011.026c.055.677.267 4.619-1.576 6.693-.763.861-1.754 1.266-3.182 1.281-1.351-.015-2.372-.431-3.121-1.281-2.01-2.26-1.578-6.746-1.574-6.787m4.613 11.203h.229l.004-.002c2.22-.037 4.025-.822 5.371-2.336 2.834-3.191 2.4-8.578 2.346-9.146-.19-4.012-2.114-5.932-3.696-6.836-1.178-.68-2.541-1.039-4.059-1.067h-.119c-.837 0-2.476.135-4.059 1.036-1.603.908-3.552 2.835-3.735 6.834-.06.601-.493 5.984 2.339 9.179 1.338 1.514 3.143 2.299 5.379 2.338m17.901 7.041h-.53a6.652 6.652 0 00-.627-1.512l.371-.371a1.271 1.271 0 000-1.797l-.777-.777a1.275 1.275 0 00-1.797 0l-3.211 3.209a.619.619 0 000 .871c.078.076.17.129.269.156.016.008.031.018.047.024a2.16 2.16 0 011.289 1.441 2.175 2.175 0 01-.203 1.66 2.162 2.162 0 01-1.312 1.028 2.185 2.185 0 01-2.689-1.516 2.196 2.196 0 01.702-2.258.616.616 0 00-.793-.941 3.413 3.413 0 002.188 6.023c.306 0 .616-.039.918-.125a3.385 3.385 0 002.054-1.609 3.395 3.395 0 00.319-2.59 3.398 3.398 0 00-1.328-1.881l2.617-2.617c.017-.018.041-.018.06 0l.778.777a.044.044 0 010 .059l-1.074 1.07.281.42a5.44 5.44 0 01.826 1.998l.1.496h1.522a.04.04 0 01.041.041v1.102a.04.04 0 01-.041.041h-1.516l-.099.494a5.564 5.564 0 01-.825 1.998l-.282.42 1.073 1.072a.038.038 0 010 .057l-.779.779a.04.04 0 01-.057 0l-1.073-1.072-.42.279a5.45 5.45 0 01-1.996.826l-.496.098v1.52a.039.039 0 01-.039.039h-1.103a.039.039 0 01-.039-.039v-1.52l-.498-.098a5.524 5.524 0 01-1.995-.826l-.421-.279-1.072 1.072c-.016.016-.04.016-.059 0l-.778-.779a.038.038 0 010-.057l1.073-1.072-.28-.42a5.45 5.45 0 01-.826-1.998l-.099-.494h-1.526a.04.04 0 01-.041-.041v-1.102a.04.04 0 01.041-.041h1.516l.099-.496a5.55 5.55 0 01.827-1.998l.279-.42-1.072-1.07c-.016-.018-.016-.043 0-.059l.777-.777c.018-.018.041-.018.06 0l1.071 1.072.418-.279a5.46 5.46 0 011.998-.826l.496-.1v-1.527c0-.024.016-.041.04-.041h1.102c.026 0 .042.017.042.041v1.015c0 .336.277.614.615.614a.615.615 0 00.612-.614v-1.015a1.27 1.27 0 00-1.269-1.27h-1.102c-.698 0-1.27.571-1.27 1.27v.527a6.718 6.718 0 00-1.512.631l-.371-.373a1.275 1.275 0 00-1.797 0l-.777.777a1.271 1.271 0 000 1.797l.372.371a6.841 6.841 0 00-.628 1.512h-.526c-.699 0-1.269.572-1.269 1.27v1.103c0 .699.57 1.272 1.269 1.272h.528c.147.529.357 1.033.628 1.511l-.371.373a1.268 1.268 0 000 1.793l.778.782c.496.492 1.3.492 1.797 0l.371-.374c.478.27.982.481 1.512.627v.536c0 .697.57 1.265 1.27 1.265h1.102c.7 0 1.27-.568 1.27-1.265v-.532a6.654 6.654 0 001.514-.629l.371.373a1.27 1.27 0 001.795 0l.777-.779a1.267 1.267 0 000-1.795l-.371-.371c.269-.478.482-.982.629-1.514h.532c.7 0 1.271-.568 1.271-1.269v-1.107c0-.698-.571-1.27-1.271-1.27M21.946 39.22c-6.121 0-10.265-1.865-11.722-2.641-.069-.521-.1-1.248-.087-1.793l.005-.109c.056-1.807.31-2.932 1.382-3.316 3.167-.815 5.792-2.477 6.569-3 .707-.5.877-1.477.381-2.186a1.568 1.568 0 00-2.189-.377c-.024.016-2.554 1.77-5.568 2.535l-.125.035c-3.425 1.176-3.536 4.827-3.58 6.233 0 .035.003.064-.005.183-.01.538-.008 2.372.396 3.391.119.313.334.572.602.738.05.036 5.25 3.436 13.949 3.436 1.26 0 2.438-.076 3.545-.199a10.6 10.6 0 01-2.352-2.953c-.392.013-.79.023-1.201.023')
						]),
					_List_Nil)
				]));
	});
var $author$project$Rights$Role$Page$UserClickedCreateIcon = {$: 0};
var $author$project$Rights$Role$Page$viewActionBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withStyle,
			$rtfeldman$elm_css$Css$zIndex(
				$rtfeldman$elm_css$Css$int(1)),
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
					A2(
						$author$project$UI$Bar$withRightIcon,
						A2(
							$author$project$UI$Icon$withOnClick,
							$author$project$Rights$Role$Page$UserClickedCreateIcon,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
						$author$project$UI$Bar$bar(
							$author$project$Translations$Misc$overview(translations)))))));
};
var $author$project$Rights$Role$CreateDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Rights$Role$CreateDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Role$createDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.createDialogHeader');
};
var $author$project$Rights$Role$CreateDialog$UserClickedCancelButton = {$: 3};
var $author$project$Rights$Role$CreateDialog$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Rights$Role$CreateDialog$UserClickedCancelButton,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$Rights$Role$CreateDialog$UserClickedCreateButton = {$: 4};
var $author$project$Rights$Role$CreateDialog$viewCreateButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Rights$Role$CreateDialog$UserClickedCreateButton,
			$author$project$UI$Button$green(
				$author$project$Translations$Buttons$create(translations))));
};
var $author$project$Rights$Role$CreateDialog$UserClickedNextButton = {$: 1};
var $author$project$Rights$Role$CreateDialog$viewNextButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Rights$Role$CreateDialog$UserClickedNextButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$next(translations)))));
	});
var $author$project$Rights$Role$CreateDialog$viewRightButton = F3(
	function (translations, disableBtn, currentStep) {
		if (!currentStep) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
							]))
					]),
				_List_fromArray(
					[
						A2($author$project$Rights$Role$CreateDialog$viewNextButton, translations, disableBtn)
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
							]))
					]),
				_List_fromArray(
					[
						$author$project$Rights$Role$CreateDialog$viewCreateButton(translations)
					]));
		}
	});
var $author$project$UI$Icons$taskListCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63.001 32.001c0 17.122-13.879 31-31.001 31-17.121 0-31-13.878-31-31 0-17.121 13.879-31 31-31 17.122 0 31.001 13.879 31.001 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M23.887 19.061c-.74 0-1.345.608-1.345 1.346v1.916a.066.066 0 01-.066.065h-5.46a.066.066 0 01-.066-.065v-5.46c0-.036.03-.067.066-.067h5.46a1.346 1.346 0 000-2.692h-5.46a2.757 2.757 0 00-2.759 2.753v5.458a2.762 2.762 0 002.76 2.758h5.459a2.76 2.76 0 002.756-2.758v-1.908a1.35 1.35 0 00-1.345-1.346m0 12.404c-.74 0-1.345.607-1.345 1.346v1.914a.067.067 0 01-.066.066h-5.46a.067.067 0 01-.066-.066v-5.457c0-.038.03-.068.066-.068h5.46c.74 0 1.342-.606 1.342-1.346a1.35 1.35 0 00-1.342-1.347h-5.46a2.764 2.764 0 00-2.759 2.76v5.458a2.764 2.764 0 002.76 2.76h5.459a2.761 2.761 0 002.756-2.76V32.81a1.35 1.35 0 00-1.345-1.346m0 12.413c-.74 0-1.345.604-1.345 1.345v1.914a.068.068 0 01-.066.066h-5.46a.068.068 0 01-.066-.066v-5.46c0-.036.03-.067.066-.067h5.46c.74 0 1.342-.605 1.342-1.345s-.603-1.345-1.342-1.345h-5.46a2.762 2.762 0 00-2.759 2.758v5.459a2.762 2.762 0 002.76 2.759h5.459a2.761 2.761 0 002.756-2.76v-1.913c0-.74-.604-1.345-1.345-1.345m4.695-22.946h19.813c.74 0 1.348-.608 1.348-1.348 0-.739-.608-1.344-1.348-1.344H28.582c-.74 0-1.344.605-1.344 1.344 0 .74.604 1.348 1.344 1.348m19.813 9.719H28.582c-.74 0-1.345.604-1.345 1.345 0 .738.606 1.347 1.345 1.347h19.813c.741 0 1.348-.609 1.348-1.347a1.35 1.35 0 00-1.348-1.345m0 12.412H28.582c-.74 0-1.345.604-1.345 1.345 0 .74.606 1.345 1.345 1.345h19.813a1.35 1.35 0 001.348-1.345 1.35 1.35 0 00-1.348-1.345')
						]),
					_List_Nil)
				]));
	});
var $author$project$Rights$Role$CreateDialog$UserClickedStepIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Role$CreateDialog$viewStepIcon = F4(
	function (icon, step, currentStep, platform) {
		var marginRight_ = function () {
			if (!step) {
				if (!platform.$) {
					return $rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(1));
				} else {
					return $rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(0.2));
				}
			} else {
				return $rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero);
			}
		}();
		var calcRem = function () {
			if (!platform.$) {
				return $rtfeldman$elm_css$Css$rem(2.5);
			} else {
				return $rtfeldman$elm_css$Css$rem(1.3);
			}
		}();
		var _v0 = _Utils_eq(step, currentStep) ? _Utils_Tuple2($author$project$UI$Style$Theme$white, $author$project$UI$Style$Theme$darkGrey) : _Utils_Tuple2($author$project$UI$Style$Theme$darkGrey, $author$project$UI$Style$Theme$lightGrey);
		var foregroundColor_ = _v0.a;
		var backgroundColor_ = _v0.b;
		return $author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Rights$Role$CreateDialog$UserClickedStepIcon(step),
				A2(
					$author$project$UI$Icon$withStyle,
					marginRight_,
					A2(
						$author$project$UI$Icon$withBackgroundColor,
						backgroundColor_,
						A2(
							$author$project$UI$Icon$withForegroundColor,
							foregroundColor_,
							A2(
								$author$project$UI$Icon$withStyle,
								$rtfeldman$elm_css$Css$height(
									A3(
										$rtfeldman$elm_css$Css$calc,
										calcRem,
										$rtfeldman$elm_css$Css$plus,
										$rtfeldman$elm_css$Css$px(2))),
								A2(
									$author$project$UI$Icon$withStyle,
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									$author$project$UI$Icon$bicolor(icon))))))));
	});
var $author$project$Rights$Role$CreateDialog$viewSteps = F2(
	function (currentStep, platform) {
		var marginLeft_ = function () {
			if (!platform.$) {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(0.6))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
							]),
						marginLeft_))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$top(
									$rtfeldman$elm_css$Css$pct(50)),
									$rtfeldman$elm_css$Css$right(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$left(
									$rtfeldman$elm_css$Css$rem(1)),
									A3(
									$rtfeldman$elm_css$Css$border3,
									$rtfeldman$elm_css$Css$px(1),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
								]))
						]),
					_List_Nil),
					A4($author$project$Rights$Role$CreateDialog$viewStepIcon, $author$project$UI$Icons$tagCircleBicolor, 0, currentStep, platform),
					A4($author$project$Rights$Role$CreateDialog$viewStepIcon, $author$project$UI$Icons$taskListCircleBicolor, 1, currentStep, platform)
				]));
	});
var $author$project$Rights$Role$CreateDialog$viewFooter = F4(
	function (translations, platform, disableBtn, currentStep) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto 1fr'),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Rights$Role$CreateDialog$viewCancelButton(translations),
					A2($author$project$Rights$Role$CreateDialog$viewSteps, currentStep, platform),
					A3($author$project$Rights$Role$CreateDialog$viewRightButton, translations, disableBtn, currentStep)
				]));
	});
var $author$project$Rights$Role$CreateDialog$viewBasicDataStep = F3(
	function (translations, platform, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(32)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(40)),
						$rtfeldman$elm_css$Css$maxWidth(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$Rights$Role$CreateDialog$viewFooter, translations, platform, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Rights$Role$CreateDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Role$createDialogHeader(translations),
									$author$project$Rights$Role$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$Translations$Role$assignRights = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.assignRights');
};
var $author$project$Rights$Role$CreateDialog$viewRightsBar = function (translations) {
	return $author$project$UI$Bar$view(
		$author$project$UI$Bar$bar(
			$author$project$Translations$Role$assignRights(translations)));
};
var $author$project$Translations$Rights$audits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'rights.audits');
};
var $author$project$UI$Icons$create = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M12.642 18.372h3.88V30.55c0 .512.417.922.928.922h12.177v3.881H12.642V18.372zm5.731-5.729h16.985v16.985H18.373V12.643zm-6.658 24.565h18.836c.51 0 .927-.417.927-.927v-4.809h4.808c.514 0 .92-.416.92-.922V11.715c0-.512-.413-.923-.92-.923H17.45c-.511 0-.928.417-.928.923v4.808h-4.807c-.511 0-.921.415-.921.928v18.834c0 .506.414.923.921.923')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M22.626 22.059h3.316v3.316c0 .513.414.927.927.927.512 0 .921-.414.921-.927v-3.316h3.316c.511 0 .92-.414.92-.926s-.413-.928-.92-.928H27.79v-3.316c0-.51-.414-.927-.921-.927-.513 0-.927.417-.927.927v3.316h-3.316c-.513 0-.922.416-.922.928-.004.512.409.926.922.926')
						]),
					_List_Nil)
				]));
	});
var $author$project$Translations$Rights$measure = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'rights.measure');
};
var $rtfeldman$elm_css$Css$breakWord = {g6: 0, ll: 'break-word'};
var $rtfeldman$elm_css$Css$overflowWrap = $rtfeldman$elm_css$Css$prop1('overflow-wrap');
var $author$project$Rights$Role$CreateDialog$viewLabel = F2(
	function (label, secondText) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$h5,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'justify-self', 'start'),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$property, 'justify-self', 'start'),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
									$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(secondText)
						]))
				]));
	});
var $author$project$Rights$Role$CreateDialog$UserClickedRight = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Rights$Role$CreateDialog$viewRightsCheckbox = F2(
	function (right, selectedRights) {
		return $author$project$UI$Checkbox$view(
			A2(
				$author$project$UI$Checkbox$withOnCheck,
				$author$project$Rights$Role$CreateDialog$UserClickedRight(right),
				A2(
					$author$project$UI$Checkbox$checked,
					A2($elm$core$List$member, right, selectedRights) || _Utils_eq(
						selectedRights,
						_List_fromArray(
							[3])),
					$author$project$UI$Checkbox$unlabeled)));
	});
var $author$project$Rights$Role$CreateDialog$AddMultipleRights = function (a) {
	return {$: 7, a: a};
};
var $author$project$Rights$Role$CreateDialog$RemoveMultipleRights = function (a) {
	return {$: 8, a: a};
};
var $author$project$Rights$Role$CreateDialog$viewRightsHeaderIcon = F2(
	function (newRights, selectedRights) {
		var msg = _Utils_eq(
			$elm$core$List$length(newRights),
			$elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function (r) {
						return A2($elm$core$List$member, r, selectedRights);
					},
					newRights))) ? $author$project$Rights$Role$CreateDialog$RemoveMultipleRights(newRights) : $author$project$Rights$Role$CreateDialog$AddMultipleRights(newRights);
		return A2(
			$elm$core$Basics$composeR,
			$author$project$UI$Icon$unicolor,
			A2(
				$elm$core$Basics$composeR,
				$author$project$UI$Icon$withOnClick(msg),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Icon$withForegroundColor($author$project$UI$Style$Theme$darkGrey),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Icon$withStyle(
							$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$rem(2.5))),
						$author$project$UI$Icon$view))));
	});
var $author$project$Rights$Role$CreateDialog$viewRightsContent = F2(
	function (translations, selectedRights) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'auto 4rem 4rem 4rem'),
							A2($rtfeldman$elm_css$Css$property, 'grid-row-gap', '1rem'),
							A2($rtfeldman$elm_css$Css$property, 'align-items', 'center'),
							A2($rtfeldman$elm_css$Css$property, 'justify-items', 'center')
						]))
				]),
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					A3(
					$author$project$Rights$Role$CreateDialog$viewRightsHeaderIcon,
					_List_fromArray(
						[4, 7]),
					selectedRights,
					$author$project$UI$Icons$create),
					A3(
					$author$project$Rights$Role$CreateDialog$viewRightsHeaderIcon,
					_List_fromArray(
						[5, 8]),
					selectedRights,
					$author$project$UI$Icons$edit),
					A3(
					$author$project$Rights$Role$CreateDialog$viewRightsHeaderIcon,
					_List_fromArray(
						[6, 9]),
					selectedRights,
					$author$project$UI$Icons$delete),
					A2(
					$author$project$Rights$Role$CreateDialog$viewLabel,
					$author$project$Translations$Rights$measure(translations),
					''),
					A2($author$project$Rights$Role$CreateDialog$viewRightsCheckbox, 4, selectedRights),
					A2($author$project$Rights$Role$CreateDialog$viewRightsCheckbox, 5, selectedRights),
					A2($author$project$Rights$Role$CreateDialog$viewRightsCheckbox, 6, selectedRights),
					A2(
					$author$project$Rights$Role$CreateDialog$viewLabel,
					$author$project$Translations$Rights$audits(translations),
					''),
					A2($author$project$Rights$Role$CreateDialog$viewRightsCheckbox, 7, selectedRights),
					A2($author$project$Rights$Role$CreateDialog$viewRightsCheckbox, 8, selectedRights),
					A2($author$project$Rights$Role$CreateDialog$viewRightsCheckbox, 9, selectedRights)
				]));
	});
var $author$project$Translations$Rights$editTenant = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'rights.editTenant');
};
var $author$project$Translations$Rights$editTenantDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'rights.editTenantDescription');
};
var $rtfeldman$elm_css$Html$Styled$h2 = $rtfeldman$elm_css$Html$Styled$node('h2');
var $author$project$Translations$Rights$organisationUnits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'rights.organisationUnits');
};
var $author$project$Translations$Rights$plans = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'rights.plans');
};
var $author$project$Translations$Rights$specialRights = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'rights.specialRights');
};
var $author$project$Translations$Rights$usersRights = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'rights.usersRights');
};
var $author$project$Rights$Role$CreateDialog$viewSpecialRightsRow = F4(
	function (label, secondLabel, right, selectedRights) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$marginRight(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Rights$Role$CreateDialog$viewLabel, label, secondLabel),
					A2($author$project$Rights$Role$CreateDialog$viewRightsCheckbox, right, selectedRights)
				]));
	});
var $author$project$Rights$Role$CreateDialog$viewSingleRight = F2(
	function (translations, selectedRights) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$property, 'justify-self', 'start'),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$rem(0.5))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Rights$specialRights(translations))
						])),
					A4(
					$author$project$Rights$Role$CreateDialog$viewSpecialRightsRow,
					$author$project$Translations$Rights$editTenant(translations),
					$author$project$Translations$Rights$editTenantDescription(translations),
					3,
					selectedRights),
					A4(
					$author$project$Rights$Role$CreateDialog$viewSpecialRightsRow,
					$author$project$Translations$Rights$usersRights(translations),
					'',
					0,
					selectedRights),
					A4(
					$author$project$Rights$Role$CreateDialog$viewSpecialRightsRow,
					$author$project$Translations$Rights$organisationUnits(translations),
					'',
					1,
					selectedRights),
					A4(
					$author$project$Rights$Role$CreateDialog$viewSpecialRightsRow,
					$author$project$Translations$Rights$plans(translations),
					'',
					2,
					selectedRights)
				]));
	});
var $author$project$Rights$Role$CreateDialog$viewRightsStep = F3(
	function (translations, platform, selectedRights) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(32)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(40)),
						$rtfeldman$elm_css$Css$maxWidth(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$Rights$Role$CreateDialog$viewFooter, translations, platform, false, 1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2($author$project$Rights$Role$CreateDialog$viewSingleRight, translations, selectedRights),
						A2(
							$author$project$UI$Dialog$appendContent,
							A2($author$project$Rights$Role$CreateDialog$viewRightsContent, translations, selectedRights),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$Rights$Role$CreateDialog$viewRightsBar(translations),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Role$createDialogHeader(translations),
										$author$project$Rights$Role$CreateDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Rights$Role$CreateDialog$viewDialog = F3(
	function (translations, platform, model) {
		var _v0 = model.b0;
		if (!_v0) {
			return A3($author$project$Rights$Role$CreateDialog$viewBasicDataStep, translations, platform, model.aQ);
		} else {
			return A3($author$project$Rights$Role$CreateDialog$viewRightsStep, translations, platform, model.aw);
		}
	});
var $author$project$Rights$Role$CreateDialog$view = F2(
	function (environment, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A4(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy3,
					$author$project$Rights$Role$CreateDialog$viewDialog,
					$author$project$Environments$Environment$translations(environment),
					$author$project$Environments$Environment$platform(environment),
					model);
			default:
				var model = dialog.a;
				return A4(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy3,
					$author$project$Rights$Role$CreateDialog$viewDialog,
					$author$project$Environments$Environment$translations(environment),
					$author$project$Environments$Environment$platform(environment),
					model);
		}
	});
var $author$project$Rights$Role$Page$viewCreateDialog = function (environment) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Rights$Role$CreateDialog$view(environment),
		$rtfeldman$elm_css$Html$Styled$map($author$project$Rights$Role$Page$GotCreateDialogMsg));
};
var $author$project$Rights$Role$EditDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Role$deletedHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.deletedHeader');
};
var $author$project$Translations$Role$deletedText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.deletedText');
};
var $author$project$Rights$Role$EditDialog$viewDeleted = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Role$deletedText(translations))
			]));
};
var $author$project$Rights$Role$EditDialog$UserClickedCloseButton = {$: 5};
var $author$project$Rights$Role$EditDialog$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Rights$Role$EditDialog$UserClickedCloseButton,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$Rights$Role$EditDialog$viewDeletedFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Rights$Role$EditDialog$viewCloseButton(translations)
			]));
};
var $author$project$Rights$Role$EditDialog$viewDeletedDialog = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return $author$project$UI$Dialog$view(
		A2(
			$author$project$UI$Dialog$appendFooter,
			$author$project$Rights$Role$EditDialog$viewDeletedFooter(translations),
			A2(
				$author$project$UI$Dialog$appendContent,
				$author$project$Rights$Role$EditDialog$viewDeleted(translations),
				A2(
					$author$project$UI$Dialog$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
					A2(
						$author$project$UI$Dialog$dialog,
						$author$project$Translations$Role$deletedHeader(translations),
						$author$project$Rights$Role$EditDialog$UserClickedCloseDialog)))));
};
var $author$project$Rights$Role$EditDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Translations$Role$editDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.editDialogHeader');
};
var $author$project$Rights$Role$EditDialog$DeleteTab = 2;
var $author$project$Rights$Role$EditDialog$UserClickedApplyButton = {$: 3};
var $author$project$Rights$Role$EditDialog$viewApplyButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Rights$Role$EditDialog$UserClickedApplyButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$apply(translations)))));
	});
var $author$project$Rights$Role$EditDialog$UserClickedCancelButton = {$: 2};
var $author$project$Rights$Role$EditDialog$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Rights$Role$EditDialog$UserClickedCancelButton,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$Rights$Role$EditDialog$UserClickedDeleteButton = {$: 4};
var $author$project$Rights$Role$EditDialog$viewDeleteButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Rights$Role$EditDialog$UserClickedDeleteButton,
					$author$project$UI$Button$darkRed(
						$author$project$Translations$Buttons$delete(translations)))));
	});
var $author$project$Rights$Role$EditDialog$viewFooter = F3(
	function (translations, disableBtn, tab) {
		var rightButton = (tab === 2) ? A2($author$project$Rights$Role$EditDialog$viewDeleteButton, translations, disableBtn) : A2($author$project$Rights$Role$EditDialog$viewApplyButton, translations, disableBtn);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Rights$Role$EditDialog$viewCancelButton(translations),
					rightButton
				]));
	});
var $author$project$Rights$Role$EditDialog$RightsTab = 1;
var $author$project$Rights$Role$EditDialog$UserClickedTabIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Role$EditDialog$viewTabBarIcon = F3(
	function (icon, tab, currentTab) {
		return _Utils_eq(tab, currentTab) ? A2(
			$author$project$UI$Icon$withForegroundColor,
			$author$project$UI$Style$Theme$darkGrey,
			$author$project$UI$Icon$unicolor(icon)) : A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$Rights$Role$EditDialog$UserClickedTabIcon(tab),
			A2(
				$author$project$UI$Icon$withForegroundColor,
				$author$project$UI$Style$Theme$grey,
				$author$project$UI$Icon$unicolor(icon)));
	});
var $author$project$Rights$Role$EditDialog$viewTabBar = F2(
	function (basicDataEditor, currentTab) {
		return $author$project$UI$TabBar$view(
			A2(
				$author$project$UI$TabBar$appendRightIcon,
				A3($author$project$Rights$Role$EditDialog$viewTabBarIcon, $author$project$UI$Icons$delete, 2, currentTab),
				A2(
					$author$project$UI$TabBar$appendRightIcon,
					A3($author$project$Rights$Role$EditDialog$viewTabBarIcon, $author$project$UI$Icons$taskList, 1, currentTab),
					A2(
						$author$project$UI$TabBar$appendRightIcon,
						A3($author$project$Rights$Role$EditDialog$viewTabBarIcon, $author$project$UI$Icons$tag, 0, currentTab),
						A2(
							$author$project$UI$TabBar$withSubTitle,
							$author$project$UI$BasicDataEditor$description(basicDataEditor),
							$author$project$UI$TabBar$tabBar(
								$author$project$UI$BasicDataEditor$title(basicDataEditor)))))));
	});
var $author$project$Rights$Role$EditDialog$viewBasicDataTab = F2(
	function (translations, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(36)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(40)),
						$rtfeldman$elm_css$Css$maxWidth(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Rights$Role$EditDialog$viewFooter, translations, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Rights$Role$EditDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$Rights$Role$EditDialog$viewTabBar, basicDataEditor, 0),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Role$editDialogHeader(translations),
										$author$project$Rights$Role$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Auth$RightSet$fromList = $turboMaCk$any_set$Set$Any$fromList($author$project$Rights$Right$toString);
var $author$project$Auth$Authorization$reduceRoleList = F2(
	function (maybeRole, list) {
		if (!maybeRole.$) {
			var role = maybeRole.a;
			return _Utils_ap(role.kF, list);
		} else {
			return list;
		}
	});
var $author$project$Rights$Role$Ids$toList = $turboMaCk$any_set$Set$Any$toList;
var $author$project$Auth$Authorization$assembleData = F3(
	function (rights, teamRole, _v0) {
		var accOrganisationUnitRightsTuple = _v0.a;
		var accRightSet = _v0.b;
		var _v1 = A2($author$project$Rights$Rights$getTeam, teamRole.k1, rights);
		if (!_v1.$) {
			var team = _v1.a;
			var rightSet = $author$project$Auth$RightSet$fromList(
				A3(
					$elm$core$List$foldl,
					$author$project$Auth$Authorization$reduceRoleList,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (id) {
							return A2($author$project$Rights$Rights$getRole, id, rights);
						},
						$author$project$Rights$Role$Ids$toList(teamRole.kH))));
			var organisationUnitRights = A2(
				$elm$core$List$map,
				function (id) {
					return _Utils_Tuple2(id, rightSet);
				},
				$author$project$OrganisationUnit$Ids$toList(team.kn));
			return _Utils_Tuple2(
				A2($elm$core$List$append, accOrganisationUnitRightsTuple, organisationUnitRights),
				A2($elm$core$List$cons, rightSet, accRightSet));
		} else {
			return _Utils_Tuple2(accOrganisationUnitRightsTuple, accRightSet);
		}
	});
var $turboMaCk$any_set$Set$Any$filter = F2(
	function (f, _v0) {
		var dict = _v0;
		return A2(
			$turboMaCk$any_dict$Dict$Any$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$always, f),
			dict);
	});
var $author$project$Auth$RightSet$filter = $turboMaCk$any_set$Set$Any$filter;
var $author$project$Auth$RightSet$isEmpty = $turboMaCk$any_set$Set$Any$isEmpty;
var $author$project$Rights$Role$Ids$remove = $turboMaCk$any_set$Set$Any$remove;
var $author$project$Auth$RightSet$union = $turboMaCk$any_set$Set$Any$union;
var $author$project$Auth$Authorization$unifyRightSet = F2(
	function (rightSet, acc) {
		return A2($author$project$Auth$RightSet$union, rightSet, acc);
	});
var $author$project$Translations$Role$cantDelete = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.cantDelete');
};
var $author$project$Rights$Role$EditDialog$viewCantDelete = F2(
	function (translations, show_) {
		return show_ ? A2(
			$rtfeldman$elm_css$Html$Styled$h4,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$Role$cantDelete(translations))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Translations$Role$deleteHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.deleteHeader');
};
var $author$project$Rights$Role$EditDialog$viewDeleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Role$deleteHeader(translations))));
};
var $author$project$Rights$Role$EditDialog$viewDeleteTitle = function (role) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$paddingLeft(
						$rtfeldman$elm_css$Css$rem(1.5))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1.2)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(role.k8)
					]))
			]));
};
var $author$project$Rights$Role$EditDialog$viewDeleteDetails = function (role) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$author$project$Rights$Role$EditDialog$viewDeleteTitle(role)
			]));
};
var $author$project$Translations$Role$deleteText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.deleteText');
};
var $author$project$Rights$Role$EditDialog$viewDeleteQuestion = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Role$deleteText(translations))
			]));
};
var $author$project$Rights$Role$EditDialog$viewDeleteTab = F5(
	function (translations, environment, repository, basicDataEditor, role) {
		var rights = $author$project$Environments$Repository$getRights(repository);
		var maybeUser = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				function (userId) {
					return A2($author$project$Environments$Repository$getUser, userId, repository);
				},
				$author$project$Auth$Session$maybeUserId(
					$author$project$Environments$Environment$session(environment))));
		var disableBtn = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (user) {
					return $author$project$Auth$RightSet$isEmpty(
						A2(
							$author$project$Auth$RightSet$filter,
							function (right) {
								return (!right) || (right === 3);
							},
							A3(
								$elm$core$List$foldl,
								$author$project$Auth$Authorization$unifyRightSet,
								$author$project$Auth$RightSet$empty,
								A3(
									$elm$core$List$foldl,
									$author$project$Auth$Authorization$assembleData(rights),
									_Utils_Tuple2(_List_Nil, _List_Nil),
									A2(
										$elm$core$List$map,
										function (teamRole) {
											return _Utils_update(
												teamRole,
												{
													kH: A2($author$project$Rights$Role$Ids$remove, role.hc, teamRole.kH)
												});
										},
										$author$project$User$TeamRoles$toList(user.k2))).b)));
				},
				maybeUser));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(36)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(40)),
						$rtfeldman$elm_css$Css$maxWidth(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Rights$Role$EditDialog$viewFooter, translations, disableBtn, 2),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2($author$project$Rights$Role$EditDialog$viewCantDelete, translations, disableBtn),
						A2(
							$author$project$UI$Dialog$appendContent,
							$author$project$Rights$Role$EditDialog$viewDeleteDetails(role),
							A2(
								$author$project$UI$Dialog$appendContent,
								$author$project$Rights$Role$EditDialog$viewDeleteQuestion(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									$author$project$Rights$Role$EditDialog$viewDeleteBar(translations),
									A2(
										$author$project$UI$Dialog$appendHeader,
										A2($author$project$Rights$Role$EditDialog$viewTabBar, basicDataEditor, 2),
										A2(
											$author$project$UI$Dialog$withIcon,
											$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
											A2(
												$author$project$UI$Dialog$dialog,
												$author$project$Translations$Role$editDialogHeader(translations),
												$author$project$Rights$Role$EditDialog$UserClickedCloseDialog))))))))));
	});
var $author$project$Rights$Role$EditDialog$viewLabel = F2(
	function (label, secondText) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$h5,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'justify-self', 'start'),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$property, 'justify-self', 'start'),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
									$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(secondText)
						]))
				]));
	});
var $author$project$Rights$Role$EditDialog$UserClickedRight = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Rights$Role$EditDialog$viewRightsCheckbox = F2(
	function (right, selectedRights) {
		return $author$project$UI$Checkbox$view(
			A2(
				$author$project$UI$Checkbox$withOnCheck,
				$author$project$Rights$Role$EditDialog$UserClickedRight(right),
				A2(
					$author$project$UI$Checkbox$checked,
					A2($elm$core$List$member, right, selectedRights) || _Utils_eq(
						selectedRights,
						_List_fromArray(
							[3])),
					$author$project$UI$Checkbox$unlabeled)));
	});
var $author$project$Rights$Role$EditDialog$AddMultipleRights = function (a) {
	return {$: 8, a: a};
};
var $author$project$Rights$Role$EditDialog$RemoveMultipleRights = function (a) {
	return {$: 9, a: a};
};
var $author$project$Rights$Role$EditDialog$viewRightsHeaderIcon = F2(
	function (newRights, selectedRights) {
		var msg = _Utils_eq(
			$elm$core$List$length(newRights),
			$elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function (r) {
						return A2($elm$core$List$member, r, selectedRights);
					},
					newRights))) ? $author$project$Rights$Role$EditDialog$RemoveMultipleRights(newRights) : $author$project$Rights$Role$EditDialog$AddMultipleRights(newRights);
		return A2(
			$elm$core$Basics$composeR,
			$author$project$UI$Icon$unicolor,
			A2(
				$elm$core$Basics$composeR,
				$author$project$UI$Icon$withOnClick(msg),
				A2(
					$elm$core$Basics$composeR,
					$author$project$UI$Icon$withForegroundColor($author$project$UI$Style$Theme$darkGrey),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Icon$withStyle(
							$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$rem(2.5))),
						$author$project$UI$Icon$view))));
	});
var $author$project$Rights$Role$EditDialog$viewRightGroupContent = F2(
	function (translations, selectedRights) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'auto 4rem 4rem 4rem'),
							A2($rtfeldman$elm_css$Css$property, 'grid-row-gap', '1rem'),
							A2($rtfeldman$elm_css$Css$property, 'align-items', 'center'),
							A2($rtfeldman$elm_css$Css$property, 'justify-items', 'center')
						]))
				]),
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					A3(
					$author$project$Rights$Role$EditDialog$viewRightsHeaderIcon,
					_List_fromArray(
						[4, 7]),
					selectedRights,
					$author$project$UI$Icons$create),
					A3(
					$author$project$Rights$Role$EditDialog$viewRightsHeaderIcon,
					_List_fromArray(
						[5, 8]),
					selectedRights,
					$author$project$UI$Icons$edit),
					A3(
					$author$project$Rights$Role$EditDialog$viewRightsHeaderIcon,
					_List_fromArray(
						[6, 9]),
					selectedRights,
					$author$project$UI$Icons$delete),
					A2(
					$author$project$Rights$Role$EditDialog$viewLabel,
					$author$project$Translations$Rights$measure(translations),
					''),
					A2($author$project$Rights$Role$EditDialog$viewRightsCheckbox, 4, selectedRights),
					A2($author$project$Rights$Role$EditDialog$viewRightsCheckbox, 5, selectedRights),
					A2($author$project$Rights$Role$EditDialog$viewRightsCheckbox, 6, selectedRights),
					A2(
					$author$project$Rights$Role$EditDialog$viewLabel,
					$author$project$Translations$Rights$audits(translations),
					''),
					A2($author$project$Rights$Role$EditDialog$viewRightsCheckbox, 7, selectedRights),
					A2($author$project$Rights$Role$EditDialog$viewRightsCheckbox, 8, selectedRights),
					A2($author$project$Rights$Role$EditDialog$viewRightsCheckbox, 9, selectedRights)
				]));
	});
var $author$project$Rights$Role$EditDialog$viewRightsBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$taskList),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Role$assignRights(translations))));
};
var $author$project$Rights$Role$EditDialog$viewSpecialRightsRow = F4(
	function (label, secondLabel, right, selectedRights) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$marginRight(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Rights$Role$EditDialog$viewLabel, label, secondLabel),
					A2($author$project$Rights$Role$EditDialog$viewRightsCheckbox, right, selectedRights)
				]));
	});
var $author$project$Rights$Role$EditDialog$viewSingleRight = F2(
	function (translations, selectedRights) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$property, 'justify-self', 'start'),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$rem(0.5))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Rights$specialRights(translations))
						])),
					A4(
					$author$project$Rights$Role$EditDialog$viewSpecialRightsRow,
					$author$project$Translations$Rights$editTenant(translations),
					$author$project$Translations$Rights$editTenantDescription(translations),
					3,
					selectedRights),
					A4(
					$author$project$Rights$Role$EditDialog$viewSpecialRightsRow,
					$author$project$Translations$Rights$usersRights(translations),
					'',
					0,
					selectedRights),
					A4(
					$author$project$Rights$Role$EditDialog$viewSpecialRightsRow,
					$author$project$Translations$Rights$organisationUnits(translations),
					'',
					1,
					selectedRights),
					A4(
					$author$project$Rights$Role$EditDialog$viewSpecialRightsRow,
					$author$project$Translations$Rights$plans(translations),
					'',
					2,
					selectedRights)
				]));
	});
var $author$project$Rights$Role$EditDialog$viewRightsTab = F3(
	function (translations, basicDataEditor, selectedRights) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(32)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(40)),
						$rtfeldman$elm_css$Css$maxWidth(
						$rtfeldman$elm_css$Css$rem(40))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Rights$Role$EditDialog$viewFooter, translations, false, 1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2($author$project$Rights$Role$EditDialog$viewSingleRight, translations, selectedRights),
						A2(
							$author$project$UI$Dialog$appendContent,
							A2($author$project$Rights$Role$EditDialog$viewRightGroupContent, translations, selectedRights),
							A2(
								$author$project$UI$Dialog$appendHeader,
								$author$project$Rights$Role$EditDialog$viewRightsBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A2($author$project$Rights$Role$EditDialog$viewTabBar, basicDataEditor, 1),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Role$editDialogHeader(translations),
											$author$project$Rights$Role$EditDialog$UserClickedCloseDialog)))))))));
	});
var $author$project$Rights$Role$EditDialog$viewTab = F4(
	function (environment, repository, model, role) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var _v0 = model.cI;
		switch (_v0) {
			case 0:
				return A2($author$project$Rights$Role$EditDialog$viewBasicDataTab, translations, model.aQ);
			case 1:
				return A3($author$project$Rights$Role$EditDialog$viewRightsTab, translations, model.aQ, model.aw);
			default:
				return A5($author$project$Rights$Role$EditDialog$viewDeleteTab, translations, environment, repository, model.aQ, role);
		}
	});
var $author$project$Rights$Role$EditDialog$viewDialog = F3(
	function (environment, repository, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Rights$Role$EditDialog$viewDeletedDialog(environment),
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Rights$Role$EditDialog$viewTab, environment, repository, model),
				A2(
					$author$project$Rights$Rights$getRole,
					model.d9.hc,
					$author$project$Environments$Repository$getRights(repository))));
	});
var $author$project$Rights$Role$EditDialog$view = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Rights$Role$EditDialog$viewDialog, environment, repository, model);
			case 2:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Rights$Role$EditDialog$viewDialog, environment, repository, model);
			default:
				return A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Rights$Role$EditDialog$viewDeletedDialog, environment);
		}
	});
var $author$project$Rights$Role$Page$viewEditDialog = F2(
	function (environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Rights$Role$EditDialog$view, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Rights$Role$Page$GotEditDialogMsg));
	});
var $author$project$Translations$Role$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.emptyText');
};
var $author$project$Rights$Rights$getRoles = A2(
	$elm$core$Basics$composeR,
	$author$project$Rights$Rights$unwrap,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.db;
		},
		$author$project$Rights$Role$Dict$values));
var $author$project$Rights$Role$Page$UserClickedEditIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Role$Page$viewEditIcon = $author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle);
var $author$project$Rights$Role$Page$viewRow = F2(
	function (viewType, role) {
		return A2(
			$author$project$UI$Table$Row$withOnClick,
			$author$project$Rights$Role$Page$UserClickedEditIcon(role),
			A2(
				$author$project$UI$Table$Row$withRightIcon,
				$author$project$Rights$Role$Page$viewEditIcon,
				A3($author$project$UI$Table$Row$row, viewType, role.k8, role)));
	});
var $author$project$Rights$Role$Page$viewTable = F2(
	function (translations, viewType) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Environments$Repository$getRights,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Rights$Rights$getRoles,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$sortBy(
						function (r) {
							return $elm$core$String$toLower(r.k8);
						}),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Table$fromList(
							$author$project$Rights$Role$Page$viewRow(viewType)),
						A2(
							$elm$core$Basics$composeR,
							$author$project$UI$Table$withEmptyText(
								$author$project$Translations$Role$emptyText(translations)),
							$author$project$UI$Table$view)))));
	});
var $author$project$Rights$Role$Page$view = F3(
	function (environment, repository, _v0) {
		var page = _v0;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				A3($author$project$Rights$Role$Page$viewEditDialog, environment, repository, page.cO),
				A2(
					$author$project$UI$Page$appendContent,
					A2($author$project$Rights$Role$Page$viewCreateDialog, environment, page.fi),
					A2(
						$author$project$UI$Page$appendContent,
						A4(
							$rtfeldman$elm_css$Html$Styled$Lazy$lazy3,
							$author$project$Rights$Role$Page$viewTable,
							translations,
							$author$project$Environments$Environment$getViewType(environment),
							repository),
						A2(
							$author$project$UI$Page$appendContent,
							A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Rights$Role$Page$viewActionBar, translations),
							A2(
								$author$project$UI$Page$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$roles),
								$author$project$UI$Page$page(
									$author$project$Translations$Role$pageHeader(translations))))))));
	});
var $author$project$Page$Page$roles = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 15) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotRolePageMsg,
		kZ: $elm$core$Maybe$Nothing,
		le: $author$project$Rights$Role$Page$update,
		lm: $author$project$Rights$Role$Page$view
	});
var $author$project$Page$Page$GotSettingsPageMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Tenant$EditModal$Edit = 0;
var $author$project$Page$Settings$GotEditTenantModelMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Tenant$EditModal$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tenant$EditModal$show = F2(
	function (context, tenant) {
		return $author$project$Tenant$EditModal$Visible(
			{
				aq: context,
				gw: $elm$core$String$trim(tenant.gw),
				gP: $elm$core$String$trim(tenant.gP),
				gV: $elm$core$String$trim(tenant.gV),
				jX: tenant.jX,
				g7: $elm$core$String$trim(tenant.g7),
				hb: $elm$core$String$trim(tenant.hb),
				iC: tenant,
				lg: $elm$core$String$trim(tenant.lg),
				hr: $elm$core$String$trim(tenant.hr)
			});
	});
var $author$project$Tenant$Commands$fromList = $author$project$Types$Queue$fromList;
var $author$project$Environments$Repository$getTenant = function (_v0) {
	var data = _v0;
	return A2(
		$author$project$Tenant$Tenant$applyModification,
		$author$project$Tenant$Store$events(data.ag),
		$author$project$Tenant$Store$tenant(data.ag)).a;
};
var $author$project$Tenant$Commands$fold = $author$project$Types$Queue$fold;
var $author$project$Tenant$Tenant$AlreadyExists = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tenant$Tenant$applyEvents = F2(
	function (events, acc) {
		return A3($author$project$Tenant$Events$fold, $author$project$Tenant$Tenant$applyEventHelper, acc, events);
	});
var $author$project$Tenant$Commands$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$Tenant$Tenant$handleChangeCountryCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(acc.au);
		if (!_v0.$) {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Tenant$Event$CountryChanged(
				{L: payload.L, M: payload.M, gw: payload.gw, N: eventId, k5: payload.k5, n: 0});
			var newModification = A2(
				$author$project$Tenant$Tenant$applyEvents,
				$author$project$Tenant$Events$singleton(event),
				acc.au);
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Tenant$Commands$enqueue,
						$author$project$Tenant$Command$ChangeCountry(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Tenant$Events$enqueue, event, acc.b8),
					au: newModification
				});
		} else {
			return $elm$core$Result$Err(
				$author$project$Tenant$Tenant$AlreadyExists(payload.k5));
		}
	});
var $author$project$Tenant$Tenant$handleChangeHouseNumberCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(acc.au);
		if (!_v0.$) {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Tenant$Event$HouseNumberChanged(
				{L: payload.L, M: payload.M, N: eventId, gP: payload.gP, k5: payload.k5, n: 0});
			var newModification = A2(
				$author$project$Tenant$Tenant$applyEvents,
				$author$project$Tenant$Events$singleton(event),
				acc.au);
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Tenant$Commands$enqueue,
						$author$project$Tenant$Command$ChangeHouseNumber(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Tenant$Events$enqueue, event, acc.b8),
					au: newModification
				});
		} else {
			return $elm$core$Result$Err(
				$author$project$Tenant$Tenant$AlreadyExists(payload.k5));
		}
	});
var $author$project$Tenant$Tenant$handleChangeLocationCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(acc.au);
		if (!_v0.$) {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Tenant$Event$LocationChanged(
				{L: payload.L, M: payload.M, N: eventId, gV: payload.gV, k5: payload.k5, n: 0});
			var newModification = A2(
				$author$project$Tenant$Tenant$applyEvents,
				$author$project$Tenant$Events$singleton(event),
				acc.au);
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Tenant$Commands$enqueue,
						$author$project$Tenant$Command$ChangeLocation(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Tenant$Events$enqueue, event, acc.b8),
					au: newModification
				});
		} else {
			return $elm$core$Result$Err(
				$author$project$Tenant$Tenant$AlreadyExists(payload.k5));
		}
	});
var $author$project$Tenant$Tenant$handleChangeLogoCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(acc.au);
		if (!_v0.$) {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Tenant$Event$LogoChanged(
				{L: payload.L, M: payload.M, N: eventId, jX: payload.jX, k5: payload.k5, n: 0});
			var newModification = A2(
				$author$project$Tenant$Tenant$applyEvents,
				$author$project$Tenant$Events$singleton(event),
				acc.au);
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Tenant$Commands$enqueue,
						$author$project$Tenant$Command$ChangeLogo(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Tenant$Events$enqueue, event, acc.b8),
					au: newModification
				});
		} else {
			return $elm$core$Result$Err(
				$author$project$Tenant$Tenant$AlreadyExists(payload.k5));
		}
	});
var $author$project$Tenant$Tenant$handleChangePhoneNumberCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(acc.au);
		if (!_v0.$) {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Tenant$Event$PhoneNumberChanged(
				{L: payload.L, M: payload.M, N: eventId, g7: payload.g7, k5: payload.k5, n: 0});
			var newModification = A2(
				$author$project$Tenant$Tenant$applyEvents,
				$author$project$Tenant$Events$singleton(event),
				acc.au);
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Tenant$Commands$enqueue,
						$author$project$Tenant$Command$ChangePhoneNumber(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Tenant$Events$enqueue, event, acc.b8),
					au: newModification
				});
		} else {
			return $elm$core$Result$Err(
				$author$project$Tenant$Tenant$AlreadyExists(payload.k5));
		}
	});
var $author$project$Tenant$Tenant$DoesNotExist = function (a) {
	return {$: 0, a: a};
};
var $author$project$Tenant$Tenant$handleChangeRoadCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(acc.au);
		if (!_v0.$) {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Tenant$Event$RoadChanged(
				{L: payload.L, M: payload.M, N: eventId, hb: payload.hb, k5: payload.k5, n: 0});
			var newModification = A2(
				$author$project$Tenant$Tenant$applyEvents,
				$author$project$Tenant$Events$singleton(event),
				acc.au);
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Tenant$Commands$enqueue,
						$author$project$Tenant$Command$ChangeRoad(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Tenant$Events$enqueue, event, acc.b8),
					au: newModification
				});
		} else {
			return $elm$core$Result$Err(
				$author$project$Tenant$Tenant$DoesNotExist(payload.k5));
		}
	});
var $author$project$Tenant$Tenant$handleChangeUrlCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(acc.au);
		if (!_v0.$) {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Tenant$Event$UrlChanged(
				{L: payload.L, M: payload.M, N: eventId, k5: payload.k5, lg: payload.lg, n: 0});
			var newModification = A2(
				$author$project$Tenant$Tenant$applyEvents,
				$author$project$Tenant$Events$singleton(event),
				acc.au);
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Tenant$Commands$enqueue,
						$author$project$Tenant$Command$ChangeUrl(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Tenant$Events$enqueue, event, acc.b8),
					au: newModification
				});
		} else {
			return $elm$core$Result$Err(
				$author$project$Tenant$Tenant$AlreadyExists(payload.k5));
		}
	});
var $author$project$Tenant$Tenant$handleChangeZipCodeCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$Tenant$Tenant$tenantFromModification(acc.au);
		if (!_v0.$) {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$Tenant$Event$ZipCodeChanged(
				{L: payload.L, M: payload.M, N: eventId, k5: payload.k5, n: 0, hr: payload.hr});
			var newModification = A2(
				$author$project$Tenant$Tenant$applyEvents,
				$author$project$Tenant$Events$singleton(event),
				acc.au);
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$Tenant$Commands$enqueue,
						$author$project$Tenant$Command$ChangeZipCode(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$Tenant$Events$enqueue, event, acc.b8),
					au: newModification
				});
		} else {
			return $elm$core$Result$Err(
				$author$project$Tenant$Tenant$AlreadyExists(payload.k5));
		}
	});
var $author$project$Tenant$Tenant$handleCommandHelper = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $author$project$Tenant$Tenant$handleChangeRoadCommand(payload);
		case 1:
			var payload = command.a;
			return $author$project$Tenant$Tenant$handleChangeHouseNumberCommand(payload);
		case 2:
			var payload = command.a;
			return $author$project$Tenant$Tenant$handleChangeZipCodeCommand(payload);
		case 3:
			var payload = command.a;
			return $author$project$Tenant$Tenant$handleChangeLocationCommand(payload);
		case 4:
			var payload = command.a;
			return $author$project$Tenant$Tenant$handleChangeCountryCommand(payload);
		case 5:
			var payload = command.a;
			return $author$project$Tenant$Tenant$handleChangePhoneNumberCommand(payload);
		case 6:
			var payload = command.a;
			return $author$project$Tenant$Tenant$handleChangeUrlCommand(payload);
		default:
			var payload = command.a;
			return $author$project$Tenant$Tenant$handleChangeLogoCommand(payload);
	}
};
var $author$project$Tenant$Tenant$handleCommands = F3(
	function (commands, environment, maybeTenant) {
		var acc = $elm$core$Result$Ok(
			{
				cD: $author$project$Tenant$Commands$empty,
				ac: environment,
				b8: $author$project$Tenant$Events$empty,
				au: $author$project$Tenant$Tenant$NotModified(maybeTenant)
			});
		return A2(
			$elm$core$Result$map,
			function (data) {
				return {cD: data.cD, ac: data.ac, b8: data.b8};
			},
			A3(
				$author$project$Tenant$Commands$fold,
				A2($elm$core$Basics$composeR, $author$project$Tenant$Tenant$handleCommandHelper, $elm$core$Result$andThen),
				acc,
				commands));
	});
var $author$project$Tenant$Store$SaveCommandsAndEvents = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Tenant$Commands$merge = $author$project$Types$Queue$merge;
var $author$project$Tenant$Events$merge = $author$project$Types$Queue$merge;
var $author$project$Tenant$Store$saveCommandsAndEvents = F3(
	function (commands_, events_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Tenant$Store$Saving(
							{
								cD: A2($author$project$Tenant$Commands$merge, data.cD, commands_),
								b8: A2($author$project$Tenant$Events$merge, data.b8, events_),
								iC: $elm$core$Maybe$Nothing
							}),
						$author$project$Tenant$Store$send(
							A2($author$project$Tenant$Store$SaveCommandsAndEvents, commands_, events_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$Tenant$Store$Saving(
							_Utils_update(
								data,
								{
									cD: A2($author$project$Tenant$Commands$merge, data.cD, commands_),
									b8: A2($author$project$Tenant$Events$merge, data.b8, events_)
								})),
						$author$project$Tenant$Store$send(
							A2($author$project$Tenant$Store$SaveCommandsAndEvents, commands_, events_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$saveTenantCommandsAndEvents = F3(
	function (commands, events, repository) {
		var _v0 = A3(
			$author$project$Tenant$Store$saveCommandsAndEvents,
			commands,
			events,
			$author$project$Environments$Repository$tenantStore(repository));
		if (!_v0.$) {
			var _v1 = _v0.a;
			var newTenantStore = _v1.a;
			var tenantStoreCmd = _v1.b;
			return _Utils_Tuple2(
				A2($author$project$Environments$Repository$withTenantStore, newTenantStore, repository),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[tenantStoreCmd])));
		} else {
			return _Utils_Tuple2(repository, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Environments$ErrorHandling$ToString$tenantErrorToString = function (err) {
	if (!err.$) {
		var id = err.a;
		return 'Tenant.DoesNotExist' + $author$project$Tenant$Id$toString(id);
	} else {
		var id = err.a;
		return 'Tenant.AlreadyExists' + $author$project$Tenant$Id$toString(id);
	}
};
var $author$project$Tenant$EditModal$createdCommands = F4(
	function (commands, environment, repository, _v0) {
		var _v1 = A3(
			$author$project$Tenant$Tenant$handleCommands,
			$author$project$Tenant$Commands$fromList(commands),
			environment,
			$author$project$Environments$Repository$getTenant(repository));
		if (_v1.$ === 1) {
			var err = _v1.a;
			var _v2 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Environments$ErrorHandling$Id$from,
				$author$project$Environments$Environment$generateUuid(environment));
			var newId = _v2.a;
			var newEnvironment = _v2.b;
			var newError = {
				gg: '',
				gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
					$author$project$Environments$ErrorHandling$ToString$tenantErrorToString(err)),
				gH: 'Tenant.EditDialog.elm',
				gK: 'createdCommands',
				fw: newId
			};
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Tenant$EditModal$Hidden,
				ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
				ae: repository
			};
		} else {
			var resultData = _v1.a;
			if ($author$project$Tenant$Commands$isEmpty(resultData.cD) || $author$project$Tenant$Events$isEmpty(resultData.b8)) {
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Tenant$EditModal$Hidden, ac: environment, ae: repository};
			} else {
				var _v3 = A3($author$project$Environments$Repository$saveTenantCommandsAndEvents, resultData.cD, resultData.b8, repository);
				var newRepository = _v3.a;
				var cmd = _v3.b;
				return {ab: cmd, jn: $author$project$Tenant$EditModal$Hidden, ac: resultData.ac, ae: newRepository};
			}
		}
	});
var $author$project$Tenant$EditModal$CreatedCommands = function (a) {
	return {$: 9, a: a};
};
var $author$project$Tenant$EditModal$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$Tenant$Command$commandHelper = F2(
	function (environment, buildCommand) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Types$CommandId$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var commandId_ = _v0.a;
		var newEnvironment = _v0.b;
		return _Utils_Tuple2(
			newEnvironment,
			A2(
				$elm$core$Task$map,
				buildCommand(commandId_),
				$elm$time$Time$now));
	});
var $author$project$Tenant$Command$changeCountry = F3(
	function (environment, tenantId, country) {
		return A2(
			$author$project$Tenant$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Tenant$Command$ChangeCountry(
						{L: commandId_, M: commandTimestamp, gw: country, k5: tenantId});
				}));
	});
var $author$project$Tenant$EditModal$nothingWhenEmpty = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
};
var $author$project$Tenant$EditModal$withChangeCountryCommand = F3(
	function (tenant, country, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(tenant.gw, country) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A3(
				$author$project$Tenant$Command$changeCountry,
				environment,
				tenant.k5,
				$author$project$Tenant$EditModal$nothingWhenEmpty(country)));
	});
var $author$project$Tenant$Command$changeHouseNumber = F3(
	function (environment, tenantId, houseNumber) {
		return A2(
			$author$project$Tenant$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Tenant$Command$ChangeHouseNumber(
						{L: commandId_, M: commandTimestamp, gP: houseNumber, k5: tenantId});
				}));
	});
var $author$project$Tenant$EditModal$withChangeHouseNumberCommand = F3(
	function (tenant, houseNumber, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(tenant.gP, houseNumber) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A3(
				$author$project$Tenant$Command$changeHouseNumber,
				environment,
				tenant.k5,
				$author$project$Tenant$EditModal$nothingWhenEmpty(houseNumber)));
	});
var $author$project$Tenant$Command$changeLocation = F3(
	function (environment, tenantId, location) {
		return A2(
			$author$project$Tenant$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Tenant$Command$ChangeLocation(
						{L: commandId_, M: commandTimestamp, gV: location, k5: tenantId});
				}));
	});
var $author$project$Tenant$EditModal$withChangeLocationCommand = F3(
	function (tenant, location, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(tenant.gV, location) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A3(
				$author$project$Tenant$Command$changeLocation,
				environment,
				tenant.k5,
				$author$project$Tenant$EditModal$nothingWhenEmpty(location)));
	});
var $author$project$Tenant$Command$changeLogo = F3(
	function (environment, tenantId, logo) {
		return A2(
			$author$project$Tenant$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Tenant$Command$ChangeLogo(
						{L: commandId_, M: commandTimestamp, jX: logo, k5: tenantId});
				}));
	});
var $author$project$Tenant$EditModal$withChangeLogoCommand = F3(
	function (tenant, logo, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(tenant.jX, logo) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A3($author$project$Tenant$Command$changeLogo, environment, tenant.k5, logo));
	});
var $author$project$Tenant$Command$changePhoneNumber = F3(
	function (environment, tenantId, phoneNumber) {
		return A2(
			$author$project$Tenant$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Tenant$Command$ChangePhoneNumber(
						{L: commandId_, M: commandTimestamp, g7: phoneNumber, k5: tenantId});
				}));
	});
var $author$project$Tenant$EditModal$withChangePhoneNumberCommand = F3(
	function (tenant, phoneNumber, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(tenant.g7, phoneNumber) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A3(
				$author$project$Tenant$Command$changePhoneNumber,
				environment,
				tenant.k5,
				$author$project$Tenant$EditModal$nothingWhenEmpty(phoneNumber)));
	});
var $author$project$Tenant$Command$changeRoad = F3(
	function (environment, tenantId, road) {
		return A2(
			$author$project$Tenant$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Tenant$Command$ChangeRoad(
						{L: commandId_, M: commandTimestamp, hb: road, k5: tenantId});
				}));
	});
var $author$project$Tenant$EditModal$withChangeRoadCommand = F3(
	function (tenant, road, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(tenant.hb, road) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A3(
				$author$project$Tenant$Command$changeRoad,
				environment,
				tenant.k5,
				$author$project$Tenant$EditModal$nothingWhenEmpty(road)));
	});
var $author$project$Tenant$Command$changeUrl = F3(
	function (environment, tenantId, url) {
		return A2(
			$author$project$Tenant$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Tenant$Command$ChangeUrl(
						{L: commandId_, M: commandTimestamp, k5: tenantId, lg: url});
				}));
	});
var $author$project$Tenant$EditModal$withChangeUrlCommand = F3(
	function (tenant, url, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(tenant.lg, url) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A3(
				$author$project$Tenant$Command$changeUrl,
				environment,
				tenant.k5,
				$author$project$Tenant$EditModal$nothingWhenEmpty(url)));
	});
var $author$project$Tenant$Command$changeZipCode = F3(
	function (environment, tenantId, zipCode) {
		return A2(
			$author$project$Tenant$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Tenant$Command$ChangeZipCode(
						{L: commandId_, M: commandTimestamp, k5: tenantId, hr: zipCode});
				}));
	});
var $author$project$Tenant$EditModal$withChangeZipCodeCommand = F3(
	function (tenant, zipCode, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(tenant.hr, zipCode) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A3(
				$author$project$Tenant$Command$changeZipCode,
				environment,
				tenant.k5,
				$author$project$Tenant$EditModal$nothingWhenEmpty(zipCode)));
	});
var $author$project$Tenant$EditModal$createCommands = F2(
	function (environment, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A3(
				$author$project$Tenant$EditModal$withChangeLogoCommand,
				model.iC,
				model.jX,
				A3(
					$author$project$Tenant$EditModal$withChangeUrlCommand,
					model.iC,
					model.lg,
					A3(
						$author$project$Tenant$EditModal$withChangePhoneNumberCommand,
						model.iC,
						model.g7,
						A3(
							$author$project$Tenant$EditModal$withChangeCountryCommand,
							model.iC,
							model.gw,
							A3(
								$author$project$Tenant$EditModal$withChangeLocationCommand,
								model.iC,
								model.gV,
								A3(
									$author$project$Tenant$EditModal$withChangeZipCodeCommand,
									model.iC,
									model.hr,
									A3(
										$author$project$Tenant$EditModal$withChangeHouseNumberCommand,
										model.iC,
										model.gP,
										A3(
											$author$project$Tenant$EditModal$withChangeRoadCommand,
											model.iC,
											model.hb,
											_Utils_Tuple2(environment, _List_Nil))))))))));
	});
var $author$project$Tenant$EditModal$userClickedApplyButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var _v1 = A2($author$project$Tenant$EditModal$createCommands, environment, model);
				var newEnvironment = _v1.a;
				var tasks = _v1.b;
				return $elm$core$List$isEmpty(tasks) ? {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository} : {
					ab: A2(
						$elm$core$Task$perform,
						$author$project$Tenant$EditModal$CreatedCommands,
						$elm$core$Task$sequence(tasks)),
					jn: $author$project$Tenant$EditModal$HandlingCommands(model),
					ac: newEnvironment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Tenant$EditModal$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Tenant$EditModal$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Tenant$EditModal$userEnteredCountry = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Tenant$EditModal$Visible(
					_Utils_update(
						model,
						{gw: input})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Tenant$EditModal$userEnteredHouseNumber = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Tenant$EditModal$Visible(
					_Utils_update(
						model,
						{gP: input})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Tenant$EditModal$userEnteredLocation = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Tenant$EditModal$Visible(
					_Utils_update(
						model,
						{gV: input})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Tenant$EditModal$userEnteredPhoneNumber = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Tenant$EditModal$Visible(
					_Utils_update(
						model,
						{g7: input})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Tenant$EditModal$userEnteredRoad = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Tenant$EditModal$Visible(
					_Utils_update(
						model,
						{hb: input})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Tenant$EditModal$userEnteredUrl = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Tenant$EditModal$Visible(
					_Utils_update(
						model,
						{lg: input})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Tenant$EditModal$userEnteredZipCode = F4(
	function (input, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Tenant$EditModal$Visible(
					_Utils_update(
						model,
						{hr: input})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Tenant$EditModal$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Tenant$EditModal$userClickedCloseDialog;
		case 8:
			return $author$project$Tenant$EditModal$userClickedApplyButton;
		case 9:
			var commands = msg.a;
			return $author$project$Tenant$EditModal$createdCommands(commands);
		case 1:
			var string = msg.a;
			return $author$project$Tenant$EditModal$userEnteredRoad(string);
		case 2:
			var string = msg.a;
			return $author$project$Tenant$EditModal$userEnteredHouseNumber(string);
		case 3:
			var string = msg.a;
			return $author$project$Tenant$EditModal$userEnteredZipCode(string);
		case 4:
			var string = msg.a;
			return $author$project$Tenant$EditModal$userEnteredLocation(string);
		case 5:
			var string = msg.a;
			return $author$project$Tenant$EditModal$userEnteredCountry(string);
		case 6:
			var string = msg.a;
			return $author$project$Tenant$EditModal$userEnteredPhoneNumber(string);
		default:
			var string = msg.a;
			return $author$project$Tenant$EditModal$userEnteredUrl(string);
	}
};
var $author$project$Page$Settings$update = F4(
	function (msg, environment, repository, page) {
		var tenantEditModal = page;
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					ac: A2($author$project$Environments$Environment$navigateTo, route, environment),
					ak: page,
					ae: repository
				};
			case 1:
				var tenant = msg.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					ac: environment,
					ak: A2($author$project$Tenant$EditModal$show, 0, tenant),
					ae: repository
				};
			default:
				var tenantEditMsg = msg.a;
				var result = A4($author$project$Tenant$EditModal$update, tenantEditMsg, environment, repository, tenantEditModal);
				return {
					ab: A2($elm$core$Platform$Cmd$map, $author$project$Page$Settings$GotEditTenantModelMsg, result.ab),
					ac: result.ac,
					ak: result.jn,
					ae: result.ae
				};
		}
	});
var $author$project$Translations$Settings$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'settings.header');
};
var $author$project$Tenant$EditModal$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Tenant$editTenantHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.editTenantHeader ');
};
var $author$project$Tenant$EditModal$UserEnteredCountry = function (a) {
	return {$: 5, a: a};
};
var $author$project$Tenant$EditModal$UserEnteredHouseNumber = function (a) {
	return {$: 2, a: a};
};
var $author$project$Tenant$EditModal$UserEnteredLocation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Tenant$EditModal$UserEnteredPhoneNumber = function (a) {
	return {$: 6, a: a};
};
var $author$project$Tenant$EditModal$UserEnteredRoad = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tenant$EditModal$UserEnteredUrl = function (a) {
	return {$: 7, a: a};
};
var $author$project$Tenant$EditModal$UserEnteredZipCode = function (a) {
	return {$: 3, a: a};
};
var $author$project$Translations$Tenant$addressData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.addressData');
};
var $author$project$Translations$Tenant$contactData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.contactData');
};
var $author$project$Translations$Tenant$country = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.country');
};
var $author$project$Translations$Tenant$houseNumber = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.houseNumber');
};
var $author$project$Translations$Tenant$location = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.location');
};
var $author$project$Translations$Tenant$phoneNumber = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.phoneNumber');
};
var $author$project$Translations$Tenant$road = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.road');
};
var $author$project$Translations$Tenant$url = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.url');
};
var $author$project$Tenant$EditModal$viewLabel = F3(
	function (noContent, label, rem_) {
		return noContent ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(700)),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(rem_)),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(20)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $author$project$Tenant$EditModal$viewTextInput = F3(
	function (inputMsg, label, value) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						])),
					$author$project$UI$TextInput$view(
					A2(
						$author$project$UI$TextInput$withStyle,
						$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(0.4)),
						A2(
							$author$project$UI$TextInput$withOnInput,
							inputMsg,
							A2($author$project$UI$TextInput$withValue, value, $author$project$UI$TextInput$singleLine))))
				]));
	});
var $author$project$Translations$Tenant$zipCode = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.zipCode');
};
var $author$project$Tenant$EditModal$viewEdit = F2(
	function (translations, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Tenant$EditModal$viewLabel,
					false,
					$author$project$Translations$Tenant$addressData(translations),
					0),
					A3(
					$author$project$Tenant$EditModal$viewTextInput,
					$author$project$Tenant$EditModal$UserEnteredRoad,
					$author$project$Translations$Tenant$road(translations),
					model.hb),
					A3(
					$author$project$Tenant$EditModal$viewTextInput,
					$author$project$Tenant$EditModal$UserEnteredHouseNumber,
					$author$project$Translations$Tenant$houseNumber(translations),
					model.gP),
					A3(
					$author$project$Tenant$EditModal$viewTextInput,
					$author$project$Tenant$EditModal$UserEnteredZipCode,
					$author$project$Translations$Tenant$zipCode(translations),
					model.hr),
					A3(
					$author$project$Tenant$EditModal$viewTextInput,
					$author$project$Tenant$EditModal$UserEnteredLocation,
					$author$project$Translations$Tenant$location(translations),
					model.gV),
					A3(
					$author$project$Tenant$EditModal$viewTextInput,
					$author$project$Tenant$EditModal$UserEnteredCountry,
					$author$project$Translations$Tenant$country(translations),
					model.gw),
					A3(
					$author$project$Tenant$EditModal$viewLabel,
					false,
					$author$project$Translations$Tenant$contactData(translations),
					1),
					A3(
					$author$project$Tenant$EditModal$viewTextInput,
					$author$project$Tenant$EditModal$UserEnteredPhoneNumber,
					$author$project$Translations$Tenant$phoneNumber(translations),
					model.g7),
					A3(
					$author$project$Tenant$EditModal$viewTextInput,
					$author$project$Tenant$EditModal$UserEnteredUrl,
					$author$project$Translations$Tenant$url(translations),
					model.lg)
				]));
	});
var $author$project$Tenant$EditModal$viewTextValue = F2(
	function (label, value) {
		return $elm$core$String$isEmpty(value) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(18)),
							$rtfeldman$elm_css$Css$displayFlex
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$rem(9))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label + ':')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$rem(16))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(value)
						]))
				]));
	});
var $author$project$Tenant$EditModal$viewUrl = F2(
	function (translations, value) {
		if ($elm$core$String$isEmpty(value)) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var fixedUrl = A2($elm$core$String$contains, 'https://', value) ? value : ('https://' + value);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$px(18)),
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$width(
										$rtfeldman$elm_css$Css$rem(9))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Translations$Tenant$url(translations))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href(fixedUrl),
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$width(
										$rtfeldman$elm_css$Css$rem(16))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(value)
							]))
					]));
		}
	});
var $author$project$Tenant$EditModal$viewNoEdit = F2(
	function (translations, model) {
		var street = A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				function (str) {
					return !$elm$core$String$isEmpty(str);
				},
				_List_fromArray(
					[model.hb, model.gP])));
		var hasNoContentData = $elm$core$String$isEmpty(model.g7) && $elm$core$String$isEmpty(model.lg);
		var hasNoAddressData = $elm$core$String$isEmpty(model.hb) && ($elm$core$String$isEmpty(model.gP) && ($elm$core$String$isEmpty(model.hr) && ($elm$core$String$isEmpty(model.gV) && $elm$core$String$isEmpty(model.gw))));
		var city = A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				function (str) {
					return !$elm$core$String$isEmpty(str);
				},
				_List_fromArray(
					[model.hr, model.gV])));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							A2($rtfeldman$elm_css$Css$property, 'user-select', 'text')
						]))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Tenant$EditModal$viewLabel,
					hasNoAddressData,
					$author$project$Translations$Tenant$addressData(translations),
					0),
					A2(
					$author$project$Tenant$EditModal$viewTextValue,
					$author$project$Translations$Tenant$road(translations),
					street),
					A2(
					$author$project$Tenant$EditModal$viewTextValue,
					$author$project$Translations$Tenant$location(translations),
					city),
					A2(
					$author$project$Tenant$EditModal$viewTextValue,
					$author$project$Translations$Tenant$country(translations),
					model.gw),
					A3(
					$author$project$Tenant$EditModal$viewLabel,
					hasNoContentData,
					$author$project$Translations$Tenant$contactData(translations),
					1),
					A2(
					$author$project$Tenant$EditModal$viewTextValue,
					$author$project$Translations$Tenant$phoneNumber(translations),
					model.g7),
					A2($author$project$Tenant$EditModal$viewUrl, translations, model.lg)
				]));
	});
var $author$project$Tenant$EditModal$viewContent = F2(
	function (translations, model) {
		var _v0 = model.aq;
		if (!_v0) {
			return A2($author$project$Tenant$EditModal$viewEdit, translations, model);
		} else {
			return A2($author$project$Tenant$EditModal$viewNoEdit, translations, model);
		}
	});
var $author$project$Tenant$EditModal$UserClickedApplyButton = {$: 8};
var $author$project$Tenant$EditModal$viewApplyButton = F2(
	function (translations, disabled) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withOnClick,
				$author$project$Tenant$EditModal$UserClickedApplyButton,
				A2(
					$author$project$UI$Button$disabled,
					disabled,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$apply(translations)))));
	});
var $author$project$Tenant$EditModal$viewLeftButton = F2(
	function (translations, context) {
		var leftButtonText = function () {
			if (!context) {
				return $author$project$Translations$Buttons$cancel(translations);
			} else {
				return $author$project$Translations$Buttons$close(translations);
			}
		}();
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withOnClick,
				$author$project$Tenant$EditModal$UserClickedCloseDialog,
				$author$project$UI$Button$lightGrey(leftButtonText)));
	});
var $author$project$Tenant$EditModal$viewFooter = F3(
	function (translations, context, disabled) {
		var rightButton = function () {
			if (!context) {
				return A2($author$project$Tenant$EditModal$viewApplyButton, translations, disabled);
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Tenant$EditModal$viewLeftButton, translations, context),
					rightButton
				]));
	});
var $author$project$Translations$Tenant$limitations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.limitations');
};
var $author$project$Translations$Sidebar$organisationUnits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.organisationUnits');
};
var $author$project$Translations$Sidebar$plans = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.plans');
};
var $author$project$Translations$Tenant$unlimited = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'tenant.unlimited');
};
var $author$project$Translations$Sidebar$users = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.users');
};
var $author$project$Tenant$EditModal$viewLimitations = F4(
	function (translations, userRights, repository, limitations) {
		var intToText = function (_int) {
			return _Utils_eq(_int, -1) ? $author$project$Translations$Tenant$unlimited(translations) : $elm$core$String$fromInt(_int);
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$px(18)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$px(20)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(700)),
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Tenant$limitations(translations))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Sidebar$users(translations) + (': ' + intToText(limitations.lk)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Sidebar$organisationUnits(translations) + (': ' + intToText(limitations.kn)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Sidebar$plans(translations) + (': ' + intToText(limitations.aL)))
						]))
				]));
	});
var $author$project$Tenant$EditModal$viewDialog = F4(
	function (translations, userRights, repository, model) {
		var header = function () {
			var _v0 = model.aq;
			if (!_v0) {
				return $author$project$Translations$Tenant$editTenantHeader(translations);
			} else {
				return model.iC.aP;
			}
		}();
		var disabledButton = _Utils_eq(model.iC.hb, model.hb) && (_Utils_eq(model.iC.gP, model.gP) && (_Utils_eq(model.iC.hr, model.hr) && (_Utils_eq(model.iC.gV, model.gV) && (_Utils_eq(model.iC.gw, model.gw) && (_Utils_eq(model.iC.g7, model.g7) && _Utils_eq(model.iC.lg, model.lg))))));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendFooter,
				A3($author$project$Tenant$EditModal$viewFooter, translations, model.aq, disabledButton),
				A2(
					$author$project$UI$Dialog$appendContent,
					A4($author$project$Tenant$EditModal$viewLimitations, translations, userRights, repository, model.iC.jW),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2($author$project$Tenant$EditModal$viewContent, translations, model),
						A2($author$project$UI$Dialog$dialog, header, $author$project$Tenant$EditModal$UserClickedCloseDialog)))));
	});
var $author$project$Tenant$EditModal$view = F4(
	function (translations, userRights, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$Tenant$EditModal$viewDialog, translations, userRights, repository, model);
			default:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$Tenant$EditModal$viewDialog, translations, userRights, repository, model);
		}
	});
var $author$project$Page$Settings$viewEditTenant = F4(
	function (translations, userRights, repository, tenantEditModal) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$Page$Settings$GotEditTenantModelMsg,
			A4($author$project$Tenant$EditModal$view, translations, userRights, repository, tenantEditModal));
	});
var $author$project$UI$Table$default = {fc: _List_Nil, dE: '', c_: _List_Nil, cu: _List_Nil, dd: _List_Nil};
var $author$project$Environments$Route$OrganisationUnits = {$: 6};
var $author$project$Page$Settings$UserClickedEntry = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Table$appendRow = F2(
	function (newRow, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				cu: A2($elm$core$List$cons, newRow, config.cu)
			});
	});
var $author$project$Page$Settings$viewAvatar = A2($elm$core$Basics$composeR, $author$project$UI$Icon$unicolor, $author$project$UI$Avatar$icon);
var $author$project$Page$Settings$viewOrganisationUnitsRow = F4(
	function (translations, userRights, viewType, tableConfig) {
		return (A2($author$project$Auth$Authorization$authorizeSetting, userRights, 1) || A2($author$project$Auth$Authorization$authorizeSetting, userRights, 3)) ? A2(
			$author$project$UI$Table$appendRow,
			A2(
				$author$project$UI$Table$Row$withOnClick,
				$author$project$Page$Settings$UserClickedEntry($author$project$Environments$Route$OrganisationUnits),
				A2(
					$author$project$UI$Table$Row$withAvatar,
					$author$project$Page$Settings$viewAvatar($author$project$UI$Icons$factory),
					A3(
						$author$project$UI$Table$Row$row,
						viewType,
						$author$project$Translations$Settings$organisationUnits(translations),
						'OrganisationUnits'))),
			tableConfig) : tableConfig;
	});
var $author$project$Environments$Route$Plans = {$: 7};
var $author$project$Page$Settings$viewPlansRow = F4(
	function (translations, userRights, viewType, tableConfig) {
		return (A2($author$project$Auth$Authorization$authorizeSetting, userRights, 2) || A2($author$project$Auth$Authorization$authorizeSetting, userRights, 3)) ? A2(
			$author$project$UI$Table$appendRow,
			A2(
				$author$project$UI$Table$Row$withOnClick,
				$author$project$Page$Settings$UserClickedEntry($author$project$Environments$Route$Plans),
				A2(
					$author$project$UI$Table$Row$withAvatar,
					$author$project$Page$Settings$viewAvatar($author$project$UI$Icons$plan),
					A3(
						$author$project$UI$Table$Row$row,
						viewType,
						$author$project$Translations$Settings$plans(translations),
						'Plans'))),
			tableConfig) : tableConfig;
	});
var $author$project$Environments$Route$Roles = {$: 15};
var $author$project$Translations$Role$roles = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'role.roles');
};
var $author$project$Page$Settings$viewRolesRow = F4(
	function (translations, userRights, viewType, tableConfig) {
		return (A2($author$project$Auth$Authorization$authorizeSetting, userRights, 0) || A2($author$project$Auth$Authorization$authorizeSetting, userRights, 3)) ? A2(
			$author$project$UI$Table$appendRow,
			A2(
				$author$project$UI$Table$Row$withOnClick,
				$author$project$Page$Settings$UserClickedEntry($author$project$Environments$Route$Roles),
				A2(
					$author$project$UI$Table$Row$withAvatar,
					$author$project$Page$Settings$viewAvatar($author$project$UI$Icons$roles),
					A3(
						$author$project$UI$Table$Row$row,
						viewType,
						$author$project$Translations$Role$roles(translations),
						'Roles'))),
			tableConfig) : tableConfig;
	});
var $author$project$Environments$Route$Teams = {$: 16};
var $author$project$Translations$Team$teams = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.teams');
};
var $author$project$UI$Icons$teams = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M38.852 26.961c-2.128-1.746-4.393-3.019-5.477-3.591v-2.784c.526-.551.82-1.292.82-2.068v-4.077c0-2.679-2.178-4.858-4.858-4.858h-.873c-2.678 0-4.858 2.179-4.858 4.858v4.077c0 .781.296 1.517.821 2.068v2.784c-1.083.572-3.355 1.845-5.476 3.591-.729.605-1.149 1.492-1.149 2.443v6.644h-7.438v-6.125c0-.131.058-.249.151-.329 1.962-1.614 4.091-2.685 4.496-2.882.454-.224.75-.69.75-1.196v-3.203c0-.394-.198-.761-.526-.984-.046-.026-.144-.112-.144-.263v-3.323c0-.998.814-1.811 1.812-1.811h.714c1 0 1.814.813 1.814 1.811v3.323c0 .151-.099.237-.145.263-.545.36-.689 1.096-.328 1.641.361.545 1.096.69 1.641.328.748-.499 1.196-1.333 1.196-2.232v-3.323c0-2.304-1.873-4.175-4.178-4.175h-.714c-2.305 0-4.176 1.871-4.176 4.175v3.323c0 .663.243 1.287.67 1.773v2.048c-.932.486-2.712 1.503-4.379 2.883C8.375 28.301 8 29.089 8 29.929v7.308c0 .649.531 1.18 1.181 1.18h9.804c.65 0 1.181-.531 1.181-1.18v-7.833c0-.243.106-.466.289-.617 2.429-1.996 5.067-3.329 5.573-3.579.466-.228.763-.708.763-1.227v-3.932c0-.395-.198-.762-.526-.985-.183-.126-.294-.329-.294-.546v-4.077c0-1.372 1.114-2.495 2.493-2.495h.88c1.373 0 2.497 1.117 2.497 2.495v4.077c0 .217-.114.428-.298.546-.328.216-.523.59-.523.985v3.932c0 .519.3.999.76 1.227.506.25 3.146 1.576 5.574 3.579.184.151.288.374.288.617v6.644H23.999c-.649 0-1.181.531-1.181 1.181s.532 1.183 1.181 1.183h14.82c.65 0 1.181-.533 1.181-1.183v-7.825c0-.951-.42-1.838-1.148-2.443')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Settings$viewTeamsRow = F4(
	function (translations, userRights, viewType, tableConfig) {
		return (A2($author$project$Auth$Authorization$authorizeSetting, userRights, 0) || A2($author$project$Auth$Authorization$authorizeSetting, userRights, 3)) ? A2(
			$author$project$UI$Table$appendRow,
			A2(
				$author$project$UI$Table$Row$withOnClick,
				$author$project$Page$Settings$UserClickedEntry($author$project$Environments$Route$Teams),
				A2(
					$author$project$UI$Table$Row$withAvatar,
					$author$project$Page$Settings$viewAvatar($author$project$UI$Icons$teams),
					A3(
						$author$project$UI$Table$Row$row,
						viewType,
						$author$project$Translations$Team$teams(translations),
						'Teams'))),
			tableConfig) : tableConfig;
	});
var $author$project$Page$Settings$UserClickedEditTenant = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Avatar$image = function (filename) {
	return $author$project$UI$Avatar$Image(
		{b7: false, P: filename, cm: 0, bJ: $elm$core$Maybe$Nothing, by: _List_Nil});
};
var $author$project$Translations$Settings$tenantData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'settings.tenantData');
};
var $author$project$Page$Settings$viewTenantRow = F5(
	function (translations, repository, userRights, viewType, tableConfig) {
		var _v0 = $author$project$Environments$Repository$getTenant(repository);
		if (_v0.$ === 1) {
			return tableConfig;
		} else {
			var tenant = _v0.a;
			if (A2($author$project$Auth$Authorization$authorizeSetting, userRights, 3)) {
				var avatar_ = function () {
					var _v1 = tenant.jX;
					if (!_v1.$) {
						var filename = _v1.a;
						return $author$project$UI$Avatar$image(filename);
					} else {
						return $author$project$Page$Settings$viewAvatar($author$project$UI$Icons$info);
					}
				}();
				return A2(
					$author$project$UI$Table$appendRow,
					A2(
						$author$project$UI$Table$Row$withOnClick,
						$author$project$Page$Settings$UserClickedEditTenant(tenant),
						A2(
							$author$project$UI$Table$Row$withAvatar,
							avatar_,
							A3(
								$author$project$UI$Table$Row$row,
								viewType,
								$author$project$Translations$Settings$tenantData(translations),
								'Tenant'))),
					tableConfig);
			} else {
				return tableConfig;
			}
		}
	});
var $author$project$Environments$Route$Users = {$: 5};
var $author$project$Page$Settings$viewUsersRow = F4(
	function (translations, userRights, viewType, tableConfig) {
		return (A2($author$project$Auth$Authorization$authorizeSetting, userRights, 0) || A2($author$project$Auth$Authorization$authorizeSetting, userRights, 3)) ? A2(
			$author$project$UI$Table$appendRow,
			A2(
				$author$project$UI$Table$Row$withOnClick,
				$author$project$Page$Settings$UserClickedEntry($author$project$Environments$Route$Users),
				A2(
					$author$project$UI$Table$Row$withAvatar,
					$author$project$Page$Settings$viewAvatar($author$project$UI$Icons$user),
					A3(
						$author$project$UI$Table$Row$row,
						viewType,
						$author$project$Translations$Settings$users(translations),
						'Users'))),
			tableConfig) : tableConfig;
	});
var $author$project$Page$Settings$viewSettingsTable = F2(
	function (environment, repository) {
		var viewType = $author$project$Environments$Environment$getViewType(environment);
		var userRights = $author$project$Environments$Environment$userRights(environment);
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Table$view(
			A5(
				$author$project$Page$Settings$viewTenantRow,
				translations,
				repository,
				userRights,
				viewType,
				A4(
					$author$project$Page$Settings$viewTeamsRow,
					translations,
					userRights,
					viewType,
					A4(
						$author$project$Page$Settings$viewRolesRow,
						translations,
						userRights,
						viewType,
						A4(
							$author$project$Page$Settings$viewPlansRow,
							translations,
							userRights,
							viewType,
							A4(
								$author$project$Page$Settings$viewOrganisationUnitsRow,
								translations,
								userRights,
								viewType,
								A4($author$project$Page$Settings$viewUsersRow, translations, userRights, viewType, $author$project$UI$Table$default)))))));
	});
var $author$project$Page$Settings$view = F3(
	function (environment, repository, _v0) {
		var tenantEditModal = _v0;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				A4(
					$author$project$Page$Settings$viewEditTenant,
					translations,
					$author$project$Environments$Environment$userRights(environment),
					repository,
					tenantEditModal),
				A2(
					$author$project$UI$Page$appendContent,
					A2($author$project$Page$Settings$viewSettingsTable, environment, repository),
					A2(
						$author$project$UI$Page$withIcon,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
						$author$project$UI$Page$page(
							$author$project$Translations$Settings$header(translations))))));
	});
var $author$project$Page$Page$settings = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 4) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotSettingsPageMsg,
		kZ: $elm$core$Maybe$Nothing,
		le: $author$project$Page$Settings$update,
		lm: $author$project$Page$Settings$view
	});
var $author$project$Page$Page$GotTeamPageMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Rights$Team$Page$GotCreateDialogMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Team$Page$createDialog = function (_v0) {
	var page = _v0;
	return page.fi;
};
var $author$project$Rights$Team$CreateDialog$createdCreateCommand = F4(
	function (command, environment, repository, dialog) {
		if (dialog.$ === 2) {
			var _v1 = A3(
				$author$project$Rights$CommandHandler$handleCommands,
				$author$project$Rights$Commands$singleton(command),
				environment,
				$author$project$Environments$Repository$getRights(repository));
			if (_v1.$ === 1) {
				if (_v1.a.$ === 3) {
					var msg = _v1.a.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$rightsErrorToString(
								$author$project$Rights$CommandHandler$TeamAlreadyExists(msg))),
						gH: 'Rights.Team.EditDialog.elm',
						gK: 'createdCommands',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: $author$project$Rights$Team$CreateDialog$Hidden,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				} else {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Team$CreateDialog$Hidden, ac: environment, ae: repository};
				}
			} else {
				var resultData = _v1.a;
				if ($author$project$Rights$Commands$isEmpty(resultData.cD) || $author$project$Rights$Events$isEmpty(resultData.b8)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Team$CreateDialog$Hidden, ac: environment, ae: repository};
				} else {
					var _v3 = A3($author$project$Environments$Repository$saveRightsCommandsAndEvents, resultData.cD, resultData.b8, repository);
					var newRepository = _v3.a;
					var cmd = _v3.b;
					return {ab: cmd, jn: $author$project$Rights$Team$CreateDialog$Hidden, ac: resultData.ac, ae: newRepository};
				}
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$CreateDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Team$CreateDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Rights$Team$CreateDialog$Visible(
						_Utils_update(
							model,
							{
								aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
							})),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$CreateDialog$receivedCollapseOrganisationUnitMsg = F4(
	function (organisationUnitId, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Team$CreateDialog$Visible(
					_Utils_update(
						model,
						{
							ca: A2(
								$elm$core$List$filter,
								function (id) {
									return !_Utils_eq(id, organisationUnitId);
								},
								model.ca)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$CreateDialog$receivedExpandOrganisationUnitMsg = F4(
	function (organisationUnitId, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Team$CreateDialog$Visible(
					_Utils_update(
						model,
						{
							ca: A2($elm$core$List$cons, organisationUnitId, model.ca)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$CreateDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Team$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$CreateDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Team$CreateDialog$Hidden, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$CreateDialog$CreatedCreateCommand = function (a) {
	return {$: 9, a: a};
};
var $author$project$Rights$Team$CreateDialog$HandlingCommand = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Command$createTeam = F2(
	function (environment, model) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$CreateTeam(
						{L: commandId_, M: commandTimestamp, aY: model.aY, kn: model.kn, k1: model.k1, k8: model.k8});
				}));
	});
var $author$project$Rights$Team$Id$from = $elm$core$Basics$identity;
var $author$project$Rights$Team$CreateDialog$createCommand = F2(
	function (environment, model) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Rights$Team$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var teamId = _v0.a;
		var newEnvironment = _v0.b;
		return A2(
			$author$project$Rights$Command$createTeam,
			newEnvironment,
			{
				aY: $author$project$UI$BasicDataEditor$description(model.aQ),
				kn: model.bw,
				k1: teamId,
				k8: $author$project$UI$BasicDataEditor$title(model.aQ)
			});
	});
var $author$project$Rights$Team$CreateDialog$userClickedCreateButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				var title = $author$project$UI$BasicDataEditor$title(model.aQ);
				if ($elm$core$String$isEmpty(title)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				} else {
					var _v1 = A2($author$project$Rights$Team$CreateDialog$createCommand, environment, model);
					var newEnvironment = _v1.a;
					var task = _v1.b;
					return {
						ab: A2($elm$core$Task$perform, $author$project$Rights$Team$CreateDialog$CreatedCreateCommand, task),
						jn: $author$project$Rights$Team$CreateDialog$HandlingCommand(model),
						ac: newEnvironment,
						ae: repository
					};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$CreateDialog$OrganisationUnitsStep = 1;
var $author$project$Rights$Team$CreateDialog$switchStep = F2(
	function (step, model) {
		if (_Utils_eq(model.b0, step)) {
			return model;
		} else {
			var _v0 = model.b0;
			if (!_v0) {
				var title = $author$project$UI$BasicDataEditor$title(model.aQ);
				return $elm$core$String$isEmpty(title) ? model : _Utils_update(
					model,
					{
						aQ: A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ),
						b0: step
					});
			} else {
				return _Utils_update(
					model,
					{b0: step});
			}
		}
	});
var $author$project$Rights$Team$CreateDialog$nextStep = function (model) {
	var _v0 = model.b0;
	if (!_v0) {
		return A2($author$project$Rights$Team$CreateDialog$switchStep, 1, model);
	} else {
		return model;
	}
};
var $author$project$Rights$Team$CreateDialog$userClickedNextButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Rights$Team$CreateDialog$Visible(
						$author$project$Rights$Team$CreateDialog$nextStep(model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$OrganisationUnit$Ids$filter = $turboMaCk$any_set$Set$Any$filter;
var $author$project$OrganisationUnit$Ids$member = $turboMaCk$any_set$Set$Any$member;
var $author$project$OrganisationUnit$Ids$remove = $turboMaCk$any_set$Set$Any$remove;
var $author$project$Rights$Team$CreateDialog$userClickedOrganisationUnit = F4(
	function (organisationUnit, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var hierarchy = $author$project$OrganisationUnit$OrganisationUnits$hierarchy(
				$author$project$Environments$Repository$organisationUnits(repository));
			var parentIsSelected = A2(
				$elm$core$List$member,
				true,
				A2(
					$elm$core$List$map,
					function (organisationUnitId) {
						return A3($author$project$OrganisationUnit$Hierarchy$isAncestorOf, organisationUnitId, organisationUnit.km, hierarchy);
					},
					$author$project$OrganisationUnit$Ids$toList(model.bw)));
			var newSelectedList = parentIsSelected ? model.bw : (A2($author$project$OrganisationUnit$Ids$member, organisationUnit.km, model.bw) ? A2($author$project$OrganisationUnit$Ids$remove, organisationUnit.km, model.bw) : A2(
				$author$project$OrganisationUnit$Ids$filter,
				function (elem) {
					return !A3($author$project$OrganisationUnit$Hierarchy$isAncestorOf, organisationUnit.km, elem, hierarchy);
				},
				A2($author$project$OrganisationUnit$Ids$insert, organisationUnit.km, model.bw)));
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Team$CreateDialog$Visible(
					_Utils_update(
						model,
						{bw: newSelectedList})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$CreateDialog$userClickedStepIcon = F4(
	function (step, environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				var model = dialog.a;
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$Rights$Team$CreateDialog$Visible(
						A2($author$project$Rights$Team$CreateDialog$switchStep, step, model)),
					ac: environment,
					ae: repository
				};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$CreateDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Rights$Team$CreateDialog$userClickedCloseDialog;
		case 1:
			return $author$project$Rights$Team$CreateDialog$userClickedNextButton;
		case 2:
			var step = msg.a;
			return $author$project$Rights$Team$CreateDialog$userClickedStepIcon(step);
		case 3:
			return $author$project$Rights$Team$CreateDialog$userClickedCancelButton;
		case 4:
			return $author$project$Rights$Team$CreateDialog$userClickedCreateButton;
		case 5:
			var editorMsg = msg.a;
			return $author$project$Rights$Team$CreateDialog$gotBasicDataEditorMsg(editorMsg);
		case 6:
			var organisationUnitId = msg.a;
			return $author$project$Rights$Team$CreateDialog$receivedExpandOrganisationUnitMsg(organisationUnitId);
		case 7:
			var organisationUnitId = msg.a;
			return $author$project$Rights$Team$CreateDialog$receivedCollapseOrganisationUnitMsg(organisationUnitId);
		case 8:
			var organisationUnit = msg.a;
			return $author$project$Rights$Team$CreateDialog$userClickedOrganisationUnit(organisationUnit);
		default:
			var command = msg.a;
			return $author$project$Rights$Team$CreateDialog$createdCreateCommand(command);
	}
};
var $author$project$Rights$Team$Page$withCreateDialog = F2(
	function (createDialog_, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{fi: createDialog_});
	});
var $author$project$Rights$Team$Page$gotCreateDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$Rights$Team$CreateDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$Rights$Team$Page$createDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Rights$Team$Page$GotCreateDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$Rights$Team$Page$withCreateDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$Rights$Team$Page$GotEditDialogMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Rights$Team$Page$editDialog = function (_v0) {
	var page = _v0;
	return page.cO;
};
var $author$project$Rights$Team$EditDialog$Deleted = {$: 3};
var $author$project$Rights$Team$EditDialog$createdCommands = F4(
	function (commands, environment, repository, dialog) {
		if (dialog.$ === 2) {
			var _v1 = A3(
				$author$project$Rights$CommandHandler$handleCommands,
				$author$project$Rights$Commands$fromList(commands),
				environment,
				$author$project$Environments$Repository$getRights(repository));
			if (_v1.$ === 1) {
				if (_v1.a.$ === 3) {
					var msg = _v1.a.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$rightsErrorToString(
								$author$project$Rights$CommandHandler$TeamAlreadyExists(msg))),
						gH: 'Rights.Team.EditDialog.elm',
						gK: 'createdCommands',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: $author$project$Rights$Team$EditDialog$Hidden,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				} else {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Team$EditDialog$Deleted, ac: environment, ae: repository};
				}
			} else {
				var resultData = _v1.a;
				if ($author$project$Rights$Commands$isEmpty(resultData.cD) || $author$project$Rights$Events$isEmpty(resultData.b8)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Team$EditDialog$Hidden, ac: environment, ae: repository};
				} else {
					var _v3 = A3($author$project$Environments$Repository$saveRightsCommandsAndEvents, resultData.cD, resultData.b8, repository);
					var newRepository = _v3.a;
					var cmd = _v3.b;
					return {ab: cmd, jn: $author$project$Rights$Team$EditDialog$Hidden, ac: resultData.ac, ae: newRepository};
				}
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$EditDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Team$EditDialog$gotBasicDataEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Team$EditDialog$Visible(
					_Utils_update(
						model,
						{
							aQ: A2($author$project$UI$BasicDataEditor$update, editorMsg, model.aQ)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$EditDialog$receivedCollapseOrganisationUnitMsg = F4(
	function (organisationUnitId, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Team$EditDialog$Visible(
					_Utils_update(
						model,
						{
							ca: A2(
								$elm$core$List$filter,
								function (id) {
									return !_Utils_eq(id, organisationUnitId);
								},
								model.ca)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$EditDialog$receivedExpandOrganisationUnitMsg = F4(
	function (organisationUnitId, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Team$EditDialog$Visible(
					_Utils_update(
						model,
						{
							ca: A2($elm$core$List$cons, organisationUnitId, model.ca)
						})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$EditDialog$CreatedCommands = function (a) {
	return {$: 10, a: a};
};
var $author$project$Rights$Team$EditDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Command$addOrganisationUnits = F2(
	function (environment, model) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$AddOrganisationUnits(
						{L: commandId_, M: commandTimestamp, kn: model.kn, k1: model.k1, l: model.l});
				}));
	});
var $author$project$Rights$Team$EditDialog$withAddOrganisationUnitsCommand = F3(
	function (team, organisationUnitIds, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var organisationUnits = A2($author$project$OrganisationUnit$Ids$diff, organisationUnitIds, team.kn);
		if ($author$project$OrganisationUnit$Ids$isEmpty(organisationUnits)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {kn: organisationUnits, k1: team.k1, l: team.k8};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$Rights$Command$addOrganisationUnits, environment, data));
		}
	});
var $author$project$Rights$Command$changeTeamDescription = F2(
	function (environment, model) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$ChangeTeamDescription(
						{L: commandId_, M: commandTimestamp, aY: model.aY, k1: model.k1, l: model.l});
				}));
	});
var $author$project$Rights$Team$EditDialog$withChangeDescriptionCommand = F3(
	function (team, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		if (_Utils_eq(
			$author$project$UI$BasicDataEditor$description(basicDataEditor),
			team.aY)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {
				aY: $author$project$UI$BasicDataEditor$description(basicDataEditor),
				k1: team.k1,
				l: team.k8
			};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$Rights$Command$changeTeamDescription, environment, data));
		}
	});
var $author$project$Rights$Command$changeTeamTitle = F2(
	function (environment, model) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$ChangeTeamTitle(
						{L: commandId_, M: commandTimestamp, k1: model.k1, k8: model.k8, l: model.l});
				}));
	});
var $author$project$Rights$Team$EditDialog$withChangeTitleCommand = F3(
	function (team, basicDataEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		if ($elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor)) || _Utils_eq(
			$author$project$UI$BasicDataEditor$title(basicDataEditor),
			team.k8)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {
				k1: team.k1,
				k8: $author$project$UI$BasicDataEditor$title(basicDataEditor),
				l: team.k8
			};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$Rights$Command$changeTeamTitle, environment, data));
		}
	});
var $author$project$Rights$Command$removeOrganisationUnits = F2(
	function (environment, model) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$RemoveOrganisationUnits(
						{L: commandId_, M: commandTimestamp, kn: model.kn, k1: model.k1, l: model.l});
				}));
	});
var $author$project$Rights$Team$EditDialog$withRemoveOrganisationUnitsCommand = F3(
	function (team, organisationUnitIds, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var organisationUnits = A2($author$project$OrganisationUnit$Ids$diff, team.kn, organisationUnitIds);
		if ($author$project$OrganisationUnit$Ids$isEmpty(organisationUnits)) {
			return _Utils_Tuple2(environment, tasks);
		} else {
			var data = {kn: organisationUnits, k1: team.k1, l: team.k8};
			return A2(
				$elm$core$Tuple$mapSecond,
				function (task) {
					return A2($elm$core$List$cons, task, tasks);
				},
				A2($author$project$Rights$Command$removeOrganisationUnits, environment, data));
		}
	});
var $author$project$Rights$Team$EditDialog$createCommands = F3(
	function (environment, team, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A3(
				$author$project$Rights$Team$EditDialog$withRemoveOrganisationUnitsCommand,
				team,
				model.bw,
				A3(
					$author$project$Rights$Team$EditDialog$withAddOrganisationUnitsCommand,
					team,
					model.bw,
					A3(
						$author$project$Rights$Team$EditDialog$withChangeDescriptionCommand,
						team,
						model.aQ,
						A3(
							$author$project$Rights$Team$EditDialog$withChangeTitleCommand,
							team,
							model.aQ,
							_Utils_Tuple2(environment, _List_Nil))))));
	});
var $author$project$Rights$Team$EditDialog$userClickedApplyButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var _v1 = A2(
				$author$project$Rights$Rights$getTeam,
				model.eh.k1,
				$author$project$Environments$Repository$getRights(repository));
			if (_v1.$ === 1) {
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Team$EditDialog$Deleted, ac: environment, ae: repository};
			} else {
				var team = _v1.a;
				var _v2 = A3($author$project$Rights$Team$EditDialog$createCommands, environment, team, model);
				var newEnvironment = _v2.a;
				var tasks = _v2.b;
				return {
					ab: A2(
						$elm$core$Task$perform,
						$author$project$Rights$Team$EditDialog$CreatedCommands,
						$elm$core$Task$sequence(tasks)),
					jn: $author$project$Rights$Team$EditDialog$HandlingCommands(model),
					ac: newEnvironment,
					ae: repository
				};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$EditDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Team$EditDialog$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$EditDialog$userClickedCloseButton = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Team$EditDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$EditDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$Rights$Team$EditDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Command$deleteTeam = F3(
	function (environment, teamId, titleForError) {
		return A2(
			$author$project$Rights$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$Rights$Command$DeleteTeam(
						{L: commandId_, M: commandTimestamp, k1: teamId, l: titleForError});
				}));
	});
var $author$project$Rights$Team$EditDialog$userClickedDeleteButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var _v1 = A2(
				$elm$core$Tuple$mapSecond,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$singleton,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Task$sequence,
						$elm$core$Task$perform($author$project$Rights$Team$EditDialog$CreatedCommands))),
				A3($author$project$Rights$Command$deleteTeam, environment, model.eh.k1, model.eh.k8));
			var newEnvironment = _v1.a;
			var cmd = _v1.b;
			return {
				ab: cmd,
				jn: $author$project$Rights$Team$EditDialog$HandlingCommands(model),
				ac: newEnvironment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$EditDialog$userClickedOrganisationUnit = F4(
	function (organisationUnit, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var hierarchy = $author$project$OrganisationUnit$OrganisationUnits$hierarchy(
				$author$project$Environments$Repository$organisationUnits(repository));
			var parentIsSelected = A2(
				$elm$core$List$member,
				true,
				A2(
					$elm$core$List$map,
					function (organisationUnitId) {
						return A3($author$project$OrganisationUnit$Hierarchy$isAncestorOf, organisationUnitId, organisationUnit.km, hierarchy);
					},
					$author$project$OrganisationUnit$Ids$toList(model.bw)));
			var newSelectedList = parentIsSelected ? model.bw : (A2($author$project$OrganisationUnit$Ids$member, organisationUnit.km, model.bw) ? A2($author$project$OrganisationUnit$Ids$remove, organisationUnit.km, model.bw) : A2(
				$author$project$OrganisationUnit$Ids$filter,
				function (elem) {
					return !A3($author$project$OrganisationUnit$Hierarchy$isAncestorOf, organisationUnit.km, elem, hierarchy);
				},
				A2($author$project$OrganisationUnit$Ids$insert, organisationUnit.km, model.bw)));
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Team$EditDialog$Visible(
					_Utils_update(
						model,
						{bw: newSelectedList})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$EditDialog$BasicDataTab = 0;
var $author$project$Rights$Team$EditDialog$switchTab = F2(
	function (tab, model) {
		if (_Utils_eq(model.cI, tab)) {
			return model;
		} else {
			if (!model.cI) {
				var title = $author$project$UI$BasicDataEditor$title(model.aQ);
				return _Utils_update(
					model,
					{
						aQ: A2($author$project$UI$BasicDataEditor$withTitle, title, model.aQ),
						cI: tab
					});
			} else {
				return _Utils_update(
					model,
					{cI: tab});
			}
		}
	});
var $author$project$Rights$Team$EditDialog$userClickedTabIcon = F4(
	function (tab, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$Rights$Team$EditDialog$Visible(
					A2($author$project$Rights$Team$EditDialog$switchTab, tab, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$Rights$Team$EditDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Rights$Team$EditDialog$userClickedCloseDialog;
		case 1:
			var tab = msg.a;
			return $author$project$Rights$Team$EditDialog$userClickedTabIcon(tab);
		case 2:
			return $author$project$Rights$Team$EditDialog$userClickedCancelButton;
		case 3:
			return $author$project$Rights$Team$EditDialog$userClickedApplyButton;
		case 4:
			return $author$project$Rights$Team$EditDialog$userClickedDeleteButton;
		case 5:
			return $author$project$Rights$Team$EditDialog$userClickedCloseButton;
		case 6:
			var editorMsg = msg.a;
			return $author$project$Rights$Team$EditDialog$gotBasicDataEditorMsg(editorMsg);
		case 7:
			var organisationUnitId = msg.a;
			return $author$project$Rights$Team$EditDialog$receivedExpandOrganisationUnitMsg(organisationUnitId);
		case 8:
			var organisationUnitId = msg.a;
			return $author$project$Rights$Team$EditDialog$receivedCollapseOrganisationUnitMsg(organisationUnitId);
		case 9:
			var organisationUnit = msg.a;
			return $author$project$Rights$Team$EditDialog$userClickedOrganisationUnit(organisationUnit);
		default:
			var commands = msg.a;
			return $author$project$Rights$Team$EditDialog$createdCommands(commands);
	}
};
var $author$project$Rights$Team$Page$withEditDialog = F2(
	function (editDialog_, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{cO: editDialog_});
	});
var $author$project$Rights$Team$Page$gotEditDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$Rights$Team$EditDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$Rights$Team$Page$editDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$Rights$Team$Page$GotEditDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$Rights$Team$Page$withEditDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$Rights$Team$CreateDialog$BasicDataStep = 0;
var $author$project$Rights$Team$CreateDialog$show = $author$project$Rights$Team$CreateDialog$Visible(
	{aQ: $author$project$UI$BasicDataEditor$default, b0: 0, ca: _List_Nil, bw: $author$project$OrganisationUnit$Ids$empty});
var $author$project$Rights$Team$Page$userClickedCreateIcon = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2($author$project$Rights$Team$Page$withCreateDialog, $author$project$Rights$Team$CreateDialog$show, page),
			ae: repository
		};
	});
var $author$project$Rights$Team$EditDialog$show = function (team) {
	return $author$project$Rights$Team$EditDialog$Visible(
		{
			aQ: $author$project$UI$BasicDataEditor$from(team),
			cI: 0,
			ca: _List_Nil,
			bw: team.kn,
			eh: team
		});
};
var $author$project$Rights$Team$Page$userClickedEditIcon = F4(
	function (team, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2(
				$author$project$Rights$Team$Page$withEditDialog,
				$author$project$Rights$Team$EditDialog$show(team),
				page),
			ae: repository
		};
	});
var $author$project$Rights$Team$Page$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$Rights$Team$Page$userClickedCreateIcon;
		case 1:
			var dialogMsg = msg.a;
			return $author$project$Rights$Team$Page$gotCreateDialogMsg(dialogMsg);
		case 2:
			var user = msg.a;
			return $author$project$Rights$Team$Page$userClickedEditIcon(user);
		default:
			var dialogMsg = msg.a;
			return $author$project$Rights$Team$Page$gotEditDialogMsg(dialogMsg);
	}
};
var $author$project$Translations$Team$pageHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.pageHeader');
};
var $author$project$Rights$Team$Page$UserClickedCreateIcon = {$: 0};
var $author$project$Rights$Team$Page$viewActionBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withStyle,
			$rtfeldman$elm_css$Css$zIndex(
				$rtfeldman$elm_css$Css$int(1)),
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
					A2(
						$author$project$UI$Bar$withRightIcon,
						A2(
							$author$project$UI$Icon$withOnClick,
							$author$project$Rights$Team$Page$UserClickedCreateIcon,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
						$author$project$UI$Bar$bar(
							$author$project$Translations$Misc$overview(translations)))))));
};
var $author$project$Rights$Team$CreateDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Rights$Team$CreateDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Team$createDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.createDialogHeader');
};
var $author$project$Rights$Team$CreateDialog$UserClickedCancelButton = {$: 3};
var $author$project$Rights$Team$CreateDialog$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Rights$Team$CreateDialog$UserClickedCancelButton,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$Rights$Team$CreateDialog$UserClickedCreateButton = {$: 4};
var $author$project$Rights$Team$CreateDialog$viewCreateButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Rights$Team$CreateDialog$UserClickedCreateButton,
			$author$project$UI$Button$green(
				$author$project$Translations$Buttons$create(translations))));
};
var $author$project$Rights$Team$CreateDialog$UserClickedNextButton = {$: 1};
var $author$project$Rights$Team$CreateDialog$viewNextButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Rights$Team$CreateDialog$UserClickedNextButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$next(translations)))));
	});
var $author$project$Rights$Team$CreateDialog$viewRightButton = F3(
	function (translations, disableBtn, currentStep) {
		if (!currentStep) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
							]))
					]),
				_List_fromArray(
					[
						A2($author$project$Rights$Team$CreateDialog$viewNextButton, translations, disableBtn)
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
							]))
					]),
				_List_fromArray(
					[
						$author$project$Rights$Team$CreateDialog$viewCreateButton(translations)
					]));
		}
	});
var $author$project$Rights$Team$CreateDialog$UserClickedStepIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Team$CreateDialog$viewStepIcon = F4(
	function (icon, step, currentStep, platform) {
		var marginRight_ = function () {
			if (!step) {
				if (!platform.$) {
					return $rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(1));
				} else {
					return $rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(0.2));
				}
			} else {
				return $rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero);
			}
		}();
		var calcRem = function () {
			if (!platform.$) {
				return $rtfeldman$elm_css$Css$rem(2.5);
			} else {
				return $rtfeldman$elm_css$Css$rem(1.3);
			}
		}();
		var _v0 = _Utils_eq(step, currentStep) ? _Utils_Tuple2($author$project$UI$Style$Theme$white, $author$project$UI$Style$Theme$darkGrey) : _Utils_Tuple2($author$project$UI$Style$Theme$darkGrey, $author$project$UI$Style$Theme$lightGrey);
		var foregroundColor_ = _v0.a;
		var backgroundColor_ = _v0.b;
		return $author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$Rights$Team$CreateDialog$UserClickedStepIcon(step),
				A2(
					$author$project$UI$Icon$withStyle,
					marginRight_,
					A2(
						$author$project$UI$Icon$withBackgroundColor,
						backgroundColor_,
						A2(
							$author$project$UI$Icon$withForegroundColor,
							foregroundColor_,
							A2(
								$author$project$UI$Icon$withStyle,
								$rtfeldman$elm_css$Css$height(
									A3(
										$rtfeldman$elm_css$Css$calc,
										calcRem,
										$rtfeldman$elm_css$Css$plus,
										$rtfeldman$elm_css$Css$px(2))),
								A2(
									$author$project$UI$Icon$withStyle,
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									$author$project$UI$Icon$bicolor(icon))))))));
	});
var $author$project$Rights$Team$CreateDialog$viewSteps = F2(
	function (currentStep, platform) {
		var marginLeft_ = function () {
			if (!platform.$) {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(0.6))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
							]),
						marginLeft_))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$top(
									$rtfeldman$elm_css$Css$pct(50)),
									$rtfeldman$elm_css$Css$right(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$left(
									$rtfeldman$elm_css$Css$rem(1)),
									A3(
									$rtfeldman$elm_css$Css$border3,
									$rtfeldman$elm_css$Css$px(1),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
								]))
						]),
					_List_Nil),
					A4($author$project$Rights$Team$CreateDialog$viewStepIcon, $author$project$UI$Icons$tagCircleBicolor, 0, currentStep, platform),
					A4($author$project$Rights$Team$CreateDialog$viewStepIcon, $author$project$UI$Icons$factoryCircleBicolor, 1, currentStep, platform)
				]));
	});
var $author$project$Rights$Team$CreateDialog$viewFooter = F4(
	function (translations, platform, disableBtn, currentStep) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto 1fr'),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Rights$Team$CreateDialog$viewCancelButton(translations),
					A2($author$project$Rights$Team$CreateDialog$viewSteps, currentStep, platform),
					A3($author$project$Rights$Team$CreateDialog$viewRightButton, translations, disableBtn, currentStep)
				]));
	});
var $author$project$Rights$Team$CreateDialog$viewBasicDataStep = F3(
	function (translations, platform, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(32)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$Rights$Team$CreateDialog$viewFooter, translations, platform, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Rights$Team$CreateDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Team$createDialogHeader(translations),
									$author$project$Rights$Team$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$Translations$Team$assignOrganisationUnits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.assignOrganisationUnits');
};
var $author$project$UI$OrganisationStructure$MultiSelect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Team$CreateDialog$ReceivedCollapseOrganisationUnitMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Rights$Team$CreateDialog$ReceivedExpandOrganisationUnitMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Rights$Team$CreateDialog$UserClickedOrganisationUnit = function (a) {
	return {$: 8, a: a};
};
var $author$project$Rights$Team$CreateDialog$viewOrganisationUnitStepContent = F5(
	function (environment, translations, repository, expandedOrganisationUnits, selectedOrganisationUnits) {
		var markSelectedOrganisationUnits = F2(
			function (organisationUnitIds, organisationUnit) {
				var selectedIsAncestorList = A2(
					$elm$core$List$map,
					function (elem) {
						return A3(
							$author$project$OrganisationUnit$Hierarchy$isAncestorOf,
							elem,
							organisationUnit.km,
							$author$project$OrganisationUnit$OrganisationUnits$hierarchy(
								$author$project$Environments$Repository$organisationUnits(repository)));
					},
					organisationUnitIds);
				var contrastColor = $author$project$UI$Style$Color$calculateContrastColor(organisationUnit.K);
				if (A2($elm$core$List$member, organisationUnit.km, organisationUnitIds) || A2($elm$core$List$member, true, selectedIsAncestorList)) {
					var color_ = _Utils_eq(contrastColor, $author$project$UI$Style$Theme$white) ? $author$project$UI$Style$Theme$grey : $author$project$UI$Style$Theme$darkGrey;
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									A3(
									$rtfeldman$elm_css$Css$borderTop3,
									$rtfeldman$elm_css$Css$px(6),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(color_)),
									A3(
									$rtfeldman$elm_css$Css$borderBottom3,
									$rtfeldman$elm_css$Css$px(6),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(color_)),
									A3(
									$rtfeldman$elm_css$Css$borderLeft3,
									$rtfeldman$elm_css$Css$px(6),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(color_)),
									A3(
									$rtfeldman$elm_css$Css$borderRight3,
									$rtfeldman$elm_css$Css$px(6),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(color_))
								]))
						]);
				} else {
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
						]);
				}
			});
		var multiSelectConfig = {
			j0: $elm$core$Maybe$Just(markSelectedOrganisationUnits),
			kP: $author$project$OrganisationUnit$Ids$toList(selectedOrganisationUnits)
		};
		return A2(
			$author$project$UI$OrganisationStructure$view,
			environment,
			{
				iN: $author$project$UI$OrganisationStructure$MultiSelect(multiSelectConfig),
				iY: $elm$core$Maybe$Just($author$project$Rights$Team$CreateDialog$UserClickedOrganisationUnit),
				i9: $author$project$Rights$Team$CreateDialog$ReceivedCollapseOrganisationUnitMsg,
				jg: $author$project$UI$OrganisationStructure$NoContent,
				jx: $author$project$Rights$Team$CreateDialog$ReceivedExpandOrganisationUnitMsg,
				jy: expandedOrganisationUnits,
				jV: $elm$core$Maybe$Nothing,
				kn: $author$project$Environments$Repository$organisationUnits(repository),
				kC: _List_Nil,
				kD: _List_Nil,
				kE: $elm$core$Maybe$Nothing,
				kS: true
			});
	});
var $author$project$Rights$Team$CreateDialog$viewRightsHeaderLabel = function (label) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, 'justify-self', 'start'),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(0.5))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(label)
			]));
};
var $author$project$Rights$Team$CreateDialog$viewOrganisationUnitsStep = F6(
	function (environment, translations, platform, repository, expandedOrganisationUnits, selectedOrganisationUnits) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(32)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A4($author$project$Rights$Team$CreateDialog$viewFooter, translations, platform, false, 1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A5($author$project$Rights$Team$CreateDialog$viewOrganisationUnitStepContent, environment, translations, repository, expandedOrganisationUnits, selectedOrganisationUnits),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Rights$Team$CreateDialog$viewRightsHeaderLabel(
								$author$project$Translations$Team$assignOrganisationUnits(translations)),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$factory),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Team$createDialogHeader(translations),
									$author$project$Rights$Team$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$Rights$Team$CreateDialog$viewDialog = F3(
	function (environment, repository, model) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var platform = $author$project$Environments$Environment$platform(environment);
		var _v0 = model.b0;
		if (!_v0) {
			return A3($author$project$Rights$Team$CreateDialog$viewBasicDataStep, translations, platform, model.aQ);
		} else {
			return A6($author$project$Rights$Team$CreateDialog$viewOrganisationUnitsStep, environment, translations, platform, repository, model.ca, model.bw);
		}
	});
var $author$project$Rights$Team$CreateDialog$view = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Rights$Team$CreateDialog$viewDialog, environment, repository, model);
			default:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Rights$Team$CreateDialog$viewDialog, environment, repository, model);
		}
	});
var $author$project$Rights$Team$Page$viewCreateDialog = F2(
	function (environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Rights$Team$CreateDialog$view, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Rights$Team$Page$GotCreateDialogMsg));
	});
var $author$project$Rights$Team$EditDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Team$deletedHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.deletedHeader');
};
var $author$project$Translations$Team$deletedText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.deletedText');
};
var $author$project$Rights$Team$EditDialog$viewDeleted = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Team$deletedText(translations))
			]));
};
var $author$project$Rights$Team$EditDialog$UserClickedCloseButton = {$: 5};
var $author$project$Rights$Team$EditDialog$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Rights$Team$EditDialog$UserClickedCloseButton,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$Rights$Team$EditDialog$viewDeletedFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Rights$Team$EditDialog$viewCloseButton(translations)
			]));
};
var $author$project$Rights$Team$EditDialog$viewDeletedDialog = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return $author$project$UI$Dialog$view(
		A2(
			$author$project$UI$Dialog$appendFooter,
			$author$project$Rights$Team$EditDialog$viewDeletedFooter(translations),
			A2(
				$author$project$UI$Dialog$appendContent,
				$author$project$Rights$Team$EditDialog$viewDeleted(translations),
				A2(
					$author$project$UI$Dialog$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
					A2(
						$author$project$UI$Dialog$dialog,
						$author$project$Translations$Team$deletedHeader(translations),
						$author$project$Rights$Team$EditDialog$UserClickedCloseDialog)))));
};
var $author$project$Rights$Team$EditDialog$GotBasicDataEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Translations$Team$editDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.editDialogHeader');
};
var $author$project$Rights$Team$EditDialog$DeleteTab = 2;
var $author$project$Rights$Team$EditDialog$UserClickedApplyButton = {$: 3};
var $author$project$Rights$Team$EditDialog$viewApplyButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Rights$Team$EditDialog$UserClickedApplyButton,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$apply(translations)))));
	});
var $author$project$Rights$Team$EditDialog$UserClickedCancelButton = {$: 2};
var $author$project$Rights$Team$EditDialog$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Rights$Team$EditDialog$UserClickedCancelButton,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$Rights$Team$EditDialog$UserClickedDeleteButton = {$: 4};
var $author$project$Rights$Team$EditDialog$viewDeleteButton = F2(
	function (translations, disableBtn) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disableBtn,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Rights$Team$EditDialog$UserClickedDeleteButton,
					$author$project$UI$Button$darkRed(
						$author$project$Translations$Buttons$delete(translations)))));
	});
var $author$project$Rights$Team$EditDialog$viewFooter = F3(
	function (translations, disableBtn, tab) {
		var rightButton = (tab === 2) ? A2($author$project$Rights$Team$EditDialog$viewDeleteButton, translations, disableBtn) : A2($author$project$Rights$Team$EditDialog$viewApplyButton, translations, disableBtn);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Rights$Team$EditDialog$viewCancelButton(translations),
					rightButton
				]));
	});
var $author$project$Rights$Team$EditDialog$OrganisationUnitsTab = 1;
var $author$project$Rights$Team$EditDialog$UserClickedTabIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Rights$Team$EditDialog$viewTabBarIcon = F3(
	function (icon, tab, currentTab) {
		return _Utils_eq(tab, currentTab) ? A2(
			$author$project$UI$Icon$withForegroundColor,
			$author$project$UI$Style$Theme$darkGrey,
			$author$project$UI$Icon$unicolor(icon)) : A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$Rights$Team$EditDialog$UserClickedTabIcon(tab),
			A2(
				$author$project$UI$Icon$withForegroundColor,
				$author$project$UI$Style$Theme$grey,
				$author$project$UI$Icon$unicolor(icon)));
	});
var $author$project$Rights$Team$EditDialog$viewTabBar = F2(
	function (basicDataEditor, currentTab) {
		return $author$project$UI$TabBar$view(
			A2(
				$author$project$UI$TabBar$appendRightIcon,
				A3($author$project$Rights$Team$EditDialog$viewTabBarIcon, $author$project$UI$Icons$delete, 2, currentTab),
				A2(
					$author$project$UI$TabBar$appendRightIcon,
					A3($author$project$Rights$Team$EditDialog$viewTabBarIcon, $author$project$UI$Icons$factory, 1, currentTab),
					A2(
						$author$project$UI$TabBar$appendRightIcon,
						A3($author$project$Rights$Team$EditDialog$viewTabBarIcon, $author$project$UI$Icons$tag, 0, currentTab),
						A2(
							$author$project$UI$TabBar$withSubTitle,
							$author$project$UI$BasicDataEditor$description(basicDataEditor),
							$author$project$UI$TabBar$tabBar(
								$author$project$UI$BasicDataEditor$title(basicDataEditor)))))));
	});
var $author$project$Rights$Team$EditDialog$viewBasicDataTab = F2(
	function (translations, basicDataEditor) {
		var disableBtn = $elm$core$String$isEmpty(
			$author$project$UI$BasicDataEditor$title(basicDataEditor));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(36)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Rights$Team$EditDialog$viewFooter, translations, disableBtn, 0),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Rights$Team$EditDialog$GotBasicDataEditorMsg,
							A2($author$project$UI$BasicDataEditor$viewForm, translations, basicDataEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$UI$BasicDataEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$Rights$Team$EditDialog$viewTabBar, basicDataEditor, 0),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Team$editDialogHeader(translations),
										$author$project$Rights$Team$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$User$TeamRoles$filter = $turboMaCk$any_set$Set$Any$filter;
var $author$project$Translations$Team$cantDelete = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.cantDelete');
};
var $author$project$Rights$Team$EditDialog$viewCantDelete = F2(
	function (translations, show_) {
		return show_ ? A2(
			$rtfeldman$elm_css$Html$Styled$h4,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$Team$cantDelete(translations))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Translations$Team$deleteHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.deleteHeader');
};
var $author$project$Rights$Team$EditDialog$viewDeleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Team$deleteHeader(translations))));
};
var $author$project$Rights$Team$EditDialog$viewDeleteTitle = function (team) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$paddingLeft(
						$rtfeldman$elm_css$Css$rem(1.5))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1.2)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(team.k8)
					]))
			]));
};
var $author$project$Rights$Team$EditDialog$viewDeleteDetails = function (team) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$author$project$Rights$Team$EditDialog$viewDeleteTitle(team)
			]));
};
var $author$project$Translations$Team$deleteText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.deleteText');
};
var $author$project$Rights$Team$EditDialog$viewDeleteQuestion = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Team$deleteText(translations))
			]));
};
var $author$project$Rights$Team$EditDialog$viewDeleteTab = F5(
	function (translations, environment, repository, basicDataEditor, team) {
		var rights = $author$project$Environments$Repository$getRights(repository);
		var maybeUser = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				function (userId) {
					return A2($author$project$Environments$Repository$getUser, userId, repository);
				},
				$author$project$Auth$Session$maybeUserId(
					$author$project$Environments$Environment$session(environment))));
		var disableBtn = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (user) {
					return $author$project$Auth$RightSet$isEmpty(
						A2(
							$author$project$Auth$RightSet$filter,
							function (right) {
								return (!right) || (right === 3);
							},
							A3(
								$elm$core$List$foldl,
								$author$project$Auth$Authorization$unifyRightSet,
								$author$project$Auth$RightSet$empty,
								A3(
									$elm$core$List$foldl,
									$author$project$Auth$Authorization$assembleData(rights),
									_Utils_Tuple2(_List_Nil, _List_Nil),
									$author$project$User$TeamRoles$toList(
										A2(
											$author$project$User$TeamRoles$filter,
											function (teamRole) {
												return !_Utils_eq(teamRole.k1, team.k1);
											},
											user.k2))).b)));
				},
				maybeUser));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(36)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Rights$Team$EditDialog$viewFooter, translations, disableBtn, 2),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2($author$project$Rights$Team$EditDialog$viewCantDelete, translations, disableBtn),
						A2(
							$author$project$UI$Dialog$appendContent,
							$author$project$Rights$Team$EditDialog$viewDeleteDetails(team),
							A2(
								$author$project$UI$Dialog$appendContent,
								$author$project$Rights$Team$EditDialog$viewDeleteQuestion(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									$author$project$Rights$Team$EditDialog$viewDeleteBar(translations),
									A2(
										$author$project$UI$Dialog$appendHeader,
										A2($author$project$Rights$Team$EditDialog$viewTabBar, basicDataEditor, 2),
										A2(
											$author$project$UI$Dialog$withIcon,
											$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
											A2(
												$author$project$UI$Dialog$dialog,
												$author$project$Translations$Team$editDialogHeader(translations),
												$author$project$Rights$Team$EditDialog$UserClickedCloseDialog))))))))));
	});
var $author$project$Rights$Team$EditDialog$ReceivedCollapseOrganisationUnitMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Rights$Team$EditDialog$ReceivedExpandOrganisationUnitMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Rights$Team$EditDialog$UserClickedOrganisationUnit = function (a) {
	return {$: 9, a: a};
};
var $author$project$Rights$Team$EditDialog$viewOrganisationUnitStepContent = F5(
	function (environment, translations, repository, expandedOrganisationUnits, selectedOrganisationUnits) {
		var markSelectedOrganisationUnits = F2(
			function (organisationUnitIds, organisationUnit) {
				var selectedIsAncestorList = A2(
					$elm$core$List$map,
					function (elem) {
						return A3(
							$author$project$OrganisationUnit$Hierarchy$isAncestorOf,
							elem,
							organisationUnit.km,
							$author$project$OrganisationUnit$OrganisationUnits$hierarchy(
								$author$project$Environments$Repository$organisationUnits(repository)));
					},
					organisationUnitIds);
				var contrastColor = $author$project$UI$Style$Color$calculateContrastColor(organisationUnit.K);
				if (A2($elm$core$List$member, organisationUnit.km, organisationUnitIds) || A2($elm$core$List$member, true, selectedIsAncestorList)) {
					var color_ = _Utils_eq(contrastColor, $author$project$UI$Style$Theme$white) ? $author$project$UI$Style$Theme$grey : $author$project$UI$Style$Theme$darkGrey;
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									A3(
									$rtfeldman$elm_css$Css$borderTop3,
									$rtfeldman$elm_css$Css$px(6),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(color_)),
									A3(
									$rtfeldman$elm_css$Css$borderBottom3,
									$rtfeldman$elm_css$Css$px(6),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(color_)),
									A3(
									$rtfeldman$elm_css$Css$borderLeft3,
									$rtfeldman$elm_css$Css$px(6),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(color_)),
									A3(
									$rtfeldman$elm_css$Css$borderRight3,
									$rtfeldman$elm_css$Css$px(6),
									$rtfeldman$elm_css$Css$solid,
									$author$project$UI$Style$Color$toCssColor(color_))
								]))
						]);
				} else {
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
						]);
				}
			});
		var multiSelectConfig = {
			j0: $elm$core$Maybe$Just(markSelectedOrganisationUnits),
			kP: $author$project$OrganisationUnit$Ids$toList(selectedOrganisationUnits)
		};
		return A2(
			$author$project$UI$OrganisationStructure$view,
			environment,
			{
				iN: $author$project$UI$OrganisationStructure$MultiSelect(multiSelectConfig),
				iY: $elm$core$Maybe$Just($author$project$Rights$Team$EditDialog$UserClickedOrganisationUnit),
				i9: $author$project$Rights$Team$EditDialog$ReceivedCollapseOrganisationUnitMsg,
				jg: $author$project$UI$OrganisationStructure$NoContent,
				jx: $author$project$Rights$Team$EditDialog$ReceivedExpandOrganisationUnitMsg,
				jy: expandedOrganisationUnits,
				jV: $elm$core$Maybe$Nothing,
				kn: $author$project$Environments$Repository$organisationUnits(repository),
				kC: _List_Nil,
				kD: _List_Nil,
				kE: $elm$core$Maybe$Nothing,
				kS: true
			});
	});
var $author$project$Rights$Team$EditDialog$viewRightsHeaderLabel = function (label) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, 'justify-self', 'start'),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(0.5))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(label)
			]));
};
var $author$project$Rights$Team$EditDialog$viewOrganisationUnitsTab = F6(
	function (environment, translations, repository, basicDataEditor, expandedOrganisationUnits, selectedOrganisationUnits) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(32)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(80))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$Rights$Team$EditDialog$viewFooter, translations, false, 1),
					A2(
						$author$project$UI$Dialog$appendContent,
						A5($author$project$Rights$Team$EditDialog$viewOrganisationUnitStepContent, environment, translations, repository, expandedOrganisationUnits, selectedOrganisationUnits),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$Rights$Team$EditDialog$viewRightsHeaderLabel(
								$author$project$Translations$Team$assignOrganisationUnits(translations)),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$Rights$Team$EditDialog$viewTabBar, basicDataEditor, 1),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$factory),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Team$editDialogHeader(translations),
										$author$project$Rights$Team$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$Rights$Team$EditDialog$viewTab = F4(
	function (environment, model, repository, team) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var _v0 = model.cI;
		switch (_v0) {
			case 0:
				return A2($author$project$Rights$Team$EditDialog$viewBasicDataTab, translations, model.aQ);
			case 1:
				return A6($author$project$Rights$Team$EditDialog$viewOrganisationUnitsTab, environment, translations, repository, model.aQ, model.ca, model.bw);
			default:
				return A5($author$project$Rights$Team$EditDialog$viewDeleteTab, translations, environment, repository, model.aQ, team);
		}
	});
var $author$project$Rights$Team$EditDialog$viewDialog = F3(
	function (environment, repository, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Rights$Team$EditDialog$viewDeletedDialog(environment),
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Rights$Team$EditDialog$viewTab, environment, model, repository),
				A2(
					$author$project$Rights$Rights$getTeam,
					model.eh.k1,
					$author$project$Environments$Repository$getRights(repository))));
	});
var $author$project$Rights$Team$EditDialog$view = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Rights$Team$EditDialog$viewDialog, environment, repository, model);
			case 2:
				var model = dialog.a;
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Rights$Team$EditDialog$viewDialog, environment, repository, model);
			default:
				return A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Rights$Team$EditDialog$viewDeletedDialog, environment);
		}
	});
var $author$project$Rights$Team$Page$viewEditDialog = F2(
	function (environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Rights$Team$EditDialog$view, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Rights$Team$Page$GotEditDialogMsg));
	});
var $author$project$Translations$Team$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'team.emptyText');
};
var $author$project$Rights$Rights$getTeams = A2(
	$elm$core$Basics$composeR,
	$author$project$Rights$Rights$unwrap,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.dg;
		},
		$author$project$Rights$Team$Dict$values));
var $author$project$Rights$Team$Page$UserClickedEditIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rights$Team$Page$viewEditIcon = $author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle);
var $author$project$Rights$Team$Page$viewRow = F2(
	function (viewType, team) {
		return A2(
			$author$project$UI$Table$Row$withOnClick,
			$author$project$Rights$Team$Page$UserClickedEditIcon(team),
			A2(
				$author$project$UI$Table$Row$withRightIcon,
				$author$project$Rights$Team$Page$viewEditIcon,
				A3($author$project$UI$Table$Row$row, viewType, team.k8, team)));
	});
var $author$project$Rights$Team$Page$viewTable = F2(
	function (translations, viewType) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Environments$Repository$getRights,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Rights$Rights$getTeams,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$sortBy(
						function (t) {
							return $elm$core$String$toLower(t.k8);
						}),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Table$fromList(
							$author$project$Rights$Team$Page$viewRow(viewType)),
						A2(
							$elm$core$Basics$composeR,
							$author$project$UI$Table$withEmptyText(
								$author$project$Translations$Team$emptyText(translations)),
							$author$project$UI$Table$view)))));
	});
var $author$project$Rights$Team$Page$view = F3(
	function (environment, repository, _v0) {
		var page = _v0;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				A3($author$project$Rights$Team$Page$viewEditDialog, environment, repository, page.cO),
				A2(
					$author$project$UI$Page$appendContent,
					A3($author$project$Rights$Team$Page$viewCreateDialog, environment, repository, page.fi),
					A2(
						$author$project$UI$Page$appendContent,
						A4(
							$rtfeldman$elm_css$Html$Styled$Lazy$lazy3,
							$author$project$Rights$Team$Page$viewTable,
							translations,
							$author$project$Environments$Environment$getViewType(environment),
							repository),
						A2(
							$author$project$UI$Page$appendContent,
							A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Rights$Team$Page$viewActionBar, translations),
							A2(
								$author$project$UI$Page$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$teams),
								$author$project$UI$Page$page(
									$author$project$Translations$Team$pageHeader(translations))))))));
	});
var $author$project$Page$Page$teams = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 16) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotTeamPageMsg,
		kZ: $elm$core$Maybe$Nothing,
		le: $author$project$Rights$Team$Page$update,
		lm: $author$project$Rights$Team$Page$view
	});
var $author$project$Page$Page$GotUserPageMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$User$Page$GotCreateDialogMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$Page$GotEditDialogMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$CreateDialog$GotProfileEditorMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$ProfileEditor$GotAvatarEditorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$User$ProfileEditor$subscriptions = function (_v0) {
	return A2($elm$core$Platform$Sub$map, $author$project$User$ProfileEditor$GotAvatarEditorMsg, $author$project$UI$ImageEditor$subscriptions);
};
var $author$project$User$CreateDialog$subscriptions = function (dialog) {
	switch (dialog.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			var model = dialog.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$User$CreateDialog$GotProfileEditorMsg,
				$author$project$User$ProfileEditor$subscriptions(model.aM));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$User$EditDialog$GotProfileEditorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$User$EditDialog$subscriptions = function (dialog) {
	switch (dialog.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			var model = dialog.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$User$EditDialog$GotProfileEditorMsg,
				$author$project$User$ProfileEditor$subscriptions(model.aM));
		case 2:
			return $elm$core$Platform$Sub$none;
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$User$Page$subscriptions = function (_v0) {
	var page = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$User$Page$GotCreateDialogMsg,
				$author$project$User$CreateDialog$subscriptions(page.fi)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$User$Page$GotEditDialogMsg,
				$author$project$User$EditDialog$subscriptions(page.cO))
			]));
};
var $author$project$User$Page$withUserLimitationModalState = F2(
	function (userLimitationModalState_, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{ho: userLimitationModalState_});
	});
var $author$project$User$Page$closeUserLimitationsModel = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2($author$project$User$Page$withUserLimitationModalState, $author$project$User$Page$Hidden, page),
			ae: repository
		};
	});
var $author$project$User$Page$createDialog = function (_v0) {
	var page = _v0;
	return page.fi;
};
var $author$project$User$User$DoesNotExist = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$User$applyEvents = F2(
	function (events, acc) {
		return A3($author$project$User$Events$fold, $author$project$User$User$applyEventHelper, acc, events);
	});
var $author$project$User$Commands$enqueue = $author$project$Types$Queue$enqueue;
var $author$project$User$TeamRoles$member = $turboMaCk$any_set$Set$Any$member;
var $author$project$User$User$handleAddTeamRoleCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$User$User$userFromModification(acc.au);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$User$User$DoesNotExist(payload.dk));
		} else {
			var user = _v0.a;
			if (A2($author$project$User$TeamRoles$member, payload.bQ, user.k2)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$User$Event$TeamRoleAdded(
					{L: payload.L, M: payload.M, N: eventId, bQ: payload.bQ, dk: payload.dk, n: user.i + 1});
				var _v2 = A2(
					$author$project$User$User$applyEvents,
					$author$project$User$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$User$Commands$enqueue,
							$author$project$User$Command$AddTeamRole(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$User$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		}
	});
var $author$project$User$User$handleChangeAvatarCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$User$User$userFromModification(acc.au);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$User$User$DoesNotExist(payload.dk));
		} else {
			var user = _v0.a;
			if (_Utils_eq(user.iX, payload.iX)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$User$Event$AvatarChanged(
					{iX: payload.iX, L: payload.L, M: payload.M, N: eventId, dk: payload.dk, n: user.i + 1});
				var _v2 = A2(
					$author$project$User$User$applyEvents,
					$author$project$User$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$User$Commands$enqueue,
							$author$project$User$Command$ChangeAvatar(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$User$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		}
	});
var $author$project$User$User$handleChangeEmailAddressCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$User$User$userFromModification(acc.au);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$User$User$DoesNotExist(payload.dk));
		} else {
			var user = _v0.a;
			if (_Utils_eq(
				user.ju,
				$elm$core$Maybe$Just(payload.ju))) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$User$Event$EmailAddressChanged(
					{L: payload.L, M: payload.M, ju: payload.ju, N: eventId, dk: user.dk, n: user.i + 1});
				var _v2 = A2(
					$author$project$User$User$applyEvents,
					$author$project$User$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$User$Commands$enqueue,
							$author$project$User$Command$ChangeEmailAddress(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$User$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		}
	});
var $author$project$User$User$handleChangeEntryOrganisationUnitCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$User$User$userFromModification(acc.au);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$User$User$DoesNotExist(payload.dk));
		} else {
			var user = _v0.a;
			if (_Utils_eq(user.hT, payload.hT)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$User$Event$EntryOrganisationUnitChanged(
					{L: payload.L, M: payload.M, hT: payload.hT, N: eventId, dk: payload.dk, n: user.i + 1});
				var _v2 = A2(
					$author$project$User$User$applyEvents,
					$author$project$User$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$User$Commands$enqueue,
							$author$project$User$Command$ChangeEntryOrganisationUnit(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$User$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		}
	});
var $author$project$User$User$handleChangePasswordCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$User$User$userFromModification(acc.au);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$User$User$DoesNotExist(payload.dk));
		} else {
			var user = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$User$Event$PasswordChanged(
				{L: payload.L, M: payload.M, N: eventId, dk: payload.dk, n: user.i + 1});
			var _v2 = A2(
				$author$project$User$User$applyEvents,
				$author$project$User$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.au;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newModification = _v2.a;
			var newFileOperations = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$User$Commands$enqueue,
						$author$project$User$Command$ChangePassword(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$User$Events$enqueue, event, acc.b8),
					cb: newFileOperations,
					au: newModification
				});
		}
	});
var $author$project$User$User$handleChangeTeamRoleCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$User$User$userFromModification(acc.au);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$User$User$DoesNotExist(payload.dk));
		} else {
			var user = _v0.a;
			if (!A2($author$project$User$TeamRoles$member, payload.bQ, user.k2)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$User$Event$TeamRoleChanged(
					{L: payload.L, M: payload.M, N: eventId, bQ: payload.bQ, dk: payload.dk, n: user.i + 1});
				var _v2 = A2(
					$author$project$User$User$applyEvents,
					$author$project$User$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$User$Commands$enqueue,
							$author$project$User$Command$ChangeTeamRole(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$User$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		}
	});
var $author$project$User$User$AlreadyExists = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$User$handleCreateCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$User$User$userFromModification(acc.au);
		if (_v0.$ === 1) {
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$User$Event$Created(
				{iX: payload.iX, L: payload.L, M: payload.M, ju: payload.ju, hT: payload.hT, N: eventId, g_: payload.g_, k2: payload.k2, dk: payload.dk, iK: payload.iK, n: 0});
			var _v2 = A2(
				$author$project$User$User$applyEvents,
				$author$project$User$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.au;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newModification = _v2.a;
			var newFileOperations = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$User$Commands$enqueue,
						$author$project$User$Command$Create(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$User$Events$enqueue, event, acc.b8),
					cb: newFileOperations,
					au: newModification
				});
		} else {
			var user = _v0.a;
			return $elm$core$Result$Err(
				$author$project$User$User$AlreadyExists(user.dk));
		}
	});
var $author$project$User$User$handleDeleteCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$User$User$userFromModification(acc.au);
		if (_v0.$ === 1) {
			return $elm$core$Result$Ok(acc);
		} else {
			var user = _v0.a;
			var _v1 = A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Types$EventId$from,
				$author$project$Environments$Environment$generateUuid(acc.ac));
			var eventId = _v1.a;
			var newEnvironment = _v1.b;
			var event = $author$project$User$Event$Deleted(
				{L: payload.L, M: payload.M, N: eventId, dk: payload.dk, iK: payload.iK, n: user.i + 1});
			var _v2 = A2(
				$author$project$User$User$applyEvents,
				$author$project$User$Events$singleton(event),
				A3(
					$author$project$Utils$Tuple$with,
					function ($) {
						return $.au;
					},
					function ($) {
						return $.cb;
					},
					acc));
			var newModification = _v2.a;
			var newFileOperations = _v2.b;
			return $elm$core$Result$Ok(
				{
					cD: A2(
						$author$project$User$Commands$enqueue,
						$author$project$User$Command$Delete(payload),
						acc.cD),
					ac: newEnvironment,
					b8: A2($author$project$User$Events$enqueue, event, acc.b8),
					cb: newFileOperations,
					au: newModification
				});
		}
	});
var $author$project$User$User$handleRemoveTeamRoleCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$User$User$userFromModification(acc.au);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$User$User$DoesNotExist(payload.dk));
		} else {
			var user = _v0.a;
			if (!A2($author$project$User$TeamRoles$member, payload.bQ, user.k2)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$User$Event$TeamRoleRemoved(
					{L: payload.L, M: payload.M, N: eventId, bQ: payload.bQ, dk: payload.dk, n: user.i + 1});
				var _v2 = A2(
					$author$project$User$User$applyEvents,
					$author$project$User$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$User$Commands$enqueue,
							$author$project$User$Command$RemoveTeamRole(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$User$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		}
	});
var $author$project$User$User$handleRenameCommand = F2(
	function (payload, acc) {
		var _v0 = $author$project$User$User$userFromModification(acc.au);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				$author$project$User$User$DoesNotExist(payload.dk));
		} else {
			var user = _v0.a;
			if (_Utils_eq(user.g_, payload.g_)) {
				return $elm$core$Result$Ok(acc);
			} else {
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Types$EventId$from,
					$author$project$Environments$Environment$generateUuid(acc.ac));
				var eventId = _v1.a;
				var newEnvironment = _v1.b;
				var event = $author$project$User$Event$Renamed(
					{L: payload.L, M: payload.M, N: eventId, g_: payload.g_, dk: payload.dk, n: user.i + 1});
				var _v2 = A2(
					$author$project$User$User$applyEvents,
					$author$project$User$Events$singleton(event),
					A3(
						$author$project$Utils$Tuple$with,
						function ($) {
							return $.au;
						},
						function ($) {
							return $.cb;
						},
						acc));
				var newModification = _v2.a;
				var newFileOperations = _v2.b;
				return $elm$core$Result$Ok(
					{
						cD: A2(
							$author$project$User$Commands$enqueue,
							$author$project$User$Command$Rename(payload),
							acc.cD),
						ac: newEnvironment,
						b8: A2($author$project$User$Events$enqueue, event, acc.b8),
						cb: newFileOperations,
						au: newModification
					});
			}
		}
	});
var $author$project$User$User$handleCommandHelper = function (command) {
	switch (command.$) {
		case 0:
			var payload = command.a;
			return $author$project$User$User$handleCreateCommand(payload);
		case 1:
			var payload = command.a;
			return $author$project$User$User$handleChangeEmailAddressCommand(payload);
		case 2:
			var payload = command.a;
			return $author$project$User$User$handleChangePasswordCommand(payload);
		case 3:
			var payload = command.a;
			return $author$project$User$User$handleRenameCommand(payload);
		case 4:
			var payload = command.a;
			return $author$project$User$User$handleAddTeamRoleCommand(payload);
		case 5:
			var payload = command.a;
			return $author$project$User$User$handleChangeTeamRoleCommand(payload);
		case 6:
			var payload = command.a;
			return $author$project$User$User$handleRemoveTeamRoleCommand(payload);
		case 7:
			var payload = command.a;
			return $author$project$User$User$handleChangeAvatarCommand(payload);
		case 8:
			var payload = command.a;
			return $author$project$User$User$handleChangeEntryOrganisationUnitCommand(payload);
		default:
			var payload = command.a;
			return $author$project$User$User$handleDeleteCommand(payload);
	}
};
var $author$project$User$User$handleCommand = F3(
	function (command, environment, maybeUser) {
		var acc = {
			cD: $author$project$User$Commands$empty,
			ac: environment,
			b8: $author$project$User$Events$empty,
			cb: $author$project$File$Operations$empty,
			au: $author$project$User$User$NotModified(maybeUser)
		};
		return A2(
			$elm$core$Result$map,
			A3(
				$author$project$Utils$Triple$with,
				function ($) {
					return $.b8;
				},
				function ($) {
					return $.cb;
				},
				function ($) {
					return $.ac;
				}),
			A2($author$project$User$User$handleCommandHelper, command, acc));
	});
var $author$project$User$Store$SaveCommandsAndEvents = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$User$Commands$merge = $author$project$Types$Queue$merge;
var $author$project$User$Events$merge = $author$project$Types$Queue$merge;
var $author$project$User$Store$saveCommandsAndEvents = F3(
	function (commands_, events_, state) {
		switch (state.$) {
			case 0:
				return $elm$core$Result$Err(0);
			case 1:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$User$Store$Saving(
							{
								cD: A2($author$project$User$Commands$merge, data.cD, commands_),
								b8: A2($author$project$User$Events$merge, data.b8, events_),
								lk: $author$project$User$Users$empty
							}),
						$author$project$User$Store$send(
							A2($author$project$User$Store$SaveCommandsAndEvents, commands_, events_))));
			case 2:
				var data = state.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						$author$project$User$Store$Saving(
							_Utils_update(
								data,
								{
									cD: A2($author$project$User$Commands$merge, data.cD, commands_),
									b8: A2($author$project$User$Events$merge, data.b8, events_)
								})),
						$author$project$User$Store$send(
							A2($author$project$User$Store$SaveCommandsAndEvents, commands_, events_))));
			default:
				return $elm$core$Result$Err(0);
		}
	});
var $author$project$Environments$Repository$saveUserCommandsAndEventsAndFileOperations = F4(
	function (commands, events, fileOperations, repository) {
		var _v0 = A3(
			$author$project$User$Store$saveCommandsAndEvents,
			commands,
			events,
			$author$project$Environments$Repository$userStore(repository));
		if (!_v0.$) {
			var _v1 = _v0.a;
			var newUserStore = _v1.a;
			var userStoreCmd = _v1.b;
			var _v2 = A2(
				$author$project$File$Store$saveLocalOperations,
				fileOperations,
				$author$project$Environments$Repository$fileStore(repository));
			var newFileStore = _v2.a;
			var fileStoreCmd = _v2.b;
			return _Utils_Tuple2(
				A2(
					$author$project$Environments$Repository$withFileStore,
					newFileStore,
					A2($author$project$Environments$Repository$withUserStore, newUserStore, repository)),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[userStoreCmd, fileStoreCmd])));
		} else {
			return _Utils_Tuple2(repository, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$User$Commands$singleton = $author$project$Types$Queue$singleton;
var $author$project$Environments$Repository$saveUserCommandAndEventsAndFileOperations = function (command) {
	return $author$project$Environments$Repository$saveUserCommandsAndEventsAndFileOperations(
		$author$project$User$Commands$singleton(command));
};
var $author$project$Environments$ErrorHandling$ToString$userErrorToString = function (err) {
	if (!err.$) {
		var id = err.a;
		return 'User.DoesNotExist' + $author$project$User$Id$toString(id);
	} else {
		var id = err.a;
		return 'User.AlreadyExists' + $author$project$User$Id$toString(id);
	}
};
var $author$project$User$CreateDialog$createdCreateCommand = F4(
	function (command, environment, repository, dialog) {
		if (dialog.$ === 2) {
			var _v1 = A3($author$project$User$User$handleCommand, command, environment, $elm$core$Maybe$Nothing);
			if (_v1.$ === 1) {
				var error = _v1.a;
				var _v2 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v2.a;
				var newEnvironment = _v2.b;
				var newError = {
					gg: '',
					gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
						$author$project$Environments$ErrorHandling$ToString$userErrorToString(error)),
					gH: 'User.CreateDialog.elm',
					gK: 'createdCreateCommand',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					jn: $author$project$User$CreateDialog$Hidden,
					ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
					ae: repository
				};
			} else {
				var _v3 = _v1.a;
				var events = _v3.a;
				var fileOperations = _v3.b;
				var newEnvironment = _v3.c;
				if ($author$project$User$Events$isEmpty(events)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$User$CreateDialog$Hidden, ac: environment, ae: repository};
				} else {
					var _v4 = A4($author$project$Environments$Repository$saveUserCommandAndEventsAndFileOperations, command, events, fileOperations, repository);
					var newRepository = _v4.a;
					var cmd = _v4.b;
					return {ab: cmd, jn: $author$project$User$CreateDialog$Hidden, ac: newEnvironment, ae: newRepository};
				}
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$CreateDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$ProfileEditor$Editor = $elm$core$Basics$identity;
var $author$project$User$ProfileEditor$withAvatarDialog = F2(
	function (avatarDialog_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{a5: avatarDialog_});
	});
var $author$project$User$ProfileEditor$withEmailAddress = F2(
	function (emailAddress_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{ju: emailAddress_});
	});
var $author$project$User$ProfileEditor$withFirstPassword = F2(
	function (password_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{dJ: password_});
	});
var $author$project$User$ProfileEditor$withName = F2(
	function (name_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{g_: name_});
	});
var $author$project$User$ProfileEditor$withSecondPassword = F2(
	function (password_, _v0) {
		var editor = _v0;
		return _Utils_update(
			editor,
			{ed: password_});
	});
var $author$project$User$ProfileEditor$withUsername = F2(
	function (username_, _v0) {
		var editor = _v0;
		return editor.dC ? editor : _Utils_update(
			editor,
			{iK: username_});
	});
var $author$project$User$ProfileEditor$update = F2(
	function (msg, editor) {
		var editorModel = editor;
		switch (msg.$) {
			case 0:
				var name_ = msg.a;
				return _Utils_Tuple2(
					A2($author$project$User$ProfileEditor$withName, name_, editor),
					$elm$core$Platform$Cmd$none);
			case 1:
				var username_ = msg.a;
				return _Utils_Tuple2(
					A2($author$project$User$ProfileEditor$withUsername, username_, editor),
					$elm$core$Platform$Cmd$none);
			case 2:
				var emailAddress_ = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$User$ProfileEditor$withEmailAddress,
						$elm$core$Maybe$Just(emailAddress_),
						editor),
					$elm$core$Platform$Cmd$none);
			case 3:
				var password_ = msg.a;
				return _Utils_Tuple2(
					A2($author$project$User$ProfileEditor$withFirstPassword, password_, editor),
					$elm$core$Platform$Cmd$none);
			case 4:
				var password_ = msg.a;
				return _Utils_Tuple2(
					A2($author$project$User$ProfileEditor$withSecondPassword, password_, editor),
					$elm$core$Platform$Cmd$none);
			default:
				var editorMsg = msg.a;
				var _v1 = A2($author$project$UI$ImageEditor$update, editorMsg, editorModel.a5);
				var newImageEditor = _v1.a;
				var imageEditorCmd = _v1.b;
				return _Utils_Tuple2(
					A2($author$project$User$ProfileEditor$withAvatarDialog, newImageEditor, editor),
					A2($elm$core$Platform$Cmd$map, $author$project$User$ProfileEditor$GotAvatarEditorMsg, imageEditorCmd));
		}
	});
var $author$project$User$CreateDialog$gotProfileEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var _v1 = A2($author$project$User$ProfileEditor$update, editorMsg, model.aM);
			var editor = _v1.a;
			var editorCmd = _v1.b;
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$User$CreateDialog$GotProfileEditorMsg, editorCmd),
				jn: $author$project$User$CreateDialog$Visible(
					_Utils_update(
						model,
						{aM: editor})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$CreateDialog$GotRoleEditorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$User$RoleEditor$Editor = $elm$core$Basics$identity;
var $author$project$User$RoleEditor$RoleModalHidden = {$: 0};
var $author$project$User$RoleEditor$closeRoleModal = function (_v0) {
	var model = _v0;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{ea: $author$project$User$RoleEditor$RoleModalHidden}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$User$RoleEditor$TeamModalHidden = 0;
var $author$project$User$RoleEditor$closeTeamModal = function (_v0) {
	var model = _v0;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{df: 0}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$User$RoleEditor$gotOrganisationUnitNavigationMsg = F2(
	function (msg, _v0) {
		var model = _v0;
		var organisationUnitId = function () {
			if (msg.$ === 3) {
				var organisationUnit = msg.a;
				return $elm$core$Maybe$Just(organisationUnit.km);
			} else {
				return model.hT;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hT: organisationUnitId,
					d3: A2($author$project$UI$OrganisationUnitNavigation$update, msg, model.d3)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$User$RoleEditor$RoleModalVisible = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$RoleEditor$openRoleModal = F2(
	function (teamId, _v0) {
		var model = _v0;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ea: $author$project$User$RoleEditor$RoleModalVisible(teamId)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$User$RoleEditor$TeamModalVisible = 1;
var $author$project$User$RoleEditor$openTeamModal = function (_v0) {
	var model = _v0;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{df: 1}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$User$RoleEditor$userClickedAddRole = F3(
	function (teamRole, roleId, _v0) {
		var model = _v0;
		var newTeamRole = _Utils_update(
			teamRole,
			{
				kH: A2($author$project$Rights$Role$Ids$insert, roleId, teamRole.kH)
			});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					k2: A2($author$project$User$TeamRoles$insert, newTeamRole, model.k2)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$User$RoleEditor$userClickedDeleteTeamRole = F2(
	function (teamRole, _v0) {
		var model = _v0;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					k2: A2($author$project$User$TeamRoles$remove, teamRole, model.k2)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$User$RoleEditor$userClickedEntryOrganisationUnit = function (_v0) {
	var model = _v0;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				d3: $author$project$UI$OrganisationUnitNavigation$visible(true)
			}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$User$RoleEditor$userClickedRemoveRole = F3(
	function (teamRole, roleId, _v0) {
		var model = _v0;
		var newTeamRole = _Utils_update(
			teamRole,
			{
				kH: A2($author$project$Rights$Role$Ids$remove, roleId, teamRole.kH)
			});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					k2: A2($author$project$User$TeamRoles$insert, newTeamRole, model.k2)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$User$RoleEditor$userSelectedTeam = F2(
	function (teamId, _v0) {
		var model = _v0;
		var newTeamRole = {kH: $author$project$Rights$Role$Ids$empty, k1: teamId};
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					df: 0,
					k2: A2($author$project$User$TeamRoles$insert, newTeamRole, model.k2)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$User$RoleEditor$update = function (msg) {
	switch (msg.$) {
		case 0:
			var organisationUnitNavigationMsg = msg.a;
			return $author$project$User$RoleEditor$gotOrganisationUnitNavigationMsg(organisationUnitNavigationMsg);
		case 1:
			return $author$project$User$RoleEditor$userClickedEntryOrganisationUnit;
		case 2:
			return $author$project$User$RoleEditor$openTeamModal;
		case 3:
			return $author$project$User$RoleEditor$closeTeamModal;
		case 4:
			var teamId = msg.a;
			return $author$project$User$RoleEditor$openRoleModal(teamId);
		case 5:
			return $author$project$User$RoleEditor$closeRoleModal;
		case 6:
			var teamId = msg.a;
			return $author$project$User$RoleEditor$userSelectedTeam(teamId);
		case 7:
			var teamRole = msg.a;
			return $author$project$User$RoleEditor$userClickedDeleteTeamRole(teamRole);
		case 8:
			var teamRole = msg.a;
			var roleId = msg.b;
			return A2($author$project$User$RoleEditor$userClickedAddRole, teamRole, roleId);
		default:
			var teamRole = msg.a;
			var roleId = msg.b;
			return A2($author$project$User$RoleEditor$userClickedRemoveRole, teamRole, roleId);
	}
};
var $author$project$User$CreateDialog$gotRoleEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var _v1 = A2($author$project$User$RoleEditor$update, editorMsg, model.da);
			var editor = _v1.a;
			var editorCmd = _v1.b;
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$User$CreateDialog$GotRoleEditorMsg, editorCmd),
				jn: $author$project$User$CreateDialog$Visible(
					_Utils_update(
						model,
						{da: editor})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$CreateDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$User$CreateDialog$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$CreateDialog$CreatedCreateCommand = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$CreateDialog$HandlingCommand = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$ProfileEditor$unwrap = function (_v0) {
	var model = _v0;
	return model;
};
var $author$project$User$ProfileEditor$avatar = A2(
	$elm$core$Basics$composeR,
	$author$project$User$ProfileEditor$unwrap,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.a5;
		},
		$author$project$UI$ImageEditor$image));
var $author$project$User$Command$commandHelper = F2(
	function (environment, buildCommand) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Types$CommandId$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var commandId_ = _v0.a;
		var newEnvironment = _v0.b;
		return _Utils_Tuple2(
			newEnvironment,
			A2(
				$elm$core$Task$map,
				buildCommand(commandId_),
				$elm$time$Time$now));
	});
var $author$project$User$Command$create = F2(
	function (environment, model) {
		return A2(
			$author$project$User$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$User$Command$Create(
						{iX: model.iX, L: commandId_, M: commandTimestamp, ju: model.ju, hT: model.hT, g_: model.g_, a1: model.a1, k2: model.k2, dk: model.dk, iK: model.iK});
				}));
	});
var $author$project$User$Id$from = $elm$core$Basics$identity;
var $author$project$User$RoleEditor$getEntryOrganisationUnit = function (_v0) {
	var model = _v0;
	return model.hT;
};
var $author$project$User$RoleEditor$getTeamRoles = function (_v0) {
	var model = _v0;
	return model.k2;
};
var $author$project$User$ProfileEditor$name = A2(
	$elm$core$Basics$composeR,
	$author$project$User$ProfileEditor$unwrap,
	function ($) {
		return $.g_;
	});
var $author$project$User$CreateDialog$createCommand = F5(
	function (environment, username, emailAddress, password, model) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$User$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var userId = _v0.a;
		var newEnvironment = _v0.b;
		return A2(
			$author$project$User$Command$create,
			newEnvironment,
			{
				iX: $author$project$User$ProfileEditor$avatar(model.aM),
				ju: emailAddress,
				hT: $author$project$User$RoleEditor$getEntryOrganisationUnit(model.da),
				g_: $elm$core$String$trim(
					$author$project$User$ProfileEditor$name(model.aM)),
				a1: password,
				k2: $author$project$User$RoleEditor$getTeamRoles(model.da),
				dk: userId,
				iK: username
			});
	});
var $author$project$User$ProfileEditor$emailAddress = A2(
	$elm$core$Basics$composeR,
	$author$project$User$ProfileEditor$unwrap,
	function ($) {
		return $.ju;
	});
var $author$project$Auth$Password$Error = $elm$core$Basics$identity;
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Auth$Password$fromString = function (input) {
	var isSpecial = A2($elm$core$Basics$composeR, $elm$core$Char$isAlphaNum, $elm$core$Basics$not);
	var chars = A2(
		$elm$core$List$take,
		100,
		A2(
			$elm$core$List$filter,
			function (c) {
				return ($elm$core$Char$toCode(c) >= 32) && ($elm$core$Char$toCode(c) !== 127);
			},
			$elm$core$String$toList(input)));
	var verification = function (r) {
		return {
			gj: $elm$core$List$length(chars) >= 8,
			gk: $elm$core$Set$size(r.fm) >= 6,
			cE: r.cE,
			cF: r.cF,
			cG: r.cG,
			cH: r.cH
		};
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (c, acc) {
					return _Utils_update(
						acc,
						{
							cE: acc.cE || $elm$core$Char$isDigit(c),
							cF: acc.cF || $elm$core$Char$isLower(c),
							cG: acc.cG || isSpecial(c),
							cH: acc.cH || $elm$core$Char$isUpper(c),
							fm: A2($elm$core$Set$insert, c, acc.fm)
						});
				}),
			{cE: false, cF: false, cG: false, cH: false, fm: $elm$core$Set$empty},
			chars));
	return (verification.gj && (verification.gk && (verification.cE && (verification.cH && (verification.cF && verification.cG))))) ? $elm$core$Result$Ok(
		$elm$core$String$fromList(chars)) : $elm$core$Result$Err(verification);
};
var $author$project$User$ProfileEditor$password = A2(
	$elm$core$Basics$composeR,
	$author$project$User$ProfileEditor$unwrap,
	function ($) {
		return $.dJ;
	});
var $author$project$User$ProfileEditor$username = A2(
	$elm$core$Basics$composeR,
	$author$project$User$ProfileEditor$unwrap,
	function ($) {
		return $.iK;
	});
var $author$project$User$CreateDialog$userClickedCreateButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var email = function () {
				var _v3 = $author$project$User$ProfileEditor$emailAddress(model.aM);
				if (!_v3.$) {
					var mail = _v3.a;
					return $author$project$User$EmailAddress$fromString(mail);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			var _v1 = _Utils_Tuple3(
				$elm$core$String$trim(
					$author$project$User$ProfileEditor$username(model.aM)),
				email,
				$author$project$Auth$Password$fromString(
					$elm$core$String$trim(
						$author$project$User$ProfileEditor$password(model.aM))));
			if (!_v1.c.$) {
				var username = _v1.a;
				var emailAddress = _v1.b;
				var password = _v1.c.a;
				var _v2 = A5($author$project$User$CreateDialog$createCommand, environment, username, emailAddress, password, model);
				var newEnvironment = _v2.a;
				var task = _v2.b;
				return {
					ab: A2($elm$core$Task$perform, $author$project$User$CreateDialog$CreatedCreateCommand, task),
					jn: $author$project$User$CreateDialog$HandlingCommand(model),
					ac: newEnvironment,
					ae: repository
				};
			} else {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$CreateDialog$RightsAndVisibilityStep = 1;
var $author$project$Utils$Result$isOk = A2(
	$elm$core$Basics$composeR,
	$elm$core$Result$map(
		$elm$core$Basics$always(true)),
	$elm$core$Result$withDefault(false));
var $author$project$User$CreateDialog$switchStep = F2(
	function (step, model) {
		if (_Utils_eq(model.b0, step)) {
			return model;
		} else {
			var _v0 = model.b0;
			if (!_v0) {
				return ((!$elm$core$String$isEmpty(
					$author$project$User$ProfileEditor$username(model.aM))) && $author$project$Utils$Result$isOk(
					$author$project$Auth$Password$fromString(
						$author$project$User$ProfileEditor$password(model.aM)))) ? _Utils_update(
					model,
					{b0: step}) : model;
			} else {
				return _Utils_update(
					model,
					{b0: step});
			}
		}
	});
var $author$project$User$CreateDialog$nextStep = function (model) {
	var _v0 = model.b0;
	if (!_v0) {
		return A2($author$project$User$CreateDialog$switchStep, 1, model);
	} else {
		return model;
	}
};
var $author$project$User$CreateDialog$userClickedNextButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$User$CreateDialog$Visible(
					$author$project$User$CreateDialog$nextStep(model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$CreateDialog$userClickedStepIcon = F4(
	function (step, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$User$CreateDialog$Visible(
					A2($author$project$User$CreateDialog$switchStep, step, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$CreateDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$User$CreateDialog$userClickedCloseDialog;
		case 1:
			return $author$project$User$CreateDialog$userClickedCreateButton;
		case 2:
			return $author$project$User$CreateDialog$userClickedNextButton;
		case 3:
			var step = msg.a;
			return $author$project$User$CreateDialog$userClickedStepIcon(step);
		case 4:
			var editorMsg = msg.a;
			return $author$project$User$CreateDialog$gotProfileEditorMsg(editorMsg);
		case 5:
			var editorMsg = msg.a;
			return $author$project$User$CreateDialog$gotRoleEditorMsg(editorMsg);
		default:
			var command = msg.a;
			return $author$project$User$CreateDialog$createdCreateCommand(command);
	}
};
var $author$project$User$Page$withCreateDialog = F2(
	function (createDialog_, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{fi: createDialog_});
	});
var $author$project$User$Page$gotCreateDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$User$CreateDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$User$Page$createDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$User$Page$GotCreateDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$User$Page$withCreateDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$User$Page$editDialog = function (_v0) {
	var page = _v0;
	return page.cO;
};
var $author$project$User$EditDialog$Deleted = {$: 3};
var $author$project$User$Commands$fromList = $author$project$Types$Queue$fromList;
var $author$project$User$Commands$fold = $author$project$Types$Queue$fold;
var $author$project$User$User$handleCommands = F3(
	function (commands, environment, maybeUser) {
		var acc = $elm$core$Result$Ok(
			{
				cD: $author$project$User$Commands$empty,
				ac: environment,
				b8: $author$project$User$Events$empty,
				cb: $author$project$File$Operations$empty,
				au: $author$project$User$User$NotModified(maybeUser)
			});
		return A2(
			$elm$core$Result$map,
			function (data) {
				return {cD: data.cD, ac: data.ac, b8: data.b8, cb: data.cb};
			},
			A3(
				$author$project$User$Commands$fold,
				A2($elm$core$Basics$composeR, $author$project$User$User$handleCommandHelper, $elm$core$Result$andThen),
				acc,
				commands));
	});
var $author$project$User$EditDialog$createdCommands = F4(
	function (commands, environment, repository, dialog) {
		if (dialog.$ === 2) {
			var model = dialog.a;
			var _v1 = A3(
				$author$project$User$User$handleCommands,
				$author$project$User$Commands$fromList(commands),
				environment,
				A2($author$project$Environments$Repository$getUser, model.lh.dk, repository));
			if (_v1.$ === 1) {
				if (!_v1.a.$) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$User$EditDialog$Deleted, ac: environment, ae: repository};
				} else {
					var msg = _v1.a.a;
					var _v2 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v2.a;
					var newEnvironment = _v2.b;
					var newError = {
						gg: '',
						gE: $author$project$Environments$ErrorHandling$Error$CommandHandlingError(
							$author$project$Environments$ErrorHandling$ToString$userErrorToString(
								$author$project$User$User$AlreadyExists(msg))),
						gH: 'User.EditDialog.elm',
						gK: 'createdCommands',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						jn: $author$project$User$EditDialog$Hidden,
						ac: A2($author$project$Environments$Environment$addError, newError, newEnvironment),
						ae: repository
					};
				}
			} else {
				var resultData = _v1.a;
				if ($author$project$User$Commands$isEmpty(resultData.cD) || $author$project$User$Events$isEmpty(resultData.b8)) {
					return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$User$EditDialog$Hidden, ac: environment, ae: repository};
				} else {
					var _v3 = A4($author$project$Environments$Repository$saveUserCommandsAndEventsAndFileOperations, resultData.cD, resultData.b8, resultData.cb, repository);
					var newRepository = _v3.a;
					var cmd = _v3.b;
					return {ab: cmd, jn: $author$project$User$EditDialog$Hidden, ac: resultData.ac, ae: newRepository};
				}
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$EditDialog$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$EditDialog$gotProfileEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var _v1 = A2($author$project$User$ProfileEditor$update, editorMsg, model.aM);
			var editor = _v1.a;
			var editorCmd = _v1.b;
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$User$EditDialog$GotProfileEditorMsg, editorCmd),
				jn: $author$project$User$EditDialog$Visible(
					_Utils_update(
						model,
						{aM: editor})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$EditDialog$GotRoleEditorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$EditDialog$gotRoleEditorMsg = F4(
	function (editorMsg, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var _v1 = A2($author$project$User$RoleEditor$update, editorMsg, model.da);
			var editor = _v1.a;
			var editorCmd = _v1.b;
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$User$EditDialog$GotRoleEditorMsg, editorCmd),
				jn: $author$project$User$EditDialog$Visible(
					_Utils_update(
						model,
						{da: editor})),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$EditDialog$CreatedCommands = function (a) {
	return {$: 7, a: a};
};
var $author$project$User$EditDialog$HandlingCommands = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$Command$addTeamRole = F4(
	function (environment, userId, nameForError, teamRole) {
		return A2(
			$author$project$User$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$User$Command$AddTeamRole(
						{L: commandId_, M: commandTimestamp, cl: nameForError, bQ: teamRole, dk: userId});
				}));
	});
var $author$project$User$TeamRoles$diff = $turboMaCk$any_set$Set$Any$diff;
var $author$project$User$EditDialog$withAddTeamRoleCommands = F3(
	function (user, roleEditor, acc) {
		var newTeamRoles = A2(
			$author$project$User$TeamRoles$diff,
			$author$project$User$RoleEditor$getTeamRoles(roleEditor),
			user.k2);
		var commandFn = F2(
			function (teamRole, _v0) {
				var environment = _v0.a;
				var tasks = _v0.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$List$cons, task, tasks);
					},
					A4($author$project$User$Command$addTeamRole, environment, user.dk, user.iK, teamRole));
			});
		return A3(
			$elm$core$List$foldl,
			commandFn,
			acc,
			$author$project$User$TeamRoles$toList(newTeamRoles));
	});
var $author$project$User$Command$changeAvatar = F2(
	function (environment, model) {
		return A2(
			$author$project$User$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$User$Command$ChangeAvatar(
						{iX: model.iX, L: commandId_, M: commandTimestamp, cl: model.cl, dk: model.dk});
				}));
	});
var $author$project$User$EditDialog$withChangeAvatarCommand = F3(
	function (user, profileEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(
			user.iX,
			$author$project$User$ProfileEditor$avatar(profileEditor)) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$User$Command$changeAvatar,
				environment,
				{
					iX: $author$project$User$ProfileEditor$avatar(profileEditor),
					cl: user.iK,
					dk: user.dk
				}));
	});
var $author$project$User$Command$changeEmailAddress = F4(
	function (environment, userId, nameForError, emailAddress) {
		return A2(
			$author$project$User$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$User$Command$ChangeEmailAddress(
						{L: commandId_, M: commandTimestamp, ju: emailAddress, cl: nameForError, dk: userId});
				}));
	});
var $author$project$User$EditDialog$withChangeEmailAddressCommand = F3(
	function (user, profileEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		var _v1 = $author$project$User$ProfileEditor$emailAddress(profileEditor);
		if (!_v1.$) {
			var mail = _v1.a;
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(environment, tasks),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						A3($author$project$User$Command$changeEmailAddress, environment, user.dk, user.iK),
						$elm$core$Tuple$mapSecond(
							function (task) {
								return A2($elm$core$List$cons, task, tasks);
							})),
					$author$project$User$EmailAddress$fromString(mail)));
		} else {
			return _Utils_Tuple2(environment, tasks);
		}
	});
var $author$project$User$Command$changeEntryOrganisationUnit = F2(
	function (environment, model) {
		return A2(
			$author$project$User$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$User$Command$ChangeEntryOrganisationUnit(
						{L: commandId_, M: commandTimestamp, hT: model.hT, cl: model.cl, dk: model.dk});
				}));
	});
var $author$project$User$EditDialog$withChangeEntryOrganisationUnitCommand = F3(
	function (user, selectedEntryOrganisationUnit, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return _Utils_eq(user.hT, selectedEntryOrganisationUnit) ? _Utils_Tuple2(environment, tasks) : A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A2(
				$author$project$User$Command$changeEntryOrganisationUnit,
				environment,
				{hT: selectedEntryOrganisationUnit, cl: user.iK, dk: user.dk}));
	});
var $author$project$User$Command$changePassword = F4(
	function (environment, userId, nameForError, password) {
		return A2(
			$author$project$User$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$User$Command$ChangePassword(
						{L: commandId_, M: commandTimestamp, cl: nameForError, a1: password, dk: userId});
				}));
	});
var $author$project$User$EditDialog$withChangePasswordCommand = F3(
	function (user, profileEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return A2(
			$elm$core$Result$withDefault,
			_Utils_Tuple2(environment, tasks),
			A2(
				$elm$core$Result$map,
				A2(
					$elm$core$Basics$composeR,
					A3($author$project$User$Command$changePassword, environment, user.dk, user.iK),
					$elm$core$Tuple$mapSecond(
						function (task) {
							return A2($elm$core$List$cons, task, tasks);
						})),
				$author$project$Auth$Password$fromString(
					$author$project$User$ProfileEditor$password(profileEditor))));
	});
var $author$project$User$Command$changeTeamRole = F4(
	function (environment, userId, nameForError, teamRole) {
		return A2(
			$author$project$User$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$User$Command$ChangeTeamRole(
						{L: commandId_, M: commandTimestamp, cl: nameForError, bQ: teamRole, dk: userId});
				}));
	});
var $turboMaCk$any_dict$Dict$Any$equal = F2(
	function (_v0, _v1) {
		var r1 = _v0;
		var r2 = _v1;
		return _Utils_eq(r1.cL, r2.cL);
	});
var $turboMaCk$any_set$Set$Any$equal = F2(
	function (_v0, _v1) {
		var a = _v0;
		var b = _v1;
		return A2($turboMaCk$any_dict$Dict$Any$equal, a, b);
	});
var $author$project$Rights$Role$Ids$equal = $turboMaCk$any_set$Set$Any$equal;
var $turboMaCk$any_dict$Dict$Any$getKey = F2(
	function (k, _v0) {
		var dict = _v0.cL;
		var toKey = _v0.a3;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$Dict$get,
				toKey(k),
				dict));
	});
var $turboMaCk$any_set$Set$Any$get = F2(
	function (a, _v0) {
		var dict = _v0;
		return A2($turboMaCk$any_dict$Dict$Any$getKey, a, dict);
	});
var $author$project$User$TeamRoles$getTeamRole = function (teamId) {
	var teamRole = A2($author$project$User$TeamRoles$TeamRole, teamId, $author$project$Rights$Role$Ids$empty);
	return $turboMaCk$any_set$Set$Any$get(teamRole);
};
var $author$project$User$EditDialog$withChangeTeamRoleCommands = F3(
	function (user, roleEditor, acc) {
		var newTeamRoles = A2(
			$elm$core$List$filter,
			function (teamRole) {
				var _v1 = A2($author$project$User$TeamRoles$getTeamRole, teamRole.k1, user.k2);
				if (!_v1.$) {
					var oldTeamTole = _v1.a;
					return !A2($author$project$Rights$Role$Ids$equal, teamRole.kH, oldTeamTole.kH);
				} else {
					return false;
				}
			},
			$author$project$User$TeamRoles$toList(
				$author$project$User$RoleEditor$getTeamRoles(roleEditor)));
		var commandFn = F2(
			function (teamRole, _v0) {
				var environment = _v0.a;
				var tasks = _v0.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$List$cons, task, tasks);
					},
					A4($author$project$User$Command$changeTeamRole, environment, user.dk, user.iK, teamRole));
			});
		return A3($elm$core$List$foldl, commandFn, acc, newTeamRoles);
	});
var $author$project$User$Command$removeTeamRole = F4(
	function (environment, userId, nameForError, teamRole) {
		return A2(
			$author$project$User$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$User$Command$RemoveTeamRole(
						{L: commandId_, M: commandTimestamp, cl: nameForError, bQ: teamRole, dk: userId});
				}));
	});
var $author$project$User$EditDialog$withRemoveTeamRoleCommands = F3(
	function (user, roleEditor, acc) {
		var removedTeamRoles = A2(
			$author$project$User$TeamRoles$diff,
			user.k2,
			$author$project$User$RoleEditor$getTeamRoles(roleEditor));
		var commandFn = F2(
			function (teamRole, _v0) {
				var environment = _v0.a;
				var tasks = _v0.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (task) {
						return A2($elm$core$List$cons, task, tasks);
					},
					A4($author$project$User$Command$removeTeamRole, environment, user.dk, user.iK, teamRole));
			});
		return A3(
			$elm$core$List$foldl,
			commandFn,
			acc,
			$author$project$User$TeamRoles$toList(removedTeamRoles));
	});
var $author$project$User$Command$rename = F4(
	function (environment, userId, nameForError, name) {
		return A2(
			$author$project$User$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$User$Command$Rename(
						{L: commandId_, M: commandTimestamp, g_: name, cl: nameForError, dk: userId});
				}));
	});
var $author$project$User$EditDialog$withRenameCommand = F3(
	function (user, profileEditor, _v0) {
		var environment = _v0.a;
		var tasks = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (task) {
				return A2($elm$core$List$cons, task, tasks);
			},
			A4(
				$author$project$User$Command$rename,
				environment,
				user.dk,
				user.iK,
				$elm$core$String$trim(
					$author$project$User$ProfileEditor$name(profileEditor))));
	});
var $author$project$User$EditDialog$createCommands = F2(
	function (environment, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$reverse,
			A3(
				$author$project$User$EditDialog$withChangeEntryOrganisationUnitCommand,
				model.lh,
				$author$project$User$RoleEditor$getEntryOrganisationUnit(model.da),
				A3(
					$author$project$User$EditDialog$withChangeAvatarCommand,
					model.lh,
					model.aM,
					A3(
						$author$project$User$EditDialog$withRemoveTeamRoleCommands,
						model.lh,
						model.da,
						A3(
							$author$project$User$EditDialog$withChangeTeamRoleCommands,
							model.lh,
							model.da,
							A3(
								$author$project$User$EditDialog$withAddTeamRoleCommands,
								model.lh,
								model.da,
								A3(
									$author$project$User$EditDialog$withChangePasswordCommand,
									model.lh,
									model.aM,
									A3(
										$author$project$User$EditDialog$withRenameCommand,
										model.lh,
										model.aM,
										A3(
											$author$project$User$EditDialog$withChangeEmailAddressCommand,
											model.lh,
											model.aM,
											_Utils_Tuple2(environment, _List_Nil))))))))));
	});
var $author$project$Utils$Result$isErr = A2(
	$elm$core$Basics$composeR,
	$elm$core$Result$map(
		$elm$core$Basics$always(false)),
	$elm$core$Result$withDefault(true));
var $author$project$User$EditDialog$userClickedApplyButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var passwordString = $author$project$User$ProfileEditor$password(model.aM);
			if ($elm$core$String$isEmpty(
				$author$project$User$ProfileEditor$username(model.aM))) {
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			} else {
				if ((!$elm$core$String$isEmpty(passwordString)) && $author$project$Utils$Result$isErr(
					$author$project$Auth$Password$fromString(passwordString))) {
					return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
				} else {
					var _v1 = A2($author$project$User$EditDialog$createCommands, environment, model);
					var newEnvironment = _v1.a;
					var tasks = _v1.b;
					return {
						ab: A2(
							$elm$core$Task$perform,
							$author$project$User$EditDialog$CreatedCommands,
							$elm$core$Task$sequence(tasks)),
						jn: $author$project$User$EditDialog$HandlingCommands(model),
						ac: newEnvironment,
						ae: repository
					};
				}
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$EditDialog$userClickedCancelButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$User$EditDialog$Hidden, ac: environment, ae: repository};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$EditDialog$userClickedCloseDialog = F3(
	function (environment, repository, dialog) {
		switch (dialog.$) {
			case 0:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			case 1:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$User$EditDialog$Hidden, ac: environment, ae: repository};
			case 2:
				return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
			default:
				return {ab: $elm$core$Platform$Cmd$none, jn: $author$project$User$EditDialog$Hidden, ac: environment, ae: repository};
		}
	});
var $author$project$User$Command$delete = F3(
	function (environment, userId, username) {
		return A2(
			$author$project$User$Command$commandHelper,
			environment,
			F2(
				function (commandId_, commandTimestamp) {
					return $author$project$User$Command$Delete(
						{L: commandId_, M: commandTimestamp, dk: userId, iK: username});
				}));
	});
var $author$project$User$EditDialog$userClickedDeleteButton = F3(
	function (environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			var _v1 = A2(
				$elm$core$Tuple$mapSecond,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$singleton,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Task$sequence,
						$elm$core$Task$perform($author$project$User$EditDialog$CreatedCommands))),
				A3($author$project$User$Command$delete, environment, model.lh.dk, model.lh.iK));
			var newEnvironment = _v1.a;
			var cmd = _v1.b;
			return {
				ab: cmd,
				jn: $author$project$User$EditDialog$HandlingCommands(model),
				ac: newEnvironment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$EditDialog$ProfileTab = 0;
var $author$project$User$EmailAddress$isValid = A2(
	$elm$core$Basics$composeR,
	$author$project$User$EmailAddress$fromString,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			$elm$core$Basics$always(true)),
		$elm$core$Maybe$withDefault(false)));
var $author$project$User$ProfileEditor$secondPassword = A2(
	$elm$core$Basics$composeR,
	$author$project$User$ProfileEditor$unwrap,
	function ($) {
		return $.ed;
	});
var $author$project$User$ProfileEditor$passwordsAreEqual = function (editor) {
	return _Utils_eq(
		$author$project$User$ProfileEditor$password(editor),
		$author$project$User$ProfileEditor$secondPassword(editor));
};
var $author$project$User$EditDialog$switchTab = F2(
	function (tab, model) {
		if (_Utils_eq(model.cI, tab)) {
			return model;
		} else {
			if (!model.cI) {
				var passwordString = $author$project$User$ProfileEditor$password(model.aM);
				var name = $elm$core$String$trim(
					$author$project$User$ProfileEditor$name(model.aM));
				var mailIsValid = function () {
					var _v0 = $author$project$User$ProfileEditor$emailAddress(model.aM);
					if (!_v0.$) {
						var email = _v0.a;
						return $author$project$User$EmailAddress$isValid(email);
					} else {
						return true;
					}
				}();
				return $elm$core$String$isEmpty(
					$author$project$User$ProfileEditor$username(model.aM)) ? model : ((((!$elm$core$String$isEmpty(passwordString)) && $author$project$Utils$Result$isErr(
					$author$project$Auth$Password$fromString(passwordString))) || (!$author$project$User$ProfileEditor$passwordsAreEqual(model.aM))) ? model : ((!mailIsValid) ? model : _Utils_update(
					model,
					{
						cI: tab,
						aM: A2($author$project$User$ProfileEditor$withName, name, model.aM)
					})));
			} else {
				return _Utils_update(
					model,
					{cI: tab});
			}
		}
	});
var $author$project$User$EditDialog$userClickedTabIcon = F4(
	function (tab, environment, repository, dialog) {
		if (dialog.$ === 1) {
			var model = dialog.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				jn: $author$project$User$EditDialog$Visible(
					A2($author$project$User$EditDialog$switchTab, tab, model)),
				ac: environment,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, jn: dialog, ac: environment, ae: repository};
		}
	});
var $author$project$User$EditDialog$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$User$EditDialog$userClickedCloseDialog;
		case 1:
			var tab = msg.a;
			return $author$project$User$EditDialog$userClickedTabIcon(tab);
		case 2:
			return $author$project$User$EditDialog$userClickedCancelButton;
		case 3:
			return $author$project$User$EditDialog$userClickedApplyButton;
		case 4:
			return $author$project$User$EditDialog$userClickedDeleteButton;
		case 5:
			var editorMsg = msg.a;
			return $author$project$User$EditDialog$gotProfileEditorMsg(editorMsg);
		case 6:
			var editorMsg = msg.a;
			return $author$project$User$EditDialog$gotRoleEditorMsg(editorMsg);
		default:
			var commands = msg.a;
			return $author$project$User$EditDialog$createdCommands(commands);
	}
};
var $author$project$User$Page$withEditDialog = F2(
	function (editDialog_, _v0) {
		var page = _v0;
		return _Utils_update(
			page,
			{cO: editDialog_});
	});
var $author$project$User$Page$gotEditDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		var result = A4(
			$author$project$User$EditDialog$update,
			dialogMsg,
			environment,
			repository,
			$author$project$User$Page$editDialog(page));
		return {
			ab: A2($elm$core$Platform$Cmd$map, $author$project$User$Page$GotEditDialogMsg, result.ab),
			ac: result.ac,
			ak: A2($author$project$User$Page$withEditDialog, result.jn, page),
			ae: result.ae
		};
	});
var $author$project$User$Page$Visible = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$User$CreateDialog$ProfileStep = 0;
var $author$project$User$ProfileEditor$default = {a5: $author$project$UI$ImageEditor$default, dC: false, ju: $elm$core$Maybe$Nothing, dJ: '', g_: '', ed: '', iK: ''};
var $author$project$User$RoleEditor$default = {hT: $elm$core$Maybe$Nothing, d3: $author$project$UI$OrganisationUnitNavigation$hidden, ea: $author$project$User$RoleEditor$RoleModalHidden, df: 0, k2: $author$project$User$TeamRoles$empty, dk: $elm$core$Maybe$Nothing};
var $author$project$User$CreateDialog$show = $author$project$User$CreateDialog$Visible(
	{b0: 0, aM: $author$project$User$ProfileEditor$default, da: $author$project$User$RoleEditor$default});
var $author$project$User$Dict$size = $turboMaCk$any_dict$Dict$Any$size;
var $author$project$User$Page$userClickedCreateIcon = F3(
	function (environment, repository, page) {
		var updatedPage = A2(
			$elm$core$Maybe$withDefault,
			page,
			A2(
				$elm$core$Maybe$map,
				function (tenant) {
					var currentUserCount = $author$project$User$Dict$size(
						$author$project$Environments$Repository$users(repository));
					return (_Utils_eq(tenant.jW.lk, -1) || (_Utils_cmp(tenant.jW.lk, currentUserCount) > 0)) ? A2($author$project$User$Page$withCreateDialog, $author$project$User$CreateDialog$show, page) : A2(
						$author$project$User$Page$withUserLimitationModalState,
						A2($author$project$User$Page$Visible, tenant.jW.lk, currentUserCount),
						page);
				},
				$author$project$Environments$Repository$getTenant(repository)));
		return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: updatedPage, ae: repository};
	});
var $author$project$User$ProfileEditor$disableUsername = function (_v0) {
	var editor = _v0;
	return _Utils_update(
		editor,
		{dC: true});
};
var $author$project$User$ProfileEditor$from = function (model) {
	var maybeEmailAddressString = function () {
		var _v0 = model.ju;
		if (!_v0.$) {
			var mail = _v0.a;
			return $elm$core$Maybe$Just(
				$author$project$User$EmailAddress$toString(mail));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return {
		a5: $author$project$UI$ImageEditor$from(model.iX),
		dC: false,
		ju: maybeEmailAddressString,
		dJ: '',
		g_: model.g_,
		ed: '',
		iK: model.iK
	};
};
var $author$project$User$RoleEditor$from = function (model) {
	return {
		hT: model.hT,
		d3: $author$project$UI$OrganisationUnitNavigation$hidden,
		ea: $author$project$User$RoleEditor$RoleModalHidden,
		df: 0,
		k2: model.k2,
		dk: $elm$core$Maybe$Just(model.dk)
	};
};
var $author$project$User$EditDialog$show = function (user) {
	return $author$project$User$EditDialog$Visible(
		{
			cI: 0,
			aM: $author$project$User$ProfileEditor$disableUsername(
				$author$project$User$ProfileEditor$from(user)),
			da: $author$project$User$RoleEditor$from(user),
			lh: user
		});
};
var $author$project$User$Page$userClickedEditIcon = F4(
	function (user, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: A2(
				$author$project$User$Page$withEditDialog,
				$author$project$User$EditDialog$show(user),
				page),
			ae: repository
		};
	});
var $author$project$User$Page$update = function (msg) {
	switch (msg.$) {
		case 0:
			return $author$project$User$Page$userClickedCreateIcon;
		case 1:
			var dialogMsg = msg.a;
			return $author$project$User$Page$gotCreateDialogMsg(dialogMsg);
		case 2:
			var user = msg.a;
			return $author$project$User$Page$userClickedEditIcon(user);
		case 3:
			var dialogMsg = msg.a;
			return $author$project$User$Page$gotEditDialogMsg(dialogMsg);
		default:
			return $author$project$User$Page$closeUserLimitationsModel;
	}
};
var $author$project$Translations$Users$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.header');
};
var $author$project$User$Page$UserClickedCreateIcon = {$: 0};
var $author$project$User$Page$viewActionBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withStyle,
			$rtfeldman$elm_css$Css$zIndex(
				$rtfeldman$elm_css$Css$int(1)),
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
					A2(
						$author$project$UI$Bar$withRightIcon,
						A2(
							$author$project$UI$Icon$withOnClick,
							$author$project$User$Page$UserClickedCreateIcon,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
						$author$project$UI$Bar$bar(
							$author$project$Translations$Misc$overview(translations)))))));
};
var $author$project$User$CreateDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Users$createDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.createDialogHeader');
};
var $author$project$Translations$Users$Profile$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.header');
};
var $author$project$User$ProfileEditor$viewBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$user),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Users$Profile$header(translations))));
};
var $author$project$UI$ImageEditor$withImageStyle = F2(
	function (styles, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{eG: styles});
	});
var $author$project$User$ProfileEditor$viewAvatar = F2(
	function (translations, imageEditor) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$User$ProfileEditor$GotAvatarEditorMsg,
			A2(
				$author$project$UI$ImageEditor$view,
				translations,
				$author$project$UI$ImageEditor$withDelete(
					A2(
						$author$project$UI$ImageEditor$withImageStyle,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$maxHeight(
								$rtfeldman$elm_css$Css$rem(15)),
								$rtfeldman$elm_css$Css$maxWidth(
								$rtfeldman$elm_css$Css$rem(15))
							]),
						imageEditor))));
	});
var $author$project$User$ProfileEditor$UserEnteredEmailAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Translations$Users$Profile$emailAddress = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.emailAddress');
};
var $author$project$User$ProfileEditor$viewEmailAddress = F2(
	function (translations, emailAddress_) {
		var mailValue = function () {
			if (!emailAddress_.$) {
				var mail = emailAddress_.a;
				return mail;
			} else {
				return '';
			}
		}();
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withOnInput,
				$author$project$User$ProfileEditor$UserEnteredEmailAddress,
				A2(
					$author$project$UI$TextInput$withPlaceholder,
					$author$project$Translations$Users$Profile$emailAddress(translations),
					A2($author$project$UI$TextInput$withValue, mailValue, $author$project$UI$TextInput$singleLine))));
	});
var $author$project$User$ProfileEditor$UserEnteredName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Translations$Users$Profile$name = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.name');
};
var $author$project$User$ProfileEditor$viewName = F2(
	function (translations, name_) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withOnInput,
				$author$project$User$ProfileEditor$UserEnteredName,
				A2(
					$author$project$UI$TextInput$withPlaceholder,
					$author$project$Translations$Users$Profile$name(translations),
					A2($author$project$UI$TextInput$withValue, name_, $author$project$UI$TextInput$singleLine))));
	});
var $author$project$User$ProfileEditor$UserEnteredFirstPassword = function (a) {
	return {$: 3, a: a};
};
var $author$project$Translations$Users$Profile$password = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.password');
};
var $author$project$UI$TextInput$password = $author$project$UI$TextInput$Password(
	{dx: $elm$core$Maybe$Nothing, jo: false, fw: '', eO: $elm$core$Maybe$Nothing, d1: $elm$core$Maybe$Nothing, cr: '', dd: _List_Nil, ll: ''});
var $author$project$User$ProfileEditor$viewFirstPasswordInput = F2(
	function (translations, password_) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withOnInput,
				$author$project$User$ProfileEditor$UserEnteredFirstPassword,
				A2(
					$author$project$UI$TextInput$withPlaceholder,
					$author$project$Translations$Users$Profile$password(translations),
					A2($author$project$UI$TextInput$withValue, password_, $author$project$UI$TextInput$password))));
	});
var $author$project$Translations$Users$Profile$passwordDontEqual = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordDontEqual');
};
var $author$project$Translations$Users$Profile$passwordEqual = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordEqual');
};
var $author$project$User$ProfileEditor$viewPasswordEquals = F3(
	function (translations, firstPassword_, secondPassword_) {
		var _v0 = (_Utils_eq(firstPassword_, secondPassword_) && (!$elm$core$String$isEmpty(firstPassword_))) ? _Utils_Tuple2(
			$author$project$Translations$Users$Profile$passwordEqual(translations),
			$author$project$UI$Style$Theme$green) : _Utils_Tuple2(
			$author$project$Translations$Users$Profile$passwordDontEqual(translations),
			$author$project$UI$Style$Theme$red);
		var userMsg = _v0.a;
		var color_ = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor(color_)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(userMsg)
				]));
	});
var $author$project$Translations$Users$Profile$PasswordRules$different = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordRules.different');
};
var $author$project$Translations$Users$Profile$PasswordRules$digits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordRules.digits');
};
var $author$project$Translations$Users$Profile$PasswordRules$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordRules.header');
};
var $author$project$Translations$Users$Profile$PasswordRules$length = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordRules.length');
};
var $rtfeldman$elm_css$Css$listStyleType = $rtfeldman$elm_css$Css$prop1('list-style-type');
var $author$project$Translations$Users$Profile$PasswordRules$lowercase = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordRules.lowercase');
};
var $author$project$Translations$Users$Profile$PasswordRules$specialCharacter = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordRules.specialCharacter');
};
var $rtfeldman$elm_css$Css$square = {e: 0, d: 0, ll: 'square'};
var $author$project$Translations$Users$Profile$PasswordRules$uppercase = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordRules.uppercase');
};
var $author$project$Translations$Users$Profile$PasswordRules$whitespace = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordRules.whitespace');
};
var $author$project$User$ProfileEditor$viewPasswordRules = F2(
	function (translations, firstPassword_) {
		var showRule = F2(
			function (content, fullFiledRule) {
				var color_ = fullFiledRule ? $author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$green) : $author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$red);
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color(color_),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(content)
						]));
			});
		var chars = $elm$core$String$toList(firstPassword_);
		var whitespaceMessage = function () {
			var _v1 = _Utils_Tuple2(
				$elm$core$List$head(chars),
				$elm$core$List$head(
					$elm$core$List$reverse(chars)));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var firstChar = _v1.a.a;
				var lastChar = _v1.b.a;
				return ((firstChar === ' ') || (lastChar === ' ')) ? A2(
					showRule,
					$author$project$Translations$Users$Profile$PasswordRules$whitespace(translations),
					false) : $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}();
		var _v0 = $author$project$Auth$Password$fromString(firstPassword_);
		if (_v0.$ === 1) {
			var verification = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$color(
										$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$red)),
										$rtfeldman$elm_css$Css$fontWeight(
										$rtfeldman$elm_css$Css$int(600))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Translations$Users$Profile$PasswordRules$header(translations))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$square)
									]))
							]),
						_List_fromArray(
							[
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$length(translations),
								verification.gj),
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$different(translations),
								verification.gk),
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$uppercase(translations),
								verification.cH),
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$lowercase(translations),
								verification.cF),
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$digits(translations),
								verification.cE),
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$specialCharacter(translations),
								verification.cG),
								whitespaceMessage
							]))
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$color(
										$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$green)),
										$rtfeldman$elm_css$Css$fontWeight(
										$rtfeldman$elm_css$Css$int(600))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Translations$Users$Profile$PasswordRules$header(translations))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$square)
									]))
							]),
						_List_fromArray(
							[
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$length(translations),
								true),
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$different(translations),
								true),
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$uppercase(translations),
								true),
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$lowercase(translations),
								true),
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$digits(translations),
								true),
								A2(
								showRule,
								$author$project$Translations$Users$Profile$PasswordRules$specialCharacter(translations),
								true),
								whitespaceMessage
							]))
					]));
		}
	});
var $author$project$User$ProfileEditor$UserEnteredSecondPassword = function (a) {
	return {$: 4, a: a};
};
var $author$project$Translations$Users$Profile$passwordAgain = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.passwordAgain');
};
var $author$project$User$ProfileEditor$viewSecondPasswordInput = F2(
	function (translations, password_) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withOnInput,
				$author$project$User$ProfileEditor$UserEnteredSecondPassword,
				A2(
					$author$project$UI$TextInput$withPlaceholder,
					$author$project$Translations$Users$Profile$passwordAgain(translations),
					A2($author$project$UI$TextInput$withValue, password_, $author$project$UI$TextInput$password))));
	});
var $author$project$User$ProfileEditor$viewPassword = F3(
	function (translations, firstPassword_, secondPassword_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$User$ProfileEditor$viewFirstPasswordInput, translations, firstPassword_),
					A2($author$project$User$ProfileEditor$viewPasswordRules, translations, firstPassword_),
					A2($author$project$User$ProfileEditor$viewSecondPasswordInput, translations, secondPassword_),
					A3($author$project$User$ProfileEditor$viewPasswordEquals, translations, firstPassword_, secondPassword_)
				]));
	});
var $author$project$User$ProfileEditor$UserEnteredUsername = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$Users$Profile$userNameWarning = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.userNameWarning');
};
var $author$project$Translations$Users$Profile$username = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.profile.username');
};
var $author$project$User$ProfileEditor$viewUsername = F4(
	function (translations, name_, usernameExists, disableUsername_) {
		var usernameWarning = usernameExists ? A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$red)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$Users$Profile$userNameWarning(translations))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					usernameWarning,
					$author$project$UI$TextInput$view(
					A2(
						$author$project$UI$TextInput$withOnInput,
						$author$project$User$ProfileEditor$UserEnteredUsername,
						A2(
							$author$project$UI$TextInput$withPlaceholder,
							$author$project$Translations$Users$Profile$username(translations),
							A2(
								$author$project$UI$TextInput$disabled,
								disableUsername_,
								A2($author$project$UI$TextInput$withValue, name_, $author$project$UI$TextInput$singleLine)))))
				]));
	});
var $author$project$User$ProfileEditor$viewForm = F8(
	function (translations, name_, username_, usernameExists, emailAddress_, password_, secondPassword_, disableUsername_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$form,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flexGrow(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$flexShrink(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$paddingLeft(
							$rtfeldman$elm_css$Css$rem(1.5))
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$User$ProfileEditor$viewName, translations, name_),
					A4($author$project$User$ProfileEditor$viewUsername, translations, username_, usernameExists, disableUsername_),
					A2($author$project$User$ProfileEditor$viewEmailAddress, translations, emailAddress_),
					A3($author$project$User$ProfileEditor$viewPassword, translations, password_, secondPassword_)
				]));
	});
var $author$project$User$ProfileEditor$viewContent = F3(
	function (translations, usernameExists, _v0) {
		var model = _v0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$User$ProfileEditor$viewAvatar, translations, model.a5),
					A8($author$project$User$ProfileEditor$viewForm, translations, model.g_, model.iK, usernameExists, model.ju, model.dJ, model.ed, model.dC)
				]));
	});
var $author$project$User$CreateDialog$viewCancelButton = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$User$CreateDialog$UserClickedCloseDialog,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$cancel(translations))))
			]));
};
var $author$project$User$CreateDialog$UserClickedCreateButton = {$: 1};
var $author$project$User$CreateDialog$viewCreateButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$User$CreateDialog$UserClickedCreateButton,
			$author$project$UI$Button$green(
				$author$project$Translations$Buttons$create(translations))));
};
var $author$project$User$CreateDialog$UserClickedNextButton = {$: 2};
var $author$project$User$CreateDialog$viewNextButton = F2(
	function (translations, disabled) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withOnClick,
				$author$project$User$CreateDialog$UserClickedNextButton,
				A2(
					$author$project$UI$Button$disabled,
					disabled,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$next(translations)))));
	});
var $author$project$User$CreateDialog$viewRightButton = F3(
	function (translations, currentStep, disabled) {
		if (currentStep === 1) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
							]))
					]),
				_List_fromArray(
					[
						$author$project$User$CreateDialog$viewCreateButton(translations)
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
							]))
					]),
				_List_fromArray(
					[
						A2($author$project$User$CreateDialog$viewNextButton, translations, disabled)
					]));
		}
	});
var $author$project$UI$Icons$userProfileCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63 32c0 17.121-13.879 31-31 31C14.878 63 1 49.121 1 32 1 14.879 14.878 1 32 1c17.121 0 31 13.879 31 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M24.518 21.834l.01-.066.003-.041c.184-4.296 2.801-4.939 4.346-4.939l.068-.004c1.895.046 4.183.945 4.353 4.911l.007.206.012.027c.05.677.248 4.618-1.467 6.693-.71.86-1.635 1.267-2.961 1.28-1.259-.013-2.207-.43-2.904-1.28-1.871-2.259-1.47-6.75-1.467-6.788M28.81 33.04h.219c2.065-.038 3.747-.825 4.998-2.339 2.639-3.196 2.236-8.58 2.184-9.152-.177-4.012-1.969-5.934-3.438-6.838-1.099-.678-2.366-1.037-3.78-1.067h-.112c-.778 0-2.302.135-3.776 1.037-1.49.908-3.305 2.836-3.477 6.837-.054.602-.457 5.985 2.18 9.182 1.245 1.514 2.924 2.302 5.003 2.34m14.008 9.545c-.04-1.376-.14-5.036-3.336-6.21l-.106-.034c-2.79-.763-5.166-2.52-5.19-2.537a1.372 1.372 0 00-.838-.286c-.474 0-.921.248-1.196.665-.459.705-.299 1.691.356 2.187.112.083 2.782 2.08 6.062 2.984 1.046.402 1.286 1.572 1.335 3.313 0 .092.001.173.007.182.005.516-.02 1.238-.083 1.744-1.344.773-5.177 2.633-10.903 2.633-5.698 0-9.554-1.865-10.909-2.64a13.817 13.817 0 01-.081-1.796l.004-.11c.053-1.806.288-2.932 1.285-3.316 2.949-.814 5.393-2.478 6.115-3.002.387-.294.617-.773.617-1.282 0-.86-.657-1.568-1.457-1.57-.301 0-.591.1-.842.29-.023.016-2.378 1.77-5.18 2.534l-.118.037c-3.188 1.177-3.293 4.828-3.33 6.233 0 .035 0 .066-.008.185-.01.538-.006 2.372.37 3.39.11.315.31.575.558.739.048.034 4.887 3.438 12.984 3.438 7.718 0 12.454-3.076 12.976-3.432.257-.18.455-.44.566-.746.366-1.046.354-3.002.35-3.393l-.008-.2zm5.255-24.108h-8.799c-.497 0-.905.44-.905.974s.408.973.905.973h7.893v20.537H44.49c-.498 0-.906.44-.906.974s.408.973.906.973h3.584c.497 0 .905-.439.905-.973V19.45c0-.535-.408-.974-.905-.974')
						]),
					_List_Nil)
				]));
	});
var $author$project$UI$Icons$userSettingsCircleBicolor = F3(
	function (foregroundColor, backgroundColor, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2($author$project$UI$Icons$setViewBox, '0 0 64 64', attributes),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(backgroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M63 32c0 17.121-13.879 31-31 31C14.878 63 1 49.121 1 32 1 14.879 14.878 1 32 1c17.121 0 31 13.879 31 31')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$author$project$UI$Icons$fillColor(foregroundColor),
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M25.21 21.835l.01-.064.002-.041c.198-4.295 3.01-4.934 4.672-4.934 2.034.045 4.568.937 4.75 4.902l.008.205.011.026c.055.677.267 4.619-1.576 6.693-.763.861-1.754 1.266-3.182 1.281-1.35-.015-2.372-.431-3.12-1.281-2.01-2.26-1.579-6.746-1.575-6.787m4.613 11.203h.23l.003-.002c2.22-.037 4.025-.822 5.371-2.336 2.834-3.191 2.4-8.578 2.346-9.146-.19-4.012-2.114-5.932-3.696-6.836-1.178-.68-2.54-1.039-4.059-1.067H29.9c-.837 0-2.476.135-4.059 1.036-1.603.908-3.552 2.835-3.735 6.834-.06.601-.493 5.984 2.34 9.179 1.337 1.514 3.142 2.299 5.378 2.338m17.901 7.041h-.53a6.652 6.652 0 00-.627-1.512l.371-.371a1.271 1.271 0 000-1.797l-.777-.777a1.275 1.275 0 00-1.797 0l-3.21 3.209a.619.619 0 000 .871c.077.076.17.129.268.156.016.008.031.018.047.024a2.16 2.16 0 011.29 1.441 2.175 2.175 0 01-.204 1.66 2.162 2.162 0 01-1.312 1.028 2.185 2.185 0 01-2.689-1.516 2.196 2.196 0 01.702-2.258.616.616 0 00-.793-.941 3.413 3.413 0 002.188 6.023c.306 0 .616-.039.918-.125a3.385 3.385 0 002.054-1.609 3.395 3.395 0 00.32-2.59 3.398 3.398 0 00-1.329-1.881l2.617-2.617c.017-.018.041-.018.06 0l.778.777a.044.044 0 010 .059l-1.074 1.07.281.42a5.44 5.44 0 01.826 1.998l.1.496h1.522a.04.04 0 01.041.041v1.102a.04.04 0 01-.04.041h-1.517l-.099.494a5.564 5.564 0 01-.825 1.998l-.282.42 1.073 1.072a.038.038 0 010 .057l-.779.779a.04.04 0 01-.057 0l-1.073-1.072-.42.279a5.45 5.45 0 01-1.996.826l-.496.098v1.52a.039.039 0 01-.039.039h-1.103a.039.039 0 01-.039-.039v-1.52l-.498-.098a5.524 5.524 0 01-1.995-.826l-.42-.279-1.073 1.072c-.016.016-.04.016-.059 0l-.778-.779a.038.038 0 010-.057l1.073-1.072-.28-.42a5.45 5.45 0 01-.826-1.998l-.099-.494h-1.526a.04.04 0 01-.04-.041v-1.102a.04.04 0 01.04-.041h1.516l.1-.496a5.55 5.55 0 01.826-1.998l.28-.42-1.073-1.07c-.016-.018-.016-.043 0-.059l.777-.777c.018-.018.041-.018.06 0l1.071 1.072.418-.279a5.46 5.46 0 011.998-.826l.496-.1v-1.527c0-.024.016-.041.04-.041h1.102c.026 0 .042.017.042.041v1.015c0 .336.277.614.615.614a.615.615 0 00.612-.614v-1.015a1.27 1.27 0 00-1.269-1.27h-1.102c-.698 0-1.27.571-1.27 1.27v.527a6.718 6.718 0 00-1.512.631l-.37-.373a1.275 1.275 0 00-1.798 0l-.777.777a1.271 1.271 0 000 1.797l.372.371a6.841 6.841 0 00-.628 1.512h-.526c-.699 0-1.269.572-1.269 1.27v1.103c0 .699.57 1.272 1.27 1.272h.527c.147.529.357 1.033.628 1.511l-.37.373a1.268 1.268 0 000 1.793l.777.782c.496.492 1.3.492 1.797 0l.371-.374c.478.27.982.481 1.512.627v.536c0 .697.57 1.265 1.27 1.265h1.102c.7 0 1.27-.568 1.27-1.265v-.532a6.654 6.654 0 001.514-.629l.371.373a1.27 1.27 0 001.795 0l.777-.779a1.267 1.267 0 000-1.795l-.37-.371c.268-.478.481-.982.628-1.514h.532c.7 0 1.271-.568 1.271-1.269v-1.107c0-.698-.57-1.27-1.27-1.27M29.945 47.22c-6.12 0-10.265-1.865-11.722-2.641-.069-.521-.1-1.248-.087-1.793l.005-.109c.056-1.807.31-2.932 1.382-3.316 3.167-.815 5.792-2.477 6.57-3 .706-.5.876-1.477.38-2.186a1.568 1.568 0 00-2.189-.377c-.024.016-2.554 1.77-5.568 2.535l-.125.035c-3.425 1.176-3.536 4.827-3.58 6.233 0 .035.003.064-.005.183-.01.538-.008 2.372.396 3.391.12.313.334.572.602.738.05.036 5.25 3.436 13.95 3.436 1.26 0 2.437-.076 3.544-.199a10.6 10.6 0 01-2.352-2.953c-.392.013-.79.023-1.2.023')
						]),
					_List_Nil)
				]));
	});
var $author$project$User$CreateDialog$UserClickedStepIcon = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$CreateDialog$viewStepIcon = F3(
	function (icon, step, currentStep) {
		var marginRight_ = (step === 1) ? $rtfeldman$elm_css$Css$marginRight($rtfeldman$elm_css$Css$zero) : $rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$rem(1));
		var _v0 = _Utils_eq(step, currentStep) ? _Utils_Tuple2($author$project$UI$Style$Theme$white, $author$project$UI$Style$Theme$darkGrey) : _Utils_Tuple2($author$project$UI$Style$Theme$darkGrey, $author$project$UI$Style$Theme$lightGrey);
		var foregroundColor_ = _v0.a;
		var backgroundColor_ = _v0.b;
		return $author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withOnClick,
				$author$project$User$CreateDialog$UserClickedStepIcon(step),
				A2(
					$author$project$UI$Icon$withStyle,
					marginRight_,
					A2(
						$author$project$UI$Icon$withBackgroundColor,
						backgroundColor_,
						A2(
							$author$project$UI$Icon$withForegroundColor,
							foregroundColor_,
							A2(
								$author$project$UI$Icon$withStyle,
								$rtfeldman$elm_css$Css$height(
									A3(
										$rtfeldman$elm_css$Css$calc,
										$rtfeldman$elm_css$Css$rem(2.5),
										$rtfeldman$elm_css$Css$plus,
										$rtfeldman$elm_css$Css$px(2))),
								A2(
									$author$project$UI$Icon$withStyle,
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									$author$project$UI$Icon$bicolor(icon))))))));
	});
var $author$project$User$CreateDialog$viewSteps = function (currentStep) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$pct(50)),
								$rtfeldman$elm_css$Css$right(
								$rtfeldman$elm_css$Css$rem(1)),
								$rtfeldman$elm_css$Css$left(
								$rtfeldman$elm_css$Css$rem(1)),
								A3(
								$rtfeldman$elm_css$Css$border3,
								$rtfeldman$elm_css$Css$px(1),
								$rtfeldman$elm_css$Css$solid,
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
							]))
					]),
				_List_Nil),
				A3($author$project$User$CreateDialog$viewStepIcon, $author$project$UI$Icons$userProfileCircleBicolor, 0, currentStep),
				A3($author$project$User$CreateDialog$viewStepIcon, $author$project$UI$Icons$userSettingsCircleBicolor, 1, currentStep)
			]));
};
var $author$project$User$CreateDialog$viewFooter = F3(
	function (translations, currentStep, disabled) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '1fr auto 1fr'),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$User$CreateDialog$viewCancelButton(translations),
					$author$project$User$CreateDialog$viewSteps(currentStep),
					A3($author$project$User$CreateDialog$viewRightButton, translations, currentStep, disabled)
				]));
	});
var $author$project$User$CreateDialog$viewProfileStep = F3(
	function (translations, repository, profileEditor) {
		var usernameExists = !$elm$core$List$isEmpty(
			A2(
				$elm$core$List$filter,
				function (user) {
					return _Utils_eq(
						user.iK,
						$author$project$User$ProfileEditor$username(profileEditor));
				},
				$author$project$User$Dict$values(
					$author$project$Environments$Repository$users(repository))));
		var passwordFulfillsRules = function () {
			var _v1 = $author$project$Auth$Password$fromString(
				$author$project$User$ProfileEditor$password(profileEditor));
			if (!_v1.$) {
				return true;
			} else {
				return false;
			}
		}();
		var chars = $elm$core$String$toList(
			$author$project$User$ProfileEditor$password(profileEditor));
		var whitespaceMessage = function () {
			var _v0 = _Utils_Tuple2(
				$elm$core$List$head(chars),
				$elm$core$List$head(
					$elm$core$List$reverse(chars)));
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var firstChar = _v0.a.a;
				var lastChar = _v0.b.a;
				return ((firstChar === ' ') || (lastChar === ' ')) ? true : false;
			} else {
				return false;
			}
		}();
		var disabledBtn = $elm$core$String$isEmpty(
			$author$project$User$ProfileEditor$username(profileEditor)) || ($elm$core$String$isEmpty(
			$author$project$User$ProfileEditor$password(profileEditor)) || ((!$author$project$User$ProfileEditor$passwordsAreEqual(profileEditor)) || ((!passwordFulfillsRules) || (usernameExists || whitespaceMessage))));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(64))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$User$CreateDialog$viewFooter, translations, 0, disabledBtn),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$User$CreateDialog$GotProfileEditorMsg,
							A3($author$project$User$ProfileEditor$viewContent, translations, usernameExists, profileEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$User$ProfileEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Users$createDialogHeader(translations),
									$author$project$User$CreateDialog$UserClickedCloseDialog)))))));
	});
var $author$project$User$RoleEditor$GotOrganisationUnitNavigationMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$RoleEditor$UserClickedEntryOrganisationUnit = {$: 1};
var $author$project$Translations$Users$Role$additionalSettings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.role.additionalSettings');
};
var $author$project$Translations$Users$Role$entryOrganisationUnit = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.role.entryOrganisationUnit');
};
var $author$project$Translations$Users$Role$noOrganisationUnitSelected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.role.noOrganisationUnitSelected');
};
var $author$project$User$RoleEditor$viewLabel = F3(
	function (label, color_, fontWeight_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$h5,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'justify-self', 'start'),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(fontWeight_)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor(color_))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $author$project$User$RoleEditor$viewEntryOrganisationUnit = F4(
	function (translations, environment, repository, _v0) {
		var entryOrganisationUnit = _v0.hT;
		var organisationUnitNavigation = _v0.d3;
		var labelText = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Translations$Users$Role$noOrganisationUnitSelected(translations),
			A2(
				$elm$core$Maybe$map,
				function (organisationUnit) {
					return organisationUnit.k8;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return A2($author$project$Environments$Repository$getOrganisationUnit, id, repository);
					},
					entryOrganisationUnit)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Bar$view(
					$author$project$UI$Bar$bar(
						$author$project$Translations$Users$Role$additionalSettings(translations))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$rem(1))
								])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$User$RoleEditor$UserClickedEntryOrganisationUnit)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$User$RoleEditor$viewLabel,
							$author$project$Translations$Users$Role$entryOrganisationUnit(translations),
							$author$project$UI$Style$Theme$grey,
							500),
							A3($author$project$User$RoleEditor$viewLabel, labelText, $author$project$UI$Style$Theme$darkGrey, 600)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$User$RoleEditor$GotOrganisationUnitNavigationMsg,
					A3(
						$author$project$UI$OrganisationUnitNavigation$view,
						$author$project$Environments$Repository$organisationUnits(repository),
						organisationUnitNavigation,
						environment))
				]));
	});
var $author$project$User$RoleEditor$CloseRoleModal = {$: 5};
var $author$project$Translations$Users$Role$assignRoles = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.role.assignRoles');
};
var $author$project$User$RoleEditor$UserClickedAddRole = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$User$RoleEditor$UserClickedRemoveRole = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$UI$Table$Row$withMaybeOnClick = F2(
	function (msg, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{bJ: msg});
	});
var $author$project$User$RoleEditor$viewRoleRow = F6(
	function (viewType, isOwnUser, rights, teamRoles_, teamRole, role) {
		var roleIsSelected = A2($author$project$Rights$Role$Ids$member, role.hc, teamRole.kH);
		var disableRemove = (!isOwnUser) ? false : $author$project$Auth$RightSet$isEmpty(
			A2(
				$author$project$Auth$RightSet$filter,
				function (right) {
					return (!right) || (right === 3);
				},
				A3(
					$elm$core$List$foldl,
					$author$project$Auth$Authorization$unifyRightSet,
					$author$project$Auth$RightSet$empty,
					A3(
						$elm$core$List$foldl,
						$author$project$Auth$Authorization$assembleData(rights),
						_Utils_Tuple2(_List_Nil, _List_Nil),
						A2(
							$elm$core$List$map,
							function (teamRole_) {
								return _Utils_update(
									teamRole,
									{
										kH: A2($author$project$Rights$Role$Ids$remove, role.hc, teamRole_.kH)
									});
							},
							$author$project$User$TeamRoles$toList(teamRoles_))).b)));
		var _v0 = (roleIsSelected && disableRemove) ? _Utils_Tuple2($author$project$UI$Style$Theme$lightGreen, $elm$core$Maybe$Nothing) : (roleIsSelected ? _Utils_Tuple2(
			$author$project$UI$Style$Theme$lightGreen,
			$elm$core$Maybe$Just(
				A2($author$project$User$RoleEditor$UserClickedRemoveRole, teamRole, role.hc))) : _Utils_Tuple2(
			$author$project$UI$Style$Theme$grey,
			$elm$core$Maybe$Just(
				A2($author$project$User$RoleEditor$UserClickedAddRole, teamRole, role.hc))));
		var color_ = _v0.a;
		var msg = _v0.b;
		return A2(
			$author$project$UI$Table$Row$withMaybeOnClick,
			msg,
			A2(
				$author$project$UI$Table$Row$withBeamColor,
				color_,
				A2(
					$author$project$UI$Table$Row$withLabelColor,
					color_,
					A2(
						$author$project$UI$Table$Row$withSubLabel,
						role.aY,
						A3($author$project$UI$Table$Row$row, viewType, role.k8, role)))));
	});
var $author$project$User$RoleEditor$viewRoleModalContent = F6(
	function (translations, viewType, repository, isOwnUser, currentTeamRoles, teamRole) {
		var rights = $author$project$Environments$Repository$getRights(repository);
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Role$emptyText(translations),
				A2(
					$author$project$UI$Table$fromList,
					A5($author$project$User$RoleEditor$viewRoleRow, viewType, isOwnUser, rights, currentTeamRoles, teamRole),
					$author$project$Rights$Rights$getRoles(rights))));
	});
var $author$project$User$RoleEditor$viewRoleModalFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$User$RoleEditor$CloseRoleModal,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$close(translations))))
			]));
};
var $author$project$User$RoleEditor$viewRoleModal = F6(
	function (translations, viewType, repository, isOwnUser, teamModal, currentTeamRoles) {
		if (!teamModal.$) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var teamId = teamModal.a;
			var _v1 = A2($author$project$User$TeamRoles$getTeamRole, teamId, currentTeamRoles);
			if (_v1.$ === 1) {
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				var teamRole = _v1.a;
				return $author$project$UI$Modal$view(
					A2(
						$author$project$UI$Modal$appendFooter,
						$author$project$User$RoleEditor$viewRoleModalFooter(translations),
						A2(
							$author$project$UI$Modal$appendContent,
							A6($author$project$User$RoleEditor$viewRoleModalContent, translations, viewType, repository, isOwnUser, currentTeamRoles, teamRole),
							A2(
								$author$project$UI$Modal$modal,
								$author$project$Translations$Users$Role$assignRoles(translations),
								$author$project$User$RoleEditor$CloseRoleModal))));
			}
		}
	});
var $author$project$User$RoleEditor$CloseTeamModal = {$: 3};
var $author$project$Translations$Users$Role$assignTeams = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.role.assignTeams');
};
var $author$project$User$RoleEditor$UserSelectedTeam = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$RoleEditor$viewTeamRow = F2(
	function (viewType, team) {
		return A2(
			$author$project$UI$Table$Row$withOnClick,
			$author$project$User$RoleEditor$UserSelectedTeam(team.k1),
			A2(
				$author$project$UI$Table$Row$withSubLabel,
				team.aY,
				A3($author$project$UI$Table$Row$row, viewType, team.k8, team)));
	});
var $author$project$User$RoleEditor$viewTeamModalContent = F4(
	function (translations, viewType, repository, currentTeamRoles) {
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Team$emptyText(translations),
				A2(
					$author$project$UI$Table$fromList,
					$author$project$User$RoleEditor$viewTeamRow(viewType),
					A2(
						$elm$core$List$filter,
						function (team) {
							return !A2(
								$elm$core$List$member,
								team.k1,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.k1;
									},
									$author$project$User$TeamRoles$toList(currentTeamRoles)));
						},
						$author$project$Rights$Rights$getTeams(
							$author$project$Environments$Repository$getRights(repository))))));
	});
var $author$project$User$RoleEditor$viewTeamModal = F5(
	function (translations, viewType, repository, teamModal, currentTeamRoles) {
		if (!teamModal) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			return $author$project$UI$Modal$view(
				A2(
					$author$project$UI$Modal$appendContent,
					A4($author$project$User$RoleEditor$viewTeamModalContent, translations, viewType, repository, currentTeamRoles),
					A2(
						$author$project$UI$Modal$modal,
						$author$project$Translations$Users$Role$assignTeams(translations),
						$author$project$User$RoleEditor$CloseTeamModal)));
		}
	});
var $author$project$User$RoleEditor$OpenTeamModal = {$: 2};
var $author$project$Translations$Users$Role$noTeamAssigned = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.role.noTeamAssigned');
};
var $author$project$User$RoleEditor$teamRoleToTriple = F3(
	function (repository, teamRole, acc) {
		var rights = $author$project$Environments$Repository$getRights(repository);
		var _v0 = A2($author$project$Rights$Rights$getTeam, teamRole.k1, rights);
		if (!_v0.$) {
			var team = _v0.a;
			var roles = A3(
				$elm$core$List$foldl,
				$author$project$Utils$Utils$reduceMaybeList,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (id) {
						return A2($author$project$Rights$Rights$getRole, id, rights);
					},
					$author$project$Rights$Role$Ids$toList(teamRole.kH)));
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple3(teamRole, team, roles),
				acc);
		} else {
			return acc;
		}
	});
var $author$project$Translations$Users$Role$teamsWithRoles = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.role.teamsWithRoles');
};
var $author$project$User$RoleEditor$OpenRoleModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$RoleEditor$UserClickedDeleteTeamRole = function (a) {
	return {$: 7, a: a};
};
var $author$project$User$RoleEditor$viewTeamIcon = F2(
	function (icon, toMsg) {
		return A2(
			$author$project$UI$Icon$withOnClick,
			toMsg,
			$author$project$UI$Icon$unicolor(icon));
	});
var $author$project$User$RoleEditor$appendDeleteIcon = F5(
	function (repository, isOwnUser, teamRoles_, teamRole, config) {
		var rights = $author$project$Environments$Repository$getRights(repository);
		var disableDelete = (!isOwnUser) ? false : $author$project$Auth$RightSet$isEmpty(
			A2(
				$author$project$Auth$RightSet$filter,
				function (right) {
					return (!right) || (right === 3);
				},
				A3(
					$elm$core$List$foldl,
					$author$project$Auth$Authorization$unifyRightSet,
					$author$project$Auth$RightSet$empty,
					A3(
						$elm$core$List$foldl,
						$author$project$Auth$Authorization$assembleData(rights),
						_Utils_Tuple2(_List_Nil, _List_Nil),
						$author$project$User$TeamRoles$toList(
							A2($author$project$User$TeamRoles$remove, teamRole, teamRoles_))).b)));
		return disableDelete ? config : A2(
			$author$project$UI$Table$Row$appendRightIcon,
			A2(
				$author$project$User$RoleEditor$viewTeamIcon,
				$author$project$UI$Icons$deleteCircle,
				$author$project$User$RoleEditor$UserClickedDeleteTeamRole(teamRole)),
			config);
	});
var $author$project$User$RoleEditor$viewTeamRoleRow = F5(
	function (viewType, repository, isOwnUser, teamRoles_, data) {
		var teamRole = data.a;
		var team = data.b;
		var roles = data.c;
		var subLabel = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.k8;
				},
				roles));
		return A5(
			$author$project$User$RoleEditor$appendDeleteIcon,
			repository,
			isOwnUser,
			teamRoles_,
			teamRole,
			A2(
				$author$project$UI$Table$Row$withRightIcon,
				A2(
					$author$project$User$RoleEditor$viewTeamIcon,
					$author$project$UI$Icons$add,
					$author$project$User$RoleEditor$OpenRoleModal(teamRole.k1)),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					subLabel,
					A3($author$project$UI$Table$Row$row, viewType, team.k8, data))));
	});
var $author$project$User$RoleEditor$viewTeamRoleTable = F5(
	function (translations, viewType, repository, isOwnUser, teamRoles_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$Bar$view(
					A2(
						$author$project$UI$Bar$withRightIcon,
						A2(
							$author$project$UI$Icon$withOnClick,
							$author$project$User$RoleEditor$OpenTeamModal,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$add)),
						$author$project$UI$Bar$bar(
							$author$project$Translations$Users$Role$teamsWithRoles(translations)))),
					$author$project$UI$Table$view(
					A2(
						$author$project$UI$Table$withEmptyText,
						$author$project$Translations$Users$Role$noTeamAssigned(translations),
						A2(
							$author$project$UI$Table$fromList,
							A4($author$project$User$RoleEditor$viewTeamRoleRow, viewType, repository, isOwnUser, teamRoles_),
							A3(
								$elm$core$List$foldl,
								$author$project$User$RoleEditor$teamRoleToTriple(repository),
								_List_Nil,
								$author$project$User$TeamRoles$toList(teamRoles_)))))
				]));
	});
var $author$project$User$RoleEditor$viewContent = F3(
	function (environment, repository, _v0) {
		var model = _v0;
		var viewType = $author$project$Environments$Environment$getViewType(environment);
		var translations = $author$project$Environments$Environment$translations(environment);
		var maybeCurrentUser = $author$project$Auth$Session$maybeUserId(
			$author$project$Environments$Environment$session(environment));
		var isOwnUser = function () {
			var _v1 = _Utils_Tuple2(model.dk, maybeCurrentUser);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var userId = _v1.a.a;
				var currentUser = _v1.b.a;
				return _Utils_eq(userId, currentUser);
			} else {
				return false;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$User$RoleEditor$viewTeamRoleTable, translations, viewType, repository, isOwnUser, model.k2),
					A4($author$project$User$RoleEditor$viewEntryOrganisationUnit, translations, environment, repository, model),
					A5($author$project$User$RoleEditor$viewTeamModal, translations, viewType, repository, model.df, model.k2),
					A6($author$project$User$RoleEditor$viewRoleModal, translations, viewType, repository, isOwnUser, model.ea, model.k2)
				]));
	});
var $author$project$User$CreateDialog$viewRoleStep = F4(
	function (translations, environment, repository, roleEditor) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(64))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$User$CreateDialog$viewFooter, translations, 1, false),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$User$CreateDialog$GotRoleEditorMsg,
							A3($author$project$User$RoleEditor$viewContent, environment, repository, roleEditor)),
						A2(
							$author$project$UI$Dialog$withIcon,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
							A2(
								$author$project$UI$Dialog$dialog,
								$author$project$Translations$Users$createDialogHeader(translations),
								$author$project$User$CreateDialog$UserClickedCloseDialog))))));
	});
var $author$project$User$CreateDialog$viewDialog = F4(
	function (translations, environment, repository, model) {
		var _v0 = model.b0;
		if (!_v0) {
			return A3($author$project$User$CreateDialog$viewProfileStep, translations, repository, model.aM);
		} else {
			return A4($author$project$User$CreateDialog$viewRoleStep, translations, environment, repository, model.da);
		}
	});
var $author$project$User$CreateDialog$view = F3(
	function (environment, repository, dialog) {
		var translations = $author$project$Environments$Environment$translations(environment);
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$User$CreateDialog$viewDialog, translations, environment, repository, model);
			default:
				var model = dialog.a;
				return A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$User$CreateDialog$viewDialog, translations, environment, repository, model);
		}
	});
var $author$project$User$Page$viewCreateDialog = F2(
	function (environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$User$CreateDialog$view, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$User$Page$GotCreateDialogMsg));
	});
var $author$project$User$EditDialog$UserClickedCloseDialog = {$: 0};
var $author$project$Translations$Users$editDialogHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.editDialogHeader');
};
var $author$project$Translations$Users$deleted = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.deleted');
};
var $author$project$User$EditDialog$viewDeleted = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Users$deleted(translations))
			]));
};
var $author$project$User$EditDialog$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$User$EditDialog$UserClickedCloseDialog,
			$author$project$UI$Button$darkGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$User$EditDialog$viewDeletedFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$User$EditDialog$viewCloseButton(translations)
			]));
};
var $author$project$User$EditDialog$viewDeletedDialog = function (translations) {
	return $author$project$UI$Dialog$view(
		A2(
			$author$project$UI$Dialog$appendFooter,
			$author$project$User$EditDialog$viewDeletedFooter(translations),
			A2(
				$author$project$UI$Dialog$appendContent,
				$author$project$User$EditDialog$viewDeleted(translations),
				A2(
					$author$project$UI$Dialog$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
					A2(
						$author$project$UI$Dialog$dialog,
						$author$project$Translations$Users$editDialogHeader(translations),
						$author$project$User$EditDialog$UserClickedCloseDialog)))));
};
var $author$project$User$EditDialog$DeleteTab = 2;
var $author$project$Translations$Users$Delete$header = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.delete.header');
};
var $author$project$User$EditDialog$viewDeleteBar = function (translations) {
	return $author$project$UI$Bar$view(
		A2(
			$author$project$UI$Bar$withLeftIcon,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$delete),
			$author$project$UI$Bar$bar(
				$author$project$Translations$Users$Delete$header(translations))));
};
var $author$project$User$EditDialog$viewDelete = function (name) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexGrow(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$flexShrink(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$paddingLeft(
						$rtfeldman$elm_css$Css$rem(1.5))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1.2)),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(name)
					]))
			]));
};
var $author$project$User$EditDialog$viewDeleteAvatar = function (image) {
	var avatar = A2(
		$elm$core$Maybe$withDefault,
		$author$project$UI$Avatar$icon(
			$author$project$UI$Icon$bicolor($author$project$UI$Icons$userCircleBicolor)),
		A2($elm$core$Maybe$map, $author$project$UI$Avatar$image, image));
	return $author$project$UI$Avatar$view(
		A2(
			$author$project$UI$Avatar$withStyle,
			$rtfeldman$elm_css$Css$flexShrink($rtfeldman$elm_css$Css$zero),
			A2(
				$author$project$UI$Avatar$withStyle,
				$rtfeldman$elm_css$Css$flexGrow($rtfeldman$elm_css$Css$zero),
				avatar)));
};
var $author$project$User$EditDialog$viewDeleteDetails = function (user) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightestRed))
					]))
			]),
		_List_fromArray(
			[
				$author$project$User$EditDialog$viewDeleteAvatar(user.iX),
				$author$project$User$EditDialog$viewDelete(user.g_)
			]));
};
var $author$project$Translations$Users$Delete$deleteCurrentUser = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.delete.deleteCurrentUser');
};
var $author$project$Translations$Users$Delete$question = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.delete.question');
};
var $author$project$User$EditDialog$viewDeleteQuestion = F2(
	function (translations, isCurrentUser) {
		var text_ = isCurrentUser ? $author$project$Translations$Users$Delete$deleteCurrentUser(translations) : $author$project$Translations$Users$Delete$question(translations);
		return A2(
			$rtfeldman$elm_css$Html$Styled$h4,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(text_)
				]));
	});
var $author$project$User$EditDialog$UserClickedApplyButton = {$: 3};
var $author$project$User$EditDialog$viewApplyButton = F2(
	function (translations, disabled) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withOnClick,
				$author$project$User$EditDialog$UserClickedApplyButton,
				A2(
					$author$project$UI$Button$disabled,
					disabled,
					$author$project$UI$Button$darkGrey(
						$author$project$Translations$Buttons$apply(translations)))));
	});
var $author$project$User$EditDialog$UserClickedCancelButton = {$: 2};
var $author$project$User$EditDialog$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$User$EditDialog$UserClickedCancelButton,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$User$EditDialog$UserClickedDeleteButton = {$: 4};
var $author$project$User$EditDialog$viewDeleteButton = F2(
	function (translations, disabled) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withOnClick,
				$author$project$User$EditDialog$UserClickedDeleteButton,
				A2(
					$author$project$UI$Button$disabled,
					disabled,
					$author$project$UI$Button$darkRed(
						$author$project$Translations$Buttons$delete(translations)))));
	});
var $author$project$User$EditDialog$viewFooter = F3(
	function (translations, tab, disabled) {
		var rightButton = (tab === 2) ? A2($author$project$User$EditDialog$viewDeleteButton, translations, disabled) : A2($author$project$User$EditDialog$viewApplyButton, translations, disabled);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$User$EditDialog$viewCancelButton(translations),
					rightButton
				]));
	});
var $author$project$User$EditDialog$RoleTab = 1;
var $author$project$UI$Icons$userProfile = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 48 48', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M16.156 13.7l.01-.067.004-.043c.203-4.413 3.093-5.073 4.799-5.073l.075-.004c2.093.047 4.62.97 4.807 5.045l.008.211.013.028c.055.695.274 4.744-1.62 6.876-.783.883-1.805 1.301-3.27 1.315-1.39-.014-2.437-.442-3.207-1.316-2.066-2.32-1.622-6.933-1.62-6.973m4.74 11.513h.242c2.28-.039 4.138-.847 5.519-2.402 2.914-3.284 2.469-8.815 2.412-9.402-.195-4.122-2.174-6.096-3.797-7.025-1.213-.697-2.612-1.065-4.174-1.096h-.123c-.86 0-2.543.138-4.17 1.065-1.646.933-3.65 2.914-3.84 7.024-.06.618-.505 6.148 2.407 9.433 1.375 1.555 3.229 2.364 5.525 2.403m15.469 9.806c-.043-1.414-.154-5.173-3.684-6.379l-.117-.035c-3.08-.784-5.705-2.589-5.732-2.607a1.59 1.59 0 00-.925-.294c-.523 0-1.017.255-1.32.684a1.615 1.615 0 00.393 2.246c.124.086 3.072 2.137 6.694 3.066 1.155.413 1.42 1.615 1.474 3.403 0 .095.002.178.008.187.006.53-.023 1.272-.092 1.792-1.484.794-5.717 2.705-12.04 2.705-6.292 0-10.55-1.916-12.046-2.713a13.208 13.208 0 01-.09-1.844l.004-.113c.059-1.856.319-3.012 1.42-3.407 3.256-.836 5.955-2.546 6.752-3.084a1.612 1.612 0 00-.927-2.929c-.333 0-.653.101-.93.297-.026.017-2.626 1.818-5.721 2.603l-.13.038c-3.52 1.21-3.636 4.96-3.678 6.404 0 .036 0 .067-.008.19-.01.552-.006 2.436.408 3.483.123.323.344.59.617.758.053.035 5.397 3.532 14.338 3.532 8.523 0 13.753-3.16 14.33-3.526a1.62 1.62 0 00.625-.766c.404-1.074.39-3.084.385-3.485l-.008-.206zm5.803-24.766h-9.716a1 1 0 100 2h8.716V33.35H38.21a1 1 0 100 2h3.958a1 1 0 001-1V11.252a1 1 0 00-1-1')
						]),
					_List_Nil)
				]));
	});
var $author$project$User$EditDialog$viewTabBarAvatar = function (image) {
	var avatar = A2(
		$elm$core$Maybe$withDefault,
		$author$project$UI$Avatar$icon(
			$author$project$UI$Icon$bicolor($author$project$UI$Icons$userCircleBicolor)),
		A2($elm$core$Maybe$map, $author$project$UI$Avatar$image, image));
	return A2(
		$author$project$UI$Avatar$withStyle,
		$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$rem(4)),
		A2(
			$author$project$UI$Avatar$withStyle,
			$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$rem(4)),
			avatar));
};
var $author$project$User$EditDialog$UserClickedTabIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$EditDialog$viewTabBarIcon = F3(
	function (icon, tab, currentTab) {
		var color = _Utils_eq(tab, currentTab) ? $author$project$UI$Style$Theme$darkGrey : $author$project$UI$Style$Theme$grey;
		return A2(
			$author$project$UI$Icon$withOnClick,
			$author$project$User$EditDialog$UserClickedTabIcon(tab),
			A2(
				$author$project$UI$Icon$withForegroundColor,
				color,
				$author$project$UI$Icon$unicolor(icon)));
	});
var $author$project$User$EditDialog$viewTabBar = F2(
	function (user, currentTab) {
		var title = $elm$core$String$isEmpty(user.g_) ? user.iK : user.g_;
		return $author$project$UI$TabBar$view(
			A2(
				$author$project$UI$TabBar$appendRightIcon,
				A3($author$project$User$EditDialog$viewTabBarIcon, $author$project$UI$Icons$delete, 2, currentTab),
				A2(
					$author$project$UI$TabBar$appendRightIcon,
					A3($author$project$User$EditDialog$viewTabBarIcon, $author$project$UI$Icons$roles, 1, currentTab),
					A2(
						$author$project$UI$TabBar$appendRightIcon,
						A3($author$project$User$EditDialog$viewTabBarIcon, $author$project$UI$Icons$userProfile, 0, currentTab),
						A2(
							$author$project$UI$TabBar$withAvatar,
							$author$project$User$EditDialog$viewTabBarAvatar(user.iX),
							$author$project$UI$TabBar$tabBar(title))))));
	});
var $author$project$User$EditDialog$viewDeleteTab = F3(
	function (translations, session, user) {
		var isCurrentUser = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (userId) {
					return _Utils_eq(userId, user.dk);
				},
				$author$project$Auth$Session$maybeUserId(session)));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(64))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$User$EditDialog$viewFooter, translations, 2, isCurrentUser),
					A2(
						$author$project$UI$Dialog$appendContent,
						$author$project$User$EditDialog$viewDeleteDetails(user),
						A2(
							$author$project$UI$Dialog$appendContent,
							A2($author$project$User$EditDialog$viewDeleteQuestion, translations, isCurrentUser),
							A2(
								$author$project$UI$Dialog$appendContent,
								$author$project$User$EditDialog$viewDeleteBar(translations),
								A2(
									$author$project$UI$Dialog$appendHeader,
									A2($author$project$User$EditDialog$viewTabBar, user, 2),
									A2(
										$author$project$UI$Dialog$withIcon,
										$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
										A2(
											$author$project$UI$Dialog$dialog,
											$author$project$Translations$Users$editDialogHeader(translations),
											$author$project$User$EditDialog$UserClickedCloseDialog)))))))));
	});
var $author$project$User$EditDialog$viewProfileTab = F3(
	function (translations, profileEditor, user) {
		var passwordFulfillsRules = function () {
			var _v2 = $author$project$Auth$Password$fromString(
				$author$project$User$ProfileEditor$password(profileEditor));
			if (!_v2.$) {
				return true;
			} else {
				return false;
			}
		}();
		var mailIsValid = function () {
			var _v1 = $author$project$User$ProfileEditor$emailAddress(profileEditor);
			if (!_v1.$) {
				var email = _v1.a;
				return $author$project$User$EmailAddress$isValid(email);
			} else {
				return true;
			}
		}();
		var chars = $elm$core$String$toList(
			$author$project$User$ProfileEditor$password(profileEditor));
		var whitespaceMessage = function () {
			var _v0 = _Utils_Tuple2(
				$elm$core$List$head(chars),
				$elm$core$List$head(
					$elm$core$List$reverse(chars)));
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var firstChar = _v0.a.a;
				var lastChar = _v0.b.a;
				return ((firstChar === ' ') || (lastChar === ' ')) ? true : false;
			} else {
				return false;
			}
		}();
		var disabled = ((!passwordFulfillsRules) && (!$elm$core$String$isEmpty(
			$author$project$User$ProfileEditor$password(profileEditor)))) || ((!mailIsValid) || ((!$author$project$User$ProfileEditor$passwordsAreEqual(profileEditor)) || whitespaceMessage));
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(64))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$User$EditDialog$viewFooter, translations, 0, disabled),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$User$EditDialog$GotProfileEditorMsg,
							A3($author$project$User$ProfileEditor$viewContent, translations, false, profileEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							$author$project$User$ProfileEditor$viewBar(translations),
							A2(
								$author$project$UI$Dialog$appendHeader,
								A2($author$project$User$EditDialog$viewTabBar, user, 0),
								A2(
									$author$project$UI$Dialog$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
									A2(
										$author$project$UI$Dialog$dialog,
										$author$project$Translations$Users$editDialogHeader(translations),
										$author$project$User$EditDialog$UserClickedCloseDialog))))))));
	});
var $author$project$User$EditDialog$viewRoleTab = F5(
	function (translations, environment, repository, roleEditor, user) {
		return $author$project$UI$Dialog$view(
			A2(
				$author$project$UI$Dialog$appendStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$minHeight(
						$rtfeldman$elm_css$Css$rem(40)),
						$rtfeldman$elm_css$Css$minWidth(
						$rtfeldman$elm_css$Css$pct(64))
					]),
				A2(
					$author$project$UI$Dialog$appendFooter,
					A3($author$project$User$EditDialog$viewFooter, translations, 1, false),
					A2(
						$author$project$UI$Dialog$appendContent,
						A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$User$EditDialog$GotRoleEditorMsg,
							A3($author$project$User$RoleEditor$viewContent, environment, repository, roleEditor)),
						A2(
							$author$project$UI$Dialog$appendHeader,
							A2($author$project$User$EditDialog$viewTabBar, user, 1),
							A2(
								$author$project$UI$Dialog$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$gear),
								A2(
									$author$project$UI$Dialog$dialog,
									$author$project$Translations$Users$editDialogHeader(translations),
									$author$project$User$EditDialog$UserClickedCloseDialog)))))));
	});
var $author$project$User$EditDialog$viewTab = F6(
	function (translations, environment, session, repository, model, user) {
		var _v0 = model.cI;
		switch (_v0) {
			case 0:
				return A3($author$project$User$EditDialog$viewProfileTab, translations, model.aM, user);
			case 1:
				return A5($author$project$User$EditDialog$viewRoleTab, translations, environment, repository, model.da, user);
			default:
				return A3($author$project$User$EditDialog$viewDeleteTab, translations, session, user);
		}
	});
var $author$project$User$EditDialog$viewDialog = F5(
	function (translations, environment, session, repository, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$EditDialog$viewDeletedDialog(translations),
			A2(
				$elm$core$Maybe$map,
				A5($author$project$User$EditDialog$viewTab, translations, environment, session, repository, model),
				A2($author$project$Environments$Repository$getUser, model.lh.dk, repository)));
	});
var $author$project$User$EditDialog$view = F4(
	function (environment, session, repository, dialog) {
		var translations = $author$project$Environments$Environment$translations(environment);
		switch (dialog.$) {
			case 0:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 1:
				var model = dialog.a;
				return A6($rtfeldman$elm_css$Html$Styled$Lazy$lazy5, $author$project$User$EditDialog$viewDialog, translations, environment, session, repository, model);
			case 2:
				var model = dialog.a;
				return A6($rtfeldman$elm_css$Html$Styled$Lazy$lazy5, $author$project$User$EditDialog$viewDialog, translations, environment, session, repository, model);
			default:
				return A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$User$EditDialog$viewDeletedDialog, translations);
		}
	});
var $author$project$User$Page$viewEditDialog = F3(
	function (environment, session, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A3($author$project$User$EditDialog$view, environment, session, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$User$Page$GotEditDialogMsg));
	});
var $author$project$User$Page$CloseUserLimitationsModel = {$: 4};
var $author$project$Translations$Users$Limitations$userLimitReachedHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.limitations.userLimitReachedHeader');
};
var $author$project$Translations$Users$Limitations$currentLimitCount = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'users.limitations.currentLimitCount',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Translations$Users$Limitations$currentUserCount = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'users.limitations.currentUserCount',
			_List_fromArray(
				[
					_Utils_Tuple2('{number', number)
				]));
	});
var $author$project$Translations$Users$Limitations$recommendationText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.limitations.recommendationText');
};
var $author$project$Translations$Users$Limitations$userLimitReachedText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.limitations.userLimitReachedText');
};
var $author$project$User$Page$viewLimitationModalContent = F3(
	function (translations, userLimitation, userCount) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Users$Limitations$userLimitReachedText(translations))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$Translations$Users$Limitations$currentLimitCount,
								translations,
								$elm$core$String$fromInt(userLimitation)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$Translations$Users$Limitations$currentUserCount,
								translations,
								$elm$core$String$fromInt(userCount)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Users$Limitations$recommendationText(translations))
						]))
				]));
	});
var $author$project$User$Page$viewLimitationModalFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$User$Page$CloseUserLimitationsModel,
					$author$project$UI$Button$lightGrey(
						$author$project$Translations$Buttons$close(translations))))
			]));
};
var $author$project$User$Page$viewLimitationModal = F2(
	function (translations, userLimitationModalState_) {
		if (!userLimitationModalState_.$) {
			var userLimitation = userLimitationModalState_.a;
			var userCount = userLimitationModalState_.b;
			return $author$project$UI$Modal$view(
				A2(
					$author$project$UI$Modal$appendStyle,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$maxWidth(
							$rtfeldman$elm_css$Css$rem(32))
						]),
					A2(
						$author$project$UI$Modal$appendFooter,
						$author$project$User$Page$viewLimitationModalFooter(translations),
						A2(
							$author$project$UI$Modal$appendContent,
							A3($author$project$User$Page$viewLimitationModalContent, translations, userLimitation, userCount),
							A2(
								$author$project$UI$Modal$modal,
								$author$project$Translations$Users$Limitations$userLimitReachedHeader(translations),
								$author$project$User$Page$CloseUserLimitationsModel)))));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Translations$Users$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'users.emptyText');
};
var $author$project$User$Page$viewAvatar = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($author$project$UI$Avatar$image),
	$elm$core$Maybe$withDefault(
		$author$project$UI$Avatar$icon(
			$author$project$UI$Icon$bicolor($author$project$UI$Icons$userCircleBicolor))));
var $author$project$User$Page$UserClickedEditIcon = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$Page$viewEditIcon = function (user) {
	return A2(
		$author$project$UI$Icon$withOnClick,
		$author$project$User$Page$UserClickedEditIcon(user),
		$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle));
};
var $author$project$User$Page$viewRow = F2(
	function (viewType, user) {
		var _v0 = $elm$core$String$isEmpty(user.g_) ? _Utils_Tuple2(user.iK, '') : _Utils_Tuple2(user.iK, user.g_);
		var mainLabel = _v0.a;
		var subLabel = _v0.b;
		return A2(
			$author$project$UI$Table$Row$withRightIcon,
			$author$project$User$Page$viewEditIcon(user),
			A2(
				$author$project$UI$Table$Row$withAvatar,
				$author$project$User$Page$viewAvatar(user.iX),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					subLabel,
					A3($author$project$UI$Table$Row$row, viewType, mainLabel, user))));
	});
var $author$project$User$Page$viewTable = F2(
	function (translations, viewType) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Environments$Repository$users,
			A2(
				$elm$core$Basics$composeR,
				$author$project$User$Dict$values,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$sortBy(
						function (u) {
							return $elm$core$String$toLower(
								_Utils_ap(u.g_, u.iK));
						}),
					A2(
						$elm$core$Basics$composeR,
						$author$project$UI$Table$fromList(
							$author$project$User$Page$viewRow(viewType)),
						A2(
							$elm$core$Basics$composeR,
							$author$project$UI$Table$withEmptyText(
								$author$project$Translations$Users$emptyText(translations)),
							$author$project$UI$Table$view)))));
	});
var $author$project$User$Page$view = F3(
	function (environment, repository, _v0) {
		var page = _v0;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				A2($author$project$User$Page$viewLimitationModal, translations, page.ho),
				A2(
					$author$project$UI$Page$appendContent,
					A4(
						$author$project$User$Page$viewEditDialog,
						environment,
						$author$project$Environments$Environment$session(environment),
						repository,
						page.cO),
					A2(
						$author$project$UI$Page$appendContent,
						A3($author$project$User$Page$viewCreateDialog, environment, repository, page.fi),
						A2(
							$author$project$UI$Page$appendContent,
							A4(
								$rtfeldman$elm_css$Html$Styled$Lazy$lazy3,
								$author$project$User$Page$viewTable,
								translations,
								$author$project$Environments$Environment$getViewType(environment),
								repository),
							A2(
								$author$project$UI$Page$appendContent,
								A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$User$Page$viewActionBar, translations),
								A2(
									$author$project$UI$Page$withIcon,
									$author$project$UI$Icon$unicolor($author$project$UI$Icons$user),
									$author$project$UI$Page$page(
										$author$project$Translations$Users$header(translations)))))))));
	});
var $author$project$Page$Page$users = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 5) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotUserPageMsg,
		kZ: $elm$core$Maybe$Just($author$project$User$Page$subscriptions),
		le: $author$project$User$Page$update,
		lm: $author$project$User$Page$view
	});
var $author$project$Page$Page$GotViewArchivedAuditPageMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Archive$ViewArchivedAudit$GotEditAuditDialogMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Archive$ViewArchivedAudit$GotTmpFileMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Archive$ViewArchivedAudit$subscriptions = function (page) {
	if (!page.$) {
		return A2($elm$core$Platform$Sub$map, $author$project$Archive$ViewArchivedAudit$GotGetAuditResult, $author$project$Utils$Http$subscriptions);
	} else {
		var model = page.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Sub$map, $author$project$Archive$ViewArchivedAudit$GotGetAuditResult, $author$project$Utils$Http$subscriptions),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Archive$ViewArchivedAudit$GotEditAuditDialogMsg,
					$author$project$Audit$EditDialog$subscriptions(model.cN)),
					A2($elm$core$Platform$Sub$map, $author$project$Archive$ViewArchivedAudit$GotTmpFileMsg, $author$project$File$TmpFile$TmpFile$subscriptions)
				]));
	}
};
var $author$project$Archive$ViewArchivedAudit$gotBackToArchiveMsg = F3(
	function (environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Archive, environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$Archive$ViewArchivedAudit$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Archive$ViewArchivedAudit$gotCollapseCheckpointGroup = F4(
	function (checkpointGroupId, environment, repository, page) {
		if (!page.$) {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		} else {
			var model = page.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: $author$project$Archive$ViewArchivedAudit$Loaded(
					_Utils_update(
						model,
						{
							bk: A2($elm$core$List$cons, checkpointGroupId, model.bk)
						})),
				ae: repository
			};
		}
	});
var $author$project$Archive$ViewArchivedAudit$gotEditAuditDialogMsg = F4(
	function (dialogMsg, environment, repository, page) {
		if (!page.$) {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		} else {
			var model = page.a;
			var result = A4($author$project$Audit$EditDialog$update, dialogMsg, environment, repository, model.cN);
			return {
				ab: A2($elm$core$Platform$Cmd$map, $author$project$Archive$ViewArchivedAudit$GotEditAuditDialogMsg, result.ab),
				ac: result.ac,
				ak: $author$project$Archive$ViewArchivedAudit$Loaded(
					_Utils_update(
						model,
						{cN: result.jn})),
				ae: result.ae
			};
		}
	});
var $author$project$Archive$ViewArchivedAudit$gotExpandCheckpointGroup = F4(
	function (checkpointGroupId, environment, repository, page) {
		if (!page.$) {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		} else {
			var model = page.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: $author$project$Archive$ViewArchivedAudit$Loaded(
					_Utils_update(
						model,
						{
							bk: A2(
								$elm$core$List$filter,
								function (id) {
									return !_Utils_eq(id, checkpointGroupId);
								},
								model.bk)
						})),
				ae: repository
			};
		}
	});
var $author$project$Archive$ViewArchivedAudit$Visible = 1;
var $author$project$File$TmpFile$TmpFile$DownloadTmpRecordFile = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$File$TmpFile$TmpFile$downloadRecordFile = F4(
	function (environment, filename, path, recordId) {
		return $author$project$File$TmpFile$TmpFile$send(
			A4(
				$author$project$File$TmpFile$TmpFile$DownloadTmpRecordFile,
				$author$project$Environments$Environment$apiVersion(environment),
				filename,
				path,
				recordId));
	});
var $author$project$Audit$Record$Records$toList = A2(
	$elm$core$Basics$composeR,
	$author$project$Audit$Record$Records$unwrap,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.cL;
		},
		$turboMaCk$any_dict$Dict$Any$toList));
var $author$project$Archive$ViewArchivedAudit$gotGetAuditResult = F4(
	function (httpMsg, environment, repository, page) {
		if (!page.$) {
			switch (httpMsg.$) {
				case 13:
					var audit = httpMsg.a;
					var addImage = F2(
						function (_v5, acc) {
							var recordId = _v5.a;
							var record = _v5.b;
							var _v4 = record.ll;
							switch (_v4.$) {
								case 8:
									var filename = _v4.a;
									return A2(
										$elm$core$List$cons,
										_Utils_Tuple2(recordId, filename),
										acc);
								case 9:
									var filename = _v4.a;
									return A2(
										$elm$core$List$cons,
										_Utils_Tuple2(recordId, filename),
										acc);
								default:
									return acc;
							}
						});
					var files = A3(
						$elm$core$List$foldl,
						addImage,
						_List_Nil,
						$author$project$Audit$Record$Records$toList(audit.io));
					var _v2 = $elm$core$List$isEmpty(files) ? _Utils_Tuple2(
						$author$project$Archive$ViewArchivedAudit$Loaded(
							{es: audit, bk: _List_Nil, cN: $author$project$Audit$EditDialog$Hidden, cS: _List_Nil, ee: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$author$project$Archive$ViewArchivedAudit$Loaded(
							{es: audit, bk: _List_Nil, cN: $author$project$Audit$EditDialog$Hidden, cS: _List_Nil, ee: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								function (_v3) {
									var recordId = _v3.a;
									var filename = _v3.b;
									return A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Archive$ViewArchivedAudit$GotTmpFileMsg,
										A4(
											$author$project$File$TmpFile$TmpFile$downloadRecordFile,
											environment,
											filename,
											A2($author$project$File$File$getAuditFilePath, audit.gm, recordId),
											recordId));
								},
								files)));
					var newPage = _v2.a;
					var cmds = _v2.b;
					return {ab: cmds, ac: environment, ak: newPage, ae: repository};
				case 2:
					var status = httpMsg.a;
					var responseMessage = httpMsg.b;
					var resultType = httpMsg.c;
					if (status === 404) {
						return {
							ab: $elm$core$Platform$Cmd$none,
							ac: environment,
							ak: $author$project$Archive$ViewArchivedAudit$LoadingAudit(1),
							ae: repository
						};
					} else {
						var _v6 = A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Environments$ErrorHandling$Id$from,
							$author$project$Environments$Environment$generateUuid(environment));
						var newId = _v6.a;
						var updatedEnvironment = _v6.b;
						var newError = {
							gg: resultType,
							gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
							gH: 'Archive.ViewArchivedAudit.elm',
							gK: 'gotGetAuditResult',
							fw: newId
						};
						return {
							ab: $elm$core$Platform$Cmd$none,
							ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
							ak: page,
							ae: repository
						};
					}
				case 0:
					var resultType = httpMsg.a;
					var _v7 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v7.a;
					var updatedEnvironment = _v7.b;
					var newError = {
						gg: 'Unknown return from Javascript in http handler. index.js -> initHttpPort',
						gE: $author$project$Environments$ErrorHandling$Error$OtherError(resultType),
						gH: 'Archive.ViewArchivedAudit.elm',
						gK: 'gotGetAuditResult',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
						ak: page,
						ae: repository
					};
				case 1:
					var decodeError = httpMsg.a;
					var _v8 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Environments$ErrorHandling$Id$from,
						$author$project$Environments$Environment$generateUuid(environment));
					var newId = _v8.a;
					var updatedEnvironment = _v8.b;
					var newError = {
						gg: 'Error while Decoding incoming http request',
						gE: $author$project$Environments$ErrorHandling$Error$DecodeError(decodeError),
						gH: 'Archive.ViewArchivedAudit.elm',
						gK: 'gotGetAuditResult',
						fw: newId
					};
					return {
						ab: $elm$core$Platform$Cmd$none,
						ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
						ak: page,
						ae: repository
					};
				default:
					return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
			}
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		}
	});
var $author$project$Archive$ViewArchivedAudit$gotTmpFileMsg = F4(
	function (msg, environment, repository, page) {
		var _v0 = _Utils_Tuple2(page, msg);
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var loadedModel = _v0.a.a;
			var _v1 = _v0.b;
			var blobUrl = _v1.a;
			var recordId = _v1.b;
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: $author$project$Archive$ViewArchivedAudit$Loaded(
					_Utils_update(
						loadedModel,
						{
							cS: A2(
								$elm$core$List$cons,
								_Utils_Tuple2(recordId, blobUrl),
								loadedModel.cS)
						})),
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		}
	});
var $author$project$Archive$ViewArchivedAudit$userClickedEditIcon = F4(
	function (audit, environment, repository, page) {
		if (!page.$) {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		} else {
			var model = page.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: $author$project$Archive$ViewArchivedAudit$Loaded(
					_Utils_update(
						model,
						{
							cN: A5(
								$author$project$Audit$EditDialog$show,
								environment,
								repository,
								1,
								$author$project$Environments$Environment$timeZone(environment),
								audit)
						})),
				ae: repository
			};
		}
	});
var $author$project$Archive$ViewArchivedAudit$changeSelectOrganisationUnit = F2(
	function (organisationUnit, currentlySelectedOrganisationUnit) {
		if (!currentlySelectedOrganisationUnit.$) {
			var selectedOrganisationUnit = currentlySelectedOrganisationUnit.a;
			return _Utils_eq(selectedOrganisationUnit, organisationUnit.km) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(organisationUnit.km);
		} else {
			return $elm$core$Maybe$Just(organisationUnit.km);
		}
	});
var $author$project$Archive$ViewArchivedAudit$userClickedOrganisationUnitTile = F4(
	function (organisationUnit, environment, repository, page) {
		if (!page.$) {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		} else {
			var model = page.a;
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: $author$project$Archive$ViewArchivedAudit$Loaded(
					_Utils_update(
						model,
						{
							ee: A2($author$project$Archive$ViewArchivedAudit$changeSelectOrganisationUnit, organisationUnit, model.ee)
						})),
				ae: repository
			};
		}
	});
var $author$project$Archive$ViewArchivedAudit$update = function (msg) {
	switch (msg.$) {
		case 0:
			var organisationUnit = msg.a;
			return $author$project$Archive$ViewArchivedAudit$userClickedOrganisationUnitTile(organisationUnit);
		case 1:
			var id = msg.a;
			return $author$project$Archive$ViewArchivedAudit$gotCollapseCheckpointGroup(id);
		case 2:
			var id = msg.a;
			return $author$project$Archive$ViewArchivedAudit$gotExpandCheckpointGroup(id);
		case 3:
			var audit = msg.a;
			return $author$project$Archive$ViewArchivedAudit$userClickedEditIcon(audit);
		case 4:
			var dialogMsg = msg.a;
			return $author$project$Archive$ViewArchivedAudit$gotEditAuditDialogMsg(dialogMsg);
		case 5:
			var httpMsg = msg.a;
			return $author$project$Archive$ViewArchivedAudit$gotGetAuditResult(httpMsg);
		case 6:
			return $author$project$Archive$ViewArchivedAudit$gotBackToArchiveMsg;
		default:
			var tmpFileMsg = msg.a;
			return $author$project$Archive$ViewArchivedAudit$gotTmpFileMsg(tmpFileMsg);
	}
};
var $author$project$Translations$Archive$auditPageHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.auditPageHeader');
};
var $author$project$Archive$ViewArchivedAudit$CollapseCheckpointGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Archive$ViewArchivedAudit$ExpandCheckpointGroup = function (a) {
	return {$: 2, a: a};
};
var $author$project$Archive$ViewArchivedAudit$viewBar = F2(
	function (checkpointGroup, model) {
		var msg = A2($elm$core$List$member, checkpointGroup.cC, model.bk) ? $author$project$Archive$ViewArchivedAudit$ExpandCheckpointGroup(checkpointGroup.cC) : $author$project$Archive$ViewArchivedAudit$CollapseCheckpointGroup(checkpointGroup.cC);
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
				A2(
					$author$project$UI$Bar$withOnBarClick,
					$elm$core$Maybe$Just(msg),
					$author$project$UI$Bar$bar(checkpointGroup.k8))));
	});
var $author$project$CheckpointData$Checkpoint$CheckpointRow$withAlternativeFileLookup = F2(
	function (lookup, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fa: lookup});
	});
var $author$project$Archive$ViewArchivedAudit$viewCheckpoint = F4(
	function (translations, records, downloadedFiles, checkpoint) {
		var record = A2($author$project$Audit$Record$Records$getRecordFor, checkpoint.i5, records);
		return A2(
			$author$project$CheckpointData$Checkpoint$CheckpointRow$view,
			translations,
			A2(
				$author$project$CheckpointData$Checkpoint$CheckpointRow$withAlternativeFileLookup,
				$elm$core$Maybe$Just(downloadedFiles),
				A2(
					$author$project$CheckpointData$Checkpoint$CheckpointRow$withRecord,
					record,
					$author$project$CheckpointData$Checkpoint$CheckpointRow$checkpointRow(checkpoint))));
	});
var $author$project$Archive$ViewArchivedAudit$viewCheckpoints = F4(
	function (translations, checkpointGroup, audit, downloadedFiles) {
		var checkpointList = A2(
			$elm$core$List$filter,
			function (checkpoint) {
				return _Utils_eq(checkpoint.cC, checkpointGroup.cC);
			},
			audit.ff.i6);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				A3($author$project$Archive$ViewArchivedAudit$viewCheckpoint, translations, audit.io, downloadedFiles),
				checkpointList));
	});
var $author$project$Archive$ViewArchivedAudit$viewCheckpointGroup = F4(
	function (translations, model, audit, checkpointGroup) {
		var subContent = A2($elm$core$List$member, checkpointGroup.cC, model.bk) ? $rtfeldman$elm_css$Html$Styled$text('') : A4($author$project$Archive$ViewArchivedAudit$viewCheckpoints, translations, checkpointGroup, audit, model.cS);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Archive$ViewArchivedAudit$viewBar, checkpointGroup, model),
					subContent
				]));
	});
var $author$project$Archive$ViewArchivedAudit$UserClickedOrganisationUnitTile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Archive$ViewArchivedAudit$viewCheckpointGroupOfOrganisationUnit = F5(
	function (organisationUnitId, translations, model, audit, checkpointGroup) {
		if (_Utils_eq(checkpointGroup.km, organisationUnitId)) {
			var subContent = A2($elm$core$List$member, checkpointGroup.cC, model.bk) ? $rtfeldman$elm_css$Html$Styled$text('') : A4($author$project$Archive$ViewArchivedAudit$viewCheckpoints, translations, checkpointGroup, audit, model.cS);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						A2($author$project$Archive$ViewArchivedAudit$viewBar, checkpointGroup, model),
						subContent
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Archive$ViewArchivedAudit$viewMultipleOrganisationUnits = F5(
	function (ouIds, audit, translations, model, repository) {
		var _v0 = model.ee;
		if (!_v0.$) {
			var selectedOrganisationUnit = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$UI$OUTiles$view,
					repository,
					A2(
						$author$project$UI$OUTiles$withOnClickMsg,
						$elm$core$Maybe$Just($author$project$Archive$ViewArchivedAudit$UserClickedOrganisationUnitTile),
						A2($author$project$UI$OUTiles$ouTilesRow, selectedOrganisationUnit, ouIds))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$Archive$ViewArchivedAudit$viewCheckpointGroupOfOrganisationUnit, selectedOrganisationUnit, translations, model, audit),
						audit.ff.gt))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$UI$OUTiles$view,
					repository,
					A2(
						$author$project$UI$OUTiles$withOnClickMsg,
						$elm$core$Maybe$Just($author$project$Archive$ViewArchivedAudit$UserClickedOrganisationUnitTile),
						$author$project$UI$OUTiles$ouTilesGrid(ouIds)))
				]);
		}
	});
var $author$project$Archive$ViewArchivedAudit$viewContent = F4(
	function (translations, model, repository, audit) {
		var maybeAddOrganisationUnitId = F2(
			function (group, idList) {
				return A2($elm$core$List$member, group.km, idList) ? idList : A2($elm$core$List$cons, group.km, idList);
			});
		var organisationUnitIds = A3($elm$core$List$foldl, maybeAddOrganisationUnitId, _List_Nil, audit.ff.gt);
		return (!$elm$core$List$length(organisationUnitIds)) ? _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$PerformAudit$noOrganisationUnitErr(translations))
			]) : (($elm$core$List$length(organisationUnitIds) === 1) ? A2(
			$elm$core$List$map,
			A3($author$project$Archive$ViewArchivedAudit$viewCheckpointGroup, translations, model, audit),
			audit.ff.gt) : A5($author$project$Archive$ViewArchivedAudit$viewMultipleOrganisationUnits, organisationUnitIds, audit, translations, model, repository));
	});
var $author$project$Archive$ViewArchivedAudit$viewEditAuditDialog = F2(
	function (environment, repository) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Audit$EditDialog$view, environment, repository),
			$rtfeldman$elm_css$Html$Styled$map($author$project$Archive$ViewArchivedAudit$GotEditAuditDialogMsg));
	});
var $author$project$Translations$Archive$loadingAudit = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.loadingAudit');
};
var $author$project$Archive$ViewArchivedAudit$viewLoading = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Archive$loadingAudit(translations))
			]));
};
var $author$project$Archive$ViewArchivedAudit$GotBackToArchiveMsg = {$: 6};
var $author$project$Translations$Archive$auditNotFoundHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'archive.auditNotFoundHeader');
};
var $author$project$Archive$ViewArchivedAudit$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Archive$ViewArchivedAudit$GotBackToArchiveMsg,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$Archive$ViewArchivedAudit$viewModalFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Archive$ViewArchivedAudit$viewCloseButton(translations)
			]));
};
var $author$project$Archive$ViewArchivedAudit$viewNotFoundContent = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Archive$auditNotFoundText(translations))
			]));
};
var $author$project$Archive$ViewArchivedAudit$viewNotFoundModal = F2(
	function (translations, modal) {
		if (!modal) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			return $author$project$UI$Modal$view(
				A2(
					$author$project$UI$Modal$appendFooter,
					$author$project$Archive$ViewArchivedAudit$viewModalFooter(translations),
					A2(
						$author$project$UI$Modal$appendContent,
						$author$project$Archive$ViewArchivedAudit$viewNotFoundContent(translations),
						A2(
							$author$project$UI$Modal$modal,
							$author$project$Translations$Archive$auditNotFoundHeader(translations),
							$author$project$Archive$ViewArchivedAudit$GotBackToArchiveMsg))));
		}
	});
var $author$project$Archive$ViewArchivedAudit$UserClickedEditIcon = function (a) {
	return {$: 3, a: a};
};
var $author$project$Archive$ViewArchivedAudit$viewEditIcon = function (audit) {
	return A2(
		$author$project$UI$Icon$withOnClick,
		$author$project$Archive$ViewArchivedAudit$UserClickedEditIcon(audit),
		$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle));
};
var $author$project$Archive$ViewArchivedAudit$viewTabBar = F3(
	function (environment, repository, audit) {
		var withEditAudit = function (config) {
			var allowedToEditAudit = A2(
				$elm$core$List$member,
				true,
				A2(
					$elm$core$List$map,
					function (organisationUnitId) {
						return A3(
							$author$project$Auth$Authorization$authorize,
							$author$project$Environments$Environment$userRights(environment),
							7,
							organisationUnitId) || A3(
							$author$project$Auth$Authorization$authorize,
							$author$project$Environments$Environment$userRights(environment),
							9,
							organisationUnitId);
					},
					A2(
						$elm$core$List$map,
						function (organisationUnitId) {
							return organisationUnitId.km;
						},
						$author$project$OrganisationUnit$Hierarchy$organisationUnits(
							$author$project$OrganisationUnit$OrganisationUnits$hierarchy(
								$author$project$Environments$Repository$organisationUnits(repository))))));
			return allowedToEditAudit ? A2(
				$author$project$UI$TabBar$appendRightIcon,
				$author$project$Archive$ViewArchivedAudit$viewEditIcon(audit),
				config) : config;
		};
		var timeZone = $author$project$Environments$Environment$timeZone(environment);
		var deadlineTime = $author$project$Date_Time$NaiveTime$format(
			A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, audit.hI));
		var deadlineDate = $author$project$Date_Time$NaiveDate$format(
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, audit.hI));
		var subLabel = deadlineDate + (' | ' + (deadlineTime + ' Uhr'));
		return $author$project$UI$TabBar$view(
			withEditAudit(
				A2(
					$author$project$UI$TabBar$withId,
					audit.fw,
					A2(
						$author$project$UI$TabBar$withSubTitle,
						subLabel,
						$author$project$UI$TabBar$tabBar(audit.k8)))));
	});
var $author$project$Archive$ViewArchivedAudit$view = F3(
	function (environment, repository, page) {
		var translations = $author$project$Environments$Environment$translations(environment);
		if (!page.$) {
			var notFoundModal = page.a;
			return A2(
				$author$project$UI$Page$view,
				environment,
				A2(
					$author$project$UI$Page$appendContent,
					A2($author$project$Archive$ViewArchivedAudit$viewNotFoundModal, translations, notFoundModal),
					A2(
						$author$project$UI$Page$appendContent,
						$author$project$Archive$ViewArchivedAudit$viewLoading(translations),
						A2(
							$author$project$UI$Page$withIcon,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$audits),
							$author$project$UI$Page$page(
								$author$project$Translations$Archive$auditPageHeader(translations))))));
		} else {
			var model = page.a;
			return A2(
				$author$project$UI$Page$view,
				environment,
				A2(
					$author$project$UI$Page$appendContent,
					A3($author$project$Archive$ViewArchivedAudit$viewEditAuditDialog, environment, repository, model.cN),
					A2(
						$author$project$UI$Page$appendContentList,
						A4($author$project$Archive$ViewArchivedAudit$viewContent, translations, model, repository, model.es),
						A2(
							$author$project$UI$Page$appendHeader,
							A3($author$project$Archive$ViewArchivedAudit$viewTabBar, environment, repository, model.es),
							A2(
								$author$project$UI$Page$withIcon,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$audits),
								$author$project$UI$Page$page(
									$author$project$Translations$Archive$auditPageHeader(translations)))))));
		}
	});
var $author$project$Page$Page$viewArchivedAudit = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 12) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotViewArchivedAuditPageMsg,
		kZ: $elm$core$Maybe$Just($author$project$Archive$ViewArchivedAudit$subscriptions),
		le: $author$project$Archive$ViewArchivedAudit$update,
		lm: $author$project$Archive$ViewArchivedAudit$view
	});
var $author$project$Page$Page$GotViewCheckpointHistoryPageMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$CheckpointHistory$Page$GotTmpFileMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointHistory$Page$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$core$Platform$Sub$map, $author$project$CheckpointHistory$Page$GotGetCheckpointHistoryResult, $author$project$Utils$Http$subscriptions),
				A2($elm$core$Platform$Sub$map, $author$project$CheckpointHistory$Page$GotTmpFileMsg, $author$project$File$TmpFile$TmpFile$subscriptions)
			]));
};
var $author$project$CheckpointHistory$Page$PageError = {$: 2};
var $author$project$CheckpointHistory$Page$PageLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointHistory$Page$gotGetCheckpointHistoryResult = F4(
	function (result, environment, repository, page) {
		switch (result.$) {
			case 0:
				var resultType = result.a;
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v1.a;
				var updatedEnvironment = _v1.b;
				var newError = {
					gg: 'Unknown return from Javascript in http handler. index.js -> initHttpPort',
					gE: $author$project$Environments$ErrorHandling$Error$OtherError(resultType),
					gH: 'CheckpointHistory.Page.elm',
					gK: 'gotGetAuditsResult',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					ak: $author$project$CheckpointHistory$Page$PageError,
					ae: repository
				};
			case 1:
				var decodeError = result.a;
				var _v2 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v2.a;
				var updatedEnvironment = _v2.b;
				var newError = {
					gg: 'Error while Decoding incoming http request',
					gE: $author$project$Environments$ErrorHandling$Error$DecodeError(decodeError),
					gH: 'CheckpointHistory.Page.elm',
					gK: 'gotGetAuditsResult',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					ak: $author$project$CheckpointHistory$Page$PageError,
					ae: repository
				};
			case 2:
				var status = result.a;
				var responseMessage = result.b;
				var resultType = result.c;
				var _v3 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$ErrorHandling$Id$from,
					$author$project$Environments$Environment$generateUuid(environment));
				var newId = _v3.a;
				var updatedEnvironment = _v3.b;
				var newError = {
					gg: resultType,
					gE: A2($author$project$Environments$ErrorHandling$Error$HttpError, status, responseMessage),
					gH: 'CheckpointHistory.Page.elm',
					gK: 'gotGetAuditsResult',
					fw: newId
				};
				return {
					ab: $elm$core$Platform$Cmd$none,
					ac: A2($author$project$Environments$Environment$addError, newError, updatedEnvironment),
					ak: $author$project$CheckpointHistory$Page$PageError,
					ae: repository
				};
			case 31:
				var checkpointHistory = result.a;
				var addImage = F2(
					function (auditRecord, acc) {
						var _v6 = auditRecord.ct.ll;
						switch (_v6.$) {
							case 8:
								var filename = _v6.a;
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple3(auditRecord.gm, auditRecord.ct.bK, filename),
									acc);
							case 9:
								var filename = _v6.a;
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple3(auditRecord.gm, auditRecord.ct.bK, filename),
									acc);
							default:
								return acc;
						}
					});
				var files = A3($elm$core$List$foldl, addImage, _List_Nil, checkpointHistory.iV);
				var fileCmds = $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						function (_v5) {
							var auditId = _v5.a;
							var recordId = _v5.b;
							var filename = _v5.c;
							return A2(
								$elm$core$Platform$Cmd$map,
								$author$project$CheckpointHistory$Page$GotTmpFileMsg,
								A4(
									$author$project$File$TmpFile$TmpFile$downloadRecordFile,
									environment,
									filename,
									A2($author$project$File$File$getAuditFilePath, auditId, recordId),
									recordId));
						},
						files));
				switch (page.$) {
					case 0:
						var checkpointId = page.a;
						return {
							ab: fileCmds,
							ac: environment,
							ak: $author$project$CheckpointHistory$Page$PageLoaded(
								{dt: checkpointHistory, i5: checkpointId, cS: _List_Nil}),
							ae: repository
						};
					case 1:
						var model = page.a;
						return {
							ab: fileCmds,
							ac: environment,
							ak: $author$project$CheckpointHistory$Page$PageLoaded(
								_Utils_update(
									model,
									{dt: checkpointHistory})),
							ae: repository
						};
					default:
						return {
							ab: fileCmds,
							ac: environment,
							ak: $author$project$CheckpointHistory$Page$PageLoaded(
								{dt: checkpointHistory, i5: checkpointHistory.i5, cS: _List_Nil}),
							ae: repository
						};
				}
			default:
				return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		}
	});
var $author$project$CheckpointHistory$Page$gotTmpFileMsg = F4(
	function (msg, environment, repository, page) {
		var _v0 = _Utils_Tuple2(page, msg);
		if ((_v0.a.$ === 1) && (!_v0.b.$)) {
			var loadedModel = _v0.a.a;
			var _v1 = _v0.b;
			var blobUrl = _v1.a;
			var recordId = _v1.b;
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: environment,
				ak: $author$project$CheckpointHistory$Page$PageLoaded(
					_Utils_update(
						loadedModel,
						{
							cS: A2(
								$elm$core$List$cons,
								_Utils_Tuple2(recordId, blobUrl),
								loadedModel.cS)
						})),
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		}
	});
var $author$project$OrganisationUnit$Hierarchy$getPredecessorIdsOf = F2(
	function (organisationUnit, hierarchy) {
		var withParentIdsOf = F2(
			function (organisationUnit_, organisationUnitIds) {
				return A2(
					$elm$core$Maybe$withDefault,
					organisationUnitIds,
					A2(
						$elm$core$Maybe$map,
						function (parent) {
							return A2(
								withParentIdsOf,
								parent,
								A2($author$project$OrganisationUnit$Ids$insert, parent.km, organisationUnitIds));
						},
						$author$project$Utils$Maybe$join(
							A2(
								$elm$core$Maybe$map,
								function (parentId) {
									return A2($author$project$OrganisationUnit$Hierarchy$getOrganisationUnit, parentId, hierarchy);
								},
								organisationUnit_.fV))));
			});
		return A2(withParentIdsOf, organisationUnit, $author$project$OrganisationUnit$Ids$empty);
	});
var $author$project$CheckpointData$CheckpointGroup$Ids$singleton = function (id) {
	return A2($author$project$CheckpointData$CheckpointGroup$Ids$insert, id, $author$project$CheckpointData$CheckpointGroup$Ids$empty);
};
var $author$project$CheckpointHistory$Page$userClickedViewParentOrganisationUnit = F5(
	function (organisationUnit, checkpointGroup, environment, repository, page) {
		if (page.$ === 1) {
			var prevOrganisationUnits = A2(
				$author$project$OrganisationUnit$Ids$insert,
				organisationUnit.km,
				A2(
					$author$project$OrganisationUnit$Hierarchy$getPredecessorIdsOf,
					organisationUnit,
					$author$project$OrganisationUnit$OrganisationUnits$hierarchy(
						$author$project$Environments$Repository$organisationUnits(repository))));
			var checkpointOverview = $author$project$Environments$Route$CheckpointOverview(
				{
					b9: $author$project$CheckpointData$CheckpointGroup$Ids$singleton(checkpointGroup.cC),
					ca: prevOrganisationUnits
				});
			return {
				ab: $elm$core$Platform$Cmd$none,
				ac: A2($author$project$Environments$Environment$navigateTo, checkpointOverview, environment),
				ak: page,
				ae: repository
			};
		} else {
			return {ab: $elm$core$Platform$Cmd$none, ac: environment, ak: page, ae: repository};
		}
	});
var $author$project$CheckpointHistory$Page$update = function (msg) {
	switch (msg.$) {
		case 0:
			var result = msg.a;
			return $author$project$CheckpointHistory$Page$gotGetCheckpointHistoryResult(result);
		case 1:
			var organisationUnit = msg.a;
			var checkpointGroup = msg.b;
			return A2($author$project$CheckpointHistory$Page$userClickedViewParentOrganisationUnit, organisationUnit, checkpointGroup);
		default:
			var tmpFileMsg = msg.a;
			return $author$project$CheckpointHistory$Page$gotTmpFileMsg(tmpFileMsg);
	}
};
var $author$project$Translations$CheckpointHistory$historyHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointHistory.historyHeader');
};
var $author$project$CheckpointHistory$Page$viewErrorText = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Archive$error(translations))
			]));
};
var $author$project$CheckpointHistory$Page$viewError = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return A2(
		$author$project$UI$Page$view,
		environment,
		A2(
			$author$project$UI$Page$appendContent,
			$author$project$CheckpointHistory$Page$viewErrorText(translations),
			A2(
				$author$project$UI$Page$withIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedDocument),
				$author$project$UI$Page$page(
					$author$project$Translations$CheckpointHistory$historyHeader(translations)))));
};
var $author$project$CheckpointHistory$Page$UserClickedViewParentOrganisationUnit = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$UI$Bar$withOnLabelClick = F2(
	function (maybeMsg, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{g5: maybeMsg});
	});
var $author$project$CheckpointHistory$Page$viewBar = F2(
	function (repository, checkpointId) {
		var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
		var maybeCheckpoint = A2($author$project$CheckpointData$CheckpointData$getCheckpoint, checkpointId, checkpointData);
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			A2(
				$elm$core$Maybe$map,
				function (checkpoint) {
					return _Utils_Tuple2(
						A2($author$project$CheckpointData$CheckpointData$getCheckpointGroup, checkpoint.cC, checkpointData),
						_List_fromArray(
							[checkpoint.k8]));
				},
				maybeCheckpoint));
		var maybeCheckpointGroup = _v0.a;
		var listWithCheckpointTitle = _v0.b;
		var _v1 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2($elm$core$Maybe$Nothing, listWithCheckpointTitle),
			A2(
				$elm$core$Maybe$map,
				function (checkpointGroup) {
					return _Utils_Tuple2(
						A2($author$project$Environments$Repository$getOrganisationUnit, checkpointGroup.km, repository),
						A2($elm$core$List$cons, checkpointGroup.k8, listWithCheckpointTitle));
				},
				maybeCheckpointGroup));
		var maybeOrganisationUnit = _v1.a;
		var listWithCheckpointGroupTitle = _v1.b;
		var listWithOrganisationUnitTitle = A2(
			$elm$core$Maybe$withDefault,
			listWithCheckpointGroupTitle,
			A2(
				$elm$core$Maybe$map,
				function (organisationUnit) {
					return A2($elm$core$List$cons, organisationUnit.k8, listWithCheckpointGroupTitle);
				},
				maybeOrganisationUnit));
		var withBarMsg = function (barConfig) {
			var _v2 = _Utils_Tuple2(maybeOrganisationUnit, maybeCheckpointGroup);
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var organisationUnit = _v2.a.a;
				var checkpointGroup = _v2.b.a;
				return A2(
					$author$project$UI$Bar$withOnLabelClick,
					$elm$core$Maybe$Just(
						A2($author$project$CheckpointHistory$Page$UserClickedViewParentOrganisationUnit, organisationUnit, checkpointGroup)),
					barConfig);
			} else {
				return barConfig;
			}
		};
		return $author$project$UI$Bar$view(
			withBarMsg(
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$zIndex(
						$rtfeldman$elm_css$Css$int(1)),
					A2(
						$author$project$UI$Bar$withStyle,
						$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
						A2(
							$author$project$UI$Bar$withStyle,
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
							$author$project$UI$Bar$bar(
								A2($elm$core$String$join, ' >> ', listWithOrganisationUnitTitle)))))));
	});
var $author$project$UI$Table$Row$setAdditionalRowStyle = F2(
	function (additionalRowStyle, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{gh: additionalRowStyle});
	});
var $author$project$CheckpointHistory$Page$viewChecked = $author$project$UI$Icon$view(
	A2(
		$author$project$UI$Icon$withStyle,
		$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$rem(3)),
		A2(
			$author$project$UI$Icon$withForegroundColor,
			$author$project$UI$Style$Theme$green,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedCircle))));
var $author$project$CheckpointHistory$Page$viewUnchecked = $author$project$UI$Icon$view(
	A2(
		$author$project$UI$Icon$withStyle,
		$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$rem(3)),
		A2(
			$author$project$UI$Icon$withForegroundColor,
			$author$project$UI$Style$Theme$red,
			$author$project$UI$Icon$unicolor($author$project$UI$Icons$uncheckedCircle))));
var $author$project$CheckpointHistory$Page$viewCheckbox = function (bool) {
	var content = bool ? $author$project$CheckpointHistory$Page$viewChecked : $author$project$CheckpointHistory$Page$viewUnchecked;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$rtfeldman$elm_css$Css$displayFlex]))
			]),
		_List_fromArray(
			[content]));
};
var $author$project$CheckpointHistory$Page$renderSpan = F2(
	function (styles, string) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(600)),
								$rtfeldman$elm_css$Css$marginRight(
								$rtfeldman$elm_css$Css$rem(1))
							]),
						styles))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(string)
				]));
	});
var $author$project$CheckpointHistory$Page$viewDate = function (naiveDate) {
	return A2(
		$author$project$CheckpointHistory$Page$renderSpan,
		_List_Nil,
		$author$project$Date_Time$NaiveDate$format(naiveDate));
};
var $author$project$CheckpointHistory$Page$viewFloat = function (_float) {
	var changedFloat = A3(
		$elm$core$String$replace,
		'.',
		',',
		$elm$core$String$fromFloat(_float));
	return A2($author$project$CheckpointHistory$Page$renderSpan, _List_Nil, changedFloat);
};
var $author$project$CheckpointHistory$Page$viewImage = F2(
	function (recordId, fileUrls) {
		var content = A2(
			$elm$core$Maybe$withDefault,
			$rtfeldman$elm_css$Html$Styled$text('loading file'),
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var url = _v1.b;
					return A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$maxWidth(
										$rtfeldman$elm_css$Css$rem(13))
									])),
								$rtfeldman$elm_css$Html$Styled$Attributes$src(url)
							]),
						_List_Nil);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var recordId_ = _v0.a;
							return _Utils_eq(recordId_, recordId);
						},
						fileUrls))));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$CheckpointHistory$Page$viewOption = function (option) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginRight(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$rem(1))
					]))
			]),
		_List_fromArray(
			[
				$author$project$UI$Checkbox$view(
				A2(
					$author$project$UI$Checkbox$disabled,
					true,
					A2(
						$author$project$UI$Checkbox$checked,
						true,
						$author$project$UI$Checkbox$labeled(option.hl))))
			]));
};
var $author$project$CheckpointHistory$Page$viewMultiSelect = function (options) {
	var cssList = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$start),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(1)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(75))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(cssList)
			]),
		A2($elm$core$List$map, $author$project$CheckpointHistory$Page$viewOption, options));
};
var $author$project$CheckpointHistory$Page$viewSelect = function (option) {
	var cssList = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$start),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(1))
		]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(cssList)
			]),
		A2(
			$elm$core$List$map,
			$author$project$CheckpointHistory$Page$viewOption,
			_List_fromArray(
				[option])));
};
var $author$project$CheckpointHistory$Page$viewTextMemo = function (value) {
	return A2($author$project$CheckpointHistory$Page$renderSpan, _List_Nil, value);
};
var $author$project$CheckpointHistory$Page$viewTextRow = function (value) {
	return A2(
		$author$project$CheckpointHistory$Page$renderSpan,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap)
			]),
		value);
};
var $author$project$CheckpointHistory$Page$viewTime = function (naiveTime) {
	return A2(
		$author$project$CheckpointHistory$Page$renderSpan,
		_List_Nil,
		$author$project$Date_Time$NaiveTime$toString(naiveTime));
};
var $author$project$CheckpointHistory$Page$viewRecordValue = F3(
	function (recordId, fileUrls, value) {
		switch (value.$) {
			case 0:
				var _float = value.a;
				return $author$project$CheckpointHistory$Page$viewFloat(_float);
			case 1:
				var str = value.a;
				return $author$project$CheckpointHistory$Page$viewTextRow(str);
			case 2:
				var str = value.a;
				return $author$project$CheckpointHistory$Page$viewTextMemo(str);
			case 3:
				var bool = value.a;
				return $author$project$CheckpointHistory$Page$viewCheckbox(bool);
			case 4:
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 5:
				var option = value.a;
				return $author$project$CheckpointHistory$Page$viewSelect(option);
			case 6:
				var options = value.a;
				return $author$project$CheckpointHistory$Page$viewMultiSelect(options);
			case 7:
				var date = value.a;
				return $author$project$CheckpointHistory$Page$viewDate(date);
			case 8:
				return A2($author$project$CheckpointHistory$Page$viewImage, recordId, fileUrls);
			case 9:
				return A2($author$project$CheckpointHistory$Page$viewImage, recordId, fileUrls);
			default:
				var time = value.a;
				return $author$project$CheckpointHistory$Page$viewTime(time);
		}
	});
var $author$project$CheckpointHistory$Page$viewRow = F5(
	function (translations, viewType, timeZone, fileUrls, auditRecord) {
		var recordTime = $author$project$Date_Time$NaiveTime$format(
			A2($author$project$Date_Time$NaiveTime$fromPosix, timeZone, auditRecord.ct.g8));
		var recordDate = $author$project$Date_Time$NaiveDate$format(
			A2($author$project$Date_Time$NaiveDate$fromPosix, timeZone, auditRecord.ct.g8));
		var subLabel = A3($author$project$Translations$Archive$completionTimestamp, translations, recordDate, recordTime);
		return A2(
			$author$project$UI$Table$Row$appendContent,
			$elm$core$Maybe$Just(
				A3($author$project$CheckpointHistory$Page$viewRecordValue, auditRecord.ct.bK, fileUrls, auditRecord.ct.ll)),
			A2(
				$author$project$UI$Table$Row$setAdditionalRowStyle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
					]),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					subLabel,
					A3($author$project$UI$Table$Row$row, viewType, '', auditRecord))));
	});
var $author$project$CheckpointHistory$Page$viewTable = F4(
	function (translations, environment, fileUrls, checkpointHistory) {
		return $author$project$UI$Table$view(
			A2(
				$author$project$UI$Table$withEmptyText,
				$author$project$Translations$Archive$emptyText(
					$author$project$Environments$Environment$translations(environment)),
				A2(
					$author$project$UI$Table$fromList,
					A4(
						$author$project$CheckpointHistory$Page$viewRow,
						translations,
						$author$project$Environments$Environment$getViewType(environment),
						$author$project$Environments$Environment$timeZone(environment),
						fileUrls),
					$elm$core$List$reverse(
						A2(
							$elm$core$List$sortBy,
							function (auditRecord) {
								return $elm$time$Time$posixToMillis(auditRecord.ct.g8);
							},
							checkpointHistory.iV)))));
	});
var $author$project$CheckpointHistory$Page$viewLoaded = F3(
	function (environment, repository, model) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$CheckpointHistory$Page$viewTable, translations, environment, model.cS, model.dt),
				A2(
					$author$project$UI$Page$appendContent,
					A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$CheckpointHistory$Page$viewBar, repository, model.dt.i5),
					A2(
						$author$project$UI$Page$withIcon,
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedDocument),
						$author$project$UI$Page$page(
							$author$project$Translations$CheckpointHistory$historyHeader(translations))))));
	});
var $author$project$Translations$CheckpointHistory$loadingText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointHistory.loadingText');
};
var $author$project$CheckpointHistory$Page$viewLoadingText = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$CheckpointHistory$loadingText(translations))
			]));
};
var $author$project$CheckpointHistory$Page$viewLoading = function (environment) {
	var translations = $author$project$Environments$Environment$translations(environment);
	return A2(
		$author$project$UI$Page$view,
		environment,
		A2(
			$author$project$UI$Page$appendContent,
			$author$project$CheckpointHistory$Page$viewLoadingText(translations),
			A2(
				$author$project$UI$Page$withIcon,
				$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedDocument),
				$author$project$UI$Page$page(
					$author$project$Translations$CheckpointHistory$historyHeader(translations)))));
};
var $author$project$CheckpointHistory$Page$view = F3(
	function (environment, repository, page) {
		switch (page.$) {
			case 0:
				return $author$project$CheckpointHistory$Page$viewLoading(environment);
			case 1:
				var model = page.a;
				return A3($author$project$CheckpointHistory$Page$viewLoaded, environment, repository, model);
			default:
				return $author$project$CheckpointHistory$Page$viewError(environment);
		}
	});
var $author$project$Page$Page$viewCheckpointHistory = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 14) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotViewCheckpointHistoryPageMsg,
		kZ: $elm$core$Maybe$Just($author$project$CheckpointHistory$Page$subscriptions),
		le: $author$project$CheckpointHistory$Page$update,
		lm: $author$project$CheckpointHistory$Page$view
	});
var $author$project$Page$Page$GotViewCheckpointOverviewPageMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$CheckpointHistory$CheckpointOverview$collapseOrganisationUnit = F4(
	function (organisationUnitId, environment, repository, _v0) {
		var page = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				page,
				{
					ca: A2($author$project$OrganisationUnit$Ids$remove, organisationUnitId, page.ca)
				}),
			ae: repository
		};
	});
var $author$project$CheckpointHistory$CheckpointOverview$collapsedCheckpointGroup = F4(
	function (groupId, environment, repository, _v0) {
		var page = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				page,
				{
					b9: A2($author$project$CheckpointData$CheckpointGroup$Ids$remove, groupId, page.b9)
				}),
			ae: repository
		};
	});
var $author$project$CheckpointHistory$CheckpointOverview$enteredSearchString = F4(
	function (newSearchValue, environment, repository, _v0) {
		var page = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				page,
				{aN: newSearchValue}),
			ae: repository
		};
	});
var $author$project$CheckpointHistory$CheckpointOverview$expandOrganisationUnit = F4(
	function (organisationUnitId, environment, repository, _v0) {
		var page = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				page,
				{
					ca: A2($author$project$OrganisationUnit$Ids$insert, organisationUnitId, page.ca)
				}),
			ae: repository
		};
	});
var $author$project$CheckpointHistory$CheckpointOverview$expandedCheckpointGroup = F4(
	function (groupId, environment, repository, _v0) {
		var page = _v0;
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: environment,
			ak: _Utils_update(
				page,
				{
					b9: A2($author$project$CheckpointData$CheckpointGroup$Ids$insert, groupId, page.b9)
				}),
			ae: repository
		};
	});
var $author$project$Environments$Route$CheckpointHistory = function (a) {
	return {$: 14, a: a};
};
var $author$project$CheckpointHistory$CheckpointOverview$userClickedViewHistory = F4(
	function (checkpointId, environment, repository, page) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2(
				$author$project$Environments$Environment$navigateTo,
				$author$project$Environments$Route$CheckpointHistory(checkpointId),
				environment),
			ak: page,
			ae: repository
		};
	});
var $author$project$CheckpointHistory$CheckpointOverview$update = function (msg) {
	switch (msg.$) {
		case 0:
			var string = msg.a;
			return $author$project$CheckpointHistory$CheckpointOverview$enteredSearchString(string);
		case 1:
			var checkpointId = msg.a;
			return $author$project$CheckpointHistory$CheckpointOverview$userClickedViewHistory(checkpointId);
		case 2:
			var ouId = msg.a;
			return $author$project$CheckpointHistory$CheckpointOverview$expandOrganisationUnit(ouId);
		case 3:
			var ouId = msg.a;
			return $author$project$CheckpointHistory$CheckpointOverview$collapseOrganisationUnit(ouId);
		case 4:
			var groupId = msg.a;
			return $author$project$CheckpointHistory$CheckpointOverview$expandedCheckpointGroup(groupId);
		default:
			var groupId = msg.a;
			return $author$project$CheckpointHistory$CheckpointOverview$collapsedCheckpointGroup(groupId);
	}
};
var $author$project$CheckpointData$CheckpointData$getCheckpoints = A2(
	$elm$core$Basics$composeR,
	$author$project$CheckpointData$CheckpointData$unwrap,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.a8;
		},
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.i6;
			},
			$author$project$CheckpointData$Checkpoint$Dict$values)));
var $author$project$CheckpointHistory$CheckpointOverview$isInfo = function (value) {
	if (value.$ === 9) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Translations$CheckpointHistory$numberOfCheckpoints = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'checkpointHistory.numberOfCheckpoints',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$CheckpointHistory$CheckpointOverview$viewBar = F3(
	function (translations, repository, searchValue) {
		var checkpoints = A2(
			$elm$core$List$filter,
			function (checkpoint) {
				return !$author$project$CheckpointHistory$CheckpointOverview$isInfo(checkpoint.fg);
			},
			$author$project$CheckpointData$CheckpointData$getCheckpoints(
				$author$project$Environments$Repository$getCheckpointData(repository)));
		var filteredCheckpoints = $elm$core$String$isEmpty(searchValue) ? checkpoints : A3(
			$author$project$Utils$FuzzySearch$fuzzySearch,
			{
				jP: function (checkpoint) {
					return checkpoint.k8;
				},
				j2: -1
			},
			searchValue,
			checkpoints);
		var text_ = A2(
			$author$project$Translations$CheckpointHistory$numberOfCheckpoints,
			translations,
			$elm$core$String$fromInt(
				$elm$core$List$length(filteredCheckpoints)));
		return $author$project$UI$Bar$view(
			A2(
				$author$project$UI$Bar$withStyle,
				$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(1)),
				A2(
					$author$project$UI$Bar$withStyle,
					$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
					A2(
						$author$project$UI$Bar$withStyle,
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky),
						$author$project$UI$Bar$bar(text_)))));
	});
var $author$project$CheckpointHistory$CheckpointOverview$CollapseOrganisationUnit = function (a) {
	return {$: 3, a: a};
};
var $author$project$CheckpointHistory$CheckpointOverview$ExpandOrganisationUnit = function (a) {
	return {$: 2, a: a};
};
var $author$project$CheckpointHistory$CheckpointOverview$CollapsedCheckpointGroup = function (a) {
	return {$: 5, a: a};
};
var $author$project$CheckpointHistory$CheckpointOverview$ExpandedCheckpointGroup = function (a) {
	return {$: 4, a: a};
};
var $author$project$CheckpointHistory$CheckpointOverview$UserClickedViewHistory = function (a) {
	return {$: 1, a: a};
};
var $author$project$CheckpointHistory$CheckpointOverview$viewTileIcon = function (icon) {
	return $author$project$UI$Icon$view(
		A2(
			$author$project$UI$Icon$withStyle,
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$padding(
					$rtfeldman$elm_css$Css$rem(1)),
				A2(
					$author$project$UI$Icon$withStyle,
					A3(
						$rtfeldman$elm_css$Css$flex3,
						$rtfeldman$elm_css$Css$int(1),
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$zero),
					A2(
						$author$project$UI$Icon$withForegroundColor,
						$author$project$UI$Style$Theme$grey,
						$author$project$UI$Icon$unicolor(icon))))));
};
var $author$project$CheckpointHistory$CheckpointOverview$viewTileLabel = function (description) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$margin3,
						$rtfeldman$elm_css$Css$zero,
						$rtfeldman$elm_css$Css$rem(0.5),
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$paddingTop(
						$rtfeldman$elm_css$Css$rem(0.5)),
						A3(
						$rtfeldman$elm_css$Css$borderTop3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
						$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
						$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
						$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(description)
			]));
};
var $author$project$CheckpointHistory$CheckpointOverview$viewTileMarker = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(0.5)),
					A4(
					$rtfeldman$elm_css$Css$borderRadius4,
					$rtfeldman$elm_css$Css$zero,
					$rtfeldman$elm_css$Css$zero,
					$rtfeldman$elm_css$Css$rem(0.5),
					$rtfeldman$elm_css$Css$rem(0.5)),
					$rtfeldman$elm_css$Css$backgroundColor(
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey))
				]))
		]),
	_List_Nil);
var $author$project$CheckpointHistory$CheckpointOverview$viewCheckpointTile = function (checkpoint) {
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'aw-tile',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$backgroundImage(
						A3(
							$rtfeldman$elm_css$Css$linearGradient,
							$rtfeldman$elm_css$Css$stop(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
							$rtfeldman$elm_css$Css$stop(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
							_List_Nil)),
						$rtfeldman$elm_css$Css$firstChild(
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$property, 'grid-row', '1 / 1'),
								A2($rtfeldman$elm_css$Css$property, 'grid-column', '1 / 1')
							]))
					])),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$CheckpointHistory$CheckpointOverview$UserClickedViewHistory(checkpoint.i5))
			]),
		_List_fromArray(
			[
				$author$project$CheckpointHistory$CheckpointOverview$viewTileIcon($author$project$UI$Icons$pin),
				$author$project$CheckpointHistory$CheckpointOverview$viewTileLabel(checkpoint.k8),
				$author$project$CheckpointHistory$CheckpointOverview$viewTileMarker
			]));
};
var $author$project$CheckpointHistory$CheckpointOverview$viewTiles = function (checkpoints) {
	return A3(
		$rtfeldman$elm_css$Html$Styled$node,
		'checkpoints',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(1)),
						A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
						A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(auto-fill, minmax(8rem, 1fr))'),
						A2($rtfeldman$elm_css$Css$property, 'grid-gap', '1rem'),
						A2($rtfeldman$elm_css$Css$property, 'grid-auto-rows', '1fr'),
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(300)),
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$before(
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$property, 'content', '\'\''),
								$rtfeldman$elm_css$Css$paddingBottom(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
								A2($rtfeldman$elm_css$Css$property, 'grid-row', '1 / 1'),
								A2($rtfeldman$elm_css$Css$property, 'grid-column', '1 / 1')
							]))
					]))
			]),
		A2($elm$core$List$map, $author$project$CheckpointHistory$CheckpointOverview$viewCheckpointTile, checkpoints));
};
var $author$project$CheckpointHistory$CheckpointOverview$viewCheckpointGroup = F3(
	function (checkpointData, expandedCheckpointGroups, checkpointGroup) {
		var _v0 = function () {
			if (A2($author$project$CheckpointData$CheckpointGroup$Ids$member, checkpointGroup.cC, expandedCheckpointGroups)) {
				var checkpoints = A2(
					$elm$core$List$filter,
					function (checkpoint) {
						return !$author$project$CheckpointHistory$CheckpointOverview$isInfo(checkpoint.fg);
					},
					A2($author$project$CheckpointData$CheckpointData$getCheckpointsOf, checkpointGroup.cC, checkpointData));
				return _Utils_Tuple3(
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$collapse),
					$author$project$CheckpointHistory$CheckpointOverview$viewTiles(checkpoints),
					$elm$core$Maybe$Just(
						$author$project$CheckpointHistory$CheckpointOverview$CollapsedCheckpointGroup(checkpointGroup.cC)));
			} else {
				return _Utils_Tuple3(
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$expand),
					$rtfeldman$elm_css$Html$Styled$text(''),
					$elm$core$Maybe$Just(
						$author$project$CheckpointHistory$CheckpointOverview$ExpandedCheckpointGroup(checkpointGroup.cC)));
			}
		}();
		var leftIcon = _v0.a;
		var checkpointContent = _v0.b;
		var barMsg = _v0.c;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
				]),
			_List_fromArray(
				[
					$author$project$UI$Bar$view(
					A2(
						$author$project$UI$Bar$appendLeftIconList,
						_List_fromArray(
							[
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$pin),
								leftIcon
							]),
						A2(
							$author$project$UI$Bar$withStyle,
							$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$rem(0.5)),
							A2(
								$author$project$UI$Bar$withOnBarClick,
								barMsg,
								$author$project$UI$Bar$bar(checkpointGroup.k8))))),
					checkpointContent
				]));
	});
var $author$project$CheckpointHistory$CheckpointOverview$viewCheckpointGroupBars = F3(
	function (checkpointData, model, organisationUnit) {
		var checkpointGroups = A2(
			$elm$core$List$filter,
			function (checkpointGroup) {
				return !$elm$core$List$isEmpty(
					A2(
						$elm$core$List$filter,
						function (checkpoint) {
							return !$author$project$CheckpointHistory$CheckpointOverview$isInfo(checkpoint.fg);
						},
						A2($author$project$CheckpointData$CheckpointData$getCheckpointsOf, checkpointGroup.cC, checkpointData)));
			},
			A2($author$project$CheckpointData$CheckpointData$getCheckpointGroupAndPrev, organisationUnit.jU, checkpointData));
		return $elm$core$List$isEmpty(checkpointGroups) ? _Utils_Tuple2(
			$rtfeldman$elm_css$Html$Styled$text(''),
			0) : _Utils_Tuple2(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$CheckpointHistory$CheckpointOverview$viewCheckpointGroup, checkpointData, model.b9),
					checkpointGroups)),
			$elm$core$List$length(checkpointGroups));
	});
var $author$project$CheckpointHistory$CheckpointOverview$viewOrganisationOverview = F4(
	function (translations, environment, repository, model) {
		var icon = {
			jI: $author$project$UI$Icon$unicolor($author$project$UI$Icons$factory),
			ka: $elm$core$Maybe$Nothing
		};
		var checkpointData = $author$project$Environments$Repository$getCheckpointData(repository);
		return A2(
			$author$project$UI$OrganisationStructure$view,
			environment,
			{
				iN: $author$project$UI$OrganisationStructure$NoFunction,
				iY: $elm$core$Maybe$Nothing,
				i9: $author$project$CheckpointHistory$CheckpointOverview$CollapseOrganisationUnit,
				jg: $author$project$UI$OrganisationStructure$Content(
					A2($author$project$CheckpointHistory$CheckpointOverview$viewCheckpointGroupBars, checkpointData, model)),
				jx: $author$project$CheckpointHistory$CheckpointOverview$ExpandOrganisationUnit,
				jy: $author$project$OrganisationUnit$Ids$toList(model.ca),
				jV: $elm$core$Maybe$Just(icon),
				kn: $author$project$Environments$Repository$organisationUnits(repository),
				kC: _List_Nil,
				kD: _List_Nil,
				kE: $elm$core$Maybe$Nothing,
				kS: false
			});
	});
var $author$project$Translations$CheckpointHistory$emptyText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointHistory.emptyText');
};
var $author$project$Translations$CheckpointHistory$overViewHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointHistory.overViewHeader');
};
var $author$project$Translations$CheckpointHistory$offlineText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'checkpointHistory.offlineText');
};
var $author$project$CheckpointHistory$CheckpointOverview$viewOfflineText = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$CheckpointHistory$offlineText(translations))
			]));
};
var $author$project$CheckpointHistory$CheckpointOverview$viewOffline = F2(
	function (translations, environment) {
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				$author$project$CheckpointHistory$CheckpointOverview$viewOfflineText(translations),
				A2(
					$author$project$UI$Page$withIcon,
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedDocument),
					$author$project$UI$Page$page(
						$author$project$Translations$CheckpointHistory$overViewHeader(translations)))));
	});
var $author$project$Translations$CheckpointHistory$subLabel = F3(
	function (translations, checkpointGroup, organisationUnit) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'checkpointHistory.subLabel:',
			_List_fromArray(
				[
					_Utils_Tuple2('checkpointGroup', checkpointGroup),
					_Utils_Tuple2('organisationUnit', organisationUnit)
				]));
	});
var $author$project$CheckpointHistory$CheckpointOverview$subLabel = F3(
	function (translations, checkpoint, repository) {
		var maybeCheckpointGroup = A2(
			$author$project$CheckpointData$CheckpointData$getCheckpointGroup,
			checkpoint.cC,
			$author$project$Environments$Repository$getCheckpointData(repository));
		var maybeOrganisationUnit = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				function (group) {
					return A2($author$project$Environments$Repository$getOrganisationUnit, group.km, repository);
				},
				maybeCheckpointGroup));
		var _v0 = _Utils_Tuple2(maybeCheckpointGroup, maybeOrganisationUnit);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var checkpointGroup = _v0.a.a;
			var organisationUnit = _v0.b.a;
			return A3($author$project$Translations$CheckpointHistory$subLabel, translations, checkpointGroup.k8, organisationUnit.k8);
		} else {
			return '';
		}
	});
var $author$project$CheckpointHistory$CheckpointOverview$viewRow = F4(
	function (translations, viewType, repository, checkpoint) {
		var subLabel_ = A3($author$project$CheckpointHistory$CheckpointOverview$subLabel, translations, checkpoint, repository);
		return A2(
			$author$project$UI$Table$Row$withOnClick,
			$author$project$CheckpointHistory$CheckpointOverview$UserClickedViewHistory(checkpoint.i5),
			A2(
				$author$project$UI$Table$Row$withRightIcon,
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$info)),
				A2(
					$author$project$UI$Table$Row$withSubLabel,
					subLabel_,
					A3($author$project$UI$Table$Row$row, viewType, checkpoint.k8, checkpoint))));
	});
var $author$project$CheckpointHistory$CheckpointOverview$viewTable = F4(
	function (translations, environment, repository, searchValue) {
		if ($author$project$Environments$Environment$isOffline(environment)) {
			return A2($author$project$CheckpointHistory$CheckpointOverview$viewOffline, translations, environment);
		} else {
			var checkpoints = $author$project$CheckpointData$CheckpointData$getCheckpoints(
				$author$project$Environments$Repository$getCheckpointData(repository));
			var filteredCheckpoints = $elm$core$String$isEmpty(searchValue) ? checkpoints : A3(
				$author$project$Utils$FuzzySearch$fuzzySearch,
				{
					jP: function (checkpoint) {
						return checkpoint.k8;
					},
					j2: -1
				},
				searchValue,
				checkpoints);
			return $author$project$UI$Table$view(
				A2(
					$author$project$UI$Table$withEmptyText,
					$author$project$Translations$CheckpointHistory$emptyText(translations),
					A2(
						$author$project$UI$Table$fromList,
						A3(
							$author$project$CheckpointHistory$CheckpointOverview$viewRow,
							translations,
							$author$project$Environments$Environment$getViewType(environment),
							repository),
						A2(
							$elm$core$List$sortBy,
							function ($) {
								return $.k8;
							},
							filteredCheckpoints))));
		}
	});
var $author$project$CheckpointHistory$CheckpointOverview$viewContent = F4(
	function (translations, environment, repository, model) {
		return $elm$core$String$isEmpty(model.aN) ? A4($author$project$CheckpointHistory$CheckpointOverview$viewOrganisationOverview, translations, environment, repository, model) : A4($author$project$CheckpointHistory$CheckpointOverview$viewTable, translations, environment, repository, model.aN);
	});
var $author$project$CheckpointHistory$CheckpointOverview$EnteredSearchString = function (a) {
	return {$: 0, a: a};
};
var $author$project$CheckpointHistory$CheckpointOverview$viewSearch = F2(
	function (translations, searchValue) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withStyle,
				$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(50)),
				A2(
					$author$project$UI$TextInput$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3)),
					A2(
						$author$project$UI$TextInput$withOnInput,
						$author$project$CheckpointHistory$CheckpointOverview$EnteredSearchString,
						A2(
							$author$project$UI$TextInput$withPlaceholder,
							$author$project$Translations$FuzzySearch$search(translations),
							A2($author$project$UI$TextInput$withValue, searchValue, $author$project$UI$TextInput$singleLine))))));
	});
var $author$project$CheckpointHistory$CheckpointOverview$viewHeader = F3(
	function (translations, searchValue, environment) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$CheckpointHistory$CheckpointOverview$viewSearch, translations, searchValue)
				]));
	});
var $author$project$CheckpointHistory$CheckpointOverview$viewPage = F3(
	function (environment, repository, _v0) {
		var page = _v0;
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$author$project$UI$Page$view,
			environment,
			A2(
				$author$project$UI$Page$appendContent,
				A5($rtfeldman$elm_css$Html$Styled$Lazy$lazy4, $author$project$CheckpointHistory$CheckpointOverview$viewContent, translations, environment, repository, page),
				A2(
					$author$project$UI$Page$appendContent,
					A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$CheckpointHistory$CheckpointOverview$viewBar, translations, repository, page.aN),
					A2(
						$author$project$UI$Page$appendHeader,
						A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$CheckpointHistory$CheckpointOverview$viewHeader, translations, page.aN, environment),
						A2(
							$author$project$UI$Page$withIcon,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$checkedDocument),
							$author$project$UI$Page$page(
								$author$project$Translations$CheckpointHistory$checkpointOverview(translations)))))));
	});
var $author$project$CheckpointHistory$CheckpointOverview$view = F3(
	function (environment, repository, page) {
		return A3($author$project$CheckpointHistory$CheckpointOverview$viewPage, environment, repository, page);
	});
var $author$project$Page$Page$viewCheckpointOverview = $author$project$Page$Page$init(
	{
		S: function (mainMsg) {
			if (mainMsg.$ === 13) {
				var msg = mainMsg.a;
				return $elm$core$Maybe$Just(msg);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		r: $author$project$Page$Page$GotViewCheckpointOverviewPageMsg,
		kZ: $elm$core$Maybe$Nothing,
		le: $author$project$CheckpointHistory$CheckpointOverview$update,
		lm: $author$project$CheckpointHistory$CheckpointOverview$view
	});
var $author$project$Environments$Router$routeTo = F2(
	function (route, environment) {
		switch (route.$) {
			case 0:
				return $author$project$Page$Page$mainMenu(
					$author$project$Page$MainMenu$init(environment));
			case 1:
				return $author$project$Page$Page$measures(
					$author$project$Measure$Page$init(environment));
			case 2:
				return $author$project$Page$Page$audits(
					$author$project$Audit$Page$init(environment));
			case 3:
				var auditId = route.a;
				return $author$project$Page$Page$performAudit(
					A2($author$project$Audit$PerformAuditPage$init, environment, auditId));
			case 4:
				return $author$project$Page$Page$settings(
					$author$project$Page$Settings$init(environment));
			case 5:
				return $author$project$Page$Page$users(
					$author$project$User$Page$init(environment));
			case 6:
				return $author$project$Page$Page$organisationUnits(
					$author$project$OrganisationUnit$Page$init(environment));
			case 7:
				return $author$project$Page$Page$plans(
					$author$project$Plan$Page$init(environment));
			case 8:
				return $author$project$Page$Page$ouOverview(
					$author$project$Page$OrganisationUnitOverview$init(environment));
			case 9:
				var fileId = route.a;
				return $author$project$Page$Page$floorPlan(
					A2($author$project$Page$FloorPlan$init, environment, fileId));
			case 10:
				return $author$project$Page$Page$eventStream(
					$author$project$EventStream$Page$init(environment));
			case 11:
				return $author$project$Page$Page$archive(
					$author$project$Archive$Page$init(environment));
			case 12:
				var auditId = route.a;
				return $author$project$Page$Page$viewArchivedAudit(
					A2($author$project$Archive$ViewArchivedAudit$init, environment, auditId));
			case 13:
				var checkpointOverviewEntryPoint = route.a;
				return $author$project$Page$Page$viewCheckpointOverview(
					A2($author$project$CheckpointHistory$CheckpointOverview$init, environment, checkpointOverviewEntryPoint));
			case 14:
				var checkpointId = route.a;
				return $author$project$Page$Page$viewCheckpointHistory(
					A2($author$project$CheckpointHistory$Page$init, environment, checkpointId));
			case 15:
				return $author$project$Page$Page$roles(
					$author$project$Rights$Role$Page$init(environment));
			case 16:
				return $author$project$Page$Page$teams(
					$author$project$Rights$Team$Page$init(environment));
			default:
				return $author$project$Page$Page$page404(
					$author$project$Page$Page404$init(environment));
		}
	});
var $author$project$Utils$Tuple$uncurry = F2(
	function (fn, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(fn, a, b);
	});
var $author$project$Main$maybeRoute = function (_v0) {
	var state = _v0.a;
	var cmd = _v0.b;
	switch (state.$) {
		case 0:
			return _Utils_Tuple2(state, cmd);
		case 1:
			return _Utils_Tuple2(state, cmd);
		case 2:
			var model = state.a;
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(state, cmd),
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						var newEnvironment = _v2.a;
						var newPage = _v2.b;
						var pageCmd = _v2.c;
						return _Utils_Tuple2(
							$author$project$Main$Loaded(
								_Utils_update(
									model,
									{ac: newEnvironment, ak: newPage})),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmd,
										A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedPageMsg, pageCmd)
									])));
					},
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Utils$Tuple$swap,
							$author$project$Utils$Tuple$uncurry($author$project$Environments$Router$routeTo)),
						$author$project$Environments$Environment$navigate(model.ac))));
		default:
			return _Utils_Tuple2(state, cmd);
	}
};
var $author$project$Main$GotCompleteSynchronisationModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$Modals$CompleteSyncModal$Hidden = 0;
var $author$project$Page$Modals$CompleteSyncModal$update = F3(
	function (msg, environment, _v0) {
		return {
			ab: $elm$core$Platform$Cmd$none,
			ac: A2($author$project$Environments$Environment$setRequiredEnvironmentUpdate, 1, environment),
			ix: 0
		};
	});
var $author$project$Environments$Repository$commandSummaryIsEmpty = function (repository) {
	var summary = $author$project$Environments$Repository$commandSummary(repository);
	return $author$project$User$Commands$isEmpty(summary.li) && ($author$project$OrganisationUnit$Commands$isEmpty(summary.kk) && ($author$project$Plan$Commands$isEmpty(summary.kp) && ($author$project$Audit$Commands$isEmpty(summary.iT) && ($author$project$Measure$Commands$isEmpty(summary.j3) && ($author$project$Tenant$Commands$isEmpty(summary.k3) && ($author$project$CheckpointData$Commands$isEmpty(summary.i3) && $author$project$Rights$Commands$isEmpty(summary.kG)))))));
};
var $author$project$Auth$Authorization$addOrganisationUnitChildren = F3(
	function (repository, data, acc) {
		var organisationUnitId = data.a;
		var rightsSet = data.b;
		var hierarchy = $author$project$OrganisationUnit$OrganisationUnits$hierarchy(
			$author$project$Environments$Repository$organisationUnits(repository));
		var children = A2(
			$elm$core$List$cons,
			data,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (organisationUnit) {
						return A2(
							$elm$core$List$map,
							function (id) {
								return _Utils_Tuple2(id, rightsSet);
							},
							$author$project$OrganisationUnit$Ids$toList(
								A2($author$project$OrganisationUnit$Hierarchy$getDescendantIdsOf, organisationUnit, hierarchy)));
					},
					A2($author$project$Environments$Repository$getOrganisationUnit, organisationUnitId, repository))));
		return A2($elm$core$List$append, children, acc);
	});
var $author$project$Auth$UserRights$insertIntoMatrix = F2(
	function (_v0, userRights) {
		var organisationUnitId = _v0.a;
		var rightSet = _v0.b;
		return A3($turboMaCk$any_dict$Dict$Any$insert, organisationUnitId, rightSet, userRights);
	});
var $author$project$Auth$Authorization$addToMatrix = F2(
	function (data, userRights) {
		var organisationUnitId = data.a;
		var rightsSet = data.b;
		var _v0 = A2($author$project$Auth$UserRights$getRightSetFromMatrix, organisationUnitId, userRights);
		if (!_v0.$) {
			var currentRights = _v0.a;
			return A2(
				$author$project$Auth$UserRights$insertIntoMatrix,
				_Utils_Tuple2(
					organisationUnitId,
					A2($author$project$Auth$RightSet$union, currentRights, rightsSet)),
				userRights);
		} else {
			return A2($author$project$Auth$UserRights$insertIntoMatrix, data, userRights);
		}
	});
var $author$project$Auth$UserRights$emptyMatrix = $turboMaCk$any_dict$Dict$Any$empty($author$project$OrganisationUnit$Id$toString);
var $author$project$Auth$Authorization$filterIsSettingRight = function (right) {
	return (!right) || ((right === 1) || ((right === 2) || (right === 3)));
};
var $author$project$Auth$Authorization$initializeUserRights = F2(
	function (repository, user) {
		var rights = $author$project$Environments$Repository$getRights(repository);
		var data = A3(
			$elm$core$List$foldl,
			$author$project$Auth$Authorization$assembleData(rights),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			$author$project$User$TeamRoles$toList(user.k2));
		var settingsRights = A2(
			$author$project$Auth$RightSet$filter,
			$author$project$Auth$Authorization$filterIsSettingRight,
			A3($elm$core$List$foldl, $author$project$Auth$Authorization$unifyRightSet, $author$project$Auth$RightSet$empty, data.b));
		return $author$project$Auth$UserRights$Initialized(
			{
				h4: A3(
					$elm$core$List$foldl,
					$author$project$Auth$Authorization$addToMatrix,
					$author$project$Auth$UserRights$emptyMatrix,
					A3(
						$elm$core$List$foldl,
						$author$project$Auth$Authorization$addOrganisationUnitChildren(repository),
						_List_Nil,
						data.a)),
				hf: settingsRights
			});
	});
var $author$project$Auth$UserRights$isInitialized = function (userRights) {
	if (userRights.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Rights$Store$isLoaded = $elm$core$Basics$neq($author$project$Rights$Store$Loading);
var $author$project$Rights$Service$isNotFetching = $elm$core$Basics$neq($author$project$Rights$Service$Fetching);
var $author$project$Environments$Repository$rightsAreReady = function (_v0) {
	var data = _v0;
	return {
		bN: $author$project$Rights$Service$isNotFetching(data.bM),
		bP: $author$project$Rights$Store$isLoaded(data.al) && (!$author$project$Rights$Store$isUninitialized(data.al))
	};
};
var $author$project$Environments$Environment$SaveUserRights = function (a) {
	return {$: 4, a: a};
};
var $author$project$Environments$Environment$saveUserRights = F2(
	function (state, userRights_) {
		return _Utils_Tuple2(
			A2(
				$author$project$Environments$Environment$map,
				function (model) {
					return _Utils_update(
						model,
						{cy: userRights_});
				},
				state),
			$author$project$Environments$Environment$send(
				$author$project$Environments$Environment$SaveUserRights(userRights_)));
	});
var $author$project$Main$updateEnvironment = F2(
	function (maybeCompleteSyncModal, triple) {
		var environment = triple.a;
		var repository = triple.b;
		var cmd = triple.c;
		var usersAreReady = $author$project$Environments$Repository$rightsAreReady(repository).bP;
		var rightsAreReady = $author$project$Environments$Repository$rightsAreReady(repository).bP;
		var organisationUnitsAreReady = $author$project$Environments$Repository$rightsAreReady(repository).bP;
		var maybeUser = A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return A2($author$project$Environments$Repository$getUser, id, repository);
			},
			$author$project$Auth$Session$maybeUserId(
				$author$project$Environments$Environment$session(environment)));
		var isNotInitialized = !$author$project$Auth$UserRights$isInitialized(
			$author$project$Environments$Environment$userRights(environment));
		var checkIfRequiredDataIsReady = rightsAreReady && (usersAreReady && organisationUnitsAreReady);
		var _v0 = _Utils_Tuple3(
			$author$project$Environments$Environment$getRequiredEnvironmentUpdate(environment),
			checkIfRequiredDataIsReady,
			maybeUser);
		_v0$0:
		while (true) {
			if (_v0.b && (!_v0.c.$)) {
				switch (_v0.a) {
					case 2:
						break _v0$0;
					case 1:
						var _v4 = _v0.a;
						var user = _v0.c.a;
						var _v5 = A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Main$ReceivedEnvironmentMsg),
							A2(
								$author$project$Environments$Environment$saveUserRights,
								environment,
								A2($author$project$Auth$Authorization$initializeUserRights, repository, user)));
						var newEnvironment = _v5.a;
						var environmentCmd = _v5.b;
						return _Utils_Tuple3(
							newEnvironment,
							repository,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[cmd, environmentCmd])));
					default:
						var user = _v0.c.a;
						if (isNotInitialized) {
							var _v6 = A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Main$ReceivedEnvironmentMsg),
								A2(
									$author$project$Environments$Environment$saveUserRights,
									environment,
									A2($author$project$Auth$Authorization$initializeUserRights, repository, user)));
							var newEnvironment = _v6.a;
							var environmentCmd = _v6.b;
							return _Utils_Tuple3(
								newEnvironment,
								repository,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[cmd, environmentCmd])));
						} else {
							return triple;
						}
				}
			} else {
				if (_v0.a === 2) {
					break _v0$0;
				} else {
					return triple;
				}
			}
		}
		var _v1 = _v0.a;
		if ($author$project$Environments$Environment$isOnline(environment) && ($author$project$Environments$Repository$commandSummaryIsEmpty(repository) && A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (completeSyncModal) {
					return !completeSyncModal;
				},
				maybeCompleteSyncModal)))) {
			var _v2 = A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Main$ReceivedRepositoryMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Environments$Repository$setEventStream(repository),
					$author$project$EventStream$EventStream$disconnect(
						$author$project$Environments$Repository$eventStream(repository))));
			var newRepository = _v2.a;
			var repositoryCmd = _v2.b;
			var _v3 = A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Main$ReceivedEnvironmentMsg),
				$author$project$Environments$Environment$resetData(environment));
			var newEnvironment = _v3.a;
			var environmentCmd = _v3.b;
			return _Utils_Tuple3(
				newEnvironment,
				newRepository,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[repositoryCmd, environmentCmd])));
		} else {
			return triple;
		}
	});
var $author$project$Main$gotCompleteSynchronisationModalMsg = F2(
	function (modalMsg, state) {
		if (state.$ === 2) {
			var loadedModel = state.a;
			var utils = loadedModel.f;
			var result = A3($author$project$Page$Modals$CompleteSyncModal$update, modalMsg, loadedModel.ac, utils.b_);
			var _v1 = A2(
				$author$project$Main$updateEnvironment,
				$elm$core$Maybe$Just(result.ix),
				_Utils_Tuple3(result.ac, loadedModel.ae, $elm$core$Platform$Cmd$none));
			var newEnvironment = _v1.a;
			var newRepository = _v1.b;
			var cmd = _v1.c;
			return _Utils_Tuple2(
				$author$project$Main$Loaded(
					_Utils_update(
						loadedModel,
						{
							ac: newEnvironment,
							ae: newRepository,
							f: _Utils_update(
								utils,
								{b_: result.ix})
						})),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							A2($elm$core$Platform$Cmd$map, $author$project$Main$GotCompleteSynchronisationModalMsg, result.ab)
						])));
		} else {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$utilsChangeRoomNavigation = F2(
	function (dialog, utils) {
		return _Utils_update(
			utils,
			{f1: dialog});
	});
var $author$project$Main$openRoomNavigation = function (state) {
	if (state.$ === 2) {
		var model = state.a;
		return _Utils_Tuple2(
			$author$project$Main$Loaded(
				_Utils_update(
					model,
					{
						f: A2(
							$author$project$Main$utilsChangeRoomNavigation,
							$author$project$UI$OrganisationUnitNavigation$visible(false),
							model.f)
					})),
			$elm$core$Platform$Cmd$none);
	} else {
		return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Main$ReceivedEditTenantModelMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$receivedEditTenantModelMsg = F2(
	function (modalMsg, state) {
		if (state.$ === 2) {
			var loadedModel = state.a;
			var utils = loadedModel.f;
			var result = A4($author$project$Tenant$EditModal$update, modalMsg, loadedModel.ac, loadedModel.ae, loadedModel.f.eZ);
			return _Utils_Tuple2(
				$author$project$Main$Loaded(
					_Utils_update(
						loadedModel,
						{
							ac: result.ac,
							ae: result.ae,
							f: _Utils_update(
								utils,
								{eZ: result.jn})
						})),
				A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedEditTenantModelMsg, result.ab));
		} else {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Navbar$Animating = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Navbar$Collapsed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$Navbar$Expanded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Navbar$Swiping = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Navbar$changeBarPosition = F2(
	function (barPosition, state) {
		switch (state.$) {
			case 0:
				var pointerState = state.a;
				var model = state.b;
				return A2(
					$author$project$Page$Navbar$Collapsed,
					pointerState,
					_Utils_update(
						model,
						{aD: barPosition}));
			case 1:
				var pointerState = state.a;
				var model = state.b;
				return A2(
					$author$project$Page$Navbar$Expanded,
					pointerState,
					_Utils_update(
						model,
						{aD: barPosition}));
			case 2:
				var record = state.a;
				var model = state.b;
				return A2(
					$author$project$Page$Navbar$Swiping,
					record,
					_Utils_update(
						model,
						{aD: barPosition}));
			default:
				var spring = state.a;
				var model = state.b;
				return A2(
					$author$project$Page$Navbar$Animating,
					spring,
					_Utils_update(
						model,
						{aD: barPosition}));
		}
	});
var $author$project$Main$Login = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$Utils = F4(
	function (roomNavigation, reLogin, tenantModal, completeSyncModal) {
		return {b_: completeSyncModal, az: reLogin, f1: roomNavigation, eZ: tenantModal};
	});
var $author$project$Auth$Login$HiddenModal = 1;
var $author$project$Auth$Login$emptyLoginForm = function (environment) {
	return {
		bC: $author$project$Environments$Environment$baseUri(environment),
		aE: 1,
		a1: '',
		aP: '',
		iK: ''
	};
};
var $author$project$Page$Navbar$SideBar = 0;
var $author$project$Page$Navbar$TopBar = 1;
var $author$project$Main$getNavbarType = function (env) {
	var _v0 = $author$project$Environments$Environment$getViewType(env);
	if (!_v0) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Page$Modals$CompleteSyncModal$hidden = 0;
var $author$project$Auth$ReLoginModal$Form = F3(
	function (username, password, tenant) {
		return {a1: password, iC: tenant, iK: username};
	});
var $author$project$Auth$ReLoginModal$LoadTenant = {$: 1};
var $author$project$Auth$ReLoginModal$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Auth$ReLoginModal$encodeOutMsg = function (msg) {
	if (!msg.$) {
		var tenantName = msg.a;
		var username = msg.b;
		var password = msg.c;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('LOGIN')),
					_Utils_Tuple2(
					'tenantName',
					$elm$json$Json$Encode$string(tenantName)),
					_Utils_Tuple2(
					'username',
					$elm$json$Json$Encode$string(username)),
					_Utils_Tuple2(
					'password',
					$author$project$Auth$Password$encode(password))
				]));
	} else {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('LOAD_TENANT'))
				]));
	}
};
var $author$project$Auth$ReLoginModal$reLoginOutbox = _Platform_outgoingPort('reLoginOutbox', $elm$core$Basics$identity);
var $author$project$Auth$ReLoginModal$send = A2($elm$core$Basics$composeR, $author$project$Auth$ReLoginModal$encodeOutMsg, $author$project$Auth$ReLoginModal$reLoginOutbox);
var $author$project$Auth$ReLoginModal$init = function (maybeTenant) {
	var _v0 = function () {
		if (!maybeTenant.$) {
			var tenant = maybeTenant.a;
			return _Utils_Tuple2(tenant.aP, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				'',
				$author$project$Auth$ReLoginModal$send($author$project$Auth$ReLoginModal$LoadTenant));
		}
	}();
	var tenantName = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		$author$project$Auth$ReLoginModal$Visible(
			A3($author$project$Auth$ReLoginModal$Form, '', '', tenantName)),
		cmd);
};
var $author$project$Page$Navbar$Hidden = 0;
var $author$project$Page$Navbar$PointerUp = {$: 0};
var $author$project$Auth$LogoutModal$Hidden = 0;
var $author$project$Auth$LogoutModal$hidden = 0;
var $author$project$Page$Modals$AboutModal$Hidden = 0;
var $author$project$Page$Modals$AboutModal$hidden = 0;
var $author$project$Page$Navbar$init = function (barPosition) {
	var model = {bR: $author$project$Page$Modals$AboutModal$hidden, aD: barPosition, dv: $author$project$Page$Modals$ConfirmOpenSettings$hidden, O: 0, ci: $author$project$Auth$LogoutModal$hidden};
	return A2($author$project$Page$Navbar$Collapsed, $author$project$Page$Navbar$PointerUp, model);
};
var $author$project$Auth$Session$isExpired = $elm$core$Basics$eq($author$project$Auth$Session$Expired);
var $author$project$Environments$Environment$isLoaded = function (state) {
	switch (state.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		default:
			return true;
	}
};
var $author$project$Environments$Repository$auditIsReady = function (_v0) {
	var data = _v0;
	return {
		bN: $author$project$Audit$Service$isNotFetching(data.bg),
		bP: $author$project$Audit$Store$isLoaded(data.aa) && (!$author$project$Audit$Store$isUninitialized(data.aa))
	};
};
var $author$project$Environments$Repository$checkpointDataIsReady = function (_v0) {
	var data = _v0;
	return {
		bN: $author$project$CheckpointData$Service$isNotFetching(data.bj),
		bP: $author$project$CheckpointData$Store$isLoaded(data.C) && (!$author$project$CheckpointData$Store$isUninitialized(data.C))
	};
};
var $author$project$EventStream$EventStream$isConnected = function (state) {
	if (state.$ === 4) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Environments$Repository$eventStreamIsReady = F2(
	function (environment, _v0) {
		var data = _v0;
		return $author$project$EventStream$EventStream$isConnected(data.j) || $author$project$Environments$Environment$isOffline(environment);
	});
var $author$project$File$Store$isNotLoading = function (state) {
	if (!state.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Environments$Repository$fileStoreIsReady = function (_v0) {
	var data = _v0;
	return $author$project$File$Store$isNotLoading(data.ad);
};
var $author$project$Environments$Repository$measureIsReady = function (_v0) {
	var data = _v0;
	return {
		bN: $author$project$Measure$Service$isNotFetching(data.bo),
		bP: $author$project$Measure$Store$isLoaded(data.R) && (!$author$project$Measure$Store$isUninitialized(data.R))
	};
};
var $author$project$Environments$Repository$organisationUnitIsReady = function (_v0) {
	var data = _v0;
	return {
		bN: $author$project$OrganisationUnit$Service$isNotFetching(data.br),
		bP: $author$project$OrganisationUnit$Store$isLoaded(data.T) && (!$author$project$OrganisationUnit$Store$isUninitialized(data.T))
	};
};
var $author$project$Environments$Repository$planIsReady = function (_v0) {
	var data = _v0;
	return {
		bN: $author$project$Plan$Service$isNotFetching(data.bt),
		bP: $author$project$Plan$Store$isLoaded(data.U) && (!$author$project$Plan$Store$isUninitialized(data.U))
	};
};
var $author$project$Environments$Repository$shortResult = function (result) {
	return result.bP && result.bN;
};
var $author$project$Environments$Repository$tenantIsReady = function (_v0) {
	var data = _v0;
	return {
		bN: $author$project$Tenant$Service$isNotFetching(data.bz),
		bP: $author$project$Tenant$Store$isLoaded(data.ag) && (!$author$project$Tenant$Store$isUninitialized(data.ag))
	};
};
var $author$project$Environments$Repository$userIsReady = function (_v0) {
	var data = _v0;
	return {
		bN: $author$project$User$Service$isNotFetching(data.bA),
		bP: $author$project$User$Store$isLoaded(data.ah) && (!$author$project$User$Store$isUninitialized(data.ah))
	};
};
var $author$project$Environments$Repository$repositoryIsReady = F2(
	function (environment, repository) {
		return A2($author$project$Environments$Repository$eventStreamIsReady, environment, repository) && ($author$project$Environments$Repository$fileStoreIsReady(repository) && ($author$project$Environments$Repository$shortResult(
			$author$project$Environments$Repository$userIsReady(repository)) && ($author$project$Environments$Repository$shortResult(
			$author$project$Environments$Repository$organisationUnitIsReady(repository)) && ($author$project$Environments$Repository$shortResult(
			$author$project$Environments$Repository$planIsReady(repository)) && ($author$project$Environments$Repository$shortResult(
			$author$project$Environments$Repository$auditIsReady(repository)) && ($author$project$Environments$Repository$shortResult(
			$author$project$Environments$Repository$measureIsReady(repository)) && ($author$project$Environments$Repository$shortResult(
			$author$project$Environments$Repository$tenantIsReady(repository)) && ($author$project$Environments$Repository$shortResult(
			$author$project$Environments$Repository$checkpointDataIsReady(repository)) && $author$project$Environments$Repository$shortResult(
			$author$project$Environments$Repository$rightsAreReady(repository))))))))));
	});
var $author$project$Auth$Login$Visible = function (a) {
	return {$: 0, a: a};
};
var $author$project$Auth$Login$show = F2(
	function (environment, loginForm) {
		return _Utils_Tuple2(
			$author$project$Auth$Login$Visible(loginForm),
			$elm$core$Platform$Cmd$batch(_List_Nil));
	});
var $author$project$Main$fromLoading = function (model) {
	if ($author$project$Environments$Environment$isLoaded(model.ac)) {
		var session = $author$project$Environments$Environment$session(model.ac);
		var _v0 = $author$project$Auth$Session$maybeUserId(session);
		if (_v0.$ === 1) {
			if ($author$project$Auth$Session$isExpired(
				$author$project$Environments$Environment$session(model.ac))) {
				var _v1 = $author$project$Auth$ReLoginModal$init(
					$author$project$Environments$Repository$getTenant(model.ae));
				var reLogin = _v1.a;
				var reLoginCmd = _v1.b;
				return _Utils_Tuple2(
					$author$project$Main$Loading(
						{ac: model.ac, az: reLogin, ae: model.ae}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedReLoginMsg, reLoginCmd));
			} else {
				var _v2 = A2(
					$author$project$Auth$Login$show,
					model.ac,
					$author$project$Auth$Login$emptyLoginForm(model.ac));
				var login = _v2.a;
				var loginCmd = _v2.b;
				return _Utils_Tuple2(
					$author$project$Main$Login(
						{
							ac: model.ac,
							dT: login,
							dU: $author$project$Auth$Login$emptyLoginForm(model.ac),
							ae: model.ae
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedLoginMsg, loginCmd));
			}
		} else {
			if (A2($author$project$Environments$Repository$repositoryIsReady, model.ac, model.ae) && $author$project$Auth$UserRights$isInitialized(
				$author$project$Environments$Environment$userRights(model.ac))) {
				var _v3 = $author$project$Page$Page$mainMenu(
					$author$project$Page$MainMenu$init(model.ac));
				var newEnvironment = _v3.a;
				var page = _v3.b;
				var pageCmd = _v3.c;
				return _Utils_Tuple2(
					$author$project$Main$Loaded(
						{
							ac: newEnvironment,
							ba: $author$project$Page$Navbar$init(
								$author$project$Main$getNavbarType(newEnvironment)),
							ak: page,
							ae: model.ae,
							f: A4($author$project$Main$Utils, $author$project$UI$OrganisationUnitNavigation$hidden, $author$project$Auth$ReLoginModal$hidden, $author$project$Tenant$EditModal$hidden, $author$project$Page$Modals$CompleteSyncModal$hidden)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedPageMsg, pageCmd));
			} else {
				return _Utils_Tuple2(
					$author$project$Main$Loading(
						{ac: model.ac, az: $author$project$Auth$ReLoginModal$hidden, ae: model.ae}),
					$elm$core$Platform$Cmd$none);
			}
		}
	} else {
		return _Utils_Tuple2(
			$author$project$Main$Loading(model),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Main$fromLogin = function (model) {
	var session = $author$project$Environments$Environment$session(model.ac);
	if ($author$project$Environments$Environment$isLoaded(model.ac)) {
		if ($author$project$Auth$Session$isUnknown(session) || $author$project$Auth$Session$isUnauthorized(session)) {
			var _v0 = A2($author$project$Auth$Login$show, model.ac, model.dU);
			var login = _v0.a;
			var loginCmd = _v0.b;
			return _Utils_Tuple2(
				$author$project$Main$Login(
					{ac: model.ac, dT: login, dU: model.dU, ae: model.ae}),
				A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedLoginMsg, loginCmd));
		} else {
			if ($author$project$Auth$Session$isExpired(session)) {
				var _v1 = $author$project$Environments$Repository$init;
				var repository = _v1.a;
				var repositoryCmd = _v1.b;
				var _v2 = $author$project$Auth$ReLoginModal$init(
					$author$project$Environments$Repository$getTenant(model.ae));
				var reLogin = _v2.a;
				var reLoginCmd = _v2.b;
				return _Utils_Tuple2(
					$author$project$Main$Loading(
						{ac: model.ac, az: reLogin, ae: repository}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedRepositoryMsg, repositoryCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedReLoginMsg, reLoginCmd)
							])));
			} else {
				var _v3 = $author$project$Environments$Repository$init;
				var repository = _v3.a;
				var repositoryCmd = _v3.b;
				return _Utils_Tuple2(
					$author$project$Main$Loading(
						{ac: model.ac, az: $author$project$Auth$ReLoginModal$hidden, ae: repository}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedRepositoryMsg, repositoryCmd));
			}
		}
	} else {
		return _Utils_Tuple2(
			$author$project$Main$Login(model),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Main$handleChangedAppState = F3(
	function (appState, environment, repository) {
		var _v0 = function () {
			if (!appState) {
				return $author$project$Environments$Repository$connectToEventStream(
					_Utils_Tuple3(environment, repository, _List_Nil));
			} else {
				return $author$project$Environments$Repository$disconnectFromEventStream(
					_Utils_Tuple3(environment, repository, _List_Nil));
			}
		}();
		var newRepository = _v0.b;
		var repositoryCmd = _v0.c;
		return _Utils_Tuple2(
			newRepository,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$Cmd$map($author$project$Main$ReceivedRepositoryMsg),
					repositoryCmd)));
	});
var $author$project$Main$handleChangedNetworkState = F3(
	function (networkState, environment, repository) {
		var _v0 = function () {
			if (!networkState) {
				return $author$project$Environments$Repository$connectToEventStream(
					_Utils_Tuple3(environment, repository, _List_Nil));
			} else {
				return $author$project$Environments$Repository$disconnectFromEventStream(
					_Utils_Tuple3(environment, repository, _List_Nil));
			}
		}();
		var newRepository = _v0.b;
		var repositoryCmd = _v0.c;
		return _Utils_Tuple2(
			newRepository,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$Cmd$map($author$project$Main$ReceivedRepositoryMsg),
					repositoryCmd)));
	});
var $author$project$Main$utilsUpdateReLogin = F3(
	function (environment, repository, utils) {
		if ($author$project$Auth$Session$isExpired(
			$author$project$Environments$Environment$session(environment))) {
			var _v0 = $author$project$Auth$ReLoginModal$init(
				$author$project$Environments$Repository$getTenant(repository));
			var newReLogin = _v0.a;
			var reLoginCmd = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					utils,
					{az: newReLogin}),
				A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedReLoginMsg, reLoginCmd));
		} else {
			return _Utils_Tuple2(utils, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$receivedEnvironmentMsg = F2(
	function (environmentMsg, state) {
		switch (state.$) {
			case 0:
				var model = state.a;
				return $author$project$Main$fromLoading(
					_Utils_update(
						model,
						{
							ac: A2($author$project$Environments$Environment$update, environmentMsg, model.ac)
						}));
			case 1:
				var model = state.a;
				return $author$project$Main$fromLogin(
					_Utils_update(
						model,
						{
							ac: A2($author$project$Environments$Environment$update, environmentMsg, model.ac)
						}));
			case 2:
				var model = state.a;
				var newEnvironment = A2($author$project$Environments$Environment$update, environmentMsg, model.ac);
				var newNavbar = function () {
					switch (environmentMsg.$) {
						case 5:
							return A2(
								$author$project$Page$Navbar$changeBarPosition,
								$author$project$Main$getNavbarType(newEnvironment),
								model.ba);
						case 4:
							return A2(
								$author$project$Page$Navbar$changeBarPosition,
								$author$project$Main$getNavbarType(newEnvironment),
								model.ba);
						default:
							return model.ba;
					}
				}();
				var _v1 = function () {
					switch (environmentMsg.$) {
						case 0:
							var appState = environmentMsg.a;
							return A3($author$project$Main$handleChangedAppState, appState, newEnvironment, model.ae);
						case 1:
							var networkState = environmentMsg.a;
							return A3($author$project$Main$handleChangedNetworkState, networkState, newEnvironment, model.ae);
						case 10:
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Main$ReceivedRepositoryMsg),
								$author$project$Environments$Repository$init);
						default:
							return _Utils_Tuple2(model.ae, $elm$core$Platform$Cmd$none);
					}
				}();
				var newRepository = _v1.a;
				var repositoryCmd = _v1.b;
				var _v3 = A3($author$project$Main$utilsUpdateReLogin, newEnvironment, newRepository, model.f);
				var newUtils = _v3.a;
				var reLoginCmd = _v3.b;
				return _Utils_Tuple2(
					$author$project$Main$Loaded(
						_Utils_update(
							model,
							{ac: newEnvironment, ba: newNavbar, ae: newRepository, f: newUtils})),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[repositoryCmd, reLoginCmd])));
			default:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Environments$Environment$unsetLastError = function (state) {
	return A2(
		$author$project$Environments$Environment$map,
		function (model) {
			return _Utils_update(
				model,
				{eH: $elm$core$Maybe$Nothing});
		},
		state);
};
var $author$project$Main$receivedErrorModalMsg = F2(
	function (msg, state) {
		var newEnvironment = function (model) {
			switch (msg.$) {
				case 0:
					return $author$project$Environments$Environment$unsetLastError(model.ac);
				case 1:
					return model.ac;
				default:
					return model.ac;
			}
		};
		var _v0 = A2($author$project$Environments$ErrorHandling$ErrorModal$update, msg, $author$project$Environments$ErrorHandling$ErrorModal$hidden);
		var cmd = _v0.b;
		switch (state.$) {
			case 0:
				var model = state.a;
				return _Utils_Tuple2(
					$author$project$Main$Loading(
						_Utils_update(
							model,
							{
								ac: newEnvironment(model)
							})),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedErrorModalMsg, cmd));
			case 1:
				var model = state.a;
				return _Utils_Tuple2(
					$author$project$Main$Login(
						_Utils_update(
							model,
							{
								ac: newEnvironment(model)
							})),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedErrorModalMsg, cmd));
			case 2:
				var model = state.a;
				return _Utils_Tuple2(
					$author$project$Main$Loaded(
						_Utils_update(
							model,
							{
								ac: newEnvironment(model)
							})),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedErrorModalMsg, cmd));
			default:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Login$getLoginForm = function (state) {
	switch (state.$) {
		case 0:
			var loginForm = state.a;
			return loginForm;
		case 1:
			var loginForm = state.a;
			return loginForm;
		default:
			var loginForm = state.a;
			return loginForm;
	}
};
var $author$project$Auth$Login$Failure = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Auth$Login$Sending = function (a) {
	return {$: 1, a: a};
};
var $author$project$Auth$Login$changeBaseUriModalState = F3(
	function (newModal, environment, state) {
		switch (state.$) {
			case 0:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{aE: newModal})),
					$elm$core$Platform$Cmd$none);
			case 1:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Sending(
						_Utils_update(
							form,
							{aE: newModal})),
					$elm$core$Platform$Cmd$none);
			default:
				var form = state.a;
				var string = state.b;
				return _Utils_Tuple3(
					environment,
					A2(
						$author$project$Auth$Login$Failure,
						_Utils_update(
							form,
							{aE: newModal}),
						string),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Login$gotCurrentUrl = F3(
	function (url, environment, state) {
		var tenantName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (str) {
					return A3(
						$elm$core$String$replace,
						'%',
						' ',
						A3(
							$elm$core$String$replace,
							'%C3%9F',
							'ß',
							A3(
								$elm$core$String$replace,
								'%C3%9C',
								'Ü',
								A3(
									$elm$core$String$replace,
									'%C3%BC',
									'ü',
									A3(
										$elm$core$String$replace,
										'%C3%96',
										'Ö',
										A3(
											$elm$core$String$replace,
											'%C3%B6',
											'ö',
											A3(
												$elm$core$String$replace,
												'%C3%84',
												'Ä',
												A3(
													$elm$core$String$replace,
													'%C3%A4',
													'ä',
													A3(
														$elm$core$String$replace,
														'%25',
														' ',
														A3(
															$elm$core$String$replace,
															'%20',
															' ',
															A3($elm$core$String$replace, 'tenant=', '', str)))))))))));
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (str) {
							return A2($elm$core$String$contains, 'tenant=', str);
						},
						$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								function (str) {
									return A2($elm$core$String$split, '&', str);
								},
								A2(
									$elm$core$String$split,
									'?',
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$elm$core$List$head(
											A2($elm$core$String$split, '#', url))))))))));
		switch (state.$) {
			case 0:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{aP: tenantName})),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			default:
				var form = state.a;
				var externalString = state.b;
				return _Utils_Tuple3(
					environment,
					A2(
						$author$project$Auth$Login$Failure,
						_Utils_update(
							form,
							{aP: tenantName}),
						externalString),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Login$FocusedInput = function (a) {
	return {$: 8, a: a};
};
var $author$project$Auth$Login$loginFailed = F3(
	function (environment, state, externalMsg) {
		switch (state.$) {
			case 0:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					A2($author$project$Auth$Login$Failure, form, externalMsg),
					$elm$core$Platform$Cmd$none);
			case 1:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					A2($author$project$Auth$Login$Failure, form, externalMsg),
					A2(
						$elm$core$Task$attempt,
						$author$project$Auth$Login$FocusedInput,
						$elm$browser$Browser$Dom$focus('login-password')));
			default:
				var from = state.a;
				return _Utils_Tuple3(
					environment,
					A2($author$project$Auth$Login$Failure, from, externalMsg),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Session$Authorized = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Auth$Session$authorized = $author$project$Auth$Session$Authorized;
var $author$project$Environments$Environment$SaveSession = function (a) {
	return {$: 1, a: a};
};
var $author$project$Environments$Environment$saveSession = F2(
	function (session_, state) {
		return _Utils_Tuple2(
			A2(
				$author$project$Environments$Environment$map,
				function (model) {
					return _Utils_update(
						model,
						{aO: session_});
				},
				state),
			$author$project$Environments$Environment$send(
				$author$project$Environments$Environment$SaveSession(session_)));
	});
var $author$project$Auth$Login$loginSucceeded = F4(
	function (tenantId, userId, environment, state) {
		var newSession = A2($author$project$Auth$Session$authorized, tenantId, userId);
		var _v0 = A2($author$project$Environments$Environment$saveSession, newSession, environment);
		var newEnvironment = _v0.a;
		var environmentCmd = _v0.b;
		return _Utils_Tuple3(newEnvironment, state, environmentCmd);
	});
var $author$project$Auth$Login$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'Login.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$Auth$Login$getBaseUri = function (state) {
	switch (state.$) {
		case 0:
			var form = state.a;
			return form.bC;
		case 1:
			var form = state.a;
			return form.bC;
		default:
			var form = state.a;
			return form.bC;
	}
};
var $author$project$Environments$Environment$saveBaseUri = F2(
	function (baseUri_, state) {
		return A2(
			$author$project$Environments$Environment$map,
			function (model) {
				return _Utils_update(
					model,
					{bC: baseUri_});
			},
			state);
	});
var $author$project$Auth$Login$savedBaseUri = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				var form = state.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Environments$Environment$saveBaseUri,
						$author$project$Auth$Login$getBaseUri(state),
						environment),
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{aE: 1})),
					$elm$core$Platform$Cmd$none);
			case 1:
				var form = state.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Environments$Environment$saveBaseUri,
						$author$project$Auth$Login$getBaseUri(state),
						environment),
					$author$project$Auth$Login$Sending(
						_Utils_update(
							form,
							{aE: 1})),
					$elm$core$Platform$Cmd$none);
			default:
				var form = state.a;
				var string = state.b;
				return _Utils_Tuple3(
					A2(
						$author$project$Environments$Environment$saveBaseUri,
						$author$project$Auth$Login$getBaseUri(state),
						environment),
					A2(
						$author$project$Auth$Login$Failure,
						_Utils_update(
							form,
							{aE: 1}),
						string),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Login$Login = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Auth$Login$encodeOutMsg = function (msg) {
	switch (msg.$) {
		case 0:
			var tenantName = msg.a;
			var username = msg.b;
			var password = msg.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('LOGIN')),
						_Utils_Tuple2(
						'tenantName',
						$elm$json$Json$Encode$string(tenantName)),
						_Utils_Tuple2(
						'username',
						$elm$json$Json$Encode$string(username)),
						_Utils_Tuple2(
						'password',
						$author$project$Auth$Password$encode(password))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('GET_CURRENT_URL'))
					]));
		default:
			var baseUri = msg.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('SAVE_BASE_URI')),
						_Utils_Tuple2(
						'baseUri',
						$elm$json$Json$Encode$string(baseUri))
					]));
	}
};
var $author$project$Auth$Login$loginOutbox = _Platform_outgoingPort('loginOutbox', $elm$core$Basics$identity);
var $author$project$Auth$Login$send = A2($elm$core$Basics$composeR, $author$project$Auth$Login$encodeOutMsg, $author$project$Auth$Login$loginOutbox);
var $author$project$Auth$Login$userClickedLoginButton = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				var form = state.a;
				var _v1 = _Utils_Tuple3(
					$elm$core$String$trim(form.aP),
					$elm$core$String$trim(form.iK),
					$author$project$Auth$Password$fromString(
						$elm$core$String$trim(form.a1)));
				if (!_v1.c.$) {
					var tenantName = _v1.a;
					var username = _v1.b;
					var password = _v1.c.a;
					return _Utils_Tuple3(
						environment,
						$author$project$Auth$Login$Sending(
							_Utils_update(
								form,
								{
									a1: $elm$core$String$trim(form.a1),
									aP: tenantName,
									iK: username
								})),
						$author$project$Auth$Login$send(
							A3($author$project$Auth$Login$Login, tenantName, username, password)));
				} else {
					return _Utils_Tuple3(
						environment,
						A2($author$project$Auth$Login$Failure, form, 'LOGIN_INVALID'),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Login$SaveBaseUri = function (a) {
	return {$: 2, a: a};
};
var $author$project$Auth$Login$userClickedSaveBaseUri = F2(
	function (environment, state) {
		if (_Utils_eq(
			$author$project$Environments$Environment$baseUri(environment),
			$author$project$Auth$Login$getBaseUri(state))) {
			switch (state.$) {
				case 0:
					var form = state.a;
					return _Utils_Tuple3(
						environment,
						$author$project$Auth$Login$Visible(
							_Utils_update(
								form,
								{aE: 1})),
						$elm$core$Platform$Cmd$none);
				case 1:
					var form = state.a;
					return _Utils_Tuple3(
						environment,
						$author$project$Auth$Login$Sending(
							_Utils_update(
								form,
								{aE: 1})),
						$elm$core$Platform$Cmd$none);
				default:
					var form = state.a;
					var string = state.b;
					return _Utils_Tuple3(
						environment,
						A2(
							$author$project$Auth$Login$Failure,
							_Utils_update(
								form,
								{aE: 1}),
							string),
						$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple3(
				environment,
				state,
				$author$project$Auth$Login$send(
					$author$project$Auth$Login$SaveBaseUri(
						$author$project$Auth$Login$getBaseUri(state))));
		}
	});
var $author$project$Auth$Login$userEnteredBaseUri = F3(
	function (input, environment, state) {
		var trimmedInput = $elm$core$String$trim(input);
		switch (state.$) {
			case 0:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{bC: trimmedInput})),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			default:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{bC: trimmedInput})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Login$userEnteredPassword = F3(
	function (password, environment, state) {
		switch (state.$) {
			case 0:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{a1: password})),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			default:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{a1: password})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Login$userEnteredTenantName = F3(
	function (tenantName, environment, state) {
		switch (state.$) {
			case 0:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{aP: tenantName})),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			default:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{aP: tenantName})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Login$userEnteredUsername = F3(
	function (username, environment, state) {
		switch (state.$) {
			case 0:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{iK: username})),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			default:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$Login$Visible(
						_Utils_update(
							form,
							{iK: username})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Login$userPressedEnterOnPasswordInput = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				var form = state.a;
				var _v1 = _Utils_Tuple3(
					form.aP,
					form.iK,
					$author$project$Auth$Password$fromString(form.a1));
				if (!_v1.c.$) {
					var tenantName = _v1.a;
					var username = _v1.b;
					var password = _v1.c.a;
					return _Utils_Tuple3(
						environment,
						$author$project$Auth$Login$Sending(form),
						$author$project$Auth$Login$send(
							A3($author$project$Auth$Login$Login, tenantName, username, password)));
				} else {
					return _Utils_Tuple3(
						environment,
						$author$project$Auth$Login$Visible(form),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$Login$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var tenantName = msg.a;
				return A3($author$project$Auth$Login$userEnteredTenantName, tenantName, environment, state);
			case 1:
				var username = msg.a;
				return A3($author$project$Auth$Login$userEnteredUsername, username, environment, state);
			case 2:
				var password = msg.a;
				return A3($author$project$Auth$Login$userEnteredPassword, password, environment, state);
			case 3:
				return A2($author$project$Auth$Login$userPressedEnterOnPasswordInput, environment, state);
			case 4:
				return A2($author$project$Auth$Login$userClickedLoginButton, environment, state);
			case 5:
				var tenantId = msg.a;
				var userId = msg.b;
				return A4($author$project$Auth$Login$loginSucceeded, tenantId, userId, environment, state);
			case 6:
				var externalMsg = msg.a;
				return A3($author$project$Auth$Login$loginFailed, environment, state, externalMsg);
			case 7:
				var url = msg.a;
				return A3($author$project$Auth$Login$gotCurrentUrl, url, environment, state);
			case 8:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 9:
				var err = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Auth$Login$receivedErrorMsg, err, environment),
					state,
					$elm$core$Platform$Cmd$none);
			case 10:
				var newModal = msg.a;
				return A3($author$project$Auth$Login$changeBaseUriModalState, newModal, environment, state);
			case 11:
				var input = msg.a;
				return A3($author$project$Auth$Login$userEnteredBaseUri, input, environment, state);
			case 12:
				return A2($author$project$Auth$Login$userClickedSaveBaseUri, environment, state);
			default:
				return A2($author$project$Auth$Login$savedBaseUri, environment, state);
		}
	});
var $author$project$Main$receivedLoginMsg = F2(
	function (loginMsg, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 1:
				var model = state.a;
				var _v1 = A3($author$project$Auth$Login$update, loginMsg, model.ac, model.dT);
				var newEnvironment = _v1.a;
				var newLogin = _v1.b;
				var loginCmd = _v1.c;
				return _Utils_Tuple2(
					$author$project$Main$Login(
						_Utils_update(
							model,
							{
								ac: newEnvironment,
								dT: newLogin,
								dU: $author$project$Auth$Login$getLoginForm(newLogin)
							})),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedLoginMsg, loginCmd));
			case 2:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$LogoutResponse = function (a) {
	return {$: 6, a: a};
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{iP: true, dq: r.dq, jz: r.jz, hX: r.hX, h7: r.h7, iF: r.iF, iH: r.iH, lg: r.lg}));
};
var $author$project$Main$logoutCmd = function (state) {
	switch (state.$) {
		case 0:
			var loadingModel = state.a;
			var uri = $author$project$Environments$Environment$baseUri(loadingModel.ac);
			return $elm$http$Http$riskyRequest(
				{
					dq: $elm$http$Http$emptyBody,
					jz: $elm$http$Http$expectWhatever($author$project$Main$LogoutResponse),
					hX: _List_Nil,
					h7: 'POST',
					iF: $elm$core$Maybe$Nothing,
					iH: $elm$core$Maybe$Nothing,
					lg: uri + '/logout'
				});
		case 2:
			var loadedModel = state.a;
			var uri = $author$project$Environments$Environment$baseUri(loadedModel.ac);
			return $elm$http$Http$riskyRequest(
				{
					dq: $elm$http$Http$emptyBody,
					jz: $elm$http$Http$expectWhatever($author$project$Main$LogoutResponse),
					hX: _List_Nil,
					h7: 'POST',
					iF: $elm$core$Maybe$Nothing,
					iH: $elm$core$Maybe$Nothing,
					lg: uri + '/logout'
				});
		default:
			return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Main$receivedLogoutMsg = function (state) {
	if (state.$ === 3) {
		return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
	} else {
		return _Utils_Tuple2(
			state,
			$author$project$Main$logoutCmd(state));
	}
};
var $author$project$Environments$Environment$DeleteSession = {$: 2};
var $author$project$Main$LoginModel = F4(
	function (environment, repository, login, loginForm) {
		return {ac: environment, dT: login, dU: loginForm, ae: repository};
	});
var $author$project$Auth$Session$unauthorized = $author$project$Auth$Session$Unauthorized;
var $author$project$Environments$Environment$clearSession = function (state) {
	return A2(
		$author$project$Environments$Environment$map,
		function (model) {
			return _Utils_update(
				model,
				{eb: $author$project$Environments$Route$MainMenu, aO: $author$project$Auth$Session$unauthorized});
		},
		state);
};
var $author$project$Auth$Login$LoginForm = F5(
	function (tenantName, username, password, baseUri, baseUriModal) {
		return {bC: baseUri, aE: baseUriModal, a1: password, aP: tenantName, iK: username};
	});
var $author$project$Auth$Login$emptyVisibleState = function (environment) {
	return $author$project$Auth$Login$Visible(
		A5(
			$author$project$Auth$Login$LoginForm,
			'',
			'',
			'',
			$author$project$Environments$Environment$baseUri(environment),
			1));
};
var $author$project$Main$clearSession = function (model) {
	return _Utils_Tuple2(
		$author$project$Main$Login(
			A4(
				$author$project$Main$LoginModel,
				$author$project$Environments$Environment$clearSession(model.ac),
				model.ae,
				$author$project$Auth$Login$emptyVisibleState(model.ac),
				$author$project$Auth$Login$emptyLoginForm(model.ac))),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Environments$Environment$send($author$project$Environments$Environment$DeleteSession)
				])));
};
var $author$project$Main$receivedLogoutResponse = function (state) {
	switch (state.$) {
		case 0:
			var model = state.a;
			return $author$project$Main$clearSession(model);
		case 2:
			var model = state.a;
			return $author$project$Main$clearSession(model);
		case 1:
			var model = state.a;
			return $author$project$Main$clearSession(model);
		default:
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Page$Navbar$closeExtendedMenu = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Collapsed,
						pointerState,
						_Utils_update(
							model,
							{O: 0})));
			case 1:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Expanded,
						pointerState,
						_Utils_update(
							model,
							{O: 0})));
			default:
				return _Utils_Tuple2(environment, state);
		}
	});
var $tad_lispy$springs$Spring$Spring = $elm$core$Basics$identity;
var $tad_lispy$springs$Spring$jumpTo = F2(
	function (newValue, _v0) {
		var _this = _v0;
		return _Utils_update(
			_this,
			{ll: newValue, dl: 0.0});
	});
var $tad_lispy$springs$Spring$animate = F2(
	function (delta, spring) {
		var _this = spring;
		if ($tad_lispy$springs$Spring$atRest(spring)) {
			return spring;
		} else {
			if (($elm$core$Basics$abs(_this.ll - _this.de) < 0.05) && ($elm$core$Basics$abs(_this.dl) < 0.05)) {
				return A2($tad_lispy$springs$Spring$jumpTo, _this.de, spring);
			} else {
				var time = A2($elm$core$Basics$min, delta, 32) / 1000;
				var stretch = _this.de - _this.ll;
				var force = stretch * _this.iy;
				var damping = _this.dl * _this.hG;
				var acceleration = time * (force - damping);
				var velocity = _this.dl + acceleration;
				var newValue = _this.ll + (velocity * time);
				return _Utils_update(
					_this,
					{ll: newValue, dl: velocity});
			}
		}
	});
var $tad_lispy$springs$Spring$target = function (_v0) {
	var _this = _v0;
	return _this.de;
};
var $author$project$Page$Navbar$gotAnimationFrame = F2(
	function (delta, state) {
		if (state.$ === 3) {
			var spring = state.a;
			var model = state.b;
			var newSpring = A2($tad_lispy$springs$Spring$animate, delta, spring);
			if ($tad_lispy$springs$Spring$atRest(newSpring)) {
				var _v1 = model.aD;
				if (!_v1) {
					return ($tad_lispy$springs$Spring$target(newSpring) <= 0) ? A2($author$project$Page$Navbar$Expanded, $author$project$Page$Navbar$PointerUp, model) : A2($author$project$Page$Navbar$Collapsed, $author$project$Page$Navbar$PointerUp, model);
				} else {
					return ($tad_lispy$springs$Spring$target(newSpring) >= 0) ? A2($author$project$Page$Navbar$Expanded, $author$project$Page$Navbar$PointerUp, model) : A2($author$project$Page$Navbar$Collapsed, $author$project$Page$Navbar$PointerUp, model);
				}
			} else {
				return A2($author$project$Page$Navbar$Animating, newSpring, model);
			}
		} else {
			return state;
		}
	});
var $author$project$Page$Navbar$Visible = 1;
var $elm$core$Basics$pow = _Basics_pow;
var $tad_lispy$springs$Spring$create = function (_v0) {
	var strength = _v0.iy;
	var dampness = _v0.hG;
	return {
		hG: A2($elm$core$Basics$pow, dampness, 2),
		iy: strength,
		de: 0,
		ll: 0,
		dl: 0
	};
};
var $author$project$Page$Navbar$offsetXBase = 300;
var $author$project$Page$Navbar$offsetYBase = function (platform) {
	if (platform.$ === 2) {
		return -510;
	} else {
		return -475;
	}
};
var $tad_lispy$springs$Spring$setTarget = F2(
	function (newTarget, _v0) {
		var spring = _v0;
		return _Utils_update(
			spring,
			{de: newTarget});
	});
var $author$project$Page$Navbar$springDampness = 6;
var $author$project$Page$Navbar$springStrength = 500;
var $author$project$Page$Navbar$collapse = F3(
	function (platform, position, model) {
		var target = function () {
			var _v0 = model.aD;
			if (!_v0) {
				return $author$project$Page$Navbar$offsetXBase;
			} else {
				return $author$project$Page$Navbar$offsetYBase(platform);
			}
		}();
		var spring = A2(
			$tad_lispy$springs$Spring$jumpTo,
			position,
			A2(
				$tad_lispy$springs$Spring$setTarget,
				target,
				$tad_lispy$springs$Spring$create(
					{hG: $author$project$Page$Navbar$springDampness, iy: $author$project$Page$Navbar$springStrength})));
		return A2($author$project$Page$Navbar$Animating, spring, model);
	});
var $author$project$Page$Navbar$openExtendedMenu = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				var pointerState = state.a;
				var model = state.b;
				var newExtendedState = function () {
					var _v1 = model.O;
					if (!_v1) {
						return 1;
					} else {
						return 0;
					}
				}();
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Collapsed,
						pointerState,
						_Utils_update(
							model,
							{O: newExtendedState})));
			case 1:
				var model = state.b;
				var newExtendedState = function () {
					var _v2 = model.O;
					if (!_v2) {
						return 1;
					} else {
						return 0;
					}
				}();
				return _Utils_Tuple2(
					environment,
					A3(
						$author$project$Page$Navbar$collapse,
						$author$project$Environments$Environment$platform(environment),
						0,
						_Utils_update(
							model,
							{O: newExtendedState})));
			default:
				return _Utils_Tuple2(environment, state);
		}
	});
var $author$project$Page$Modals$AboutModal$closeDialog = 0;
var $author$project$Page$Modals$AboutModal$update = function (msg) {
	return $author$project$Page$Modals$AboutModal$closeDialog;
};
var $author$project$Page$Navbar$receivedAboutModalMsg = F3(
	function (environment, state, aboutModalMsg) {
		switch (state.$) {
			case 0:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Collapsed,
						pointerState,
						_Utils_update(
							model,
							{
								bR: $author$project$Page$Modals$AboutModal$update(aboutModalMsg)
							})));
			case 1:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Expanded,
						pointerState,
						_Utils_update(
							model,
							{
								bR: $author$project$Page$Modals$AboutModal$update(aboutModalMsg)
							})));
			default:
				return _Utils_Tuple2(environment, state);
		}
	});
var $author$project$Auth$LogoutModal$closeDialog = 0;
var $author$project$Auth$LogoutModal$update = function (msg) {
	return $author$project$Auth$LogoutModal$closeDialog;
};
var $author$project$Page$Navbar$receivedLogoutModalMsg = F3(
	function (environment, state, logoutModalMsg) {
		switch (state.$) {
			case 0:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Collapsed,
						pointerState,
						_Utils_update(
							model,
							{
								ci: $author$project$Auth$LogoutModal$update(logoutModalMsg)
							})));
			case 1:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Expanded,
						pointerState,
						_Utils_update(
							model,
							{
								ci: $author$project$Auth$LogoutModal$update(logoutModalMsg)
							})));
			default:
				return _Utils_Tuple2(environment, state);
		}
	});
var $author$project$Page$Modals$ConfirmOpenSettings$closeDialog = 0;
var $author$project$Page$Modals$ConfirmOpenSettings$update = function (msg) {
	return $author$project$Page$Modals$ConfirmOpenSettings$closeDialog;
};
var $author$project$Page$Navbar$receivedSettingsConfirmModalMsg = F3(
	function (msg, environment, state) {
		if (!msg) {
			switch (state.$) {
				case 0:
					var pointerState = state.a;
					var model = state.b;
					return _Utils_Tuple2(
						environment,
						A2(
							$author$project$Page$Navbar$Collapsed,
							pointerState,
							_Utils_update(
								model,
								{
									dv: $author$project$Page$Modals$ConfirmOpenSettings$update(msg)
								})));
				case 1:
					var pointerState = state.a;
					var model = state.b;
					return _Utils_Tuple2(
						environment,
						A2(
							$author$project$Page$Navbar$Expanded,
							pointerState,
							_Utils_update(
								model,
								{
									dv: $author$project$Page$Modals$ConfirmOpenSettings$update(msg)
								})));
				default:
					return _Utils_Tuple2(environment, state);
			}
		} else {
			switch (state.$) {
				case 0:
					var pointerState = state.a;
					var model = state.b;
					return _Utils_Tuple2(
						A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Settings, environment),
						A2(
							$author$project$Page$Navbar$Collapsed,
							pointerState,
							_Utils_update(
								model,
								{
									dv: $author$project$Page$Modals$ConfirmOpenSettings$update(msg),
									O: 0
								})));
				case 1:
					var model = state.b;
					return _Utils_Tuple2(
						A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Settings, environment),
						A3(
							$author$project$Page$Navbar$collapse,
							$author$project$Environments$Environment$platform(environment),
							0,
							_Utils_update(
								model,
								{
									dv: $author$project$Page$Modals$ConfirmOpenSettings$update(msg),
									O: 0
								})));
				default:
					return _Utils_Tuple2(environment, state);
			}
		}
	});
var $author$project$Environments$Environment$route = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.eb;
	});
var $author$project$Page$Navbar$receivedUserClickedSettingsEntry = F2(
	function (environment, state) {
		var viewType = $author$project$Environments$Environment$getViewType(environment);
		if (viewType === 1) {
			if (_Utils_eq(
				$author$project$Environments$Environment$route(environment),
				$author$project$Environments$Route$Settings) || (_Utils_eq(
				$author$project$Environments$Environment$route(environment),
				$author$project$Environments$Route$Users) || (_Utils_eq(
				$author$project$Environments$Environment$route(environment),
				$author$project$Environments$Route$OrganisationUnits) || _Utils_eq(
				$author$project$Environments$Environment$route(environment),
				$author$project$Environments$Route$Plans)))) {
				switch (state.$) {
					case 0:
						var pointerState = state.a;
						var model = state.b;
						return _Utils_Tuple2(
							A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Settings, environment),
							A2(
								$author$project$Page$Navbar$Collapsed,
								pointerState,
								_Utils_update(
									model,
									{O: 0})));
					case 1:
						var model = state.b;
						return _Utils_Tuple2(
							A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Settings, environment),
							A3(
								$author$project$Page$Navbar$collapse,
								$author$project$Environments$Environment$platform(environment),
								0,
								_Utils_update(
									model,
									{O: 0})));
					default:
						return _Utils_Tuple2(environment, state);
				}
			} else {
				switch (state.$) {
					case 0:
						var pointerState = state.a;
						var model = state.b;
						return _Utils_Tuple2(
							environment,
							A2(
								$author$project$Page$Navbar$Collapsed,
								pointerState,
								_Utils_update(
									model,
									{dv: $author$project$Page$Modals$ConfirmOpenSettings$visible})));
					case 1:
						var pointerState = state.a;
						var model = state.b;
						return _Utils_Tuple2(
							environment,
							A2(
								$author$project$Page$Navbar$Expanded,
								pointerState,
								_Utils_update(
									model,
									{dv: $author$project$Page$Modals$ConfirmOpenSettings$visible})));
					default:
						return _Utils_Tuple2(environment, state);
				}
			}
		} else {
			var deviceHeight = $author$project$Environments$Environment$viewport(environment).Y;
			if (deviceHeight > 800) {
				switch (state.$) {
					case 0:
						var pointerState = state.a;
						var model = state.b;
						return _Utils_Tuple2(
							A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Settings, environment),
							A2(
								$author$project$Page$Navbar$Collapsed,
								pointerState,
								_Utils_update(
									model,
									{O: 0})));
					case 1:
						var model = state.b;
						return _Utils_Tuple2(
							A2($author$project$Environments$Environment$navigateTo, $author$project$Environments$Route$Settings, environment),
							A3(
								$author$project$Page$Navbar$collapse,
								$author$project$Environments$Environment$platform(environment),
								0,
								_Utils_update(
									model,
									{O: 0})));
					default:
						return _Utils_Tuple2(environment, state);
				}
			} else {
				switch (state.$) {
					case 0:
						var pointerState = state.a;
						var model = state.b;
						return _Utils_Tuple2(
							environment,
							A2(
								$author$project$Page$Navbar$Collapsed,
								pointerState,
								_Utils_update(
									model,
									{dv: $author$project$Page$Modals$ConfirmOpenSettings$visible})));
					case 1:
						var pointerState = state.a;
						var model = state.b;
						return _Utils_Tuple2(
							environment,
							A2(
								$author$project$Page$Navbar$Expanded,
								pointerState,
								_Utils_update(
									model,
									{dv: $author$project$Page$Modals$ConfirmOpenSettings$visible})));
					default:
						return _Utils_Tuple2(environment, state);
				}
			}
		}
	});
var $author$project$Page$Modals$AboutModal$Visible = 1;
var $author$project$Page$Modals$AboutModal$visible = 1;
var $author$project$Page$Navbar$userClickedAbout = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Collapsed,
						pointerState,
						_Utils_update(
							model,
							{bR: $author$project$Page$Modals$AboutModal$visible})));
			case 1:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Expanded,
						pointerState,
						_Utils_update(
							model,
							{bR: $author$project$Page$Modals$AboutModal$visible})));
			default:
				return _Utils_Tuple2(environment, state);
		}
	});
var $author$project$Page$Navbar$userClickedCollapseIcon = F2(
	function (environment, state) {
		if (state.$ === 1) {
			var model = state.b;
			return A3(
				$author$project$Page$Navbar$collapse,
				$author$project$Environments$Environment$platform(environment),
				0,
				model);
		} else {
			return state;
		}
	});
var $author$project$Page$Navbar$userClickedEntry = F3(
	function (route, environment, state) {
		switch (state.$) {
			case 0:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					A2($author$project$Environments$Environment$navigateTo, route, environment),
					A2(
						$author$project$Page$Navbar$Collapsed,
						pointerState,
						_Utils_update(
							model,
							{O: 0})));
			case 1:
				var model = state.b;
				return _Utils_Tuple2(
					A2($author$project$Environments$Environment$navigateTo, route, environment),
					A3(
						$author$project$Page$Navbar$collapse,
						$author$project$Environments$Environment$platform(environment),
						0,
						_Utils_update(
							model,
							{O: 0})));
			default:
				return _Utils_Tuple2(environment, state);
		}
	});
var $author$project$Auth$LogoutModal$Visible = 1;
var $author$project$Auth$LogoutModal$visible = 1;
var $author$project$Page$Navbar$userClickedLogout = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Collapsed,
						pointerState,
						_Utils_update(
							model,
							{ci: $author$project$Auth$LogoutModal$visible})));
			case 1:
				var pointerState = state.a;
				var model = state.b;
				return _Utils_Tuple2(
					environment,
					A2(
						$author$project$Page$Navbar$Expanded,
						pointerState,
						_Utils_update(
							model,
							{ci: $author$project$Auth$LogoutModal$visible})));
			default:
				return _Utils_Tuple2(environment, state);
		}
	});
var $author$project$Page$Navbar$startThreshold = 10;
var $author$project$Page$Navbar$userMovedPointer = F3(
	function (environment, pointer, state) {
		_v0$3:
		while (true) {
			switch (state.$) {
				case 0:
					if (state.a.$ === 1) {
						var start = state.a.a;
						var model = state.b;
						return ((_Utils_cmp(start.am - pointer.am, $author$project$Page$Navbar$startThreshold) > -1) || (_Utils_cmp(start.bf - pointer.bf, -$author$project$Page$Navbar$startThreshold) > -1)) ? A2(
							$author$project$Page$Navbar$Swiping,
							{bD: pointer, co: 0, eN: 0, bx: start},
							model) : state;
					} else {
						break _v0$3;
					}
				case 1:
					if (state.a.$ === 1) {
						var start = state.a.a;
						var model = state.b;
						return ((_Utils_cmp(pointer.am - start.am, $author$project$Page$Navbar$startThreshold) > -1) || (_Utils_cmp(start.bf - pointer.bf, -$author$project$Page$Navbar$startThreshold) > -1)) ? A2(
							$author$project$Page$Navbar$Swiping,
							{
								bD: pointer,
								co: $author$project$Page$Navbar$offsetXBase,
								eN: $author$project$Page$Navbar$offsetYBase(
									$author$project$Environments$Environment$platform(environment)),
								bx: start
							},
							model) : state;
					} else {
						break _v0$3;
					}
				case 2:
					var swipingState = state.a;
					var model = state.b;
					return A2(
						$author$project$Page$Navbar$Swiping,
						_Utils_update(
							swipingState,
							{bD: pointer}),
						model);
				default:
					break _v0$3;
			}
		}
		return state;
	});
var $author$project$Page$Navbar$PointerDown = function (a) {
	return {$: 1, a: a};
};
var $tad_lispy$springs$Spring$value = function (_v0) {
	var _this = _v0;
	return _this.ll;
};
var $author$project$Page$Navbar$userPointedDown = F3(
	function (environment, pointer, state) {
		_v0$3:
		while (true) {
			switch (state.$) {
				case 0:
					if (!state.a.$) {
						var _v1 = state.a;
						var model = state.b;
						return A2(
							$author$project$Page$Navbar$Collapsed,
							$author$project$Page$Navbar$PointerDown(pointer),
							model);
					} else {
						break _v0$3;
					}
				case 1:
					if (!state.a.$) {
						var _v2 = state.a;
						var model = state.b;
						return A2(
							$author$project$Page$Navbar$Expanded,
							$author$project$Page$Navbar$PointerDown(pointer),
							model);
					} else {
						break _v0$3;
					}
				case 3:
					var spring = state.a;
					var model = state.b;
					return A2(
						$author$project$Page$Navbar$Swiping,
						{
							bD: pointer,
							co: $author$project$Page$Navbar$offsetXBase - $tad_lispy$springs$Spring$value(spring),
							eN: $author$project$Page$Navbar$offsetYBase(
								$author$project$Environments$Environment$platform(environment)) + $tad_lispy$springs$Spring$value(spring),
							bx: pointer
						},
						model);
				default:
					break _v0$3;
			}
		}
		return state;
	});
var $author$project$Page$Navbar$distanceThreshold = 100;
var $author$project$Page$Navbar$expand = function (position) {
	return $author$project$Page$Navbar$Animating(
		A2(
			$tad_lispy$springs$Spring$jumpTo,
			position,
			A2(
				$tad_lispy$springs$Spring$setTarget,
				0,
				$tad_lispy$springs$Spring$create(
					{hG: $author$project$Page$Navbar$springDampness, iy: $author$project$Page$Navbar$springStrength}))));
};
var $author$project$Page$Navbar$speedThreshold = 0.3;
var $author$project$Page$Navbar$swipingSidebar = F4(
	function (platform, _v0, model, pointer) {
		var start = _v0.bx;
		var offsetX = _v0.co;
		var position = (($author$project$Page$Navbar$offsetXBase - start.am) + pointer.am) - offsetX;
		var duration = pointer.e$ - start.e$;
		var distanceX = start.am - pointer.am;
		var speed = distanceX / duration;
		return (_Utils_cmp(distanceX + offsetX, $author$project$Page$Navbar$offsetXBase) > -1) ? A2($author$project$Page$Navbar$Expanded, $author$project$Page$Navbar$PointerUp, model) : (((distanceX + offsetX) <= 0) ? A2($author$project$Page$Navbar$Collapsed, $author$project$Page$Navbar$PointerUp, model) : ((_Utils_cmp(speed, $author$project$Page$Navbar$speedThreshold) > 0) ? A2($author$project$Page$Navbar$expand, position, model) : ((_Utils_cmp(speed, -$author$project$Page$Navbar$speedThreshold) < 0) ? A3($author$project$Page$Navbar$collapse, platform, position, model) : ((_Utils_cmp(distanceX + offsetX, $author$project$Page$Navbar$distanceThreshold) > -1) ? A2($author$project$Page$Navbar$expand, position, model) : A3($author$project$Page$Navbar$collapse, platform, position, model)))));
	});
var $author$project$Page$Navbar$swipingTopbar = F4(
	function (platform, _v0, model, pointer) {
		var start = _v0.bx;
		var offsetY = _v0.eN;
		var position = (($author$project$Page$Navbar$offsetYBase(platform) - start.bf) + pointer.bf) - offsetY;
		var duration = pointer.e$ - start.e$;
		var distanceY = start.bf - pointer.bf;
		var speed = distanceY / duration;
		return (_Utils_cmp(
			distanceY + offsetY,
			$author$project$Page$Navbar$offsetYBase(platform)) < 1) ? A2($author$project$Page$Navbar$Expanded, $author$project$Page$Navbar$PointerUp, model) : (((distanceY + offsetY) >= 0) ? A2($author$project$Page$Navbar$Collapsed, $author$project$Page$Navbar$PointerUp, model) : ((_Utils_cmp(-speed, $author$project$Page$Navbar$speedThreshold) > 0) ? A2($author$project$Page$Navbar$expand, position, model) : ((_Utils_cmp(-speed, -$author$project$Page$Navbar$speedThreshold) < 0) ? A3($author$project$Page$Navbar$collapse, platform, position, model) : ((_Utils_cmp(distanceY + offsetY, -$author$project$Page$Navbar$distanceThreshold) < 1) ? A2($author$project$Page$Navbar$expand, position, model) : A3($author$project$Page$Navbar$collapse, platform, position, model)))));
	});
var $author$project$Page$Navbar$userPointedUp = F3(
	function (environment, pointer, state) {
		switch (state.$) {
			case 0:
				var model = state.b;
				return A2($author$project$Page$Navbar$Collapsed, $author$project$Page$Navbar$PointerUp, model);
			case 1:
				var model = state.b;
				return A2($author$project$Page$Navbar$Expanded, $author$project$Page$Navbar$PointerUp, model);
			case 2:
				var data = state.a;
				var model = state.b;
				var _v1 = model.aD;
				if (!_v1) {
					return A4(
						$author$project$Page$Navbar$swipingSidebar,
						$author$project$Environments$Environment$platform(environment),
						data,
						model,
						pointer);
				} else {
					return A4(
						$author$project$Page$Navbar$swipingTopbar,
						$author$project$Environments$Environment$platform(environment),
						data,
						model,
						pointer);
				}
			default:
				return state;
		}
	});
var $author$project$Page$Navbar$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var pointer = msg.a;
				return _Utils_Tuple2(
					environment,
					A3($author$project$Page$Navbar$userPointedDown, environment, pointer, state));
			case 1:
				var pointer = msg.a;
				return _Utils_Tuple2(
					environment,
					A3($author$project$Page$Navbar$userMovedPointer, environment, pointer, state));
			case 2:
				var pointer = msg.a;
				return _Utils_Tuple2(
					environment,
					A3($author$project$Page$Navbar$userPointedUp, environment, pointer, state));
			case 3:
				var delta = msg.a;
				return _Utils_Tuple2(
					environment,
					A2($author$project$Page$Navbar$gotAnimationFrame, delta, state));
			case 4:
				return _Utils_Tuple2(
					environment,
					A2($author$project$Page$Navbar$userClickedCollapseIcon, environment, state));
			case 5:
				var route = msg.a;
				return A3($author$project$Page$Navbar$userClickedEntry, route, environment, state);
			case 6:
				return A2($author$project$Page$Navbar$userClickedLogout, environment, state);
			case 7:
				var logoutModalMsg = msg.a;
				return A3($author$project$Page$Navbar$receivedLogoutModalMsg, environment, state, logoutModalMsg);
			case 8:
				return A2($author$project$Page$Navbar$userClickedAbout, environment, state);
			case 9:
				var logoutModalMsg = msg.a;
				return A3($author$project$Page$Navbar$receivedAboutModalMsg, environment, state, logoutModalMsg);
			case 10:
				return A2($author$project$Page$Navbar$receivedUserClickedSettingsEntry, environment, state);
			case 11:
				var modalMsg = msg.a;
				return A3($author$project$Page$Navbar$receivedSettingsConfirmModalMsg, modalMsg, environment, state);
			case 12:
				return A2($author$project$Page$Navbar$openExtendedMenu, environment, state);
			case 13:
				return A2($author$project$Page$Navbar$closeExtendedMenu, environment, state);
			default:
				return _Utils_Tuple2(environment, state);
		}
	});
var $author$project$Main$receivedNavbarMsg = F2(
	function (navbarMsg, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 2:
				var model = state.a;
				var _v1 = A3($author$project$Page$Navbar$update, navbarMsg, model.ac, model.ba);
				var newEnvironment = _v1.a;
				var newNavbar = _v1.b;
				return _Utils_Tuple2(
					$author$project$Main$Loaded(
						_Utils_update(
							model,
							{ac: newEnvironment, ba: newNavbar})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Page$update = F4(
	function (msg, environment, repository, _v0) {
		var page = _v0;
		return A3(page.le, msg, environment, repository);
	});
var $author$project$Main$receivedPageMsg = F2(
	function (pageMsg, state) {
		switch (state.$) {
			case 0:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 2:
				var model = state.a;
				var updateResult = A4($author$project$Page$Page$update, pageMsg, model.ac, model.ae, model.ak);
				return _Utils_Tuple2(
					$author$project$Main$Loaded(
						_Utils_update(
							model,
							{ac: updateResult.ac, ak: updateResult.ak, ae: updateResult.ae})),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedPageMsg, updateResult.ab));
			default:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$ReLoginModal$gotTenant = F3(
	function (tenant, environment, state) {
		if (state.$ === 1) {
			var form = state.a;
			return _Utils_Tuple3(
				environment,
				$author$project$Auth$ReLoginModal$Visible(
					_Utils_update(
						form,
						{iC: tenant.aP})),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$ReLoginModal$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Auth$ReLoginModal$FocusedInput = function (a) {
	return {$: 6, a: a};
};
var $author$project$Auth$ReLoginModal$loginFailed = F3(
	function (environment, state, externalMsg) {
		switch (state.$) {
			case 1:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					A2($author$project$Auth$ReLoginModal$Failure, form, externalMsg),
					$elm$core$Platform$Cmd$none);
			case 2:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					A2($author$project$Auth$ReLoginModal$Failure, form, externalMsg),
					A2(
						$elm$core$Task$attempt,
						$author$project$Auth$ReLoginModal$FocusedInput,
						$elm$browser$Browser$Dom$focus('login-password')));
			case 3:
				var from = state.a;
				return _Utils_Tuple3(
					environment,
					A2($author$project$Auth$ReLoginModal$Failure, from, externalMsg),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$ReLoginModal$loginSucceeded = F4(
	function (tenantId, userId, environment, _v0) {
		var newSession = A2($author$project$Auth$Session$authorized, tenantId, userId);
		var _v1 = A2($author$project$Environments$Environment$saveSession, newSession, environment);
		var newEnvironment = _v1.a;
		var environmentCmd = _v1.b;
		return _Utils_Tuple3(newEnvironment, $author$project$Auth$ReLoginModal$Hidden, environmentCmd);
	});
var $author$project$Auth$ReLoginModal$receivedErrorMsg = F2(
	function (err, environment) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Environments$ErrorHandling$Id$from,
			$author$project$Environments$Environment$generateUuid(environment));
		var newId = _v0.a;
		var newEnvironment = _v0.b;
		var newError = {
			gg: '',
			gE: $author$project$Environments$ErrorHandling$Error$DecodeError(err),
			gH: 'Login.elm',
			gK: 'decodeMsg',
			fw: newId
		};
		return A2($author$project$Environments$Environment$addError, newError, newEnvironment);
	});
var $author$project$Auth$ReLoginModal$Login = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Auth$ReLoginModal$Sending = function (a) {
	return {$: 2, a: a};
};
var $author$project$Auth$ReLoginModal$userClickedLoginButton = F3(
	function (tenantName, environment, state) {
		if (state.$ === 1) {
			var form = state.a;
			var _v1 = _Utils_Tuple2(
				$elm$core$String$trim(form.iK),
				$author$project$Auth$Password$fromString(
					$elm$core$String$trim(form.a1)));
			if (!_v1.b.$) {
				var username = _v1.a;
				var password = _v1.b.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$ReLoginModal$Sending(
						_Utils_update(
							form,
							{
								a1: $elm$core$String$trim(form.a1),
								iK: username
							})),
					$author$project$Auth$ReLoginModal$send(
						A3($author$project$Auth$ReLoginModal$Login, tenantName, username, password)));
			} else {
				return _Utils_Tuple3(
					environment,
					A2($author$project$Auth$ReLoginModal$Failure, form, 'LOGIN_INVALID'),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$ReLoginModal$userEnteredPassword = F3(
	function (password, environment, state) {
		switch (state.$) {
			case 1:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$ReLoginModal$Visible(
						_Utils_update(
							form,
							{a1: password})),
					$elm$core$Platform$Cmd$none);
			case 3:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$ReLoginModal$Visible(
						_Utils_update(
							form,
							{a1: password})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$ReLoginModal$userEnteredUsername = F3(
	function (username, environment, state) {
		switch (state.$) {
			case 1:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$ReLoginModal$Visible(
						_Utils_update(
							form,
							{iK: username})),
					$elm$core$Platform$Cmd$none);
			case 3:
				var form = state.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$ReLoginModal$Visible(
						_Utils_update(
							form,
							{iK: username})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$ReLoginModal$userPressedEnterOnPasswordInput = F3(
	function (tenantName, environment, state) {
		if (state.$ === 1) {
			var form = state.a;
			var _v1 = _Utils_Tuple2(
				form.iK,
				$author$project$Auth$Password$fromString(form.a1));
			if (!_v1.b.$) {
				var username = _v1.a;
				var password = _v1.b.a;
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$ReLoginModal$Sending(form),
					$author$project$Auth$ReLoginModal$send(
						A3($author$project$Auth$ReLoginModal$Login, tenantName, username, password)));
			} else {
				return _Utils_Tuple3(
					environment,
					$author$project$Auth$ReLoginModal$Visible(form),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Auth$ReLoginModal$update = F3(
	function (msg, environment, state) {
		switch (msg.$) {
			case 0:
				var username = msg.a;
				return A3($author$project$Auth$ReLoginModal$userEnteredUsername, username, environment, state);
			case 1:
				var password = msg.a;
				return A3($author$project$Auth$ReLoginModal$userEnteredPassword, password, environment, state);
			case 2:
				var tenantName = msg.a;
				return A3($author$project$Auth$ReLoginModal$userPressedEnterOnPasswordInput, tenantName, environment, state);
			case 3:
				var tenantName = msg.a;
				return A3($author$project$Auth$ReLoginModal$userClickedLoginButton, tenantName, environment, state);
			case 4:
				var tenantId = msg.a;
				var userId = msg.b;
				return A4($author$project$Auth$ReLoginModal$loginSucceeded, tenantId, userId, environment, state);
			case 5:
				var externalMsg = msg.a;
				return A3($author$project$Auth$ReLoginModal$loginFailed, environment, state, externalMsg);
			case 6:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			case 7:
				var err = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Auth$ReLoginModal$receivedErrorMsg, err, environment),
					state,
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple3(environment, state, $elm$core$Platform$Cmd$none);
			default:
				var tenant = msg.a;
				return A3($author$project$Auth$ReLoginModal$gotTenant, tenant, environment, state);
		}
	});
var $author$project$Main$handleReLoginMsgInLoadingState = F2(
	function (loginMsg, model) {
		var _v0 = A3($author$project$Auth$ReLoginModal$update, loginMsg, model.ac, model.az);
		var newEnvironment = _v0.a;
		var newReLogin = _v0.b;
		var loginCmd = _v0.c;
		if (loginMsg.$ === 4) {
			var _v2 = $author$project$Environments$Repository$init;
			var repository = _v2.a;
			var repositoryCmd = _v2.b;
			var _v3 = $author$project$Page$Page$mainMenu(
				$author$project$Page$MainMenu$init(newEnvironment));
			var newEnvironment2 = _v3.a;
			var page = _v3.b;
			var pageCmd = _v3.c;
			return _Utils_Tuple2(
				$author$project$Main$Loaded(
					{
						ac: newEnvironment2,
						ba: $author$project$Page$Navbar$init(
							$author$project$Main$getNavbarType(newEnvironment)),
						ak: page,
						ae: repository,
						f: A4($author$project$Main$Utils, $author$project$UI$OrganisationUnitNavigation$hidden, newReLogin, $author$project$Tenant$EditModal$hidden, $author$project$Page$Modals$CompleteSyncModal$hidden)
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedRepositoryMsg, repositoryCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedReLoginMsg, loginCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedPageMsg, pageCmd)
						])));
		} else {
			return _Utils_Tuple2(
				$author$project$Main$Loading(
					_Utils_update(
						model,
						{ac: newEnvironment, az: newReLogin})),
				A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedReLoginMsg, loginCmd));
		}
	});
var $author$project$Main$utilsChangeReLogin = F2(
	function (modal, utils) {
		return _Utils_update(
			utils,
			{az: modal});
	});
var $author$project$Main$receivedReLoginMsg = F2(
	function (loginMsg, state) {
		switch (state.$) {
			case 0:
				var model = state.a;
				return A2($author$project$Main$handleReLoginMsgInLoadingState, loginMsg, model);
			case 1:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 2:
				var model = state.a;
				var _v1 = function () {
					if (loginMsg.$ === 4) {
						return $author$project$Environments$Repository$init;
					} else {
						return _Utils_Tuple2(model.ae, $elm$core$Platform$Cmd$none);
					}
				}();
				var updatedRepository = _v1.a;
				var repositoryCmd = _v1.b;
				var _v3 = A3($author$project$Auth$ReLoginModal$update, loginMsg, model.ac, model.f.az);
				var newEnvironment = _v3.a;
				var newReLogin = _v3.b;
				var loginCmd = _v3.c;
				return _Utils_Tuple2(
					$author$project$Main$Loaded(
						_Utils_update(
							model,
							{
								ac: newEnvironment,
								ae: updatedRepository,
								f: A2($author$project$Main$utilsChangeReLogin, newReLogin, model.f)
							})),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedRepositoryMsg, repositoryCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$ReceivedReLoginMsg, loginCmd)
							])));
			default:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateRepository = F3(
	function (repositoryMsg, repository, environment) {
		return A2(
			$author$project$Utils$Triple$mapThird,
			$elm$core$Platform$Cmd$map($author$project$Main$ReceivedRepositoryMsg),
			A3($author$project$Environments$Repository$update, repositoryMsg, environment, repository));
	});
var $author$project$Page$Modals$CompleteSyncModal$Visible = 1;
var $author$project$Page$Modals$CompleteSyncModal$visible = 1;
var $author$project$Main$receivedRepositoryMsg = F2(
	function (repositoryMsg, state) {
		switch (state.$) {
			case 0:
				var model = state.a;
				var _v1 = A2(
					$author$project$Main$updateEnvironment,
					$elm$core$Maybe$Nothing,
					A3($author$project$Main$updateRepository, repositoryMsg, model.ae, model.ac));
				var newEnvironment = _v1.a;
				var newRepository = _v1.b;
				var repositoryCmd = _v1.c;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (pageCmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[repositoryCmd, pageCmd]));
					},
					$author$project$Main$fromLoading(
						_Utils_update(
							model,
							{ac: newEnvironment, ae: newRepository})));
			case 1:
				var model = state.a;
				var _v2 = A2(
					$author$project$Main$updateEnvironment,
					$elm$core$Maybe$Nothing,
					A3($author$project$Main$updateRepository, repositoryMsg, model.ae, model.ac));
				var newEnvironment = _v2.a;
				var newRepository = _v2.b;
				var repositoryCmd = _v2.c;
				return _Utils_Tuple2(
					$author$project$Main$Login(
						_Utils_update(
							model,
							{ac: newEnvironment, ae: newRepository})),
					repositoryCmd);
			case 2:
				var model = state.a;
				var _v3 = A2(
					$author$project$Main$updateEnvironment,
					$elm$core$Maybe$Just(model.f.b_),
					A3($author$project$Main$updateRepository, repositoryMsg, model.ae, model.ac));
				var newEnvironment = _v3.a;
				var newRepository = _v3.b;
				var repositoryCmd = _v3.c;
				var newCompleteSyncModal = ((!model.f.b_) && ($author$project$Environments$Environment$getRequiredEnvironmentUpdate(newEnvironment) === 3)) ? $author$project$Page$Modals$CompleteSyncModal$visible : model.f.b_;
				var _v4 = A3($author$project$Main$utilsUpdateReLogin, newEnvironment, newRepository, model.f);
				var newUtils = _v4.a;
				var reLoginCmd = _v4.b;
				return _Utils_Tuple2(
					$author$project$Main$Loaded(
						_Utils_update(
							model,
							{
								ac: newEnvironment,
								ae: newRepository,
								f: _Utils_update(
									newUtils,
									{b_: newCompleteSyncModal})
							})),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[repositoryCmd, reLoginCmd])));
			default:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$handleRoomNavigationMsg = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var organisationUnit = msg.a;
				var newEnvironment = A2(
					$author$project$Environments$Environment$setCurrentOrganisationUnit,
					model.ac,
					$elm$core$Maybe$Just(organisationUnit.km));
				return _Utils_update(
					model,
					{
						ac: newEnvironment,
						f: A2($author$project$Main$utilsChangeRoomNavigation, $author$project$UI$OrganisationUnitNavigation$hidden, model.f)
					});
			case 4:
				var newEnvironment = A2($author$project$Environments$Environment$setCurrentOrganisationUnit, model.ac, $elm$core$Maybe$Nothing);
				return _Utils_update(
					model,
					{
						ac: newEnvironment,
						f: A2($author$project$Main$utilsChangeRoomNavigation, $author$project$UI$OrganisationUnitNavigation$hidden, model.f)
					});
			default:
				var newDialog = A2($author$project$UI$OrganisationUnitNavigation$update, msg, model.f.f1);
				return _Utils_update(
					model,
					{
						f: A2($author$project$Main$utilsChangeRoomNavigation, newDialog, model.f)
					});
		}
	});
var $author$project$Main$receivedRoomNavigationMsg = F2(
	function (msg, state) {
		if (state.$ === 2) {
			var model = state.a;
			return _Utils_Tuple2(
				$author$project$Main$Loaded(
					A2($author$project$Main$handleRoomNavigationMsg, msg, model)),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$EventStream$EventStream$closeWarningModal = function (state) {
	if (state.$ === 4) {
		var data = state.a;
		var oldConfig = data.m;
		var newConfig = _Utils_update(
			oldConfig,
			{h9: 0});
		return $author$project$EventStream$EventStream$Connected(
			_Utils_update(
				data,
				{m: newConfig}));
	} else {
		return state;
	}
};
var $author$project$Main$userClickedCloseSyncWarning = function (state) {
	if (state.$ === 2) {
		var loadedModel = state.a;
		return _Utils_Tuple2(
			$author$project$Main$Loaded(
				_Utils_update(
					loadedModel,
					{
						ae: A2(
							$author$project$Environments$Repository$setEventStream,
							loadedModel.ae,
							$author$project$EventStream$EventStream$closeWarningModal(
								$author$project$Environments$Repository$eventStream(loadedModel.ae)))
					})),
			$elm$core$Platform$Cmd$none);
	} else {
		return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Tenant$EditModal$NoEdit = 1;
var $author$project$Main$userClickedEditTenant = F2(
	function (tenant, state) {
		if (state.$ === 2) {
			var loadedModel = state.a;
			var utils = loadedModel.f;
			return _Utils_Tuple2(
				$author$project$Main$Loaded(
					_Utils_update(
						loadedModel,
						{
							f: _Utils_update(
								utils,
								{
									eZ: A2($author$project$Tenant$EditModal$show, 1, tenant)
								})
						})),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateHelper = function (msg) {
	switch (msg.$) {
		case 0:
			var environmentMsg = msg.a;
			return $author$project$Main$receivedEnvironmentMsg(environmentMsg);
		case 1:
			var repositoryMsg = msg.a;
			return $author$project$Main$receivedRepositoryMsg(repositoryMsg);
		case 2:
			var loginMsg = msg.a;
			return $author$project$Main$receivedLoginMsg(loginMsg);
		case 3:
			var loginMsg = msg.a;
			if (loginMsg.$ === 8) {
				return $author$project$Main$receivedLogoutMsg;
			} else {
				return $author$project$Main$receivedReLoginMsg(loginMsg);
			}
		case 4:
			var pageMsg = msg.a;
			return $author$project$Main$receivedPageMsg(pageMsg);
		case 5:
			var navbarMsg = msg.a;
			if ((navbarMsg.$ === 7) && (navbarMsg.a === 2)) {
				var _v3 = navbarMsg.a;
				return $author$project$Main$receivedLogoutMsg;
			} else {
				return $author$project$Main$receivedNavbarMsg(navbarMsg);
			}
		case 6:
			return $author$project$Main$receivedLogoutResponse;
		case 7:
			return $author$project$Main$openRoomNavigation;
		case 8:
			var dialogMsg = msg.a;
			return $author$project$Main$receivedRoomNavigationMsg(dialogMsg);
		case 9:
			var dialogMsg = msg.a;
			return $author$project$Main$receivedErrorModalMsg(dialogMsg);
		case 10:
			var tenant = msg.a;
			return $author$project$Main$userClickedEditTenant(tenant);
		case 11:
			var modalMsg = msg.a;
			return $author$project$Main$receivedEditTenantModelMsg(modalMsg);
		case 12:
			var modalMsg = msg.a;
			return $author$project$Main$gotCompleteSynchronisationModalMsg(modalMsg);
		default:
			return $author$project$Main$userClickedCloseSyncWarning;
	}
};
var $author$project$Main$update = function (msg) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Main$updateHelper(msg),
		$author$project$Main$maybeRoute);
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$Main$viewErrorBody = function (str) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$margin(
							$rtfeldman$elm_css$Css$rem(0.6))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('An error occurred. Please contact our support at  support@awenko.de or Tel. 04442 808280 ')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(1)),
									A2($rtfeldman$elm_css$Css$property, 'white-space', 'pre-wrap')
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(str)
						]))
				]))
		]);
};
var $author$project$Main$viewError = function (str) {
	return {
		dq: A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Html$Styled$toUnstyled,
			$author$project$Main$viewErrorBody(str)),
		k8: 'awenko:Smart'
	};
};
var $author$project$Main$UserClickedCloseSyncWarning = {$: 13};
var $rtfeldman$elm_css$Css$Global$selector = F2(
	function (selectorStr, styles) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			A2($rtfeldman$elm_css$Css$Structure$CustomSelector, selectorStr, _List_Nil));
	});
var $author$project$UI$Style$Fonts$titilliumBlack = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'normal'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '900'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web Black\'), local(\'TitilliumWeb-Black\'), url(\'assets/fonts/titillium-web-v8-latin-900.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-900.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$titilliumBold = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'normal'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '700'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web Bold\'), local(\'TitilliumWeb-Bold\'), url(\'assets/fonts/titillium-web-v8-latin-700.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-700.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$titilliumBoldItalic = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'italic'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '700'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web Bold Italic\'), local(\'TitilliumWeb-BoldItalic\'), url(\'assets/fonts/titillium-web-v8-latin-700italic.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-700italic.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$titilliumExtraLight = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'normal'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '200'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web ExtraLight\'), local(\'TitilliumWeb-ExtraLight\'), url(\'assets/fonts/titillium-web-v8-latin-200.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-200.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$titilliumExtraLightItalic = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'italic'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '200'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web ExtraLight Italic\'), local(\'TitilliumWeb-ExtraLightItalic\'), url(\'assets/fonts/titillium-web-v8-latin-200italic.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-200italic.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$titilliumItalic = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'italic'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '400'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web Italic\'), local(\'TitilliumWeb-Italic\'), url(\'assets/fonts/titillium-web-v8-latin-italic.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-italic.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$titilliumLight = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'normal'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '300'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web Light\'), local(\'TitilliumWeb-Light\'), url(\'assets/fonts/titillium-web-v8-latin-300.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-300.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$titilliumLightItalic = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'italic'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '300'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web Light Italic\'), local(\'TitilliumWeb-LightItalic\'), url(\'assets/fonts/titillium-web-v8-latin-300italic.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-300italic.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$titilliumRegular = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'normal'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '400'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web Regular\'), local(\'TitilliumWeb-Regular\'), url(\'assets/fonts/titillium-web-v8-latin-regular.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-regular.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$titilliumSemiBold = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'normal'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '600'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web SemiBold\'), local(\'TitilliumWeb-SemiBold\'), url(\'assets/fonts/titillium-web-v8-latin-600.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-600.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$titilliumSemiBoldItalic = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'@font-face',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font-family', 'Titillium Web'),
			A2($rtfeldman$elm_css$Css$property, 'font-style', 'italic'),
			A2($rtfeldman$elm_css$Css$property, 'font-weight', '600'),
			A2($rtfeldman$elm_css$Css$property, 'src', 'local(\'Titillium Web SemiBold Italic\'), local(\'TitilliumWeb-SemiBoldItalic\'), url(\'assets/fonts/titillium-web-v8-latin-600italic.woff2\') format(\'woff2\'), url(\'assets/fonts/titillium-web-v8-latin-600italic.woff\') format(\'woff\')')
		]));
var $author$project$UI$Style$Fonts$fonts = _List_fromArray(
	[$author$project$UI$Style$Fonts$titilliumExtraLight, $author$project$UI$Style$Fonts$titilliumLight, $author$project$UI$Style$Fonts$titilliumRegular, $author$project$UI$Style$Fonts$titilliumSemiBold, $author$project$UI$Style$Fonts$titilliumBold, $author$project$UI$Style$Fonts$titilliumBlack, $author$project$UI$Style$Fonts$titilliumExtraLightItalic, $author$project$UI$Style$Fonts$titilliumLightItalic, $author$project$UI$Style$Fonts$titilliumItalic, $author$project$UI$Style$Fonts$titilliumSemiBoldItalic, $author$project$UI$Style$Fonts$titilliumBoldItalic]);
var $author$project$EventStream$EventStream$getWarningConfig = function (state) {
	if (state.$ === 4) {
		var data = state.a;
		return $elm$core$Maybe$Just(data.m);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Global$global = function (snippets) {
	return $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode(
		A3(
			$elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			$elm$core$List$singleton(
				$elm$virtual_dom$VirtualDom$text(
					$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						$elm$core$List$singleton(
							$rtfeldman$elm_css$Css$Preprocess$stylesheet(snippets)))))));
};
var $rtfeldman$elm_css$Html$Styled$main_ = $rtfeldman$elm_css$Html$Styled$node('main');
var $rtfeldman$elm_css$Css$Global$a = $rtfeldman$elm_css$Css$Global$typeSelector('a');
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		eq: 1,
		iZ: 0,
		K: 0,
		jE: 0,
		kz: 0,
		ll: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				eq: alpha / 255,
				iZ: blue,
				K: 0,
				jE: green,
				kz: red,
				ll: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $author$project$UI$Style$Normalize$normalizeA = $rtfeldman$elm_css$Css$Global$a(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('0d6efd')),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]));
var $rtfeldman$elm_css$Css$dotted = {aR: 0, dh: 0, ll: 'dotted'};
var $rtfeldman$elm_css$Css$help = {c: 0, ll: 'help'};
var $rtfeldman$elm_css$Css$textDecorationStyle = $rtfeldman$elm_css$Css$prop1('text-decoration-style');
var $author$project$UI$Style$Normalize$normalizeAbbr = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'abbr[title]',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
			$rtfeldman$elm_css$Css$textDecorationStyle($rtfeldman$elm_css$Css$dotted),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$help),
			A2($rtfeldman$elm_css$Css$property, 'text-decoration-skip-ink', 'none')
		]));
var $rtfeldman$elm_css$Css$fontStyle = $rtfeldman$elm_css$Css$prop1('font-style');
var $rtfeldman$elm_css$Css$initial = {hu: 0, hv: 0, et: 0, hw: 0, $7: 0, hx: 0, dp: 0, bU: 0, aR: 0, fd: 0, K: 0, c: 0, W: 0, dK: 0, gJ: 0, eD: 0, ft: 0, cV: 0, aH: 0, dL: 0, p: 0, ce: 0, fz: 0, h1: 0, gS: 0, eK: 0, dP: 0, ch: 0, dQ: 0, dR: 0, c0: 0, c1: 0, bG: 0, fE: 0, e: 0, d: 0, g$: 0, cm: 0, cn: 0, fU: 0, d4: 0, bu: 0, f6: 0, ei: 0, dh: 0, ej: 0, ek: 0, di: 0, a4: 0, en: '', e3: 0, ll: 'initial', e5: 0, cz: 0};
var $rtfeldman$elm_css$Css$inherit = _Utils_update(
	$rtfeldman$elm_css$Css$initial,
	{ll: 'inherit'});
var $rtfeldman$elm_css$Css$normal = {gG: 0, dL: 0, ce: 0, g6: 0, ll: 'normal', cz: 0};
var $author$project$UI$Style$Normalize$normalizeAddress = A2(
	$rtfeldman$elm_css$Css$Global$typeSelector,
	'address',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(1)),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$inherit)
		]));
var $rtfeldman$elm_css$Css$Global$blockquote = $rtfeldman$elm_css$Css$Global$typeSelector('blockquote');
var $author$project$UI$Style$Normalize$normalizeBlockquote = $rtfeldman$elm_css$Css$Global$blockquote(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$rem(1))
		]));
var $rtfeldman$elm_css$Css$Global$body = $rtfeldman$elm_css$Css$Global$typeSelector('body');
var $rtfeldman$elm_css$Css$stringsToValue = function (list) {
	return $elm$core$List$isEmpty(list) ? {ll: 'none'} : {
		ll: A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function (s) {
					return s;
				},
				list))
	};
};
var $rtfeldman$elm_css$Css$fontFamilies = A2(
	$elm$core$Basics$composeL,
	$rtfeldman$elm_css$Css$prop1('font-family'),
	$rtfeldman$elm_css$Css$stringsToValue);
var $author$project$UI$Style$Normalize$normalizeBody = $rtfeldman$elm_css$Css$Global$body(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				['Titillium Web', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', 'Noto Sans', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'])),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$rem(1)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1.5)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('fff')),
			A2($rtfeldman$elm_css$Css$property, '-webkit-text-size-adjust', '100%'),
			A2($rtfeldman$elm_css$Css$property, '-webkit-tap-highlight-color', 'rgba(0, 0, 0, 0)')
		]));
var $rtfeldman$elm_css$Css$Global$button = $rtfeldman$elm_css$Css$Global$typeSelector('button');
var $rtfeldman$elm_css$Css$fontFamily = $rtfeldman$elm_css$Css$prop1('font-family');
var $rtfeldman$elm_css$Css$textTransform = $rtfeldman$elm_css$Css$prop1('text-transform');
var $rtfeldman$elm_css$Css$visible = {d4: 0, bu: 0, ll: 'visible', e5: 0};
var $author$project$UI$Style$Normalize$normalizeButton = $rtfeldman$elm_css$Css$Global$button(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontFamily($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$visible),
			$rtfeldman$elm_css$Css$borderRadius($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$none)
		]));
var $rtfeldman$elm_css$Css$Global$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v5 = declarations.a.a;
				var firstSelector = _v5.a;
				var otherSelectors = _v5.b;
				var styles = _v5.c;
				var rest = declarations.b;
				return _Utils_ap(
					A2(
						$elm$core$List$cons,
						A2($rtfeldman$elm_css$Css$Global$unwrapSelector, firstSelector, styles),
						otherSelectors),
					$rtfeldman$elm_css$Css$Global$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Global$unwrapSelector = F2(
	function (_v0, styles) {
		var sequence = _v0.a;
		var combinators = _v0.b;
		var mPseudo = _v0.c;
		var unwrapSequenceSelector = F2(
			function (style, s) {
				if (style.$ === 1) {
					var nestedSelector = style.a;
					var evenMoreNestedStyles = style.b;
					return A3(
						$elm$core$List$foldr,
						unwrapSequenceSelector,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, nestedSelector, s),
						evenMoreNestedStyles);
				} else {
					return s;
				}
			});
		var unwrapCombinatorSelector = F2(
			function (style, cs) {
				if (style.$ === 2) {
					var combinator = style.a;
					var snippets = style.b;
					return A2(
						$elm$core$List$append,
						cs,
						A2(
							$elm$core$List$map,
							function (_v3) {
								var s = _v3.a;
								return _Utils_Tuple2(combinator, s);
							},
							A2(
								$elm$core$List$concatMap,
								A2($elm$core$Basics$composeR, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, $rtfeldman$elm_css$Css$Global$collectSelectors),
								snippets)));
				} else {
					return cs;
				}
			});
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			A3($elm$core$List$foldr, unwrapSequenceSelector, sequence, styles),
			A3($elm$core$List$foldr, unwrapCombinatorSelector, combinators, styles),
			mPseudo);
	});
var $rtfeldman$elm_css$Css$Global$each = F2(
	function (snippetCreators, styles) {
		var selectorsToSnippet = function (selectors) {
			if (!selectors.b) {
				return _List_Nil;
			} else {
				var first = selectors.a;
				var rest = selectors.b;
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
						A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, first, rest, styles))
					]);
			}
		};
		return selectorsToSnippet(
			$rtfeldman$elm_css$Css$Global$collectSelectors(
				A2(
					$elm$core$List$concatMap,
					$rtfeldman$elm_css$Css$Preprocess$unwrapSnippet,
					A2(
						$elm$core$List$map,
						$elm$core$Basics$apR(_List_Nil),
						snippetCreators))));
	});
var $author$project$UI$Style$Normalize$normalizeButtonAppearance = A2(
	$rtfeldman$elm_css$Css$Global$each,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$button,
			$rtfeldman$elm_css$Css$Global$selector('[type=\"button\"]'),
			$rtfeldman$elm_css$Css$Global$selector('[type=\"reset\"]'),
			$rtfeldman$elm_css$Css$Global$selector('[type=\"submit\"]')
		]),
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'button'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]));
var $rtfeldman$elm_css$Css$Global$caption = $rtfeldman$elm_css$Css$Global$typeSelector('caption');
var $author$project$UI$Style$Normalize$normalizeCaption = $rtfeldman$elm_css$Css$Global$caption(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$rem(0.5)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$rem(0.5)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('6c757d')),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left),
			A2($rtfeldman$elm_css$Css$property, 'caption-side', 'bottom')
		]));
var $rtfeldman$elm_css$Css$Structure$Child = 2;
var $rtfeldman$elm_css$Css$Global$children = $rtfeldman$elm_css$Css$Preprocess$NestSnippet(2);
var $rtfeldman$elm_css$Css$Global$code = $rtfeldman$elm_css$Css$Global$typeSelector('code');
var $rtfeldman$elm_css$Css$Structure$Descendant = 3;
var $rtfeldman$elm_css$Css$Global$descendants = $rtfeldman$elm_css$Css$Preprocess$NestSnippet(3);
var $author$project$UI$Style$Normalize$normalizeCode = $rtfeldman$elm_css$Css$Global$code(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				['SFMono-Regular', 'Menlo', 'Monaco, Consolas', 'Liberation Mono', 'Courier New', 'monospace'])),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.875)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('d63384')),
			A2($rtfeldman$elm_css$Css$property, 'word-wrap', 'break-word'),
			$rtfeldman$elm_css$Css$Global$descendants(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Global$a(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Global$children(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$Global$code(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit)
										]))
								]))
						]))
				]))
		]));
var $author$project$UI$Style$Normalize$normalizeDatalists = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'[list]::-webkit-calendar-picker-indicator',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
		]));
var $author$project$UI$Style$Normalize$normalizeDateInput = A2(
	$rtfeldman$elm_css$Css$Global$each,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$selector('input[type=\"date\"]::-webkit-inner-spin-button'),
			$rtfeldman$elm_css$Css$Global$selector('input[type=\"date\"]::-webkit-clear-button'),
			$rtfeldman$elm_css$Css$Global$selector('input[type=\"date\"]::-webkit-calendar-picker-indicator')
		]),
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
		]));
var $rtfeldman$elm_css$Css$Global$dd = $rtfeldman$elm_css$Css$Global$typeSelector('dd');
var $author$project$UI$Style$Normalize$normalizeDd = $rtfeldman$elm_css$Css$Global$dd(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(0.5)),
			$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$zero)
		]));
var $rtfeldman$elm_css$Css$Global$dl = $rtfeldman$elm_css$Css$Global$typeSelector('dl');
var $author$project$UI$Style$Normalize$normalizeDl = $rtfeldman$elm_css$Css$Global$dl(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(1))
		]));
var $rtfeldman$elm_css$Css$Global$dt = $rtfeldman$elm_css$Css$Global$typeSelector('dt');
var $author$project$UI$Style$Normalize$normalizeDt = $rtfeldman$elm_css$Css$Global$dt(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(700))
		]));
var $rtfeldman$elm_css$Css$borderBox = {gn: 0, fd: 0, ll: 'border-box'};
var $rtfeldman$elm_css$Css$boxSizing = $rtfeldman$elm_css$Css$prop1('box-sizing');
var $rtfeldman$elm_css$Css$Global$everything = function (styles) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
		styles,
		$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil));
};
var $author$project$UI$Style$Normalize$normalizeEverything = A2(
	$rtfeldman$elm_css$Css$Global$each,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$everything,
			$rtfeldman$elm_css$Css$Global$selector('*::before'),
			$rtfeldman$elm_css$Css$Global$selector('*::after')
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]));
var $rtfeldman$elm_css$Css$border = $rtfeldman$elm_css$Css$prop1('border');
var $rtfeldman$elm_css$Css$Global$fieldset = $rtfeldman$elm_css$Css$Global$typeSelector('fieldset');
var $author$project$UI$Style$Normalize$normalizeFieldset = $rtfeldman$elm_css$Css$Global$fieldset(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$minWidth($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero)
		]));
var $author$project$UI$Style$Normalize$normalizeFigure = A2(
	$rtfeldman$elm_css$Css$Global$typeSelector,
	'figure',
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$rem(1))
		]));
var $author$project$UI$Style$Normalize$normalizeFileUpload = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'::-webkit-file-upload-button',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'font', 'inherit'),
			A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'button')
		]));
var $rtfeldman$elm_css$Css$borderStyle = $rtfeldman$elm_css$Css$prop1('border-style');
var $author$project$UI$Style$Normalize$normalizeFocusInner = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'::-moz-focus-inner',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$none)
		]));
var $author$project$UI$Style$Normalize$normalizeFocusedButton = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'button:focus',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'outline', '1px dotted'),
			A2($rtfeldman$elm_css$Css$property, 'outline', '5px auto -webkit-focus-ring-color')
		]));
var $rtfeldman$elm_css$Css$Global$h1 = $rtfeldman$elm_css$Css$Global$typeSelector('h1');
var $author$project$UI$Style$Normalize$normalizeH1 = $rtfeldman$elm_css$Css$Global$h1(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$rem(2))
		]));
var $rtfeldman$elm_css$Css$Global$h2 = $rtfeldman$elm_css$Css$Global$typeSelector('h2');
var $author$project$UI$Style$Normalize$normalizeH2 = $rtfeldman$elm_css$Css$Global$h2(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$rem(1.8))
		]));
var $rtfeldman$elm_css$Css$Global$h3 = $rtfeldman$elm_css$Css$Global$typeSelector('h3');
var $author$project$UI$Style$Normalize$normalizeH3 = $rtfeldman$elm_css$Css$Global$h3(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$rem(1.6))
		]));
var $rtfeldman$elm_css$Css$Global$h4 = $rtfeldman$elm_css$Css$Global$typeSelector('h4');
var $author$project$UI$Style$Normalize$normalizeH4 = $rtfeldman$elm_css$Css$Global$h4(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$rem(1.4))
		]));
var $rtfeldman$elm_css$Css$Global$h5 = $rtfeldman$elm_css$Css$Global$typeSelector('h5');
var $author$project$UI$Style$Normalize$normalizeH5 = $rtfeldman$elm_css$Css$Global$h5(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$rem(1.25))
		]));
var $rtfeldman$elm_css$Css$Global$h6 = $rtfeldman$elm_css$Css$Global$typeSelector('h6');
var $author$project$UI$Style$Normalize$normalizeH6 = $rtfeldman$elm_css$Css$Global$h6(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$rem(1))
		]));
var $author$project$UI$Style$Normalize$normalizeHeadings = A2(
	$rtfeldman$elm_css$Css$Global$each,
	_List_fromArray(
		[$rtfeldman$elm_css$Css$Global$h1, $rtfeldman$elm_css$Css$Global$h2, $rtfeldman$elm_css$Css$Global$h3, $rtfeldman$elm_css$Css$Global$h4, $rtfeldman$elm_css$Css$Global$h5, $rtfeldman$elm_css$Css$Global$h6]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(300)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1.2))
		]));
var $author$project$UI$Style$Normalize$normalizeHoveredA = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'a:hover',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]));
var $rtfeldman$elm_css$Css$Global$hr = $rtfeldman$elm_css$Css$Global$typeSelector('hr');
var $author$project$UI$Style$Normalize$normalizeHr = $rtfeldman$elm_css$Css$Global$hr(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$em(1),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.25))
		]));
var $rtfeldman$elm_css$Css$Global$img = $rtfeldman$elm_css$Css$Global$typeSelector('img');
var $author$project$UI$Style$Normalize$normalizeImg = $rtfeldman$elm_css$Css$Global$img(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
		]));
var $rtfeldman$elm_css$Css$Global$input = $rtfeldman$elm_css$Css$Global$typeSelector('input');
var $author$project$UI$Style$Normalize$normalizeInput = $rtfeldman$elm_css$Css$Global$input(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontFamily($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$visible)
		]));
var $author$project$UI$Style$Normalize$normalizeInputAppearance = A2(
	$rtfeldman$elm_css$Css$Global$each,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$selector('input[type=\"date\"]'),
			$rtfeldman$elm_css$Css$Global$selector('input[type=\"time\"]'),
			$rtfeldman$elm_css$Css$Global$selector('input[type=\"datetime-local\"]'),
			$rtfeldman$elm_css$Css$Global$selector('input[type=\"month\"]')
		]),
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '-moz-appearance', 'none'),
			A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none'),
			A2($rtfeldman$elm_css$Css$property, 'appearance', 'none')
		]));
var $author$project$UI$Style$Normalize$normalizeKbd = A2(
	$rtfeldman$elm_css$Css$Global$typeSelector,
	'kbd',
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$rem(0.2),
			$rtfeldman$elm_css$Css$rem(0.4)),
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				['SFMono-Regular', 'Menlo', 'Monaco, Consolas', 'Liberation Mono', 'Courier New', 'monospace'])),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.875)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('fff')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('212529')),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$rem(0.2)),
			$rtfeldman$elm_css$Css$Global$descendants(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Global$typeSelector,
					'kbd',
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$em(1)),
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(700))
						]))
				]))
		]));
var $rtfeldman$elm_css$Css$Global$label = $rtfeldman$elm_css$Css$Global$typeSelector('label');
var $author$project$UI$Style$Normalize$normalizeLabel = $rtfeldman$elm_css$Css$Global$label(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock)
		]));
var $rtfeldman$elm_css$Css$Global$legend = $rtfeldman$elm_css$Css$Global$typeSelector('legend');
var $author$project$UI$Style$Normalize$normalizeLegend = $rtfeldman$elm_css$Css$Global$legend(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$float($rtfeldman$elm_css$Css$left),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(0.5)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$rem(1.5)),
			$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$normal)
		]));
var $rtfeldman$elm_css$Css$listStyle = $rtfeldman$elm_css$Css$prop1('list-style');
var $rtfeldman$elm_css$Css$Global$ol = $rtfeldman$elm_css$Css$Global$typeSelector('ol');
var $rtfeldman$elm_css$Css$Global$ul = $rtfeldman$elm_css$Css$Global$typeSelector('ul');
var $author$project$UI$Style$Normalize$normalizeLists = A2(
	$rtfeldman$elm_css$Css$Global$each,
	_List_fromArray(
		[$rtfeldman$elm_css$Css$Global$ol, $rtfeldman$elm_css$Css$Global$ul]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$rem(2)),
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(1)),
			$rtfeldman$elm_css$Css$listStyle($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$Global$descendants(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$Global$each,
					_List_fromArray(
						[$rtfeldman$elm_css$Css$Global$ul, $rtfeldman$elm_css$Css$Global$ol]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
						]))
				]))
		]));
var $rtfeldman$elm_css$Css$Global$main_ = $rtfeldman$elm_css$Css$Global$typeSelector('main');
var $author$project$UI$Style$Normalize$normalizeMain = $rtfeldman$elm_css$Css$Global$main_(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block)
		]));
var $author$project$UI$Style$Normalize$normalizeMark = A2(
	$rtfeldman$elm_css$Css$Global$typeSelector,
	'mark',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$em(0.2)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('fcf8e3'))
		]));
var $rtfeldman$elm_css$Css$Global$optgroup = $rtfeldman$elm_css$Css$Global$typeSelector('optgroup');
var $author$project$UI$Style$Normalize$normalizeOptgroup = $rtfeldman$elm_css$Css$Global$optgroup(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontFamily($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$inherit)
		]));
var $author$project$UI$Style$Normalize$normalizeOutput = A2(
	$rtfeldman$elm_css$Css$Global$typeSelector,
	'output',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock)
		]));
var $rtfeldman$elm_css$Css$Global$p = $rtfeldman$elm_css$Css$Global$typeSelector('p');
var $author$project$UI$Style$Normalize$normalizeP = $rtfeldman$elm_css$Css$Global$p(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(1))
		]));
var $rtfeldman$elm_css$Css$Global$pre = $rtfeldman$elm_css$Css$Global$typeSelector('pre');
var $author$project$UI$Style$Normalize$normalizePre = $rtfeldman$elm_css$Css$Global$pre(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$marginTop($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(1)),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				['SFMono-Regular', 'Menlo', 'Monaco, Consolas', 'Liberation Mono', 'Courier New', 'monospace'])),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.875)),
			$rtfeldman$elm_css$Css$Global$descendants(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Global$code(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
							$rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit),
							A2($rtfeldman$elm_css$Css$property, 'word-break', 'normal')
						]))
				]))
		]));
var $rtfeldman$elm_css$Css$baseline = $rtfeldman$elm_css$Css$prop1('baseline');
var $rtfeldman$elm_css$Css$Global$progress = $rtfeldman$elm_css$Css$Global$typeSelector('progress');
var $author$project$UI$Style$Normalize$normalizeProgress = $rtfeldman$elm_css$Css$Global$progress(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$baseline)
		]));
var $author$project$UI$Style$Normalize$normalizeSamp = A2(
	$rtfeldman$elm_css$Css$Global$typeSelector,
	'samp',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				['SFMono-Regular', 'Menlo', 'Monaco, Consolas', 'Liberation Mono', 'Courier New', 'monospace'])),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1))
		]));
var $rtfeldman$elm_css$Css$outlineOffset = $rtfeldman$elm_css$Css$prop1('outline-offset');
var $author$project$UI$Style$Normalize$normalizeSearch = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'[type=\"search\"]',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$outlineOffset(
			$rtfeldman$elm_css$Css$px(-2)),
			A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'textfield')
		]));
var $author$project$UI$Style$Normalize$normalizeSearchDecoration = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'::-webkit-search-decoration',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '-webkit-appearance', 'none')
		]));
var $rtfeldman$elm_css$Css$Global$select = $rtfeldman$elm_css$Css$Global$typeSelector('select');
var $author$project$UI$Style$Normalize$normalizeSelect = $rtfeldman$elm_css$Css$Global$select(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontFamily($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$none),
			A2($rtfeldman$elm_css$Css$property, 'word-wrap', 'normal')
		]));
var $rtfeldman$elm_css$Css$Global$small = $rtfeldman$elm_css$Css$Global$typeSelector('small');
var $author$project$UI$Style$Normalize$normalizeSmall = $rtfeldman$elm_css$Css$Global$small(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.875))
		]));
var $rtfeldman$elm_css$Css$bolder = {ce: 0, ll: 'bolder'};
var $rtfeldman$elm_css$Css$Global$strong = $rtfeldman$elm_css$Css$Global$typeSelector('strong');
var $author$project$UI$Style$Normalize$normalizeStrong = A2(
	$rtfeldman$elm_css$Css$Global$each,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$strong,
			$rtfeldman$elm_css$Css$Global$typeSelector('b')
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bolder)
		]));
var $author$project$UI$Style$Normalize$normalizeSub = A2(
	$rtfeldman$elm_css$Css$Global$typeSelector,
	'sub',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$em(-0.25)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.75)),
			$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$baseline)
		]));
var $rtfeldman$elm_css$Css$listItem = {W: 0, ll: 'list-item'};
var $rtfeldman$elm_css$Css$Global$summary = $rtfeldman$elm_css$Css$Global$typeSelector('summary');
var $author$project$UI$Style$Normalize$normalizeSummary = $rtfeldman$elm_css$Css$Global$summary(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$listItem),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]));
var $author$project$UI$Style$Normalize$normalizeSup = A2(
	$rtfeldman$elm_css$Css$Global$typeSelector,
	'sup',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$em(-0.5)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.75)),
			$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$baseline)
		]));
var $rtfeldman$elm_css$Css$Global$svg = $rtfeldman$elm_css$Css$Global$typeSelector('svg');
var $author$project$UI$Style$Normalize$normalizeSvg = $rtfeldman$elm_css$Css$Global$svg(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
		]));
var $author$project$UI$Style$Normalize$normalizeTabindex = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'[tabindex=\"-1\"]:focus:not(:focus-visible)',
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'outline', '0 !important')
		]));
var $rtfeldman$elm_css$Css$borderCollapse = $rtfeldman$elm_css$Css$prop1('border-collapse');
var $rtfeldman$elm_css$Css$collapse = {hA: 0, ll: 'collapse', e5: 0};
var $rtfeldman$elm_css$Css$Global$table = $rtfeldman$elm_css$Css$Global$typeSelector('table');
var $author$project$UI$Style$Normalize$normalizeTable = $rtfeldman$elm_css$Css$Global$table(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderCollapse($rtfeldman$elm_css$Css$collapse)
		]));
var $rtfeldman$elm_css$Css$Global$textarea = $rtfeldman$elm_css$Css$Global$typeSelector('textarea');
var $author$project$UI$Style$Normalize$normalizeTextarea = $rtfeldman$elm_css$Css$Global$textarea(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontFamily($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$resize($rtfeldman$elm_css$Css$vertical)
		]));
var $rtfeldman$elm_css$Css$Global$th = $rtfeldman$elm_css$Css$Global$typeSelector('th');
var $author$project$UI$Style$Normalize$normalizeTh = $rtfeldman$elm_css$Css$Global$th(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'text-align', 'inherit')
		]));
var $author$project$UI$Style$Normalize$normalizeWebkitDatetimeEdit = A2(
	$rtfeldman$elm_css$Css$Global$selector,
	'::-webkit-datetime-edit',
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$visible),
			$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$zero)
		]));
var $author$project$UI$Style$Normalize$normalize = _List_fromArray(
	[$author$project$UI$Style$Normalize$normalizeEverything, $author$project$UI$Style$Normalize$normalizeBody, $author$project$UI$Style$Normalize$normalizeTabindex, $author$project$UI$Style$Normalize$normalizeHr, $author$project$UI$Style$Normalize$normalizeHeadings, $author$project$UI$Style$Normalize$normalizeH1, $author$project$UI$Style$Normalize$normalizeH2, $author$project$UI$Style$Normalize$normalizeH3, $author$project$UI$Style$Normalize$normalizeH4, $author$project$UI$Style$Normalize$normalizeH5, $author$project$UI$Style$Normalize$normalizeH6, $author$project$UI$Style$Normalize$normalizeP, $author$project$UI$Style$Normalize$normalizeAbbr, $author$project$UI$Style$Normalize$normalizeAddress, $author$project$UI$Style$Normalize$normalizeLists, $author$project$UI$Style$Normalize$normalizeDl, $author$project$UI$Style$Normalize$normalizeDt, $author$project$UI$Style$Normalize$normalizeDd, $author$project$UI$Style$Normalize$normalizeBlockquote, $author$project$UI$Style$Normalize$normalizeStrong, $author$project$UI$Style$Normalize$normalizeSmall, $author$project$UI$Style$Normalize$normalizeSub, $author$project$UI$Style$Normalize$normalizeSup, $author$project$UI$Style$Normalize$normalizeA, $author$project$UI$Style$Normalize$normalizeHoveredA, $author$project$UI$Style$Normalize$normalizePre, $author$project$UI$Style$Normalize$normalizeCode, $author$project$UI$Style$Normalize$normalizeKbd, $author$project$UI$Style$Normalize$normalizeSamp, $author$project$UI$Style$Normalize$normalizeFigure, $author$project$UI$Style$Normalize$normalizeImg, $author$project$UI$Style$Normalize$normalizeSvg, $author$project$UI$Style$Normalize$normalizeTable, $author$project$UI$Style$Normalize$normalizeCaption, $author$project$UI$Style$Normalize$normalizeTh, $author$project$UI$Style$Normalize$normalizeLabel, $author$project$UI$Style$Normalize$normalizeButton, $author$project$UI$Style$Normalize$normalizeFocusedButton, $author$project$UI$Style$Normalize$normalizeButtonAppearance, $author$project$UI$Style$Normalize$normalizeInput, $author$project$UI$Style$Normalize$normalizeSelect, $author$project$UI$Style$Normalize$normalizeOptgroup, $author$project$UI$Style$Normalize$normalizeTextarea, $author$project$UI$Style$Normalize$normalizeDatalists, $author$project$UI$Style$Normalize$normalizeFocusInner, $author$project$UI$Style$Normalize$normalizeInputAppearance, $author$project$UI$Style$Normalize$normalizeDateInput, $author$project$UI$Style$Normalize$normalizeFieldset, $author$project$UI$Style$Normalize$normalizeLegend, $author$project$UI$Style$Normalize$normalizeMark, $author$project$UI$Style$Normalize$normalizeProgress, $author$project$UI$Style$Normalize$normalizeWebkitDatetimeEdit, $author$project$UI$Style$Normalize$normalizeSearch, $author$project$UI$Style$Normalize$normalizeSearchDecoration, $author$project$UI$Style$Normalize$normalizeFileUpload, $author$project$UI$Style$Normalize$normalizeOutput, $author$project$UI$Style$Normalize$normalizeSummary, $author$project$UI$Style$Normalize$normalizeMain]);
var $rtfeldman$elm_css$Css$VhUnits = 0;
var $rtfeldman$elm_css$Css$vh = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vh');
var $author$project$Auth$ReLoginModal$UserClickedLogout = {$: 8};
var $author$project$Translations$Login$reLogin = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'login.reLogin');
};
var $rtfeldman$elm_css$Css$margin4 = $rtfeldman$elm_css$Css$prop4('margin');
var $rtfeldman$elm_css$Svg$Styled$Attributes$fillRule = $rtfeldman$elm_css$VirtualDom$Styled$attribute('fill-rule');
var $rtfeldman$elm_css$Svg$Styled$Attributes$points = $rtfeldman$elm_css$VirtualDom$Styled$attribute('points');
var $rtfeldman$elm_css$Svg$Styled$polygon = $rtfeldman$elm_css$Svg$Styled$node('polygon');
var $rtfeldman$elm_css$Svg$Styled$Attributes$preserveAspectRatio = $rtfeldman$elm_css$VirtualDom$Styled$attribute('preserveAspectRatio');
var $author$project$UI$Logo$viewAwenkoSmartLogo = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3)),
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$rem(1))
				])),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 1560 200'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$fillRule('evenodd'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$preserveAspectRatio('none')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#375B6A'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m224.05051,52.2755l25.603,83.46l4.055,0l30.17,-81.542l19.778,0l30.166,81.542l4.313,0l25.35,-83.46l19.014,0l-30.166,95.932l-31.69,0l-26.875,-75.018l-26.875,75.018l-31.69,0l-30.17,-95.932l19.017,0z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#375B6A'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m514.07051,148.2075l0,-95.932l18.76,0l0,6.716c0,0 20.539,-8.635 39.299,-8.635c34.985,0 42.842,13.044 42.842,47.199l0,50.651l-18.76,0l0,-50.267c0,-25.328 -3.802,-34.727 -27.381,-34.727c-18.253,0 -35.746,7.097 -35.746,7.097l0,77.897l-19.014,0l0,0.001z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#375B6A'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m857.81951,99.0895c0,34.919 -11.406,51.036 -54.253,51.036c-42.593,0 -54.252,-16.116 -54.252,-51.036c0,-33.001 14.198,-48.733 54.252,-48.733c40.313,0 54.253,15.732 54.253,48.733zm-19.52,0c0,-26.669 -7.604,-36.261 -34.732,-36.261c-26.875,0 -34.731,9.592 -34.731,36.261c0,27.247 4.815,38.564 34.731,38.564c30.169,0 34.732,-11.317 34.732,-38.564z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#7E1210'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m887.46951,64.5545l20.787,0l0,21.871l-20.787,0l0,-21.871zm0,61.782l20.787,0l0,21.871l-20.787,0l0,-21.871z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#375B6A'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m191.35051,130.3645l0,-49.117c0,-20.914 -12.17,-30.891 -40.819,-30.891c-21.801,0 -49.69,4.221 -49.69,4.221l0.76,10.934c0,0 30.17,-2.491 47.916,-2.491c15.211,0 22.815,4.793 22.815,18.227l0,2.618l0,5.633l0,10.934l0,10.79l0,20.87c0,0 -21.041,5.947 -39.801,5.947c-12.931,0 -19.267,-6.524 -19.267,-17.649c0,-10.554 6.083,-16.121 21.548,-17.271l27.552,-1.971l0,-10.929l-29.833,2.154c-26.115,1.918 -38.787,9.977 -38.787,28.396c0,19.385 12.672,29.356 35.746,29.356c22.815,0 45.635,-7.673 45.635,-7.673c7.604,5.755 16.732,7.673 30.169,7.673l0.761,-11.317c-8.116,-0.77 -14.198,-2.88 -14.705,-8.444z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#375B6A'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m492.36151,106.1905l1.014,-10.938c0,-31.467 -17.239,-44.896 -50.957,-44.896c-32.197,0 -52.985,14.005 -52.985,50.459c0,32.617 12.423,49.31 50.197,49.31c20.534,0 49.437,-3.067 49.437,-3.067l-0.507,-11.322c0,0 -27.635,1.726 -46.648,1.726c-21.911,0 -31.004,-8.354 -32.849,-24.405c-0.245,-2.15 -1.311,-16.776 -0.249,-24.397c2.609,-18.716 14.027,-26.215 33.604,-26.215c22.308,0 31.944,8.443 31.944,32.232l-56.25,0l0,11.515l74.249,0l0,-0.002z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$polygon,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#375B6A'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$points('700.9835205078125,96.40251922607422 742.3054809570312,52.27550506591797 720.7575073242188,52.27550506591797 684.5054931640625,91.03148651123047 655.7775268554688,91.03148651123047 655.7775268554688,52.27550506591797 636.7645263671875,52.27550506591797 636.7645263671875,148.20751190185547 655.7775268554688,148.20751190185547 655.7775268554688,103.69548797607422 684.7584838867188,103.69548797607422 722.531494140625,148.20751190185547 744.0805053710938,148.20751190185547 \t')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#7E1210'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m1027.05251,71.6075c0,0 -26.971,-3.09 -40.684,-3.09c-13.722,0 -19.888,2.701 -19.888,10.619c0,6.38 4.798,8.115 27.202,11.396c27.43,4.064 37.258,9.85 37.258,29.165c0,22.601 -16.911,30.711 -45.254,30.711c-15.775,0 -42.292,-4.252 -42.292,-4.252l0.917,-17.571c0,0 27.426,3.094 39.08,3.094c16.466,0 22.863,-2.896 22.863,-11.405c0,-6.756 -3.889,-8.875 -26.517,-11.974c-25.144,-3.47 -37.943,-8.106 -37.943,-28.579c0,-21.823 20.119,-29.938 42.742,-29.938c16.692,0 42.974,4.247 42.974,4.247l-0.458,17.577z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#7E1210'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m1369.85651,52.8955l96.399,0l0,16.815l-35.173,2.308l0,76.189l-25.604,0l0,-76.189l-35.623,-2.308l0,-16.815l0.001,0z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#7E1210'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m1298.76751,51.7115l24.686,0l0,11.593c0,0 19.438,-10.623 38.861,-13.712l0,21.05c-20.805,3.479 -38.63,10.234 -38.63,10.234l0,67.409l-24.917,0l0,-96.574z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#7E1210'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m1281.89151,125.4925l0,-44.031c0,-22.016 -12.21,-31.87 -41.995,-31.87c-22.448,0 -49.065,5.021 -49.065,5.021l0.983,14.871c0,0 29.536,-1.932 45.889,-1.932c11.965,0 17.824,3.282 17.824,13.91l0,6.948l0,14.875l0,10.654l0,15.032c0,0 -16.352,4.248 -30.27,4.248c-10.257,0 -14.889,-5.406 -14.889,-14.098c0,-8.688 5.615,-12.935 16.837,-13.713l17.585,-1.319l0,-14.954l-20.753,1.398c-26.123,1.739 -40.277,8.696 -40.277,29.165c0,20.084 12.201,30.711 36.366,30.711c19.77,0 39.303,-7.141 39.303,-7.141c9.033,5.594 17.576,7.141 32.469,7.141l0.734,-16.028c-7.075,-0.773 -10.252,-3.093 -10.741,-8.888z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#7E1210'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('m1038.14651,148.2075l0,-95.386l25.376,0l0,5.34c0,0 13.162,-7.63 22.51,-7.63c10.684,0 18.121,2.858 23.846,8.967c0,0 17.55,-8.967 32.049,-8.967c25.949,0 33.578,15.26 33.578,45.98l0,51.696l-25.563,0l0,-53.601c0,-14.5 -1.909,-23.847 -13.354,-23.847c-7.634,0 -17.741,3.623 -17.741,3.623s0.76,14.307 0.76,21.749l0,52.076l-25.56,0l0,-51.696c0,-17.165 -1.533,-25.752 -13.358,-25.752c-8.39,0 -16.978,3.431 -16.978,3.431l0,74.017l-25.565,0z')
				]),
			_List_Nil)
		]));
var $author$project$Translations$Login$failure = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'login.failure');
};
var $rtfeldman$elm_css$Html$Styled$h6 = $rtfeldman$elm_css$Html$Styled$node('h6');
var $author$project$Auth$ReLoginModal$viewFailure = F3(
	function (translations, isOffline, externalMsg) {
		var _v0 = function () {
			if (isOffline) {
				return _Utils_Tuple2('can\'t login while offline', $author$project$UI$Style$Theme$yellow);
			} else {
				switch (externalMsg) {
					case 'SERVER_ERROR':
						return _Utils_Tuple2('error while connecting to the server', $author$project$UI$Style$Theme$lightRed);
					case 'TIMEOUT':
						return _Utils_Tuple2('error: the response from the server took to long. Please try again.', $author$project$UI$Style$Theme$lightRed);
					default:
						return _Utils_Tuple2(
							$author$project$Translations$Login$failure(translations),
							$author$project$UI$Style$Theme$lightRed);
				}
			}
		}();
		var text_ = _v0.a;
		var color_ = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$h6,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor(color_))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(text_)
				]));
	});
var $author$project$Auth$ReLoginModal$UserClickedLoginButton = function (a) {
	return {$: 3, a: a};
};
var $author$project$Translations$Login$login = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'login.login');
};
var $author$project$Auth$ReLoginModal$viewLoginButton = F3(
	function (translations, disabled, tenantName) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withOnClick,
				$author$project$Auth$ReLoginModal$UserClickedLoginButton(tenantName),
				A2(
					$author$project$UI$Button$withStyle,
					$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
					A2(
						$author$project$UI$Button$withStyle,
						$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
						A2(
							$author$project$UI$Button$disabled,
							disabled,
							$author$project$UI$Button$green(
								$author$project$Translations$Login$login(translations)))))));
	});
var $author$project$Translations$Logout$logout = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'logout.logout');
};
var $author$project$Auth$ReLoginModal$viewLogoutButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Auth$ReLoginModal$UserClickedLogout,
			A2(
				$author$project$UI$Button$withStyle,
				$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$rem(1)),
				A2(
					$author$project$UI$Button$withStyle,
					$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
					$author$project$UI$Button$darkRed(
						$author$project$Translations$Logout$logout(translations))))));
};
var $author$project$Translations$Login$reLoginText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'login.reLoginText');
};
var $author$project$Auth$ReLoginModal$viewNotice = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h6,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$red))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Login$reLoginText(translations))
			]));
};
var $author$project$Auth$ReLoginModal$viewOffline = F2(
	function (_v0, isOffline) {
		return isOffline ? A2(
			$rtfeldman$elm_css$Html$Styled$h6,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$yellow))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('can\'t login while offline')
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Auth$ReLoginModal$UserEnteredPassword = function (a) {
	return {$: 1, a: a};
};
var $author$project$Auth$ReLoginModal$UserPressedEnterOnPasswordInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Translations$Login$password = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'login.password');
};
var $author$project$Auth$ReLoginModal$viewPassword = F4(
	function (translations, password, disabled, tenantName) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withOnEnter,
				$author$project$Auth$ReLoginModal$UserPressedEnterOnPasswordInput(tenantName),
				A2(
					$author$project$UI$TextInput$withOnInput,
					$author$project$Auth$ReLoginModal$UserEnteredPassword,
					A2(
						$author$project$UI$TextInput$withId,
						'login-password',
						A2(
							$author$project$UI$TextInput$disabled,
							disabled,
							A2(
								$author$project$UI$TextInput$withPlaceholder,
								$author$project$Translations$Login$password(translations),
								A2($author$project$UI$TextInput$withValue, password, $author$project$UI$TextInput$password)))))));
	});
var $author$project$Auth$ReLoginModal$viewSendingText = A2(
	$rtfeldman$elm_css$Html$Styled$h6,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontWeight(
					$rtfeldman$elm_css$Css$int(600)),
					$rtfeldman$elm_css$Css$color(
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
				]))
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('sending data to server')
		]));
var $author$project$Translations$Login$tenantName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'login.tenantName');
};
var $author$project$Auth$ReLoginModal$viewTenantName = F3(
	function (translations, tenantName, disabled) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withId,
				'login-tenantName',
				A2(
					$author$project$UI$TextInput$disabled,
					disabled,
					A2(
						$author$project$UI$TextInput$withPlaceholder,
						$author$project$Translations$Login$tenantName(translations),
						A2($author$project$UI$TextInput$withValue, tenantName, $author$project$UI$TextInput$singleLine)))));
	});
var $author$project$Auth$ReLoginModal$UserEnteredUsername = function (a) {
	return {$: 0, a: a};
};
var $author$project$Translations$Login$username = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'login.username');
};
var $author$project$Auth$ReLoginModal$viewUsername = F3(
	function (translations, username, disabled) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withOnInput,
				$author$project$Auth$ReLoginModal$UserEnteredUsername,
				A2(
					$author$project$UI$TextInput$withId,
					'login-username',
					A2(
						$author$project$UI$TextInput$disabled,
						disabled,
						A2(
							$author$project$UI$TextInput$withPlaceholder,
							$author$project$Translations$Login$username(translations),
							A2($author$project$UI$TextInput$withValue, username, $author$project$UI$TextInput$singleLine))))));
	});
var $author$project$Auth$ReLoginModal$viewContent = F4(
	function (translations, environment, repository, state) {
		var tenantName = A2(
			$elm$core$Maybe$withDefault,
			'Unknown Tenant',
			A2(
				$elm$core$Maybe$map,
				function (tenant) {
					return tenant.aP;
				},
				$author$project$Environments$Repository$getTenant(repository)));
		switch (state.$) {
			case 1:
				var form = state.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$rem(16)),
									$rtfeldman$elm_css$Css$maxWidth(
									$rtfeldman$elm_css$Css$rem(26)),
									A4(
									$rtfeldman$elm_css$Css$margin4,
									$rtfeldman$elm_css$Css$rem(1),
									$rtfeldman$elm_css$Css$rem(1),
									$rtfeldman$elm_css$Css$rem(4),
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							$author$project$UI$Logo$viewAwenkoSmartLogo,
							A3($author$project$Auth$ReLoginModal$viewTenantName, translations, tenantName, false),
							A3($author$project$Auth$ReLoginModal$viewUsername, translations, form.iK, false),
							A4($author$project$Auth$ReLoginModal$viewPassword, translations, form.a1, false, tenantName),
							A3(
							$author$project$Auth$ReLoginModal$viewLoginButton,
							translations,
							$elm$core$String$isEmpty(form.iK) || ($elm$core$String$isEmpty(form.a1) || $author$project$Environments$Environment$isOffline(environment)),
							tenantName),
							$author$project$Auth$ReLoginModal$viewLogoutButton(translations),
							$author$project$Auth$ReLoginModal$viewNotice(translations),
							A2(
							$author$project$Auth$ReLoginModal$viewOffline,
							translations,
							$author$project$Environments$Environment$isOffline(environment))
						]));
			case 2:
				var form = state.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$rem(16)),
									$rtfeldman$elm_css$Css$maxWidth(
									$rtfeldman$elm_css$Css$rem(26)),
									$rtfeldman$elm_css$Css$margin(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							$author$project$UI$Logo$viewAwenkoSmartLogo,
							A3($author$project$Auth$ReLoginModal$viewTenantName, translations, tenantName, true),
							A3($author$project$Auth$ReLoginModal$viewUsername, translations, form.iK, true),
							A4($author$project$Auth$ReLoginModal$viewPassword, translations, form.a1, true, tenantName),
							A3($author$project$Auth$ReLoginModal$viewLoginButton, translations, true, tenantName),
							$author$project$Auth$ReLoginModal$viewLogoutButton(translations),
							$author$project$Auth$ReLoginModal$viewNotice(translations),
							$author$project$Auth$ReLoginModal$viewSendingText
						]));
			case 3:
				var form = state.a;
				var externalMsg = state.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$rem(16)),
									$rtfeldman$elm_css$Css$maxWidth(
									$rtfeldman$elm_css$Css$rem(26)),
									$rtfeldman$elm_css$Css$margin(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							$author$project$UI$Logo$viewAwenkoSmartLogo,
							A3($author$project$Auth$ReLoginModal$viewTenantName, translations, tenantName, false),
							A3($author$project$Auth$ReLoginModal$viewUsername, translations, form.iK, false),
							A4($author$project$Auth$ReLoginModal$viewPassword, translations, form.a1, false, tenantName),
							A3($author$project$Auth$ReLoginModal$viewLoginButton, translations, true, tenantName),
							$author$project$Auth$ReLoginModal$viewLogoutButton(translations),
							$author$project$Auth$ReLoginModal$viewNotice(translations),
							A3(
							$author$project$Auth$ReLoginModal$viewFailure,
							translations,
							$author$project$Environments$Environment$isOffline(environment),
							externalMsg)
						]));
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Auth$ReLoginModal$view = F3(
	function (environment, repository, state) {
		if (!_Utils_eq(state, $author$project$Auth$ReLoginModal$hidden)) {
			var translations = $author$project$Environments$Environment$translations(environment);
			return $author$project$UI$Modal$view(
				A2(
					$author$project$UI$Modal$appendStyle,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$minHeight(
							$rtfeldman$elm_css$Css$rem(35))
						]),
					A2(
						$author$project$UI$Modal$appendContent,
						A4($author$project$Auth$ReLoginModal$viewContent, translations, environment, repository, state),
						A2(
							$author$project$UI$Modal$modal,
							$author$project$Translations$Login$reLogin(translations),
							$author$project$Auth$ReLoginModal$UserClickedLogout))));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$Modals$CompleteSyncModal$CloseModal = 0;
var $author$project$Translations$Synchronisation$completeSynchronisationHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.completeSynchronisationHeader');
};
var $author$project$Page$Modals$CompleteSyncModal$unifyCheck = function (data) {
	return data.bP && data.bN;
};
var $author$project$Page$Modals$CompleteSyncModal$closeButton = F3(
	function (translations, environment, repository) {
		var isReady = A2($author$project$Environments$Repository$eventStreamIsReady, environment, repository) && ($author$project$Environments$Repository$fileStoreIsReady(repository) && ($author$project$Page$Modals$CompleteSyncModal$unifyCheck(
			$author$project$Environments$Repository$userIsReady(repository)) && ($author$project$Page$Modals$CompleteSyncModal$unifyCheck(
			$author$project$Environments$Repository$checkpointDataIsReady(repository)) && ($author$project$Page$Modals$CompleteSyncModal$unifyCheck(
			$author$project$Environments$Repository$organisationUnitIsReady(repository)) && ($author$project$Page$Modals$CompleteSyncModal$unifyCheck(
			$author$project$Environments$Repository$planIsReady(repository)) && ($author$project$Page$Modals$CompleteSyncModal$unifyCheck(
			$author$project$Environments$Repository$auditIsReady(repository)) && ($author$project$Page$Modals$CompleteSyncModal$unifyCheck(
			$author$project$Environments$Repository$measureIsReady(repository)) && ($author$project$Page$Modals$CompleteSyncModal$unifyCheck(
			$author$project$Environments$Repository$tenantIsReady(repository)) && $author$project$Page$Modals$CompleteSyncModal$unifyCheck(
			$author$project$Environments$Repository$rightsAreReady(repository))))))))));
		return isReady ? $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withStyle,
				$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$rem(1)),
				A2(
					$author$project$UI$Button$withOnClick,
					0,
					$author$project$UI$Button$green(
						$author$project$Translations$Buttons$close(translations))))) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Translations$Synchronisation$completeSynchronisationText1 = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.completeSynchronisationText1');
};
var $author$project$Translations$Synchronisation$completeSynchronisationText2 = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.completeSynchronisationText2');
};
var $author$project$Page$Modals$CompleteSyncModal$viewLoadingMiscIcon = F2(
	function (icon, loaded) {
		var color = loaded ? $author$project$UI$Style$Theme$green : $author$project$UI$Style$Theme$grey;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$rem(4))
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withForegroundColor,
						color,
						$author$project$UI$Icon$unicolor(icon)))
				]));
	});
var $author$project$Page$Modals$CompleteSyncModal$viewLoadingRightsIcon = F2(
	function (icon, state) {
		var color = (state.bP && state.bN) ? $author$project$UI$Style$Theme$green : (state.bP ? $author$project$UI$Style$Theme$lightGreen : (state.bN ? $author$project$UI$Style$Theme$yellow : $author$project$UI$Style$Theme$grey));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$rem(4))
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withForegroundColor,
						color,
						$author$project$UI$Icon$unicolor(icon)))
				]));
	});
var $author$project$Page$Modals$CompleteSyncModal$viewContent = F2(
	function (environment, repository) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$margin(
							$rtfeldman$elm_css$Css$rem(0.6)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$Synchronisation$completeSynchronisationText1(translations)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Page$Modals$CompleteSyncModal$viewLoadingMiscIcon,
							$author$project$UI$Icons$upload,
							A2($author$project$Environments$Repository$eventStreamIsReady, environment, repository)),
							A2(
							$author$project$Page$Modals$CompleteSyncModal$viewLoadingMiscIcon,
							$author$project$UI$Icons$checkedDocument,
							$author$project$Environments$Repository$fileStoreIsReady(repository)),
							A2(
							$author$project$Page$Modals$CompleteSyncModal$viewLoadingRightsIcon,
							$author$project$UI$Icons$user,
							$author$project$Environments$Repository$userIsReady(repository)),
							A2(
							$author$project$Page$Modals$CompleteSyncModal$viewLoadingRightsIcon,
							$author$project$UI$Icons$pin,
							$author$project$Environments$Repository$checkpointDataIsReady(repository)),
							A2(
							$author$project$Page$Modals$CompleteSyncModal$viewLoadingRightsIcon,
							$author$project$UI$Icons$factory,
							$author$project$Environments$Repository$organisationUnitIsReady(repository)),
							A2(
							$author$project$Page$Modals$CompleteSyncModal$viewLoadingRightsIcon,
							$author$project$UI$Icons$plan,
							$author$project$Environments$Repository$planIsReady(repository)),
							A2(
							$author$project$Page$Modals$CompleteSyncModal$viewLoadingRightsIcon,
							$author$project$UI$Icons$audits,
							$author$project$Environments$Repository$auditIsReady(repository)),
							A2(
							$author$project$Page$Modals$CompleteSyncModal$viewLoadingRightsIcon,
							$author$project$UI$Icons$edit,
							$author$project$Environments$Repository$measureIsReady(repository)),
							A2(
							$author$project$Page$Modals$CompleteSyncModal$viewLoadingRightsIcon,
							$author$project$UI$Icons$home,
							$author$project$Environments$Repository$tenantIsReady(repository)),
							A2(
							$author$project$Page$Modals$CompleteSyncModal$viewLoadingRightsIcon,
							$author$project$UI$Icons$taskList,
							$author$project$Environments$Repository$rightsAreReady(repository))
						])),
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$Synchronisation$completeSynchronisationText2(translations)),
					A3($author$project$Page$Modals$CompleteSyncModal$closeButton, translations, environment, repository)
				]));
	});
var $author$project$Page$Modals$CompleteSyncModal$viewDialog = F2(
	function (environment, repository) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Modal$view(
			A2(
				$author$project$UI$Modal$appendContent,
				A2($author$project$Page$Modals$CompleteSyncModal$viewContent, environment, repository),
				A2(
					$author$project$UI$Modal$modal,
					$author$project$Translations$Synchronisation$completeSynchronisationHeader(translations),
					0)));
	});
var $author$project$Page$Modals$CompleteSyncModal$view = F3(
	function (environment, repository, state) {
		if (!state) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			return A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Page$Modals$CompleteSyncModal$viewDialog, environment, repository);
		}
	});
var $author$project$Main$viewCompleteSynchronisationModal = F3(
	function (environment, repository, completeSyncModal) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$Main$GotCompleteSynchronisationModalMsg,
			A3($author$project$Page$Modals$CompleteSyncModal$view, environment, repository, completeSyncModal));
	});
var $author$project$Environments$Environment$lastError = A2(
	$elm$core$Basics$composeR,
	$author$project$Environments$Environment$unwrap,
	function ($) {
		return $.eH;
	});
var $author$project$Main$viewErrorModal = function (model) {
	var _v0 = $author$project$Environments$Environment$lastError(model.ac);
	if (!_v0.$) {
		var error = _v0.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$Main$ReceivedErrorModalMsg,
			A2(
				$author$project$Environments$ErrorHandling$ErrorModal$view,
				$author$project$Environments$Environment$translations(model.ac),
				$author$project$Environments$ErrorHandling$ErrorModal$visible(error)));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Main$OpenRoomNavigation = {$: 7};
var $rtfeldman$elm_css$Css$flex = $rtfeldman$elm_css$Css$prop1('flex');
var $rtfeldman$elm_css$Html$Styled$header = $rtfeldman$elm_css$Html$Styled$node('header');
var $rtfeldman$elm_css$Css$linearGradient2 = F4(
	function (direction, firstStop, secondStop, otherStops) {
		return {
			$7: 0,
			d: 0,
			ll: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'linear-gradient',
				A2(
					$elm$core$List$cons,
					direction.ll,
					$rtfeldman$elm_css$Css$collectStops(
						_Utils_ap(
							_List_fromArray(
								[firstStop, secondStop]),
							otherStops))))
		};
	});
var $rtfeldman$elm_css$Css$toRight = {bB: 0, ll: 'to right'};
var $author$project$Translations$OrganisationUnits$noSelected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'organisationUnits.noSelected');
};
var $author$project$Main$viewOuText = function (text_) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
						$rtfeldman$elm_css$Css$marginLeft(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$rem(1.2)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(300))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(text_)
			]));
};
var $author$project$Main$viewSelectedOuHeader = function (model) {
	var currentOrganisationUnit = A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		A2(
			$elm$core$Maybe$map,
			function (organisationUnitId) {
				return A2($author$project$Environments$Repository$getOrganisationUnit, organisationUnitId, model.ae);
			},
			$author$project$Environments$Environment$getCurrentOrganisationUnit(model.ac)));
	var text_ = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Translations$OrganisationUnits$noSelected(
			$author$project$Environments$Environment$translations(model.ac)),
		A2(
			$elm$core$Maybe$map,
			function (organisationUnit) {
				return organisationUnit.k8;
			},
			currentOrganisationUnit));
	return $author$project$Main$viewOuText(text_);
};
var $author$project$Main$viewLoadedHeaderThin = function (model) {
	var marginTop_ = function () {
		var _v0 = $author$project$Environments$Environment$platform(model.ac);
		if (_v0.$ === 2) {
			return 8;
		} else {
			return 5;
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$header,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, 'grid-area', 'header'),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$minWidth($rtfeldman$elm_css$Css$zero)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$flex(
								$rtfeldman$elm_css$Css$int(1)),
								$rtfeldman$elm_css$Css$paddingLeft(
								$rtfeldman$elm_css$Css$rem(2)),
								$rtfeldman$elm_css$Css$lineHeight(
								$rtfeldman$elm_css$Css$num(1.5)),
								$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
								$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
								$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
								$rtfeldman$elm_css$Css$backgroundImage(
								A4(
									$rtfeldman$elm_css$Css$linearGradient2,
									$rtfeldman$elm_css$Css$toRight,
									$rtfeldman$elm_css$Css$stop(
										$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
									$rtfeldman$elm_css$Css$stop(
										$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
									_List_Nil)),
								$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
								$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(marginTop_))
							])),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Main$OpenRoomNavigation)
					]),
				_List_fromArray(
					[
						$author$project$Main$viewSelectedOuHeader(model)
					]))
			]));
};
var $author$project$Main$UserClickedEditTenant = function (a) {
	return {$: 10, a: a};
};
var $author$project$UI$Style$Helper$stopOnPropagation = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Tenant$Tenant$tenantName = function ($) {
	return $.aP;
};
var $author$project$Main$viewAwenkoLogo = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(1))
				])),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 600 77'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$fillRule('evenodd'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$preserveAspectRatio('none')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#385b6b'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M77.217 60.074v-36.88C77.217 7.491 68.079 0 46.568 0c-16.37 0-37.31 3.17-37.31 3.17l.572 8.209s22.652-1.871 35.976-1.871c11.422 0 17.131 3.6 17.131 13.686v38.175s-15.798 4.466-29.884 4.466c-9.708 0-14.466-4.899-14.466-13.252 0-7.924 4.567-12.104 16.179-12.967l20.687-1.48V29.93l-22.4 1.617C13.445 32.988 3.93 39.038 3.93 52.868c0 14.552 9.515 22.043 26.84 22.043 17.13 0 34.264-5.762 34.264-5.762 5.709 4.321 12.563 5.762 22.652 5.762l.572-8.498c-6.094-.578-10.661-2.162-11.041-6.339zm212.496-26.798c0-17.862-7.234-24.2-23.985-24.2-14.699.001-23.273 5.63-25.231 19.682-.797 5.723.003 16.705.187 18.319 1.384 12.052 8.212 18.325 24.664 18.325 14.276 0 35.026-1.295 35.026-1.295l.381 8.501s-21.702 2.303-37.12 2.303c-28.362 0-37.69-12.533-37.69-37.024 0-27.371 15.609-37.886 39.783-37.886 25.317 0 38.261 10.083 38.261 33.71l-.761 8.211h-55.749v-8.645h42.234v-.001zM536.895 0c-30.074 0-40.736 11.812-40.736 36.59 0 26.22 8.754 38.32 40.736 38.32 32.171 0 40.734-12.1 40.734-38.32 0-24.778-10.467-36.59-40.734-36.59zM425.927 30.54h21.571l27.221-29.1h16.178l-31.026 33.133 32.358 38.897H476.05l-28.362-33.421h-21.761V73.47h-14.275V1.44h14.275v29.1zm-92.312-29.1v5.044S349.035 0 363.121 0c26.269 0 32.168 9.793 32.168 35.439V73.47h-14.086V35.727c0-19.017-2.854-26.074-20.559-26.074-13.705 0-26.839 5.328-26.839 5.328V73.47h-14.277V1.44h14.087zM120.993 64.105h3.045L146.691 2.88h14.85l22.65 61.225h3.238l19.033-62.666h14.276l-22.649 72.03h-23.795l-20.178-56.326-20.179 56.326h-23.794L87.49 1.439h14.279l19.224 62.666zm415.902 1.441c-22.463 0-26.079-8.498-26.079-28.956 0-20.024 5.899-27.226 26.079-27.226 20.369 0 26.078 7.202 26.078 27.226 0 20.458-3.425 28.956-26.078 28.956z')
				]),
			_List_Nil)
		]));
var $author$project$Main$viewLoadedHeaderWide = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(
			$author$project$Translations$Login$tenantName(
				$author$project$Environments$Environment$translations(model.ac)),
			_List_Nil),
		A2(
			$elm$core$Maybe$map,
			function (tenant) {
				return _Utils_Tuple2(
					$author$project$Tenant$Tenant$tenantName(tenant),
					_List_fromArray(
						[
							$author$project$UI$Style$Helper$stopOnPropagation(
							$author$project$Main$UserClickedEditTenant(tenant))
						]));
			},
			$author$project$Environments$Repository$getTenant(model.ae)));
	var tenantName = _v0.a;
	var attributeMsg = _v0.b;
	return A2(
		$rtfeldman$elm_css$Html$Styled$header,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, 'grid-area', 'header'),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$minWidth($rtfeldman$elm_css$Css$zero)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$flex(
								$rtfeldman$elm_css$Css$int(1)),
								$rtfeldman$elm_css$Css$paddingLeft(
								$rtfeldman$elm_css$Css$rem(2)),
								$rtfeldman$elm_css$Css$lineHeight(
								$rtfeldman$elm_css$Css$num(1.5)),
								$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
								$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
								$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
								$rtfeldman$elm_css$Css$backgroundImage(
								A4(
									$rtfeldman$elm_css$Css$linearGradient2,
									$rtfeldman$elm_css$Css$toRight,
									$rtfeldman$elm_css$Css$stop(
										$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey)),
									$rtfeldman$elm_css$Css$stop(
										$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
									_List_Nil)),
								$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
							])),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Main$OpenRoomNavigation)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$fontWeight(
										$rtfeldman$elm_css$Css$int(600)),
										$rtfeldman$elm_css$Css$color(
										$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkRed))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(': ')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_Utils_ap(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$color(
											$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
										]))
								]),
							attributeMsg),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(tenantName)
							])),
						$author$project$Main$viewSelectedOuHeader(model)
					])),
				$author$project$Main$viewAwenkoLogo
			]));
};
var $author$project$Page$Page$view = F3(
	function (environment, repository, _v0) {
		var page = _v0;
		return A2(page.lm, environment, repository);
	});
var $author$project$Main$viewLoadedPage = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$map,
		$author$project$Main$ReceivedPageMsg,
		A3($author$project$Page$Page$view, model.ac, model.ae, model.ak));
};
var $author$project$Page$Navbar$getBarPosition = function (state) {
	switch (state.$) {
		case 0:
			var model = state.b;
			return model.aD;
		case 1:
			var model = state.b;
			return model.aD;
		case 2:
			var model = state.b;
			return model.aD;
		default:
			var model = state.b;
			return model.aD;
	}
};
var $author$project$Page$Navbar$maxDeviceHeight = 620;
var $author$project$Page$Navbar$numberOfNumberOfPossibleSidebarEntries = F3(
	function (environment, barPosition, entries) {
		if (!barPosition) {
			var height = $author$project$Environments$Environment$viewport(environment).Y;
			var divider = (_Utils_cmp(
				$elm$core$Basics$round(height),
				$author$project$Page$Navbar$maxDeviceHeight) < 0) ? 50 : 66;
			var result = $elm$core$Basics$floor((height - 96) / divider);
			return (_Utils_cmp(
				result + 1,
				$elm$core$List$length(entries)) > -1) ? 1000 : result;
		} else {
			return 1000;
		}
	});
var $author$project$Page$Navbar$ReceivedAboutModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Modals$AboutModal$UserClickedCloseDialog = 0;
var $author$project$Translations$Sidebar$about = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.about');
};
var $author$project$Page$Modals$AboutModal$viewAddress = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$rem(1)),
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$color(
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Awenko GmbH & Co. KG')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Brägeler Straße 98, 49393 Lohne, Deutschland')
				]))
		]));
var $author$project$Page$Modals$AboutModal$viewBaseUri = function (text_) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Server')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(text_)
					]))
			]));
};
var $author$project$Page$Modals$AboutModal$viewPlatform = function (text_) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(text_)
					]))
			]));
};
var $author$project$Translations$AboutModal$clickHere = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'aboutModal.clickHere');
};
var $author$project$Translations$AboutModal$supportHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'aboutModal.supportHeader');
};
var $author$project$Page$Modals$AboutModal$viewSupport = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$AboutModal$supportHeader(translations))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href('https://hosting.awenko.de/trustservice/AWENKO24ftsm'),
						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$AboutModal$clickHere(translations))
					]))
			]));
};
var $author$project$Page$Modals$AboutModal$viewSupportMail = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$rem(1)),
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$color(
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('E-Mail:')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('support@awenko.de')
				]))
		]));
var $author$project$Page$Modals$AboutModal$viewTel = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$rem(1)),
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$color(
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Tel:')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('+49(0) 4442 8082840')
				]))
		]));
var $author$project$Page$Modals$AboutModal$viewURL = F2(
	function (environment, repository) {
		var tenantText = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (tenant) {
					return A3($elm$core$String$replace, ' ', '%20', tenant.aP);
				},
				$author$project$Environments$Repository$getTenant(repository)));
		if ($elm$core$String$isEmpty(tenantText)) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var tenantURL = $author$project$Environments$Environment$baseUri(environment) + ('/web' + ('?tenant=' + tenantText));
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1)),
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$color(
								$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('URL:')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href(tenantURL),
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(tenantURL)
							]))
					]));
		}
	});
var $author$project$Page$Modals$AboutModal$viewVersion = function (text_) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(text_)
					]))
			]));
};
var $author$project$Page$Modals$AboutModal$viewWebSite = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$rem(1)),
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$color(
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Internet:')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.awenko.de/'),
					$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('https://www.awenko.de/')
				]))
		]));
var $author$project$Page$Modals$AboutModal$viewContent = F4(
	function (_v0, environment, repository, platform) {
		var _v1 = function () {
			switch (platform.$) {
				case 0:
					var version = platform.a;
					return _Utils_Tuple2('Web', 'Version: ' + version);
				case 1:
					var version = platform.a;
					return _Utils_Tuple2('Android', 'Version: ' + version);
				default:
					var version = platform.a;
					return _Utils_Tuple2('iOS', 'Version: ' + version);
			}
		}();
		var platformText = _v1.a;
		var versionText = _v1.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$h4,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$margin(
							$rtfeldman$elm_css$Css$rem(0.6))
						]))
				]),
			_List_fromArray(
				[
					$author$project$Page$Modals$AboutModal$viewSupport(
					$author$project$Environments$Environment$translations(environment)),
					$author$project$Page$Modals$AboutModal$viewAddress,
					A2($author$project$Page$Modals$AboutModal$viewURL, environment, repository),
					$author$project$Page$Modals$AboutModal$viewWebSite,
					$author$project$Page$Modals$AboutModal$viewSupportMail,
					$author$project$Page$Modals$AboutModal$viewTel,
					$author$project$Page$Modals$AboutModal$viewPlatform(platformText),
					$author$project$Page$Modals$AboutModal$viewVersion(versionText),
					$author$project$Page$Modals$AboutModal$viewBaseUri(
					$author$project$Environments$Environment$baseUri(environment))
				]));
	});
var $author$project$Page$Modals$AboutModal$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			0,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$Page$Modals$AboutModal$viewFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Page$Modals$AboutModal$viewCloseButton(translations)
			]));
};
var $author$project$Page$Modals$AboutModal$viewDialog = F3(
	function (environment, repository, platform) {
		var translations = $author$project$Environments$Environment$translations(environment);
		return $author$project$UI$Modal$view(
			A2(
				$author$project$UI$Modal$appendStyle,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, 'user-select', 'text')
					]),
				A2(
					$author$project$UI$Modal$appendFooter,
					$author$project$Page$Modals$AboutModal$viewFooter(translations),
					A2(
						$author$project$UI$Modal$appendContent,
						A4($author$project$Page$Modals$AboutModal$viewContent, translations, environment, repository, platform),
						A2(
							$author$project$UI$Modal$modal,
							$author$project$Translations$Sidebar$about(translations),
							0)))));
	});
var $author$project$Page$Modals$AboutModal$view = F4(
	function (environment, repository, platform, dialog) {
		if (!dialog) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$Modals$AboutModal$viewDialog, environment, repository, platform);
		}
	});
var $author$project$Page$Navbar$viewAboutModal = F3(
	function (environment, repository, state) {
		switch (state.$) {
			case 0:
				var model = state.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$Navbar$ReceivedAboutModalMsg,
					A4(
						$author$project$Page$Modals$AboutModal$view,
						environment,
						repository,
						$author$project$Environments$Environment$platform(environment),
						model.bR));
			case 1:
				var model = state.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$Navbar$ReceivedAboutModalMsg,
					A4(
						$author$project$Page$Modals$AboutModal$view,
						environment,
						repository,
						$author$project$Environments$Environment$platform(environment),
						model.bR));
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$Navbar$ReceivedAboutModalMsg,
					A4(
						$author$project$Page$Modals$AboutModal$view,
						environment,
						repository,
						$author$project$Environments$Environment$platform(environment),
						$author$project$Page$Modals$AboutModal$hidden));
		}
	});
var $author$project$Page$Navbar$UserClickedCollapseIcon = {$: 4};
var $author$project$Page$Navbar$UserMovedPointer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Navbar$UserPointedDown = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Navbar$UserPointedUp = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Navbar$decodeIf = function (decoder) {
	return $elm$json$Json$Decode$andThen(
		function (condition) {
			return condition ? decoder : $elm$json$Json$Decode$fail('');
		});
};
var $author$project$Page$Navbar$Pointer = F3(
	function (x, y, time) {
		return {e$: time, am: x, bf: y};
	});
var $author$project$Page$Navbar$pointerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'timeStamp',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'clientY',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'clientX',
			$elm$json$Json$Decode$float,
			$elm$json$Json$Decode$succeed($author$project$Page$Navbar$Pointer))));
var $author$project$Page$Navbar$onPointerDown = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'pointerdown',
		A2(
			$elm$json$Json$Decode$map,
			msg,
			A2(
				$author$project$Page$Navbar$decodeIf,
				$author$project$Page$Navbar$pointerDecoder,
				A2($elm$json$Json$Decode$field, 'isPrimary', $elm$json$Json$Decode$bool))));
};
var $author$project$Page$Navbar$onPointerMove = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'pointermove',
		A2(
			$elm$json$Json$Decode$map,
			msg,
			A2(
				$author$project$Page$Navbar$decodeIf,
				$author$project$Page$Navbar$pointerDecoder,
				A2($elm$json$Json$Decode$field, 'isPrimary', $elm$json$Json$Decode$bool))));
};
var $author$project$Page$Navbar$onPointerUp = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'pointerup',
		A2(
			$elm$json$Json$Decode$map,
			msg,
			A2(
				$author$project$Page$Navbar$decodeIf,
				$author$project$Page$Navbar$pointerDecoder,
				A2($elm$json$Json$Decode$field, 'isPrimary', $elm$json$Json$Decode$bool))));
};
var $author$project$Page$Navbar$roundToSecondDigit = function (num) {
	return $elm$core$Basics$round(num * 100) / 100;
};
var $author$project$Page$Navbar$viewBackdrop = function (state) {
	var baseStyle = $rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$backgroundColor(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$black)),
				A2($rtfeldman$elm_css$Css$property, 'will-change', 'display, opacity')
			]));
	var backdropAttributes = function () {
		switch (state.$) {
			case 0:
				if (!state.a.$) {
					var _v1 = state.a;
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									baseStyle,
									$rtfeldman$elm_css$Css$opacity(
									$rtfeldman$elm_css$Css$num(0)),
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
								]))
						]);
				} else {
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									baseStyle,
									$rtfeldman$elm_css$Css$opacity(
									$rtfeldman$elm_css$Css$num(0))
								])),
							$author$project$Page$Navbar$onPointerMove($author$project$Page$Navbar$UserMovedPointer),
							$author$project$Page$Navbar$onPointerUp($author$project$Page$Navbar$UserPointedUp)
						]);
				}
			case 1:
				if (!state.a.$) {
					var _v2 = state.a;
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									baseStyle,
									$rtfeldman$elm_css$Css$opacity(
									$rtfeldman$elm_css$Css$num(0.5))
								])),
							$author$project$Page$Navbar$onPointerDown($author$project$Page$Navbar$UserPointedDown),
							$rtfeldman$elm_css$Svg$Styled$Events$onClick($author$project$Page$Navbar$UserClickedCollapseIcon)
						]);
				} else {
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									baseStyle,
									$rtfeldman$elm_css$Css$opacity(
									$rtfeldman$elm_css$Css$num(0.5))
								])),
							$author$project$Page$Navbar$onPointerMove($author$project$Page$Navbar$UserMovedPointer),
							$author$project$Page$Navbar$onPointerUp($author$project$Page$Navbar$UserPointedUp),
							$rtfeldman$elm_css$Svg$Styled$Events$onClick($author$project$Page$Navbar$UserClickedCollapseIcon)
						]);
				}
			case 2:
				var start = state.a.bx;
				var current = state.a.bD;
				var offsetX = state.a.co;
				var calculatedOpacity = $author$project$Page$Navbar$roundToSecondDigit(
					A3($elm$core$Basics$clamp, 0, 0.5, ((start.am + offsetX) - current.am) / 600));
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								baseStyle,
								$rtfeldman$elm_css$Css$opacity(
								$rtfeldman$elm_css$Css$num(calculatedOpacity))
							])),
						$author$project$Page$Navbar$onPointerMove($author$project$Page$Navbar$UserMovedPointer),
						$author$project$Page$Navbar$onPointerUp($author$project$Page$Navbar$UserPointedUp)
					]);
			default:
				var spring = state.a;
				var calculatedOpacity = $author$project$Page$Navbar$roundToSecondDigit(
					A3(
						$elm$core$Basics$clamp,
						0,
						0.5,
						(300 - $tad_lispy$springs$Spring$value(spring)) / 600));
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								baseStyle,
								$rtfeldman$elm_css$Css$opacity(
								$rtfeldman$elm_css$Css$num(calculatedOpacity))
							])),
						$author$project$Page$Navbar$onPointerDown($author$project$Page$Navbar$UserPointedDown)
					]);
		}
	}();
	return A2($rtfeldman$elm_css$Html$Styled$div, backdropAttributes, _List_Nil);
};
var $author$project$Page$Navbar$ReceivedSettingsConfirmModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Navbar$viewConfirmOpenSettingsModal = F2(
	function (environment, state) {
		switch (state.$) {
			case 0:
				var model = state.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$Navbar$ReceivedSettingsConfirmModalMsg,
					A2($author$project$Page$Modals$ConfirmOpenSettings$view, environment, model.dv));
			case 1:
				var model = state.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$Navbar$ReceivedSettingsConfirmModalMsg,
					A2($author$project$Page$Modals$ConfirmOpenSettings$view, environment, model.dv));
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$Navbar$ReceivedSettingsConfirmModalMsg,
					A2($author$project$Page$Modals$ConfirmOpenSettings$view, environment, $author$project$Page$Modals$ConfirmOpenSettings$hidden));
		}
	});
var $author$project$Page$Navbar$UserClickedAbout = {$: 8};
var $author$project$Page$Navbar$UserClickedLogout = {$: 6};
var $author$project$Auth$Authorization$checkOpenSettings = function (userRights) {
	if (userRights.$ === 2) {
		var data = userRights.a;
		return !$author$project$Auth$RightSet$isEmpty(data.hf);
	} else {
		return false;
	}
};
var $author$project$Environments$Flags$Platform$isWeb = function (platform) {
	if (!platform.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$UI$Icons$logout = F2(
	function (color, attributes) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			A2(
				$author$project$UI$Icons$setFillColor,
				color,
				A2($author$project$UI$Icons$setViewBox, '0 0 500 500', attributes)),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M204.429,182.327H49.519l59.848-59.847c5.527-5.527,5.527-14.528,0-20.134c-5.527-5.526-14.527-5.526-20.133,0L5.146,186.512c-5.527,5.527-5.527,14.528,0,20.134l84.087,84.086c2.763,2.763,6.395,4.185,10.026,4.185c3.632,0,7.264-1.422,10.028-4.185c5.527-5.527,5.527-14.527,0-20.133l-59.769-59.849h154.91c7.816,0,14.211-6.396,14.211-14.212S212.245,182.327,204.429,182.327z')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M293.49,182.327h-32.53c-7.816,0-14.211,6.396-14.211,14.212s6.395,14.213,14.211,14.213h32.53c7.896,0,14.211-6.396,14.211-14.213S301.307,182.327,293.49,182.327z')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M373.629,29.787h-94.035c-7.816,0-14.212,6.396-14.212,14.212c0,7.816,6.396,14.211,14.212,14.211h79.822v276.579h-79.822c-7.816,0-14.212,6.396-14.212,14.212c0,7.817,6.396,14.212,14.212,14.212h94.035c7.816,0,14.212-6.395,14.212-14.212V43.999C387.841,36.183,381.445,29.787,373.629,29.787z')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Navbar$UserClickedEntry = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Navbar$baseEntryStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
			A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '100px auto'),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]));
var $rtfeldman$elm_css$Css$padding4 = $rtfeldman$elm_css$Css$prop4('padding');
var $author$project$Page$Navbar$unselectedEntryStyle = function (barPosition) {
	var paddingLastAttr = function () {
		if (!barPosition) {
			return 2;
		} else {
			return 0;
		}
	}();
	return $rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				$author$project$Page$Navbar$baseEntryStyle,
				A4(
				$rtfeldman$elm_css$Css$padding4,
				$rtfeldman$elm_css$Css$px(8),
				$rtfeldman$elm_css$Css$rem(paddingLastAttr),
				$rtfeldman$elm_css$Css$px(8),
				$rtfeldman$elm_css$Css$rem(paddingLastAttr)),
				$rtfeldman$elm_css$Css$color(
				$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$grey)),
				$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
			]));
};
var $author$project$Page$Navbar$baseIconStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'justify-self', 'center'),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$rem(-0.5)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$rem(0.5)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50))
		]));
var $author$project$Page$Navbar$unselectedIconStyle = $author$project$Page$Navbar$baseIconStyle;
var $author$project$Page$Navbar$viewDisabledEntry = F3(
	function (barPosition, icon, text_) {
		var iconHeight = function () {
			if (!barPosition) {
				return $rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(4));
			} else {
				return $rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3));
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Page$Navbar$unselectedEntryStyle(barPosition),
							$rtfeldman$elm_css$Css$backgroundColor(
							$author$project$UI$Style$Color$toCssColor(
								A4($author$project$UI$Style$Color$rgba, 0.35, 0.44, 0.53, 1)))
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						iconHeight,
						A2(
							$author$project$UI$Icon$withStyle,
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
							A2(
								$author$project$UI$Icon$withStyle,
								$author$project$Page$Navbar$unselectedIconStyle,
								A2(
									$author$project$UI$Icon$withForegroundColor,
									$author$project$UI$Style$Theme$white,
									$author$project$UI$Icon$unicolor(icon)))))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(text_)
						]))
				]));
	});
var $author$project$Page$Navbar$selectedEntryStyle = function (barPosition) {
	var _v0 = function () {
		if (!barPosition) {
			return _Utils_Tuple2(
				2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor(
						A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.3))
					]));
		} else {
			return _Utils_Tuple2(0, _List_Nil);
		}
	}();
	var paddingLastAttr = _v0.a;
	var background = _v0.b;
	return $rtfeldman$elm_css$Css$batch(
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					$author$project$Page$Navbar$baseEntryStyle,
					A4(
					$rtfeldman$elm_css$Css$padding4,
					$rtfeldman$elm_css$Css$px(8),
					$rtfeldman$elm_css$Css$rem(paddingLastAttr),
					$rtfeldman$elm_css$Css$px(8),
					$rtfeldman$elm_css$Css$rem(paddingLastAttr)),
					$rtfeldman$elm_css$Css$fontWeight(
					$rtfeldman$elm_css$Css$int(600)),
					$rtfeldman$elm_css$Css$color(
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)
				]),
			background));
};
var $author$project$Page$Navbar$selectedIconStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$author$project$Page$Navbar$baseIconStyle,
			$rtfeldman$elm_css$Css$backgroundColor(
			$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white))
		]));
var $author$project$Page$Navbar$viewSelectedEntry = F5(
	function (toMsg, barPosition, deviceHeight, icon, text_) {
		var iconHeight = function () {
			if (!barPosition) {
				return (_Utils_cmp(deviceHeight, $author$project$Page$Navbar$maxDeviceHeight) > 0) ? $rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(4)) : $rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3));
			} else {
				return $rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3));
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Page$Navbar$selectedEntryStyle(barPosition)
						])),
					$rtfeldman$elm_css$Svg$Styled$Events$onClick(toMsg)
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						iconHeight,
						A2(
							$author$project$UI$Icon$withStyle,
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default),
							A2(
								$author$project$UI$Icon$withStyle,
								$author$project$Page$Navbar$selectedIconStyle,
								A2(
									$author$project$UI$Icon$withForegroundColor,
									$author$project$UI$Style$Theme$darkGrey,
									$author$project$UI$Icon$unicolor(icon)))))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(text_)
						]))
				]));
	});
var $author$project$Page$Navbar$viewUnselectedEntry = F5(
	function (toMsg, barPosition, deviceHeight, icon, text_) {
		var iconHeight = function () {
			if (!barPosition) {
				return (_Utils_cmp(deviceHeight, $author$project$Page$Navbar$maxDeviceHeight) > 0) ? $rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(4)) : $rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3));
			} else {
				return $rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3));
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Page$Navbar$unselectedEntryStyle(barPosition)
						])),
					$rtfeldman$elm_css$Svg$Styled$Events$onClick(toMsg)
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						iconHeight,
						A2(
							$author$project$UI$Icon$withStyle,
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
							A2(
								$author$project$UI$Icon$withStyle,
								$author$project$Page$Navbar$unselectedIconStyle,
								A2(
									$author$project$UI$Icon$withForegroundColor,
									$author$project$UI$Style$Theme$white,
									$author$project$UI$Icon$unicolor(icon)))))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(text_)
						]))
				]));
	});
var $author$project$Page$Navbar$viewArchiveEntry = F5(
	function (barPosition, deviceHeight, translations, isOnline, route) {
		return _Utils_eq(route, $author$project$Environments$Route$Archive) ? A5(
			$author$project$Page$Navbar$viewSelectedEntry,
			$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$Archive),
			barPosition,
			deviceHeight,
			$author$project$UI$Icons$checkedDocument,
			$author$project$Translations$Archive$archive(translations)) : (isOnline ? A5(
			$author$project$Page$Navbar$viewUnselectedEntry,
			$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$Archive),
			barPosition,
			deviceHeight,
			$author$project$UI$Icons$checkedDocument,
			$author$project$Translations$Archive$archive(translations)) : A3(
			$author$project$Page$Navbar$viewDisabledEntry,
			barPosition,
			$author$project$UI$Icons$checkedDocument,
			$author$project$Translations$Archive$archive(translations)));
	});
var $author$project$Translations$Sidebar$audits = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.audits');
};
var $author$project$Page$Navbar$viewAuditsEntry = F4(
	function (barPosition, deviceHeight, translations, route) {
		switch (route.$) {
			case 2:
				return A5(
					$author$project$Page$Navbar$viewSelectedEntry,
					$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$Audits),
					barPosition,
					deviceHeight,
					$author$project$UI$Icons$audits,
					$author$project$Translations$Sidebar$audits(translations));
			case 3:
				return A5(
					$author$project$Page$Navbar$viewSelectedEntry,
					$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$Audits),
					barPosition,
					deviceHeight,
					$author$project$UI$Icons$audits,
					$author$project$Translations$Sidebar$audits(translations));
			default:
				return A5(
					$author$project$Page$Navbar$viewUnselectedEntry,
					$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$Audits),
					barPosition,
					deviceHeight,
					$author$project$UI$Icons$audits,
					$author$project$Translations$Sidebar$audits(translations));
		}
	});
var $author$project$Translations$Sidebar$mainMenu = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.mainMenu');
};
var $author$project$Page$Navbar$viewMainMenuEntry = F4(
	function (barPosition, deviceHeight, translations, route) {
		return _Utils_eq(route, $author$project$Environments$Route$MainMenu) ? A5(
			$author$project$Page$Navbar$viewSelectedEntry,
			$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$MainMenu),
			barPosition,
			deviceHeight,
			$author$project$UI$Icons$home,
			$author$project$Translations$Sidebar$mainMenu(translations)) : A5(
			$author$project$Page$Navbar$viewUnselectedEntry,
			$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$MainMenu),
			barPosition,
			deviceHeight,
			$author$project$UI$Icons$home,
			$author$project$Translations$Sidebar$mainMenu(translations));
	});
var $author$project$Translations$Sidebar$measures = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.measures');
};
var $author$project$Page$Navbar$viewMeasuresEntry = F4(
	function (barPosition, deviceHeight, translations, route) {
		return _Utils_eq(route, $author$project$Environments$Route$Measures) ? A5(
			$author$project$Page$Navbar$viewSelectedEntry,
			$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$Measures),
			barPosition,
			deviceHeight,
			$author$project$UI$Icons$taskList,
			$author$project$Translations$Sidebar$measures(translations)) : A5(
			$author$project$Page$Navbar$viewUnselectedEntry,
			$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$Measures),
			barPosition,
			deviceHeight,
			$author$project$UI$Icons$taskList,
			$author$project$Translations$Sidebar$measures(translations));
	});
var $author$project$Environments$Route$OUOverview = {$: 8};
var $author$project$Page$Navbar$viewOUOverviewEntry = F4(
	function (barPosition, deviceHeight, translations, route) {
		return _Utils_eq(route, $author$project$Environments$Route$OUOverview) ? A5(
			$author$project$Page$Navbar$viewSelectedEntry,
			$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$OUOverview),
			barPosition,
			deviceHeight,
			$author$project$UI$Icons$factory,
			$author$project$Translations$Sidebar$ouOverview(translations)) : A5(
			$author$project$Page$Navbar$viewUnselectedEntry,
			$author$project$Page$Navbar$UserClickedEntry($author$project$Environments$Route$OUOverview),
			barPosition,
			deviceHeight,
			$author$project$UI$Icons$factory,
			$author$project$Translations$Sidebar$ouOverview(translations));
	});
var $author$project$Page$Navbar$UserClickedSettingsEntry = {$: 10};
var $author$project$Translations$Sidebar$settings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.settings');
};
var $author$project$Page$Navbar$viewSettingsEntry = F5(
	function (barPosition, deviceHeight, translations, isOnline, route) {
		return (_Utils_eq(route, $author$project$Environments$Route$Settings) || (_Utils_eq(route, $author$project$Environments$Route$Users) || (_Utils_eq(route, $author$project$Environments$Route$OrganisationUnits) || (_Utils_eq(route, $author$project$Environments$Route$Plans) || (_Utils_eq(route, $author$project$Environments$Route$Roles) || _Utils_eq(route, $author$project$Environments$Route$Teams)))))) ? A5(
			$author$project$Page$Navbar$viewSelectedEntry,
			$author$project$Page$Navbar$UserClickedSettingsEntry,
			barPosition,
			deviceHeight,
			$author$project$UI$Icons$gear,
			$author$project$Translations$Sidebar$settings(translations)) : (isOnline ? A5(
			$author$project$Page$Navbar$viewUnselectedEntry,
			$author$project$Page$Navbar$UserClickedSettingsEntry,
			barPosition,
			deviceHeight,
			$author$project$UI$Icons$gear,
			$author$project$Translations$Sidebar$settings(translations)) : A3(
			$author$project$Page$Navbar$viewDisabledEntry,
			barPosition,
			$author$project$UI$Icons$gear,
			$author$project$Translations$Sidebar$settings(translations)));
	});
var $author$project$Translations$Sidebar$menuPanel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.menuPanel');
};
var $author$project$Page$Navbar$topEntryStyle = F2(
	function (barPosition, additionalStyles) {
		var _v0 = function () {
			if (!barPosition) {
				return _Utils_Tuple2(2, '6rem');
			} else {
				return _Utils_Tuple2(0, '5rem');
			}
		}();
		var paddingLeftAttr = _v0.a;
		var rowHeight = _v0.b;
		return $rtfeldman$elm_css$Css$batch(
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Page$Navbar$baseEntryStyle,
						A2($rtfeldman$elm_css$Css$property, 'grid-template-rows', rowHeight),
						A2($rtfeldman$elm_css$Css$property, 'justify-items', 'stretch'),
						$rtfeldman$elm_css$Css$paddingLeft(
						$rtfeldman$elm_css$Css$rem(paddingLeftAttr)),
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$rem(1.4)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white))
					]),
				additionalStyles));
	});
var $author$project$Page$Navbar$viewCollapseIcon = function (state) {
	var baseStyle = $rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$property, 'grid-row', '1/1'),
				A2($rtfeldman$elm_css$Css$property, 'grid-column', '1/1'),
				A2($rtfeldman$elm_css$Css$property, 'will-change', 'display, fill'),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$rem(3))
			]));
	switch (state.$) {
		case 0:
			return $author$project$UI$Icon$view(
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
					A2(
						$author$project$UI$Icon$withStyle,
						baseStyle,
						A2(
							$author$project$UI$Icon$withForegroundColor,
							$author$project$UI$Style$Theme$white,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$close)))));
		case 1:
			return $author$project$UI$Icon$view(
				A2(
					$author$project$UI$Icon$withOnClick,
					$author$project$Page$Navbar$UserClickedCollapseIcon,
					A2(
						$author$project$UI$Icon$withStyle,
						baseStyle,
						A2(
							$author$project$UI$Icon$withForegroundColor,
							$author$project$UI$Style$Theme$white,
							$author$project$UI$Icon$unicolor($author$project$UI$Icons$close)))));
		case 2:
			var start = state.a.bx;
			var current = state.a.bD;
			var offsetX = state.a.co;
			var calculatedAlpha = $author$project$Page$Navbar$roundToSecondDigit(
				A3($elm$core$Basics$clamp, 0, 1, (((start.am + offsetX) - current.am) - 150) / 150));
			return $author$project$UI$Icon$view(
				A2(
					$author$project$UI$Icon$withStyle,
					baseStyle,
					A2(
						$author$project$UI$Icon$withForegroundColor,
						A4($author$project$UI$Style$Color$rgba, 255 / 255, 255 / 255, 255 / 255, calculatedAlpha),
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$close))));
		default:
			var spring = state.a;
			var calculatedAlpha = $author$project$Page$Navbar$roundToSecondDigit(
				A3(
					$elm$core$Basics$clamp,
					0,
					1,
					(150 - $tad_lispy$springs$Spring$value(spring)) / 150));
			return $author$project$UI$Icon$view(
				A2(
					$author$project$UI$Icon$withStyle,
					baseStyle,
					A2(
						$author$project$UI$Icon$withForegroundColor,
						A4($author$project$UI$Style$Color$rgba, 255, 255, 255, calculatedAlpha),
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$close))));
	}
};
var $author$project$Page$Navbar$viewLogo = function (state) {
	var baseStyle = $rtfeldman$elm_css$Css$batch(
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$property, 'grid-row', '1/1'),
				A2($rtfeldman$elm_css$Css$property, 'grid-column', '1/1'),
				A2($rtfeldman$elm_css$Css$property, 'justify-self', 'start'),
				A2($rtfeldman$elm_css$Css$property, 'will-change', 'display, fill'),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$rem(2))
			]));
	var baseAttributes = _List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 600 200'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$fillRule('evenodd'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$preserveAspectRatio('none')
		]);
	var attributes = function () {
		switch (state.$) {
			case 0:
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Svg$Styled$Attributes$css(
						_List_fromArray(
							[
								baseStyle,
								$rtfeldman$elm_css$Css$fill(
								A4($rtfeldman$elm_css$Css$rgba, 255, 255, 255, 1))
							])),
					baseAttributes);
			case 1:
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Svg$Styled$Attributes$css(
						_List_fromArray(
							[
								baseStyle,
								$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none),
								$rtfeldman$elm_css$Css$fill(
								A4($rtfeldman$elm_css$Css$rgba, 255, 255, 255, 0))
							])),
					baseAttributes);
			case 2:
				var start = state.a.bx;
				var current = state.a.bD;
				var offsetX = state.a.co;
				var calculatedAlpha = $author$project$Page$Navbar$roundToSecondDigit(
					A3($elm$core$Basics$clamp, 0, 1, (((150 - start.am) - offsetX) + current.am) / 150));
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Svg$Styled$Attributes$css(
						_List_fromArray(
							[
								baseStyle,
								$rtfeldman$elm_css$Css$fill(
								A4($rtfeldman$elm_css$Css$rgba, 255, 255, 255, calculatedAlpha))
							])),
					baseAttributes);
			default:
				var spring = state.a;
				var calculatedAlpha = $author$project$Page$Navbar$roundToSecondDigit(
					A3(
						$elm$core$Basics$clamp,
						0,
						1,
						($tad_lispy$springs$Spring$value(spring) - 150) / 150));
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Svg$Styled$Attributes$css(
						_List_fromArray(
							[
								baseStyle,
								$rtfeldman$elm_css$Css$fill(
								A4($rtfeldman$elm_css$Css$rgba, 255, 255, 255, calculatedAlpha))
							])),
					baseAttributes);
		}
	}();
	return A2(
		$rtfeldman$elm_css$Svg$Styled$svg,
		attributes,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$d('m0,64.5545l20.787,0l0,21.871l-20.787,0l0,-21.871zm0,61.782l20.787,0l0,21.871l-20.787,0l0,-21.871z')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$d('m139.583,71.6075c0,0 -26.971,-3.09 -40.684,-3.09c-13.722,0 -19.888,2.701 -19.888,10.619c0,6.38 4.798,8.115 27.202,11.396c27.43,4.064 37.258,9.85 37.258,29.165c0,22.601 -16.911,30.711 -45.254,30.711c-15.775,0 -42.292,-4.252 -42.292,-4.252l0.917,-17.571c0,0 27.426,3.094 39.08,3.094c16.466,0 22.863,-2.896 22.863,-11.405c0,-6.756 -3.889,-8.875 -26.517,-11.974c-25.144,-3.47 -37.943,-8.106 -37.943,-28.579c0,-21.823 20.119,-29.938 42.742,-29.938c16.692,0 42.974,4.247 42.974,4.247l-0.458,17.577z')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$d('m482.387,52.8955l96.399,0l0,16.815l-35.173,2.308l0,76.189l-25.604,0l0,-76.189l-35.623,-2.308l0,-16.815l0.001,0z')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$d('m411.298,51.7115l24.686,0l0,11.593c0,0 19.438,-10.623 38.861,-13.712l0,21.05c-20.805,3.479 -38.63,10.234 -38.63,10.234l0,67.409l-24.917,0l0,-96.574z')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$d('m394.422,125.4925l0,-44.031c0,-22.016 -12.21,-31.87 -41.995,-31.87c-22.448,0 -49.065,5.021 -49.065,5.021l0.983,14.871c0,0 29.536,-1.932 45.889,-1.932c11.965,0 17.824,3.282 17.824,13.91l0,6.948l0,14.875l0,10.654l0,15.032c0,0 -16.352,4.248 -30.27,4.248c-10.257,0 -14.889,-5.406 -14.889,-14.098c0,-8.688 5.615,-12.935 16.837,-13.713l17.585,-1.319l0,-14.954l-20.753,1.398c-26.123,1.739 -40.277,8.696 -40.277,29.165c0,20.084 12.201,30.711 36.366,30.711c19.77,0 39.303,-7.141 39.303,-7.141c9.033,5.594 17.576,7.141 32.469,7.141l0.734,-16.028c-7.075,-0.773 -10.252,-3.093 -10.741,-8.888z')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Svg$Styled$path,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$d('m150.677,148.2075l0,-95.386l25.376,0l0,5.34c0,0 13.162,-7.63 22.51,-7.63c10.684,0 18.121,2.858 23.846,8.967c0,0 17.55,-8.967 32.049,-8.967c25.949,0 33.578,15.26 33.578,45.98l0,51.696l-25.563,0l0,-53.601c0,-14.5 -1.909,-23.847 -13.354,-23.847c-7.634,0 -17.741,3.623 -17.741,3.623s0.76,14.307 0.76,21.749l0,52.076l-25.56,0l0,-51.696c0,-17.165 -1.533,-25.752 -13.358,-25.752c-8.39,0 -16.978,3.431 -16.978,3.431l0,74.017l-25.565,0z')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Navbar$viewSidebarTopEntry = F2(
	function (state, translations) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2(
							$author$project$Page$Navbar$topEntryStyle,
							$author$project$Page$Navbar$getBarPosition(state),
							_List_Nil)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Page$Navbar$viewLogo(state),
					$author$project$Page$Navbar$viewCollapseIcon(state),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Sidebar$menuPanel(translations))
						]))
				]));
	});
var $author$project$Page$Navbar$viewTopbarTopEntry = F3(
	function (state, translations, platform) {
		var baseStyleIcon = $rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'grid-row', '1/1'),
					A2($rtfeldman$elm_css$Css$property, 'grid-column', '1/1'),
					A2($rtfeldman$elm_css$Css$property, 'will-change', 'display, fill'),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(3))
				]));
		var additionalStyles = function () {
			if (platform.$ === 2) {
				return _List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$rem(2))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2(
							$author$project$Page$Navbar$topEntryStyle,
							$author$project$Page$Navbar$getBarPosition(state),
							additionalStyles)
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withOnClick,
						$author$project$Page$Navbar$UserClickedCollapseIcon,
						A2(
							$author$project$UI$Icon$withStyle,
							baseStyleIcon,
							A2(
								$author$project$UI$Icon$withForegroundColor,
								$author$project$UI$Style$Theme$white,
								$author$project$UI$Icon$unicolor($author$project$UI$Icons$close))))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Sidebar$menuPanel(translations))
						]))
				]));
	});
var $author$project$Translations$Sidebar$loading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'sidebar.Loading');
};
var $author$project$Page$Navbar$viewUserAvatar = function (user) {
	var _v0 = user.iX;
	if (!_v0.$) {
		var avatar = _v0.a;
		return $author$project$UI$Avatar$view(
			A2(
				$author$project$UI$Avatar$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(4)),
				$author$project$UI$Avatar$image(avatar)));
	} else {
		return $author$project$UI$Avatar$view(
			A2(
				$author$project$UI$Avatar$withStyle,
				$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$rem(4)),
				$author$project$UI$Avatar$icon(
					$author$project$UI$Icon$bicolor($author$project$UI$Icons$userCircleBicolor))));
	}
};
var $author$project$Page$Navbar$viewUnselectedUserEntry = F3(
	function (barPosition, maybeUser, translations) {
		var name = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Translations$Sidebar$loading(translations),
			A2(
				$elm$core$Maybe$map,
				function (user) {
					return $elm$core$String$isEmpty(user.g_) ? user.iK : user.g_;
				},
				maybeUser));
		var iconOrPicture = A2(
			$elm$core$Maybe$withDefault,
			$author$project$UI$Icon$view(
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default),
					A2(
						$author$project$UI$Icon$withStyle,
						$author$project$Page$Navbar$selectedIconStyle,
						A2(
							$author$project$UI$Icon$withBackgroundColor,
							$author$project$UI$Style$Theme$white,
							A2(
								$author$project$UI$Icon$withForegroundColor,
								$author$project$UI$Style$Theme$darkGrey,
								$author$project$UI$Icon$bicolor($author$project$UI$Icons$userCircleBicolor)))))),
			A2($elm$core$Maybe$map, $author$project$Page$Navbar$viewUserAvatar, maybeUser));
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Page$Navbar$unselectedEntryStyle(barPosition)
						]))
				]),
			_List_fromArray(
				[
					iconOrPicture,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(name)
								]))
						]))
				]));
	});
var $author$project$Page$Navbar$viewUserEntry = F3(
	function (barPosition, maybeUser, translations) {
		return A3($author$project$Page$Navbar$viewUnselectedUserEntry, barPosition, maybeUser, translations);
	});
var $author$project$Page$Navbar$viewEntries = F5(
	function (translations, environment, state, maybeUser, route) {
		var platform = $author$project$Environments$Environment$platform(environment);
		var topEntry = function () {
			var _v0 = $author$project$Page$Navbar$getBarPosition(state);
			if (!_v0) {
				return A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Page$Navbar$viewSidebarTopEntry, state, translations);
			} else {
				return A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$Navbar$viewTopbarTopEntry, state, translations, platform);
			}
		}();
		var isOnline = $author$project$Environments$Environment$isOnline(environment);
		var height = $elm$core$Basics$round(
			$author$project$Environments$Environment$viewport(environment).Y);
		var settingsEntry = ((!$author$project$Auth$Authorization$checkOpenSettings(
			$author$project$Environments$Environment$userRights(environment))) || ((!$author$project$Environments$Flags$Platform$isWeb(
			$author$project$Environments$Environment$platform(environment))) || (height < 650))) ? _List_Nil : _List_fromArray(
			[
				A6(
				$rtfeldman$elm_css$Html$Styled$Lazy$lazy5,
				$author$project$Page$Navbar$viewSettingsEntry,
				$author$project$Page$Navbar$getBarPosition(state),
				height,
				translations,
				isOnline,
				route)
			]);
		return _Utils_ap(
			_List_fromArray(
				[
					topEntry,
					A4(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy3,
					$author$project$Page$Navbar$viewUserEntry,
					$author$project$Page$Navbar$getBarPosition(state),
					maybeUser,
					translations),
					A5(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
					$author$project$Page$Navbar$viewMainMenuEntry,
					$author$project$Page$Navbar$getBarPosition(state),
					height,
					translations,
					route),
					A5(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
					$author$project$Page$Navbar$viewMeasuresEntry,
					$author$project$Page$Navbar$getBarPosition(state),
					height,
					translations,
					route),
					A5(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
					$author$project$Page$Navbar$viewAuditsEntry,
					$author$project$Page$Navbar$getBarPosition(state),
					height,
					translations,
					route),
					A5(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
					$author$project$Page$Navbar$viewOUOverviewEntry,
					$author$project$Page$Navbar$getBarPosition(state),
					height,
					translations,
					route),
					A6(
					$rtfeldman$elm_css$Html$Styled$Lazy$lazy5,
					$author$project$Page$Navbar$viewArchiveEntry,
					$author$project$Page$Navbar$getBarPosition(state),
					height,
					translations,
					isOnline,
					route)
				]),
			_Utils_ap(
				settingsEntry,
				_List_fromArray(
					[
						A6(
						$rtfeldman$elm_css$Html$Styled$Lazy$lazy5,
						$author$project$Page$Navbar$viewUnselectedEntry,
						$author$project$Page$Navbar$UserClickedAbout,
						$author$project$Page$Navbar$getBarPosition(state),
						height,
						$author$project$UI$Icons$info,
						$author$project$Translations$Sidebar$about(translations)),
						A6(
						$rtfeldman$elm_css$Html$Styled$Lazy$lazy5,
						$author$project$Page$Navbar$viewUnselectedEntry,
						$author$project$Page$Navbar$UserClickedLogout,
						$author$project$Page$Navbar$getBarPosition(state),
						height,
						$author$project$UI$Icons$logout,
						$author$project$Translations$Logout$logout(translations))
					])));
	});
var $author$project$Page$Navbar$OpenExtendedMenu = {$: 12};
var $author$project$Translations$Misc$extendedOptions = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'misc.extendedOptions',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Page$Navbar$viewExtendedEntry = F3(
	function (translations, barPosition, numberOfExtendedEntries) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Page$Navbar$unselectedEntryStyle(barPosition),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(3))
						])),
					$rtfeldman$elm_css$Svg$Styled$Events$onClick($author$project$Page$Navbar$OpenExtendedMenu)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$rem(3)),
									$rtfeldman$elm_css$Css$paddingLeft(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$white)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(500))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							'+' + $elm$core$String$fromInt(numberOfExtendedEntries))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$rem(3))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2(
								$author$project$Translations$Misc$extendedOptions,
								translations,
								$elm$core$String$fromInt(numberOfExtendedEntries)))
						]))
				]));
	});
var $author$project$Page$Navbar$CloseExtendedMenu = {$: 13};
var $rtfeldman$elm_css$Css$rowReverse = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{ll: 'row-reverse'});
var $author$project$Page$Navbar$viewTopRow = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse)
				])),
			$rtfeldman$elm_css$Svg$Styled$Events$onClick($author$project$Page$Navbar$CloseExtendedMenu)
		]),
	_List_fromArray(
		[
			$author$project$UI$Icon$view(
			A2(
				$author$project$UI$Icon$withForegroundColor,
				$author$project$UI$Style$Theme$white,
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(3)),
					$author$project$UI$Icon$unicolor($author$project$UI$Icons$close))))
		]));
var $author$project$Page$Navbar$viewMenu = function (entries) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
						$rtfeldman$elm_css$Css$bottom(
						$rtfeldman$elm_css$Css$rem(0.2)),
						$rtfeldman$elm_css$Css$right(
						$rtfeldman$elm_css$Css$rem(8.4)),
						$rtfeldman$elm_css$Css$backgroundColor(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkRed)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$px(4))
					]))
			]),
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[$author$project$Page$Navbar$viewTopRow]),
			entries));
};
var $author$project$Page$Navbar$viewExtendedMenu = F2(
	function (state, entries) {
		var extendedMenu = function () {
			switch (state.$) {
				case 0:
					var model = state.b;
					return model.O;
				case 1:
					var model = state.b;
					return model.O;
				case 2:
					var model = state.b;
					return model.O;
				default:
					var model = state.b;
					return model.O;
			}
		}();
		return ($elm$core$List$isEmpty(entries) || (!extendedMenu)) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Navbar$viewMenu(entries)
				]));
	});
var $author$project$Page$Navbar$ReceivedLogoutModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Auth$LogoutModal$UserClickedCloseDialog = 0;
var $rtfeldman$elm_css$Html$Styled$h3 = $rtfeldman$elm_css$Html$Styled$node('h3');
var $author$project$Translations$Logout$text1 = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'logout.text1');
};
var $author$project$Translations$Logout$text2 = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'logout.text2');
};
var $author$project$Translations$Logout$auditCommands = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'logout.auditCommands',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Translations$Logout$checkpointDataCommands = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'logout.checkpointDataCommands',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Auth$LogoutModal$commandCountToHtmlString = F2(
	function (count, translation) {
		return (!count) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					translation(
						$elm$core$String$fromInt(count)))
				]));
	});
var $author$project$Translations$Logout$measureCommands = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'logout.measureCommands',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Translations$Logout$organisationUnitCommands = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'logout.organisationUnitCommands',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Translations$Logout$planCommands = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'logout.planCommands',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Translations$Logout$rightsCommands = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'logout.rightsCommands',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Translations$Logout$tenantCommands = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'logout.tenantCommands',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Translations$Logout$userCommands = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'logout.userCommands',
			_List_fromArray(
				[
					_Utils_Tuple2('number', number)
				]));
	});
var $author$project$Auth$LogoutModal$unsynchronizedCommandsOverview = F2(
	function (translations, commandSummary) {
		var unsynchronizedUserCommands = $elm$core$List$length(
			$author$project$User$Commands$toList(commandSummary.li));
		var unsynchronizedTenantCommands = $elm$core$List$length(
			$author$project$Tenant$Commands$toList(commandSummary.k3));
		var unsynchronizedRightsCommands = $elm$core$List$length(
			$author$project$Rights$Commands$toList(commandSummary.kG));
		var unsynchronizedPlanCommands = $elm$core$List$length(
			$author$project$Plan$Commands$toList(commandSummary.kp));
		var unsynchronizedOrganisationUnitCommands = $elm$core$List$length(
			$author$project$OrganisationUnit$Commands$toList(commandSummary.kk));
		var unsynchronizedMeasureCommands = $elm$core$List$length(
			$author$project$Measure$Commands$toList(commandSummary.j3));
		var unsynchronizedCheckpointDataCommands = $elm$core$List$length(
			$author$project$CheckpointData$Commands$toList(commandSummary.i3));
		var unsynchronizedAuditCommands = $elm$core$List$length(
			$author$project$Audit$Commands$toList(commandSummary.iT));
		return _List_fromArray(
			[
				A2(
				$author$project$Auth$LogoutModal$commandCountToHtmlString,
				unsynchronizedUserCommands,
				$author$project$Translations$Logout$userCommands(translations)),
				A2(
				$author$project$Auth$LogoutModal$commandCountToHtmlString,
				unsynchronizedOrganisationUnitCommands,
				$author$project$Translations$Logout$organisationUnitCommands(translations)),
				A2(
				$author$project$Auth$LogoutModal$commandCountToHtmlString,
				unsynchronizedPlanCommands,
				$author$project$Translations$Logout$planCommands(translations)),
				A2(
				$author$project$Auth$LogoutModal$commandCountToHtmlString,
				unsynchronizedAuditCommands,
				$author$project$Translations$Logout$auditCommands(translations)),
				A2(
				$author$project$Auth$LogoutModal$commandCountToHtmlString,
				unsynchronizedMeasureCommands,
				$author$project$Translations$Logout$measureCommands(translations)),
				A2(
				$author$project$Auth$LogoutModal$commandCountToHtmlString,
				unsynchronizedTenantCommands,
				$author$project$Translations$Logout$tenantCommands(translations)),
				A2(
				$author$project$Auth$LogoutModal$commandCountToHtmlString,
				unsynchronizedCheckpointDataCommands,
				$author$project$Translations$Logout$checkpointDataCommands(translations)),
				A2(
				$author$project$Auth$LogoutModal$commandCountToHtmlString,
				unsynchronizedRightsCommands,
				$author$project$Translations$Logout$rightsCommands(translations))
			]);
	});
var $author$project$Auth$LogoutModal$viewContent = F2(
	function (translations, commandSummary) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h4,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Logout$text1(translations))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h4,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(600)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightRed))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$Logout$text2(translations))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h3,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(500)),
									$rtfeldman$elm_css$Css$color(
									$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey)),
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
								]))
						]),
					A2($author$project$Auth$LogoutModal$unsynchronizedCommandsOverview, translations, commandSummary))
				]));
	});
var $author$project$Auth$LogoutModal$UserClickedCancelButton = 1;
var $author$project$Auth$LogoutModal$viewCancelButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			1,
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$cancel(translations))));
};
var $author$project$Auth$LogoutModal$UserClickedLogoutButton = 2;
var $author$project$Auth$LogoutModal$viewLogoutButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			2,
			$author$project$UI$Button$darkRed(
				$author$project$Translations$Logout$logout(translations))));
};
var $author$project$Auth$LogoutModal$viewFooter = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Auth$LogoutModal$viewCancelButton(translations),
				$author$project$Auth$LogoutModal$viewLogoutButton(translations)
			]));
};
var $author$project$Auth$LogoutModal$viewDialog = F2(
	function (translations, commandSummary) {
		return $author$project$UI$Modal$view(
			A2(
				$author$project$UI$Modal$appendFooter,
				$author$project$Auth$LogoutModal$viewFooter(translations),
				A2(
					$author$project$UI$Modal$appendContent,
					A2($author$project$Auth$LogoutModal$viewContent, translations, commandSummary),
					A2(
						$author$project$UI$Modal$modal,
						$author$project$Translations$Logout$logout(translations),
						0))));
	});
var $author$project$Auth$LogoutModal$view = F3(
	function (translations, repository, dialog) {
		if (!dialog) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var commandSummary = $author$project$Environments$Repository$commandSummary(repository);
			return A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Auth$LogoutModal$viewDialog, translations, commandSummary);
		}
	});
var $author$project$Page$Navbar$viewLogoutModal = F3(
	function (translations, repository, state) {
		switch (state.$) {
			case 0:
				var model = state.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$Navbar$ReceivedLogoutModalMsg,
					A3($author$project$Auth$LogoutModal$view, translations, repository, model.ci));
			case 1:
				var model = state.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$Navbar$ReceivedLogoutModalMsg,
					A3($author$project$Auth$LogoutModal$view, translations, repository, model.ci));
			default:
				return A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$Navbar$ReceivedLogoutModalMsg,
					A3($author$project$Auth$LogoutModal$view, translations, repository, $author$project$Auth$LogoutModal$hidden));
		}
	});
var $rtfeldman$elm_css$Css$touchAction = $rtfeldman$elm_css$Css$prop1('touch-action');
var $rtfeldman$elm_css$Css$translateX = function (_v0) {
	var value = _v0.ll;
	return {
		q: 0,
		ll: A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'translateX',
			_List_fromArray(
				[value]))
	};
};
var $author$project$Page$Navbar$viewSidebar = F2(
	function (state, entries) {
		var baseStyle = $rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'grid-area', 'sidebar'),
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
					$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$width(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$px(400),
						$rtfeldman$elm_css$Css$plus,
						$rtfeldman$elm_css$Css$rem(2))),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$vh(100)),
					$rtfeldman$elm_css$Css$paddingLeft($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$fontSize(
					$rtfeldman$elm_css$Css$rem(1.25)),
					$rtfeldman$elm_css$Css$fontWeight(
					$rtfeldman$elm_css$Css$int(300)),
					$rtfeldman$elm_css$Css$textIndent(
					$rtfeldman$elm_css$Css$rem(1.25)),
					A2($rtfeldman$elm_css$Css$property, '-webkit-clip-path', 'polygon(2rem 0, 100% 0, 100% 100%, 0 100%, 0 68%, 2rem 65%)'),
					A2($rtfeldman$elm_css$Css$property, 'clip-path', 'polygon(2rem 0, 100% 0, 100% 100%, 0 100%, 0 68%, 2rem 65%)'),
					A2(
					$rtfeldman$elm_css$Css$property,
					'background-image',
					'linear-gradient(90deg, ' + ($author$project$UI$Style$Color$toString($author$project$UI$Style$Theme$darkRed) + (' calc(100px + 2rem), ' + ($author$project$UI$Style$Color$toString($author$project$UI$Style$Theme$darkGrey) + ' calc(100px + 2rem))')))),
					$rtfeldman$elm_css$Css$touchAction($rtfeldman$elm_css$Css$none),
					A2($rtfeldman$elm_css$Css$property, 'will-change', 'transform')
				]));
		var sidebarAttributes = function () {
			switch (state.$) {
				case 0:
					if (!state.a.$) {
						var _v1 = state.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										baseStyle,
										$rtfeldman$elm_css$Css$transform(
										$rtfeldman$elm_css$Css$translateX(
											$rtfeldman$elm_css$Css$px($author$project$Page$Navbar$offsetXBase))),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$author$project$Page$Navbar$onPointerDown($author$project$Page$Navbar$UserPointedDown)
							]);
					} else {
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										baseStyle,
										$rtfeldman$elm_css$Css$transform(
										$rtfeldman$elm_css$Css$translateX(
											$rtfeldman$elm_css$Css$px($author$project$Page$Navbar$offsetXBase))),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$author$project$Page$Navbar$onPointerMove($author$project$Page$Navbar$UserMovedPointer),
								$author$project$Page$Navbar$onPointerUp($author$project$Page$Navbar$UserPointedUp)
							]);
					}
				case 1:
					if (!state.a.$) {
						var _v2 = state.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										baseStyle,
										$rtfeldman$elm_css$Css$transform(
										$rtfeldman$elm_css$Css$translateX($rtfeldman$elm_css$Css$zero)),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$author$project$Page$Navbar$onPointerDown($author$project$Page$Navbar$UserPointedDown)
							]);
					} else {
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										baseStyle,
										$rtfeldman$elm_css$Css$transform(
										$rtfeldman$elm_css$Css$translateX($rtfeldman$elm_css$Css$zero)),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$author$project$Page$Navbar$onPointerMove($author$project$Page$Navbar$UserMovedPointer),
								$author$project$Page$Navbar$onPointerUp($author$project$Page$Navbar$UserPointedUp)
							]);
					}
				case 2:
					var data = state.a;
					var position = A3($elm$core$Basics$clamp, 0, $author$project$Page$Navbar$offsetXBase, (($author$project$Page$Navbar$offsetXBase - data.bx.am) + data.bD.am) - data.co);
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									baseStyle,
									$rtfeldman$elm_css$Css$transform(
									$rtfeldman$elm_css$Css$translateX(
										$rtfeldman$elm_css$Css$px(position)))
								])),
							$author$project$Page$Navbar$onPointerMove($author$project$Page$Navbar$UserMovedPointer),
							$author$project$Page$Navbar$onPointerUp($author$project$Page$Navbar$UserPointedUp)
						]);
				default:
					var spring = state.a;
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									baseStyle,
									$rtfeldman$elm_css$Css$transform(
									$rtfeldman$elm_css$Css$translateX(
										$rtfeldman$elm_css$Css$px(
											$tad_lispy$springs$Spring$value(spring))))
								])),
							$author$project$Page$Navbar$onPointerDown($author$project$Page$Navbar$UserPointedDown)
						]);
			}
		}();
		return A2($rtfeldman$elm_css$Html$Styled$ul, sidebarAttributes, entries);
	});
var $rtfeldman$elm_css$Css$translateY = function (_v0) {
	var value = _v0.ll;
	return {
		q: 0,
		ll: A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'translateY',
			_List_fromArray(
				[value]))
	};
};
var $author$project$Page$Navbar$viewQuickIcon = F3(
	function (targetRoute, currentRoute, icon) {
		return _Utils_eq(targetRoute, currentRoute) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Page$Navbar$selectedEntryStyle(1),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '55px auto')
						])),
					$rtfeldman$elm_css$Svg$Styled$Events$onClick(
					$author$project$Page$Navbar$UserClickedEntry(targetRoute))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(3)),
						A2(
							$author$project$UI$Icon$withStyle,
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default),
							A2(
								$author$project$UI$Icon$withStyle,
								$author$project$Page$Navbar$selectedIconStyle,
								A2(
									$author$project$UI$Icon$withForegroundColor,
									$author$project$UI$Style$Theme$darkGrey,
									$author$project$UI$Icon$unicolor(icon))))))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Page$Navbar$unselectedEntryStyle(1),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', '55px auto')
						])),
					$rtfeldman$elm_css$Svg$Styled$Events$onClick(
					$author$project$Page$Navbar$UserClickedEntry(targetRoute))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$rem(3)),
						A2(
							$author$project$UI$Icon$withStyle,
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
							A2(
								$author$project$UI$Icon$withStyle,
								$author$project$Page$Navbar$unselectedIconStyle,
								A2(
									$author$project$UI$Icon$withForegroundColor,
									$author$project$UI$Style$Theme$white,
									$author$project$UI$Icon$unicolor(icon))))))
				]));
	});
var $author$project$Page$Navbar$viewTopbarQuickRow = F2(
	function (currentRoute, platform) {
		var topMargin = function () {
			if (platform.$ === 2) {
				return $rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$rem(2));
			} else {
				return A2($rtfeldman$elm_css$Css$property, '', '');
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$rtfeldman$elm_css$Css$displayFlex, topMargin]))
				]),
			_List_fromArray(
				[
					A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$Navbar$viewQuickIcon, $author$project$Environments$Route$MainMenu, currentRoute, $author$project$UI$Icons$home),
					A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$Navbar$viewQuickIcon, $author$project$Environments$Route$Measures, currentRoute, $author$project$UI$Icons$taskList),
					A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$Navbar$viewQuickIcon, $author$project$Environments$Route$Audits, currentRoute, $author$project$UI$Icons$audits),
					A4($rtfeldman$elm_css$Html$Styled$Lazy$lazy3, $author$project$Page$Navbar$viewQuickIcon, $author$project$Environments$Route$OUOverview, currentRoute, $author$project$UI$Icons$factory)
				]));
	});
var $rtfeldman$elm_css$Css$VwUnits = 0;
var $rtfeldman$elm_css$Css$vw = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vw');
var $author$project$Page$Navbar$viewTopbar = F4(
	function (platform, state, route, entries) {
		var _v0 = function () {
			if (platform.$ === 2) {
				return _Utils_Tuple2(400, '98');
			} else {
				return _Utils_Tuple2(326, '60');
			}
		}();
		var calcHeight = _v0.a;
		var barThickness = _v0.b;
		var baseStyle = $rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
					$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$vw(100)),
					$rtfeldman$elm_css$Css$height(
					A3(
						$rtfeldman$elm_css$Css$calc,
						$rtfeldman$elm_css$Css$px(calcHeight),
						$rtfeldman$elm_css$Css$plus,
						$rtfeldman$elm_css$Css$rem(15))),
					$rtfeldman$elm_css$Css$paddingLeft($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$fontSize(
					$rtfeldman$elm_css$Css$rem(1.25)),
					$rtfeldman$elm_css$Css$fontWeight(
					$rtfeldman$elm_css$Css$int(300)),
					$rtfeldman$elm_css$Css$textIndent(
					$rtfeldman$elm_css$Css$rem(1.25)),
					A2($rtfeldman$elm_css$Css$property, '-webkit-clip-path', 'polygon(0 0, 100% 0, 100% 94%, 26% 94%, 20% 98%,0 98%)'),
					A2($rtfeldman$elm_css$Css$property, 'clip-path', 'polygon(0 0, 100% 0, 100% 94%, 26% 94%, 20% 98%,0 98%)'),
					A2(
					$rtfeldman$elm_css$Css$property,
					'background-image',
					'linear-gradient(0deg, ' + ($author$project$UI$Style$Color$toString($author$project$UI$Style$Theme$darkRed) + (' calc(76px + 1rem), ' + (' calc(' + (barThickness + ('px + 2rem), ' + ($author$project$UI$Style$Color$toString($author$project$UI$Style$Theme$darkGrey) + ' calc(76px + 1rem))'))))))),
					$rtfeldman$elm_css$Css$touchAction($rtfeldman$elm_css$Css$none),
					A2($rtfeldman$elm_css$Css$property, 'will-change', 'transform')
				]));
		var sidebarAttributes = function () {
			switch (state.$) {
				case 0:
					if (!state.a.$) {
						var _v3 = state.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										baseStyle,
										$rtfeldman$elm_css$Css$transform(
										$rtfeldman$elm_css$Css$translateY(
											$rtfeldman$elm_css$Css$px(
												$author$project$Page$Navbar$offsetYBase(platform)))),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$author$project$Page$Navbar$onPointerDown($author$project$Page$Navbar$UserPointedDown)
							]);
					} else {
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										baseStyle,
										$rtfeldman$elm_css$Css$transform(
										$rtfeldman$elm_css$Css$translateY(
											$rtfeldman$elm_css$Css$px(
												$author$project$Page$Navbar$offsetYBase(platform)))),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$author$project$Page$Navbar$onPointerMove($author$project$Page$Navbar$UserMovedPointer),
								$author$project$Page$Navbar$onPointerUp($author$project$Page$Navbar$UserPointedUp)
							]);
					}
				case 1:
					if (!state.a.$) {
						var _v4 = state.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										baseStyle,
										$rtfeldman$elm_css$Css$transform(
										$rtfeldman$elm_css$Css$translateY($rtfeldman$elm_css$Css$zero)),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$author$project$Page$Navbar$onPointerDown($author$project$Page$Navbar$UserPointedDown)
							]);
					} else {
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										baseStyle,
										$rtfeldman$elm_css$Css$transform(
										$rtfeldman$elm_css$Css$translateY($rtfeldman$elm_css$Css$zero)),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$author$project$Page$Navbar$onPointerMove($author$project$Page$Navbar$UserMovedPointer),
								$author$project$Page$Navbar$onPointerUp($author$project$Page$Navbar$UserPointedUp)
							]);
					}
				case 2:
					var data = state.a;
					var position = A3(
						$elm$core$Basics$clamp,
						$author$project$Page$Navbar$offsetYBase(platform),
						0,
						(($author$project$Page$Navbar$offsetYBase(platform) - data.bx.bf) + data.bD.bf) - data.eN);
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									baseStyle,
									$rtfeldman$elm_css$Css$transform(
									$rtfeldman$elm_css$Css$translateY(
										$rtfeldman$elm_css$Css$px(position)))
								])),
							$author$project$Page$Navbar$onPointerMove($author$project$Page$Navbar$UserMovedPointer),
							$author$project$Page$Navbar$onPointerUp($author$project$Page$Navbar$UserPointedUp)
						]);
				default:
					var spring = state.a;
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									baseStyle,
									$rtfeldman$elm_css$Css$transform(
									$rtfeldman$elm_css$Css$translateY(
										$rtfeldman$elm_css$Css$px(
											$tad_lispy$springs$Spring$value(spring))))
								])),
							$author$project$Page$Navbar$onPointerDown($author$project$Page$Navbar$UserPointedDown)
						]);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			sidebarAttributes,
			A2(
				$elm$core$List$append,
				entries,
				_List_fromArray(
					[
						A2($author$project$Page$Navbar$viewTopbarQuickRow, route, platform)
					])));
	});
var $author$project$Page$Navbar$view = F3(
	function (state, repository, environment) {
		var translations = $author$project$Environments$Environment$translations(environment);
		var route = $author$project$Environments$Environment$route(environment);
		var maybeUser = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				function (userId) {
					return A2($author$project$Environments$Repository$getUser, userId, repository);
				},
				$author$project$Auth$Session$maybeUserId(
					$author$project$Environments$Environment$session(environment))));
		var entries = A5($author$project$Page$Navbar$viewEntries, translations, environment, state, maybeUser, route);
		var _v0 = function () {
			var _v1 = $author$project$Page$Navbar$getBarPosition(state);
			if (!_v1) {
				var numberOfPossibleEntries = A3(
					$author$project$Page$Navbar$numberOfNumberOfPossibleSidebarEntries,
					environment,
					$author$project$Page$Navbar$getBarPosition(state),
					entries);
				var newEntryList = (_Utils_cmp(
					numberOfPossibleEntries,
					$elm$core$List$length(entries)) > -1) ? entries : _Utils_ap(
					A2($elm$core$List$take, numberOfPossibleEntries, entries),
					_List_fromArray(
						[
							A3(
							$author$project$Page$Navbar$viewExtendedEntry,
							translations,
							$author$project$Page$Navbar$getBarPosition(state),
							$elm$core$List$length(entries) - numberOfPossibleEntries)
						]));
				return _Utils_Tuple2(
					A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Page$Navbar$viewSidebar, state, newEntryList),
					A2(
						$author$project$Page$Navbar$viewExtendedMenu,
						state,
						A2($elm$core$List$drop, numberOfPossibleEntries, entries)));
			} else {
				return _Utils_Tuple2(
					A5(
						$rtfeldman$elm_css$Html$Styled$Lazy$lazy4,
						$author$project$Page$Navbar$viewTopbar,
						$author$project$Environments$Environment$platform(environment),
						state,
						route,
						entries),
					$rtfeldman$elm_css$Html$Styled$text(''));
			}
		}();
		var viewBar = _v0.a;
		var extendedMenu = _v0.b;
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'aw-navbar',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
							$rtfeldman$elm_css$Css$zIndex(
							$rtfeldman$elm_css$Css$int(2))
						]))
				]),
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Page$Navbar$viewBackdrop, state),
					viewBar,
					A3($author$project$Page$Navbar$viewLogoutModal, translations, repository, state),
					A3($author$project$Page$Navbar$viewAboutModal, environment, repository, state),
					A2($author$project$Page$Navbar$viewConfirmOpenSettingsModal, environment, state),
					extendedMenu
				]));
	});
var $author$project$Main$viewNavbar = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$map,
		$author$project$Main$ReceivedNavbarMsg,
		A3($author$project$Page$Navbar$view, model.ba, model.ae, model.ac));
};
var $author$project$Main$ReceivedRoomNavigationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$viewRoomNavigation = function (model) {
	var filteredOrganisationUnits = $author$project$Environments$Repository$organisationUnits(model.ae);
	return A2(
		$rtfeldman$elm_css$Html$Styled$map,
		$author$project$Main$ReceivedRoomNavigationMsg,
		A3($author$project$UI$OrganisationUnitNavigation$view, filteredOrganisationUnits, model.f.f1, model.ac));
};
var $author$project$Main$viewTenantModel = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$map,
		$author$project$Main$ReceivedEditTenantModelMsg,
		A4(
			$author$project$Tenant$EditModal$view,
			$author$project$Environments$Environment$translations(model.ac),
			$author$project$Environments$Environment$userRights(model.ac),
			model.ae,
			model.f.eZ));
};
var $author$project$Translations$Synchronisation$Warnings$modalHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.warnings.modalHeader');
};
var $author$project$Translations$Synchronisation$Warnings$modalText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'synchronisation.warnings.modalText');
};
var $author$project$EventStream$SyncWarning$viewModalContent = function (translations) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$h4,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(600)),
						$rtfeldman$elm_css$Css$color(
						$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$darkGrey))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Translations$Synchronisation$Warnings$modalText(translations))
			]));
};
var $author$project$EventStream$SyncWarning$viewCancelButton = F2(
	function (translations, closeMsg) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withOnClick,
				closeMsg,
				$author$project$UI$Button$lightGrey(
					$author$project$Translations$Buttons$cancel(translations))));
	});
var $author$project$EventStream$SyncWarning$viewModalFooter = F2(
	function (translations, closeMsg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$EventStream$SyncWarning$viewCancelButton, translations, closeMsg)
				]));
	});
var $author$project$EventStream$SyncWarning$viewWarningModal = F3(
	function (environment, maybeWarningConfig, closeMsg) {
		return A2(
			$elm$core$Maybe$withDefault,
			$rtfeldman$elm_css$Html$Styled$text(''),
			A2(
				$elm$core$Maybe$map,
				function (warningConfig) {
					var _v0 = warningConfig.h9;
					if (!_v0) {
						return $rtfeldman$elm_css$Html$Styled$text('');
					} else {
						var translations = $author$project$Environments$Environment$translations(environment);
						return $author$project$UI$Modal$view(
							A2(
								$author$project$UI$Modal$appendStyle,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$maxWidth(
										$rtfeldman$elm_css$Css$pct(40))
									]),
								A2(
									$author$project$UI$Modal$appendFooter,
									A2($author$project$EventStream$SyncWarning$viewModalFooter, translations, closeMsg),
									A2(
										$author$project$UI$Modal$appendContent,
										$author$project$EventStream$SyncWarning$viewModalContent(translations),
										A2(
											$author$project$UI$Modal$modal,
											$author$project$Translations$Synchronisation$Warnings$modalHeader(translations),
											closeMsg)))));
					}
				},
				maybeWarningConfig));
	});
var $author$project$Main$viewLoadedBody = function (model) {
	var barConfig = function () {
		var _v0 = $author$project$Environments$Environment$getViewType(model.ac);
		if (!_v0) {
			return {
				gL: '\"header header navbar\" \"page page navbar\"',
				gM: 'auto auto 100px',
				gN: '6rem auto',
				gO: $author$project$Main$viewLoadedHeaderWide(model)
			};
		} else {
			var rows = function () {
				var _v1 = $author$project$Environments$Environment$platform(model.ac);
				if (_v1.$ === 2) {
					return '10';
				} else {
					return '8';
				}
			}();
			return {
				gL: '\"header header\" \"page page\"',
				gM: 'auto auto',
				gN: rows + 'rem auto',
				gO: $author$project$Main$viewLoadedHeaderThin(model)
			};
		}
	}();
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$global($author$project$UI$Style$Fonts$fonts),
			$rtfeldman$elm_css$Css$Global$global($author$project$UI$Style$Normalize$normalize),
			A2(
			$rtfeldman$elm_css$Html$Styled$main_,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'user-select', 'none'),
							A2($rtfeldman$elm_css$Css$property, '-webkit-user-select', 'none'),
							A2($rtfeldman$elm_css$Css$property, '-moz-user-select', 'none'),
							A2($rtfeldman$elm_css$Css$property, '-ms-user-select', 'none'),
							A2($rtfeldman$elm_css$Css$property, 'display', 'grid'),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-rows', barConfig.gN),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', barConfig.gM),
							A2($rtfeldman$elm_css$Css$property, 'grid-template-areas', barConfig.gL),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$vw(100)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$vh(100))
						]))
				]),
			_List_fromArray(
				[
					barConfig.gO,
					$author$project$Main$viewLoadedPage(model),
					$author$project$Main$viewNavbar(model),
					$author$project$Main$viewRoomNavigation(model),
					$author$project$Main$viewErrorModal(model),
					$author$project$Main$viewTenantModel(model),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$ReceivedReLoginMsg,
					A3($author$project$Auth$ReLoginModal$view, model.ac, model.ae, model.f.az)),
					A3($author$project$Main$viewCompleteSynchronisationModal, model.ac, model.ae, model.f.b_),
					A3(
					$author$project$EventStream$SyncWarning$viewWarningModal,
					model.ac,
					$author$project$EventStream$EventStream$getWarningConfig(
						$author$project$Environments$Repository$eventStream(model.ae)),
					$author$project$Main$UserClickedCloseSyncWarning)
				]))
		]);
};
var $author$project$Translations$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'title');
};
var $author$project$Main$viewTitle = A2($elm$core$Basics$composeR, $author$project$Environments$Environment$translations, $author$project$Translations$title);
var $author$project$Main$viewLoaded = function (model) {
	return {
		dq: A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Html$Styled$toUnstyled,
			$author$project$Main$viewLoadedBody(model)),
		k8: $author$project$Main$viewTitle(model.ac)
	};
};
var $author$project$Main$viewLoadingMiscIcon = F2(
	function (icon, loaded) {
		var color = loaded ? $author$project$UI$Style$Theme$green : $author$project$UI$Style$Theme$grey;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$rem(4))
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withForegroundColor,
						color,
						$author$project$UI$Icon$unicolor(icon)))
				]));
	});
var $author$project$Main$viewLoadingRightsIcon = F2(
	function (icon, state) {
		var color = (state.bP && state.bN) ? $author$project$UI$Style$Theme$green : (state.bP ? $author$project$UI$Style$Theme$lightGreen : (state.bN ? $author$project$UI$Style$Theme$yellow : $author$project$UI$Style$Theme$grey));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$rem(4))
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$view(
					A2(
						$author$project$UI$Icon$withForegroundColor,
						color,
						$author$project$UI$Icon$unicolor(icon)))
				]));
	});
var $author$project$Main$viewLoadingBody = function (model) {
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$global($author$project$UI$Style$Fonts$fonts),
			$rtfeldman$elm_css$Css$Global$global($author$project$UI$Style$Normalize$normalize),
			A2(
			$rtfeldman$elm_css$Html$Styled$main_,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'user-select', 'none'),
							A2($rtfeldman$elm_css$Css$property, '-webkit-user-select', 'none'),
							A2($rtfeldman$elm_css$Css$property, '-moz-user-select', 'none'),
							A2($rtfeldman$elm_css$Css$property, '-ms-user-select', 'none'),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$vw(100)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$vh(100))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[$author$project$UI$Logo$viewAwenkoSmartLogo])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Main$viewLoadingMiscIcon,
							$author$project$UI$Icons$upload,
							A2($author$project$Environments$Repository$eventStreamIsReady, model.ac, model.ae)),
							A2(
							$author$project$Main$viewLoadingMiscIcon,
							$author$project$UI$Icons$checkedDocument,
							$author$project$Environments$Repository$fileStoreIsReady(model.ae)),
							A2(
							$author$project$Main$viewLoadingRightsIcon,
							$author$project$UI$Icons$user,
							$author$project$Environments$Repository$userIsReady(model.ae)),
							A2(
							$author$project$Main$viewLoadingRightsIcon,
							$author$project$UI$Icons$pin,
							$author$project$Environments$Repository$checkpointDataIsReady(model.ae)),
							A2(
							$author$project$Main$viewLoadingRightsIcon,
							$author$project$UI$Icons$factory,
							$author$project$Environments$Repository$organisationUnitIsReady(model.ae)),
							A2(
							$author$project$Main$viewLoadingRightsIcon,
							$author$project$UI$Icons$plan,
							$author$project$Environments$Repository$planIsReady(model.ae)),
							A2(
							$author$project$Main$viewLoadingRightsIcon,
							$author$project$UI$Icons$audits,
							$author$project$Environments$Repository$auditIsReady(model.ae)),
							A2(
							$author$project$Main$viewLoadingRightsIcon,
							$author$project$UI$Icons$edit,
							$author$project$Environments$Repository$measureIsReady(model.ae)),
							A2(
							$author$project$Main$viewLoadingRightsIcon,
							$author$project$UI$Icons$home,
							$author$project$Environments$Repository$tenantIsReady(model.ae)),
							A2(
							$author$project$Main$viewLoadingRightsIcon,
							$author$project$UI$Icons$taskList,
							$author$project$Environments$Repository$rightsAreReady(model.ae))
						])),
					$author$project$Main$viewErrorModal(model),
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$ReceivedReLoginMsg,
					A3($author$project$Auth$ReLoginModal$view, model.ac, model.ae, model.az))
				]))
		]);
};
var $author$project$Main$viewLoading = function (model) {
	return {
		dq: A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Html$Styled$toUnstyled,
			$author$project$Main$viewLoadingBody(model)),
		k8: $author$project$Main$viewTitle(model.ac)
	};
};
var $author$project$Auth$Login$ChangeBaseUriModalState = function (a) {
	return {$: 10, a: a};
};
var $author$project$Auth$Login$VisibleModal = 0;
var $author$project$Auth$Login$viewBaseUriIcon = $author$project$UI$Icon$view(
	A2(
		$author$project$UI$Icon$withOnClick,
		$author$project$Auth$Login$ChangeBaseUriModalState(0),
		A2(
			$author$project$UI$Icon$withStyle,
			$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$rem(4)),
			A2(
				$author$project$UI$Icon$withStyle,
				$rtfeldman$elm_css$Css$bottom(
					$rtfeldman$elm_css$Css$rem(1)),
				A2(
					$author$project$UI$Icon$withStyle,
					$rtfeldman$elm_css$Css$left(
						$rtfeldman$elm_css$Css$rem(1)),
					A2(
						$author$project$UI$Icon$withStyle,
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
						$author$project$UI$Icon$unicolor($author$project$UI$Icons$editCircle)))))));
var $author$project$Translations$Login$baseUriEditor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'login.baseUriEditor');
};
var $author$project$Auth$Login$UserEnteredBaseUri = function (a) {
	return {$: 11, a: a};
};
var $author$project$Translations$Login$onlyForDeveloper = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'login.onlyForDeveloper');
};
var $author$project$Auth$Login$viewBaseUriModalContent = F2(
	function (environment, baseUri) {
		var moreOptions = (baseUri === 'smart') ? _List_fromArray(
			[
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withStyle,
					$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
					A2(
						$author$project$UI$Button$withOnClick,
						$author$project$Auth$Login$UserEnteredBaseUri('https://test.awenko-smart.de'),
						$author$project$UI$Button$darkGrey('https://test.awenko-smart.de')))),
				$author$project$UI$Button$view(
				A2(
					$author$project$UI$Button$withStyle,
					$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
					A2(
						$author$project$UI$Button$withOnClick,
						$author$project$Auth$Login$UserEnteredBaseUri('http://localhost:8000'),
						$author$project$UI$Button$darkGrey('http://localhost:8000'))))
			]) : _List_Nil;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(1)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
						]))
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$author$project$UI$TextInput$view(
						A2(
							$author$project$UI$TextInput$withStyle,
							$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1)),
							A2(
								$author$project$UI$TextInput$withOnInput,
								$author$project$Auth$Login$UserEnteredBaseUri,
								A2(
									$author$project$UI$TextInput$withPlaceholder,
									$author$project$Environments$Environment$baseUri(environment),
									A2($author$project$UI$TextInput$withValue, baseUri, $author$project$UI$TextInput$singleLine))))),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$color(
										$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$red)),
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$rem(1)),
										$rtfeldman$elm_css$Css$fontWeight(
										$rtfeldman$elm_css$Css$int(600))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Translations$Login$onlyForDeveloper(
									$author$project$Environments$Environment$translations(environment)))
							])),
						$author$project$UI$Button$view(
						A2(
							$author$project$UI$Button$withStyle,
							$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(1)),
							A2(
								$author$project$UI$Button$withOnClick,
								$author$project$Auth$Login$UserEnteredBaseUri('https://smart.awenko.de'),
								$author$project$UI$Button$darkGrey('https://smart.awenko.de'))))
					]),
				moreOptions));
	});
var $author$project$Auth$Login$viewCloseButton = function (translations) {
	return $author$project$UI$Button$view(
		A2(
			$author$project$UI$Button$withOnClick,
			$author$project$Auth$Login$ChangeBaseUriModalState(1),
			$author$project$UI$Button$lightGrey(
				$author$project$Translations$Buttons$close(translations))));
};
var $author$project$Auth$Login$UserClickedSaveBaseUri = {$: 12};
var $author$project$Translations$Buttons$save = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'buttons.save');
};
var $author$project$Auth$Login$viewSaveButton = F2(
	function (translations, disabled) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$disabled,
				disabled,
				A2(
					$author$project$UI$Button$withOnClick,
					$author$project$Auth$Login$UserClickedSaveBaseUri,
					$author$project$UI$Button$green(
						$author$project$Translations$Buttons$save(translations)))));
	});
var $author$project$Auth$Login$viewBaseUriModalFooter = F2(
	function (translations, disabled) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Auth$Login$viewCloseButton(translations),
					A2($author$project$Auth$Login$viewSaveButton, translations, disabled)
				]));
	});
var $author$project$Auth$Login$viewBaseUriModal = F3(
	function (environment, baseUri, modal) {
		if (!modal) {
			var translations = $author$project$Environments$Environment$translations(environment);
			var disabled = $elm$core$String$isEmpty(baseUri);
			return $author$project$UI$Modal$view(
				A2(
					$author$project$UI$Modal$appendFooter,
					A2($author$project$Auth$Login$viewBaseUriModalFooter, translations, disabled),
					A2(
						$author$project$UI$Modal$appendContent,
						A2($author$project$Auth$Login$viewBaseUriModalContent, environment, baseUri),
						A2(
							$author$project$UI$Modal$modal,
							$author$project$Translations$Login$baseUriEditor(translations),
							$author$project$Auth$Login$ChangeBaseUriModalState(1)))));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Auth$Login$viewFailure = F3(
	function (translations, isOffline, externalMsg) {
		var _v0 = function () {
			if (isOffline) {
				return _Utils_Tuple2('can\'t login while offline', $author$project$UI$Style$Theme$yellow);
			} else {
				switch (externalMsg) {
					case 'SERVER_ERROR':
						return _Utils_Tuple2('error while connecting to the server', $author$project$UI$Style$Theme$lightRed);
					case 'TIMEOUT':
						return _Utils_Tuple2('error: the response from the server took to long. Please try again.', $author$project$UI$Style$Theme$lightRed);
					default:
						return _Utils_Tuple2(
							$author$project$Translations$Login$failure(translations),
							$author$project$UI$Style$Theme$lightRed);
				}
			}
		}();
		var text_ = _v0.a;
		var color_ = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$h6,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor(color_))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(text_)
				]));
	});
var $author$project$Auth$Login$UserClickedLoginButton = {$: 4};
var $author$project$Auth$Login$viewLoginButton = F2(
	function (translations, disabled) {
		return $author$project$UI$Button$view(
			A2(
				$author$project$UI$Button$withOnClick,
				$author$project$Auth$Login$UserClickedLoginButton,
				A2(
					$author$project$UI$Button$withStyle,
					$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$rem(1)),
					A2(
						$author$project$UI$Button$withStyle,
						$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100)),
						A2(
							$author$project$UI$Button$disabled,
							disabled,
							$author$project$UI$Button$darkRed(
								$author$project$Translations$Login$login(translations)))))));
	});
var $author$project$Auth$Login$viewOffline = F2(
	function (_v0, isOffline) {
		return isOffline ? A2(
			$rtfeldman$elm_css$Html$Styled$h6,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600)),
							$rtfeldman$elm_css$Css$color(
							$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$yellow))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('can\'t login while offline')
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Auth$Login$UserEnteredPassword = function (a) {
	return {$: 2, a: a};
};
var $author$project$Auth$Login$UserPressedEnterOnPasswordInput = {$: 3};
var $author$project$Auth$Login$viewPassword = F3(
	function (translations, password, disabled) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withOnEnter,
				$author$project$Auth$Login$UserPressedEnterOnPasswordInput,
				A2(
					$author$project$UI$TextInput$withOnInput,
					$author$project$Auth$Login$UserEnteredPassword,
					A2(
						$author$project$UI$TextInput$withId,
						'login-password',
						A2(
							$author$project$UI$TextInput$disabled,
							disabled,
							A2(
								$author$project$UI$TextInput$withPlaceholder,
								$author$project$Translations$Login$password(translations),
								A2($author$project$UI$TextInput$withValue, password, $author$project$UI$TextInput$password)))))));
	});
var $author$project$Auth$Login$viewSendingText = A2(
	$rtfeldman$elm_css$Html$Styled$h6,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontWeight(
					$rtfeldman$elm_css$Css$int(600)),
					$rtfeldman$elm_css$Css$color(
					$author$project$UI$Style$Color$toCssColor($author$project$UI$Style$Theme$lightGrey))
				]))
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('sending data to server')
		]));
var $author$project$Auth$Login$UserEnteredTenantName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Auth$Login$viewTenantName = F3(
	function (translations, tenantName, disabled) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withOnInput,
				$author$project$Auth$Login$UserEnteredTenantName,
				A2(
					$author$project$UI$TextInput$withId,
					'login-tenantName',
					A2(
						$author$project$UI$TextInput$disabled,
						disabled,
						A2(
							$author$project$UI$TextInput$withPlaceholder,
							$author$project$Translations$Login$tenantName(translations),
							A2($author$project$UI$TextInput$withValue, tenantName, $author$project$UI$TextInput$singleLine))))));
	});
var $author$project$Auth$Login$UserEnteredUsername = function (a) {
	return {$: 1, a: a};
};
var $author$project$Auth$Login$viewUsername = F3(
	function (translations, username, disabled) {
		return $author$project$UI$TextInput$view(
			A2(
				$author$project$UI$TextInput$withOnInput,
				$author$project$Auth$Login$UserEnteredUsername,
				A2(
					$author$project$UI$TextInput$withId,
					'login-username',
					A2(
						$author$project$UI$TextInput$disabled,
						disabled,
						A2(
							$author$project$UI$TextInput$withPlaceholder,
							$author$project$Translations$Login$username(translations),
							A2($author$project$UI$TextInput$withValue, username, $author$project$UI$TextInput$singleLine))))));
	});
var $author$project$Auth$Login$view = F2(
	function (environment, state) {
		var translations = $author$project$Environments$Environment$translations(environment);
		switch (state.$) {
			case 0:
				var form = state.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$rem(16)),
									$rtfeldman$elm_css$Css$maxWidth(
									$rtfeldman$elm_css$Css$rem(26)),
									A4(
									$rtfeldman$elm_css$Css$margin4,
									$rtfeldman$elm_css$Css$rem(1),
									$rtfeldman$elm_css$Css$rem(1),
									$rtfeldman$elm_css$Css$rem(4),
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							$author$project$UI$Logo$viewAwenkoSmartLogo,
							A3($author$project$Auth$Login$viewTenantName, translations, form.aP, false),
							A3($author$project$Auth$Login$viewUsername, translations, form.iK, false),
							A3($author$project$Auth$Login$viewPassword, translations, form.a1, false),
							A2(
							$author$project$Auth$Login$viewLoginButton,
							translations,
							$elm$core$String$isEmpty(form.aP) || ($elm$core$String$isEmpty(form.iK) || ($elm$core$String$isEmpty(form.a1) || $author$project$Environments$Environment$isOffline(environment)))),
							A2(
							$author$project$Auth$Login$viewOffline,
							translations,
							$author$project$Environments$Environment$isOffline(environment)),
							A3($author$project$Auth$Login$viewBaseUriModal, environment, form.bC, form.aE),
							$author$project$Auth$Login$viewBaseUriIcon
						]));
			case 1:
				var form = state.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$rem(16)),
									$rtfeldman$elm_css$Css$maxWidth(
									$rtfeldman$elm_css$Css$rem(26)),
									$rtfeldman$elm_css$Css$margin(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							$author$project$UI$Logo$viewAwenkoSmartLogo,
							A3($author$project$Auth$Login$viewTenantName, translations, form.aP, true),
							A3($author$project$Auth$Login$viewUsername, translations, form.iK, true),
							A3($author$project$Auth$Login$viewPassword, translations, form.a1, true),
							A2($author$project$Auth$Login$viewLoginButton, translations, true),
							$author$project$Auth$Login$viewSendingText,
							$author$project$Auth$Login$viewBaseUriIcon
						]));
			default:
				var form = state.a;
				var externalMsg = state.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$rem(16)),
									$rtfeldman$elm_css$Css$maxWidth(
									$rtfeldman$elm_css$Css$rem(26)),
									$rtfeldman$elm_css$Css$margin(
									$rtfeldman$elm_css$Css$rem(1)),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							$author$project$UI$Logo$viewAwenkoSmartLogo,
							A3($author$project$Auth$Login$viewTenantName, translations, form.aP, false),
							A3($author$project$Auth$Login$viewUsername, translations, form.iK, false),
							A3($author$project$Auth$Login$viewPassword, translations, form.a1, false),
							A2($author$project$Auth$Login$viewLoginButton, translations, true),
							A3(
							$author$project$Auth$Login$viewFailure,
							translations,
							$author$project$Environments$Environment$isOffline(environment),
							externalMsg),
							A3($author$project$Auth$Login$viewBaseUriModal, environment, form.bC, form.aE),
							$author$project$Auth$Login$viewBaseUriIcon
						]));
		}
	});
var $author$project$Main$viewLoginBody = function (model) {
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Global$global($author$project$UI$Style$Fonts$fonts),
			$rtfeldman$elm_css$Css$Global$global($author$project$UI$Style$Normalize$normalize),
			A2(
			$rtfeldman$elm_css$Html$Styled$main_,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$property, 'user-select', 'none'),
							A2($rtfeldman$elm_css$Css$property, '-webkit-user-select', 'none'),
							A2($rtfeldman$elm_css$Css$property, '-moz-user-select', 'none'),
							A2($rtfeldman$elm_css$Css$property, '-ms-user-select', 'none'),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$vw(100)),
							$rtfeldman$elm_css$Css$height(
							$rtfeldman$elm_css$Css$vh(100))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Main$ReceivedLoginMsg,
					A2($author$project$Auth$Login$view, model.ac, model.dT)),
					$author$project$Main$viewErrorModal(model)
				]))
		]);
};
var $author$project$Main$viewLogin = function (model) {
	return {
		dq: A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Html$Styled$toUnstyled,
			$author$project$Main$viewLoginBody(model)),
		k8: $author$project$Main$viewTitle(model.ac)
	};
};
var $author$project$Main$view = function (state) {
	switch (state.$) {
		case 0:
			var model = state.a;
			return $author$project$Main$viewLoading(model);
		case 1:
			var model = state.a;
			return $author$project$Main$viewLogin(model);
		case 2:
			var model = state.a;
			return $author$project$Main$viewLoaded(model);
		default:
			var string = state.a;
			return $author$project$Main$viewError(string);
	}
};
var $author$project$Main$main = $elm$browser$Browser$document(
	{jM: $author$project$Main$init, kZ: $author$project$Main$subscriptions, le: $author$project$Main$update, lm: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));